import { usePendingAction, useMediaQuery, usePrefersReducedMotion, useTranslate as useTranslate$1, usePageHead, usePendingScopeValue, PendingScopeContext, useRenderI18n, useScopeHasPending, runTickFrame, claimDelivery, beginPending, endPending, useDragReorder, useQuerySingleton, usePullToRefresh, useInfiniteScroll, useCanvasGestures, useAuthContext, useSwipeGesture, usePendingRows, useLongPress, useDraggable as useDraggable$1, useDropZone } from './chunk-Q4JDDFCV.js';
import { pressableProps, Box, HStack, useCanvasTheme, STATE_COLORS, avlSeries, isAtlasAsset, getAtlas, subRectFor, VStack, avlTint, CONNECTION_COLORS, parseTraitLevel, AVL_INK, AVL_FONT, AVL_STROKE, getStateRole, effectCategoryOf, EFFECT_CATEGORY_COLORS, OPERATOR_CATEGORY_COLORS, asEffectOperator, Stack, DrawSkinnedMesh, DrawShape, DrawMesh, DrawGroup, DrawFxLayer, withSeries, markColor, resolveDrawableColors, traitLevelFromTrait, resolveThemeColor, applyLineCharacter, fillLabel, labelText, THEME_SERIES, CONFETTI_BURST_KEYFRAMES, STRETCHED_CONTROL, rowOpenControlProps, STRETCHED_ABOVE, createConfettiParticles, collectDrawnItems, buildHitIndex, resolveAssetSource, blit, withPreviewPosition, hitTestSprites, DrawableRegistryContext, outlineStroke, markStrokeWidth, outlineCarriesFill, markDash, labelFont, fillMark, tracePolyline, arcPoints, drawMarker, getOrLoadImage, expandFxLayer, paintSkinnedMesh, isValidScenePos, isAnimatedGroup, applyMeshAnimation, paintShape, parseApplicationLevel, parseOrbitalLevel, traitTransitionRenderUi, spriteRect, effectZoneOf, motionTiming, layoutScale, spriteAssetState, getImageStatus, atlasUrlOf, atlasFailed, isSpriteSheetAtlas, fxHash01, traitEventWires, isAnimatedShape, SPRITE_FALLBACK_FILL, SPRITE_FALLBACK_STROKE, avlBlend } from './chunk-MGN6B6OQ.js';
import { useTapReveal } from './chunk-XJTHMW4G.js';
import { INLINE_TEXT_ATTR, Typography } from './chunk-KZRAMPM6.js';
import { useEventBus, useEventListener } from './chunk-CHNC4UYE.js';
import { ALL_SLOTS } from './chunk-L3MTZ3RH.js';
import { isNotificationSlot, isPortalSlot } from './chunk-PEST66PN.js';
import { computeLineDiff, isEditorMotion, applyMotion, isEditorOperator, motionRange, applyOperator, gearTeethPath, registerTrait, unregisterTrait, asEnterAnimation, slotPlaysDefaultEnter, useSlotEnterRestart, ENTER_SLOT_CLASS, perfTimeAsync, enterClassName, getNestedValue, parseLessonSegments, isDebugEnabled2, onDebugToggle, debugGroup, debug, debugGroupEnd, resolveImageUrl, perfStart, perfEnd, isDebugEnabled, profilerOnRender, parseContentSegments, parseMarkdownWithCodeBlocks, subscribeToTraitChanges, subscribeToTickChanges, subscribeToGuardChanges, subscribeToDebugEvents, getEntitySnapshot, getDebugEvents, getGuardHistory, getAllTicks, getAllTraits } from './chunk-N4IJS5DD.js';
import { isEditableTarget, usePresence, bindTraitStateGetter, registerTraitSnapshot, isMotionEnabled, recordTransition, recordingTransport, recordServerResponse, serverEffectTraces, Presence, bindCanvasCapture, bindLastDrawables, subscribeToVerification, updateAssetStatus, resolveKeyMapEvent, getSummary, getBridgeHealth, getTransitions, getAllChecks } from './chunk-N23SVGTH.js';
import { cn, domPassthrough } from './chunk-64WACXM7.js';
import { formatValue, toDateTimeInputValue, toDateInputValue, sortRows, formatDate } from './chunk-6ZCU3BQN.js';
import { __publicField } from './chunk-QPXIAUJD.js';
import * as React93 from 'react';
import React93__default, { createContext, useCallback, useState, useRef, useEffect, lazy, useMemo, useLayoutEffect, useId, useContext, useSyncExternalStore, Suspense, useReducer, Profiler } from 'react';
import { useNavStack, SurfaceBoundary, isInertNavStack, useContentSurface, useArbitraryClassStyles, getAllPages, matchPathAmong, CurrentPagePathProvider, NavStackProvider, OrbitalProvider, PageAccessHost, ServerBridgeProvider, VerificationProvider, EntitySchemaProvider, OrbitalThemeProvider, useServerBridge, EntityBindingContext, AwaitingSkeletonContext, useUser, RenderSlotProvider, useEntitySchemaOptional, useAwaitingSkeleton, useEntityBindingSnapshot, TraitScopeProvider, useTraitScope, useGameAudioContextOptional, useRenderSlot, useCurrentPagePath } from '@almadar/ui/providers';
export { GameAudioContext, GameAudioProvider, useGameAudioContext } from '@almadar/ui/providers';
import { loadLazyPage, createInProcessTransport, openBrowserStore, browserStoreName, collectListenerTargets, LIFECYCLE_EVENTS, TraitMountError, buildTraitIndex, createMemoryCircuitStore, createLocalStoreTransport, createResidenceTransport, createClientKernel, createTickScheduler, isValidCronExpression, parseDurationString, UNMOUNT_EVENT, createClientEffectHandlers, EffectExecutor, isSExpression, collectDeclaredConfigDefaults, createContextFromBindings, normalizeCallSiteConfigToValues, interpolateValue } from '@almadar/runtime';
import { actionTestId, LOADING_STATE_MARKER, FieldTypeSchema, EFFECT_OPERATORS, EMPTY_STATE_MARKER, isInlineTrait, isPageReference, navigatePatternPath, isAriaRole, isHostSignInRoute, localeAlternates, formatSExpr, buildResolvedTraitConfigs, collectCallsiteCaptureChildren, schemaToIR, getPage, orbitalInlineEntities, storesRowsInBrowser, traitsEmbeddedByEvent, traitReferencesCallsitePayload, configReferencesCallsitePayload, TRAIT_MOUNT_ERROR_TESTID, traitsEmbeddedByEffects, applyListenPayloadMapping, walkSExpr, isRenderBindingMarker, PATTERN_PROP_TYPE_ERROR_TESTID, isTraitValue, isBehaviorRefValue, isSExpr, isEventPayloadValue, containsEntityBinding, RENDER_BINDING_MARKER, FORM_PATTERN, ACTION_OVERFLOW_TESTID, answerToMutations, ANONYMOUS_USER, isFileValue, isBinding, clearSchemaCache as clearSchemaCache$1 } from '@almadar/core';
import { renderUiEntriesOf, SELF_OVERLAY_PATTERN_TYPES, getPatternDefinition, isDrawHostPattern, getPatternFieldsContract, getComponentForPattern, isEntityAwarePattern, eventKeyPropsOf, eventListPropsOf } from '@almadar/core/patterns';
import { useScopedMode, useThemeScope, UISlotProvider, useUISlots, useTheme } from '@almadar/ui/context';
import * as LucideIcons2 from 'lucide-react';
import { Loader2, X, Code, FileText, WrapText, Check, Copy, ChevronLeft, ChevronRight, AlertCircle, Circle, Clock, CheckCircle2, TrendingUp, TrendingDown, Minus, Eraser, Search, Bold, Italic, Underline, Strikethrough, Heading1, Heading2, Heading3, List, ListOrdered, Quote, Link, Image as Image$1, PauseCircle, HelpCircle, Upload, ZoomIn, Menu as Menu$1, ZoomOut, RotateCcw, DollarSign, Download, Printer, ArrowLeft, Link2, AlertTriangle, Trash2, Play, Terminal, CheckCircle, XCircle, GitBranch, Pencil, Eye, Plus, Lightbulb, ArrowRight, Trash, ChevronDown } from 'lucide-react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useTranslate, createTranslate, I18nProvider, useRenderI18n as useRenderI18n$1, useFormatContext } from '@almadar/ui/hooks';
import { createPortal } from 'react-dom';
import { createLogger } from '@almadar/logger';
import { evaluateListenPayloadExpr, evaluate, createMinimalContext, evaluateGuard, executeEffects, createChildContext } from '@almadar/evaluator';
import { getStdOperatorMeta, isKnownStdOperator, operatorVisualForm } from '@almadar/std/registry';
import { prepareSchemaForPreview, collectEmbeddedTraits, collectTraitRefsFromResolvedTrait, buildOrbitalsByTrait, buildTraitLinkedEntities, wrapCallbackForEvent } from '@almadar/runtime/ui';
export { adjustSchemaForMockData, buildMockData, prepareSchemaForPreview, wrapCallbackForEvent } from '@almadar/runtime/ui';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/prism-light.js';
import createHighlightElement from 'react-syntax-highlighter/dist/esm/create-element.js';
import dark from 'react-syntax-highlighter/dist/esm/styles/prism/vsc-dark-plus.js';
import light from 'react-syntax-highlighter/dist/esm/styles/prism/vs.js';
import { orbLanguage, loloLanguage, ORB_COLORS, translateLolo, translateOrb } from '@almadar/syntax';
import { coreTables, localeDirection } from '@almadar/core/i18n';
import langJson from 'react-syntax-highlighter/dist/esm/languages/prism/json.js';
import langJavascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript.js';
import langTypescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript.js';
import langJsx from 'react-syntax-highlighter/dist/esm/languages/prism/jsx.js';
import langTsx from 'react-syntax-highlighter/dist/esm/languages/prism/tsx.js';
import langCss from 'react-syntax-highlighter/dist/esm/languages/prism/css.js';
import langMarkdown from 'react-syntax-highlighter/dist/esm/languages/prism/markdown.js';
import langBash from 'react-syntax-highlighter/dist/esm/languages/prism/bash.js';
import langYaml from 'react-syntax-highlighter/dist/esm/languages/prism/yaml.js';
import langRust from 'react-syntax-highlighter/dist/esm/languages/prism/rust.js';
import langPython from 'react-syntax-highlighter/dist/esm/languages/prism/python.js';
import langSql from 'react-syntax-highlighter/dist/esm/languages/prism/sql.js';
import langDiff from 'react-syntax-highlighter/dist/esm/languages/prism/diff.js';
import langToml from 'react-syntax-highlighter/dist/esm/languages/prism/toml.js';
import langGo from 'react-syntax-highlighter/dist/esm/languages/prism/go.js';
import langGraphql from 'react-syntax-highlighter/dist/esm/languages/prism/graphql.js';
import langClojure from 'react-syntax-highlighter/dist/esm/languages/prism/clojure.js';
import langHaskell from 'react-syntax-highlighter/dist/esm/languages/prism/haskell.js';
import langLisp from 'react-syntax-highlighter/dist/esm/languages/prism/lisp.js';
import langScheme from 'react-syntax-highlighter/dist/esm/languages/prism/scheme.js';
import langScala from 'react-syntax-highlighter/dist/esm/languages/prism/scala.js';
import langElixir from 'react-syntax-highlighter/dist/esm/languages/prism/elixir.js';
import langErlang from 'react-syntax-highlighter/dist/esm/languages/prism/erlang.js';
import langElm from 'react-syntax-highlighter/dist/esm/languages/prism/elm.js';
import langFsharp from 'react-syntax-highlighter/dist/esm/languages/prism/fsharp.js';
import langOcaml from 'react-syntax-highlighter/dist/esm/languages/prism/ocaml.js';
import langJava from 'react-syntax-highlighter/dist/esm/languages/prism/java.js';
import langC from 'react-syntax-highlighter/dist/esm/languages/prism/c.js';
import langCpp from 'react-syntax-highlighter/dist/esm/languages/prism/cpp.js';
import langCsharp from 'react-syntax-highlighter/dist/esm/languages/prism/csharp.js';
import langObjectivec from 'react-syntax-highlighter/dist/esm/languages/prism/objectivec.js';
import langPhp from 'react-syntax-highlighter/dist/esm/languages/prism/php.js';
import langRuby from 'react-syntax-highlighter/dist/esm/languages/prism/ruby.js';
import langSwift from 'react-syntax-highlighter/dist/esm/languages/prism/swift.js';
import langKotlin from 'react-syntax-highlighter/dist/esm/languages/prism/kotlin.js';
import langLua from 'react-syntax-highlighter/dist/esm/languages/prism/lua.js';
import langR from 'react-syntax-highlighter/dist/esm/languages/prism/r.js';
import langDart from 'react-syntax-highlighter/dist/esm/languages/prism/dart.js';
import langJulia from 'react-syntax-highlighter/dist/esm/languages/prism/julia.js';
import langFortran from 'react-syntax-highlighter/dist/esm/languages/prism/fortran.js';
import langPerl from 'react-syntax-highlighter/dist/esm/languages/prism/perl.js';
import langPowershell from 'react-syntax-highlighter/dist/esm/languages/prism/powershell.js';
import langMakefile from 'react-syntax-highlighter/dist/esm/languages/prism/makefile.js';
import langNginx from 'react-syntax-highlighter/dist/esm/languages/prism/nginx.js';
import langIni from 'react-syntax-highlighter/dist/esm/languages/prism/ini.js';
import langClike from 'react-syntax-highlighter/dist/esm/languages/prism/clike.js';
import { useInRouterContext, useHref, useLocation, Link as Link$1, Outlet } from 'react-router-dom';
import { useDroppable, useDraggable, DndContext, useSensors, useSensor, PointerSensor, KeyboardSensor, pointerWithin, rectIntersection, closestCorners, DragOverlay } from '@dnd-kit/core';
import { useSortable, arrayMove, sortableKeyboardCoordinates, SortableContext, rectSortingStrategy, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS as CSS$1 } from '@dnd-kit/utilities';
import emojilib from 'emojilib';
import { MarkerType, useReactFlow, NodeResizeControl, ResizeControlVariant, Handle, Position, getBezierPath, EdgeLabelRenderer, useNodeId, ReactFlowProvider, useNodesState, useEdgesState, useNodesInitialized, ReactFlow, Controls, Background, BackgroundVariant } from '@xyflow/react';
import { OrbitalServerRuntime } from '@almadar/runtime/OrbitalServerRuntime';
import { InMemoryPersistence } from '@almadar/db/mock';
import { forceSimulation, forceLink, forceManyBody, forceCollide, forceX, forceY } from 'd3-force';

function resolveMarkerExpression(expression, entity, config, state, i18n) {
  const ctx = createContextFromBindings({
    entity,
    payload: {},
    state,
    ...config !== void 0 ? { config } : {},
    ...i18n !== void 0 ? { locale: i18n.locale, messages: i18n.messages } : {}
  });
  return interpolateValue(expression, ctx);
}
function isPlainObject(value) {
  if (value === null || value === void 0 || typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  if (React93__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  if (typeof value === "function") return false;
  return true;
}
var markerPresenceCache = /* @__PURE__ */ new WeakMap();
var markerResolutionCache = /* @__PURE__ */ new WeakMap();
var containerResolutionCache = /* @__PURE__ */ new WeakMap();
function cachedContainer(value, scopeTrait, entity, config, state, i18n) {
  const hit = containerResolutionCache.get(value);
  return hit !== void 0 && hit.entity === entity && hit.config === config && hit.state === state && hit.i18n === i18n && hit.scopeTrait === scopeTrait ? hit.resolved : void 0;
}
var resolvedMarkerFree = /* @__PURE__ */ new WeakSet();
var evaluatorResolvedData = /* @__PURE__ */ new WeakSet();
function isPatternNode(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value) || React93__default.isValidElement(value) || value instanceof Date) return false;
  const type = value.type;
  return typeof type === "string" && getComponentForPattern(type) !== null;
}
function holdsRenderNode(value) {
  return isPatternNode(value) || Array.isArray(value) && value.some((item) => isPatternNode(item));
}
function isEvaluatorResolvedData(value) {
  return evaluatorResolvedData.has(value);
}
function brandResolved(value) {
  if (value !== null && typeof value === "object" && !React93__default.isValidElement(value) && !(value instanceof Date)) {
    resolvedMarkerFree.add(value);
  }
}
function subtreeHasMarker(value) {
  if (resolvedMarkerFree.has(value)) return false;
  const cached = markerPresenceCache.get(value);
  if (cached !== void 0) return cached;
  let found = false;
  const children = Array.isArray(value) ? value : Object.values(value);
  for (const child of children) {
    if (isRenderBindingMarker(child)) {
      found = true;
      break;
    }
    if (Array.isArray(child) || isPlainObject(child)) {
      if (subtreeHasMarker(child)) {
        found = true;
        break;
      }
    }
  }
  markerPresenceCache.set(value, found);
  return found;
}
function walkValue(value, scopeTrait, entity, config, state, i18n) {
  if (isRenderBindingMarker(value)) {
    const cached = markerResolutionCache.get(value);
    if (cached !== void 0 && cached.entity === entity && cached.config === config && cached.state === state && cached.i18n === i18n) {
      return { resolved: cached.resolved, changed: true };
    }
    const resolved = resolveMarkerExpression(value.expression, entity, config, state, i18n);
    markerResolutionCache.set(value, { entity, config, state, i18n, resolved });
    if (resolved !== null && typeof resolved === "object" && !React93__default.isValidElement(resolved) && !(resolved instanceof Date)) {
      resolvedMarkerFree.add(resolved);
      if (!holdsRenderNode(resolved)) evaluatorResolvedData.add(resolved);
    }
    return { resolved, changed: true };
  }
  if (Array.isArray(value)) {
    if (!subtreeHasMarker(value)) {
      brandResolved(value);
      return { resolved: value, changed: false };
    }
    const cachedArray = cachedContainer(value, scopeTrait, entity, config, state, i18n);
    if (cachedArray !== void 0) return { resolved: cachedArray, changed: true };
    const out = [];
    let changed = false;
    for (const item of value) {
      const element = item;
      const wasMarker = isRenderBindingMarker(element);
      const { resolved, changed: itemChanged } = walkValue(element, scopeTrait, entity, config, state, i18n);
      if (wasMarker && Array.isArray(resolved)) {
        out.push(...resolved);
        changed = true;
        continue;
      }
      out.push(resolved);
      if (itemChanged) changed = true;
    }
    brandResolved(out);
    if (!changed) return { resolved: value, changed: false };
    containerResolutionCache.set(value, { entity, config, state, i18n, scopeTrait, resolved: out });
    return { resolved: out, changed: true };
  }
  if (isPlainObject(value)) {
    if (!subtreeHasMarker(value)) {
      brandResolved(value);
      return { resolved: value, changed: false };
    }
    const sourceTrait = value._sourceTrait;
    if (typeof sourceTrait === "string" && sourceTrait !== scopeTrait) {
      return { resolved: value, changed: false };
    }
    const cachedObject = cachedContainer(value, scopeTrait, entity, config, state, i18n);
    if (cachedObject !== void 0) return { resolved: cachedObject, changed: true };
    const out = {};
    let changed = false;
    for (const [key, item] of Object.entries(value)) {
      const { resolved, changed: itemChanged } = walkValue(item, scopeTrait, entity, config, state, i18n);
      out[key] = resolved;
      if (itemChanged) changed = true;
    }
    brandResolved(out);
    if (!changed) return { resolved: value, changed: false };
    containerResolutionCache.set(value, { entity, config, state, i18n, scopeTrait, resolved: out });
    return { resolved: out, changed: true };
  }
  return { resolved: value, changed: false };
}
function resolveRenderBindingMarkers(props, scopeTrait, entity, config, state, i18n) {
  if (props === null || typeof props !== "object") return props;
  if (resolvedMarkerFree.has(props)) return props;
  const cached = cachedContainer(props, scopeTrait, entity, config, state, i18n);
  if (cached !== void 0) return cached;
  const out = {};
  let changed = false;
  for (const [key, value] of Object.entries(props)) {
    const { resolved, changed: propChanged } = walkValue(value, scopeTrait, entity, config, state, i18n);
    out[key] = resolved;
    if (propChanged) changed = true;
  }
  brandResolved(out);
  if (!changed) return props;
  containerResolutionCache.set(props, { entity, config, state, i18n, scopeTrait, resolved: out });
  return out;
}
var DEFAULT_FAMILY = "lucide";
var VALID_FAMILIES = [DEFAULT_FAMILY];
function themeIconFamily() {
  if (typeof window === "undefined" || typeof document === "undefined") return "";
  return getComputedStyle(document.documentElement).getPropertyValue("--icon-family").trim().replace(/^["']|["']$/g, "");
}
function getCurrentIconFamily() {
  const raw = themeIconFamily();
  return VALID_FAMILIES.includes(raw) ? raw : DEFAULT_FAMILY;
}
function familyStrokeApplies(raw) {
  return raw === "" || VALID_FAMILIES.includes(raw);
}
function themeStrokeApplies() {
  return familyStrokeApplies(themeIconFamily());
}
function scopedIconFamily(el) {
  const scope = el.closest("[data-theme]");
  if (!scope || scope === document.documentElement) return null;
  const known = scopedFamilies.get(scope);
  if (known && known.version === themeVersion) return known.family;
  const raw = getComputedStyle(scope).getPropertyValue("--icon-family").trim().replace(/^["']|["']$/g, "");
  const family = raw === "" ? null : raw;
  scopedFamilies.set(scope, { version: themeVersion, family });
  return family;
}
var scopedFamilies = /* @__PURE__ */ new WeakMap();
var cachedFamily = null;
var cachedStrokeApplies = null;
var themeVersion = 0;
var listeners = /* @__PURE__ */ new Set();
var observer = null;
var scopeObserver = null;
function ensureObserver() {
  if (typeof window === "undefined" || observer) return;
  observer = new MutationObserver(() => {
    const next = getCurrentIconFamily();
    const nextStroke = themeStrokeApplies();
    if (next !== cachedFamily || nextStroke !== cachedStrokeApplies) {
      cachedFamily = next;
      cachedStrokeApplies = nextStroke;
      themeVersion++;
      listeners.forEach((fn) => fn());
    }
  });
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["data-theme", "style"]
  });
  scopeObserver = new MutationObserver((records) => {
    if (records.every((r) => r.target === document.documentElement)) return;
    themeVersion++;
    listeners.forEach((fn) => fn());
  });
  scopeObserver.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ["data-theme"]
  });
  cachedFamily = getCurrentIconFamily();
  cachedStrokeApplies = themeStrokeApplies();
}
function subscribeIconFamily(notify) {
  ensureObserver();
  listeners.add(notify);
  return () => {
    listeners.delete(notify);
  };
}
function getIconFamilySnapshot() {
  if (cachedFamily !== null) return cachedFamily;
  cachedFamily = getCurrentIconFamily();
  return cachedFamily;
}
function getIconFamilyServerSnapshot() {
  return DEFAULT_FAMILY;
}
function getStrokeAppliesSnapshot() {
  if (cachedStrokeApplies !== null) return cachedStrokeApplies;
  cachedStrokeApplies = themeStrokeApplies();
  return cachedStrokeApplies;
}
function getThemeVersionSnapshot() {
  return themeVersion;
}
function useThemeIconStrokeApplies(ref) {
  const documentApplies = useSyncExternalStore(subscribeIconFamily, getStrokeAppliesSnapshot, () => true);
  const version = useSyncExternalStore(subscribeIconFamily, getThemeVersionSnapshot, () => 0);
  const [scopedApplies, setScopedApplies] = useState(null);
  useLayoutEffect(() => {
    if (!ref.current) return;
    const scoped = scopedIconFamily(ref.current);
    setScopedApplies(scoped === null ? null : familyStrokeApplies(scoped));
  }, [ref, version]);
  return scopedApplies ?? documentApplies;
}
function useIconFamily() {
  return useSyncExternalStore(
    subscribeIconFamily,
    getIconFamilySnapshot,
    getIconFamilyServerSnapshot
  );
}
function kebabToPascal(name) {
  return name.split("-").map((part) => {
    if (/^\d+$/.test(part)) return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join("");
}
var lucideAliases = {
  close: LucideIcons2.X,
  trash: LucideIcons2.Trash2,
  loader: LucideIcons2.Loader2,
  stop: LucideIcons2.Square,
  volume: LucideIcons2.Volume2,
  "volume-off": LucideIcons2.VolumeX,
  refresh: LucideIcons2.RefreshCw,
  share: LucideIcons2.Share2,
  "sort-asc": LucideIcons2.ArrowUpNarrowWide,
  "sort-desc": LucideIcons2.ArrowDownNarrowWide
};
function isComponentLike(v) {
  return v != null && (typeof v === "function" || typeof v === "object");
}
function resolveLucide(name) {
  if (lucideAliases[name]) return lucideAliases[name];
  const pascal = kebabToPascal(name);
  const lucideMap = LucideIcons2;
  const direct = lucideMap[pascal];
  if (isComponentLike(direct)) return direct;
  const asIs = lucideMap[name];
  if (isComponentLike(asIs)) return asIs;
  return LucideIcons2.HelpCircle;
}
function makeLucideAdapter(name) {
  const LucideComp = resolveLucide(name);
  const Adapter = React93__default.forwardRef((props, ref) => /* @__PURE__ */ jsx(
    LucideComp,
    {
      ref,
      className: props.className,
      strokeWidth: props.strokeWidth,
      style: props.style,
      size: props.size
    }
  ));
  Adapter.displayName = `Lucide.${name}`;
  return Adapter;
}
function resolveIconForFamily(name, _family) {
  return makeLucideAdapter(name);
}
var colorTokenClasses = {
  primary: "text-primary",
  secondary: "text-secondary",
  success: "text-success",
  warning: "text-warning",
  error: "text-error",
  muted: "text-muted-foreground"
};
var iconAliases = {
  "close": LucideIcons2.X,
  "trash": LucideIcons2.Trash2,
  "loader": LucideIcons2.Loader2,
  "stop": LucideIcons2.Square,
  "volume": LucideIcons2.Volume2,
  "volume-off": LucideIcons2.VolumeX,
  "refresh": LucideIcons2.RefreshCw,
  "share": LucideIcons2.Share2,
  "sort-asc": LucideIcons2.ArrowUpNarrowWide,
  "sort-desc": LucideIcons2.ArrowDownNarrowWide
};
function kebabToPascal2(name) {
  return name.split("-").map((part) => {
    if (/^\d+$/.test(part)) return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join("");
}
var resolvedCache = /* @__PURE__ */ new Map();
function resolveIcon(name) {
  const cached = resolvedCache.get(name);
  if (cached) return cached;
  const resolved = doResolve(name);
  resolvedCache.set(name, resolved);
  return resolved;
}
function doResolve(name) {
  if (iconAliases[name]) return iconAliases[name];
  const isComponentLike2 = (v) => v != null && (typeof v === "function" || typeof v === "object");
  const pascalName = kebabToPascal2(name);
  const lucideMap = LucideIcons2;
  const directLookup = lucideMap[pascalName];
  if (isComponentLike2(directLookup)) return directLookup;
  const asIs = lucideMap[name];
  if (isComponentLike2(asIs)) return asIs;
  return LucideIcons2.HelpCircle;
}
var sizeClasses = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "h-icon-default w-icon-default",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
};
var animationClasses = {
  none: "",
  spin: "animate-spin",
  pulse: "animate-pulse"
};
var Icon = ({
  icon,
  name,
  size: size2 = "md",
  color,
  animation = "none",
  className,
  strokeWidth,
  style,
  ...rest
}) => {
  const directIcon = typeof icon === "string" ? void 0 : icon;
  const effectiveName = typeof icon === "string" && icon !== "" ? icon : name;
  const effectiveStrokeWidth = strokeWidth != null && strokeWidth > 0 ? strokeWidth : void 0;
  const family = useIconFamily();
  const svgRef = React93__default.useRef(null);
  const themeStroke = useThemeIconStrokeApplies(svgRef);
  const RenderedComponent = React93__default.useMemo(() => {
    if (directIcon) return null;
    return effectiveName ? resolveIconForFamily(effectiveName) : null;
  }, [directIcon, effectiveName, family]);
  const inlineStyle = {
    ...effectiveStrokeWidth === void 0 && themeStroke ? { strokeWidth: "var(--icon-stroke-width, 2)" } : {},
    ...style
  };
  const resolvedColor = color ? color in colorTokenClasses ? colorTokenClasses[color] : color : "text-current";
  const composedClassName = cn(
    sizeClasses[size2],
    animationClasses[animation],
    resolvedColor,
    className
  );
  if (directIcon) {
    const Direct = directIcon;
    return /* @__PURE__ */ jsx(
      Direct,
      {
        ref: svgRef,
        className: composedClassName,
        strokeWidth: effectiveStrokeWidth,
        style: inlineStyle,
        ...domPassthrough(rest)
      }
    );
  }
  if (RenderedComponent) {
    return /* @__PURE__ */ jsx(
      RenderedComponent,
      {
        ref: svgRef,
        className: composedClassName,
        strokeWidth: effectiveStrokeWidth,
        style: inlineStyle,
        ...domPassthrough(rest)
      }
    );
  }
  const Fallback = LucideIcons2.HelpCircle;
  return /* @__PURE__ */ jsx(
    Fallback,
    {
      ref: svgRef,
      className: composedClassName,
      strokeWidth: effectiveStrokeWidth,
      style: inlineStyle,
      ...domPassthrough(rest)
    }
  );
};
Icon.displayName = "Icon";
var sliceDataUrlCache = /* @__PURE__ */ new Map();
function useAtlasSliceDataUrl(asset) {
  const [, bump] = React93.useReducer((x) => x + 1, 0);
  if (!isAtlasAsset(asset)) return void 0;
  const key = `${asset.atlas}#${asset.sprite}`;
  const cached = sliceDataUrlCache.get(key);
  if (cached) return cached;
  const atlas = getAtlas(asset.atlas, bump);
  const img = asset?.url ? getSheetImage(asset.url, bump) : null;
  if (!atlas || !img) return void 0;
  const rect = subRectFor(atlas, asset.sprite);
  if (!rect) return void 0;
  const canvas = document.createElement("canvas");
  canvas.width = rect.sw;
  canvas.height = rect.sh;
  const ctx = canvas.getContext("2d");
  if (!ctx) return void 0;
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(img, rect.sx, rect.sy, rect.sw, rect.sh, 0, 0, rect.sw, rect.sh);
  const url = canvas.toDataURL();
  sliceDataUrlCache.set(key, url);
  return url;
}
function AtlasPanel({ asset, borderSlice = 16, borderWidth = 16, mode = "nineSlice", className, style, children, "aria-hidden": ariaHidden, ...rest }) {
  const dataUrl = useAtlasSliceDataUrl(asset);
  const skin = !dataUrl ? {} : mode === "repeat" ? { backgroundImage: `url(${dataUrl})`, backgroundRepeat: "repeat" } : {
    borderStyle: "solid",
    borderWidth,
    borderImageSource: `url(${dataUrl})`,
    borderImageSlice: `${borderSlice} fill`,
    borderImageWidth: borderWidth,
    borderImageRepeat: "stretch",
    imageRendering: "pixelated"
  };
  return /* @__PURE__ */ jsx("span", { ...domPassthrough(rest), "aria-hidden": ariaHidden, className: cn("inline-block", className), style: { ...skin, ...style }, children });
}
AtlasPanel.displayName = "AtlasPanel";
var imageCache = /* @__PURE__ */ new Map();
var imageWaiters = /* @__PURE__ */ new Map();
function getSheetImage(url, onReady) {
  const cached = imageCache.get(url);
  if (cached) return cached;
  (imageWaiters.get(url) ?? imageWaiters.set(url, /* @__PURE__ */ new Set()).get(url)).add(onReady);
  if (!imageCache.has(url)) {
    imageCache.set(url, null);
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      imageCache.set(url, img);
      imageWaiters.get(url)?.forEach((fn) => fn());
      imageWaiters.delete(url);
    };
    img.src = url;
  }
  return null;
}
function AtlasImage({
  asset,
  size: size2,
  width,
  height,
  fill = false,
  fit = "contain",
  alt,
  className,
  style,
  "aria-hidden": ariaHidden,
  ...rest
}) {
  const [, bump] = React93.useReducer((x) => x + 1, 0);
  const canvasRef = React93.useRef(null);
  const sliced = isAtlasAsset(asset);
  const atlas = sliced ? getAtlas(asset.atlas, bump) : void 0;
  const img = sliced && asset?.url ? getSheetImage(asset.url, bump) : null;
  const rect = sliced && atlas ? subRectFor(atlas, asset.sprite) : null;
  React93.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !img || !rect) return;
    canvas.width = rect.sw;
    canvas.height = rect.sh;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.clearRect(0, 0, rect.sw, rect.sh);
    ctx.drawImage(img, rect.sx, rect.sy, rect.sw, rect.sh, 0, 0, rect.sw, rect.sh);
  }, [img, rect?.sx, rect?.sy, rect?.sw, rect?.sh]);
  const w = fill ? "100%" : width ?? size2;
  const h = fill ? "100%" : height ?? size2;
  const boxStyle = {
    ...fill ? { position: "absolute", inset: 0 } : {},
    width: w,
    height: h,
    objectFit: fit,
    imageRendering: "pixelated",
    ...style
  };
  if (!asset?.url) return null;
  if (sliced) {
    if (!rect || !img) {
      return /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: cn("inline-block flex-shrink-0", className), style: { ...boxStyle, objectFit: void 0 } });
    }
    return /* @__PURE__ */ jsx(
      "canvas",
      {
        ref: canvasRef,
        role: ariaHidden ? void 0 : "img",
        "aria-hidden": ariaHidden,
        "aria-label": ariaHidden ? void 0 : alt ?? asset.name ?? asset.category ?? "",
        ...domPassthrough(rest),
        className: cn("flex-shrink-0", className),
        style: boxStyle
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "img",
    {
      src: asset.url,
      alt: alt ?? asset.name ?? asset.category ?? "",
      "aria-hidden": ariaHidden,
      ...domPassthrough(rest),
      ...typeof w === "number" ? { width: w } : {},
      ...typeof h === "number" ? { height: h } : {},
      className: cn("flex-shrink-0", className),
      style: boxStyle
    }
  );
}
AtlasImage.displayName = "AtlasImage";
function isAbsoluteHref(href) {
  return /^[a-z][a-z0-9+.-]*:/i.test(href);
}
function followHref(href, navStack) {
  if (href.startsWith("#")) {
    const target = document.getElementById(decodeURIComponent(href.slice(1)));
    target?.scrollIntoView({ behavior: "smooth" });
    target?.focus({ preventScroll: true });
  } else if (isAbsoluteHref(href) || isInertNavStack(navStack)) {
    window.location.assign(href);
  } else {
    navStack.goTo(href);
  }
}
var variantStyles = {
  primary: [
    "bg-primary text-primary-foreground",
    "border-none",
    "shadow-elevation-interactive",
    "hover:bg-primary-hover hover:shadow-elevation-popover",
    "active:scale-[var(--active-scale)] active:shadow-elevation-pressed"
  ].join(" "),
  secondary: [
    // The accent is often a signature bright that fails as text on a light page.
    "bg-transparent text-foreground",
    "border border-accent",
    "hover:bg-accent hover:text-accent-foreground hover:border-accent",
    "active:scale-[var(--active-scale)]"
  ].join(" "),
  ghost: [
    "bg-transparent text-muted-foreground",
    "border border-transparent",
    "hover:text-primary-foreground hover:bg-primary hover:border-primary",
    "active:scale-[var(--active-scale)]"
  ].join(" "),
  danger: [
    "bg-surface text-foreground",
    "border-[length:var(--border-width)] border-error",
    "shadow-elevation-interactive",
    "hover:bg-error hover:text-error-foreground hover:shadow-elevation-popover",
    "active:scale-[var(--active-scale)] active:shadow-elevation-pressed"
  ].join(" "),
  success: [
    "bg-surface text-foreground",
    "border-[length:var(--border-width)] border-success",
    "shadow-elevation-interactive",
    "hover:bg-success hover:text-success-foreground hover:shadow-elevation-popover",
    "active:scale-[var(--active-scale)] active:shadow-elevation-pressed"
  ].join(" "),
  warning: [
    "bg-surface text-foreground",
    "border-[length:var(--border-width)] border-warning",
    "shadow-elevation-interactive",
    "hover:bg-warning hover:text-warning-foreground hover:shadow-elevation-popover",
    "active:scale-[var(--active-scale)] active:shadow-elevation-pressed"
  ].join(" "),
  // "default" is an alias for secondary
  default: [
    "bg-secondary text-secondary-foreground",
    "border-[length:var(--border-width-thin)] border-border",
    "hover:bg-secondary-hover",
    "active:scale-[var(--active-scale)]"
  ].join(" "),
  link: [
    "bg-transparent text-muted-foreground",
    "border-none shadow-none",
    "underline-offset-4 hover:text-foreground hover:underline"
  ].join(" ")
};
variantStyles.destructive = variantStyles.danger;
var sizeStyles = {
  sm: "h-button-sm px-3 text-sm",
  md: "h-button-md px-4 text-sm",
  lg: "h-button-lg px-6 text-base"
};
var iconSizeStyles = {
  sm: "h-icon-default w-icon-default",
  md: "h-icon-default w-icon-default",
  lg: "h-icon-default w-icon-default"
};
function isIconLike(v) {
  return typeof v.render === "function";
}
function resolveIconProp(value, sizeClass) {
  if (!value) return null;
  if (typeof value === "string") {
    return /* @__PURE__ */ jsx(Icon, { name: value, className: sizeClass });
  }
  if (typeof value === "function") {
    const IconComp = value;
    return /* @__PURE__ */ jsx(IconComp, { className: sizeClass });
  }
  if (React93__default.isValidElement(value)) {
    return value;
  }
  if (typeof value === "object" && value !== null && isIconLike(value)) {
    const IconComp = value;
    return /* @__PURE__ */ jsx(IconComp, { className: sizeClass });
  }
  return value;
}
var Button = React93__default.forwardRef(
  ({
    className,
    variant = "primary",
    size: size2 = "md",
    isLoading = false,
    disabled,
    leftIcon,
    rightIcon,
    icon: iconProp,
    iconRight: iconRightProp,
    iconAsset,
    action,
    actionPayload,
    label,
    href,
    children,
    onClick,
    onFocus,
    onBlur,
    "data-testid": dataTestId,
    ...props
  }, ref) => {
    const eventBus = useEventBus();
    const navStack = useNavStack();
    const { pending, activate } = usePendingAction();
    const busy = isLoading || pending;
    const [focused, setFocused] = React93__default.useState(false);
    const inert = Boolean(disabled) || busy;
    const emitAction = () => {
      if (!action) return;
      activate((pendingKey) => eventBus.emit(`UI:${action}`, actionPayload ?? {}, { pendingKey }));
    };
    const leftIconValue = leftIcon || iconProp;
    const rightIconValue = rightIcon || iconRightProp;
    const px = size2 === "sm" ? 16 : size2 === "lg" ? 20 : 16;
    const resolvedLeftIcon = iconAsset?.url ? /* @__PURE__ */ jsx(AtlasImage, { asset: iconAsset, size: px, alt: iconAsset.name ?? iconAsset.category ?? "", className: "flex-shrink-0" }) : resolveIconProp(leftIconValue, iconSizeStyles[size2]);
    const resolvedRightIcon = resolveIconProp(rightIconValue, iconSizeStyles[size2]);
    const handleClick = (e) => {
      if (inert) {
        e.preventDefault();
        return;
      }
      emitAction();
      onClick?.(e);
    };
    const handleFocus = (e) => {
      setFocused(true);
      onFocus?.(e);
    };
    const handleBlur = (e) => {
      setFocused(false);
      onBlur?.(e);
    };
    const classes = cn(
      "relative inline-flex items-center justify-center gap-2",
      "font-medium",
      "rounded-interactive interactive-border",
      "cursor-pointer",
      variant !== "link" && "chrome-button",
      "transition-all duration-normal",
      "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-offset-[length:var(--focus-ring-offset)]",
      "disabled:opacity-50 disabled:cursor-not-allowed",
      variantStyles[variant],
      variant === "link" ? "h-auto px-0 text-sm" : sizeStyles[size2],
      busy && "cursor-progress",
      disabled && focused && "opacity-50 cursor-not-allowed",
      className
    );
    const testId = dataTestId ?? (action ? actionTestId(action) : void 0);
    const content = /* @__PURE__ */ jsxs(Fragment, { children: [
      busy && /* @__PURE__ */ jsx("span", { className: "almadar-busy-indicator absolute inset-0 flex items-center justify-center", "aria-hidden": "true", children: /* @__PURE__ */ jsx(Loader2, { className: "h-icon-default w-icon-default animate-spin" }) }),
      /* @__PURE__ */ jsxs("span", { className: cn("inline-flex flex-1 min-w-0 items-center [justify-content:inherit] gap-2", busy && "almadar-busy-content"), children: [
        resolvedLeftIcon && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: resolvedLeftIcon }),
        (Array.isArray(children) ? children.length > 0 : Boolean(children)) ? children : label ? /* @__PURE__ */ jsx("span", { ...{ [INLINE_TEXT_ATTR]: "label" }, children: label }) : label,
        resolvedRightIcon && /* @__PURE__ */ jsx("span", { className: "flex-shrink-0", children: resolvedRightIcon })
      ] })
    ] });
    if (href !== void 0 && href !== "") {
      const handleLinkClick = (e) => {
        if (disabled || busy) {
          e.preventDefault();
          return;
        }
        emitAction();
        onClick?.(e);
        if (e.defaultPrevented) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (!href.startsWith("#") && isInertNavStack(navStack)) return;
        e.preventDefault();
        followHref(href, navStack);
      };
      return /* @__PURE__ */ jsx(
        "a",
        {
          ...domPassthrough(props),
          href,
          id: props.id,
          title: props.title,
          style: props.style,
          "aria-label": props["aria-label"],
          "aria-disabled": disabled || busy || void 0,
          "aria-busy": busy || void 0,
          className: classes,
          onClick: handleLinkClick,
          "data-testid": testId,
          children: content
        }
      );
    }
    return /* @__PURE__ */ jsx(
      "button",
      {
        ref,
        type: "button",
        disabled: Boolean(disabled) && !focused,
        "aria-disabled": inert || void 0,
        "aria-busy": busy || void 0,
        className: classes,
        onClick: handleClick,
        onFocus: handleFocus,
        onBlur: handleBlur,
        ...props,
        "data-testid": testId,
        children: content
      }
    );
  }
);
Button.displayName = "Button";
var Dialog = React93__default.forwardRef(
  ({
    role = "dialog",
    "aria-modal": ariaModal = true,
    className,
    children,
    ...rest
  }, ref) => /* @__PURE__ */ jsx(
    "dialog",
    {
      ref,
      role,
      "aria-modal": ariaModal,
      className: cn(className),
      ...rest,
      children
    }
  )
);
Dialog.displayName = "Dialog";
var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
var openStack = /* @__PURE__ */ new Map();
var openSequence = 0;
function isTop(id) {
  let top = null;
  let max = -1;
  for (const [key, seq] of openStack) {
    if (seq > max) {
      max = seq;
      top = key;
    }
  }
  return top === id;
}
function focusables(container) {
  return Array.from(container.querySelectorAll(FOCUSABLE));
}
function useDialogBehavior({ open, containerRef, onEscape, closeOnEscape = true, modal = true, returnFocusRef }) {
  const idRef = useRef(/* @__PURE__ */ Symbol("dialog"));
  const onEscapeRef = useRef(onEscape);
  onEscapeRef.current = onEscape;
  const closeOnEscapeRef = useRef(closeOnEscape);
  closeOnEscapeRef.current = closeOnEscape;
  const seqRef = useRef(null);
  if (open && seqRef.current === null) seqRef.current = ++openSequence;
  if (!open) seqRef.current = null;
  useEffect(() => {
    if (!open) return;
    const id = idRef.current;
    const opener = returnFocusRef?.current ?? (document.activeElement instanceof HTMLElement ? document.activeElement : null);
    openStack.set(id, seqRef.current ?? ++openSequence);
    const container = containerRef.current;
    if (modal && container && !container.contains(document.activeElement)) {
      (focusables(container)[0] ?? container).focus();
    }
    const onKeyDown = (e) => {
      if (!isTop(id)) return;
      if (e.key === "Escape") {
        e.stopPropagation();
        if (closeOnEscapeRef.current) onEscapeRef.current();
        return;
      }
      if (e.key !== "Tab" || !modal) return;
      const el = containerRef.current;
      if (!el) return;
      const items = focusables(el);
      if (items.length === 0) {
        e.preventDefault();
        el.focus();
        return;
      }
      const first = items[0];
      const last = items[items.length - 1];
      const active = document.activeElement;
      if (!el.contains(active)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      openStack.delete(id);
      const active = document.activeElement;
      const current = containerRef.current ?? container;
      const focusInside = current?.contains(active) ?? false;
      const focusLeftWithDialog = focusInside || active === null || active === document.body;
      if (opener && opener.isConnected && focusLeftWithDialog) opener.focus();
    };
  }, [open, containerRef, modal, returnFocusRef]);
}

// lib/portalRoot.ts
function getOrCreatePortalRoot() {
  let root = document.getElementById("ui-slot-portal-root");
  if (!root) {
    root = document.createElement("div");
    root.id = "ui-slot-portal-root";
    root.style.position = "relative";
    root.style.zIndex = "9999";
    document.body.appendChild(root);
  }
  return root;
}
function ThemedPortal({ children, container }) {
  const { theme, mode, vars } = useThemeScope();
  const scoped = theme !== void 0 || vars !== void 0;
  return createPortal(
    scoped ? /* @__PURE__ */ jsx(Box, { "data-theme": theme, className: mode ? `contents ${mode}` : "contents", style: vars, children }) : children,
    container ?? getOrCreatePortalRoot()
  );
}
var sizeClasses2 = {
  sm: "max-w-md",
  md: "max-w-2xl",
  lg: "max-w-3xl",
  xl: "max-w-5xl",
  full: "max-w-full mx-4"
};
var minWidthClasses = {
  sm: "min-w-[min(theme(minWidth.modal-sm),100%)] max-sm:min-w-0",
  md: "min-w-[min(theme(minWidth.modal-md),100%)] max-sm:min-w-0",
  lg: "min-w-[min(theme(minWidth.modal-lg),100%)] max-sm:min-w-0",
  xl: "min-w-[min(theme(minWidth.modal-xl),100%)] max-sm:min-w-0",
  full: "min-w-0"
};
var lookStyles = {
  "centered-card": "",
  "top-sheet": "top-0 rounded-t-none rounded-b-container max-w-full w-full",
  "side-drawer": "right-0 top-0 bottom-0 h-full rounded-l-container rounded-r-none w-[400px] max-w-full",
  "full-screen": "inset-0 rounded-none w-full h-full max-w-full"
};
var Modal = ({
  isOpen = true,
  onClose = () => {
  },
  onExited,
  title,
  children = null,
  footer,
  size: size2 = "md",
  showCloseButton = true,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  className,
  closeEvent,
  swipeDownToClose = true,
  look = "centered-card",
  contained = false,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const modalRef = useRef(null);
  const titleId = useId();
  const [dragY, setDragY] = useState(0);
  const dragStartY = useRef(0);
  const isDragging = useRef(false);
  const { mounted, exiting, className: presenceAnim, onAnimationEnd: handleAnimEnd } = usePresence(isOpen, {
    animation: "modal",
    onExited
  });
  const emitClose = () => {
    if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
    onClose();
  };
  useDialogBehavior({ open: isOpen, containerRef: modalRef, onEscape: emitClose, closeOnEscape });
  useEffect(() => {
    if (contained) return;
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, contained]);
  if (typeof document === "undefined") return null;
  if (!mounted) return null;
  const dialogAnim = presenceAnim ? exiting ? "animate-modal-out" : "animate-modal-in" : "";
  const overlayAnim = presenceAnim ? exiting ? "animate-overlay-out" : "animate-overlay-in" : "";
  const handleClose = emitClose;
  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      handleClose();
    }
  };
  const layer = /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        contained ? "absolute inset-0 z-50" : "fixed inset-0 z-[1000]",
        "bg-scrim",
        "flex items-start justify-center px-4 pb-4",
        contained ? "pt-[10%]" : "pt-[10vh]",
        "max-sm:items-end max-sm:p-0 max-sm:pt-0",
        overlayAnim
      ),
      onClick: handleOverlayClick,
      children: /* @__PURE__ */ jsxs(
        Dialog,
        {
          ref: modalRef,
          ...domPassthrough(rest),
          open: true,
          className: cn(
            // Reset browser-default dialog chrome — we own styling. `static`
            // overrides the user-agent `position: absolute` so the parent
            // flex container's `justify-center` actually centers the dialog
            // (without this, the dialog drops out of flex flow and `m-0`
            // kills the user-agent's `margin: auto` centering, pinning the
            // dialog to top-left).
            "static m-0 p-0 border-0 bg-transparent",
            // Pre-existing dialog frame
            "pointer-events-auto w-full flex flex-col bg-surface surface-material border shadow-elevation-dialog rounded-container",
            // Desktop sizing + viewport-aware floor.
            sizeClasses2[size2],
            minWidthClasses[size2],
            contained ? "max-h-[80%]" : "max-h-[80vh]",
            // Mobile: a bottom sheet — full width, capped at 90vh, square
            // bottom corners, clear of the home indicator.
            "max-sm:max-w-none max-sm:w-full max-sm:max-h-[90vh] max-sm:rounded-b-none max-sm:pb-[env(safe-area-inset-bottom)]",
            lookStyles[look],
            className,
            dialogAnim
          ),
          onAnimationEnd: handleAnimEnd,
          style: dragY > 0 ? {
            transform: `translateY(${dragY}px)`,
            transition: isDragging.current ? "none" : "transform 200ms ease-out"
          } : void 0,
          ...title && !rest["aria-labelledby"] && { "aria-labelledby": titleId },
          children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "hidden max-sm:flex justify-center py-2 cursor-grab active:cursor-grabbing touch-none",
                onPointerDown: (e) => {
                  if (!swipeDownToClose) return;
                  dragStartY.current = e.clientY;
                  isDragging.current = true;
                  e.target.setPointerCapture(e.pointerId);
                },
                onPointerMove: (e) => {
                  if (!isDragging.current) return;
                  const dy = Math.max(0, e.clientY - dragStartY.current);
                  setDragY(dy);
                },
                onPointerUp: () => {
                  if (!isDragging.current) return;
                  isDragging.current = false;
                  if (dragY > 100) {
                    handleClose();
                  }
                  setDragY(0);
                },
                onPointerCancel: () => {
                  isDragging.current = false;
                  setDragY(0);
                },
                children: /* @__PURE__ */ jsx(Box, { className: "w-10 h-1 rounded-full bg-border" })
              }
            ),
            (title || showCloseButton) && /* @__PURE__ */ jsxs(
              Box,
              {
                className: cn(
                  "px-6 py-4 flex items-center justify-between",
                  "border-b-[length:var(--border-width)] border-border"
                ),
                children: [
                  title && /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", id: titleId, children: title }),
                  showCloseButton && /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "ghost",
                      size: "sm",
                      icon: "x",
                      onClick: handleClose,
                      "data-event": "CLOSE",
                      "data-testid": actionTestId("CLOSE"),
                      "aria-label": t("aria.closeModal")
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto p-6", children: /* @__PURE__ */ jsx(SurfaceBoundary, { children }) }),
            footer && /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "px-6 py-4 bg-muted",
                  "border-t-[length:var(--border-width)] border-border"
                ),
                children: footer
              }
            )
          ]
        }
      )
    }
  );
  return contained ? layer : /* @__PURE__ */ jsx(ThemedPortal, { children: layer });
};
Modal.displayName = "Modal";
var Overlay = ({
  isVisible = true,
  onClick,
  className,
  blur = false,
  action,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { mounted, className: animClass, onAnimationEnd } = usePresence(isVisible, { animation: "overlay" });
  if (!mounted) return null;
  const handleClick = (e) => {
    if (action) {
      eventBus.emit(`UI:${action}`, {});
    }
    onClick?.(e);
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "fixed inset-0 z-40 bg-scrim",
        blur && "backdrop-blur-sm",
        animClass,
        className
      ),
      onClick: action || onClick ? handleClick : void 0,
      onAnimationEnd,
      ...domPassthrough(rest),
      "aria-hidden": "true"
    }
  );
};
var sizeWidths = {
  sm: "w-full sm:w-80",
  // 320px
  md: "w-full sm:w-96",
  // 384px
  lg: "w-full sm:max-w-lg",
  // 512px (was 480px, +32)
  xl: "w-full sm:max-w-2xl",
  // 672px (was 640px, +32)
  full: "w-screen"
};
var Drawer = ({
  isOpen = true,
  onExited,
  contained = false,
  onClose = () => {
  },
  title,
  children = null,
  footer,
  position = "right",
  width = "md",
  showCloseButton = true,
  closeOnOverlayClick = true,
  closeOnEscape = true,
  className,
  closeEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const drawerRef = useRef(null);
  const titleId = useId();
  const emitClose = () => {
    if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
    onClose();
  };
  useDialogBehavior({ open: isOpen, containerRef: drawerRef, onEscape: emitClose, closeOnEscape });
  const { mounted, className: drawerAnim, onAnimationEnd } = usePresence(isOpen, { animation: "drawer", onExited });
  useEffect(() => {
    if (contained) return;
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, contained]);
  if (!mounted) return null;
  const handleClose = emitClose;
  const handleOverlayClick = (e) => {
    if (closeOnOverlayClick && e.target === e.currentTarget) {
      handleClose();
    }
  };
  const widthClass = width in sizeWidths ? sizeWidths[width] : "";
  const widthStyle = width in sizeWidths ? void 0 : { width };
  const positionClasses2 = position === "right" ? "right-0 border-l" : "left-0 border-r";
  const drawerSign = position === "right" ? 1 : -1;
  const slideTransform = position === "right" ? "translateX(100%)" : "translateX(-100%)";
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Overlay,
      {
        isVisible: isOpen,
        onClick: handleOverlayClick,
        className: contained ? "absolute z-50" : "z-[60]"
      }
    ),
    /* @__PURE__ */ jsxs(
      Box,
      {
        ref: drawerRef,
        bg: "surface",
        border: true,
        className: cn(
          "shadow-elevation-dialog",
          // Above the page's floating chrome (tool strips, chat pills: z-50), like SidePanel.
          contained ? "absolute top-0 bottom-0 z-50 surface-material" : "fixed top-0 bottom-0 z-[60] surface-material",
          "flex flex-col",
          contained ? "max-h-full" : "max-h-screen",
          positionClasses2,
          widthClass,
          drawerAnim,
          className
        ),
        style: { ...widthStyle, "--motion-drawer-sign": drawerSign, "--motion-drawer-enter-from-transform": slideTransform, "--motion-drawer-exit-to-transform": slideTransform },
        ...domPassthrough(rest),
        role: "dialog",
        "aria-modal": "true",
        onAnimationEnd,
        ...title && !rest["aria-labelledby"] && { "aria-labelledby": titleId },
        children: [
          (title || showCloseButton) && /* @__PURE__ */ jsxs(
            Box,
            {
              className: cn(
                "px-6 py-4 flex items-center justify-between shrink-0",
                "border-b-[length:var(--border-width)] border-border"
              ),
              children: [
                title && /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", id: titleId, children: title }),
                showCloseButton && /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: "x",
                    onClick: handleClose,
                    "data-event": "CLOSE",
                    "data-testid": actionTestId("CLOSE"),
                    "aria-label": t("aria.closeDrawer"),
                    className: cn(!title && "ml-auto")
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto p-6", children: /* @__PURE__ */ jsx(SurfaceBoundary, { children }) }),
          footer && /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "px-6 py-4 shrink-0 bg-muted",
                "border-t-[length:var(--border-width)] border-border"
              ),
              children: footer
            }
          )
        ]
      }
    )
  ] });
};
Drawer.displayName = "Drawer";
var SplitPane = ({
  direction = "horizontal",
  ratio: ratioProp = 50,
  minSize = 100,
  resizable = true,
  left,
  right,
  className,
  leftClassName,
  rightClassName,
  onRatioChange,
  ...rest
}) => {
  const [uncontrolledRatio, setUncontrolledRatio] = useState(ratioProp);
  const ratio = onRatioChange ? ratioProp : uncontrolledRatio;
  const containerRef = useRef(null);
  const isDragging = useRef(false);
  const handlePointerDown = useCallback(
    (e) => {
      if (!resizable) return;
      e.preventDefault();
      isDragging.current = true;
      e.currentTarget.setPointerCapture(e.pointerId);
      const handlePointerMove = (ev) => {
        if (!isDragging.current || !containerRef.current) return;
        const rect = containerRef.current.getBoundingClientRect();
        let newRatio;
        if (direction === "horizontal") {
          const x = ev.clientX - rect.left;
          newRatio = x / rect.width * 100;
        } else {
          const y = ev.clientY - rect.top;
          newRatio = y / rect.height * 100;
        }
        const minRatio = minSize / (direction === "horizontal" ? rect.width : rect.height) * 100;
        const maxRatio = 100 - minRatio;
        newRatio = Math.max(minRatio, Math.min(maxRatio, newRatio));
        if (onRatioChange) {
          onRatioChange(newRatio);
        } else {
          setUncontrolledRatio(newRatio);
        }
      };
      const handlePointerUp = () => {
        isDragging.current = false;
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp);
        document.removeEventListener("pointercancel", handlePointerUp);
      };
      document.addEventListener("pointermove", handlePointerMove);
      document.addEventListener("pointerup", handlePointerUp);
      document.addEventListener("pointercancel", handlePointerUp);
    },
    [direction, minSize, resizable, onRatioChange]
  );
  const isHorizontal = direction === "horizontal";
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      ...domPassthrough(rest),
      className: cn(
        "flex w-full h-full",
        isHorizontal ? "flex-row" : "flex-col",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn("flex flex-col overflow-auto", leftClassName),
            style: {
              [isHorizontal ? "width" : "height"]: `${ratio}%`,
              flexShrink: 0
            },
            children: left
          }
        ),
        resizable && /* @__PURE__ */ jsx(
          "div",
          {
            onPointerDown: handlePointerDown,
            className: cn(
              "flex-shrink-0 bg-border transition-colors touch-none",
              isHorizontal ? "w-1 cursor-col-resize hover:w-1.5 hover:bg-muted-foreground" : "h-1 cursor-row-resize hover:h-1.5 hover:bg-muted-foreground"
            )
          }
        ),
        /* @__PURE__ */ jsx("div", { className: cn("flex flex-col flex-1 min-h-0 min-w-0 overflow-auto", rightClassName), children: right })
      ]
    }
  );
};
SplitPane.displayName = "SplitPane";
var TRIGGER_GAP = 8;
var arrowClasses = {
  top: "top-full left-1/2 -translate-x-1/2 border-t-primary border-l-transparent border-r-transparent border-b-transparent",
  bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-primary border-l-transparent border-r-transparent border-t-transparent",
  left: "left-full top-1/2 -translate-y-1/2 border-l-primary border-t-transparent border-b-transparent border-r-transparent",
  right: "right-full top-1/2 -translate-y-1/2 border-r-primary border-t-transparent border-b-transparent border-l-transparent"
};
function computeTooltipStyle(position, triggerRect) {
  switch (position) {
    case "bottom":
      return {
        left: triggerRect.left + triggerRect.width / 2,
        top: triggerRect.bottom + TRIGGER_GAP,
        transform: "translateX(-50%)"
      };
    case "left":
      return {
        left: triggerRect.left - TRIGGER_GAP,
        top: triggerRect.top + triggerRect.height / 2,
        transform: "translate(-100%, -50%)"
      };
    case "right":
      return {
        left: triggerRect.right + TRIGGER_GAP,
        top: triggerRect.top + triggerRect.height / 2,
        transform: "translateY(-50%)"
      };
    case "top":
    default:
      return {
        left: triggerRect.left + triggerRect.width / 2,
        top: triggerRect.top - TRIGGER_GAP,
        transform: "translate(-50%, -100%)"
      };
  }
}
var Tooltip = ({
  content,
  children,
  position = "top",
  delay = 200,
  hideDelay = 0,
  showArrow = true,
  className,
  ...rest
}) => {
  const tooltipId = useId();
  const [isVisible, setIsVisible] = useState(false);
  const [triggerRect, setTriggerRect] = useState(null);
  const triggerRef = useRef(null);
  const tooltipRef = useRef(null);
  const showTimeoutRef = useRef(null);
  const hideTimeoutRef = useRef(null);
  const updatePosition = () => {
    if (triggerRef.current) {
      setTriggerRect(triggerRef.current.getBoundingClientRect());
    }
  };
  const handleMouseEnter = () => {
    if (hideTimeoutRef.current) {
      clearTimeout(hideTimeoutRef.current);
    }
    updatePosition();
    showTimeoutRef.current = setTimeout(() => {
      setIsVisible(true);
    }, delay);
  };
  const handleMouseLeave = () => {
    if (showTimeoutRef.current) {
      clearTimeout(showTimeoutRef.current);
    }
    hideTimeoutRef.current = setTimeout(() => {
      setIsVisible(false);
    }, hideDelay);
  };
  const { triggerProps } = useTapReveal({
    onReveal: handleMouseEnter,
    onDismiss: handleMouseLeave,
    refs: [triggerRef, tooltipRef]
  });
  useLayoutEffect(() => {
    if (isVisible) {
      updatePosition();
    }
  }, [isVisible]);
  useEffect(() => {
    if (!isVisible) return;
    const onKeyDown = (e) => {
      if (e.key !== "Escape") return;
      if (showTimeoutRef.current) clearTimeout(showTimeoutRef.current);
      setIsVisible(false);
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);
  useEffect(() => {
    return () => {
      if (showTimeoutRef.current) clearTimeout(showTimeoutRef.current);
      if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
    };
  }, []);
  const triggerElement = React93__default.isValidElement(children) ? children : /* @__PURE__ */ jsx("span", { children });
  const child = triggerElement;
  const childRef = child.props.ref ?? child.ref;
  const setTriggerRef = (el) => {
    triggerRef.current = el;
    if (typeof childRef === "function") childRef(el);
    else if (childRef) childRef.current = el;
  };
  const trigger = React93__default.cloneElement(child, {
    ref: setTriggerRef,
    "aria-describedby": isVisible ? [child.props["aria-describedby"], tooltipId].filter(Boolean).join(" ") : child.props["aria-describedby"],
    onMouseEnter: (e) => {
      child.props.onMouseEnter?.(e);
      handleMouseEnter();
    },
    onMouseLeave: (e) => {
      child.props.onMouseLeave?.(e);
      handleMouseLeave();
    },
    onFocus: (e) => {
      child.props.onFocus?.(e);
      handleMouseEnter();
    },
    onBlur: (e) => {
      child.props.onBlur?.(e);
      handleMouseLeave();
    },
    onPointerDown: (e) => {
      triggerProps.onPointerDown(e);
      child.props.onPointerDown?.(e);
    }
  });
  const tooltipContent = isVisible && triggerRect ? /* @__PURE__ */ jsxs(
    "div",
    {
      ref: tooltipRef,
      ...domPassthrough(rest),
      id: tooltipId,
      className: cn(
        "fixed z-50 px-3 py-2 max-w-xs",
        "bg-primary text-primary-foreground",
        "shadow-elevation-popover rounded-container",
        "text-sm pointer-events-none",
        "break-words whitespace-normal",
        "h-auto min-h-fit",
        className
      ),
      style: computeTooltipStyle(position, triggerRect),
      role: "tooltip",
      children: [
        /* @__PURE__ */ jsx("div", { className: "w-full break-words whitespace-normal h-auto", children: typeof content === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary-foreground break-words whitespace-normal", children: content }) : /* @__PURE__ */ jsx("div", { className: "break-words whitespace-normal", children: content }) }),
        showArrow && /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "absolute w-0 h-0 border-heavy",
              arrowClasses[position]
            )
          }
        )
      ]
    }
  ) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    trigger,
    typeof window !== "undefined" && tooltipContent ? /* @__PURE__ */ jsx(ThemedPortal, { children: tooltipContent }) : tooltipContent
  ] });
};
Tooltip.displayName = "Tooltip";
var IconButton = React93__default.forwardRef(
  ({ icon, label, tooltipPosition = "right", variant = "ghost", size: size2 = "sm", className, ...rest }, ref) => {
    const touch = useMediaQuery("(hover: none)");
    const button = /* @__PURE__ */ jsx(
      Button,
      {
        ref,
        variant,
        size: size2,
        "aria-label": label,
        className: `justify-center px-0 aspect-square ${className ?? ""}`,
        ...rest,
        children: /* @__PURE__ */ jsx(Icon, { icon, size: "sm" })
      }
    );
    return touch ? button : /* @__PURE__ */ jsx(Tooltip, { content: label, position: tooltipPosition, children: button });
  }
);
IconButton.displayName = "IconButton";
var DockLayoutContext = createContext({ compact: false, showPanel: () => void 0, closeMenu: () => void 0, showSecondary: () => void 0 });
function useDockLayout() {
  return useContext(DockLayoutContext);
}
var COMPACT_MEDIA_QUERY = "(max-width: 1023.98px)";
function useCompactLayout() {
  return useMediaQuery(COMPACT_MEDIA_QUERY);
}
var DESKTOP_CONTEXT = { compact: false, showPanel: () => void 0, closeMenu: () => void 0, showSecondary: () => void 0 };
function useCollapsed(controlled, onChange) {
  const [local, setLocal] = useState(false);
  const collapsed = controlled ?? local;
  const set = (next) => {
    onChange?.(next);
    if (controlled === void 0) setLocal(next);
  };
  return [collapsed, set];
}
var TOGGLE_ICONS = {
  sidebar: { open: "panel-left-close", closed: "panel-left-open", position: "right" },
  "secondary-sidebar": { open: "panel-right-close", closed: "panel-right-open", position: "left" },
  "bottom-panel": { open: "panel-bottom-close", closed: "panel-bottom-open", position: "top" }
};
var PanelToggle = ({ region, collapsed, onToggle }) => {
  const { t } = useTranslate();
  const icons = TOGGLE_ICONS[region];
  return /* @__PURE__ */ jsx(
    IconButton,
    {
      icon: collapsed ? icons.closed : icons.open,
      label: t(collapsed ? `dockLayout.expand.${region}` : `dockLayout.collapse.${region}`),
      tooltipPosition: icons.position,
      "aria-expanded": !collapsed,
      "data-testid": `dock-collapse-${region}`,
      className: "w-7 h-7",
      onClick: onToggle
    }
  );
};
var DockLayout = ({
  rail,
  sidebar,
  main,
  bottomPanel,
  statusBar,
  secondarySidebar,
  railWidth,
  secondarySidebarWidth,
  sidebarCollapsed: sidebarCollapsedProp,
  onSidebarCollapsedChange,
  sidebarWidth,
  onSidebarWidthChange,
  sidebarMinSize,
  bottomPanelCollapsed: bottomPanelCollapsedProp,
  onBottomPanelCollapsedChange,
  bottomPanelHeight,
  onBottomPanelHeightChange,
  bottomPanelMinSize,
  secondarySidebarCollapsed: secondarySidebarCollapsedProp,
  onSecondarySidebarCollapsedChange,
  compact: compactProp,
  secondarySidebarLabel,
  secondarySidebarIcon,
  bottomPanelLabel,
  bottomPanelIcon,
  topBarActions,
  className,
  railClassName,
  sidebarClassName,
  mainClassName,
  bottomPanelClassName,
  statusBarClassName,
  secondarySidebarClassName,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const narrow = useCompactLayout();
  const compact = compactProp ?? narrow;
  if (compact) {
    return /* @__PURE__ */ jsx(
      CompactDock,
      {
        rail,
        sidebar,
        main,
        bottomPanel,
        statusBar,
        secondarySidebar,
        secondarySidebarLabel,
        secondarySidebarIcon,
        bottomPanelLabel,
        bottomPanelIcon,
        topBarActions,
        className,
        mainClassName,
        statusBarClassName,
        a11y
      }
    );
  }
  return /* @__PURE__ */ jsx(
    DesktopDock,
    {
      ...{
        rail,
        sidebar,
        main,
        bottomPanel,
        statusBar,
        secondarySidebar,
        railWidth,
        secondarySidebarWidth,
        sidebarCollapsedProp,
        onSidebarCollapsedChange,
        sidebarWidth,
        onSidebarWidthChange,
        sidebarMinSize,
        bottomPanelCollapsedProp,
        onBottomPanelCollapsedChange,
        bottomPanelHeight,
        onBottomPanelHeightChange,
        bottomPanelMinSize,
        secondarySidebarCollapsedProp,
        onSecondarySidebarCollapsedChange,
        className,
        railClassName,
        sidebarClassName,
        mainClassName,
        bottomPanelClassName,
        statusBarClassName,
        secondarySidebarClassName,
        a11y
      }
    }
  );
};
var CompactDock = ({
  rail,
  sidebar,
  main,
  bottomPanel,
  statusBar,
  secondarySidebar,
  secondarySidebarLabel,
  secondarySidebarIcon,
  bottomPanelLabel,
  bottomPanelIcon,
  topBarActions,
  className,
  mainClassName,
  statusBarClassName,
  a11y
}) => {
  const { t } = useTranslate();
  const [open, setOpen] = useState(null);
  const [leftView, setLeftView] = useState("menu");
  const context = {
    compact: true,
    showPanel: () => setLeftView("panel"),
    closeMenu: () => setOpen(null),
    showSecondary: () => {
      if (secondarySidebar) setOpen("secondary");
    }
  };
  const openLeft = () => {
    setLeftView(rail ? "menu" : "panel");
    setOpen("left");
  };
  const close = () => setOpen(null);
  const leftContent = leftView === "menu" && rail ? rail : /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "h-full min-h-0", children: [
    rail && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-shrink-0 items-center px-2 py-1 border-b border-border", children: /* @__PURE__ */ jsx(IconButton, { icon: "arrow-left", label: t("dockLayout.backToMenu"), tooltipPosition: "bottom", "data-testid": "dock-drawer-back", className: "w-10 h-10", onClick: () => setLeftView("menu") }) }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1 min-h-0 overflow-auto", children: sidebar })
  ] });
  return /* @__PURE__ */ jsx(DockLayoutContext.Provider, { value: context, children: /* @__PURE__ */ jsxs(VStack, { gap: "none", ...a11y, className: cn("w-full h-full overflow-hidden", className), children: [
    (rail || sidebar || secondarySidebar || bottomPanel || topBarActions) && /* @__PURE__ */ jsxs(Box, { className: "flex flex-shrink-0 items-center gap-1 px-2 py-1 border-b border-border bg-surface", "data-testid": "dock-top-bar", children: [
      (rail || sidebar) && /* @__PURE__ */ jsx(IconButton, { icon: "menu", label: t("dockLayout.openMenu"), tooltipPosition: "bottom", "data-testid": "dock-menu", className: "w-10 h-10", onClick: openLeft }),
      /* @__PURE__ */ jsx(Box, { className: "flex-1" }),
      bottomPanel && /* @__PURE__ */ jsx(IconButton, { icon: bottomPanelIcon ?? "panel-bottom-open", label: bottomPanelLabel ?? t("dockLayout.expand.bottom-panel"), tooltipPosition: "bottom", "data-testid": "dock-open-bottom-panel", className: "w-10 h-10", onClick: () => setOpen("bottom") }),
      secondarySidebar && /* @__PURE__ */ jsx(IconButton, { icon: secondarySidebarIcon ?? "panel-right-open", label: secondarySidebarLabel ?? t("dockLayout.expand.secondary-sidebar"), tooltipPosition: "bottom", "data-testid": "dock-open-secondary-sidebar", className: "w-10 h-10", onClick: () => setOpen("secondary") }),
      topBarActions
    ] }),
    /* @__PURE__ */ jsx(Box, { className: cn("flex-1 min-h-0 min-w-0 overflow-auto", mainClassName), children: main }),
    statusBar && /* @__PURE__ */ jsx(Box, { className: cn("flex-shrink-0 border-t border-border bg-background", statusBarClassName), children: statusBar }),
    (rail || sidebar) && /* @__PURE__ */ jsx(Drawer, { isOpen: open === "left", onClose: close, position: "left", width: "md", title: t("dockLayout.menu"), children: open === "left" ? leftContent : null }),
    secondarySidebar && /* @__PURE__ */ jsx(Drawer, { isOpen: open === "secondary", onClose: close, position: "right", width: "md", title: secondarySidebarLabel ?? t("dockLayout.expand.secondary-sidebar"), children: open === "secondary" ? secondarySidebar : null }),
    bottomPanel && /* @__PURE__ */ jsx(Drawer, { isOpen: open === "bottom", onClose: close, position: "right", width: "md", title: bottomPanelLabel ?? t("dockLayout.expand.bottom-panel"), children: open === "bottom" ? bottomPanel : null })
  ] }) });
};
var DesktopDock = ({
  rail,
  sidebar,
  main,
  bottomPanel,
  statusBar,
  secondarySidebar,
  railWidth,
  secondarySidebarWidth = 280,
  sidebarCollapsedProp,
  onSidebarCollapsedChange,
  sidebarWidth = 20,
  onSidebarWidthChange,
  sidebarMinSize = 160,
  bottomPanelCollapsedProp,
  onBottomPanelCollapsedChange,
  bottomPanelHeight = 30,
  onBottomPanelHeightChange,
  bottomPanelMinSize = 120,
  secondarySidebarCollapsedProp,
  onSecondarySidebarCollapsedChange,
  className,
  railClassName,
  sidebarClassName,
  mainClassName,
  bottomPanelClassName,
  statusBarClassName,
  secondarySidebarClassName,
  a11y
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useCollapsed(sidebarCollapsedProp, onSidebarCollapsedChange);
  const [bottomPanelCollapsed, setBottomPanelCollapsed] = useCollapsed(bottomPanelCollapsedProp, onBottomPanelCollapsedChange);
  const [secondarySidebarCollapsed, setSecondarySidebarCollapsed] = useCollapsed(secondarySidebarCollapsedProp, onSecondarySidebarCollapsedChange);
  const showSidebar = Boolean(sidebar) && !sidebarCollapsed;
  const showBottomPanel = Boolean(bottomPanel) && !bottomPanelCollapsed;
  const showSecondarySidebar = Boolean(secondarySidebar) && !secondarySidebarCollapsed;
  const sideGutter = (region, collapsed, toggle, edge) => /* @__PURE__ */ jsx(Box, { className: cn("flex-shrink-0 w-8 flex flex-col items-center pt-1 bg-surface", edge === "l" ? "border-l border-border" : "border-r border-border"), children: /* @__PURE__ */ jsx(PanelToggle, { region, collapsed, onToggle: toggle }) });
  const centerRow = /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "flex-1 min-h-0 min-w-0", children: [
    /* @__PURE__ */ jsx(Box, { className: cn("flex-1 min-w-0 min-h-0 overflow-auto", mainClassName), children: main }),
    secondarySidebar && sideGutter("secondary-sidebar", secondarySidebarCollapsed, () => setSecondarySidebarCollapsed(!secondarySidebarCollapsed), "l"),
    showSecondarySidebar && /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex-shrink-0 h-full overflow-auto border-l border-border",
          secondarySidebarClassName
        ),
        style: { width: secondarySidebarWidth },
        children: secondarySidebar
      }
    )
  ] });
  const sidebarAndCenter = showSidebar ? /* @__PURE__ */ jsx(
    SplitPane,
    {
      direction: "horizontal",
      ratio: sidebarWidth,
      onRatioChange: onSidebarWidthChange,
      minSize: sidebarMinSize,
      resizable: true,
      left: /* @__PURE__ */ jsx(Box, { className: cn("h-full overflow-auto", sidebarClassName), children: sidebar }),
      right: /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "h-full min-w-0", children: [
        sideGutter("sidebar", false, () => setSidebarCollapsed(true), "r"),
        centerRow
      ] }),
      className: "flex-1 min-h-0 min-w-0"
    }
  ) : sidebar ? /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "flex-1 min-h-0 min-w-0", children: [
    sideGutter("sidebar", true, () => setSidebarCollapsed(false), "r"),
    centerRow
  ] }) : centerRow;
  const bottomGutter = bottomPanel ? /* @__PURE__ */ jsx(HStack, { gap: "none", className: "flex-shrink-0 h-8 items-center justify-end px-1 border-t border-border bg-surface", children: /* @__PURE__ */ jsx(PanelToggle, { region: "bottom-panel", collapsed: bottomPanelCollapsed, onToggle: () => setBottomPanelCollapsed(!bottomPanelCollapsed) }) }) : null;
  const body = /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "flex-1 min-h-0 min-w-0", children: [
    rail && /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex-shrink-0 min-h-0 overflow-y-auto overflow-x-hidden border-r border-border",
          railClassName
        ),
        style: { width: railWidth },
        children: rail
      }
    ),
    sidebarAndCenter
  ] });
  const bodyPlusBottom = showBottomPanel ? /* @__PURE__ */ jsx(
    SplitPane,
    {
      direction: "vertical",
      ratio: 100 - bottomPanelHeight,
      onRatioChange: (topRatio) => onBottomPanelHeightChange?.(100 - topRatio),
      minSize: bottomPanelMinSize,
      resizable: true,
      left: body,
      right: /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "h-full", children: [
        bottomGutter,
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-1 min-h-0 overflow-auto",
              bottomPanelClassName
            ),
            children: bottomPanel
          }
        )
      ] }),
      className: "flex-1 min-h-0"
    }
  ) : bottomPanel ? /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-h-0", children: [
    body,
    bottomGutter
  ] }) : body;
  return /* @__PURE__ */ jsx(DockLayoutContext.Provider, { value: DESKTOP_CONTEXT, children: /* @__PURE__ */ jsxs(VStack, { gap: "none", ...a11y, className: cn("w-full h-full overflow-hidden", className), children: [
    bodyPlusBottom,
    statusBar && /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex-shrink-0 border-t border-border bg-background",
          statusBarClassName
        ),
        children: statusBar
      }
    )
  ] }) });
};
DockLayout.displayName = "DockLayout";
var PAGE_IN = "animate-page-in";
var PageTransitionScopeContext = createContext(null);
var PageTransition = ({ locationKey, children, className, ...rest }) => {
  const claimEnclosing = useContext(PageTransitionScopeContext);
  const [claims, setClaims] = useState(0);
  const claim = useCallback(() => {
    setClaims((c) => c + 1);
    return () => setClaims((c) => c - 1);
  }, []);
  useLayoutEffect(() => claimEnclosing?.(), [claimEnclosing]);
  const owns = claims === 0 && isMotionEnabled();
  const ref = useRef(null);
  const lastKey = useRef(locationKey);
  useLayoutEffect(() => {
    if (lastKey.current === locationKey) return;
    lastKey.current = locationKey;
    const el = ref.current;
    if (!el || !owns) return;
    el.classList.remove(PAGE_IN);
    void el.offsetWidth;
    el.classList.add(PAGE_IN);
  }, [locationKey, owns]);
  return /* @__PURE__ */ jsx(PageTransitionScopeContext.Provider, { value: claim, children: /* @__PURE__ */ jsx(Box, { ref, ...domPassthrough(rest), "data-page-transition": owns ? "owner" : "claimed", className: cn(owns && PAGE_IN, className), children }) });
};
PageTransition.displayName = "PageTransition";
var variantStyles2 = {
  default: [
    "bg-muted text-foreground",
    "border-[length:var(--border-width-thin)] border-border"
  ].join(" "),
  primary: "bg-primary text-primary-foreground",
  secondary: "bg-secondary text-secondary-foreground",
  success: [
    "bg-success/10 text-foreground",
    "border-[length:var(--border-width)] border-success"
  ].join(" "),
  warning: [
    "bg-warning/10 text-foreground",
    "border-[length:var(--border-width)] border-warning"
  ].join(" "),
  danger: [
    "bg-error/10 text-foreground",
    "border-[length:var(--border-width)] border-error"
  ].join(" "),
  error: [
    "bg-error/10 text-foreground",
    "border-[length:var(--border-width)] border-error"
  ].join(" "),
  info: [
    "bg-info/10 text-foreground",
    "border-[length:var(--border-width)] border-info"
  ].join(" "),
  neutral: [
    "bg-muted text-muted-foreground",
    "border-[length:var(--border-width-thin)] border-border"
  ].join(" ")
};
var sizeStyles2 = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-1 text-sm",
  lg: "px-3 py-1.5 text-base"
};
var Badge = React93__default.forwardRef(
  ({ className, variant = "default", size: size2 = "sm", amount, label, icon, iconAsset, children, onRemove, removeLabel, onClick, ...props }, ref) => {
    const { t } = useTranslate();
    const iconSizes3 = {
      sm: "h-icon-default w-icon-default",
      md: "h-icon-default w-icon-default",
      lg: "h-icon-default w-icon-default"
    };
    const iconPx = size2 === "lg" ? 20 : 16;
    const resolvedIcon = iconAsset?.url ? /* @__PURE__ */ jsx(AtlasImage, { asset: iconAsset, size: iconPx, alt: iconAsset.name ?? iconAsset.category ?? "", className: "flex-shrink-0" }) : typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: iconSizes3[size2] }) : icon ? /* @__PURE__ */ jsx(Icon, { icon, className: iconSizes3[size2] }) : null;
    const hasText = Boolean(children) || amount != null || label !== void 0 && label !== null && label !== "";
    if (!hasText && !resolvedIcon && !onRemove) return null;
    const text = typeof children === "string" || typeof children === "number" ? String(children) : amount != null ? `${label ? `${label} ` : ""}${amount}` : label !== void 0 && label !== null ? String(label) : "";
    const removeName = removeLabel ?? `${t("common.remove")}${text ? `: ${text}` : ""}`;
    const body = /* @__PURE__ */ jsxs(Fragment, { children: [
      resolvedIcon,
      children || (amount != null ? `${label ? `${label} ` : ""}${amount}` : label ? /* @__PURE__ */ jsx("span", { ...{ [INLINE_TEXT_ATTR]: "label" }, children: label }) : label)
    ] });
    return /* @__PURE__ */ jsxs(
      "span",
      {
        ref,
        className: cn(
          "inline-flex items-center gap-1 font-bold rounded-pill",
          variantStyles2[variant],
          sizeStyles2[size2],
          onRemove && "pr-1",
          className
        ),
        ...props,
        children: [
          onClick ? /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick,
              className: "inline-flex items-center gap-1 rounded-pill focus:outline-none focus-visible:ring-1 focus-visible:ring-ring",
              children: body
            }
          ) : body,
          onRemove ? /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              "aria-label": removeName,
              onClick: (e) => {
                e.stopPropagation();
                onRemove();
              },
              className: cn(
                "inline-flex items-center justify-center rounded-pill",
                "hover:bg-foreground/10 focus:outline-none focus-visible:ring-1 focus-visible:ring-ring",
                "transition-colors",
                size2 === "sm" ? "w-4 h-4 ml-0.5" : size2 === "md" ? "w-5 h-5 ml-1" : "w-6 h-6 ml-1"
              ),
              children: /* @__PURE__ */ jsx(X, { className: iconSizes3[size2] })
            }
          ) : null
        ]
      }
    );
  }
);
Badge.displayName = "Badge";
var variantClasses = {
  success: "bg-card border-[length:var(--border-width)] border-success",
  error: "bg-card border-[length:var(--border-width)] border-error",
  info: "bg-card border-[length:var(--border-width)] border-info",
  warning: "bg-card border-[length:var(--border-width)] border-warning"
};
var iconMap = {
  success: "check-circle",
  error: "alert-circle",
  info: "info",
  warning: "alert-triangle"
};
var iconColors = {
  success: "text-success",
  error: "text-error",
  info: "text-info",
  warning: "text-warning"
};
var Toast = ({
  variant = "info",
  message,
  title,
  duration = 5e3,
  dismissible = true,
  onDismiss,
  actionLabel,
  onAction,
  badge,
  className,
  dismissEvent,
  actionEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [leaving, setLeaving] = useState(false);
  const doRealDismiss = () => {
    if (dismissEvent) eventBus.emit(`UI:${dismissEvent}`, {});
    onDismiss?.();
  };
  const handleDismiss = () => {
    if (leaving) return;
    setLeaving(true);
  };
  const handleAction = () => {
    if (actionEvent) eventBus.emit(`UI:${actionEvent}`, {});
    onAction?.();
  };
  const handleAnimEnd = (e) => {
    if (e.target !== e.currentTarget) return;
    if (leaving) doRealDismiss();
  };
  const hasAction = Boolean(actionLabel) && Boolean(onAction || actionEvent);
  const [paused, setPaused] = useState(false);
  const remainingRef = useRef(duration);
  useEffect(() => {
    remainingRef.current = duration;
  }, [duration]);
  useEffect(() => {
    if (duration <= 0 || hasAction || paused || !onDismiss && !dismissEvent) {
      return;
    }
    const startedAt = Date.now();
    const timer = setTimeout(() => {
      handleDismiss();
    }, remainingRef.current);
    return () => {
      clearTimeout(timer);
      remainingRef.current = Math.max(0, remainingRef.current - (Date.now() - startedAt));
    };
  }, [duration, hasAction, paused, onDismiss, dismissEvent]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        // `min-w-[300px]` only kicks in at `sm:` and above so a phone
        // viewport doesn't get a toast wider than the screen near the
        // edge. `max-w-[calc(100vw-2rem)]` clamps to viewport too.
        "border-l-heavy p-4 shadow-elevation-toast min-w-0 sm:min-w-[300px] max-w-md max-w-[calc(100vw-2rem)]",
        "rounded-container surface-material",
        leaving ? "animate-toast-out" : "animate-toast-in",
        variantClasses[variant],
        className
      ),
      role: variant === "error" || variant === "warning" ? "alert" : "status",
      onAnimationEnd: handleAnimEnd,
      onMouseEnter: () => setPaused(true),
      onMouseLeave: () => setPaused(false),
      onFocus: () => setPaused(true),
      onBlur: () => setPaused(false),
      children: /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-3", children: [
        /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 mt-0.5", children: /* @__PURE__ */ jsx(
          Icon,
          {
            name: iconMap[variant],
            size: "md",
            className: iconColors[variant]
          }
        ) }),
        /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
          title && /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "mb-1", children: title }),
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-sm", children: message }),
          actionLabel && (onAction || actionEvent) && /* @__PURE__ */ jsx(Box, { className: "mt-3", children: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleAction, children: actionLabel }) })
        ] }),
        /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-2 flex-shrink-0", children: [
          badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: badge }),
          dismissible && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "x",
              onClick: handleDismiss,
              "aria-label": t("aria.closeToast"),
              className: "flex-shrink-0"
            }
          )
        ] })
      ] })
    }
  );
};
Toast.displayName = "Toast";
var slotLog = createLogger("almadar:ui:slot-render");
var refIds = /* @__PURE__ */ new WeakMap();
var nextRefId = 1;
function refId(obj) {
  if (obj === null || obj === void 0 || typeof obj !== "object") return null;
  const existing = refIds.get(obj);
  if (existing !== void 0) return existing;
  const id = nextRefId++;
  refIds.set(obj, id);
  return id;
}
var SlotContainedContext = createContext(false);
function buildForkPaths(x, y, branches, scale) {
  const inLength = 30 * scale;
  const outLength = 30 * scale;
  const fanSpread = 20 * scale;
  const junctionX = x + inLength;
  const paths = [];
  paths.push(`M ${x} ${y} L ${junctionX} ${y}`);
  for (let i = 0; i < branches; i++) {
    const fraction = branches === 1 ? 0 : i / (branches - 1) * 2 - 1;
    const endY = y + fraction * fanSpread;
    const endX = junctionX + outLength;
    const cpX = junctionX + outLength * 0.5;
    paths.push(`M ${junctionX} ${y} C ${cpX} ${y} ${cpX} ${endY} ${endX} ${endY}`);
  }
  return paths;
}
function buildMergePaths(x, y, branches, scale) {
  const inLength = 30 * scale;
  const outLength = 30 * scale;
  const fanSpread = 20 * scale;
  const junctionX = x + inLength;
  const paths = [];
  for (let i = 0; i < branches; i++) {
    const fraction = branches === 1 ? 0 : i / (branches - 1) * 2 - 1;
    const startY = y + fraction * fanSpread;
    const cpX = x + inLength * 0.5;
    paths.push(`M ${x} ${startY} C ${cpX} ${startY} ${cpX} ${y} ${junctionX} ${y}`);
  }
  paths.push(`M ${junctionX} ${y} L ${junctionX + outLength} ${y}`);
  return paths;
}
function buildDiamondPoints(x, y, scale) {
  const w = 20 * scale;
  const h = 14 * scale;
  return [
    `${x + w} ${y}`,
    `${x + w * 2} ${y + h}`,
    `${x + w} ${y + h * 2}`,
    `${x} ${y + h}`
  ].join(" ");
}
var SvgBranch = ({
  x = 5,
  y = 50,
  variant = "fork",
  branches = 2,
  size: size2 = 1,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  let inner;
  if (variant === "diamond") {
    const points = buildDiamondPoints(x, y, size2);
    inner = /* @__PURE__ */ jsx("g", { ...asRoot ? void 0 : a11y, className, opacity, children: /* @__PURE__ */ jsx(
      "polygon",
      {
        points,
        fill: "none",
        stroke: color,
        strokeWidth: 2,
        strokeLinejoin: "round"
      }
    ) });
  } else {
    const paths = variant === "fork" ? buildForkPaths(x, y, branches, size2) : buildMergePaths(x, y, branches, size2);
    inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
      paths.map((d, i) => /* @__PURE__ */ jsx(
        "path",
        {
          d,
          fill: "none",
          stroke: color,
          strokeWidth: 2,
          strokeLinecap: "round"
        },
        i
      )),
      variant === "fork" && /* @__PURE__ */ jsx("circle", { cx: x + 30 * size2, cy: y, r: 3, fill: color }),
      variant === "merge" && /* @__PURE__ */ jsx("circle", { cx: x + 30 * size2, cy: y, r: 3, fill: color })
    ] });
  }
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return /* @__PURE__ */ jsx(Fragment, { children: inner });
};
SvgBranch.displayName = "SvgBranch";
var SvgConnection = ({
  x1 = 10,
  y1 = 50,
  x2 = 90,
  y2 = 50,
  variant = "solid",
  color = "var(--color-primary)",
  strokeWidth = 1.5,
  opacity = 1,
  className,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const dashProps = variant === "solid" ? {} : {
    strokeDasharray: "8 6"
  };
  const inner = /* @__PURE__ */ jsx(
    "line",
    {
      ...asRoot ? void 0 : a11y,
      className: [
        variant === "animated" ? "almadar-svg-flow-dash" : void 0,
        className
      ].filter(Boolean).join(" ") || void 0,
      x1,
      y1,
      x2,
      y2,
      stroke: color,
      strokeWidth,
      strokeLinecap: "round",
      opacity,
      ...dashProps
    }
  );
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgConnection.displayName = "SvgConnection";
var flowIdCounter = 0;
var DEFAULT_POINTS = [[10, 50], [50, 20], [90, 50]];
var SvgFlow = ({
  points = DEFAULT_POINTS,
  color = "var(--color-primary)",
  strokeWidth = 1.5,
  animated = false,
  opacity = 1,
  className,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const markerId = React93__default.useMemo(() => {
    flowIdCounter += 1;
    return `almadar-flow-arrow-${flowIdCounter}`;
  }, []);
  if (points.length < 2) {
    return null;
  }
  const pathData = points.map((pt, i) => `${i === 0 ? "M" : "L"}${pt[0]},${pt[1]}`).join(" ");
  const inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
      "marker",
      {
        id: markerId,
        markerWidth: "8",
        markerHeight: "6",
        refX: "7",
        refY: "3",
        orient: "auto",
        markerUnits: "strokeWidth",
        children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,3 L0,6 Z", fill: color })
      }
    ) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: pathData,
        fill: "none",
        stroke: color,
        strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        markerEnd: `url(#${markerId})`,
        className: animated ? "almadar-svg-flow-dash" : void 0,
        strokeDasharray: animated ? "8 6" : void 0
      }
    )
  ] });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgFlow.displayName = "SvgFlow";
var SvgGrid = ({
  x = 10,
  y = 10,
  cols = 4,
  rows: rows2 = 3,
  spacing = 20,
  nodeRadius = 3,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  highlights = [],
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const highlightSet = new Set(highlights);
  const inner = /* @__PURE__ */ jsx("g", { ...asRoot ? void 0 : a11y, className, opacity, children: Array.from({ length: rows2 }).map(
    (_, row) => Array.from({ length: cols }).map((_2, col) => {
      const index = row * cols + col;
      const isHighlighted = highlightSet.has(index);
      const cx = x + col * spacing;
      const cy = y + row * spacing;
      return /* @__PURE__ */ jsx(
        "circle",
        {
          cx,
          cy,
          r: isHighlighted ? nodeRadius * 1.6 : nodeRadius,
          fill: color,
          opacity: isHighlighted ? 1 : 0.4
        },
        index
      );
    })
  ) });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgGrid.displayName = "SvgGrid";
var SvgLobe = ({
  cx = 50,
  cy = 50,
  rx = 14,
  ry = 20,
  rotation = 0,
  shells = 2,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const clampedShells = Math.max(1, Math.min(3, shells));
  const renderShell = (shellIndex) => {
    const scale = shellIndex === 0 ? 1 : 1 - shellIndex * 0.3;
    const shellOpacity = shellIndex === 0 ? 1 : 0.5;
    const sRx = rx * scale;
    const sRy = ry * scale;
    return /* @__PURE__ */ jsxs("g", { opacity: shellOpacity, children: [
      /* @__PURE__ */ jsx(
        "ellipse",
        {
          cx,
          cy: cy - sRy,
          rx: sRx,
          ry: sRy,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5
        }
      ),
      /* @__PURE__ */ jsx(
        "ellipse",
        {
          cx,
          cy: cy + sRy,
          rx: sRx,
          ry: sRy,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5
        }
      )
    ] }, shellIndex);
  };
  const inner = /* @__PURE__ */ jsx(
    "g",
    {
      ...asRoot ? void 0 : a11y,
      className,
      opacity,
      transform: `rotate(${rotation}, ${cx}, ${cy})`,
      children: Array.from({ length: clampedShells }, (_, i) => renderShell(i))
    }
  );
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgLobe.displayName = "SvgLobe";
function getNodePositions(cx, cy, count, radius) {
  return Array.from({ length: count }).map((_, i) => {
    const angle = i / count * Math.PI * 2 - Math.PI / 2;
    return {
      x: cx + Math.cos(angle) * radius,
      y: cy + Math.sin(angle) * radius
    };
  });
}
function getConnections(count, density) {
  const allPairs = [];
  for (let i = 0; i < count; i++) {
    for (let j = i + 1; j < count; j++) {
      allPairs.push([i, j]);
    }
  }
  const connectCount = Math.round(allPairs.length * Math.max(0, Math.min(1, density)));
  return allPairs.slice(0, connectCount);
}
var SvgMesh = ({
  cx = 60,
  cy = 60,
  nodes = 6,
  radius = 50,
  color = "var(--color-primary)",
  connectionDensity = 0.5,
  opacity = 1,
  className,
  asRoot = true,
  width = 120,
  height = 120,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const positions = getNodePositions(cx, cy, nodes, radius);
  const connections = getConnections(nodes, connectionDensity);
  const inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
    connections.map(([a, b]) => /* @__PURE__ */ jsx(
      "line",
      {
        x1: positions[a].x,
        y1: positions[a].y,
        x2: positions[b].x,
        y2: positions[b].y,
        stroke: color,
        strokeWidth: 1,
        opacity: 0.3
      },
      `${a}-${b}`
    )),
    positions.map((pos, i) => /* @__PURE__ */ jsx(
      "circle",
      {
        cx: pos.x,
        cy: pos.y,
        r: 4,
        fill: color
      },
      i
    ))
  ] });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgMesh.displayName = "SvgMesh";
var TextLines = ({
  x,
  y,
  scale,
  color
}) => {
  const widths = [28, 22, 26];
  return /* @__PURE__ */ jsx("g", { children: widths.map((w, i) => /* @__PURE__ */ jsx(
    "rect",
    {
      x,
      y: y + i * 8 * scale,
      width: w * scale,
      height: 3 * scale,
      rx: 1.5 * scale,
      fill: color,
      opacity: 0.7 - i * 0.1
    },
    i
  )) });
};
TextLines.displayName = "TextLines";
var CodeBrackets = ({
  x,
  y,
  scale,
  color
}) => {
  const h = 20 * scale;
  const w = 8 * scale;
  return /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: `M ${x + w} ${y} L ${x} ${y + h / 2} L ${x + w} ${y + h}`,
        fill: "none",
        stroke: color,
        strokeWidth: 2 * scale,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: `M ${x + w * 2} ${y} L ${x + w * 3} ${y + h / 2} L ${x + w * 2} ${y + h}`,
        fill: "none",
        stroke: color,
        strokeWidth: 2 * scale,
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  ] });
};
CodeBrackets.displayName = "CodeBrackets";
var AppRect = ({
  x,
  y,
  scale,
  color
}) => {
  const w = 22 * scale;
  const h = 20 * scale;
  return /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x,
        y,
        width: w,
        height: h,
        rx: 4 * scale,
        fill: "none",
        stroke: color,
        strokeWidth: 2 * scale
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: x + 4 * scale,
        y: y + 4 * scale,
        width: w - 8 * scale,
        height: 3 * scale,
        rx: 1 * scale,
        fill: color,
        opacity: 0.5
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: x + 4 * scale,
        y: y + 10 * scale,
        width: (w - 8 * scale) * 0.6,
        height: 3 * scale,
        rx: 1 * scale,
        fill: color,
        opacity: 0.3
      }
    )
  ] });
};
AppRect.displayName = "AppRect";
var FlowArrow = ({ x1, y, x2, scale, color }) => {
  const arrowSize = 4 * scale;
  return /* @__PURE__ */ jsxs("g", { children: [
    /* @__PURE__ */ jsx(
      "line",
      {
        x1,
        y1: y,
        x2: x2 - arrowSize,
        y2: y,
        stroke: color,
        strokeWidth: 1.5 * scale,
        strokeDasharray: `${3 * scale} ${3 * scale}`,
        opacity: 0.5
      }
    ),
    /* @__PURE__ */ jsx(
      "polygon",
      {
        points: `${x2} ${y}, ${x2 - arrowSize} ${y - arrowSize / 2}, ${x2 - arrowSize} ${y + arrowSize / 2}`,
        fill: color,
        opacity: 0.6
      }
    )
  ] });
};
FlowArrow.displayName = "FlowArrow";
var SvgMorph = ({
  x = 5,
  y = 10,
  size: size2 = 1,
  variant = "generic",
  color = "var(--color-primary)",
  opacity = 1,
  className,
  asRoot = true,
  width = 130,
  height = 50,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const gap = 40 * size2;
  const midY = y + 10 * size2;
  let inner;
  if (variant === "text-to-code") {
    const leftEnd = x + 30 * size2;
    const rightStart = leftEnd + gap;
    inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
      /* @__PURE__ */ jsx(TextLines, { x, y, scale: size2, color }),
      /* @__PURE__ */ jsx(FlowArrow, { x1: leftEnd, y: midY, x2: rightStart, scale: size2, color }),
      /* @__PURE__ */ jsx(CodeBrackets, { x: rightStart, y, scale: size2, color })
    ] });
  } else if (variant === "code-to-app") {
    const leftEnd = x + 26 * size2;
    const rightStart = leftEnd + gap;
    inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
      /* @__PURE__ */ jsx(CodeBrackets, { x, y, scale: size2, color }),
      /* @__PURE__ */ jsx(FlowArrow, { x1: leftEnd, y: midY, x2: rightStart, scale: size2, color }),
      /* @__PURE__ */ jsx(AppRect, { x: rightStart, y, scale: size2, color })
    ] });
  } else {
    const circleR = 10 * size2;
    const circleX = x + circleR;
    const squareStart = x + circleR * 2 + gap;
    const squareSize = circleR * 2;
    inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
      /* @__PURE__ */ jsx(
        "circle",
        {
          cx: circleX,
          cy: midY,
          r: circleR,
          fill: "none",
          stroke: color,
          strokeWidth: 2 * size2
        }
      ),
      /* @__PURE__ */ jsx(
        FlowArrow,
        {
          x1: circleX + circleR + 2 * size2,
          y: midY,
          x2: squareStart,
          scale: size2,
          color
        }
      ),
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: squareStart,
          y: midY - circleR,
          width: squareSize,
          height: squareSize,
          rx: 3 * size2,
          fill: "none",
          stroke: color,
          strokeWidth: 2 * size2
        }
      )
    ] });
  }
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return /* @__PURE__ */ jsx(Fragment, { children: inner });
};
SvgMorph.displayName = "SvgMorph";
var SvgNode = ({
  x = 50,
  y = 50,
  r = 6,
  variant = "filled",
  color = "var(--color-primary)",
  opacity = 1,
  className,
  label,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
    variant === "pulse" && /* @__PURE__ */ jsx(
      "circle",
      {
        cx: x,
        cy: y,
        r: r * 2,
        fill: "none",
        stroke: color,
        strokeWidth: 1,
        opacity: 0.3,
        className: "almadar-svg-pulse-ring"
      }
    ),
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: x,
        cy: y,
        r,
        fill: variant === "stroked" ? "none" : color,
        stroke: variant === "stroked" ? color : "none",
        strokeWidth: variant === "stroked" ? 2 : 0
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + r + 14,
        textAnchor: "middle",
        fill: color,
        fontSize: 11,
        fontFamily: "inherit",
        children: label
      }
    )
  ] });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgNode.displayName = "SvgNode";
var PULSE_KEYFRAMES = `
@keyframes almadar-svg-pulse-expand {
  0% {
    transform: scale(0.3);
    opacity: 0.4;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}
`;
var SvgPulse = ({
  cx = 70,
  cy = 70,
  rings = 3,
  maxRadius = 60,
  color = "var(--color-primary)",
  animated = true,
  opacity = 1,
  className,
  asRoot = true,
  width = 140,
  height = 140,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
    animated && /* @__PURE__ */ jsx("style", { children: PULSE_KEYFRAMES }),
    Array.from({ length: rings }).map((_, i) => {
      const ringRadius = (i + 1) / rings * maxRadius;
      const ringOpacity = 1 - i / rings * 0.6;
      const delay = i * 0.6;
      return /* @__PURE__ */ jsx(
        "circle",
        {
          cx,
          cy,
          r: ringRadius,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5,
          opacity: animated ? void 0 : ringOpacity * 0.4,
          style: animated ? {
            transformOrigin: `${cx}px ${cy}px`,
            animation: `almadar-svg-pulse-expand 2s ease-out ${delay}s infinite`
          } : void 0
        },
        i
      );
    }),
    /* @__PURE__ */ jsx("circle", { cx, cy, r: 3, fill: color })
  ] });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgPulse.displayName = "SvgPulse";
var ringIdCounter = 0;
var SvgRing = ({
  cx = 50,
  cy = 50,
  r = 40,
  variant = "solid",
  color = "var(--color-primary)",
  strokeWidth = 1.5,
  opacity = 1,
  className,
  label,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const gradientId = React93__default.useMemo(() => {
    ringIdCounter += 1;
    return `almadar-ring-glow-${ringIdCounter}`;
  }, []);
  const inner = /* @__PURE__ */ jsxs("g", { ...asRoot ? void 0 : a11y, className, opacity, children: [
    variant === "glow" && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("radialGradient", { id: gradientId, cx: "50%", cy: "50%", r: "50%", children: [
        /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: color, stopOpacity: 0.15 }),
        /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: color, stopOpacity: 0 })
      ] }) }),
      /* @__PURE__ */ jsx("circle", { cx, cy, r, fill: `url(#${gradientId})` })
    ] }),
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx,
        cy,
        r,
        fill: "none",
        stroke: color,
        strokeWidth,
        strokeDasharray: variant === "dashed" ? "6 4" : void 0
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: cx,
        y: cy - r - 6,
        textAnchor: "middle",
        fill: color,
        fontSize: 11,
        fontFamily: "inherit",
        children: label
      }
    )
  ] });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgRing.displayName = "SvgRing";
var SHIELD_PATH = "M15,2 C15,2 5,5 2,6 C2,6 2,18 5,24 C8,30 15,34 15,34 C15,34 22,30 25,24 C28,18 28,6 28,6 C25,5 15,2 15,2 Z";
var CHECK_PATH = "M10,18 L14,22 L21,13";
var SvgShield = ({
  x = 50,
  y = 50,
  size: size2 = 1,
  variant = "outline",
  color = "var(--color-primary)",
  opacity = 1,
  className,
  asRoot = true,
  width = 100,
  height = 100,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const inner = /* @__PURE__ */ jsxs(
    "g",
    {
      ...asRoot ? void 0 : a11y,
      className,
      opacity,
      transform: `translate(${x - 15 * size2}, ${y - 18 * size2}) scale(${size2})`,
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: SHIELD_PATH,
            fill: variant === "filled" || variant === "check" ? color : "none",
            stroke: color,
            strokeWidth: 2,
            strokeLinejoin: "round"
          }
        ),
        variant === "check" && /* @__PURE__ */ jsx(
          "path",
          {
            d: CHECK_PATH,
            fill: "none",
            stroke: "var(--surface-diagram)",
            strokeWidth: 2.5,
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ]
    }
  );
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${width} ${height}`, width, height, ...a11y, children: inner });
  }
  return inner;
};
SvgShield.displayName = "SvgShield";
var SvgStack = ({
  x = 10,
  y = 40,
  layers: rawLayers = 3,
  width = 60,
  height = 40,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  labels,
  asRoot = true,
  svgWidth = 90,
  svgHeight = 80,
  ...rest
}) => {
  const a11y = domPassthrough(rest);
  const layers = Math.max(2, Math.min(4, rawLayers));
  const verticalOffset = 8;
  const horizontalOffset = 4;
  const inner = /* @__PURE__ */ jsx("g", { ...asRoot ? void 0 : a11y, className, opacity, children: Array.from({ length: layers }).map((_, i) => {
    const layerIndex = layers - 1 - i;
    const layerX = x + layerIndex * horizontalOffset;
    const layerY = y - layerIndex * verticalOffset;
    const layerOpacity = 0.3 + layerIndex / (layers - 1) * 0.7;
    const label = labels?.[layerIndex];
    return /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: layerX,
          y: layerY,
          width,
          height,
          rx: 6,
          ry: 6,
          fill: color,
          opacity: layerOpacity,
          stroke: color,
          strokeWidth: 1,
          strokeOpacity: layerOpacity * 0.6
        }
      ),
      label && /* @__PURE__ */ jsx(
        "text",
        {
          x: layerX + width / 2,
          y: layerY + height / 2 + 4,
          textAnchor: "middle",
          fill: "var(--surface-diagram)",
          fontSize: 10,
          fontFamily: "inherit",
          opacity: layerOpacity,
          children: label
        }
      )
    ] }, layerIndex);
  }) });
  if (asRoot) {
    return /* @__PURE__ */ jsx("svg", { viewBox: `0 0 ${svgWidth} ${svgHeight}`, width: svgWidth, height: svgHeight, ...a11y, children: inner });
  }
  return inner;
};
SvgStack.displayName = "SvgStack";
var Input = React93__default.forwardRef(
  ({
    className,
    inputType,
    type: htmlType,
    label,
    helperText,
    error,
    leftIcon,
    rightIcon,
    icon: iconProp,
    clearable,
    onClear,
    action,
    value,
    options,
    rows: rows2 = 3,
    onChange,
    ...props
  }, ref) => {
    const { t } = useTranslate();
    const eventBus = useEventBus();
    const type = inputType || htmlType || "text";
    const generatedId = React93__default.useId();
    const fieldId = props.id ?? generatedId;
    const descriptionId = helperText || error ? `${fieldId}-description` : void 0;
    const describedBy = [props["aria-describedby"], descriptionId].filter(Boolean).join(" ") || void 0;
    const a11yProps = {
      id: fieldId,
      "aria-invalid": error ? true : props["aria-invalid"],
      "aria-required": props.required ? true : void 0,
      "aria-describedby": describedBy
    };
    const isDeclarative = typeof onChange === "string";
    const [localValue, setLocalValue] = React93__default.useState(value);
    const pendingEchoRef = React93__default.useRef(/* @__PURE__ */ new Set());
    React93__default.useEffect(() => {
      if (!isDeclarative) return;
      const incoming = value == null ? "" : String(value);
      if (pendingEchoRef.current.has(incoming)) {
        pendingEchoRef.current.delete(incoming);
        return;
      }
      pendingEchoRef.current.clear();
      setLocalValue(value);
    }, [value, isDeclarative]);
    const displayValue = isDeclarative ? localValue : value;
    const resolveIconNode = (i, cls) => {
      if (!i) return null;
      if (typeof i === "string") return /* @__PURE__ */ jsx(Icon, { name: i, className: cls });
      const C = i;
      return /* @__PURE__ */ jsx(C, { className: cls });
    };
    const iconCls = "h-icon-default w-icon-default";
    const IconComponent = typeof iconProp === "string" ? resolveIcon(iconProp) : iconProp;
    const resolvedLeftIcon = (leftIcon ? resolveIconNode(leftIcon, iconCls) : null) || IconComponent && /* @__PURE__ */ jsx(IconComponent, { className: iconCls });
    const showClearButton = clearable && displayValue && String(displayValue).length > 0;
    const isMultiline = type === "textarea";
    const baseClassName = cn(
      "block w-full rounded-interactive transition-all duration-fast",
      "border-[length:var(--border-width-thin)] border-border interactive-border",
      isMultiline ? "px-3 py-2 text-sm" : "h-input-md px-3 text-sm",
      "bg-card hover:bg-muted focus:bg-card",
      "text-foreground placeholder:text-muted-foreground",
      "focus:outline-none focus:ring-1 focus:ring-ring focus:border-ring",
      "disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-muted",
      error ? "border-error focus:border-error focus:ring-error" : "",
      resolvedLeftIcon && "pl-10",
      (rightIcon || showClearButton) && "pr-10",
      className
    );
    const handleChange = (e) => {
      if (typeof onChange === "string") {
        const target = e.target;
        const payload = type === "checkbox" ? { checked: target.checked } : { value: target.value };
        if (type !== "checkbox") {
          pendingEchoRef.current.add(target.value);
          setLocalValue(target.value);
        }
        eventBus.emit(`UI:${onChange}`, payload);
      } else {
        onChange?.(e);
      }
    };
    const handleClear = () => {
      if (typeof onClear === "string") {
        eventBus.emit(`UI:${onClear}`, {});
      } else {
        onClear?.();
      }
    };
    const handleKeyDown = (e) => {
      if (!action || e.key !== "Enter") return;
      const raw = e.currentTarget.value;
      if (type === "number") {
        if (raw.trim() === "") return;
        const numeric = Number(raw);
        if (Number.isNaN(numeric)) return;
        eventBus.emit(`UI:${action}`, { value: numeric });
        return;
      }
      eventBus.emit(`UI:${action}`, { value: raw });
    };
    const wrapField = (field, fullWidth = true) => /* @__PURE__ */ jsxs("div", { className: fullWidth ? "w-full" : "w-fit", children: [
      label && /* @__PURE__ */ jsx("label", { htmlFor: fieldId, className: "block text-sm font-medium text-foreground mb-1", children: label }),
      field,
      (helperText || error) && /* @__PURE__ */ jsx("p", { id: descriptionId, className: cn("mt-1 text-xs", error ? "text-error" : "text-muted-foreground"), children: error ?? helperText })
    ] });
    if (type === "select") {
      return wrapField(
        /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
          resolvedLeftIcon && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted-foreground", children: resolvedLeftIcon }),
          /* @__PURE__ */ jsxs(
            "select",
            {
              ref,
              value: displayValue,
              onChange: handleChange,
              className: cn(baseClassName, "appearance-none pr-10", className),
              ...props,
              ...a11yProps,
              children: [
                /* @__PURE__ */ jsx("option", { value: "", children: t("form.selectPlaceholder", { label: "" }) }),
                options?.map((opt) => /* @__PURE__ */ jsx("option", { value: opt.value, children: opt.label }, opt.value))
              ]
            }
          ),
          /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-muted-foreground", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default" }) })
        ] })
      );
    }
    if (type === "textarea") {
      return wrapField(
        /* @__PURE__ */ jsx("div", { className: "relative w-full", children: /* @__PURE__ */ jsx(
          "textarea",
          {
            ref,
            value: displayValue,
            onChange: handleChange,
            rows: rows2,
            className: baseClassName,
            ...props,
            ...a11yProps
          }
        ) })
      );
    }
    if (type === "checkbox") {
      return wrapField(
        /* @__PURE__ */ jsx(
          "input",
          {
            ref,
            type: "checkbox",
            checked: props.checked,
            onChange: handleChange,
            className: cn(
              "h-icon-default w-icon-default rounded-interactive",
              "border-border",
              "text-primary focus:ring-ring",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              className
            ),
            ...props,
            ...a11yProps
          }
        ),
        false
      );
    }
    return wrapField(
      /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
        resolvedLeftIcon && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-muted-foreground", children: resolvedLeftIcon }),
        /* @__PURE__ */ jsx(
          "input",
          {
            ref,
            type,
            value: displayValue,
            onChange: handleChange,
            onKeyDown: handleKeyDown,
            className: baseClassName,
            ...props,
            ...a11yProps
          }
        ),
        showClearButton && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            icon: "x",
            "aria-label": t("aria.clearInput"),
            onClick: handleClear,
            className: "absolute inset-y-0 right-0 text-muted-foreground hover:text-foreground"
          }
        ),
        rightIcon && !showClearButton && /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center text-muted-foreground", children: resolveIconNode(rightIcon, iconCls) })
      ] })
    );
  }
);
Input.displayName = "Input";
var Label = React93__default.forwardRef(
  ({ className, required, children, ...props }, ref) => {
    return /* @__PURE__ */ jsxs(
      "label",
      {
        ref,
        className: cn(
          "block text-sm font-bold text-foreground",
          className
        ),
        ...props,
        children: [
          children,
          required && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "text-error ml-1", children: "*" })
        ]
      }
    );
  }
);
Label.displayName = "Label";
var Textarea = React93__default.forwardRef(
  ({ className, label, helperText, error, onChange, action, onKeyDown, id, required, ...props }, ref) => {
    const eventBus = useEventBus();
    const generatedId = React93__default.useId();
    const fieldId = id ?? generatedId;
    const descriptionId = error || helperText ? `${fieldId}-description` : void 0;
    const describedBy = [props["aria-describedby"], descriptionId].filter(Boolean).join(" ") || void 0;
    const handleChange = (e) => {
      if (typeof onChange === "string") {
        eventBus.emit(`UI:${onChange}`, { value: e.target.value });
      } else {
        onChange?.(e);
      }
    };
    const handleKeyDown = (e) => {
      onKeyDown?.(e);
      if (!action || e.key !== "Enter" || !(e.metaKey || e.ctrlKey)) return;
      e.preventDefault();
      eventBus.emit(`UI:${action}`, { value: e.currentTarget.value });
    };
    const field = /* @__PURE__ */ jsx(
      "textarea",
      {
        ref,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        className: cn(
          "block w-full rounded-interactive border-[length:var(--border-width)] shadow-elevation-interactive interactive-border",
          "px-3 py-2 text-sm text-foreground",
          "bg-card",
          "placeholder:text-[var(--color-placeholder)]",
          "focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-ring",
          "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
          "resize-y min-h-20",
          error ? "border-error focus:border-error" : "border-border focus:border-primary",
          className
        ),
        ...props,
        id: fieldId,
        required,
        "aria-required": required ? true : void 0,
        "aria-invalid": error ? true : props["aria-invalid"],
        "aria-describedby": describedBy
      }
    );
    if (!label && !descriptionId) return field;
    return /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
      label && /* @__PURE__ */ jsx(Label, { htmlFor: fieldId, className: "mb-1", children: label }),
      field,
      descriptionId && /* @__PURE__ */ jsx(Typography, { id: descriptionId, variant: "caption", color: error ? "error" : "muted", className: "mt-1", children: error ?? helperText })
    ] });
  }
);
Textarea.displayName = "Textarea";
function dispatchValueChange(onValueChange, eventBus, value) {
  if (typeof onValueChange === "string") {
    eventBus.emit(`UI:${onValueChange}`, { value });
  } else {
    onValueChange?.(value);
  }
}
function flatOptions(opts, groups) {
  const flat = opts ?? [];
  const grp = (groups ?? []).flatMap((g) => g.options);
  return [...flat, ...grp];
}
function NativeSelect({
  className,
  options,
  groups,
  placeholder,
  error,
  label,
  onChange,
  onValueChange,
  action,
  value,
  ...props
}) {
  const eventBus = useEventBus();
  const generatedId = useId();
  const fieldId = props.id ?? generatedId;
  const errorId = error ? `${fieldId}-error` : void 0;
  const describedBy = [props["aria-describedby"], errorId].filter(Boolean).join(" ") || void 0;
  const handleChange = (e) => {
    if (typeof onChange === "string") {
      eventBus.emit(`UI:${onChange}`, { value: e.target.value });
    } else {
      onChange?.(e);
    }
    dispatchValueChange(onValueChange, eventBus, e.target.value);
    if (action) {
      eventBus.emit(`UI:${action}`, { value: e.target.value });
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    label && /* @__PURE__ */ jsx(Label, { htmlFor: fieldId, className: "mb-1", children: label }),
    /* @__PURE__ */ jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ jsxs(
        "select",
        {
          onChange: handleChange,
          value,
          className: cn(
            "block w-full rounded-interactive border-[length:var(--border-width)] shadow-elevation-interactive interactive-border appearance-none",
            "px-3 py-2 pr-10 text-sm text-foreground font-medium",
            "bg-card",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-ring",
            "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
            error ? "border-error focus:border-error" : "border-border focus:border-primary",
            className
          ),
          ...props,
          id: fieldId,
          "aria-invalid": error ? true : void 0,
          "aria-required": props.required ? true : void 0,
          "aria-describedby": describedBy,
          children: [
            placeholder && /* @__PURE__ */ jsx("option", { value: "", disabled: true, children: placeholder }),
            options?.map((option) => /* @__PURE__ */ jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)),
            groups?.map((group) => /* @__PURE__ */ jsx("optgroup", { label: group.label, children: group.options.map((option) => /* @__PURE__ */ jsx("option", { value: option.value, disabled: option.disabled, children: option.label }, option.value)) }, group.label))
          ]
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none", children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default text-foreground" }) })
    ] }),
    error && /* @__PURE__ */ jsx(Typography, { id: errorId, variant: "caption", color: "error", className: "mt-1", children: error })
  ] });
}
function RichSelect({
  className,
  options,
  groups,
  placeholder,
  error,
  label,
  onChange,
  onValueChange,
  action,
  value,
  multiple,
  searchable,
  clearable,
  disabled,
  required,
  ...rest
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const containerRef = useRef(null);
  const triggerRef = useRef(null);
  const baseId = useId();
  const passthrough = domPassthrough(rest);
  const triggerId = typeof passthrough.id === "string" ? passthrough.id : `${baseId}-trigger`;
  const listId = `${baseId}-list`;
  const errorId = error ? `${baseId}-error` : void 0;
  const describedBy = [passthrough["aria-describedby"], errorId].filter(Boolean).join(" ") || void 0;
  const optionId = (index) => `${baseId}-opt-${index}`;
  const selected = multiple ? Array.isArray(value) ? value : value ? [value] : [] : value ? [value] : [];
  const all = flatOptions(options, groups);
  const matches = (o) => !(searchable && search) || o.label.toLowerCase().includes(search.toLowerCase());
  const useGroups = Boolean(groups && groups.length > 0);
  const visible = useGroups ? (groups ?? []).flatMap((g) => g.options.filter(matches)) : all.filter(matches);
  const indexOf = new Map(visible.map((o, i) => [o, i]));
  const closeList = () => {
    setOpen(false);
    setSearch("");
    setActiveIndex(-1);
  };
  useDialogBehavior({
    open,
    containerRef,
    onEscape: closeList,
    modal: false,
    returnFocusRef: triggerRef
  });
  const emitValue = (next) => {
    if (typeof onChange === "string") {
      eventBus.emit(`UI:${onChange}`, { value: next });
    }
    dispatchValueChange(onValueChange, eventBus, next);
    if (action) {
      eventBus.emit(`UI:${action}`, { value: next });
    }
  };
  const toggle = (optValue) => {
    if (multiple) {
      emitValue(
        selected.includes(optValue) ? selected.filter((v) => v !== optValue) : [...selected, optValue]
      );
    } else {
      closeList();
      triggerRef.current?.focus();
      emitValue(optValue);
    }
  };
  const clear = (e) => {
    e.stopPropagation();
    emitValue(multiple ? [] : "");
  };
  React93__default.useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        closeList();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const step = (from, dir) => {
    for (let i = from + dir; i >= 0 && i < visible.length; i += dir) {
      if (!visible[i].disabled) return i;
    }
    return from;
  };
  const firstEnabled = () => step(-1, 1);
  const lastEnabled = () => {
    const last = step(visible.length, -1);
    return last === visible.length ? -1 : last;
  };
  const openList = (at) => {
    if (disabled) return;
    setOpen(true);
    const selectedIdx = visible.findIndex((o) => selected.includes(o.value) && !o.disabled);
    if (at === "last") setActiveIndex(lastEnabled());
    else setActiveIndex(at === "selected" && selectedIdx >= 0 ? selectedIdx : firstEnabled());
  };
  const scrollTo = (index) => {
    requestAnimationFrame(() => document.getElementById(optionId(index))?.scrollIntoView?.({ block: "nearest" }));
  };
  const moveTo = (index) => {
    setActiveIndex(index);
    if (index >= 0) scrollTo(index);
  };
  const typeAhead = (e) => {
    const typed = e.key.toLowerCase();
    const hit = visible.findIndex((o) => !o.disabled && o.label.toLowerCase().startsWith(typed));
    if (hit < 0) return;
    e.preventDefault();
    if (!open) setOpen(true);
    moveTo(hit);
  };
  const handleKeyDown = (e) => {
    const fromSearch = e.currentTarget !== triggerRef.current;
    if (e.altKey || e.ctrlKey || e.metaKey) return;
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        if (!open) openList("selected");
        else moveTo(activeIndex < 0 ? firstEnabled() : step(activeIndex, 1));
        return;
      case "ArrowUp":
        e.preventDefault();
        if (!open) openList("last");
        else moveTo(activeIndex < 0 ? lastEnabled() : step(activeIndex, -1));
        return;
      case "Home":
        if (!open || fromSearch) return;
        e.preventDefault();
        moveTo(firstEnabled());
        return;
      case "End":
        if (!open || fromSearch) return;
        e.preventDefault();
        moveTo(lastEnabled());
        return;
      case "Enter":
        e.preventDefault();
        if (!open) openList("selected");
        else if (activeIndex >= 0) toggle(visible[activeIndex].value);
        return;
      case " ":
        if (fromSearch) return;
        e.preventDefault();
        if (!open) openList("selected");
        else if (activeIndex >= 0) toggle(visible[activeIndex].value);
        return;
      case "Tab":
        if (open) closeList();
        return;
      default:
        if (fromSearch || e.key.length !== 1) return;
        typeAhead(e);
    }
  };
  const displayLabel = selected.length === 0 ? placeholder ?? "" : multiple ? t("select.nSelected", { count: selected.length }) : all.find((o) => o.value === selected[0])?.label ?? selected[0];
  const hasValue = selected.length > 0;
  const activeId = open && activeIndex >= 0 ? optionId(activeIndex) : void 0;
  const renderOptions = (opts) => opts.map((opt) => {
    const index = indexOf.get(opt) ?? -1;
    const isSelected = selected.includes(opt.value);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        id: optionId(index),
        role: "option",
        "aria-selected": isSelected,
        "aria-disabled": opt.disabled ? true : void 0,
        dir: opt.dir,
        onClick: () => !opt.disabled && toggle(opt.value),
        onMouseMove: () => !opt.disabled && index !== activeIndex && setActiveIndex(index),
        className: cn(
          "w-full flex items-center justify-between px-3 py-1.5 text-sm text-start cursor-pointer",
          "hover:bg-muted transition-colors",
          opt.disabled && "opacity-50 cursor-not-allowed",
          isSelected && "text-primary font-medium",
          index === activeIndex && "bg-muted"
        ),
        children: [
          /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-2 min-w-0", children: [
            opt.icon != null && /* @__PURE__ */ jsx("span", { className: "shrink-0 flex items-center", children: opt.icon }),
            /* @__PURE__ */ jsxs("span", { className: "flex flex-col min-w-0", children: [
              /* @__PURE__ */ jsx("span", { children: opt.label }),
              opt.secondaryLabel != null && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground font-normal", children: opt.secondaryLabel })
            ] })
          ] }),
          isSelected && /* @__PURE__ */ jsx(Icon, { name: "check", className: "h-icon-default w-icon-default shrink-0" })
        ]
      },
      opt.value
    );
  });
  const labelledBy = typeof passthrough["aria-labelledby"] === "string" ? passthrough["aria-labelledby"] : void 0;
  const ariaLabel = typeof passthrough["aria-label"] === "string" ? passthrough["aria-label"] : void 0;
  const listName = label ?? ariaLabel;
  return /* @__PURE__ */ jsxs("div", { ref: containerRef, className: cn("relative w-full", className), children: [
    label && /* @__PURE__ */ jsx(Label, { htmlFor: triggerId, className: "mb-1", children: label }),
    /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          ...passthrough,
          ref: triggerRef,
          id: triggerId,
          type: "button",
          role: "combobox",
          "aria-haspopup": "listbox",
          "aria-expanded": open,
          "aria-controls": listId,
          "aria-activedescendant": activeId,
          "aria-labelledby": labelledBy,
          "aria-invalid": error ? true : void 0,
          "aria-required": required ? true : void 0,
          "aria-describedby": describedBy,
          disabled,
          onClick: () => !disabled && (open ? closeList() : openList("selected")),
          onKeyDown: handleKeyDown,
          className: cn(
            "block w-full rounded-interactive border-[length:var(--border-width)] shadow-elevation-interactive interactive-border",
            "px-3 py-2 pr-10 text-sm text-start font-medium",
            "bg-card rounded-interactive",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-0 focus-visible:ring-ring",
            "disabled:bg-muted disabled:text-muted-foreground disabled:cursor-not-allowed",
            error ? "border-error focus:border-error" : "border-border focus:border-primary",
            !hasValue && "text-muted-foreground"
          ),
          children: displayLabel
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "absolute inset-y-0 right-0 pr-3 flex items-center gap-1 pointer-events-none", children: [
        clearable && hasValue && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            icon: "x",
            "aria-label": t("aria.clearSelection"),
            onClick: clear,
            className: "pointer-events-auto text-muted-foreground hover:text-foreground"
          }
        ),
        /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "h-icon-default w-icon-default text-foreground" })
      ] }),
      open && /* @__PURE__ */ jsxs("div", { className: cn(
        "absolute z-50 mt-1 w-full",
        "bg-card border-[length:var(--border-width)] border-border",
        "surface-material rounded-container shadow-elevation-popover py-1 max-h-60 overflow-y-auto"
      ), children: [
        searchable && /* @__PURE__ */ jsx("div", { className: "px-2 pb-1 border-b border-border", children: /* @__PURE__ */ jsx(
          "input",
          {
            autoFocus: true,
            type: "search",
            value: search,
            onChange: (e) => {
              setSearch(e.target.value);
              setActiveIndex(0);
            },
            onKeyDown: handleKeyDown,
            "aria-label": t("aria.searchOptions"),
            "aria-controls": listId,
            "aria-activedescendant": activeId,
            placeholder: t("select.searchPlaceholder"),
            className: cn(
              "w-full px-2 py-1 text-sm bg-transparent rounded-interactive",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              "text-foreground placeholder:text-muted-foreground"
            )
          }
        ) }),
        /* @__PURE__ */ jsx("div", { id: listId, role: "listbox", "aria-multiselectable": multiple ? true : void 0, "aria-labelledby": listName ? void 0 : labelledBy, "aria-label": listName, children: useGroups ? (groups ?? []).map((g, gi) => {
          const groupFiltered = g.options.filter(matches);
          if (groupFiltered.length === 0) return null;
          const groupLabelId = `${baseId}-group-${gi}`;
          return /* @__PURE__ */ jsxs("div", { role: "group", "aria-labelledby": groupLabelId, children: [
            /* @__PURE__ */ jsx("div", { id: groupLabelId, className: "px-3 py-1 text-xs font-semibold text-muted-foreground uppercase tracking-wide", children: g.label }),
            renderOptions(groupFiltered)
          ] }, g.label);
        }) : renderOptions(visible) })
      ] })
    ] }),
    error && /* @__PURE__ */ jsx(Typography, { id: errorId, variant: "caption", color: "error", className: "mt-1", children: error })
  ] });
}
var Select = React93__default.forwardRef(
  (props, _ref) => {
    const { multiple, searchable, clearable } = props;
    if (multiple || searchable || clearable) {
      return /* @__PURE__ */ jsx(RichSelect, { ...props });
    }
    return /* @__PURE__ */ jsx(NativeSelect, { ...props });
  }
);
Select.displayName = "Select";
var Checkbox = React93__default.forwardRef(
  ({ className, label, id, error, required, onChange, ...props }, ref) => {
    const generatedId = React93__default.useId();
    const inputId = id || generatedId;
    const errorId = error ? `${inputId}-error` : void 0;
    const describedBy = [props["aria-describedby"], errorId].filter(Boolean).join(" ") || void 0;
    const eventBus = useEventBus();
    const handleChange = (e) => {
      if (typeof onChange === "string") {
        eventBus.emit(`UI:${onChange}`, { checked: e.target.checked });
      } else {
        onChange?.(e);
      }
    };
    return /* @__PURE__ */ jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ jsx("div", { className: "relative flex items-center", children: /* @__PURE__ */ jsx(
          "input",
          {
            ref,
            type: "checkbox",
            onChange: handleChange,
            className: cn(
              "peer h-4 w-4 border-[length:var(--border-width)] border-border",
              "accent-primary focus:ring-ring focus:ring-offset-0",
              "bg-card checked:bg-primary",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              className
            ),
            ...props,
            id: inputId,
            required,
            "aria-required": required ? true : void 0,
            "aria-invalid": error ? true : props["aria-invalid"],
            "aria-describedby": describedBy
          }
        ) }),
        label && /* @__PURE__ */ jsxs(
          "label",
          {
            htmlFor: inputId,
            className: "ml-2 text-sm text-foreground font-medium cursor-pointer select-none",
            children: [
              label,
              required && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "text-error ml-1", children: "*" })
            ]
          }
        )
      ] }),
      error && /* @__PURE__ */ jsx(Typography, { id: errorId, variant: "caption", color: "error", className: "mt-1", children: error })
    ] });
  }
);
Checkbox.displayName = "Checkbox";
var sizeStyles3 = {
  xs: "h-3 w-3",
  sm: "h-icon-default w-icon-default",
  md: "h-6 w-6",
  lg: "h-8 w-8"
};
var Spinner = React93__default.forwardRef(
  ({ className, size: size2 = "md", overlay, ...props }, ref) => {
    const { t } = useTranslate();
    if (overlay) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          ref,
          role: "status",
          "aria-label": t("aria.loading"),
          ...{ [LOADING_STATE_MARKER]: "" },
          className: cn(
            "absolute inset-0 z-10 flex items-center justify-center",
            "bg-background/60 backdrop-blur-sm",
            className
          ),
          ...props,
          children: /* @__PURE__ */ jsx(Icon, { name: "loader", className: cn("animate-spin text-foreground", sizeStyles3[size2]) })
        }
      );
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        role: "status",
        "aria-label": t("aria.loading"),
        ...{ [LOADING_STATE_MARKER]: "" },
        className: cn("text-foreground", className),
        ...props,
        children: /* @__PURE__ */ jsx(Icon, { name: "loader", className: cn("animate-spin", sizeStyles3[size2]) })
      }
    );
  }
);
Spinner.displayName = "Spinner";
var variantStyles3 = {
  default: [
    "surface-content",
    "transition-all duration-normal",
    "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
  ].join(" "),
  bordered: [
    "surface-content",
    "transition-all duration-normal",
    "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
  ].join(" "),
  elevated: [
    "bg-card surface-material",
    "border-[length:var(--border-width)] border-border",
    "shadow",
    "transition-all duration-normal",
    "hover:shadow-elevation-dialog hover:translate-y-[var(--hover-translate-y)]"
  ].join(" "),
  // Interactive variant with theme-specific hover effects
  interactive: [
    "bg-card surface-material",
    "border-[length:var(--border-width)] border-border",
    "shadow",
    "cursor-pointer",
    "transition-all duration-normal",
    "hover:shadow-elevation-dialog"
  ].join(" ")
};
var paddingStyles = {
  none: "",
  sm: "p-card-sm",
  md: "p-card-md",
  lg: "p-card-lg"
};
var shadowStyles = {
  none: "shadow-none",
  sm: "shadow-elevation-card",
  md: "shadow",
  lg: "shadow-elevation-dialog"
};
var lookStyles2 = {
  elevated: "",
  "flat-bordered": "shadow-none border-[length:var(--border-width)] border-border",
  "borderless-divider": "shadow-none border-0 border-b border-border rounded-none",
  ticket: "shadow-none border-dashed border-[length:var(--border-width)] border-border",
  invoice: "shadow-none border-[length:var(--border-width-thick)] border-border rounded-sm",
  chip: "shadow-none rounded-pill border-[length:var(--border-width)] border-border",
  "tile-image-first": "p-0 overflow-hidden"
};
var Card = React93__default.forwardRef(
  ({
    className,
    variant = "bordered",
    padding = "md",
    title,
    subtitle,
    shadow,
    look = "elevated",
    children,
    action,
    loading,
    onClick,
    ...props
  }, ref) => {
    const eventBus = useEventBus();
    const handleClick = action ? (e) => {
      eventBus.emit(`UI:${action}`, {});
      onClick?.(e);
    } : onClick;
    const press = pressableProps(handleClick);
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        className: cn(
          "rounded-container relative",
          "transition-all duration-normal",
          "chrome-panel",
          variantStyles3[variant],
          paddingStyles[padding],
          lookStyles2[look],
          shadow && shadowStyles[shadow],
          className
        ),
        ...press,
        ...props,
        children: [
          loading && /* @__PURE__ */ jsx(Spinner, { overlay: true, size: "md" }),
          (title || subtitle) && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
            title && /* @__PURE__ */ jsx("h3", { className: "text-lg text-card-foreground heading-voice", children: title }),
            subtitle && /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground mt-1", children: subtitle })
          ] }),
          /* @__PURE__ */ jsx(SurfaceBoundary, { children })
        ]
      }
    );
  }
);
Card.displayName = "Card";
var CardHeader = React93__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("mb-4", className), ...props }));
CardHeader.displayName = "CardHeader";
var CardTitle = React93__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "h3",
  {
    ref,
    className: cn(
      "text-lg text-card-foreground",
      "heading-voice",
      className
    ),
    ...props
  }
));
CardTitle.displayName = "CardTitle";
var CardContent = React93__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx("div", { ref, className: cn("", className), ...props }));
CardContent.displayName = "CardContent";
var CardBody = CardContent;
CardBody.displayName = "CardBody";
var CardFooter = React93__default.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  "div",
  {
    ref,
    className: cn("mt-4 flex items-center", className),
    ...props
  }
));
CardFooter.displayName = "CardFooter";
var fitClass = {
  cover: "object-cover",
  contain: "object-contain",
  fill: "object-fill",
  none: "object-none"
};
var aspectClass = {
  auto: "",
  "1/1": "aspect-square",
  "4/3": "aspect-[4/3]",
  "3/2": "aspect-[3/2]",
  "16/9": "aspect-video",
  "21/9": "aspect-[21/9]"
};
var roundedClass = {
  none: "",
  sm: "rounded-sm",
  md: "rounded-md",
  lg: "rounded-lg",
  xl: "rounded-xl",
  "2xl": "rounded-[calc(var(--radius-xl)*1.5)]",
  full: "rounded-full"
};
var positionClass = {
  center: "object-center",
  top: "object-top",
  bottom: "object-bottom",
  left: "object-left",
  right: "object-right"
};
var Image2 = ({
  src,
  alt,
  fit = "cover",
  aspect = "auto",
  rounded = "md",
  bordered = false,
  loading = "lazy",
  position = "center",
  srcSet,
  sizes,
  priority = false,
  className,
  ...rest
}) => {
  if (!src) return null;
  return /* @__PURE__ */ jsx(
    "img",
    {
      src,
      srcSet,
      sizes,
      fetchPriority: priority ? "high" : void 0,
      alt,
      ...domPassthrough(rest),
      role: alt === "" ? "presentation" : rest.role,
      loading: priority ? "eager" : loading,
      decoding: "async",
      className: cn(
        "block w-full h-auto max-w-full",
        fitClass[fit],
        positionClass[position],
        aspectClass[aspect],
        roundedClass[rounded],
        bordered && "border border-border",
        className
      )
    }
  );
};
Image2.displayName = "Image";
var sizeMap = {
  sm: 16,
  md: 24,
  lg: 32
};
function GameIcon({ assetUrl, icon, size: size2 = "md", alt, className, ...rest }) {
  const px = typeof size2 === "number" ? size2 : sizeMap[size2];
  useIconFamily();
  if (assetUrl?.url) {
    return /* @__PURE__ */ jsx(
      AtlasImage,
      {
        asset: assetUrl,
        size: px,
        alt: alt ?? assetUrl.category ?? "",
        className: cn("flex-shrink-0", className),
        ...domPassthrough(rest)
      }
    );
  }
  const I = typeof icon === "string" ? resolveIconForFamily(icon) : icon;
  return /* @__PURE__ */ jsx(I, { width: px, height: px, className: cn("flex-shrink-0", className), ...domPassthrough(rest) });
}
GameIcon.displayName = "GameIcon";
var variantStyles4 = {
  default: [
    "bg-muted text-foreground",
    "border-[length:var(--border-width-thin)] border-border"
  ].join(" "),
  primary: "bg-primary/10 text-foreground border-[length:var(--border-width)] border-primary",
  secondary: "bg-secondary/10 text-foreground border-[length:var(--border-width)] border-secondary",
  success: [
    "bg-success/10 text-foreground",
    "border-[length:var(--border-width)] border-success"
  ].join(" "),
  warning: [
    "bg-warning/10 text-foreground",
    "border-[length:var(--border-width)] border-warning"
  ].join(" "),
  danger: [
    "bg-error/10 text-foreground",
    "border-[length:var(--border-width)] border-error"
  ].join(" "),
  info: [
    "bg-info/10 text-foreground",
    "border-[length:var(--border-width)] border-info"
  ].join(" "),
  neutral: [
    "bg-muted text-muted-foreground",
    "border-[length:var(--border-width-thin)] border-border"
  ].join(" ")
};
var sizeStyles4 = {
  sm: "px-2 py-0.5 text-xs",
  md: "px-2.5 py-1 text-sm",
  lg: "px-3 py-1.5 text-base"
};
var iconSizes = {
  sm: "w-3 h-3",
  md: "w-3.5 h-3.5",
  lg: "w-4 h-4"
};
var FilterPill = React93__default.forwardRef(
  ({
    className,
    variant = "default",
    size: size2 = "sm",
    label,
    icon,
    onRemove,
    removable = true,
    onClick,
    clickEvent,
    removeEvent,
    children,
    "aria-pressed": ariaPressed,
    ...props
  }, ref) => {
    const eventBus = useEventBus();
    const { t } = useTranslate();
    const payloadLabel = typeof children === "string" || typeof children === "number" ? children : label;
    const handleClick = useCallback(() => {
      onClick?.();
      if (clickEvent) eventBus.emit(`UI:${clickEvent}`, { label: payloadLabel });
    }, [onClick, clickEvent, eventBus, payloadLabel]);
    const handleRemove = useCallback(() => {
      onRemove?.();
      if (removeEvent) eventBus.emit(`UI:${removeEvent}`, { label: payloadLabel });
    }, [onRemove, removeEvent, eventBus, payloadLabel]);
    const resolvedIcon = typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: iconSizes[size2] }) : icon ? /* @__PURE__ */ jsx(Icon, { icon, className: iconSizes[size2] }) : null;
    const pressable = onClick || clickEvent ? handleClick : void 0;
    return /* @__PURE__ */ jsxs(
      "span",
      {
        ref,
        className: cn(
          "inline-flex items-center gap-1 font-bold rounded-pill",
          variantStyles4[variant],
          sizeStyles4[size2],
          className
        ),
        ...props,
        children: [
          /* @__PURE__ */ jsxs(
            "span",
            {
              className: cn("inline-flex items-center gap-1", pressable && "cursor-pointer"),
              ...pressableProps(pressable),
              "aria-pressed": pressable ? ariaPressed : void 0,
              children: [
                resolvedIcon,
                /* @__PURE__ */ jsx("span", { children: children ?? label })
              ]
            }
          ),
          removable && (onRemove || removeEvent) && /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: (e) => {
                e.stopPropagation();
                handleRemove();
              },
              "aria-label": t("aria.removeFilter"),
              className: cn(
                "ml-0.5 rounded-full hover:bg-foreground/10 transition-colors flex items-center justify-center"
              ),
              children: /* @__PURE__ */ jsx(Icon, { name: "x", className: iconSizes[size2] })
            }
          )
        ]
      }
    );
  }
);
FilterPill.displayName = "FilterPill";
var sizeClasses3 = {
  xs: "w-6 h-6 text-xs",
  sm: "w-8 h-8 text-sm",
  md: "w-10 h-10 text-base",
  lg: "w-12 h-12 text-lg",
  xl: "w-16 h-16 text-xl"
};
var iconSizeClasses = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
};
var statusSizeClasses = {
  xs: "w-1.5 h-1.5",
  sm: "w-2 h-2",
  md: "w-2.5 h-2.5",
  lg: "w-3 h-3",
  xl: "w-4 h-4"
};
var statusClasses = {
  online: "bg-success",
  offline: "bg-muted-foreground",
  away: "bg-warning",
  busy: "bg-error"
};
var badgeSizeClasses = {
  xs: "w-3 h-3 text-xs",
  sm: "w-4 h-4 text-xs",
  md: "w-5 h-5 text-xs",
  lg: "w-6 h-6 text-sm",
  xl: "w-7 h-7 text-base"
};
function generateInitials(name) {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
var Avatar = ({
  src,
  alt,
  name,
  initials: providedInitials,
  icon: iconProp,
  size: size2 = "md",
  status,
  badge,
  className,
  onClick,
  action,
  actionPayload,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [imgFailed, setImgFailed] = React93__default.useState(false);
  React93__default.useEffect(() => {
    setImgFailed(false);
  }, [src]);
  const initials = providedInitials ?? (name ? generateInitials(name) : void 0);
  const IconComponent = typeof iconProp === "string" ? resolveIcon(iconProp) : iconProp;
  const hasIcon = !!IconComponent;
  const hasInitials = !!initials && !(hasIcon && !providedInitials);
  const getInitialsBackground = () => "bg-primary text-primary-foreground";
  const isClickable = action || onClick;
  const handleClick = () => {
    if (action) {
      eventBus.emit(`UI:${action}`, actionPayload ?? {});
    }
    onClick?.();
  };
  const press = pressableProps(isClickable ? handleClick : void 0);
  return /* @__PURE__ */ jsxs("div", { className: "relative inline-block", ...domPassthrough(rest), children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "relative inline-flex items-center justify-center",
          "bg-muted border-[length:var(--border-width)] border-border",
          "overflow-hidden",
          sizeClasses3[size2],
          isClickable && "cursor-pointer hover:bg-[var(--color-surface-hover)] transition-colors",
          className
        ),
        ...press,
        "aria-label": isClickable ? alt || name || initials : void 0,
        children: src && !imgFailed ? /* @__PURE__ */ jsx(
          "img",
          {
            src,
            alt: alt || t("avatar.alt"),
            className: "w-full h-full object-cover",
            onError: () => setImgFailed(true)
          }
        ) : hasInitials ? /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "w-full h-full flex items-center justify-center font-bold",
              getInitialsBackground()
            ),
            children: initials.substring(0, 2).toUpperCase()
          }
        ) : hasIcon && IconComponent ? /* @__PURE__ */ jsx(
          IconComponent,
          {
            className: cn(
              "text-foreground",
              iconSizeClasses[size2]
            )
          }
        ) : /* @__PURE__ */ jsx(
          Icon,
          {
            name: "user",
            className: cn(
              "text-foreground",
              iconSizeClasses[size2]
            )
          }
        )
      }
    ),
    status && /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "absolute bottom-0 right-0 border-heavy border-card",
          statusClasses[status],
          statusSizeClasses[size2]
        ),
        role: "img",
        "aria-label": t("avatar.status", { status: t(`avatar.status.${status}`) })
      }
    ),
    badge !== void 0 && /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "absolute -top-1 -right-1 flex items-center justify-center",
          "bg-primary text-primary-foreground font-bold",
          "border-heavy border-card",
          badgeSizeClasses[size2]
        ),
        "aria-label": t("avatar.badge", { badge }),
        children: typeof badge === "number" && badge > 99 ? "99+" : badge
      }
    )
  ] });
};
Avatar.displayName = "Avatar";
var Center = ({
  inline = false,
  horizontal = true,
  vertical = true,
  minHeight,
  fullHeight = false,
  fullWidth = false,
  className,
  style,
  children,
  as: Component = "div",
  ...rest
}) => {
  const mergedStyle = minHeight ? { minHeight, ...style } : style;
  return React93__default.createElement(Component, {
    ...domPassthrough(rest),
    className: cn(
      inline ? "inline-flex" : "flex",
      horizontal && "justify-center",
      vertical && "items-center",
      fullHeight && "h-full",
      fullWidth && "w-full",
      className
    ),
    style: mergedStyle,
    children
  });
};
var variantStyles5 = {
  solid: "border-solid",
  dashed: "border-dashed",
  dotted: "border-dotted"
};
var Divider = ({
  orientation = "horizontal",
  label,
  variant = "solid",
  className,
  ...rest
}) => {
  if (orientation === "vertical") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "w-0 h-full border-l border-border",
          variantStyles5[variant],
          className
        ),
        ...domPassthrough(rest),
        role: "separator",
        "aria-orientation": "vertical"
      }
    );
  }
  if (label) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: cn("flex items-center gap-3 my-4", className),
        ...domPassthrough(rest),
        role: "separator",
        "aria-label": rest["aria-label"] ?? label,
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "flex-1 h-0 border-t border-border",
                variantStyles5[variant]
              )
            }
          ),
          /* @__PURE__ */ jsx("span", { className: "text-sm text-foreground font-bold uppercase tracking-wide", children: label }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "flex-1 h-0 border-t border-border",
                variantStyles5[variant]
              )
            }
          )
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "w-full h-0 border-t border-border my-4",
        variantStyles5[variant],
        className
      ),
      ...domPassthrough(rest),
      role: "separator",
      "aria-orientation": "horizontal"
    }
  );
};
Divider.displayName = "Divider";
var colorClasses = {
  default: "bg-primary",
  primary: "bg-primary",
  success: "bg-success",
  warning: "bg-warning",
  error: "bg-error",
  danger: "bg-error"
};
var circularSizeClasses = {
  sm: "w-16 h-16",
  md: "w-24 h-24",
  lg: "w-32 h-32"
};
var ProgressBar = ({
  value,
  max = 100,
  progressType = "linear",
  variant = "primary",
  color,
  showPercentage = false,
  showLabel = false,
  label,
  size: size2 = "md",
  steps = 5,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const fmt2 = useFormatContext();
  const percentage = Math.min(Math.max(value / max * 100, 0), 100);
  const percentText = formatValue(Math.round(percentage), "percent", fmt2);
  const effectiveColor = color ?? variant;
  const effectiveShowPercentage = showPercentage || showLabel;
  const progressSemantics = {
    role: "progressbar",
    "aria-valuenow": value,
    "aria-valuemin": 0,
    "aria-valuemax": max,
    "aria-label": rest["aria-label"] ?? (label || t("progressBar.ariaLabel", { percent: percentText }))
  };
  if (progressType === "linear") {
    const showHeader = label || effectiveShowPercentage;
    return /* @__PURE__ */ jsxs("div", { className: cn("w-full", className), ...domPassthrough(rest), ...progressSemantics, children: [
      showHeader && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-1.5", children: [
        label && /* @__PURE__ */ jsx("span", { className: "text-sm font-bold text-foreground", children: label }),
        effectiveShowPercentage && /* @__PURE__ */ jsx("span", { className: cn("text-sm text-foreground font-medium", !label && "ml-auto"), children: percentText })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "w-full h-2 bg-muted border border-border overflow-hidden", children: /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "h-full transition-all duration-normal ease-emphasized",
            colorClasses[effectiveColor]
          ),
          style: { width: `${percentage}%` }
        }
      ) })
    ] });
  }
  if (progressType === "circular") {
    const radius = size2 === "sm" ? 28 : size2 === "md" ? 40 : 56;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - percentage / 100 * circumference;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        className: cn(
          "relative inline-flex items-center justify-center",
          className
        ),
        ...domPassthrough(rest),
        ...progressSemantics,
        children: [
          /* @__PURE__ */ jsxs(
            "svg",
            {
              className: cn("transform -rotate-90", circularSizeClasses[size2]),
              viewBox: "0 0 100 100",
              children: [
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    cx: "50",
                    cy: "50",
                    r: radius,
                    stroke: "currentColor",
                    strokeWidth: "8",
                    fill: "none",
                    className: "text-muted"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    cx: "50",
                    cy: "50",
                    r: radius,
                    stroke: "currentColor",
                    strokeWidth: "8",
                    fill: "none",
                    strokeDasharray: circumference,
                    strokeDashoffset: offset,
                    strokeLinecap: "round",
                    className: cn(
                      "transition-all duration-normal ease-emphasized",
                      colorClasses[effectiveColor]
                    )
                  }
                )
              ]
            }
          ),
          effectiveShowPercentage && /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx("span", { className: "text-sm font-bold text-foreground", children: percentText }) })
        ]
      }
    );
  }
  if (progressType === "stepped") {
    const stepValue = max / steps;
    const activeSteps = Math.floor(value / stepValue);
    const partialStep = value % stepValue / stepValue;
    const showStepHeader = label || effectiveShowPercentage;
    return /* @__PURE__ */ jsxs("div", { className: cn("w-full", className), ...domPassthrough(rest), ...progressSemantics, children: [
      showStepHeader && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-2", children: [
        label && /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-foreground", children: label }),
        effectiveShowPercentage && /* @__PURE__ */ jsx("span", { className: cn("text-sm text-muted-foreground", !label && "ml-auto"), children: percentText })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "flex gap-1", children: Array.from({ length: steps }).map((_, index) => {
        const isActive = index < activeSteps;
        const isPartial = index === activeSteps && partialStep > 0;
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "flex-1 h-2 bg-muted border border-border overflow-hidden",
            children: /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "h-full transition-all duration-normal ease-emphasized",
                  (isActive || isPartial) && colorClasses[effectiveColor]
                ),
                style: {
                  width: isPartial ? `${partialStep * 100}%` : isActive ? "100%" : "0%"
                }
              }
            )
          },
          index
        );
      }) })
    ] });
  }
  return null;
};
ProgressBar.displayName = "ProgressBar";
var sizeClasses4 = {
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6"
};
var dotSizeClasses = {
  sm: "w-2 h-2",
  md: "w-2.5 h-2.5",
  lg: "w-3 h-3"
};
var Radio = React93__default.forwardRef(
  ({
    label,
    helperText,
    error,
    size: size2 = "md",
    className,
    id,
    checked,
    disabled,
    options,
    value,
    action,
    name,
    onChange,
    required,
    ...props
  }, ref) => {
    const reactId = React93__default.useId();
    const baseId = id || `radio-${reactId}`;
    const hasError = !!error;
    const eventBus = useEventBus();
    const [selected, setSelected] = React93__default.useState(value);
    React93__default.useEffect(() => {
      if (value !== void 0) setSelected(value);
    }, [value]);
    const pick = (next, e) => {
      setSelected(next);
      if (action) eventBus.emit(`UI:${action}`, { value: next });
      onChange?.(e);
    };
    const control = (key, inputId, isChecked2, input) => /* @__PURE__ */ jsxs("div", { className: "relative flex-shrink-0 mt-0.5", children: [
      input,
      /* @__PURE__ */ jsx(
        "label",
        {
          htmlFor: inputId,
          className: cn(
            "flex items-center justify-center",
            "border-[length:var(--border-width)] transition-all cursor-pointer",
            sizeClasses4[size2],
            hasError ? "border-error peer-focus-visible:ring-error/20" : "border-border peer-focus-visible:ring-ring/20",
            isChecked2 ? hasError ? "border-error" : "border-primary bg-primary" : "",
            "peer-focus:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2",
            disabled && "opacity-50 cursor-not-allowed",
            !disabled && "hover:border-[var(--color-border-hover)]"
          ),
          children: isChecked2 && /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "transition-all",
                dotSizeClasses[size2],
                hasError ? "bg-error" : "bg-primary-foreground"
              )
            }
          )
        }
      )
    ] }, key);
    const optionLabel = (inputId, text) => /* @__PURE__ */ jsx("div", { className: "flex-1 min-w-0", children: /* @__PURE__ */ jsx(
      "label",
      {
        htmlFor: inputId,
        className: cn(
          "block text-sm font-medium cursor-pointer select-none",
          hasError ? "text-error" : "text-foreground",
          disabled && "opacity-50 cursor-not-allowed"
        ),
        children: text
      }
    ) });
    const describedBy = (extra) => [extra, error ? `${baseId}-error` : helperText ? `${baseId}-helper` : void 0].filter(Boolean).join(" ") || void 0;
    const helper = helperText || error ? /* @__PURE__ */ jsxs("div", { className: "mt-1.5 ml-8", children: [
      error && /* @__PURE__ */ jsx("p", { id: `${baseId}-error`, className: "text-sm text-error font-medium", role: "alert", children: error }),
      !error && helperText && /* @__PURE__ */ jsx("p", { id: `${baseId}-helper`, className: "text-sm text-muted-foreground", children: helperText })
    ] }) : null;
    if (options && options.length > 0) {
      const groupName = name || baseId;
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            ...domPassthrough(props),
            className: "flex flex-col gap-3",
            role: "radiogroup",
            "aria-label": props["aria-label"] ?? (props["aria-labelledby"] ? void 0 : label),
            "aria-invalid": hasError,
            "aria-required": required ? true : void 0,
            "aria-describedby": describedBy(props["aria-describedby"]),
            children: options.map((opt, i) => {
              const inputId = `${baseId}-${i}`;
              const isChecked2 = selected === opt;
              return /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
                control(
                  opt,
                  inputId,
                  isChecked2,
                  /* @__PURE__ */ jsx(
                    "input",
                    {
                      type: "radio",
                      id: inputId,
                      name: groupName,
                      value: opt,
                      checked: isChecked2,
                      disabled,
                      required,
                      onChange: (e) => pick(opt, e),
                      className: cn("sr-only peer", className)
                    }
                  )
                ),
                optionLabel(inputId, opt)
              ] }, opt);
            })
          }
        ),
        helper
      ] });
    }
    const isChecked = checked !== void 0 ? !!checked : selected === (value ?? baseId);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
        control(
          baseId,
          baseId,
          isChecked,
          /* @__PURE__ */ jsx(
            "input",
            {
              ref,
              type: "radio",
              id: baseId,
              checked: isChecked,
              disabled,
              onChange: (e) => pick(value ?? baseId, e),
              className: cn("sr-only peer", className),
              required,
              ...props,
              "aria-invalid": hasError,
              "aria-required": required ? true : void 0,
              "aria-describedby": describedBy(props["aria-describedby"])
            }
          )
        ),
        label && optionLabel(baseId, label)
      ] }),
      helper
    ] });
  }
);
Radio.displayName = "Radio";
var COLOR_VAR = {
  primary: "var(--color-primary)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  error: "var(--color-error)",
  info: "var(--color-info)",
  muted: "var(--color-muted-foreground)"
};
var Sparkline = ({
  data,
  color = "auto",
  width = 80,
  height = 32,
  strokeWidth = 2,
  fill = false,
  className,
  ...rest
}) => {
  if (data.length < 2) return null;
  const pad = 2;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const points = data.map((v, i) => {
    const x = pad + i / (data.length - 1) * (width - pad * 2);
    const y = pad + (1 - (v - min) / range) * (height - pad * 2);
    return `${x},${y}`;
  }).join(" ");
  const resolvedColor = color === "auto" ? data[data.length - 1] >= data[0] ? COLOR_VAR.success : COLOR_VAR.error : COLOR_VAR[color];
  const areaPath = fill ? `M ${pad},${height - pad} L ${points.split(" ").join(" L ")} L ${width - pad},${height - pad} Z` : null;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width,
      height,
      viewBox: `0 0 ${width} ${height}`,
      className: cn("flex-shrink-0", className),
      ...domPassthrough(rest),
      "aria-hidden": rest["aria-hidden"] ?? true,
      children: [
        areaPath && /* @__PURE__ */ jsx("path", { d: areaPath, fill: resolvedColor, opacity: 0.15 }),
        /* @__PURE__ */ jsx(
          "polyline",
          {
            fill: "none",
            stroke: resolvedColor,
            strokeWidth,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            points
          }
        )
      ]
    }
  );
};
Sparkline.displayName = "Sparkline";
var Switch = React93.forwardRef(
  ({
    checked,
    defaultChecked = false,
    onChange,
    disabled = false,
    label,
    id,
    name,
    className,
    ...rest
  }, ref) => {
    const generatedId = React93.useId();
    const switchId = id ?? generatedId;
    const [isChecked, setIsChecked] = React93.useState(
      checked !== void 0 ? checked : defaultChecked
    );
    React93.useEffect(() => {
      if (checked !== void 0) {
        setIsChecked(checked);
      }
    }, [checked]);
    const handleClick = () => {
      if (disabled) return;
      const newValue = !isChecked;
      if (checked === void 0) {
        setIsChecked(newValue);
      }
      onChange?.(newValue);
    };
    return /* @__PURE__ */ jsxs("div", { className: cn("inline-flex items-center gap-2", className), children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          ...domPassthrough(rest),
          ref,
          type: "button",
          role: "switch",
          "aria-checked": isChecked,
          id: switchId,
          name,
          disabled,
          onClick: handleClick,
          className: cn(
            // Fixed rem sizes instead of spacing tokens: themes like atelier
            // redefine --space-11 to 68px, which makes w-11 enormous and leaves
            // the thumb stuck near the left edge. The switch geometry must stay
            // proportional regardless of a theme's density scale.
            "relative inline-flex h-[1.5rem] w-[2.75rem] shrink-0 cursor-pointer items-center rounded-full border-heavy border-transparent transition-colors duration-fast",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
            isChecked ? "bg-primary" : "bg-muted",
            disabled && "cursor-not-allowed opacity-50"
          ),
          children: /* @__PURE__ */ jsx(
            "span",
            {
              className: cn(
                "pointer-events-none block h-[1.25rem] w-[1.25rem] rounded-full bg-background shadow-elevation-interactive ring-0 transition-transform duration-fast",
                isChecked ? "translate-x-[1.25rem]" : "translate-x-0"
              )
            }
          )
        }
      ),
      label && /* @__PURE__ */ jsx(
        "label",
        {
          htmlFor: switchId,
          className: cn(
            "text-sm font-medium leading-none cursor-pointer",
            disabled && "cursor-not-allowed opacity-70"
          ),
          children: label
        }
      )
    ] });
  }
);
Switch.displayName = "Switch";
var horizontalSizes = {
  xs: "w-1",
  sm: "w-2",
  md: "w-4",
  lg: "w-6",
  xl: "w-8",
  "2xl": "w-12"
};
var verticalSizes = {
  xs: "h-1",
  sm: "h-2",
  md: "h-4",
  lg: "h-6",
  xl: "h-8",
  "2xl": "h-12"
};
var Spacer = ({
  size: size2 = "auto",
  axis = "horizontal",
  className,
  ...rest
}) => {
  if (size2 === "auto") {
    return /* @__PURE__ */ jsx("div", { className: cn("flex-1", className), ...domPassthrough(rest), "aria-hidden": "true" });
  }
  const sizeClass = axis === "horizontal" ? horizontalSizes[size2] : verticalSizes[size2];
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("flex-shrink-0", sizeClass, className),
      ...domPassthrough(rest),
      "aria-hidden": "true"
    }
  );
};
var TextHighlight = ({
  highlightType,
  isActive = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
  annotationId,
  className,
  children,
  action,
  hoverEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const baseStyles = "cursor-pointer transition-all duration-fast";
  const typeStyles = {
    question: cn(
      // Blue border for questions
      "bg-card border-b-heavy border-primary",
      "hover:bg-muted",
      isActive && "bg-primary/10 ring-2 ring-primary"
    ),
    note: cn(
      // Yellow border for notes
      "bg-card border-b-heavy border-warning",
      "hover:bg-muted",
      isActive && "bg-warning/10 ring-2 ring-warning"
    )
  };
  return /* @__PURE__ */ jsx(
    "span",
    {
      "data-highlight": "true",
      "data-highlight-type": highlightType,
      "data-annotation-id": annotationId,
      className: cn(baseStyles, typeStyles[highlightType], className),
      onClick: () => {
        if (action) eventBus.emit(`UI:${action}`, { annotationId });
        onClick?.();
      },
      onMouseEnter: () => {
        if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: true, annotationId });
        onMouseEnter?.();
      },
      onMouseLeave: () => {
        if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: false, annotationId });
        onMouseLeave?.();
      },
      onPointerDown: (e) => {
        if (e.pointerType === "mouse") return;
        if (hoverEvent) eventBus.emit(`UI:${hoverEvent}`, { hovered: true, annotationId });
        onMouseEnter?.();
      },
      role: "button",
      tabIndex: 0,
      "aria-pressed": isActive,
      ...domPassthrough(rest),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (action) eventBus.emit(`UI:${action}`, { annotationId });
          onClick?.();
        }
      },
      children
    }
  );
};
TextHighlight.displayName = "TextHighlight";
var sizeClasses5 = {
  sm: "p-1.5",
  md: "p-2",
  lg: "p-2.5"
};
var iconSizes2 = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6"
};
var ThemeToggle = ({
  className,
  size: size2 = "md",
  showLabel = false,
  ...rest
}) => {
  const { resolvedMode, toggleMode } = useTheme();
  const { t } = useTranslate();
  const isDark = resolvedMode === "dark";
  const switchLabel = isDark ? t("themeToggle.switchToLight") : t("themeToggle.switchToDark");
  return /* @__PURE__ */ jsxs(
    "button",
    {
      type: "button",
      onClick: toggleMode,
      className: cn(
        "inline-flex items-center justify-center gap-2",
        "text-foreground",
        "hover:bg-muted border-[length:var(--border-width)] border-transparent hover:border-border",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "transition-colors duration-fast",
        sizeClasses5[size2],
        className
      ),
      ...domPassthrough(rest),
      "aria-label": rest["aria-label"] ?? switchLabel,
      title: switchLabel,
      children: [
        isDark ? /* @__PURE__ */ jsx(
          Icon,
          {
            name: "sun",
            className: cn(iconSizes2[size2], "text-foreground")
          }
        ) : /* @__PURE__ */ jsx(
          Icon,
          {
            name: "moon",
            className: cn(iconSizes2[size2], "text-foreground")
          }
        ),
        showLabel && /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: isDark ? t("themeToggle.light") : t("themeToggle.dark") })
      ]
    }
  );
};
ThemeToggle.displayName = "ThemeToggle";
var FlipContainer = ({
  flipped,
  className,
  children,
  onClick,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn("relative w-full cursor-pointer", className),
      style: { perspective: "1000px" },
      ...domPassthrough(rest),
      ...pressableProps(onClick),
      children: /* @__PURE__ */ jsx(
        Box,
        {
          className: "relative w-full h-full transition-transform duration-slow",
          style: {
            transformStyle: "preserve-3d",
            transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)"
          },
          children
        }
      )
    }
  );
};
FlipContainer.displayName = "FlipContainer";
var Aside = React93__default.forwardRef(
  ({ className, children, ...rest }, ref) => /* @__PURE__ */ jsx("aside", { ref, className: cn(className), ...rest, children })
);
Aside.displayName = "Aside";
function toSharedContext(ctx) {
  return createMinimalContext(
    {
      formValues: ctx.formValues,
      globalVariables: ctx.globalVariables,
      localVariables: ctx.localVariables ?? {},
      ...ctx.entity
    },
    {},
    "active"
  );
}
var ConditionalWrapper = ({
  condition,
  context,
  children,
  fallback = null,
  animate = false
}) => {
  if (!condition) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  const sharedContext = toSharedContext(context);
  const result = evaluate(condition, sharedContext);
  const isVisible = Boolean(result);
  if (animate) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        overflow: "hidden",
        className: `transition-all duration-fast ${isVisible ? "opacity-100 max-h-[1000px]" : "opacity-0 max-h-0"}`,
        children: isVisible ? children : fallback
      }
    );
  }
  return isVisible ? /* @__PURE__ */ jsx(Fragment, { children }) : /* @__PURE__ */ jsx(Fragment, { children: fallback });
};
ConditionalWrapper.displayName = "ConditionalWrapper";
var positionStyles = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2"
};
var arrowStyles = {
  top: "top-full left-1/2 -translate-x-1/2 border-t-foreground border-l-transparent border-r-transparent border-b-transparent",
  bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-foreground border-l-transparent border-r-transparent border-t-transparent",
  left: "left-full top-1/2 -translate-y-1/2 border-l-foreground border-t-transparent border-b-transparent border-r-transparent",
  right: "right-full top-1/2 -translate-y-1/2 border-r-foreground border-t-transparent border-b-transparent border-l-transparent"
};
var LawReferenceTooltip = ({
  reference,
  children,
  position = "top",
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const [isVisible, setIsVisible] = React93__default.useState(false);
  const timeoutRef = React93__default.useRef(null);
  const triggerRef = React93__default.useRef(null);
  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setIsVisible(true), 200);
  };
  const handleMouseLeave = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsVisible(false);
  };
  const { revealed, triggerProps } = useTapReveal({ refs: [triggerRef] });
  const open = isVisible || revealed;
  React93__default.useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: triggerRef,
      as: "span",
      position: "relative",
      display: "inline-block",
      className,
      ...domPassthrough(rest),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onFocus: handleMouseEnter,
      onBlur: handleMouseLeave,
      onPointerDown: triggerProps.onPointerDown,
      children: [
        children,
        open && /* @__PURE__ */ jsxs(
          Box,
          {
            padding: "sm",
            rounded: "lg",
            position: "absolute",
            className: cn(
              "z-50 w-64 bg-foreground text-background shadow-elevation-popover",
              positionStyles[position]
            ),
            role: "tooltip",
            children: [
              /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                /* @__PURE__ */ jsxs(
                  Typography,
                  {
                    variant: "label",
                    weight: "semibold",
                    className: "text-warning",
                    children: [
                      reference.law,
                      " ",
                      reference.article
                    ]
                  }
                ),
                reference.lawName && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: "text-muted-foreground",
                    children: reference.lawName
                  }
                ),
                reference.clause && /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Divider, { className: "border-border" }),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      className: "text-background leading-relaxed",
                      children: reference.clause
                    }
                  )
                ] }),
                reference.link && /* @__PURE__ */ jsx(
                  "a",
                  {
                    href: reference.link,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    onClick: (e) => e.stopPropagation(),
                    className: "text-xs text-info hover:text-info/80 underline cursor-pointer",
                    children: t("lawReference.viewFullText")
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  as: "span",
                  position: "absolute",
                  className: cn("w-0 h-0 border-heavy", arrowStyles[position])
                }
              )
            ]
          }
        )
      ]
    }
  );
};
LawReferenceTooltip.displayName = "LawReferenceTooltip";
function DayCell({
  date,
  isToday = false,
  onClick,
  className,
  ...rest
}) {
  const { locale } = useTranslate();
  const safeDate = date instanceof Date && !Number.isNaN(date.getTime()) ? date : /* @__PURE__ */ new Date();
  const handleClick = useCallback(() => {
    onClick?.(safeDate);
  }, [onClick, safeDate]);
  const dayAbbr = new Intl.DateTimeFormat(locale, { weekday: "short" }).format(safeDate);
  const press = pressableProps(onClick ? handleClick : void 0);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "p-2 text-center cursor-pointer hover:bg-muted transition-colors",
        isToday && "bg-primary/10",
        className
      ),
      ...domPassthrough(rest),
      ...press,
      "aria-label": rest["aria-label"] ?? (onClick ? new Intl.DateTimeFormat(locale, { dateStyle: "full" }).format(safeDate) : void 0),
      children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "small",
            className: cn(
              "font-medium",
              isToday ? "text-primary" : "text-muted-foreground"
            ),
            children: dayAbbr
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            display: "flex",
            rounded: "full",
            className: cn(
              "h-8 w-8 mx-auto items-center justify-center",
              isToday && "bg-primary text-primary-foreground"
            ),
            children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-semibold", children: safeDate.getDate() })
          }
        )
      ]
    }
  );
}
DayCell.displayName = "DayCell";
function TimeSlotCell({
  time,
  onClick,
  className,
  children,
  isOccupied = false,
  onPointerDown,
  onPointerUp,
  onPointerCancel,
  onPointerLeave,
  "data-testid": testId,
  ...rest
}) {
  const handleClick = useCallback(() => {
    onClick?.(time);
  }, [onClick, time]);
  const press = pressableProps(onClick ? handleClick : void 0);
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn(
        "p-1 min-h-[60px] cursor-pointer hover:bg-muted transition-colors",
        isOccupied && "bg-muted/30",
        className
      ),
      ...domPassthrough(rest),
      ...press,
      "aria-label": rest["aria-label"] ?? (onClick ? time : void 0),
      onPointerDown,
      onPointerUp,
      onPointerCancel,
      onPointerLeave,
      "data-testid": testId,
      children
    }
  );
}
TimeSlotCell.displayName = "TimeSlotCell";
var statusColors = {
  online: "bg-success",
  offline: "bg-muted-foreground",
  away: "bg-warning",
  busy: "bg-error",
  warning: "bg-warning",
  critical: "bg-error"
};
var pulseRingColors = {
  online: "ring-success",
  offline: "ring-muted-foreground",
  away: "ring-warning",
  busy: "ring-error",
  warning: "ring-warning",
  critical: "ring-error"
};
var sizeStyles5 = {
  sm: "w-2 h-2",
  md: "w-2.5 h-2.5",
  lg: "w-3 h-3"
};
var StatusDot = React93__default.forwardRef(
  ({ className, status = "offline", pulse = false, size: size2 = "md", label, ...props }, ref) => {
    const { t } = useTranslate();
    return /* @__PURE__ */ jsx(
      "span",
      {
        ref,
        className: cn(
          "inline-block rounded-full flex-shrink-0",
          statusColors[status],
          sizeStyles5[size2],
          pulse && [
            "animate-pulse",
            "ring-2 ring-offset-1",
            pulseRingColors[status],
            "ring-opacity-40"
          ],
          className
        ),
        role: "status",
        "aria-label": label ?? t(`statusDot.${status}`),
        ...props
      }
    );
  }
);
StatusDot.displayName = "StatusDot";
var sizeStyles6 = {
  sm: { icon: "w-3 h-3", text: "text-xs" },
  md: { icon: "w-4 h-4", text: "text-sm" },
  lg: { icon: "w-5 h-5", text: "text-base" }
};
function resolveDirection(value, direction) {
  if (direction) return direction;
  if (value === void 0 || value === 0) return "flat";
  return value > 0 ? "up" : "down";
}
function resolveColor(dir, invert) {
  if (dir === "flat") return "text-muted-foreground";
  const isPositive = dir === "up";
  const isGood = invert ? !isPositive : isPositive;
  return isGood ? "text-success" : "text-error";
}
var iconNameMap = {
  up: "trending-up",
  down: "trending-down",
  flat: "arrow-right"
};
var TrendIndicator = React93__default.forwardRef(
  ({
    className,
    value,
    direction,
    showValue = true,
    invert = false,
    label,
    size: size2 = "md",
    ...props
  }, ref) => {
    const { t, locale } = useTranslate();
    const hasValue = typeof value === "number" && Number.isFinite(value);
    if (!hasValue && !direction) return null;
    const dir = resolveDirection(hasValue ? value : void 0, direction);
    const colorClass = resolveColor(dir, invert);
    const iconName = iconNameMap[dir];
    const styles = sizeStyles6[size2];
    const formattedValue = hasValue ? new Intl.NumberFormat(locale, { style: "percent", signDisplay: "exceptZero", maximumFractionDigits: 2 }).format(value / 100) : void 0;
    const ariaLabel = label ?? (formattedValue ? t("trendIndicator.withValue", { direction: t(`trendIndicator.${dir}`), value: formattedValue }) : t(`trendIndicator.${dir}`));
    return /* @__PURE__ */ jsxs(
      "span",
      {
        ref,
        className: cn(
          "inline-flex items-center gap-1 font-medium",
          colorClass,
          styles.text,
          className
        ),
        role: "status",
        "aria-label": ariaLabel,
        ...props,
        children: [
          /* @__PURE__ */ jsx(Icon, { name: iconName, className: styles.icon }),
          showValue && formattedValue && /* @__PURE__ */ jsx("span", { children: formattedValue })
        ]
      }
    );
  }
);
TrendIndicator.displayName = "TrendIndicator";
function useSafeEventBus() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var trackSizes = {
  sm: "h-1",
  md: "h-1.5",
  lg: "h-2"
};
var thumbSizes = {
  sm: "w-3 h-3",
  md: "w-4 h-4",
  lg: "w-5 h-5"
};
var RangeSlider = React93__default.forwardRef(
  ({
    className,
    min = 0,
    max = 100,
    value = 0,
    step = 1,
    showTooltip = false,
    showTicks = false,
    buffered,
    size: size2 = "md",
    disabled = false,
    action,
    actionPayload,
    onChange,
    formatValue: formatValue3,
    ...props
  }, ref) => {
    const { t } = useTranslate();
    const [isDragging, setIsDragging] = useState(false);
    const [showTip, setShowTip] = useState(false);
    const inputRef = useRef(null);
    const eventBus = useSafeEventBus();
    const percentage = max !== min ? (value - min) / (max - min) * 100 : 0;
    const bufferedPercentage = buffered !== void 0 ? Math.min(buffered, 100) : void 0;
    const displayValue = formatValue3 ? formatValue3(value) : String(value);
    const handleChange = useCallback(
      (e) => {
        const newValue = Number(e.target.value);
        onChange?.(newValue);
        if (action) {
          eventBus.emit(`UI:${action}`, { ...actionPayload, value: newValue });
        }
      },
      [onChange, action, actionPayload, eventBus]
    );
    const tickCount = showTicks ? Math.min(Math.floor((max - min) / step), 20) : 0;
    return /* @__PURE__ */ jsxs(
      "div",
      {
        ref,
        className: cn(
          "relative w-full",
          disabled && "opacity-50 cursor-not-allowed",
          className
        ),
        ...props,
        children: [
          /* @__PURE__ */ jsxs("div", { className: "relative w-full py-2", children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute inset-x-0 rounded-full bg-muted",
                  trackSizes[size2]
                ),
                style: { top: "50%", transform: "translateY(-50%)" }
              }
            ),
            bufferedPercentage !== void 0 && /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute rounded-full bg-muted-foreground opacity-30",
                  trackSizes[size2]
                ),
                style: {
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: 0,
                  width: `${bufferedPercentage}%`
                }
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute rounded-full bg-primary",
                  trackSizes[size2]
                ),
                style: {
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: 0,
                  width: `${percentage}%`
                }
              }
            ),
            /* @__PURE__ */ jsx(
              "input",
              {
                ref: inputRef,
                type: "range",
                min,
                max,
                step,
                value,
                disabled,
                onChange: handleChange,
                onMouseDown: () => {
                  setIsDragging(true);
                  setShowTip(true);
                },
                onMouseUp: () => {
                  setIsDragging(false);
                  setShowTip(false);
                },
                onTouchStart: () => {
                  setIsDragging(true);
                  setShowTip(true);
                },
                onTouchEnd: () => {
                  setIsDragging(false);
                  setShowTip(false);
                },
                onFocus: () => setShowTip(true),
                onBlur: () => {
                  if (!isDragging) setShowTip(false);
                },
                className: cn(
                  "absolute inset-0 w-full opacity-0 cursor-pointer",
                  disabled && "cursor-not-allowed",
                  // Thumb sizing via pseudo-element
                  "[&::-webkit-slider-thumb]:appearance-none",
                  "[&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5",
                  "[&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5"
                ),
                style: { height: "100%", margin: 0 },
                "aria-label": props["aria-label"] ?? t("rangeSlider.ariaLabel"),
                "aria-valuemin": min,
                "aria-valuemax": max,
                "aria-valuenow": value,
                "aria-valuetext": displayValue
              }
            ),
            /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute rounded-full bg-primary-foreground",
                  "border-heavy border-primary",
                  "shadow-elevation-interactive",
                  "pointer-events-none",
                  "transition-transform duration-instant",
                  isDragging && "scale-[var(--hover-scale)]",
                  thumbSizes[size2]
                ),
                style: {
                  top: "50%",
                  transform: `translateY(-50%) translateX(-50%)${isDragging ? " scale(var(--hover-scale))" : ""}`,
                  left: `${percentage}%`
                }
              }
            ),
            showTooltip && showTip && /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "absolute -top-8 px-2 py-0.5 rounded-container",
                  "bg-foreground text-background",
                  "text-xs font-medium whitespace-nowrap",
                  "pointer-events-none"
                ),
                style: {
                  left: `${percentage}%`,
                  transform: "translateX(-50%)"
                },
                children: displayValue
              }
            )
          ] }),
          showTicks && tickCount > 0 && /* @__PURE__ */ jsx("div", { className: "relative w-full h-2 mt-1", children: Array.from({ length: tickCount + 1 }, (_, i) => {
            const tickPercent = i / tickCount * 100;
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: "absolute w-px h-1.5 bg-muted-foreground",
                style: { left: `${tickPercent}%` }
              },
              i
            );
          }) })
        ]
      }
    );
  }
);
RangeSlider.displayName = "RangeSlider";
var InfiniteScrollSentinel = ({
  loadMoreEvent,
  loadMorePayload,
  isLoading = false,
  hasMore = true,
  threshold = "200px",
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const onLoadMore = useCallback(() => {
    eventBus.emit(`UI:${loadMoreEvent}`, loadMorePayload ?? {});
  }, [eventBus, loadMoreEvent, loadMorePayload]);
  const { sentinelRef } = useInfiniteScroll(onLoadMore, {
    rootMargin: threshold,
    hasMore,
    isLoading
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn("flex items-center justify-center py-4", className),
      ...domPassthrough(rest),
      children: [
        /* @__PURE__ */ jsx(Box, { ref: sentinelRef, className: "h-1 w-full", "aria-hidden": "true" }),
        isLoading && /* @__PURE__ */ jsx(Spinner, { size: "sm" })
      ]
    }
  );
};
InfiniteScrollSentinel.displayName = "InfiniteScrollSentinel";
var ConfettiEffect = ({
  trigger,
  duration = 2e3,
  particleCount = 30,
  className,
  ...rest
}) => {
  const [particles, setParticles] = useState([]);
  const previousTriggerRef = useRef(false);
  const burstRef = useRef(0);
  const reducedMotion = usePrefersReducedMotion();
  useEffect(() => {
    const wasFalse = !previousTriggerRef.current;
    previousTriggerRef.current = trigger;
    if (trigger && wasFalse && !reducedMotion) {
      burstRef.current += 1;
      const newParticles = createConfettiParticles(particleCount, `confetti-${burstRef.current}`);
      setParticles(newParticles);
      const timer = window.setTimeout(() => {
        setParticles([]);
      }, duration);
      return () => {
        window.clearTimeout(timer);
      };
    }
    return void 0;
  }, [trigger, particleCount, duration, reducedMotion]);
  if (particles.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      position: "absolute",
      className: cn(
        "inset-0 pointer-events-none overflow-hidden z-50",
        className
      ),
      ...domPassthrough(rest),
      "aria-hidden": "true",
      children: [
        particles.map((p) => {
          const rad = p.angle * Math.PI / 180;
          const tx = Math.cos(rad) * p.distance;
          const ty = Math.sin(rad) * p.distance - 20;
          return /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute rounded-sm",
              style: {
                left: `${p.left}%`,
                top: "50%",
                width: p.size,
                height: p.size,
                backgroundColor: p.color,
                animation: `confetti-burst ${duration - p.delay}ms ease-out ${p.delay}ms forwards`,
                opacity: 0,
                "--confetti-tx": `${tx}px`,
                "--confetti-ty": `${ty}px`,
                "--confetti-rotate": `${p.rotation}deg`
              }
            },
            p.id
          );
        }),
        /* @__PURE__ */ jsx("style", { children: CONFETTI_BURST_KEYFRAMES })
      ]
    }
  );
};
ConfettiEffect.displayName = "ConfettiEffect";
var TypewriterText = ({
  text,
  speed = 40,
  startDelay = 0,
  className,
  onComplete,
  ...rest
}) => {
  const safeText = typeof text === "string" ? text : String(text ?? "");
  const [charCount, setCharCount] = useState(0);
  const [started, setStarted] = useState(startDelay === 0);
  const reducedMotion = usePrefersReducedMotion();
  const onCompleteRef = useRef(onComplete);
  onCompleteRef.current = onComplete;
  useEffect(() => {
    if (startDelay <= 0) {
      setStarted(true);
      return void 0;
    }
    setStarted(false);
    setCharCount(0);
    const delayTimer = window.setTimeout(() => {
      setStarted(true);
    }, startDelay);
    return () => {
      window.clearTimeout(delayTimer);
    };
  }, [startDelay, text]);
  useEffect(() => {
    setCharCount(0);
  }, [text]);
  useEffect(() => {
    if (!started) return void 0;
    if (reducedMotion || charCount >= safeText.length) {
      onCompleteRef.current?.();
      return void 0;
    }
    const interval = window.setInterval(() => {
      setCharCount((prev) => {
        const next = prev + 1;
        if (next >= safeText.length) {
          window.clearInterval(interval);
        }
        return next;
      });
    }, speed);
    return () => {
      window.clearInterval(interval);
    };
  }, [started, text, speed, charCount, reducedMotion]);
  const isComplete = reducedMotion || charCount >= safeText.length;
  const displayedText = reducedMotion ? safeText : safeText.slice(0, charCount);
  return /* @__PURE__ */ jsxs(Typography, { variant: "body", className: cn("inline", className), ...domPassthrough(rest), children: [
    displayedText,
    !isComplete && /* @__PURE__ */ jsx(
      "span",
      {
        className: "inline-block w-[2px] h-[1em] bg-foreground ml-[1px] align-text-bottom animate-pulse",
        "aria-hidden": "true"
      }
    )
  ] });
};
TypewriterText.displayName = "TypewriterText";
var levelToVariant = {
  1: "h1",
  2: "h2",
  3: "h3"
};
var alignClasses = {
  center: "text-center",
  left: "text-left",
  right: "text-right"
};
var alignToStack = {
  center: "center",
  left: "start",
  right: "end"
};
var SectionHeader = ({ title, subtitle, align = "center", level = 2, className, ...rest }) => {
  const variant = levelToVariant[level];
  return /* @__PURE__ */ jsxs(
    VStack,
    {
      gap: "sm",
      align: alignToStack[align],
      className: cn(alignClasses[align], className),
      ...domPassthrough(rest),
      children: [
        /* @__PURE__ */ jsx(Typography, { variant, weight: "bold", children: title }),
        subtitle ? /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: subtitle }) : null
      ]
    }
  );
};
SectionHeader.displayName = "SectionHeader";
var PI = Math.PI;
function lineIntersection(x1, y1, x2, y2, x3, y3, x4, y4) {
  const denom = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
  if (Math.abs(denom) < 1e-10) return [(x1 + x3) / 2, (y1 + y3) / 2];
  const t = ((x1 - x3) * (y3 - y4) - (y1 - y3) * (x3 - x4)) / denom;
  return [x1 + t * (x2 - x1), y1 + t * (y2 - y1)];
}
function f(n) {
  return n.toFixed(3);
}
function picStar(cx, cy, R, n, theta, extent) {
  const verts = [];
  for (let k = 0; k < n; k++) {
    const angle = PI / n + k * (2 * PI) / n;
    verts.push([cx + R * Math.cos(angle), cy + R * Math.sin(angle)]);
  }
  const mids = [];
  for (let k = 0; k < n; k++) {
    const next = (k + 1) % n;
    mids.push([(verts[k][0] + verts[next][0]) / 2, (verts[k][1] + verts[next][1]) / 2]);
  }
  const innerPts = [];
  for (let k = 0; k < n; k++) {
    const next = (k + 1) % n;
    const M1 = mids[k];
    const M2 = mids[next];
    const edx1 = verts[(k + 1) % n][0] - verts[k][0];
    const edy1 = verts[(k + 1) % n][1] - verts[k][1];
    const elen1 = Math.sqrt(edx1 * edx1 + edy1 * edy1);
    const tx1 = edx1 / elen1;
    const ty1 = edy1 / elen1;
    const r1x = tx1 * Math.cos(theta) + ty1 * Math.sin(theta);
    const r1y = -tx1 * Math.sin(theta) + ty1 * Math.cos(theta);
    const edx2 = verts[(next + 1) % n][0] - verts[next][0];
    const edy2 = verts[(next + 1) % n][1] - verts[next][1];
    const elen2 = Math.sqrt(edx2 * edx2 + edy2 * edy2);
    const tx2 = edx2 / elen2;
    const ty2 = edy2 / elen2;
    const bTheta = PI - theta;
    const r2x = tx2 * Math.cos(bTheta) + ty2 * Math.sin(bTheta);
    const r2y = -tx2 * Math.sin(bTheta) + ty2 * Math.cos(bTheta);
    const P = lineIntersection(
      M1[0],
      M1[1],
      M1[0] + r1x * extent,
      M1[1] + r1y * extent,
      M2[0],
      M2[1],
      M2[0] + r2x * extent,
      M2[1] + r2y * extent
    );
    innerPts.push(P);
  }
  const starPath = mids.map((m, k) => {
    const inner = innerPts[k];
    const nextMid = mids[(k + 1) % n];
    return `M ${f(m[0])},${f(m[1])} L ${f(inner[0])},${f(inner[1])} L ${f(nextMid[0])},${f(nextMid[1])}`;
  }).join(" ");
  return { starPath, mids, verts };
}
function Star8({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const R = a / (2 * Math.sin(PI / 8));
  const theta = 67.5 * PI / 180;
  const { starPath, mids } = picStar(cx, cy, R, 8, theta, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = mids[dists[0].i];
    const m2 = mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Star6({ size: size2, color, strokeWidth }) {
  const w = size2;
  const h = size2 * (2 / Math.sqrt(3));
  const cx = w / 2;
  const cy = h / 2;
  const a = w / Math.sqrt(3);
  const R = a;
  const theta = 60 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 6, theta, w);
  const triPaths = [];
  for (let k = 0; k < 6; k++) {
    const v = verts[k];
    const m1 = mids[(k + 5) % 6];
    const m2 = mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Khatam({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const R = a / (2 * Math.sin(PI / 8));
  const theta = 72 * PI / 180;
  const { starPath, mids } = picStar(cx, cy, R, 8, theta, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = mids[dists[0].i];
    const m2 = mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const orbitR = R * 0.35;
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)),
    /* @__PURE__ */ jsx("circle", { cx, cy, r: orbitR, opacity: "0.4" })
  ] });
}
function RosetteDouble({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const Router = a / (2 * Math.sin(PI / 8));
  const Rinner = Router * 0.45;
  const outer = picStar(cx, cy, Router, 8, 72 * PI / 180, s);
  const inner = picStar(cx, cy, Rinner, 8, 68 * PI / 180, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = outer.mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = outer.mids[dists[0].i];
    const m2 = outer.mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const connectors = [];
  for (let k = 0; k < 8; k++) {
    const om = outer.mids[k];
    const im = inner.mids[k];
    connectors.push(`M ${f(im[0])},${f(im[1])} L ${f(om[0])},${f(om[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: outer.starPath }),
    /* @__PURE__ */ jsx("path", { d: inner.starPath, opacity: "0.7" }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    connectors.map((d, i) => /* @__PURE__ */ jsx("path", { d, opacity: "0.4" }, `n${i}`))
  ] });
}
function RosetteFilled({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const a = s / (1 + Math.SQRT2);
  const Router = a / (2 * Math.sin(PI / 8));
  const theta = 72 * PI / 180;
  const outer = picStar(cx, cy, Router, 8, theta, s);
  const Rinner = Router * 0.35;
  const inner6 = picStar(cx, cy, Rinner, 6, 60 * PI / 180, s);
  const corners = [[0, 0], [s, 0], [s, s], [0, s]];
  const crossPaths = [];
  for (const [cornX, cornY] of corners) {
    const dists = outer.mids.map((m, i) => ({ i, d: Math.hypot(m[0] - cornX, m[1] - cornY) }));
    dists.sort((a2, b) => a2.d - b.d);
    const m1 = outer.mids[dists[0].i];
    const m2 = outer.mids[dists[1].i];
    crossPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(cornX)},${f(cornY)} L ${f(m2[0])},${f(m2[1])}`);
  }
  const triPaths = [];
  for (let k = 0; k < 6; k++) {
    const v = inner6.verts[k];
    const m1 = inner6.mids[(k + 5) % 6];
    const m2 = inner6.mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  const orbitR = Router * 0.35;
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: outer.starPath }),
    crossPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    /* @__PURE__ */ jsx("circle", { cx, cy, r: orbitR, opacity: "0.3" }),
    /* @__PURE__ */ jsx("path", { d: inner6.starPath, opacity: "0.6" }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d, opacity: "0.5" }, `t${i}`))
  ] });
}
function Star10({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const R = s * 0.42;
  const theta = 72 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 10, theta, s);
  const edgePaths = [];
  for (let k = 0; k < 10; k++) {
    const v = verts[k];
    const m1 = mids[(k + 9) % 10];
    const m2 = mids[k];
    edgePaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    edgePaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Star12({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cx = s / 2;
  const cy = s / 2;
  const R = s * 0.44;
  const theta = 75 * PI / 180;
  const { starPath, mids, verts } = picStar(cx, cy, R, 12, theta, s);
  const triPaths = [];
  for (let k = 0; k < 12; k++) {
    const v = verts[k];
    const m1 = mids[(k + 11) % 12];
    const m2 = mids[k];
    triPaths.push(`M ${f(m1[0])},${f(m1[1])} L ${f(v[0])},${f(v[1])} L ${f(m2[0])},${f(m2[1])}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    /* @__PURE__ */ jsx("path", { d: starPath }),
    triPaths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i))
  ] });
}
function Seigaiha({ size: size2, color, strokeWidth }) {
  const s = size2;
  const r = s / 2;
  const paths = [];
  const centers = [
    [s / 2, s * 0.6],
    [0, s * 0.1],
    [s, s * 0.1]
  ];
  for (const [cx, cy] of centers) {
    for (let ring = 1; ring <= 3; ring++) {
      const cr = r * (ring / 3);
      paths.push(
        `M ${f(cx - cr)},${f(cy)} A ${f(cr)} ${f(cr)} 0 0 1 ${f(cx + cr)},${f(cy)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function GreekKey({ size: size2, color, strokeWidth }) {
  const s = size2;
  const u = s / 4;
  const paths = [
    // Outer frame
    `M 0,0 L ${f(s)},0`,
    `M 0,${f(s)} L ${f(s)},${f(s)}`,
    // Spiral from left
    `M 0,${f(u)} L ${f(3 * u)},${f(u)} L ${f(3 * u)},${f(3 * u)} L ${f(u)},${f(3 * u)} L ${f(u)},${f(2 * u)} L ${f(2 * u)},${f(2 * u)}`,
    // Spiral from right (mirrored, offset)
    `M ${f(s)},${f(3 * u)} L ${f(s - 3 * u)},${f(3 * u)} L ${f(s - 3 * u)},${f(u)} L ${f(s - u)},${f(u)} L ${f(s - u)},${f(2 * u)} L ${f(s - 2 * u)},${f(2 * u)}`,
    // Vertical connectors at edges
    `M 0,0 L 0,${f(u)}`,
    `M ${f(s)},0 L ${f(s)},${f(u)}`,
    `M 0,${f(3 * u)} L 0,${f(s)}`,
    `M ${f(s)},${f(3 * u)} L ${f(s)},${f(s)}`
  ];
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function CelticKnot({ size: size2, color, strokeWidth }) {
  const s = size2;
  const q = s / 4;
  const r = q * 0.9;
  const paths = [
    // Band 1: diagonal with curves at crossings
    `M 0,0 Q ${f(q)},${f(q)} ${f(2 * q)},${f(2 * q)}`,
    `M ${f(2 * q)},${f(2 * q)} Q ${f(3 * q)},${f(3 * q)} ${f(s)},${f(s)}`,
    // Band 2: other diagonal
    `M ${f(s)},0 Q ${f(3 * q)},${f(q)} ${f(2 * q)},${f(2 * q)}`,
    `M ${f(2 * q)},${f(2 * q)} Q ${f(q)},${f(3 * q)} 0,${f(s)}`,
    // Outer loops that connect bands at tile edges for continuous weave
    `M 0,0 Q ${f(-q * 0.3)},${f(2 * q)} 0,${f(s)}`,
    `M ${f(s)},0 Q ${f(s + q * 0.3)},${f(2 * q)} ${f(s)},${f(s)}`,
    `M 0,0 Q ${f(2 * q)},${f(-q * 0.3)} ${f(s)},0`,
    `M 0,${f(s)} Q ${f(2 * q)},${f(s + q * 0.3)} ${f(s)},${f(s)}`,
    // Inner circle at crossing
    `M ${f(2 * q + r * 0.3)},${f(2 * q)} A ${f(r * 0.3)} ${f(r * 0.3)} 0 1 1 ${f(2 * q + r * 0.3)},${f(2 * q + 1e-3)}`
  ];
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function Kolam({ size: size2, color, strokeWidth }) {
  const s = size2;
  const u = s / 4;
  const dotR = s * 0.015;
  const dots = [];
  for (let row = 1; row <= 3; row++) {
    for (let col = 1; col <= 3; col++) {
      dots.push([col * u, row * u]);
    }
  }
  const curves = [];
  for (let row = 1; row <= 3; row++) {
    const y = row * u;
    for (let col = 1; col < 3; col++) {
      const x1 = col * u;
      const x2 = (col + 1) * u;
      const mx = (x1 + x2) / 2;
      const bulge = u * 0.4;
      curves.push(`M ${f(x1)},${f(y)} C ${f(mx)},${f(y - bulge)} ${f(mx)},${f(y - bulge)} ${f(x2)},${f(y)}`);
      curves.push(`M ${f(x1)},${f(y)} C ${f(mx)},${f(y + bulge)} ${f(mx)},${f(y + bulge)} ${f(x2)},${f(y)}`);
    }
  }
  for (let col = 1; col <= 3; col++) {
    const x = col * u;
    for (let row = 1; row < 3; row++) {
      const y1 = row * u;
      const y2 = (row + 1) * u;
      const my = (y1 + y2) / 2;
      const bulge = u * 0.4;
      curves.push(`M ${f(x)},${f(y1)} C ${f(x - bulge)},${f(my)} ${f(x - bulge)},${f(my)} ${f(x)},${f(y2)}`);
      curves.push(`M ${f(x)},${f(y1)} C ${f(x + bulge)},${f(my)} ${f(x + bulge)},${f(my)} ${f(x)},${f(y2)}`);
    }
  }
  for (let k = 1; k <= 3; k++) {
    curves.push(`M ${f(k * u)},${f(u)} C ${f(k * u)},${f(u * 0.5)} ${f(k * u)},${f(u * 0.5)} ${f(k * u)},0`);
    curves.push(`M ${f(k * u)},${f(3 * u)} C ${f(k * u)},${f(3.5 * u)} ${f(k * u)},${f(3.5 * u)} ${f(k * u)},${f(s)}`);
    curves.push(`M ${f(u)},${f(k * u)} C ${f(u * 0.5)},${f(k * u)} ${f(u * 0.5)},${f(k * u)} 0,${f(k * u)}`);
    curves.push(`M ${f(3 * u)},${f(k * u)} C ${f(3.5 * u)},${f(k * u)} ${f(3.5 * u)},${f(k * u)} ${f(s)},${f(k * u)}`);
  }
  return /* @__PURE__ */ jsxs("g", { fill: "none", stroke: color, strokeWidth, children: [
    curves.map((d, i) => /* @__PURE__ */ jsx("path", { d }, `c${i}`)),
    dots.map(([x, y], i) => /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: dotR, fill: color, opacity: "0.5" }, `d${i}`))
  ] });
}
function Arch({ size: size2, color, strokeWidth }) {
  const w = size2;
  const h = size2 * 1.5;
  const cx = w / 2;
  const paths = [];
  for (let ring = 0; ring < 4; ring++) {
    const scale = 1 - ring * 0.2;
    const archW = w * 0.48 * scale;
    const archH = h * 0.7 * scale;
    const baseY = h * 0.85;
    const tipY = baseY - archH;
    const lx = cx - archW;
    const rx = cx + archW;
    const offset = archW * 0.3;
    const lcx = lx + offset;
    const rdx = cx - lcx;
    const rdy = baseY - tipY;
    const radius = Math.sqrt(rdx * rdx + rdy * rdy);
    paths.push(
      `M ${f(lx)},${f(baseY)} A ${f(radius)} ${f(radius)} 0 0 1 ${f(cx)},${f(tipY)} A ${f(radius)} ${f(radius)} 0 0 1 ${f(rx)},${f(baseY)}`
    );
    if (ring === 0) {
      paths.push(`M ${f(lx)},${f(baseY)} L ${f(rx)},${f(baseY)}`);
    }
  }
  const innerScale = 1 - 3 * 0.2;
  const keyR = w * 0.48 * innerScale * 0.35;
  const keyY = h * 0.85 - h * 0.7 * innerScale * 0.4;
  paths.push(
    `M ${f(cx + keyR)},${f(keyY)} A ${f(keyR)} ${f(keyR)} 0 1 1 ${f(cx + keyR)},${f(keyY + 1e-3)}`
  );
  const spR = w * 0.15;
  paths.push(`M 0,0 A ${f(spR)} ${f(spR)} 0 0 0 ${f(spR)},${f(spR)}`);
  paths.push(`M ${f(w)},0 A ${f(spR)} ${f(spR)} 0 0 1 ${f(w - spR)},${f(spR)}`);
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function ArabesqueVine({ size: size2, color, strokeWidth }) {
  const w = size2;
  const h = size2 * 1.2;
  const cx = w / 2;
  const paths = [];
  const amp = w * 0.3;
  const segments = 3;
  const segH = h / segments;
  for (let i = 0; i < segments; i++) {
    const y0 = i * segH;
    const y1 = y0 + segH;
    const dir = i % 2 === 0 ? 1 : -1;
    paths.push(
      `M ${f(cx)},${f(y0)} C ${f(cx + amp * dir)},${f(y0 + segH * 0.33)} ${f(cx - amp * dir)},${f(y0 + segH * 0.66)} ${f(cx)},${f(y1)}`
    );
    const branchY = y0 + segH * 0.5;
    const branchX = cx + amp * dir * 0.15;
    const tendrilLen = w * 0.25;
    const tlx = branchX - tendrilLen;
    const tly = branchY - tendrilLen * 0.4;
    paths.push(
      `M ${f(branchX)},${f(branchY)} C ${f(branchX - tendrilLen * 0.5)},${f(branchY - tendrilLen * 0.8)} ${f(tlx - tendrilLen * 0.2)},${f(tly + tendrilLen * 0.3)} ${f(tlx)},${f(tly)}`
    );
    paths.push(
      `M ${f(tlx)},${f(tly)} C ${f(tlx + tendrilLen * 0.3)},${f(tly + tendrilLen * 0.5)} ${f(branchX - tendrilLen * 0.2)},${f(branchY + tendrilLen * 0.3)} ${f(branchX)},${f(branchY)}`
    );
    const trx = branchX + tendrilLen;
    const try_ = branchY + tendrilLen * 0.4;
    paths.push(
      `M ${f(branchX)},${f(branchY)} C ${f(branchX + tendrilLen * 0.5)},${f(branchY + tendrilLen * 0.8)} ${f(trx + tendrilLen * 0.2)},${f(try_ - tendrilLen * 0.3)} ${f(trx)},${f(try_)}`
    );
    paths.push(
      `M ${f(trx)},${f(try_)} C ${f(trx - tendrilLen * 0.3)},${f(try_ - tendrilLen * 0.5)} ${f(branchX + tendrilLen * 0.2)},${f(branchY - tendrilLen * 0.3)} ${f(branchX)},${f(branchY)}`
    );
    const spiralR = tendrilLen * 0.15;
    paths.push(
      `M ${f(tlx)},${f(tly)} A ${f(spiralR)} ${f(spiralR)} 0 1 0 ${f(tlx + spiralR * 2)},${f(tly)}`
    );
    paths.push(
      `M ${f(trx)},${f(try_)} A ${f(spiralR)} ${f(spiralR)} 0 1 1 ${f(trx - spiralR * 2)},${f(try_)}`
    );
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function ArabesqueNet({ size: size2, color, strokeWidth }) {
  const s = size2;
  const cells = 4;
  const cellW = s / cells;
  const cellH = s / cells;
  const paths = [];
  for (let row = 0; row < cells; row++) {
    for (let col = 0; col < cells; col++) {
      const cx = col * cellW + cellW / 2;
      const cy = row * cellH + cellH / 2;
      const hw = cellW * 0.5;
      const hh = cellH * 0.5;
      const bulge = cellW * 0.25;
      paths.push(
        `M ${f(cx)},${f(cy - hh)} Q ${f(cx + bulge)},${f(cy - bulge)} ${f(cx + hw)},${f(cy)}`
      );
      paths.push(
        `M ${f(cx + hw)},${f(cy)} Q ${f(cx + bulge)},${f(cy + bulge)} ${f(cx)},${f(cy + hh)}`
      );
      paths.push(
        `M ${f(cx)},${f(cy + hh)} Q ${f(cx - bulge)},${f(cy + bulge)} ${f(cx - hw)},${f(cy)}`
      );
      paths.push(
        `M ${f(cx - hw)},${f(cy)} Q ${f(cx - bulge)},${f(cy - bulge)} ${f(cx)},${f(cy - hh)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
var VARIANT_MAP = {
  "star8": Star8,
  "star6": Star6,
  "khatam": Khatam,
  "star10": Star10,
  "star12": Star12,
  "rosette-double": RosetteDouble,
  "rosette-filled": RosetteFilled,
  "seigaiha": Seigaiha,
  "greek-key": GreekKey,
  "celtic-knot": CelticKnot,
  "kolam": Kolam,
  "arch": Arch,
  "arabesque-vine": ArabesqueVine,
  "arabesque-net": ArabesqueNet
};
var PatternTile = ({
  variant = "star8",
  size: size2 = 60,
  color = "var(--color-primary)",
  strokeWidth = 0.5,
  className,
  ...rest
}) => {
  const Variant = VARIANT_MAP[variant];
  return /* @__PURE__ */ jsx("g", { className, ...domPassthrough(rest), children: /* @__PURE__ */ jsx(Variant, { size: size2, color, strokeWidth }) });
};
PatternTile.displayName = "PatternTile";
function getTileDimensions(variant, size2) {
  if (variant === "star6") {
    return { width: size2, height: size2 * (2 / Math.sqrt(3)) };
  }
  if (variant === "arch") {
    return { width: size2, height: size2 * 1.5 };
  }
  if (variant === "arabesque-vine") {
    return { width: size2, height: size2 * 1.2 };
  }
  return { width: size2, height: size2 };
}
var revealLog = createLogger("almadar:ui:animated-reveal");
function revealThresholds(threshold) {
  const steps = Array.from({ length: 20 }, (_, i) => i * threshold / 20);
  return [...steps, threshold];
}
var initialStyles = {
  "fade-up": { opacity: 0, transform: "translateY(24px)" },
  "fade-down": { opacity: 0, transform: "translateY(-24px)" },
  "fade-in": { opacity: 0 },
  "fade-left": { opacity: 0, transform: "translateX(24px)" },
  "fade-right": { opacity: 0, transform: "translateX(-24px)" },
  "scale": { opacity: 0, transform: "scale(0.92)" },
  "scale-up": { opacity: 0, transform: "scale(0.92) translateY(16px)" },
  "none": {}
};
var animatedStyles = {
  "fade-up": { opacity: 1, transform: "translateY(0)" },
  "fade-down": { opacity: 1, transform: "translateY(0)" },
  "fade-in": { opacity: 1 },
  "fade-left": { opacity: 1, transform: "translateX(0)" },
  "fade-right": { opacity: 1, transform: "translateX(0)" },
  "scale": { opacity: 1, transform: "scale(1)" },
  "scale-up": { opacity: 1, transform: "scale(1) translateY(0)" },
  "none": {}
};
var AnimatedReveal = React93__default.forwardRef(
  ({
    trigger = "scroll",
    animation = "fade-up",
    duration = 600,
    delay = 0,
    threshold = 0.15,
    once = true,
    revealEvent,
    enterEvent,
    leaveEvent,
    animate: manualAnimate,
    easing = "cubic-bezier(0.16, 1, 0.3, 1)",
    children,
    className,
    style,
    ...props
  }, forwardedRef) => {
    const [isAnimated, setIsAnimated] = useState(false);
    const reducedMotion = usePrefersReducedMotion();
    const eventBus = useEventBus();
    const revealEmitted = useRef(false);
    const internalRef = useRef(null);
    const hasAnimated = useRef(false);
    const inView = useRef(false);
    const setRef = useCallback(
      (node) => {
        internalRef.current = node;
        if (typeof forwardedRef === "function") forwardedRef(node);
        else if (forwardedRef) forwardedRef.current = node;
      },
      [forwardedRef]
    );
    useEffect(() => {
      if (trigger !== "scroll") return;
      const el = internalRef.current;
      if (!el) return;
      const observer2 = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting !== inView.current) {
            const event = entry.isIntersecting ? enterEvent : leaveEvent;
            inView.current = entry.isIntersecting;
            if (event) eventBus.emit(`UI:${event}`, {});
          }
          const seenEnough = entry.isIntersecting && (entry.intersectionRatio >= threshold || entry.rootBounds !== null && entry.intersectionRect.height >= threshold * entry.rootBounds.height);
          if (seenEnough) {
            if (revealEvent && !reducedMotion && !revealEmitted.current) {
              revealEmitted.current = true;
              revealLog.debug("reveal event", { event: revealEvent });
              eventBus.emit(`UI:${revealEvent}`, {});
            }
            if (once && hasAnimated.current) return;
            hasAnimated.current = true;
            setIsAnimated(true);
          } else if (!entry.isIntersecting && !once) {
            setIsAnimated(false);
          }
        },
        { threshold: revealThresholds(threshold) }
      );
      observer2.observe(el);
      return () => observer2.disconnect();
    }, [trigger, threshold, once, revealEvent, enterEvent, leaveEvent, reducedMotion, eventBus]);
    useEffect(() => {
      const el = internalRef.current;
      if (!el || typeof IntersectionObserver === "undefined") return;
      const observer2 = new IntersectionObserver(
        ([entry]) => {
          el.dataset.onScreen = entry.isIntersecting ? "true" : "false";
        },
        { rootMargin: "200px" }
      );
      observer2.observe(el);
      return () => observer2.disconnect();
    }, []);
    const handleMouseEnter = trigger === "hover" ? () => setIsAnimated(true) : void 0;
    const handleMouseLeave = trigger === "hover" ? () => {
      if (!once || !hasAnimated.current) {
        hasAnimated.current = true;
        setIsAnimated(false);
      }
    } : void 0;
    useEffect(() => {
      if (trigger === "manual" && manualAnimate !== void 0) {
        setIsAnimated(manualAnimate);
      }
    }, [trigger, manualAnimate]);
    const active = isAnimated || reducedMotion;
    const currentStyle = active ? animatedStyles[animation] : initialStyles[animation];
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref: setRef,
        className: cn(className),
        style: {
          ...currentStyle,
          // A revealed band is page-sized: keeping the layer hint after the reveal holds a huge GPU layer.
          willChange: active ? "auto" : "opacity, transform",
          transitionProperty: "opacity, transform",
          transitionDuration: reducedMotion ? "0ms" : `${duration}ms`,
          transitionDelay: `${delay}ms`,
          transitionTimingFunction: easing,
          ...style
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        ...props,
        children: typeof children === "function" ? children(active) : children
      }
    );
  }
);
AnimatedReveal.displayName = "AnimatedReveal";
function useFetchedSvg(src) {
  const [svg, setSvg] = useState(null);
  const cache = useRef({});
  useEffect(() => {
    if (!src) {
      setSvg(null);
      return;
    }
    if (cache.current[src]) {
      setSvg(cache.current[src]);
      return;
    }
    let cancelled = false;
    fetch(src).then((res) => {
      if (!res.ok) throw new Error(`Failed to fetch SVG: ${res.status}`);
      return res.text();
    }).then((text) => {
      if (cancelled) return;
      cache.current[src] = text;
      setSvg(text);
    }).catch(() => {
      if (!cancelled) setSvg(null);
    });
    return () => {
      cancelled = true;
    };
  }, [src]);
  return svg;
}
function applyDrawAnimation(container, animate, duration, delay, easing) {
  const paths = container.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
  paths.forEach((el) => {
    if ("getTotalLength" in el && typeof el.getTotalLength === "function") {
      const len = el.getTotalLength();
      el.style.strokeDasharray = `${len}`;
      el.style.strokeDashoffset = animate ? "0" : `${len}`;
      el.style.transition = `stroke-dashoffset ${duration}ms ${easing} ${delay}ms`;
    }
  });
}
function applyFillAnimation(container, animate, duration, delay, easing, fillColor) {
  const paths = container.querySelectorAll("path, circle, ellipse, rect, polygon");
  paths.forEach((el) => {
    if ("getTotalLength" in el && typeof el.getTotalLength === "function") {
      const geom = el;
      const len = geom.getTotalLength();
      geom.style.strokeDasharray = `${len}`;
      geom.style.strokeDashoffset = animate ? "0" : `${len}`;
      geom.style.transition = `stroke-dashoffset ${duration * 0.6}ms ${easing} ${delay}ms, fill-opacity ${duration * 0.4}ms ${easing} ${delay + duration * 0.6}ms`;
    }
    if (fillColor) el.style.fill = fillColor;
    el.style.fillOpacity = animate ? "1" : "0";
  });
}
function applyPulseAnimation(container, animate, duration) {
  const svg = container.querySelector("svg");
  if (!svg) return;
  if (animate) {
    svg.style.animation = `ag-pulse ${duration}ms ease-in-out infinite`;
  } else {
    svg.style.animation = "none";
  }
}
function applyMorphAnimation(container, animate, duration, delay, easing) {
  const paths = container.querySelectorAll("path, circle, ellipse, rect, polygon");
  paths.forEach((el) => {
    el.style.transition = `all ${duration}ms ${easing} ${delay}ms`;
    el.style.transform = animate ? "scale(1)" : "scale(0)";
    el.style.transformOrigin = "center";
    el.style.opacity = animate ? "1" : "0";
  });
}
var AnimatedGraphic = React93__default.forwardRef(
  ({
    src,
    svgContent,
    animation = "draw",
    animate = false,
    duration = 1200,
    delay = 0,
    easing = "cubic-bezier(0.16, 1, 0.3, 1)",
    width,
    height,
    strokeColor,
    fillColor,
    alt,
    className,
    style,
    children,
    ...props
  }, ref) => {
    const containerRef = useRef(null);
    const fetchedSvg = useFetchedSvg(svgContent ? void 0 : src);
    const resolvedSvg = svgContent ?? fetchedSvg;
    const prevAnimateRef = useRef(animate);
    const setRef = React93__default.useCallback(
      (node) => {
        containerRef.current = node;
        if (typeof ref === "function") ref(node);
        else if (ref) ref.current = node;
      },
      [ref]
    );
    useEffect(() => {
      const el = containerRef.current;
      if (!el || !strokeColor) return;
      const paths = el.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
      paths.forEach((p) => {
        p.style.stroke = strokeColor;
      });
    }, [resolvedSvg, strokeColor]);
    useEffect(() => {
      const el = containerRef.current;
      if (!el || !resolvedSvg) return;
      if (animation === "draw" || animation === "fill") {
        const paths = el.querySelectorAll("path, line, polyline, polygon, circle, ellipse, rect");
        paths.forEach((p) => {
          if ("getTotalLength" in p && typeof p.getTotalLength === "function") {
            const len = p.getTotalLength();
            p.style.strokeDasharray = `${len}`;
            p.style.strokeDashoffset = `${len}`;
          }
          if (animation === "fill") {
            p.style.fillOpacity = "0";
          }
        });
      }
      if (animation === "morph") {
        const paths = el.querySelectorAll("path, circle, ellipse, rect, polygon");
        paths.forEach((p) => {
          p.style.transform = "scale(0)";
          p.style.transformOrigin = "center";
          p.style.opacity = "0";
        });
      }
    }, [resolvedSvg, animation]);
    useEffect(() => {
      const el = containerRef.current;
      if (!el) return;
      const id = requestAnimationFrame(() => {
        switch (animation) {
          case "draw":
            applyDrawAnimation(el, animate, duration, delay, easing);
            break;
          case "fill":
            applyFillAnimation(el, animate, duration, delay, easing, fillColor);
            break;
          case "pulse":
            applyPulseAnimation(el, animate, duration);
            break;
          case "morph":
            applyMorphAnimation(el, animate, duration, delay, easing);
            break;
        }
      });
      prevAnimateRef.current = animate;
      return () => cancelAnimationFrame(id);
    }, [animate, animation, duration, delay, easing, fillColor, resolvedSvg]);
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("style", { children: `@keyframes ag-pulse { 0%, 100% { transform: scale(1); opacity: 1; } 50% { transform: scale(1.04); opacity: 0.85; } }` }),
      /* @__PURE__ */ jsx(
        "div",
        {
          ref: setRef,
          className: cn("inline-flex items-center justify-center", className),
          style: { width, height, ...style },
          role: alt ? "img" : void 0,
          "aria-label": alt,
          ...props,
          children: resolvedSvg ? /* @__PURE__ */ jsx(
            "div",
            {
              className: "w-full h-full [&>svg]:w-full [&>svg]:h-full",
              "aria-hidden": "true",
              dangerouslySetInnerHTML: { __html: resolvedSvg }
            }
          ) : children
        }
      )
    ] });
  }
);
AnimatedGraphic.displayName = "AnimatedGraphic";
var gapStyles = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8"
};
var gapLengths = {
  none: "0px",
  xs: "0.25rem",
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  xl: "2rem"
};
var colStyles = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2 @max-sm:!grid-cols-1",
  3: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 @max-lg:!grid-cols-2 @max-sm:!grid-cols-1",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
  5: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 @max-xl:!grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
  6: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 @max-xl:!grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1"
};
var SimpleGrid = ({
  minChildWidth = 250,
  maxCols,
  cols,
  gap = "md",
  className,
  children,
  ...rest
}) => {
  const passthrough = domPassthrough(rest);
  if (cols) {
    return /* @__PURE__ */ jsx(Box, { className: cn("grid", colStyles[cols], gapStyles[gap], className), ...passthrough, children });
  }
  const minWidth = typeof minChildWidth === "number" ? `${minChildWidth}px` : minChildWidth;
  const templateColumns = maxCols ? `repeat(auto-fit, minmax(max(min(${minWidth}, 100%), calc((100% - ${maxCols - 1} * ${gapLengths[gap]}) / ${maxCols})), 1fr))` : `repeat(auto-fit, minmax(${minWidth}, 1fr))`;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      className: cn("grid", gapStyles[gap], className),
      style: { gridTemplateColumns: templateColumns },
      ...passthrough,
      children
    }
  );
};
SimpleGrid.displayName = "SimpleGrid";
var pulseClass = "almadar-shimmer animate-shimmer rounded-container";
function SkeletonLine({ className }) {
  return /* @__PURE__ */ jsx(Box, { className: cn(pulseClass, "h-4", className) });
}
function SkeletonBlock({ className }) {
  return /* @__PURE__ */ jsx(Box, { className: cn(pulseClass, className) });
}
function HeaderSkeleton({ className }) {
  return /* @__PURE__ */ jsxs(HStack, { className: cn("items-center justify-between px-6 py-5", className), children: [
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "flex-1", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-7 w-48" }),
      /* @__PURE__ */ jsx(SkeletonLine, { className: "w-64" })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-24 rounded-interactive" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-32 rounded-interactive" })
    ] })
  ] });
}
function TableSkeleton({ rows: rows2 = 5, columns = 4, className }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: cn("border border-border rounded-container overflow-hidden", className), children: [
    /* @__PURE__ */ jsx(HStack, { className: "px-4 py-3 bg-muted/30 border-b border-border", children: Array.from({ length: columns }).map((_, i) => /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-4 flex-1 mx-2" }, i)) }),
    Array.from({ length: rows2 }).map((_, rowIdx) => /* @__PURE__ */ jsx(
      HStack,
      {
        className: cn(
          "px-4 py-3",
          rowIdx < rows2 - 1 && "border-b border-border"
        ),
        children: Array.from({ length: columns }).map((_2, colIdx) => /* @__PURE__ */ jsx(SkeletonLine, { className: "flex-1 mx-2" }, colIdx))
      },
      rowIdx
    ))
  ] });
}
function FormSkeleton({ fields = 4, className }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("p-6", className), children: [
    /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-40" }),
    Array.from({ length: fields }).map((_, i) => /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-4 w-24" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-full rounded-interactive" })
    ] }, i)),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", className: "justify-end pt-2", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-20 rounded-interactive" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-24 rounded-interactive" })
    ] })
  ] });
}
function CardSkeleton({ className }) {
  return /* @__PURE__ */ jsxs(
    VStack,
    {
      gap: "md",
      className: cn(
        "p-5 border border-border rounded-container",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(HStack, { className: "items-center", gap: "md", children: [
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-10 rounded-full" }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1", children: [
            /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-5 w-32" }),
            /* @__PURE__ */ jsx(SkeletonLine, { className: "w-48" })
          ] })
        ] }),
        /* @__PURE__ */ jsx(SkeletonLine, { className: "w-full" }),
        /* @__PURE__ */ jsx(SkeletonLine, { className: "w-3/4" }),
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "pt-2", children: [
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-16 rounded-full" }),
          /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-20 rounded-full" })
        ] })
      ]
    }
  );
}
function TextSkeleton({ rows: rows2 = 3, className }) {
  return /* @__PURE__ */ jsx(VStack, { gap: "sm", className, children: Array.from({ length: rows2 }).map((_, i) => /* @__PURE__ */ jsx(
    SkeletonLine,
    {
      className: i === rows2 - 1 ? "w-2/3" : "w-full"
    },
    i
  )) });
}
function ListSkeleton({ rows: rows2 = 5, className }) {
  return /* @__PURE__ */ jsx(VStack, { gap: "none", className: cn("border border-border rounded-container overflow-hidden", className), children: Array.from({ length: rows2 }).map((_, i) => /* @__PURE__ */ jsxs(HStack, { gap: "md", className: cn("items-center px-4 py-3", i < rows2 - 1 && "border-b border-border"), children: [
    /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-10 w-10 rounded-full shrink-0" }),
    /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-4 w-1/3" }),
      /* @__PURE__ */ jsx(SkeletonLine, { className: "w-2/3 h-3" })
    ] }),
    /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-16 rounded-full" })
  ] }, i)) });
}
function GridSkeleton({ rows: rows2 = 6, className }) {
  return /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "256px", gap: "md", className, children: Array.from({ length: rows2 }).map((_, i) => /* @__PURE__ */ jsx(CardSkeleton, {}, i)) });
}
function StatsSkeleton({ columns = 4, className }) {
  return /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "176px", gap: "md", className, children: Array.from({ length: columns }).map((_, i) => /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4 border border-border rounded-container", children: [
    /* @__PURE__ */ jsx(SkeletonLine, { className: "w-1/2 h-3" }),
    /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-7 w-2/3" })
  ] }, i)) });
}
function DetailSkeleton({ rows: rows2 = 6, className }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "lg", className: cn("p-6 border border-border rounded-container", className), children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-start justify-between", gap: "md", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center", children: [
        /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-8 w-56" }),
        /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-6 w-20 rounded-full" })
      ] }),
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", children: [
        /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-24 rounded-interactive" }),
        /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-9 w-9 rounded-interactive" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", children: [
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-20 flex-1" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-20 flex-1" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-20 flex-1" })
    ] }),
    /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "192px", maxCols: 3, gap: "md", children: Array.from({ length: rows2 }).map((_, i) => /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
      /* @__PURE__ */ jsx(SkeletonLine, { className: "w-1/3 h-3" }),
      /* @__PURE__ */ jsx(SkeletonBlock, { className: "h-5 w-2/3" })
    ] }, i)) }),
    /* @__PURE__ */ jsx(TextSkeleton, { rows: 3 })
  ] });
}
function Skeleton({
  variant = "text",
  spec,
  rows: rows2,
  columns,
  fields,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const shape = spec !== void 0 ? shapeOfSpec(spec) : { variant, rows: rows2, columns, fields };
  if (shape === null) return null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      role: "status",
      "aria-busy": "true",
      "aria-label": rest["aria-label"] ?? t("common.loading"),
      "data-skeleton": shape.variant,
      ...{ [LOADING_STATE_MARKER]: "" },
      className: "w-full",
      children: renderVariant(shape.variant, shape.rows, shape.columns, shape.fields, className)
    }
  );
}
function shapeOfSpec(spec) {
  if (spec === "none") return null;
  return typeof spec === "string" ? { variant: spec } : spec;
}
function renderNode(node, key) {
  if ("stack" in node) {
    return /* @__PURE__ */ jsx(VStack, { gap: "lg", children: node.stack.map((child, i) => renderNode(child, i)) }, key);
  }
  const { variant, rows: rows2, columns, fields } = node.shape;
  return /* @__PURE__ */ jsx(React93__default.Fragment, { children: renderVariant(variant, rows2, columns, fields, void 0) }, key);
}
function SkeletonTree({ node, className }) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    Box,
    {
      role: "status",
      "aria-busy": "true",
      "aria-label": t("common.loading"),
      "data-skeleton": "tree",
      ...{ [LOADING_STATE_MARKER]: "" },
      className: cn("w-full almadar-awaiting-skeleton", className),
      children: renderNode(node)
    }
  );
}
function renderVariant(variant, rows2, columns, fields, className) {
  switch (variant) {
    case "header":
      return /* @__PURE__ */ jsx(HeaderSkeleton, { className });
    case "table":
      return /* @__PURE__ */ jsx(TableSkeleton, { rows: rows2, columns, className });
    case "list":
      return /* @__PURE__ */ jsx(ListSkeleton, { rows: rows2, className });
    case "grid":
      return /* @__PURE__ */ jsx(GridSkeleton, { rows: rows2, className });
    case "detail":
      return /* @__PURE__ */ jsx(DetailSkeleton, { rows: rows2, className });
    case "stats":
      return /* @__PURE__ */ jsx(StatsSkeleton, { columns, className });
    case "form":
      return /* @__PURE__ */ jsx(FormSkeleton, { fields, className });
    case "card":
      return /* @__PURE__ */ jsx(CardSkeleton, { className });
    case "text":
      return /* @__PURE__ */ jsx(TextSkeleton, { rows: rows2, className });
  }
}
Skeleton.displayName = "Skeleton";
var LazySlotContentRenderer = lazy(
  () => import('./UISlotRenderer-ERKBTKWI.js').then((m) => ({
    default: m.SlotContentRenderer
  }))
);
function useTraitContent(traitName) {
  const slotManager = useUISlots();
  const [content, setContent] = useState(
    () => slotManager.getTraitContent(traitName)
  );
  useEffect(() => {
    setContent(slotManager.getTraitContent(traitName));
    const unsubscribe = slotManager.subscribeTrait(traitName, (nextContent) => {
      setContent(nextContent ?? slotManager.getTraitContent(traitName));
    });
    return unsubscribe;
  }, [slotManager, traitName]);
  return content;
}
function TraitFrame({
  traitName,
  fallback = null
}) {
  const content = useTraitContent(traitName);
  const awaiting = useAwaitingSkeleton({ trait: traitName });
  const entitySchema = useEntitySchemaOptional();
  const orbital = entitySchema?.orbitalsByTrait.get(traitName);
  if (!content) {
    return awaiting !== void 0 ? /* @__PURE__ */ jsx(SkeletonTree, { node: awaiting }) : /* @__PURE__ */ jsx(Fragment, { children: fallback });
  }
  const rendered = /* @__PURE__ */ jsx(Suspense, { fallback, children: /* @__PURE__ */ jsx(
    LazySlotContentRenderer,
    {
      content,
      onDismiss: () => {
      }
    }
  ) });
  if (!orbital) {
    return rendered;
  }
  return /* @__PURE__ */ jsx(TraitScopeProvider, { orbital, trait: traitName, children: rendered });
}
TraitFrame.displayName = "TraitFrame";

// lib/game.ts
function createInitialGameState(width, height, units, defaultTerrain = "floorStone") {
  const board = Array.from(
    { length: height },
    () => Array.from({ length: width }, () => ({
      terrain: defaultTerrain
    }))
  );
  const unitsMap = {};
  for (const unit of units) {
    unitsMap[unit.id] = unit;
    if (unit.position.y < height && unit.position.x < width) {
      board[unit.position.y][unit.position.x].unitId = unit.id;
    }
  }
  return {
    board,
    units: unitsMap,
    currentPhase: "observation",
    currentTurn: 1,
    activeTeam: "player",
    validMoves: [],
    attackTargets: []
  };
}
function calculateValidMoves(state, unitId) {
  const unit = state.units[unitId];
  if (!unit) return [];
  const moves = [];
  const { x, y } = unit.position;
  const range = unit.movement;
  for (let dy = -range; dy <= range; dy++) {
    for (let dx = -range; dx <= range; dx++) {
      const nx = x + dx;
      const ny = y + dy;
      const distance = Math.abs(dx) + Math.abs(dy);
      if (distance > 0 && distance <= range && ny >= 0 && ny < state.board.length && nx >= 0 && nx < state.board[0].length && !state.board[ny][nx].unitId && !state.board[ny][nx].isBlocked) {
        moves.push({ x: nx, y: ny });
      }
    }
  }
  return moves;
}
function calculateAttackTargets(state, unitId) {
  const unit = state.units[unitId];
  if (!unit) return [];
  const targets = [];
  const { x, y } = unit.position;
  const directions = [
    { dx: -1, dy: 0 },
    { dx: 1, dy: 0 },
    { dx: 0, dy: -1 },
    { dx: 0, dy: 1 }
  ];
  for (const { dx, dy } of directions) {
    const nx = x + dx;
    const ny = y + dy;
    if (ny >= 0 && ny < state.board.length && nx >= 0 && nx < state.board[0].length) {
      const targetTile = state.board[ny][nx];
      if (targetTile.unitId) {
        const targetUnit = state.units[targetTile.unitId];
        if (targetUnit && targetUnit.team !== unit.team) {
          targets.push({ x: nx, y: ny });
        }
      }
    }
  }
  return targets;
}

// lib/boardEntity.ts
function boardEntity(entity) {
  if (!entity) return void 0;
  return Array.isArray(entity) ? entity[0] : entity;
}
function str(v) {
  return v == null ? "" : String(v);
}
function num(v, fallback = 0) {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
}
function bool(v) {
  return Boolean(v);
}
function rows(v) {
  return Array.isArray(v) ? v : [];
}
function vec2(v) {
  const o = v ?? {};
  return { x: num(o.x), y: num(o.y) };
}
function unitPosition(u) {
  return vec2(u.position);
}
function unitTeam(u) {
  return str(u.team);
}
function unitHealth(u) {
  return num(u.health);
}

// lib/makeAsset.ts
var ROLE_DEFAULTS = {
  tile: { dimension: "2d", animations: ["static"], aspect: "1:1" },
  decoration: { dimension: "2d", animations: ["static"], aspect: "1:1" },
  effect: { dimension: "2d", animations: ["static"], aspect: "1:1" },
  item: { dimension: "2d", animations: ["static"], aspect: "5:7" },
  player: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
  enemy: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
  npc: { dimension: "2d", animations: ["idle", "walk", "attack", "hit", "death"], aspect: "1:1" },
  projectile: { dimension: "2d", animations: ["static"], aspect: "1:1" },
  vehicle: { dimension: "2d", animations: ["idle", "walk"], aspect: "1:1" },
  ui: { dimension: "2d", animations: ["static"], aspect: "1:1" }
};
function makeAsset(url, role, overrides = {}) {
  const defaults = ROLE_DEFAULTS[role] ?? { dimension: "2d", animations: ["static"], aspect: "1:1" };
  return {
    url,
    role,
    category: url.split("/").pop()?.replace(/\.[^.]+$/, "") ?? role,
    ...defaults,
    ...overrides
  };
}
function makeAssetMap(record, role, overrides = {}) {
  const result = {};
  for (const [key, url] of Object.entries(record)) {
    result[key] = makeAsset(url, role, overrides);
  }
  return result;
}
function useImageCache(urls) {
  const cacheRef = useRef(/* @__PURE__ */ new Map());
  const loadingRef = useRef(/* @__PURE__ */ new Set());
  const [pendingCount, setPendingCount] = useState(0);
  useEffect(() => {
    const cache = cacheRef.current;
    const loading = loadingRef.current;
    const newUrls = urls.filter((url) => url && !cache.has(url) && !loading.has(url));
    if (newUrls.length === 0) return;
    setPendingCount((prev) => prev + newUrls.length);
    for (const url of newUrls) {
      loading.add(url);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        cache.set(url, img);
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        updateAssetStatus(url, "loaded");
      };
      img.onerror = () => {
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        updateAssetStatus(url, "failed");
      };
      updateAssetStatus(url, "pending");
      img.src = url;
    }
  }, [urls.join(",")]);
  const getImage = useCallback((url) => {
    return cacheRef.current.get(url);
  }, []);
  return {
    getImage,
    isLoaded: pendingCount === 0,
    pendingCount
  };
}

// lib/isometric.ts
var TILE_WIDTH = 256;
var TILE_HEIGHT = 512;
var FLOOR_HEIGHT = 128;
var DIAMOND_TOP_Y = 374;
var FEATURE_COLORS = {
  goldMine: "#fbbf24",
  resonanceCrystal: "#a78bfa",
  traitCache: "#60a5fa",
  salvageYard: "#6b7280",
  portal: "#c084fc",
  castle: "#f59e0b",
  mountain: "#78716c",
  default: "#9ca3af"
};
var BACKGROUND_FALLBACK_COLOR = "#1a1a2e";
var MINIMAP_TERRAIN_COLORS = {
  default: "#4ade80"
};
function isoToScreen(tileX, tileY, cellWidth, baseOffsetX, layout = "isometric") {
  const w = cellWidth;
  const fh = cellWidth / 2;
  if (layout === "hex") {
    const screenX2 = tileX * w + (tileY & 1) * (w / 2) + baseOffsetX;
    const screenY2 = tileY * (fh * 0.75);
    return { x: screenX2, y: screenY2 };
  }
  if (layout === "flat") {
    const screenX2 = tileX * w + baseOffsetX;
    const screenY2 = tileY * w;
    return { x: screenX2, y: screenY2 };
  }
  const screenX = (tileX - tileY) * (w / 2) + baseOffsetX;
  const screenY = (tileX + tileY) * (fh / 2);
  return { x: screenX, y: screenY };
}
function screenToIso(screenX, screenY, cellWidth, baseOffsetX, layout = "isometric") {
  const w = cellWidth;
  const fh = cellWidth / 2;
  if (layout === "hex") {
    const row = Math.round(screenY / (fh * 0.75));
    const col = Math.round((screenX - (row & 1) * (w / 2) - baseOffsetX) / w);
    return { x: col, y: row };
  }
  if (layout === "flat") {
    const col = Math.round((screenX - baseOffsetX) / w);
    const row = Math.round(screenY / w);
    return { x: col, y: row };
  }
  const adjustedX = screenX - baseOffsetX;
  const tileX = (adjustedX / (w / 2) + screenY / (fh / 2)) / 2;
  const tileY = (screenY / (fh / 2) - adjustedX / (w / 2)) / 2;
  return { x: Math.round(tileX), y: Math.round(tileY) };
}

// lib/spriteSheetConstants.ts
var SHEET_COLUMNS = 8;
var SPRITE_SHEET_LAYOUT = {
  idle: { row: 0, frames: 4, frameRate: 6, loop: true },
  walk: { row: 1, frames: 8, frameRate: 10, loop: true },
  attack: { row: 2, frames: 6, frameRate: 12, loop: false },
  hit: { row: 3, frames: 3, frameRate: 8, loop: false },
  death: { row: 4, frames: 6, frameRate: 8, loop: false }
};

// lib/spriteAnimation.ts
function inferDirection(dx, dy) {
  if (dx === 0 && dy === 0) return "se";
  if (dx >= 0 && dy >= 0) return "se";
  if (dx <= 0 && dy >= 0) return "sw";
  if (dx >= 0 && dy <= 0) return "ne";
  return "nw";
}
function resolveSheetDirection(facing) {
  switch (facing) {
    case "se":
      return { sheetDir: "se", flipX: false };
    case "sw":
      return { sheetDir: "sw", flipX: false };
    case "ne":
      return { sheetDir: "sw", flipX: true };
    case "nw":
      return { sheetDir: "se", flipX: true };
  }
}
function frameRect(frame, row, columns, frameWidth, frameHeight) {
  return {
    sx: frame % columns * frameWidth,
    sy: row * frameHeight,
    sw: frameWidth,
    sh: frameHeight
  };
}
function getCurrentFrameFromDef(def, elapsed) {
  const frameDuration = 1e3 / def.frameRate;
  const totalDuration = def.frames * frameDuration;
  if (def.loop) {
    const frame2 = Math.floor(elapsed % totalDuration / frameDuration);
    return { frame: frame2, finished: false };
  }
  if (elapsed >= totalDuration) {
    return { frame: def.frames - 1, finished: true };
  }
  const frame = Math.floor(elapsed / frameDuration);
  return { frame, finished: false };
}
function getCurrentFrame(animName, elapsed) {
  const def = SPRITE_SHEET_LAYOUT[animName] ?? { frames: 4, frameRate: 6, loop: true };
  return getCurrentFrameFromDef(def, elapsed);
}
function resolveFrame(sheetUrls, frameDims, animState) {
  if (!sheetUrls) return null;
  const real = sheetUrls[animState.direction];
  const { sheetUrl, flipX } = real ? { sheetUrl: real, flipX: false } : (() => {
    const legacy = resolveSheetDirection(animState.direction);
    return { sheetUrl: sheetUrls[legacy.sheetDir], flipX: legacy.flipX };
  })();
  if (!sheetUrl) return null;
  const def = SPRITE_SHEET_LAYOUT[animState.animation] ?? { row: 0, frames: 4};
  const { frame } = getCurrentFrame(animState.animation, animState.elapsed);
  const rect = frameRect(frame, def.row, def.frames, frameDims.width, frameDims.height);
  return {
    sheetUrl,
    sx: rect.sx,
    sy: rect.sy,
    sw: rect.sw,
    sh: rect.sh,
    flipX
  };
}
function createUnitAnimationState(unitId) {
  return {
    unitId,
    animation: "idle",
    direction: "se",
    frame: 0,
    elapsed: 0,
    queuedAnimation: null,
    finished: false
  };
}
function transitionAnimation(state, newAnim, direction) {
  if (state.animation === "death" && state.finished) return state;
  if (state.animation === newAnim && SPRITE_SHEET_LAYOUT[newAnim]?.loop) {
    return direction ? { ...state, direction } : state;
  }
  return {
    ...state,
    animation: newAnim,
    direction: direction ?? state.direction,
    frame: 0,
    elapsed: 0,
    queuedAnimation: null,
    finished: false
  };
}
function tickAnimationState(state, deltaMs) {
  const newElapsed = state.elapsed + deltaMs;
  const { frame, finished } = getCurrentFrame(state.animation, newElapsed);
  const def = SPRITE_SHEET_LAYOUT[state.animation];
  if (finished && !def?.loop && !state.finished) {
    if (state.animation === "death") {
      return { ...state, elapsed: newElapsed, frame, finished: true };
    }
    const nextAnim = state.queuedAnimation ?? "idle";
    return {
      ...state,
      animation: nextAnim,
      elapsed: 0,
      frame: 0,
      queuedAnimation: null,
      finished: false
    };
  }
  return { ...state, elapsed: newElapsed, frame, finished };
}
var heartIcon = (filled, size2) => /* @__PURE__ */ jsx(
  "svg",
  {
    className: cn("transition-all duration-200", size2, filled ? "text-error" : "text-muted-foreground"),
    viewBox: "0 0 24 24",
    fill: filled ? "currentColor" : "none",
    stroke: "currentColor",
    strokeWidth: filled ? 0 : 2,
    children: /* @__PURE__ */ jsx("path", { d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" })
  }
);
var sizeMap2 = {
  sm: { heart: "w-4 h-4", bar: "h-2", text: "text-sm", label: "text-xs", badge: "text-xs px-1.5 py-0.5" },
  md: { heart: "w-6 h-6", bar: "h-3", text: "text-base", label: "text-xs", badge: "text-xs px-2 py-0.5" },
  lg: { heart: "w-8 h-8", bar: "h-4", text: "text-lg", label: "text-sm", badge: "text-sm px-2.5 py-1" }
};
function HealthBar({
  current = 3,
  max = 5,
  format = "hearts",
  level,
  showLabel = true,
  labelSuffix,
  size: size2 = "md",
  className,
  animated = true,
  frameAsset,
  fillAsset,
  ...rest
}) {
  const sizes = sizeMap2[size2];
  const percentage = max > 0 ? Math.max(0, Math.min(100, current / max * 100)) : 0;
  if (format === "hearts") {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("flex items-center gap-1", className), children: Array.from({ length: max }).map((_, i) => /* @__PURE__ */ jsx(
      Box,
      {
        as: "span",
        className: cn(animated && "transition-transform hover:scale-110"),
        children: heartIcon(i < current, sizes.heart)
      },
      i
    )) });
  }
  if (format === "bar") {
    return /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(rest),
        position: "relative",
        overflow: "hidden",
        className: cn(
          "rounded-full",
          !frameAsset && "bg-muted",
          sizes.bar,
          "w-24",
          className
        ),
        style: frameAsset ? { backgroundImage: `url(${frameAsset.url})`, backgroundSize: "100% 100%" } : void 0,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: cn(
              "inset-y-0 left-0 rounded-full",
              !fillAsset && (percentage > 66 ? "bg-success" : percentage > 33 ? "bg-warning" : "bg-error"),
              animated && "transition-all duration-300"
            ),
            style: {
              width: `${percentage}%`,
              ...fillAsset ? { backgroundImage: `url(${fillAsset.url})`, backgroundSize: "auto 100%" } : {}
            }
          }
        )
      }
    );
  }
  if (format === "progress") {
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex items-center gap-2", className), children: [
      level != null && /* @__PURE__ */ jsxs(
        Typography,
        {
          as: "span",
          className: cn(
            "flex-shrink-0 rounded-interactive font-bold",
            "bg-accent text-accent-foreground border border-accent",
            sizes.badge
          ),
          children: [
            "Lv.",
            level
          ]
        }
      ),
      /* @__PURE__ */ jsxs(Box, { className: "flex-1 flex flex-col gap-0.5", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            position: "relative",
            className: cn(
              "w-full overflow-hidden rounded-full",
              !frameAsset && "bg-muted border border-muted",
              sizes.bar
            ),
            style: frameAsset ? { backgroundImage: `url(${frameAsset.url})`, backgroundSize: "100% 100%" } : void 0,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                position: "absolute",
                className: cn(
                  "inset-y-0 left-0 rounded-full",
                  !fillAsset && "bg-gradient-to-r from-accent to-info",
                  animated && "transition-all duration-500 ease-out"
                ),
                style: {
                  width: `${percentage}%`,
                  ...fillAsset ? { backgroundImage: `url(${fillAsset.url})`, backgroundSize: "auto 100%" } : {}
                }
              }
            )
          }
        ),
        showLabel && /* @__PURE__ */ jsxs(Typography, { as: "span", className: cn("text-foreground/70 tabular-nums", sizes.label), children: [
          current,
          " / ",
          max,
          labelSuffix ? ` ${labelSuffix}` : ""
        ] })
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs(Typography, { as: "span", ...domPassthrough(rest), className: cn("font-mono font-bold", sizes.text, className), children: [
    current,
    "/",
    max
  ] });
}
HealthBar.displayName = "HealthBar";
var sizeMap3 = {
  sm: "text-sm",
  md: "text-lg",
  lg: "text-2xl",
  xl: "text-4xl"
};
function ScoreDisplay({
  assetUrl,
  value,
  score,
  label,
  icon,
  size: size2 = "md",
  className,
  locale: localeProp,
  ...rest
}) {
  const { locale: appLocale } = useTranslate();
  const locale = localeProp ?? appLocale;
  const resolvedValue = typeof value === "number" && !Number.isNaN(value) ? value : typeof score === "number" && !Number.isNaN(score) ? score : 0;
  const formattedValue = new Intl.NumberFormat(locale).format(resolvedValue);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        "flex items-center gap-2 font-bold",
        sizeMap3[size2],
        className
      ),
      children: [
        assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 20, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0", children: typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon }) : /* @__PURE__ */ jsx(Icon, { icon }) }) : null,
        label && /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-muted-foreground", children: label }),
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "tabular-nums", children: formattedValue })
      ]
    }
  );
}
ScoreDisplay.displayName = "ScoreDisplay";
var sizeMap4 = {
  sm: "w-10 h-10 text-sm",
  md: "w-14 h-14 text-base",
  lg: "w-18 h-18 text-lg",
  xl: "w-24 h-24 text-xl"
};
var shapeMap = {
  circle: "rounded-full",
  rounded: "rounded-interactive",
  square: "rounded-interactive"
};
var variantMap = {
  primary: "bg-primary text-primary-foreground border-primary hover:bg-primary-hover",
  secondary: "bg-secondary text-secondary-foreground border-border hover:bg-secondary-hover",
  ghost: "bg-transparent text-foreground border-border hover:bg-muted"
};
function ControlButton({
  assetUrl,
  label,
  icon,
  size: size2 = "md",
  shape = "circle",
  variant = "secondary",
  onPress,
  onRelease,
  pressEvent,
  releaseEvent,
  pressed,
  disabled,
  className,
  ...rest
}) {
  const eventBus = useEventBus();
  const [isPressed, setIsPressed] = React93.useState(false);
  const actualPressed = pressed ?? isPressed;
  const handlePointerDown = React93.useCallback(
    (e) => {
      e.preventDefault();
      if (disabled) return;
      setIsPressed(true);
      if (pressEvent) eventBus.emit(`UI:${pressEvent}`, {});
      onPress?.();
    },
    [disabled, pressEvent, eventBus, onPress]
  );
  const handlePointerUp = React93.useCallback(
    (e) => {
      e.preventDefault();
      if (disabled) return;
      setIsPressed(false);
      if (releaseEvent) eventBus.emit(`UI:${releaseEvent}`, {});
      onRelease?.();
    },
    [disabled, releaseEvent, eventBus, onRelease]
  );
  const handlePointerLeave = React93.useCallback(
    (e) => {
      if (isPressed) {
        setIsPressed(false);
        if (releaseEvent) eventBus.emit(`UI:${releaseEvent}`, {});
        onRelease?.();
      }
    },
    [isPressed, releaseEvent, eventBus, onRelease]
  );
  return /* @__PURE__ */ jsx(
    Button,
    {
      ...domPassthrough(rest),
      variant,
      disabled,
      onPointerDown: handlePointerDown,
      onPointerUp: handlePointerUp,
      onPointerLeave: handlePointerLeave,
      onContextMenu: (e) => e.preventDefault(),
      className: cn(
        "flex items-center justify-center border-heavy font-bold",
        "select-none touch-none",
        "transition-all duration-100",
        "active:scale-95",
        sizeMap4[size2] ?? sizeMap4.md,
        shapeMap[shape] ?? shapeMap.circle,
        variantMap[variant] ?? variantMap.secondary,
        actualPressed && "scale-95 brightness-110 border-foreground",
        disabled && "opacity-50 cursor-not-allowed",
        className
      ),
      children: assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 24, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "text-2xl", children: typeof icon === "string" ? /^[a-zA-Z0-9-]+$/.test(icon) ? (() => {
        const I = resolveIcon(icon);
        return I ? /* @__PURE__ */ jsx(I, { className: "w-6 h-6" }) : null;
      })() : icon : /* @__PURE__ */ (() => {
        const I = icon;
        return /* @__PURE__ */ jsx(I, { className: "w-6 h-6" });
      })() }) : label ? /* @__PURE__ */ jsx(Typography, { as: "span", children: label }) : null
    }
  );
}
ControlButton.displayName = "ControlButton";
var sizeMap5 = {
  sm: "text-sm px-2 py-0.5",
  md: "text-lg px-3 py-1",
  lg: "text-2xl px-4 py-1.5"
};
function formatTime(seconds, format, t) {
  const clamped = Math.max(0, Math.floor(seconds));
  if (format === "ss") {
    return t("timerDisplay.seconds", { count: clamped });
  }
  const mins = Math.floor(clamped / 60);
  const secs = clamped % 60;
  const padded = secs.toString().padStart(2, "0");
  if (format === "countdown") {
    return mins > 0 ? `${mins}:${padded}` : `${secs}`;
  }
  return `${mins.toString().padStart(2, "0")}:${padded}`;
}
function TimerDisplay({
  seconds = 90,
  running = true,
  format = "mm:ss",
  size: size2 = "md",
  className,
  lowThreshold,
  iconAsset,
  ...rest
}) {
  const { t } = useTranslate();
  const isLow = lowThreshold != null && seconds <= lowThreshold && seconds > 0;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex items-center gap-1 justify-center rounded-container",
        "bg-card/80 border border-muted font-mono font-bold tabular-nums",
        sizeMap5[size2],
        running && "border-success/50",
        isLow && "text-error border-error/50 animate-pulse",
        !isLow && "text-foreground",
        className
      ),
      children: [
        iconAsset && /* @__PURE__ */ jsx(GameIcon, { assetUrl: iconAsset, icon: "image", size: 16, className: "w-4 h-4 object-contain flex-shrink-0" }),
        formatTime(seconds, format, t)
      ]
    }
  );
}
TimerDisplay.displayName = "TimerDisplay";
var DEFAULT_PORTRAIT = {
  url: "https://almadar-kflow-assets.web.app/shared/ui-winter-ski-board/default/units/hero/hero.png",
  role: "effect",
  category: "character"
};
var MOOD_RING_CLASS = {
  neutral: "border-warning/60",
  happy: "border-success/70",
  concerned: "border-info/70",
  angry: "border-error/70"
};
function DialogueBubble({
  speaker: speakerProp,
  text: textProp,
  portrait = DEFAULT_PORTRAIT,
  position = "bottom",
  mood = "neutral",
  revealedChars,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const speaker = speakerProp ?? t("dialogueBubble.defaultSpeaker");
  const text = textProp ?? t("dialogueBubble.defaultText");
  const visibleText = revealedChars === void 0 ? text : text.slice(0, revealedChars);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        "flex items-start gap-3 rounded-container bg-background/80 backdrop-blur-sm px-4 py-3 border border-border/10",
        position === "top" ? "rounded-bl-none" : "rounded-tl-none",
        className
      ),
      children: [
        portrait && /* @__PURE__ */ jsx(Box, { className: cn("flex-shrink-0 w-12 h-12 rounded-full overflow-hidden border-heavy transition-colors duration-300", MOOD_RING_CLASS[mood]), children: /* @__PURE__ */ jsx(GameIcon, { assetUrl: portrait, icon: "image", size: 48, alt: speaker, className: "w-full h-full object-cover" }) }),
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1 min-w-0", children: [
          speaker && /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm font-bold text-warning", children: speaker }),
          /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm text-foreground leading-relaxed", children: visibleText })
        ] })
      ]
    }
  );
}
DialogueBubble.displayName = "DialogueBubble";
function ChoiceButton({
  text: textProp,
  index,
  assetUrl,
  icon,
  disabled = false,
  selected = false,
  onClick,
  action,
  payload,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const text = textProp ?? t("choiceButton.defaultText");
  return /* @__PURE__ */ jsxs(
    Button,
    {
      variant: "ghost",
      disabled,
      action,
      actionPayload: payload,
      onClick,
      "aria-pressed": selected,
      ...domPassthrough(rest),
      className: cn(
        "w-full text-left px-4 py-2.5 rounded-interactive border transition-all duration-150",
        "flex items-center gap-2",
        selected ? "bg-accent/15 border-accent text-foreground" : "bg-muted/40 border-border text-foreground hover:bg-muted hover:border-border",
        disabled && "opacity-40 cursor-not-allowed hover:bg-muted/40 hover:border-border",
        className
      ),
      children: [
        index !== void 0 && /* @__PURE__ */ jsxs(
          Typography,
          {
            as: "span",
            className: cn(
              "flex-shrink-0 font-mono font-bold text-sm",
              selected ? "text-accent" : "text-muted-foreground"
            ),
            children: [
              index,
              "."
            ]
          }
        ),
        assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 16, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0 text-sm", children: typeof icon === "string" ? (() => {
          const I = resolveIcon(icon);
          return I ? /* @__PURE__ */ jsx(I, { className: "w-4 h-4" }) : null;
        })() : /* @__PURE__ */ (() => {
          const I = icon;
          return /* @__PURE__ */ jsx(I, { className: "w-4 h-4" });
        })() }) : null,
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-sm leading-snug", children: text })
      ]
    }
  );
}
ChoiceButton.displayName = "ChoiceButton";
var sizeKey = { sm: "sm", md: "md", lg: "lg" };
var layoutClass = {
  horizontal: "flex flex-row gap-2",
  vertical: "flex flex-col gap-2",
  diamond: "grid grid-cols-3 gap-1"
};
var dpadSizeMap = {
  sm: { gap: "gap-0.5", container: "w-28" },
  md: { gap: "gap-1", container: "w-40" },
  lg: { gap: "gap-1.5", container: "w-52" }
};
var arrowIcons = {
  up: "\u25B2",
  down: "\u25BC",
  left: "\u25C0",
  right: "\u25B6"
};
var DEFAULT_BUTTON_KEYS = [
  { id: "jump", labelKey: "controlGrid.jump", icon: "chevron-up", variant: "primary" },
  { id: "attack", labelKey: "controlGrid.attack", icon: "sword", variant: "secondary" },
  { id: "dodge", labelKey: "controlGrid.dodge", icon: "wind", variant: "ghost" }
];
function ControlGrid({
  kind,
  buttons: buttonsProp,
  layout = "horizontal",
  includeDiagonals = false,
  onAction,
  actionEvent,
  onDirection,
  directionEvent,
  directionEvents,
  directionReleaseEvents,
  directionAssets,
  size: size2 = "md",
  disabled,
  visibility = "auto",
  className,
  ...rest
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const buttons = buttonsProp ?? DEFAULT_BUTTON_KEYS.map(({ labelKey, ...rest2 }) => ({ ...rest2, label: t(labelKey) }));
  const [active, setActive] = React93.useState(/* @__PURE__ */ new Set());
  const [coarse, setCoarse] = React93.useState(
    () => typeof window !== "undefined" && window.matchMedia("(pointer: coarse)").matches
  );
  React93.useEffect(() => {
    if (visibility !== "auto" || typeof window === "undefined") return;
    const mq = window.matchMedia("(pointer: coarse)");
    const onChange = (e) => setCoarse(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [visibility]);
  const handlePress = React93.useCallback(
    (id) => {
      setActive((prev) => new Set(prev).add(id));
      if (actionEvent) eventBus.emit(`UI:${actionEvent}`, { id, pressed: true });
      onAction?.(id, true);
      if (kind === "dpad") {
        const semantic = directionEvents?.[id];
        if (semantic) eventBus.emit(`UI:${semantic}`, {});
        if (directionEvent) eventBus.emit(`UI:${directionEvent}`, { direction: id, pressed: true });
        onDirection?.(id, true);
      }
    },
    [kind, actionEvent, directionEvent, directionEvents, eventBus, onAction, onDirection]
  );
  const handleRelease = React93.useCallback(
    (id) => {
      setActive((prev) => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
      if (actionEvent) eventBus.emit(`UI:${actionEvent}`, { id, pressed: false });
      onAction?.(id, false);
      if (kind === "dpad") {
        const semantic = directionReleaseEvents?.[id];
        if (semantic) eventBus.emit(`UI:${semantic}`, {});
        if (directionEvent) eventBus.emit(`UI:${directionEvent}`, { direction: id, pressed: false });
        onDirection?.(id, false);
      }
    },
    [kind, actionEvent, directionEvent, directionReleaseEvents, eventBus, onAction, onDirection]
  );
  if (visibility === "auto" && !coarse) return null;
  if (kind === "dpad") {
    const ds = dpadSizeMap[size2];
    const dir = (d) => /* @__PURE__ */ jsx(
      ControlButton,
      {
        icon: directionAssets?.[d] ? void 0 : arrowIcons[d],
        assetUrl: directionAssets?.[d],
        size: sizeKey[size2],
        variant: "secondary",
        pressed: active.has(d),
        onPress: () => handlePress(d),
        onRelease: () => handleRelease(d),
        disabled
      },
      d
    );
    const usesSemantic = !!directionEvents;
    const cell = (d) => !usesSemantic || directionEvents?.[d] ? dir(d) : /* @__PURE__ */ jsx(Box, {}, d);
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("inline-grid grid-cols-3", ds.gap, ds.container, className), children: [
      /* @__PURE__ */ jsx(Box, {}),
      cell("up"),
      /* @__PURE__ */ jsx(Box, {}),
      cell("left"),
      /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center", children: /* @__PURE__ */ jsx(Box, { className: "w-6 h-6 rounded-interactive bg-muted border-heavy border-muted-foreground" }) }),
      cell("right"),
      /* @__PURE__ */ jsx(Box, {}),
      cell("down"),
      /* @__PURE__ */ jsx(Box, {})
    ] });
  }
  if (layout === "diamond" && buttons.length === 4) {
    const [top, right, bottom, left] = buttons;
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn(layoutClass.diamond, className), children: [
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: top.icon,
          assetUrl: top.assetUrl,
          label: top.label,
          size: sizeKey[size2],
          variant: top.variant,
          pressed: active.has(top.id),
          onPress: () => handlePress(top.id),
          onRelease: () => handleRelease(top.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: left.icon,
          assetUrl: left.assetUrl,
          label: left.label,
          size: sizeKey[size2],
          variant: left.variant,
          pressed: active.has(left.id),
          onPress: () => handlePress(left.id),
          onRelease: () => handleRelease(left.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: right.icon,
          assetUrl: right.assetUrl,
          label: right.label,
          size: sizeKey[size2],
          variant: right.variant,
          pressed: active.has(right.id),
          onPress: () => handlePress(right.id),
          onRelease: () => handleRelease(right.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {}),
      /* @__PURE__ */ jsx(
        ControlButton,
        {
          icon: bottom.icon,
          assetUrl: bottom.assetUrl,
          label: bottom.label,
          size: sizeKey[size2],
          variant: bottom.variant,
          pressed: active.has(bottom.id),
          onPress: () => handlePress(bottom.id),
          onRelease: () => handleRelease(bottom.id),
          disabled
        }
      ),
      /* @__PURE__ */ jsx(Box, {})
    ] });
  }
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(layoutClass[layout], className), children: buttons.map((button) => /* @__PURE__ */ jsx(
    ControlButton,
    {
      icon: button.icon,
      assetUrl: button.assetUrl,
      label: button.label,
      size: sizeKey[size2],
      variant: button.variant,
      pressed: active.has(button.id),
      onPress: () => handlePress(button.id),
      onRelease: () => handleRelease(button.id),
      disabled
    },
    button.id
  )) });
}
ControlGrid.displayName = "ControlGrid";
var sizeMap6 = {
  xs: "text-xs px-1.5 py-0.5",
  sm: "text-xs px-2 py-1",
  md: "text-sm px-3 py-1.5",
  lg: "text-base px-4 py-2"
};
var variantMap2 = {
  default: "bg-card/80 border-border text-foreground",
  primary: "bg-primary/15 border-primary/40 text-foreground",
  success: "bg-success/15 border-success/40 text-foreground",
  warning: "bg-warning/15 border-warning/40 text-foreground",
  danger: "bg-error/15 border-error/40 text-foreground"
};
function StatBadge({
  assetUrl,
  iconUrl,
  label,
  value,
  max,
  format = "number",
  icon,
  size: size2 = "md",
  variant = "default",
  className,
  // Ignored config props (used for schema binding)
  source: _source,
  field: _field,
  ...rest
}) {
  const hasValue = value !== void 0 && value !== null;
  const numValue = typeof value === "number" ? value : parseInt(String(value), 10) || 0;
  const resolvedAsset = iconUrl ?? assetUrl;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex items-center gap-2 rounded-container border backdrop-blur-sm",
        sizeMap6[size2] ?? sizeMap6.md,
        variantMap2[variant] ?? variantMap2.default,
        className
      ),
      children: [
        resolvedAsset ? /* @__PURE__ */ jsx(GameIcon, { assetUrl: resolvedAsset, icon: "image", size: 16, className: "flex-shrink-0" }) : icon ? /* @__PURE__ */ jsx(Box, { as: "span", className: "flex-shrink-0 text-lg", children: typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: "w-4 h-4" }) : /* @__PURE__ */ jsx(Icon, { icon, className: "w-4 h-4" }) }) : null,
        /* @__PURE__ */ jsx(Typography, { as: "span", className: "text-muted-foreground font-medium text-xs", children: label }),
        hasValue && format === "hearts" && max && /* @__PURE__ */ jsx(
          HealthBar,
          {
            current: numValue,
            max,
            format: "hearts",
            size: size2 === "lg" ? "md" : "sm"
          }
        ),
        hasValue && format === "bar" && max && /* @__PURE__ */ jsx(
          HealthBar,
          {
            current: numValue,
            max,
            format: "bar",
            size: size2 === "lg" ? "md" : "sm"
          }
        ),
        hasValue && format === "number" && /* @__PURE__ */ jsx(
          ScoreDisplay,
          {
            value: numValue,
            size: size2 === "lg" ? "md" : "sm",
            className: "font-display"
          }
        ),
        hasValue && format === "text" && /* @__PURE__ */ jsx(Typography, { as: "span", className: "font-bold text-foreground", children: value })
      ]
    }
  );
}
StatBadge.displayName = "StatBadge";
var positionMap = {
  corners: "inset-0 pointer-events-none"
};
var ELEMENT_LABEL_KEYS = {
  "health-bar": "gameHud.health",
  "score-display": "gameHud.score",
  lives: "gameHud.lives",
  timer: "gameHud.time"
};
function convertElementsToStats(elements, t) {
  return elements.map((el) => {
    const [source, field] = el.bind?.split(".") ?? [];
    return {
      label: el.label || (ELEMENT_LABEL_KEYS[el.type ?? ""] ? t(ELEMENT_LABEL_KEYS[el.type ?? ""]) : el.type) || "",
      source,
      field,
      // Pass through direct values from compiled render-ui effects
      ...el.value !== void 0 && { value: el.value },
      ...el.icon !== void 0 && { icon: el.icon },
      ...el.assetUrl !== void 0 && { assetUrl: el.assetUrl },
      ...el.format !== void 0 && { format: el.format },
      ...el.max !== void 0 && { max: el.max }
    };
  });
}
var DEFAULT_HUD_STATS = [
  { labelKey: "gameHud.hp", value: 75, max: 100, format: "bar", variant: "danger" },
  { labelKey: "gameHud.mp", value: 40, max: 60, format: "bar", variant: "primary" },
  { labelKey: "gameHud.score", value: 4200, format: "number", variant: "warning" },
  { labelKey: "gameHud.level", value: 4, format: "number", variant: "default" }
];
function GameHud({
  position: propPosition,
  stats: propStats,
  items,
  elements,
  size: size2 = "md",
  variant = "floating",
  className,
  transparent = true,
  ...rest
}) {
  const { t } = useTranslate();
  const defaultStats = DEFAULT_HUD_STATS.map(({ labelKey, ...rest2 }) => ({ ...rest2, label: t(labelKey) }));
  const rawStats = propStats ?? items ?? (elements && Array.isArray(elements) ? convertElementsToStats(elements, t) : defaultStats);
  const stats = Array.isArray(rawStats) ? rawStats : [];
  const position = propPosition ?? "top";
  if (position === "corners") {
    const leftStats = stats.slice(0, Math.ceil(stats.length / 2));
    const rightStats = stats.slice(Math.ceil(stats.length / 2));
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), position: "relative", className: cn(positionMap[position], className), children: [
      /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-4 left-4 flex flex-col gap-2 pointer-events-auto", children: leftStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size: size2 }, i)) }),
      /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-4 right-4 flex flex-col gap-2 items-end pointer-events-auto", children: rightStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size: size2 }, i)) })
    ] });
  }
  if ((position === "top" || position === "bottom") && variant === "bar") {
    const mid = Math.ceil(stats.length / 2);
    const leftStats = stats.slice(0, mid);
    const rightStats = stats.slice(mid);
    return /* @__PURE__ */ jsxs(
      Card,
      {
        ...domPassthrough(rest),
        variant: "bordered",
        padding: "none",
        className: cn(
          "flex items-center justify-between w-full rounded-none bg-card",
          "px-4 py-2 gap-4",
          transparent && "backdrop-blur-sm",
          className
        ),
        style: transparent ? { backgroundColor: "color-mix(in srgb, var(--color-card) 40%, transparent)" } : void 0,
        children: [
          /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-3 flex-shrink-0", children: leftStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size: size2 }, i)) }),
          rightStats.length > 0 && /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-3 flex-shrink-0", children: rightStats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size: size2 }, i)) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Card,
    {
      ...domPassthrough(rest),
      variant: "bordered",
      padding: "sm",
      className: cn(
        "z-10 relative flex items-center gap-4 bg-card",
        transparent && "backdrop-blur-sm",
        className
      ),
      style: transparent ? { backgroundColor: "color-mix(in srgb, var(--color-card) 30%, transparent)" } : void 0,
      children: stats.map((stat, i) => /* @__PURE__ */ jsx(StatBadge, { ...stat, size: size2 }, i))
    }
  );
}
GameHud.displayName = "GameHud";
var GameOverlayContext = React93.createContext(false);
var DEFAULT_MENU_OPTION_KEYS = [
  { labelKey: "gameMenu.newGame", event: "NEW_GAME", variant: "primary" },
  { labelKey: "gameMenu.continue", event: "CONTINUE", variant: "secondary" },
  { labelKey: "gameMenu.settings", event: "SETTINGS", variant: "ghost" }
];
function GameMenu({
  title: titleProp,
  subtitle,
  options,
  menuItems,
  onSelect,
  background,
  logo,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const title = titleProp ?? t("gameMenu.defaultTitle");
  const defaultOptions = DEFAULT_MENU_OPTION_KEYS.map((o) => ({
    label: t(o.labelKey),
    event: o.event,
    variant: o.variant
  }));
  const resolvedOptions = (options?.length ? options : void 0) ?? (menuItems?.length ? menuItems : void 0) ?? defaultOptions;
  const eventBus = useEventBus();
  const inOverlay = React93.useContext(GameOverlayContext);
  const handleOptionClick = React93.useCallback(
    (option) => {
      if (option.event) {
        eventBus.emit(`UI:${option.event}`, { option });
      }
      if (onSelect) {
        onSelect(option);
      }
      if (option.navigatesTo) {
        eventBus.emit("UI:NAVIGATE", { url: option.navigatesTo, option });
      }
    },
    [eventBus, onSelect]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      "data-game-menu": "",
      className: cn(
        inOverlay ? "flex flex-col items-center justify-center" : "min-h-screen w-full flex flex-col items-center justify-center p-8",
        !background && !inOverlay && "bg-background",
        className
      ),
      style: background ? { background } : void 0,
      children: [
        /* @__PURE__ */ jsxs(
          Card,
          {
            variant: "bordered",
            padding: "lg",
            className: "bg-card flex flex-col items-center max-w-md w-full",
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "text-center mb-8 animate-fade-in", children: [
                logo && /* @__PURE__ */ jsx(GameIcon, { assetUrl: logo, icon: "image", size: 96, alt: title, className: "h-24 w-auto mx-auto mb-6 drop-shadow-2xl" }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "h1",
                    className: "text-4xl md:text-5xl text-foreground tracking-tight",
                    style: {
                      textShadow: "0 4px 12px rgba(0,0,0,0.5)"
                    },
                    children: title
                  }
                ),
                subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", className: "mt-2 text-lg text-muted-foreground tracking-widest uppercase", children: subtitle })
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-4 w-full", children: resolvedOptions.map((option, index) => /* @__PURE__ */ jsx(
                ChoiceButton,
                {
                  text: option.label,
                  index: index + 1,
                  disabled: option.disabled,
                  onClick: () => handleOptionClick(option),
                  className: "text-lg py-4 px-8"
                },
                index
              )) })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { position: "absolute", className: "inset-0 pointer-events-none overflow-hidden -z-10", children: [
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "top-1/4 left-1/4 w-64 h-64 bg-info/10 rounded-container blur-3xl" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-container blur-3xl" })
        ] })
      ]
    }
  );
}
GameMenu.displayName = "GameMenu";
function useContainerWidth(ref) {
  const [width, setWidth] = useState(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    setWidth(el.clientWidth);
    if (typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(([entry]) => setWidth(entry.contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);
  return width;
}

// lib/avl-elk-layout.ts
function stateWidth(transitionCount) {
  if (transitionCount >= 5) return 160;
  if (transitionCount >= 3) return 130;
  return 110;
}
var STATE_H = 40;
var elk;
function loadElk() {
  elk ?? (elk = import('elkjs/lib/elk.bundled.js').then(({ default: Elk }) => new Elk()));
  return elk;
}
function flowOrder(data) {
  const byName = new Map(data.states.map((s) => [s.name, s]));
  const seen = /* @__PURE__ */ new Set();
  const queue = data.states.filter((s) => s.isInitial).map((s) => s.name);
  const out = [];
  while (queue.length > 0) {
    const name = queue.shift();
    if (seen.has(name)) continue;
    const state = byName.get(name);
    if (!state) continue;
    seen.add(name);
    out.push(state);
    for (const t of data.transitions) if (t.from === name && !seen.has(t.to)) queue.push(t.to);
  }
  for (const s of data.states) if (!seen.has(s.name)) out.push(s);
  return out;
}
async function computeTraitLayout(data, metrics) {
  const transitionCounts = {};
  for (const s of data.states) transitionCounts[s.name] = 0;
  for (const t of data.transitions) {
    transitionCounts[t.from] = (transitionCounts[t.from] ?? 0) + 1;
    transitionCounts[t.to] = (transitionCounts[t.to] ?? 0) + 1;
  }
  const maxTC = Math.max(...Object.values(transitionCounts), 0);
  const LABEL_BASE_W = 100;
  const LABEL_H = 44;
  const states = metrics ? flowOrder(data) : data.states;
  const elkGraph = {
    id: "root",
    layoutOptions: {
      "elk.algorithm": "layered",
      "elk.direction": metrics?.direction === "rtl" ? "LEFT" : "RIGHT",
      "elk.spacing.nodeNode": String(metrics?.nodeSpacing ?? 80),
      "elk.spacing.edgeNode": "30",
      "elk.spacing.edgeEdge": "24",
      "elk.spacing.edgeLabel": "10",
      "elk.spacing.labelLabel": "8",
      "elk.layered.spacing.nodeNodeBetweenLayers": String(metrics?.layerSpacing ?? 100),
      ...metrics?.orthogonal ? { "elk.edgeRouting": "ORTHOGONAL" } : {},
      ...metrics ? { "elk.layered.considerModelOrder.strategy": "NODES_AND_EDGES", "elk.layered.cycleBreaking.strategy": "MODEL_ORDER" } : {},
      "elk.edgeLabels.placement": "CENTER",
      "elk.layered.mergeEdges": "false",
      "elk.layered.nodePlacement.strategy": "NETWORK_SIMPLEX"
    },
    children: states.map((s) => {
      const tc = transitionCounts[s.name] ?? 0;
      const size2 = metrics ? metrics.nodeSize(s.name) : { width: stateWidth(tc), height: STATE_H };
      return {
        id: s.name,
        width: size2.width,
        height: size2.height,
        labels: [{ text: s.name, width: size2.width - 10, height: 14 }],
        ...metrics && s.isInitial ? { layoutOptions: { "elk.layered.layering.layerConstraint": "FIRST" } } : {}
      };
    }),
    edges: data.transitions.map((t, i) => {
      const textW = Math.max(t.event.length * 8, 60);
      const iconsW = Math.min(t.effects.length, 6) * 28 + 20;
      const label = metrics ? metrics.labelSize(t) : { width: Math.max(textW, iconsW, LABEL_BASE_W), height: LABEL_H };
      return {
        id: `e${i}`,
        sources: [t.from],
        targets: [t.to],
        labels: [{
          text: t.event,
          width: label.width,
          height: label.height,
          ...metrics ? { layoutOptions: { "elk.edgeLabels.inline": "true" } } : {}
        }]
      };
    })
  };
  const layout = await (await loadElk()).layout(elkGraph);
  const layoutChildren = layout.children ?? [];
  const layoutEdges = layout.edges ?? [];
  const nodeXMap = {};
  for (const n of layoutChildren) {
    nodeXMap[n.id] = n.x ?? 0;
  }
  const nodes = layoutChildren.map((n) => {
    const name = n.id;
    const stateInfo = data.states.find((s) => s.name === name);
    const tc = transitionCounts[name] ?? 0;
    return {
      id: name,
      x: n.x ?? 0,
      y: n.y ?? 0,
      width: n.width ?? 110,
      height: n.height ?? STATE_H,
      isInitial: stateInfo?.isInitial ?? void 0,
      isTerminal: stateInfo?.isTerminal ?? void 0,
      role: getStateRole(stateInfo?.isInitial ?? void 0, stateInfo?.isTerminal ?? void 0, tc, maxTC),
      transitionCount: tc
    };
  });
  const edges = layoutEdges.map((e, i) => {
    const t = data.transitions[i];
    const labels = e.labels ?? [];
    const label = labels[0];
    const sections = e.sections ?? [];
    const points = [];
    for (const section of sections) {
      const bendPoints = section.bendPoints ?? [];
      points.push({ x: section.startPoint.x, y: section.startPoint.y });
      for (const bp of bendPoints) points.push({ x: bp.x, y: bp.y });
      points.push({ x: section.endPoint.x, y: section.endPoint.y });
    }
    const isSelf = t.from === t.to;
    const toX = nodeXMap[t.to] ?? 0;
    const fromX = nodeXMap[t.from] ?? 0;
    const isBackward = !isSelf && (metrics?.direction === "rtl" ? toX >= fromX : toX <= fromX);
    const lw = label?.width ?? LABEL_BASE_W;
    const lh = label?.height ?? LABEL_H;
    return {
      id: e.id,
      from: t.from,
      to: t.to,
      event: t.event,
      effects: t.effects,
      guard: !!t.guard,
      guardExpr: typeof t.guard === "string" ? t.guard : void 0,
      index: t.index,
      labelX: label?.x ?? 0,
      labelY: label?.y ?? 0,
      labelW: lw,
      labelH: lh,
      points,
      isSelf,
      isBackward
    };
  });
  return {
    nodes,
    edges,
    width: layout.width ?? 600,
    height: layout.height ?? 400
  };
}
function roundedEdgePath(points, radius) {
  if (points.length < 3) return edgePath(points);
  let d = `M ${points[0].x},${points[0].y}`;
  for (let i = 1; i < points.length - 1; i++) {
    const prev = points[i - 1];
    const cur = points[i];
    const next = points[i + 1];
    const inLen = Math.hypot(cur.x - prev.x, cur.y - prev.y);
    const outLen = Math.hypot(next.x - cur.x, next.y - cur.y);
    const r = Math.min(radius, inLen / 2, outLen / 2);
    if (r <= 0) {
      d += ` L ${cur.x},${cur.y}`;
      continue;
    }
    const ax = cur.x - (cur.x - prev.x) / inLen * r;
    const ay = cur.y - (cur.y - prev.y) / inLen * r;
    const bx = cur.x + (next.x - cur.x) / outLen * r;
    const by = cur.y + (next.y - cur.y) / outLen * r;
    d += ` L ${ax},${ay} Q ${cur.x},${cur.y} ${bx},${by}`;
  }
  const last = points[points.length - 1];
  return `${d} L ${last.x},${last.y}`;
}
function edgePath(points) {
  if (points.length === 0) return "";
  let d = `M ${points[0].x},${points[0].y}`;
  for (let i = 1; i < points.length; i++) d += ` L ${points[i].x},${points[i].y}`;
  return d;
}
var log = createLogger("almadar:ui:avl:effect");
function headIcon(type, x, y, s, color) {
  switch (type) {
    case "render-ui":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("rect", { x: x - s, y: y - s, width: s * 2, height: s * 2, fill: "none", stroke: color, strokeWidth: 1.5, rx: 1 }),
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s, x2: x, y2: y + s, stroke: color, strokeWidth: 1 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s, y2: y, stroke: color, strokeWidth: 1 })
      ] });
    case "set":
      return /* @__PURE__ */ jsx(
        "path",
        {
          d: `M${x - s * 0.6},${y + s} L${x - s},${y + s * 0.4} L${x + s * 0.4},${y - s} L${x + s},${y - s * 0.4} Z`,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5,
          strokeLinejoin: "round"
        }
      );
    case "persist":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("ellipse", { cx: x, cy: y - s * 0.6, rx: s, ry: s * 0.4, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.6, x2: x - s, y2: y + s * 0.4, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x + s, y1: y - s * 0.6, x2: x + s, y2: y + s * 0.4, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("ellipse", { cx: x, cy: y + s * 0.4, rx: s, ry: s * 0.4, fill: "none", stroke: color, strokeWidth: 1.5 })
      ] });
    case "fetch":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s, x2: x, y2: y + s * 0.6, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x - s * 0.5},${y + s * 0.1} ${x},${y + s} ${x + s * 0.5},${y + s * 0.1}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "emit":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s * 0.3, fill: color }),
        /* @__PURE__ */ jsx("path", { d: `M${x - s * 0.7},${y - s * 0.7} A${s},${s} 0 0,1 ${x + s * 0.7},${y - s * 0.7}`, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("path", { d: `M${x - s},${y - s} A${s * 1.4},${s * 1.4} 0 0,1 ${x + s},${y - s}`, fill: "none", stroke: color, strokeWidth: 1, opacity: 0.6 })
      ] });
    case "navigate":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s * 0.6, y2: y, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x + s * 0.1},${y - s * 0.5} ${x + s},${y} ${x + s * 0.1},${y + s * 0.5}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "call-service":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.3, x2: x + s, y2: y - s * 0.3, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x + s * 0.5},${y - s * 0.7} ${x + s},${y - s * 0.3} ${x + s * 0.5},${y + s * 0.1}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" }),
        /* @__PURE__ */ jsx("line", { x1: x + s, y1: y + s * 0.3, x2: x - s, y2: y + s * 0.3, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polyline", { points: `${x - s * 0.5},${y - s * 0.1} ${x - s},${y + s * 0.3} ${x - s * 0.5},${y + s * 0.7}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
      ] });
    case "spawn":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s * 0.5, y1: y, x2: x + s * 0.5, y2: y, stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x, y1: y - s * 0.5, x2: x, y2: y + s * 0.5, stroke: color, strokeWidth: 1.5 })
      ] });
    case "despawn":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("line", { x1: x - s * 0.5, y1: y, x2: x + s * 0.5, y2: y, stroke: color, strokeWidth: 1.5 })
      ] });
    case "do":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("polygon", { points: `${x - s * 0.3},${y - s * 0.5} ${x + s * 0.5},${y} ${x - s * 0.3},${y + s * 0.5}`, fill: color })
      ] });
    case "if":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: `${x},${y - s} ${x + s * 0.7},${y} ${x},${y + s} ${x - s * 0.7},${y}`,
          fill: "none",
          stroke: color,
          strokeWidth: 1.5,
          strokeLinejoin: "round"
        }
      );
    case "log":
      return /* @__PURE__ */ jsx(
        "text",
        {
          x,
          y,
          textAnchor: "middle",
          dominantBaseline: "central",
          fill: color,
          fontSize: s * 2.2,
          fontFamily: "serif",
          children: "\xB6"
        }
      );
    default:
      return null;
  }
}
var clock = (x, y, s, color) => /* @__PURE__ */ jsxs("g", { children: [
  /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 }),
  /* @__PURE__ */ jsx("polyline", { points: `${x},${y - s * 0.6} ${x},${y} ${x + s * 0.5},${y + s * 0.3}`, fill: "none", stroke: color, strokeWidth: 1.5, strokeLinejoin: "round" })
] });
var neuron = (x, y, s, color) => /* @__PURE__ */ jsxs("g", { children: [
  /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.6, x2: x + s * 0.8, y2: y, stroke: color, strokeWidth: 1 }),
  /* @__PURE__ */ jsx("line", { x1: x - s, y1: y + s * 0.6, x2: x + s * 0.8, y2: y, stroke: color, strokeWidth: 1 }),
  /* @__PURE__ */ jsx("circle", { cx: x - s, cy: y - s * 0.6, r: s * 0.3, fill: color }),
  /* @__PURE__ */ jsx("circle", { cx: x - s, cy: y + s * 0.6, r: s * 0.3, fill: color }),
  /* @__PURE__ */ jsx("circle", { cx: x + s * 0.8, cy: y, r: s * 0.35, fill: color })
] });
var gear = (x, y, s, color) => /* @__PURE__ */ jsxs("g", { children: [
  /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s * 0.75, fill: "none", stroke: color, strokeWidth: 1.5, strokeDasharray: `${s * 0.5} ${s * 0.3}` }),
  /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s * 0.3, fill: color })
] });
var unknown = (x, y, s, color) => /* @__PURE__ */ jsxs("g", { children: [
  /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.2, strokeDasharray: "2 2" }),
  /* @__PURE__ */ jsx("text", { x, y, textAnchor: "middle", dominantBaseline: "central", fill: color, fontSize: s * 1.4, children: "?" })
] });
var CATEGORY_GLYPH = {
  ui: (x, y, s, c) => headIcon("render-ui", x, y, s, c),
  data: (x, y, s, c) => headIcon("set", x, y, s, c),
  communication: (x, y, s, c) => headIcon("emit", x, y, s, c),
  lifecycle: (x, y, s, c) => headIcon("spawn", x, y, s, c),
  control: (x, y, s, c) => headIcon("if", x, y, s, c),
  async: clock,
  compute: neuron,
  system: gear
};
function effectIcon(type, x, y, s, color) {
  const op = asEffectOperator(type);
  const own = op ? headIcon(op, x, y, s, color) : null;
  if (own) return own;
  const category = effectCategoryOf(type);
  if (category) return CATEGORY_GLYPH[category](x, y, s, color);
  log.error("unknown-effect-operator", { effectType: type });
  return unknown(x, y, s, color);
}
var AvlEffect = ({
  x = 0,
  y = 0,
  effectType,
  size: size2 = 8,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  showBackground = false
}) => {
  const category = effectCategoryOf(effectType);
  const catColors = category ? EFFECT_CATEGORY_COLORS[category] : null;
  const iconColor = showBackground && catColors ? catColors.color : color;
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    showBackground && catColors && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: size2 * 1.2, fill: catColors.bg }),
      /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: size2 * 1.2, fill: "none", stroke: catColors.color, strokeWidth: 0.5, opacity: 0.3 })
    ] }),
    effectIcon(effectType, x, y, size2, iconColor),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + size2 + 10,
        textAnchor: "middle",
        fill: iconColor,
        fontSize: 11,
        fontWeight: 500,
        fontFamily: "inherit",
        opacity: 0.7,
        children: label
      }
    )
  ] });
};
AvlEffect.displayName = "AvlEffect";
var INTERACTIVE_SELECTOR = 'button, a[href], input, select, textarea, [role="button"], [tabindex]:not([tabindex="-1"])';
var arrowClasses2 = {
  top: "top-full left-1/2 -translate-x-1/2 border-t-white border-l-transparent border-r-transparent border-b-transparent",
  bottom: "bottom-full left-1/2 -translate-x-1/2 border-b-white border-l-transparent border-r-transparent border-t-transparent",
  left: "left-full top-1/2 -translate-y-1/2 border-l-white border-t-transparent border-b-transparent border-r-transparent",
  right: "right-full top-1/2 -translate-y-1/2 border-r-white border-t-transparent border-b-transparent border-l-transparent"
};
var VIEWPORT_EDGE_PADDING = 8;
var TRIGGER_GAP2 = 8;
function placePopover(position, trigger, panel, viewport) {
  const clamp = (value, size2, extent) => Math.max(VIEWPORT_EDGE_PADDING, Math.min(value, Math.max(VIEWPORT_EDGE_PADDING, extent - size2 - VIEWPORT_EDGE_PADDING)));
  if (position === "left" || position === "right") {
    const rightLeft = trigger.right + TRIGGER_GAP2;
    const leftLeft = trigger.left - panel.width - TRIGGER_GAP2;
    const fitsRight = rightLeft + panel.width <= viewport.width - VIEWPORT_EDGE_PADDING;
    const fitsLeft = leftLeft >= VIEWPORT_EDGE_PADDING;
    const side2 = position === "right" ? fitsRight || !fitsLeft ? "right" : "left" : fitsLeft || !fitsRight ? "left" : "right";
    const left2 = clamp(side2 === "right" ? rightLeft : leftLeft, panel.width, viewport.width);
    const top2 = clamp(trigger.top + trigger.height / 2 - panel.height / 2, panel.height, viewport.height);
    return { side: side2, left: left2, top: top2 };
  }
  const aboveTop = trigger.top - TRIGGER_GAP2 - panel.height;
  const belowTop = trigger.bottom + TRIGGER_GAP2;
  const fitsAbove = aboveTop >= VIEWPORT_EDGE_PADDING;
  const fitsBelow = belowTop + panel.height <= viewport.height - VIEWPORT_EDGE_PADDING;
  const side = position === "top" ? fitsAbove || !fitsBelow ? "top" : "bottom" : fitsBelow || !fitsAbove ? "bottom" : "top";
  const left = clamp(trigger.left + trigger.width / 2 - panel.width / 2, panel.width, viewport.width);
  const top = clamp(side === "top" ? aboveTop : belowTop, panel.height, viewport.height);
  return { side, left, top };
}
var Popover = ({
  content,
  children,
  position = "bottom",
  trigger = "click",
  showArrow = true,
  open,
  onOpenChange,
  className,
  ...rest
}) => {
  const [uncontrolledOpen, setUncontrolledOpen] = useState(false);
  const isOpen = open !== void 0 ? open : uncontrolledOpen;
  const setIsOpen = (next) => {
    if (open === void 0) setUncontrolledOpen(next);
    onOpenChange?.(next);
  };
  const [triggerRect, setTriggerRect] = useState(null);
  const [panelSize, setPanelSize] = useState({ width: 0, height: 0 });
  const popoverWidth = panelSize.width;
  const triggerRef = useRef(null);
  const popoverRef = useRef(null);
  const { mounted, className: panelAnim, onAnimationEnd } = usePresence(isOpen, { animation: "popover" });
  const updatePosition = () => {
    if (triggerRef.current) {
      setTriggerRect(triggerRef.current.getBoundingClientRect());
    }
    if (popoverRef.current) {
      setPanelSize({ width: popoverRef.current.offsetWidth, height: popoverRef.current.offsetHeight });
    }
  };
  const handleOpen = () => {
    updatePosition();
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  const panelId = useId();
  const focusReturnRef = useRef(null);
  useDialogBehavior({ open: isOpen, containerRef: popoverRef, onEscape: handleClose, modal: false, returnFocusRef: focusReturnRef });
  const handleToggle = () => {
    if (isOpen) {
      handleClose();
    } else {
      handleOpen();
    }
  };
  useEffect(() => {
    if (isOpen) {
      updatePosition();
    }
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen) return;
    let raf = 0;
    let lastTop = Number.NaN;
    let lastLeft = Number.NaN;
    const track = () => {
      const rect = triggerRef.current?.getBoundingClientRect();
      if (rect && (rect.top !== lastTop || rect.left !== lastLeft)) {
        lastTop = rect.top;
        lastLeft = rect.left;
        updatePosition();
      }
      raf = requestAnimationFrame(track);
    };
    raf = requestAnimationFrame(track);
    return () => cancelAnimationFrame(raf);
  }, [isOpen]);
  useEffect(() => {
    if (!mounted) setPanelSize({ width: 0, height: 0 });
  }, [mounted]);
  useLayoutEffect(() => {
    if (isOpen && popoverRef.current) {
      const width = popoverRef.current.offsetWidth;
      const height = popoverRef.current.offsetHeight;
      if (width !== panelSize.width || height !== panelSize.height) {
        setPanelSize({ width, height });
      }
    }
  });
  useEffect(() => {
    if (trigger !== "click") {
      return;
    }
    const handleClickOutside = (e) => {
      if (isOpen && popoverRef.current && !popoverRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
        handleClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, trigger]);
  const { triggerProps: tapTriggerProps } = useTapReveal({
    enabled: trigger === "hover",
    onReveal: handleOpen,
    onDismiss: handleClose,
    refs: [triggerRef, popoverRef]
  });
  const handlerProps = trigger === "click" ? {
    onClick: handleToggle
  } : {
    onMouseEnter: handleOpen,
    onMouseLeave: handleClose,
    onPointerDown: tapTriggerProps.onPointerDown
  };
  const wrapsContent = !React93__default.isValidElement(children);
  const [innerControl, setInnerControl] = useState(null);
  useLayoutEffect(() => {
    if (!wrapsContent || trigger !== "click") return;
    setInnerControl(triggerRef.current?.querySelector(INTERACTIVE_SELECTOR) ?? null);
  }, [wrapsContent, trigger, children]);
  useLayoutEffect(() => {
    focusReturnRef.current = innerControl ?? triggerRef.current;
  });
  useLayoutEffect(() => {
    if (innerControl === null) return;
    innerControl.setAttribute("aria-expanded", String(isOpen));
    innerControl.setAttribute("aria-haspopup", "dialog");
    if (mounted) innerControl.setAttribute("aria-controls", panelId);
    else innerControl.removeAttribute("aria-controls");
  }, [innerControl, isOpen, mounted, panelId]);
  const triggerIsWrapper = innerControl === null;
  const childElement = !wrapsContent ? children : trigger === "click" && triggerIsWrapper ? /* @__PURE__ */ jsx(
    "span",
    {
      role: "button",
      tabIndex: 0,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleToggle();
        }
      },
      children
    }
  ) : /* @__PURE__ */ jsx("span", { children });
  const childPointerDown = childElement.props.onPointerDown;
  const triggerElement = React93__default.cloneElement(
    childElement,
    {
      ref: triggerRef,
      ...handlerProps,
      // Dialog semantics belong to a click-opened panel; a hover popover is a tooltip.
      ...trigger === "click" && triggerIsWrapper ? {
        "aria-expanded": isOpen,
        "aria-haspopup": "dialog",
        ...mounted ? { "aria-controls": panelId } : void 0
      } : void 0,
      ...trigger === "hover" ? {
        onPointerDown: (e) => {
          tapTriggerProps.onPointerDown(e);
          childPointerDown?.(e);
        }
      } : void 0
    }
  );
  const placement = triggerRect ? placePopover(position, triggerRect, panelSize, {
    width: typeof window !== "undefined" ? window.innerWidth : 1024,
    height: typeof window !== "undefined" ? window.innerHeight : 768
  }) : null;
  const panel = mounted && placement ? /* @__PURE__ */ jsxs(
    "div",
    {
      ref: popoverRef,
      className: cn(
        "fixed z-50 p-4",
        "bg-card surface-material rounded-container border-heavy border-border shadow-elevation-popover",
        panelAnim,
        className
      ),
      style: {
        left: placement.left,
        top: placement.top,
        ...popoverWidth === 0 ? { visibility: "hidden" } : void 0
      },
      ...domPassthrough(rest),
      id: panelId,
      role: "dialog",
      "aria-label": rest["aria-label"] ?? (typeof content === "string" ? content : void 0),
      onAnimationEnd,
      onMouseEnter: trigger === "hover" ? handleOpen : void 0,
      onMouseLeave: trigger === "hover" ? handleClose : void 0,
      children: [
        typeof content === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "body", children: content }) : /* @__PURE__ */ jsx(SurfaceBoundary, { children: content }),
        showArrow && /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "absolute w-0 h-0 border-heavy",
              arrowClasses2[placement.side]
            )
          }
        )
      ]
    }
  ) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    triggerElement,
    panel && typeof document !== "undefined" ? /* @__PURE__ */ jsx(ThemedPortal, { children: panel }) : panel
  ] });
};
Popover.displayName = "Popover";
var AvlExplain = ({ lines, note, children }) => {
  if (note !== void 0) {
    return /* @__PURE__ */ jsx(
      Popover,
      {
        trigger: "hover",
        position: "top",
        content: /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "max-w-xs", children: [
          note.title ? /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "semibold", children: note.title }) : null,
          /* @__PURE__ */ jsx(Typography, { variant: "small", children: note.body }),
          /* @__PURE__ */ jsx(Box, { className: "border-t border-border pt-1", children: lines.map((line2, i) => /* @__PURE__ */ jsx(Typography, { variant: "caption", color: i === 0 ? "inherit" : "muted", weight: i === 0 ? "semibold" : "normal", children: line2 }, i)) })
        ] }),
        children
      }
    );
  }
  if (lines.length === 0) return children;
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      position: "top",
      content: /* @__PURE__ */ jsx(VStack, { gap: "none", children: lines.map((line2, i) => /* @__PURE__ */ jsx(Box, { as: "span", className: i === 0 ? "font-semibold" : "opacity-80", children: line2 }, i)) }),
      children
    }
  );
};
AvlExplain.displayName = "AvlExplain";
function useEffectLines(effectType) {
  const { t } = useTranslate();
  const category = effectCategoryOf(effectType);
  const description = getStdOperatorMeta(effectType)?.description;
  return [effectType, ...category ? [t(`avl.effectCategory.${category}`)] : [], ...description ? [description] : []];
}
var AvlEffectChip = ({ effectType, size: size2 = 16, note }) => {
  const lines = useEffectLines(effectType);
  const half = size2 / 2;
  return /* @__PURE__ */ jsx(AvlExplain, { lines, note, children: /* @__PURE__ */ jsx(Box, { as: "span", role: "img", tabIndex: 0, "aria-label": effectType, "data-testid": "avl-effect-chip", className: "inline-flex shrink-0 rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring", children: /* @__PURE__ */ jsx("svg", { width: size2, height: size2, viewBox: `0 0 ${size2} ${size2}`, "aria-hidden": "true", children: /* @__PURE__ */ jsx(AvlEffect, { x: half, y: half, effectType, size: half / 1.2 - 0.5, showBackground: true }) }) }) });
};
AvlEffectChip.displayName = "AvlEffectChip";
var log2 = createLogger("almadar:ui:avl:state-machine");
var MONO_CHAR = 7.3;
var BODY_CHAR = 7.6;
var NODE_H = 44;
var PILL_H = 24;
var GUARD_H = 20;
var EFFECT_CHIP = 14;
var EFFECT_GAP = 4;
var MARGIN = 28;
var MIN_SCALE = 0.85;
var MAX_SCALE = 1.25;
function guardText(t) {
  return t.guard === void 0 || t.guard === null ? null : formatSExpr(t.guard);
}
function pillWidth(t) {
  return 20 + (guardText(t) === null ? 0 : 16) + t.event.length * MONO_CHAR + t.effects.length * (EFFECT_CHIP + EFFECT_GAP);
}
function gearDiameter(name) {
  return Math.max(96, Math.round(name.length * BODY_CHAR + 40));
}
function metricsFor(nodeShape, direction) {
  return {
    nodeSize: (name) => nodeShape === "gear" ? { width: gearDiameter(name), height: gearDiameter(name) } : { width: Math.max(112, Math.round(name.length * BODY_CHAR + 44)), height: NODE_H },
    labelSize: (t) => {
      const guard = guardText(t);
      const width = Math.max(pillWidth(t), guard === null ? 0 : guard.length * MONO_CHAR + 8);
      return { width, height: guard === null ? PILL_H : PILL_H + 2 * GUARD_H };
    },
    nodeSpacing: 40,
    layerSpacing: 88,
    orthogonal: true,
    direction
  };
}
var AvlStateMachine = ({
  trait,
  activeState,
  activeTransition,
  visitedStates,
  stateClickEvent,
  transitionClickEvent,
  onTransitionClick,
  selectedState,
  pendingSourceState,
  nodeShape = "pill",
  entityFields,
  direction = "ltr",
  showHeader = true,
  annotations,
  className,
  ...rest
}) => {
  const passthrough = domPassthrough(rest);
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const clickable = transitionClickEvent !== void 0 || onTransitionClick !== void 0;
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const [layout, setLayout] = useState(null);
  const hostRef = useRef(null);
  const hostWidth = useContainerWidth(hostRef);
  const traitKey = useMemo(() => JSON.stringify(trait), [trait]);
  useEffect(() => {
    if (trait.states.length === 0) return;
    let live = true;
    computeTraitLayout(trait, metricsFor(nodeShape, direction)).then((l) => {
      if (live) setLayout(l);
    }).catch((error) => log2.error("layout-failed", { trait: trait.name, error: error instanceof Error ? error : String(error) }));
    return () => {
      live = false;
    };
  }, [traitKey, nodeShape, direction]);
  const visitOrder = useMemo(() => new Map((visitedStates ?? []).map((s, i) => [s, i + 1])), [visitedStates]);
  const nextFromActive = useMemo(
    () => new Set(trait.transitions.filter((tr) => activeState !== void 0 && tr.from === activeState).map((tr) => tr.index)),
    [trait.transitions, activeState]
  );
  const header = showHeader ? /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-baseline justify-between gap-2 pb-3", children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex items-baseline gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: trait.name }),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
        t("avl.onEntity", { entity: trait.linkedEntity }),
        " \xB7 ",
        t("avl.stateCount", { count: trait.states.length }),
        " \xB7 ",
        t("avl.transitionCount", { count: trait.transitions.length })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap gap-2", children: [
      entityFields && entityFields.length > 0 ? /* @__PURE__ */ jsxs(Box, { as: "span", "data-testid": "avl-sm-fields", style: { fontFamily: AVL_FONT.mono, fontSize: 12, lineHeight: "20px", color: AVL_INK.quiet }, children: [
        trait.linkedEntity,
        " ",
        "{ ",
        entityFields.join(", "),
        " }"
      ] }) : null,
      trait.listenedEvents.map((ev) => /* @__PURE__ */ jsx(Rail, { kind: t("avl.listensRail"), event: ev }, `in-${ev}`)),
      trait.emittedEvents.map((ev) => /* @__PURE__ */ jsx(Rail, { kind: t("avl.emitsRail"), event: ev }, `out-${ev}`))
    ] })
  ] }) : null;
  if (trait.states.length === 0) {
    return /* @__PURE__ */ jsxs(Box, { "data-testid": "avl-state-machine", className, style: { width: "100%" }, ...passthrough, children: [
      header,
      /* @__PURE__ */ jsx(Box, { "data-testid": "avl-state-machine-empty", className: "rounded-md border border-dashed p-6 text-center", style: { borderColor: AVL_INK.line }, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.noStateMachine") }) })
    ] });
  }
  const w = layout ? layout.width + 2 * MARGIN : 0;
  const h = layout ? layout.height + 2 * MARGIN : 0;
  const fit = layout && hostWidth ? hostWidth / w : 1;
  const scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, fit));
  return /* @__PURE__ */ jsxs(Box, { "data-testid": "avl-state-machine", className, style: { width: "100%" }, ...passthrough, children: [
    header,
    /* @__PURE__ */ jsx(Box, { ref: hostRef, className: "overflow-x-auto", style: { width: "100%" }, children: layout ? /* @__PURE__ */ jsx(Box, { className: "relative mx-auto", style: { width: w * scale, height: h * scale }, children: /* @__PURE__ */ jsxs(Box, { className: "absolute left-0 top-0", style: { width: w, height: h, transform: `scale(${scale})`, transformOrigin: "0 0" }, children: [
      /* @__PURE__ */ jsxs("svg", { width: w, height: h, className: "absolute left-0 top-0 overflow-visible", "aria-hidden": "true", children: [
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsx("marker", { id: `avl-sm-head-${trait.name}`, viewBox: "0 0 10 10", refX: "9", refY: "5", markerWidth: "7", markerHeight: "7", orient: "auto-start-reverse", children: /* @__PURE__ */ jsx("path", { d: "M0 0 L10 5 L0 10z", fill: AVL_INK.quiet, fillOpacity: 0.8 }) }),
          /* @__PURE__ */ jsx("marker", { id: `avl-sm-head-hot-${trait.name}`, viewBox: "0 0 10 10", refX: "9", refY: "5", markerWidth: "6", markerHeight: "6", orient: "auto-start-reverse", children: /* @__PURE__ */ jsx("path", { d: "M0 0 L10 5 L0 10z", fill: AVL_INK.focus }) })
        ] }),
        /* @__PURE__ */ jsxs("g", { transform: `translate(${MARGIN},${MARGIN})`, children: [
          layout.nodes.filter((n) => n.isInitial).map((n) => {
            const cy = n.y + n.height / 2;
            const rtl = direction === "rtl";
            const dot = rtl ? n.x + n.width + 18 : n.x - 18;
            const d = rtl ? `M ${n.x + n.width + 13} ${cy} H ${n.x + n.width + 1}` : `M ${n.x - 13} ${cy} H ${n.x - 1}`;
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx("circle", { cx: dot, cy, r: 5, fill: AVL_INK.text }),
              /* @__PURE__ */ jsx("path", { d, stroke: AVL_INK.quiet, strokeWidth: AVL_STROKE.wire, markerEnd: `url(#avl-sm-head-${trait.name})` })
            ] }, `init-${n.id}`);
          }),
          layout.edges.map((e) => {
            const fired = e.index === activeTransition;
            return /* @__PURE__ */ jsx(
              "path",
              {
                "data-testid": "avl-sm-wire",
                "data-event": e.event,
                "data-fired": fired ? "true" : "false",
                d: roundedEdgePath(e.points, 10),
                fill: "none",
                stroke: fired ? AVL_INK.focus : AVL_INK.quiet,
                strokeOpacity: fired ? 1 : 0.55,
                strokeWidth: fired ? AVL_STROKE.active : AVL_STROKE.wire,
                strokeDasharray: fired ? "8 6" : e.isBackward || e.isSelf ? "5 4" : void 0,
                markerEnd: `url(#avl-sm-head${fired ? "-hot" : ""}-${trait.name})`,
                children: fired && !reduceMotion ? /* @__PURE__ */ jsx("animate", { attributeName: "stroke-dashoffset", from: "0", to: "-14", dur: "0.8s", repeatCount: "indefinite" }) : null
              },
              e.id
            );
          }),
          layout.nodes.filter((n) => n.id === activeState).map((n) => /* @__PURE__ */ jsx(
            "rect",
            {
              x: n.x - 5,
              y: n.y - 5,
              width: n.width + 10,
              height: n.height + 10,
              rx: 12,
              fill: "none",
              stroke: AVL_INK.focus,
              strokeWidth: 4,
              strokeOpacity: 0.22,
              children: !reduceMotion ? /* @__PURE__ */ jsx("animate", { attributeName: "stroke-opacity", values: "0.28;0.06;0.28", dur: "1.6s", repeatCount: "indefinite" }) : null
            },
            `ring-${n.id}`
          ))
        ] })
      ] }),
      layout.edges.map((e) => {
        const tr = trait.transitions.find((x) => x.index === e.index);
        if (!tr) return null;
        const fired = e.index === activeTransition;
        const next = !fired && nextFromActive.has(e.index);
        const guard = guardText(tr);
        const pw = pillWidth(tr);
        return /* @__PURE__ */ jsxs(
          Box,
          {
            "data-testid": "avl-sm-label",
            "data-event": tr.event,
            role: clickable ? "button" : void 0,
            tabIndex: clickable ? 0 : void 0,
            "aria-current": fired ? "true" : void 0,
            onClick: clickable ? () => {
              const payload = { index: tr.index, event: tr.event, from: tr.from, to: tr.to };
              onTransitionClick?.(payload);
              if (transitionClickEvent) eventBus.emit(`UI:${transitionClickEvent}`, payload);
            } : void 0,
            className: `absolute flex flex-col items-center justify-center ${clickable ? "cursor-pointer" : ""}`,
            style: { left: MARGIN + e.labelX, top: MARGIN + e.labelY, width: e.labelW, height: e.labelH },
            children: [
              /* @__PURE__ */ jsxs(
                Box,
                {
                  className: "flex items-center gap-1 rounded-md px-2",
                  style: {
                    height: PILL_H,
                    width: pw,
                    background: AVL_INK.surface,
                    border: `1px ${next ? "dashed" : "solid"} ${fired ? AVL_INK.focus : AVL_INK.line}`,
                    fontFamily: AVL_FONT.mono,
                    fontSize: 12,
                    color: fired ? AVL_INK.focus : AVL_INK.text,
                    fontWeight: fired ? 600 : 400
                  },
                  children: [
                    guard !== null ? /* @__PURE__ */ jsx("svg", { width: 12, height: 12, viewBox: "0 0 12 12", "aria-label": t("avl.guard"), children: /* @__PURE__ */ jsx("path", { d: "M6 1 L11 6 L6 11 L1 6z", fill: AVL_INK.surface, stroke: fired ? AVL_INK.focus : AVL_INK.quiet, strokeWidth: 1.2 }) }) : null,
                    annotations?.transitions?.[tr.event] ? /* @__PURE__ */ jsx(AvlExplain, { lines: guard === null ? [tr.event] : [tr.event, guard], note: annotations.transitions[tr.event], children: /* @__PURE__ */ jsx(Box, { as: "span", tabIndex: 0, "data-explain": `transition:${tr.event}`, className: "whitespace-nowrap underline decoration-dotted underline-offset-2 cursor-help", children: tr.event }) }) : /* @__PURE__ */ jsx(Box, { as: "span", className: "whitespace-nowrap", children: tr.event }),
                    tr.effects.map((fx, i) => /* @__PURE__ */ jsx(AvlEffectChip, { effectType: fx.type, size: EFFECT_CHIP, note: annotations?.effects?.[fx.type] }, `${fx.type}-${i}`))
                  ]
                }
              ),
              guard !== null ? /* @__PURE__ */ jsx(Box, { as: "span", dir: "ltr", className: "whitespace-nowrap", style: { height: GUARD_H, lineHeight: `${GUARD_H}px`, fontFamily: AVL_FONT.mono, fontSize: 12, color: fired ? AVL_INK.focus : AVL_INK.quiet }, children: guard }) : null
            ]
          },
          `label-${e.id}`
        );
      }),
      trait.states.map((s) => {
        const n = layout.nodes.find((x) => x.id === s.name);
        if (!n) return null;
        const active = s.name === activeState;
        const selected = s.name === selectedState;
        const pending = s.name === pendingSourceState;
        const visit = visitOrder.get(s.name);
        const idle = activeState !== void 0 && !active && visit === void 0;
        const gear2 = nodeShape === "gear";
        const emphasis = active || selected || pending;
        return /* @__PURE__ */ jsxs(
          Box,
          {
            "data-testid": "avl-sm-state",
            "data-state": s.name,
            "data-active": active ? "true" : "false",
            "data-selected": selected ? "true" : "false",
            "data-pending": pending ? "true" : "false",
            "data-shape": nodeShape,
            role: stateClickEvent ? "button" : void 0,
            tabIndex: stateClickEvent ? 0 : void 0,
            "aria-current": active ? "true" : void 0,
            "aria-pressed": stateClickEvent ? selected : void 0,
            onClick: stateClickEvent ? () => eventBus.emit(`UI:${stateClickEvent}`, { stateId: s.name }) : void 0,
            className: `absolute flex items-center justify-center ${gear2 ? "rounded-full" : "rounded-lg"} ${stateClickEvent ? "cursor-pointer" : ""}`,
            style: {
              left: MARGIN + n.x,
              top: MARGIN + n.y,
              width: n.width,
              height: n.height,
              background: gear2 ? "transparent" : AVL_INK.surface,
              border: gear2 ? "none" : `${emphasis ? 2 : 1}px ${pending ? "dashed" : "solid"} ${emphasis ? AVL_INK.focus : AVL_INK.line}`,
              boxShadow: gear2 ? "none" : s.isTerminal ? `0 0 0 3px ${AVL_INK.surface}, 0 0 0 4px ${AVL_INK.line}, var(--shadow-sm)` : selected ? `0 0 0 4px ${avlTint(AVL_INK.focus, 18)}, var(--shadow-hover)` : active ? "var(--shadow-hover)" : "var(--shadow-sm)",
              color: idle ? AVL_INK.quiet : AVL_INK.text,
              fontFamily: AVL_FONT.body,
              fontSize: 13,
              fontWeight: active ? 600 : 500,
              transition: "border-color var(--duration-normal, 200ms), box-shadow var(--duration-normal, 200ms)"
            },
            children: [
              visit !== void 0 && !active ? /* @__PURE__ */ jsx(
                Box,
                {
                  as: "span",
                  "data-testid": "avl-sm-visit",
                  className: "absolute flex items-center justify-center rounded-full",
                  style: { top: -9, left: -9, width: 18, height: 18, fontSize: 11, fontWeight: 600, background: AVL_INK.wash, color: AVL_INK.quiet, border: `1px solid ${AVL_INK.line}` },
                  children: visit
                }
              ) : null,
              active ? /* @__PURE__ */ jsx(
                Box,
                {
                  as: "span",
                  className: "absolute rounded-full px-1.5",
                  style: { top: -10, right: 8, fontSize: 11, fontWeight: 600, background: AVL_INK.focus, color: AVL_INK.onFocus, boxShadow: `0 0 0 2px ${avlTint(AVL_INK.focus, 18)}` },
                  children: t("avl.now")
                }
              ) : null,
              gear2 ? /* @__PURE__ */ jsxs("svg", { "data-testid": "avl-sm-gear", width: n.width, height: n.height, className: "absolute left-0 top-0", "aria-hidden": "true", children: [
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: gearTeethPath(n.width / 2, n.height / 2, n.width / 2 - 8, n.width / 2 - 1, 12),
                    fill: AVL_INK.surface,
                    stroke: emphasis ? AVL_INK.focus : AVL_INK.line,
                    strokeWidth: emphasis ? 2 : 1.25,
                    strokeDasharray: pending || s.isTerminal ? "4 3" : void 0
                  }
                ),
                /* @__PURE__ */ jsx("circle", { cx: n.width / 2, cy: n.height / 2, r: n.width / 2 - 14, fill: "none", stroke: AVL_INK.line, strokeWidth: 1 })
              ] }) : null,
              annotations?.states?.[s.name] ? /* @__PURE__ */ jsx(AvlExplain, { lines: [s.name], note: annotations.states[s.name], children: /* @__PURE__ */ jsx(Box, { as: "span", tabIndex: 0, "data-explain": `state:${s.name}`, className: "relative underline decoration-dotted underline-offset-2 cursor-help", children: s.name }) }) : /* @__PURE__ */ jsx(Box, { as: "span", className: "relative", children: s.name })
            ]
          },
          s.name
        );
      })
    ] }) }) : /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center py-10", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.computingLayout") }) }) })
  ] });
};
var Rail = ({ kind, event }) => /* @__PURE__ */ jsxs(
  Box,
  {
    as: "span",
    className: "inline-flex items-center gap-1 rounded-full px-2",
    style: { fontFamily: AVL_FONT.mono, fontSize: 12, lineHeight: "20px", border: `1px solid ${AVL_INK.line}`, background: AVL_INK.wash, color: AVL_INK.quiet },
    children: [
      kind,
      /* @__PURE__ */ jsx(Box, { as: "span", style: { color: AVL_INK.text, fontWeight: 600 }, children: event })
    ]
  }
);
AvlStateMachine.displayName = "AvlStateMachine";
function StateGraph({
  states,
  transitions = [],
  currentState,
  selectedState,
  addingFrom,
  initialState,
  width = 500,
  height = 400,
  nodeClickEvent,
  className,
  ...rest
}) {
  const trait = React93.useMemo(() => ({
    name: "StateGraph",
    linkedEntity: "",
    states: (states ?? []).map((name) => ({ name, isInitial: name === initialState, isTerminal: false })),
    transitions: transitions.map((tr, index) => ({
      from: tr.from,
      to: tr.to,
      event: tr.event,
      guard: tr.guardHint ?? null,
      effects: [],
      index
    })),
    emittedEvents: [],
    listenedEvents: []
  }), [states, transitions, initialState]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      position: "relative",
      className: cn("rounded-container border border-border bg-background overflow-auto p-2", className),
      style: { width, height },
      children: /* @__PURE__ */ jsx(
        AvlStateMachine,
        {
          trait,
          activeState: currentState || void 0,
          selectedState: selectedState || void 0,
          pendingSourceState: addingFrom || void 0,
          stateClickEvent: nodeClickEvent,
          showHeader: false
        }
      )
    }
  );
}
var DEFAULT_TILES = [
  { x: 10, y: 10, color: "#4ade80" },
  { x: 20, y: 15, color: "#4ade80" },
  { x: 30, y: 25, color: "#22c55e" },
  { x: 50, y: 40, color: "#4ade80" },
  { x: 60, y: 55, color: "#16a34a" },
  { x: 40, y: 60, color: "#4ade80" },
  { x: 70, y: 30, color: "#22c55e" },
  { x: 80, y: 70, color: "#4ade80" }
];
var DEFAULT_UNITS = [
  { x: 30, y: 30, color: "#60a5fa", isPlayer: true }
];
var DEFAULT_VIEWPORT = { x: 20, y: 20, w: 40, h: 40 };
function MiniMap({
  tiles = DEFAULT_TILES,
  units = DEFAULT_UNITS,
  width = 150,
  height = 150,
  mapWidth = 100,
  mapHeight = 100,
  viewportRect = DEFAULT_VIEWPORT,
  className,
  tileAssets,
  unitAssets,
  ...rest
}) {
  const { t } = useTranslate();
  const canvasRef = React93.useRef(null);
  const imgCacheRef = React93.useRef(/* @__PURE__ */ new Map());
  function loadImg(url) {
    const cached = imgCacheRef.current.get(url);
    if (cached) return cached.complete ? cached : null;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      if (ctx) ctx.clearRect(0, 0, 0, 0);
    };
    imgCacheRef.current.set(url, img);
    return null;
  }
  React93.useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const scaleX2 = width / mapWidth;
    const scaleY2 = height / mapHeight;
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = "#111";
    ctx.fillRect(0, 0, width, height);
    for (const tile of tiles) {
      const tileAsset = tileAssets?.[tile.color] ?? tileAssets?.["default"];
      const tileImg = tileAsset ? loadImg(tileAsset.url) : null;
      const tx = Math.floor(tile.x * scaleX2);
      const ty = Math.floor(tile.y * scaleY2);
      const tw = Math.max(1, Math.ceil(scaleX2));
      const th = Math.max(1, Math.ceil(scaleY2));
      if (tileImg) {
        ctx.drawImage(tileImg, tx, ty, tw, th);
      } else {
        ctx.fillStyle = tile.color;
        ctx.fillRect(tx, ty, tw, th);
      }
    }
    for (const unit of units) {
      if (unit.isPlayer) continue;
      const unitAsset = unitAssets?.[unit.color] ?? unitAssets?.["default"];
      const unitImg = unitAsset ? loadImg(unitAsset.url) : null;
      const ux = Math.floor(unit.x * scaleX2) - 1;
      const uy = Math.floor(unit.y * scaleY2) - 1;
      if (unitImg) {
        ctx.drawImage(unitImg, ux, uy, 5, 5);
      } else {
        ctx.fillStyle = unit.color;
        ctx.fillRect(ux, uy, 3, 3);
      }
    }
    if (viewportRect) {
      ctx.strokeStyle = "#ffffff";
      ctx.lineWidth = 1;
      ctx.strokeRect(
        Math.floor(viewportRect.x * scaleX2),
        Math.floor(viewportRect.y * scaleY2),
        Math.floor(viewportRect.w * scaleX2),
        Math.floor(viewportRect.h * scaleY2)
      );
    }
  }, [tiles, units, width, height, mapWidth, mapHeight, viewportRect, tileAssets, unitAssets]);
  const scaleX = width / mapWidth;
  const scaleY = height / mapHeight;
  const playerUnit = units.find((u) => u.isPlayer);
  const playerLeft = playerUnit ? Math.floor(playerUnit.x * scaleX) - 1 : null;
  const playerTop = playerUnit ? Math.floor(playerUnit.y * scaleY) - 1 : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("style", { children: `@keyframes minimap-blink{0%,49%{opacity:1}50%,100%{opacity:0}}` }),
    /* @__PURE__ */ jsxs(
      Box,
      {
        position: "relative",
        display: "inline-block",
        className: cn(
          "border border-border/20 rounded-container",
          className
        ),
        children: [
          /* @__PURE__ */ jsx(
            "canvas",
            {
              ref: canvasRef,
              width,
              height,
              className: "block",
              style: { width, height },
              role: "img",
              "aria-label": t("aria.minimap"),
              ...domPassthrough(rest)
            }
          ),
          playerLeft !== null && playerTop !== null && /* @__PURE__ */ jsx(
            Box,
            {
              position: "absolute",
              style: {
                left: playerLeft,
                top: playerTop,
                width: 3,
                height: 3,
                backgroundColor: "#ffffff",
                animation: "minimap-blink 1s steps(2, end) infinite",
                pointerEvents: "none"
              }
            }
          )
        ]
      }
    )
  ] });
}
MiniMap.displayName = "MiniMap";
var MIN_ZOOM = 0.05;
var MAX_ZOOM = 10;
function useCamera(initial) {
  const cameraRef = useRef({
    x: initial?.x ?? 0,
    y: initial?.y ?? 0,
    zoom: initial?.zoom ?? 1
  });
  const targetCameraRef = useRef(null);
  const isDraggingRef = useRef(false);
  const dragDistanceRef = useRef(0);
  const lastMouseRef = useRef({ x: 0, y: 0 });
  const handleMouseDown = useCallback((e) => {
    isDraggingRef.current = true;
    dragDistanceRef.current = 0;
    lastMouseRef.current = { x: e.clientX, y: e.clientY };
    if (e.button === 1 || e.button === 2) {
      e.preventDefault();
    }
  }, []);
  const handleMouseUp = useCallback(() => {
    isDraggingRef.current = false;
  }, []);
  const handleMouseMove = useCallback((e, drawFn) => {
    if (!isDraggingRef.current) return false;
    const dx = e.clientX - lastMouseRef.current.x;
    const dy = e.clientY - lastMouseRef.current.y;
    dragDistanceRef.current += Math.abs(dx) + Math.abs(dy);
    cameraRef.current.x -= dx;
    cameraRef.current.y -= dy;
    lastMouseRef.current = { x: e.clientX, y: e.clientY };
    targetCameraRef.current = null;
    drawFn?.();
    return dragDistanceRef.current > 5;
  }, []);
  const handleMouseLeave = useCallback(() => {
    isDraggingRef.current = false;
  }, []);
  const handleWheel = useCallback((e, drawFn) => {
    e.preventDefault();
    const zoomDelta = e.deltaY > 0 ? 0.9 : 1.1;
    cameraRef.current.zoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, cameraRef.current.zoom * zoomDelta));
    drawFn?.();
  }, []);
  const handlePointerDown = useCallback((e) => {
    handleMouseDown(e);
  }, [handleMouseDown]);
  const handlePointerUp = useCallback(() => {
    handleMouseUp();
  }, [handleMouseUp]);
  const handlePointerMove = useCallback((e, drawFn) => {
    return handleMouseMove(e, drawFn);
  }, [handleMouseMove]);
  const panBy = useCallback((dx, dy, drawFn) => {
    cameraRef.current.x -= dx;
    cameraRef.current.y -= dy;
    targetCameraRef.current = null;
    drawFn?.();
  }, []);
  const zoomAtPoint = useCallback((factor, centerX, centerY, viewportSize, drawFn) => {
    const cam = cameraRef.current;
    const oldZoom = cam.zoom;
    const newZoom = Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, oldZoom * factor));
    if (newZoom === oldZoom) {
      drawFn?.();
      return;
    }
    const inv = 1 / oldZoom - 1 / newZoom;
    cam.x += (centerX - viewportSize.width / 2) * inv;
    cam.y += (centerY - viewportSize.height / 2) * inv;
    cam.zoom = newZoom;
    targetCameraRef.current = null;
    drawFn?.();
  }, []);
  const screenToWorld = useCallback((clientX, clientY, canvas, viewportSize) => {
    const rect = canvas.getBoundingClientRect();
    const screenX = clientX - rect.left;
    const screenY = clientY - rect.top;
    const cam = cameraRef.current;
    const worldX = (screenX - viewportSize.width / 2) / cam.zoom + viewportSize.width / 2 + cam.x;
    const worldY = (screenY - viewportSize.height / 2) / cam.zoom + viewportSize.height / 2 + cam.y;
    return { x: worldX, y: worldY };
  }, []);
  const lerpToTarget = useCallback((t = 0.08) => {
    if (!targetCameraRef.current) return false;
    const cam = cameraRef.current;
    cam.x += (targetCameraRef.current.x - cam.x) * t;
    cam.y += (targetCameraRef.current.y - cam.y) * t;
    if (Math.abs(cam.x - targetCameraRef.current.x) < 0.5 && Math.abs(cam.y - targetCameraRef.current.y) < 0.5) {
      cam.x = targetCameraRef.current.x;
      cam.y = targetCameraRef.current.y;
      targetCameraRef.current = null;
    }
    return true;
  }, []);
  return {
    cameraRef,
    targetCameraRef,
    isDragging: () => isDraggingRef.current,
    dragDistance: () => dragDistanceRef.current,
    handleMouseDown,
    handleMouseUp,
    handleMouseMove,
    handleMouseLeave,
    handleWheel,
    handlePointerDown,
    handlePointerUp,
    handlePointerMove,
    panBy,
    zoomAtPoint,
    screenToWorld,
    lerpToTarget
  };
}

// lib/webPainter2d.ts
var handleByImage = /* @__PURE__ */ new WeakMap();
var imageByHandle = /* @__PURE__ */ new WeakMap();
var noiseHash = (x, y) => {
  const s = Math.sin(x * 12.9898 + y * 78.233) * 43758.5453;
  return s - Math.floor(s);
};
var NOISE_CELLS = 32;
function makeNoiseTile(alpha, color) {
  const tile = document.createElement("canvas");
  tile.width = NOISE_CELLS;
  tile.height = NOISE_CELLS;
  const t = tile.getContext("2d");
  if (t) {
    t.fillStyle = color;
    for (let y = 0; y < NOISE_CELLS; y++) {
      for (let x = 0; x < NOISE_CELLS; x++) {
        t.globalAlpha = noiseHash(x, y) * alpha;
        t.fillRect(x, y, 1, 1);
      }
    }
  }
  return tile;
}
function createWebPainter(ctx, onAssetLoad) {
  let vw = 0;
  let vh = 0;
  const patternCache = /* @__PURE__ */ new Map();
  const tracePoly = (points, closed) => {
    if (points.length === 0) return;
    ctx.beginPath();
    ctx.moveTo(points[0].x, points[0].y);
    for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y);
    if (closed) ctx.closePath();
  };
  const toCanvasPattern = (style) => {
    const key = JSON.stringify(style);
    let pattern = patternCache.get(key);
    if (pattern === void 0) {
      if (style.kind === "noise") {
        pattern = ctx.createPattern(makeNoiseTile(style.alpha ?? 0.12, style.color ?? "#000000"), "repeat");
      } else {
        const img = getOrLoadImage(style.url, onAssetLoad);
        if (!img) return "rgba(0,0,0,0)";
        pattern = ctx.createPattern(img, "repeat");
      }
      if (pattern && style.scale !== void 0 && style.scale !== 1) {
        pattern.setTransform(new DOMMatrix().scale(style.scale));
      }
      patternCache.set(key, pattern);
    }
    return pattern ?? "rgba(0,0,0,0)";
  };
  const toCanvasStyle = (style) => {
    if (typeof style === "string") return style;
    if (style.kind === "noise" || style.kind === "image") return toCanvasPattern(style);
    const g = style.kind === "linear" ? ctx.createLinearGradient(style.x1, style.y1, style.x2, style.y2) : style.kind === "conic" ? ctx.createConicGradient(style.angle, style.cx, style.cy) : ctx.createRadialGradient(style.cx, style.cy, 0, style.cx, style.cy, style.r);
    for (const stop of style.stops) g.addColorStop(stop.offset, stop.color);
    return g;
  };
  return {
    setViewport(width, height, dpr) {
      vw = width;
      vh = height;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    },
    clear() {
      ctx.clearRect(0, 0, vw, vh);
    },
    save() {
      ctx.save();
    },
    restore() {
      ctx.restore();
    },
    translate(x, y) {
      ctx.translate(x, y);
    },
    scale(sx, sy) {
      ctx.scale(sx, sy);
    },
    rotate(radians) {
      ctx.rotate(radians);
    },
    setAlpha(alpha) {
      ctx.globalAlpha = alpha;
    },
    setShadow(shadow) {
      ctx.shadowColor = shadow ? shadow.color : "transparent";
      ctx.shadowBlur = shadow ? shadow.blur : 0;
    },
    setBlend(mode) {
      ctx.globalCompositeOperation = mode ?? "source-over";
    },
    setLineDash(pattern, offset = 0) {
      ctx.setLineDash(pattern ? [...pattern] : []);
      ctx.lineDashOffset = offset;
    },
    setBlur(px) {
      ctx.filter = px && px > 0 ? `blur(${px}px)` : "none";
    },
    clipPath(d) {
      ctx.clip(new Path2D(d));
    },
    resolveTexture(url) {
      const img = getOrLoadImage(url, onAssetLoad);
      if (!img) return null;
      let handle = handleByImage.get(img);
      if (!handle) {
        handle = { width: img.naturalWidth, height: img.naturalHeight };
        handleByImage.set(img, handle);
        imageByHandle.set(handle, img);
      }
      return handle;
    },
    blit(tex, dest, src) {
      const img = imageByHandle.get(tex);
      if (!img) return;
      const dw = dest.w ?? (src ? src.w : tex.width);
      const dh = dest.h ?? (src ? src.h : tex.height);
      if (src) {
        ctx.drawImage(img, src.x, src.y, src.w, src.h, dest.x, dest.y, dw, dh);
      } else {
        ctx.drawImage(img, dest.x, dest.y, dw, dh);
      }
    },
    blitTransformed(tex, src, affine) {
      const img = imageByHandle.get(tex);
      if (!img) return;
      ctx.save();
      ctx.transform(affine[0], affine[1], affine[2], affine[3], affine[4], affine[5]);
      ctx.drawImage(img, src.x, src.y, src.w, src.h, src.x, src.y, src.w, src.h);
      ctx.restore();
    },
    fillRect(x, y, w, h, style) {
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fillRect(x, y, w, h);
    },
    strokeRect(x, y, w, h, style, lineWidth = 1) {
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.strokeRect(x, y, w, h);
    },
    fillPoly(points, style) {
      if (points.length === 0) return;
      tracePoly(points, true);
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill();
    },
    strokePoly(points, style, lineWidth = 1, closed = false) {
      if (points.length === 0) return;
      tracePoly(points, closed);
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    },
    fillEllipse(cx, cy, rx, ry, style) {
      ctx.beginPath();
      ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill();
    },
    strokeEllipse(cx, cy, rx, ry, style, lineWidth = 1) {
      ctx.beginPath();
      ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    },
    fillPath(d, style) {
      ctx.fillStyle = toCanvasStyle(style);
      ctx.fill(new Path2D(d));
    },
    strokePath(d, style, lineWidth = 1) {
      ctx.strokeStyle = toCanvasStyle(style);
      ctx.lineWidth = lineWidth;
      ctx.stroke(new Path2D(d));
    },
    text(str2, x, y, style) {
      if (style.font) ctx.font = style.font;
      ctx.fillStyle = style.color;
      ctx.textAlign = style.align ?? "left";
      ctx.textBaseline = style.baseline ?? "alphabetic";
      ctx.fillText(str2, x, y);
    }
  };
}

// lib/drawable/projector.ts
function create2DProjector(opts) {
  const { baseOffsetX, layout } = opts;
  const tw = opts.tileWidth ?? TILE_WIDTH;
  const tileWidth = layout === "free" ? 1 : tw;
  const floorHeight = layout === "free" ? 1 : tw / 2;
  const diamondTopY = layout === "free" ? 0 : opts.diamondTopY ?? tw * (DIAMOND_TOP_Y / TILE_WIDTH);
  const squareGrid = layout === "flat" || layout === "free";
  const project = (pos) => layout === "free" ? { x: pos.x, y: pos.y } : isoToScreen(pos.x, pos.y, tw, baseOffsetX, layout);
  const anchorPoint = (pos, anchor) => {
    const base = project(pos);
    if (anchor === "top-left") return base;
    const cx = base.x + tileWidth / 2;
    if (anchor === "ground") {
      const gy = squareGrid ? base.y + tileWidth * 0.92 : base.y + diamondTopY + floorHeight * 0.5;
      return { x: cx, y: gy };
    }
    const cy = squareGrid ? base.y + tileWidth / 2 : base.y + diamondTopY + floorHeight * 0.5;
    return { x: cx, y: cy };
  };
  const cellPath = (pos) => {
    const base = project(pos);
    if (squareGrid) {
      return [
        { x: base.x, y: base.y },
        { x: base.x + tileWidth, y: base.y },
        { x: base.x + tileWidth, y: base.y + tileWidth },
        { x: base.x, y: base.y + tileWidth }
      ];
    }
    const cx = base.x + tileWidth / 2;
    const topY = base.y + diamondTopY;
    return [
      { x: cx, y: topY },
      { x: base.x + tileWidth, y: topY + floorHeight / 2 },
      { x: cx, y: topY + floorHeight },
      { x: base.x, y: topY + floorHeight / 2 }
    ];
  };
  return { project, anchorPoint, cellPath, tileWidth, floorHeight, diamondTopY, squareGrid, worldPixelDirect: layout === "free" };
}
var spriteLog = createLogger("almadar:ui:draw-sprite");
var loggedMissing = /* @__PURE__ */ new Set();
var FALLBACK_WORLD_PX = 32;
function warnMissingOnce(reason, node) {
  const asset = node.asset ?? {};
  const key = `${reason}:${String(asset.url)}:${String(asset.atlas)}:${String(asset.sprite)}`;
  if (loggedMissing.has(key)) return;
  loggedMissing.add(key);
  spriteLog.warn("draw-sprite asset unresolvable \u2014 painting fallback square", { reason, url: asset.url, atlas: asset.atlas, sprite: asset.sprite });
}
function paintFallbackSquare(painter, node, dctx, reason) {
  warnMissingOnce(reason, node);
  const tw = dctx.projector.tileWidth;
  const natural = dctx.projector.worldPixelDirect ? FALLBACK_WORLD_PX : tw;
  const rect = spriteRect(dctx.projector, node, { w: natural, h: natural });
  painter.save();
  if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
  painter.fillRect(rect.x, rect.y, rect.w, rect.h, SPRITE_FALLBACK_FILL);
  painter.strokeRect(rect.x, rect.y, rect.w, rect.h, SPRITE_FALLBACK_STROKE, Math.max(1, tw / 32));
  painter.restore();
}
var paintSprite = (painter, node, dctx) => {
  const state = spriteAssetState(node);
  if (state === "invalid-position") return;
  if (state === "asset-unset") {
    paintFallbackSquare(painter, node, dctx, "asset-unset");
    return;
  }
  const tex = painter.resolveTexture(node.asset.url);
  if (!tex) {
    if (getImageStatus(node.asset.url) === "failed") paintFallbackSquare(painter, node, dctx, "texture-failed");
    return;
  }
  let src = typeof node.frame === "object" ? node.frame : void 0;
  const sheetAtlasUrl = atlasUrlOf(node.asset);
  if (!src && node.animation !== void 0 && sheetAtlasUrl !== void 0) {
    const atlas = getAtlas(sheetAtlasUrl, dctx.invalidate);
    if (!atlas) {
      if (atlasFailed(sheetAtlasUrl)) paintFallbackSquare(painter, node, dctx, "atlas-failed");
      return;
    }
    if (isSpriteSheetAtlas(atlas)) {
      const def = atlas.animations[node.animation];
      if (!def) {
        paintFallbackSquare(painter, node, dctx, "sprite-missing");
        return;
      }
      const { frame } = getCurrentFrameFromDef(node.loop === void 0 ? def : { ...def, loop: node.loop }, node.clockMs ?? dctx.time);
      const r = frameRect(frame, def.row, atlas.columns, atlas.frameWidth, atlas.frameHeight);
      if (![r.sx, r.sy, r.sw, r.sh].every(Number.isFinite)) {
        paintFallbackSquare(painter, node, dctx, "sprite-missing");
        return;
      }
      src = { x: r.sx, y: r.sy, w: r.sw, h: r.sh };
    }
  }
  if (!src && isAtlasAsset(node.asset)) {
    const atlas = getAtlas(node.asset.atlas, dctx.invalidate);
    if (!atlas) {
      if (atlasFailed(node.asset.atlas)) paintFallbackSquare(painter, node, dctx, "atlas-failed");
      return;
    }
    const r = subRectFor(atlas, node.asset.sprite);
    if (!r) {
      paintFallbackSquare(painter, node, dctx, "sprite-missing");
      return;
    }
    src = { x: r.sx, y: r.sy, w: r.sw, h: r.sh };
  }
  const rect = spriteRect(dctx.projector, node, src ? { w: src.w, h: src.h } : { w: tex.width, h: tex.height });
  const { w, h } = rect;
  const dx = rect.x;
  const dy = rect.y;
  painter.save();
  if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
  if (node.shadow) painter.setShadow(node.shadow);
  if (node.rotation) {
    const cx = dx + w / 2;
    const cy = dy + h / 2;
    painter.translate(cx, cy);
    painter.rotate(node.rotation);
    painter.translate(-cx, -cy);
  }
  if (node.flipX) {
    const cx = dx + w / 2;
    painter.translate(cx, 0);
    painter.scale(-1, 1);
    painter.translate(-cx, 0);
  }
  painter.blit(tex, { x: dx, y: dy, w, h }, src);
  painter.restore();
};
function isAnimatedSprite(node) {
  return node.animation !== void 0 && typeof node.asset?.atlas === "string";
}
function DrawSprite(_props) {
  return null;
}

// components/game/atoms/DrawText.tsx
var paintText = (painter, node, dctx) => {
  if (!isValidScenePos(node.position)) return;
  const p = dctx.projector.anchorPoint(node.position, node.anchor ?? "center");
  const x = p.x + (node.offsetX ?? 0);
  const y = p.y + (node.offsetY ?? 0);
  painter.save();
  if (node.opacity !== void 0 && node.opacity !== 1) painter.setAlpha(node.opacity);
  painter.text(node.text, x, y, { color: node.color, font: node.font, align: node.align, baseline: node.baseline });
  painter.restore();
};
function DrawText(_props) {
  return null;
}

// components/game/molecules/DrawSpriteLayer.tsx
var paintSpriteLayer = (painter, node, dctx) => {
  for (const item of node.items) {
    paintSprite(painter, item, dctx);
  }
};
function DrawSpriteLayer(_props) {
  return null;
}

// components/game/molecules/DrawShapeLayer.tsx
var paintShapeLayer = (painter, node, dctx) => {
  for (const item of node.items) {
    paintShape(painter, item, dctx);
  }
};
function DrawShapeLayer(_props) {
  return null;
}

// components/game/molecules/DrawTextLayer.tsx
var paintTextLayer = (painter, node, dctx) => {
  for (const item of node.items) {
    paintText(painter, item, dctx);
  }
};
function DrawTextLayer(_props) {
  return null;
}
var paint2dLog = createLogger("almadar:ui:drawable-2d");
var warnedUnsupported2d = /* @__PURE__ */ new Set();
var warnUnsupported2d = (kind) => {
  if (warnedUnsupported2d.has(kind)) return;
  warnedUnsupported2d.add(kind);
  paint2dLog.warn("unsupported drawable kind on the 2D painter \u2014 skipped", { kind });
};
function paintDrawable(painter, node, dctx) {
  switch (node.type) {
    case "draw-sprite":
      paintSprite(painter, node, dctx);
      break;
    case "draw-shape":
      paintShape(painter, node, dctx);
      break;
    case "draw-text":
      paintText(painter, node, dctx);
      break;
    case "draw-group": {
      if (!isValidScenePos(node.position)) break;
      if (!Array.isArray(node.items)) break;
      const p = dctx.projector.project(node.position);
      const anim = dctx.time > 0 && isAnimatedGroup(node) ? applyMeshAnimation(node, dctx.time) : null;
      const tw = dctx.projector.tileWidth;
      painter.save();
      painter.translate(p.x + (anim ? anim.offset[0] * tw : 0), p.y + (anim ? anim.offset[1] * tw : 0));
      const scale = (node.scale ?? 1) * (anim?.scale ?? 1);
      if (scale !== 1) painter.scale(scale, scale);
      const rotate = (node.rotate ?? 0) + (node.rotation?.[2] ?? 0) + (anim?.rotate[2] ?? 0);
      if (rotate !== 0) painter.rotate(rotate);
      const opacity = (node.opacity ?? 1) * (anim?.opacity ?? 1);
      if (opacity !== 1) painter.setAlpha(opacity);
      if (node.clip) {
        painter.scale(tw, tw);
        painter.clipPath(node.clip);
        painter.scale(1 / tw, 1 / tw);
      }
      const childCtx = scale !== 1 ? { ...dctx, groupScale: (dctx.groupScale ?? 1) * scale } : dctx;
      for (const item of node.items) paintDrawable(painter, item, childCtx);
      painter.restore();
      break;
    }
    case "draw-mesh":
      warnUnsupported2d("draw-mesh");
      break;
    case "draw-skinned-mesh":
      paintSkinnedMesh(painter, node, dctx);
      break;
    case "draw-sprite-layer":
      paintSpriteLayer(painter, node, dctx);
      break;
    case "draw-shape-layer":
      paintShapeLayer(painter, node, dctx);
      break;
    case "draw-text-layer":
      paintTextLayer(painter, node, dctx);
      break;
    case "draw-fx-layer": {
      const epochNow = dctx.time > 0 && typeof performance !== "undefined" ? performance.timeOrigin + dctx.time : 0;
      for (const child of expandFxLayer(node, epochNow, "2d", dctx.projector, dctx.fontFamily)) paintDrawable(painter, child, dctx);
      break;
    }
  }
}
var canvas2DLog = createLogger("almadar:ui:game-canvas");
function normalizeBackdrop(bg) {
  return typeof bg === "string" ? { url: bg, role: "decoration", category: "background" } : bg;
}
var EDIT_SELECTION_COLOR = "highlight";
var EDIT_HANDLE_SIZE_PX = 8;
var EDIT_SELECTION_CORNERS = [[0, 0], [1, 0], [0, 1], [1, 1]];
function selectionOverlayNodes(projector, item) {
  const r = spriteRect(projector, { position: item.pos, anchor: item.anchor, width: item.width, height: item.height });
  const tw = projector.tileWidth;
  const cellTopLeft = projector.anchorPoint(item.pos, "top-left");
  const offsetX = (r.x - cellTopLeft.x) / tw;
  const offsetY = (r.y - cellTopLeft.y) / tw;
  const width = r.w / tw;
  const height = r.h / tw;
  const handle = EDIT_HANDLE_SIZE_PX / tw;
  const ring = {
    type: "draw-shape",
    shape: "rect",
    position: item.pos,
    anchor: "top-left",
    offsetX,
    offsetY,
    width,
    height,
    stroke: EDIT_SELECTION_COLOR,
    strokeWidth: 2,
    fill: "none"
  };
  const handles = EDIT_SELECTION_CORNERS.map(([cx, cy]) => ({
    type: "draw-shape",
    shape: "rect",
    position: item.pos,
    anchor: "top-left",
    offsetX: offsetX + cx * width - handle / 2,
    offsetY: offsetY + cy * height - handle / 2,
    width: handle,
    height: handle,
    fill: EDIT_SELECTION_COLOR
  }));
  return [ring, ...handles];
}
function Canvas2D({
  className,
  isLoading = false,
  error = null,
  projection = "isometric",
  drawables,
  backgroundImage: backgroundImageRaw,
  tileClickEvent,
  unitClickEvent,
  tileHoverEvent,
  tileLeaveEvent,
  keyMap,
  keyUpMap,
  editable = false,
  selectedId = null,
  onSelect,
  onMove,
  selectEvent,
  moveEvent,
  camera = "pan-zoom",
  scale = 0.4,
  tileWidth,
  fit = false,
  showMinimap = true,
  followTarget,
  cameraPos,
  bgColor,
  children,
  description,
  ...rest
}) {
  const descId = React93.useId();
  const instanceId = useMemo(() => Math.random().toString(36).slice(2, 8), []);
  const childDrawablesRef = useRef([]);
  childDrawablesRef.current = [];
  const registerChildDrawable = useCallback((node) => {
    childDrawablesRef.current.push(node);
  }, []);
  const hasJsxChildren = React93.Children.count(children) > 0;
  function isDrawableLayer(node) {
    return node.type === "draw-sprite-layer" || node.type === "draw-shape-layer" || node.type === "draw-text-layer";
  }
  const layerSummaries = drawables?.map((d) => {
    if (!isDrawableLayer(d)) return { type: d.type };
    return { type: d.type, itemsLen: d.items.length, firstItem: d.items[0] };
  });
  canvas2DLog.debug("Canvas2D render", { instanceId, projection, scale, cameraMode: camera, cameraPos: cameraPos ? JSON.stringify(cameraPos) : void 0, drawablesCount: drawables?.length, layerSummaries: layerSummaries ? JSON.stringify(layerSummaries) : void 0 });
  const backgroundImage = normalizeBackdrop(backgroundImageRaw);
  const isFree = projection === "free";
  const squareGrid = projection === "flat" || isFree || projection === "side";
  const layout = projection === "side" ? "free" : projection;
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const { theme: canvasTheme } = useCanvasTheme(containerRef);
  const lerpRafRef = useRef(0);
  const [viewportSize, setViewportSize] = useState({ width: 800, height: 600 });
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    if (typeof ResizeObserver === "undefined") return;
    const observer2 = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        const w = Math.round(entry.contentRect.width) || 800;
        const h = Math.round(entry.contentRect.height) || 600;
        setViewportSize((prev) => {
          if (Math.abs(prev.width - w) < 2 && Math.abs(prev.height - h) < 2) return prev;
          return { width: w, height: h };
        });
      }
    });
    observer2.observe(el);
    return () => observer2.disconnect();
  }, []);
  const [atlasVersion, setAtlasVersion] = useState(0);
  const bumpAtlas = useCallback(() => setAtlasVersion((v) => v + 1), []);
  const detectedTileWidth = useMemo(() => {
    for (const n of drawables ?? []) {
      const refs = [];
      if (n.type === "draw-sprite") refs.push(n.asset);
      else if (n.type === "draw-sprite-layer") for (const it of n.items) refs.push(it.asset);
      for (const a of refs) {
        if (a && isAtlasAsset(a) && a.atlas) {
          const atlas = getAtlas(a.atlas, bumpAtlas);
          if (atlas) {
            if ("tileWidth" in atlas) return atlas.tileWidth;
            if ("subTextures" in atlas) {
              const first = Object.values(atlas.subTextures)[0];
              if (first && typeof first.width === "number") return first.width;
            }
          }
        }
      }
    }
    return void 0;
  }, [drawables, atlasVersion]);
  const nativeTileW = tileWidth ?? detectedTileWidth ?? TILE_WIDTH;
  const scaledTileWidth = nativeTileW;
  const scaledFloorHeight = nativeTileW / 2;
  const scaledDiamondTopY = nativeTileW * (DIAMOND_TOP_Y / TILE_WIDTH);
  const drawnItems = useMemo(() => collectDrawnItems(drawables ?? []), [drawables]);
  const scenePositions = useMemo(() => drawnItems.map((i) => i.pos), [drawnItems]);
  const hitIndex = useMemo(() => buildHitIndex(drawnItems), [drawnItems]);
  const gridExtent = useMemo(() => {
    if (scenePositions.length === 0) return { width: 0, height: 0 };
    let maxX = 0;
    let maxY = 0;
    for (const p of scenePositions) {
      if (p.x > maxX) maxX = p.x;
      if (p.y > maxY) maxY = p.y;
    }
    return { width: maxX + 1, height: maxY + 1 };
  }, [scenePositions]);
  const defaultGridFocus = useMemo(() => {
    if (isFree || projection === "side") return void 0;
    if (gridExtent.width < 2 || gridExtent.height < 2) return void 0;
    return { x: (gridExtent.width - 1) / 2, y: (gridExtent.height - 1) / 2 };
  }, [isFree, projection, gridExtent]);
  const baseOffsetX = useMemo(() => {
    if (isFree || projection === "flat" || projection === "side") return 0;
    return (gridExtent.height - 1) * (scaledTileWidth / 2);
  }, [isFree, projection, gridExtent.height, scaledTileWidth]);
  const effectiveZoom = useMemo(() => {
    if (isFree || projection === "side") return scale;
    if (!fit) {
      const z2 = TILE_WIDTH * scale * scale / nativeTileW;
      return Number.isFinite(z2) && z2 > 0 ? z2 : scale;
    }
    if (!viewportSize.width || gridExtent.width < 2 || gridExtent.height < 2) return scale;
    let boardW;
    let boardH;
    if (projection === "flat") {
      boardW = gridExtent.width * nativeTileW;
      boardH = gridExtent.height * nativeTileW;
    } else if (projection === "hex") {
      boardW = (gridExtent.width + 0.5) * nativeTileW;
      boardH = gridExtent.height * (nativeTileW / 2) * 0.75 + nativeTileW / 2;
    } else {
      boardW = (gridExtent.width + gridExtent.height) * (nativeTileW / 2);
      boardH = (gridExtent.width + gridExtent.height) * (nativeTileW / 4);
    }
    const z = Math.min(viewportSize.width * 0.85 / boardW, viewportSize.height * 0.85 / boardH);
    return Number.isFinite(z) && z > 0 ? z : scale;
  }, [isFree, projection, fit, viewportSize, gridExtent, nativeTileW, scale]);
  const projector = useMemo(
    () => create2DProjector({ tileWidth: nativeTileW, baseOffsetX, layout }),
    [nativeTileW, baseOffsetX, layout]
  );
  const unproject = useCallback((screenX, screenY) => {
    if (projection === "free" || projection === "side") return { x: Math.round(screenX), y: Math.round(screenY) };
    return screenToIso(screenX, screenY, nativeTileW, baseOffsetX, projection);
  }, [projection, nativeTileW, baseOffsetX]);
  const bgUrls = useMemo(() => backgroundImage?.url ? [backgroundImage.url] : [], [backgroundImage]);
  const { getImage, pendingCount: _imagePendingCount } = useImageCache(bgUrls);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    bindCanvasCapture(() => canvas.toDataURL("image/png"));
    bindLastDrawables(() => drawables ?? null);
    return () => {
      bindCanvasCapture(() => null);
      bindLastDrawables(() => null);
    };
  }, [drawables]);
  const enableCamera = camera === "pan-zoom";
  const {
    cameraRef,
    targetCameraRef,
    dragDistance,
    handleMouseLeave,
    handlePointerDown,
    handlePointerUp,
    handlePointerMove,
    panBy,
    zoomAtPoint,
    screenToWorld,
    lerpToTarget
  } = useCamera({ zoom: effectiveZoom });
  const miniMapTiles = useMemo(() => {
    if (!showMinimap) return [];
    const color = MINIMAP_TERRAIN_COLORS.default;
    return scenePositions.map((p) => ({ x: p.x, y: p.y, color }));
  }, [showMinimap, scenePositions]);
  const miniMapWidth = gridExtent.width || 10;
  const miniMapHeight = gridExtent.height || 10;
  const drawableIsAnimated = (node) => {
    if (node.type === "draw-shape") return isAnimatedShape(node);
    if (node.type === "draw-sprite") return isAnimatedSprite(node);
    if (node.type === "draw-group")
      return isAnimatedGroup(node) || Array.isArray(node.items) && node.items.some(drawableIsAnimated);
    if (node.type === "draw-shape-layer") return Array.isArray(node.items) && node.items.some(isAnimatedShape);
    if (node.type === "draw-sprite-layer") return Array.isArray(node.items) && node.items.some(isAnimatedSprite);
    if (node.type === "draw-fx-layer") return Array.isArray(node.items) && node.items.length > 0;
    return false;
  };
  const animRafRef = useRef(0);
  const drawTimeRef = useRef(() => void 0);
  const draw = useCallback((timeMs = 0) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const scheduleAnimation = (nodes) => {
      if (!nodes.some(drawableIsAnimated)) return;
      if (canvasTheme && !canvasTheme.motion.enabled) return;
      cancelAnimationFrame(animRafRef.current);
      animRafRef.current = requestAnimationFrame(() => drawTimeRef.current(performance.now()));
    };
    const dpr = window.devicePixelRatio || 1;
    canvas.width = viewportSize.width * dpr;
    canvas.height = viewportSize.height * dpr;
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, viewportSize.width, viewportSize.height);
    const themed = (nodes) => canvasTheme ? resolveDrawableColors(nodes, (c) => markColor(canvasTheme, c, canvas, "ink")) : [...nodes];
    ctx.fillStyle = canvasTheme ? bgColor !== void 0 ? markColor(canvasTheme, bgColor, canvas, "fill") : canvasTheme.ground : bgColor ?? BACKGROUND_FALLBACK_COLOR;
    ctx.fillRect(0, 0, viewportSize.width, viewportSize.height);
    if (backgroundImage?.url) {
      const bgImg = getImage(backgroundImage.url);
      const bgSrc = bgImg ? resolveAssetSource(bgImg, backgroundImage, bumpAtlas) : null;
      if (bgSrc?.rect) {
        const k = Math.max(viewportSize.width / bgSrc.rect.sw, viewportSize.height / bgSrc.rect.sh);
        const dw = bgSrc.rect.sw * k;
        const dh = bgSrc.rect.sh * k;
        blit(ctx, bgSrc, (viewportSize.width - dw) / 2, (viewportSize.height - dh) / 2, dw, dh);
      } else if (bgImg) {
        const cam2 = cameraRef.current;
        const patW = bgImg.naturalWidth;
        const patH = bgImg.naturalHeight;
        const startX = -(cam2.x % patW + patW) % patW;
        const startY = -(cam2.y % patH + patH) % patH;
        for (let y = startY - patH; y < viewportSize.height; y += patH) {
          for (let x = startX - patW; x < viewportSize.width; x += patW) {
            ctx.drawImage(bgImg, x, y);
          }
        }
      }
    }
    if (!drawables || drawables.length === 0) {
      const childDrawables = childDrawablesRef.current;
      if (childDrawables.length === 0) return;
      const cam0 = cameraRef.current;
      if (camera !== "follow" && dragDistance() === 0) {
        const focus = cameraPos ?? defaultGridFocus;
        if (focus) {
          const p = projector.anchorPoint(focus, "center");
          cam0.x = p.x - viewportSize.width / 2;
          cam0.y = p.y - viewportSize.height / 2;
        }
      }
      const painter0 = createWebPainter(ctx, bumpAtlas);
      painter0.save();
      painter0.translate(viewportSize.width / 2, viewportSize.height / 2);
      painter0.scale(cam0.zoom, cam0.zoom);
      painter0.translate(-viewportSize.width / 2 - cam0.x, -viewportSize.height / 2 - cam0.y);
      const dctx0 = { projector, time: timeMs, invalidate: bumpAtlas };
      for (const node of themed(childDrawables)) paintDrawable(painter0, node, dctx0);
      painter0.restore();
      scheduleAnimation(childDrawables);
      return;
    }
    const cam = cameraRef.current;
    if (camera !== "follow" && dragDistance() === 0) {
      const focus = cameraPos ?? defaultGridFocus;
      if (focus) {
        const p = projector.anchorPoint(focus, "center");
        cam.x = p.x - viewportSize.width / 2;
        cam.y = p.y - viewportSize.height / 2;
      }
    }
    const containerRect = containerRef.current?.getBoundingClientRect();
    const canvasRect = canvas.getBoundingClientRect();
    canvas2DLog.debug("Canvas2D draw", { instanceId, viewportSize, baseOffsetX, cam: { x: cam.x, y: cam.y, zoom: cam.zoom }, cameraPos: cameraPos ? JSON.stringify(cameraPos) : void 0, containerRect: containerRect ? { width: containerRect.width, height: containerRect.height } : null, canvasRect: canvasRect ? { width: canvasRect.width, height: canvasRect.height } : null });
    const painter = createWebPainter(ctx, bumpAtlas);
    painter.save();
    painter.translate(viewportSize.width / 2, viewportSize.height / 2);
    painter.scale(cam.zoom, cam.zoom);
    painter.translate(-viewportSize.width / 2 - cam.x, -viewportSize.height / 2 - cam.y);
    const dctx = { projector, time: timeMs, invalidate: bumpAtlas };
    let paintNodes = drawables;
    if (editable) {
      const drag = editDragRef.current;
      if (drag && drag.moved) {
        paintNodes = withPreviewPosition(paintNodes, drag.id, { x: drag.previewX, y: drag.previewY });
      }
      const selectedItem = selectedId != null ? drawnItems.find((it) => it.id === selectedId) : void 0;
      if (selectedItem) {
        const overlaySource = drag && drag.moved && drag.id === selectedId ? { ...selectedItem, pos: { x: drag.previewX, y: drag.previewY } } : selectedItem;
        paintNodes = [...paintNodes, ...selectionOverlayNodes(projector, overlaySource)];
      }
    }
    for (const node of themed(paintNodes)) paintDrawable(painter, node, dctx);
    painter.restore();
    scheduleAnimation(paintNodes);
  }, [viewportSize, backgroundImage, bgColor, drawables, projector, cameraRef, bumpAtlas, getImage, cameraPos, defaultGridFocus, camera, dragDistance, editable, selectedId, drawnItems, canvasTheme]);
  useEffect(() => {
    drawTimeRef.current = draw;
  }, [draw]);
  useEffect(() => () => cancelAnimationFrame(animRafRef.current), []);
  useEffect(() => {
    if (camera !== "follow" || !followTarget) return;
    const p = projector.anchorPoint(followTarget, "center");
    targetCameraRef.current = {
      x: p.x - viewportSize.width / 2,
      y: p.y - viewportSize.height / 2
    };
  }, [camera, followTarget, projector, viewportSize, targetCameraRef]);
  useEffect(() => {
    draw();
  }, [draw]);
  useEffect(() => {
    draw();
  }, [_imagePendingCount, draw]);
  const userZoomedRef = useRef(false);
  useEffect(() => {
    if (userZoomedRef.current) return;
    if (cameraRef.current.zoom === effectiveZoom) return;
    cameraRef.current.zoom = effectiveZoom;
    draw();
  }, [effectiveZoom, cameraRef, draw]);
  useEffect(() => {
    draw();
  }, [atlasVersion, draw]);
  useEffect(() => {
    if (camera !== "follow" || !followTarget) return;
    let running = true;
    const tick = () => {
      if (!running) return;
      const stillLerping = lerpToTarget();
      draw();
      if (stillLerping) lerpRafRef.current = requestAnimationFrame(tick);
    };
    lerpRafRef.current = requestAnimationFrame(tick);
    return () => {
      running = false;
      cancelAnimationFrame(lerpRafRef.current);
    };
  }, [camera, followTarget, lerpToTarget, draw]);
  const singlePointerActiveRef = useRef(false);
  const editDragRef = useRef(null);
  const pointerToScene = useCallback((clientX, clientY) => {
    const canvas = canvasRef.current;
    if (!canvas) return { x: 0, y: 0 };
    const world = screenToWorld(clientX, clientY, canvas, viewportSize);
    const adjustedX = world.x - scaledTileWidth / 2;
    const adjustedY = squareGrid ? world.y - scaledTileWidth / 2 : world.y - scaledDiamondTopY - scaledFloorHeight / 2;
    return unproject(adjustedX, adjustedY);
  }, [screenToWorld, viewportSize, scaledTileWidth, squareGrid, scaledDiamondTopY, scaledFloorHeight, unproject]);
  const handleCanvasPointerDown = useCallback((e) => {
    singlePointerActiveRef.current = true;
    if (editable) {
      if (!canvasRef.current) return;
      const world = screenToWorld(e.clientX, e.clientY, canvasRef.current, viewportSize);
      const hitId = hitTestSprites(drawnItems, projector, world);
      if (hitId === void 0) return;
      const item = [...drawnItems].reverse().find((it) => it.id === hitId);
      if (!item) return;
      editDragRef.current = {
        id: hitId,
        pointerId: e.pointerId,
        startClientX: e.clientX,
        startClientY: e.clientY,
        startSceneX: item.pos.x,
        startSceneY: item.pos.y,
        moved: false,
        previewX: item.pos.x,
        previewY: item.pos.y
      };
      return;
    }
    if (enableCamera) handlePointerDown(e);
  }, [editable, screenToWorld, viewportSize, drawnItems, projector, enableCamera, handlePointerDown]);
  const handleCanvasPointerMove = useCallback((e) => {
    if (editable) {
      const drag = editDragRef.current;
      if (!drag || drag.pointerId !== e.pointerId) return;
      const dxPx = e.clientX - drag.startClientX;
      const dyPx = e.clientY - drag.startClientY;
      if (!drag.moved && Math.abs(dxPx) + Math.abs(dyPx) <= 5) return;
      drag.moved = true;
      const nowScene = pointerToScene(e.clientX, e.clientY);
      const startScene = pointerToScene(drag.startClientX, drag.startClientY);
      drag.previewX = drag.startSceneX + (nowScene.x - startScene.x);
      drag.previewY = drag.startSceneY + (nowScene.y - startScene.y);
      draw();
      return;
    }
    if (enableCamera) handlePointerMove(e, () => draw());
  }, [editable, pointerToScene, draw, enableCamera, handlePointerMove]);
  const handleCanvasHover = useCallback((e) => {
    if (singlePointerActiveRef.current) return;
    if (!tileHoverEvent || !canvasRef.current) return;
    const isoPos = pointerToScene(e.clientX, e.clientY);
    eventBus.emit(`UI:${tileHoverEvent}`, { x: isoPos.x, y: isoPos.y });
  }, [pointerToScene, tileHoverEvent, eventBus]);
  const handleCanvasPointerUp = useCallback((e) => {
    if (editable) {
      singlePointerActiveRef.current = false;
      const drag = editDragRef.current;
      if (drag && drag.pointerId === e.pointerId) {
        editDragRef.current = null;
        if (drag.moved) {
          onMove?.(drag.id, drag.previewX, drag.previewY);
          if (moveEvent) eventBus.emit(`UI:${moveEvent}`, { id: drag.id, x: drag.previewX, y: drag.previewY });
          draw();
          return;
        }
        const next = selectedId === drag.id ? null : drag.id;
        onSelect?.(next);
        if (selectEvent) eventBus.emit(`UI:${selectEvent}`, { id: next });
        return;
      }
      onSelect?.(null);
      if (selectEvent) eventBus.emit(`UI:${selectEvent}`, { id: null });
      return;
    }
    singlePointerActiveRef.current = false;
    if (enableCamera) handlePointerUp();
    if (dragDistance() > 5) return;
    if (!canvasRef.current || !tileClickEvent && !unitClickEvent) return;
    const world = screenToWorld(e.clientX, e.clientY, canvasRef.current, viewportSize);
    const spriteHit = unitClickEvent ? hitTestSprites(drawnItems, projector, world) : void 0;
    if (spriteHit !== void 0 && unitClickEvent) {
      eventBus.emit(`UI:${unitClickEvent}`, { unitId: spriteHit });
      return;
    }
    const isoPos = pointerToScene(e.clientX, e.clientY);
    const hitId = hitIndex.get(`${isoPos.x},${isoPos.y}`);
    if (hitId !== void 0 && unitClickEvent) {
      eventBus.emit(`UI:${unitClickEvent}`, { unitId: hitId });
    } else if (tileClickEvent) {
      eventBus.emit(`UI:${tileClickEvent}`, { x: isoPos.x, y: isoPos.y });
    }
  }, [editable, selectedId, onMove, moveEvent, onSelect, selectEvent, eventBus, draw, enableCamera, handlePointerUp, dragDistance, screenToWorld, viewportSize, drawnItems, projector, tileClickEvent, unitClickEvent, hitIndex, pointerToScene]);
  const handleCanvasPointerLeave = useCallback(() => {
    handleMouseLeave();
    if (tileLeaveEvent) eventBus.emit(`UI:${tileLeaveEvent}`, {});
  }, [handleMouseLeave, tileLeaveEvent, eventBus]);
  const applyZoom = useCallback((factor, centerX, centerY) => {
    if (!enableCamera) return;
    userZoomedRef.current = true;
    zoomAtPoint(factor, centerX, centerY, viewportSize, () => draw());
  }, [enableCamera, zoomAtPoint, viewportSize, draw]);
  const applyPanDelta = useCallback((dx, dy) => {
    if (enableCamera) panBy(dx, dy, () => draw());
  }, [enableCamera, panBy, draw]);
  const cancelSinglePointer = useCallback(() => {
    singlePointerActiveRef.current = false;
    if (enableCamera) handlePointerUp();
  }, [enableCamera, handlePointerUp]);
  const gestureHandlers = useCanvasGestures({
    canvasRef,
    enabled: enableCamera || !!tileHoverEvent || !!tileClickEvent || !!unitClickEvent || editable,
    onPointerDown: handleCanvasPointerDown,
    onPointerMove: handleCanvasPointerMove,
    onPointerUp: handleCanvasPointerUp,
    onZoom: applyZoom,
    onPanDelta: applyPanDelta,
    onMultiTouchStart: cancelSinglePointer
  });
  const canvasWheelHandler = gestureHandlers.onWheel;
  useEffect(() => {
    const el = canvasRef.current;
    if (!el) return;
    el.addEventListener("wheel", canvasWheelHandler, { passive: false });
    return () => el.removeEventListener("wheel", canvasWheelHandler);
  }, [canvasWheelHandler]);
  useEffect(() => {
    if (!keyMap && !keyUpMap) return;
    const onDown = (e) => {
      const ev = resolveKeyMapEvent(keyMap, e);
      if (ev) {
        eventBus.emit(`UI:${ev}`, {});
        e.preventDefault();
      }
    };
    const onUp = (e) => {
      const ev = resolveKeyMapEvent(keyUpMap, e);
      if (ev) eventBus.emit(`UI:${ev}`, {});
    };
    window.addEventListener("keydown", onDown);
    window.addEventListener("keyup", onUp);
    return () => {
      window.removeEventListener("keydown", onDown);
      window.removeEventListener("keyup", onUp);
    };
  }, [keyMap, keyUpMap, eventBus]);
  useEffect(() => {
    if (!keyMap && !keyUpMap) return;
    canvasRef.current?.focus();
  }, [keyMap, keyUpMap]);
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center w-full h-full bg-[var(--color-card)] rounded-container", className), children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
      /* @__PURE__ */ jsx(Icon, { name: "alert-circle", size: "xl" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-error", children: error.message })
    ] }) });
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center w-full h-full bg-[var(--color-card)] rounded-container", className), children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
      /* @__PURE__ */ jsx(Icon, { name: "loader", size: "xl", className: "animate-spin" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-muted-foreground", children: t("canvas.loadingMessage") })
    ] }) });
  }
  if ((!drawables || drawables.length === 0) && !hasJsxChildren) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: cn("relative w-full overflow-hidden rounded-container", className),
        style: { height: viewportSize.height },
        "data-testid": "canvas-2d-empty",
        children: /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center h-full bg-[var(--color-card)] rounded-container", children: /* @__PURE__ */ jsxs(Stack, { direction: "vertical", gap: "md", align: "center", children: [
          /* @__PURE__ */ jsx(Icon, { name: "map", size: "xl" }),
          /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-muted-foreground", children: t("canvas.emptyMessage") })
        ] }) })
      }
    );
  }
  return /* @__PURE__ */ jsx(DrawableRegistryContext.Provider, { value: registerChildDrawable, children: /* @__PURE__ */ jsxs(
    Box,
    {
      ref: containerRef,
      className: cn("relative overflow-hidden w-full h-full min-w-0 max-w-full", className),
      children: [
        /* @__PURE__ */ jsx(
          "canvas",
          {
            ref: canvasRef,
            "data-testid": "canvas-2d",
            onPointerDown: gestureHandlers.onPointerDown,
            onPointerMove: (e) => {
              gestureHandlers.onPointerMove(e);
              handleCanvasHover(e);
            },
            onPointerUp: gestureHandlers.onPointerUp,
            onPointerCancel: gestureHandlers.onPointerCancel,
            onPointerLeave: handleCanvasPointerLeave,
            onContextMenu: (e) => e.preventDefault(),
            className: "block max-w-full cursor-pointer touch-none",
            tabIndex: isFree || keyMap || keyUpMap ? 0 : void 0,
            style: {
              width: viewportSize.width,
              height: viewportSize.height
            },
            role: "img",
            "aria-label": t("aria.canvasScene"),
            "aria-describedby": description ? descId : void 0,
            ...domPassthrough(rest)
          }
        ),
        description && /* @__PURE__ */ jsx(Box, { id: descId, className: "sr-only", children: description }),
        process.env.NODE_ENV !== "production" && (tileClickEvent || unitClickEvent) && /* @__PURE__ */ jsxs(Box, { "data-game-actions": "", className: "sr-only", "aria-hidden": "true", children: [
          tileClickEvent && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              "data-event": tileClickEvent,
              "data-x": "0",
              "data-y": "0",
              onClick: () => eventBus.emit(`UI:${tileClickEvent}`, { x: 0, y: 0 }),
              children: tileClickEvent
            }
          ),
          unitClickEvent && hitIndex.size > 0 && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              "data-event": unitClickEvent,
              "data-unit-id": [...hitIndex.values()][0],
              onClick: () => eventBus.emit(`UI:${unitClickEvent}`, { unitId: [...hitIndex.values()][0] }),
              children: unitClickEvent
            }
          )
        ] }),
        showMinimap && /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-2 right-2 pointer-events-none", style: { zIndex: 10 }, children: /* @__PURE__ */ jsx(
          MiniMap,
          {
            tiles: miniMapTiles,
            units: [],
            width: 150,
            height: 100,
            mapWidth: miniMapWidth,
            mapHeight: miniMapHeight
          }
        ) }),
        hasJsxChildren && /* @__PURE__ */ jsx("div", { "aria-hidden": "true", style: { position: "absolute", width: 0, height: 0, overflow: "hidden" }, children })
      ]
    }
  ) });
}
Canvas2D.displayName = "Canvas2D";
var Canvas3DHost = lazy(
  () => import('@almadar/ui/components/molecules/game/three').then((m) => ({ default: m.Canvas3DHost }))
);
var canvasLog = createLogger("almadar:ui:game-canvas");
function to2DCamera(mode, controls) {
  if (mode === "follow") return "follow";
  if (controls === false) return "fixed";
  if (mode === "isometric" || mode === "top-down") return "fixed";
  return "pan-zoom";
}
function to3DCameraMode(mode) {
  return mode ?? "isometric";
}
function Canvas({
  mode = "2d",
  drawables,
  camera,
  projection,
  className,
  isLoading,
  unitScale,
  showMinimap,
  fit,
  tileWidth,
  backgroundImage,
  backgroundColor,
  worldWidth,
  worldHeight,
  pixelsPerUnit,
  showGrid,
  shadows,
  showCoordinates,
  showTileInfo,
  fogOfWar,
  lighting,
  post,
  tileClickEvent,
  unitClickEvent,
  tileHoverEvent,
  tileLeaveEvent,
  featureClickEvent,
  keyMap,
  keyUpMap,
  editable,
  selectedId,
  onSelect,
  onMove,
  selectEvent,
  moveEvent,
  children,
  ...rest
}) {
  canvasLog.debug("Canvas render", { mode, drawablesCount: drawables?.length, projection, camera: camera ? JSON.stringify(camera) : void 0 });
  const zoom = camera?.zoom;
  const childDrawablesRef = useRef([]);
  if (mode === "3d") childDrawablesRef.current = [];
  const registerChildDrawable = useCallback((node) => {
    childDrawablesRef.current.push(node);
  }, []);
  const [childDrawables, setChildDrawables] = useState([]);
  useEffect(() => {
    if (mode !== "3d") return;
    const next = childDrawablesRef.current;
    canvasLog.debug("children:adopt", { registered: next.length, adopted: childDrawables.length });
    if (next.length === 0 && React93.Children.count(children) > 0) return;
    setChildDrawables(
      (prev) => prev.length === next.length && JSON.stringify(prev) === JSON.stringify(next) ? prev : [...next]
    );
  });
  if (mode === "3d") {
    const props3d = {
      className,
      drawables: [...drawables ?? [], ...childDrawables],
      isLoading,
      cameraMode: to3DCameraMode(camera?.mode),
      ...camera?.controls === false ? { controlsEnabled: false } : {},
      ...zoom !== void 0 ? { zoom } : {},
      ...camera?.fov !== void 0 ? { fov: camera.fov } : {},
      ...camera?.azimuth !== void 0 ? { azimuth: camera.azimuth } : {},
      ...camera?.elevation !== void 0 ? { elevation: camera.elevation } : {},
      ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
      unitScale,
      backgroundColor,
      worldWidth,
      worldHeight,
      pixelsPerUnit,
      showGrid,
      shadows,
      showCoordinates,
      showTileInfo,
      fogOfWar,
      lighting,
      post,
      tileClickEvent,
      unitClickEvent,
      tileHoverEvent,
      tileLeaveEvent,
      featureClickEvent,
      keyMap,
      keyUpMap
    };
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(Canvas3DHost, { ...props3d }) }),
      React93.Children.count(children) > 0 && /* @__PURE__ */ jsx(DrawableRegistryContext.Provider, { value: registerChildDrawable, children: /* @__PURE__ */ jsx("div", { "aria-hidden": "true", style: { position: "absolute", width: 0, height: 0, overflow: "hidden" }, children }) })
    ] });
  }
  return /* @__PURE__ */ jsx(
    Canvas2D,
    {
      ...domPassthrough(rest),
      className,
      drawables,
      isLoading,
      projection,
      camera: to2DCamera(camera?.mode, camera?.controls),
      ...zoom !== void 0 ? { scale: zoom } : {},
      ...fit !== void 0 ? { fit } : {},
      ...tileWidth !== void 0 ? { tileWidth } : {},
      ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
      ...camera?.pos !== void 0 ? { cameraPos: camera.pos } : {},
      showMinimap,
      backgroundImage,
      ...backgroundColor !== void 0 ? { bgColor: backgroundColor } : {},
      tileClickEvent,
      unitClickEvent,
      tileHoverEvent,
      tileLeaveEvent,
      keyMap,
      keyUpMap,
      editable,
      selectedId,
      onSelect,
      onMove,
      selectEvent,
      moveEvent,
      ...children !== void 0 ? { children } : {}
    }
  );
}
Canvas.displayName = "Canvas";
function unitAtlasUrl(unit) {
  return unit.spriteSheet?.url ?? null;
}
function resolveSheetUrl(atlasUrl, relativeSheetPath) {
  try {
    return new URL(relativeSheetPath, atlasUrl).toString();
  } catch {
    const base = atlasUrl.slice(0, atlasUrl.lastIndexOf("/") + 1);
    return `${base}${relativeSheetPath.replace(/^\.\//, "")}`;
  }
}
function useUnitSpriteAtlas(units) {
  const atlasCacheRef = useRef(/* @__PURE__ */ new Map());
  const loadingRef = useRef(/* @__PURE__ */ new Set());
  const [pendingCount, setPendingCount] = useState(0);
  const [, forceTick] = useState(0);
  const atlasUrls = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const unit of units) {
      const url = unitAtlasUrl(unit);
      if (url) set.add(url);
    }
    return [...set];
  }, [units]);
  useEffect(() => {
    const cache = atlasCacheRef.current;
    const loading = loadingRef.current;
    const toLoad = atlasUrls.filter((url) => !cache.has(url) && !loading.has(url));
    if (toLoad.length === 0) return;
    let cancelled = false;
    setPendingCount((prev) => prev + toLoad.length);
    for (const url of toLoad) {
      loading.add(url);
      fetch(url).then((res) => res.ok ? res.json() : Promise.reject(new Error(String(res.status)))).then((atlas) => {
        if (cancelled) return;
        cache.set(url, atlas);
      }).catch(() => {
      }).finally(() => {
        if (cancelled) return;
        loading.delete(url);
        setPendingCount((prev) => Math.max(0, prev - 1));
        forceTick((n) => n + 1);
      });
    }
    return () => {
      cancelled = true;
    };
  }, [atlasUrls]);
  const sheetUrls = useMemo(() => {
    const urls = /* @__PURE__ */ new Set();
    for (const unit of units) {
      const atlasUrl = unitAtlasUrl(unit);
      if (!atlasUrl) continue;
      const atlas = atlasCacheRef.current.get(atlasUrl);
      if (!atlas) continue;
      for (const rel of Object.values(atlas.sheets)) {
        if (rel) urls.add(resolveSheetUrl(atlasUrl, rel));
      }
    }
    return [...urls];
  }, [units, pendingCount]);
  const resolveUnitFrame = useCallback((unitId) => {
    const unit = units.find((u) => u.id === unitId);
    if (!unit) return null;
    const atlasUrl = unitAtlasUrl(unit);
    if (!atlasUrl) return null;
    const atlas = atlasCacheRef.current.get(atlasUrl);
    if (!atlas) return null;
    const animation = unit.animation ?? "idle";
    const frame = unit.frame ?? 0;
    const def = atlas.animations[animation] ?? atlas.animations.idle;
    if (!def) return null;
    const { sheetDir, flipX } = resolveSheetDirection("se");
    const rel = atlas.sheets[sheetDir] ?? atlas.sheets.se ?? atlas.sheets.sw;
    if (!rel) return null;
    const sheetUrl = resolveSheetUrl(atlasUrl, rel);
    const rect = frameRect(frame, def.row, atlas.columns, atlas.frameWidth, atlas.frameHeight);
    return {
      sheetUrl,
      sx: rect.sx,
      sy: rect.sy,
      sw: rect.sw,
      sh: rect.sh,
      flipX,
      applyBreathing: animation === "idle"
    };
  }, [units]);
  return { sheetUrls, resolveUnitFrame, pendingCount };
}
function GameAudioToggle({
  size: size2 = "sm",
  className,
  onAsset,
  offAsset,
  toggleEvent,
  ...rest
}) {
  const ctx = useGameAudioContextOptional();
  const [localMuted, setLocalMuted] = useState(false);
  const muted = ctx ? ctx.muted : localMuted;
  const setMuted = ctx ? ctx.setMuted : setLocalMuted;
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const stateLabel = muted ? t("gameAudio.muted") : t("gameAudio.soundOn");
  const handleToggle = useCallback(() => {
    const next = !muted;
    setMuted(next);
    if (toggleEvent) eventBus.emit(`UI:${toggleEvent}`, { muted: next });
  }, [muted, setMuted, toggleEvent, eventBus]);
  const activeAsset = muted ? offAsset : onAsset;
  return /* @__PURE__ */ jsx(
    Button,
    {
      ...domPassthrough(rest),
      variant: "ghost",
      size: size2,
      onClick: handleToggle,
      className: cn("text-lg leading-none px-2", className),
      "aria-pressed": muted,
      "aria-label": rest["aria-label"] ?? stateLabel,
      children: activeAsset ? /* @__PURE__ */ jsx(GameIcon, { assetUrl: activeAsset, icon: "image", size: 20, alt: stateLabel, className: "w-5 h-5 object-contain" }) : muted ? "\u{1F507}" : "\u{1F50A}"
    }
  );
}
GameAudioToggle.displayName = "GameAudioToggle";
function pickPath(entry) {
  if (Array.isArray(entry.path)) {
    return entry.path[Math.floor(Math.random() * entry.path.length)];
  }
  return entry.path;
}
function useGameAudio({
  manifest,
  baseUrl = "",
  initialMuted = false,
  initialVolume = 1
}) {
  const [muted, setMutedState] = useState(initialMuted);
  const [masterVolume, setMasterVolumeState] = useState(initialVolume);
  const mutedRef = useRef(muted);
  const volumeRef = useRef(masterVolume);
  const manifestRef = useRef(manifest);
  mutedRef.current = muted;
  volumeRef.current = masterVolume;
  manifestRef.current = manifest;
  const poolsRef = useRef(/* @__PURE__ */ new Map());
  const getOrCreateElement = useCallback((key) => {
    const entry = manifestRef.current[key];
    if (!entry) return null;
    let pool = poolsRef.current.get(key);
    if (!pool) {
      pool = [];
      poolsRef.current.set(key, pool);
    }
    const maxSize = entry.poolSize ?? 1;
    for (const audio of pool) {
      if (audio.paused && (audio.ended || audio.currentTime === 0)) {
        return audio;
      }
    }
    if (pool.length < maxSize) {
      const src = baseUrl + pickPath(entry);
      const audio = new Audio(src);
      audio.loop = entry.loop ?? false;
      pool.push(audio);
      return audio;
    }
    if (!entry.loop) {
      let oldest = pool[0];
      for (const audio of pool) {
        if (audio.currentTime > oldest.currentTime) {
          oldest = audio;
        }
      }
      oldest.pause();
      oldest.currentTime = 0;
      return oldest;
    }
    return null;
  }, [baseUrl]);
  const play = useCallback((key) => {
    if (mutedRef.current) return;
    const entry = manifestRef.current[key];
    if (!entry) return;
    const audio = getOrCreateElement(key);
    if (!audio) return;
    audio.volume = Math.min(1, (entry.volume ?? 1) * volumeRef.current);
    if (!entry.loop) {
      audio.currentTime = 0;
    }
    const promise = audio.play();
    if (promise) {
      promise.catch(() => {
      });
    }
  }, [getOrCreateElement]);
  const stop = useCallback((key) => {
    const pool = poolsRef.current.get(key);
    if (!pool) return;
    for (const audio of pool) {
      audio.pause();
      audio.currentTime = 0;
    }
  }, []);
  const currentMusicKeyRef = useRef(null);
  const currentMusicElRef = useRef(null);
  const musicFadeRef = useRef(null);
  const pendingMusicKeyRef = useRef(null);
  const clearMusicFade = useCallback(() => {
    if (musicFadeRef.current) {
      clearInterval(musicFadeRef.current);
      musicFadeRef.current = null;
    }
  }, []);
  const playMusic = useCallback((key) => {
    if (key === currentMusicKeyRef.current) return;
    pendingMusicKeyRef.current = key;
    const entry = manifestRef.current[key];
    if (!entry) return;
    const fadeDurationMs = entry.crossfadeDurationMs ?? 1500;
    const stepMs = 50;
    const totalSteps = Math.max(1, fadeDurationMs / stepMs);
    const targetVolume = Math.min(1, (entry.volume ?? 1) * volumeRef.current);
    clearMusicFade();
    const src = baseUrl + (Array.isArray(entry.path) ? entry.path[0] : entry.path);
    const incoming = new Audio(src);
    incoming.loop = true;
    incoming.volume = 0;
    const outgoing = currentMusicElRef.current;
    const outgoingStartVol = outgoing?.volume ?? 0;
    currentMusicKeyRef.current = key;
    currentMusicElRef.current = incoming;
    if (!mutedRef.current) {
      incoming.play().catch(() => {
        currentMusicKeyRef.current = null;
        currentMusicElRef.current = outgoing;
      });
    }
    let step = 0;
    musicFadeRef.current = setInterval(() => {
      step++;
      const progress = Math.min(step / totalSteps, 1);
      incoming.volume = Math.min(1, targetVolume * progress);
      if (outgoing) {
        outgoing.volume = Math.max(0, outgoingStartVol * (1 - progress));
      }
      if (progress >= 1) {
        clearMusicFade();
        if (outgoing) {
          outgoing.pause();
          outgoing.src = "";
        }
      }
    }, stepMs);
  }, [baseUrl, clearMusicFade]);
  const stopMusic = useCallback((fadeDurationMs = 1e3) => {
    const outgoing = currentMusicElRef.current;
    if (!outgoing) return;
    currentMusicKeyRef.current = null;
    currentMusicElRef.current = null;
    pendingMusicKeyRef.current = null;
    clearMusicFade();
    const startVolume = outgoing.volume;
    const stepMs = 50;
    const totalSteps = Math.max(1, fadeDurationMs / stepMs);
    let step = 0;
    musicFadeRef.current = setInterval(() => {
      step++;
      const progress = step / totalSteps;
      outgoing.volume = Math.max(0, startVolume * (1 - progress));
      if (progress >= 1) {
        clearMusicFade();
        outgoing.pause();
        outgoing.src = "";
      }
    }, stepMs);
  }, [clearMusicFade]);
  const stopAll = useCallback(() => {
    for (const pool of poolsRef.current.values()) {
      for (const audio of pool) {
        audio.pause();
        audio.currentTime = 0;
      }
    }
    stopMusic(0);
  }, [stopMusic]);
  const setMuted = useCallback((value) => {
    setMutedState(value);
    if (value) {
      for (const [key, pool] of poolsRef.current.entries()) {
        if (manifestRef.current[key]?.loop) {
          for (const audio of pool) {
            if (!audio.paused) audio.pause();
          }
        }
      }
      currentMusicElRef.current?.pause();
    } else {
      for (const [key, pool] of poolsRef.current.entries()) {
        const entry = manifestRef.current[key];
        if (entry?.loop && entry?.autostart) {
          for (const audio of pool) {
            if (audio.paused) audio.play().catch(() => {
            });
          }
        }
      }
      const musicEl = currentMusicElRef.current;
      if (musicEl) {
        musicEl.play().catch(() => {
        });
      }
    }
  }, []);
  const setMasterVolume = useCallback((volume) => {
    const clamped = Math.max(0, Math.min(1, volume));
    setMasterVolumeState(clamped);
    for (const [key, pool] of poolsRef.current.entries()) {
      const entryVol = manifestRef.current[key]?.volume ?? 1;
      for (const audio of pool) {
        audio.volume = Math.min(1, entryVol * clamped);
      }
    }
    if (!musicFadeRef.current && currentMusicElRef.current) {
      const key = currentMusicKeyRef.current;
      const entryVol = key ? manifestRef.current[key]?.volume ?? 1 : 1;
      currentMusicElRef.current.volume = Math.min(1, entryVol * clamped);
    }
  }, []);
  const unlockedRef = useRef(false);
  useEffect(() => {
    const autoKeys = Object.keys(manifest).filter((k) => manifest[k].autostart);
    const hasPendingMusic = () => pendingMusicKeyRef.current !== null;
    const hasAutoStart = autoKeys.length > 0;
    if (!hasAutoStart && !hasPendingMusic()) return;
    const unlock = () => {
      if (unlockedRef.current) return;
      unlockedRef.current = true;
      if (!mutedRef.current) {
        for (const key of autoKeys) {
          play(key);
        }
        const pending = pendingMusicKeyRef.current;
        if (pending && pending !== currentMusicKeyRef.current) {
          playMusic(pending);
        }
      }
    };
    document.addEventListener("click", unlock, { once: true });
    document.addEventListener("keydown", unlock, { once: true });
    document.addEventListener("touchstart", unlock, { once: true });
    return () => {
      document.removeEventListener("click", unlock);
      document.removeEventListener("keydown", unlock);
      document.removeEventListener("touchstart", unlock);
    };
  }, [manifest, play, playMusic]);
  useEffect(() => {
    return () => {
      clearMusicFade();
      for (const pool of poolsRef.current.values()) {
        for (const audio of pool) {
          audio.pause();
          audio.src = "";
        }
      }
      poolsRef.current.clear();
      if (currentMusicElRef.current) {
        currentMusicElRef.current.pause();
        currentMusicElRef.current.src = "";
        currentMusicElRef.current = null;
      }
    };
  }, [clearMusicFade]);
  return {
    play,
    stop,
    stopAll,
    playMusic,
    stopMusic,
    muted,
    setMuted,
    masterVolume,
    setMasterVolume
  };
}
useGameAudio.displayName = "useGameAudio";

// components/game/atoms/GameAudioCue.tsx
function GameAudioCue({
  cue,
  cueSeq,
  music,
  muted,
  volume,
  manifest,
  baseUrl
}) {
  const { play, playMusic, stopMusic, setMuted, setMasterVolume } = useGameAudio({
    manifest,
    baseUrl,
    initialMuted: muted,
    initialVolume: volume
  });
  const prevCueSeqRef = useRef(cueSeq);
  useEffect(() => {
    if (cue && cueSeq !== void 0 && cueSeq !== prevCueSeqRef.current) {
      play(cue);
    }
    prevCueSeqRef.current = cueSeq;
  }, [cue, cueSeq, play]);
  useEffect(() => {
    if (music) playMusic(music);
    else stopMusic();
  }, [music, playMusic, stopMusic]);
  useEffect(() => {
    if (muted !== void 0) setMuted(muted);
  }, [muted, setMuted]);
  useEffect(() => {
    if (volume !== void 0) setMasterVolume(volume);
  }, [volume, setMasterVolume]);
  return null;
}
GameAudioCue.displayName = "GameAudioCue";
var DEFAULT_ASSET_URL = {
  url: "https://almadar-kflow-assets.web.app/shared/ui-topdown-dungeon-board/default/features/chest/chest.png",
  role: "ui",
  category: "state"
};
var DEFAULT_STATE_STYLES = {
  idle: { icon: "\u23F8", bgClass: "bg-muted" },
  active: { icon: "\u25B6", bgClass: "bg-success" },
  sleeping: { icon: "\u{1F4A4}", bgClass: "bg-muted" },
  moving: { icon: "\u{1F6B6}", bgClass: "bg-info" },
  eating: { icon: "\u{1F37D}\uFE0F", bgClass: "bg-success" },
  waiting: { icon: "\u23F3", bgClass: "bg-warning" },
  happy: { icon: "\u{1F60A}", bgClass: "bg-success" },
  scared: { icon: "\u{1F628}", bgClass: "bg-error" },
  done: { icon: "\u2713", bgClass: "bg-success" },
  error: { icon: "\u2717", bgClass: "bg-error" },
  ready: { icon: "\u2713", bgClass: "bg-success" },
  cooldown: { icon: "\u{1F504}", bgClass: "bg-warning" }
};
var DEFAULT_STYLE = { icon: "?", bgClass: "bg-muted" };
var STATIC_STATES = /* @__PURE__ */ new Set(["idle", "done"]);
function isKnownState(s) {
  return s in DEFAULT_STATE_STYLES;
}
var SIZE_CLASSES = {
  sm: "text-xs px-1.5 py-0.5",
  md: "text-sm px-2 py-1",
  lg: "text-base px-3 py-1.5"
};
function StateIndicator({
  assetUrl = DEFAULT_ASSET_URL,
  state = "idle",
  label,
  size: size2 = "md",
  animated = true,
  stateStyles,
  className
}) {
  const mergedStyles = stateStyles ? { ...DEFAULT_STATE_STYLES, ...stateStyles } : DEFAULT_STATE_STYLES;
  const knownState = isKnownState(state) ? state : null;
  const config = knownState !== null ? mergedStyles[knownState] ?? DEFAULT_STYLE : DEFAULT_STYLE;
  const displayLabel = label ?? state;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      display: "inline-flex",
      className: cn(
        "items-center gap-1 rounded-full text-foreground font-medium",
        config.bgClass,
        SIZE_CLASSES[size2],
        animated && (knownState === null || !STATIC_STATES.has(knownState)) && "animate-pulse",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Box, { as: "span", children: assetUrl ? /* @__PURE__ */ jsx(GameIcon, { assetUrl, icon: "image", size: 16, alt: displayLabel, className: "flex-shrink-0" }) : typeof config.icon === "string" ? /^[a-zA-Z0-9-]+$/.test(config.icon) ? /* @__PURE__ */ jsx(Icon, { name: config.icon }) : config.icon : /* @__PURE__ */ jsx(Icon, { icon: config.icon }) }),
        /* @__PURE__ */ jsx(Box, { as: "span", children: displayLabel })
      ]
    }
  );
}
StateIndicator.displayName = "StateIndicator";
var SIZE_CONFIG = {
  sm: { nodeSize: "min-w-12 h-8", fontSize: "text-xs", gap: "gap-2" },
  md: { nodeSize: "min-w-16 h-10", fontSize: "text-sm", gap: "gap-4" },
  lg: { nodeSize: "min-w-20 h-12", fontSize: "text-base", gap: "gap-6" }
};
function LinearView({
  trait,
  size: size2 = "md",
  className,
  passthrough
}) {
  const currentIdx = trait.states.indexOf(trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", ...passthrough, children: [
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: trait.description }),
    /* @__PURE__ */ jsx(HStack, { className: "flex-wrap items-center", gap: "xs", children: trait.states.map((state, i) => {
      const isDone = i < currentIdx;
      const isCurrent = i === currentIdx;
      return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
        i > 0 && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            className: cn(
              "text-lg",
              isDone || isCurrent ? "text-primary" : "text-muted-foreground"
            ),
            children: "\u2192"
          }
        ),
        /* @__PURE__ */ jsxs(
          Box,
          {
            display: "inline-flex",
            "aria-current": isCurrent ? "step" : void 0,
            className: cn(
              "items-center justify-center rounded-pill px-3 py-1 border-heavy transition-all",
              SIZE_CONFIG[size2 || "md"].fontSize,
              isDone && "bg-success/20 border-success text-foreground",
              isCurrent && "bg-primary/20 border-primary text-foreground font-bold shadow-elevation-card shadow-primary/20",
              !isDone && !isCurrent && "bg-muted border-border text-muted-foreground"
            ),
            children: [
              /* @__PURE__ */ jsx(Box, { as: "span", className: "mr-1", children: isDone ? "\u2714" : isCurrent ? "\u25CF" : "\u25CB" }),
              /* @__PURE__ */ jsx(Box, { as: "span", children: state })
            ]
          }
        )
      ] }, state);
    }) })
  ] });
}
function CompactView({
  trait,
  size: size2 = "md",
  stateStyles,
  className,
  passthrough
}) {
  const { t } = useTranslate();
  const config = SIZE_CONFIG[size2 || "md"];
  const currentTransitions = trait.transitions.filter((t2) => t2.from === trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", ...passthrough, children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-foreground font-bold", children: trait.name }),
      /* @__PURE__ */ jsx(StateIndicator, { state: trait.currentState, size: "sm", stateStyles })
    ] }),
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", overflow: "wrap", children: trait.description }),
    currentTransitions.length > 0 && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("trait.availableActions") + ":" }),
      /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "xs", children: currentTransitions.map((transition, i) => /* @__PURE__ */ jsxs(
        Box,
        {
          display: "inline-flex",
          className: cn("items-center gap-1 px-2 py-1 rounded bg-muted", config.fontSize),
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent", children: transition.event }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2192" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-success", children: transition.to }),
            transition.guardHint && /* @__PURE__ */ jsx(Box, { as: "span", className: "text-warning ml-1 cursor-help", title: transition.guardHint, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-warning", children: "\u26A0" }) })
          ]
        },
        i
      )) })
    ] })
  ] });
}
function FullView({
  trait,
  size: size2 = "md",
  showTransitions = true,
  onStateClick,
  stateStyles,
  className,
  passthrough
}) {
  const { t } = useTranslate();
  const config = SIZE_CONFIG[size2 || "md"];
  const currentTransitions = trait.transitions.filter((t2) => t2.from === trait.currentState);
  return /* @__PURE__ */ jsxs(VStack, { className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", ...passthrough, children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-foreground font-bold", children: trait.name }),
      /* @__PURE__ */ jsx(StateIndicator, { state: trait.currentState, size: "sm", stateStyles })
    ] }),
    trait.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", overflow: "wrap", children: trait.description }),
    /* @__PURE__ */ jsx(HStack, { className: cn("flex-wrap", config.gap), children: trait.states.map((state) => {
      const isCurrent = state === trait.currentState;
      const hasOutgoing = trait.transitions.some((t2) => t2.from === state);
      return /* @__PURE__ */ jsx(
        Box,
        {
          display: "flex",
          "aria-current": isCurrent ? "true" : void 0,
          className: cn(
            "items-center justify-center rounded-container border-heavy transition-all px-2",
            config.nodeSize,
            isCurrent && "bg-primary/20 border-primary shadow-elevation-card shadow-primary/20",
            !isCurrent && hasOutgoing && "bg-muted border-border hover:border-muted-foreground",
            !isCurrent && !hasOutgoing && "bg-background border-border opacity-60",
            onStateClick && "cursor-pointer"
          ),
          ...pressableProps(onStateClick ? () => onStateClick(state) : void 0),
          children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: cn(
                config.fontSize,
                "whitespace-nowrap",
                isCurrent ? "text-primary font-bold" : "text-foreground/80"
              ),
              children: state
            }
          )
        },
        state
      );
    }) }),
    showTransitions && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("trait.transitions") + ":" }),
      /* @__PURE__ */ jsx(VStack, { gap: "xs", children: trait.transitions.map((transition, i) => {
        const isActive = transition.from === trait.currentState;
        return /* @__PURE__ */ jsxs(
          HStack,
          {
            className: cn(
              "items-center px-2 py-1 rounded text-xs",
              isActive ? "bg-primary/10" : "bg-muted/50"
            ),
            gap: "xs",
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: isActive ? "text-primary font-medium" : "text-muted-foreground", children: transition.from }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2014[" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent font-medium", children: transition.event }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "]\u2192" }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: isActive ? "text-success font-medium" : "text-foreground/70", children: transition.to }),
              transition.guardHint && /* @__PURE__ */ jsx(Box, { as: "span", className: "text-warning ml-1 cursor-help", title: transition.guardHint, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-warning", children: "\u26A0 " + transition.guardHint }) })
            ]
          },
          i
        );
      }) })
    ] }),
    showTransitions && currentTransitions.length > 0 && /* @__PURE__ */ jsxs(VStack, { className: "pt-2 border-t border-border", gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-primary font-medium", children: t("trait.availableNow") + ":" }),
      /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "xs", children: currentTransitions.map((t2, i) => /* @__PURE__ */ jsxs(
        Box,
        {
          display: "inline-flex",
          className: "items-center gap-1 px-2 py-1 rounded bg-primary/10 border border-primary/30 text-xs",
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-accent font-medium", children: t2.event }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u2192" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-success", children: t2.to })
          ]
        },
        i
      )) })
    ] })
  ] });
}
function TraitStateViewer({
  trait,
  variant = "compact",
  size: size2 = "md",
  showTransitions = true,
  onStateClick,
  stateStyles,
  className,
  ...rest
}) {
  const passthrough = domPassthrough(rest);
  switch (variant) {
    case "linear":
      return /* @__PURE__ */ jsx(LinearView, { trait, size: size2, className, passthrough });
    case "compact":
      return /* @__PURE__ */ jsx(
        CompactView,
        {
          trait,
          size: size2,
          stateStyles,
          className,
          passthrough
        }
      );
    case "full":
      return /* @__PURE__ */ jsx(
        FullView,
        {
          trait,
          size: size2,
          showTransitions,
          onStateClick,
          stateStyles,
          className,
          passthrough
        }
      );
  }
}
TraitStateViewer.displayName = "TraitStateViewer";
var SIZE_CONFIG2 = {
  sm: { box: 40, icon: 20, font: "text-xs" },
  md: { box: 56, icon: 28, font: "text-sm" },
  lg: { box: 72, icon: 40, font: "text-base" }
};
var DRAG_MIME = "application/x-almadar-slot-item";
function TraitSlot({
  slotNumber,
  equippedItem,
  locked = false,
  lockLabel,
  selected = false,
  size: size2 = "md",
  showTooltip = true,
  categoryColors,
  tooltipFrameUrl,
  className,
  feedback,
  onItemDrop,
  draggable = false,
  onDragStart,
  onClick,
  onRemove,
  clickEvent,
  removeEvent,
  dropEvent,
  ...rest
}) {
  const { emit } = useEventBus();
  const { t } = useTranslate();
  const [isHovered, setIsHovered] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const slotRef = useRef(null);
  const config = SIZE_CONFIG2[size2];
  const isEmpty = !equippedItem;
  const catColor = equippedItem && categoryColors ? categoryColors[equippedItem.category] : null;
  const handleClick = useCallback(() => {
    if (locked) return;
    if (clickEvent) {
      emit(`UI:${clickEvent}`, { slotNumber });
    } else {
      onClick?.();
    }
  }, [locked, clickEvent, slotNumber, emit, onClick]);
  const handleRemove = useCallback((e) => {
    e.stopPropagation();
    if (removeEvent) {
      emit(`UI:${removeEvent}`, { slotNumber });
    } else {
      onRemove?.();
    }
  }, [removeEvent, slotNumber, emit, onRemove]);
  const handleDragStart = useCallback((e) => {
    if (!equippedItem || !draggable) return;
    e.dataTransfer.setData(DRAG_MIME, JSON.stringify(equippedItem));
    e.dataTransfer.effectAllowed = "move";
    onDragStart?.(equippedItem);
  }, [equippedItem, draggable, onDragStart]);
  const handleDragOver = useCallback((e) => {
    if (locked || !onItemDrop && !dropEvent) return;
    if (e.dataTransfer.types.includes(DRAG_MIME)) {
      e.preventDefault();
      const allowed = e.dataTransfer.effectAllowed;
      e.dataTransfer.dropEffect = allowed === "copy" ? "copy" : "move";
      setIsDragOver(true);
    }
  }, [locked, onItemDrop, dropEvent]);
  const handleDragLeave = useCallback(() => {
    setIsDragOver(false);
  }, []);
  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (locked || !onItemDrop && !dropEvent) return;
    const raw = e.dataTransfer.getData(DRAG_MIME);
    if (!raw) return;
    try {
      const item = JSON.parse(raw);
      if (dropEvent) emit(`UI:${dropEvent}`, { slotNumber, itemId: item.id });
      else onItemDrop?.(item);
    } catch {
    }
  }, [locked, onItemDrop, dropEvent, emit, slotNumber]);
  const getTooltipStyle = () => {
    if (!slotRef.current) return {};
    const rect = slotRef.current.getBoundingClientRect();
    return {
      position: "fixed",
      left: rect.left + rect.width / 2,
      top: rect.top - 8,
      transform: "translate(-50%, -100%)",
      zIndex: 9999
    };
  };
  const itemMachine = equippedItem?.stateMachine || (equippedItem ? {
    name: equippedItem.name,
    states: ["idle", "active", "done"],
    currentState: "idle",
    transitions: [
      { from: "idle", to: "active", event: "ACTIVATE" },
      { from: "active", to: "done", event: "COMPLETE" }
    ],
    description: equippedItem.description
  } : null);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      ref: slotRef,
      display: "flex",
      position: "relative",
      className: cn(
        "items-center justify-center rounded-container transition-all duration-200 bg-card/50",
        !locked && "cursor-pointer",
        locked && "cursor-not-allowed opacity-50",
        isEmpty && !locked && "border-heavy border-dashed border-border hover:border-muted-foreground",
        isEmpty && locked && "border-heavy border-dashed border-border",
        !isEmpty && "border-heavy",
        selected && "ring-2 ring-primary ring-offset-2 ring-offset-background",
        isDragOver && "ring-2 ring-accent ring-offset-1 scale-110 border-accent",
        !isDragOver && feedback === "correct" && "ring-2 ring-success ring-offset-1 ring-offset-background",
        !isDragOver && feedback === "wrong" && "ring-2 ring-error ring-offset-1 ring-offset-background",
        !locked && !isDragOver && "hover:scale-105",
        className
      ),
      style: {
        width: config.box,
        height: config.box,
        backgroundColor: catColor?.bg || void 0,
        borderColor: isDragOver ? void 0 : feedback === "correct" ? "var(--color-success)" : feedback === "wrong" ? "var(--color-error)" : catColor?.border || void 0
      },
      ...pressableProps(clickEvent || onClick ? handleClick : void 0, { disabled: locked }),
      "aria-label": equippedItem ? equippedItem.name : void 0,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      draggable: draggable && !isEmpty,
      onDragStart: handleDragStart,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
      children: [
        locked ? /* @__PURE__ */ jsxs(Box, { className: "text-center", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: "\u{1F512}" }),
          lockLabel && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground block text-xs", children: lockLabel })
        ] }) : isEmpty ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-lg", children: "+" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          equippedItem.iconUrl ? /* @__PURE__ */ jsx(
            Box,
            {
              as: "img",
              className: "object-contain",
              style: { width: config.icon, height: config.icon },
              ...{ src: equippedItem.iconUrl.url, alt: equippedItem.name }
            }
          ) : /* @__PURE__ */ jsx(Typography, { variant: "body1", className: "text-center leading-none", style: { fontSize: config.icon }, children: equippedItem.iconEmoji || "\u2726" }),
          (onRemove || removeEvent) && /* @__PURE__ */ jsx(
            Box,
            {
              position: "absolute",
              className: "-top-1.5 -right-1.5 w-4 h-4 bg-error rounded-pill flex items-center justify-center cursor-pointer hover:bg-error/80 transition-colors",
              ...pressableProps(handleRemove),
              "aria-label": t("common.remove"),
              children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-foreground text-xs leading-none", children: "\xD7" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "-bottom-1 -left-1 w-4 h-4 bg-card rounded-pill flex items-center justify-center border border-border",
            children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-xs", children: slotNumber })
          }
        ),
        showTooltip && isHovered && itemMachine && !isEmpty && equippedItem && /* @__PURE__ */ jsxs(
          Box,
          {
            className: "p-3 bg-background border border-border rounded-container shadow-elevation-popover",
            style: {
              ...getTooltipStyle(),
              minWidth: 200,
              ...tooltipFrameUrl ? {
                borderImage: `url(${tooltipFrameUrl.url}) 60 fill / 15px / 0 stretch`,
                border: "none"
              } : {}
            },
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "text-foreground mb-2 text-center", children: equippedItem.name }),
              equippedItem.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground block mb-2 text-center", children: equippedItem.description }),
              /* @__PURE__ */ jsx(TraitStateViewer, { trait: itemMachine, variant: "compact", size: "sm" }),
              /* @__PURE__ */ jsx(
                Box,
                {
                  position: "absolute",
                  className: "-bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-heavy border-r-heavy border-t-heavy border-transparent border-t-border"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
TraitSlot.displayName = "TraitSlot";
var MODE_LABEL_KEYS = {
  select: "editor.modeSelect",
  paint: "editor.modePaint",
  unit: "editor.modeUnit",
  feature: "editor.modeFeature",
  erase: "editor.modeErase"
};
var TERRAIN_COLORS = {
  grass: "#4a7c3f",
  dirt: "#8b6c42",
  stone: "#7a7a7a",
  sand: "#c4a84d",
  water: "#3a6ea5",
  forest: "#2d5a1e",
  mountain: "#5a4a3a",
  lava: "#c44b2b",
  ice: "#a0d2e8",
  plains: "#6b8e4e",
  fortress: "#4a4a5a",
  castle: "#5a5a6a"
};
var FEATURE_TYPES = [
  "goldMine",
  "resonanceCrystal",
  "traitCache",
  "salvageYard",
  "portal",
  "battleMarker",
  "treasure",
  "castle"
];
function CollapsibleSection({ title, expanded, onToggle, children, assetManifest, className }) {
  const ui = assetManifest?.ui;
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: onToggle,
        className: "w-full justify-start text-left",
        children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(
            GameIcon,
            {
              icon: expanded ? ChevronDown : ChevronRight,
              assetUrl: expanded ? ui?.["collapse"] : ui?.["expand"],
              size: 14
            }
          ),
          /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", children: title })
        ] })
      }
    ),
    expanded && /* @__PURE__ */ jsx(Box, { padding: "xs", paddingX: "sm", children })
  ] });
}
CollapsibleSection.displayName = "CollapsibleSection";
function EditorSlider({ label, value, min, max, step = 0.1, onChange, className }) {
  const { locale } = useTranslate();
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "range",
        min,
        max,
        step,
        value,
        onChange: (e) => onChange(parseFloat(e.target.value)),
        className: "w-full h-1.5 bg-muted rounded-interactive appearance-none cursor-pointer accent-primary"
      }
    ) }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[40px] text-right text-muted-foreground", children: typeof step === "number" && step < 1 ? new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value) : new Intl.NumberFormat(locale).format(value) })
  ] });
}
EditorSlider.displayName = "EditorSlider";
function EditorSelect({ label, value, options, onChange, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "select",
      {
        value,
        onChange: (e) => onChange(e.target.value),
        className: "w-full px-2 py-1 text-xs bg-muted text-foreground border border-muted rounded cursor-pointer",
        children: options.map((opt) => /* @__PURE__ */ jsx("option", { value: opt.value, children: opt.label }, opt.value))
      }
    ) })
  ] });
}
EditorSelect.displayName = "EditorSelect";
function EditorCheckbox({ label, checked, onChange, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "checkbox",
        checked,
        onChange: (e) => onChange(e.target.checked),
        className: "w-4 h-4 accent-primary cursor-pointer"
      }
    ) })
  ] });
}
EditorCheckbox.displayName = "EditorCheckbox";
function EditorTextInput({ label, value, onChange, placeholder, className }) {
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "min-w-[80px] text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1", children: /* @__PURE__ */ jsx(
      "input",
      {
        type: "text",
        value,
        onChange: (e) => onChange(e.target.value),
        placeholder,
        className: "w-full px-2 py-1 text-xs bg-muted text-foreground border border-muted rounded"
      }
    ) })
  ] });
}
EditorTextInput.displayName = "EditorTextInput";
function StatusBar({ hoveredTile, mode, gridSize, unitCount, featureCount, className }) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: `px-3 py-1.5 bg-background border-t border-border ${className ?? ""}`, children: [
    /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t(MODE_LABEL_KEYS[mode]) }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("editor.tile", { position: hoveredTile ? `(${hoveredTile.x}, ${hoveredTile.y})` : "\u2014" }) }),
    gridSize && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("editor.grid", { width: gridSize.width, height: gridSize.height }) }),
    unitCount !== void 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("editor.units", { count: unitCount }) }),
    featureCount !== void 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("editor.features", { count: featureCount }) })
  ] });
}
StatusBar.displayName = "StatusBar";
function TerrainPalette({ terrains, selectedTerrain, onSelect, className }) {
  return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, className, children: terrains.map((terrain) => /* @__PURE__ */ jsx(
    Box,
    {
      onClick: () => onSelect(terrain),
      className: `w-8 h-8 rounded cursor-pointer border-2 transition-all ${selectedTerrain === terrain ? "border-foreground scale-110 shadow-lg" : "border-muted hover:border-muted-foreground"}`,
      style: { backgroundColor: TERRAIN_COLORS[terrain] || "var(--color-muted)" },
      title: terrain
    },
    terrain
  )) });
}
TerrainPalette.displayName = "TerrainPalette";
function EditorToolbar({ mode, onModeChange, className }) {
  const { t } = useTranslate();
  const modes = ["select", "paint", "unit", "feature", "erase"];
  return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, className, children: modes.map((m) => /* @__PURE__ */ jsx(
    Button,
    {
      variant: mode === m ? "primary" : "ghost",
      size: "sm",
      onClick: () => onModeChange(m),
      children: t(MODE_LABEL_KEYS[m])
    },
    m
  )) });
}
EditorToolbar.displayName = "EditorToolbar";
var DRAG_MIME2 = "application/x-almadar-slot-item";
var SIZE_CONFIG3 = {
  sm: { px: "px-2 py-1", icon: "text-lg", text: "text-xs" },
  md: { px: "px-3 py-2", icon: "text-2xl", text: "text-sm" },
  lg: { px: "px-4 py-3", icon: "text-3xl", text: "text-base" }
};
function ActionTile({
  action,
  size: size2 = "md",
  disabled = false,
  categoryColors,
  className,
  ...rest
}) {
  useTranslate();
  const config = SIZE_CONFIG3[size2];
  const catColor = categoryColors?.[action.category];
  const handleDragStart = useCallback((e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    e.dataTransfer.setData(DRAG_MIME2, JSON.stringify(action));
    e.dataTransfer.effectAllowed = "copy";
  }, [action, disabled]);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      display: "flex",
      className: cn(
        "flex-col items-center gap-1 rounded-container border-heavy transition-all select-none",
        config.px,
        disabled ? "opacity-40 cursor-not-allowed border-border bg-muted" : "cursor-grab active:cursor-grabbing hover:scale-105 hover:shadow-elevation-popover border-border bg-card",
        className
      ),
      style: {
        backgroundColor: !disabled && catColor ? catColor.bg : void 0,
        borderColor: !disabled && catColor ? catColor.border : void 0
      },
      draggable: !disabled,
      onDragStart: handleDragStart,
      children: [
        action.iconUrl ? /* @__PURE__ */ jsx("img", { src: action.iconUrl.url, alt: "", className: "w-8 h-8 object-contain" }) : /* @__PURE__ */ jsx(Typography, { variant: "body1", className: cn(config.icon, "leading-none"), children: action.iconEmoji || "\u2726" }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", className: cn(config.text, "text-foreground font-medium whitespace-nowrap"), children: action.name })
      ]
    }
  );
}
ActionTile.displayName = "ActionTile";
function ActionPalette({
  actions,
  usedActionIds = [],
  allowDuplicates = true,
  categoryColors,
  size: size2 = "md",
  label,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), className: cn("p-3 rounded-container bg-card border border-border", className), gap: "sm", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-muted-foreground font-medium", children: label ?? t("sequencer.actions") }),
    /* @__PURE__ */ jsx(HStack, { className: "flex-wrap", gap: "sm", children: (actions ?? []).map((action) => /* @__PURE__ */ jsx(
      ActionTile,
      {
        action,
        size: size2,
        categoryColors,
        disabled: !allowDuplicates && usedActionIds.includes(action.id)
      },
      action.id
    )) })
  ] });
}
ActionPalette.displayName = "ActionPalette";
function SequenceBar({
  slots,
  maxSlots,
  onSlotDrop,
  onSlotRemove,
  slotDropEvent,
  slotRemoveEvent,
  playing = false,
  currentStep = -1,
  categoryColors,
  slotFeedback,
  size: size2 = "lg",
  className,
  ...rest
}) {
  const { emit } = useEventBus();
  const handleDrop = useCallback((index) => (item) => {
    if (playing) return;
    if (slotDropEvent) emit(`UI:${slotDropEvent}`, { slotNumber: index, itemId: item.id });
    else onSlotDrop?.(index, item);
  }, [emit, slotDropEvent, onSlotDrop, playing]);
  const handleRemove = useCallback((index) => () => {
    if (playing) return;
    if (slotRemoveEvent) emit(`UI:${slotRemoveEvent}`, { slotNumber: index });
    else onSlotRemove?.(index);
  }, [emit, slotRemoveEvent, onSlotRemove, playing]);
  const paddedSlots = Array.from({ length: maxSlots }, (_, i) => slots[i]);
  return /* @__PURE__ */ jsx(HStack, { ...domPassthrough(rest), className: cn("items-center", className), gap: "sm", children: paddedSlots.map((slot, i) => /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
    i > 0 && /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "body1",
        className: cn(
          "text-lg",
          currentStep >= 0 && i <= currentStep ? "text-primary" : "text-muted-foreground"
        ),
        children: "\u2192"
      }
    ),
    /* @__PURE__ */ jsx(
      TraitSlot,
      {
        slotNumber: i + 1,
        equippedItem: slot,
        size: size2,
        categoryColors,
        onItemDrop: handleDrop(i),
        onRemove: slot ? handleRemove(i) : void 0,
        draggable: !playing && !!slot,
        selected: currentStep === i,
        locked: playing,
        feedback: slotFeedback?.[i]
      }
    )
  ] }, i)) });
}
SequenceBar.displayName = "SequenceBar";

// lib/puzzleObject.ts
function objId(o) {
  return o.id == null ? "" : String(o.id);
}
function objName(o) {
  return o.name == null ? "" : String(o.name);
}
function objIcon(o) {
  return o.icon == null ? "" : String(o.icon);
}
function objStates(o) {
  return Array.isArray(o.states) ? o.states : [];
}
function objCurrentState(o) {
  return o.currentState == null ? "" : String(o.currentState);
}
function objAvailableEvents(o) {
  return Array.isArray(o.availableEvents) ? o.availableEvents : [];
}
function objAvailableActions(o) {
  return Array.isArray(o.availableActions) ? o.availableActions : [];
}
function objRules(o) {
  return Array.isArray(o.rules) ? o.rules : [];
}
function objMaxRules(o) {
  const n = Number(o.maxRules);
  return Number.isFinite(n) && n > 0 ? n : 3;
}
function StateJsonView({
  name,
  initialState,
  states,
  transitions,
  label,
  defaultExpanded = false,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const [expanded, setExpanded] = useState(defaultExpanded);
  const jsonString = JSON.stringify(
    { name, initialState, states: states ?? [], transitions: transitions ?? [] },
    null,
    2
  );
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), className: cn("rounded-container border border-border overflow-hidden", className), gap: "none", children: [
    /* @__PURE__ */ jsxs(HStack, { className: "items-center justify-between p-2 bg-muted", gap: "sm", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground font-medium", children: label ?? t("stateArchitect.viewCode") }),
      /* @__PURE__ */ jsx(Button, { variant: "ghost", onClick: () => setExpanded(!expanded), className: "text-xs", children: expanded ? t("stateArchitect.hideJson") : t("stateArchitect.showJson") })
    ] }),
    expanded && /* @__PURE__ */ jsx(Box, { className: "p-3 bg-background overflow-x-auto", children: /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "caption",
        className: "text-foreground font-mono whitespace-pre text-xs leading-relaxed block",
        children: jsonString
      }
    ) })
  ] });
}
StateJsonView.displayName = "StateJsonView";

// lib/mechanics.ts
var projectileMotion = {
  id: "mechanics-projectile",
  nameKey: "physicsPreset.projectileMotion",
  descriptionKey: "physicsPreset.projectileMotionDescription",
  domain: "natural",
  gravity: { x: 0, y: 9.81 },
  bodies: [
    { id: "ball", x: 50, y: 350, vx: 80, vy: -120, mass: 1, radius: 10, color: "#e94560", fixed: false },
    { id: "ground", x: 300, y: 390, vx: 0, vy: 0, mass: 1e3, radius: 400, color: "#333", fixed: true }
  ],
  showVelocity: true,
  parameters: {
    angle: { value: 45, min: 0, max: 90, step: 1, labelKey: "physicsPreset.launchAngle" },
    velocity: { value: 100, min: 10, max: 200, step: 5, labelKey: "physicsPreset.initialVelocity" },
    gravity: { value: 9.81, min: 0, max: 20, step: 0.1, labelKey: "physicsPreset.gravity" }
  }
};
var pendulum = {
  id: "mechanics-pendulum",
  nameKey: "physicsPreset.simplePendulum",
  descriptionKey: "physicsPreset.simplePendulumDescription",
  domain: "natural",
  gravity: { x: 0, y: 9.81 },
  bodies: [
    { id: "pivot", x: 300, y: 50, vx: 0, vy: 0, mass: 1e3, radius: 5, color: "#888", fixed: true },
    { id: "bob", x: 400, y: 200, vx: 0, vy: 0, mass: 5, radius: 15, color: "#e94560", fixed: false }
  ],
  constraints: [{ bodyA: 0, bodyB: 1, length: 180, stiffness: 1 }],
  parameters: {
    length: { value: 180, min: 50, max: 300, step: 10, labelKey: "physicsPreset.stringLength" },
    mass: { value: 5, min: 1, max: 20, step: 0.5, labelKey: "physicsPreset.mass" },
    gravity: { value: 9.81, min: 0, max: 20, step: 0.1, labelKey: "physicsPreset.gravity" }
  }
};
var springOscillator = {
  id: "mechanics-spring",
  nameKey: "physicsPreset.springOscillator",
  descriptionKey: "physicsPreset.springOscillatorDescription",
  domain: "natural",
  gravity: { x: 0, y: 0 },
  bodies: [
    { id: "anchor", x: 300, y: 50, vx: 0, vy: 0, mass: 1e3, radius: 8, color: "#888", fixed: true },
    { id: "mass", x: 300, y: 250, vx: 0, vy: 0, mass: 2, radius: 20, color: "#0f3460", fixed: false }
  ],
  constraints: [{ bodyA: 0, bodyB: 1, length: 150, stiffness: 0.5 }],
  parameters: {
    stiffness: { value: 0.5, min: 0.1, max: 2, step: 0.05, labelKey: "physicsPreset.springStiffness" },
    mass: { value: 2, min: 0.5, max: 10, step: 0.5, labelKey: "physicsPreset.mass" },
    damping: { value: 0, min: 0, max: 0.5, step: 0.01, labelKey: "physicsPreset.damping" }
  }
};

// lib/physicsPresets.ts
var ALL_PRESETS = [
  projectileMotion,
  pendulum,
  springOscillator
];

// lib/gameFonts.ts
var GAME_FONT_KEYS = {
  fredoka: "Fredoka",
  future: "Kenney Future",
  "future-narrow": "Kenney Future Narrow",
  pixel: "Kenney Pixel",
  blocks: "Kenney Blocks",
  mini: "Kenney Mini"
};
function resolveGameFontFamily(input) {
  if (!input) return void 0;
  const resolved = GAME_FONT_KEYS[input];
  if (resolved) return `'${resolved}', ui-sans-serif, system-ui, sans-serif`;
  return input;
}
var GameShell = ({
  appName: appNameProp,
  hud,
  addons,
  controls,
  overlay,
  className,
  showTopBar = true,
  children,
  backgroundAsset,
  fontFamily,
  "data-theme": dataTheme,
  ...rest
}) => {
  const { t } = useTranslate();
  const appName = appNameProp ?? t("gameShell.defaultName");
  const displayFont = resolveGameFontFamily(fontFamily);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      "data-theme": dataTheme || void 0,
      className: cn("game-shell", className),
      style: {
        position: "relative",
        width: "100%",
        maxWidth: "100vw",
        height: "100vh",
        overflow: "hidden",
        background: "var(--color-background, #0a0a0f)",
        color: "var(--color-foreground, #e0e0e0)",
        // The fontFamily knob is a scoped override of the theme contract's
        // display slot: titles/numerics take the game face, body text keeps
        // the active theme's --font-family-body. Set ONLY when explicitly
        // passed — an always-on inline stamp would shadow the orbital's
        // inline-theme font-family-display token (inline style beats the
        // theme provider's vars for the whole shell subtree).
        ...displayFont ? { "--font-family-display": displayFont } : {}
      },
      children: [
        backgroundAsset && /* @__PURE__ */ jsx(
          AtlasPanel,
          {
            asset: backgroundAsset,
            mode: "repeat",
            "aria-hidden": true,
            className: "game-shell__bg",
            style: { position: "absolute", inset: 0, opacity: 0.18, zIndex: 0, display: "block" }
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: "game-shell__content", style: { position: "absolute", inset: 0, zIndex: 1 }, children }),
        (showTopBar || hud) && /* @__PURE__ */ jsxs(
          Box,
          {
            className: "game-shell__top pointer-events-none",
            style: {
              position: "absolute",
              top: 12,
              left: 12,
              right: 12,
              zIndex: 2,
              display: "flex",
              alignItems: "flex-start",
              gap: 12
            },
            children: [
              showTopBar && /* @__PURE__ */ jsx(
                Card,
                {
                  variant: "bordered",
                  padding: "none",
                  className: "game-shell__title bg-card pointer-events-auto",
                  style: { padding: "6px 16px", flexShrink: 0 },
                  children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      as: "span",
                      className: "font-display",
                      style: {
                        fontWeight: 700,
                        fontSize: "1.05rem",
                        letterSpacing: "0.06em",
                        textShadow: "0 2px 0 rgba(0,0,0,0.5)",
                        whiteSpace: "nowrap"
                      },
                      children: appName
                    }
                  )
                }
              ),
              hud && /* @__PURE__ */ jsx(Box, { className: "game-shell__hud pointer-events-auto", style: { flex: 1, minWidth: 0 }, children: hud })
            ]
          }
        ),
        controls && /* @__PURE__ */ jsx(
          Box,
          {
            className: "game-shell__controls pointer-events-auto",
            style: {
              position: "absolute",
              left: 16,
              bottom: 16,
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: 10,
              filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.5))"
            },
            children: controls
          }
        ),
        addons && /* @__PURE__ */ jsx(
          Box,
          {
            className: "game-shell__actions pointer-events-auto",
            style: {
              position: "absolute",
              right: 16,
              bottom: 16,
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              gap: 10,
              filter: "drop-shadow(0 6px 12px rgba(0,0,0,0.5))"
            },
            children: addons
          }
        ),
        overlay && /* @__PURE__ */ jsx(
          Box,
          {
            className: "game-shell__overlay pointer-events-none",
            style: {
              position: "absolute",
              inset: 0,
              zIndex: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto", children: /* @__PURE__ */ jsx(GameOverlayContext.Provider, { value: true, children: overlay }) })
          }
        )
      ]
    }
  );
};
GameShell.displayName = "GameShell";
function useKeyMapEvents(keyMap, keyUpMap) {
  const eventBus = useEventBus();
  const keyMapKey = keyMap ? JSON.stringify(keyMap) : null;
  const keyUpMapKey = keyUpMap ? JSON.stringify(keyUpMap) : null;
  const stableKeyMap = useMemo(() => keyMap, [keyMapKey]);
  const stableKeyUpMap = useMemo(() => keyUpMap, [keyUpMapKey]);
  useEffect(() => {
    if (!stableKeyMap && !stableKeyUpMap) return;
    const onDown = (e) => {
      const ev = resolveKeyMapEvent(stableKeyMap, e);
      if (ev) {
        eventBus.emit(`UI:${ev}`, {});
        e.preventDefault();
      }
    };
    const onUp = (e) => {
      const ev = resolveKeyMapEvent(stableKeyUpMap, e);
      if (ev) eventBus.emit(`UI:${ev}`, {});
    };
    window.addEventListener("keydown", onDown);
    window.addEventListener("keyup", onUp);
    return () => {
      window.removeEventListener("keydown", onDown);
      window.removeEventListener("keyup", onUp);
    };
  }, [stableKeyMap, stableKeyUpMap, eventBus]);
}
function shapeBounds(shape) {
  switch (shape.type) {
    case "line":
    case "arrow":
      if (shape.x1 == null || shape.y1 == null || shape.x2 == null || shape.y2 == null) return null;
      return {
        x: Math.min(shape.x1, shape.x2) - 6,
        y: Math.min(shape.y1, shape.y2) - 6,
        w: Math.abs(shape.x2 - shape.x1) + 12,
        h: Math.abs(shape.y2 - shape.y1) + 12
      };
    case "circle":
      if (shape.x == null || shape.y == null || shape.radius == null) return null;
      return {
        x: shape.x - shape.radius - 4,
        y: shape.y - shape.radius - 4,
        w: shape.radius * 2 + 8,
        h: shape.radius * 2 + 8
      };
    case "ellipse":
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) return null;
      return {
        x: shape.x - shape.width / 2 - 4,
        y: shape.y - shape.height / 2 - 4,
        w: shape.width + 8,
        h: shape.height + 8
      };
    case "rect":
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) return null;
      return { x: shape.x - 4, y: shape.y - 4, w: shape.width + 8, h: shape.height + 8 };
    case "polygon":
      if (!shape.points || shape.points.length === 0) return null;
      {
        const xs = shape.points.map((p) => p.x);
        const ys = shape.points.map((p) => p.y);
        const minX = Math.min(...xs);
        const minY = Math.min(...ys);
        return {
          x: minX - 4,
          y: minY - 4,
          w: Math.max(...xs) - minX + 8,
          h: Math.max(...ys) - minY + 8
        };
      }
    case "text":
      if (shape.x == null || shape.y == null) return null;
      return { x: shape.x - 4, y: shape.y - (shape.fontSize ?? 14) - 4, w: 120, h: (shape.fontSize ?? 14) + 8 };
    default:
      return null;
  }
}
var DEFAULT_TONE = {
  grid: "grid",
  axis: "axis",
  text: "label"
};
var DEFAULT_STROKE = {
  grid: "thin"
};
function isLiteralColor(value) {
  return value !== void 0 && value !== "" && !value.startsWith("var(") && !/^[a-z]+(-\d)?$/.test(value);
}
function strokeMark(ctx, color, width) {
  ctx.strokeStyle = color;
  ctx.lineWidth = width;
  ctx.stroke();
}
function drawShape(ctx, shape, width, height, allShapes, theme, fontFamily) {
  const scope = ctx.canvas;
  ctx.save();
  ctx.globalAlpha = shape.opacity ?? 1;
  const fillValue = shape.fill ?? shape.fillTone;
  const fill = fillValue !== void 0 ? markColor(theme, fillValue, scope, "fill") : void 0;
  const fillStyle = shape.fillStyle ?? (isLiteralColor(shape.fill) ? "solid" : theme.fillStyle);
  const stroke = outlineStroke(markColor(theme, shape.color ?? shape.tone, scope, DEFAULT_TONE[shape.type] ?? "ink"), fill, fillStyle, fillValue);
  const declaredWidth = markStrokeWidth(theme, shape.lineWidth, shape.stroke, DEFAULT_STROKE[shape.type] ?? "normal");
  const lineWidth = outlineCarriesFill(fill, fillStyle, fillValue) ? Math.max(declaredWidth, theme.strokes.bold) : declaredWidth;
  applyLineCharacter(ctx, theme, stroke);
  ctx.setLineDash([...markDash(theme, shape.dash)]);
  const closedMark = (points) => {
    tracePolyline(ctx, theme, points, true);
    if (fill) fillMark(ctx, theme, fill, fillStyle);
    strokeMark(ctx, stroke, lineWidth);
  };
  switch (shape.type) {
    case "grid": {
      const step = shape.step ?? 40;
      ctx.beginPath();
      for (let x = 0; x <= width; x += step) {
        ctx.moveTo(x, 0);
        ctx.lineTo(x, height);
      }
      for (let y = 0; y <= height; y += step) {
        ctx.moveTo(0, y);
        ctx.lineTo(width, y);
      }
      strokeMark(ctx, stroke, lineWidth);
      break;
    }
    case "axis": {
      const horizontal = (shape.axis ?? "x") === "x";
      tracePolyline(ctx, theme, horizontal ? [{ x: 0, y: height / 2 }, { x: width, y: height / 2 }] : [{ x: width / 2, y: 0 }, { x: width / 2, y: height }], false);
      strokeMark(ctx, stroke, lineWidth);
      break;
    }
    case "line":
    case "arrow": {
      if (shape.x1 == null || shape.y1 == null || shape.x2 == null || shape.y2 == null) break;
      tracePolyline(ctx, theme, [{ x: shape.x1, y: shape.y1 }, { x: shape.x2, y: shape.y2 }], false);
      strokeMark(ctx, stroke, lineWidth);
      if (shape.type === "arrow") drawMarker(ctx, theme, shape.x1, shape.y1, shape.x2, shape.y2, stroke, lineWidth);
      break;
    }
    case "circle": {
      if (shape.x == null || shape.y == null || shape.radius == null) break;
      if (theme.roughness > 0) closedMark(arcPoints(shape.x, shape.y, shape.radius, shape.radius));
      else {
        ctx.beginPath();
        ctx.arc(shape.x, shape.y, shape.radius, 0, Math.PI * 2);
        if (fill) fillMark(ctx, theme, fill, fillStyle);
        strokeMark(ctx, stroke, lineWidth);
      }
      break;
    }
    case "ellipse": {
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) break;
      const start = (shape.startAngle ?? 0) * Math.PI / 180;
      const end = (shape.endAngle ?? 360) * Math.PI / 180;
      const whole = Math.abs(end - start) >= Math.PI * 2 - 1e-6;
      if (theme.roughness > 0) {
        tracePolyline(ctx, theme, arcPoints(shape.x, shape.y, shape.width / 2, shape.height / 2, start, end), whole);
      } else {
        ctx.beginPath();
        ctx.ellipse(shape.x, shape.y, shape.width / 2, shape.height / 2, 0, start, end);
      }
      if (fill) fillMark(ctx, theme, fill, fillStyle);
      strokeMark(ctx, stroke, lineWidth);
      break;
    }
    case "rect": {
      if (shape.x == null || shape.y == null || shape.width == null || shape.height == null) break;
      if (theme.roughness > 0 || theme.corner <= 0 || typeof ctx.roundRect !== "function") {
        closedMark([
          { x: shape.x, y: shape.y },
          { x: shape.x + shape.width, y: shape.y },
          { x: shape.x + shape.width, y: shape.y + shape.height },
          { x: shape.x, y: shape.y + shape.height }
        ]);
      } else {
        ctx.beginPath();
        ctx.roundRect(shape.x, shape.y, shape.width, shape.height, Math.min(theme.corner, shape.width / 2, shape.height / 2));
        if (fill) fillMark(ctx, theme, fill, fillStyle);
        strokeMark(ctx, stroke, lineWidth);
      }
      break;
    }
    case "polygon": {
      if (!shape.points || shape.points.length < 2) break;
      closedMark(shape.points);
      break;
    }
    case "path": {
      if (!shape.path || typeof Path2D === "undefined") break;
      const p = new Path2D(shape.path);
      if (fill && fillStyle !== "outline") {
        ctx.save();
        ctx.globalAlpha *= fillStyle === "tint" ? theme.fillOpacity : 1;
        ctx.fillStyle = fill;
        ctx.fill(p);
        ctx.restore();
      }
      ctx.strokeStyle = stroke;
      ctx.lineWidth = lineWidth;
      ctx.stroke(p);
      break;
    }
    case "text": {
      if (shape.x == null || shape.y == null || !shape.text) break;
      ctx.shadowBlur = 0;
      ctx.fillStyle = stroke;
      ctx.font = labelFont(theme, shape, shape.fontSize, shape.fontFamily ?? fontFamily).font;
      ctx.textAlign = shape.align ?? "left";
      ctx.textBaseline = "middle";
      fillLabel(ctx, theme, labelText(theme, shape.text, shape.textCase), shape.x, shape.y);
      break;
    }
    case "venn-region": {
      const resolveCircles = (ids) => (ids ?? []).flatMap((id) => {
        const c = allShapes.find((s) => s.type === "circle" && s.id === id);
        return c && c.x != null && c.y != null && c.radius != null ? [{ x: c.x, y: c.y, radius: c.radius }] : [];
      });
      const inside = resolveCircles(shape.inside);
      if (inside.length === 0 || typeof Path2D === "undefined") break;
      const outside = resolveCircles(shape.outside);
      const off = document.createElement("canvas");
      off.width = ctx.canvas.width;
      off.height = ctx.canvas.height;
      const octx = off.getContext("2d");
      if (!octx) break;
      octx.setTransform(ctx.getTransform());
      for (const c of inside) {
        const p = new Path2D();
        p.arc(c.x, c.y, c.radius, 0, Math.PI * 2);
        octx.clip(p);
      }
      octx.globalAlpha = fillStyle === "tint" ? theme.fillOpacity * 2 : 1;
      octx.fillStyle = fill ?? stroke;
      octx.fillRect(0, 0, width, height);
      octx.globalCompositeOperation = "destination-out";
      octx.globalAlpha = 1;
      for (const c of outside) {
        const p = new Path2D();
        p.arc(c.x, c.y, c.radius, 0, Math.PI * 2);
        octx.fill(p);
      }
      ctx.save();
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(off, 0, 0);
      ctx.restore();
      break;
    }
  }
  ctx.restore();
}
function readoutShapes(readouts, width, theme, fontFamily) {
  const out = [];
  const px = theme.text.xs;
  const chipH = Math.round(px * 1.9);
  const pad = Math.round(px * 0.75);
  const dot = Math.max(3, Math.round(px * 0.3));
  const gap = 6;
  const charW = px * 0.62;
  let rightEdge = width - 8;
  let rowY = 8;
  for (const readout of readouts) {
    const text = labelText(theme, `${readout.label} ${String(readout.value)}`, "verbatim");
    const chipW = Math.max(40, Math.round(text.length * charW + pad * 2 + dot * 3));
    let chipX = rightEdge - chipW;
    if (chipX < 8) {
      rowY += chipH + 4;
      rightEdge = width - 8;
      chipX = rightEdge - chipW;
    }
    out.push({ type: "rect", x: chipX, y: rowY, width: chipW, height: chipH, tone: "grid", fill: theme.ground, fillStyle: "solid", stroke: "thin", opacity: 0.94 });
    out.push({ type: "circle", x: chipX + pad + dot, y: rowY + chipH / 2, radius: dot, color: readout.color ?? "highlight", fill: readout.color ?? "highlight", fillStyle: "solid", stroke: "thin" });
    out.push({ type: "text", x: chipX + pad + dot * 3, y: rowY + chipH / 2, text: `${readout.label} ${String(readout.value)}`, tone: "ink", textCase: "verbatim", textSize: "xs", fontFamily });
    rightEdge = chipX - gap;
  }
  return out;
}
function traceShapes(panel, k, width, height, theme, fontFamily) {
  const w = panel.width ?? Math.round(width * 0.32);
  const h = panel.height ?? Math.round(height * 0.28);
  const x = panel.x ?? width - w - 8;
  const y = panel.y ?? height - h - 8 - k * (h + 8);
  const allSamples = panel.series.flatMap((series) => series.samples);
  let xLo = Math.min(...allSamples.map((p) => p.x));
  let xHi = Math.max(...allSamples.map((p) => p.x));
  let yLo = Math.min(...allSamples.map((p) => p.y));
  let yHi = Math.max(...allSamples.map((p) => p.y));
  if (xLo === xHi) {
    xLo -= 1;
    xHi += 1;
  }
  if (yLo === yHi) {
    yLo -= 1;
    yHi += 1;
  }
  const out = [];
  out.push({
    type: "rect",
    x,
    y,
    width: w,
    height: h,
    color: panel.frameColor ?? "grid",
    fill: panel.backgroundColor ?? theme.ground,
    fillStyle: "solid",
    stroke: "thin",
    opacity: panel.backgroundOpacity ?? 0.92
  });
  const showLegend = panel.series.length > 1 || !panel.yLabel;
  panel.series.forEach((series, j) => {
    const color = series.color ?? `series-${j % 8 + 1}`;
    const mapped = series.samples.map((p) => ({
      x: x + 4 + (p.x - xLo) / (xHi - xLo) * (w - 8),
      y: y + h - 4 - (p.y - yLo) / (yHi - yLo) * (h - 8)
    }));
    for (let i = 1; i < mapped.length; i++) {
      out.push({
        type: "line",
        x1: mapped[i - 1].x,
        y1: mapped[i - 1].y,
        x2: mapped[i].x,
        y2: mapped[i].y,
        color,
        stroke: "normal"
      });
    }
    if (mapped.length > 0) {
      const last = mapped[mapped.length - 1];
      out.push({ type: "circle", x: last.x, y: last.y, radius: 2.5, color, fill: color, fillStyle: "solid", stroke: "thin" });
    }
    if (series.label && showLegend) {
      const ly = y + 10 + 13 * j;
      out.push({ type: "line", id: `trace-swatch-${j}`, x1: x + 6, y1: ly, x2: x + 16, y2: ly, color, stroke: "bold" });
      out.push({ type: "text", x: x + 20, y: ly, text: series.label, tone: "label", textCase: "verbatim", textSize: "xs", fontFamily });
    }
  });
  if (panel.yLabel) {
    out.push({ type: "text", x: x + w - 6, y: y + 10, text: panel.yLabel, tone: "label", textCase: "verbatim", textSize: "xs", align: "right", fontFamily });
  }
  if (panel.xLabel) {
    out.push({ type: "text", x: x + w - 6, y: y + h - 8, text: panel.xLabel, tone: "label", textCase: "verbatim", textSize: "xs", align: "right", fontFamily });
  }
  return out;
}
function drawableNeedsAnimation(nodes) {
  if (!nodes) return false;
  return nodes.some((node) => {
    if (node.type === "draw-sprite") return node.animation !== void 0;
    if (node.type === "draw-fx-layer") return Array.isArray(node.items) && node.items.length > 0;
    if (node.type === "draw-sprite-layer") return Array.isArray(node.items) && node.items.some((it) => it.animation !== void 0);
    if (node.type === "draw-group") return Array.isArray(node.items) && drawableNeedsAnimation(node.items);
    return false;
  });
}
var LearningCanvas = ({
  className,
  width = 600,
  height = 400,
  backgroundColor,
  series,
  fontFamily,
  shapes = [],
  drawables,
  projector,
  readouts,
  traces,
  keyMap,
  keyUpMap,
  interactive = false,
  animate = false,
  onShapeClick,
  onShapeHover,
  description,
  isLoading,
  error,
  ...rest
}) => {
  const descId = useId();
  useKeyMapEvents(keyMap, keyUpMap);
  const canvasRef = useRef(null);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const animRef = useRef(0);
  const hoverIndexRef = useRef(-1);
  const [drawVersion, setDrawVersion] = useState(0);
  const invalidateRef = useRef(() => setDrawVersion((v) => v + 1));
  const needsAnim = useMemo(() => drawableNeedsAnimation(drawables), [drawables]);
  const findShapeAt = useCallback((clientX, clientY) => {
    const canvas2 = canvasRef.current;
    if (!canvas2) return -1;
    const rect = canvas2.getBoundingClientRect();
    const x = (clientX - rect.left) * (rect.width > 0 ? width / rect.width : 1);
    const y = (clientY - rect.top) * (rect.height > 0 ? height / rect.height : 1);
    for (let i = shapes.length - 1; i >= 0; i--) {
      const b = shapeBounds(shapes[i]);
      if (b && x >= b.x && x <= b.x + b.w && y >= b.y && y <= b.y + b.h) {
        return i;
      }
    }
    return -1;
  }, [shapes, width, height]);
  const { theme: baseTheme, version: themeVersion2 } = useCanvasTheme(canvasRef);
  const seriesKey = series ? series.join("|") : "";
  const theme = useMemo(() => withSeries(baseTheme, series, canvasRef.current), [baseTheme, seriesKey]);
  const displayWidth = useContainerWidth(canvasRef);
  const derivedShapes = useMemo(() => {
    if (!theme || !traces?.length && !readouts?.length) return shapes;
    const traceOut = (traces ?? []).flatMap((panel, k) => traceShapes(panel, k, width, height, theme, fontFamily));
    const readoutOut = readouts?.length ? readoutShapes(readouts, width, theme, fontFamily) : [];
    return [...shapes, ...traceOut, ...readoutOut];
  }, [shapes, traces, readouts, width, height, fontFamily, theme]);
  const draw = useCallback(() => {
    const _perfT = perfStart("learningcanvas:paint");
    const canvas2 = canvasRef.current;
    if (!canvas2 || !theme) return;
    const ctx = canvas2.getContext("2d");
    if (!ctx) return;
    const dpr = typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1;
    const scale = (displayWidth && displayWidth > 0 ? displayWidth : width) / width;
    canvas2.width = Math.max(1, Math.floor(width * scale * dpr));
    canvas2.height = Math.max(1, Math.floor(height * scale * dpr));
    ctx.setTransform(dpr * scale, 0, 0, dpr * scale, 0, 0);
    ctx.clearRect(0, 0, width, height);
    ctx.fillStyle = markColor(theme, backgroundColor, canvas2, "fill");
    if (!backgroundColor) ctx.fillStyle = theme.ground;
    ctx.fillRect(0, 0, width, height);
    for (const shape of derivedShapes) {
      if (shape.type !== "text") drawShape(ctx, shape, width, height, derivedShapes, theme, fontFamily);
    }
    for (const shape of derivedShapes) {
      if (shape.type === "text") drawShape(ctx, shape, width, height, derivedShapes, theme, fontFamily);
    }
    if (drawables?.length && projector) {
      const painter = createWebPainter(ctx, invalidateRef.current);
      const timeMs = needsAnim && theme.motion.enabled && typeof performance !== "undefined" ? performance.now() : 0;
      const dctx = { projector, time: timeMs, invalidate: invalidateRef.current, fontFamily: fontFamily || theme.faces[theme.label.font] };
      for (const node of resolveDrawableColors(drawables, (c) => markColor(theme, c, canvas2, "ink"))) {
        paintDrawable(painter, node, dctx);
      }
    }
    perfEnd("learningcanvas:paint", _perfT);
  }, [width, height, backgroundColor, derivedShapes, drawables, projector, needsAnim, theme, themeVersion2, displayWidth, fontFamily]);
  useEffect(() => {
    draw();
  }, [draw, drawVersion]);
  useEffect(() => {
    const shouldAnimate = (animate || needsAnim) && theme?.motion.enabled === true;
    if (!shouldAnimate) return;
    const loop = () => {
      draw();
      animRef.current = requestAnimationFrame(loop);
    };
    animRef.current = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(animRef.current);
  }, [animate, needsAnim, draw, theme]);
  const handlePointerMove = useCallback(
    (e) => {
      if (!interactive) return;
      const idx = findShapeAt(e.clientX, e.clientY);
      if (idx !== hoverIndexRef.current) {
        hoverIndexRef.current = idx;
        if (idx >= 0) {
          const shape = shapes[idx];
          const payload = { id: shape.id, type: shape.type, index: idx };
          if (onShapeHover) onShapeHover(payload);
          else if (eventBus) eventBus.emit(`UI:SHAPE_HOVER`, payload);
        }
      }
    },
    [interactive, onShapeHover, eventBus, findShapeAt, shapes]
  );
  const handleClick = useCallback(
    (e) => {
      if (!interactive) return;
      const idx = findShapeAt(e.clientX, e.clientY);
      if (idx >= 0) {
        const shape = shapes[idx];
        const payload = { id: shape.id, type: shape.type, index: idx };
        if (onShapeClick) onShapeClick(payload);
        else if (eventBus) eventBus.emit(`UI:SHAPE_CLICK`, payload);
      }
    },
    [interactive, onShapeClick, eventBus, findShapeAt, shapes]
  );
  if (isLoading || error) {
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: cn("flex w-full items-center justify-center rounded-container bg-[var(--surface-diagram)]", className),
        style: { aspectRatio: `${width} / ${height}` },
        children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: error ? "error" : "muted", children: error ? error.message : t("learningCanvas.loading") })
      }
    );
  }
  const canvas = /* @__PURE__ */ jsx(
    "canvas",
    {
      ref: canvasRef,
      className: cn("mx-auto block touch-none rounded-container", className),
      style: { width: "100%", maxWidth: `min(100%, calc(70vh * ${width} / ${height}))`, height: "auto", aspectRatio: `${width} / ${height}` },
      onClick: handleClick,
      onPointerMove: handlePointerMove,
      role: "img",
      "aria-label": t("aria.learningCanvas"),
      "aria-describedby": description ? descId : void 0,
      ...domPassthrough(rest)
    }
  );
  if (!description) return canvas;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    canvas,
    /* @__PURE__ */ jsx(Box, { id: descId, className: "sr-only", children: description })
  ] });
};
var ErrorState = ({
  title,
  message,
  description,
  onRetry,
  className,
  retryEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleRetry = () => {
    if (retryEvent) eventBus.emit(`UI:${retryEvent}`, {});
    onRetry?.();
  };
  const resolvedTitle = title ?? t("error.generic");
  const resolvedMessage = message ?? description ?? t("error.occurred");
  return /* @__PURE__ */ jsxs(
    VStack,
    {
      ...domPassthrough(rest),
      align: "center",
      className: cn(
        "justify-center py-12 text-center",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Box, { className: "mb-4 rounded-full bg-error/10 p-3", children: /* @__PURE__ */ jsx(Icon, { name: "alert-circle", className: "h-8 w-8 text-error" }) }),
        /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "text-lg text-foreground", children: resolvedTitle }),
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "mt-1 text-muted-foreground max-w-sm", children: resolvedMessage }),
        (onRetry || retryEvent) && /* @__PURE__ */ jsx(Button, { variant: "secondary", className: "mt-4", onClick: handleRetry, children: t("error.retry") })
      ]
    }
  );
};
ErrorState.displayName = "ErrorState";
var DefaultFallback = ({ error, onRetry }) => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    ErrorState,
    {
      title: t("error.somethingWentWrong"),
      message: error.message,
      onRetry
    }
  );
};
var ErrorBoundary = class extends React93__default.Component {
  constructor(props) {
    super(props);
    __publicField(this, "reset", () => {
      this.setState({ error: null });
    });
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    this.props.onError?.(error, errorInfo);
  }
  render() {
    const { error } = this.state;
    const { children, fallback, className } = this.props;
    if (error) {
      const fallbackNode = typeof fallback === "function" ? fallback(error, this.reset) : fallback || /* @__PURE__ */ jsx(DefaultFallback, { error, onRetry: this.reset });
      return className ? /* @__PURE__ */ jsx("div", { className: cn(className), children: fallbackNode }) : fallbackNode;
    }
    return children;
  }
};
__publicField(ErrorBoundary, "displayName", "ErrorBoundary");

// lib/propTypeMismatch.ts
var ACCEPTS_PRIMITIVE = /* @__PURE__ */ new Set(["string", "number", "boolean", "icon", "asset", "date", "node", "component", "sexpr", "function"]);
var ACCEPTS_ARRAY = /* @__PURE__ */ new Set(["array", "node", "sexpr"]);
var ACCEPTS_OBJECT = /* @__PURE__ */ new Set(["object", "node", "component", "sexpr", "icon", "asset", "date"]);
var STRUCTURE = /* @__PURE__ */ new Set(["array", "object"]);
function shapeOf(value) {
  if (typeof value === "string") return "string";
  if (typeof value === "number") return "number";
  if (typeof value === "boolean") return "boolean";
  if (Array.isArray(value)) return "array";
  if (value !== null && typeof value === "object" && Object.getPrototypeOf(value) === Object.prototype) return "object";
  return null;
}
function accepts(types, shape) {
  const set = shape === "array" ? ACCEPTS_ARRAY : shape === "object" ? ACCEPTS_OBJECT : ACCEPTS_PRIMITIVE;
  return types.some((t) => set.has(t));
}
function propTypeMismatches(propsSchema, props, delivered = []) {
  if (!propsSchema) return [];
  const out = [];
  for (const [prop, def] of Object.entries(propsSchema)) {
    if (delivered.includes(prop)) continue;
    const types = def.types;
    const value = props[prop];
    if (value === void 0 || value === null) {
      if (def.required && types && types.length > 0 && types.every((t) => STRUCTURE.has(t))) {
        out.push({ prop, expected: types, got: "missing" });
      }
      continue;
    }
  }
  for (const [prop, value] of Object.entries(props)) {
    if (delivered.includes(prop)) continue;
    const types = propsSchema[prop]?.types;
    if (!types || types.length === 0) continue;
    const shape = shapeOf(value);
    if (shape === null || accepts(types, shape)) continue;
    out.push({ prop, expected: types, got: shape });
  }
  return out;
}
function generateItemId(item, index) {
  if (item.id) return item.id;
  const headerText = item.header ?? item.title;
  if (typeof headerText === "string") {
    return `accordion-${headerText.toLowerCase().replace(/\s+/g, "-")}-${index}`;
  }
  return `accordion-item-${index}`;
}
function normalizeItem(item, index) {
  return {
    ...item,
    id: generateItemId(item, index),
    header: item.header ?? item.title ?? ""
  };
}
var Accordion = ({
  items,
  multiple = false,
  defaultOpenItems,
  defaultOpen,
  openItems: controlledOpenItems,
  onItemToggle,
  className,
  toggleEvent,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const normalizedItems = items.map(
    (item, index) => normalizeItem(item, index)
  );
  const resolveDefaultOpen = () => {
    if (defaultOpenItems) return defaultOpenItems;
    if (defaultOpen) {
      return defaultOpen.filter((index) => index >= 0 && index < normalizedItems.length).map((index) => normalizedItems[index].id);
    }
    return normalizedItems.filter((item) => item.defaultOpen).map((item) => item.id);
  };
  const [internalOpenItems, setInternalOpenItems] = useState(
    new Set(resolveDefaultOpen())
  );
  const openItemsSet = controlledOpenItems ? new Set(controlledOpenItems) : internalOpenItems;
  const handleToggle = (itemId) => {
    const isOpen = openItemsSet.has(itemId);
    const newOpenItems = new Set(openItemsSet);
    if (isOpen) {
      newOpenItems.delete(itemId);
    } else {
      if (!multiple) {
        newOpenItems.clear();
      }
      newOpenItems.add(itemId);
    }
    if (controlledOpenItems === void 0) {
      setInternalOpenItems(newOpenItems);
    }
    onItemToggle?.(itemId, !isOpen);
    if (toggleEvent) eventBus.emit(`UI:${toggleEvent}`, { itemId, isOpen: !isOpen });
  };
  return contentSurface.provide(
    /* @__PURE__ */ jsx(
      "div",
      {
        ...domPassthrough(rest),
        className: cn("w-full divide-y divide-border", contentSurface.className && cn(contentSurface.className, "overflow-hidden"), className),
        children: normalizedItems.map((item) => {
          const isOpen = openItemsSet.has(item.id);
          const isDisabled = item.disabled;
          return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", { className: "overflow-hidden", children: [
            /* @__PURE__ */ jsxs(
              "button",
              {
                type: "button",
                onClick: () => !isDisabled && handleToggle(item.id),
                disabled: isDisabled,
                className: cn(
                  "w-full flex items-center justify-between px-4 py-3",
                  "hover:bg-muted",
                  "transition-colors duration-fast",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset",
                  "disabled:opacity-50 disabled:cursor-not-allowed",
                  isOpen && "bg-muted font-bold"
                ),
                "aria-expanded": isOpen,
                "aria-controls": `accordion-content-${item.id}`,
                children: [
                  /* @__PURE__ */ jsx("div", { className: "flex-1 text-left", children: typeof item.header === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "medium", children: item.header }) : item.header }),
                  /* @__PURE__ */ jsx(
                    Icon,
                    {
                      name: "chevron-down",
                      size: "sm",
                      className: cn(
                        "transition-transform duration-fast",
                        isOpen && "transform rotate-180"
                      )
                    }
                  )
                ]
              }
            ),
            isOpen && /* @__PURE__ */ jsx(
              "div",
              {
                id: `accordion-content-${item.id}`,
                className: "px-4 py-3 border-t-heavy border-border",
                children: item.content
              }
            )
          ] }) }, item.id);
        })
      }
    )
  );
};
Accordion.displayName = "Accordion";
var ActivationBlock = ({
  question,
  savedResponse,
  saveEvent = "SAVE_ACTIVATION",
  className,
  ...rest
}) => {
  const [response, setResponse] = useState(savedResponse ?? "");
  const [isExpanded, setIsExpanded] = useState(!savedResponse);
  const { emit } = useEventBus();
  const { t } = useTranslate();
  const handleSubmit = () => {
    emit(`UI:${saveEvent}`, { response });
    setIsExpanded(false);
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "bg-primary/10 border-heavy border-primary rounded-container p-5 mb-6",
        className
      ),
      children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
        /* @__PURE__ */ jsx(Lightbulb, { className: "text-primary flex-shrink-0 mt-1", size: 24 }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ jsx("h4", { className: "heading-voice text-primary mb-2", children: t("activation.title") }),
          /* @__PURE__ */ jsx("p", { className: "text-foreground mb-3 text-sm md:text-base", children: question }),
          isExpanded ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "textarea",
              {
                className: "w-full p-3 border border-input rounded-interactive bg-card text-foreground focus:ring-2 focus:ring-ring focus:border-transparent text-sm",
                placeholder: t("activation.placeholder"),
                value: response,
                onChange: (e) => setResponse(e.target.value),
                rows: 3
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "flex gap-2 mt-3", children: [
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: handleSubmit,
                  className: "px-4 py-2 bg-primary text-primary-foreground rounded-interactive hover:bg-primary-hover text-sm font-medium transition-colors",
                  children: t("activation.continue")
                }
              ),
              /* @__PURE__ */ jsx(
                "button",
                {
                  onClick: () => {
                    emit(`UI:${saveEvent}`, { response: "" });
                    setIsExpanded(false);
                  },
                  className: "px-4 py-2 text-primary hover:underline text-sm",
                  children: t("activation.skip")
                }
              )
            ] })
          ] }) : /* @__PURE__ */ jsx(
            "button",
            {
              onClick: () => setIsExpanded(true),
              className: "text-sm text-primary hover:underline font-medium",
              children: t("activation.answeredEdit")
            }
          )
        ] })
      ] })
    }
  );
};
ActivationBlock.displayName = "ActivationBlock";
var ICON_NAME_ALIASES = {
  check: "check-circle",
  error: "x-circle",
  warning: "alert-circle"
};
var lookStyles3 = {
  "icon-only": "",
  illustrated: "[&_svg]:w-32 [&_svg]:h-32",
  "text-only": "[&_svg]:hidden",
  mascot: "[&_svg]:w-24 [&_svg]:h-24 [&_svg]:rounded-pill"
};
var EmptyState = ({
  icon,
  title,
  message,
  description,
  actionLabel,
  onAction,
  className,
  destructive,
  variant,
  actionEvent,
  look = "icon-only",
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleAction = () => {
    if (actionEvent) eventBus.emit(`UI:${actionEvent}`, {});
    onAction?.();
  };
  const iconName = typeof icon === "string" ? ICON_NAME_ALIASES[icon] ?? icon : void 0;
  const iconComponent = typeof icon === "function" ? icon : void 0;
  const hasIcon = Boolean(iconName || iconComponent);
  const isDestructive = destructive || variant === "error";
  const isSuccess = variant === "success";
  const displayText = title || message || t("empty.noItems");
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: "contents", ...{ [EMPTY_STATE_MARKER]: "" }, children: /* @__PURE__ */ jsxs(
    VStack,
    {
      align: "center",
      className: cn(
        "justify-center py-12 text-center",
        lookStyles3[look],
        className
      ),
      children: [
        hasIcon && /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "mb-4 rounded-full p-3",
              isDestructive ? "bg-error/10" : isSuccess ? "bg-success/10" : "bg-muted"
            ),
            children: /* @__PURE__ */ jsx(
              Icon,
              {
                ...iconName ? { name: iconName } : { icon: iconComponent },
                className: cn(
                  "h-8 w-8",
                  isDestructive ? "text-error" : isSuccess ? "text-success" : "text-muted-foreground"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "h3",
            className: cn(
              "text-lg",
              isDestructive ? "text-error" : isSuccess ? "text-success" : "text-foreground"
            ),
            children: displayText
          }
        ),
        description && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "mt-1 text-muted-foreground max-w-sm", children: description }),
        actionLabel && (onAction || actionEvent) && /* @__PURE__ */ jsx(
          Button,
          {
            className: "mt-4",
            variant: isDestructive ? "danger" : "primary",
            onClick: handleAction,
            children: actionLabel
          }
        )
      ]
    }
  ) });
};
EmptyState.displayName = "EmptyState";
var Tabs = ({
  items,
  tabs,
  defaultActiveTab,
  activeTab: controlledActiveTab,
  onTabChange,
  tabChangeEvent,
  variant = "default",
  orientation = "horizontal",
  className,
  ...rest
}) => {
  const rawItems = items ?? tabs ?? [];
  const safeItems = rawItems.map(({ id, value, ...rest2 }) => ({
    ...rest2,
    id: id || value || ""
  }));
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const initialActive = safeItems.find((item) => item.active)?.id;
  const [internalActiveTab, setInternalActiveTab] = useState(
    defaultActiveTab || initialActive || safeItems[0]?.id || ""
  );
  const activeTab = controlledActiveTab !== void 0 ? controlledActiveTab : internalActiveTab;
  const tabRefs = useRef({});
  const uid = useId();
  const tabId = (id) => `${uid}-tab-${id}`;
  const panelId = (id) => `${uid}-panel-${id}`;
  const laneRef = useRef(null);
  const [hidden, setHidden] = useState({ start: false, end: false });
  const measure = useCallback(() => {
    const lane = laneRef.current;
    if (!lane || orientation !== "horizontal") return;
    const max = lane.scrollWidth - lane.clientWidth;
    const start = max > 1 && lane.scrollLeft > 1;
    const end = max > 1 && lane.scrollLeft < max - 1;
    setHidden((prev) => prev.start === start && prev.end === end ? prev : { start, end });
  }, [orientation]);
  useLayoutEffect(() => {
    measure();
    const lane = laneRef.current;
    if (!lane || typeof ResizeObserver === "undefined") return void 0;
    const observer2 = new ResizeObserver(measure);
    observer2.observe(lane);
    return () => observer2.disconnect();
  }, [measure, rawItems.length]);
  const scrollLane = (direction) => {
    const lane = laneRef.current;
    if (lane) lane.scrollBy({ left: direction * lane.clientWidth * 0.8, behavior: "smooth" });
  };
  const handleTabChange = (tabId2, tabEvent) => {
    if (controlledActiveTab === void 0) {
      setInternalActiveTab(tabId2);
    }
    onTabChange?.(tabId2);
    if (tabChangeEvent) {
      eventBus.emit(`UI:${tabChangeEvent}`, { tabId: tabId2 });
    }
    if (tabEvent) {
      eventBus.emit(`UI:${tabEvent}`, { tabId: tabId2 });
    }
  };
  const focusTab = (target) => {
    if (!target) return;
    handleTabChange(target.id);
    tabRefs.current[target.id]?.focus();
  };
  const handleKeyDown = (e, index) => {
    const prevKey = orientation === "vertical" ? "ArrowUp" : "ArrowLeft";
    const nextKey = orientation === "vertical" ? "ArrowDown" : "ArrowRight";
    const enabled = safeItems.filter((item) => !item.disabled);
    if (e.key === prevKey || e.key === nextKey) {
      e.preventDefault();
      const step = e.key === prevKey ? -1 : 1;
      for (let i = 1; i <= safeItems.length; i++) {
        const candidate = safeItems[(index + step * i + safeItems.length * i) % safeItems.length];
        if (!candidate.disabled) {
          focusTab(candidate);
          return;
        }
      }
    } else if (e.key === "Home" || e.key === "End") {
      e.preventDefault();
      focusTab(e.key === "Home" ? enabled[0] : enabled[enabled.length - 1]);
    }
  };
  const activeTabContent = safeItems.find((item) => item.id === activeTab)?.content;
  const rendersPanel = activeTabContent !== void 0 && activeTabContent !== null;
  if (safeItems.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("w-full", className), children: /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", className: "py-4", children: t("empty.noItems") }) });
  }
  const variantClasses2 = {
    default: [
      "border-b-[length:var(--border-width)] border-transparent",
      "hover:border-muted-foreground",
      "data-[active=true]:border-primary"
    ].join(" "),
    pills: [
      "rounded-interactive",
      "data-[active=true]:bg-primary",
      "data-[active=true]:text-primary-foreground"
    ].join(" "),
    underline: [
      "border-b-[length:var(--border-width)] border-transparent",
      "data-[active=true]:border-primary"
    ].join(" ")
  };
  const tablist = /* @__PURE__ */ jsx(
    Box,
    {
      ref: laneRef,
      role: "tablist",
      "aria-orientation": orientation,
      onScroll: measure,
      "data-scroll-affordance": hidden.start || hidden.end ? "true" : void 0,
      className: cn(
        "flex",
        // Horizontal tab strip becomes a horizontally-scrollable lane
        // below its container width — phones with many tabs scroll
        // instead of clipping. `snap-x` snaps to each tab; the
        // scrollbar is hidden — the edge chevrons are the affordance.
        orientation === "horizontal" ? "flex-row border-b-[length:var(--border-width)] border-border overflow-x-auto snap-x snap-mandatory [&::-webkit-scrollbar]:hidden" : "flex-col border-r-[length:var(--border-width)] border-border",
        variant === "pills" && "gap-1 p-1 bg-muted border-0 rounded-interactive",
        variant === "underline" && orientation === "vertical" && "border-b-0"
      ),
      children: safeItems.map((item, index) => {
        const isActive = item.id === activeTab;
        const isDisabled = item.disabled;
        return /* @__PURE__ */ jsxs(
          Box,
          {
            as: "button",
            ref: (el) => {
              tabRefs.current[item.id] = el;
            },
            id: tabId(item.id),
            role: "tab",
            "aria-selected": isActive,
            "aria-controls": isActive && rendersPanel ? panelId(item.id) : void 0,
            "aria-disabled": isDisabled,
            tabIndex: isActive ? 0 : -1,
            onClick: () => !isDisabled && handleTabChange(item.id, item.event),
            onKeyDown: (e) => handleKeyDown(e, index),
            "data-active": isActive,
            "data-testid": `tab-${item.id}`,
            className: cn(
              "flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap",
              orientation === "horizontal" && "snap-start shrink-0",
              "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
              isDisabled && "opacity-50 cursor-not-allowed",
              variantClasses2[variant],
              isActive ? variant === "pills" ? "text-primary-foreground" : "text-foreground" : "text-muted-foreground hover:text-foreground"
            ),
            children: [
              item.iconAsset?.url ? /* @__PURE__ */ jsx("img", { src: item.iconAsset.url, alt: item.iconAsset.name ?? item.iconAsset.category ?? "", width: 16, height: 16, style: { imageRendering: "pixelated", objectFit: "contain", width: 16, height: 16 }, className: "flex-shrink-0" }) : item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" })),
              /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "!text-inherit", children: item.label }),
              item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: item.badge })
            ]
          },
          item.id
        );
      })
    }
  );
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("w-full", orientation === "vertical" && "flex flex-row", className), children: [
    orientation === "horizontal" ? /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
      tablist,
      hidden.start && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Box, { className: "pointer-events-none absolute inset-y-0 start-0 w-10 bg-gradient-to-r from-[var(--color-background)] to-transparent rtl:bg-gradient-to-l" }),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            leftIcon: "chevron-left",
            "aria-label": t("tabs.scrollStart"),
            "data-testid": "tabs-scroll-start",
            className: "absolute start-0 top-1/2 -translate-y-1/2 px-1 rtl:rotate-180",
            onClick: () => scrollLane(-1)
          }
        )
      ] }),
      hidden.end && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Box, { className: "pointer-events-none absolute inset-y-0 end-0 w-10 bg-gradient-to-l from-[var(--color-background)] to-transparent rtl:bg-gradient-to-r" }),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            leftIcon: "chevron-right",
            "aria-label": t("tabs.scrollEnd"),
            "data-testid": "tabs-scroll-end",
            className: "absolute end-0 top-1/2 -translate-y-1/2 px-1 rtl:rotate-180",
            onClick: () => scrollLane(1)
          }
        )
      ] })
    ] }) : tablist,
    rendersPanel && /* @__PURE__ */ jsx(
      Box,
      {
        role: "tabpanel",
        id: panelId(activeTab),
        "aria-labelledby": tabId(activeTab),
        tabIndex: 0,
        className: orientation === "vertical" ? "flex-1 min-w-0 ps-4" : "mt-4",
        children: activeTabContent
      }
    )
  ] });
};
Tabs.displayName = "Tabs";
var LoadingState = ({
  title,
  message,
  className,
  fullPage = false,
  ...rest
}) => {
  const { t } = useTranslate();
  const displayMessage = message ?? t("common.loading");
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: "contents", ...{ [LOADING_STATE_MARKER]: "" }, children: /* @__PURE__ */ jsxs(
    VStack,
    {
      align: "center",
      className: cn(
        "justify-center",
        fullPage ? "fixed inset-0 z-[1000] py-12 bg-background/80 backdrop-blur-sm animate-overlay-in" : "py-12",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Spinner, { size: "lg" }),
        title && /* @__PURE__ */ jsx(Typography, { variant: "h3", className: "mt-4 text-lg text-foreground", children: title }),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "small",
            className: cn(
              "text-muted-foreground",
              title ? "mt-2" : "mt-4"
            ),
            children: displayMessage
          }
        )
      ]
    }
  ) });
};
LoadingState.displayName = "LoadingState";
function applyCompletion(code, offset, prefix, label) {
  const at = Math.min(offset, code.length);
  const start = Math.max(0, at - prefix.length);
  return { code: code.slice(0, start) + label + code.slice(at), caret: start + label.length };
}
var REQUEST_DEBOUNCE_MS = 120;
var NAVIGATION_KEYS = /* @__PURE__ */ new Set([
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "Tab",
  "Escape",
  "Enter"
]);
function useCodeCompletion(provider, textareaRef, apply) {
  const [offer, setOffer] = useState(null);
  const [selected, setSelected] = useState(0);
  const narrowed = useRef(false);
  const latest = useRef(0);
  const timer = useRef(null);
  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);
  const ask = useCallback(() => {
    const ta = textareaRef.current;
    if (!provider || !ta) return;
    const id = ++latest.current;
    const code = ta.value;
    const offset = ta.selectionStart;
    void provider(code, offset).then((result) => {
      if (id !== latest.current) return;
      const next = result && result.candidates.length > 0 ? { result, offset, code } : null;
      narrowed.current = next !== null && next.result.prefix.length > 0;
      setOffer(next);
      setSelected(0);
    });
  }, [provider, textareaRef]);
  const dismiss = useCallback(() => {
    latest.current++;
    narrowed.current = false;
    setOffer(null);
  }, []);
  const accept = useCallback((label) => {
    const ta = textareaRef.current;
    if (!offer || !ta) return;
    if (ta.value !== offer.code) {
      dismiss();
      return;
    }
    const next = applyCompletion(ta.value, offer.offset, offer.result.prefix, label);
    dismiss();
    apply(next.code, next.caret);
  }, [offer, textareaRef, apply, dismiss]);
  const onKeyUp = useCallback((e) => {
    if (!provider || NAVIGATION_KEYS.has(e.key) || e.ctrlKey || e.metaKey) return;
    if (offer && textareaRef.current?.value !== offer.code) {
      narrowed.current = false;
      setOffer(null);
    }
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(ask, REQUEST_DEBOUNCE_MS);
  }, [provider, ask, offer, textareaRef]);
  const onKeyDown = useCallback((e) => {
    if (!provider) return false;
    if (e.key === " " && e.ctrlKey) {
      e.preventDefault();
      ask();
      return true;
    }
    const count = offer?.result.candidates.length ?? 0;
    if ((e.key === "ArrowDown" || e.key === "ArrowUp") && count > 0) {
      e.preventDefault();
      setSelected((i) => (i + (e.key === "ArrowDown" ? 1 : count - 1)) % count);
      return true;
    }
    const fresh = offer !== null && textareaRef.current?.value === offer.code;
    const chosen = fresh ? offer.result.candidates[Math.min(selected, count - 1)] : void 0;
    if (e.key === "Tab" && chosen) {
      e.preventDefault();
      accept(chosen.label);
      return true;
    }
    if (e.key === "Escape" && offer) {
      dismiss();
      return true;
    }
    return false;
  }, [provider, offer, selected, ask, accept, dismiss, textareaRef]);
  const isNarrowed = useCallback(() => narrowed.current, []);
  return { offer, selected, isNarrowed, onKeyDown, onKeyUp, accept, dismiss };
}

// lib/codeAssist.ts
function singleChange(prev, next) {
  if (prev === next) return null;
  let start = 0;
  const max = Math.min(prev.length, next.length);
  while (start < max && prev.charCodeAt(start) === next.charCodeAt(start)) start++;
  let endPrev = prev.length;
  let endNext = next.length;
  while (endPrev > start && endNext > start && prev.charCodeAt(endPrev - 1) === next.charCodeAt(endNext - 1)) {
    endPrev--;
    endNext--;
  }
  return { from: start, to: endPrev, text: next.slice(start, endNext) };
}
function remapSuggestions(suggestions, change) {
  const delta = change.text.length - (change.to - change.from);
  const out = [];
  for (const s of suggestions) {
    const typedThrough = s.from === s.to && change.from === s.from && change.to === s.from && change.text.length > 0;
    if (typedThrough) {
      if (s.text.startsWith(change.text) && s.text.length > change.text.length) {
        const at = s.from + change.text.length;
        out.push({ ...s, from: at, to: at, text: s.text.slice(change.text.length) });
      }
      continue;
    }
    if (change.to <= s.from && !(change.from === s.from && change.to === s.from)) out.push({ ...s, from: s.from + delta, to: s.to + delta });
    else if (change.from >= s.to && !(change.from === s.to && change.to === s.to && s.from === s.to)) out.push(s);
  }
  return out;
}
function applySuggestions(code, suggestions, caret) {
  const ordered2 = [...suggestions].sort((a, b) => b.from - a.from);
  let next = code;
  let at = caret;
  for (const s of ordered2) {
    next = next.slice(0, s.from) + s.text + next.slice(s.to);
    if (s.from === s.to && s.from === at) at += s.text.length;
    else if (s.to <= at) at += s.text.length - (s.to - s.from);
    else if (s.from < at) at = s.from + s.text.length;
  }
  return { code: next, caret: at };
}
function orderSuggestions(suggestions, caret) {
  const byPos = [...suggestions].sort((a, b) => a.from - b.from);
  const i = byPos.findIndex((s) => s.from === caret && s.to === caret);
  return i < 0 ? byPos : [byPos[i], ...byPos.slice(0, i), ...byPos.slice(i + 1)];
}

// hooks/useCodeAssist.ts
var IDLE_MS = 600;
var NAVIGATION_KEYS2 = /* @__PURE__ */ new Set([
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "Home",
  "End",
  "PageUp",
  "PageDown",
  "Shift",
  "Control",
  "Alt",
  "Meta",
  "Tab",
  "Escape",
  "CapsLock"
]);
function useCodeAssist(provider, textareaRef, apply, askOnPause = () => true) {
  const [suggestions, setSuggestions] = useState([]);
  const [note, setNote] = useState(null);
  const [asking, setAsking] = useState(null);
  const [atCaret, setAtCaret] = useState(false);
  const latest = useRef(0);
  const timer = useRef(null);
  const current = useRef([]);
  current.current = suggestions;
  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);
  const set = useCallback((next) => {
    current.current = next;
    setSuggestions(next);
  }, []);
  const request = useCallback((kind, trigger) => {
    const ta = textareaRef.current;
    if (!provider || !ta) return;
    if (timer.current) clearTimeout(timer.current);
    const id = ++latest.current;
    const req = { code: ta.value, offset: ta.selectionStart, kind, trigger };
    setAsking(kind);
    void provider(req).then(
      (result) => {
        if (id !== latest.current) return;
        setAsking(null);
        if (textareaRef.current?.value !== req.code) return;
        set(result ? orderSuggestions(result.suggestions, req.offset) : []);
        setAtCaret(kind === "complete");
        setNote(result?.note ?? null);
      },
      () => {
        if (id === latest.current) setAsking(null);
      }
    );
  }, [provider, textareaRef, set]);
  const dismiss = useCallback(() => {
    latest.current++;
    if (timer.current) clearTimeout(timer.current);
    setAsking(null);
    setNote(null);
    set([]);
  }, [set]);
  const commit = useCallback((chosen, rest) => {
    const ta = textareaRef.current;
    if (!ta) return;
    const next = applySuggestions(ta.value, chosen, ta.selectionStart);
    let left = rest;
    for (const s of [...chosen].sort((a, b) => b.from - a.from)) left = remapSuggestions(left, s);
    latest.current++;
    set(left);
    if (left.length === 0) setNote(null);
    apply(next.code, next.caret);
  }, [textareaRef, apply, set]);
  const accept = useCallback((s) => {
    commit([s], current.current.filter((x) => x !== s));
  }, [commit]);
  const acceptAll = useCallback(() => {
    commit(current.current, []);
  }, [commit]);
  const onEdited = useCallback((prev, next) => {
    const change = singleChange(prev, next);
    if (change && current.current.length > 0) set(remapSuggestions(current.current, change));
  }, [set]);
  const onCaretMoved = useCallback((caret) => {
    const first = current.current[0];
    if (atCaret && first && first.from !== caret) set([]);
  }, [atCaret, set]);
  const onKeyUp = useCallback((e) => {
    if (!provider || NAVIGATION_KEYS2.has(e.key) || e.ctrlKey || e.metaKey) return;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      if (askOnPause()) request("complete", "idle");
    }, IDLE_MS);
  }, [provider, request, askOnPause]);
  const onKeyDown = useCallback((e) => {
    if (!provider) return false;
    const mod = e.metaKey || e.ctrlKey;
    if (mod && e.key === ".") {
      e.preventDefault();
      request("fix", "explicit");
      return true;
    }
    if (e.key === " " && e.ctrlKey) {
      request("complete", "explicit");
      return false;
    }
    const pending = current.current;
    if (pending.length === 0) return false;
    if (e.key === "Tab" && !e.shiftKey) {
      e.preventDefault();
      accept(pending[0]);
      return true;
    }
    if (mod && e.key === "Enter") {
      e.preventDefault();
      acceptAll();
      return true;
    }
    if (e.key === "Escape") {
      dismiss();
      return true;
    }
    return false;
  }, [provider, request, accept, acceptAll, dismiss]);
  return { suggestions, note, atCaret, asking, onKeyDown, onKeyUp, onEdited, onCaretMoved, request, accept, acceptAll, dismiss };
}

// lib/codeIdentifiers.ts
var WORD = /[\p{L}\p{N}_]/u;
function isWord(code, i) {
  return i >= 0 && i < code.length && WORD.test(code[i] ?? "");
}
function identifierAt(code, offset) {
  let at = offset;
  if (!isWord(code, at)) {
    if (!isWord(code, at - 1)) return null;
    at -= 1;
  }
  let start = at;
  for (; ; ) {
    while (isWord(code, start - 1)) start -= 1;
    if (code[start - 1] === "." && isWord(code, start - 2)) start -= 1;
    else break;
  }
  let end = at + 1;
  for (; ; ) {
    while (isWord(code, end)) end += 1;
    if (code[end] === "." && isWord(code, end + 1)) end += 1;
    else break;
  }
  return { text: code.slice(start, end), start, end };
}

// lib/codeDiagnostics.ts
var utf16 = (chars) => chars.join("").length;
function diagnosticRanges(code, diagnostics) {
  const lines = code.split("\n");
  const starts = [];
  let at = 0;
  for (const l of lines) {
    starts.push(at);
    at += l.length + 1;
  }
  const out = [];
  for (const d of diagnostics) {
    const i = d.line - 1;
    if (i < 0 || i >= lines.length) continue;
    const chars = Array.from(lines[i]);
    let start;
    let end;
    if (d.column === void 0) {
      start = chars.findIndex((c) => c !== " " && c !== "	");
      if (start < 0) start = chars.length;
      end = chars.length;
      while (end > start && (chars[end - 1] === " " || chars[end - 1] === "	")) end--;
    } else {
      start = Math.min(Math.max(d.column - 1, 0), chars.length);
      const sameLine = d.endLine === void 0 || d.endLine === d.line;
      end = sameLine && d.endColumn !== void 0 ? d.endColumn - 1 : chars.length;
      end = Math.min(Math.max(end, start), chars.length);
      if (end === start && start < chars.length) end = start + 1;
    }
    out.push({
      from: starts[i] + utf16(chars.slice(0, start)),
      to: starts[i] + utf16(chars.slice(0, end)),
      severity: d.severity,
      message: d.message,
      approximate: d.approximate === true
    });
  }
  return out.sort((a, b) => a.from - b.from || a.to - b.to);
}
var rank = (r) => r.severity === "error" ? 1 : 0;
function underlineSegments(code, ranges) {
  const cuts = /* @__PURE__ */ new Set([0, code.length]);
  for (const r of ranges) {
    cuts.add(r.from);
    cuts.add(r.to);
  }
  const points = [...cuts].sort((a, b) => a - b);
  const segments = [];
  for (let k = 0; k < points.length; k++) {
    const from = points[k];
    const markers = ranges.filter((r) => r.from === r.to && r.from === from);
    if (markers.length > 0) {
      segments.push({ text: "", marker: [...markers].sort((a, b) => rank(b) - rank(a))[0] });
    }
    const to = points[k + 1];
    if (to === void 0 || to === from) continue;
    const covering = ranges.filter((r) => r.from <= from && r.to >= to && r.to > r.from);
    const top = [...covering].sort((a, b) => rank(b) - rank(a))[0];
    segments.push(top ? { text: code.slice(from, to), range: top } : { text: code.slice(from, to) });
  }
  return segments;
}
function diagnosticAt(ranges, caret) {
  return [...ranges].filter((r) => r.from <= caret && caret <= r.to).sort((a, b) => rank(b) - rank(a))[0];
}
function remapRanges(basis, current, ranges) {
  const change = singleChange(basis, current);
  if (!change) return [...ranges];
  const delta = change.text.length - (change.to - change.from);
  const out = [];
  for (const r of ranges) {
    if (r.to < change.from || r.to === change.from && r.from < r.to) out.push(r);
    else if (r.from > change.to || r.from === change.to && change.to > change.from) out.push({ ...r, from: r.from + delta, to: r.to + delta });
  }
  return out;
}
function isMotionPayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.motion === "string" && typeof payload.count === "number";
}
function isOperatePayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.operator === "string" && typeof payload.motion === "string" && typeof payload.count === "number";
}
function isInsertTextPayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.text === "string";
}
function isSetModePayload(payload) {
  return !!payload && typeof payload.editorId === "string" && typeof payload.mode === "string" && typeof payload.caret === "string";
}
function typedDelta(prev, next) {
  const maxPrefix = Math.min(prev.length, next.length);
  let prefixLen = 0;
  while (prefixLen < maxPrefix && prev[prefixLen] === next[prefixLen]) prefixLen++;
  const maxSuffix = Math.min(prev.length - prefixLen, next.length - prefixLen);
  let suffixLen = 0;
  while (suffixLen < maxSuffix && prev[prev.length - 1 - suffixLen] === next[next.length - 1 - suffixLen]) {
    suffixLen++;
  }
  const removed = prev.slice(prefixLen, prev.length - suffixLen);
  const inserted = next.slice(prefixLen, next.length - suffixLen);
  return removed + inserted;
}
function useEditorCapabilities(args) {
  const [caretMode, setCaretMode] = useState("bar");
  const registerRef = useRef("");
  const registerLinewiseRef = useRef(false);
  const pastRef = useRef([]);
  const futureRef = useRef([]);
  const openTypingStepRef = useRef(false);
  const insertSessionOpenRef = useRef(false);
  const closeOpenTypingStep = useCallback(() => {
    openTypingStepRef.current = false;
  }, []);
  const pushHistoryStep = useCallback(
    (text, caret) => {
      closeOpenTypingStep();
      pastRef.current.push({ text, caret });
      futureRef.current = [];
    },
    [closeOpenTypingStep]
  );
  const recordKeystroke = useCallback(
    (prevText, prevCaret, nextText) => {
      if (!openTypingStepRef.current) {
        pastRef.current.push({ text: prevText, caret: prevCaret });
        futureRef.current = [];
        openTypingStepRef.current = true;
      }
      if (!insertSessionOpenRef.current && /\s/.test(typedDelta(prevText, nextText))) {
        openTypingStepRef.current = false;
      }
    },
    []
  );
  const performUndo = useCallback(
    (count) => {
      const ta = args.textareaRef.current;
      if (!ta) return;
      closeOpenTypingStep();
      let moved = false;
      for (let i = 0; i < Math.max(1, count) && pastRef.current.length > 0; i++) {
        const prev = pastRef.current.pop();
        futureRef.current.push({ text: ta.value, caret: ta.selectionStart });
        ta.value = prev.text;
        ta.setSelectionRange(prev.caret, prev.caret);
        moved = true;
      }
      if (moved) args.applyChange(ta.value, "capability");
    },
    [args, closeOpenTypingStep]
  );
  const performRedo = useCallback(
    (count) => {
      const ta = args.textareaRef.current;
      if (!ta) return;
      closeOpenTypingStep();
      let moved = false;
      for (let i = 0; i < Math.max(1, count) && futureRef.current.length > 0; i++) {
        const next = futureRef.current.pop();
        pastRef.current.push({ text: ta.value, caret: ta.selectionStart });
        ta.value = next.text;
        ta.setSelectionRange(next.caret, next.caret);
        moved = true;
      }
      if (moved) args.applyChange(ta.value, "capability");
    },
    [args, closeOpenTypingStep]
  );
  const undo = useCallback(() => performUndo(1), [performUndo]);
  const redo = useCallback(() => performRedo(1), [performRedo]);
  const wasFocusedRef = useRef(args.focused);
  useEffect(() => {
    if (wasFocusedRef.current && !args.focused) {
      setCaretMode("bar");
    }
    wasFocusedRef.current = args.focused;
  }, [args.focused]);
  useEventListener(`UI:${args.events.onMotion}`, (evt) => {
    if (!args.editorId || !isMotionPayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const { motion, count } = evt.payload;
    if (!isEditorMotion(motion)) {
      console.warn(`useEditorCapabilities: ignoring MOTION with unknown motion "${motion}"`);
      return;
    }
    const ta = args.textareaRef.current;
    if (!ta) return;
    const selecting = ta.selectionStart !== ta.selectionEnd;
    const backward = ta.selectionDirection === "backward";
    const moving = selecting && !backward ? ta.selectionEnd : ta.selectionStart;
    const newCaret = applyMotion(ta.value, moving, motion, count);
    if (selecting) {
      const anchor = backward ? ta.selectionEnd : ta.selectionStart;
      ta.setSelectionRange(Math.min(anchor, newCaret), Math.max(anchor, newCaret), newCaret < anchor ? "backward" : "forward");
    } else {
      ta.setSelectionRange(newCaret, newCaret);
    }
    args.onCaret?.(newCaret);
  });
  useEventListener(`UI:${args.events.onOperate}`, (evt) => {
    if (!args.editorId || !isOperatePayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const { operator, motion, count } = evt.payload;
    if (!isEditorOperator(operator)) {
      console.warn(`useEditorCapabilities: ignoring OPERATE with unknown operator "${operator}"`);
      return;
    }
    if (!isEditorMotion(motion)) {
      console.warn(`useEditorCapabilities: ignoring OPERATE with unknown motion "${motion}"`);
      return;
    }
    const ta = args.textareaRef.current;
    if (!ta) return;
    if (operator === "undo") {
      performUndo(count);
      return;
    }
    if (operator === "redo") {
      performRedo(count);
      return;
    }
    pushHistoryStep(ta.value, ta.selectionStart);
    const selection = motion === "selection" ? [ta.selectionStart, ta.selectionEnd] : void 0;
    const range = motionRange(ta.value, ta.selectionStart, motion, count, selection);
    const result = applyOperator({
      text: ta.value,
      caret: ta.selectionStart,
      range,
      operator,
      motion,
      count,
      register: registerRef.current,
      registerLinewise: registerLinewiseRef.current
    });
    registerRef.current = result.register;
    registerLinewiseRef.current = result.registerLinewise;
    if (operator === "yank") {
      ta.setSelectionRange(result.caret, result.caret);
      args.onCaret?.(result.caret);
    } else {
      ta.value = result.text;
      ta.setSelectionRange(result.caret, result.caret);
    }
    args.applyChange(ta.value, "capability");
  });
  useEventListener(`UI:${args.events.onInsertText}`, (evt) => {
    if (!args.editorId || !isInsertTextPayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    const ta = args.textareaRef.current;
    if (!ta) return;
    pushHistoryStep(ta.value, ta.selectionStart);
    ta.setRangeText(evt.payload.text, ta.selectionStart, ta.selectionEnd, "end");
    args.applyChange(ta.value, "capability");
  });
  useEventListener(`UI:${args.events.onSetMode}`, (evt) => {
    if (!args.editorId || !isSetModePayload(evt.payload) || evt.payload.editorId !== args.editorId) return;
    closeOpenTypingStep();
    insertSessionOpenRef.current = evt.payload.mode === "INSERT";
    setCaretMode(evt.payload.caret);
  });
  return { caretMode, recordKeystroke, undo, redo };
}
SyntaxHighlighter.registerLanguage("json", langJson);
SyntaxHighlighter.registerLanguage("javascript", langJavascript);
SyntaxHighlighter.registerLanguage("js", langJavascript);
SyntaxHighlighter.registerLanguage("typescript", langTypescript);
SyntaxHighlighter.registerLanguage("ts", langTypescript);
SyntaxHighlighter.registerLanguage("jsx", langJsx);
SyntaxHighlighter.registerLanguage("tsx", langTsx);
SyntaxHighlighter.registerLanguage("css", langCss);
SyntaxHighlighter.registerLanguage("markdown", langMarkdown);
SyntaxHighlighter.registerLanguage("md", langMarkdown);
SyntaxHighlighter.registerLanguage("bash", langBash);
SyntaxHighlighter.registerLanguage("shell", langBash);
SyntaxHighlighter.registerLanguage("sh", langBash);
SyntaxHighlighter.registerLanguage("yaml", langYaml);
SyntaxHighlighter.registerLanguage("yml", langYaml);
SyntaxHighlighter.registerLanguage("rust", langRust);
SyntaxHighlighter.registerLanguage("python", langPython);
SyntaxHighlighter.registerLanguage("py", langPython);
SyntaxHighlighter.registerLanguage("sql", langSql);
SyntaxHighlighter.registerLanguage("diff", langDiff);
SyntaxHighlighter.registerLanguage("toml", langToml);
SyntaxHighlighter.registerLanguage("go", langGo);
SyntaxHighlighter.registerLanguage("graphql", langGraphql);
SyntaxHighlighter.registerLanguage("clojure", langClojure);
SyntaxHighlighter.registerLanguage("clj", langClojure);
SyntaxHighlighter.registerLanguage("edn", langClojure);
SyntaxHighlighter.registerLanguage("haskell", langHaskell);
SyntaxHighlighter.registerLanguage("hs", langHaskell);
SyntaxHighlighter.registerLanguage("lisp", langLisp);
SyntaxHighlighter.registerLanguage("scheme", langScheme);
SyntaxHighlighter.registerLanguage("scala", langScala);
SyntaxHighlighter.registerLanguage("elixir", langElixir);
SyntaxHighlighter.registerLanguage("ex", langElixir);
SyntaxHighlighter.registerLanguage("exs", langElixir);
SyntaxHighlighter.registerLanguage("erlang", langErlang);
SyntaxHighlighter.registerLanguage("erl", langErlang);
SyntaxHighlighter.registerLanguage("elm", langElm);
SyntaxHighlighter.registerLanguage("fsharp", langFsharp);
SyntaxHighlighter.registerLanguage("fs", langFsharp);
SyntaxHighlighter.registerLanguage("fsx", langFsharp);
SyntaxHighlighter.registerLanguage("ocaml", langOcaml);
SyntaxHighlighter.registerLanguage("ml", langOcaml);
SyntaxHighlighter.registerLanguage("java", langJava);
SyntaxHighlighter.registerLanguage("c", langC);
SyntaxHighlighter.registerLanguage("cpp", langCpp);
SyntaxHighlighter.registerLanguage("c++", langCpp);
SyntaxHighlighter.registerLanguage("cc", langCpp);
SyntaxHighlighter.registerLanguage("cxx", langCpp);
SyntaxHighlighter.registerLanguage("hpp", langCpp);
SyntaxHighlighter.registerLanguage("h", langCpp);
SyntaxHighlighter.registerLanguage("csharp", langCsharp);
SyntaxHighlighter.registerLanguage("cs", langCsharp);
SyntaxHighlighter.registerLanguage("objectivec", langObjectivec);
SyntaxHighlighter.registerLanguage("objc", langObjectivec);
SyntaxHighlighter.registerLanguage("php", langPhp);
SyntaxHighlighter.registerLanguage("ruby", langRuby);
SyntaxHighlighter.registerLanguage("rb", langRuby);
SyntaxHighlighter.registerLanguage("swift", langSwift);
SyntaxHighlighter.registerLanguage("kotlin", langKotlin);
SyntaxHighlighter.registerLanguage("kt", langKotlin);
SyntaxHighlighter.registerLanguage("lua", langLua);
SyntaxHighlighter.registerLanguage("r", langR);
SyntaxHighlighter.registerLanguage("dart", langDart);
SyntaxHighlighter.registerLanguage("julia", langJulia);
SyntaxHighlighter.registerLanguage("fortran", langFortran);
SyntaxHighlighter.registerLanguage("f90", langFortran);
SyntaxHighlighter.registerLanguage("f95", langFortran);
SyntaxHighlighter.registerLanguage("perl", langPerl);
SyntaxHighlighter.registerLanguage("pl", langPerl);
SyntaxHighlighter.registerLanguage("powershell", langPowershell);
SyntaxHighlighter.registerLanguage("ps1", langPowershell);
SyntaxHighlighter.registerLanguage("makefile", langMakefile);
SyntaxHighlighter.registerLanguage("make", langMakefile);
SyntaxHighlighter.registerLanguage("nginx", langNginx);
SyntaxHighlighter.registerLanguage("ini", langIni);
SyntaxHighlighter.registerLanguage("clike", langClike);
SyntaxHighlighter.registerLanguage("orb", orbLanguage);
SyntaxHighlighter.registerLanguage("lolo", loloLanguage);
var dynamicallyLoaded = /* @__PURE__ */ new Set();
var codeLanguageLoader = null;
function registerCodeLanguageLoader(loader) {
  codeLanguageLoader = loader;
}
function isLanguageRegistered(lang) {
  return CODE_LANGUAGE_SET.has(lang) || dynamicallyLoaded.has(lang);
}
async function loadPrismLanguage(lang) {
  if (isLanguageRegistered(lang)) return;
  try {
    const grammar = codeLanguageLoader ? await codeLanguageLoader(lang) : null;
    SyntaxHighlighter.registerLanguage(lang, grammar ?? langClike);
    dynamicallyLoaded.add(lang);
  } catch {
    dynamicallyLoaded.add(lang);
  }
}
var orbStyleOverrides = (c) => ({
  "orb-binding": { color: c.binding, fontWeight: "bold" },
  "orb-effect": { color: c.effect, fontWeight: "bold" },
  "orb-event": { color: c.event },
  "orb-slot": { color: c.uiSlot },
  "orb-structural": { color: c.structural },
  "orb-field-type": { color: c.fieldType },
  "orb-persistence": { color: c.persistence },
  "orb-pattern": { color: c.pattern },
  "orb-behavior": { color: c.behavior },
  "orb-unknown-op": { color: c.error, textDecoration: "wavy underline" },
  "orb-op-arithmetic": { color: c.arithmetic, fontWeight: "bold" },
  "orb-op-comparison": { color: c.comparison },
  "orb-op-logic": { color: c.logic },
  "orb-op-string": { color: c.string },
  "orb-op-collection": { color: c.collection },
  "orb-op-time": { color: c.time },
  "orb-op-control": { color: c.control },
  "orb-op-async": { color: c.async }
});
var loloStyleOverrides = (c) => ({
  "lolo-binding": { color: c.binding, fontWeight: "bold" },
  "lolo-event": { color: c.event },
  "lolo-effect": { color: c.effect, fontWeight: "bold" },
  "keyword": { color: c.loloKeyword },
  "lolo-constructor": { color: c.loloConstructor },
  "lolo-arrow": { color: c.loloArrow },
  "lolo-reference": { color: c.loloReference },
  "lolo-type": { color: c.fieldType },
  "lolo-persistence": { color: c.persistence },
  "lolo-unknown-op": { color: c.error },
  "lolo-op-arithmetic": { color: c.arithmetic, fontWeight: "bold" },
  "lolo-op-comparison": { color: c.comparison },
  "lolo-op-logic": { color: c.logic },
  "lolo-op-string": { color: c.string },
  "lolo-op-collection": { color: c.collection },
  "lolo-op-time": { color: c.time },
  "lolo-op-control": { color: c.control },
  "lolo-op-async": { color: c.async }
});
var SCHEME_BASE = { dark, light };
var HIGHLIGHT_STYLES = {
  dark: {
    orb: { ...dark, ...orbStyleOverrides(ORB_COLORS.dark) },
    lolo: { ...dark, ...loloStyleOverrides(ORB_COLORS.dark) }
  },
  light: {
    orb: { ...light, ...orbStyleOverrides(ORB_COLORS.light) },
    lolo: { ...light, ...loloStyleOverrides(ORB_COLORS.light) }
  }
};
function computeFoldRegions(code) {
  const lines = code.split("\n");
  const regions = [];
  const stack = [];
  for (let i = 0; i < lines.length; i++) {
    const line2 = lines[i];
    let inString = false;
    for (let j = 0; j < line2.length; j++) {
      const ch = line2[j];
      if (ch === "\\" && inString) {
        j++;
        continue;
      }
      if (ch === '"') {
        inString = !inString;
        continue;
      }
      if (inString) continue;
      if (ch === "{" || ch === "[") {
        stack.push({ line: i, bracket: ch });
      } else if (ch === "}" || ch === "]") {
        const open = stack.pop();
        if (open && open.line < i) {
          regions.push({
            start: open.line,
            end: i,
            closeBracket: ch
          });
        }
      }
    }
  }
  return regions.sort((a, b) => a.start - b.start);
}
var MONO_EDITOR_FONT = 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace';
var GHOST_COLOR = "#7f848e";
var GUTTER_COLOR = "#858585";
var caretOf = (ta) => ta.selectionDirection === "backward" ? ta.selectionStart : ta.selectionEnd;
function withTokenTypes(node) {
  if (node.type !== "element") return node;
  const classes = node.properties?.className;
  return {
    ...node,
    ...node.properties ? { properties: { ...node.properties, ...Array.isArray(classes) && classes.length > 0 ? { "data-token": classes.join(" ") } : {} } } : {},
    ...node.children ? { children: node.children.map(withTokenTypes) } : {}
  };
}
function renderWithTokenTypes({ rows: rows2, stylesheet, useInlineStyles }) {
  return rows2.map((node, i) => createHighlightElement({ node: withTokenTypes(node), stylesheet, useInlineStyles, key: `code-segment-${i}` }));
}
var LTR_WORD = /[A-Za-z0-9_$@?][A-Za-z0-9_$@?.!-]*/g;
var LTR_ISLAND_STYLE = { unicodeBidi: "isolate", direction: "ltr" };
var STRING_ISLAND_STYLE = { unicodeBidi: "plaintext" };
function island(value, style) {
  return { type: "element", tagName: "span", properties: { className: [], "data-bidi-island": "", style }, children: [{ type: "text", value }] };
}
function splitLtrWords(value) {
  const out = [];
  let last = 0;
  for (const match of value.matchAll(LTR_WORD)) {
    const start = match.index ?? 0;
    if (start > last) out.push({ type: "text", value: value.slice(last, start) });
    out.push(island(match[0], LTR_ISLAND_STYLE));
    last = start + match[0].length;
  }
  if (last < value.length) out.push({ type: "text", value: value.slice(last) });
  return out;
}
function withBidiIslands(node) {
  if (node.type === "text") return splitLtrWords(String(node.value ?? ""));
  if (node.type !== "element") return [node];
  const classes = node.properties?.className;
  if (Array.isArray(classes) && classes.includes("string")) {
    return [{ ...node, properties: { ...node.properties, className: classes, "data-bidi-island": "", style: STRING_ISLAND_STYLE } }];
  }
  return [{ ...node, ...node.children ? { children: node.children.flatMap(withBidiIslands) } : {} }];
}
function renderRtlCode({ rows: rows2, stylesheet, useInlineStyles }) {
  return rows2.map(
    (node, i) => withBidiIslands(node).map((n, j) => createHighlightElement({ node: n, stylesheet, useInlineStyles, key: `code-rtl-${i}-${j}` }))
  );
}
function tokenClassAt(layer, offset) {
  const walker = document.createTreeWalker(layer, NodeFilter.SHOW_TEXT);
  let pos = 0;
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    const length = node.textContent?.length ?? 0;
    if (offset < pos + length) return node.parentElement?.closest("[data-token]")?.getAttribute("data-token") ?? "";
    pos += length;
  }
  return "";
}
function offsetUnderPointer(ta, layer, x, y) {
  if (!layer || typeof document.caretRangeFromPoint !== "function") return null;
  const previous = ta.style.pointerEvents;
  ta.style.pointerEvents = "none";
  const range = document.caretRangeFromPoint(x, y);
  ta.style.pointerEvents = previous;
  if (!range || !layer.contains(range.startContainer)) return null;
  const walker = document.createTreeWalker(layer, NodeFilter.SHOW_TEXT);
  let pos = 0;
  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (node === range.startContainer) return pos + range.startOffset;
    pos += node.textContent?.length ?? 0;
  }
  return null;
}
var DIAGNOSTIC_ERROR_COLOR = "#f14c4c";
var DIAGNOSTIC_WARNING_COLOR = "#cca700";
var EDITOR_LINE_PX = 19.5;
var log3 = createLogger("almadar:ui:markdown-code");
var CODE_LANGUAGES = [
  "text",
  "json",
  "javascript",
  "js",
  "typescript",
  "ts",
  "jsx",
  "tsx",
  "css",
  "markdown",
  "md",
  "bash",
  "shell",
  "sh",
  "yaml",
  "yml",
  "rust",
  "python",
  "py",
  "sql",
  "diff",
  "toml",
  "go",
  "graphql",
  "html",
  "xml",
  "clojure",
  "clj",
  "edn",
  "haskell",
  "hs",
  "lisp",
  "scheme",
  "scala",
  "elixir",
  "ex",
  "exs",
  "erlang",
  "erl",
  "elm",
  "fsharp",
  "fs",
  "fsx",
  "ocaml",
  "ml",
  "java",
  "c",
  "cpp",
  "c++",
  "cc",
  "cxx",
  "hpp",
  "h",
  "csharp",
  "cs",
  "objectivec",
  "objc",
  "php",
  "ruby",
  "rb",
  "swift",
  "kotlin",
  "kt",
  "lua",
  "r",
  "dart",
  "julia",
  "fortran",
  "f90",
  "f95",
  "perl",
  "pl",
  "powershell",
  "ps1",
  "makefile",
  "make",
  "nginx",
  "ini",
  "orb",
  "lolo"
];
var CODE_LANGUAGE_SET = new Set(CODE_LANGUAGES);
function toCodeLanguage(value) {
  if (!value) return "text";
  return value.toLowerCase();
}
function generateDiff(oldVal, newVal) {
  return computeLineDiff(oldVal, newVal).map((line2) => ({
    type: line2.type,
    content: line2.content,
    lineNumber: line2.afterLineNumber ?? line2.beforeLineNumber
  }));
}
var DIFF_STYLES = {
  add: { bg: "bg-success/10", prefix: "+", text: "text-success" },
  added: { bg: "bg-success/10", prefix: "+", text: "text-success" },
  remove: { bg: "bg-error/10", prefix: "-", text: "text-error" },
  removed: { bg: "bg-error/10", prefix: "-", text: "text-error" },
  context: { bg: "", prefix: " ", text: "text-foreground" },
  unchanged: { bg: "", prefix: " ", text: "text-foreground" }
};
var DIFF_STYLE_FALLBACK = { bg: "", prefix: " ", text: "text-foreground" };
var LINE_PROPS_FN = (n) => ({ "data-line": String(n - 1) });
var HIDDEN_LINE_NUMBERS = { display: "none" };
var HIGHLIGHT_CAPACITY_BYTES = 512 * 1024;
var PLAIN_CODE_CHUNK_LINES = 400;
function PlainCodeChunks({ code, style }) {
  const { chunks, widest } = useMemo(() => {
    const lines = code.split("\n");
    const out = [];
    for (let i = 0; i < lines.length; i += PLAIN_CODE_CHUNK_LINES) {
      const slice = lines.slice(i, i + PLAIN_CODE_CHUNK_LINES);
      out.push({ text: slice.join("\n"), lines: slice.length });
    }
    return { chunks: out, widest: lines.reduce((w, l) => Math.max(w, l.length), 0) };
  }, [code]);
  return /* @__PURE__ */ jsx(Box, { style: { ...style, minWidth: `max(100%, ${widest}ch)` }, children: chunks.map((chunk, i) => /* @__PURE__ */ jsx(
    Box,
    {
      "data-code-chunk": i,
      style: { contentVisibility: "auto", containIntrinsicBlockSize: `auto ${chunk.lines}lh` },
      children: chunk.text
    },
    i
  )) });
}
function overlayText(value) {
  return value === "" || value.endsWith("\n") ? `${value} ` : value;
}
function useLanguageReady(language) {
  const [ready, setReady] = useState(() => isLanguageRegistered(language));
  useEffect(() => {
    if (isLanguageRegistered(language)) {
      if (!ready) setReady(true);
      return;
    }
    let active = true;
    loadPrismLanguage(language).then(() => {
      if (active) setReady(true);
    });
    return () => {
      active = false;
    };
  }, [language]);
  return ready;
}
var MONO_FONT_FAMILY = 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", "IBM Plex Sans Arabic", "Noto Sans Arabic", monospace';
function resolveHighlightStyle(lang, scheme) {
  if (lang === "orb" || lang === "lolo") return HIGHLIGHT_STYLES[scheme][lang];
  return SCHEME_BASE[scheme];
}
function plainCodeColorOf(style) {
  return style['code[class*="language-"]']?.color ?? "#d4d4d4";
}
function buildLineProps(errorLines, extraClassName) {
  return (lineNumber) => {
    const base = {
      "data-line": String(lineNumber - 1),
      ...extraClassName ? { className: extraClassName } : {}
    };
    const severity = errorLines?.get(lineNumber);
    if (!severity) return base;
    return {
      ...base,
      style: {
        display: "block",
        backgroundColor: severity === "error" ? "rgba(248, 113, 113, 0.18)" : "rgba(251, 191, 36, 0.18)",
        // amber-400 @ 18%
        borderLeft: `3px solid ${severity === "error" ? "#ef4444" : "#f59e0b"}`,
        paddingLeft: "0.5rem",
        marginLeft: "-0.5rem"
      }
    };
  };
}
var VIEWER_LINE_NUMBER_STYLE = {
  minWidth: "2.5em",
  paddingRight: "1rem",
  textAlign: "right",
  userSelect: "none",
  opacity: 0.5,
  fontVariantNumeric: "tabular-nums"
};
var VIEWER_LINE_NUMBER_STYLE_RTL = {
  minWidth: "2.5em",
  paddingRight: 0,
  paddingLeft: "1rem",
  textAlign: "left",
  userSelect: "none",
  opacity: 0.5,
  fontVariantNumeric: "tabular-nums"
};
function translateProgram(source, language, lang) {
  if (lang === "en") return source;
  if (language === "lolo") return translateLolo(source, lang);
  if (language === "orb") {
    const translated = translateOrb(source, lang);
    return typeof translated === "string" ? translated : source;
  }
  return source;
}
var CodeBlock = React93__default.memo(
  ({
    code: rawCode,
    language = "text",
    showCopyButton = true,
    showLanguageBadge = true,
    maxHeight = "60vh",
    foldable: foldableProp,
    className,
    editable = false,
    onChange,
    errorLines,
    completions,
    assist: assistProvider,
    problems,
    diagnostics,
    definitionAt,
    onGoToDefinition,
    diagnosticsCode,
    lineNumbers,
    // viewer props
    title,
    mode = "code",
    diff: propDiff,
    oldValue,
    newValue,
    showLineNumbers = false,
    wordWrap = false,
    files,
    naturalLanguages,
    actions,
    isLoading = false,
    error,
    showCopy,
    // editor capability surface — P1 wires these
    editorId,
    onEditorFocus = "EDITOR_FOCUS",
    onEditorBlur = "EDITOR_BLUR",
    onMotion = "MOTION",
    onOperate = "OPERATE",
    onInsertText = "INSERT_TEXT",
    onSetMode = "SET_MODE",
    motions = [
      "left",
      "right",
      "up",
      "down",
      "word-forward",
      "word-back",
      "word-end",
      "line-start",
      "line-end",
      "first-nonblank",
      "doc-start",
      "doc-end",
      "paragraph-forward",
      "paragraph-back",
      "line",
      "selection",
      "match-bracket"
    ],
    operators = [
      "delete",
      "yank",
      "change",
      "put",
      "put-before",
      "undo",
      "redo",
      "join",
      "toggle-case",
      "indent",
      "dedent",
      "replace"
    ],
    ...a11yRest
  }) => {
    const englishCode = typeof rawCode === "string" ? rawCode : String(rawCode ?? "");
    const naturalTabs = !editable && naturalLanguages && naturalLanguages.length > 1 ? naturalLanguages : void 0;
    const { locale: pageLocale } = useTranslate();
    const [naturalLanguage, setNaturalLanguage] = useState(
      () => naturalTabs?.find((lang) => lang === pageLocale) ?? naturalTabs?.[0] ?? "en"
    );
    const activeNaturalLanguage = naturalTabs?.includes(naturalLanguage) === true ? naturalLanguage : naturalTabs?.[0] ?? "en";
    const codeDir = naturalTabs && coreTables[activeNaturalLanguage].meta.rtl ? "rtl" : "ltr";
    const translationCache = useMemo(() => /* @__PURE__ */ new Map(), [englishCode, files]);
    const translateFor = useCallback(
      (source, sourceLanguage, cacheKey) => {
        if (activeNaturalLanguage === "en") return source;
        const key = `${cacheKey}|${sourceLanguage}|${activeNaturalLanguage}`;
        const hit = translationCache.get(key);
        if (hit !== void 0) return hit;
        const translated = translateProgram(source, sourceLanguage, activeNaturalLanguage);
        translationCache.set(key, translated);
        return translated;
      },
      [translationCache, activeNaturalLanguage]
    );
    const code = translateFor(englishCode, language, "code");
    const naturalTabItems = naturalTabs?.map((lang) => ({
      id: `lang-${lang}`,
      label: coreTables[lang].meta.name,
      content: null
    }));
    const naturalTabStrip = naturalTabs && naturalTabItems ? /* @__PURE__ */ jsx(
      Box,
      {
        className: "border-b border-border",
        dir: coreTables[activeNaturalLanguage].meta.rtl ? "rtl" : "ltr",
        "data-testid": "codeblock-language-tabs",
        children: /* @__PURE__ */ jsx(
          Tabs,
          {
            tabs: naturalTabItems,
            activeTab: `lang-${activeNaturalLanguage}`,
            onTabChange: (id) => {
              const next = naturalTabs.find((lang) => `lang-${lang}` === id);
              if (next) setNaturalLanguage(next);
            }
          }
        )
      }
    ) : null;
    const activeStyle = resolveHighlightStyle(language, "dark");
    const overCapacity = code.length > HIGHLIGHT_CAPACITY_BYTES;
    const plainCodeColor = plainCodeColorOf(activeStyle);
    const eventBus = useEventBus();
    const { t } = useTranslate();
    const resolvedMode = useScopedMode();
    const scrollRef = useRef(null);
    const codeRef = useRef(null);
    const savedScrollLeftRef = useRef(0);
    const [copied, setCopied] = useState(false);
    const [wrap, setWrap] = useState(wordWrap);
    const [activeFileIndex, setActiveFileIndex] = useState(0);
    const activeFile = files?.[activeFileIndex];
    const activeLanguage = activeFile?.language ?? language;
    const activeCode = activeFile ? translateFor(activeFile.code, activeLanguage, `file-${activeFileIndex}`) : code;
    const languageReady = useLanguageReady(activeLanguage);
    const viewerStyle = resolveHighlightStyle(activeLanguage, resolvedMode);
    const viewerPlainCodeColor = plainCodeColorOf(viewerStyle);
    const diffLines = useMemo(() => {
      if (propDiff && propDiff.length > 0) return propDiff;
      if (mode === "diff" && oldValue !== void 0 && newValue !== void 0) {
        return generateDiff(oldValue, newValue);
      }
      return null;
    }, [propDiff, mode, oldValue, newValue]);
    const isViewerMode = !!(title || files && files.length > 0 || showLineNumbers || diffLines || mode === "diff" || actions);
    const effectiveCopy = showCopy ?? showCopyButton;
    const [editableValue, setEditableValue] = useState(code);
    const [editableTextareaKey, setEditableTextareaKey] = useState(0);
    const lastPropCodeRef = useRef(code);
    const editableTextareaRef = useRef(null);
    const highlightLayerRef = useRef(null);
    const [definitionHover, setDefinitionHover] = useState(null);
    const definitionAtOffset = useCallback((code2, offset) => {
      if (!definitionAt) return null;
      const id = identifierAt(code2, offset);
      if (!id) return null;
      const layer = highlightLayerRef.current;
      if (layer && /\b(comment|string)\b/.test(tokenClassAt(layer, id.start))) return null;
      return definitionAt(id.text) ? id : null;
    }, [definitionAt]);
    const editableOverlayRef = useRef(null);
    const [isFocused, setIsFocused] = useState(false);
    const prevCaretRef = useRef(0);
    const [caretIndex, setCaretIndex] = useState(0);
    const caretMirrorRef = useRef(null);
    const caretMarkerRef = useRef(null);
    const [caretGeometry, setCaretGeometry] = useState(null);
    useEffect(() => {
      if (code !== lastPropCodeRef.current) {
        lastPropCodeRef.current = code;
        setEditableValue(code);
        setEditableTextareaKey((k) => k + 1);
      }
    }, [code]);
    const editableGutterRef = useRef(null);
    const [scrollTick, setScrollTick] = useState(0);
    const handleEditableScroll = useCallback(() => {
      const ta = editableTextareaRef.current;
      const ov = editableOverlayRef.current;
      if (ta && ov) {
        ov.scrollTop = ta.scrollTop;
        ov.scrollLeft = ta.scrollLeft;
      }
      if (ta && editableGutterRef.current) editableGutterRef.current.scrollTop = ta.scrollTop;
      setScrollTick((n) => n + 1);
    }, []);
    const handleEditableChange = useCallback((v, _origin) => {
      lastPropCodeRef.current = v;
      setEditableValue(v);
      const ta = editableTextareaRef.current;
      if (ta) setCaretIndex(caretOf(ta));
      onChange?.(v);
    }, [onChange]);
    const { caretMode, recordKeystroke, undo, redo } = useEditorCapabilities({
      editorId: editable ? editorId : void 0,
      textareaRef: editableTextareaRef,
      events: { onMotion, onOperate, onInsertText, onSetMode },
      focused: isFocused,
      applyChange: handleEditableChange,
      onCaret: setCaretIndex
    });
    const applyCompletionEdit = useCallback((next, caret) => {
      const ta = editableTextareaRef.current;
      if (!ta) return;
      recordKeystroke(ta.value, ta.selectionStart, next);
      ta.value = next;
      ta.setSelectionRange(caret, caret);
      handleEditableChange(next, "keystroke");
    }, [recordKeystroke, handleEditableChange]);
    const completion = useCodeCompletion(editable ? completions : void 0, editableTextareaRef, applyCompletionEdit);
    const keywordListNarrowed = completion.isNarrowed;
    const askOnPause = useCallback(() => !keywordListNarrowed(), [keywordListNarrowed]);
    const assist = useCodeAssist(editable ? assistProvider : void 0, editableTextareaRef, applyCompletionEdit, askOnPause);
    const problemCount = problems ?? errorLines?.size ?? 0;
    const diagnosticRangesNow = useMemo(() => {
      if (!editable || !diagnostics || diagnostics.length === 0) return [];
      const basis = diagnosticsCode ?? editableValue;
      return remapRanges(basis, editableValue, diagnosticRanges(basis, diagnostics));
    }, [editable, diagnostics, diagnosticsCode, editableValue]);
    const diagnosticUnderlines = useMemo(
      () => diagnosticRangesNow.length > 0 ? underlineSegments(editableValue, diagnosticRangesNow) : [],
      [diagnosticRangesNow, editableValue]
    );
    const diagnosticHere = diagnosticAt(diagnosticRangesNow, caretIndex);
    const showGutter = editable && lineNumbers !== false;
    const lineCount = editableValue.split("\n").length;
    const gutterWidth = showGutter ? String(lineCount).length * 8 + 20 : 0;
    const errorLineSet = useMemo(() => {
      const set = new Set(errorLines ? [...errorLines.keys()] : []);
      for (const r of diagnosticRangesNow) {
        if (r.severity === "error") set.add(editableValue.slice(0, r.from).split("\n").length);
      }
      return set;
    }, [errorLines, diagnosticRangesNow, editableValue]);
    const ghost = assist.atCaret ? assist.suggestions[0] : void 0;
    const keyword = completion.offer ? completion.offer.result.candidates[completion.selected] : void 0;
    const inline = ghost ? { at: ghost.from, text: ghost.text } : completion.offer && keyword ? {
      at: completion.offer.offset,
      text: keyword.label.startsWith(completion.offer.result.prefix) ? keyword.label.slice(completion.offer.result.prefix.length) : ""
    } : void 0;
    const ghostLines = inline ? inline.text.split("\n") : [];
    const listed = ghost ? assist.suggestions.slice(1) : assist.suggestions;
    const ghostAnchorRef = useRef(null);
    const [anchor, setAnchor] = useState({ top: 0, left: 0, scrollTop: 0, scrollLeft: 0, height: 0 });
    useLayoutEffect(() => {
      const a = ghostAnchorRef.current;
      const ov = editableOverlayRef.current;
      if (a && ov) setAnchor({ top: a.offsetTop, left: a.offsetLeft, scrollTop: ov.scrollTop, scrollLeft: ov.scrollLeft, height: ov.clientHeight });
    }, [inline?.at, inline?.text, editableValue, scrollTick]);
    useEffect(() => {
      if (ghost) completion.dismiss();
    }, [ghost, completion.dismiss]);
    const handleEditableKeyDown = useCallback(
      (e) => {
        const ta = editableTextareaRef.current;
        if (ta) prevCaretRef.current = ta.selectionStart;
        if (assist.onKeyDown(e)) return;
        if (completion.onKeyDown(e)) return;
        const mod = e.metaKey || e.ctrlKey;
        if (!mod) return;
        if (e.key === "Enter" && ta && onGoToDefinition) {
          const id = definitionAtOffset(ta.value, ta.selectionStart);
          if (id) {
            e.preventDefault();
            onGoToDefinition(id.text);
            return;
          }
        }
        const key = e.key.toLowerCase();
        if (key === "z" && !e.shiftKey) {
          e.preventDefault();
          undo();
        } else if (key === "z" && e.shiftKey || key === "y") {
          e.preventDefault();
          redo();
        }
      },
      [undo, redo, completion, assist, onGoToDefinition, definitionAtOffset]
    );
    const showBlockCaret = isFocused && caretMode !== "bar";
    useLayoutEffect(() => {
      if (!showBlockCaret) return;
      const ta = editableTextareaRef.current;
      const mirror = caretMirrorRef.current;
      const marker = caretMarkerRef.current;
      if (!ta || !mirror || !marker) return;
      const computed = window.getComputedStyle(ta);
      const MIRRORED_PROPS = [
        "font-family",
        "font-size",
        "font-weight",
        "font-style",
        "letter-spacing",
        "line-height",
        "padding-top",
        "padding-right",
        "padding-bottom",
        "padding-left",
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width",
        "box-sizing",
        "width",
        "white-space",
        "word-break",
        "overflow-wrap",
        "tab-size"
      ];
      for (const prop of MIRRORED_PROPS) {
        mirror.style.setProperty(prop, computed.getPropertyValue(prop));
      }
      const lineHeight = parseFloat(computed.getPropertyValue("line-height"));
      setCaretGeometry({
        top: marker.offsetTop,
        left: marker.offsetLeft,
        lineHeight: Number.isFinite(lineHeight) ? lineHeight : 0
      });
    }, [showBlockCaret, editableValue, caretIndex]);
    const errorLineProps = useMemo(() => buildLineProps(errorLines), [errorLines]);
    const viewerLineProps = useMemo(
      () => buildLineProps(errorLines, "px-4 py-0.5 hover:bg-muted/50"),
      [errorLines]
    );
    const isFoldable = foldableProp ?? true;
    const [collapsed, setCollapsed] = useState(() => /* @__PURE__ */ new Set());
    const foldRegions = useMemo(
      () => isFoldable && !overCapacity ? computeFoldRegions(code) : [],
      [code, isFoldable, overCapacity]
    );
    const foldStartMap = useMemo(() => {
      const m = /* @__PURE__ */ new Map();
      for (const r of foldRegions) m.set(r.start, r);
      return m;
    }, [foldRegions]);
    const hiddenLines = useMemo(() => {
      const h = /* @__PURE__ */ new Set();
      for (const r of foldRegions) {
        if (!collapsed.has(r.start)) continue;
        for (let i = r.start + 1; i <= r.end; i++) h.add(i);
      }
      return h;
    }, [foldRegions, collapsed]);
    const collapsedRef = useRef(collapsed);
    collapsedRef.current = collapsed;
    const foldStartMapRef = useRef(foldStartMap);
    foldStartMapRef.current = foldStartMap;
    const hiddenLinesRef = useRef(hiddenLines);
    hiddenLinesRef.current = hiddenLines;
    const toggleFold = useCallback((lineNum) => {
      setCollapsed((prev) => {
        const next = new Set(prev);
        if (next.has(lineNum)) next.delete(lineNum);
        else next.add(lineNum);
        return next;
      });
    }, []);
    const toggleFoldRef = useRef(toggleFold);
    toggleFoldRef.current = toggleFold;
    useEffect(() => {
      setCollapsed(/* @__PURE__ */ new Set());
    }, [code]);
    const editableOverCapacity = editableValue.length > HIGHLIGHT_CAPACITY_BYTES;
    const editableHighlightedElement = useMemo(
      () => editableOverCapacity ? /* @__PURE__ */ jsx(
        "div",
        {
          style: {
            padding: "1rem",
            margin: 0,
            whiteSpace: "pre",
            minWidth: "100%",
            color: plainCodeColor,
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
            fontSize: "13px",
            lineHeight: "1.5"
          },
          children: overlayText(editableValue)
        }
      ) : /* @__PURE__ */ jsx(
        SyntaxHighlighter,
        {
          PreTag: "div",
          renderer: renderWithTokenTypes,
          language,
          style: activeStyle,
          wrapLines: errorLines && errorLines.size > 0,
          lineProps: errorLineProps,
          customStyle: {
            backgroundColor: "transparent",
            borderRadius: 0,
            padding: "1rem",
            margin: 0,
            whiteSpace: "pre",
            minWidth: "100%",
            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
            fontSize: "13px",
            lineHeight: "1.5"
          },
          codeTagProps: {
            style: {
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
              fontSize: "13px",
              lineHeight: "1.5"
            }
          },
          children: overlayText(editableValue)
        }
      ),
      [editableValue, editableOverCapacity, plainCodeColor, language, activeStyle, errorLines, errorLineProps, languageReady]
    );
    const highlightedElement = useMemo(
      () => overCapacity ? /* @__PURE__ */ jsx(
        PlainCodeChunks,
        {
          code,
          style: {
            margin: 0,
            whiteSpace: "pre",
            color: plainCodeColor
          }
        }
      ) : /* @__PURE__ */ jsx(
        SyntaxHighlighter,
        {
          PreTag: "div",
          language,
          style: activeStyle,
          wrapLines: true,
          showLineNumbers: true,
          showInlineLineNumbers: false,
          lineNumberContainerStyle: HIDDEN_LINE_NUMBERS,
          lineProps: LINE_PROPS_FN,
          customStyle: {
            backgroundColor: "transparent",
            borderRadius: 0,
            padding: 0,
            margin: 0,
            whiteSpace: "pre",
            minWidth: "100%"
          },
          children: code
        }
      ),
      [code, overCapacity, plainCodeColor, language, activeStyle, languageReady]
    );
    const viewerOverCapacity = activeCode.length > HIGHLIGHT_CAPACITY_BYTES;
    const viewerHighlightedElement = useMemo(
      () => viewerOverCapacity ? /* @__PURE__ */ jsx(
        PlainCodeChunks,
        {
          code: activeCode,
          style: {
            margin: 0,
            padding: "0.125rem 1rem",
            whiteSpace: wrap ? "pre-wrap" : "pre",
            wordBreak: wrap ? "break-all" : "normal",
            color: viewerPlainCodeColor,
            fontFamily: MONO_FONT_FAMILY,
            fontSize: "12px",
            lineHeight: "1.6"
          }
        }
      ) : /* @__PURE__ */ jsx(
        SyntaxHighlighter,
        {
          PreTag: "div",
          language: activeLanguage,
          style: viewerStyle,
          wrapLines: true,
          wrapLongLines: wrap,
          showLineNumbers,
          lineNumberStyle: codeDir === "rtl" ? VIEWER_LINE_NUMBER_STYLE_RTL : VIEWER_LINE_NUMBER_STYLE,
          lineProps: viewerLineProps,
          renderer: codeDir === "rtl" ? renderRtlCode : void 0,
          customStyle: {
            backgroundColor: "transparent",
            borderRadius: 0,
            padding: "0.25rem 0",
            margin: 0,
            whiteSpace: wrap ? "pre-wrap" : "pre",
            wordBreak: wrap ? "break-all" : "normal",
            fontFamily: MONO_FONT_FAMILY,
            fontSize: "12px",
            lineHeight: "1.6",
            direction: codeDir,
            textAlign: "start"
          },
          codeTagProps: { style: { fontFamily: MONO_FONT_FAMILY, fontSize: "12px", lineHeight: "1.6", direction: codeDir, textAlign: "start" } },
          children: activeCode
        }
      ),
      [activeCode, viewerOverCapacity, viewerPlainCodeColor, activeLanguage, viewerStyle, wrap, showLineNumbers, viewerLineProps, languageReady, codeDir]
    );
    const diffOverCapacity = useMemo(
      () => !!diffLines && diffLines.reduce((n, l) => n + l.content.length + 1, 0) > HIGHLIGHT_CAPACITY_BYTES,
      [diffLines]
    );
    const diffRowElements = useMemo(() => {
      if (!diffLines) return null;
      return diffLines.map((line2, idx) => {
        const style = DIFF_STYLES[line2.type] ?? DIFF_STYLE_FALLBACK;
        return /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "start", className: cn(style.bg, "px-4 py-0.5"), children: [
          showLineNumbers && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              color: "secondary",
              className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
              children: line2.lineNumber ?? ""
            }
          ),
          /* @__PURE__ */ jsxs(
            Typography,
            {
              variant: "caption",
              className: cn("font-mono flex-1 min-w-0", style.text, wrap ? "whitespace-pre-wrap break-all" : "whitespace-pre"),
              children: [
                /* @__PURE__ */ jsx(Box, { as: "span", className: "select-none opacity-50 mr-2", children: style.prefix }),
                diffOverCapacity ? line2.content || " " : /* @__PURE__ */ jsx(
                  SyntaxHighlighter,
                  {
                    PreTag: "span",
                    CodeTag: "span",
                    language: activeLanguage,
                    style: viewerStyle,
                    customStyle: {
                      display: "inline",
                      background: "transparent",
                      padding: 0,
                      margin: 0,
                      whiteSpace: wrap ? "pre-wrap" : "pre",
                      wordBreak: wrap ? "break-all" : "normal",
                      fontFamily: "inherit",
                      fontSize: "inherit",
                      lineHeight: "inherit"
                    },
                    codeTagProps: {
                      style: {
                        whiteSpace: wrap ? "pre-wrap" : "pre",
                        fontFamily: "inherit",
                        fontSize: "inherit"
                      }
                    },
                    children: line2.content || " "
                  }
                )
              ]
            }
          )
        ] }, idx);
      });
    }, [diffLines, showLineNumbers, wrap, diffOverCapacity, activeLanguage, viewerStyle, languageReady]);
    useLayoutEffect(() => {
      const container = codeRef.current;
      if (!container) return;
      container.querySelectorAll(".fold-toggle, .fold-summary").forEach((el) => el.remove());
      const lineEls = container.querySelectorAll("[data-line]");
      if (!isFoldable || foldRegions.length === 0) {
        lineEls.forEach((el) => {
          el.style.display = "";
          el.style.position = "";
          el.style.paddingLeft = "";
        });
        return;
      }
      lineEls.forEach((el) => {
        const num2 = parseInt(el.getAttribute("data-line") ?? "-1", 10);
        if (hiddenLines.has(num2)) {
          el.style.display = "none";
          return;
        }
        el.style.display = "";
        el.style.position = "relative";
        el.style.paddingLeft = "1.2em";
        const region = foldStartMap.get(num2);
        if (!region) return;
        const isCollapsed = collapsed.has(num2);
        const toggle = document.createElement("span");
        toggle.className = "fold-toggle";
        toggle.textContent = isCollapsed ? "\u25B6" : "\u25BC";
        toggle.style.cssText = "position:absolute;left:0;top:0;width:1.2em;text-align:center;cursor:pointer;color:#858585;font-size:10px;user-select:none;line-height:inherit;height:100%";
        toggle.addEventListener("click", (e) => {
          e.stopPropagation();
          toggleFoldRef.current(num2);
        });
        el.insertBefore(toggle, el.firstChild);
        if (isCollapsed) {
          const summary = document.createElement("span");
          summary.className = "fold-summary";
          summary.style.cssText = "color:#858585;font-style:italic";
          const count = region.end - region.start - 1;
          summary.textContent = ` ... ${count} line${count !== 1 ? "s" : ""} ${region.closeBracket}`;
          el.appendChild(summary);
        }
      });
    }, [collapsed, hiddenLines, foldStartMap, foldRegions, isFoldable]);
    useLayoutEffect(() => {
      const el = scrollRef.current;
      return () => {
        if (el) savedScrollLeftRef.current = el.scrollLeft;
      };
    }, [language, code]);
    useLayoutEffect(() => {
      const el = scrollRef.current;
      if (el) el.scrollLeft = savedScrollLeftRef.current;
    }, [language, code]);
    useEffect(() => {
      const el = scrollRef.current;
      if (!el) return;
      const handle = () => {
        savedScrollLeftRef.current = el.scrollLeft;
      };
      el.addEventListener("scroll", handle, { passive: true });
      return () => el.removeEventListener("scroll", handle);
    }, [language, code]);
    const handleCopy = async () => {
      try {
        await navigator.clipboard.writeText(activeCode);
        setCopied(true);
        eventBus.emit("UI:COPY_CODE", { language: activeLanguage, success: true });
        setTimeout(() => setCopied(false), 2e3);
      } catch (err) {
        log3.error("Failed to copy code", { error: err instanceof Error ? err : String(err) });
        eventBus.emit("UI:COPY_CODE", { language: activeLanguage, success: false });
      }
    };
    const handleSelectionCopy = useCallback((e) => {
      if (hiddenLinesRef.current.size === 0) return;
      const sel = typeof window !== "undefined" ? window.getSelection() : null;
      if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
      const lineOf = (node) => {
        const start = node instanceof HTMLElement ? node : node?.parentElement ?? null;
        const lineEl = start?.closest("[data-line]");
        if (!lineEl) return null;
        const n = parseInt(lineEl.getAttribute("data-line") ?? "", 10);
        return Number.isNaN(n) ? null : n;
      };
      const range = sel.getRangeAt(0);
      let a = lineOf(range.startContainer);
      let b = lineOf(range.endContainer);
      if (a === null || b === null) {
        const container = codeRef.current;
        if (!container) return;
        let min = Infinity, max = -Infinity;
        container.querySelectorAll("[data-line]").forEach((el) => {
          if (!sel.containsNode(el, true)) return;
          const n = parseInt(el.getAttribute("data-line") ?? "", 10);
          if (!Number.isNaN(n)) {
            min = Math.min(min, n);
            max = Math.max(max, n);
          }
        });
        if (min === Infinity) return;
        a = a ?? min;
        b = b ?? max;
      }
      if (a > b) [a, b] = [b, a];
      let touchesFold = false;
      for (let i = a; i <= b; i++) {
        if (hiddenLinesRef.current.has(i) || foldStartMapRef.current.has(i) && collapsedRef.current.has(i)) {
          touchesFold = true;
          break;
        }
      }
      if (!touchesFold) return;
      let endLine = b;
      let changed = true;
      while (changed) {
        changed = false;
        foldStartMapRef.current.forEach((region, start) => {
          if (start >= a && start <= endLine && collapsedRef.current.has(start) && region.end > endLine) {
            endLine = region.end;
            changed = true;
          }
        });
      }
      const full = activeCode.split("\n").slice(a, endLine + 1).join("\n");
      e.clipboardData.setData("text/plain", full);
      e.preventDefault();
    }, [code]);
    if (isLoading) {
      return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
    }
    if (error) {
      return /* @__PURE__ */ jsx(ErrorState, { title: t("display.codeViewerError"), message: error.message, className });
    }
    if (isViewerMode && !activeCode && !diffLines) {
      return /* @__PURE__ */ jsx(EmptyState, { icon: Code, title: t("display.noCode"), description: t("codeBlock.noCode"), className });
    }
    if (isViewerMode) {
      const tabItems = files?.map((file, idx) => ({
        id: `file-${idx}`,
        label: file.label,
        content: null
      }));
      return /* @__PURE__ */ jsx(Card, { ...domPassthrough(a11yRest), className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column" }, children: [
        naturalTabStrip,
        tabItems && tabItems.length > 1 && /* @__PURE__ */ jsx(Box, { className: "border-b border-border", children: /* @__PURE__ */ jsx(
          Tabs,
          {
            tabs: tabItems,
            activeTab: `file-${activeFileIndex}`,
            onTabChange: (id) => {
              const idx = parseInt(id.replace("file-", ""), 10);
              setActiveFileIndex(idx);
            }
          }
        ) }),
        /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "sm",
            align: "center",
            justify: "between",
            className: "px-4 py-2 border-b border-border bg-muted/30",
            children: [
              /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
                /* @__PURE__ */ jsx(Icon, { icon: mode === "diff" ? FileText : Code, size: "sm", className: "text-muted-foreground" }),
                title && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "truncate", children: title }),
                activeLanguage && activeLanguage !== "text" && /* @__PURE__ */ jsx(Badge, { variant: "default", children: activeLanguage })
              ] }),
              /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: WrapText,
                    "aria-label": t("aria.wrapLines"),
                    "aria-pressed": wrap,
                    onClick: () => setWrap(!wrap),
                    className: cn(wrap && "text-primary")
                  }
                ),
                effectiveCopy && /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    icon: copied ? Check : Copy,
                    "aria-label": t("aria.copyCode"),
                    onClick: handleCopy,
                    className: cn(copied && "text-success")
                  }
                ),
                actions?.map((action, idx) => /* @__PURE__ */ jsx(
                  Badge,
                  {
                    variant: "default",
                    className: "cursor-pointer hover:opacity-80 transition-opacity",
                    onClick: () => {
                      if (action.event) eventBus.emit(`UI:${action.event}`, {});
                    },
                    children: action.label
                  },
                  idx
                ))
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: "overflow-auto bg-muted/20", style: { maxHeight }, dir: codeDir, role: "region", tabIndex: 0, "aria-label": title ?? t("codeBlock.region"), children: diffLines ? /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column" }, className: "font-mono text-xs", children: diffRowElements }) : /* @__PURE__ */ jsx("div", { className: "font-mono text-xs", children: viewerHighlightedElement }) })
      ] }) });
    }
    const hasHeader = showLanguageBadge;
    const copyButton = effectiveCopy ? /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: handleCopy,
        className: `opacity-0 group-hover:opacity-100 focus:opacity-100 transition-opacity text-muted-foreground hover:text-foreground${hasHeader ? "" : " absolute top-2 end-2 z-10"}`,
        "aria-label": t("common.copy"),
        children: copied ? /* @__PURE__ */ jsx(Icon, { name: "check", className: "w-4 h-4 text-success" }) : /* @__PURE__ */ jsx(Icon, { name: "copy", className: "w-4 h-4" })
      }
    ) : null;
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(a11yRest), className: `relative group not-prose ${className || ""}`, style: { display: "flex", flexDirection: "column", height: "100%" }, children: [
      hasHeader ? /* @__PURE__ */ jsxs(
        HStack,
        {
          justify: "between",
          align: "center",
          className: "px-3 py-2 bg-[var(--color-card)] rounded-t-container border-b border-border",
          "data-testid": "code-block-header",
          children: [
            /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: language }),
            copyButton
          ]
        }
      ) : copyButton,
      naturalTabStrip,
      editable ? (
        /* GAP-77 / GAP-82 / GAP-83: editable mode = transparent textarea on
                     top of a Prism-highlighted SyntaxHighlighter overlay.
        
                     Layout: BOTH children are `position: absolute, inset: 0` so neither
                     contributes to flow. The parent Box has `height: 100%` so it fills
                     whatever container the consumer provides (the consumer is
                     responsible for giving the parent a real height — usually via flex
                     column with `minHeight: 0`).
        
                     Stacking: the overlay is FIRST in DOM order so it paints first
                     (behind), the textarea is SECOND so it paints second (on top). No
                     explicit z-index — DOM order alone determines stacking inside the
                     parent's stacking context. The textarea has `color: transparent`
                     plus `WebkitTextFillColor: transparent` (Safari) so its glyphs
                     never paint, but the caret stays visible via `caretColor`.
        
                     Scroll sync: textarea scrolls naturally; `handleEditableScroll`
                     mirrors its scrollTop/scrollLeft onto the overlay div so the
                     highlighted spans stay aligned with the textarea content.
        
                     Error highlights (GAP-80): `errorLines` prop accepts a Map of
                     1-based line numbers → severity. The overlay's SyntaxHighlighter
                     uses `wrapLines` + `lineProps` to paint a colored background on
                     those lines. */
        /* @__PURE__ */ jsxs(
          Box,
          {
            style: {
              position: "relative",
              flex: 1,
              minHeight: 0,
              maxHeight,
              backgroundColor: "#1e1e1e",
              borderRadius: hasHeader ? "0 0 0.5rem 0.5rem" : "0.5rem",
              overflow: "hidden"
            },
            children: [
              showGutter && /* @__PURE__ */ jsx(
                Box,
                {
                  ref: editableGutterRef,
                  "aria-hidden": true,
                  "data-testid": "code-editor-gutter",
                  style: {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: gutterWidth,
                    overflow: "hidden",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    pointerEvents: "none",
                    userSelect: "none"
                  },
                  children: Array.from({ length: lineCount }, (_, i) => {
                    const isError = errorLineSet.has(i + 1);
                    return /* @__PURE__ */ jsx(
                      Box,
                      {
                        "data-error": isError ? "true" : void 0,
                        style: {
                          height: EDITOR_LINE_PX,
                          paddingRight: 8,
                          textAlign: "right",
                          fontFamily: MONO_EDITOR_FONT,
                          fontSize: "13px",
                          lineHeight: "1.5",
                          color: isError ? DIAGNOSTIC_ERROR_COLOR : GUTTER_COLOR
                        },
                        children: i + 1
                      },
                      i
                    );
                  })
                }
              ),
              /* @__PURE__ */ jsxs(
                "div",
                {
                  ref: editableOverlayRef,
                  "aria-hidden": true,
                  "data-testid": "code-editor-overlay",
                  style: {
                    position: "absolute",
                    top: 0,
                    left: gutterWidth,
                    width: `calc(100% - ${gutterWidth}px)`,
                    height: "100%",
                    overflow: "hidden",
                    pointerEvents: "none"
                  },
                  children: [
                    /* @__PURE__ */ jsx(Box, { ref: highlightLayerRef, style: { display: "contents" }, children: editableHighlightedElement }),
                    definitionHover && /* @__PURE__ */ jsxs(
                      Box,
                      {
                        "aria-hidden": true,
                        "data-testid": "code-definition-layer",
                        style: {
                          position: "absolute",
                          top: 0,
                          left: 0,
                          minWidth: "100%",
                          padding: "1rem",
                          margin: 0,
                          whiteSpace: "pre",
                          color: "transparent",
                          fontFamily: MONO_EDITOR_FONT,
                          fontSize: "13px",
                          lineHeight: "1.5"
                        },
                        children: [
                          editableValue.slice(0, definitionHover.start),
                          /* @__PURE__ */ jsx(
                            Box,
                            {
                              as: "span",
                              "data-testid": "code-definition-link",
                              style: { textDecorationLine: "underline", textDecorationColor: "var(--color-primary)", textUnderlineOffset: "3px" },
                              children: editableValue.slice(definitionHover.start, definitionHover.end)
                            }
                          )
                        ]
                      }
                    ),
                    diagnosticUnderlines.length > 0 && /* @__PURE__ */ jsx(
                      Box,
                      {
                        "aria-hidden": true,
                        "data-testid": "code-diagnostics-layer",
                        style: {
                          position: "absolute",
                          top: 0,
                          left: 0,
                          minWidth: "100%",
                          padding: "1rem",
                          margin: 0,
                          whiteSpace: "pre",
                          color: "transparent",
                          fontFamily: MONO_EDITOR_FONT,
                          fontSize: "13px",
                          lineHeight: "1.5"
                        },
                        children: diagnosticUnderlines.map((seg, i) => {
                          const mark = seg.range ?? seg.marker;
                          if (!mark) return /* @__PURE__ */ jsx(React93__default.Fragment, { children: seg.text }, i);
                          return /* @__PURE__ */ jsx(
                            Box,
                            {
                              as: "span",
                              "data-testid": "code-diagnostic",
                              "data-severity": mark.severity,
                              "data-approximate": String(mark.approximate),
                              style: {
                                textDecorationLine: "underline",
                                textDecorationStyle: mark.approximate ? "dotted" : "wavy",
                                textDecorationColor: mark.severity === "error" ? DIAGNOSTIC_ERROR_COLOR : DIAGNOSTIC_WARNING_COLOR,
                                textDecorationThickness: "1.5px",
                                textDecorationSkipInk: "none",
                                textUnderlineOffset: "3px"
                              },
                              children: seg.range ? seg.text : "\xA0"
                            },
                            i
                          );
                        })
                      }
                    ),
                    inline && /* @__PURE__ */ jsxs(
                      Box,
                      {
                        "aria-hidden": true,
                        style: {
                          position: "absolute",
                          top: 0,
                          left: 0,
                          minWidth: "100%",
                          padding: "1rem",
                          margin: 0,
                          whiteSpace: "pre",
                          color: "transparent",
                          fontFamily: MONO_EDITOR_FONT,
                          fontSize: "13px",
                          lineHeight: "1.5"
                        },
                        children: [
                          editableValue.slice(0, inline.at),
                          /* @__PURE__ */ jsx(Box, { as: "span", ref: ghostAnchorRef }),
                          ghostLines[0] !== "" && /* @__PURE__ */ jsx(Box, { as: "span", "data-testid": "code-assist-ghost", style: { color: GHOST_COLOR, backgroundColor: "#1e1e1e", fontStyle: "italic" }, children: ghostLines[0] })
                        ]
                      }
                    ),
                    inline && ghostLines.length > 1 && /* @__PURE__ */ jsx(
                      Box,
                      {
                        "aria-hidden": true,
                        "data-testid": "code-assist-ghost-rest",
                        style: {
                          position: "absolute",
                          top: anchor.top + EDITOR_LINE_PX,
                          left: 0,
                          minWidth: "100%",
                          padding: "0 1rem",
                          margin: 0,
                          whiteSpace: "pre",
                          color: GHOST_COLOR,
                          fontStyle: "italic",
                          backgroundColor: "#1e1e1e",
                          borderTop: "1px dashed #3c3c3c",
                          borderBottom: "1px dashed #3c3c3c",
                          fontFamily: MONO_EDITOR_FONT,
                          fontSize: "13px",
                          lineHeight: "1.5"
                        },
                        children: ghostLines.slice(1).join("\n")
                      }
                    ),
                    showBlockCaret && /* @__PURE__ */ jsxs(
                      "div",
                      {
                        ref: caretMirrorRef,
                        "aria-hidden": true,
                        "data-testid": "editor-caret-mirror",
                        style: {
                          position: "absolute",
                          top: 0,
                          left: 0,
                          padding: "1rem",
                          margin: 0,
                          border: "none",
                          visibility: "hidden",
                          pointerEvents: "none"
                        },
                        children: [
                          editableValue.slice(0, caretIndex),
                          /* @__PURE__ */ jsx("span", { ref: caretMarkerRef, "data-testid": "editor-caret-marker", children: "\u200B" })
                        ]
                      }
                    ),
                    showBlockCaret && caretGeometry && /* @__PURE__ */ jsx(
                      "span",
                      {
                        "aria-hidden": true,
                        "data-testid": "editor-caret",
                        style: {
                          position: "absolute",
                          top: caretGeometry.top,
                          left: caretGeometry.left,
                          width: "1ch",
                          height: caretMode === "block" ? caretGeometry.lineHeight || "1.2em" : "2px",
                          backgroundColor: caretMode === "block" ? "rgba(230, 230, 230, 0.5)" : void 0,
                          borderBottom: caretMode === "underline" ? "2px solid #e6e6e6" : void 0,
                          pointerEvents: "none"
                        }
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                Textarea,
                {
                  ref: editableTextareaRef,
                  defaultValue: code,
                  onChange: (e) => {
                    const next = e.target.value;
                    recordKeystroke(editableValue, prevCaretRef.current, next);
                    assist.onEdited(editableValue, next);
                    handleEditableChange(next, "keystroke");
                  },
                  onScroll: handleEditableScroll,
                  onSelect: (e) => setCaretIndex(caretOf(e.currentTarget)),
                  onKeyUp: (e) => {
                    setCaretIndex(caretOf(e.currentTarget));
                    if (e.key.startsWith("Arrow") || e.key === "Home" || e.key === "End" || e.key.startsWith("Page")) assist.onCaretMoved(e.currentTarget.selectionStart);
                    completion.onKeyUp(e);
                    assist.onKeyUp(e);
                  },
                  onClick: (e) => {
                    setCaretIndex(caretOf(e.currentTarget));
                    assist.onCaretMoved(e.currentTarget.selectionStart);
                    if ((e.metaKey || e.ctrlKey) && onGoToDefinition) {
                      const id = definitionAtOffset(e.currentTarget.value, e.currentTarget.selectionStart);
                      if (id) onGoToDefinition(id.text);
                    }
                  },
                  onMouseMove: (e) => {
                    if (!definitionAt) return;
                    if (!(e.metaKey || e.ctrlKey)) {
                      if (definitionHover) setDefinitionHover(null);
                      return;
                    }
                    const offset = offsetUnderPointer(e.currentTarget, highlightLayerRef.current, e.clientX, e.clientY);
                    const id = offset === null ? null : definitionAtOffset(e.currentTarget.value, offset);
                    if (id?.start !== definitionHover?.start || id?.end !== definitionHover?.end) setDefinitionHover(id);
                  },
                  onMouseLeave: () => {
                    if (definitionHover) setDefinitionHover(null);
                  },
                  onKeyDown: handleEditableKeyDown,
                  onFocus: () => {
                    setIsFocused(true);
                    if (editorId) eventBus.emit(`UI:${onEditorFocus}`, { editorId });
                  },
                  onBlur: () => {
                    setIsFocused(false);
                    if (editorId) eventBus.emit(`UI:${onEditorBlur}`, { editorId });
                  },
                  spellCheck: false,
                  style: {
                    position: "absolute",
                    top: 0,
                    left: gutterWidth,
                    width: `calc(100% - ${gutterWidth}px)`,
                    height: "100%",
                    padding: "1rem",
                    margin: 0,
                    border: "none",
                    outline: "none",
                    resize: "none",
                    backgroundColor: "transparent",
                    color: "transparent",
                    caretColor: caretMode === "block" ? "transparent" : "#e6e6e6",
                    WebkitTextFillColor: "transparent",
                    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, "Cascadia Mono", "Courier New", monospace',
                    fontSize: "13px",
                    lineHeight: "1.5",
                    whiteSpace: "pre",
                    overflowWrap: "normal",
                    overflow: "auto"
                  }
                },
                editableTextareaKey
              ),
              completion.offer && /* @__PURE__ */ jsx(
                Box,
                {
                  "data-testid": "code-completions",
                  role: "listbox",
                  className: "rounded-container border border-border shadow-elevation-popover",
                  style: {
                    position: "absolute",
                    zIndex: 2,
                    left: gutterWidth + Math.max(0, anchor.left - anchor.scrollLeft),
                    ...anchor.top - anchor.scrollTop > anchor.height / 2 ? { bottom: anchor.height - (anchor.top - anchor.scrollTop) } : { top: anchor.top - anchor.scrollTop + EDITOR_LINE_PX },
                    maxHeight: "12rem",
                    minWidth: "12rem",
                    overflowY: "auto",
                    backgroundColor: "#252526"
                  },
                  children: completion.offer.result.candidates.map((c, i) => /* @__PURE__ */ jsx(
                    Box,
                    {
                      role: "option",
                      "aria-selected": i === completion.selected,
                      onMouseDown: (e) => e.preventDefault(),
                      onClick: () => completion.accept(c.label),
                      className: "cursor-pointer px-2 py-0.5",
                      style: { backgroundColor: i === completion.selected ? "#04395e" : void 0 },
                      "data-testid": `code-completion-${c.label}`,
                      children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", justify: "between", children: [
                        /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-mono", style: { color: "#e6e6e6" }, children: c.label }),
                        c.detail && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: c.detail })
                      ] })
                    },
                    c.label
                  ))
                }
              )
            ]
          }
        )
      ) : /* @__PURE__ */ jsx(
        "div",
        {
          ref: scrollRef,
          onCopy: handleSelectionCopy,
          dir: "ltr",
          className: "[&_code]:!bg-transparent [&_code]:!p-0 [&_code]:!border-0 [&_code]:!shadow-none [&_span]:!bg-transparent",
          role: "region",
          tabIndex: 0,
          "aria-label": title ?? t("codeBlock.region"),
          style: {
            flex: 1,
            minHeight: 0,
            overflowX: "auto",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
            maxHeight,
            overscrollBehavior: "auto",
            touchAction: "pan-x pan-y",
            contain: "paint",
            backgroundColor: "#1e1e1e",
            borderRadius: hasHeader ? "0 0 0.5rem 0.5rem" : "0.5rem"
          },
          children: /* @__PURE__ */ jsx("div", { ref: codeRef, style: { padding: "1rem" }, children: highlightedElement })
        }
      ),
      diagnosticHere && /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 border-t border-border px-2 py-1", "data-testid": "code-diagnostic-at-caret", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", style: { color: diagnosticHere.severity === "error" ? DIAGNOSTIC_ERROR_COLOR : DIAGNOSTIC_WARNING_COLOR }, children: diagnosticHere.message }) }),
      editable && assistProvider && (assist.asking || assist.suggestions.length > 0 || assist.note || problemCount > 0) && /* @__PURE__ */ jsxs(Box, { className: "flex-shrink-0 border-t border-border px-2 py-1.5", "data-testid": "code-assist-bar", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", wrap: true, children: [
          assist.asking && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: assist.asking === "fix" ? t("codeAssist.findingFixes") : t("codeAssist.thinking") }),
          assist.suggestions.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t("codeAssist.suggested", { count: assist.suggestions.length }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: t("codeAssist.keys") }),
            listed.length > 0 && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "primary", onClick: assist.acceptAll, "data-testid": "code-assist-accept-all", children: t("codeAssist.acceptAll") })
          ] }),
          !assist.asking && assist.suggestions.length === 0 && problemCount > 0 && /* @__PURE__ */ jsx(Button, { size: "sm", variant: "secondary", onClick: () => assist.request("fix", "explicit"), "data-testid": "code-assist-request-fix", children: t("codeAssist.suggestFixes", { count: problemCount }) }),
          assist.note && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: assist.note })
        ] }),
        listed.map((s, i) => /* @__PURE__ */ jsxs(
          Box,
          {
            role: "button",
            tabIndex: 0,
            onClick: () => assist.accept(s),
            className: "mt-1 cursor-pointer rounded-interactive border border-border px-2 py-1 hover:bg-muted/50",
            "data-testid": `code-assist-fix-${i}`,
            children: [
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", children: [
                t("codeAssist.line", { line: editableValue.slice(0, s.from).split("\n").length }),
                s.why ? ` \xB7 ${s.why}` : ""
              ] }),
              s.to > s.from && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "block whitespace-pre font-mono", style: { color: "#f48771" }, children: editableValue.slice(s.from, s.to).replace(/^/gm, "\u2212 ") }),
              s.text !== "" && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "block whitespace-pre font-mono", style: { color: "#89d185" }, children: s.text.replace(/^\n/, "").replace(/^/gm, "+ ") })
            ]
          },
          `${s.from}-${s.to}-${i}`
        ))
      ] })
    ] });
  },
  (prev, next) => prev.language === next.language && prev.code === next.code && prev.showCopyButton === next.showCopyButton && prev.showCopy === next.showCopy && prev.maxHeight === next.maxHeight && prev.foldable === next.foldable && prev.editable === next.editable && prev.onChange === next.onChange && prev.completions === next.completions && prev.assist === next.assist && prev.problems === next.problems && prev.diagnostics === next.diagnostics && prev.definitionAt === next.definitionAt && prev.onGoToDefinition === next.onGoToDefinition && prev.diagnosticsCode === next.diagnosticsCode && prev.lineNumbers === next.lineNumbers && prev.errorLines === next.errorLines && prev.mode === next.mode && prev.title === next.title && prev.diff === next.diff && prev.files === next.files && prev.naturalLanguages === next.naturalLanguages && prev.actions === next.actions && prev.isLoading === next.isLoading && prev.error === next.error && prev.editorId === next.editorId && prev.onEditorFocus === next.onEditorFocus && prev.onEditorBlur === next.onEditorBlur && prev.onMotion === next.onMotion && prev.onOperate === next.onOperate && prev.onInsertText === next.onInsertText && prev.onSetMode === next.onSetMode && prev.motions === next.motions && prev.operators === next.operators
);
CodeBlock.displayName = "CodeBlock";
var SelectionAnnotator = ({
  askEvent,
  noteEvent,
  askLabel,
  noteLabel,
  className,
  children,
  ...rest
}) => {
  const { t } = useTranslate();
  const { emit } = useEventBus();
  const containerRef = useRef(null);
  const barRef = useRef(null);
  const [active, setActive] = useState(null);
  const enabled = askEvent !== void 0 || noteEvent !== void 0;
  useEffect(() => {
    if (!enabled) return void 0;
    const onSelectionChange = () => {
      const container = containerRef.current;
      const selection = document.getSelection();
      if (!container || !selection) return;
      const text = selection.toString().trim();
      if (selection.rangeCount > 0 && !selection.isCollapsed && text.length > 0) {
        const range = selection.getRangeAt(0);
        if (container.contains(range.commonAncestorContainer)) {
          const box = range.getBoundingClientRect();
          const origin = container.getBoundingClientRect();
          setActive({ text, top: box.bottom - origin.top, left: box.left - origin.left });
          return;
        }
      }
      if (barRef.current?.contains(document.activeElement)) return;
      setActive(null);
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => document.removeEventListener("selectionchange", onSelectionChange);
  }, [enabled]);
  const fire = useCallback(
    (event) => {
      if (!event || !active) return;
      emit(`UI:${event}`, { selectedText: active.text });
      document.getSelection()?.removeAllRanges();
      setActive(null);
    },
    [active, emit]
  );
  const dismiss = (e) => {
    if (e.key === "Escape") setActive(null);
  };
  if (!enabled) return /* @__PURE__ */ jsx(Fragment, { children });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      ref: containerRef,
      position: "relative",
      className,
      onKeyDown: dismiss,
      children: [
        children,
        active ? /* @__PURE__ */ jsx(
          Box,
          {
            ref: barRef,
            role: "toolbar",
            "aria-label": t("selection.toolbar"),
            position: "absolute",
            className: cn(
              "z-10 bg-card rounded-interactive border border-border p-1",
              "shadow-elevation-popover transition-opacity duration-fast"
            ),
            style: { top: active.top + 4, left: active.left },
            onMouseDown: (e) => e.preventDefault(),
            children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", children: [
              askEvent ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: () => fire(askEvent), children: askLabel ?? t("selection.ask") }) : null,
              noteEvent ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: () => fire(noteEvent), children: noteLabel ?? t("selection.note") }) : null
            ] })
          }
        ) : null
      ]
    }
  );
};
SelectionAnnotator.displayName = "SelectionAnnotator";

// lib/content-annotations.ts
var OPAQUE_TAGS = /* @__PURE__ */ new Set(["code", "pre", "mark"]);
function splitFirstMatch(node, annotation) {
  const children = node.children;
  if (!children) return false;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (child.type === "text" && typeof child.value === "string") {
      const at = child.value.indexOf(annotation.text);
      if (at < 0) continue;
      const before = child.value.slice(0, at);
      const after = child.value.slice(at + annotation.text.length);
      const replacement = [];
      if (before) replacement.push({ type: "text", value: before });
      replacement.push({
        type: "element",
        tagName: "mark",
        properties: { dataAnnotationId: annotation.id, dataAnnotationKind: annotation.kind },
        children: [{ type: "text", value: annotation.text }]
      });
      if (after) replacement.push({ type: "text", value: after });
      children.splice(i, 1, ...replacement);
      return true;
    }
    if (child.type === "element" && child.tagName && OPAQUE_TAGS.has(child.tagName)) continue;
    if (splitFirstMatch(child, annotation)) return true;
  }
  return false;
}
function rehypeAnnotate(annotations) {
  return () => (tree) => {
    for (const annotation of annotations) {
      if (annotation.text.length === 0) continue;
      splitFirstMatch(tree, annotation);
    }
  };
}

// components/core/molecules/markdown/mermaidSource.ts
var NODE_SHAPES = [
  ["[[", "]]"],
  ["[(", ")]"],
  ["([", "])"],
  ["((", "))"],
  ["{{", "}}"],
  ["[", "]"],
  ["(", ")"],
  ["{", "}"]
];
var FLOWCHART_DIRECTIVE = /^(?:graph|flowchart)\b/;
function isQuoted(label) {
  const trimmed = label.trim();
  return trimmed.length === 0 || trimmed.startsWith('"') && trimmed.endsWith('"') && trimmed.length > 1;
}
function quote(label) {
  return `"${label.replace(/"/g, "#quot;")}"`;
}
function isIdentifierChar(ch) {
  return /[A-Za-z0-9_\-.]/.test(ch);
}
function declaredType(code) {
  for (const line2 of code.split("\n")) {
    const trimmed = line2.trim();
    if (trimmed.length === 0 || trimmed.startsWith("%%")) continue;
    return trimmed;
  }
  return "";
}
function isFlowchart(code) {
  return FLOWCHART_DIRECTIVE.test(declaredType(code));
}
function quoteNodeLabels(code) {
  let out = "";
  let i = 0;
  while (i < code.length) {
    const shape = NODE_SHAPES.find(([open2]) => code.startsWith(open2, i));
    const precededByIdentifier = i > 0 && isIdentifierChar(code[i - 1] ?? "");
    if (shape === void 0 || !precededByIdentifier) {
      out += code[i];
      i += 1;
      continue;
    }
    const [open, close] = shape;
    const contentStart = i + open.length;
    const closeAt = code.indexOf(close, contentStart);
    const newlineAt = code.indexOf("\n", contentStart);
    if (closeAt === -1 || newlineAt !== -1 && newlineAt < closeAt) {
      out += code[i];
      i += 1;
      continue;
    }
    const label = code.slice(contentStart, closeAt);
    out += open + (isQuoted(label) ? label : quote(label)) + close;
    i = closeAt + close.length;
  }
  return out;
}
function quoteEdgeLabels(code) {
  return code.split("\n").map((line2) => {
    let out = "";
    let rest = line2;
    for (; ; ) {
      const open = rest.indexOf("|");
      if (open === -1) break;
      const close = rest.indexOf("|", open + 1);
      if (close === -1) break;
      const label = rest.slice(open + 1, close);
      out += rest.slice(0, open + 1) + (isQuoted(label) ? label : quote(label)) + "|";
      rest = rest.slice(close + 1);
    }
    return out + rest;
  }).join("\n");
}
function quoteSubgraphTitles(code) {
  return code.split("\n").map((line2) => {
    const match = /^(\s*subgraph\s+)(.+?)(\s*)$/.exec(line2);
    if (match === null) return line2;
    const [, prefix, title, trailing] = match;
    if (title === void 0 || prefix === void 0) return line2;
    if (isQuoted(title) || title.includes("[")) return line2;
    return prefix + quote(title) + (trailing ?? "");
  }).join("\n");
}
function mermaidRepairCandidates(code) {
  if (!isFlowchart(code)) return [];
  const nodes = quoteNodeLabels(code);
  const nodesAndEdges = quoteEdgeLabels(nodes);
  const all = quoteSubgraphTitles(nodesAndEdges);
  const ordered2 = [nodes, nodesAndEdges, all];
  const seen = /* @__PURE__ */ new Set([code]);
  const candidates = [];
  for (const candidate of ordered2) {
    if (seen.has(candidate)) continue;
    seen.add(candidate);
    candidates.push(candidate);
  }
  return candidates;
}

// lib/mermaidTheme.ts
var PIE_SLOTS = 12;
function mermaidThemeVariables(theme, mode) {
  const { tones, series } = theme;
  const seriesAt = (i) => series[i % series.length] ?? tones.highlight;
  const vars = {
    darkMode: mode === "dark",
    background: theme.ground,
    fontFamily: theme.faces[theme.label.font],
    fontSize: `${theme.text[theme.label.size]}px`,
    primaryColor: tones.fill,
    primaryBorderColor: tones.ink,
    primaryTextColor: tones.label,
    secondaryColor: tones.grid,
    secondaryBorderColor: tones.guide,
    secondaryTextColor: tones.label,
    tertiaryColor: theme.ground,
    tertiaryBorderColor: tones.guide,
    tertiaryTextColor: tones.label,
    textColor: tones.label,
    nodeTextColor: tones.label,
    lineColor: tones.axis,
    edgeLabelBackground: theme.ground,
    clusterBkg: tones.grid,
    clusterBorder: tones.guide,
    titleColor: tones.ink,
    noteBkgColor: tones.fill,
    noteBorderColor: tones.highlight,
    noteTextColor: tones.label,
    actorBkg: tones.fill,
    actorBorder: tones.ink,
    actorTextColor: tones.label,
    actorLineColor: tones.guide,
    signalColor: tones.axis,
    signalTextColor: tones.label,
    labelBoxBkgColor: tones.fill,
    labelBoxBorderColor: tones.ink,
    labelTextColor: tones.label,
    activationBkgColor: tones.grid,
    activationBorderColor: tones.ink,
    pieTitleTextColor: tones.ink,
    pieSectionTextColor: theme.ground,
    pieStrokeColor: theme.ground,
    pieOuterStrokeColor: tones.guide,
    pieOpacity: "1"
  };
  for (let i = 0; i < PIE_SLOTS; i++) vars[`pie${i + 1}`] = seriesAt(i);
  return vars;
}
var log4 = createLogger("almadar:ui:mermaid-diagram");
var mermaidModule = null;
function loadMermaid() {
  mermaidModule ?? (mermaidModule = import('mermaid').then((m) => m.default));
  return mermaidModule;
}
var MermaidDiagram = React93__default.memo(
  ({ code, className }) => {
    const resolvedMode = useScopedMode();
    const { t } = useTranslate();
    const containerRef = useRef(null);
    const [unrenderable, setUnrenderable] = useState(false);
    const reactId = useId();
    const { theme: canvasTheme, version: themeVersion2 } = useCanvasTheme(containerRef);
    useEffect(() => {
      if (canvasTheme === null) return;
      let active = true;
      void (async () => {
        const mermaid = await loadMermaid();
        mermaid.initialize({
          startOnLoad: false,
          securityLevel: "strict",
          theme: "base",
          themeVariables: mermaidThemeVariables(canvasTheme, resolvedMode),
          // Mermaid's default is to append its "Syntax error in text" bomb
          // graphic to <body> on a failed parse, outside any error boundary —
          // the catch below owns failure presentation (source + log), so the
          // library must not paint its own.
          suppressErrorRendering: true
        });
        const domId = `mermaid-${reactId.replace(/[^a-zA-Z0-9]/g, "")}`;
        let firstError = null;
        for (const [index, source] of [code, ...mermaidRepairCandidates(code)].entries()) {
          try {
            const { svg } = await mermaid.render(domId, source);
            if (!active) return;
            const container = containerRef.current;
            if (container === null) return;
            container.innerHTML = svg;
            container.dataset.mermaidRepaired = String(index > 0);
            setUnrenderable(false);
            if (index > 0) log4.debug("mermaid:repaired", { candidate: index });
            return;
          } catch (err) {
            firstError ?? (firstError = err instanceof Error ? err : new Error(String(err)));
          }
        }
        if (!active) return;
        log4.warn("mermaid:unrenderable", { error: firstError?.message ?? "", code });
        setUnrenderable(true);
      })();
      return () => {
        active = false;
      };
    }, [code, resolvedMode, reactId, canvasTheme, themeVersion2]);
    return /* @__PURE__ */ jsxs(Box, { className: cn("not-prose my-4", className), children: [
      unrenderable && /* @__PURE__ */ jsxs(Box, { className: "space-y-2 mb-2", "data-testid": "mermaid-unrenderable", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("mermaid.unrenderable") }),
        /* @__PURE__ */ jsx(CodeBlock, { code, language: "mermaid" })
      ] }),
      /* @__PURE__ */ jsx(
        Box,
        {
          ref: containerRef,
          "data-testid": "mermaid-diagram",
          className: "overflow-x-auto",
          style: unrenderable ? { display: "none" } : void 0
        }
      )
    ] });
  },
  (prev, next) => prev.code === next.code && prev.className === next.className
);
MermaidDiagram.displayName = "MermaidDiagram";
function samePassthrough(a, b) {
  const pa = domPassthrough(a);
  const pb = domPassthrough(b);
  const keys = Object.keys(pa);
  return keys.length === Object.keys(pb).length && keys.every((k) => pa[k] === pb[k]);
}
var urlTransform = (url, key, node) => key === "src" && node.tagName === "img" && /^data:image\//i.test(url) ? url : defaultUrlTransform(url);
var MarkdownContent = React93__default.memo(
  ({ content, direction = "ltr", askEvent, noteEvent, askLabel, noteLabel, annotations, annotationEvent, className, ...rest }) => {
    const { t: _t } = useTranslate();
    const safeContent = typeof content === "string" ? content : String(content ?? "");
    const body = /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(rest),
        className: cn("prose max-w-none", className),
        style: {
          color: "var(--color-foreground)",
          "--tw-prose-body": "var(--color-foreground)",
          "--tw-prose-headings": "var(--color-foreground)",
          "--tw-prose-lead": "var(--color-muted-foreground)",
          "--tw-prose-links": "var(--color-primary)",
          "--tw-prose-bold": "var(--color-foreground)",
          "--tw-prose-counters": "var(--color-muted-foreground)",
          "--tw-prose-bullets": "var(--color-muted-foreground)",
          "--tw-prose-hr": "var(--color-border)",
          "--tw-prose-quotes": "var(--color-foreground)",
          "--tw-prose-quote-borders": "var(--color-primary)",
          "--tw-prose-captions": "var(--color-muted-foreground)",
          "--tw-prose-code": "var(--color-foreground)",
          "--tw-prose-pre-code": "var(--color-foreground)",
          "--tw-prose-pre-bg": "var(--color-muted)",
          "--tw-prose-th-borders": "var(--color-border)",
          "--tw-prose-td-borders": "var(--color-border)",
          direction
        },
        children: /* @__PURE__ */ jsx(
          ReactMarkdown,
          {
            urlTransform,
            remarkPlugins: [remarkMath, remarkGfm],
            rehypePlugins: [
              ...annotations && annotations.length > 0 ? [rehypeAnnotate(annotations)] : [],
              [rehypeKatex, { strict: false, throwOnError: false }]
            ],
            components: {
              code({
                className: codeClassName,
                children,
                inline,
                ...props
              }) {
                if (!inline) {
                  const match = /language-(\w+)/.exec(codeClassName ?? "");
                  const code = String(children).replace(/\n$/, "");
                  if (match?.[1] === "mermaid") {
                    return /* @__PURE__ */ jsx(MermaidDiagram, { code });
                  }
                  if (match) {
                    return /* @__PURE__ */ jsx(
                      CodeBlock,
                      {
                        code,
                        language: toCodeLanguage(match[1]),
                        maxHeight: "60vh"
                      }
                    );
                  }
                  return /* @__PURE__ */ jsx(
                    "code",
                    {
                      ...props,
                      className: codeClassName,
                      style: {
                        backgroundColor: "var(--color-muted)",
                        color: "var(--color-foreground)",
                        border: "1px solid var(--color-border)",
                        padding: "0.125rem 0.375rem",
                        borderRadius: "0.25rem",
                        fontSize: "0.875em",
                        fontFamily: "ui-monospace, monospace",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word"
                      },
                      children
                    }
                  );
                }
                return /* @__PURE__ */ jsx(
                  "code",
                  {
                    ...props,
                    className: codeClassName,
                    style: {
                      backgroundColor: "var(--color-muted)",
                      color: "var(--color-foreground)",
                      border: "1px solid var(--color-border)",
                      padding: "0.125rem 0.375rem",
                      borderRadius: "0.25rem",
                      fontSize: "0.875em",
                      fontFamily: "ui-monospace, monospace"
                    },
                    children
                  }
                );
              },
              mark({ node }) {
                const id = node?.properties?.dataAnnotationId;
                const kind = node?.properties?.dataAnnotationKind;
                return /* @__PURE__ */ jsx(
                  TextHighlight,
                  {
                    highlightType: kind === "question" ? "question" : "note",
                    annotationId: typeof id === "string" ? id : void 0,
                    action: annotationEvent,
                    children: node?.children.map((c) => c.type === "text" ? c.value : "")
                  }
                );
              },
              // Style links
              a({ href, children, ...props }) {
                return /* @__PURE__ */ jsx(
                  "a",
                  {
                    href,
                    ...props,
                    className: "text-[var(--color-primary)] hover:underline",
                    target: href?.startsWith("http") ? "_blank" : void 0,
                    rel: href?.startsWith("http") ? "noopener noreferrer" : void 0,
                    children
                  }
                );
              },
              // Style tables
              table({ children, ...props }) {
                return /* @__PURE__ */ jsx("div", { className: "overflow-x-auto my-4", children: /* @__PURE__ */ jsx(
                  "table",
                  {
                    ...props,
                    className: "min-w-full border-collapse border border-[var(--color-border)]",
                    children
                  }
                ) });
              },
              th({ children, ...props }) {
                return /* @__PURE__ */ jsx(
                  "th",
                  {
                    ...props,
                    className: "border border-[var(--color-border)] bg-[var(--color-muted)] px-4 py-2 text-left font-semibold",
                    children
                  }
                );
              },
              td({ children, ...props }) {
                return /* @__PURE__ */ jsx(
                  "td",
                  {
                    ...props,
                    className: "border border-[var(--color-border)] px-4 py-2",
                    children
                  }
                );
              },
              // Strip <pre> wrapper so block code renders inline when needed
              pre({ children }) {
                return /* @__PURE__ */ jsx(Fragment, { children });
              },
              // Style blockquotes
              blockquote({ children, ...props }) {
                return /* @__PURE__ */ jsx(
                  "blockquote",
                  {
                    ...props,
                    className: "border-l-heavy border-[var(--color-primary)] pl-4 italic text-[var(--color-foreground)] my-4",
                    children
                  }
                );
              }
            },
            children: safeContent
          }
        )
      }
    );
    if (!askEvent && !noteEvent) return body;
    return /* @__PURE__ */ jsx(SelectionAnnotator, { askEvent, noteEvent, askLabel, noteLabel, children: body });
  },
  (prev, next) => prev.content === next.content && prev.className === next.className && prev.direction === next.direction && prev.askEvent === next.askEvent && prev.noteEvent === next.noteEvent && prev.askLabel === next.askLabel && prev.noteLabel === next.noteLabel && prev.annotations === next.annotations && prev.annotationEvent === next.annotationEvent && samePassthrough(prev, next)
);
MarkdownContent.displayName = "MarkdownContent";
var CHANGE_KIND_ICON = {
  "orbital-added": "circle-plus",
  "orbital-removed": "circle-minus",
  "entity-fields-changed": "database",
  "trait-added": "plus-square",
  "trait-removed": "minus-square",
  "trait-config-changed": "sliders-horizontal",
  "state-machine-changed": "git-branch",
  "guard-changed": "shield",
  "effect-changed": "zap",
  "render-ui-changed": "layout-panel-top",
  "event-wiring-changed": "cable",
  "page-changed": "file",
  "theme-changed": "palette",
  "behavior-composed": "layers"
};
function jumpTargetOf(activity) {
  switch (activity.type) {
    case "orbital_started":
    case "orbital_done":
      return { orbital: activity.orbitalName };
    case "schema_change":
      return {
        orbital: activity.orbitalName,
        ...activity.traitName !== void 0 ? { trait: activity.traitName } : {},
        ...activity.transitionEvent !== void 0 ? { transition: activity.transitionEvent } : {}
      };
    default:
      return void 0;
  }
}
function activityRowFacts(items, activityOf) {
  const facts = items.map(() => ({ settled: false, readyCount: 0 }));
  const open = /* @__PURE__ */ new Map();
  let ready = /* @__PURE__ */ new Set();
  items.forEach((item, index) => {
    const activity = activityOf(item);
    if (activity === null) return;
    if (activity.type === "orbital_started") {
      open.set(activity.orbitalName, [...open.get(activity.orbitalName) ?? [], index]);
    } else if (activity.type === "orbital_done") {
      const starts = open.get(activity.orbitalName) ?? [];
      const last = starts.pop();
      if (last !== void 0) facts[last].settled = true;
      open.set(activity.orbitalName, starts);
      ready.add(activity.orbitalName);
    } else if (activity.type === "done") {
      facts[index].readyCount = ready.size;
      ready = /* @__PURE__ */ new Set();
    }
  });
  return facts;
}
function describe(activity, t, facts) {
  switch (activity.type) {
    case "message":
      return { icon: "info", color: "muted", text: activity.content, details: [] };
    case "tool_call":
      return {
        icon: "wrench",
        color: "muted",
        text: t("agentActivity.toolCall", { tool: activity.tool }),
        details: [],
        ...activity.argsText !== "" && activity.argsText !== "{}" ? { raw: activity.argsText } : {}
      };
    case "tool_result":
      return {
        icon: activity.success ? "corner-down-right" : "alert-circle",
        color: activity.success ? "muted" : "error",
        text: t("agentActivity.toolResult", { tool: activity.tool }),
        details: [
          ...activity.detail !== void 0 ? [activity.detail] : [],
          ...activity.rows !== void 0 ? [t("agentActivity.toolRows", { count: activity.rows })] : []
        ],
        raw: activity.resultText
      };
    case "file_operation":
      return { icon: "file-text", color: "muted", text: t("agentActivity.fileOperation", { operation: activity.operation }), details: [activity.path] };
    case "schema_diff":
      return { icon: "file-diff", color: "muted", text: t("agentActivity.schemaDiff", { filePath: activity.filePath }), details: [] };
    case "error":
      return { icon: "alert-circle", color: "error", text: activity.message, details: activity.code ? [activity.code] : [] };
    case "coordinator_decision":
      return { icon: "compass", color: "muted", text: t("agentActivity.coordinatorDecision", { organism: activity.organism }), details: [activity.reason] };
    case "plan_committed":
      return { icon: "layers", color: "muted", text: t("agentActivity.roster", { count: activity.orbitals.length }), details: [activity.orbitals.join(", ")] };
    case "pending_question":
      return { icon: "help-circle", color: "warning", text: activity.question, details: [] };
    case "clarification_question":
      return {
        icon: "help-circle",
        color: "warning",
        text: activity.question,
        details: activity.candidates.map((c) => c.whyThisFits ? `${c.label} \u2014 ${c.whyThisFits}` : c.label)
      };
    case "analysis":
      return {
        icon: "check",
        color: "success",
        text: t("agentActivity.analyzed", { organism: activity.organism }),
        details: [
          ...activity.organismReason ? [activity.organismReason] : [],
          ...activity.complexity?.reasoning ? [activity.complexity.reasoning] : [],
          ...activity.renames.map((r) => t("agentActivity.renamed", { from: r.from, to: r.to })),
          ...activity.deletes.map((d) => t("agentActivity.deleted", { orbitalName: d }))
        ]
      };
    case "orbital_started":
      return facts.settled ? { icon: "layers", color: "muted", text: t("agentActivity.orbitalStartedSettled", { orbitalName: activity.orbitalName }), details: [] } : { icon: "loader", color: "primary", animation: "spin", text: t("agentActivity.orbitalStarted", { orbitalName: activity.orbitalName }), details: [] };
    case "orbital_done":
      return {
        icon: "check",
        color: "success",
        text: t("agentActivity.orbitalDone", { orbitalName: activity.orbitalName }),
        details: activity.traitCount !== void 0 || activity.transitionCount !== void 0 ? [t("agentActivity.orbitalCounts", { traitCount: activity.traitCount ?? 0, transitionCount: activity.transitionCount ?? 0 })] : []
      };
    case "schema_change":
      return {
        icon: CHANGE_KIND_ICON[activity.changeKind],
        color: "primary",
        text: t(`agentActivity.change.${activity.changeKind}`, { orbitalName: activity.orbitalName }),
        details: [activity.traitName, activity.transitionEvent].filter((d) => d !== void 0)
      };
    case "done":
      return { icon: "check-circle", color: "success", text: t("agentActivity.done", { count: facts.readyCount }), details: [] };
    case "cancelled":
      return { icon: "circle-x", color: "muted", text: activity.message || t("agentActivity.cancelled"), details: [] };
    case "llm_response":
      return { icon: "cpu", color: "muted", text: t("agentActivity.llmResponse"), details: [activity.content] };
  }
}
function llmSummary(activity, t) {
  const llm = activity.llm;
  if (!llm) return t("agentActivity.llmResponse");
  const parts = [
    `${llm.service} \xB7 ${llm.model}`,
    t("agentActivity.llmDuration", { seconds: (llm.durationMs / 1e3).toFixed(1) }),
    ...llm.promptTokens !== void 0 || llm.completionTokens !== void 0 ? [t("agentActivity.llmTokens", { prompt: llm.promptTokens ?? 0, completion: llm.completionTokens ?? 0 })] : [],
    ...llm.costUSD !== void 0 ? [`$${llm.costUSD.toFixed(4)}`] : []
  ];
  return parts.join(" \xB7 ");
}
function LlmSection({ label, text }) {
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-full", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", color: "muted", children: label }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "whitespace-pre-wrap break-all font-mono", children: text })
  ] });
}
function LlmResponseRow({ activity }) {
  const { t } = useTranslate();
  const llm = activity.llm;
  return /* @__PURE__ */ jsx(Box, { className: "w-full", "data-testid": "agent-activity-llm_response", children: /* @__PURE__ */ jsx(
    Accordion,
    {
      items: [{
        id: `llm-${activity.timestamp}`,
        header: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 min-w-0", children: [
          /* @__PURE__ */ jsx(Icon, { name: "cpu", size: "sm", color: "muted", className: "shrink-0" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "truncate", children: llmSummary(activity, t) })
        ] }),
        content: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "w-full", children: [
          /* @__PURE__ */ jsx(LlmSection, { label: t("agentActivity.llmResponseLabel"), text: activity.content }),
          llm && /* @__PURE__ */ jsx(LlmSection, { label: t("agentActivity.llmSystemPrompt"), text: llm.systemPrompt }),
          llm && /* @__PURE__ */ jsx(LlmSection, { label: t("agentActivity.llmUserPrompt"), text: llm.userPrompt }),
          llm?.toolCallsJson && /* @__PURE__ */ jsx(LlmSection, { label: t("agentActivity.llmToolCalls"), text: llm.toolCallsJson })
        ] })
      }]
    }
  ) });
}
function AgentActivityRow({ activity, onJump, facts }) {
  const { t } = useTranslate();
  if (activity.type === "llm_response") return /* @__PURE__ */ jsx(LlmResponseRow, { activity });
  if (activity.type === "message" && activity.role !== "system") {
    const mine = activity.role === "user";
    return /* @__PURE__ */ jsx(
      Box,
      {
        "data-testid": `agent-activity-${mine ? "user" : "assistant"}-message`,
        className: `max-w-[90%] rounded-[var(--radius-lg)] px-3 py-2 ${mine ? "self-end bg-[var(--color-primary)] text-[var(--color-primary-foreground)]" : "self-start bg-[var(--color-surface)]"}`,
        children: mine ? /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "inherit", className: "whitespace-pre-wrap break-words", children: activity.content }) : /* @__PURE__ */ jsx(MarkdownContent, { content: activity.content, className: "prose-sm break-words" })
      }
    );
  }
  const spec = describe(activity, t, facts);
  const target = jumpTargetOf(activity);
  return /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-2 w-full", "data-testid": `agent-activity-${activity.type}`, children: [
    /* @__PURE__ */ jsx(Icon, { name: spec.icon, size: "sm", color: spec.color, animation: spec.animation, className: "mt-0.5 shrink-0" }),
    /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0", children: [
      spec.raw === void 0 ? /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "break-words", children: spec.text }) : /* @__PURE__ */ jsx(
        Accordion,
        {
          items: [{
            id: `${activity.type}-${activity.timestamp}`,
            header: /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "break-words", children: spec.text }),
            content: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "whitespace-pre-wrap break-all font-mono", children: spec.raw })
          }]
        }
      ),
      spec.details.map((detail, i) => /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "break-all whitespace-pre-wrap", children: detail }, i))
    ] }),
    onJump && target && /* @__PURE__ */ jsxs(Button, { variant: "ghost", size: "sm", onClick: () => onJump(target), "data-testid": "agent-activity-jump", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("agentActivity.jump") }),
      /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: "xs" })
    ] })
  ] });
}
function AgentThinkingRow() {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 w-full", "data-testid": "agent-activity-thinking", role: "status", "aria-live": "polite", children: [
    /* @__PURE__ */ jsx(Icon, { name: "loader", size: "sm", color: "primary", animation: "spin", className: "shrink-0" }),
    /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: t("agentActivity.thinking") })
  ] });
}
function groupIntoConversations(activities) {
  const groups = [];
  for (const activity of activities) {
    const isPrompt = activity.type === "message" && activity.role === "user";
    const current = groups[groups.length - 1];
    if (isPrompt || !current) {
      groups.push({ ...isPrompt ? { prompt: activity.content } : {}, startedAt: activity.timestamp, activities: [activity] });
    } else {
      current.activities.push(activity);
    }
  }
  return groups;
}
function ConversationRows({ activities, onJump }) {
  const facts = activityRowFacts(activities, (activity) => activity);
  return /* @__PURE__ */ jsx(Fragment, { children: activities.map((activity, index) => /* @__PURE__ */ jsx(AgentActivityRow, { activity, onJump, facts: facts[index] }, `${activity.type}-${activity.timestamp}-${index}`)) });
}
function EarlierConversations({ conversations, onJump }) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1 w-full", "data-testid": "agent-earlier-conversations", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "semibold", children: t("agentActivity.earlierConversations", { count: conversations.length }) }),
    /* @__PURE__ */ jsx(
      Accordion,
      {
        multiple: true,
        items: conversations.map((conversation, i) => ({
          id: `conversation-${conversation.startedAt}-${i}`,
          header: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 min-w-0", "data-testid": "agent-earlier-conversation", children: [
            /* @__PURE__ */ jsx(Icon, { name: "message-square", size: "sm", color: "muted", className: "shrink-0" }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "truncate", children: conversation.prompt ?? t("agentActivity.earlierActivity") })
          ] }),
          content: /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-2 w-full", children: /* @__PURE__ */ jsx(
            ConversationRows,
            {
              activities: conversation.prompt === void 0 ? conversation.activities : conversation.activities.slice(1),
              onJump
            }
          ) })
        }))
      }
    )
  ] });
}
function AgentActivityFeed({ activities, working = false, onJump, emptyTitle, emptyDescription, followLatest = true, className }) {
  const { t } = useTranslate();
  const endRef = useRef(null);
  useEffect(() => {
    if (followLatest) endRef.current?.scrollIntoView?.({ block: "end" });
  }, [activities.length, working, followLatest]);
  const conversations = groupIntoConversations(activities);
  const earlier = conversations.slice(0, -1);
  const current = conversations[conversations.length - 1];
  if (activities.length === 0 && !working) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        icon: "sparkles",
        title: emptyTitle ?? t("agentActivity.emptyTitle"),
        description: emptyDescription ?? t("agentActivity.emptyDescription")
      }
    );
  }
  return /* @__PURE__ */ jsxs(Box, { className: `flex flex-col gap-2 ${className ?? ""}`, "data-testid": "agent-activity-feed", children: [
    earlier.length > 0 ? /* @__PURE__ */ jsx(EarlierConversations, { conversations: earlier, onJump }) : null,
    /* @__PURE__ */ jsx(ConversationRows, { activities: current?.activities ?? [], onJump }),
    working ? /* @__PURE__ */ jsx(AgentThinkingRow, {}) : null,
    /* @__PURE__ */ jsx(Box, { ref: endRef })
  ] });
}
AgentActivityFeed.displayName = "AgentActivityFeed";
AgentActivityRow.displayName = "AgentActivityRow";
var FOLLOW_SLACK_PX = 48;
function readFlag(key) {
  try {
    return localStorage.getItem(key) === "true";
  } catch {
    return false;
  }
}
function isUserMessage(a) {
  return a.type === "message" && a.role === "user";
}
function isReply(a) {
  return a.type === "message" && a.role !== "user" || a.type === "error";
}
function groupTurns(activities) {
  const turns = [];
  for (const activity of activities) {
    const current = turns[turns.length - 1];
    if (isUserMessage(activity) || current === void 0) {
      turns.push({
        ...isUserMessage(activity) ? { request: activity } : {},
        steps: isUserMessage(activity) || isReply(activity) ? [] : [activity],
        replies: isReply(activity) ? [activity] : [],
        startedAt: activity.timestamp
      });
    } else if (isReply(activity)) {
      current.replies.push(activity);
    } else {
      current.steps.push(activity);
    }
  }
  return turns;
}
function dayKey(ts) {
  return new Date(ts).toDateString();
}
function messageText(a) {
  return a.type === "message" ? a.content : "";
}
function DaySeparator({ ts }) {
  const { t } = useTranslate();
  const today = dayKey(Date.now());
  const yesterday = dayKey(Date.now() - 24 * 60 * 60 * 1e3);
  const key = dayKey(ts);
  const label = key === today ? t("agentChat.today") : key === yesterday ? t("agentChat.yesterday") : new Date(ts).toLocaleDateString(void 0, { month: "short", day: "numeric", year: "numeric" });
  return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 w-full py-1", "data-testid": "agent-chat-day", role: "separator", children: [
    /* @__PURE__ */ jsx(Box, { className: "h-px flex-1 bg-[var(--color-border)]" }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: label }),
    /* @__PURE__ */ jsx(Box, { className: "h-px flex-1 bg-[var(--color-border)]" })
  ] });
}
function Time({ ts, align }) {
  return /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: align === "end" ? "self-end" : "self-start", children: new Date(ts).toLocaleTimeString(void 0, { hour: "2-digit", minute: "2-digit" }) });
}
function CopyReply({ text }) {
  const { t } = useTranslate();
  const [copied, setCopied] = useState(false);
  const copy = useCallback(() => {
    void navigator.clipboard?.writeText(text).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    });
  }, [text]);
  return /* @__PURE__ */ jsx(
    Button,
    {
      variant: "ghost",
      size: "sm",
      onClick: copy,
      "aria-label": copied ? t("agentChat.copied") : t("agentChat.copy"),
      title: copied ? t("agentChat.copied") : t("agentChat.copy"),
      "data-testid": "agent-chat-copy",
      children: /* @__PURE__ */ jsx(Icon, { name: copied ? "check" : "copy", size: "xs" })
    }
  );
}
function StepRows({ steps }) {
  const facts = activityRowFacts(steps, (a) => a);
  return /* @__PURE__ */ jsx(VStack, { gap: "xs", className: "w-full", children: steps.map((step, i) => /* @__PURE__ */ jsx(AgentActivityRow, { activity: step, facts: facts[i] }, `${step.type}-${step.timestamp}-${i}`)) });
}
function TurnSteps({ steps, showRawLlm, onToggleRaw, idPrefix, index }) {
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  const visible = showRawLlm ? steps : steps.filter((s) => s.type !== "llm_response");
  const toolSteps = steps.filter((s) => s.type !== "llm_response").length;
  const hasRaw = steps.some((s) => s.type === "llm_response");
  if (toolSteps === 0 && !hasRaw) return null;
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "self-start w-full max-w-[90%]", "data-testid": "agent-chat-steps", children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: () => setOpen((v) => !v),
        "aria-expanded": open,
        className: "self-start",
        "data-testid": "agent-chat-steps-toggle",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: open ? "chevron-down" : "chevron-right", size: "xs" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("agentChat.workedThrough", { count: toolSteps }) })
        ]
      }
    ),
    open ? /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "w-full border-s-[length:var(--border-width)] border-[var(--color-border)] ps-3", children: [
      hasRaw ? /* @__PURE__ */ jsx(Switch, { checked: showRawLlm, onChange: onToggleRaw, label: t("agentActivity.showRawLlm"), id: `${idPrefix}-show-raw-llm-${index}` }) : null,
      /* @__PURE__ */ jsx(StepRows, { steps: visible })
    ] }) : null
  ] });
}
function AgentChatFeed({ activities, emptyTitle, rawLlmPreferenceKey, idPrefix, working = false, className }) {
  const { t } = useTranslate();
  const [showRawLlm, setShowRawLlm] = useState(() => readFlag(rawLlmPreferenceKey));
  const scrollerRef = useRef(null);
  const endRef = useRef(null);
  const atBottomRef = useRef(true);
  const [unseen, setUnseen] = useState(false);
  const handleToggle = useCallback((checked) => {
    setShowRawLlm(checked);
    try {
      localStorage.setItem(rawLlmPreferenceKey, String(checked));
    } catch {
    }
  }, [rawLlmPreferenceKey]);
  const onScroll = useCallback(() => {
    const el = scrollerRef.current;
    if (!el) return;
    atBottomRef.current = el.scrollHeight - el.scrollTop - el.clientHeight <= FOLLOW_SLACK_PX;
    if (atBottomRef.current) setUnseen(false);
  }, []);
  const jumpToLatest = useCallback(() => {
    endRef.current?.scrollIntoView?.({ block: "end" });
    atBottomRef.current = true;
    setUnseen(false);
  }, []);
  useEffect(() => {
    if (atBottomRef.current) endRef.current?.scrollIntoView?.({ block: "end" });
    else setUnseen(true);
  }, [activities.length, working]);
  const turns = useMemo(() => groupTurns(activities), [activities]);
  if (activities.length === 0 && !working) {
    return /* @__PURE__ */ jsx(VStack, { gap: "none", className: `min-h-0 items-center justify-center ${className ?? ""}`, children: /* @__PURE__ */ jsx(EmptyState, { icon: "sparkles", title: emptyTitle, description: t("agentChat.emptyDescription") }) });
  }
  return /* @__PURE__ */ jsxs(Box, { className: `relative flex flex-col min-h-0 ${className ?? ""}`, children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: scrollerRef,
        onScroll,
        className: "flex-1 min-h-0 overflow-y-auto p-3",
        "data-testid": `${idPrefix}-scroller`,
        role: "log",
        "aria-live": "polite",
        children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "w-full", children: [
          turns.map((turn, i) => {
            const previous = turns[i - 1];
            const newDay = previous === void 0 || dayKey(previous.startedAt) !== dayKey(turn.startedAt);
            const isLast = i === turns.length - 1;
            const live = isLast && working && turn.replies.length === 0;
            return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "w-full", children: [
              newDay ? /* @__PURE__ */ jsx(DaySeparator, { ts: turn.startedAt }) : null,
              turn.request !== void 0 ? /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-full", children: [
                /* @__PURE__ */ jsx(AgentActivityRow, { activity: turn.request, facts: activityRowFacts([turn.request], (a) => a)[0] }),
                /* @__PURE__ */ jsx(Time, { ts: turn.request.timestamp, align: "end" })
              ] }) : null,
              live ? /* @__PURE__ */ jsx(StepRows, { steps: showRawLlm ? turn.steps : turn.steps.filter((s) => s.type !== "llm_response") }) : /* @__PURE__ */ jsx(TurnSteps, { steps: turn.steps, showRawLlm, onToggleRaw: handleToggle, idPrefix, index: i }),
              turn.replies.map((reply, r) => /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-full", children: [
                /* @__PURE__ */ jsx(AgentActivityRow, { activity: reply, facts: activityRowFacts([reply], (a) => a)[0] }),
                /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1 self-start", children: [
                  /* @__PURE__ */ jsx(Time, { ts: reply.timestamp, align: "start" }),
                  reply.type === "message" ? /* @__PURE__ */ jsx(CopyReply, { text: messageText(reply) }) : null
                ] })
              ] }, `reply-${reply.timestamp}-${r}`))
            ] }, `turn-${turn.startedAt}-${i}`);
          }),
          working ? /* @__PURE__ */ jsx(AgentThinkingRow, {}) : null,
          /* @__PURE__ */ jsx(Box, { ref: endRef })
        ] })
      }
    ),
    unseen ? /* @__PURE__ */ jsx(Box, { className: "absolute inset-x-0 bottom-2 flex justify-center pointer-events-none", children: /* @__PURE__ */ jsxs(
      Button,
      {
        variant: "secondary",
        size: "sm",
        onClick: jumpToLatest,
        className: "pointer-events-auto shadow-elevation-toast",
        "data-testid": "agent-chat-new-messages",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "arrow-down", size: "xs" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("agentChat.newMessages") })
        ]
      }
    ) }) : null
  ] });
}
AgentChatFeed.displayName = "AgentChatFeed";
var variantBorderClasses = {
  info: "border-info",
  success: "border-success",
  warning: "border-warning",
  error: "border-error"
};
var variantIconColors = {
  info: "text-info",
  success: "text-success",
  warning: "text-warning",
  error: "text-error"
};
var iconMap2 = {
  info: "info",
  success: "check-circle",
  warning: "alert-triangle",
  error: "alert-circle"
};
var Alert = ({
  children,
  message,
  variant = "info",
  title,
  dismissible = false,
  onDismiss,
  onClose,
  actions,
  icon,
  className,
  dismissEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleDismissCallback = onDismiss || onClose;
  const handleDismiss = () => {
    if (dismissEvent) eventBus.emit(`UI:${dismissEvent}`, {});
    handleDismissCallback?.();
  };
  const content = children ?? message;
  const isUrgent = variant === "error" || variant === "warning";
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      bg: "surface",
      border: true,
      padding: "md",
      className: cn("rounded-container shadow-elevation-card", variantBorderClasses[variant], className),
      role: isUrgent ? "alert" : "status",
      "data-pattern": "alert",
      children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
        /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 mt-0.5", children: icon && typeof icon !== "string" ? /* @__PURE__ */ jsx(Icon, { icon, size: "md", className: variantIconColors[variant] }) : /* @__PURE__ */ jsx(Icon, { name: icon ?? iconMap2[variant], size: "md", className: variantIconColors[variant] }) }),
        /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
          title && /* @__PURE__ */ jsx(Typography, { variant: "h6", className: "mb-1", children: title }),
          /* @__PURE__ */ jsx(Typography, { variant: "body2", children: content }),
          actions && /* @__PURE__ */ jsx(HStack, { gap: "sm", wrap: true, className: "mt-3", children: actions })
        ] }),
        (dismissible || dismissEvent || handleDismissCallback) && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            icon: "x",
            onClick: handleDismiss,
            className: "flex-shrink-0",
            "aria-label": t("aria.closeAlert")
          }
        )
      ] })
    }
  );
};
Alert.displayName = "Alert";
var FloatingActionButton = ({
  action,
  actionPayload,
  actions,
  icon,
  onClick,
  variant,
  label,
  position = "bottom-right",
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const resolvedAction = icon ? {
    icon,
    onClick: () => {
      if (action) eventBus.emit(`UI:${action}`, actionPayload ?? {});
      onClick?.();
    },
    label,
    variant
  } : void 0;
  const [isExpanded, setIsExpanded] = useState(false);
  const fabRef = useRef(null);
  useEffect(() => {
    if (!isExpanded || !actions || actions.length <= 1) return;
    const handleClickOutside = (event) => {
      if (fabRef.current && !fabRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isExpanded, actions]);
  const positionClasses2 = {
    "bottom-right": "bottom-6 right-6",
    "bottom-left": "bottom-6 left-6",
    "bottom-center": "bottom-6 left-1/2 -translate-x-1/2",
    "top-right": "top-6 right-6",
    "top-left": "top-6 left-6",
    "top-center": "top-6 left-1/2 -translate-x-1/2"
  };
  if (resolvedAction && (!actions || actions.length === 0)) {
    return /* @__PURE__ */ jsx(Box, { className: cn("fixed z-50", positionClasses2[position], className), children: /* @__PURE__ */ jsx(
      Button,
      {
        ...domPassthrough(rest),
        variant: resolvedAction.variant || "primary",
        size: "lg",
        icon: resolvedAction.icon,
        onClick: resolvedAction.onClick,
        className: "rounded-full shadow-elevation-popover",
        "aria-label": rest["aria-label"] ?? (resolvedAction.label || t("fab.action")),
        children: resolvedAction.label && /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: resolvedAction.label })
      }
    ) });
  }
  if (actions && actions.length > 0) {
    const handleMainClick = () => {
      if (actions.length === 1) {
        if (actions[0].event) eventBus.emit(`UI:${actions[0].event}`, { actionId: actions[0].id });
        actions[0].onClick?.();
      } else {
        setIsExpanded(!isExpanded);
      }
    };
    return /* @__PURE__ */ jsxs(
      Box,
      {
        ref: fabRef,
        className: cn(
          "fixed z-50 flex flex-col items-end gap-3",
          positionClasses2[position],
          position.includes("left") && "items-start",
          className
        ),
        children: [
          isExpanded && actions.length > 1 && /* @__PURE__ */ jsx(
            VStack,
            {
              className: cn(
                "gap-3",
                position.includes("left") ? "items-start" : "items-end"
              ),
              children: actions.map((actionItem, index) => /* @__PURE__ */ jsxs(
                HStack,
                {
                  align: "center",
                  gap: "sm",
                  className: "transition-all duration-fast",
                  style: {
                    opacity: isExpanded ? 1 : 0,
                    transform: isExpanded ? "translateY(0)" : "translateY(10px)",
                    transitionDelay: `${index * 50}ms`
                  },
                  children: [
                    position.includes("right") && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground bg-card px-2 py-1 rounded-interactive shadow-elevation-card whitespace-nowrap", children: actionItem.label }),
                    /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: actionItem.variant || "primary",
                        size: "lg",
                        icon: actionItem.icon,
                        onClick: () => {
                          setIsExpanded(false);
                          if (actionItem.event) eventBus.emit(`UI:${actionItem.event}`, { actionId: actionItem.id });
                          actionItem.onClick?.();
                        },
                        className: "rounded-full shadow-elevation-popover",
                        "aria-label": actionItem.label,
                        children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: actionItem.label })
                      }
                    ),
                    position.includes("left") && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground bg-card px-2 py-1 rounded-interactive shadow-elevation-card whitespace-nowrap", children: actionItem.label })
                  ]
                },
                actionItem.id
              ))
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              ...domPassthrough(rest),
              variant: isExpanded ? "secondary" : "primary",
              size: "lg",
              icon: isExpanded ? "x" : "plus",
              onClick: handleMainClick,
              className: "rounded-full shadow-elevation-popover transition-all duration-normal",
              "aria-label": rest["aria-label"] ?? (isExpanded ? t("fab.closeActions") : t("fab.openActions")),
              "aria-expanded": isExpanded,
              children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: isExpanded ? t("common.close") : t("common.open") })
            }
          )
        ]
      }
    );
  }
  return null;
};
FloatingActionButton.displayName = "FloatingActionButton";
function ButtonPattern({
  action,
  onClick,
  event,
  icon,
  iconPosition,
  ...rest
}) {
  const resolvedAction = action ?? onClick ?? event;
  const iconProps = iconPosition === "right" ? { iconRight: icon } : { icon };
  return /* @__PURE__ */ jsx(Button, { ...rest, action: resolvedAction, ...iconProps });
}
ButtonPattern.displayName = "ButtonPattern";
function IconButtonPattern({
  action,
  onClick,
  event,
  icon,
  ariaLabel,
  variant = "ghost",
  ...rest
}) {
  const resolvedAction = action ?? onClick ?? event;
  const name = ariaLabel ?? rest["aria-label"] ?? rest.label;
  if (name) {
    const { label: _label, "aria-label": _ariaLabel, ...named } = rest;
    return /* @__PURE__ */ jsx(IconButton, { ...named, variant, action: resolvedAction, icon, label: name });
  }
  return /* @__PURE__ */ jsx(Button, { ...rest, variant, action: resolvedAction, icon });
}
IconButtonPattern.displayName = "IconButtonPattern";
function TextPattern({
  content,
  variant = "body",
  size: size2 = "md",
  weight = "normal",
  color,
  align,
  className
}) {
  return /* @__PURE__ */ jsx(
    Typography,
    {
      variant,
      size: size2,
      weight,
      className,
      style: { color, textAlign: align },
      children: content
    }
  );
}
TextPattern.displayName = "TextPattern";
function LabelPattern({
  text,
  htmlFor,
  required = false,
  className
}) {
  return /* @__PURE__ */ jsx(Label, { htmlFor, required, className, children: text });
}
LabelPattern.displayName = "LabelPattern";
function AlertPattern({
  message,
  title,
  variant = "info",
  dismissible = false,
  onDismiss,
  className
}) {
  const { emit } = useEventBus();
  const handleDismiss = () => {
    if (onDismiss) {
      emit(`UI:${onDismiss}`, {});
    }
  };
  return /* @__PURE__ */ jsx(
    Alert,
    {
      message,
      title,
      variant,
      dismissible,
      onDismiss: dismissible ? handleDismiss : void 0,
      className
    }
  );
}
AlertPattern.displayName = "AlertPattern";
var NODE_STATE_COLOR = {
  unvisited: "ink",
  frontier: "highlight",
  current: "primary",
  visited: "muted",
  goal: "success",
  path: "accent"
};
var EDGE_STATE_COLOR = {
  default: "ink",
  tree: "muted",
  relaxed: "primary",
  candidate: "highlight",
  path: "accent"
};
var DEFAULT_NODE_RADIUS = 18;
function layoutCircle(nodes, width, height) {
  const cx = width / 2;
  const cy = height / 2;
  const radius = Math.max(10, Math.min(cx, cy) - 40);
  const positions = /* @__PURE__ */ new Map();
  const n = nodes.length;
  nodes.forEach((node, i) => {
    const angle = 2 * Math.PI * i / Math.max(n, 1) - Math.PI / 2;
    positions.set(node.id, { x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) });
  });
  return positions;
}
function layoutTree(nodes, edges, root, width, height) {
  const nodeIds = nodes.map((n) => n.id);
  const idSet = new Set(nodeIds);
  const childrenOf = /* @__PURE__ */ new Map();
  const hasIncoming = /* @__PURE__ */ new Set();
  for (const e of edges) {
    if (!idSet.has(e.from) || !idSet.has(e.to)) continue;
    const list = childrenOf.get(e.from) ?? [];
    list.push(e.to);
    childrenOf.set(e.from, list);
    hasIncoming.add(e.to);
  }
  const depth = /* @__PURE__ */ new Map();
  const treeChildren = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  const bfsFrom = (start) => {
    if (visited.has(start)) return;
    visited.add(start);
    depth.set(start, 0);
    const queue = [start];
    while (queue.length > 0) {
      const u = queue.shift();
      for (const v of childrenOf.get(u) ?? []) {
        if (visited.has(v)) continue;
        visited.add(v);
        depth.set(v, (depth.get(u) ?? 0) + 1);
        const list = treeChildren.get(u) ?? [];
        list.push(v);
        treeChildren.set(u, list);
        queue.push(v);
      }
    }
  };
  const primaryRoot = root && idSet.has(root) ? root : nodeIds.find((id) => !hasIncoming.has(id)) ?? nodeIds[0];
  const rootsOrder = [];
  if (primaryRoot !== void 0) {
    bfsFrom(primaryRoot);
    rootsOrder.push(primaryRoot);
  }
  for (const id of nodeIds) {
    if (!visited.has(id)) {
      bfsFrom(id);
      rootsOrder.push(id);
    }
  }
  let leafCounter = 0;
  const xSlot = /* @__PURE__ */ new Map();
  const assignXSlot = (u) => {
    const children = treeChildren.get(u) ?? [];
    if (children.length === 0) {
      const slot = leafCounter++;
      xSlot.set(u, slot);
      return slot;
    }
    const childSlots = children.map(assignXSlot);
    const avg = childSlots.reduce((a, b) => a + b, 0) / childSlots.length;
    xSlot.set(u, avg);
    return avg;
  };
  for (const r of rootsOrder) assignXSlot(r);
  let maxDepth = 0;
  for (const d of depth.values()) maxDepth = Math.max(maxDepth, d);
  const colWidth = width / Math.max(1, leafCounter);
  const rowHeight = height / (maxDepth + 1);
  const positions = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    const slot = xSlot.get(id) ?? 0;
    const d = depth.get(id) ?? 0;
    positions.set(id, { x: slot * colWidth + colWidth / 2, y: d * rowHeight + rowHeight / 2 });
  }
  return positions;
}
function layoutLayered(nodes, edges, width, height) {
  const nodeIds = nodes.map((n) => n.id);
  const idSet = new Set(nodeIds);
  const adj = /* @__PURE__ */ new Map();
  const remainingIndegree = /* @__PURE__ */ new Map();
  for (const id of nodeIds) remainingIndegree.set(id, 0);
  for (const e of edges) {
    if (!idSet.has(e.from) || !idSet.has(e.to)) continue;
    const list = adj.get(e.from) ?? [];
    list.push(e.to);
    adj.set(e.from, list);
    remainingIndegree.set(e.to, (remainingIndegree.get(e.to) ?? 0) + 1);
  }
  const layer = /* @__PURE__ */ new Map();
  const dequeued = /* @__PURE__ */ new Set();
  const queue = [];
  for (const id of nodeIds) {
    if ((remainingIndegree.get(id) ?? 0) === 0) {
      layer.set(id, 0);
      queue.push(id);
    }
  }
  while (queue.length > 0) {
    const u = queue.shift();
    dequeued.add(u);
    for (const v of adj.get(u) ?? []) {
      const candidate = (layer.get(u) ?? 0) + 1;
      layer.set(v, Math.max(layer.get(v) ?? 0, candidate));
      remainingIndegree.set(v, (remainingIndegree.get(v) ?? 0) - 1);
      if ((remainingIndegree.get(v) ?? 0) === 0 && !dequeued.has(v)) {
        queue.push(v);
      }
    }
  }
  let baseMaxLayer = 0;
  for (const id of nodeIds) {
    if (dequeued.has(id)) baseMaxLayer = Math.max(baseMaxLayer, layer.get(id) ?? 0);
  }
  const cycleLayer = baseMaxLayer + 1;
  let maxLayer = baseMaxLayer;
  for (const id of nodeIds) {
    if (!dequeued.has(id)) {
      layer.set(id, cycleLayer);
      maxLayer = cycleLayer;
    }
  }
  const colWidth = width / Math.max(1, maxLayer + 1);
  const byLayer = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    const l = layer.get(id) ?? 0;
    const list = byLayer.get(l) ?? [];
    list.push(id);
    byLayer.set(l, list);
  }
  const positions = /* @__PURE__ */ new Map();
  for (const [l, ids] of byLayer) {
    const rowHeight = height / ids.length;
    ids.forEach((id, i) => {
      positions.set(id, { x: l * colWidth + colWidth / 2, y: i * rowHeight + rowHeight / 2 });
    });
  }
  return positions;
}
function computePositions(nodes, edges, layout, root, width, height) {
  switch (layout) {
    case "circle":
      return layoutCircle(nodes, width, height);
    case "tree":
      return layoutTree(nodes, edges, root, width, height);
    case "layered":
      return layoutLayered(nodes, edges, width, height);
    case "manual":
    default: {
      const positions = /* @__PURE__ */ new Map();
      for (const n of nodes) positions.set(n.id, { x: n.x ?? 0, y: n.y ?? 0 });
      return positions;
    }
  }
}
var AlgoGraphCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  keyMap,
  keyUpMap,
  nodes = [],
  edges = [],
  layout = "manual",
  root,
  shapes = [],
  interactive = false,
  animate = false,
  onShapeClick,
  onNodeClick,
  isLoading,
  error,
  ...rest
}) => {
  const nodeById = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const n of nodes) m.set(n.id, n);
    return m;
  }, [nodes]);
  const nodeIndexById = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    nodes.forEach((n, i) => m.set(n.id, i));
    return m;
  }, [nodes]);
  const derivedShapes = useMemo(() => {
    const out = [];
    const positions = computePositions(nodes, edges, layout, root, width, height);
    const edgeGeoms = [];
    for (const e of edges) {
      const a = nodeById.get(e.from);
      const b = nodeById.get(e.to);
      const posA = positions.get(e.from);
      const posB = positions.get(e.to);
      if (!a || !b || !posA || !posB) continue;
      const rA = a.radius ?? DEFAULT_NODE_RADIUS;
      const rB = b.radius ?? DEFAULT_NODE_RADIUS;
      const dx = posB.x - posA.x;
      const dy = posB.y - posA.y;
      const dist = Math.max(1e-6, Math.hypot(dx, dy));
      const ux = dx / dist;
      const uy = dy / dist;
      edgeGeoms.push({
        directed: e.directed ?? false,
        x1: posA.x + ux * rA,
        y1: posA.y + uy * rA,
        x2: posB.x - ux * rB,
        y2: posB.y - uy * rB,
        color: e.color ?? EDGE_STATE_COLOR[e.state ?? "default"],
        label: e.label ?? (e.weight != null ? String(e.weight) : void 0)
      });
    }
    for (const g of edgeGeoms) {
      out.push({
        type: g.directed ? "arrow" : "line",
        x1: g.x1,
        y1: g.y1,
        x2: g.x2,
        y2: g.y2,
        color: g.color,
        stroke: "normal"
      });
    }
    for (const g of edgeGeoms) {
      if (g.label === void 0) continue;
      const midX = (g.x1 + g.x2) / 2;
      const midY = (g.y1 + g.y2) / 2;
      const dx = g.x2 - g.x1;
      const dy = g.y2 - g.y1;
      const dist = Math.max(1e-6, Math.hypot(dx, dy));
      const perpX = -(dy / dist);
      const perpY = dx / dist;
      out.push({
        type: "text",
        x: midX + perpX * 10,
        y: midY + perpY * 10,
        text: g.label,
        textSize: "sm",
        align: "center",
        tone: "label"
      });
    }
    const nodeGeoms = [];
    for (const n of nodes) {
      const pos = positions.get(n.id);
      if (!pos) continue;
      nodeGeoms.push({
        id: n.id,
        x: pos.x,
        y: pos.y,
        radius: n.radius ?? DEFAULT_NODE_RADIUS,
        color: n.color ?? NODE_STATE_COLOR[n.state ?? "unvisited"],
        label: n.label,
        badge: n.badge
      });
    }
    for (const g of nodeGeoms) {
      out.push({ type: "circle", id: g.id, x: g.x, y: g.y, radius: g.radius, color: g.color, fill: g.color, fillStyle: "tint", stroke: "normal" });
    }
    const badgeGeoms = [];
    for (const g of nodeGeoms) {
      if (!g.badge || g.badge.text === "") continue;
      const w = Math.min(42, Math.max(18, g.badge.text.length * 6 + 10));
      badgeGeoms.push({
        cx: g.x + g.radius * 0.75,
        cy: g.y - g.radius * 0.75,
        w,
        h: 14,
        color: g.badge.color ?? "ink",
        text: g.badge.text
      });
    }
    for (const b of badgeGeoms) {
      out.push({ type: "rect", x: b.cx - b.w / 2, y: b.cy - b.h / 2, width: b.w, height: b.h, color: b.color, fillTone: "fill", fillStyle: "solid", stroke: "thin" });
    }
    for (const b of badgeGeoms) {
      out.push({ type: "text", x: b.cx, y: b.cy, text: b.text, textSize: "xs", align: "center", tone: "ink" });
    }
    for (const g of nodeGeoms) {
      if (g.label === void 0) continue;
      out.push({
        type: "text",
        x: g.x,
        y: g.y + g.radius + 14,
        text: g.label,
        textSize: "sm",
        align: "center",
        tone: "ink"
      });
    }
    out.push(...shapes);
    return out;
  }, [nodes, edges, layout, root, width, height, nodeById, shapes]);
  const handleShapeClick = useCallback(
    (payload) => {
      if (payload.type === "circle" && payload.id) {
        const node = nodeById.get(payload.id);
        const idx = nodeIndexById.get(payload.id);
        if (node && idx !== void 0) {
          onNodeClick?.({ id: node.id, label: node.label, index: idx });
        }
      }
      onShapeClick?.(payload);
    },
    [nodeById, nodeIndexById, onNodeClick, onShapeClick]
  );
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        shapes: derivedShapes,
        interactive,
        animate,
        onShapeClick: onShapeClick || onNodeClick ? handleShapeClick : void 0,
        isLoading,
        error
      }
    )
  ] }) });
};
var DEFAULT_BAR_COLOR = "series-1";
var DEFAULT_CELL_COLOR = "fill";
var DEFAULT_POINTER_COLOR = "highlight";
var POINTER_BAND = 40;
var TOP_PAD = 26;
var PANEL_FAMILY_ORDER = ["bars", "slots", "cells", "buckets", "frames"];
var RANGE_COLOR_DEFAULT = "highlight";
var RANGE_FILL_OPACITY = 0.15;
var BRACKET_TOP_OFFSET = 16;
var BRACKET_ROW_H = 14;
var BRACKET_TICK_H = 6;
var BRACKET_LABEL_OFFSET = 6;
var SLOT_EMPTY_FILL = "fill";
var SLOT_EMPTY_STROKE = "guide";
var SLOT_FILLED_STROKE = "ink";
var SLOT_HIGHLIGHT_DEFAULT = "highlight";
var SLOT_VALUE_TEXT_COLOR = "ink";
var FRAME_ACTIVE_COLOR = "primary";
var FRAME_RETURNING_COLOR = "highlight";
var FRAME_DONE_COLOR = "muted";
var FRAME_LABEL_COLOR = "ink";
var FRAME_DETAIL_COLOR = "label";
var FRAME_TWO_LINE_MIN_H = 22;
var FRAME_STRIP_H = 44;
var FRAME_GAP = 6;
var FRAME_BOTTOM_PAD = 8;
var FRAME_MIN_H = 12;
var BUCKET_INDEX_FILL = "fill";
var BUCKET_INDEX_STROKE = "ink";
var BUCKET_INDEX_TEXT = "ink";
var BUCKET_ENTRY_TEXT = "ink";
var BUCKET_ENTRY_DEFAULT = "series-1";
var BUCKET_ENTRY_HIGHLIGHT = "highlight";
var BUCKET_ENTRY_PROBING = "accent";
var BUCKET_ENTRY_MIN_W = 24;
var BUCKET_ENTRY_MAX_W = 64;
var AXIS_LABEL_COLOR = "label";
var CORNER_TEXT_COLOR = "ink";
var CORNER_MIN_CELL = 28;
var CORNER_INSET_X = 3;
var CORNER_INSET_Y = 6;
var AUX_PRIMARY_RATIO = 0.6;
var AUX_LABEL_BAND = 18;
var AUX_BASELINE_PAD = 8;
var AlgorithmCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  keyMap,
  keyUpMap,
  bars = [],
  cells = [],
  pointers = [],
  ranges = [],
  slots = [],
  slotOrientation = "horizontal",
  frames = [],
  buckets = [],
  auxBars = [],
  rowLabels = [],
  colLabels = [],
  shapes = [],
  interactive = false,
  animate = false,
  onShapeClick,
  isLoading,
  error,
  ...rest
}) => {
  const derivedShapes = useMemo(() => {
    const out = [];
    const presence = {
      bars: bars.length > 0,
      slots: slots.length > 0,
      cells: cells.length > 0,
      buckets: buckets.length > 0,
      frames: frames.length > 0
    };
    const panelCount = PANEL_FAMILY_ORDER.filter((f3) => presence[f3]).length;
    const panelHeight = height / Math.max(1, panelCount);
    const panelY = { bars: 0, slots: 0, cells: 0, buckets: 0, frames: 0 };
    let compactIndex = 0;
    PANEL_FAMILY_ORDER.forEach((f3) => {
      if (presence[f3]) {
        panelY[f3] = compactIndex * panelHeight;
        compactIndex += 1;
      }
    });
    if (bars.length > 0) {
      const panelYBars = panelY.bars;
      const slot = width / bars.length;
      const barW = slot * 0.8;
      const gap = slot * 0.1;
      const bracketRanges = ranges.filter((r) => r.kind === "bracket");
      const bracketCount = bracketRanges.length;
      const bracketHeadroom = bracketCount > 0 ? BRACKET_TOP_OFFSET + bracketCount * BRACKET_ROW_H : 0;
      const hasAux = auxBars.length > 0;
      const primaryH = hasAux ? panelHeight * AUX_PRIMARY_RATIO : panelHeight;
      const baseline = panelYBars + primaryH - POINTER_BAND;
      const usableH = baseline - (panelYBars + TOP_PAD + bracketHeadroom);
      const maxV = Math.max(1, ...bars.map((b) => Number.isFinite(b.value) ? b.value : 0));
      bars.forEach((bar, i) => {
        const v = Number.isFinite(bar.value) ? bar.value : 0;
        const bh = Math.max(0, v / maxV * usableH);
        const x = i * slot + gap;
        const color = bar.color ?? DEFAULT_BAR_COLOR;
        out.push({
          type: "rect",
          id: `bar-${i}`,
          x,
          y: baseline - bh,
          width: barW,
          height: bh,
          color,
          fill: color,
          fillStyle: "tint",
          stroke: "normal"
        });
        const label = bar.label ?? (bars.length <= 24 ? String(v) : void 0);
        if (label) {
          out.push({
            type: "text",
            x: x + barW / 2,
            y: baseline - bh - 8,
            text: label,
            tone: "label",
            textSize: "xs",
            align: "center"
          });
        }
      });
      ranges.forEach((r) => {
        const kind = r.kind ?? "fill";
        if (kind !== "fill") return;
        const color = r.color ?? RANGE_COLOR_DEFAULT;
        out.push({
          type: "rect",
          x: r.from * slot,
          y: panelYBars,
          width: (r.to - r.from + 1) * slot,
          height: primaryH,
          color,
          fill: color,
          fillStyle: "solid",
          stroke: "thin",
          opacity: RANGE_FILL_OPACITY
        });
        if (r.label) {
          out.push({
            type: "text",
            x: r.from * slot + 4,
            // Sits below the bracket block (if any) so fill and bracket labels never collide.
            y: panelYBars + 10 + bracketHeadroom,
            text: r.label,
            tone: "label",
            textSize: "xs",
            align: "left"
          });
        }
      });
      bracketRanges.forEach((r, i) => {
        const bracketY = panelYBars + BRACKET_TOP_OFFSET + i * BRACKET_ROW_H;
        const x1 = r.from * slot + slot * 0.1;
        const x2 = (r.to + 1) * slot - slot * 0.1;
        const color = r.color ?? RANGE_COLOR_DEFAULT;
        out.push({ type: "line", x1, y1: bracketY, x2, y2: bracketY, color, stroke: "normal" });
        out.push({ type: "line", x1, y1: bracketY, x2: x1, y2: bracketY + BRACKET_TICK_H, color, stroke: "normal" });
        out.push({ type: "line", x1: x2, y1: bracketY, x2, y2: bracketY + BRACKET_TICK_H, color, stroke: "normal" });
        if (r.label) {
          out.push({
            type: "text",
            x: (x1 + x2) / 2,
            y: bracketY - BRACKET_LABEL_OFFSET,
            text: r.label,
            tone: "label",
            textSize: "xs",
            align: "center"
          });
        }
      });
      if (hasAux) {
        const auxH = panelHeight - primaryH;
        const slot2 = width / auxBars.length;
        const auxBaseline = panelYBars + primaryH + auxH - AUX_BASELINE_PAD;
        const auxUsableH = auxBaseline - (panelYBars + primaryH + AUX_LABEL_BAND);
        const maxAuxV = Math.max(1, ...auxBars.map((b) => Number.isFinite(b.value) ? b.value : 0));
        auxBars.forEach((bar, i) => {
          const v = Number.isFinite(bar.value) ? bar.value : 0;
          const bh = Math.max(0, v / maxAuxV * auxUsableH);
          const x = i * slot2 + slot2 * 0.1;
          const w = slot2 * 0.8;
          const color = bar.color ?? DEFAULT_BAR_COLOR;
          out.push({
            type: "rect",
            id: `auxbar-${i}`,
            x,
            y: auxBaseline - bh,
            width: w,
            height: bh,
            color,
            fill: color,
            fillStyle: "tint",
            stroke: "normal"
          });
          const label = bar.label ?? (auxBars.length <= 24 ? String(v) : void 0);
          if (label) {
            out.push({
              type: "text",
              x: x + w / 2,
              y: auxBaseline - bh - 8,
              text: label,
              tone: "label",
              textSize: "xs",
              align: "center"
            });
          }
        });
      }
      const pointersByIndex = /* @__PURE__ */ new Map();
      pointers.forEach((p) => {
        const prev = pointersByIndex.get(p.index);
        const label = [prev?.label, p.label].filter((l) => !!l).join(" \xB7 ");
        pointersByIndex.set(p.index, { ...prev ?? p, label: label || void 0 });
      });
      pointersByIndex.forEach((p) => {
        if (p.index < 0 || p.index >= bars.length) return;
        const cx = p.index * slot + slot / 2;
        const color = p.color ?? DEFAULT_POINTER_COLOR;
        out.push({
          type: "arrow",
          x1: cx,
          y1: baseline + 15,
          x2: cx,
          y2: baseline + 3,
          color,
          stroke: "normal"
        });
        if (p.label) {
          out.push({
            type: "text",
            x: cx,
            y: panelYBars + primaryH - 10,
            text: p.label,
            color,
            textSize: "sm",
            align: "center"
          });
        }
      });
    }
    if (slots.length > 0) {
      const panelYSlots = panelY.slots;
      const n = slots.length;
      const vertical = slotOrientation === "vertical";
      const vBoxH = panelHeight / n;
      const vBoxW = Math.min(width * 0.5, 120);
      const vBoxX = (width - vBoxW) / 2;
      const hCellW = width / n;
      const hBoxW = hCellW * 0.82;
      const hBoxH = Math.min(panelHeight * 0.6, 48);
      const hBoxY = panelYSlots + (panelHeight - hBoxH) / 2;
      const slotBox = (i) => vertical ? { x: vBoxX, y: panelYSlots + panelHeight - (i + 1) * vBoxH, width: vBoxW, height: vBoxH } : { x: i * hCellW + (hCellW - hBoxW) / 2, y: hBoxY, width: hBoxW, height: hBoxH };
      slots.forEach((s, i) => {
        const box = slotBox(i);
        const state = s.state ?? "filled";
        const fill = state === "empty" ? SLOT_EMPTY_FILL : state === "highlight" ? s.color ?? SLOT_HIGHLIGHT_DEFAULT : s.color ?? DEFAULT_BAR_COLOR;
        const stroke = state === "empty" ? SLOT_EMPTY_STROKE : SLOT_FILLED_STROKE;
        out.push({
          type: "rect",
          id: `slot-${i}`,
          x: box.x,
          y: box.y,
          width: box.width,
          height: box.height,
          color: stroke,
          fill,
          fillStyle: "tint",
          stroke: "normal"
        });
        if (s.value != null && state !== "empty") {
          out.push({
            type: "text",
            x: box.x + box.width / 2,
            y: box.y + box.height / 2,
            text: String(s.value),
            tone: SLOT_VALUE_TEXT_COLOR,
            textSize: "sm",
            align: "center"
          });
        }
      });
      if (bars.length === 0) {
        pointers.forEach((p) => {
          if (p.index < 0 || p.index >= slots.length) return;
          const box = slotBox(p.index);
          const color = p.color ?? DEFAULT_POINTER_COLOR;
          if (vertical) {
            const cy = box.y + box.height / 2;
            out.push({
              type: "arrow",
              x1: box.x + box.width + 34,
              y1: cy,
              x2: box.x + box.width + 4,
              y2: cy,
              color,
              stroke: "normal"
            });
            if (p.label) {
              out.push({
                type: "text",
                x: box.x + box.width + 38,
                y: cy,
                text: p.label,
                color,
                textSize: "sm",
                align: "left"
              });
            }
          } else {
            const cx = box.x + box.width / 2;
            out.push({
              type: "arrow",
              x1: cx,
              y1: panelYSlots + panelHeight - 18,
              x2: cx,
              y2: box.y + box.height + 4,
              color,
              stroke: "normal"
            });
            if (p.label) {
              out.push({
                type: "text",
                x: cx,
                y: panelYSlots + panelHeight - 8,
                text: p.label,
                color,
                textSize: "sm",
                align: "center"
              });
            }
          }
        });
      }
    }
    if (cells.length > 0) {
      const panelYCells = panelY.cells;
      const maxCol = Math.max(0, ...cells.map((c) => c.col)) + 1;
      const maxRow = Math.max(0, ...cells.map((c) => c.row)) + 1;
      const colLabelH = colLabels.length > 0 ? 16 : 0;
      const rowLabelW = rowLabels.length > 0 ? 20 : 0;
      const gridX0 = rowLabelW;
      const gridY0 = panelYCells + colLabelH;
      const cw = (width - rowLabelW) / maxCol;
      const ch = (panelHeight - colLabelH) / maxRow;
      cells.forEach((c, i) => {
        const x = gridX0 + c.col * cw;
        const y = gridY0 + c.row * ch;
        const color = c.color ?? DEFAULT_CELL_COLOR;
        out.push({
          type: "rect",
          id: `cell-${i}`,
          x: x + 1,
          y: y + 1,
          width: cw - 2,
          height: ch - 2,
          color: "ink",
          fill: color,
          stroke: "thin"
        });
        const label = c.label ?? (c.value != null ? String(c.value) : void 0);
        if (label && cw >= 18 && ch >= 14) {
          out.push({
            type: "text",
            x: x + cw / 2,
            y: y + ch / 2,
            text: label,
            tone: "ink",
            textSize: "sm",
            align: "center"
          });
        }
        if (c.corner && cw >= CORNER_MIN_CELL && ch >= CORNER_MIN_CELL) {
          const { tl, tr, bl, br } = c.corner;
          if (tl) {
            out.push({
              type: "text",
              x: x + CORNER_INSET_X,
              y: y + CORNER_INSET_Y,
              text: tl,
              tone: CORNER_TEXT_COLOR,
              textSize: "xs",
              align: "left"
            });
          }
          if (tr) {
            out.push({
              type: "text",
              x: x + cw - CORNER_INSET_X,
              y: y + CORNER_INSET_Y,
              text: tr,
              tone: CORNER_TEXT_COLOR,
              textSize: "xs",
              align: "right"
            });
          }
          if (bl) {
            out.push({
              type: "text",
              x: x + CORNER_INSET_X,
              y: y + ch - CORNER_INSET_Y,
              text: bl,
              tone: CORNER_TEXT_COLOR,
              textSize: "xs",
              align: "left"
            });
          }
          if (br) {
            out.push({
              type: "text",
              x: x + cw - CORNER_INSET_X,
              y: y + ch - CORNER_INSET_Y,
              text: br,
              tone: CORNER_TEXT_COLOR,
              textSize: "xs",
              align: "right"
            });
          }
        }
      });
      colLabels.forEach((l) => {
        out.push({
          type: "text",
          x: gridX0 + l.index * cw + cw / 2,
          y: panelYCells + colLabelH / 2,
          text: l.text,
          color: l.color ?? AXIS_LABEL_COLOR,
          textSize: "xs",
          align: "center"
        });
      });
      rowLabels.forEach((l) => {
        out.push({
          type: "text",
          x: rowLabelW - 6,
          y: gridY0 + l.index * ch + ch / 2,
          text: l.text,
          color: l.color ?? AXIS_LABEL_COLOR,
          textSize: "xs",
          align: "right"
        });
      });
    }
    if (buckets.length > 0) {
      const panelYBuckets = panelY.buckets;
      const bucketCount = Math.max(0, ...buckets.map((b) => b.index)) + 1;
      const rowH = panelHeight / bucketCount;
      const indexColW = Math.min(width * 0.12, 40);
      const maxChainLen = Math.max(1, ...buckets.map((b) => b.entries.length));
      const entryW = Math.min(BUCKET_ENTRY_MAX_W, Math.max(BUCKET_ENTRY_MIN_W, (width - indexColW - 8) / maxChainLen));
      const maxVisible = Math.floor((width - indexColW - 4) / entryW);
      buckets.forEach((b) => {
        const rowY = panelYBuckets + b.index * rowH;
        out.push({
          type: "rect",
          id: `bucket-index-${b.index}`,
          x: 2,
          y: rowY + 2,
          width: indexColW - 4,
          height: rowH - 4,
          color: BUCKET_INDEX_STROKE,
          fill: BUCKET_INDEX_FILL,
          stroke: "thin"
        });
        out.push({
          type: "text",
          x: 2 + (indexColW - 4) / 2,
          y: rowY + rowH / 2,
          text: String(b.index),
          tone: BUCKET_INDEX_TEXT,
          textSize: "xs",
          align: "center"
        });
        const overflow = b.entries.length > maxVisible;
        const visibleCount = overflow ? Math.max(0, maxVisible - 1) : b.entries.length;
        for (let j = 0; j < visibleCount; j++) {
          const entry = b.entries[j];
          const ex = indexColW + 4 + j * entryW;
          const state = entry.state ?? "default";
          const fill = state === "highlight" ? entry.color ?? BUCKET_ENTRY_HIGHLIGHT : state === "probing" ? entry.color ?? BUCKET_ENTRY_PROBING : entry.color ?? BUCKET_ENTRY_DEFAULT;
          out.push({
            type: "rect",
            id: `bucket-${b.index}-${j}`,
            x: ex,
            y: rowY + 2,
            width: entryW - 2,
            height: rowH - 4,
            color: fill,
            fill,
            fillStyle: "tint",
            stroke: "normal"
          });
          if (entryW >= 20 && rowH >= 16) {
            out.push({
              type: "text",
              x: ex + (entryW - 2) / 2,
              y: rowY + rowH / 2,
              text: entry.label,
              tone: BUCKET_ENTRY_TEXT,
              textSize: "xs",
              align: "center"
            });
          }
        }
        if (overflow) {
          const ex = indexColW + 4 + visibleCount * entryW;
          out.push({
            type: "rect",
            id: `bucket-${b.index}-overflow`,
            x: ex,
            y: rowY + 2,
            width: entryW - 2,
            height: rowH - 4,
            color: BUCKET_ENTRY_DEFAULT,
            fill: BUCKET_ENTRY_DEFAULT,
            fillStyle: "tint",
            stroke: "normal"
          });
          out.push({
            type: "text",
            x: ex + (entryW - 2) / 2,
            y: rowY + rowH / 2,
            text: `+${b.entries.length - visibleCount}`,
            tone: BUCKET_ENTRY_TEXT,
            textSize: "xs",
            align: "center"
          });
        }
      });
    }
    if (frames.length > 0) {
      const panelYFrames = panelY.frames;
      const n = frames.length;
      const maxStride = (panelHeight - FRAME_BOTTOM_PAD - TOP_PAD) / n;
      const stride = Math.min(FRAME_STRIP_H + FRAME_GAP, maxStride);
      const frameH = Math.max(FRAME_MIN_H, stride - FRAME_GAP);
      const x = 8;
      const w = width - 16;
      const bottom = panelYFrames + panelHeight - FRAME_BOTTOM_PAD;
      frames.forEach((f3, i) => {
        const y = bottom - i * stride - frameH;
        const state = f3.state ?? "active";
        const fill = state === "returning" ? f3.color ?? FRAME_RETURNING_COLOR : state === "done" ? f3.color ?? FRAME_DONE_COLOR : f3.color ?? FRAME_ACTIVE_COLOR;
        out.push({ type: "rect", id: `frame-${i}`, x, y, width: w, height: frameH, color: fill, fill, fillStyle: "tint", stroke: "normal" });
        if (frameH >= FRAME_TWO_LINE_MIN_H) {
          out.push({
            type: "text",
            x: 16,
            y: y + frameH * 0.35,
            text: f3.label,
            tone: FRAME_LABEL_COLOR,
            textSize: "sm",
            align: "left"
          });
          if (f3.detail) {
            out.push({
              type: "text",
              x: 16,
              y: y + frameH * 0.72,
              text: f3.detail,
              tone: FRAME_DETAIL_COLOR,
              textSize: "xs",
              align: "left"
            });
          }
        } else {
          out.push({
            type: "text",
            x: 16,
            y: y + frameH / 2,
            text: f3.label,
            tone: FRAME_LABEL_COLOR,
            textSize: "xs",
            align: "left"
          });
        }
      });
    }
    out.push(...shapes);
    return out;
  }, [bars, cells, pointers, ranges, slots, slotOrientation, frames, buckets, auxBars, rowLabels, colLabels, shapes, width, height]);
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        shapes: derivedShapes,
        interactive,
        animate,
        onShapeClick,
        isLoading,
        error
      }
    )
  ] }) });
};
function parseValue(value) {
  if (typeof value === "number") {
    const decimals = Number.isInteger(value) ? 0 : String(value).split(".")[1]?.length ?? 0;
    return { num: value, prefix: "", suffix: "", decimals };
  }
  const match = String(value ?? "").match(/^([^0-9-]*)(-?[0-9]+(?:\.[0-9]+)?)(.*)$/);
  if (!match) return { num: null, prefix: "", suffix: String(value ?? ""), decimals: 0 };
  const numStr = match[2];
  const dot = numStr.indexOf(".");
  return {
    prefix: match[1],
    num: parseFloat(numStr),
    suffix: match[3],
    decimals: dot >= 0 ? numStr.length - dot - 1 : 0
  };
}
function formatNumber(value, format, decimals, fmt2) {
  switch (format) {
    case "currency":
      return formatValue(value, "currency", fmt2);
    case "percent":
      return formatValue(Math.round(value), "percent", fmt2);
    case "number":
      return formatValue(Math.round(value), "number", fmt2);
    default:
      return new Intl.NumberFormat(fmt2.locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: false
      }).format(value);
  }
}
function prefersReducedMotion() {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}
var AnimatedCounter = ({
  value,
  label,
  duration = 1500,
  prefix,
  suffix,
  format,
  className,
  ...rest
}) => {
  const fmt2 = useFormatContext();
  const ref = useRef(null);
  const parsed = parseValue(value);
  const target = parsed.num ?? 0;
  const [visible, setVisible] = useState(() => typeof IntersectionObserver === "undefined");
  const [display, setDisplay] = useState(() => typeof IntersectionObserver === "undefined" ? target : 0);
  const shownRef = useRef(display);
  const frameRef = useRef(null);
  useEffect(() => {
    if (visible) return;
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const observer2 = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setVisible(true);
          observer2.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer2.observe(el);
    return () => observer2.disconnect();
  }, [visible]);
  useEffect(() => {
    if (!visible) return;
    const from = shownRef.current;
    if (from === target || prefersReducedMotion() || typeof requestAnimationFrame === "undefined") {
      shownRef.current = target;
      setDisplay(target);
      return;
    }
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = from + (target - from) * eased;
      shownRef.current = current;
      setDisplay(current);
      if (progress < 1) frameRef.current = requestAnimationFrame(tick);
    };
    frameRef.current = requestAnimationFrame(tick);
    return () => {
      if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
    };
  }, [visible, target, duration]);
  const text = parsed.num === null ? parsed.suffix : `${prefix ?? ""}${parsed.prefix}${formatNumber(display, format, parsed.decimals, fmt2)}${parsed.suffix}${suffix ?? ""}`;
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), ref, className: cn("flex flex-col items-center gap-1", className), children: [
    /* @__PURE__ */ jsx(Typography, { variant: "h2", className: "text-primary tabular-nums", children: text }),
    label ? /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "text-center", children: label }) : null
  ] });
};
AnimatedCounter.displayName = "AnimatedCounter";
var AuthLayout = ({
  appName: appNameProp,
  logo,
  backgroundImage,
  showBranding = true,
  brandingContent,
  ...rest
}) => {
  const { t } = useTranslate();
  const appName = appNameProp ?? t("auth.defaultAppName");
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: "min-h-screen flex", children: [
    showBranding && /* @__PURE__ */ jsxs(
      VStack,
      {
        className: cn(
          "hidden lg:flex lg:w-1/2 bg-primary relative overflow-hidden",
          "justify-between p-12"
        ),
        style: backgroundImage ? {
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover"
        } : void 0,
        gap: "none",
        children: [
          /* @__PURE__ */ jsx(Box, { className: "absolute inset-0 bg-gradient-to-br from-primary/90 to-primary-hover/90" }),
          /* @__PURE__ */ jsx(Box, { className: "relative z-10", children: /* @__PURE__ */ jsxs(Link$1, { to: "/", className: "flex items-center gap-3", children: [
            logo || /* @__PURE__ */ jsx(Box, { className: "w-10 h-10 bg-primary-foreground/20 rounded-container flex items-center justify-center backdrop-blur", children: /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                className: "text-primary-foreground font-bold text-lg",
                children: appName.charAt(0).toUpperCase()
              }
            ) }),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                className: "text-2xl font-bold text-primary-foreground",
                children: appName
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx(Box, { className: "relative z-10", children: brandingContent || /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "h1",
                className: "text-4xl text-primary-foreground leading-tight",
                children: t("auth.welcomeTo", { appName })
              }
            ),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                className: "text-lg text-primary-foreground/80 max-w-md",
                children: t("auth.brandingSubtitle")
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx(Box, { className: "absolute -bottom-32 -right-32 w-96 h-96 bg-primary-foreground/5 rounded-full" }),
          /* @__PURE__ */ jsx(Box, { className: "absolute -top-16 -right-16 w-64 h-64 bg-primary-foreground/5 rounded-full" })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex-1 flex items-center justify-center p-6 sm:p-12",
          "bg-background surface-page"
        ),
        children: /* @__PURE__ */ jsxs(Box, { className: "w-full max-w-md", children: [
          /* @__PURE__ */ jsx(Box, { className: "lg:hidden mb-8 text-center", children: /* @__PURE__ */ jsxs(Link$1, { to: "/", className: "inline-flex items-center gap-3", children: [
            logo || /* @__PURE__ */ jsx(Box, { className: "w-12 h-12 bg-primary rounded-container flex items-center justify-center", children: /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                className: "text-primary-foreground font-bold text-xl",
                children: appName.charAt(0).toUpperCase()
              }
            ) }),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "body1",
                className: "text-2xl font-bold text-foreground",
                children: appName
              }
            )
          ] }) }),
          /* @__PURE__ */ jsx(Outlet, {})
        ] })
      }
    )
  ] });
};
AuthLayout.displayName = "AuthLayout";
var AvlApplication = ({
  x = 0,
  y = 0,
  width = 500,
  height = 350,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x,
        y,
        width,
        height,
        rx: 12,
        ry: 12,
        fill: "none",
        stroke: color,
        strokeWidth: 3
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        x,
        y,
        width,
        height,
        rx: 12,
        ry: 12,
        fill: color,
        opacity: 0.02
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: x + 16,
        y: y + 20,
        fill: color,
        fontSize: 12,
        fontFamily: "inherit",
        fontWeight: "bold",
        children: label
      }
    )
  ] });
};
AvlApplication.displayName = "AvlApplication";
var AvlOrbital = ({
  cx = 0,
  cy = 0,
  r = 80,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx,
        cy,
        r,
        fill: "none",
        stroke: color,
        strokeWidth: 2
      }
    ),
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx,
        cy,
        r,
        fill: color,
        opacity: 0.03
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: cx,
        y: cy - r - 8,
        textAnchor: "middle",
        fill: color,
        fontSize: 11,
        fontFamily: "inherit",
        fontWeight: "bold",
        children: label
      }
    )
  ] });
};
AvlOrbital.displayName = "AvlOrbital";
var PERSISTENCE_STROKE = {
  persistent: { strokeWidth: 2.5 },
  runtime: { strokeDasharray: "6 3", strokeWidth: 2 }
};
var AvlEntity = ({
  x = 0,
  y = 0,
  r = 18,
  fieldCount = 0,
  persistence = "persistent",
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const strokeProps = PERSISTENCE_STROKE[persistence];
  const facets = Array.from({ length: fieldCount }, (_, i) => {
    const angle = Math.PI * 2 * i / fieldCount - Math.PI / 2;
    const innerR = r + 2;
    const outerR = r + 10;
    return {
      x1: x + innerR * Math.cos(angle),
      y1: y + innerR * Math.sin(angle),
      x2: x + outerR * Math.cos(angle),
      y2: y + outerR * Math.sin(angle)
    };
  });
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r, fill: color, opacity: 0.15 }),
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: x,
        cy: y,
        r,
        fill: "none",
        stroke: color,
        strokeWidth: strokeProps.strokeWidth,
        strokeDasharray: strokeProps.strokeDasharray
      }
    ),
    facets.map((f3, i) => /* @__PURE__ */ jsx(
      "line",
      {
        x1: f3.x1,
        y1: f3.y1,
        x2: f3.x2,
        y2: f3.y2,
        stroke: color,
        strokeWidth: 1,
        opacity: 0.6
      },
      i
    )),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + r + (fieldCount > 0 ? 18 : 14),
        textAnchor: "middle",
        fill: color,
        fontSize: 10,
        fontFamily: "inherit",
        fontWeight: "bold",
        children: label
      }
    )
  ] });
};
AvlEntity.displayName = "AvlEntity";
var AvlTrait = ({
  cx = 0,
  cy = 0,
  rx = 60,
  ry = 30,
  rotation = 0,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, transform: `rotate(${rotation},${cx},${cy})`, children: [
    /* @__PURE__ */ jsx(
      "ellipse",
      {
        cx,
        cy,
        rx,
        ry,
        fill: "none",
        stroke: color,
        strokeWidth: 1.5,
        strokeDasharray: "4 2"
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: cx - rx - 6,
        y: cy,
        textAnchor: "end",
        dominantBaseline: "central",
        fill: color,
        fontSize: 9,
        fontFamily: "inherit",
        opacity: 0.8,
        transform: `rotate(${-rotation},${cx - rx - 6},${cy})`,
        children: label
      }
    )
  ] });
};
AvlTrait.displayName = "AvlTrait";
var AvlPage = ({
  x = 0,
  y = 0,
  size: size2 = 12,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const half = size2 / 2;
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: x - half,
        y: y - half,
        width: size2,
        height: size2,
        fill: color,
        opacity: 0.3,
        stroke: color,
        strokeWidth: 1.5
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + half + 12,
        textAnchor: "middle",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        children: label
      }
    )
  ] });
};
AvlPage.displayName = "AvlPage";
function computeWidth(explicit, transitionCount) {
  if (explicit != null) return explicit;
  if (transitionCount == null) return 100;
  if (transitionCount >= 5) return 160;
  if (transitionCount >= 3) return 130;
  return 100;
}
var AvlState = ({
  x = 0,
  y = 0,
  name,
  isInitial = false,
  isTerminal = false,
  width: explicitWidth,
  height = 40,
  color = "var(--color-primary)",
  opacity = 1,
  className,
  role,
  transitionCount
}) => {
  const width = computeWidth(explicitWidth, transitionCount);
  const rx = height / 2;
  const roleColors = role ? STATE_COLORS[role] : null;
  const fillColor = roleColors ? roleColors.fill : "none";
  const strokeColor = roleColors ? roleColors.border : color;
  const textColor = roleColors ? roleColors.border : color;
  return /* @__PURE__ */ jsxs("g", { className, opacity, transform: `translate(${x},${y})`, children: [
    isInitial && /* @__PURE__ */ jsx(
      "circle",
      {
        cx: -16,
        cy: height / 2,
        r: 6,
        fill: strokeColor
      }
    ),
    isTerminal && /* @__PURE__ */ jsx(
      "rect",
      {
        x: -4,
        y: -4,
        width: width + 8,
        height: height + 8,
        rx: rx + 4,
        ry: rx + 4,
        fill: "none",
        stroke: strokeColor,
        strokeWidth: 1,
        opacity: 0.5
      }
    ),
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: 0,
        y: 0,
        width,
        height,
        rx,
        ry: rx,
        fill: fillColor,
        stroke: strokeColor,
        strokeWidth: 2
      }
    ),
    name && /* @__PURE__ */ jsx(
      "text",
      {
        x: width / 2,
        y: height / 2,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: textColor,
        fontSize: role ? 14 : 11,
        fontWeight: role ? 600 : 400,
        fontFamily: "inherit",
        children: name
      }
    )
  ] });
};
AvlState.displayName = "AvlState";
var avlTransitionId = 0;
var AvlTransition = ({
  x1,
  y1,
  x2,
  y2,
  curved = false,
  curveAwayFrom,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const ids = React93__default.useMemo(() => {
    avlTransitionId += 1;
    return { arrow: `avl-tr-${avlTransitionId}-arrow` };
  }, []);
  const mx = (x1 + x2) / 2;
  const my = (y1 + y2) / 2;
  const dx = x2 - x1;
  const dy = y2 - y1;
  const len = Math.sqrt(dx * dx + dy * dy) || 1;
  const curvature = len * 0.2;
  let perpX = -dy / len;
  let perpY = dx / len;
  if (curveAwayFrom) {
    const testX = mx + perpX * curvature;
    const testY = my + perpY * curvature;
    const distTest = Math.sqrt((testX - curveAwayFrom.x) ** 2 + (testY - curveAwayFrom.y) ** 2);
    const distMid = Math.sqrt((mx - curveAwayFrom.x) ** 2 + (my - curveAwayFrom.y) ** 2);
    if (distTest < distMid) {
      perpX = -perpX;
      perpY = -perpY;
    }
  }
  const cpx = mx + perpX * curvature;
  const cpy = my + perpY * curvature;
  const d = curved ? `M${x1},${y1} Q${cpx},${cpy} ${x2},${y2}` : `M${x1},${y1} L${x2},${y2}`;
  const labelX = curved ? (x1 + 2 * cpx + x2) / 4 : mx;
  const labelY = curved ? (y1 + 2 * cpy + y2) / 4 : my;
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
      "marker",
      {
        id: ids.arrow,
        markerWidth: "8",
        markerHeight: "6",
        refX: "7",
        refY: "3",
        orient: "auto",
        markerUnits: "strokeWidth",
        children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,3 L0,6 Z", fill: color })
      }
    ) }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d,
        fill: "none",
        stroke: color,
        strokeWidth: 1.5,
        markerEnd: `url(#${ids.arrow})`
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: labelX,
        y: labelY - 6,
        textAnchor: "middle",
        fill: color,
        fontSize: 9,
        fontFamily: "inherit",
        opacity: 0.8,
        children: label
      }
    )
  ] });
};
AvlTransition.displayName = "AvlTransition";
var AvlEvent = ({
  x = 0,
  y = 0,
  size: size2 = 16,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const s = size2 / 16;
  const bolt = [
    `M${x - 2 * s},${y - 8 * s}`,
    `L${x + 4 * s},${y - 8 * s}`,
    `L${x + 1 * s},${y - 1 * s}`,
    `L${x + 5 * s},${y - 1 * s}`,
    `L${x - 3 * s},${y + 8 * s}`,
    `L${x},${y + 1 * s}`,
    `L${x - 4 * s},${y + 1 * s}`,
    "Z"
  ].join(" ");
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx("path", { d: bolt, fill: color }),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + size2 / 2 + 12,
        textAnchor: "middle",
        fill: color,
        fontSize: 9,
        fontFamily: "inherit",
        children: label
      }
    )
  ] });
};
AvlEvent.displayName = "AvlEvent";
var AvlGuard = ({
  x = 0,
  y = 0,
  size: size2 = 24,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const h = size2 / 2;
  const points = `${x},${y - h} ${x + h},${y} ${x},${y + h} ${x - h},${y}`;
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "polygon",
      {
        points,
        fill: "none",
        stroke: color,
        strokeWidth: 2,
        strokeLinejoin: "round"
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        children: label
      }
    )
  ] });
};
AvlGuard.displayName = "AvlGuard";
var AvlField = ({
  x = 0,
  y = 0,
  angle = 0,
  length = 30,
  required = true,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const x2 = x + length * Math.cos(angle);
  const y2 = y + length * Math.sin(angle);
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "line",
      {
        x1: x,
        y1: y,
        x2,
        y2,
        stroke: color,
        strokeWidth: 1.5,
        strokeDasharray: required ? void 0 : "3 2"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: x2, cy: y2, r: 2.5, fill: color, opacity: 0.6 }),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: x2 + 6 * Math.cos(angle),
        y: y2 + 6 * Math.sin(angle),
        textAnchor: Math.cos(angle) >= 0 ? "start" : "end",
        dominantBaseline: "central",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        opacity: 0.7,
        children: label
      }
    )
  ] });
};
AvlField.displayName = "AvlField";
var FIELD_TYPE_SHAPES = {
  string: "circle",
  email: "circle",
  url: "circle",
  phone: "circle",
  uuid: "circle",
  number: "triangle",
  money: "triangle",
  scalar: "triangle",
  boolean: "square",
  date: "diamond",
  timestamp: "diamond",
  datetime: "diamond",
  enum: "ring",
  union: "ring",
  object: "hexagon",
  image: "hexagon",
  file: "hexagon",
  trait: "hexagon",
  orbital: "hexagon",
  behavior: "hexagon",
  slot: "hexagon",
  pattern: "hexagon",
  node: "hexagon",
  event: "hexagon",
  EventAddress: "hexagon",
  SExpr: "hexagon",
  array: "bars",
  tuple: "bars",
  relation: "link"
};
function drawShape2(shape, x, y, s, color) {
  switch (shape) {
    case "circle":
      return /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: color });
    case "triangle":
      return /* @__PURE__ */ jsx("polygon", { points: `${x},${y - s} ${x + s},${y + s * 0.7} ${x - s},${y + s * 0.7}`, fill: color });
    case "square":
      return /* @__PURE__ */ jsx("rect", { x: x - s * 0.8, y: y - s * 0.8, width: s * 1.6, height: s * 1.6, fill: color });
    case "diamond":
      return /* @__PURE__ */ jsx("polygon", { points: `${x},${y - s} ${x + s},${y} ${x},${y + s} ${x - s},${y}`, fill: color });
    case "ring":
      return /* @__PURE__ */ jsx("circle", { cx: x, cy: y, r: s, fill: "none", stroke: color, strokeWidth: 1.5 });
    case "hexagon":
      return /* @__PURE__ */ jsx(
        "polygon",
        {
          points: Array.from({ length: 6 }, (_, i) => {
            const a = Math.PI * 2 * i / 6 - Math.PI / 6;
            return `${x + s * Math.cos(a)},${y + s * Math.sin(a)}`;
          }).join(" "),
          fill: color,
          opacity: 0.8
        }
      );
    case "bars":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y - s * 0.6, x2: x + s, y2: y - s * 0.6, stroke: color, strokeWidth: 2 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y, x2: x + s, y2: y, stroke: color, strokeWidth: 2 }),
        /* @__PURE__ */ jsx("line", { x1: x - s, y1: y + s * 0.6, x2: x + s, y2: y + s * 0.6, stroke: color, strokeWidth: 2 })
      ] });
    case "link":
      return /* @__PURE__ */ jsxs("g", { children: [
        /* @__PURE__ */ jsx("circle", { cx: x - s * 0.45, cy: y, r: s * 0.55, fill: "none", stroke: color, strokeWidth: 1.5 }),
        /* @__PURE__ */ jsx("circle", { cx: x + s * 0.45, cy: y, r: s * 0.55, fill: "none", stroke: color, strokeWidth: 1.5 })
      ] });
  }
}
var AvlFieldType = ({
  x = 0,
  y = 0,
  kind,
  size: size2 = 5,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    drawShape2(FIELD_TYPE_SHAPES[kind], x, y, size2, color),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + size2 + 10,
        textAnchor: "middle",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        opacity: 0.7,
        children: label
      }
    )
  ] });
};
AvlFieldType.displayName = "AvlFieldType";
var AvlBinding = ({
  x1,
  y1,
  x2,
  y2,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const mx = (x1 + x2) / 2;
  const my = (y1 + y2) / 2;
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "line",
      {
        x1,
        y1,
        x2,
        y2,
        stroke: color,
        strokeWidth: 1,
        strokeDasharray: "2 3",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ jsx(
      "text",
      {
        x: mx,
        y: my - 4,
        textAnchor: "middle",
        fill: color,
        fontSize: 10,
        fontFamily: "inherit",
        fontWeight: "bold",
        children: "@"
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: mx,
        y: my + 10,
        textAnchor: "middle",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        opacity: 0.6,
        children: label
      }
    )
  ] });
};
AvlBinding.displayName = "AvlBinding";
var AvlBindingRef = ({
  x = 0,
  y = 0,
  path,
  size: size2 = 12,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const fullLabel = `@${path}`;
  const autoR = Math.max(size2, fullLabel.length * 3.5 + 4);
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: x,
        cy: y,
        r: autoR,
        fill: "none",
        stroke: color,
        strokeWidth: 1.5,
        strokeDasharray: "3 2"
      }
    ),
    /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + 1,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: color,
        fontSize: 10,
        fontFamily: "inherit",
        children: fullLabel
      }
    )
  ] });
};
AvlBindingRef.displayName = "AvlBindingRef";
var PERSISTENCE_STROKE2 = {
  persistent: { strokeWidth: 2.5 },
  runtime: { strokeDasharray: "6 3", strokeWidth: 2 }
};
var AvlPersistence = ({
  x = 0,
  y = 0,
  kind,
  size: size2 = 20,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  const half = size2 / 2;
  const strokeProps = PERSISTENCE_STROKE2[kind];
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "line",
      {
        x1: x - half,
        y1: y,
        x2: x + half,
        y2: y,
        stroke: color,
        strokeWidth: strokeProps.strokeWidth,
        strokeDasharray: strokeProps.strokeDasharray,
        strokeLinecap: "round"
      }
    ),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + 14,
        textAnchor: "middle",
        fill: color,
        fontSize: 8,
        fontFamily: "inherit",
        opacity: 0.7,
        children: label
      }
    )
  ] });
};
AvlPersistence.displayName = "AvlPersistence";
var AvlOperator = ({
  x = 0,
  y = 0,
  name,
  namespace = "arithmetic",
  size: size2 = 16,
  color,
  opacity = 1,
  className
}) => {
  const opColor2 = color ?? OPERATOR_CATEGORY_COLORS[namespace];
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x: x - size2,
        y: y - size2 * 0.7,
        width: size2 * 2,
        height: size2 * 1.4,
        rx: 4,
        ry: 4,
        fill: opColor2,
        fillOpacity: 0.15,
        stroke: opColor2,
        strokeWidth: 1.5
      }
    ),
    /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + 1,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: opColor2,
        fontSize: size2 > 14 ? 10 : 8,
        fontFamily: "inherit",
        fontWeight: "bold",
        children: name
      }
    )
  ] });
};
AvlOperator.displayName = "AvlOperator";
var AvlSExpr = ({
  x = 0,
  y = 0,
  width = 140,
  height = 80,
  label,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "rect",
      {
        x,
        y,
        width,
        height,
        rx: 6,
        ry: 6,
        fill: color,
        fillOpacity: 0.05,
        stroke: color,
        strokeWidth: 1,
        strokeDasharray: "6 3"
      }
    ),
    /* @__PURE__ */ jsx("circle", { cx: x + 12, cy: y + 12, r: 3, fill: color, opacity: 0.4 }),
    /* @__PURE__ */ jsx("line", { x1: x + 12, y1: y + 15, x2: x + 8, y2: y + 22, stroke: color, strokeWidth: 0.8, opacity: 0.3 }),
    /* @__PURE__ */ jsx("line", { x1: x + 12, y1: y + 15, x2: x + 16, y2: y + 22, stroke: color, strokeWidth: 0.8, opacity: 0.3 }),
    label && /* @__PURE__ */ jsx(
      "text",
      {
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: color,
        fontSize: 9,
        fontFamily: "inherit",
        opacity: 0.6,
        children: label
      }
    )
  ] });
};
AvlSExpr.displayName = "AvlSExpr";
var AvlLiteral = ({
  x = 0,
  y = 0,
  value,
  size: size2 = 12,
  color = "var(--color-primary)",
  opacity = 1,
  className
}) => {
  return /* @__PURE__ */ jsxs("g", { className, opacity, children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: x,
        cy: y,
        r: size2,
        fill: "none",
        stroke: color,
        strokeWidth: 1,
        opacity: 0.5
      }
    ),
    /* @__PURE__ */ jsx(
      "text",
      {
        x,
        y: y + 1,
        textAnchor: "middle",
        dominantBaseline: "central",
        fill: color,
        fontSize: size2 > 10 ? 9 : 7,
        fontFamily: "inherit",
        children: value
      }
    )
  ] });
};
AvlLiteral.displayName = "AvlLiteral";
var AVL_GLYPH_KINDS = [
  "application",
  "orbital",
  "entity",
  "trait",
  "page",
  "state",
  "transition",
  "event",
  "guard",
  "effect",
  "field",
  "fieldType",
  "binding",
  "bindingRef",
  "persistence",
  "operator",
  "sexpr",
  "literal"
];
var HEIGHT = { sm: 32, md: 56, lg: 88 };
var PAD = 6;
function Symbol2({ kind, label, effectType, fieldType, persistence, namespace }) {
  switch (kind) {
    case "application":
      return /* @__PURE__ */ jsx(AvlApplication, { width: 120, height: 80 });
    case "orbital":
      return /* @__PURE__ */ jsx(AvlOrbital, { r: 36 });
    case "entity":
      return /* @__PURE__ */ jsx(AvlEntity, { r: 18, fieldCount: 4, persistence: persistence ?? "persistent" });
    case "trait":
      return /* @__PURE__ */ jsx(AvlTrait, { rx: 44, ry: 22 });
    case "page":
      return /* @__PURE__ */ jsx(AvlPage, { size: 20 });
    case "state":
      return /* @__PURE__ */ jsx(AvlState, { width: 96, height: 34 });
    case "transition":
      return /* @__PURE__ */ jsx(AvlTransition, { x1: -40, y1: 0, x2: 40, y2: 0 });
    case "event":
      return /* @__PURE__ */ jsx(AvlEvent, { size: 20 });
    case "guard":
      return /* @__PURE__ */ jsx(AvlGuard, { size: 28 });
    case "effect":
      return /* @__PURE__ */ jsx(AvlEffect, { effectType: effectType ?? "set", size: 14 });
    case "field":
      return /* @__PURE__ */ jsx(AvlField, { length: 40 });
    case "fieldType":
      return /* @__PURE__ */ jsx(AvlFieldType, { kind: fieldType ?? "string", size: 9 });
    case "binding":
      return /* @__PURE__ */ jsx(AvlBinding, { x1: -40, y1: 0, x2: 40, y2: 0 });
    case "bindingRef":
      return /* @__PURE__ */ jsx(AvlBindingRef, { path: label ?? "entity.id", size: 14 });
    case "persistence":
      return /* @__PURE__ */ jsx(AvlPersistence, { kind: persistence ?? "persistent", size: 24 });
    case "operator":
      return /* @__PURE__ */ jsx(AvlOperator, { name: label ?? "+", namespace: namespace ?? "arithmetic", size: 20 });
    case "sexpr":
      return /* @__PURE__ */ jsx(AvlSExpr, { width: 110, height: 60 });
    case "literal":
      return /* @__PURE__ */ jsx(AvlLiteral, { value: label ?? "42", size: 14 });
  }
}
var AvlGlyph = ({ kind, label, size: size2 = "md", showCaption = true, className, effectType, fieldType, persistence, namespace, ...rest }) => {
  const variant = { effectType, fieldType, persistence, namespace };
  const { t } = useTranslate();
  const groupRef = useRef(null);
  const [box, setBox] = useState({ x: -50, y: -50, w: 100, h: 100 });
  useLayoutEffect(() => {
    const g = groupRef.current;
    if (!g || typeof g.getBBox !== "function") return;
    const b = g.getBBox();
    if (b.width > 0 && b.height > 0) setBox({ x: b.x - PAD, y: b.y - PAD, w: b.width + 2 * PAD, h: b.height + 2 * PAD });
  }, [kind, label, variant.effectType, variant.fieldType, variant.persistence, variant.namespace]);
  const height = HEIGHT[size2];
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), "data-testid": "avl-glyph", "data-kind": kind, className: `inline-flex flex-col items-center gap-1 ${className ?? ""}`, children: [
    /* @__PURE__ */ jsx("svg", { height, width: height * box.w / box.h, viewBox: `${box.x} ${box.y} ${box.w} ${box.h}`, role: "img", "aria-label": label ?? t(`avl.glyph.${kind}`), children: /* @__PURE__ */ jsx("g", { ref: groupRef, children: /* @__PURE__ */ jsx(Symbol2, { kind, label, ...variant }) }) }),
    showCaption ? /* @__PURE__ */ jsx(Box, { "data-testid": "avl-glyph-caption", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: label ?? t(`avl.glyph.${kind}`) }) }) : null
  ] });
};
AvlGlyph.displayName = "AvlGlyph";
var isObj = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
var isArr = (v) => Array.isArray(v);
function kindOf(v) {
  if (v === null) return "null";
  if (isArr(v)) return "array";
  if (isObj(v)) return "object";
  if (typeof v === "number") return "number";
  if (typeof v === "boolean") return "boolean";
  return "string";
}
var TYPE_LABEL_KEY = {
  string: "jsonTree.type.text",
  number: "jsonTree.type.number",
  boolean: "jsonTree.type.boolean"
};
var TYPE_LABEL_SYMBOL = {
  object: "{}",
  array: "[]",
  null: "\u2014"
};
function typeLabel(kind, t) {
  if (kind === "object" || kind === "array" || kind === "null") return TYPE_LABEL_SYMBOL[kind];
  return t(TYPE_LABEL_KEY[kind] ?? "");
}
var KIND_OPTIONS = ["string", "number", "boolean", "object", "array"];
function emptyOf(kind) {
  switch (kind) {
    case "object":
      return {};
    case "array":
      return [];
    case "number":
      return 0;
    case "boolean":
      return false;
    case "null":
      return null;
    default:
      return "";
  }
}
function templateFrom(arr) {
  if (arr.length === 0) return "";
  const first = arr[0];
  if (isObj(first)) {
    const blank = {};
    for (const k of Object.keys(first)) blank[k] = isObj(first[k]) ? {} : isArr(first[k]) ? [] : first[k];
    return blank;
  }
  if (isArr(first)) return [];
  return emptyOf(kindOf(first));
}
function ScalarControl({
  value,
  onChange
}) {
  if (typeof value === "boolean") {
    return /* @__PURE__ */ jsx(Switch, { checked: value, onChange: (c) => onChange(c) });
  }
  const numeric = typeof value === "number";
  const initial = value === null ? "" : String(value);
  const [draft, setDraft] = React93__default.useState(initial);
  React93__default.useEffect(() => setDraft(initial), [initial]);
  const commit = () => {
    if (numeric) {
      const n = draft.trim() === "" ? 0 : Number(draft);
      onChange(Number.isNaN(n) ? 0 : n);
    } else {
      onChange(draft);
    }
  };
  return /* @__PURE__ */ jsx(
    Input,
    {
      inputType: numeric ? "number" : "text",
      value: draft,
      placeholder: value === null ? "null" : void 0,
      onChange: (e) => setDraft(e.target.value),
      onBlur: commit,
      onKeyDown: (e) => {
        if (e.key === "Enter") commit();
      }
    }
  );
}
function KindSelect({
  kind,
  onChange
}) {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    "select",
    {
      value: kind === "null" ? "string" : kind,
      onChange: (e) => onChange(e.target.value),
      "aria-label": t("jsonTree.valueType"),
      className: cn(
        "h-6 rounded-interactive bg-muted text-muted-foreground text-[10px] font-mono px-1",
        "border-[length:var(--border-width-thin)] border-border",
        "hover:bg-card focus:outline-none focus:ring-1 focus:ring-ring"
      ),
      children: KIND_OPTIONS.map((k) => /* @__PURE__ */ jsx("option", { value: k, children: typeLabel(k, t) }, k))
    }
  );
}
function ValueNode({
  value,
  onChange,
  depth,
  readonly
}) {
  const kind = kindOf(value);
  if (kind === "object" || kind === "array") {
    return /* @__PURE__ */ jsx(ContainerNode, { value, onChange, depth, readonly });
  }
  if (readonly) {
    return /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-mono text-foreground", children: value === null ? "null" : String(value) });
  }
  return /* @__PURE__ */ jsx(ScalarControl, { value, onChange });
}
function Row({
  rowKey,
  isArrayItem,
  value,
  depth,
  onValue,
  onRenameKey,
  onChangeKind,
  onRemove,
  readonly
}) {
  const { t } = useTranslate();
  const [keyDraft, setKeyDraft] = React93__default.useState(rowKey);
  React93__default.useEffect(() => setKeyDraft(rowKey), [rowKey]);
  const container = isObj(value) || isArr(value);
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "group w-max min-w-full", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", className: "py-0.5 w-max", children: [
      readonly ? /* @__PURE__ */ jsx("span", { className: cn(
        "h-6 rounded-interactive bg-muted text-muted-foreground text-[10px] font-mono px-1 flex items-center",
        "border-[length:var(--border-width-thin)] border-border"
      ), children: typeLabel(kindOf(value), t) }) : /* @__PURE__ */ jsx(KindSelect, { kind: kindOf(value), onChange: onChangeKind }),
      isArrayItem ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "w-6 shrink-0 font-mono", children: rowKey }) : readonly ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "w-20 shrink-0 font-mono truncate", children: rowKey }) : /* @__PURE__ */ jsx("div", { className: "w-20 shrink-0", children: /* @__PURE__ */ jsx(
        Input,
        {
          inputType: "text",
          value: keyDraft,
          onChange: (e) => setKeyDraft(e.target.value),
          onBlur: () => keyDraft !== rowKey && onRenameKey(keyDraft),
          onKeyDown: (e) => {
            if (e.key === "Enter" && keyDraft !== rowKey) onRenameKey(keyDraft);
          },
          className: "font-mono"
        }
      ) }),
      !container && /* @__PURE__ */ jsx("div", { className: "w-48 shrink-0", children: /* @__PURE__ */ jsx(ValueNode, { value, onChange: onValue, depth: depth + 1, readonly }) }),
      !readonly && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          icon: "x",
          onClick: onRemove,
          "aria-label": t("common.remove"),
          className: "shrink-0 text-muted-foreground hover:text-error"
        }
      )
    ] }),
    container && /* @__PURE__ */ jsx("div", { className: "pl-2", children: /* @__PURE__ */ jsx(ValueNode, { value, onChange: onValue, depth: depth + 1, readonly }) })
  ] });
}
function ContainerNode({
  value,
  onChange,
  depth,
  readonly
}) {
  const { t } = useTranslate();
  const [open, setOpen] = React93__default.useState(depth < 2);
  const array = isArr(value);
  const entries = array ? value.map((v, i) => [String(i), v]) : Object.entries(value);
  const setObjValue = (key, next) => {
    onChange({ ...value, [key]: next });
  };
  const renameKey = (oldKey, newKey) => {
    if (!newKey || newKey === oldKey) return;
    const out = {};
    for (const [k, v] of Object.entries(value)) out[k === oldKey ? newKey : k] = v;
    onChange(out);
  };
  const removeObjKey = (key) => {
    const out = {};
    for (const [k, v] of Object.entries(value)) if (k !== key) out[k] = v;
    onChange(out);
  };
  const changeObjKind = (key, k) => setObjValue(key, emptyOf(k));
  const setArrValue = (idx, next) => {
    const copy = [...value];
    copy[idx] = next;
    onChange(copy);
  };
  const removeArrIdx = (idx) => onChange(value.filter((_, i) => i !== idx));
  const changeArrKind = (idx, k) => setArrValue(idx, emptyOf(k));
  const add = () => {
    if (array) {
      onChange([...value, templateFrom(value)]);
    } else {
      const obj = value;
      let key = "key";
      let n = 1;
      while (key in obj) {
        key = `key${n}`;
        n += 1;
      }
      onChange({ ...obj, [key]: "" });
    }
  };
  const summaryKey = array ? entries.length === 1 ? "jsonTree.itemCountOne" : "jsonTree.itemCountOther" : entries.length === 1 ? "jsonTree.fieldCountOne" : "jsonTree.fieldCountOther";
  const summary = t(summaryKey, { count: entries.length });
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-full", children: [
    /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", children: /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        onClick: () => setOpen((o) => !o),
        className: "flex items-center gap-1 text-muted-foreground hover:text-foreground",
        "aria-label": open ? t("jsonTree.collapse") : t("jsonTree.expand"),
        children: [
          /* @__PURE__ */ jsx(Icon, { name: open ? "chevron-down" : "chevron-right", size: "sm" }),
          /* @__PURE__ */ jsx("span", { className: "font-mono text-xs", children: array ? "[ ]" : "{ }" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: summary })
        ]
      }
    ) }),
    open && /* @__PURE__ */ jsxs(
      VStack,
      {
        gap: "none",
        className: cn("ml-1.5 pl-1.5 w-max min-w-full border-l-[length:var(--border-width-thin)] border-border"),
        children: [
          entries.map(([k, v], idx) => /* @__PURE__ */ jsx(
            Row,
            {
              rowKey: k,
              isArrayItem: array,
              value: v,
              depth,
              onValue: (next) => array ? setArrValue(idx, next) : setObjValue(k, next),
              onRenameKey: (nk) => renameKey(k, nk),
              onChangeKind: (kind) => array ? changeArrKind(idx, kind) : changeObjKind(k, kind),
              onRemove: () => array ? removeArrIdx(idx) : removeObjKey(k),
              readonly
            },
            array ? idx : k
          )),
          !readonly && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "plus",
              label: array ? t("jsonTree.addItem") : t("jsonTree.addField"),
              onClick: add,
              className: "self-start text-muted-foreground"
            }
          )
        ]
      }
    )
  ] });
}
var JsonTreeEditor = ({ value, onChange, className, readonly }) => {
  const root = value ?? "";
  return /* @__PURE__ */ jsx("div", { className: cn("w-full overflow-x-auto rounded-container bg-card/40 p-2 border-[length:var(--border-width-thin)] border-border", className), children: /* @__PURE__ */ jsx(ValueNode, { value: root, onChange, depth: 0, readonly }) });
};
var MONO = 7.4;
var ROW = 40;
var GAP_X = 112;
var GAP_Y = 16;
var PAD2 = 12;
var keyOf = (path) => path.join(".");
function leafLabel(expr) {
  if (typeof expr === "string") return isBinding(expr) ? expr : JSON.stringify(expr);
  if (expr === null) return "null";
  if (typeof expr === "number" || typeof expr === "boolean") return String(expr);
  return Array.isArray(expr) ? "[\u2026]" : "{\u2026}";
}
function build(expr, path) {
  const base = { key: keyOf(path), path, expr, x: 0, y: 0, w: 0, h: 0, bandTop: 0, bandBottom: 0, wireLabels: [] };
  if (Array.isArray(expr) && expr.length > 0 && typeof expr[0] === "string") {
    const op = expr[0];
    const args = expr.slice(1);
    const form = operatorVisualForm(op) ?? "unknown";
    if (form === "scope" && Array.isArray(args[0])) {
      const pairs = args[0];
      const bindings = pairs.map((pair, i) => {
        const value = Array.isArray(pair) ? pair[1] : pair;
        return build(value, [...path, 1, i, 1]);
      });
      const names = pairs.map((pair) => Array.isArray(pair) && typeof pair[0] === "string" ? pair[0] : "");
      const body = args.slice(1).map((a, i) => build(a, [...path, i + 2]));
      return { ...base, kind: "call", label: op, form, children: [...bindings, ...body], wireLabels: [...names, ...body.map(() => "")] };
    }
    if (form === "template") {
      const params = args[0];
      const body = args.slice(1).map((a, i) => build(a, [...path, i + 2]));
      const paramText = Array.isArray(params) ? params.join(" ") : typeof params === "string" ? params : "";
      return { ...base, kind: "call", label: `fn [${paramText}]`, form, children: body, wireLabels: body.map(() => "") };
    }
    const children = args.map((a, i) => build(a, [...path, i + 1]));
    return { ...base, kind: "call", label: op, form, children, wireLabels: children.map(() => "") };
  }
  if (Array.isArray(expr)) {
    const children = expr.map((a, i) => build(a, [...path, i]));
    return { ...base, kind: "array", label: "[ ]", form: null, children, wireLabels: children.map((_, i) => String(i)) };
  }
  if (expr !== null && typeof expr === "object") {
    const entries = Object.entries(expr);
    const children = entries.map(([k, v]) => build(v, [...path, k]));
    return { ...base, kind: "object", label: "{ }", form: null, children, wireLabels: entries.map(([k]) => k) };
  }
  return { ...base, kind: isBinding(expr) ? "binding" : "literal", label: leafLabel(expr), form: null, children: [] };
}
function size(n) {
  n.children.forEach(size);
  const ports = Math.max(1, n.children.length);
  if (n.kind === "binding" || n.kind === "literal") {
    n.w = Math.max(40, Math.round(n.label.length * MONO + 26));
    n.h = 28;
    return;
  }
  const labelW = Math.round(n.label.length * MONO + 28);
  switch (n.form) {
    case "series":
    case "parallel":
      n.w = Math.max(labelW, 120);
      n.h = Math.max(ROW + 16, ports * 40 + 26);
      return;
    case "conveyor":
      n.w = Math.max(labelW, 200);
      n.h = Math.max(64, ports * 30 + 14);
      return;
    case "ladder":
      n.w = Math.max(labelW, 80);
      n.h = Math.max(ROW, ports * 30 + 14);
      return;
    case "actuator":
      n.w = Math.max(labelW + 22, 96);
      n.h = Math.max(ROW, ports * 26 + 12);
      return;
    default:
      n.w = Math.max(labelW, 56);
      n.h = Math.max(ROW, ports * 26 + 12);
  }
}
function place(n, right, top) {
  n.x = right - n.w;
  if (n.children.length === 0) {
    n.bandTop = top;
    n.bandBottom = top + n.h;
    n.y = top;
    return n.h;
  }
  let cursor = top;
  const childRight = n.x - GAP_X;
  for (const child of n.children) {
    const band2 = place(child, childRight, cursor);
    cursor += band2 + GAP_Y;
  }
  const childrenBottom = cursor - GAP_Y;
  const span = childrenBottom - top;
  const band = Math.max(span, n.h);
  n.bandTop = top;
  n.bandBottom = top + band;
  n.y = top + (band - n.h) / 2;
  return band;
}
function subtreeWidth(n) {
  return n.w + (n.children.length ? GAP_X + Math.max(...n.children.map(subtreeWidth)) : 0);
}
function shift(n, dx, dy) {
  n.x += dx;
  n.y += dy;
  n.bandTop += dy;
  n.bandBottom += dy;
  n.children.forEach((c) => shift(c, dx, dy));
}
function buildCircuit(expr) {
  const root = build(expr, []);
  size(root);
  const width = subtreeWidth(root);
  const height = place(root, width, 0);
  shift(root, PAD2, PAD2);
  return { root, w: width + 2 * PAD2, h: height + 2 * PAD2 };
}
function portY(n, i) {
  const count = Math.max(1, n.children.length);
  return n.y + n.h * (i + 1) / (count + 1);
}
function circuitState(trace, cursor) {
  const out = /* @__PURE__ */ new Map();
  const get = (k) => {
    let s = out.get(k);
    if (!s) {
      s = { status: "idle", results: [] };
      out.set(k, s);
    }
    return s;
  };
  for (let i = 0; i <= cursor && i < trace.length; i++) {
    const step = trace[i];
    const s = get(keyOf(step.path));
    if (step.kind === "enter") s.status = "active";
    else if (step.kind === "skip") s.status = "skipped";
    else if (step.kind === "exit") {
      if (step.error !== void 0) {
        s.status = "error";
        s.error = step.error;
      } else {
        s.status = "done";
        s.value = step.value;
        s.results.push(step.value ?? null);
      }
    }
  }
  return out;
}
function activeStack(trace, cursor) {
  const stack = [];
  for (let i = 0; i <= cursor && i < trace.length; i++) {
    const step = trace[i];
    const k = keyOf(step.path);
    if (step.kind === "enter") stack.push(k);
    else if (step.kind === "exit") {
      const at = stack.lastIndexOf(k);
      if (at >= 0) stack.splice(at, 1);
    }
  }
  return stack;
}
var MIN_SCALE2 = 0.85;
var MAX_SCALE2 = 1.2;
var IDLE = { status: "idle", results: [] };
function truthy(v) {
  return v !== void 0 && v !== null && v !== false && v !== 0 && v !== "";
}
function fmt(v) {
  if (v === void 0) return "";
  if (v === null || typeof v !== "object") return typeof v === "string" ? JSON.stringify(v) : String(v);
  if (Array.isArray(v)) {
    return v.length <= 4 && v.every((x) => x === null || typeof x !== "object") ? `[${v.map(fmt).join(" ")}]` : `[${v.length}]`;
  }
  const keys = Object.keys(v);
  return keys.length <= 3 ? `{${keys.join(", ")}}` : `{${keys.length}}`;
}
function opColor(op) {
  const meta = getStdOperatorMeta(op);
  return meta ? OPERATOR_CATEGORY_COLORS[meta.category] : AVL_INK.quiet;
}
var AvlCircuit = ({ expr, trace, cursor, title, showCode = true, className }) => {
  const { t } = useTranslate();
  const reduceMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const hostRef = useRef(null);
  const hostWidth = useContainerWidth(hostRef);
  const circuit = useMemo(() => buildCircuit(expr), [expr]);
  const at = trace ? Math.min(cursor ?? trace.length - 1, trace.length - 1) : -1;
  const states = useMemo(() => trace ? circuitState(trace, at) : /* @__PURE__ */ new Map(), [trace, at]);
  const stack = useMemo(() => trace ? activeStack(trace, at) : [], [trace, at]);
  const nodes = useMemo(() => {
    const out = /* @__PURE__ */ new Map();
    const walk2 = (n) => {
      out.set(n.key, n);
      n.children.forEach(walk2);
    };
    walk2(circuit.root);
    return out;
  }, [circuit]);
  const parents = useMemo(() => {
    const out = /* @__PURE__ */ new Map();
    const walk2 = (n) => {
      n.children.forEach((c) => {
        out.set(c.key, n);
        walk2(c);
      });
    };
    walk2(circuit.root);
    return out;
  }, [circuit]);
  const stateOf = (n) => {
    const s = states.get(n.key) ?? IDLE;
    if (s.status !== "skipped") return s;
    const form = parents.get(n.key)?.form;
    return form === "series" || form === "parallel" || form === "branch" ? s : IDLE;
  };
  const scale = Math.min(MAX_SCALE2, Math.max(MIN_SCALE2, hostWidth ? hostWidth / (circuit.w + 120) : 1));
  const W = circuit.w + 120;
  const narration = (() => {
    if (!trace || at < 0) return null;
    const step = trace[at];
    const node = nodes.get(step.path.join("."));
    const code = node ? formatSExpr(node.expr) : "";
    if (step.kind === "enter") return t("avl.circuit.evaluating", { code });
    if (step.kind === "skip") return t("avl.circuit.skipped", { code });
    if (step.kind === "iter") return t("avl.circuit.nextItem", { code });
    if (step.error !== void 0) return t("avl.circuit.failed", { code, error: step.error });
    return t("avl.circuit.returned", { code, value: fmt(step.value) });
  })();
  const wire = (parent, child, i) => {
    const s = stateOf(child);
    const x1 = child.x + child.w;
    const y1 = child.y + child.h / 2;
    const x2 = parent.x;
    const y2 = portY(parent, i);
    const xm = x2 - 24;
    const d = roundedEdgePath([{ x: x1, y: y1 }, { x: xm, y: y1 }, { x: xm, y: y2 }, { x: x2, y: y2 }], 8);
    const live = s.status === "done";
    const running = s.status === "active";
    const label = parent.wireLabels[i];
    return /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d,
          fill: "none",
          stroke: s.status === "error" ? AVL_INK.fail : live || running ? AVL_INK.focus : AVL_INK.quiet,
          strokeOpacity: s.status === "skipped" ? 0.25 : live || running ? 1 : 0.5,
          strokeWidth: live ? 2 : 1.5,
          strokeDasharray: s.status === "skipped" ? "3 4" : running ? "8 6" : void 0,
          children: running && !reduceMotion ? /* @__PURE__ */ jsx("animate", { attributeName: "stroke-dashoffset", from: "0", to: "-14", dur: "0.8s", repeatCount: "indefinite" }) : null
        }
      ),
      label ? /* @__PURE__ */ jsx("text", { x: xm + 4, y: y2 - 6, fontFamily: AVL_FONT.mono, fontSize: 12, fill: AVL_INK.quiet, children: label }) : null,
      live && s.value !== void 0 ? valueChip((x1 + xm) / 2, y1, s.value, true) : null
    ] }, `w-${child.key}`);
  };
  const valueChip = (x, y, v, centered = false) => {
    const text = fmt(v);
    const w = Math.max(28, text.length * 7.4 + 14);
    if (centered) x -= w / 2;
    const isBool = typeof v === "boolean";
    const tone = isBool ? v ? AVL_INK.pass : AVL_INK.fail : AVL_INK.focus;
    return /* @__PURE__ */ jsxs("g", { children: [
      /* @__PURE__ */ jsx("title", { children: JSON.stringify(v) }),
      /* @__PURE__ */ jsx("rect", { x, y: y - 22, width: w, height: 18, rx: 9, fill: avlTint(tone, 16), stroke: tone, strokeWidth: 1 }),
      /* @__PURE__ */ jsx(
        "text",
        {
          "data-testid": "avl-circuit-value",
          x: x + w / 2,
          y: y - 13,
          textAnchor: "middle",
          dominantBaseline: "central",
          fontFamily: AVL_FONT.mono,
          fontSize: 12,
          fontWeight: 600,
          fill: AVL_INK.text,
          children: text
        }
      )
    ] });
  };
  const switchGlyph = (n, i, cx, cy, vertical) => {
    const child = n.children[i];
    const s = stateOf(child);
    const decided = s.status === "done";
    const closed = decided && truthy(s.value);
    const color = s.status === "skipped" ? AVL_INK.quiet : decided ? closed ? AVL_INK.focus : AVL_INK.fail : AVL_INK.quiet;
    const a = vertical ? { x: cx, y: cy - 13 } : { x: cx - 14, y: cy };
    const b = vertical ? { x: cx, y: cy + 13 } : { x: cx + 14, y: cy };
    const lever = closed || !decided ? b : vertical ? { x: cx + 16, y: cy + 6 } : { x: cx + 8, y: cy - 14 };
    return /* @__PURE__ */ jsxs(
      "g",
      {
        opacity: s.status === "skipped" ? 0.35 : 1,
        ...decided && !closed ? { "data-testid": "avl-circuit-open-switch", "data-key": child.key } : {},
        children: [
          /* @__PURE__ */ jsx("line", { x1: n.x, y1: portY(n, i), x2: vertical ? cx - 4 : cx, y2: cy, stroke: AVL_INK.quiet, strokeWidth: 1, strokeDasharray: "2 3" }),
          /* @__PURE__ */ jsx("circle", { cx: a.x, cy: a.y, r: 2.5, fill: AVL_INK.text }),
          /* @__PURE__ */ jsx("circle", { cx: b.x, cy: b.y, r: 2.5, fill: decided && !closed ? AVL_INK.quiet : AVL_INK.text }),
          /* @__PURE__ */ jsx("line", { x1: a.x, y1: a.y, x2: lever.x, y2: lever.y, stroke: color, strokeWidth: 2.5, strokeLinecap: "round" })
        ]
      },
      `sw-${child.key}`
    );
  };
  const body = (n) => {
    const s = stateOf(n);
    const cx = n.x + n.w / 2;
    const cy = n.y + n.h / 2;
    const tint = n.kind === "call" && n.form !== "template" ? opColor(n.label) : AVL_INK.quiet;
    const frame = (dashed = false) => /* @__PURE__ */ jsx(
      "rect",
      {
        x: n.x,
        y: n.y,
        width: n.w,
        height: n.h,
        rx: n.kind === "binding" || n.kind === "literal" ? n.h / 2 : 10,
        fill: n.kind === "call" ? avlBlend(tint, 12, AVL_INK.surface) : n.kind === "literal" ? AVL_INK.wash : AVL_INK.surface,
        stroke: s.status === "error" ? AVL_INK.fail : s.status === "active" ? AVL_INK.focus : n.kind === "call" ? avlBlend(tint, 55, AVL_INK.line) : AVL_INK.line,
        strokeWidth: s.status === "active" ? 2 : 1,
        strokeDasharray: dashed || n.form === "unknown" ? "5 4" : void 0
      }
    );
    const caption = (text, big = false) => /* @__PURE__ */ jsx(
      "text",
      {
        x: n.form === "series" || n.form === "parallel" || n.form === "conveyor" || n.form === "ladder" ? n.x + 10 : cx,
        y: n.form === "series" || n.form === "parallel" || n.form === "conveyor" || n.form === "ladder" ? n.y + 14 : cy,
        textAnchor: n.form === "series" || n.form === "parallel" || n.form === "conveyor" || n.form === "ladder" ? "start" : "middle",
        dominantBaseline: "central",
        fontFamily: AVL_FONT.mono,
        fontSize: big ? 18 : 12,
        fontWeight: big ? 600 : 500,
        fill: n.kind === "literal" ? AVL_INK.quiet : AVL_INK.text,
        children: text
      }
    );
    if (n.kind !== "call") return /* @__PURE__ */ jsxs(Fragment, { children: [
      frame(),
      caption(n.label)
    ] });
    switch (n.form) {
      case "series": {
        const rx = n.x + n.w - 34;
        const ys = n.children.map((_, i) => portY(n, i));
        let lit = true;
        const segs = [];
        let prev = n.y + 8;
        n.children.forEach((c, i) => {
          const cs = stateOf(c);
          segs.push(/* @__PURE__ */ jsx("line", { x1: rx, y1: prev, x2: rx, y2: ys[i] - 13, stroke: lit ? AVL_INK.focus : AVL_INK.quiet, strokeOpacity: lit ? 1 : 0.4, strokeWidth: 2 }, `r${i}`));
          lit = lit && cs.status === "done" && truthy(cs.value);
          prev = ys[i] + 13;
        });
        segs.push(/* @__PURE__ */ jsx("line", { x1: rx, y1: prev, x2: rx, y2: cy, stroke: lit ? AVL_INK.focus : AVL_INK.quiet, strokeOpacity: lit ? 1 : 0.4, strokeWidth: 2 }, "rend"));
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          caption(n.label),
          segs,
          n.children.map((_, i) => switchGlyph(n, i, rx, ys[i], true))
        ] });
      }
      case "parallel": {
        const l = n.x + 18;
        const r = n.x + n.w - 18;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          caption(n.label),
          /* @__PURE__ */ jsx("line", { x1: l, y1: portY(n, 0) - 10, x2: l, y2: portY(n, n.children.length - 1) + 10, stroke: AVL_INK.quiet, strokeWidth: 2 }),
          /* @__PURE__ */ jsx("line", { x1: r, y1: portY(n, 0) - 10, x2: r, y2: portY(n, n.children.length - 1) + 10, stroke: AVL_INK.quiet, strokeWidth: 2 }),
          n.children.map((c, i) => {
            const cs = stateOf(c);
            const on = cs.status === "done" && truthy(cs.value);
            const py = portY(n, i);
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx("line", { x1: l, y1: py, x2: (l + r) / 2 - 12, y2: py, stroke: on ? AVL_INK.focus : AVL_INK.quiet, strokeWidth: 1.5 }),
              /* @__PURE__ */ jsx("line", { x1: (l + r) / 2 + 12, y1: py, x2: r, y2: py, stroke: on ? AVL_INK.focus : AVL_INK.quiet, strokeWidth: 1.5 }),
              switchGlyph(n, i, (l + r) / 2, py, false)
            ] }, `b${i}`);
          })
        ] });
      }
      case "branch": {
        const cond = stateOf(n.children[0]);
        const takenIndex = cond.status === "done" ? truthy(cond.value) ? 1 : 2 : -1;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          n.children.slice(1).map((c, j) => {
            const i = j + 1;
            const on = i === takenIndex;
            return /* @__PURE__ */ jsx(
              "path",
              {
                d: `M ${n.x} ${portY(n, i)} C ${cx} ${portY(n, i)}, ${cx} ${cy}, ${n.x + n.w} ${cy}`,
                fill: "none",
                stroke: on ? AVL_INK.focus : AVL_INK.quiet,
                strokeOpacity: on ? 1 : 0.35,
                strokeWidth: on ? 2.5 : 1.5
              },
              `t${i}`
            );
          }),
          /* @__PURE__ */ jsx("line", { x1: n.x, y1: portY(n, 0), x2: cx, y2: cy, stroke: AVL_INK.quiet, strokeWidth: 1, strokeDasharray: "2 3" }),
          /* @__PURE__ */ jsx("text", { x: n.x + 8, y: n.y + 12, fontFamily: AVL_FONT.mono, fontSize: 12, fill: AVL_INK.text, children: n.label })
        ] });
      }
      case "conveyor": {
        const collection = stateOf(n.children[0]);
        const items = Array.isArray(collection.value) ? collection.value : [];
        const lambda = n.children[1];
        const bodyNode = lambda?.children[lambda.children.length - 1];
        const bodyState = bodyNode ? stateOf(bodyNode) : IDLE;
        const results = bodyState.results;
        const beltY = n.y + n.h - 26;
        const step = items.length ? (n.w - 24) / items.length : 0;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          caption(n.label),
          /* @__PURE__ */ jsx("rect", { x: n.x + 8, y: beltY - 12, width: n.w - 16, height: 24, rx: 12, fill: AVL_INK.wash, stroke: AVL_INK.line }),
          items.map((item, i) => {
            const done = i < results.length;
            const current = bodyState.status === "active" && i === results.length;
            const result = done ? results[i] : void 0;
            const kept = typeof result === "boolean" ? result : true;
            const x = n.x + 12 + i * step;
            return /* @__PURE__ */ jsxs("g", { "data-testid": "avl-circuit-item", "data-result": done ? String(result) : "pending", children: [
              /* @__PURE__ */ jsx("title", { children: JSON.stringify(item) }),
              /* @__PURE__ */ jsx(
                "rect",
                {
                  x,
                  y: beltY - 9,
                  width: step - 6,
                  height: 18,
                  rx: 9,
                  fill: done ? avlTint(kept ? AVL_INK.pass : AVL_INK.fail, 16) : AVL_INK.surface,
                  stroke: current ? AVL_INK.focus : done ? kept ? AVL_INK.pass : AVL_INK.fail : AVL_INK.line,
                  strokeWidth: current ? 2 : 1,
                  opacity: done && !kept ? 0.55 : 1
                }
              ),
              /* @__PURE__ */ jsxs(
                "text",
                {
                  x: x + (step - 6) / 2,
                  y: beltY,
                  textAnchor: "middle",
                  dominantBaseline: "central",
                  fontFamily: AVL_FONT.mono,
                  fontSize: 12,
                  fill: AVL_INK.text,
                  textDecoration: done && !kept ? "line-through" : void 0,
                  children: [
                    `#${i + 1}`,
                    done ? typeof result === "boolean" ? kept ? " \u2713" : " \u2715" : ` ${fmt(result)}` : ""
                  ]
                }
              )
            ] }, `it${i}`);
          })
        ] });
      }
      case "ladder": {
        const rl = n.x + 14;
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          caption(n.label),
          /* @__PURE__ */ jsx("line", { x1: rl, y1: n.y + 22, x2: rl, y2: n.y + n.h - 6, stroke: AVL_INK.focus, strokeWidth: 2 }),
          n.children.map((c, i) => {
            const cs = stateOf(c);
            const color = cs.status === "done" ? AVL_INK.pass : cs.status === "active" ? AVL_INK.focus : cs.status === "error" ? AVL_INK.fail : AVL_INK.quiet;
            return /* @__PURE__ */ jsx("line", { x1: rl, y1: portY(n, i), x2: n.x + n.w - 10, y2: portY(n, i), stroke: color, strokeWidth: cs.status === "idle" ? 1 : 2 }, `r${i}`);
          })
        ] });
      }
      case "actuator": {
        const zone = effectZoneOf(n.label);
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          /* @__PURE__ */ jsx("svg", { x: n.x + 6, y: cy - 9, width: 18, height: 18, viewBox: "-9 -9 18 18", overflow: "visible", children: /* @__PURE__ */ jsx(AvlEffect, { effectType: n.label, size: 7, color: s.status === "done" ? AVL_INK.pass : AVL_INK.quiet }) }),
          /* @__PURE__ */ jsx("text", { x: n.x + 28, y: cy, dominantBaseline: "central", fontFamily: AVL_FONT.mono, fontSize: 12, fontWeight: 600, fill: AVL_INK.text, children: n.label }),
          s.status === "done" && zone ? /* @__PURE__ */ jsxs("text", { "data-testid": "avl-circuit-zone", x: n.x + n.w - 8, y: n.y + n.h + 14, textAnchor: "end", fontFamily: AVL_FONT.mono, fontSize: 12, fill: AVL_INK.pass, children: [
            "\u2192 ",
            t(`avl.circuit.zone.${zone}`)
          ] }) : null
        ] });
      }
      case "invert":
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("path", { d: `M ${n.x + 8} ${n.y + 6} L ${n.x + n.w - 14} ${cy} L ${n.x + 8} ${n.y + n.h - 6} Z`, fill: AVL_INK.surface, stroke: AVL_INK.line }),
          /* @__PURE__ */ jsx("circle", { cx: n.x + n.w - 9, cy, r: 4, fill: AVL_INK.surface, stroke: AVL_INK.line })
        ] });
      case "delay":
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          /* @__PURE__ */ jsx("circle", { cx: n.x + 16, cy, r: 7, fill: "none", stroke: AVL_INK.quiet, strokeWidth: 1.5 }),
          /* @__PURE__ */ jsx("polyline", { points: `${n.x + 16},${cy - 4} ${n.x + 16},${cy} ${n.x + 19},${cy + 2}`, fill: "none", stroke: AVL_INK.quiet, strokeWidth: 1.5 }),
          /* @__PURE__ */ jsx("text", { x: n.x + 30, y: cy, dominantBaseline: "central", fontFamily: AVL_FONT.mono, fontSize: 12, fill: AVL_INK.text, children: n.label })
        ] });
      case "template":
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(true),
          caption(n.label)
        ] });
      default:
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          frame(),
          caption(n.form === "unknown" ? `${n.label} ?` : n.label, n.label.length <= 2)
        ] });
    }
  };
  const drawn = [];
  const walk = (n) => {
    n.children.forEach((c, i) => {
      walk(c);
      drawn.push(wire(n, c, i));
    });
    const s = stateOf(n);
    drawn.push(
      /* @__PURE__ */ jsxs(
        "g",
        {
          "data-testid": "avl-circuit-node",
          "data-key": n.key,
          "data-kind": n.kind,
          "data-form": n.form ?? "",
          "data-status": s.status,
          opacity: s.status === "skipped" ? 0.35 : 1,
          children: [
            s.status === "active" ? /* @__PURE__ */ jsx("rect", { x: n.x - 4, y: n.y - 4, width: n.w + 8, height: n.h + 8, rx: 14, fill: "none", stroke: AVL_INK.focus, strokeOpacity: 0.22, strokeWidth: 4, children: !reduceMotion ? /* @__PURE__ */ jsx("animate", { attributeName: "stroke-opacity", values: "0.28;0.06;0.28", dur: "1.6s", repeatCount: "indefinite" }) : null }) : null,
            body(n)
          ]
        },
        `n-${n.key}`
      )
    );
  };
  walk(circuit.root);
  const root = circuit.root;
  const rootState = stateOf(root);
  const outY = root.y + root.h / 2;
  return /* @__PURE__ */ jsxs(Box, { className, style: { width: "100%" }, children: [
    title || showCode ? /* @__PURE__ */ jsxs(Box, { className: "pb-2", children: [
      title ? /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: title }) : null,
      showCode ? /* @__PURE__ */ jsx(Box, { as: "code", "data-testid": "avl-circuit-code", style: { display: "block", fontFamily: AVL_FONT.mono, fontSize: 13, color: AVL_INK.quiet, whiteSpace: "pre-wrap" }, children: formatSExpr(expr) }) : null
    ] }) : null,
    /* @__PURE__ */ jsx(Box, { ref: hostRef, className: "overflow-x-auto", style: { width: "100%" }, children: /* @__PURE__ */ jsx(Box, { className: "relative mx-auto", style: { width: W * scale, height: circuit.h * scale }, children: /* @__PURE__ */ jsxs("svg", { width: W * scale, height: circuit.h * scale, viewBox: `0 0 ${W} ${circuit.h}`, role: "img", "aria-label": formatSExpr(expr), children: [
      drawn,
      /* @__PURE__ */ jsx("path", { d: `M ${root.x + root.w} ${outY} H ${root.x + root.w + 38}`, stroke: rootState.status === "done" ? AVL_INK.focus : AVL_INK.quiet, strokeWidth: 2 }),
      rootState.status === "done" && typeof rootState.value === "boolean" ? /* @__PURE__ */ jsx("circle", { cx: root.x + root.w + 48, cy: outY, r: 8, fill: rootState.value ? AVL_INK.pass : AVL_INK.fail }) : null,
      rootState.status === "done" && rootState.value !== void 0 ? valueChip(root.x + root.w + 62, outY + 10, rootState.value) : null
    ] }) }) }),
    narration !== null ? /* @__PURE__ */ jsxs(Box, { className: "pt-2", children: [
      /* @__PURE__ */ jsxs(Box, { "data-testid": "avl-circuit-narration", style: { fontSize: 13, color: AVL_INK.quiet }, children: [
        /* @__PURE__ */ jsx(Box, { as: "span", style: { color: AVL_INK.text, fontWeight: 600 }, children: t("avl.circuit.step", { n: at + 1, total: trace?.length ?? 0 }) }),
        " \u2014 ",
        narration
      ] }),
      stack.length > 0 ? /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-center gap-1 pt-1", style: { fontFamily: AVL_FONT.mono, fontSize: 12, color: AVL_INK.quiet }, children: [
        t("avl.circuit.stack"),
        stack.map((k, i) => /* @__PURE__ */ jsx(
          Box,
          {
            as: "span",
            "data-testid": "avl-circuit-stack-frame",
            className: "rounded px-1.5",
            style: { border: `1px solid ${i === stack.length - 1 ? AVL_INK.focus : AVL_INK.line}`, color: i === stack.length - 1 ? AVL_INK.focus : AVL_INK.quiet, background: AVL_INK.wash },
            children: nodes.get(k)?.label ?? k
          },
          k
        ))
      ] }) : null
    ] }) : null
  ] });
};
AvlCircuit.displayName = "AvlCircuit";
var isConfigObject = (v) => typeof v === "object" && v !== null && !Array.isArray(v);
var EffectHeader = ({ type, failed, failedLabel, note }) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
  /* @__PURE__ */ jsx(AvlEffectChip, { effectType: type, size: 18, note }),
  /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: type }),
  failed ? /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: failedLabel }) : null
] });
var AvlTransitionDetail = ({ orbital, trait, transition, annotations, playback, stepEvent, className }) => {
  const { t } = useTranslate();
  const [payload, setPayload] = useState({});
  const guard = transition.guard ?? null;
  const guardRun = playback?.guard;
  const request = { orbital, trait, from: transition.from, event: transition.event, payload };
  const effectItems = useMemo(
    () => transition.effects.map((effect, i) => {
      const expr = [effect.type, ...effect.args];
      const ran = playback?.effects[i];
      return {
        id: `effect-${i}`,
        header: /* @__PURE__ */ jsx(EffectHeader, { type: effect.type, failed: ran?.status === "failed", failedLabel: t("avl.play.effectFailed"), note: annotations?.effects?.[effect.type] }),
        content: /* @__PURE__ */ jsx(AvlCircuit, { expr, trace: ran?.evalTrace, showCode: true })
      };
    }),
    [transition.effects, playback, t, annotations]
  );
  const openEffects = transition.effects.map((effect, i) => effectZoneOf(effect.type) === "screen" ? null : `effect-${i}`).filter((id) => id !== null);
  return /* @__PURE__ */ jsx(Card, { className: `w-full max-w-5xl mx-auto ${className ?? ""}`, shadow: "md", "data-testid": "avl-transition-detail", children: /* @__PURE__ */ jsx(Box, { className: "p-6", children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "md", justify: "between", align: "center", wrap: true, children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
        /* @__PURE__ */ jsx(Badge, { variant: "neutral", size: "lg", children: transition.from }),
        annotations?.transitions?.[transition.event] ? /* @__PURE__ */ jsx(AvlExplain, { lines: [transition.event], note: annotations.transitions[transition.event], children: /* @__PURE__ */ jsx(Box, { as: "span", tabIndex: 0, "data-testid": "avl-td-event", className: "underline decoration-dotted underline-offset-4 cursor-help", children: /* @__PURE__ */ jsx(Typography, { variant: "body1", weight: "semibold", as: "span", children: transition.event }) }) }) : /* @__PURE__ */ jsx(Box, { as: "span", "data-testid": "avl-td-event", children: /* @__PURE__ */ jsx(Typography, { variant: "body1", weight: "semibold", as: "span", children: transition.event }) }),
        /* @__PURE__ */ jsx(Typography, { variant: "h5", color: "muted", children: "\u2192" }),
        /* @__PURE__ */ jsx(Badge, { variant: "neutral", size: "lg", children: transition.to })
      ] }),
      playback ? /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", children: /* @__PURE__ */ jsx(Badge, { variant: playback.fired ? "success" : "warning", size: "md", "data-testid": "avl-transition-verdict", children: playback.fired ? t("avl.play.fired") : guardRun && !guardRun.passed ? t("avl.play.blocked") : t("avl.play.notReached") }) }) : null
    ] }),
    stepEvent ? /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "muted", children: t("avl.play.payload") }),
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
        /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0", children: /* @__PURE__ */ jsx(JsonTreeEditor, { value: payload, onChange: (next) => setPayload(isConfigObject(next) ? next : {}) }) }),
        /* @__PURE__ */ jsx(Button, { variant: "primary", size: "sm", action: stepEvent, actionPayload: request, leftIcon: "skip-forward", children: t("avl.play.step") })
      ] })
    ] }) : null,
    !playback && stepEvent ? /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: t("avl.play.notPlayed") }) : null,
    guard !== null ? /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "muted", children: t("avl.guard") }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", "data-testid": "avl-td-guard-caption", children: t("avl.guardCaption") }),
        guardRun ? /* @__PURE__ */ jsx(Badge, { variant: guardRun.passed ? "success" : "danger", size: "sm", children: guardRun.passed ? t("avl.play.guardPassed") : t("avl.play.guardFailed") }) : null
      ] }),
      /* @__PURE__ */ jsx(AvlCircuit, { expr: guard, trace: guardRun?.trace })
    ] }) : null,
    effectItems.length > 0 ? /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", wrap: true, children: [
        /* @__PURE__ */ jsxs(Typography, { variant: "overline", color: "muted", children: [
          t("avl.effects"),
          " (",
          effectItems.length,
          ")"
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", "data-testid": "avl-td-effects-caption", children: t("avl.effectsCaption") })
      ] }),
      /* @__PURE__ */ jsx(Accordion, { items: effectItems, multiple: true, defaultOpenItems: openEffects })
    ] }) : null
  ] }) }) });
};
AvlTransitionDetail.displayName = "AvlTransitionDetail";
var AvlTransitionExplainer = ({ orbitalName, traitName, transition, annotations, className, ...rest }) => {
  const detail = { ...transition, guard: transition.guard ?? null };
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsx(AvlTransitionDetail, { orbital: orbitalName, trait: traitName, transition: detail, annotations }) });
};
AvlTransitionExplainer.displayName = "AvlTransitionExplainer";
var BehaviorView = ({ data, ...rest }) => {
  const { t } = useTranslate();
  const details = data.traits.map((tr) => data.traitDetails[tr.name]).filter((d) => d !== void 0);
  if (details.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), "data-testid": "behavior-view-empty", children: /* @__PURE__ */ jsx(EmptyState, { icon: "workflow", title: t("avl.noTraitData") }) });
  }
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: "flex flex-col gap-4", style: { width: "100%" }, children: details.map((trait) => /* @__PURE__ */ jsx(
    Box,
    {
      className: "rounded-lg border px-5 pb-4 pt-4",
      style: { background: "var(--color-card)", borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" },
      children: /* @__PURE__ */ jsx(AvlStateMachine, { trait })
    },
    trait.name
  )) });
};
BehaviorView.displayName = "BehaviorView";
var sceneLog = createLogger("almadar:ui:learning-scene-3d");
var KNOWN_BLOOM_KEYS = /* @__PURE__ */ new Set(["intensity", "threshold", "smoothing"]);
var Canvas3DHost2 = lazy(
  () => import('@almadar/ui/components/molecules/game/three').then((m) => ({ default: m.Canvas3DHost }))
);
function LearningScene3D({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  drawables,
  camera,
  lighting,
  post,
  showGrid = false,
  shadows,
  interactive,
  isLoading,
  error,
  onItemClick,
  description,
  ...rest
}) {
  const { t } = useTranslate();
  const descId = useId();
  const instanceId = useId().replace(/[^a-zA-Z0-9]/g, "");
  const clickEvent = onItemClick ? `LEARNING_SCENE_3D.ITEM_CLICK.${instanceId}` : void 0;
  const onItemClickRef = useRef(onItemClick);
  onItemClickRef.current = onItemClick;
  useEventListener(`UI:${clickEvent ?? "LEARNING_SCENE_3D.ITEM_CLICK.__disabled"}`, (event) => {
    const unitId = event.payload?.unitId;
    if (typeof unitId === "string") onItemClickRef.current?.(unitId);
  });
  if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && post?.bloom) {
    const unknownKeys = Object.keys(post.bloom).filter((k) => !KNOWN_BLOOM_KEYS.has(k));
    if (unknownKeys.length > 0) {
      sceneLog.debug("post.bloom has unrecognized keys \u2014 only intensity/threshold/smoothing are read", { unknownKeys });
    }
  }
  const props3d = {
    drawables,
    isLoading,
    error: error ? error.message : null,
    cameraMode: camera?.mode ?? "perspective",
    ...camera?.zoom !== void 0 ? { zoom: camera.zoom } : {},
    ...camera?.fov !== void 0 ? { fov: camera.fov } : {},
    ...camera?.azimuth !== void 0 ? { azimuth: camera.azimuth } : {},
    ...camera?.elevation !== void 0 ? { elevation: camera.elevation } : {},
    ...camera?.target !== void 0 ? { followTarget: camera.target } : {},
    backgroundColor,
    ...series !== void 0 ? { series } : {},
    showGrid,
    ...shadows !== void 0 ? { shadows } : {},
    ...interactive !== void 0 ? { controlsEnabled: interactive } : {},
    lighting,
    post,
    ...clickEvent !== void 0 ? { unitClickEvent: clickEvent } : {}
  };
  return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      Box,
      {
        className: "mx-auto flex w-full overflow-hidden rounded-container",
        style: { aspectRatio: `${width} / ${height}`, maxWidth: `min(100%, calc(70vh * ${width} / ${height}))` },
        role: "img",
        "aria-label": title ?? t("aria.scene3d"),
        "aria-describedby": description ? descId : void 0,
        ...domPassthrough(rest),
        children: /* @__PURE__ */ jsx(Suspense, { fallback: null, children: /* @__PURE__ */ jsx(Canvas3DHost2, { ...props3d }) })
      }
    ),
    description ? /* @__PURE__ */ jsx(Box, { id: descId, className: "sr-only", children: description }) : null
  ] }) });
}
LearningScene3D.displayName = "LearningScene3D";
function meshSphere(id, x, y, z, radius, color, opts) {
  return {
    type: "draw-mesh",
    ...id !== void 0 ? { id } : {},
    shape: opts?.shape ?? "sphere",
    position: { x, y, z },
    radius,
    pivot: "center",
    segments: opts?.segments ?? 24,
    material: { color, ...opts?.material },
    ...opts?.opacity !== void 0 ? { opacity: opts.opacity } : {}
  };
}
function axisRotation(from, to) {
  const wx = to[0] - from[0];
  const wy = to[2] - from[2];
  const wz = to[1] - from[1];
  const len = Math.sqrt(wx * wx + wy * wy + wz * wz);
  const tilt = Math.acos(Math.min(1, Math.max(-1, len > 0 ? wy / len : 1)));
  return [0, Math.atan2(wz, -wx), tilt];
}
function segmentLength(from, to) {
  const dx = to[0] - from[0];
  const dy = to[1] - from[1];
  const dz = to[2] - from[2];
  return Math.sqrt(dx * dx + dy * dy + dz * dz);
}
function cylinderBetween(from, to, radius, color) {
  const len = segmentLength(from, to);
  if (len < 1e-6) return null;
  return {
    type: "draw-mesh",
    shape: "cylinder",
    position: { x: (from[0] + to[0]) / 2, y: (from[1] + to[1]) / 2, z: (from[2] + to[2]) / 2 },
    radius,
    height: len,
    rotation: axisRotation(from, to),
    pivot: "center",
    segments: 12,
    material: { color }
  };
}
function arrowBetween(from, to, color, shaftRadius = 0.08, id) {
  const len = segmentLength(from, to);
  if (len < 1e-6) return null;
  const tipLen = Math.min(shaftRadius * 8, len * 0.35);
  const k = (len - tipLen) / len;
  const delta = [to[0] - from[0], to[1] - from[1], to[2] - from[2]];
  const shaftEnd = [delta[0] * k, delta[1] * k, delta[2] * k];
  const tipStart = shaftEnd;
  const tipEnd = delta;
  const shaft = cylinderBetween([0, 0, 0], shaftEnd, shaftRadius, color);
  const tipLenActual = segmentLength(tipStart, tipEnd);
  const tip = {
    type: "draw-mesh",
    shape: "cone",
    position: {
      x: (tipStart[0] + tipEnd[0]) / 2,
      y: (tipStart[1] + tipEnd[1]) / 2,
      z: (tipStart[2] + tipEnd[2]) / 2
    },
    radius: shaftRadius * 3,
    height: tipLenActual,
    rotation: axisRotation(tipStart, tipEnd),
    pivot: "center",
    segments: 12,
    material: { color }
  };
  return {
    type: "draw-group",
    ...id !== void 0 ? { id } : {},
    position: { x: from[0], y: from[1], z: from[2] },
    items: tipLenActual < 1e-6 ? shaft ? [shaft] : [] : shaft ? [shaft, tip] : [tip]
  };
}
function billboardLabel(text, x, y, z, opts) {
  return {
    type: "draw-text",
    text,
    position: { x, y, z },
    color: opts?.color ?? "ink"
  };
}
function get3DClickPayload(onShapeClick, idToIndex) {
  if (!onShapeClick) return void 0;
  return (id) => onShapeClick({ id, index: idToIndex.get(id) ?? -1 });
}
function polylineTube(points, radius, color, opts) {
  const maxSegments = opts?.maxSegments ?? 128;
  let pts = points;
  if (pts.length - 1 > maxSegments) {
    const step = (pts.length - 1) / maxSegments;
    const kept = [pts[0]];
    for (let s = 1; s < maxSegments; s++) kept.push(pts[Math.round(s * step)]);
    kept.push(pts[pts.length - 1]);
    pts = kept;
  }
  const out = [];
  for (let i = 0; i < pts.length - 1; i++) {
    const seg = cylinderBetween(pts[i], pts[i + 1], radius, color);
    if (seg) out.push(opts?.opacity !== void 0 ? { ...seg, opacity: opts.opacity } : seg);
  }
  return out;
}
function heightFieldMesh(spec) {
  const { nx, ny, heights, spacing = 1, x = 0, y = 0 } = spec;
  const flatShading = spec.flatShading ?? true;
  const vertices = [];
  for (let iy = 0; iy < ny; iy++) {
    for (let ix = 0; ix < nx; ix++) {
      vertices.push([
        x + (ix - (nx - 1) / 2) * spacing,
        y + (iy - (ny - 1) / 2) * spacing,
        heights[iy * nx + ix] ?? 0
      ]);
    }
  }
  const bands = [...spec.bands ?? []].sort((a, b) => (a.min ?? -Infinity) - (b.min ?? -Infinity));
  const facesByBand = /* @__PURE__ */ new Map();
  for (let iy = 0; iy < ny - 1; iy++) {
    for (let ix = 0; ix < nx - 1; ix++) {
      const v00 = iy * nx + ix;
      const v10 = iy * nx + ix + 1;
      const v01 = (iy + 1) * nx + ix;
      const v11 = (iy + 1) * nx + ix + 1;
      for (const face of [[v00, v10, v01], [v10, v11, v01]]) {
        const centroid = (vertices[face[0]][2] + vertices[face[1]][2] + vertices[face[2]][2]) / 3;
        let band = null;
        for (const b of bands) {
          if ((b.min ?? -Infinity) <= centroid) band = b;
        }
        const key = bands.length > 0 ? band : null;
        const list = facesByBand.get(key) ?? [];
        list.push(face);
        facesByBand.set(key, list);
      }
    }
  }
  const out = [];
  for (const [band, faces] of facesByBand) {
    if (faces.length === 0) continue;
    out.push({
      type: "draw-mesh",
      shape: "polyhedron",
      position: { x: 0, y: 0, z: 0 },
      vertices,
      faces,
      pivot: "center",
      material: { color: band?.color ?? spec.color ?? "series-1", flatShading, side: "double" },
      ...spec.opacity !== void 0 ? { opacity: spec.opacity } : {}
    });
  }
  return out;
}
function arrowField(vectors, opts) {
  const scale = opts?.scale ?? 1;
  const out = [];
  for (const v of vectors) {
    const to = [
      v.from[0] + v.delta[0] * scale,
      v.from[1] + v.delta[1] * scale,
      v.from[2] + v.delta[2] * scale
    ];
    const arrow = arrowBetween(v.from, to, v.color ?? "series-5", v.width, v.id);
    if (arrow) out.push(arrow);
    if (v.label) out.push(billboardLabel(v.label, to[0], to[1], to[2], { color: opts?.labelColor }));
  }
  return out;
}
function helixDrawables(spec, opts) {
  const count = spec.count ?? spec.rungs?.length ?? 0;
  const rungs = Array.from({ length: count }, (_, i) => spec.rungs?.[i] ?? {});
  const radius = spec.radius ?? 1;
  const rise = spec.rise ?? 0.34;
  const twistRad = (spec.twistDeg ?? 36) * (Math.PI / 180);
  const strandAColor = spec.strandAColor ?? "series-1";
  const strandBColor = spec.strandBColor ?? "series-2";
  const backboneRadius = spec.backboneRadius ?? 0.16;
  const rungRadius = spec.rungRadius ?? 0.12;
  const cx = spec.x ?? 0;
  const cy = spec.y ?? 0;
  const cz = spec.z ?? 0;
  const unwoundCount = spec.unwoundCount ?? 0;
  const unwindSpread = spec.unwindSpread ?? 1.8;
  const strandA = [];
  const strandB = [];
  for (let i = 0; i < count; i++) {
    const yi = cy + (i - (count - 1) / 2) * rise;
    const theta = i * twistRad;
    const s = i < unwoundCount ? unwindSpread : 1;
    strandA.push([cx + s * radius * Math.cos(theta), yi, cz + s * radius * Math.sin(theta)]);
    strandB.push([cx + s * radius * Math.cos(theta + Math.PI), yi, cz + s * radius * Math.sin(theta + Math.PI)]);
  }
  const out = [];
  for (let i = 0; i < count; i++) {
    out.push(meshSphere(`hx-a-${i}`, strandA[i][0], strandA[i][1], strandA[i][2], backboneRadius, strandAColor));
    out.push(meshSphere(`hx-b-${i}`, strandB[i][0], strandB[i][1], strandB[i][2], backboneRadius, strandBColor));
    if (i > 0) {
      const segA = cylinderBetween(strandA[i - 1], strandA[i], backboneRadius, strandAColor);
      if (segA) out.push(segA);
      const segB = cylinderBetween(strandB[i - 1], strandB[i], backboneRadius, strandBColor);
      if (segB) out.push(segB);
    }
    const rung = rungs[i];
    const rungColor = rung.color ?? "muted";
    const rod = cylinderBetween(strandA[i], strandB[i], rungRadius, rungColor);
    if (rod) out.push(rod);
    const mid = [
      (strandA[i][0] + strandB[i][0]) / 2,
      (strandA[i][1] + strandB[i][1]) / 2,
      (strandA[i][2] + strandB[i][2]) / 2
    ];
    const markerRadius = rung.radius ?? rungRadius;
    out.push(meshSphere(rung.id, mid[0], mid[1], mid[2], markerRadius, rungColor));
    if (rung.label) out.push(billboardLabel(rung.label, mid[0], mid[1], mid[2] + markerRadius, { color: opts?.labelColor }));
  }
  return out;
}
function latticeDrawables(spec, opts) {
  const nx = spec.nx ?? 2;
  const ny = spec.ny ?? 2;
  const nz = spec.nz ?? 2;
  const latticeConstant = spec.latticeConstant ?? 2;
  const bondRadius = spec.bondRadius ?? 0.06;
  const highlightCell = spec.highlightCell ?? false;
  const dimColor = spec.dimColor ?? "muted";
  const showLabels = spec.showLabels ?? false;
  const selectedColor = spec.selectedColor ?? "highlight";
  const posByKey = /* @__PURE__ */ new Map();
  const inCellByKey = /* @__PURE__ */ new Map();
  const out = [];
  for (const site of spec.basis) {
    const snx = site.xEdge ? nx + 1 : nx;
    const sny = site.yEdge ? ny + 1 : ny;
    const snz = site.zEdge ? nz + 1 : nz;
    for (let i = 0; i < snx; i++) {
      for (let j = 0; j < sny; j++) {
        for (let k = 0; k < snz; k++) {
          const key = `${site.key}-${i}-${j}-${k}`;
          const inCell = i + site.dx <= 1 && j + site.dy <= 1 && k + site.dz <= 1;
          const pos = [
            (i + site.dx) * latticeConstant - nx * latticeConstant / 2,
            (j + site.dy) * latticeConstant - ny * latticeConstant / 2,
            (k + site.dz) * latticeConstant - nz * latticeConstant / 2
          ];
          posByKey.set(key, pos);
          inCellByKey.set(key, inCell);
          const isSelected = spec.selectedId === `lat-${key}`;
          const color = isSelected ? selectedColor : highlightCell && !inCell ? dimColor : site.color ?? "series-1";
          const radius = (site.radius ?? 0.3) * (isSelected ? 1.4 : 1);
          out.push(meshSphere(`lat-${key}`, pos[0], pos[1], pos[2], radius, color));
          if (showLabels && site.element) {
            out.push(billboardLabel(site.element, pos[0], pos[1], pos[2] + radius, { color: opts?.labelColor }));
          }
        }
      }
    }
  }
  const basisByKey = new Map(spec.basis.map((s) => [s.key, s]));
  for (const bond of spec.bonds ?? []) {
    const fromSite = basisByKey.get(bond.from);
    const toSite = basisByKey.get(bond.to);
    if (!fromSite || !toSite) continue;
    const fnx = fromSite.xEdge ? nx + 1 : nx;
    const fny = fromSite.yEdge ? ny + 1 : ny;
    const fnz = fromSite.zEdge ? nz + 1 : nz;
    const tnx = toSite.xEdge ? nx + 1 : nx;
    const tny = toSite.yEdge ? ny + 1 : ny;
    const tnz = toSite.zEdge ? nz + 1 : nz;
    const bdx = bond.dx ?? 0;
    const bdy = bond.dy ?? 0;
    const bdz = bond.dz ?? 0;
    for (let i = 0; i < fnx; i++) {
      for (let j = 0; j < fny; j++) {
        for (let k = 0; k < fnz; k++) {
          const ti = i + bdx;
          const tj = j + bdy;
          const tk = k + bdz;
          if (ti < 0 || ti >= tnx || tj < 0 || tj >= tny || tk < 0 || tk >= tnz) continue;
          const fromKey = `${fromSite.key}-${i}-${j}-${k}`;
          const toKey = `${toSite.key}-${ti}-${tj}-${tk}`;
          const fromPos = posByKey.get(fromKey);
          const toPos = posByKey.get(toKey);
          if (!fromPos || !toPos) continue;
          const dimmed = highlightCell && !(inCellByKey.get(fromKey) && inCellByKey.get(toKey));
          const seg = cylinderBetween(fromPos, toPos, bondRadius, dimmed ? dimColor : bond.color ?? "ink");
          if (seg) out.push(seg);
        }
      }
    }
  }
  return out;
}
var biologyLog = createLogger("almadar:ui:biology-canvas");
var SERIES_TONES = ["series-1", "series-2", "series-3", "series-4", "series-5", "series-6", "series-7", "series-8"];
function seriesTone(i) {
  return SERIES_TONES[i % SERIES_TONES.length];
}
var BIO_STAGE_FILL = {
  pending: "fill",
  active: "primary",
  done: "muted"
};
var BIO_STAGE_TEXT = {
  pending: "label",
  active: "ink",
  done: "ink"
};
var BiologyCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  keyMap,
  keyUpMap,
  mode = "2d",
  camera,
  lighting,
  post,
  nodes = [],
  edges = [],
  compartments = [],
  bands = [],
  stages = [],
  stageStyle = "timeline",
  helix,
  helix3d,
  shapes = [],
  readouts,
  traces,
  showGrid,
  shadows,
  interactive,
  animate = false,
  onShapeClick,
  isLoading,
  error,
  ...rest
}) => {
  const derivedShapes = useMemo(() => {
    const out = [];
    const nodeById = /* @__PURE__ */ new Map();
    for (const n of nodes) {
      if (n.id) nodeById.set(n.id, n);
    }
    const bandCount = bands.length;
    for (let i = 0; i < bandCount; i++) {
      const band = bands[i];
      const bandColor = band.color ?? seriesTone(i);
      const bandY = i * height / bandCount;
      const bandH = height / bandCount;
      out.push({
        type: "rect",
        x: 0,
        y: bandY,
        width,
        height: bandH,
        color: bandColor,
        fill: bandColor,
        fillStyle: "tint",
        stroke: "thin",
        opacity: 0.45
      });
      if (band.label) {
        out.push({
          type: "text",
          x: 8,
          y: bandY + 14,
          text: band.label,
          tone: "label",
          textSize: "xs"
        });
      }
    }
    for (const c of compartments) {
      const color = c.color ?? "ink";
      out.push({
        type: "ellipse",
        x: c.x,
        y: c.y,
        width: c.width,
        height: c.height,
        color,
        fill: c.fill ?? color,
        fillStyle: "tint",
        ...c.lineWidth !== void 0 ? { lineWidth: c.lineWidth } : { stroke: "normal" },
        ...c.dash ? { dash: c.dash } : {}
      });
      if (c.label) {
        out.push({
          type: "text",
          x: c.x,
          y: c.y - c.height / 2 + 14,
          text: c.label,
          tone: "ink",
          textSize: "sm",
          align: "center"
        });
      }
    }
    if (helix) {
      const hx = helix.x ?? 24;
      const hy = helix.y ?? height * 0.25;
      const hw = helix.width ?? width - 48;
      const hh = helix.height ?? height * 0.5;
      const rungs = helix.rungs;
      const n = rungs.length;
      const cy = hy + hh / 2;
      const colorA = helix.colorA ?? "series-1";
      const colorB = helix.colorB ?? "series-2";
      const rungColor = helix.rungColor ?? "muted";
      const fork = helix.fork ?? 0;
      const maxSep = Math.min(hh - 8, 96);
      const strandA = [];
      const strandB = [];
      const rungGeoms = [];
      for (let i = 0; i < n; i++) {
        const rx = hx + (i + 0.5) * hw / n;
        const t = (i + 0.5) / n;
        const paired = t >= fork;
        const sep = paired ? 28 : 28 + (maxSep - 28) * ((fork - t) / fork);
        strandA.push({ x: rx, y: cy - sep / 2 });
        strandB.push({ x: rx, y: cy + sep / 2 });
        rungGeoms.push({ rx, sep, rung: rungs[i], paired });
      }
      for (let i = 1; i < n; i++) {
        out.push({ type: "line", x1: strandA[i - 1].x, y1: strandA[i - 1].y, x2: strandA[i].x, y2: strandA[i].y, color: colorA, stroke: "bold" });
      }
      for (let i = 1; i < n; i++) {
        out.push({ type: "line", x1: strandB[i - 1].x, y1: strandB[i - 1].y, x2: strandB[i].x, y2: strandB[i].y, color: colorB, stroke: "bold" });
      }
      for (const g of rungGeoms) {
        const rColor = g.rung.color ?? (g.rung.state === "new" ? "accent" : rungColor);
        const topY = cy - g.sep / 2;
        const bottomY = cy + g.sep / 2;
        if (g.paired) {
          out.push({ type: "line", x1: g.rx, y1: topY, x2: g.rx, y2: bottomY, color: rColor, stroke: "thin" });
          if (g.rung.a) {
            out.push({ type: "text", x: g.rx, y: cy - g.sep / 4, text: g.rung.a, textSize: "xs", align: "center", tone: "label" });
          }
          if (g.rung.b) {
            out.push({ type: "text", x: g.rx, y: cy + g.sep / 4, text: g.rung.b, textSize: "xs", align: "center", tone: "label" });
          }
        } else {
          const stubTopY = topY + 8;
          const stubBottomY = bottomY - 8;
          out.push({ type: "line", x1: g.rx, y1: topY, x2: g.rx, y2: stubTopY, color: rColor, stroke: "thin" });
          out.push({ type: "line", x1: g.rx, y1: bottomY, x2: g.rx, y2: stubBottomY, color: rColor, stroke: "thin" });
          if (g.rung.a) {
            out.push({ type: "text", x: g.rx, y: stubTopY + 6, text: g.rung.a, textSize: "xs", align: "center", tone: "label" });
          }
          if (g.rung.b) {
            out.push({ type: "text", x: g.rx, y: stubBottomY - 6, text: g.rung.b, textSize: "xs", align: "center", tone: "label" });
          }
        }
      }
    }
    for (const e of edges) {
      const a = nodeById.get(e.from);
      const b = nodeById.get(e.to);
      if (!a || !b) continue;
      const color = e.color ?? "ink";
      if (e.directed) {
        const rA = a.radius ?? 16;
        const rB = b.radius ?? 16;
        const dx = b.x - a.x;
        const dy = b.y - a.y;
        const dist = Math.max(1e-6, Math.hypot(dx, dy));
        const ux = dx / dist;
        const uy = dy / dist;
        out.push({
          type: "arrow",
          x1: a.x + ux * rA,
          y1: a.y + uy * rA,
          x2: b.x - ux * rB,
          y2: b.y - uy * rB,
          color,
          stroke: "normal"
        });
      } else {
        out.push({
          type: "line",
          x1: a.x,
          y1: a.y,
          x2: b.x,
          y2: b.y,
          color,
          stroke: "normal"
        });
      }
      if (e.label) {
        out.push({
          type: "text",
          x: (a.x + b.x) / 2 + 4,
          y: (a.y + b.y) / 2 - 4,
          text: e.label,
          tone: "label",
          textSize: "sm"
        });
      }
    }
    nodes.forEach((n, ni) => {
      const state = n.state ?? "default";
      const muted = state === "muted";
      const nodeColor = n.color ?? seriesTone(ni);
      out.push({
        type: "circle",
        x: n.x,
        y: n.y,
        radius: n.radius ?? 16,
        color: nodeColor,
        fill: nodeColor,
        fillStyle: "tint",
        stroke: "normal",
        id: n.id,
        ...muted ? { opacity: 0.35 } : {}
      });
      if (state === "highlight") {
        out.push({
          type: "circle",
          x: n.x,
          y: n.y,
          radius: (n.radius ?? 16) + 4,
          tone: "highlight",
          stroke: "normal"
        });
      }
      if (n.label) {
        out.push({
          type: "text",
          x: n.x,
          y: n.y + (n.radius ?? 16) + 14,
          text: n.label,
          ...muted ? { opacity: 0.35 } : {},
          tone: "ink",
          textSize: "sm",
          align: "center"
        });
      }
    });
    const stageCount = stages.length;
    if (stageCount > 0) {
      if (stageStyle === "ring") {
        const cx = width / 2;
        const cy = height / 2;
        const R = Math.min(width, height) / 2 - 48;
        const ringPoints = [];
        for (let i = 0; i < stageCount; i++) {
          const angleRad = (-90 + 360 * i / stageCount) * Math.PI / 180;
          ringPoints.push({ x: cx + R * Math.cos(angleRad), y: cy + R * Math.sin(angleRad) });
        }
        if (stageCount >= 2) {
          for (let i = 0; i < stageCount - 1; i++) {
            const p1 = ringPoints[i];
            const p2 = ringPoints[i + 1];
            const dx = p2.x - p1.x;
            const dy = p2.y - p1.y;
            const dist = Math.max(1e-6, Math.hypot(dx, dy));
            const ux = dx / dist;
            const uy = dy / dist;
            out.push({
              type: "arrow",
              x1: p1.x + ux * 46,
              y1: p1.y + uy * 46,
              x2: p2.x - ux * 46,
              y2: p2.y - uy * 46,
              tone: "guide",
              stroke: "normal"
            });
          }
        }
        for (let i = 0; i < stageCount; i++) {
          const stage = stages[i];
          const state = stage.state ?? "pending";
          const fill = stage.color ?? BIO_STAGE_FILL[state];
          const w = Math.max(26, Math.min(84, stage.label.length * 6 + 10));
          const h = 18;
          const p = ringPoints[i];
          out.push({ type: "rect", x: p.x - w / 2, y: p.y - h / 2, width: w, height: h, color: fill, fill, fillStyle: "tint", stroke: "normal" });
          out.push({ type: "text", x: p.x, y: p.y, text: stage.label, tone: BIO_STAGE_TEXT[state], textSize: "xs", align: "center" });
        }
      } else {
        const stripY = height - 32;
        const slotW = (width - 16) / stageCount;
        const chipGeoms = [];
        for (let i = 0; i < stageCount; i++) {
          chipGeoms.push({ x: 8 + i * slotW + 5, w: slotW - 10 });
        }
        for (let i = 0; i < stageCount - 1; i++) {
          const midY = stripY + 13;
          out.push({
            type: "arrow",
            x1: chipGeoms[i].x + chipGeoms[i].w,
            y1: midY,
            x2: chipGeoms[i + 1].x,
            y2: midY,
            tone: "guide",
            stroke: "normal"
          });
        }
        for (let i = 0; i < stageCount; i++) {
          const stage = stages[i];
          const state = stage.state ?? "pending";
          const fill = stage.color ?? BIO_STAGE_FILL[state];
          const g = chipGeoms[i];
          out.push({ type: "rect", x: g.x, y: stripY, width: g.w, height: 26, color: fill, fill, fillStyle: "tint", stroke: "normal" });
          out.push({
            type: "text",
            x: g.x + g.w / 2,
            y: stripY + 13,
            text: stage.label,
            tone: BIO_STAGE_TEXT[state],
            textSize: "xs",
            align: "center"
          });
        }
      }
    }
    out.push(...shapes);
    return out;
  }, [nodes, edges, compartments, bands, stages, stageStyle, helix, shapes, width, height]);
  const drawables3D = useMemo(() => {
    if (mode !== "3d") return [];
    if (shapes.length > 0) {
      biologyLog.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
    }
    if (compartments.length > 0 || bands.length > 0 || stages.length > 0 || helix) {
      biologyLog.debug("2D-only families ignored in 3D mode (pixel-authored 2D vocabulary)", {
        compartments: compartments.length,
        bands: bands.length,
        stages: stages.length,
        helix: helix != null
      });
    }
    if (animate) {
      biologyLog.debug("animate ignored in 3D mode (motion is entity-state driven)");
    }
    const tone3d = (value, fallback) => value ?? fallback;
    const out = [];
    const labelColor = "ink";
    const nodeById = /* @__PURE__ */ new Map();
    for (const n of nodes) {
      if (n.id) nodeById.set(n.id, n);
    }
    for (const e of edges) {
      const a = nodeById.get(e.from);
      const b = nodeById.get(e.to);
      if (!a || !b) continue;
      const edgeRadius = Math.max(0.04, Math.min(a.radius ?? 0.5, b.radius ?? 0.5) * 0.12);
      const edge = cylinderBetween([a.x, a.y, a.z ?? 0], [b.x, b.y, b.z ?? 0], edgeRadius, tone3d(e.color, "ink"));
      if (edge) out.push(edge);
      if (e.label) {
        out.push(
          billboardLabel(
            e.label,
            (a.x + b.x) / 2,
            (a.y + b.y) / 2,
            ((a.z ?? 0) + (b.z ?? 0)) / 2,
            { color: labelColor }
          )
        );
      }
    }
    nodes.forEach((n, ni) => {
      const radius = n.radius ?? 0.5;
      const nz = n.z ?? 0;
      out.push(meshSphere(n.id, n.x, n.y, nz, radius, tone3d(n.color, seriesTone(ni)), { shape: n.shape, ...n.opacity !== void 0 ? { opacity: n.opacity } : {} }));
      if (n.label) {
        out.push(billboardLabel(n.label, n.x, n.y, nz + radius, { color: labelColor }));
      }
    });
    if (helix3d) {
      const rungCount = helix3d.count ?? helix3d.rungs?.length ?? 0;
      const resolvedHelix = {
        ...helix3d,
        strandAColor: tone3d(helix3d.strandAColor, "series-1"),
        strandBColor: tone3d(helix3d.strandBColor, "series-2"),
        rungs: Array.from({ length: rungCount }, (_, i) => ({ ...helix3d.rungs?.[i], color: tone3d(helix3d.rungs?.[i]?.color, "muted") }))
      };
      out.push(...helixDrawables(resolvedHelix, { labelColor }));
    }
    return out;
  }, [mode, nodes, edges, shapes, compartments, bands, stages, helix, helix3d, animate, backgroundColor]);
  const nodeIndexById = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    (helix3d?.rungs ?? []).forEach((rung, i) => {
      if (rung.id) m.set(rung.id, i);
    });
    nodes.forEach((n, i) => {
      if (n.id) m.set(n.id, i);
    });
    return m;
  }, [nodes, helix3d]);
  if (mode === "3d") {
    return /* @__PURE__ */ jsx(
      LearningScene3D,
      {
        ...domPassthrough(rest),
        className,
        width,
        height,
        title,
        backgroundColor,
        series,
        drawables: drawables3D,
        camera,
        lighting,
        post,
        showGrid,
        shadows,
        interactive,
        isLoading,
        error,
        onItemClick: get3DClickPayload(onShapeClick, nodeIndexById)
      }
    );
  }
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        shapes: derivedShapes,
        readouts,
        traces,
        interactive: interactive ?? false,
        animate,
        onShapeClick,
        isLoading,
        error
      }
    )
  ] }) });
};
var BLOOM_CONFIG = {
  remember: { color: "bg-secondary text-secondary-foreground", bgColor: "bg-muted", labelKey: "bloomQuiz.level.remember" },
  understand: { color: "bg-info text-info-foreground", bgColor: "bg-info/10", labelKey: "bloomQuiz.level.understand" },
  apply: { color: "bg-success text-success-foreground", bgColor: "bg-success/10", labelKey: "bloomQuiz.level.apply" },
  analyze: { color: "bg-warning text-warning-foreground", bgColor: "bg-warning/10", labelKey: "bloomQuiz.level.analyze" },
  evaluate: { color: "bg-accent text-accent-foreground", bgColor: "bg-accent/10", labelKey: "bloomQuiz.level.evaluate" },
  create: { color: "bg-primary text-primary-foreground", bgColor: "bg-primary/10", labelKey: "bloomQuiz.level.create" }
};
var BloomQuizBlock = ({
  level,
  question,
  answer,
  index,
  isAnswered,
  answerEvent = "ANSWER_BLOOM",
  className,
  ...rest
}) => {
  const [revealed, setRevealed] = useState(false);
  const config = BLOOM_CONFIG[level];
  const { emit } = useEventBus();
  const { t } = useTranslate();
  const questionSegments = useMemo(() => parseMarkdownWithCodeBlocks(question), [question]);
  const answerSegments = useMemo(() => parseMarkdownWithCodeBlocks(answer), [answer]);
  const handleReveal = () => {
    if (!revealed) {
      emit(`UI:${answerEvent}`, { index: index ?? 0, level });
    }
    setRevealed(!revealed);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "rounded-container border border-primary p-4 my-4 transition-all",
        config.bgColor,
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 flex-wrap", children: [
            index !== void 0 && /* @__PURE__ */ jsx("span", { className: "text-muted-foreground font-medium text-sm", children: t("bloomQuiz.question", { number: index + 1 }) }),
            /* @__PURE__ */ jsx("span", { className: cn(config.color, "text-xs px-2 py-1 rounded-full font-medium"), children: t(config.labelKey) })
          ] }),
          isAnswered && /* @__PURE__ */ jsx(CheckCircle, { className: "text-success flex-shrink-0", size: 20 })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "font-semibold text-primary mb-3 space-y-2", children: questionSegments.map(
          (segment, idx) => segment.type === "markdown" ? /* @__PURE__ */ jsx(MarkdownContent, { content: segment.content }, `q-md-${idx}`) : /* @__PURE__ */ jsx(
            CodeBlock,
            {
              language: segment.language ?? "text",
              code: segment.content
            },
            `q-code-${idx}`
          )
        ) }),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "inline-flex items-center rounded-interactive bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground hover:bg-primary-hover transition-colors",
            onClick: handleReveal,
            children: revealed ? t("bloomQuiz.hideAnswer") : t("bloomQuiz.revealAnswer")
          }
        ),
        revealed && /* @__PURE__ */ jsxs("div", { className: "rounded-container bg-card/80 p-3 text-sm text-foreground shadow-elevation-card surface-material border border-primary mt-3 space-y-2", children: [
          /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground mb-1 font-medium uppercase tracking-wide", children: t("bloomQuiz.answer") }),
          answerSegments.map(
            (segment, idx) => segment.type === "markdown" ? /* @__PURE__ */ jsx(MarkdownContent, { content: segment.content }, `a-md-${idx}`) : /* @__PURE__ */ jsx(
              CodeBlock,
              {
                language: segment.language ?? "text",
                code: segment.content
              },
              `a-code-${idx}`
            )
          )
        ] })
      ]
    }
  );
};
BloomQuizBlock.displayName = "BloomQuizBlock";
function BoxPattern({
  p,
  m,
  radius,
  isLoading: _isLoading,
  error: _error,
  entity: _entity,
  ...boxProps
}) {
  return /* @__PURE__ */ jsx(
    Box,
    {
      padding: boxProps.padding ?? p,
      margin: boxProps.margin ?? m,
      rounded: boxProps.rounded ?? radius,
      ...boxProps
    }
  );
}
BoxPattern.displayName = "BoxPattern";
function SpacerPattern({ size: size2 = "flex" }) {
  if (size2 === "flex") {
    return /* @__PURE__ */ jsx(Spacer, {});
  }
  const sizeMap8 = {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem"
  };
  return /* @__PURE__ */ jsx(Box, { style: { width: sizeMap8[size2], height: sizeMap8[size2], flexShrink: 0 } });
}
SpacerPattern.displayName = "SpacerPattern";
function DividerPattern({
  orientation = "horizontal",
  variant = "solid",
  spacing = "md"
}) {
  const spacingMap = {
    xs: "my-1",
    sm: "my-2",
    md: "my-4",
    lg: "my-6"
  };
  const verticalSpacingMap = {
    xs: "mx-1",
    sm: "mx-2",
    md: "mx-4",
    lg: "mx-6"
  };
  return /* @__PURE__ */ jsx(
    Divider,
    {
      orientation,
      variant,
      className: orientation === "horizontal" ? spacingMap[spacing] : verticalSpacingMap[spacing]
    }
  );
}
DividerPattern.displayName = "DividerPattern";
var END_OF_SURVEY = "end-of-survey";
function generateRuleId() {
  return `rule-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}
function questionsToOptions(questions, endOfSurveyLabel) {
  const opts = questions.map((q) => ({
    value: q.id,
    label: q.label
  }));
  if (endOfSurveyLabel !== null) {
    opts.push({ value: END_OF_SURVEY, label: endOfSurveyLabel });
  }
  return opts;
}
function isRuleBroken(rule, questions) {
  const sourceExists = questions.some((q) => q.id === rule.sourceQuestionId);
  const targetExists = rule.targetQuestionId === END_OF_SURVEY || questions.some((q) => q.id === rule.targetQuestionId);
  return !sourceExists || !targetExists;
}
var RuleRow = ({
  rule,
  questions,
  readOnly,
  broken,
  onChange,
  onDelete
}) => {
  const { t } = useTranslate();
  const operatorOptions = useMemo(
    () => [
      { value: "equals", label: t("branchingLogic.operatorEquals") },
      { value: "not-equals", label: t("branchingLogic.operatorNotEquals") },
      { value: "contains", label: t("branchingLogic.operatorContains") },
      { value: "in", label: t("branchingLogic.operatorIn") }
    ],
    [t]
  );
  const sourceOptions = useMemo(() => questionsToOptions(questions, null), [questions]);
  const targetOptions = useMemo(
    () => questionsToOptions(questions, t("branchingLogic.endOfSurvey")),
    [questions, t]
  );
  const sourceQuestion = questions.find((q) => q.id === rule.sourceQuestionId);
  const valueOptions = useMemo(() => {
    if (!sourceQuestion?.optionValues) return [];
    return sourceQuestion.optionValues.map((v) => ({ value: v, label: v }));
  }, [sourceQuestion]);
  const handleSource = (v) => {
    onChange({ ...rule, sourceQuestionId: v });
  };
  const handleOperator = (v) => {
    const next = v;
    const nextValue = next === "in" && !Array.isArray(rule.value) ? rule.value ? [rule.value] : [] : next !== "in" && Array.isArray(rule.value) ? rule.value[0] ?? "" : rule.value;
    onChange({ ...rule, operator: next, value: nextValue });
  };
  const handleScalarValue = (e) => {
    onChange({ ...rule, value: e.target.value });
  };
  const handleAddChip = (v) => {
    const val = v;
    if (!val) return;
    const current = Array.isArray(rule.value) ? rule.value : [];
    if (current.includes(val)) return;
    onChange({ ...rule, value: [...current, val] });
  };
  const handleRemoveChip = (chip) => {
    const current = Array.isArray(rule.value) ? rule.value : [];
    onChange({ ...rule, value: current.filter((c) => c !== chip) });
  };
  const handleTarget = (v) => {
    onChange({ ...rule, targetQuestionId: v });
  };
  const isMulti = rule.operator === "in";
  const chips = Array.isArray(rule.value) ? rule.value : [];
  const scalarValue = Array.isArray(rule.value) ? "" : rule.value;
  return /* @__PURE__ */ jsxs(
    Card,
    {
      variant: "bordered",
      padding: "sm",
      className: cn(
        "flex flex-col gap-2",
        broken && "border-error"
      ),
      children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-center gap-2", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", className: "shrink-0", children: t("branchingLogic.if") }),
          /* @__PURE__ */ jsx(Box, { className: "min-w-[10rem] grow basis-40", children: /* @__PURE__ */ jsx(
            Select,
            {
              options: sourceOptions,
              value: rule.sourceQuestionId,
              placeholder: t("branchingLogic.selectQuestion"),
              onValueChange: handleSource,
              disabled: readOnly,
              error: broken ? t("branchingLogic.brokenReference") : void 0
            }
          ) }),
          /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem] basis-32", children: /* @__PURE__ */ jsx(
            Select,
            {
              options: operatorOptions,
              value: rule.operator,
              onValueChange: handleOperator,
              disabled: readOnly
            }
          ) }),
          isMulti ? /* @__PURE__ */ jsxs(Box, { className: "flex min-w-[10rem] grow basis-40 flex-wrap items-center gap-1", children: [
            chips.map((chip) => /* @__PURE__ */ jsx(
              FilterPill,
              {
                variant: "primary",
                size: "sm",
                label: chip,
                removable: !readOnly,
                onRemove: readOnly ? void 0 : () => handleRemoveChip(chip)
              },
              chip
            )),
            valueOptions.length > 0 ? /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem]", children: /* @__PURE__ */ jsx(
              Select,
              {
                options: valueOptions.filter((o) => !chips.includes(o.value)),
                value: "",
                placeholder: t("branchingLogic.addValue"),
                onValueChange: handleAddChip,
                disabled: readOnly
              }
            ) }) : /* @__PURE__ */ jsx(
              Input,
              {
                inputType: "text",
                placeholder: t("branchingLogic.typeValuePressEnter"),
                value: "",
                onKeyDown: (e) => {
                  if (e.key !== "Enter") return;
                  const target = e.target;
                  const v = target.value.trim();
                  if (!v || chips.includes(v)) return;
                  onChange({ ...rule, value: [...chips, v] });
                  target.value = "";
                },
                disabled: readOnly
              }
            )
          ] }) : /* @__PURE__ */ jsx(Box, { className: "min-w-[8rem] grow basis-32", children: valueOptions.length > 0 ? /* @__PURE__ */ jsx(
            Select,
            {
              options: valueOptions,
              value: scalarValue,
              placeholder: t("branchingLogic.selectValue"),
              onValueChange: (v) => onChange({ ...rule, value: v }),
              disabled: readOnly
            }
          ) : /* @__PURE__ */ jsx(
            Input,
            {
              inputType: "text",
              placeholder: t("branchingLogic.value"),
              value: scalarValue,
              onChange: handleScalarValue,
              disabled: readOnly
            }
          ) }),
          /* @__PURE__ */ jsxs(Typography, { variant: "label", weight: "semibold", className: "shrink-0 inline-flex items-center gap-1", children: [
            /* @__PURE__ */ jsx(ArrowRight, { className: "h-4 w-4" }),
            t("branchingLogic.goTo")
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "min-w-[10rem] grow basis-40", children: /* @__PURE__ */ jsx(
            Select,
            {
              options: targetOptions,
              value: rule.targetQuestionId,
              placeholder: t("branchingLogic.selectTarget"),
              onValueChange: handleTarget,
              disabled: readOnly,
              error: broken && rule.targetQuestionId !== END_OF_SURVEY ? t("branchingLogic.brokenReference") : void 0
            }
          ) }),
          !readOnly && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: Trash,
              action: "DELETE_RULE",
              actionPayload: { ruleId: rule.id },
              onClick: onDelete,
              "aria-label": t("branchingLogic.deleteRule")
            }
          )
        ] }),
        broken && /* @__PURE__ */ jsx(Badge, { variant: "error", size: "sm", label: t("branchingLogic.brokenReference") })
      ]
    }
  );
};
var NODE_WIDTH = 180;
var NODE_HEIGHT = 56;
var NODE_GAP_Y = 80;
var PADDING = 32;
var LogicGraph = ({ questions, rules, surface }) => {
  const contentSurface = useContentSurface(surface);
  const { t } = useTranslate();
  const endOfSurveyLabel = t("branchingLogic.endOfSurvey");
  const layout = useMemo(() => {
    const items = [
      ...questions.map((q) => ({ id: q.id, label: q.label, isEnd: false })),
      { id: END_OF_SURVEY, label: endOfSurveyLabel, isEnd: true }
    ];
    const positions = {};
    items.forEach((item, i) => {
      positions[item.id] = {
        x: PADDING,
        y: PADDING + i * (NODE_HEIGHT + NODE_GAP_Y)
      };
    });
    const width = NODE_WIDTH + PADDING * 2 + 220;
    const height = PADDING * 2 + items.length * (NODE_HEIGHT + NODE_GAP_Y);
    return { items, positions, width, height };
  }, [questions, endOfSurveyLabel]);
  return contentSurface.provide(
    /* @__PURE__ */ jsx(Box, { className: cn("overflow-auto p-2", contentSurface.className), children: /* @__PURE__ */ jsxs(
      "svg",
      {
        width: layout.width,
        height: layout.height,
        role: "img",
        "aria-label": t("branchingLogic.graphAriaLabel"),
        style: { display: "block" },
        children: [
          /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
            "marker",
            {
              id: "branching-arrowhead",
              viewBox: "0 0 10 10",
              refX: "8",
              refY: "5",
              markerWidth: "8",
              markerHeight: "8",
              orient: "auto",
              children: /* @__PURE__ */ jsx("path", { d: "M 0 0 L 10 5 L 0 10 z", fill: "var(--color-muted-foreground)" })
            }
          ) }),
          rules.map((rule, i) => {
            const from = layout.positions[rule.sourceQuestionId];
            const to = layout.positions[rule.targetQuestionId];
            if (!from || !to) return null;
            const startX = from.x + NODE_WIDTH;
            const startY = from.y + NODE_HEIGHT / 2;
            const endX = to.x + NODE_WIDTH;
            const endY = to.y + NODE_HEIGHT / 2;
            const offset = 40 + i % 4 * 30;
            const cx = Math.max(startX, endX) + offset;
            const path = `M ${startX} ${startY} C ${cx} ${startY}, ${cx} ${endY}, ${endX} ${endY}`;
            const labelText2 = rule.operator === "in" && Array.isArray(rule.value) ? `in [${rule.value.join(", ")}]` : `${rule.operator} ${Array.isArray(rule.value) ? rule.value.join(", ") : rule.value}`;
            const labelY = (startY + endY) / 2;
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  d: path,
                  fill: "none",
                  stroke: "var(--color-muted-foreground)",
                  strokeWidth: 1.5,
                  markerEnd: "url(#branching-arrowhead)"
                }
              ),
              /* @__PURE__ */ jsx(
                "rect",
                {
                  x: cx - 4,
                  y: labelY - 10,
                  width: Math.min(160, labelText2.length * 7 + 12),
                  height: 20,
                  rx: 4,
                  fill: "var(--color-card)",
                  stroke: "var(--color-border)"
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: cx + 4,
                  y: labelY + 4,
                  fontSize: "11",
                  fontFamily: "JetBrains Mono, monospace",
                  fill: "var(--color-foreground)",
                  children: labelText2.length > 22 ? `${labelText2.slice(0, 21)}\u2026` : labelText2
                }
              )
            ] }, rule.id);
          }),
          layout.items.map((item) => {
            const pos = layout.positions[item.id];
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "rect",
                {
                  x: pos.x,
                  y: pos.y,
                  width: NODE_WIDTH,
                  height: NODE_HEIGHT,
                  rx: 6,
                  fill: item.isEnd ? "var(--color-surface)" : "var(--color-card)",
                  stroke: item.isEnd ? "var(--color-error)" : "var(--color-border)",
                  strokeWidth: item.isEnd ? 2 : 1.5
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: pos.x + NODE_WIDTH / 2,
                  y: pos.y + NODE_HEIGHT / 2 + 4,
                  textAnchor: "middle",
                  fontSize: "13",
                  fontFamily: "Inter, sans-serif",
                  fill: "var(--color-foreground)",
                  fontWeight: 600,
                  children: item.label.length > 22 ? `${item.label.slice(0, 21)}\u2026` : item.label
                }
              )
            ] }, item.id);
          })
        ]
      }
    ) })
  );
};
var BranchingLogicBuilder = ({
  questions: questionsProp,
  rules: rulesProp,
  onRulesChange,
  rulesChangeEvent,
  readOnly = false,
  className,
  surface = "auto",
  ...rest
}) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const questions = Array.isArray(questionsProp) ? questionsProp : [];
  const rulesInitial = Array.isArray(rulesProp) ? rulesProp : [];
  const [rules, setRules] = useState([...rulesInitial]);
  const [view, setView] = useState("edit");
  useEffect(() => {
    setRules(Array.isArray(rulesProp) ? [...rulesProp] : []);
  }, [rulesProp]);
  const updateRules = useCallback(
    (next) => {
      setRules(next);
      onRulesChange?.(next);
      if (rulesChangeEvent) {
        eventBus.emit(`UI:${rulesChangeEvent}`, { rules: next });
      }
    },
    [onRulesChange, rulesChangeEvent, eventBus]
  );
  const handleAddRule = useCallback(() => {
    const firstQ = questions[0];
    if (!firstQ) return;
    const target = questions[1]?.id ?? END_OF_SURVEY;
    const next = {
      id: generateRuleId(),
      sourceQuestionId: firstQ.id,
      operator: "equals",
      value: firstQ.optionValues?.[0] ?? "",
      targetQuestionId: target
    };
    updateRules([...rules, next]);
  }, [questions, rules, updateRules]);
  const handleRuleChange = useCallback(
    (id, next) => {
      updateRules(rules.map((r) => r.id === id ? next : r));
    },
    [rules, updateRules]
  );
  const handleRuleDelete = useCallback(
    (id) => {
      updateRules(rules.filter((r) => r.id !== id));
    },
    [rules, updateRules]
  );
  const brokenCount = useMemo(
    () => rules.filter((r) => isRuleBroken(r, questions)).length,
    [rules, questions]
  );
  const noQuestions = questions.length === 0;
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex flex-col gap-3", className), children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(GitBranch, { className: "h-5 w-5 text-foreground" }),
        /* @__PURE__ */ jsx(Typography, { variant: "subheading", weight: "semibold", children: t("branchingLogic.title") }),
        /* @__PURE__ */ jsx(
          Badge,
          {
            variant: "neutral",
            size: "sm",
            label: rules.length === 1 ? t("branchingLogic.ruleCountOne", { count: rules.length }) : t("branchingLogic.ruleCountOther", { count: rules.length })
          }
        ),
        brokenCount > 0 && /* @__PURE__ */ jsx(
          Badge,
          {
            variant: "error",
            size: "sm",
            label: t("branchingLogic.brokenCount", { count: brokenCount })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1 rounded-container border border-border bg-card p-0.5", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: view === "edit" ? "primary" : "ghost",
            size: "sm",
            leftIcon: Pencil,
            action: "VIEW_EDIT",
            onClick: () => setView("edit"),
            children: t("branchingLogic.rules")
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: view === "graph" ? "primary" : "ghost",
            size: "sm",
            leftIcon: Eye,
            action: "VIEW_GRAPH",
            onClick: () => setView("graph"),
            children: t("branchingLogic.logicGraph")
          }
        )
      ] })
    ] }),
    view === "edit" ? /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2", children: [
      rules.length === 0 ? /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "lg", className: "text-center", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: noQuestions ? t("branchingLogic.emptyNoQuestions") : t("branchingLogic.emptyNoRules") }) }) : rules.map((rule) => /* @__PURE__ */ jsx(
        RuleRow,
        {
          rule,
          questions,
          readOnly,
          broken: isRuleBroken(rule, questions),
          onChange: (next) => handleRuleChange(rule.id, next),
          onDelete: () => handleRuleDelete(rule.id)
        },
        rule.id
      )),
      !readOnly && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "sm",
          leftIcon: Plus,
          action: "ADD_RULE",
          onClick: handleAddRule,
          disabled: noQuestions,
          children: t("branchingLogic.addRule")
        }
      ) })
    ] }) : /* @__PURE__ */ jsx(LogicGraph, { questions, rules, surface })
  ] });
};
BranchingLogicBuilder.displayName = "BranchingLogicBuilder";
var Breadcrumb = ({
  items,
  fromNavStack = false,
  itemEvent,
  separator = "chevron-right",
  maxItems,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const navStack = useNavStack();
  const sourceItems = fromNavStack ? navStack.entries.map((entry, i) => ({
    label: entry.label,
    path: entry.href,
    isCurrent: i === navStack.entries.length - 1,
    event: itemEvent
  })) : items ?? [];
  if (fromNavStack && sourceItems.length === 0) return null;
  const allCrumbs = sourceItems.map((item, index) => ({ kind: "item", item, index }));
  const crumbs = maxItems && sourceItems.length > maxItems ? [allCrumbs[0], { kind: "collapsed" }, ...allCrumbs.slice(-maxItems + 1)] : allCrumbs;
  const activate = (item, index) => {
    const href = item.path ?? item.href;
    if (item.event) {
      eventBus.emit(`UI:${item.event}`, { label: item.label, href, index });
    } else if (fromNavStack && href) {
      navStack.goTo(href);
    }
    item.onClick?.();
  };
  const separatorIcon = /* @__PURE__ */ jsx(Box, { as: "span", "aria-hidden": "true", "data-breadcrumb-separator": true, className: "inline-flex text-muted-foreground rtl:-scale-x-100", children: typeof separator === "string" ? /* @__PURE__ */ jsx(Icon, { name: separator, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: separator, size: "sm" }) });
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), as: "nav", "aria-label": rest["aria-label"] ?? t("aria.breadcrumb"), className: cn("min-w-0", className), children: /* @__PURE__ */ jsx(Box, { as: "ol", className: "flex flex-wrap items-center gap-x-2 gap-y-1 min-w-0", children: crumbs.map((crumb, position) => {
    const isLast = position === crumbs.length - 1;
    if (crumb.kind === "collapsed") {
      return /* @__PURE__ */ jsxs(Box, { as: "li", className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", "aria-hidden": "true", children: "\u2026" }),
        separatorIcon
      ] }, "collapsed");
    }
    const { item, index } = crumb;
    const href = item.href || item.path;
    const icon = item.icon ? typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm" }) : null;
    const label = /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", truncate: true, className: "max-w-[16rem]", children: item.label });
    const tone = isLast ? "text-foreground" : "text-muted-foreground hover:text-foreground";
    return /* @__PURE__ */ jsxs(Box, { as: "li", className: "flex items-center gap-2 min-w-0", children: [
      isLast ? /* @__PURE__ */ jsxs(Box, { as: "span", "aria-current": "page", className: cn("flex items-center gap-1.5 min-w-0", tone), children: [
        icon,
        label
      ] }) : href && !item.event && !fromNavStack ? /* @__PURE__ */ jsxs(Button, { variant: "link", href, className: cn("h-auto gap-1.5 min-w-0 no-underline", tone), children: [
        icon,
        label
      ] }) : /* @__PURE__ */ jsxs(Button, { variant: "link", onClick: () => activate(item, index), className: cn("h-auto gap-1.5 min-w-0 no-underline", tone), children: [
        icon,
        label
      ] }),
      !isLast && separatorIcon
    ] }, index);
  }) }) });
};
Breadcrumb.displayName = "Breadcrumb";
var log5 = createLogger("almadar:ui:button-group");
var lookStyles4 = {
  "right-aligned-buttons": "",
  "floating-bar": "fixed bottom-section left-1/2 -translate-x-1/2 shadow-elevation-toast bg-card p-card-sm rounded-container",
  "inline-row": "gap-2 inline-flex",
  "dropdown-menu": "[&>button:not(:first-child)]:hidden",
  "command-palette-trigger": "[&>button:not(:first-child)]:hidden"
};
function useSafeEventBus2() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var ButtonGroup = ({
  children,
  primary,
  secondary,
  variant = "default",
  orientation = "horizontal",
  className,
  // Filter-group pattern props (entity and filters are used for schema-driven filtering)
  entity: _entity,
  filters,
  look = "right-aligned-buttons",
  ...rest
}) => {
  const eventBus = useSafeEventBus2();
  const variantClasses2 = {
    default: "gap-0",
    segmented: "gap-0 [&>button]:rounded-none [&>button:first-child]:rounded-l-interactive [&>button:last-child]:rounded-r-interactive [&>button:not(:first-child)]:border-l-0",
    toggle: "gap-0 [&>button]:rounded-none [&>button:first-child]:rounded-l-interactive [&>button:last-child]:rounded-r-interactive [&>button:not(:first-child)]:border-l-0"
  };
  const orientationClasses = {
    horizontal: "flex-row",
    vertical: "flex-col [&>button:first-child]:rounded-t-interactive [&>button:last-child]:rounded-b-interactive [&>button:not(:first-child)]:border-t-0 [&>button:not(:first-child)]:border-l"
  };
  const handleActionClick = (action) => {
    if (action.event) {
      eventBus.emit("UI:DISPATCH", { event: action.event });
    }
    if (action.navigatesTo) {
      eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
    }
  };
  const renderFormActions = () => {
    const buttons = [];
    if (secondary) {
      secondary.forEach((action, index) => {
        buttons.push(
          /* @__PURE__ */ jsx(
            Button,
            {
              type: action.actionType === "submit" ? "submit" : "button",
              variant: action.variant || "ghost",
              onClick: () => handleActionClick(action),
              children: action.label
            },
            `secondary-${index}`
          )
        );
      });
    }
    if (primary) {
      const isSubmit = primary.actionType === "submit";
      buttons.push(
        /* @__PURE__ */ jsx(
          Button,
          {
            type: isSubmit ? "submit" : "button",
            variant: primary.variant || "primary",
            onClick: () => handleActionClick(primary),
            "data-testid": isSubmit ? "form-submit" : void 0,
            children: primary.label
          },
          "primary"
        )
      );
    }
    return buttons;
  };
  const renderFilters = () => {
    if (!filters || filters.length === 0) return null;
    return filters.map((filter, index) => /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        onClick: () => {
          log5.debug("Filter clicked", { field: filter.field });
        },
        children: filter.label
      },
      `filter-${filter.field}-${index}`
    ));
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex gap-2",
        variantClasses2[variant],
        orientationClasses[orientation],
        lookStyles4[look],
        className
      ),
      role: "group",
      children: children || renderFilters() || renderFormActions()
    }
  );
};
ButtonGroup.displayName = "ButtonGroup";
function dayWindowForViewport(width) {
  if (width <= 640) return 1;
  if (width <= 1024) return 3;
  return 7;
}
function useDayWindow(override) {
  const [w, setW] = useState(() => {
    if (override !== "auto") return override;
    if (typeof window === "undefined") return 7;
    return dayWindowForViewport(window.innerWidth);
  });
  useEffect(() => {
    if (override !== "auto") {
      setW(override);
      return void 0;
    }
    if (typeof window === "undefined") return void 0;
    const onResize = () => setW(dayWindowForViewport(window.innerWidth));
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [override]);
  return w;
}
var SHORT_DATE = { month: "short", day: "numeric" };
function formatDateRange(start, end, locale) {
  const startStr = start.toLocaleDateString(locale, SHORT_DATE);
  const endStr = end.toLocaleDateString(locale, SHORT_DATE);
  return start.toDateString() === end.toDateString() ? startStr : `${startStr} \u2013 ${endStr}`;
}
function getStartOfWeek(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  d.setDate(diff);
  d.setHours(0, 0, 0, 0);
  return d;
}
function getWeekDays(start) {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(start);
    day.setDate(start.getDate() + i);
    days.push(day);
  }
  return days;
}
var DEFAULT_FIRST_HOUR = 9;
var DEFAULT_LAST_HOUR = 17;
var slotLabel = (hour) => `${hour.toString().padStart(2, "0")}:00`;
function eventStartDate(event, startField) {
  const raw = getNestedValue(event, startField);
  return new Date(raw ?? "");
}
function eventEndDate(event, endField) {
  const raw = getNestedValue(event, endField);
  if (raw === void 0 || raw === null || raw === "") return null;
  const end = new Date(raw);
  return Number.isNaN(end.getTime()) ? null : end;
}
function eventContinuesInSlot(event, day, slotTime, startField, endField) {
  const eventStart = eventStartDate(event, startField);
  const eventEnd = eventEndDate(event, endField);
  if (eventEnd === null || Number.isNaN(eventStart.getTime())) return false;
  const [slotHour] = slotTime.split(":").map(Number);
  const slotStart = new Date(day);
  slotStart.setHours(slotHour, 0, 0, 0);
  return slotStart.getTime() > eventStart.getTime() && slotStart.getTime() < eventEnd.getTime();
}
function generateDefaultTimeSlots(events, startField, endField) {
  let first = DEFAULT_FIRST_HOUR;
  let last = DEFAULT_LAST_HOUR;
  for (const ev of events) {
    const start = eventStartDate(ev, startField);
    if (Number.isNaN(start.getTime())) continue;
    const hour = start.getHours();
    if (hour < first) first = hour;
    if (hour > last) last = hour;
    const end = eventEndDate(ev, endField);
    if (end && end.toDateString() === start.toDateString()) {
      const endHour = end.getMinutes() === 0 && end.getSeconds() === 0 ? end.getHours() - 1 : end.getHours();
      if (endHour > last) last = endHour;
    }
  }
  const slots = [];
  for (let hour = first; hour <= last; hour++) {
    slots.push(slotLabel(hour));
  }
  return slots;
}
function eventInSlot(event, day, slotTime, startField) {
  const eventStart = eventStartDate(event, startField);
  if (Number.isNaN(eventStart.getTime())) return false;
  const [slotHour] = slotTime.split(":").map(Number);
  return eventStart.toDateString() === day.toDateString() && eventStart.getHours() === slotHour;
}
function CalendarGrid({
  weekStart,
  timeSlots,
  events = [],
  onSlotClick,
  onDayClick,
  onEventClick,
  className,
  surface = "auto",
  longPressEvent,
  longPressPayload,
  swipeLeftEvent,
  swipeRightEvent,
  dayWindow = "auto",
  titleField = "title",
  startField = "startTime",
  endField = "endTime",
  colorField = "color",
  children,
  renderItem,
  ...rest
}) {
  const evs = Array.isArray(events) ? events : events ? [events] : [];
  const eventBus = useEventBus();
  const contentSurface = useContentSurface(surface);
  const { t, locale } = useTranslate();
  const longPressTimer = useRef(null);
  const longPressFired = useRef(false);
  const resolvedWeekStart = useMemo(
    () => weekStart ? getStartOfWeek(weekStart) : getStartOfWeek(/* @__PURE__ */ new Date()),
    [weekStart]
  );
  const weekDays = useMemo(
    () => getWeekDays(resolvedWeekStart),
    [resolvedWeekStart]
  );
  const resolvedTimeSlots = useMemo(
    () => timeSlots ?? generateDefaultTimeSlots(evs, startField, endField),
    [timeSlots, evs, startField, endField]
  );
  const visibleCount = useDayWindow(dayWindow);
  const [dayOffset, setDayOffset] = useState(0);
  useEffect(() => {
    if (dayOffset + visibleCount > 7) {
      setDayOffset(Math.max(0, 7 - visibleCount));
    }
  }, [visibleCount, dayOffset]);
  const visibleDays = useMemo(
    () => weekDays.slice(dayOffset, dayOffset + visibleCount),
    [weekDays, dayOffset, visibleCount]
  );
  const canPrev = dayOffset > 0;
  const canNext = dayOffset + visibleCount < 7;
  const stepPrev = useCallback(() => {
    setDayOffset((d) => Math.max(0, d - visibleCount));
  }, [visibleCount]);
  const stepNext = useCallback(() => {
    setDayOffset((d) => Math.min(7 - visibleCount, d + visibleCount));
  }, [visibleCount]);
  const gridColsClass = visibleCount === 1 ? "grid-cols-2" : visibleCount === 3 ? "grid-cols-4" : "grid-cols-8";
  const handleSlotClick = useCallback(
    (day, time) => {
      if (longPressFired.current) {
        longPressFired.current = false;
        return;
      }
      onSlotClick?.(day, time);
    },
    [onSlotClick]
  );
  const handleEventClick = useCallback(
    (event, e) => {
      e.stopPropagation();
      onEventClick?.(event);
    },
    [onEventClick]
  );
  const eventPressProps = (event) => onEventClick ? pressableProps((e) => handleEventClick(event, e)) : { onClick: (e) => e.stopPropagation() };
  const eventsForDayCount = useCallback(
    (day) => evs.filter(
      (ev) => eventStartDate(ev, startField).toDateString() === day.toDateString()
    ).length,
    [events, startField]
  );
  const swipeCallbacks = useMemo(() => ({
    onSwipeLeft: swipeLeftEvent ? () => eventBus.emit(`UI:${swipeLeftEvent}`, {}) : void 0,
    onSwipeRight: swipeRightEvent ? () => eventBus.emit(`UI:${swipeRightEvent}`, {}) : void 0
  }), [swipeLeftEvent, swipeRightEvent, eventBus]);
  const swipe = useSwipeGesture(swipeCallbacks);
  const clearLongPress = useCallback(() => {
    if (longPressTimer.current) {
      clearTimeout(longPressTimer.current);
      longPressTimer.current = null;
    }
  }, []);
  const startLongPress = useCallback((day, time) => {
    if (!longPressEvent) return;
    longPressFired.current = false;
    longPressTimer.current = setTimeout(() => {
      longPressTimer.current = null;
      longPressFired.current = true;
      eventBus.emit(`UI:${longPressEvent}`, { date: day.toISOString(), time, ...longPressPayload });
    }, 500);
  }, [longPressEvent, longPressPayload, eventBus]);
  const renderChip = children ?? renderItem;
  const renderEvent = (event) => {
    const color = getNestedValue(event, colorField);
    const label = String(getNestedValue(event, titleField) ?? "");
    const eventIndex = evs.indexOf(event);
    return /* @__PURE__ */ jsx(
      Box,
      {
        rounded: "md",
        padding: "xs",
        border: true,
        className: cn(
          "cursor-pointer hover:shadow-elevation-card transition-shadow text-xs truncate",
          color ? color : "bg-primary/10 border-primary/30 text-foreground"
        ),
        ...eventPressProps(event),
        children: renderChip ? renderChip(event, eventIndex) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate font-medium", children: label })
      },
      event.id
    );
  };
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(
      Box,
      {
        ...domPassthrough(rest),
        className: cn(contentSurface.className && cn(contentSurface.className, "p-card-sm"), className),
        ...swipeLeftEvent || swipeRightEvent ? {
          onPointerDown: swipe.onPointerDown,
          onPointerMove: swipe.onPointerMove,
          onPointerUp: swipe.onPointerUp,
          onPointerCancel: swipe.onPointerCancel
        } : {},
        children: [
          visibleCount < 7 && /* @__PURE__ */ jsxs(HStack, { align: "center", justify: "between", className: "mb-2 px-2", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                icon: "chevron-left",
                onClick: stepPrev,
                "aria-disabled": !canPrev || void 0,
                "aria-label": t("aria.previousDays"),
                children: t("nav.previous")
              }
            ),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: formatDateRange(visibleDays[0], visibleDays[visibleDays.length - 1], locale) }),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                iconRight: "chevron-right",
                onClick: stepNext,
                "aria-disabled": !canNext || void 0,
                "aria-label": t("aria.nextDays"),
                children: t("nav.next")
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsxs(Box, { className: cn("grid border-b border-border", gridColsClass), children: [
              /* @__PURE__ */ jsx(Box, { className: "p-2" }),
              visibleDays.map((day) => {
                const isToday = day.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
                const count = eventsForDayCount(day);
                return /* @__PURE__ */ jsxs(
                  Box,
                  {
                    className: "border-l border-border",
                    children: [
                      /* @__PURE__ */ jsx(
                        DayCell,
                        {
                          date: day,
                          isToday,
                          onClick: onDayClick
                        }
                      ),
                      count > 0 && /* @__PURE__ */ jsx(Box, { className: "text-center pb-1", children: /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: count }) })
                    ]
                  },
                  day.toISOString()
                );
              })
            ] }),
            /* @__PURE__ */ jsx(Box, { className: "max-h-[500px] overflow-y-auto", children: resolvedTimeSlots.map((time) => /* @__PURE__ */ jsxs(
              Box,
              {
                className: cn("grid border-b border-border", gridColsClass),
                children: [
                  /* @__PURE__ */ jsx(Box, { className: "p-2 text-right pr-3", children: /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "small",
                      className: "text-muted-foreground",
                      children: time
                    }
                  ) }),
                  visibleDays.map((day) => {
                    const slotEvents = evs.filter(
                      (ev) => eventInSlot(ev, day, time, startField)
                    );
                    const continuingEvents = evs.filter(
                      (ev) => eventContinuesInSlot(ev, day, time, startField, endField)
                    );
                    const isToday = day.toDateString() === (/* @__PURE__ */ new Date()).toDateString();
                    return /* @__PURE__ */ jsx(
                      TimeSlotCell,
                      {
                        time,
                        "data-testid": `time-slot-${time}`,
                        isOccupied: slotEvents.length > 0 || continuingEvents.length > 0,
                        onClick: () => handleSlotClick(day, time),
                        className: cn(
                          "border-l border-border",
                          isToday && "bg-primary/10"
                        ),
                        ...longPressEvent ? {
                          onPointerDown: () => startLongPress(day, time),
                          onPointerUp: clearLongPress,
                          onPointerCancel: clearLongPress,
                          onPointerLeave: clearLongPress
                        } : {},
                        children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                          slotEvents.map(renderEvent),
                          continuingEvents.map((event) => {
                            const color = getNestedValue(event, colorField);
                            return /* @__PURE__ */ jsx(
                              Box,
                              {
                                rounded: "sm",
                                border: true,
                                className: cn(
                                  "cursor-pointer h-2",
                                  color ? cn(color, "opacity-50") : "bg-primary/10 border-primary/20"
                                ),
                                ...eventPressProps(event),
                                "aria-label": onEventClick ? String(getNestedValue(event, titleField) ?? "") : void 0
                              },
                              `${event.id}-cont`
                            );
                          })
                        ] })
                      },
                      `${day.toISOString()}-${time}`
                    );
                  })
                ]
              },
              time
            )) })
          ] })
        ]
      }
    )
  );
}
CalendarGrid.displayName = "CalendarGrid";
function useSafeEventBus3() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var Carousel = ({
  items,
  renderItem,
  children,
  autoPlay = false,
  autoPlayInterval = 5e3,
  showDots = true,
  showArrows = true,
  loop = false,
  slideChangeEvent,
  slideChangePayload,
  className,
  ...rest
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);
  const autoPlayRef = useRef(null);
  const eventBus = useSafeEventBus3();
  const { t } = useTranslate();
  const safeItems = items ?? [];
  const totalSlides = safeItems.length;
  const emitSlideChange = useCallback(
    (newIndex) => {
      if (slideChangeEvent) {
        eventBus.emit(`UI:${slideChangeEvent}`, {
          index: newIndex,
          ...slideChangePayload
        });
      }
    },
    [slideChangeEvent, slideChangePayload, eventBus]
  );
  const scrollToSlide = useCallback(
    (index) => {
      const container = scrollRef.current;
      if (!container) return;
      const slideWidth = container.offsetWidth;
      container.scrollTo({
        left: slideWidth * index,
        behavior: "smooth"
      });
    },
    []
  );
  const goToSlide = useCallback(
    (index) => {
      let targetIndex = index;
      if (loop) {
        if (targetIndex < 0) targetIndex = totalSlides - 1;
        if (targetIndex >= totalSlides) targetIndex = 0;
      } else {
        targetIndex = Math.max(0, Math.min(totalSlides - 1, targetIndex));
      }
      setActiveIndex(targetIndex);
      scrollToSlide(targetIndex);
      emitSlideChange(targetIndex);
    },
    [loop, totalSlides, scrollToSlide, emitSlideChange]
  );
  const goNext = useCallback(() => {
    goToSlide(activeIndex + 1);
  }, [goToSlide, activeIndex]);
  const goPrev = useCallback(() => {
    goToSlide(activeIndex - 1);
  }, [goToSlide, activeIndex]);
  const swipeHandlers = useSwipeGesture(
    {
      onSwipeLeft: goNext,
      onSwipeRight: goPrev
    },
    { threshold: 40 }
  );
  useEffect(() => {
    if (!autoPlay || totalSlides <= 1) return;
    autoPlayRef.current = setInterval(() => {
      setActiveIndex((prev) => {
        const next = loop ? (prev + 1) % totalSlides : Math.min(prev + 1, totalSlides - 1);
        setTimeout(() => {
          scrollToSlide(next);
          emitSlideChange(next);
        }, 0);
        return next;
      });
    }, autoPlayInterval);
    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
        autoPlayRef.current = null;
      }
    };
  }, [autoPlay, autoPlayInterval, loop, totalSlides, scrollToSlide, emitSlideChange]);
  const handleScroll = useCallback(() => {
    const container = scrollRef.current;
    if (!container) return;
    const slideWidth = container.offsetWidth;
    if (slideWidth === 0) return;
    const newIndex = Math.round(container.scrollLeft / slideWidth);
    setActiveIndex((prev) => {
      if (prev !== newIndex && newIndex >= 0 && newIndex < totalSlides) {
        return newIndex;
      }
      return prev;
    });
  }, [totalSlides]);
  const hasPrev = loop || activeIndex > 0;
  const hasNext = loop || activeIndex < totalSlides - 1;
  if (totalSlides === 0) return null;
  return /* @__PURE__ */ jsxs(Box, { position: "relative", overflow: "hidden", ...domPassthrough(rest), className: cn("w-full", className), children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: scrollRef,
        display: "flex",
        overflow: "auto",
        className: cn(
          "w-full",
          "scroll-smooth",
          "scrollbar-none",
          "[scroll-snap-type:x_mandatory]",
          "[&::-webkit-scrollbar]:hidden",
          "[-ms-overflow-style:none]"
        ),
        style: {
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch"
        },
        onScroll: handleScroll,
        onPointerDown: swipeHandlers.onPointerDown,
        onPointerMove: swipeHandlers.onPointerMove,
        onPointerUp: swipeHandlers.onPointerUp,
        onPointerCancel: swipeHandlers.onPointerCancel,
        children: safeItems.map((item, index) => /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-shrink-0 w-full",
              "[scroll-snap-align:start]"
            ),
            style: {
              scrollSnapAlign: "start"
            },
            children: (renderItem ?? children)?.(item, index)
          },
          index
        ))
      }
    ),
    showArrows && hasPrev && totalSlides > 1 && /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        className: "left-2 top-1/2 -translate-y-1/2 z-10",
        children: /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: goPrev,
            "aria-label": t("aria.previousSlide"),
            className: cn(
              "rounded-full",
              "bg-surface/80",
              "backdrop-blur-sm",
              "shadow-elevation-interactive",
              "hover:bg-surface"
            ),
            children: /* @__PURE__ */ jsx(ChevronLeft, { className: "w-5 h-5" })
          }
        )
      }
    ),
    showArrows && hasNext && totalSlides > 1 && /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        className: "right-2 top-1/2 -translate-y-1/2 z-10",
        children: /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: goNext,
            "aria-label": t("aria.nextSlide"),
            className: cn(
              "rounded-full",
              "bg-surface/80",
              "backdrop-blur-sm",
              "shadow-elevation-interactive",
              "hover:bg-surface"
            ),
            children: /* @__PURE__ */ jsx(ChevronRight, { className: "w-5 h-5" })
          }
        )
      }
    ),
    showDots && totalSlides > 1 && /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        className: "bottom-3 left-0 right-0 z-10",
        children: /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", justify: "center", role: "tablist", "aria-label": t("aria.carouselSlides"), children: safeItems.map((_, index) => {
          const isActive = index === activeIndex;
          return /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "rounded-full cursor-pointer transition-all duration-fast"
              ),
              style: {
                width: isActive ? 10 : 8,
                height: isActive ? 10 : 8,
                backgroundColor: isActive ? "var(--color-primary)" : "var(--color-muted, #d4d4d8)",
                opacity: isActive ? 1 : 0.6
              },
              ...pressableProps(() => goToSlide(index)),
              role: "tab",
              "aria-selected": isActive,
              tabIndex: isActive ? 0 : -1,
              "aria-label": t("carousel.goToSlide", { number: index + 1 })
            },
            index
          );
        }) })
      }
    )
  ] });
};
Carousel.displayName = "Carousel";
var TYPE_STYLE = {
  added: { icon: "plus-circle", badge: "success", text: "text-success" },
  modified: { icon: "edit-3", badge: "warning", text: "text-warning" },
  removed: { icon: "minus-circle", badge: "error", text: "text-error" }
};
function isChangeListItem(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value) && "title" in value && typeof value.title === "string" && "type" in value && (value.type === "added" || value.type === "modified" || value.type === "removed");
}
function toItems(value) {
  if (!Array.isArray(value)) return [];
  const out = [];
  for (const item of value) if (isChangeListItem(item)) out.push(item);
  return out;
}
var ChangeList = ({ changes, inspectEvent, className, ...rest }) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const items = toItems(changes);
  if (items.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("py-6", className), "data-testid": "change-list-empty", children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", align: "center", children: t("changeList.empty") }) });
  }
  return /* @__PURE__ */ jsx(VStack, { ...domPassthrough(rest), gap: "sm", className, children: items.map((change, idx) => {
    const style = TYPE_STYLE[change.type];
    return /* @__PURE__ */ jsx(Card, { "data-testid": "change-list-item", "data-change-type": change.type, children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "p-3", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "min-w-0", children: [
        /* @__PURE__ */ jsx(Icon, { name: style.icon, size: "sm", className: style.text }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", className: "truncate", children: change.title }),
        /* @__PURE__ */ jsx(Badge, { variant: style.badge, size: "sm", children: t(`changeList.${change.type}`) })
      ] }),
      change.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: change.description }),
      change.type === "modified" && (change.before || change.after) && /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "stretch", children: [
        change.before && /* @__PURE__ */ jsxs(Box, { className: "flex-1 rounded-container border border-error/20 bg-error/5 p-2", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "semibold", children: t("changeList.before") }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "block font-mono whitespace-pre-wrap", children: change.before })
        ] }),
        change.after && /* @__PURE__ */ jsxs(Box, { className: "flex-1 rounded-container border border-success/20 bg-success/5 p-2", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "semibold", children: t("changeList.after") }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "block font-mono whitespace-pre-wrap", children: change.after })
        ] })
      ] }),
      inspectEvent && /* @__PURE__ */ jsx(Box, { children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          icon: "external-link",
          onClick: () => eventBus.emit(`UI:${inspectEvent}`, { title: change.title, type: change.type }),
          children: t("changeList.inspect")
        }
      ) })
    ] }) }, `${change.title}-${idx}`);
  }) });
};
ChangeList.displayName = "ChangeList";
var ItemMoveScopeContext = createContext(null);
var ItemMoveScopeProvider = ItemMoveScopeContext.Provider;
function useNewItemMoveScope() {
  const id = useId();
  const last = useRef(/* @__PURE__ */ new Map()).current;
  const flights = useRef(/* @__PURE__ */ new Map()).current;
  const heights = useRef(/* @__PURE__ */ new Map()).current;
  const resizes = useRef(/* @__PURE__ */ new Map()).current;
  return { id, last, flights, heights, resizes };
}
function inFlight(flight) {
  if (flight === void 0 || flight.glide.playState !== "running") return void 0;
  const progress = Number(flight.glide.effect?.getComputedTiming().progress ?? 1);
  if (!(progress < 1)) return void 0;
  return { x: flight.to.x + flight.offset.x * (1 - progress), y: flight.to.y + flight.offset.y * (1 - progress) };
}
var near = (a, b) => Math.abs(a.x - b.x) < 0.5 && Math.abs(a.y - b.y) < 0.5;
function easeHeight(scope, id, el, timing, scale) {
  const running = scope.resizes.get(id);
  const live = running !== void 0 && running.glide.playState === "running" ? running : void 0;
  const shown = el.getBoundingClientRect().height / scale;
  const elapsed = live?.glide.currentTime ?? null;
  live?.glide.cancel();
  scope.resizes.delete(id);
  const height = el.getBoundingClientRect().height / scale;
  const resume = live !== void 0 && Math.abs(live.to - height) < 1;
  const from = resume ? live.from : live !== void 0 ? shown : scope.heights.get(id);
  scope.heights.set(id, height);
  if (from === void 0 || Math.abs(from - height) < 1) return;
  const glide = el.animate([{ height: `${from}px`, overflow: "clip" }, { height: `${height}px`, overflow: "clip" }], timing);
  if (glide === void 0) return;
  if (resume && elapsed !== null) glide.currentTime = elapsed;
  scope.resizes.set(id, { glide, from, to: height });
}
function glideMoved(scope) {
  const container = document.querySelector(`[data-item-move-root="${scope.id}"]`);
  if (container === null) return;
  const rows2 = container.querySelectorAll(`[data-item-move="${scope.id}"][data-item-key]`);
  const timing = motionTiming("--duration-slow", "--easing-emphasized", container);
  const origin = container.getBoundingClientRect();
  const scale = layoutScale(container);
  for (const el of rows2) {
    const id = el.getAttribute("data-item-key");
    if (id === null) continue;
    if (timing !== void 0) easeHeight(scope, id, el, timing, scale);
    const flight = scope.flights.get(id);
    const shown = inFlight(flight);
    const box = el.getBoundingClientRect();
    const onEl = shown !== void 0 && flight !== void 0 && el.getAnimations?.().includes(flight.glide) === true;
    const now = onEl && flight !== void 0 ? { x: (box.left - origin.left) / scale - (shown.x - flight.to.x), y: (box.top - origin.top) / scale - (shown.y - flight.to.y) } : { x: (box.left - origin.left) / scale, y: (box.top - origin.top) / scale };
    if (shown !== void 0 && flight !== void 0 && near(now, flight.to)) {
      scope.last.set(id, now);
      continue;
    }
    const from = shown ?? scope.last.get(id);
    scope.last.set(id, now);
    flight?.glide.cancel();
    scope.flights.delete(id);
    if (timing === void 0 || from === void 0 || near(from, now)) continue;
    for (const entrance of el.getAnimations?.() ?? []) entrance.cancel();
    const offset = { x: from.x - now.x, y: from.y - now.y };
    const glide = el.animate([{ transform: `translate(${offset.x}px, ${offset.y}px)` }, { transform: "none" }], timing);
    if (glide !== void 0) scope.flights.set(id, { glide, to: now, offset });
  }
}
function useItemMoves(enabled) {
  const parent = useContext(ItemMoveScopeContext);
  const own = useNewItemMoveScope();
  const scope = parent ?? own;
  useLayoutEffect(() => {
    if (enabled) glideMoved(scope);
  });
  return { row: enabled ? scope.id : void 0, root: enabled && parent === null ? own.id : void 0 };
}
function pointName(label, seriesName, value) {
  return seriesName === "default" ? `${label}: ${value}` : `${label}, ${seriesName}: ${value}`;
}
var FOCUS_SVG = "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2";
var CHART_COLORS = [
  "var(--color-primary)",
  "var(--color-success)",
  "var(--color-warning)",
  "var(--color-error)",
  "var(--color-info)",
  "var(--color-accent)"
];
var seriesColor = (series, idx) => series.color ?? CHART_COLORS[idx % CHART_COLORS.length];
var barColor = (series, sIdx) => seriesColor(series, sIdx);
var dayFormatter = (locale) => new Intl.DateTimeFormat(locale, { month: "short", day: "numeric", timeZone: "UTC" });
var monthFormatter = (locale) => new Intl.DateTimeFormat(locale, { month: "short", year: "numeric", timeZone: "UTC" });
var formatTimeLabel = (raw, period, i18n) => {
  const { t, locale } = i18n;
  const parsed = new Date(period !== void 0 && /^-?\d+$/.test(raw) ? Number(raw) : raw);
  if (Number.isNaN(parsed.getTime())) return raw;
  switch (period) {
    case "day":
      return dayFormatter(locale).format(parsed);
    case "week":
      return t("chart.weekOf", { date: dayFormatter(locale).format(parsed) });
    case "quarter":
      return t("chart.quarterOf", {
        quarter: new Intl.NumberFormat(locale).format(Math.floor(parsed.getUTCMonth() / 3) + 1),
        year: new Intl.NumberFormat(locale, { useGrouping: false }).format(parsed.getUTCFullYear())
      });
    case "year":
      return new Intl.NumberFormat(locale, { useGrouping: false }).format(parsed.getUTCFullYear());
    default:
      return monthFormatter(locale).format(parsed);
  }
};
var BarChart = ({ series, height, showValues, stack, timeAxis, period, histogram = false, horizontal = false, onPointClick }) => {
  const i18n = useTranslate();
  const categories = useMemo(() => {
    const set = [];
    const seen = /* @__PURE__ */ new Set();
    for (const s of series) {
      for (const p of s.data) {
        if (!seen.has(p.label)) {
          seen.add(p.label);
          set.push(p.label);
        }
      }
    }
    return set;
  }, [series]);
  const valueAt = useCallback(
    (s, label) => {
      const p = s.data.find((d) => d.label === label);
      return p ? p.value : 0;
    },
    []
  );
  const columnTotals = useMemo(() => {
    if (stack === "none") return null;
    return categories.map(
      (label) => series.reduce((sum, s) => sum + valueAt(s, label), 0)
    );
  }, [categories, series, stack, valueAt]);
  const maxValue = useMemo(() => {
    if (stack === "normalize") return 100;
    if (stack === "stack" && columnTotals) {
      return Math.max(...columnTotals, 1);
    }
    let m = 1;
    for (const s of series) {
      for (const p of s.data) if (p.value > m) m = p.value;
    }
    return m;
  }, [series, stack, columnTotals]);
  const moves = useItemMoves(true);
  if (horizontal) {
    return /* @__PURE__ */ jsx(VStack, { gap: "xs", align: "stretch", className: "w-full", style: { minHeight: height }, "data-item-move-root": moves.root, children: categories.map((label, catIdx) => {
      const displayLabel = timeAxis ? formatTimeLabel(label, period, i18n) : label;
      const total = columnTotals?.[catIdx] ?? 1;
      return /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "w-full", "data-item-key": label, "data-item-move": moves.row, children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            color: "secondary",
            className: "truncate text-right",
            style: { width: 80, flexShrink: 0 },
            children: displayLabel
          }
        ),
        /* @__PURE__ */ jsx(
          HStack,
          {
            gap: stack === "none" ? "xs" : "none",
            align: "center",
            className: "flex-1 min-w-0",
            style: { height: 24 },
            children: series.map((s, sIdx) => {
              const value = valueAt(s, label);
              const ratio = stack === "normalize" ? total === 0 ? 0 : value / total * 100 : value / maxValue * 100;
              const color = barColor(s, sIdx);
              return /* @__PURE__ */ jsx(
                Box,
                {
                  className: "h-full rounded-r-sm transition-all duration-slow ease-standard min-w-[2px] cursor-pointer hover:opacity-80",
                  style: {
                    width: `${ratio}%`,
                    backgroundColor: color
                  },
                  ...pressableProps(
                    onPointClick ? () => onPointClick({ label, value, color }, s.name) : void 0
                  ),
                  ...onPointClick ? { "aria-label": pointName(label, s.name, value) } : void 0,
                  title: pointName(label, s.name, value)
                },
                s.name
              );
            })
          }
        ),
        showValues && series.length === 1 && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            color: "secondary",
            className: "tabular-nums",
            style: { width: 40, flexShrink: 0 },
            children: valueAt(series[0], label)
          }
        )
      ] }, label);
    }) });
  }
  return /* @__PURE__ */ jsx(
    HStack,
    {
      gap: histogram ? "none" : "xs",
      align: "end",
      className: "w-full",
      style: { height },
      "data-item-move-root": moves.root,
      children: categories.map((label, catIdx) => {
        const displayLabel = timeAxis ? formatTimeLabel(label, period, i18n) : label;
        if (stack === "none") {
          return /* @__PURE__ */ jsxs(
            VStack,
            {
              gap: "xs",
              align: "center",
              flex: true,
              className: "min-w-0",
              style: { height: "100%" },
              "data-item-key": label,
              "data-item-move": moves.row,
              children: [
                /* @__PURE__ */ jsx(HStack, { gap: histogram ? "none" : "xs", align: "end", justify: histogram ? void 0 : "center", className: "w-full flex-1 min-h-0", children: series.map((s, sIdx) => {
                  const value = valueAt(s, label);
                  const barHeight = value / maxValue * 100;
                  const color = barColor(s, sIdx);
                  return /* @__PURE__ */ jsx(
                    Box,
                    {
                      className: cn(
                        "rounded-t-sm transition-all duration-slow ease-standard min-h-[4px] cursor-pointer hover:opacity-80",
                        histogram ? "flex-1 mx-0" : "flex-1"
                      ),
                      style: {
                        height: `${barHeight}%`,
                        // Cap width so a lone category doesn't paint the whole plot as one solid block; narrow columns are unaffected (flex-1 binds first).
                        ...!histogram && { maxWidth: 72 },
                        backgroundColor: color
                      },
                      ...pressableProps(
                        onPointClick ? () => onPointClick({ label, value, color }, s.name) : void 0
                      ),
                      ...onPointClick ? { "aria-label": pointName(label, s.name, value) } : void 0,
                      title: pointName(label, s.name, value)
                    },
                    s.name
                  );
                }) }),
                showValues && series.length === 1 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "tabular-nums", children: valueAt(series[0], label) }),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    color: "secondary",
                    className: "truncate w-full text-center",
                    children: displayLabel
                  }
                )
              ]
            },
            label
          );
        }
        const total = columnTotals?.[catIdx] ?? 1;
        return /* @__PURE__ */ jsxs(
          VStack,
          {
            gap: "xs",
            align: "center",
            flex: true,
            className: "min-w-0",
            style: { height: "100%" },
            "data-item-key": label,
            "data-item-move": moves.row,
            children: [
              /* @__PURE__ */ jsx(VStack, { gap: "none", className: "w-full flex-1 min-h-0", justify: "end", children: series.map((s, sIdx) => {
                const value = valueAt(s, label);
                const ratio = stack === "normalize" ? total === 0 ? 0 : value / total * 100 : value / maxValue * 100;
                const color = barColor(s, sIdx);
                return /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: "w-full transition-all duration-slow ease-standard cursor-pointer hover:opacity-80",
                    style: {
                      height: `${ratio}%`,
                      backgroundColor: color
                    },
                    ...pressableProps(
                      onPointClick ? () => onPointClick({ label, value, color }, s.name) : void 0
                    ),
                    ...onPointClick ? { "aria-label": pointName(label, s.name, value) } : void 0,
                    title: pointName(label, s.name, value)
                  },
                  s.name
                );
              }) }),
              /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  color: "secondary",
                  className: "truncate w-full text-center",
                  children: displayLabel
                }
              )
            ]
          },
          label
        );
      })
    }
  );
};
var PieChart = ({ data, height, showValues, donut = false, onPointClick }) => {
  const { locale } = useTranslate();
  const total = data.reduce((sum, d) => sum + d.value, 0);
  const size2 = Math.min(height, 200);
  const radius = size2 / 2 - 8;
  const innerRadius = donut ? radius * 0.6 : 0;
  const center = size2 / 2;
  const segments = useMemo(() => {
    if (!Number.isFinite(total) || total <= 0) return [];
    let currentAngle = -Math.PI / 2;
    return data.map((point, idx) => {
      const angle = point.value / total * 2 * Math.PI;
      const startAngle = currentAngle;
      const endAngle = currentAngle + angle;
      currentAngle = endAngle;
      const largeArc = angle > Math.PI ? 1 : 0;
      const x1 = center + radius * Math.cos(startAngle);
      const y1 = center + radius * Math.sin(startAngle);
      const x2 = center + radius * Math.cos(endAngle);
      const y2 = center + radius * Math.sin(endAngle);
      const fullCircle = angle >= 2 * Math.PI - 1e-9;
      const midAngle = startAngle + angle / 2;
      const xm = center + radius * Math.cos(midAngle);
      const ym = center + radius * Math.sin(midAngle);
      let d;
      if (innerRadius > 0) {
        const ix1 = center + innerRadius * Math.cos(startAngle);
        const iy1 = center + innerRadius * Math.sin(startAngle);
        const ix2 = center + innerRadius * Math.cos(endAngle);
        const iy2 = center + innerRadius * Math.sin(endAngle);
        if (fullCircle) {
          const ixm = center + innerRadius * Math.cos(midAngle);
          const iym = center + innerRadius * Math.sin(midAngle);
          d = `M ${ix1} ${iy1} L ${x1} ${y1} A ${radius} ${radius} 0 1 1 ${xm} ${ym} A ${radius} ${radius} 0 1 1 ${x2} ${y2} L ${ix2} ${iy2} A ${innerRadius} ${innerRadius} 0 1 0 ${ixm} ${iym} A ${innerRadius} ${innerRadius} 0 1 0 ${ix1} ${iy1} Z`;
        } else {
          d = `M ${ix1} ${iy1} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} L ${ix2} ${iy2} A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${ix1} ${iy1} Z`;
        }
      } else if (fullCircle) {
        d = `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 1 1 ${xm} ${ym} A ${radius} ${radius} 0 1 1 ${x2} ${y2} Z`;
      } else {
        d = `M ${center} ${center} L ${x1} ${y1} A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2} Z`;
      }
      return {
        d,
        color: point.color || CHART_COLORS[idx % CHART_COLORS.length],
        label: point.label,
        value: point.value,
        percentage: (point.value / total * 100).toFixed(1)
      };
    });
  }, [data, total, radius, innerRadius, center]);
  return /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", justify: "center", className: "w-full", children: [
    /* @__PURE__ */ jsxs("svg", { width: size2, height: size2, viewBox: `0 0 ${size2} ${size2}`, children: [
      segments.map((seg, idx) => /* @__PURE__ */ jsx(
        "path",
        {
          d: seg.d,
          fill: seg.color,
          stroke: "var(--color-card)",
          strokeWidth: "2",
          className: cn("transition-opacity duration-fast hover:opacity-80 cursor-pointer", FOCUS_SVG),
          ...pressableProps(
            onPointClick ? () => onPointClick({ label: seg.label, value: seg.value, color: seg.color }, "default") : void 0
          ),
          ...onPointClick ? { "aria-label": pointName(seg.label, "default", seg.value) } : void 0
        },
        idx
      )),
      donut && /* @__PURE__ */ jsx(
        "text",
        {
          x: center,
          y: center,
          textAnchor: "middle",
          dominantBaseline: "middle",
          fill: "var(--color-foreground)",
          fontSize: "14",
          fontWeight: "bold",
          children: total
        }
      )
    ] }),
    showValues && /* @__PURE__ */ jsx(VStack, { gap: "xs", children: segments.map((seg, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          className: "w-3 h-3 rounded-sm flex-shrink-0",
          style: { backgroundColor: seg.color }
        }
      ),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
        seg.label,
        ": ",
        new Intl.NumberFormat(locale, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Number(seg.percentage) / 100)
      ] })
    ] }, idx)) })
  ] });
};
var LineChart = ({ series, height, showValues, fill = false, timeAxis, period, onPointClick }) => {
  const i18n = useTranslate();
  const width = 400;
  const padding = { top: 20, right: 20, bottom: 30, left: 40 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const labels = useMemo(() => {
    const seen = /* @__PURE__ */ new Set();
    const out = [];
    for (const s of series) {
      for (const p of s.data) {
        if (!seen.has(p.label)) {
          seen.add(p.label);
          out.push(p.label);
        }
      }
    }
    return out;
  }, [series]);
  const maxValue = useMemo(() => {
    let m = 1;
    for (const s of series) {
      for (const p of s.data) if (p.value > m) m = p.value;
    }
    return m;
  }, [series]);
  const xFor = useCallback(
    (idx) => labels.length === 1 ? padding.left + chartWidth / 2 : padding.left + idx / (labels.length - 1) * chartWidth,
    [labels.length, chartWidth, padding.left]
  );
  const valueTicks = useMemo(() => {
    const ticks = [];
    for (const frac of [0, 0.5, 1]) {
      const v = Math.round(maxValue * frac);
      if (ticks[ticks.length - 1] !== v) ticks.push(v);
    }
    return ticks;
  }, [maxValue]);
  const yFor = useCallback(
    (value) => padding.top + chartHeight - value / maxValue * chartHeight,
    [maxValue, chartHeight, padding.top]
  );
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      height,
      viewBox: `0 0 ${width} ${height}`,
      preserveAspectRatio: "xMidYMid meet",
      children: [
        [0, 0.25, 0.5, 0.75, 1].map((frac) => {
          const y = padding.top + chartHeight * (1 - frac);
          return /* @__PURE__ */ jsx(
            "line",
            {
              x1: padding.left,
              y1: y,
              x2: width - padding.right,
              y2: y,
              stroke: "var(--color-border)",
              strokeDasharray: "4 4",
              opacity: 0.5
            },
            frac
          );
        }),
        series.map((s, sIdx) => {
          const color = seriesColor(s, sIdx);
          const points = labels.map((label, idx) => {
            const point = s.data.find((d) => d.label === label);
            return {
              x: xFor(idx),
              y: yFor(point ? point.value : 0),
              value: point ? point.value : 0,
              label
            };
          });
          const linePath = points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
          const areaPath = `${linePath} L ${points[points.length - 1]?.x ?? 0} ${padding.top + chartHeight} L ${points[0]?.x ?? padding.left} ${padding.top + chartHeight} Z`;
          return /* @__PURE__ */ jsxs("g", { children: [
            fill && /* @__PURE__ */ jsx(
              "path",
              {
                d: areaPath,
                fill: color,
                opacity: series.length > 1 ? 0.08 : 0.1
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                d: linePath,
                fill: "none",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: s.dashed ? "6 4" : void 0
              }
            ),
            points.map((p, idx) => /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "circle",
                {
                  cx: p.x,
                  cy: p.y,
                  r: "4",
                  fill: "var(--color-card)",
                  stroke: color,
                  strokeWidth: "2",
                  className: cn("cursor-pointer", FOCUS_SVG),
                  ...pressableProps(
                    onPointClick ? () => onPointClick({ label: p.label, value: p.value, color }, s.name) : void 0
                  ),
                  ...onPointClick ? { "aria-label": pointName(p.label, s.name, p.value) } : void 0
                }
              ),
              (showValues || labels.length === 1) && series.length === 1 && /* @__PURE__ */ jsx(
                "text",
                {
                  x: p.x,
                  y: p.y - 10,
                  textAnchor: "middle",
                  fill: "var(--color-foreground)",
                  fontSize: "10",
                  fontWeight: "500",
                  children: formatValue(p.value, "number", { locale: i18n.locale })
                }
              )
            ] }, idx))
          ] }, s.name);
        }),
        valueTicks.map((v) => /* @__PURE__ */ jsx(
          "text",
          {
            x: padding.left - 6,
            y: yFor(v) + 3,
            textAnchor: "end",
            fill: "var(--color-muted-foreground)",
            fontSize: "9",
            children: formatValue(v, "number", { locale: i18n.locale })
          },
          `tick-${v}`
        )),
        labels.map((label, idx) => /* @__PURE__ */ jsx(
          "text",
          {
            x: xFor(idx),
            y: height - 8,
            textAnchor: "middle",
            fill: "var(--color-muted-foreground)",
            fontSize: "9",
            children: timeAxis ? formatTimeLabel(label, period, i18n) : label
          },
          label
        ))
      ]
    }
  );
};
var ScatterChart = ({ data, height, onPointClick }) => {
  const { locale } = useTranslate();
  const axisNumber = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const width = 400;
  const padding = { top: 20, right: 20, bottom: 30, left: 40 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const { minX, maxX, minY, maxY } = useMemo(() => {
    if (data.length === 0) {
      return { minX: 0, maxX: 1, minY: 0, maxY: 1 };
    }
    let mnX = data[0].x;
    let mxX = data[0].x;
    let mnY = data[0].y;
    let mxY = data[0].y;
    for (const p of data) {
      if (p.x < mnX) mnX = p.x;
      if (p.x > mxX) mxX = p.x;
      if (p.y < mnY) mnY = p.y;
      if (p.y > mxY) mxY = p.y;
    }
    return { minX: mnX, maxX: mxX, minY: mnY, maxY: mxY };
  }, [data]);
  const rangeX = maxX - minX || 1;
  const rangeY = maxY - minY || 1;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      height,
      viewBox: `0 0 ${width} ${height}`,
      preserveAspectRatio: "xMidYMid meet",
      children: [
        [0, 0.25, 0.5, 0.75, 1].map((frac) => {
          const y = padding.top + chartHeight * (1 - frac);
          return /* @__PURE__ */ jsx(
            "line",
            {
              x1: padding.left,
              y1: y,
              x2: width - padding.right,
              y2: y,
              stroke: "var(--color-border)",
              strokeDasharray: "4 4",
              opacity: 0.5
            },
            frac
          );
        }),
        data.map((p, idx) => {
          const cx = padding.left + (p.x - minX) / rangeX * chartWidth;
          const cy = padding.top + chartHeight - (p.y - minY) / rangeY * chartHeight;
          const r = p.size ?? 5;
          const color = p.color ?? CHART_COLORS[idx % CHART_COLORS.length];
          return /* @__PURE__ */ jsx(
            "circle",
            {
              cx,
              cy,
              r,
              fill: color,
              opacity: 0.7,
              className: cn("cursor-pointer hover:opacity-100", FOCUS_SVG),
              ...pressableProps(
                onPointClick ? () => onPointClick({ label: p.label ?? `(${p.x}, ${p.y})`, value: p.y, color }, "default") : void 0
              ),
              ...onPointClick ? { "aria-label": pointName(p.label ?? `(${p.x}, ${p.y})`, "default", p.y) } : void 0,
              children: /* @__PURE__ */ jsx("title", { children: p.label ?? `(${p.x}, ${p.y})` })
            },
            idx
          );
        }),
        /* @__PURE__ */ jsx(
          "text",
          {
            x: padding.left,
            y: height - 8,
            fill: "var(--color-muted-foreground)",
            fontSize: "9",
            children: axisNumber.format(minX)
          }
        ),
        /* @__PURE__ */ jsx(
          "text",
          {
            x: width - padding.right,
            y: height - 8,
            textAnchor: "end",
            fill: "var(--color-muted-foreground)",
            fontSize: "9",
            children: axisNumber.format(maxX)
          }
        )
      ]
    }
  );
};
var LOOK_FROM_CHART_TYPE = {
  bar: "bar-vertical",
  line: "line",
  pie: "pie",
  area: "area",
  donut: "donut",
  scatter: "scatter",
  histogram: "histogram"
};
var Chart = ({
  title,
  subtitle,
  chartType,
  look,
  series,
  data: simpleData,
  scatterData,
  height = 200,
  showLegend = true,
  showValues = false,
  stack = "none",
  timeAxis = false,
  period,
  drillEvent,
  actions,
  isLoading = false,
  skeleton = "card",
  error,
  className,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const resolvedLook = look ?? (chartType ? LOOK_FROM_CHART_TYPE[chartType] : "bar-vertical");
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleAction = useCallback(
    (action) => {
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, {});
      }
    },
    [eventBus]
  );
  const handlePointClick = useCallback(
    (point, seriesName) => {
      if (drillEvent) {
        eventBus.emit(`UI:${drillEvent}`, {
          label: point.label,
          value: point.value,
          seriesLabel: seriesName === "default" ? void 0 : seriesName
        });
      }
    },
    [drillEvent, eventBus]
  );
  const normalizedSeries = useMemo(() => {
    if (series && series.length > 0) return series;
    if (simpleData) return [{ name: "default", data: simpleData }];
    return [];
  }, [simpleData, series]);
  const firstSeriesData = normalizedSeries[0]?.data ?? [];
  const hasContent = resolvedLook === "scatter" ? (scatterData?.length ?? 0) > 0 : normalizedSeries.some((s) => s.data.length > 0);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.chartError"),
        message: error.message,
        className
      }
    );
  }
  if (!hasContent) {
    return /* @__PURE__ */ jsx(EmptyState, { title: t("empty.noData"), className });
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsx(Box, { className: cn(contentSurface.className, "p-6 rounded-container", className), ...domPassthrough(rest), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
      (title || subtitle || actions && actions.length > 0) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
          title && /* @__PURE__ */ jsx(Typography, { variant: "h5", children: title }),
          subtitle && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle })
        ] }),
        actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant: "default",
            className: "cursor-pointer hover:opacity-80 transition-opacity",
            onClick: () => handleAction(action),
            children: action.label
          },
          idx
        )) })
      ] }),
      /* @__PURE__ */ jsxs(Box, { className: "w-full", children: [
        resolvedLook === "bar-vertical" && /* @__PURE__ */ jsx(
          BarChart,
          {
            series: normalizedSeries,
            height,
            showValues,
            stack,
            timeAxis,
            period,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "bar-horizontal" && /* @__PURE__ */ jsx(
          BarChart,
          {
            series: normalizedSeries,
            height,
            showValues,
            stack,
            timeAxis,
            period,
            horizontal: true,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "histogram" && /* @__PURE__ */ jsx(
          BarChart,
          {
            series: normalizedSeries,
            height,
            showValues,
            stack: "none",
            timeAxis: false,
            histogram: true,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "line" && /* @__PURE__ */ jsx(
          LineChart,
          {
            series: normalizedSeries,
            height,
            showValues,
            timeAxis,
            period,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "area" && /* @__PURE__ */ jsx(
          LineChart,
          {
            series: normalizedSeries,
            height,
            showValues,
            timeAxis,
            period,
            fill: true,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "pie" && /* @__PURE__ */ jsx(
          PieChart,
          {
            data: firstSeriesData,
            height,
            showValues: showLegend,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "donut" && /* @__PURE__ */ jsx(
          PieChart,
          {
            data: firstSeriesData,
            height,
            showValues: showLegend,
            donut: true,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        ),
        resolvedLook === "scatter" && /* @__PURE__ */ jsx(
          ScatterChart,
          {
            data: scatterData ?? [],
            height,
            onPointClick: drillEvent ? handlePointClick : void 0
          }
        )
      ] }),
      showLegend && normalizedSeries.length > 1 && /* @__PURE__ */ jsx(HStack, { gap: "md", justify: "center", wrap: true, children: normalizedSeries.map((s, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "w-3 h-3 rounded-full flex-shrink-0",
            style: { backgroundColor: seriesColor(s, idx) }
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: s.name })
      ] }, idx)) })
    ] }) })
  );
};
Chart.displayName = "Chart";
var ChartLegend = ({
  items,
  className,
  direction = "horizontal",
  ...rest
}) => {
  const Wrapper = direction === "horizontal" ? HStack : VStack;
  return /* @__PURE__ */ jsx(Wrapper, { ...domPassthrough(rest), gap: "md", className: cn("flex-wrap", className), children: items.map((item) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        className: "rounded-full shrink-0",
        style: {
          width: 10,
          height: 10,
          backgroundColor: item.color
        }
      }
    ),
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: item.label })
  ] }, item.label)) });
};
ChartLegend.displayName = "ChartLegend";

// components/core/organisms/trace-edit-focus.ts
var ELEMENT_SELECTED_EVENT = "UI:ELEMENT_SELECTED";
var EDIT_FOCUS_LEVELS = /* @__PURE__ */ new Set([
  "node",
  "slot",
  "field",
  "effect",
  "trait",
  "page",
  "orbital"
]);
function asString(v) {
  return typeof v === "string" ? v : void 0;
}
function asLevel(v) {
  if (typeof v === "string" && EDIT_FOCUS_LEVELS.has(v)) {
    return v;
  }
  return "node";
}
function isEventPayload(v) {
  return v !== null && v !== void 0 && typeof v === "object" && !Array.isArray(v) && !(v instanceof Date);
}
function parseEditFocus(value) {
  if (!isEventPayload(value)) return null;
  const payload = value;
  const orbital = asString(payload.orbital);
  if (orbital === void 0 || orbital.length === 0) return null;
  const focus = {
    level: asLevel(payload.level),
    orbital,
    label: asString(payload.label) ?? orbital
  };
  const trait = asString(payload.trait);
  if (trait !== void 0) focus.trait = trait;
  const transition = asString(payload.transition);
  if (transition !== void 0) focus.transition = transition;
  const state = asString(payload.state);
  if (state !== void 0) focus.state = state;
  const slot = asString(payload.slot);
  if (slot !== void 0) focus.slot = slot;
  const path = asString(payload.path);
  if (path !== void 0) focus.path = path;
  const patternType = asString(payload.patternType);
  if (patternType !== void 0) focus.patternType = patternType;
  const entity = asString(payload.entity);
  if (entity !== void 0) focus.entity = entity;
  const source = asString(payload.source);
  if (source !== void 0) focus.source = source;
  return focus;
}
function getJepaBadgeVariant(probability) {
  if (probability >= 0.9) return "success";
  if (probability >= 0.5) return "warning";
  return "danger";
}
var INPUT_MAX_HEIGHT_PX = 160;
function ChatBar({
  status = "idle",
  activeGate,
  jepaValidity,
  runningIndicator,
  placeholder,
  context,
  sendEvent = "CHAT_SEND",
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);
  const [requestedPlaceholder, setRequestedPlaceholder] = useState(null);
  const [focus, setFocus] = useState(null);
  useLayoutEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    el.style.height = "auto";
    const fitted = Math.min(el.scrollHeight, INPUT_MAX_HEIGHT_PX);
    el.style.height = `${fitted}px`;
    el.style.overflowY = el.scrollHeight > INPUT_MAX_HEIGHT_PX ? "auto" : "hidden";
  }, [inputValue]);
  const clearFocus = useCallback(() => {
    setFocus(null);
    eventBus.emit(ELEMENT_SELECTED_EVENT, { focus: null });
  }, [eventBus]);
  const handleKeyDown = useCallback((e) => {
    if (e.key !== "Enter" || e.shiftKey) return;
    const trimmed = inputValue.trim();
    if (!trimmed) return;
    e.preventDefault();
    eventBus.emit(`UI:${sendEvent}`, { message: trimmed });
  }, [inputValue, eventBus, sendEvent]);
  useEffect(() => {
    const unsubSend = eventBus.on(`UI:${sendEvent}`, () => {
      setInputValue("");
      setFocus(null);
      setRequestedPlaceholder(null);
    });
    const unsubFocus = eventBus.on("UI:CHAT_FOCUS", (e) => {
      const hint = e.payload?.placeholder;
      if (typeof hint === "string" && hint.length > 0) setRequestedPlaceholder(hint);
      inputRef.current?.focus();
    });
    const unsubSelect = eventBus.on(ELEMENT_SELECTED_EVENT, (e) => {
      setFocus(parseEditFocus(e.payload?.focus));
    });
    return () => {
      unsubSend();
      unsubFocus();
      unsubSelect();
    };
  }, [eventBus, sendEvent]);
  const trailingAction = status === "error" ? /* @__PURE__ */ jsxs(Button, { variant: "secondary", size: "sm", action: "RETRY_GENERATION", className: "rounded-none flex-shrink-0 h-auto", children: [
    /* @__PURE__ */ jsx(Icon, { name: "refresh-cw", size: "xs" }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("openFile.retry") })
  ] }) : status === "running" ? /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: "PAUSE",
        title: t("chatBar.pauseTheAgentYouCanEdit"),
        className: "rounded-none flex-shrink-0 h-auto",
        children: /* @__PURE__ */ jsx(Icon, { name: "pause", size: "xs" })
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: "STOP",
        title: t("chatBar.cancelGeneration"),
        className: "rounded-none flex-shrink-0 h-auto border-l border-[var(--color-border)]",
        children: /* @__PURE__ */ jsx(Icon, { name: "square", size: "xs" })
      }
    )
  ] }) : status === "paused" ? /* @__PURE__ */ jsxs(
    Button,
    {
      variant: "primary",
      size: "sm",
      action: "RESUME",
      title: t("chatBar.resumeTheAgentYourCanvasEdits"),
      className: "rounded-none flex-shrink-0 h-auto",
      children: [
        /* @__PURE__ */ jsx(Icon, { name: "play", size: "xs" }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("chatBar.resume") })
      ]
    }
  ) : /* @__PURE__ */ jsx(
    Button,
    {
      variant: "primary",
      size: "sm",
      action: sendEvent,
      actionPayload: { message: inputValue.trim() },
      disabled: !inputValue.trim(),
      "aria-label": t("chatBar.sendMessage"),
      className: "rounded-none flex-shrink-0 h-auto",
      children: /* @__PURE__ */ jsx(Icon, { name: "send", size: "xs" })
    }
  );
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: `border-t border-[var(--color-border)] bg-[var(--color-card)] ${className ?? ""}`, children: [
    focus && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "items-center px-4 pt-2", children: /* @__PURE__ */ jsxs(Badge, { variant: "secondary", size: "sm", className: "flex items-center gap-1 max-w-full", children: [
      /* @__PURE__ */ jsx(Icon, { name: "mouse-pointer-2", size: "xs" }),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-inherit truncate", children: [
        t("chatBar.editing"),
        ": ",
        focus.label
      ] }),
      /* @__PURE__ */ jsx(
        Box,
        {
          onClick: clearFocus,
          title: t("chatBar.clearSelection"),
          className: "cursor-pointer flex items-center ml-1 hover:opacity-70",
          children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" })
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center px-4 py-2", children: [
      context && /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", className: "whitespace-nowrap flex-shrink-0", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-inherit", children: context }) }),
      /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0 flex items-stretch rounded-[var(--radius-md)] border border-[var(--color-border)] bg-[var(--color-background)] focus-within:border-[var(--color-primary)] overflow-hidden", children: [
        /* @__PURE__ */ jsx(
          Textarea,
          {
            ref: inputRef,
            value: inputValue,
            placeholder: requestedPlaceholder ?? placeholder ?? t("chatBar.askTheAgentAnything"),
            onChange: (e) => setInputValue(e.target.value),
            onKeyDown: handleKeyDown,
            rows: 1,
            className: "flex-1 min-w-0 min-h-0 text-sm border-0 rounded-none shadow-none bg-transparent resize-none focus:ring-0"
          }
        ),
        trailingAction
      ] }),
      (activeGate || jepaValidity !== void 0) && /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center flex-shrink-0", children: [
        status === "running" && /* @__PURE__ */ jsx(Box, { "data-testid": "chat-bar-running", className: "flex items-center", children: runningIndicator ?? /* @__PURE__ */ jsx(Spinner, { size: "sm" }) }),
        activeGate && /* @__PURE__ */ jsx(
          Typography,
          {
            variant: status === "running" ? "body" : "caption",
            weight: status === "running" ? "medium" : void 0,
            color: status === "running" ? void 0 : "muted",
            className: "whitespace-nowrap",
            children: activeGate
          }
        ),
        jepaValidity !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: getJepaBadgeVariant(jepaValidity), size: "sm", children: /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-inherit", children: [
          (jepaValidity * 100).toFixed(1),
          "%"
        ] }) })
      ] })
    ] })
  ] });
}
ChatBar.displayName = "ChatBar";
var chemistryLog = createLogger("almadar:ui:chemistry-canvas");
var CHEM_BOND_STATE_COLOR = {
  default: "ink",
  forming: "series-3",
  breaking: "series-2",
  highlight: "highlight"
};
var SERIES_TONES2 = ["series-1", "series-2", "series-3", "series-4", "series-5", "series-6", "series-7", "series-8"];
function seriesTone2(i) {
  return SERIES_TONES2[i % SERIES_TONES2.length];
}
function elementTones(atoms) {
  const m = /* @__PURE__ */ new Map();
  for (const a of atoms) {
    if (a.element !== void 0 && !m.has(a.element)) m.set(a.element, seriesTone2(m.size));
  }
  return m;
}
function atomTone(a, tones) {
  return (a.element !== void 0 ? tones.get(a.element) : void 0) ?? "series-1";
}
var LONE_PAIR_ANGLES = [-90, 0, 90, 180];
function bondPerpendicular(a, b) {
  const dx = b[0] - a[0];
  const dy = b[1] - a[1];
  const px = dy;
  const py = -dx;
  const len = Math.sqrt(px * px + py * py);
  if (len < 1e-6) return [1, 0, 0];
  return [px / len, py / len, 0];
}
var ChemistryCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  keyMap,
  keyUpMap,
  mode = "2d",
  camera,
  lighting,
  post,
  atoms = [],
  bonds = [],
  arrows = [],
  bondStyle = "thick",
  containers = [],
  equation,
  equationColor,
  lattice3d,
  shapes = [],
  readouts,
  traces,
  showGrid,
  shadows,
  interactive,
  animate = false,
  onShapeClick,
  isLoading,
  error,
  ...rest
}) => {
  const derivedShapes = useMemo(() => {
    const out = [];
    const tones = elementTones(atoms);
    const atomById = /* @__PURE__ */ new Map();
    for (const a of atoms) {
      if (a.id) atomById.set(a.id, a);
    }
    for (const c of containers) {
      const color = c.color ?? "ink";
      if (c.level != null) {
        const lv = c.level;
        out.push({
          type: "rect",
          x: c.x + 1,
          y: c.y + c.height * (1 - lv),
          width: c.width - 2,
          height: c.height * lv - 1,
          color: c.levelColor ?? "series-1",
          fill: c.levelColor ?? "series-1",
          fillStyle: "solid",
          stroke: "thin",
          opacity: 0.5
        });
      }
      out.push({
        type: "rect",
        x: c.x,
        y: c.y,
        width: c.width,
        height: c.height,
        color,
        fill: c.fill,
        stroke: "normal",
        lineWidth: c.lineWidth
      });
      const divider = c.divider ?? "none";
      if (divider !== "none") {
        out.push({
          type: "line",
          x1: c.x + c.width / 2,
          y1: c.y,
          x2: c.x + c.width / 2,
          y2: c.y + c.height,
          color: c.dividerColor ?? color,
          stroke: "thin",
          ...divider === "dashed" || divider === "dotted" ? { dash: divider } : {}
        });
      }
      if (c.leftLabel) {
        out.push({
          type: "text",
          x: c.x + c.width * 0.25,
          y: c.y + 12,
          text: c.leftLabel,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      if (c.rightLabel) {
        out.push({
          type: "text",
          x: c.x + c.width * 0.75,
          y: c.y + 12,
          text: c.rightLabel,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      if (c.label) {
        out.push({
          type: "text",
          x: c.x + c.width / 2,
          y: c.y + c.height + 12,
          text: c.label,
          tone: "ink",
          textSize: "sm",
          align: "center"
        });
      }
    }
    for (const b of bonds) {
      const a = atomById.get(b.from);
      const c = atomById.get(b.to);
      if (!a || !c) continue;
      const state = b.state ?? "default";
      const color = b.color ?? CHEM_BOND_STATE_COLOR[state];
      const dash = state === "forming" || state === "breaking" ? "dashed" : void 0;
      if (bondStyle === "parallel") {
        const dx = c.x - a.x;
        const dy = c.y - a.y;
        const dist = Math.max(1e-6, Math.hypot(dx, dy));
        const ux = dx / dist;
        const uy = dy / dist;
        const px = -uy;
        const py = ux;
        const offsets = b.type === "double" ? [-3, 3] : b.type === "triple" ? [-4, 0, 4] : [0];
        for (const off of offsets) {
          out.push({
            type: "line",
            x1: a.x + px * off,
            y1: a.y + py * off,
            x2: c.x + px * off,
            y2: c.y + py * off,
            color,
            stroke: "normal",
            ...dash ? { dash } : {}
          });
        }
      } else {
        const strokeWidth = b.type === "double" ? 4 : b.type === "triple" ? 6 : 2;
        out.push({
          type: "line",
          x1: a.x,
          y1: a.y,
          x2: c.x,
          y2: c.y,
          color,
          lineWidth: strokeWidth,
          ...dash ? { dash } : {}
        });
      }
    }
    for (const a of arrows) {
      const angle = (a.angle ?? 0) * (Math.PI / 180);
      const len = a.length ?? 60;
      const x2 = a.x + Math.cos(angle) * len;
      const y2 = a.y + Math.sin(angle) * len;
      out.push({
        type: "arrow",
        x1: a.x,
        y1: a.y,
        x2,
        y2,
        color: a.color ?? "ink",
        stroke: "bold"
      });
      if (a.label) {
        out.push({
          type: "text",
          x: (a.x + x2) / 2,
          y: (a.y + y2) / 2 - 10,
          text: a.label,
          textCase: "verbatim",
          tone: "ink",
          textSize: "sm",
          align: "center"
        });
      }
    }
    for (const a of atoms) {
      out.push({
        type: "circle",
        x: a.x,
        y: a.y,
        radius: a.radius ?? 14,
        color: a.color ?? atomTone(a, tones),
        fill: a.color ?? atomTone(a, tones),
        id: a.id
      });
      if (a.element) {
        out.push({
          type: "text",
          x: a.x,
          y: a.y,
          text: a.element,
          textCase: "verbatim",
          tone: "ink",
          textSize: "sm",
          align: "center"
        });
      }
      const r = a.radius ?? 14;
      if (a.charge) {
        out.push({
          type: "text",
          x: a.x + r * 0.85,
          y: a.y - r * 0.85,
          text: a.charge,
          textCase: "verbatim",
          tone: "ink",
          textSize: "xs",
          align: "left"
        });
      }
      const lonePairs = Math.max(0, Math.min(4, a.lonePairs ?? 0));
      for (let k = 0; k < lonePairs; k++) {
        const angleRad = LONE_PAIR_ANGLES[k] * Math.PI / 180;
        const cx = a.x + (r + 6) * Math.cos(angleRad);
        const cy = a.y + (r + 6) * Math.sin(angleRad);
        const perpX = -Math.sin(angleRad);
        const perpY = Math.cos(angleRad);
        for (const sign of [1, -1]) {
          out.push({
            type: "circle",
            x: cx + perpX * 2.5 * sign,
            y: cy + perpY * 2.5 * sign,
            radius: 1.5,
            color: "ink",
            fill: "ink",
            fillStyle: "solid"
          });
        }
      }
    }
    if (equation) {
      out.push({
        type: "text",
        x: width / 2,
        y: 14,
        text: equation,
        textCase: "verbatim",
        color: equationColor ?? "ink",
        textSize: "sm",
        align: "center"
      });
    }
    out.push(...shapes);
    return out;
  }, [atoms, bonds, arrows, bondStyle, containers, equation, equationColor, shapes, width]);
  const drawables3D = useMemo(() => {
    if (mode !== "3d") return [];
    const tone3d = (value, fallback) => value ?? fallback;
    const tones = elementTones(atoms);
    if (shapes.length > 0) {
      chemistryLog.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
    }
    if (containers.length > 0) {
      chemistryLog.debug("containers ignored in 3D mode (pixel-authored 2D vocabulary)", { count: containers.length });
    }
    if (animate) {
      chemistryLog.debug("animate ignored in 3D mode (motion is entity-state driven)");
    }
    const out = [];
    const labelColor = "ink";
    const atomById = /* @__PURE__ */ new Map();
    for (const a of atoms) {
      if (a.id) atomById.set(a.id, a);
    }
    for (const b of bonds) {
      const a = atomById.get(b.from);
      const c = atomById.get(b.to);
      if (!a || !c) continue;
      const color = tone3d(b.color, "ink");
      const from = [a.x, a.y, a.z ?? 0];
      const to = [c.x, c.y, c.z ?? 0];
      const perp = bondPerpendicular(from, to);
      const bondRadius = Math.max(0.06, Math.min(a.radius ?? 0.45, c.radius ?? 0.45) * 0.22);
      const step = bondRadius * 2.2;
      const offsets = b.type === "double" ? [-step, step] : b.type === "triple" ? [-step, 0, step] : [0];
      for (const off of offsets) {
        const bond = cylinderBetween(
          [from[0] + perp[0] * off, from[1] + perp[1] * off, from[2] + perp[2] * off],
          [to[0] + perp[0] * off, to[1] + perp[1] * off, to[2] + perp[2] * off],
          bondRadius,
          color
        );
        if (bond) out.push(bond);
      }
    }
    for (const a of arrows) {
      const angle = (a.angle ?? 0) * (Math.PI / 180);
      const len = a.length ?? 60;
      const x2 = a.x + Math.cos(angle) * len;
      const y2 = a.y + Math.sin(angle) * len;
      const arrow = arrowBetween([a.x, a.y, 0], [x2, y2, 0], tone3d(a.color, "ink"));
      if (arrow) out.push(arrow);
      if (a.label) {
        out.push(billboardLabel(a.label, (a.x + x2) / 2, (a.y + y2) / 2, 0, { color: labelColor }));
      }
    }
    for (const a of atoms) {
      const radius = a.radius ?? 0.45;
      const az = a.z ?? 0;
      out.push(meshSphere(a.id, a.x, a.y, az, radius, tone3d(a.color, atomTone(a, tones))));
      if (a.element) {
        out.push(billboardLabel(a.element, a.x, a.y, az + radius, { color: labelColor }));
      }
    }
    if (lattice3d) {
      out.push(
        ...latticeDrawables(
          {
            ...lattice3d,
            basis: lattice3d.basis.map((site, i) => ({ ...site, color: tone3d(site.color, seriesTone2(i)) })),
            bonds: lattice3d.bonds?.map((bond) => ({ ...bond, color: tone3d(bond.color, "ink") })),
            dimColor: tone3d(lattice3d.dimColor, "muted"),
            selectedColor: tone3d(lattice3d.selectedColor, "highlight")
          },
          { labelColor }
        )
      );
    }
    return out;
  }, [mode, atoms, bonds, arrows, shapes, containers, lattice3d, animate, backgroundColor]);
  const atomIndexById = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    atoms.forEach((a, i) => {
      if (a.id) m.set(a.id, i);
    });
    return m;
  }, [atoms]);
  if (mode === "3d") {
    return /* @__PURE__ */ jsx(
      LearningScene3D,
      {
        ...domPassthrough(rest),
        className,
        width,
        height,
        title,
        backgroundColor,
        series,
        drawables: drawables3D,
        camera,
        lighting,
        post,
        showGrid,
        shadows,
        interactive,
        isLoading,
        error,
        onItemClick: get3DClickPayload(onShapeClick, atomIndexById)
      }
    );
  }
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        shapes: derivedShapes,
        readouts,
        traces,
        interactive: interactive ?? false,
        animate,
        onShapeClick,
        isLoading,
        error
      }
    )
  ] }) });
};
var CodeRunnerPanel = ({
  code: initialCode,
  language,
  runnable = false,
  runEvent = "RUN_CODE",
  resetEvent,
  runId = "",
  output = null,
  running = false,
  error = null,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [code, setCode] = useState(initialCode);
  const [copied, setCopied] = useState(false);
  const isRunning = running;
  const handleRun = useCallback(() => {
    eventBus.emit(`UI:${runEvent}`, { code, language, runId });
  }, [code, language, runEvent, runId, eventBus]);
  const handleReset = useCallback(() => {
    setCode(initialCode);
    if (resetEvent) eventBus.emit(`UI:${resetEvent}`, { runId });
  }, [initialCode, resetEvent, runId, eventBus]);
  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      eventBus.emit("UI:COPY_CODE", { language, success: true });
      setTimeout(() => setCopied(false), 2e3);
    } catch {
      eventBus.emit("UI:COPY_CODE", { language, success: false });
    }
  }, [code, language, eventBus]);
  if (!runnable) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsx(CodeBlock, { language, code }) });
  }
  const hasOutput = output !== null || error !== null;
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("space-y-3", className), children: [
    /* @__PURE__ */ jsxs(Box, { className: "group relative", style: { height: 360 }, children: [
      /* @__PURE__ */ jsx(
        CodeBlock,
        {
          language,
          code,
          editable: true,
          onChange: setCode,
          showLanguageBadge: true,
          showCopyButton: false,
          maxHeight: "100%"
        }
      ),
      /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "xs",
          align: "center",
          className: "absolute top-2 right-2 z-10 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto focus-within:opacity-100 focus-within:pointer-events-auto transition-opacity bg-[var(--color-card)]/90 backdrop-blur-sm rounded-container p-1 shadow-elevation-popover border border-border",
          children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: handleCopy,
                icon: copied ? Check : Copy,
                "aria-label": t("common.copy"),
                className: copied ? "text-success" : ""
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                onClick: handleReset,
                disabled: isRunning,
                icon: RotateCcw,
                "aria-label": t("common.reset")
              }
            ),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "primary",
                size: "sm",
                onClick: handleRun,
                isLoading: isRunning,
                icon: isRunning ? RotateCcw : Play,
                className: isRunning ? "[&_svg]:animate-spin" : "",
                children: isRunning ? t("common.loading") : t("codeRunner.run")
              }
            )
          ]
        }
      )
    ] }),
    hasOutput && /* @__PURE__ */ jsxs(Box, { className: "rounded-container border border-border bg-foreground overflow-hidden", children: [
      /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          align: "center",
          className: "px-3 py-2 bg-card border-b border-border",
          children: [
            /* @__PURE__ */ jsx(Terminal, { size: 16, className: "text-muted-foreground" }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground font-medium", children: t("codeRunner.output") }),
            output && /* @__PURE__ */ jsx(
              Badge,
              {
                variant: output.exitCode === 0 ? "success" : "danger",
                size: "sm",
                children: t("codeRunner.exit", { code: output.exitCode })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx(VStack, { gap: "none", className: "p-3 font-mono text-sm", children: error ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error whitespace-pre-wrap", children: error }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        output?.stdout ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background whitespace-pre-wrap", children: output.stdout }) : null,
        output?.stderr ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error whitespace-pre-wrap", children: output.stderr }) : null,
        !output?.stdout && !output?.stderr ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background italic", children: t("codeRunner.noOutput") }) : null,
        output && output.testResults.length > 0 && /* @__PURE__ */ jsx(Box, { className: "mt-3 pt-3 border-t border-border space-y-2", children: output.testResults.map((test, index) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", className: "text-xs", children: [
          test.passed ? /* @__PURE__ */ jsx(CheckCircle, { size: 14, className: "text-success mt-0.5" }) : /* @__PURE__ */ jsx(XCircle, { size: 14, className: "text-error mt-0.5" }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1", children: [
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "small",
                className: test.passed ? "text-success" : "text-error",
                children: test.passed ? t("codeRunner.testPassed", { number: index + 1 }) : t("codeRunner.testFailed", { number: index + 1 })
              }
            ),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background", children: t("codeRunner.input", { value: test.input }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background", children: t("codeRunner.expected", { value: test.expectedOutput }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-background", children: t("codeRunner.actual", { value: test.actualOutput }) })
          ] })
        ] }, index)) })
      ] }) })
    ] })
  ] });
};
CodeRunnerPanel.displayName = "CodeRunnerPanel";
function matchesQuery(query, text) {
  if (!query) return true;
  let qi = 0;
  const q = query.toLowerCase();
  const t = text.toLowerCase();
  for (let ti = 0; ti < t.length && qi < q.length; ti++) {
    if (t[ti] === q[qi]) qi++;
  }
  return qi === q.length;
}
function commandMatches(command, query) {
  if (!query) return true;
  if (matchesQuery(query, command.label)) return true;
  return (command.keywords ?? []).some((keyword) => matchesQuery(query, keyword));
}
var UNGROUPED = /* @__PURE__ */ Symbol("command-palette-ungrouped");
function dispatchCommandPaletteCommand(command, deps) {
  if (command.disabled) return;
  if (command.event) deps.emit(`UI:${command.event}`, { commandId: command.id });
  if (command.action) deps.emit(`UI:${command.action}`, command.actionPayload ?? {});
  deps.onSelect?.(command);
}
var CommandPalette = ({
  open,
  onOpenChange,
  commands,
  onSelect,
  placeholder: placeholderProp,
  emptyLabel: emptyLabelProp,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const placeholder = placeholderProp ?? t("commandPalette.placeholder");
  const emptyLabel = emptyLabelProp ?? t("commandPalette.noMatches");
  const [query, setQuery] = useState("");
  const [highlightIndex, setHighlightIndex] = useState(0);
  const filtered = useMemo(
    () => commands.filter((command) => commandMatches(command, query)),
    [commands, query]
  );
  const groups = useMemo(() => {
    const order = [];
    const byGroup = /* @__PURE__ */ new Map();
    for (const command of filtered) {
      const key = command.group ?? UNGROUPED;
      if (!byGroup.has(key)) {
        byGroup.set(key, []);
        order.push(key);
      }
      byGroup.get(key).push(command);
    }
    return order.map((key) => ({ group: key === UNGROUPED ? void 0 : key, items: byGroup.get(key) }));
  }, [filtered]);
  const resetQuery = useCallback(() => {
    setQuery("");
    setHighlightIndex(0);
  }, []);
  const handleClose = useCallback(() => {
    resetQuery();
    onOpenChange(false);
  }, [onOpenChange, resetQuery]);
  const handleSelect = useCallback(
    (command) => {
      if (command.disabled) return;
      dispatchCommandPaletteCommand(command, { emit: eventBus.emit, onSelect });
      handleClose();
    },
    [eventBus, onSelect, handleClose]
  );
  const handleQueryChange = useCallback((e) => {
    setQuery(e.target.value);
    setHighlightIndex(0);
  }, []);
  const handleKeyDown = useCallback(
    (e) => {
      if (filtered.length === 0) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightIndex((prev) => prev < filtered.length - 1 ? prev + 1 : 0);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightIndex((prev) => prev > 0 ? prev - 1 : filtered.length - 1);
      } else if (e.key === "Enter") {
        e.preventDefault();
        const command = filtered[highlightIndex];
        if (command) handleSelect(command);
      }
    },
    [filtered, highlightIndex, handleSelect]
  );
  return /* @__PURE__ */ jsx(
    Modal,
    {
      ...domPassthrough(rest),
      isOpen: open,
      onClose: handleClose,
      onExited: resetQuery,
      showCloseButton: false,
      size: "md",
      className,
      children: /* @__PURE__ */ jsx(Box, { "data-testid": "command-palette", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            inputType: "search",
            placeholder,
            value: query,
            onChange: handleQueryChange,
            onKeyDown: handleKeyDown,
            leftIcon: "search",
            clearable: query.length > 0,
            onClear: resetQuery,
            autoFocus: true,
            "data-testid": "command-palette-input"
          }
        ),
        filtered.length === 0 ? /* @__PURE__ */ jsx(Box, { className: "px-2 py-6 text-center", "data-testid": "command-palette-empty", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: emptyLabel }) }) : /* @__PURE__ */ jsx(
          Box,
          {
            className: "max-h-80 overflow-y-auto",
            role: "listbox",
            "aria-label": placeholder,
            children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: groups.map(({ group, items }) => /* @__PURE__ */ jsxs(Box, { children: [
              group ? /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  color: "muted",
                  className: "px-3 pt-2 pb-1 block",
                  children: group
                }
              ) : null,
              items.map((command) => {
                const index = filtered.indexOf(command);
                const isHighlighted = index === highlightIndex;
                return /* @__PURE__ */ jsxs(
                  Box,
                  {
                    as: "button",
                    role: "option",
                    "aria-selected": isHighlighted,
                    "aria-disabled": command.disabled || void 0,
                    "data-testid": `command-palette-item-${command.id}`,
                    onMouseEnter: () => !command.disabled && setHighlightIndex(index),
                    onClick: () => handleSelect(command),
                    className: cn(
                      "w-full flex items-center gap-3 px-3 py-2 text-start rounded-interactive",
                      "text-sm transition-colors",
                      "focus:outline-none",
                      "focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
                      isHighlighted && "bg-muted",
                      command.disabled && "opacity-50 cursor-not-allowed"
                    ),
                    children: [
                      command.icon ? /* @__PURE__ */ jsx(Icon, { icon: command.icon, size: "sm", className: "flex-shrink-0" }) : null,
                      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1 truncate", children: command.label }),
                      command.shortcut ? /* @__PURE__ */ jsx(Badge, { variant: "neutral", size: "sm", children: command.shortcut }) : null
                    ]
                  },
                  command.id
                );
              })
            ] }, String(group ?? "__ungrouped__"))) })
          }
        )
      ] }) })
    }
  );
};
CommandPalette.displayName = "CommandPalette";
var KIND_ICONS = {
  user: "user",
  agent: "sparkles",
  restore: "rotate-ccw",
  undo: "undo-2",
  redo: "redo-2",
  snapshot: "camera",
  merge: "git-merge"
};
var CommitRow = ({
  sha,
  message,
  author,
  timestamp,
  kind,
  additions,
  deletions,
  selected = false,
  current = false,
  selectEvent,
  restoreEvent,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const shortSha = sha.length > 7 ? sha.substring(0, 7) : sha;
  const select = useCallback(() => {
    if (selectEvent) eventBus.emit(`UI:${selectEvent}`, { sha });
  }, [eventBus, selectEvent, sha]);
  return /* @__PURE__ */ jsxs(HStack, { ...domPassthrough(rest), gap: "sm", align: "start", className: cn("rounded-interactive px-2 py-1.5", selected ? "bg-muted" : "hover:bg-muted", className), children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        role: "button",
        tabIndex: 0,
        "aria-pressed": selected,
        "data-testid": "commit-row",
        className: "flex-1 min-w-0 cursor-pointer",
        onClick: select,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            select();
          }
        },
        children: /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "min-w-0", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", className: "min-w-0", children: [
            kind && /* @__PURE__ */ jsx(Box, { "data-testid": "commit-row-kind", "data-kind": kind, className: "flex-shrink-0", title: t(`commitRow.kind.${kind}`), children: /* @__PURE__ */ jsx(Icon, { name: KIND_ICONS[kind], size: "xs", className: "text-muted-foreground" }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "truncate", children: message })
          ] }),
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", className: "flex-wrap", children: [
            /* @__PURE__ */ jsx(Box, { as: "span", title: sha, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "font-mono text-[0.65rem]", children: shortSha }) }),
            author && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: author }),
            timestamp && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: timestamp }),
            additions !== void 0 && /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
              "+",
              additions
            ] }),
            deletions !== void 0 && /* @__PURE__ */ jsxs(Badge, { variant: "error", size: "sm", children: [
              "-",
              deletions
            ] }),
            current && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", "data-testid": "commit-row-current", children: t("commitRow.current") })
          ] })
        ] })
      }
    ),
    restoreEvent && !current && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        icon: "rotate-ccw",
        onClick: () => eventBus.emit(`UI:${restoreEvent}`, { sha }),
        children: t("commitRow.restore")
      }
    )
  ] });
};
CommitRow.displayName = "CommitRow";
var variantConfig = {
  danger: {
    icon: Trash2,
    iconBg: "bg-error",
    iconColor: "text-error-foreground",
    confirmVariant: "danger"
  },
  warning: {
    icon: AlertTriangle,
    iconBg: "bg-warning",
    iconColor: "text-warning-foreground",
    confirmVariant: "warning"
  },
  info: {
    icon: Check,
    iconBg: "bg-info",
    iconColor: "text-info-foreground",
    confirmVariant: "primary"
  },
  default: {
    icon: Check,
    iconBg: "bg-primary",
    iconColor: "text-primary-foreground",
    confirmVariant: "primary"
  }
};
var ConfirmDialog = ({
  isOpen = true,
  onClose = () => {
  },
  onExited,
  onConfirm = () => {
  },
  title,
  message,
  description,
  confirmText,
  confirmLabel,
  cancelText,
  cancelLabel,
  variant = "danger",
  size: size2 = "sm",
  isLoading = false,
  error,
  className,
  ...rest
}) => {
  const config = variantConfig[variant];
  const { t } = useTranslate();
  const resolvedMessage = message ?? description ?? "";
  const resolvedConfirmText = confirmText ?? confirmLabel ?? t("dialog.confirm");
  const resolvedCancelText = cancelText ?? cancelLabel ?? t("dialog.cancel");
  const handleConfirm = () => {
    onConfirm();
  };
  return /* @__PURE__ */ jsx(
    Modal,
    {
      ...domPassthrough(rest),
      isOpen,
      onExited,
      onClose,
      size: size2,
      showCloseButton: false,
      closeOnOverlayClick: !isLoading,
      closeOnEscape: !isLoading,
      className,
      footer: /* @__PURE__ */ jsxs(HStack, { className: "justify-end gap-3", children: [
        /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: onClose, disabled: isLoading, children: resolvedCancelText }),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: config.confirmVariant,
            onClick: handleConfirm,
            isLoading,
            children: isLoading ? t("common.loading") : resolvedConfirmText
          }
        )
      ] }),
      children: /* @__PURE__ */ jsxs(HStack, { className: "gap-4", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "flex-shrink-0 w-12 h-12 flex items-center justify-center",
              config.iconBg
            ),
            children: /* @__PURE__ */ jsx(Icon, { icon: config.icon, size: "lg", className: config.iconColor })
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "flex-1", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "h5", className: "mb-2", children: title }),
          typeof resolvedMessage === "string" ? /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body2",
              className: "text-muted-foreground",
              children: resolvedMessage
            }
          ) : resolvedMessage,
          error && /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "error", role: "alert", className: "mt-2", children: error.message })
        ] })
      ] })
    }
  );
};
ConfirmDialog.displayName = "ConfirmDialog";
var ConnectionBlock = ({ content, className, ...rest }) => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("bg-success/10 border-s-heavy border-success rounded-e-container p-5 mb-6", className), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
    /* @__PURE__ */ jsx(Link2, { className: "text-success flex-shrink-0 mt-1", size: 20 }),
    /* @__PURE__ */ jsxs(Box, { className: "flex-1", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h6", as: "h4", className: "mb-2", children: t("connection.title") }),
      /* @__PURE__ */ jsx(MarkdownContent, { content, className: "text-sm" })
    ] })
  ] }) });
};
ConnectionBlock.displayName = "ConnectionBlock";
var sizeStyles7 = {
  xs: "max-w-xs",
  // 320px
  sm: "max-w-screen-sm",
  // 640px
  md: "max-w-screen-md",
  // 768px
  lg: "max-w-screen-lg",
  // 1024px
  xl: "max-w-screen-xl",
  // 1280px
  "2xl": "max-w-screen-2xl",
  // 1536px
  full: "max-w-full"
};
var paddingStyles2 = {
  none: "px-0",
  // Mobile-tighter, desktop-identical: fixed px-6 on a 360px phone eats ~13% of
  // the viewport, so each token steps down below the sm breakpoint.
  sm: "px-3 sm:px-4",
  md: "px-4 sm:px-6",
  lg: "px-4 sm:px-6 md:px-8",
  xl: "px-4 sm:px-8 md:px-12"
};
var Container = ({
  size: size2,
  maxWidth,
  padding = "md",
  center = true,
  className,
  children,
  as: Component = "div",
  ...rest
}) => {
  const resolvedSize = maxWidth ?? size2 ?? "lg";
  return React93__default.createElement(
    Component,
    {
      ...domPassthrough(rest),
      className: cn(
        "w-full",
        sizeStyles7[resolvedSize],
        paddingStyles2[padding],
        center && "mx-auto",
        className
      )
    },
    children
  );
};
Container.displayName = "Container";
function Card2({
  title,
  subtitle,
  image,
  actions,
  children,
  onClick,
  className = "",
  action,
  longPressEvent,
  longPressPayload
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const isClickable = !!onClick || !!action;
  const handleLongPress = useCallback(() => {
    if (longPressEvent) {
      eventBus.emit(`UI:${longPressEvent}`, longPressPayload ?? {});
    }
  }, [longPressEvent, longPressPayload, eventBus]);
  const longPress = useLongPress(handleLongPress);
  const handleClick = () => {
    if (action) eventBus.emit(`UI:${action}`, {});
    onClick?.();
  };
  return /* @__PURE__ */ jsxs(
    Card,
    {
      padding: "none",
      className: cn(isClickable && "hover:shadow-elevation-dialog transition-shadow", className),
      onClick: isClickable ? handleClick : void 0,
      ...longPressEvent ? {
        onPointerDown: longPress.onPointerDown,
        onPointerMove: longPress.onPointerMove,
        onPointerUp: longPress.onPointerUp,
        onPointerCancel: longPress.onPointerCancel
      } : {},
      children: [
        image && /* @__PURE__ */ jsx(Box, { className: "aspect-video w-full overflow-hidden rounded-t-container", children: /* @__PURE__ */ jsx(Image2, { src: image, alt: title || t("card.imageAlt"), className: "w-full h-full object-cover" }) }),
        /* @__PURE__ */ jsxs(Box, { className: "p-4", children: [
          (title || subtitle) && /* @__PURE__ */ jsxs(Box, { className: "mb-3", children: [
            title && /* @__PURE__ */ jsx(Typography, { variant: "h5", as: "h3", className: "text-card-foreground", children: title }),
            subtitle && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", className: "mt-1", children: subtitle })
          ] }),
          children && /* @__PURE__ */ jsx(Box, { className: "text-card-foreground", children }),
          actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "sm", wrap: true, className: "mt-4 pt-4 border-t border-border", children: actions.map((cardAction, index) => /* @__PURE__ */ jsx(
            Button,
            {
              size: "sm",
              variant: cardAction.variant === "primary" ? "primary" : cardAction.variant === "danger" ? "danger" : "secondary",
              leftIcon: cardAction.icon,
              disabled: cardAction.disabled,
              onClick: (e) => {
                e.stopPropagation();
                if (cardAction.event) eventBus.emit(`UI:${cardAction.event}`, { label: cardAction.label });
                cardAction.onClick?.();
              },
              children: cardAction.label
            },
            index
          )) })
        ] })
      ]
    }
  );
}
Card2.displayName = "Card";
var QuizBlock = ({
  question,
  answer,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const [revealed, setRevealed] = useState(false);
  return /* @__PURE__ */ jsx(Card2, { ...domPassthrough(rest), className: cn("my-4 border-primary", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
      /* @__PURE__ */ jsx(Icon, { icon: HelpCircle, size: "sm", className: "text-primary mt-0.5 shrink-0" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-medium", children: question })
    ] }),
    revealed ? /* @__PURE__ */ jsx(Box, { className: "pl-7 pt-2 border-t border-border", children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-foreground", children: answer }) }) : null,
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: () => setRevealed((r) => !r),
        className: "self-start ml-7",
        children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", children: revealed ? t("quiz.hideAnswer") : t("quiz.showAnswer") }),
          revealed ? /* @__PURE__ */ jsx(Icon, { name: "chevron-up", className: "w-3.5 h-3.5" }) : /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "w-3.5 h-3.5" })
        ] })
      }
    )
  ] }) });
};
QuizBlock.displayName = "QuizBlock";
function extractTrait(schema, trait, traitIndex) {
  if (trait) return trait;
  if (!schema?.orbitals?.length) return null;
  for (const orbital of schema.orbitals) {
    const traits = orbital.traits ?? [];
    if (traitIndex < traits.length) {
      const traitRef = traits[traitIndex];
      return isInlineTrait(traitRef) ? traitRef : null;
    }
  }
  return null;
}
function firstEntity(schema) {
  const entity = schema?.orbitals?.[0]?.entity;
  if (!entity || typeof entity !== "object" || !("fields" in entity) || typeof entity.name !== "string") return null;
  const fields = (entity.fields ?? []).map((f3) => f3.name).filter((n) => typeof n === "string" && n.length > 0);
  return { name: entity.name, fields };
}
var JazariStateMachine = ({
  schema,
  trait: traitProp,
  traitIndex = 0,
  entityFields: entityFieldsProp,
  direction = "ltr",
  className,
  isLoading = false,
  error = null,
  ...rest
}) => {
  const { t } = useTranslate();
  const entity = useMemo(() => firstEntity(schema), [schema]);
  const entityFields = useMemo(() => entityFieldsProp ?? entity?.fields ?? [], [entityFieldsProp, entity]);
  const traitData = useMemo(() => {
    const trait = extractTrait(schema, traitProp, traitIndex);
    return trait ? traitLevelFromTrait(trait, entity?.name ?? "") : null;
  }, [schema, traitProp, traitIndex, entity]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { ...domPassthrough(rest), message: t("stateMachine.loading") });
  }
  if (error) {
    return /* @__PURE__ */ jsx(ErrorState, { ...domPassthrough(rest), message: error instanceof Error ? error.message : String(error) });
  }
  if (!traitData || traitData.states.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), padding: "lg", className: cn("text-center", className), children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: t("stateMachine.noStateMachine") }) });
  }
  return /* @__PURE__ */ jsx(
    AvlStateMachine,
    {
      ...domPassthrough(rest),
      trait: traitData,
      nodeShape: "gear",
      direction,
      entityFields,
      className: cn("jazari-state-machine", className)
    }
  );
};
JazariStateMachine.displayName = "JazariStateMachine";
var ContentRenderer = ({
  content,
  segments: segmentsProp,
  direction,
  className,
  ...rest
}) => {
  const { t: _t } = useTranslate();
  const segments = useMemo(
    () => segmentsProp ?? parseContentSegments(content),
    [segmentsProp, content]
  );
  if (segments.length === 0) return null;
  return /* @__PURE__ */ jsx(VStack, { ...domPassthrough(rest), gap: "md", className: cn("w-full", className), children: segments.map((segment, i) => {
    const key = `seg-${i}`;
    switch (segment.type) {
      case "markdown":
        return /* @__PURE__ */ jsx(
          MarkdownContent,
          {
            content: segment.content,
            direction
          },
          key
        );
      case "code":
        return /* @__PURE__ */ jsx(
          CodeBlock,
          {
            code: segment.content,
            language: toCodeLanguage(segment.language)
          },
          key
        );
      case "orbital": {
        const parsed = segment.schema;
        const isFullSchema = (v) => Array.isArray(v.orbitals);
        const inlineTrait = {
          name: "inline",
          scope: "instance",
          stateMachine: parsed
        };
        const schema = isFullSchema(parsed) ? parsed : {
          name: "inline",
          orbitals: [{
            name: "inline",
            entity: { name: "inline", fields: [] },
            traits: [inlineTrait],
            pages: []
          }]
        };
        return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
          /* @__PURE__ */ jsx(
            CodeBlock,
            {
              code: segment.content,
              language: toCodeLanguage(segment.language)
            }
          ),
          /* @__PURE__ */ jsx(
            JazariStateMachine,
            {
              schema,
              direction
            }
          )
        ] }, key);
      }
      case "quiz":
        return /* @__PURE__ */ jsx(
          QuizBlock,
          {
            question: segment.question,
            answer: segment.answer
          },
          key
        );
      default:
        return null;
    }
  }) });
};
ContentRenderer.displayName = "ContentRenderer";
var sizeStyles8 = {
  sm: { display: "text-4xl", button: "sm" },
  md: { display: "text-6xl", button: "md" },
  lg: { display: "text-8xl", button: "lg" }
};
function CounterMinimal({
  entity,
  size: size2 = "md",
  onDecrement,
  onIncrement,
  decrementEvent,
  incrementEvent,
  className,
  ...rest
}) {
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsxs(HStack, { gap: "lg", align: "center", justify: "center", ...domPassthrough(rest), className, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        size: sizeStyles8[size2].button,
        action: decrementEvent,
        onClick: onDecrement,
        disabled: resolved.decrementDisabled,
        icon: "minus",
        children: resolved.decrementLabel
      }
    ),
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h1",
        className: cn(
          sizeStyles8[size2].display,
          "tabular-nums min-w-[3ch] text-center"
        ),
        children: resolved.count
      }
    ),
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "secondary",
        size: sizeStyles8[size2].button,
        action: incrementEvent,
        onClick: onIncrement,
        disabled: resolved.incrementDisabled,
        icon: "plus",
        children: resolved.incrementLabel
      }
    )
  ] });
}
CounterMinimal.displayName = "CounterMinimal";
function CounterStandard({
  entity,
  size: size2 = "md",
  title: titleProp,
  showReset = true,
  onDecrement,
  onIncrement,
  onReset,
  decrementEvent,
  incrementEvent,
  resetEvent,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const title = titleProp ?? t("counter.title");
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsx(Container, { size: "sm", padding: "lg", ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "lg", align: "center", children: [
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h2",
        className: "text-muted-foreground",
        children: title
      }
    ),
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h1",
        className: cn(
          sizeStyles8[size2].display,
          "tabular-nums text-primary"
        ),
        children: resolved.count
      }
    ),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: sizeStyles8[size2].button,
          action: decrementEvent,
          onClick: onDecrement,
          disabled: resolved.decrementDisabled,
          icon: "minus"
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: sizeStyles8[size2].button,
          action: incrementEvent,
          onClick: onIncrement,
          disabled: resolved.incrementDisabled,
          icon: "plus"
        }
      )
    ] }),
    showReset && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: resetEvent,
        onClick: onReset,
        icon: "rotate-ccw",
        children: t("common.reset")
      }
    )
  ] }) });
}
CounterStandard.displayName = "CounterStandard";
function CounterFull({
  entity,
  size: size2 = "md",
  title: titleProp,
  showReset = true,
  onDecrement,
  onIncrement,
  onReset,
  decrementEvent,
  incrementEvent,
  resetEvent,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const title = titleProp ?? t("counter.title");
  const resolved = entity && typeof entity === "object" && !Array.isArray(entity) ? entity : void 0;
  if (!resolved) return null;
  return /* @__PURE__ */ jsx(Container, { size: "sm", padding: "lg", ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "xl", align: "center", children: [
    /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h2",
        className: "text-muted-foreground",
        children: title
      }
    ),
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", children: [
      /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "h1",
          className: cn(
            sizeStyles8[size2].display,
            "tabular-nums text-primary"
          ),
          children: resolved.count
        }
      ),
      resolved.rangeText && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: resolved.rangeText })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { gap: "md", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: sizeStyles8[size2].button,
          action: decrementEvent,
          onClick: onDecrement,
          disabled: resolved.decrementDisabled,
          icon: "minus",
          children: resolved.decrementLabel
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: sizeStyles8[size2].button,
          action: incrementEvent,
          onClick: onIncrement,
          disabled: resolved.incrementDisabled,
          icon: "plus",
          children: resolved.incrementLabel
        }
      )
    ] }),
    showReset && /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "sm",
        action: resetEvent,
        onClick: onReset,
        icon: "rotate-ccw",
        children: t("counter.resetToZero")
      }
    )
  ] }) });
}
CounterFull.displayName = "CounterFull";
var CounterTemplate = (props) => {
  switch (props.variant) {
    case "minimal":
      return /* @__PURE__ */ jsx(CounterMinimal, { ...props });
    case "full":
      return /* @__PURE__ */ jsx(CounterFull, { ...props });
    default:
      return /* @__PURE__ */ jsx(CounterStandard, { ...props });
  }
};
CounterTemplate.displayName = "CounterTemplate";
var gapStyles2 = {
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6"
};
var columnStyles = {
  2: "grid-cols-1 sm:grid-cols-2 @max-sm:!grid-cols-1",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 @max-lg:!grid-cols-3 @max-md:!grid-cols-2 @max-sm:!grid-cols-1"
};
var colSpanStyles = {
  1: "col-span-1",
  2: "col-span-1 sm:col-span-2 @max-sm:!col-span-1",
  3: "col-span-1 sm:col-span-2 md:col-span-3 @max-md:!col-span-2 @max-sm:!col-span-1",
  4: "col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-4 @max-lg:!col-span-3 @max-md:!col-span-2 @max-sm:!col-span-1"
};
var rowSpanStyles = {
  1: "row-span-1",
  2: "row-span-2"
};
var DashboardGrid = ({
  columns = 3,
  gap = "md",
  cells,
  className,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  return contentSurface.provide(
    /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(rest),
        className: cn(
          "grid w-full",
          columnStyles[columns],
          gapStyles2[gap],
          className
        ),
        children: cells.map((cell, idx) => /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "min-w-0 p-4",
              // Each cell is a surface; already on one, a hairline keeps the tiles apart.
              contentSurface.className ?? "rounded-container border border-border",
              colSpanStyles[Math.min(cell.colSpan ?? 1, columns)],
              rowSpanStyles[cell.rowSpan ?? 1]
            ),
            children: cell.content
          },
          cell.id != null ? String(cell.id) : idx
        ))
      }
    )
  );
};
DashboardGrid.displayName = "DashboardGrid";
function ItemIcon({ icon }) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(Icon, { icon, className: "h-4 w-4" });
}
function TopNavItem({ item, activeHref, tone = "solid", className, ...rest }) {
  const navStack = useNavStack();
  const [open, setOpen] = useState(false);
  const children = item.children ?? [];
  const hasChildren = children.length > 0;
  const isActive = item.active === true || item.href !== void 0 && item.href === activeHref || children.some((child) => child.active === true || child.href !== void 0 && child.href === activeHref);
  const follow = (target) => {
    if (target.onClick) target.onClick();
    else if (target.href !== void 0) followHref(target.href, navStack);
  };
  const triggerClass = cn(
    "flex items-center gap-1.5 px-3 py-1.5 rounded-interactive text-sm font-medium transition-colors whitespace-nowrap",
    isActive ? tone === "solid" ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "bg-primary/10 text-foreground" : "text-muted-foreground hover:bg-muted hover:text-foreground",
    className
  );
  const content = /* @__PURE__ */ jsxs(Fragment, { children: [
    item.icon && /* @__PURE__ */ jsx(ItemIcon, { icon: item.icon }),
    /* @__PURE__ */ jsx(Typography, { variant: "small", color: "inherit", className: "flex-1", as: "span", children: item.label }),
    item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge })
  ] });
  if (!hasChildren) {
    const current = isActive ? "page" : void 0;
    if (item.href !== void 0 && !item.onClick) {
      return /* @__PURE__ */ jsx(Button, { ...domPassthrough(rest), variant: "ghost", href: item.href, "aria-current": current ?? rest["aria-current"], "data-active": isActive ? "true" : "false", className: triggerClass, children: content });
    }
    return /* @__PURE__ */ jsx(Button, { ...domPassthrough(rest), variant: "ghost", "aria-current": current ?? rest["aria-current"], "data-active": isActive ? "true" : "false", className: triggerClass, onClick: () => follow(item), children: content });
  }
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: "relative", children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        variant: "ghost",
        "aria-expanded": open,
        "aria-haspopup": "menu",
        "data-active": isActive ? "true" : "false",
        className: triggerClass,
        onClick: () => setOpen(!open),
        children: [
          content,
          /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: cn("h-3.5 w-3.5 shrink-0 transition-transform", open && "rotate-180") })
        ]
      }
    ),
    open && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Box, { className: "fixed inset-0 z-20", onClick: () => setOpen(false) }),
      /* @__PURE__ */ jsx(
        Box,
        {
          role: "menu",
          className: "absolute start-0 top-full mt-1 min-w-48 bg-card surface-material rounded-container shadow-elevation-popover border border-border py-1 z-30",
          children: children.map((child) => {
            const childActive = child.active === true || child.href !== void 0 && child.href === activeHref;
            return /* @__PURE__ */ jsxs(
              Button,
              {
                role: "menuitem",
                variant: "ghost",
                "aria-current": childActive ? "page" : void 0,
                "data-active": childActive ? "true" : "false",
                onClick: () => {
                  setOpen(false);
                  follow(child);
                },
                className: cn(
                  "flex w-full items-center justify-start gap-2 rounded-none px-3 py-2 text-sm transition-colors",
                  childActive ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                ),
                children: [
                  child.icon && /* @__PURE__ */ jsx(ItemIcon, { icon: child.icon }),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1 text-start", as: "span", children: child.label }),
                  child.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: childActive ? "primary" : "default", size: "sm", children: child.badge })
                ]
              },
              child.href ?? child.label
            );
          })
        }
      )
    ] })
  ] });
}
TopNavItem.displayName = "TopNavItem";
var TRIGGER_CONTROL_SELECTOR = 'button, a[href], input, select, textarea, [role="button"], [tabindex]:not([tabindex="-1"])';
var MENU_GAP = 4;
function focusMenuItem(menu, target) {
  if (!menu) return;
  const items = Array.from(menu.querySelectorAll(':scope > [role="menuitem"], :scope > * > [role="menuitem"]'));
  if (items.length === 0) return;
  const at = items.indexOf(document.activeElement);
  const index = target === "first" ? 0 : target === "last" ? items.length - 1 : target === "next" ? (at + 1) % items.length : (at - 1 + items.length) % items.length;
  items[index].focus();
}
var MENU_NAV_KEYS = {
  ArrowDown: "next",
  ArrowUp: "prev",
  Home: "first",
  End: "last"
};
function downloadItemUrl(url, label) {
  const a = document.createElement("a");
  a.href = url;
  a.download = url.startsWith("data:") ? label : url.split("/").pop() ?? "download";
  document.body.appendChild(a);
  a.click();
  a.remove();
}
function computeMenuStyle(position, triggerRect) {
  const isTop2 = position.startsWith("top");
  const isRight = position.endsWith("right") || position.endsWith("end");
  if (isTop2) {
    return {
      top: triggerRect.top - MENU_GAP,
      transform: "translateY(-100%)",
      ...isRight ? { right: window.innerWidth - triggerRect.right } : { left: triggerRect.left }
    };
  }
  return {
    top: triggerRect.bottom + MENU_GAP,
    ...isRight ? { right: window.innerWidth - triggerRect.right } : { left: triggerRect.left }
  };
}
var menuContainerStyles = cn(
  "bg-card",
  "border-[length:var(--border-width)] border-border",
  "shadow-elevation-popover",
  "rounded-container",
  "min-w-0 sm:min-w-[200px] max-w-[calc(100vw-1rem)] py-1"
);
function SubMenu({
  items,
  itemRef,
  direction,
  eventBus,
  autoFocus,
  onClose,
  onActivate
}) {
  const [rect, setRect] = useState(null);
  const navStack = useNavStack();
  const subRef = useRef(null);
  useEffect(() => {
    if (rect && autoFocus) focusMenuItem(subRef.current, "first");
  }, [rect, autoFocus]);
  useEffect(() => {
    if (itemRef) {
      setRect(itemRef.getBoundingClientRect());
    }
  }, [itemRef]);
  if (!rect) return null;
  const isRtl = direction === "rtl";
  const style = {
    top: rect.top,
    ...isRtl ? { right: window.innerWidth - rect.left } : { left: rect.right }
  };
  const backKey = isRtl ? "ArrowRight" : "ArrowLeft";
  const panel = /* @__PURE__ */ jsx(
    "div",
    {
      ref: subRef,
      role: "menu",
      className: cn("fixed z-50", menuContainerStyles),
      style,
      onKeyDown: (e) => {
        const nav = MENU_NAV_KEYS[e.key];
        if (nav) {
          e.preventDefault();
          e.stopPropagation();
          focusMenuItem(subRef.current, nav);
        } else if (e.key === backKey || e.key === "Escape") {
          e.preventDefault();
          e.stopPropagation();
          onClose();
        }
      },
      children: items.map((item, index) => {
        const isDivider = item.type === "divider";
        const itemId = item.id ?? `item-${item.label.toLowerCase().replace(/\s+/g, "-")}-${index}`;
        const isDanger = item.variant === "danger";
        if (isDivider) {
          return /* @__PURE__ */ jsx(Divider, { className: "my-1" }, `divider-${index}`);
        }
        return /* @__PURE__ */ jsxs(
          Box,
          {
            as: "button",
            role: "menuitem",
            tabIndex: -1,
            onClick: () => {
              if (item.disabled) return;
              if (item.event && !item.onClick) eventBus.emit(`UI:${item.event}`, { itemId, label: item.label });
              if (item.url) downloadItemUrl(item.url, item.label);
              if (item.href !== void 0) followHref(item.href, navStack);
              item.onClick?.();
              onActivate();
            },
            "aria-disabled": item.disabled || void 0,
            title: item.title,
            "data-testid": item.event ? actionTestId(item.event) : void 0,
            className: cn(
              "w-full flex items-center gap-3 px-4 py-2 text-start",
              "text-sm transition-colors",
              "hover:bg-muted focus:outline-none focus:bg-muted",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              item.disabled && "cursor-not-allowed",
              isDanger && "text-foreground hover:bg-error/10 border-s-heavy border-error"
            ),
            children: [
              item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: cn("flex-shrink-0", isDanger && "text-error") }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: cn("flex-shrink-0", isDanger && "text-error") })),
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1", children: item.label }),
              item.badge !== void 0 && /* @__PURE__ */ jsx("span", { className: "ml-auto text-xs font-medium", children: item.badge })
            ]
          },
          itemId
        );
      })
    }
  );
  return typeof document !== "undefined" ? /* @__PURE__ */ jsx(ThemedPortal, { children: panel }) : panel;
}
function MenuItemRow({
  item,
  itemId,
  hasSubMenu,
  isDanger,
  direction,
  isSubMenuOpen,
  subMenuAutoFocus,
  activeSubMenuRef,
  eventBus,
  onItemClick,
  openSubMenu,
  closeSubMenu,
  closeMenu
}) {
  const rowRef = useRef(null);
  const openKey = direction === "rtl" ? "ArrowLeft" : "ArrowRight";
  const { triggerProps } = useTapReveal({
    enabled: hasSubMenu,
    onReveal: () => openSubMenu(itemId, rowRef.current),
    refs: [rowRef]
  });
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: rowRef,
        as: "button",
        role: "menuitem",
        tabIndex: -1,
        "aria-haspopup": hasSubMenu ? "menu" : void 0,
        "aria-expanded": hasSubMenu ? isSubMenuOpen : void 0,
        onClick: () => onItemClick({ ...item, id: itemId }, itemId),
        onKeyDown: (e) => {
          if (hasSubMenu && e.key === openKey) {
            e.preventDefault();
            e.stopPropagation();
            openSubMenu(itemId, e.currentTarget, true);
          }
        },
        "aria-disabled": item.disabled || void 0,
        title: item.title,
        onMouseEnter: (e) => {
          if (hasSubMenu) openSubMenu(itemId, e.currentTarget);
        },
        onPointerDown: hasSubMenu ? triggerProps.onPointerDown : void 0,
        "data-testid": item.event ? actionTestId(item.event) : void 0,
        className: cn(
          "w-full flex items-center justify-between gap-3 px-4 py-2 text-start",
          "text-sm transition-colors",
          "hover:bg-muted",
          "focus:outline-none focus:bg-muted",
          "disabled:opacity-50 disabled:cursor-not-allowed",
          item.disabled && "cursor-not-allowed",
          isDanger && "text-foreground hover:bg-error/10 border-s-heavy border-error"
        ),
        children: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-3 flex-1 min-w-0", children: [
          item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: cn("flex-shrink-0", isDanger && "text-error") }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: cn("flex-shrink-0", isDanger && "text-error") })),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "small",
              className: "flex-1",
              children: item.label
            }
          ),
          item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: item.badge }),
          hasSubMenu && /* @__PURE__ */ jsx(
            Icon,
            {
              name: direction === "rtl" ? "chevron-left" : "chevron-right",
              size: "sm",
              className: "flex-shrink-0"
            }
          )
        ] })
      }
    ),
    hasSubMenu && isSubMenuOpen && item.subMenu && /* @__PURE__ */ jsx(
      SubMenu,
      {
        items: item.subMenu,
        itemRef: activeSubMenuRef,
        direction,
        eventBus,
        autoFocus: subMenuAutoFocus,
        onClose: () => {
          closeSubMenu();
          rowRef.current?.focus();
        },
        onActivate: closeMenu
      }
    )
  ] });
}
var Menu = ({
  trigger,
  items,
  position = "bottom-left",
  className,
  header,
  footer,
  ...rest
}) => {
  const eventBus = useEventBus();
  const navStack = useNavStack();
  const { direction } = useTranslate();
  const [isOpen, setIsOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activeSubMenuRef, setActiveSubMenuRef] = useState(null);
  const [subMenuAutoFocus, setSubMenuAutoFocus] = useState(false);
  const [triggerRect, setTriggerRect] = useState(null);
  const triggerRef = useRef(null);
  const [innerControl, setInnerControl] = useState(null);
  const focusReturnRef = useRef(null);
  const menuRef = useRef(null);
  const menuId = useId();
  const updatePosition = () => {
    if (triggerRef.current) {
      setTriggerRect(triggerRef.current.getBoundingClientRect());
    }
  };
  const handleToggle = () => {
    if (!isOpen) {
      updatePosition();
    }
    setIsOpen(!isOpen);
    setActiveSubMenu(null);
    setActiveSubMenuRef(null);
  };
  const handleItemClick = (item, itemId) => {
    if (item.disabled) return;
    if (item.subMenu && item.subMenu.length > 0) {
      setActiveSubMenu(itemId);
    } else {
      if (item.event && !item.onClick) eventBus.emit(`UI:${item.event}`, { itemId, label: item.label });
      if (item.url) downloadItemUrl(item.url, item.label);
      if (item.href !== void 0) followHref(item.href, navStack);
      item.onClick?.();
      setIsOpen(false);
    }
  };
  const openSubMenu = (itemId, el, focusFirst = false) => {
    setActiveSubMenu(itemId);
    setActiveSubMenuRef(el);
    setSubMenuAutoFocus(focusFirst);
  };
  const closeSubMenu = () => {
    setActiveSubMenu(null);
    setActiveSubMenuRef(null);
  };
  const closeMenu = () => {
    setIsOpen(false);
    closeSubMenu();
  };
  const openMenu = () => {
    updatePosition();
    setIsOpen(true);
  };
  focusReturnRef.current = innerControl ?? triggerRef.current;
  useDialogBehavior({ open: isOpen, containerRef: menuRef, onEscape: closeMenu, modal: false, returnFocusRef: focusReturnRef });
  const panelMounted = isOpen && triggerRect !== null;
  useEffect(() => {
    if (panelMounted) focusMenuItem(menuRef.current, "first");
  }, [panelMounted]);
  const onTriggerKeyDown = (e) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      if (!isOpen) openMenu();
    }
  };
  const triggerA11y = {
    "aria-haspopup": "menu",
    "aria-expanded": isOpen,
    ...isOpen ? { "aria-controls": menuId } : void 0
  };
  const wrapsTrigger = !React93__default.isValidElement(trigger);
  useLayoutEffect(() => {
    setInnerControl(wrapsTrigger ? triggerRef.current?.querySelector(TRIGGER_CONTROL_SELECTOR) ?? null : null);
  }, [wrapsTrigger, trigger]);
  useLayoutEffect(() => {
    if (!innerControl) return;
    innerControl.setAttribute("aria-haspopup", "menu");
    innerControl.setAttribute("aria-expanded", String(isOpen));
    if (isOpen) innerControl.setAttribute("aria-controls", menuId);
    else innerControl.removeAttribute("aria-controls");
  }, [innerControl, isOpen, menuId]);
  useEffect(() => {
    if (isOpen) {
      updatePosition();
    }
  }, [isOpen]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && menuRef.current && !menuRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) {
        setIsOpen(false);
        setActiveSubMenu(null);
        setActiveSubMenuRef(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);
  const rtlMirror = {
    "top-left": "top-right",
    "top-right": "top-left",
    "bottom-left": "bottom-right",
    "bottom-right": "bottom-left",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
  };
  const effectivePosition = direction === "rtl" ? rtlMirror[position] ?? position : position;
  const triggerElement = React93__default.isValidElement(trigger) ? React93__default.cloneElement(trigger, {
    ref: triggerRef,
    onClick: handleToggle,
    onKeyDown: onTriggerKeyDown,
    ...triggerA11y
  }) : /* @__PURE__ */ jsx(
    Box,
    {
      as: "span",
      ref: (el) => {
        triggerRef.current = el;
      },
      onClick: handleToggle,
      ...innerControl ? void 0 : { role: "button", tabIndex: 0, ...triggerA11y },
      onKeyDown: (e) => {
        if (!innerControl && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          handleToggle();
        } else {
          onTriggerKeyDown(e);
        }
      },
      className: "inline-flex",
      children: typeof trigger === "string" || typeof trigger === "number" ? /* @__PURE__ */ jsx(Typography, { variant: "small", as: "span", children: trigger }) : trigger
    }
  );
  const renderMenuItems = (menuItems) => menuItems.map((item, index) => {
    const isDivider = item.type === "divider";
    const itemId = item.id ?? `item-${item.label.toLowerCase().replace(/\s+/g, "-")}-${index}`;
    const hasSubMenu = !!(item.subMenu && item.subMenu.length > 0);
    const isDanger = item.variant === "danger";
    if (isDivider) {
      return /* @__PURE__ */ jsx(Divider, { className: "my-1" }, `divider-${index}`);
    }
    return /* @__PURE__ */ jsx(
      MenuItemRow,
      {
        item,
        itemId,
        hasSubMenu,
        isDanger,
        direction,
        isSubMenuOpen: activeSubMenu === itemId,
        subMenuAutoFocus,
        activeSubMenuRef,
        eventBus,
        onItemClick: handleItemClick,
        openSubMenu,
        closeSubMenu,
        closeMenu
      },
      itemId
    );
  });
  const panel = isOpen && triggerRect ? /* @__PURE__ */ jsxs(
    "div",
    {
      ref: menuRef,
      ...domPassthrough(rest),
      className: cn("fixed z-50", menuContainerStyles, className),
      style: computeMenuStyle(effectivePosition, triggerRect),
      id: menuId,
      role: "menu",
      onKeyDown: (e) => {
        const nav = MENU_NAV_KEYS[e.key];
        if (nav) {
          e.preventDefault();
          focusMenuItem(menuRef.current, nav);
        } else if (e.key === "Tab") {
          closeMenu();
        }
      },
      children: [
        header && /* @__PURE__ */ jsx("div", { className: "px-4 py-2 border-b border-border", children: header }),
        renderMenuItems(items),
        footer && /* @__PURE__ */ jsx("div", { className: "px-4 py-2 border-t border-border", children: footer })
      ]
    }
  ) : null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    triggerElement,
    panel && typeof document !== "undefined" ? /* @__PURE__ */ jsx(ThemedPortal, { children: panel }) : panel
  ] });
};
Menu.displayName = "Menu";
function resolveActiveNavHref(items, currentPath) {
  let best;
  for (const item of items) {
    for (const href of item.children?.length ? [item.href, ...item.children.map((c) => c.href)] : [item.href]) {
      if (currentPath === href) return href;
      if (currentPath.startsWith(href + "/") && (!best || href.length > best.length)) {
        best = href;
      }
    }
  }
  return best;
}
var DashboardLayout = ({
  appName: appNameProp,
  logo,
  navItems = [],
  user: userProp,
  headerActions,
  showSearch = false,
  searchEvent,
  onSearchSubmit,
  topBarActions = [],
  userMenuItems = [],
  fullBleed = false,
  notifications,
  notificationClickEvent,
  onNotificationClick,
  showThemeToggle = true,
  sidebarFooter,
  sidebarContent,
  onSignOut: onSignOutProp,
  currentPath,
  layoutMode = "sidebar",
  children
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const appName = appNameProp ?? t("dashboard.defaultAppName");
  const searchEnabled = showSearch || Boolean(searchEvent) || Boolean(onSearchSubmit);
  const notificationsEnabled = Array.isArray(notifications);
  const unreadCount = notificationsEnabled ? notifications.filter((n) => n.read !== true).length : 0;
  const handleSearchSubmit = (value) => {
    if (searchEvent) eventBus.emit(`UI:${searchEvent}`, { value });
    if (onSearchSubmit) onSearchSubmit(value);
  };
  const handleNotificationClick = () => {
    if (notificationClickEvent) eventBus.emit(`UI:${notificationClickEvent}`, {});
    if (onNotificationClick) onNotificationClick();
  };
  const handleTopBarActionClick = (action) => {
    if (action.event) eventBus.emit(`UI:${action.event}`, {});
    if (action.navigatesTo) eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
  };
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const layoutRef = useRef(null);
  const [layoutWidth, setLayoutWidth] = useState(null);
  useEffect(() => {
    const el = layoutRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width ?? el.clientWidth;
      setLayoutWidth(w);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  const isMobile = layoutWidth !== null && layoutWidth < 768;
  const isDrawer = layoutMode === "drawer";
  const offCanvas = isMobile || isDrawer;
  const isRail = !isDrawer && layoutWidth !== null && layoutWidth >= 768 && layoutWidth < 1024;
  useEffect(() => {
    if (!offCanvas && sidebarOpen) setSidebarOpen(false);
  }, [offCanvas, sidebarOpen]);
  const location = useLocation();
  const ctxPagePath = useCurrentPagePath();
  const activePath = (currentPath || void 0) ?? ctxPagePath ?? location.pathname;
  const activeHref = useMemo(() => resolveActiveNavHref(navItems, activePath), [navItems, activePath]);
  const [topNavMenuOpen, setTopNavMenuOpen] = useState(false);
  const mainRef = useRef(null);
  const navigatedFrom = useRef(activePath);
  useEffect(() => {
    setTopNavMenuOpen(false);
    setSidebarOpen(false);
    if (navigatedFrom.current !== activePath) {
      navigatedFrom.current = activePath;
      mainRef.current?.focus({ preventScroll: true });
    }
  }, [activePath]);
  const { registerNavItems } = useNavStack();
  useEffect(() => {
    registerNavItems(navItems);
  }, [navItems, registerNavItems]);
  const { user: authUser, signOut: authSignOut } = useAuthContext();
  const user = userProp || (authUser ? {
    name: authUser.displayName || authUser.email?.split("@")[0] || t("dashboard.defaultUserName"),
    email: authUser.email || "",
    avatar: authUser.photoURL || void 0
  } : null);
  const handleSignOut = onSignOutProp || authSignOut;
  const showSidebar = layoutMode === "sidebar" || isDrawer;
  const showHeader = layoutMode !== "minimal";
  const showBottomNav = layoutMode === "bottomnav";
  const isTopNav = layoutMode === "topnav";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: layoutRef,
      className: "@container/dashboard min-h-screen w-full bg-background surface-page flex flex-row items-stretch",
      children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "link",
            href: "#main-content",
            className: "sr-only focus:not-sr-only focus:fixed focus:top-2 focus:start-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-card focus:shadow-elevation-popover",
            children: t("aria.skipToContent")
          }
        ),
        showSidebar && offCanvas && sidebarOpen && /* @__PURE__ */ jsx(
          Box,
          {
            className: "fixed inset-0 bg-scrim z-20",
            onClick: () => setSidebarOpen(false)
          }
        ),
        showSidebar && /* @__PURE__ */ jsxs(
          Box,
          {
            as: "aside",
            inert: offCanvas && !sidebarOpen ? true : void 0,
            className: cn(
              "z-30 flex-shrink-0 bg-card surface-material border-e-[length:var(--border-width)] border-border",
              isRail ? "w-16" : "w-64",
              "flex flex-col"
            ),
            style: offCanvas ? {
              position: "fixed",
              top: 0,
              bottom: 0,
              left: 0,
              transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
              transition: "transform 200ms ease-in-out"
            } : { position: "static", transform: "none" },
            children: [
              /* @__PURE__ */ jsxs(
                HStack,
                {
                  align: "center",
                  justify: isRail ? "center" : "between",
                  className: cn("h-16 border-b-[length:var(--border-width)] border-border", isRail ? "px-2" : "px-4"),
                  children: [
                    /* @__PURE__ */ jsxs(Link$1, { to: "/", className: "flex items-center gap-2", title: isRail ? appName : void 0, children: [
                      logo || /* @__PURE__ */ jsx(Box, { className: "w-8 h-8 bg-primary rounded-interactive flex items-center justify-center", children: /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "small",
                          className: "text-primary-foreground font-bold text-sm",
                          as: "span",
                          children: appName.charAt(0).toUpperCase()
                        }
                      ) }),
                      !isRail && /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "label",
                          className: "heading-voice text-foreground",
                          as: "span",
                          children: appName
                        }
                      )
                    ] }),
                    offCanvas && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        className: "p-2",
                        onClick: () => setSidebarOpen(false),
                        "aria-label": t("aria.closePanel"),
                        children: /* @__PURE__ */ jsx(Icon, { name: "x", className: "h-5 w-5" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ jsx(
                VStack,
                {
                  as: "nav",
                  "aria-label": t("aria.mainNavigation"),
                  gap: "none",
                  className: cn(
                    "py-4 space-y-1 overflow-y-auto",
                    sidebarContent && !isRail ? "shrink-0" : "flex-1",
                    isRail ? "px-2" : "px-3"
                  ),
                  children: navItems.map((item) => /* @__PURE__ */ jsx(
                    NavLink,
                    {
                      item,
                      activeHref,
                      compact: isRail
                    },
                    item.href
                  ))
                }
              ),
              sidebarContent && !isRail && /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto border-t-[length:var(--border-width)] border-border px-2 py-3", children: sidebarContent }),
              sidebarFooter && /* @__PURE__ */ jsx(Box, { className: "p-4 border-t-[length:var(--border-width)] border-border", children: sidebarFooter })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0 min-h-screen", children: [
          showHeader && /* @__PURE__ */ jsx(
            Box,
            {
              as: "header",
              className: "sticky top-0 z-20 pt-[env(safe-area-inset-top)] bg-card surface-material border-b-[length:var(--border-width)] border-border",
              children: /* @__PURE__ */ jsxs(
                HStack,
                {
                  align: "center",
                  justify: "between",
                  className: "h-16 px-3 @sm/dashboard:px-4 gap-2 @sm/dashboard:gap-4",
                  children: [
                    showSidebar && offCanvas && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        className: "p-2 rounded-interactive hover:bg-muted text-muted-foreground touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center",
                        onClick: () => setSidebarOpen(true),
                        "aria-label": t("aria.openSidebar"),
                        children: /* @__PURE__ */ jsx(Icon, { name: "menu", className: "h-5 w-5" })
                      }
                    ),
                    isTopNav && isMobile && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        className: "p-2 rounded-interactive hover:bg-muted text-muted-foreground touch-manipulation min-h-[44px] min-w-[44px] flex items-center justify-center",
                        onClick: () => setTopNavMenuOpen(true),
                        "aria-label": t("aria.openMenu"),
                        "aria-expanded": topNavMenuOpen,
                        children: /* @__PURE__ */ jsx(Icon, { name: "menu", className: "h-5 w-5" })
                      }
                    ),
                    isMobile && !searchOpen && /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "medium", truncate: true, className: "flex-1 min-w-0 text-foreground", children: appName }),
                    isDrawer && !isMobile && /* @__PURE__ */ jsxs(Link$1, { to: "/", className: "flex items-center gap-2 shrink-0", children: [
                      logo,
                      /* @__PURE__ */ jsx(Typography, { variant: "label", className: "heading-voice text-foreground", as: "span", children: appName })
                    ] }),
                    isTopNav && !isMobile && /* @__PURE__ */ jsxs(
                      HStack,
                      {
                        as: "nav",
                        "aria-label": t("aria.mainNavigation"),
                        align: "center",
                        gap: "none",
                        className: "flex items-center gap-1 overflow-x-auto",
                        children: [
                          /* @__PURE__ */ jsxs(Link$1, { to: "/", className: "flex items-center gap-2 mr-3 shrink-0", children: [
                            logo || /* @__PURE__ */ jsx(Box, { className: "w-7 h-7 bg-primary rounded-interactive flex items-center justify-center", children: /* @__PURE__ */ jsx(
                              Typography,
                              {
                                variant: "small",
                                className: "text-primary-foreground font-bold text-xs",
                                as: "span",
                                children: appName.charAt(0).toUpperCase()
                              }
                            ) }),
                            /* @__PURE__ */ jsx(
                              Typography,
                              {
                                variant: "label",
                                className: "heading-voice text-foreground",
                                as: "span",
                                children: appName
                              }
                            )
                          ] }),
                          navItems.map((item) => /* @__PURE__ */ jsx(
                            TopNavItem,
                            {
                              item,
                              activeHref,
                              tone: "solid"
                            },
                            item.href
                          ))
                        ]
                      }
                    ),
                    searchEnabled && /* @__PURE__ */ jsx(
                      Box,
                      {
                        "data-dashboard-search": true,
                        className: cn(
                          "flex-1 min-w-0 @xl/dashboard:max-w-md",
                          isMobile && !searchOpen ? "hidden" : "block"
                        ),
                        children: /* @__PURE__ */ jsx(
                          Input,
                          {
                            type: "search",
                            icon: "search",
                            placeholder: t("common.search"),
                            className: "w-full",
                            autoFocus: isMobile && searchOpen,
                            onKeyDown: (e) => {
                              if (e.key === "Enter") {
                                handleSearchSubmit(e.target.value);
                              } else if (e.key === "Escape" && isMobile) {
                                setSearchOpen(false);
                              }
                            }
                          }
                        )
                      }
                    ),
                    searchEnabled && isMobile && /* @__PURE__ */ jsx(
                      Button,
                      {
                        variant: "ghost",
                        icon: searchOpen ? "x" : "search",
                        onClick: () => setSearchOpen((open) => !open),
                        "aria-label": t("aria.search"),
                        "aria-expanded": searchOpen,
                        className: "shrink-0 min-h-[44px] min-w-[44px]"
                      }
                    ),
                    !searchEnabled && /* @__PURE__ */ jsx(Box, { className: "flex-1" }),
                    /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
                      headerActions,
                      showThemeToggle && /* @__PURE__ */ jsx(ThemeToggle, {}),
                      topBarActions.map((action, idx) => /* @__PURE__ */ jsxs(
                        Button,
                        {
                          variant: "ghost",
                          className: "relative p-2",
                          onClick: () => handleTopBarActionClick(action),
                          "aria-label": action.label ?? (typeof action.icon === "string" ? action.icon : void 0),
                          children: [
                            /* @__PURE__ */ jsx(Icon, { icon: action.icon, className: "h-5 w-5 text-muted-foreground" }),
                            action.badge !== void 0 && action.badge !== null && action.badge !== 0 && action.badge !== "" && /* @__PURE__ */ jsx(
                              Box,
                              {
                                as: "span",
                                className: cn(
                                  "absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full text-xs font-semibold flex items-center justify-center",
                                  action.variant === "danger" ? "bg-error text-error-foreground" : action.variant === "primary" ? "bg-primary text-primary-foreground" : "bg-foreground text-background"
                                ),
                                children: action.badge
                              }
                            )
                          ]
                        },
                        `${action.event ?? action.navigatesTo ?? "action"}-${idx}`
                      )),
                      notificationsEnabled && /* @__PURE__ */ jsxs(
                        Button,
                        {
                          variant: "ghost",
                          className: "relative p-2",
                          onClick: handleNotificationClick,
                          "aria-label": t("common.notifications"),
                          children: [
                            /* @__PURE__ */ jsx(Icon, { name: "bell", className: "h-5 w-5 text-muted-foreground" }),
                            unreadCount > 0 && /* @__PURE__ */ jsx(
                              Box,
                              {
                                as: "span",
                                className: "absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-error rounded-full text-xs font-semibold text-error-foreground flex items-center justify-center",
                                children: unreadCount > 99 ? "99+" : unreadCount
                              }
                            )
                          ]
                        }
                      ),
                      user?.name && /* @__PURE__ */ jsx(
                        Menu,
                        {
                          position: "bottom-end",
                          header: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
                            /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", as: "p", children: user.name }),
                            user.email && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", as: "p", children: user.email })
                          ] }),
                          trigger: /* @__PURE__ */ jsxs(Button, { variant: "ghost", className: "flex items-center gap-2 p-2", children: [
                            /* @__PURE__ */ jsx(
                              Avatar,
                              {
                                src: user.avatar,
                                alt: user.name,
                                initials: user.name.split(" ").map((n) => n[0]).join("").substring(0, 2),
                                size: "sm"
                              }
                            ),
                            /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", as: "span", className: "hidden @sm/dashboard:block text-foreground", children: user.name }),
                            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: "hidden @sm/dashboard:block h-4 w-4 text-muted-foreground" })
                          ] }),
                          items: [
                            ...userMenuItems.map((action, idx) => ({
                              id: `${action.event ?? action.navigatesTo ?? "entry"}-${idx}`,
                              label: action.label ?? "",
                              icon: action.icon,
                              variant: action.variant === "danger" ? "danger" : void 0,
                              onClick: () => handleTopBarActionClick(action)
                            })),
                            { id: "sign-out", label: t("auth.signOut"), icon: "log-out", variant: "danger", onClick: () => handleSignOut?.() }
                          ]
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          ),
          isTopNav && isMobile && /* @__PURE__ */ jsx(
            Drawer,
            {
              isOpen: topNavMenuOpen,
              onClose: () => setTopNavMenuOpen(false),
              title: appName,
              position: "left",
              children: /* @__PURE__ */ jsx(VStack, { as: "nav", "aria-label": t("aria.mainNavigation"), gap: "none", className: "space-y-1", children: navItems.map((item) => /* @__PURE__ */ jsx(NavLink, { item, activeHref }, item.href)) })
            }
          ),
          /* @__PURE__ */ jsx(
            Box,
            {
              as: "main",
              ref: mainRef,
              id: "main-content",
              tabIndex: -1,
              className: cn(
                fullBleed ? "flex-1 min-h-0 flex flex-col focus:outline-none" : "flex-1 p-3 @sm/dashboard:p-4 @md/dashboard:p-6 focus:outline-none",
                // Reserve space for the fixed bottom nav so content isn't
                // hidden under the tab bar.
                showBottomNav && "pb-[calc(5rem+env(safe-area-inset-bottom))]"
              ),
              children: /* @__PURE__ */ jsx(PageTransition, { locationKey: activePath, className: fullBleed ? "w-full flex-1 min-h-0" : "mx-auto w-full max-w-[1440px]", children })
            }
          ),
          showBottomNav && /* @__PURE__ */ jsx(
            Box,
            {
              as: "nav",
              "aria-label": t("aria.mainNavigation"),
              className: "fixed bottom-0 inset-x-0 z-20 pb-[env(safe-area-inset-bottom)] bg-card surface-material border-t-[length:var(--border-width)] border-border",
              children: /* @__PURE__ */ jsx(HStack, { align: "center", justify: "around", className: "h-16 px-2", children: navItems.map((item) => /* @__PURE__ */ jsx(
                NavLinkBottom,
                {
                  item,
                  activeHref
                },
                item.href
              )) })
            }
          )
        ] })
      ]
    }
  );
};
DashboardLayout.displayName = "DashboardLayout";
var NavLink = ({
  item,
  activeHref,
  compact = false
}) => {
  const hasChildren = !!item.children?.length;
  const childActive = hasChildren && item.children.some((child) => child.href === activeHref);
  const isActive = item.href === activeHref || childActive;
  const [open, setOpen] = useState(childActive);
  const iconClassName = cn(
    "h-5 w-5",
    isActive ? "text-primary-foreground" : "text-muted-foreground"
  );
  if (compact) {
    if (hasChildren) {
      return /* @__PURE__ */ jsxs(Box, { className: "relative", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            title: item.label,
            "aria-label": item.label,
            "aria-expanded": open,
            className: cn(
              "flex items-center justify-center w-full px-2 py-2 rounded-interactive transition-colors",
              isActive ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "text-muted-foreground hover:bg-muted hover:text-foreground"
            ),
            onClick: () => setOpen(!open),
            children: /* @__PURE__ */ jsxs(Box, { as: "span", className: "relative inline-flex", children: [
              item.icon ? typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName }) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold", as: "span", children: item.label.charAt(0).toUpperCase() }),
              item.badge && /* @__PURE__ */ jsx(
                Badge,
                {
                  variant: isActive ? "primary" : "default",
                  size: "sm",
                  className: "absolute -top-2 -right-2 px-1 py-0 text-[10px] leading-4",
                  children: item.badge
                }
              )
            ] })
          }
        ),
        open && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Box, { className: "fixed inset-0 z-20", onClick: () => setOpen(false) }),
          /* @__PURE__ */ jsx(Box, { className: "absolute left-full top-0 ml-2 w-48 bg-card surface-material rounded-container shadow-elevation-popover border border-border py-1 z-30", children: item.children.map((child) => {
            const childIsActive = child.href === activeHref;
            return /* @__PURE__ */ jsxs(
              Link$1,
              {
                to: child.href,
                "aria-current": child.href === activeHref ? "page" : void 0,
                onClick: () => setOpen(false),
                className: cn(
                  "flex items-center gap-2 px-3 py-2 text-sm transition-colors",
                  childIsActive ? "bg-muted text-foreground font-medium" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                ),
                children: [
                  child.icon && (typeof child.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: child.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(child.icon, { className: "h-4 w-4" })),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "flex-1", as: "span", children: child.label }),
                  child.badge && /* @__PURE__ */ jsx(Badge, { variant: childIsActive ? "primary" : "default", size: "sm", children: child.badge })
                ]
              },
              child.href
            );
          }) })
        ] })
      ] });
    }
    return /* @__PURE__ */ jsx(
      Link$1,
      {
        to: item.href,
        "aria-current": item.href === activeHref ? "page" : void 0,
        title: item.label,
        "aria-label": item.label,
        className: cn(
          "flex items-center justify-center px-2 py-2 rounded-interactive transition-colors",
          isActive ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "text-muted-foreground hover:bg-muted hover:text-foreground"
        ),
        children: /* @__PURE__ */ jsxs(Box, { as: "span", className: "relative inline-flex", children: [
          item.icon ? typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName }) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold", as: "span", children: item.label.charAt(0).toUpperCase() }),
          item.badge && /* @__PURE__ */ jsx(
            Badge,
            {
              variant: isActive ? "primary" : "default",
              size: "sm",
              className: "absolute -top-2 -right-2 px-1 py-0 text-[10px] leading-4",
              children: item.badge
            }
          )
        ] })
      }
    );
  }
  if (hasChildren) {
    return /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          "aria-expanded": open,
          className: cn(
            "flex items-center gap-3 w-full px-3 py-2 rounded-interactive text-sm font-medium transition-colors",
            isActive ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "text-muted-foreground hover:bg-muted hover:text-foreground"
          ),
          onClick: () => setOpen(!open),
          children: [
            item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "small",
                color: isActive ? "inherit" : "primary",
                className: "flex-1 text-left",
                as: "span",
                children: item.label
              }
            ),
            item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge }),
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: "chevron-down",
                className: cn("h-4 w-4 shrink-0 transition-transform", open && "rotate-180")
              }
            )
          ]
        }
      ),
      open && /* @__PURE__ */ jsx(
        VStack,
        {
          gap: "none",
          className: "mt-1 ml-4 pl-4 border-s-[length:var(--border-width)] border-border space-y-1",
          children: item.children.map((child) => {
            const childIsActive = child.href === activeHref;
            return /* @__PURE__ */ jsxs(
              Link$1,
              {
                to: child.href,
                "aria-current": child.href === activeHref ? "page" : void 0,
                className: cn(
                  "flex items-center gap-2 px-3 py-1.5 rounded-interactive text-sm transition-colors",
                  childIsActive ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "text-muted-foreground hover:bg-muted hover:text-foreground"
                ),
                children: [
                  child.icon && (typeof child.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: child.icon, className: "h-4 w-4" }) : /* @__PURE__ */ jsx(child.icon, { className: "h-4 w-4" })),
                  /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "small",
                      color: childIsActive ? "inherit" : "primary",
                      className: "flex-1",
                      as: "span",
                      children: child.label
                    }
                  ),
                  child.badge && /* @__PURE__ */ jsx(Badge, { variant: childIsActive ? "primary" : "default", size: "sm", children: child.badge })
                ]
              },
              child.href
            );
          })
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs(
    Link$1,
    {
      to: item.href,
      "aria-current": item.href === activeHref ? "page" : void 0,
      className: cn(
        "flex items-center gap-3 px-3 py-2 rounded-interactive text-sm font-medium transition-colors",
        isActive ? "bg-primary text-primary-foreground shadow-elevation-interactive" : "text-muted-foreground hover:bg-muted hover:text-foreground"
      ),
      children: [
        item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "small",
            color: isActive ? "inherit" : "primary",
            className: "flex-1",
            as: "span",
            children: item.label
          }
        ),
        item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", children: item.badge })
      ]
    }
  );
};
NavLink.displayName = "NavLink";
var NavLinkBottom = ({
  item,
  activeHref
}) => {
  const isActive = item.href === activeHref;
  const iconClassName = cn(
    "h-5 w-5",
    isActive ? "text-primary" : "text-muted-foreground"
  );
  return /* @__PURE__ */ jsxs(
    Link$1,
    {
      to: item.href,
      "aria-current": item.href === activeHref ? "page" : void 0,
      className: "flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-interactive transition-colors flex-1 min-w-0",
      children: [
        item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, className: iconClassName }) : /* @__PURE__ */ jsx(item.icon, { className: iconClassName })),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            className: cn(
              "text-xs leading-tight truncate max-w-full",
              isActive ? "text-primary font-medium" : "text-muted-foreground"
            ),
            as: "span",
            children: item.label
          }
        ),
        item.badge && /* @__PURE__ */ jsx(Badge, { variant: isActive ? "primary" : "default", size: "sm", className: "text-xs px-1 py-0 min-w-0", children: item.badge })
      ]
    }
  );
};
NavLinkBottom.displayName = "NavLinkBottom";

// lib/entityRows.ts
function entityRows(entity) {
  if (isRowList(entity)) return entity;
  return entity ? [entity] : [];
}
function isRowList(entity) {
  return Array.isArray(entity);
}

// lib/relationLabel.ts
function relationLabel(value) {
  if (value === null || typeof value !== "object" || Array.isArray(value) || value instanceof Date)
    return null;
  for (const key of ["name", "title", "label"]) {
    const candidate = value[key];
    if (typeof candidate === "string" && candidate !== "") return candidate;
  }
  const id = value.id;
  return id !== void 0 && id !== null ? String(id) : null;
}
function relationDisplayLabels(value, options) {
  if (value === void 0 || value === null || value === "") return [];
  if (Array.isArray(value)) {
    return value.flatMap((item) => relationDisplayLabels(item, options));
  }
  const hydrated = relationLabel(value);
  if (hydrated !== null) return [hydrated];
  const raw = String(value);
  const match = options?.find((opt) => opt.value === raw);
  return [match ? match.label : raw];
}
function resolveRelationCellDisplay(value, options) {
  if (value === null || value === void 0 || value === "") return void 0;
  const isObjectShaped = typeof value === "object" && !(value instanceof Date) || Array.isArray(value) && value.some((v) => v !== null && typeof v === "object" && !(v instanceof Date));
  if (!isObjectShaped && !options) return void 0;
  const labels = relationDisplayLabels(value, options);
  return labels.length > 0 ? labels.join(", ") : void 0;
}
var whenLog = createLogger("almadar:ui:row-action-when");
function lambdaParts(when) {
  if (!Array.isArray(when) || when.length !== 3 || when[0] !== "fn") return null;
  const params = when[1];
  const param = typeof params === "string" ? params : Array.isArray(params) && params.length === 1 ? params[0] : null;
  if (typeof param !== "string" || param.length === 0) return null;
  return { param: param.startsWith("@") ? param.slice(1) : param, body: when[2] };
}
function contextFor(row, param, bindings) {
  const base = createMinimalContext(bindings.entity ?? {}, {}, "idle");
  base.user = bindings.user ?? ANONYMOUS_USER;
  if (bindings.config !== void 0) base.config = bindings.config;
  return createChildContext(base, /* @__PURE__ */ new Map([[param, row]]));
}
function rowActionPayload(action, row, bindings) {
  const base = { id: row.id, row };
  const declared = action.payload;
  if (declared === void 0) return base;
  try {
    if (typeof declared === "function") return { ...base, ...declared(row) };
    const lambda = lambdaParts(declared);
    if (lambda === null) {
      whenLog.warn("malformed-payload", { payload: JSON.stringify(declared) });
      return base;
    }
    const ctx = contextFor(row, lambda.param, bindings);
    const body = lambda.body;
    const out = { ...base };
    if (body !== null && typeof body === "object" && !Array.isArray(body)) {
      for (const [key, expr] of Object.entries(body)) {
        const value2 = evaluate(expr, ctx);
        if (isEventPayloadValue(value2)) out[key] = value2;
      }
      return out;
    }
    const value = evaluate(body, ctx);
    if (value !== null && typeof value === "object" && !Array.isArray(value)) {
      for (const [key, v] of Object.entries(value)) {
        if (isEventPayloadValue(v)) out[key] = v;
      }
    }
    return out;
  } catch (error) {
    whenLog.warn("payload-threw", { message: error instanceof Error ? error.message : String(error) });
    return base;
  }
}
function isActionShownForRow(action, row, bindings) {
  const when = action.when;
  if (when === void 0) return true;
  if (typeof when === "function") {
    try {
      return when(row) === true;
    } catch (error) {
      whenLog.warn("when-threw", { message: error instanceof Error ? error.message : String(error) });
      return false;
    }
  }
  const lambda = lambdaParts(when);
  if (lambda === null) {
    whenLog.warn("malformed-when", { when: JSON.stringify(when) });
    return false;
  }
  try {
    return evaluate(lambda.body, contextFor(row, lambda.param, bindings)) === true;
  } catch (error) {
    whenLog.warn("when-threw", { message: error instanceof Error ? error.message : String(error) });
    return false;
  }
}
function actionsShownForRow(actions, row, bindings) {
  if (!actions.some((a) => a.when !== void 0)) return actions;
  return actions.filter((a) => isActionShownForRow(a, row, bindings));
}

// hooks/useRowActions.ts
function useRowActions() {
  const { user } = useUser();
  return useCallback(
    (actions, row) => actionsShownForRow(actions, row, { user }),
    [user]
  );
}
function useRowActionPayload() {
  const { user } = useUser();
  return useCallback(
    (action, row) => rowActionPayload(action, row, { user }),
    [user]
  );
}
function useRowActionFire() {
  const eventBus = useEventBus();
  const payloadFor = useRowActionPayload();
  const { isRowPending, activateRow } = usePendingRows();
  const fire = useCallback((action, row, rowKey) => {
    if (!action.event) return;
    const event = action.event;
    activateRow(rowKey, (pendingKey) => eventBus.emit(`UI:${event}`, payloadFor(action, row), { pendingKey }));
  }, [eventBus, payloadFor, activateRow]);
  return { fire, isRowPending };
}
var ALMADAR_DND_ACTIVATION_DISTANCE = 5;
function useAlmadarDndSensors(withSortableKeyboard = true) {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: ALMADAR_DND_ACTIVATION_DISTANCE }
    }),
    useSensor(
      KeyboardSensor,
      withSortableKeyboard ? { coordinateGetter: sortableKeyboardCoordinates } : void 0
    )
  );
}
function innermostFirst(collisions, containers) {
  const nodeOf = new Map(containers.map((c) => [c.id, c.node.current]));
  const depth = (id) => {
    const node = nodeOf.get(id);
    return node ? collisions.filter((other) => other.id !== id && nodeOf.get(other.id)?.contains(node)).length : 0;
  };
  const depths = new Map(collisions.map((c) => [c.id, depth(c.id)]));
  return [...collisions].sort((a, b) => (depths.get(b.id) ?? 0) - (depths.get(a.id) ?? 0));
}
var almadarDndCollisionDetection = (args) => {
  const pw = pointerWithin(args);
  if (pw.length > 0) return innermostFirst(pw, args.droppableContainers);
  const ri = rectIntersection(args);
  if (ri.length > 0) return ri;
  return closestCorners(args);
};
var dndLog = createLogger("almadar:ui:dnd");
var RootCtx = React93__default.createContext(null);
function useDataDnd(args) {
  const {
    dragGroup,
    accepts: accepts2,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField = "id",
    dndRoot,
    items,
    layout
  } = args;
  const isZone = Boolean(dragGroup || accepts2 || sortable);
  const enabled = isZone || Boolean(dndRoot);
  const eventBus = useEventBus();
  const parentRoot = React93__default.useContext(RootCtx);
  const isRoot = enabled && parentRoot === null;
  const zoneId = React93__default.useId();
  const ownGroup = dragGroup ?? accepts2 ?? zoneId;
  const [optimisticOrders, setOptimisticOrders] = React93__default.useState(() => /* @__PURE__ */ new Map());
  const optimisticOrdersRef = React93__default.useRef(optimisticOrders);
  optimisticOrdersRef.current = optimisticOrders;
  const clearOptimisticOrder = React93__default.useCallback((group) => {
    setOptimisticOrders((prev) => {
      if (!prev.has(group)) return prev;
      const next = new Map(prev);
      next.delete(group);
      return next;
    });
  }, []);
  const sharedOptimistic = isRoot ? optimisticOrders : parentRoot?.optimisticOrders ?? /* @__PURE__ */ new Map();
  const optimisticEntry = sharedOptimistic.get(ownGroup);
  const orderedItems = optimisticEntry ?? items;
  if (isZone && enabled) {
    dndLog.debug("hook:render", {
      group: ownGroup,
      isRoot,
      itemsLen: items.length,
      optimisticEntryLen: optimisticEntry ? optimisticEntry.length : null,
      orderedLen: orderedItems.length,
      sharedKeys: Array.from(sharedOptimistic.keys())
    });
  }
  const itemIdsSignature = orderedItems.map((it, idx) => {
    const raw = it[dndItemIdField];
    return raw != null ? String(raw) : `__idx_${idx}`;
  }).join("|");
  const itemIds = React93__default.useMemo(
    () => orderedItems.map((it, idx) => {
      const raw = it[dndItemIdField];
      return raw != null ? String(raw) : `__idx_${idx}`;
    }),
    [itemIdsSignature]
  );
  const itemsContentSig = items.map((it, idx) => {
    const raw = it[dndItemIdField];
    return raw != null ? String(raw) : `__${idx}`;
  }).join("|");
  React93__default.useEffect(() => {
    const root = isRoot ? null : parentRoot;
    if (root) {
      root.clearOptimisticOrder(ownGroup);
    } else {
      clearOptimisticOrder(ownGroup);
    }
  }, [itemsContentSig, ownGroup]);
  const zonesRef = React93__default.useRef(/* @__PURE__ */ new Map());
  const registerZone = React93__default.useCallback((zoneId2, meta2) => {
    zonesRef.current.set(zoneId2, meta2);
  }, []);
  const unregisterZone = React93__default.useCallback((zoneId2) => {
    zonesRef.current.delete(zoneId2);
  }, []);
  const [activeDrag, setActiveDrag] = React93__default.useState(null);
  const [overZoneGroup, setOverZoneGroup] = React93__default.useState(null);
  const meta = React93__default.useMemo(
    () => ({ group: ownGroup, dropEvent, reorderEvent, positionEvent, itemIds, rawItems: items, idField: dndItemIdField }),
    [ownGroup, dropEvent, reorderEvent, positionEvent, itemIds, items, dndItemIdField]
  );
  React93__default.useEffect(() => {
    const target = isRoot ? null : parentRoot;
    if (!target) {
      zonesRef.current.set(zoneId, meta);
      dndLog.debug("zone:register:self", { zoneId, group: meta.group, itemCount: meta.itemIds.length, isRoot });
      return () => {
        zonesRef.current.delete(zoneId);
        dndLog.debug("zone:unregister:self", { zoneId, group: meta.group });
      };
    }
    target.registerZone(zoneId, meta);
    dndLog.debug("zone:register", { zoneId, group: meta.group, itemCount: meta.itemIds.length, dropEvent: meta.dropEvent, reorderEvent: meta.reorderEvent });
    return () => {
      target.unregisterZone(zoneId);
      dndLog.debug("zone:unregister", { zoneId, group: meta.group });
    };
  }, [parentRoot, isRoot, zoneId, meta]);
  const sensors = useAlmadarDndSensors(true);
  const collisionDetection = almadarDndCollisionDetection;
  const findZoneByItem = React93__default.useCallback(
    (id) => {
      for (const z of zonesRef.current.values()) {
        if (z.itemIds.includes(id)) return z;
      }
      return void 0;
    },
    []
  );
  React93__default.useCallback(
    (group) => {
      for (const z of zonesRef.current.values()) {
        if (z.group === group) return z;
      }
      return void 0;
    },
    []
  );
  const handleDragEnd = React93__default.useCallback(
    (event) => {
      const { active, over } = event;
      const activeIdStr = String(active.id);
      dndLog.debug("dragEnd:received", {
        activeId: active.id,
        overId: over?.id,
        overData: over?.data?.current
      });
      let sourceMeta;
      let oldIndex = -1;
      let targetMeta;
      let newIndex = -1;
      for (const m of zonesRef.current.values()) {
        const rawIdx = m.rawItems.findIndex((it) => String(it[m.idField]) === activeIdStr);
        if (rawIdx >= 0) {
          sourceMeta = m;
          oldIndex = rawIdx;
        }
        const currentItems = optimisticOrdersRef.current.get(m.group) ?? m.rawItems;
        const curIdx = currentItems.findIndex((it) => String(it[m.idField]) === activeIdStr);
        if (curIdx >= 0) {
          targetMeta = m;
          newIndex = curIdx;
        }
      }
      if (!sourceMeta || !targetMeta) {
        dndLog.warn("dragEnd:abort:no-zone-resolved", { activeId: active.id, hasSource: !!sourceMeta, hasTarget: !!targetMeta });
        return;
      }
      const emitPositions = (zoneMeta) => {
        if (!zoneMeta.positionEvent) {
          dndLog.debug("dragEnd:positions:no-event", { group: zoneMeta.group });
          return;
        }
        const evt = `UI:${zoneMeta.positionEvent}`;
        const order = optimisticOrdersRef.current.get(zoneMeta.group) ?? zoneMeta.rawItems;
        order.forEach((it, idx) => {
          const id = String(it[zoneMeta.idField]);
          const position = idx * 1e3;
          eventBus.emit(evt, { id, position });
        });
        dndLog.info("dragEnd:positions:emitted", { event: evt, group: zoneMeta.group, count: order.length });
      };
      if (sourceMeta.group !== targetMeta.group) {
        if (targetMeta.dropEvent) {
          const evt = `UI:${targetMeta.dropEvent}`;
          dndLog.info("dragEnd:cross-container:emit", {
            event: evt,
            id: activeIdStr,
            sourceGroup: sourceMeta.group,
            targetGroup: targetMeta.group,
            newIndex
          });
          eventBus.emit(evt, {
            id: activeIdStr,
            sourceGroup: sourceMeta.group,
            targetGroup: targetMeta.group,
            newIndex
          });
        } else {
          dndLog.warn("dragEnd:cross-container:no-dropEvent-on-target", { targetGroup: targetMeta.group });
        }
        emitPositions(sourceMeta);
        emitPositions(targetMeta);
        return;
      }
      if (oldIndex === newIndex) {
        dndLog.debug("dragEnd:reorder:no-op", { sourceGroup: sourceMeta.group, oldIndex });
        return;
      }
      if (sourceMeta.reorderEvent) {
        const evt = `UI:${sourceMeta.reorderEvent}`;
        dndLog.info("dragEnd:reorder:emit", {
          event: evt,
          id: activeIdStr,
          oldIndex,
          newIndex
        });
        eventBus.emit(evt, {
          id: activeIdStr,
          oldIndex,
          newIndex
        });
      } else {
        dndLog.debug("dragEnd:reorder:no-reorderEvent", { sourceGroup: sourceMeta.group });
      }
      emitPositions(sourceMeta);
    },
    [eventBus]
  );
  const sortableData = React93__default.useMemo(() => ({ dndGroup: ownGroup }), [ownGroup]);
  const SortableItem = React93__default.useCallback(
    ({ id, children }) => {
      const {
        attributes,
        listeners: listeners2,
        setNodeRef,
        transform,
        transition,
        isDragging
      } = useSortable({ id, data: sortableData });
      const { role: dndRole, ...dndAttributes } = attributes;
      const style = {
        transform: CSS$1.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
        cursor: enabled ? "grab" : void 0,
        // Lift the dragged element above siblings so its visual movement
        // isn't hidden behind other cards / column boundaries.
        zIndex: isDragging ? 50 : void 0,
        position: isDragging ? "relative" : void 0
      };
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "touch-none",
          ref: setNodeRef,
          style,
          role: isAriaRole(dndRole) ? dndRole : void 0,
          ...dndAttributes,
          ...listeners2,
          children
        }
      );
    },
    [sortableData, enabled]
  );
  const DropZoneShell = ({ children }) => {
    const droppableId = `dnd-zone-${zoneId}`;
    const { setNodeRef, isOver } = useDroppable({
      id: droppableId,
      data: sortableData
    });
    const ctx = React93__default.useContext(RootCtx);
    const activeDrag2 = ctx?.activeDrag ?? null;
    const overZoneGroup2 = ctx?.overZoneGroup ?? null;
    const isThisZoneOver = overZoneGroup2 === ownGroup;
    const showForeignPlaceholder = isThisZoneOver && activeDrag2 != null && activeDrag2.sourceGroup !== ownGroup;
    dndLog.debug("dropzone:render", {
      group: ownGroup,
      isOver,
      isThisZoneOver,
      overZoneGroup: overZoneGroup2,
      activeDragSourceGroup: activeDrag2?.sourceGroup ?? null,
      activeDragHeight: activeDrag2?.height ?? null,
      showForeignPlaceholder,
      ctxAvailable: ctx != null
    });
    React93__default.useEffect(() => {
      dndLog.info("dropzone:isOver:change", { droppableId, group: ownGroup, isOver, isThisZoneOver, showForeignPlaceholder, activeDragSourceGroup: activeDrag2?.sourceGroup ?? null });
    }, [droppableId, isOver, isThisZoneOver, showForeignPlaceholder]);
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref: setNodeRef,
        "data-dnd-zone": ownGroup,
        "data-dnd-is-over": isThisZoneOver ? "true" : "false",
        className: isThisZoneOver ? "ring-2 ring-primary/40 ring-offset-2 rounded-container transition-all min-h-[3rem]" : "min-h-[3rem] rounded-container transition-all",
        children
      }
    );
  };
  const rootContextValue = React93__default.useMemo(
    () => ({ registerZone, unregisterZone, activeDrag, overZoneGroup, optimisticOrders, clearOptimisticOrder }),
    [registerZone, unregisterZone, activeDrag, overZoneGroup, optimisticOrders, clearOptimisticOrder]
  );
  const handleDragStart = React93__default.useCallback((event) => {
    const sourceZone = findZoneByItem(event.active.id);
    const rect = event.active.rect.current.initial;
    const height = rect?.height && rect.height > 0 ? rect.height : 64;
    if (sourceZone) {
      setActiveDrag({ sourceGroup: sourceZone.group, height });
      dndLog.info("dragStart:activeDrag:set", { sourceGroup: sourceZone.group, height, isRoot, hookZoneId: zoneId });
    } else {
      dndLog.warn("dragStart:no-source-zone", { activeId: event.active.id, zoneCount: zonesRef.current.size, isRoot });
    }
    dndLog.info("dragStart", {
      activeId: event.active.id,
      activeData: event.active.data?.current,
      sourceGroup: sourceZone?.group,
      height,
      zoneCount: zonesRef.current.size,
      isRoot
    });
  }, [findZoneByItem, isRoot, zoneId]);
  const handleDragOver = React93__default.useCallback((event) => {
    const { active, over } = event;
    const overData = over?.data?.current;
    const overGroup = overData?.dndGroup ?? null;
    setOverZoneGroup(overGroup);
    if (!over || !overGroup) return;
    const activeIdStr = String(active.id);
    let sourceMeta;
    let sourceGroup;
    for (const m of zonesRef.current.values()) {
      const currentItems = optimisticOrdersRef.current.get(m.group) ?? m.rawItems;
      const found = currentItems.find((it) => String(it[m.idField]) === activeIdStr);
      if (found) {
        sourceMeta = m;
        sourceGroup = m.group;
        break;
      }
    }
    if (!sourceMeta || !sourceGroup) {
      dndLog.debug("dragOver:no-source-zone", { activeId: active.id });
      return;
    }
    let targetMeta;
    for (const m of zonesRef.current.values()) {
      if (m.group === overGroup) {
        targetMeta = m;
        break;
      }
    }
    if (!targetMeta) {
      dndLog.debug("dragOver:no-target-zone", { overGroup });
      return;
    }
    if (sourceGroup === overGroup) {
      setOptimisticOrders((prev) => {
        const currentItems = prev.get(sourceGroup) ?? sourceMeta.rawItems;
        const oldIndex = currentItems.findIndex((it) => String(it[sourceMeta.idField]) === activeIdStr);
        const newIndex = currentItems.findIndex((it) => String(it[sourceMeta.idField]) === String(over.id));
        if (oldIndex === -1 || newIndex === -1 || oldIndex === newIndex) return prev;
        const reordered = arrayMove([...currentItems], oldIndex, newIndex);
        const next = new Map(prev);
        next.set(sourceGroup, reordered);
        return next;
      });
      return;
    }
    setOptimisticOrders((prev) => {
      const currentSource = prev.get(sourceGroup) ?? sourceMeta.rawItems;
      const currentTarget = prev.get(overGroup) ?? targetMeta.rawItems;
      const activeItem = currentSource.find((it) => String(it[sourceMeta.idField]) === activeIdStr);
      if (!activeItem) return prev;
      if (currentTarget.some((it) => String(it[targetMeta.idField]) === activeIdStr)) {
        return prev;
      }
      const newSource = currentSource.filter((it) => String(it[sourceMeta.idField]) !== activeIdStr);
      const overIdStr = String(over.id);
      const overIndex = currentTarget.findIndex((it) => String(it[targetMeta.idField]) === overIdStr);
      const insertAt = overIndex >= 0 ? overIndex : currentTarget.length;
      const newTarget = [
        ...currentTarget.slice(0, insertAt),
        activeItem,
        ...currentTarget.slice(insertAt)
      ];
      const next = new Map(prev);
      next.set(sourceGroup, newSource);
      next.set(overGroup, newTarget);
      dndLog.debug("dragOver:cross-zone:splice", { sourceGroup, overGroup, sourceLen: newSource.length, targetLen: newTarget.length, insertAt });
      return next;
    });
  }, []);
  const handleDragCancel = React93__default.useCallback((event) => {
    setActiveDrag(null);
    setOverZoneGroup(null);
    dndLog.warn("dragCancel", {
      activeId: event.active.id,
      reason: "dnd-kit cancelled the drag (escape key, pointer interrupted, or external)"
    });
  }, []);
  const handleDragEndWithCleanup = React93__default.useCallback((event) => {
    handleDragEnd(event);
    setActiveDrag(null);
    setOverZoneGroup(null);
  }, [handleDragEnd]);
  const wrapContainer = React93__default.useCallback(
    (children) => {
      if (!enabled) return children;
      const strategy = layout === "grid" ? rectSortingStrategy : verticalListSortingStrategy;
      if (!isZone) {
        if (!isRoot) return children;
        return /* @__PURE__ */ jsx(RootCtx.Provider, { value: rootContextValue, children: /* @__PURE__ */ jsx(
          DndContext,
          {
            sensors,
            collisionDetection,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragEnd: handleDragEndWithCleanup,
            onDragCancel: handleDragCancel,
            children
          }
        ) });
      }
      const inner = /* @__PURE__ */ jsx(DropZoneShell, { children: /* @__PURE__ */ jsx(SortableContext, { items: itemIds, strategy, children }) });
      if (isRoot) {
        return /* @__PURE__ */ jsx(RootCtx.Provider, { value: rootContextValue, children: /* @__PURE__ */ jsx(
          DndContext,
          {
            sensors,
            collisionDetection,
            onDragStart: handleDragStart,
            onDragOver: handleDragOver,
            onDragEnd: handleDragEndWithCleanup,
            onDragCancel: handleDragCancel,
            children: inner
          }
        ) });
      }
      return inner;
    },
    [enabled, isZone, layout, sensors, collisionDetection, handleDragStart, handleDragOver, handleDragEndWithCleanup, handleDragCancel, itemIds, isRoot, rootContextValue]
  );
  return {
    enabled,
    isZone,
    wrapContainer,
    SortableItem,
    orderedItems
  };
}

// lib/displayField.ts
function isDisplayField(input) {
  return typeof input.name === "string" && !("key" in input) && !("header" in input);
}
function normalizeDisplayField(input) {
  if (typeof input === "string") return input ? { name: input } : null;
  if (isDisplayField(input)) return input.name ? input : null;
  const name = input.name ?? input.key;
  if (!name) return null;
  const label = input.label ?? input.header;
  return label === void 0 ? { name } : { name, label };
}
function badgeVariantFor(value, colorMap) {
  const declared = colorMap?.[value];
  if (declared === void 0) return "default";
  return declared === "destructive" ? "danger" : declared;
}
function valueLabelFor(value, labels) {
  return labels?.[value] ?? value;
}
function titleFieldOf(fields) {
  return fields.find((f3) => f3.variant === "h3" || f3.variant === "h4");
}
var dataGridLog = createLogger("almadar:ui:data-grid");
function renderIconInput(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
var fieldLabel = (name) => name;
var gapStyles3 = {
  none: "gap-0",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8"
};
var lookStyles5 = {
  dense: "gap-2 [&>*]:p-card-sm",
  spacious: "gap-8 [&>*]:p-card-lg",
  striped: "[&>*:nth-child(even)]:bg-muted/30",
  borderless: "[&>*]:border-0 [&>*]:shadow-none",
  "card-rows": "[&>*]:shadow-elevation-card [&>*]:rounded-container [&>*]:border [&>*]:border-border [&>*]:p-card-md"
};
function DataGrid({
  entity,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  fields,
  columns,
  itemActions,
  itemClickEvent,
  maxInlineActions,
  scrollX = false,
  cols,
  gap = "md",
  minCardWidth = 280,
  className,
  isLoading = false,
  skeleton = "grid",
  error = null,
  imageField,
  selectable = false,
  selectionEvent,
  infiniteScroll,
  loadMoreEvent,
  hasMore,
  children,
  pageSize = 0,
  renderItem: schemaRenderItem,
  dragGroup,
  accepts: accepts2,
  sortable,
  dropEvent,
  reorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  look = "dense",
  surface = "auto",
  relationsData,
  itemEnter,
  ...rest
}) {
  const eventBus = useEventBus();
  const moves = useItemMoves(itemEnter !== void 0 && itemEnter !== "none");
  const nestedMoves = useNewItemMoveScope();
  const rowActions = useRowActions();
  useRowActionPayload();
  const { fire: fireRowAction, isRowPending } = useRowActionFire();
  const { t } = useTranslate();
  const contentSurface = useContentSurface(surface);
  const fmt2 = useFormatContext();
  const boolLabels = { yes: t("common.yes"), no: t("common.no") };
  const [selectedIds, setSelectedIds] = useState(/* @__PURE__ */ new Set());
  const [visibleCount, setVisibleCount] = useState(pageSize || Infinity);
  const fieldDefs = (Array.isArray(fields) ? fields : void 0) ?? (Array.isArray(columns) ? columns : void 0) ?? [];
  const actionDefs = Array.isArray(itemActions) ? itemActions : [];
  const allDataRaw = entityRows(entity);
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "grid",
    dragGroup,
    accepts: accepts2,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const allData = dnd.orderedItems;
  const data = pageSize > 0 ? allData.slice(0, visibleCount) : allData;
  const hasMoreLocal = pageSize > 0 && visibleCount < allData.length;
  const toggleSelection = useCallback((id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      if (selectionEvent) {
        const payload = { selectedIds: Array.from(next) };
        eventBus.emit(`UI:${selectionEvent}`, payload);
      }
      return next;
    });
  }, [selectionEvent, eventBus]);
  const toggleAll = useCallback(() => {
    setSelectedIds((prev) => {
      const allIds2 = data.map((item, i) => item.id || String(i));
      const allSelected2 = allIds2.length > 0 && allIds2.every((id) => prev.has(id));
      const next = allSelected2 ? /* @__PURE__ */ new Set() : new Set(allIds2);
      if (selectionEvent) {
        const payload = { selectedIds: Array.from(next) };
        eventBus.emit(`UI:${selectionEvent}`, payload);
      }
      return next;
    });
  }, [data, selectionEvent, eventBus]);
  const titleField = titleFieldOf(fieldDefs);
  const badgeFields = fieldDefs.filter((f3) => f3.variant === "badge" && f3 !== titleField);
  const bodyFields = fieldDefs.filter((f3) => f3 !== titleField && !badgeFields.includes(f3));
  const inlineCap = Math.min(maxInlineActions ?? 1, 1);
  const cardActionsFor = (itemData) => {
    const visible = rowActions(actionDefs, itemData);
    const inline = visible.filter((a) => a.variant === "primary").slice(0, inlineCap);
    return {
      visible,
      inline,
      menu: visible.filter((a) => !inline.includes(a))
    };
  };
  const fireAction = (action, itemData) => {
    if (action.navigatesTo) {
      const url = action.navigatesTo.replace(
        /\{\{row\.(\w+(?:\.\w+)*)\}\}/g,
        (_, field) => String(itemData[field] ?? "")
      );
      eventBus.emit("UI:NAVIGATE", { url, row: itemData });
      return;
    }
    fireRowAction(action, itemData, String(itemData.id ?? ""));
  };
  const handleActionClick = (action, itemData) => (e) => {
    e.stopPropagation();
    fireAction(action, itemData);
  };
  const renderItemFn = typeof schemaRenderItem === "function" ? schemaRenderItem : void 0;
  const itemRenderer = typeof children === "function" ? children : renderItemFn;
  const hasRenderProp = typeof itemRenderer === "function";
  useEffect(() => {
    if (data.length > 0 && !hasRenderProp && fieldDefs.length === 0) {
      const schemaArr = Array.isArray(schemaRenderItem) ? schemaRenderItem : null;
      const isFnLambda = schemaArr !== null && schemaArr.length >= 3 && (schemaArr[0] === "fn" || schemaArr[0] === "lambda");
      dataGridLog.warn("renderItem-unresolved", {
        rowCount: data.length,
        renderItemIsFnLambda: isFnLambda
      });
    }
  }, [data, hasRenderProp, schemaRenderItem, fieldDefs]);
  const gridTemplateColumns = cols ? void 0 : `repeat(auto-fit, minmax(min(${minCardWidth}px, 100%), 1fr))`;
  const colsClass = cols ? {
    1: "grid-cols-1",
    2: "@[30rem]:grid-cols-2",
    3: "@[30rem]:grid-cols-2 @[42rem]:grid-cols-3",
    4: "@[30rem]:grid-cols-2 @[42rem]:grid-cols-3 @[56rem]:grid-cols-4",
    5: "@[30rem]:grid-cols-2 @[42rem]:grid-cols-3 @[64rem]:grid-cols-5",
    6: "@[30rem]:grid-cols-2 @[42rem]:grid-cols-3 @[72rem]:grid-cols-6"
  }[cols] : void 0;
  const asRows = cols === 1 && !scrollX && !hasRenderProp;
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (data.length === 0) {
    const emptyNode = /* @__PURE__ */ jsx(
      EmptyState,
      {
        icon: emptyIcon,
        title: emptyTitle || t("empty.noItems"),
        description: emptyDescription,
        actionLabel: emptyAction?.label,
        actionEvent: emptyAction?.event
      }
    );
    return dnd.enabled ? /* @__PURE__ */ jsx(Fragment, { children: dnd.wrapContainer(emptyNode) }) : emptyNode;
  }
  const allIds = data.map((item, i) => item.id || String(i));
  const allSelected = allIds.length > 0 && allIds.every((id) => selectedIds.has(id));
  const someSelected = selectedIds.size > 0;
  const idFieldName = dndItemIdField ?? "id";
  return contentSurface.provide(dnd.wrapContainer(
    /* @__PURE__ */ jsx(ItemMoveScopeProvider, { value: nestedMoves, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "@container w-full min-w-0", ...domPassthrough(rest), "data-item-move-root": moves.root, children: [
      selectable && someSelected && /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center px-2 py-2 bg-muted rounded-container", children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: allSelected,
            onChange: toggleAll,
            "aria-label": t("aria.selectAll")
          }
        ),
        /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "font-semibold", children: [
          selectedIds.size,
          " ",
          t("common.selected")
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Box,
        {
          "data-grid-layout": asRows ? "rows" : "cards",
          "data-item-move-root": nestedMoves.id,
          className: cn(
            asRows ? cn("flex flex-col divide-y divide-border", contentSurface.className && cn(contentSurface.className, "overflow-hidden")) : cn("grid", gapStyles3[gap], scrollX ? "grid-flow-col overflow-x-auto snap-x snap-mandatory [&>*]:snap-start pb-2" : colsClass, lookStyles5[look]),
            className
          ),
          style: scrollX ? { gridAutoFlow: "column", gridAutoColumns: `minmax(min(${minCardWidth}px, 85%), 1fr)` } : gridTemplateColumns ? { gridTemplateColumns } : void 0,
          children: data.map((item, index) => {
            const itemData = item;
            const id = itemData.id || String(index);
            const isSelected = selectedIds.has(id);
            const rowAct = cardActionsFor(itemData);
            const handleCardClick = itemClickEvent ? () => eventBus.emit(`UI:${itemClickEvent}`, { id: itemData.id, row: itemData }) : void 0;
            const stopCardClick = handleCardClick ? (e) => e.stopPropagation() : void 0;
            const dndId = itemData[idFieldName] ?? `__idx_${index}`;
            const wrapDnd = (node) => dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: dndId, children: node }, dndId) : node;
            if (hasRenderProp) {
              return wrapDnd(
                /* @__PURE__ */ jsxs(
                  Box,
                  {
                    "data-entity-row": true,
                    "data-entity-id": id,
                    "data-item-key": id,
                    "data-item-move": moves.row ?? nestedMoves.id,
                    "data-row-pending": isRowPending(String(itemData.id ?? "")) || void 0,
                    "aria-busy": isRowPending(String(itemData.id ?? "")) || void 0,
                    "aria-current": isSelected ? "true" : void 0,
                    onClick: handleCardClick,
                    className: cn("relative group/rowactions", handleCardClick && "cursor-pointer", isSelected && "ring-2 ring-primary rounded-container", enterClassName(itemEnter)),
                    children: [
                      handleCardClick && /* @__PURE__ */ jsx(
                        Box,
                        {
                          ...rowOpenControlProps(true),
                          "aria-label": t("aria.openRow", { position: index + 1 }),
                          className: "absolute inset-0 rounded-[inherit] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset"
                        }
                      ),
                      /* @__PURE__ */ jsx(Box, { className: cn(handleCardClick && "relative"), children: itemRenderer(itemData, index) }),
                      rowAct.visible.length > 0 && /* @__PURE__ */ jsx(Box, { onClick: stopCardClick, className: "absolute top-2 right-2 z-10 opacity-0 group-hover/rowactions:opacity-100 focus-within:opacity-100 [@media(pointer:coarse)]:opacity-100 transition-opacity duration-fast", children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "rounded-container border border-border bg-card/95 backdrop-blur-sm shadow-elevation-popover surface-material p-0.5", children: [
                        rowAct.inline.map((action, idx) => /* @__PURE__ */ jsxs(
                          Button,
                          {
                            variant: "primary",
                            size: "sm",
                            onClick: handleActionClick(action, itemData),
                            "data-testid": action.event ? actionTestId(action.event) : void 0,
                            "data-row-id": String(itemData.id),
                            children: [
                              action.icon && renderIconInput(action.icon, { size: "xs", className: "mr-1" }),
                              action.label
                            ]
                          },
                          idx
                        )),
                        rowAct.menu.length > 0 && /* @__PURE__ */ jsx(
                          Menu,
                          {
                            position: "bottom-end",
                            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                            items: rowAct.menu.map((action) => ({
                              label: action.label,
                              icon: action.icon,
                              variant: action.variant === "danger" ? "danger" : "default",
                              onClick: () => fireAction(action, itemData)
                            }))
                          }
                        )
                      ] }) })
                    ]
                  },
                  id
                )
              );
            }
            const titleValue = getNestedValue(itemData, titleField?.name ?? "");
            const titleDisplay = resolveRelationCellDisplay(
              titleValue,
              titleField ? relationsData?.[titleField.name] : void 0
            ) ?? (titleValue !== void 0 && titleValue !== null ? String(titleValue) : void 0);
            const bodyContent = bodyFields.length > 0 ? /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
              bodyFields.filter((f3) => f3.variant === "caption" && f3.format !== "boolean").map((field) => {
                const value = getNestedValue(itemData, field.name);
                if (value === void 0 || value === null || value === "") return null;
                return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", className: "line-clamp-2", children: resolveRelationCellDisplay(value, relationsData?.[field.name]) ?? formatValue(value, field.format, fmt2) }, field.name);
              }),
              /* @__PURE__ */ jsx(HStack, { gap: "md", className: "flex-wrap gap-y-1", children: bodyFields.filter((f3) => (f3.variant !== "caption" || f3.format === "boolean") && f3.variant !== "progress").map((field) => {
                const value = getNestedValue(itemData, field.name);
                if (value === void 0 || value === null || value === "") return null;
                if (field.format === "boolean") {
                  return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                    field.icon && renderIconInput(field.icon, { size: "xs", className: "text-muted-foreground" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: field.label ?? fieldLabel(field.name) }),
                    /* @__PURE__ */ jsx(Badge, { variant: value ? "success" : "neutral", children: value ? boolLabels.yes : boolLabels.no })
                  ] }, field.name);
                }
                return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                  field.icon && renderIconInput(field.icon, { size: "xs", className: "text-muted-foreground" }),
                  /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: field.icon ? "sr-only" : void 0, children: (field.label ?? fieldLabel(field.name)) + ":" }),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: resolveRelationCellDisplay(value, relationsData?.[field.name]) ?? formatValue(value, field.format, fmt2) })
                ] }, field.name);
              }) }),
              bodyFields.filter((f3) => f3.variant === "progress").map((field) => {
                const value = getNestedValue(itemData, field.name);
                if (typeof value !== "number") return null;
                return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                  /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                    field.icon && renderIconInput(field.icon, { size: "xs", className: "text-muted-foreground" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: field.label ?? fieldLabel(field.name) })
                  ] }),
                  /* @__PURE__ */ jsx(ProgressBar, { value, max: 100 })
                ] }, field.name);
              })
            ] }) : null;
            return wrapDnd(
              /* @__PURE__ */ jsxs(
                Box,
                {
                  "data-entity-row": true,
                  "data-entity-id": id,
                  "data-item-key": id,
                  "data-item-move": moves.row ?? nestedMoves.id,
                  "data-row-pending": isRowPending(String(itemData.id ?? "")) || void 0,
                  "aria-busy": isRowPending(String(itemData.id ?? "")) || void 0,
                  "aria-current": isSelected ? "true" : void 0,
                  onClick: handleCardClick,
                  className: cn(
                    "relative",
                    enterClassName(itemEnter),
                    asRows ? "flex flex-row items-center gap-3 px-card-md transition-colors duration-fast hover:bg-muted/50" : cn(
                      // Each card is a surface; already on one, a hairline keeps the tiles apart.
                      contentSurface.className ?? "rounded-container border border-border",
                      "hover:shadow-elevation-dialog hover:border-primary transition-all",
                      "flex flex-col"
                    ),
                    handleCardClick && "cursor-pointer",
                    isSelected && (asRows ? "bg-primary/5" : "ring-2 ring-primary border-primary")
                  ),
                  children: [
                    imageField && (() => {
                      const imgUrl = resolveImageUrl(getNestedValue(itemData, imageField));
                      const mediaClass = asRows ? "w-12 h-12 flex-shrink-0 overflow-hidden rounded-container" : "w-full aspect-video overflow-hidden rounded-t-container";
                      if (!imgUrl) {
                        return /* @__PURE__ */ jsx(Box, { "data-media-placeholder": true, "aria-hidden": "true", className: cn(mediaClass, "flex items-center justify-center bg-muted text-muted-foreground"), children: /* @__PURE__ */ jsx(Icon, { name: "image", size: asRows ? "sm" : "lg" }) });
                      }
                      return /* @__PURE__ */ jsx(Box, { className: mediaClass, children: /* @__PURE__ */ jsx(
                        "img",
                        {
                          src: imgUrl,
                          alt: titleDisplay ?? "",
                          className: "w-full h-full object-cover",
                          loading: "lazy"
                        }
                      ) });
                    })(),
                    /* @__PURE__ */ jsx(Box, { className: cn(asRows ? "flex-1 min-w-0 py-card-sm" : cn("p-4", bodyFields.length > 0 && "pb-0")), children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: cn("justify-between", asRows ? "items-center" : "items-start"), children: [
                      selectable && /* @__PURE__ */ jsx(
                        Checkbox,
                        {
                          checked: isSelected,
                          onChange: () => toggleSelection(id),
                          onClick: (e) => e.stopPropagation(),
                          className: cn("mt-1 flex-shrink-0", STRETCHED_ABOVE),
                          "aria-label": t("card.selectItem", { item: titleDisplay ?? t("card.itemFallback") })
                        }
                      ),
                      /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: cn("flex-1 min-w-0", asRows && "flex-row flex-wrap items-center gap-x-2"), children: [
                        titleDisplay !== void 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center min-w-0", children: [
                          titleField?.icon && renderIconInput(titleField.icon, { size: "sm", className: "text-primary flex-shrink-0" }),
                          /* @__PURE__ */ jsx(
                            Box,
                            {
                              ...rowOpenControlProps(handleCardClick !== void 0),
                              className: cn("min-w-0", handleCardClick && STRETCHED_CONTROL),
                              children: /* @__PURE__ */ jsx(
                                Typography,
                                {
                                  variant: titleField?.variant === "h3" && !asRows ? "h3" : "h4",
                                  className: cn("font-semibold min-w-0", asRows ? "truncate" : "line-clamp-2 break-words"),
                                  children: titleDisplay
                                }
                              )
                            }
                          )
                        ] }),
                        badgeFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: badgeFields.map((field) => {
                          const val = getNestedValue(itemData, field.name);
                          if (val === void 0 || val === null || val === "") return null;
                          return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                            field.icon && renderIconInput(field.icon, { size: "xs" }),
                            /* @__PURE__ */ jsx(Badge, { variant: badgeVariantFor(String(val), field.colorMap), children: resolveRelationCellDisplay(val, relationsData?.[field.name]) ?? valueLabelFor(formatValue(val, field.format, fmt2), field.labels) })
                          ] }, field.name);
                        }) }),
                        asRows && bodyContent && /* @__PURE__ */ jsx(Box, { className: "basis-full min-w-0", children: bodyContent })
                      ] }),
                      rowAct.visible.length > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", onClick: stopCardClick, className: cn("flex-shrink-0", STRETCHED_ABOVE), children: [
                        rowAct.inline.map((action, idx) => /* @__PURE__ */ jsx(
                          Button,
                          {
                            variant: "primary",
                            size: "sm",
                            onClick: handleActionClick(action, itemData),
                            "data-testid": action.event ? actionTestId(action.event) : void 0,
                            "data-row-id": String(itemData.id),
                            "aria-label": action.label,
                            title: action.label,
                            className: cn(action.icon && "px-2"),
                            children: action.icon ? renderIconInput(action.icon, { size: "xs" }) : action.label
                          },
                          idx
                        )),
                        rowAct.menu.length > 0 && /* @__PURE__ */ jsx(
                          Menu,
                          {
                            position: "bottom-end",
                            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                            items: rowAct.menu.map((action) => ({
                              label: action.label,
                              icon: action.icon,
                              variant: action.variant === "danger" ? "danger" : "default",
                              onClick: () => fireAction(action, itemData)
                            }))
                          }
                        )
                      ] })
                    ] }) }),
                    !asRows && bodyContent && /* @__PURE__ */ jsx(Box, { className: "px-4 pt-2 pb-4 flex-1", children: bodyContent })
                  ]
                },
                id
              )
            );
          })
        }
      ),
      hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
            t("common.showMore"),
            " (",
            t("common.remaining", { count: allData.length - visibleCount }),
            ")"
          ]
        }
      ) }),
      infiniteScroll && loadMoreEvent && /* @__PURE__ */ jsx(
        InfiniteScrollSentinel,
        {
          loadMoreEvent,
          isLoading,
          hasMore
        }
      )
    ] }) })
  ));
}
DataGrid.displayName = "DataGrid";

// lib/groupRows.ts
function groupRows(items, field, format, fmt2 = {}) {
  const groups = /* @__PURE__ */ new Map();
  for (const item of items) {
    const raw = getNestedValue(item, field);
    const key = format ? formatValue(raw ?? void 0, format, fmt2) : String(raw ?? "");
    const group = groups.get(key);
    if (group) group.push(item);
    else groups.set(key, [item]);
  }
  return Array.from(groups.entries()).map(([label, groupItems]) => ({ label, items: groupItems }));
}
var dataListLog = createLogger("almadar:ui:data-list");
function renderIconInput2(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
var fieldLabel2 = (name) => name;
function formatValue2(value, format, fmt2, relationOptions) {
  const relationDisplay = resolveRelationCellDisplay(value, relationOptions);
  if (relationDisplay !== void 0) return relationDisplay;
  return formatValue(value, format, fmt2);
}
var listLookStyles = {
  dense: "[&_[data-entity-row]>div]:!py-1 [&_[data-entity-row]>div]:!px-3",
  spacious: "[&_[data-entity-row]>div]:!py-5 [&_[data-entity-row]>div]:!px-8",
  striped: "[&_[data-entity-row]:nth-child(even)>div]:bg-muted/30",
  borderless: "[&_[data-entity-row]>div]:!border-0 [&_[data-entity-row]>div]:!hover:border-transparent",
  "card-rows": "[&_[data-entity-row]>div]:surface-content [&_[data-entity-row]]:mb-2"
};
function DataList({
  entity,
  fields,
  columns,
  itemActions,
  itemEnter,
  maxInlineActions,
  itemClickEvent,
  gap = "none",
  variant = "default",
  groupBy,
  groupFormat,
  senderField,
  senderLabelField,
  currentUser,
  emptyMessage,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  className,
  isLoading = false,
  skeleton = "list",
  error = null,
  // Gesture props: reorderable, swipeLeftEvent, swipeRightEvent, longPressEvent
  // are consumed by the compiler to wrap items in SwipeableRow/SortableList.
  // DataList destructures them here to prevent DOM passthrough.
  reorderable: _reorderable,
  reorderEvent: _reorderEvent,
  swipeLeftEvent: _swipeLeftEvent,
  swipeLeftActions: _swipeLeftActions,
  swipeRightEvent: _swipeRightEvent,
  swipeRightActions: _swipeRightActions,
  longPressEvent: _longPressEvent,
  infiniteScroll,
  loadMoreEvent,
  hasMore,
  children,
  pageSize = 5,
  sortBy,
  sortDirection,
  renderItem: schemaRenderItem,
  dragGroup,
  accepts: accepts2,
  sortable: sortableProp,
  dropEvent,
  reorderEvent: dndReorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  look = "dense",
  surface = "auto",
  relationsData,
  ...rest
}) {
  const eventBus = useEventBus();
  const moves = useItemMoves(itemEnter !== void 0 && itemEnter !== "none");
  const rowActions = useRowActions();
  useRowActionPayload();
  const { fire: fireRowAction, isRowPending } = useRowActionFire();
  const { t } = useTranslate();
  const fmt2 = useFormatContext();
  const contentSurface = useContentSurface(look === "card-rows" ? "none" : surface);
  const [visibleCount, setVisibleCount] = React93__default.useState(pageSize || Infinity);
  const fieldDefs = fields ?? columns ?? [];
  const allDataRaw = entityRows(entity);
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "list",
    dragGroup,
    accepts: accepts2,
    sortable: sortableProp,
    dropEvent,
    reorderEvent: dndReorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const orderedData = dnd.orderedItems;
  const allData = React93__default.useMemo(
    () => sortRows(orderedData, sortBy, sortDirection),
    [orderedData, sortBy, sortDirection]
  );
  const data = pageSize > 0 ? allData.slice(0, visibleCount) : allData;
  const hasMoreLocal = pageSize > 0 && visibleCount < allData.length;
  const renderItemFn = typeof schemaRenderItem === "function" ? schemaRenderItem : void 0;
  const itemRenderer = typeof children === "function" ? children : renderItemFn;
  const hasRenderProp = typeof itemRenderer === "function";
  React93__default.useEffect(() => {
    const renderItemTypeOf = typeof schemaRenderItem;
    const childrenTypeOf = typeof children;
    if (data.length > 0 && !hasRenderProp) {
      const firstRow = data[0];
      const sampleKeys = firstRow ? Object.keys(firstRow).slice(0, 6) : [];
      const isFnLambda = Array.isArray(schemaRenderItem) && schemaRenderItem.length >= 3 && (schemaRenderItem[0] === "fn" || schemaRenderItem[0] === "lambda");
      dataListLog.warn("renderItem-unresolved", {
        rowCount: data.length,
        fieldsCount: fieldDefs.length,
        renderItemTypeOf,
        renderItemIsArray: Array.isArray(schemaRenderItem),
        renderItemIsFnLambda: isFnLambda,
        renderItemHead: Array.isArray(schemaRenderItem) ? String(schemaRenderItem[0]) : void 0,
        childrenTypeOf,
        sampleRowKeys: sampleKeys
      });
    }
  }, [data, hasRenderProp, schemaRenderItem, children, fieldDefs]);
  const titleField = titleFieldOf(fieldDefs);
  const avatarField = fieldDefs.find((f3) => f3.variant === "avatar");
  const overlineFields = fieldDefs.filter((f3) => f3.variant === "overline");
  const badgeFields = fieldDefs.filter((f3) => f3.variant === "badge" && f3 !== titleField);
  const progressFields = fieldDefs.filter((f3) => f3.variant === "progress");
  const proseFields = fieldDefs.filter((f3) => f3.variant === "caption" && f3.format !== "boolean");
  const bodyFields = fieldDefs.filter(
    (f3) => f3 !== titleField && f3.variant !== "avatar" && !overlineFields.includes(f3) && !badgeFields.includes(f3) && !progressFields.includes(f3) && !proseFields.includes(f3)
  );
  const fireAction = (action, itemData) => {
    if (action.navigatesTo) {
      const url = action.navigatesTo.replace(
        /\{\{row\.(\w+(?:\.\w+)*)\}\}/g,
        (_, field) => String(itemData[field] ?? "")
      );
      eventBus.emit("UI:NAVIGATE", { url, row: itemData });
      return;
    }
    fireRowAction(action, itemData, String(itemData.id ?? ""));
  };
  const handleActionClick = (action, itemData) => (e) => {
    e.stopPropagation();
    fireAction(action, itemData);
  };
  const renderItemActions = (itemData, onPrimary = false, only) => {
    if (!itemActions || itemActions.length === 0) return null;
    const shown = only ?? rowActions(itemActions, itemData);
    if (shown.length === 0) return null;
    const inline = maxInlineActions != null ? shown.slice(0, maxInlineActions) : shown;
    const overflow = maxInlineActions != null ? shown.slice(maxInlineActions) : [];
    return (
      // stopPropagation at the cluster: the "⋯" trigger opens the overflow
      // menu without also firing the row's default click (inline buttons
      // already stop it in handleActionClick; the Menu panel is portaled).
      /* @__PURE__ */ jsxs(HStack, { gap: "xs", onClick: itemClickEvent ? (e) => e.stopPropagation() : void 0, className: cn("flex-shrink-0", STRETCHED_ABOVE), children: [
        inline.map((action, idx) => /* @__PURE__ */ jsxs(
          Button,
          {
            variant: action.variant ?? "ghost",
            size: "sm",
            onClick: handleActionClick(action, itemData),
            "data-testid": actionTestId(action.event),
            "data-row-id": String(itemData.id),
            className: cn(
              action.variant === "danger" && "text-foreground hover:bg-error/10",
              // Must sit on the Button itself: the variant's own text colour
              // beats an inherited one from the row wrapper.
              onPrimary && "!text-primary-foreground hover:bg-primary-foreground/15"
            ),
            children: [
              action.icon && renderIconInput2(action.icon, { size: "xs", className: "mr-1" }),
              action.label
            ]
          },
          idx
        )),
        overflow.length > 0 && /* @__PURE__ */ jsx(
          Menu,
          {
            position: "bottom-end",
            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
            items: overflow.map((action) => ({
              label: action.label,
              icon: action.icon,
              variant: action.variant === "danger" ? "danger" : "default",
              onClick: () => fireAction(action, itemData)
            }))
          }
        )
      ] })
    );
  };
  const handleRowClick = (itemData) => () => {
    if (!itemClickEvent) return;
    const payload = {
      id: itemData.id,
      row: itemData
    };
    eventBus.emit(`UI:${itemClickEvent}`, payload);
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (data.length === 0) {
    const emptyNode = /* @__PURE__ */ jsx(
      EmptyState,
      {
        icon: emptyIcon,
        title: emptyTitle || emptyMessage || t("empty.noItems"),
        description: emptyDescription,
        actionLabel: emptyAction?.label,
        actionEvent: emptyAction?.event
      }
    );
    return dnd.enabled ? /* @__PURE__ */ jsx(Fragment, { children: dnd.wrapContainer(emptyNode) }) : emptyNode;
  }
  const gapClass = {
    none: "",
    sm: "gap-1",
    md: "gap-2",
    lg: "gap-4"
  }[gap];
  const isCard = variant === "card";
  const isCompact = variant === "compact";
  const isMessage = variant === "message";
  if (isMessage) {
    const items2 = [...data];
    const groups2 = groupBy ? groupRows(items2, groupBy, groupFormat, fmt2) : [{ label: "", items: items2 }];
    const contentField = (fieldDefs.find((f3) => f3.variant === "body") ?? titleField)?.name ?? "";
    const senderLabel = (itemData, raw) => {
      if (!senderLabelField) return raw;
      const v = getNestedValue(itemData, senderLabelField);
      return v === void 0 || v === null || v === "" ? raw : String(v);
    };
    return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn("py-2", className), "data-item-move-root": moves.root, children: [
      groups2.map((group, gi) => /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
        group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: "my-2" }),
        group.items.map((itemData, index) => {
          const id = itemData.id || `${gi}-${index}`;
          const sender = senderField ? String(getNestedValue(itemData, senderField) ?? "") : "";
          const isSent = Boolean(currentUser && sender === currentUser);
          const content = getNestedValue(itemData, contentField);
          const timestampField = fieldDefs.find((f3) => f3.format === "date");
          const timestamp = timestampField ? getNestedValue(itemData, timestampField.name) : null;
          const metaFields = fieldDefs.filter(
            (f3) => f3.name !== contentField && f3.name !== timestampField?.name
          );
          return /* @__PURE__ */ jsx(
            Box,
            {
              "data-entity-row": true,
              "data-entity-id": id,
              "data-item-key": id,
              "data-item-move": moves.row,
              "data-row-pending": isRowPending(String(itemData.id ?? "")) || void 0,
              "aria-busy": isRowPending(String(itemData.id ?? "")) || void 0,
              onClick: itemClickEvent ? handleRowClick(itemData) : void 0,
              className: cn(
                enterClassName(itemEnter),
                "relative flex px-4 group/rowactions",
                itemClickEvent && "cursor-pointer",
                isSent ? "justify-end" : "justify-start"
              ),
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  className: cn(
                    "max-w-[75%] px-4 py-2",
                    isSent ? "bg-primary text-primary-foreground rounded-container rounded-ee-sm" : "bg-muted text-foreground rounded-container rounded-es-sm"
                  ),
                  children: [
                    !isSent && senderField && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold mb-0.5", children: senderLabel(itemData, sender) }),
                    /* @__PURE__ */ jsx(Box, { ...rowOpenControlProps(itemClickEvent !== void 0), className: cn(itemClickEvent && STRETCHED_CONTROL), children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: cn(isSent && "text-primary-foreground"), children: content !== void 0 && content !== null ? String(content) : "" }) }),
                    metaFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "mt-1 flex-wrap", children: metaFields.map((f3) => {
                      const v = getNestedValue(itemData, f3.name);
                      if (v === void 0 || v === null || v === "") return null;
                      return f3.variant === "badge" ? (
                        // `format` applies here too — a boolean field badged
                        // without it renders the raw "false" instead of "No".
                        /* @__PURE__ */ jsx(Badge, { variant: badgeVariantFor(String(v), f3.colorMap), children: valueLabelFor(formatValue2(v, f3.format, fmt2, relationsData?.[f3.name]), f3.labels) }, f3.name)
                      ) : /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "caption",
                          className: cn("text-xs", isSent ? "opacity-70" : "text-muted-foreground"),
                          children: formatValue2(v, f3.format, fmt2, relationsData?.[f3.name])
                        },
                        f3.name
                      );
                    }) }),
                    /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "mt-1 items-center justify-between flex-wrap", children: [
                      timestamp != null ? /* @__PURE__ */ jsx(
                        Typography,
                        {
                          variant: "caption",
                          className: cn("text-xs whitespace-nowrap", isSent ? "opacity-70" : "text-muted-foreground"),
                          children: formatDate(timestamp)
                        }
                      ) : /* @__PURE__ */ jsx("span", {}),
                      renderItemActions(itemData, isSent)
                    ] })
                  ]
                }
              )
            },
            id
          );
        })
      ] }, gi)),
      hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
            t("common.showMore"),
            " (",
            t("common.remaining", { count: allData.length - visibleCount }),
            ")"
          ]
        }
      ) })
    ] });
  }
  const items = [...data];
  const groups = groupBy ? groupRows(items, groupBy, groupFormat, fmt2) : [{ label: "", items }];
  const idFieldName = dndItemIdField ?? "id";
  const renderItem = (itemData, index, isLast) => {
    const dndId = itemData[idFieldName] ?? `__idx_${index}`;
    const wrapDnd = (node) => dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: dndId, children: node }, dndId) : node;
    const rowId = String(itemData.id ?? "");
    const pending = isRowPending(rowId) || void 0;
    const onOpen = itemClickEvent ? handleRowClick(itemData) : void 0;
    const divider = (isCard || isCompact) && !isLast ? /* @__PURE__ */ jsx(Box, { className: cn("border-b border-border/40", isCompact ? "mx-4" : "mx-6") }) : null;
    if (hasRenderProp) {
      const id2 = itemData.id || String(index);
      const allActions = itemActions ? rowActions(itemActions, itemData) : [];
      const primaryActions = allActions.filter((a) => a.variant === "primary");
      const otherActions = allActions.filter((a) => a.variant !== "primary");
      const primary = primaryActions.length > 0 ? renderItemActions(itemData, false, primaryActions) : null;
      const actions = otherActions.length > 0 ? renderItemActions(itemData, false, otherActions) : null;
      return wrapDnd(
        /* @__PURE__ */ jsxs(
          Box,
          {
            "data-entity-row": true,
            "data-entity-id": id2,
            "data-item-key": id2,
            "data-item-move": moves.row,
            "data-row-pending": pending,
            "aria-busy": pending,
            onClick: onOpen,
            className: cn("relative group/rowactions", onOpen && "cursor-pointer", enterClassName(itemEnter)),
            children: [
              onOpen && /* @__PURE__ */ jsx(
                Box,
                {
                  ...rowOpenControlProps(true),
                  "aria-label": t("aria.openRow", { position: index + 1 }),
                  className: "absolute inset-0 rounded-[inherit] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset"
                }
              ),
              /* @__PURE__ */ jsx(Box, { className: cn(onOpen && "relative"), children: itemRenderer(itemData, index) }),
              primary && /* @__PURE__ */ jsx(HStack, { justify: "end", className: cn("relative px-4 pb-3", STRETCHED_ABOVE), children: primary }),
              actions && /* @__PURE__ */ jsxs(Box, { onClick: (e) => e.stopPropagation(), className: "absolute top-2 right-2 z-10 opacity-0 group-hover/rowactions:opacity-100 focus-within:opacity-100 [@media(pointer:coarse)]:opacity-100 transition-opacity duration-fast", children: [
                /* @__PURE__ */ jsx(Box, { className: "rounded-container border border-border bg-card/95 backdrop-blur-sm shadow-elevation-popover surface-material p-0.5 [@media(pointer:coarse)]:hidden", children: actions }),
                /* @__PURE__ */ jsx(Box, { className: "hidden [@media(pointer:coarse)]:block rounded-container border border-border bg-card/95 backdrop-blur-sm shadow-elevation-popover surface-material p-0.5", children: /* @__PURE__ */ jsx(
                  Menu,
                  {
                    position: "bottom-end",
                    trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                    items: otherActions.map((action) => ({
                      label: action.label,
                      icon: action.icon,
                      variant: action.variant === "danger" ? "danger" : "default",
                      onClick: () => fireAction(action, itemData)
                    }))
                  }
                ) })
              ] }),
              isCard && divider
            ]
          },
          id2
        )
      );
    }
    const id = itemData.id || String(index);
    const titleValue = getNestedValue(itemData, titleField?.name ?? "");
    const titleDisplay = resolveRelationCellDisplay(
      titleValue,
      titleField ? relationsData?.[titleField.name] : void 0
    ) ?? (titleValue !== void 0 && titleValue !== null ? String(titleValue) : void 0);
    const avatarValue = avatarField ? getNestedValue(itemData, avatarField.name) : void 0;
    const display = (field) => {
      const v = getNestedValue(itemData, field.name);
      return v === void 0 || v === null || v === "" ? void 0 : formatValue2(v, field.format, fmt2, relationsData?.[field.name]);
    };
    const titleNode = titleDisplay !== void 0 && /* @__PURE__ */ jsx(
      Typography,
      {
        variant: isCompact ? "small" : titleField?.variant === "h3" ? "h3" : "h4",
        weight: "semibold",
        className: isCompact ? "truncate" : "line-clamp-2 break-words",
        children: titleDisplay
      }
    );
    return wrapDnd(
      /* @__PURE__ */ jsxs(
        Box,
        {
          "data-entity-row": true,
          "data-entity-id": id,
          "data-item-key": id,
          "data-item-move": moves.row,
          "data-row-pending": pending,
          "aria-busy": pending,
          onClick: onOpen,
          className: cn("relative", onOpen && "cursor-pointer", enterClassName(itemEnter)),
          children: [
            /* @__PURE__ */ jsxs(
              Box,
              {
                className: cn(
                  // items-start, not items-center: a multi-line row (title + meta +
                  // progress) centred its action cluster in the vertical middle, so
                  // the buttons floated between the meta fields instead of anchoring
                  // to the title they act on (U-DATALIST-ACTIONS-FLOAT-MID-ROW).
                  "group flex items-start gap-4 transition-all duration-fast",
                  isCompact ? "px-4 py-2" : "px-6 py-4",
                  "hover:bg-muted/80",
                  !isCard && !isCompact && "rounded-container border border-transparent hover:border-border"
                ),
                children: [
                  avatarValue !== void 0 && avatarValue !== null && avatarValue !== "" && /* @__PURE__ */ jsx(Avatar, { name: String(avatarValue), size: isCompact ? "sm" : "md", className: "flex-shrink-0" }),
                  titleField?.icon && !isCompact && /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 w-10 h-10 rounded-container bg-primary/10 flex items-center justify-center", children: renderIconInput2(titleField.icon, { size: "sm", className: "text-primary" }) }),
                  /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
                    overlineFields.map((field) => {
                      const text = display(field);
                      return text === void 0 ? null : /* @__PURE__ */ jsx(Typography, { variant: "overline", className: "block text-primary mb-0.5", children: text }, field.name);
                    }),
                    /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center min-w-0", children: [
                      titleField?.icon && isCompact && renderIconInput2(titleField.icon, { size: "xs", className: "text-primary flex-shrink-0" }),
                      titleNode && (onOpen ? /* @__PURE__ */ jsx(Box, { ...rowOpenControlProps(true), className: cn("min-w-0 flex-1", STRETCHED_CONTROL), children: titleNode }) : /* @__PURE__ */ jsx(Box, { className: "min-w-0 flex-1", children: titleNode })),
                      badgeFields.map((field) => {
                        const val = getNestedValue(itemData, field.name);
                        if (val === void 0 || val === null || val === "") return null;
                        return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center flex-shrink-0", children: [
                          field.icon && renderIconInput2(field.icon, { size: "xs" }),
                          /* @__PURE__ */ jsx(Badge, { variant: badgeVariantFor(String(val), field.colorMap), children: valueLabelFor(formatValue2(val, field.format, fmt2, relationsData?.[field.name]), field.labels) })
                        ] }, field.name);
                      })
                    ] }),
                    proseFields.map((field) => {
                      const text = display(field);
                      return text === void 0 ? null : /* @__PURE__ */ jsx(Box, { className: isCompact ? "mt-0.5" : "mt-1", children: /* @__PURE__ */ jsx(Typography, { variant: isCompact ? "small" : "body", color: "secondary", className: cn("whitespace-pre-wrap break-words", isCompact && "line-clamp-1"), children: text }) }, field.name);
                    }),
                    bodyFields.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "md", className: cn("flex-wrap", isCompact ? "mt-0.5" : "mt-1.5"), children: bodyFields.map((field) => {
                      const value = getNestedValue(itemData, field.name);
                      if (value === void 0 || value === null || value === "") return null;
                      return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                        field.icon && renderIconInput2(field.icon, { size: "xs", className: "text-muted-foreground" }),
                        /* @__PURE__ */ jsxs(
                          Typography,
                          {
                            variant: "caption",
                            color: "secondary",
                            className: cn(field.format !== "boolean" && "sr-only"),
                            children: [
                              field.label ?? fieldLabel2(field.name),
                              ":"
                            ]
                          }
                        ),
                        /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: formatValue2(value, field.format, fmt2, relationsData?.[field.name]) })
                      ] }, field.name);
                    }) }),
                    progressFields.map((field) => {
                      const value = getNestedValue(itemData, field.name);
                      if (typeof value !== "number") return null;
                      return /* @__PURE__ */ jsxs(Box, { className: "mt-2 max-w-xs", children: [
                        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center mb-1", children: [
                          field.icon && renderIconInput2(field.icon, { size: "xs", className: "text-muted-foreground" }),
                          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: field.label ?? fieldLabel2(field.name) })
                        ] }),
                        /* @__PURE__ */ jsx(ProgressBar, { value, max: 100 })
                      ] }, field.name);
                    })
                  ] }),
                  renderItemActions(itemData)
                ]
              }
            ),
            divider
          ]
        },
        id
      )
    );
  };
  return contentSurface.provide(dnd.wrapContainer(
    /* @__PURE__ */ jsxs(
      Box,
      {
        ...domPassthrough(rest),
        "data-item-move-root": moves.root,
        className: cn(
          contentSurface.className && cn(contentSurface.className, "overflow-hidden"),
          // `gap-*` is inert on a block container, and Box only emits a display
          // class when its `display` prop is set — so every non-card list had
          // been asking for a gap that CSS silently dropped. flex-col makes it
          // real. `compact` keeps gap-0 on purpose: it separates with the row
          // divider above instead, never both (Almadar_UI_Beauty.md 6).
          !isCard && "flex flex-col",
          !isCard && !isCompact && gapClass,
          listLookStyles[look],
          className
        ),
        children: [
          groups.map((group, gi) => /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
            group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: gi > 0 ? "mt-4" : "mt-0" }),
            group.items.map(
              (itemData, index) => renderItem(itemData, index, gi === groups.length - 1 && index === group.items.length - 1)
            )
          ] }, gi)),
          hasMoreLocal && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: () => setVisibleCount((prev) => prev + (pageSize || 5)),
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
                t("common.showMore"),
                " (",
                t("common.remaining", { count: allData.length - visibleCount }),
                ")"
              ]
            }
          ) }),
          infiniteScroll && loadMoreEvent && /* @__PURE__ */ jsx(
            InfiniteScrollSentinel,
            {
              loadMoreEvent,
              isLoading,
              hasMore
            }
          )
        ]
      }
    )
  ));
}
DataList.displayName = "DataList";
function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}
function startOfQuarter(d) {
  return new Date(d.getFullYear(), Math.floor(d.getMonth() / 3) * 3, 1);
}
function startOfYear(d) {
  return new Date(d.getFullYear(), 0, 1);
}
function daysAgo(n) {
  const d = /* @__PURE__ */ new Date();
  d.setDate(d.getDate() - n);
  return d;
}
var TOKEN_RANGES = {
  "7d": () => ({ from: toDateInputValue(daysAgo(7)), to: toDateInputValue(/* @__PURE__ */ new Date()) }),
  "30d": () => ({ from: toDateInputValue(daysAgo(30)), to: toDateInputValue(/* @__PURE__ */ new Date()) }),
  month: () => ({ from: toDateInputValue(startOfMonth(/* @__PURE__ */ new Date())), to: toDateInputValue(/* @__PURE__ */ new Date()) }),
  quarter: () => ({ from: toDateInputValue(startOfQuarter(/* @__PURE__ */ new Date())), to: toDateInputValue(/* @__PURE__ */ new Date()) }),
  ytd: () => ({ from: toDateInputValue(startOfYear(/* @__PURE__ */ new Date())), to: toDateInputValue(/* @__PURE__ */ new Date()) })
};
var DEFAULT_PRESET_KEYS = [
  { value: "7d", labelKey: "dateRange.last7Days" },
  { value: "30d", labelKey: "dateRange.last30Days" },
  { value: "month", labelKey: "dateRange.thisMonth" },
  { value: "quarter", labelKey: "dateRange.thisQuarter" },
  { value: "ytd", labelKey: "dateRange.yearToDate" }
];
function resolvePresetRange(preset) {
  if (typeof preset.range === "function") return preset.range();
  if (preset.range) return preset.range;
  return TOKEN_RANGES[preset.value]?.() ?? null;
}
var DateRangePicker = ({
  from: fromProp,
  to: toProp,
  event,
  onChange,
  presets: presetsProp,
  fromLabel,
  toLabel,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const presets = useMemo(
    () => presetsProp ?? DEFAULT_PRESET_KEYS.map((p) => ({ value: p.value, label: t(p.labelKey) })),
    [presetsProp, t]
  );
  const [from, setFrom] = useState(fromProp ?? "");
  const [to, setTo] = useState(toProp ?? "");
  const [activePreset, setActivePreset] = useState(null);
  const emit = useCallback(
    (range) => {
      onChange?.(range);
      if (event) eventBus.emit(`UI:${event}`, range);
    },
    [onChange, event, eventBus]
  );
  const handleFromChange = useCallback(
    (next) => {
      setFrom(next);
      setActivePreset(null);
      emit({ from: next, to });
    },
    [to, emit]
  );
  const handleToChange = useCallback(
    (next) => {
      setTo(next);
      setActivePreset(null);
      emit({ from, to: next });
    },
    [from, emit]
  );
  const handlePreset = useCallback(
    (preset) => {
      const range = resolvePresetRange(preset);
      if (range === null) return;
      setFrom(range.from);
      setTo(range.to);
      setActivePreset(preset.value);
      emit(range);
    },
    [emit]
  );
  const renderablePresets = useMemo(
    () => presets.filter((p) => p.range !== void 0 || TOKEN_RANGES[p.value] !== void 0),
    [presets]
  );
  const presetButtons = useMemo(
    () => renderablePresets.map((preset) => /* @__PURE__ */ jsx(
      Button,
      {
        variant: activePreset === preset.value ? "primary" : "ghost",
        size: "sm",
        onClick: () => handlePreset(preset),
        children: preset.label
      },
      preset.value
    )),
    [renderablePresets, activePreset, handlePreset]
  );
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), gap: "sm", className: cn(className), children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "end", children: [
      /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: fromLabel ?? t("dateRange.from") }),
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "date",
            value: from,
            onChange: (e) => handleFromChange(e.target.value)
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: toLabel ?? t("dateRange.to") }),
        /* @__PURE__ */ jsx(
          Input,
          {
            type: "date",
            value: to,
            onChange: (e) => handleToChange(e.target.value)
          }
        )
      ] })
    ] }),
    renderablePresets.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: presetButtons })
  ] });
};
DateRangePicker.displayName = "DateRangePicker";
var DEFAULT_OPTIONS = [
  { label: "1W", value: "week" },
  { label: "1M", value: "month" },
  { label: "3M", value: "3months" },
  { label: "1Y", value: "year" }
];
var DateRangeSelector = ({
  options = DEFAULT_OPTIONS,
  selected = "month",
  onSelect,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(HStack, { ...domPassthrough(rest), gap: "xs", className: cn(className), children: options.map((option) => /* @__PURE__ */ jsx(
    Button,
    {
      variant: selected === option.value ? "primary" : "ghost",
      size: "sm",
      onClick: () => onSelect?.(option.value),
      children: option.label
    },
    option.value
  )) });
};
DateRangeSelector.displayName = "DateRangeSelector";
function useSafeEventBus4() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var Lightbox = ({
  images = [],
  currentIndex = 0,
  isOpen = false,
  showCounter = true,
  closeAction,
  onClose,
  onIndexChange,
  className,
  ...rest
}) => {
  const safeImages = Array.isArray(images) ? images : [];
  const [index, setIndex] = useState(currentIndex);
  const [touchStartX, setTouchStartX] = useState(null);
  const eventBus = useSafeEventBus4();
  const { t, direction } = useTranslate();
  const dialogRef = useRef(null);
  useEffect(() => {
    setIndex(currentIndex);
  }, [currentIndex]);
  const handleClose = useCallback(() => {
    if (closeAction) {
      eventBus.emit(`UI:${closeAction}`, {});
    }
    onClose?.();
  }, [closeAction, eventBus, onClose]);
  const goTo = useCallback(
    (newIndex) => {
      if (safeImages.length === 0) return;
      const clamped = Math.max(0, Math.min(safeImages.length - 1, newIndex));
      setIndex(clamped);
      onIndexChange?.(clamped);
    },
    [safeImages.length, onIndexChange]
  );
  const goPrev = useCallback(() => goTo(index - 1), [goTo, index]);
  const goNext = useCallback(() => goTo(index + 1), [goTo, index]);
  useDialogBehavior({ open: isOpen && safeImages.length > 0, containerRef: dialogRef, onEscape: handleClose });
  useEffect(() => {
    if (!isOpen) return;
    const nextKey = direction === "rtl" ? "ArrowLeft" : "ArrowRight";
    const prevKey = direction === "rtl" ? "ArrowRight" : "ArrowLeft";
    const handleKeyDown = (e) => {
      if (e.key === nextKey) goNext();
      else if (e.key === prevKey) goPrev();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, direction, goPrev, goNext]);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [isOpen]);
  if (!isOpen || safeImages.length === 0) return null;
  const currentImage = safeImages[index];
  const hasPrev = index > 0;
  const hasNext = index < safeImages.length - 1;
  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const diff = e.changedTouches[0].clientX - touchStartX;
    const threshold = 50;
    if (diff > threshold && hasPrev) goPrev();
    if (diff < -threshold && hasNext) goNext();
    setTouchStartX(null);
  };
  const overlayButton = "absolute z-10 rounded-full bg-card text-foreground hover:bg-muted";
  return /* @__PURE__ */ jsx(ThemedPortal, { children: /* @__PURE__ */ jsxs(
    Box,
    {
      ref: dialogRef,
      ...domPassthrough(rest),
      className: cn(
        "fixed inset-0 z-[1000] flex items-center justify-center",
        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: lightbox scrim behind images
        "bg-black/90",
        className
      ),
      onClick: handleClose,
      role: "dialog",
      "data-pattern": "lightbox",
      "aria-modal": "true",
      "aria-label": rest["aria-label"] ?? (currentImage?.alt || t("aria.imageViewer")),
      children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            icon: "x",
            onClick: (e) => {
              e.stopPropagation();
              handleClose();
            },
            className: cn(overlayButton, "top-4 end-4"),
            "aria-label": t("aria.closeModal")
          }
        ),
        hasPrev && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            icon: direction === "rtl" ? "chevron-right" : "chevron-left",
            onClick: (e) => {
              e.stopPropagation();
              goPrev();
            },
            className: cn(overlayButton, "start-4"),
            "aria-label": t("aria.previousImage")
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "flex items-center justify-center w-full h-full p-12",
            onClick: (e) => e.stopPropagation(),
            onTouchStart: handleTouchStart,
            onTouchEnd: handleTouchEnd,
            children: currentImage && /* @__PURE__ */ jsx(
              "img",
              {
                src: currentImage.src,
                alt: currentImage.alt ?? "",
                className: "max-w-full max-h-full object-contain select-none",
                draggable: false
              }
            )
          }
        ),
        hasNext && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            icon: direction === "rtl" ? "chevron-left" : "chevron-right",
            onClick: (e) => {
              e.stopPropagation();
              goNext();
            },
            className: cn(overlayButton, "end-4"),
            "aria-label": t("aria.nextImage")
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "absolute bottom-4 inset-x-0 text-center", children: [
          showCounter && safeImages.length > 1 && // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: text over the dark scrim
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-white mb-1", children: t("lightbox.counter", { current: index + 1, total: safeImages.length }) }),
          currentImage?.caption && // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: text over the dark scrim
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-white/80 px-8", children: currentImage.caption })
        ] })
      ]
    }
  ) });
};
Lightbox.displayName = "Lightbox";
var MapViewImpl = lazy(async () => {
  const [reactLeaflet, leafletMod] = await Promise.all([
    import('react-leaflet'),
    import('leaflet')
  ]);
  await import('leaflet/dist/leaflet.css');
  const { MapContainer, TileLayer, Marker, Polyline, Popup, useMap } = reactLeaflet;
  const L = leafletMod.default;
  const defaultIcon = L.icon({
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
  });
  L.Marker.prototype.options.icon = defaultIcon;
  const { useEffect: useEffect77, useRef: useRef79, useCallback: useCallback92, useState: useState107 } = React93__default;
  const { Typography: Typography2 } = await import('./Typography-BY4A2NBY.js');
  const { useEventBus: useEventBus2 } = await import('./useEventBus-SWRN475O.js');
  function MapUpdater({ centerLat, centerLng, zoom }) {
    const map = useMap();
    const prevRef = useRef79({ centerLat, centerLng, zoom });
    useEffect77(() => {
      const prev = prevRef.current;
      if (prev.centerLat !== centerLat || prev.centerLng !== centerLng || prev.zoom !== zoom) {
        map.setView([centerLat, centerLng], zoom);
        prevRef.current = { centerLat, centerLng, zoom };
      }
    }, [map, centerLat, centerLng, zoom]);
    return null;
  }
  function MapClickHandler({ onMapClick }) {
    const map = useMap();
    useEffect77(() => {
      if (!onMapClick) return;
      const handler = (e) => {
        onMapClick(e.latlng.lat, e.latlng.lng);
      };
      map.on("click", handler);
      return () => {
        map.off("click", handler);
      };
    }, [map, onMapClick]);
    return null;
  }
  function MapViewInner({
    markers = [],
    routes = [],
    centerLat = 51.505,
    centerLng = -0.09,
    zoom = 13,
    height = "400px",
    onMarkerClick,
    onMapClick,
    mapClickEvent,
    markerClickEvent,
    showClickedPin = false,
    className,
    showAttribution = true,
    surface = "auto",
    ...rest
  }) {
    const contentSurface = useContentSurface(surface);
    const eventBus = useEventBus2();
    const [clickedPosition, setClickedPosition] = useState107(null);
    const handleMapClick = useCallback92((lat, lng) => {
      if (showClickedPin) {
        setClickedPosition({ lat, lng });
      }
      onMapClick?.(lat, lng);
      if (mapClickEvent) {
        eventBus.emit(`UI:${mapClickEvent}`, { latitude: lat, longitude: lng });
      }
    }, [onMapClick, mapClickEvent, eventBus, showClickedPin]);
    const handleMarkerClick = useCallback92((marker) => {
      onMarkerClick?.(marker);
      if (markerClickEvent) {
        eventBus.emit(`UI:${markerClickEvent}`, { ...marker });
      }
    }, [onMarkerClick, markerClickEvent, eventBus]);
    return contentSurface.provide(
      /* @__PURE__ */ jsx(
        Box,
        {
          ...domPassthrough(rest),
          className: cn("relative isolate z-0 w-full overflow-hidden rounded-container", contentSurface.className, className),
          style: { height },
          "data-testid": "map-view",
          children: /* @__PURE__ */ jsxs(
            MapContainer,
            {
              center: [centerLat, centerLng],
              zoom,
              style: { height: "100%", width: "100%" },
              attributionControl: showAttribution,
              children: [
                /* @__PURE__ */ jsx(
                  TileLayer,
                  {
                    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                    attribution: showAttribution ? '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' : void 0
                  }
                ),
                /* @__PURE__ */ jsx(MapUpdater, { centerLat, centerLng, zoom }),
                /* @__PURE__ */ jsx(MapClickHandler, { onMapClick: handleMapClick }),
                showClickedPin && clickedPosition && /* @__PURE__ */ jsx(Marker, { position: [clickedPosition.lat, clickedPosition.lng], children: /* @__PURE__ */ jsx(Popup, { children: /* @__PURE__ */ jsxs(Typography2, { variant: "body2", children: [
                  clickedPosition.lat.toFixed(5),
                  ", ",
                  clickedPosition.lng.toFixed(5)
                ] }) }) }),
                markers.map((marker) => /* @__PURE__ */ jsx(
                  Marker,
                  {
                    position: [marker.lat, marker.lng],
                    eventHandlers: onMarkerClick || markerClickEvent ? { click: () => handleMarkerClick(marker) } : void 0,
                    children: marker.label ? /* @__PURE__ */ jsxs(Popup, { children: [
                      /* @__PURE__ */ jsx(Typography2, { variant: "body2", children: marker.label }),
                      marker.category ? /* @__PURE__ */ jsx(Typography2, { variant: "caption", className: "text-muted-foreground", children: marker.category }) : null
                    ] }) : null
                  },
                  marker.id
                )),
                routes.map((route) => /* @__PURE__ */ jsx(
                  Polyline,
                  {
                    positions: route.waypoints.map((wp) => [wp.lat, wp.lng]),
                    pathOptions: {
                      color: route.color ?? "var(--primary, #2563eb)",
                      weight: route.weight ?? 4,
                      opacity: route.opacity ?? 0.8,
                      dashArray: route.dashArray
                    },
                    children: route.label ? /* @__PURE__ */ jsx(Popup, { children: /* @__PURE__ */ jsx(Typography2, { variant: "body2", children: route.label }) }) : null
                  },
                  route.id
                ))
              ]
            },
            `map-${centerLat}-${centerLng}-${zoom}`
          )
        }
      )
    );
  }
  return { default: MapViewInner };
});
function MapView(props) {
  const contentSurface = useContentSurface(props.surface);
  return /* @__PURE__ */ jsx(
    Suspense,
    {
      fallback: /* @__PURE__ */ jsx(
        Box,
        {
          ...domPassthrough(props),
          className: cn("relative w-full overflow-hidden rounded-container", contentSurface.className ?? "bg-muted/20", props.className),
          style: { height: props.height ?? "400px" },
          "data-testid": "map-view"
        }
      ),
      children: /* @__PURE__ */ jsx(MapViewImpl, { ...props })
    }
  );
}
var WizardProgress = ({
  steps,
  currentStep,
  onStepClick,
  allowNavigation = true,
  compact = false,
  className,
  stepClickEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const normalizedSteps = (steps ?? []).map(
    (s, i) => typeof s === "string" ? { id: `step-${i}`, title: s } : s
  );
  const totalSteps = normalizedSteps.length;
  const handleStepClick = (index) => {
    const isCompleted = index < currentStep;
    if (isCompleted && allowNavigation) {
      if (stepClickEvent) eventBus.emit(`UI:${stepClickEvent}`, { stepIndex: index });
      onStepClick?.(index);
    }
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      border: true,
      className: cn(
        "@container border-b-heavy border-x-0 border-t-0 border-border",
        compact ? "px-4 py-2" : "px-6 py-4",
        className
      ),
      children: /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2", children: normalizedSteps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;
        const canNavigate = isCompleted && allowNavigation;
        return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: () => handleStepClick(index),
              disabled: !canNavigate,
              "aria-current": isActive ? "step" : void 0,
              "aria-label": `${t("wizard.stepOf", { current: index + 1, total: totalSteps })}: ${step.title}`,
              className: cn(
                "flex-shrink-0 p-0 rounded-full text-sm tabular-nums border-heavy disabled:opacity-100",
                compact ? "w-6 h-6" : "w-8 h-8",
                isActive || isCompleted ? "bg-primary text-primary-foreground border-primary" : "bg-card text-muted-foreground border-border",
                canNavigate && "hover:bg-primary-hover"
              ),
              children: isCompleted ? /* @__PURE__ */ jsx(Icon, { name: "check", size: "sm" }) : index + 1
            }
          ),
          !compact && /* @__PURE__ */ jsx(
            Box,
            {
              "data-step-title": true,
              className: cn("min-w-0", !isActive && "hidden @md:block", isActive ? "text-foreground" : "text-muted-foreground"),
              children: /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", truncate: true, children: step.title })
            }
          ),
          index < totalSteps - 1 && /* @__PURE__ */ jsx(
            Box,
            {
              "aria-hidden": "true",
              className: cn("flex-1 min-w-4 h-0.5", index < currentStep ? "bg-primary" : "bg-border")
            }
          )
        ] }, step.id || `step-${index}`);
      }) })
    }
  );
};
WizardProgress.displayName = "WizardProgress";
var sizeStyles9 = {
  sm: {
    button: "w-7 h-7",
    text: "text-sm min-w-[2rem]",
    icon: "w-3 h-3"
  },
  md: {
    button: "w-9 h-9",
    text: "text-base min-w-[2.5rem]",
    icon: "w-4 h-4"
  },
  lg: {
    button: "w-11 h-11",
    text: "text-lg min-w-[3rem]",
    icon: "w-5 h-5"
  }
};
var VoteStack = ({
  count,
  userVote = null,
  onVote,
  voteEvent,
  disabled = false,
  size: size2 = "md",
  variant = "vertical",
  className,
  label,
  ...rest
}) => {
  const styles = sizeStyles9[size2];
  const isUp = userVote === "up";
  const isDown = userVote === "down";
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleUp = useCallback(() => {
    const next = isUp ? null : "up";
    onVote?.(next);
    if (voteEvent) {
      eventBus.emit(`UI:${voteEvent}`, { next });
    }
  }, [isUp, onVote, voteEvent, eventBus]);
  const handleDown = useCallback(() => {
    const next = isDown ? null : "down";
    onVote?.(next);
    if (voteEvent) {
      eventBus.emit(`UI:${voteEvent}`, { next });
    }
  }, [isDown, onVote, voteEvent, eventBus]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex items-center justify-center",
        // Shrink-wrap in stretch contexts (slot/sidecar wrappers are
        // flex-column with stretch alignment): without this the root spans
        // the full wrapper width and the count row's `w-full` turns the
        // compact pill into a page-wide band.
        "w-fit",
        variant === "vertical" ? "flex-col" : "flex-row",
        "rounded-interactive",
        "border-[length:var(--border-width)] border-border",
        "bg-surface",
        disabled && "opacity-50 cursor-not-allowed",
        className
      ),
      role: "group",
      "aria-label": rest["aria-label"] ?? label ?? t("voteStack.ariaLabel"),
      children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: handleUp,
            disabled,
            "aria-label": t("aria.upvote"),
            "aria-pressed": isUp,
            className: cn(
              "inline-flex items-center justify-center",
              variant === "vertical" ? "rounded-t-interactive" : "rounded-l-interactive",
              isUp ? "text-primary" : "text-muted-foreground",
              "hover:bg-muted",
              "active:bg-muted",
              "transition-colors duration-instant",
              "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
              "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
              styles.button
            ),
            children: /* @__PURE__ */ jsx(Icon, { name: "chevron-up", className: styles.icon })
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cn(
              "text-center font-bold tabular-nums select-none",
              "text-foreground",
              variant === "vertical" ? "border-y-[length:var(--border-width)] border-border w-full" : "border-x-[length:var(--border-width)] border-border h-full",
              "px-1 py-0.5",
              styles.text
            ),
            "aria-live": "polite",
            "aria-atomic": "true",
            children: count
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: handleDown,
            disabled,
            "aria-label": t("aria.downvote"),
            "aria-pressed": isDown,
            className: cn(
              "inline-flex items-center justify-center",
              variant === "vertical" ? "rounded-b-interactive" : "rounded-r-interactive",
              isDown ? "text-primary" : "text-muted-foreground",
              "hover:bg-muted",
              "active:bg-muted",
              "transition-colors duration-instant",
              "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
              "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
              styles.button
            ),
            children: /* @__PURE__ */ jsx(Icon, { name: "chevron-down", className: styles.icon })
          }
        )
      ]
    }
  );
};
VoteStack.displayName = "VoteStack";
var ReplyTreeNode = ({
  node,
  depth,
  maxDepth,
  collapsedSet,
  toggleCollapse,
  onVote,
  onReply,
  onFlag,
  onContinueThread,
  voteEvent,
  replyEvent,
  flagEvent,
  continueThreadEvent,
  showActions
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const nodeId = node.id;
  const authorName = node.authorName;
  const authorAvatarUrl = node.authorAvatarUrl;
  const content = node.content;
  const postedAt = node.postedAt;
  const voteCount = node.voteCount;
  const userVote = node.userVote;
  const replies = node.replies;
  const hasReplies = !!replies && replies.length > 0;
  const isCollapsed = collapsedSet.has(nodeId);
  const atMaxDepth = depth >= maxDepth;
  const [replyOpen, setReplyOpen] = useState(false);
  const [draft, setDraft] = useState("");
  const handleVote = useCallback(
    (next) => {
      onVote?.(nodeId, next);
      if (voteEvent) eventBus.emit(`UI:${voteEvent}`, { nodeId, vote: next });
    },
    [nodeId, onVote, voteEvent, eventBus]
  );
  const handleReply = useCallback(() => {
    onReply?.(nodeId);
    setReplyOpen((open) => !open);
  }, [nodeId, onReply]);
  const handleSubmitReply = useCallback(() => {
    const text = draft.trim();
    if (!text) return;
    if (replyEvent) eventBus.emit(`UI:${replyEvent}`, { parentNodeId: nodeId, content: text });
    setDraft("");
    setReplyOpen(false);
  }, [nodeId, draft, replyEvent, eventBus]);
  const handleCancelReply = useCallback(() => {
    setDraft("");
    setReplyOpen(false);
  }, []);
  const handleFlag = useCallback(() => {
    onFlag?.(nodeId);
    if (flagEvent) eventBus.emit(`UI:${flagEvent}`, { nodeId });
  }, [nodeId, onFlag, flagEvent, eventBus]);
  const handleContinue = useCallback(() => {
    onContinueThread?.(nodeId);
    if (continueThreadEvent) eventBus.emit(`UI:${continueThreadEvent}`, { nodeId });
  }, [nodeId, onContinueThread, continueThreadEvent, eventBus]);
  const handleToggle = useCallback(() => {
    toggleCollapse(nodeId);
  }, [nodeId, toggleCollapse]);
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-stretch min-w-0", children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-col items-center flex-shrink-0 w-6", children: [
      hasReplies ? /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: handleToggle,
          "aria-label": isCollapsed ? t("replyTree.expandReplies") : t("replyTree.collapseReplies"),
          "aria-expanded": !isCollapsed,
          leftIcon: isCollapsed ? "chevron-right" : "chevron-down",
          className: cn(
            "w-6 h-6 p-0 min-w-0",
            "rounded-interactive text-muted-foreground",
            "hover:bg-muted hover:text-foreground"
          )
        }
      ) : /* @__PURE__ */ jsx(Box, { className: "w-6 h-6", "aria-hidden": "true" }),
      hasReplies && !isCollapsed && /* @__PURE__ */ jsx(
        Box,
        {
          className: "flex-1 w-px bg-border mt-1",
          "aria-hidden": "true"
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2 flex-1 min-w-0 pb-3", children: [
      /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center min-w-0", children: [
        /* @__PURE__ */ jsx(
          Avatar,
          {
            src: authorAvatarUrl,
            name: authorName,
            size: "sm"
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: authorName }),
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: postedAt })
      ] }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap break-words", children: content }),
      showActions && /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center", children: [
        /* @__PURE__ */ jsx(
          VoteStack,
          {
            count: voteCount ?? 0,
            userVote: userVote ?? null,
            onVote: handleVote,
            size: "sm",
            variant: "horizontal",
            label: t("replyTree.voteOnReplyBy", { author: authorName })
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            leftIcon: "message-square",
            onClick: handleReply,
            "aria-label": t("replyTree.replyTo", { author: authorName }),
            children: t("replyTree.reply")
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            leftIcon: "flag",
            onClick: handleFlag,
            "aria-label": t("replyTree.flagReplyBy", { author: authorName }),
            children: t("replyTree.flag")
          }
        )
      ] }),
      replyOpen && /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2 mt-1", children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            inputType: "textarea",
            rows: 2,
            value: draft,
            placeholder: t("replyTree.replyToPlaceholder", { author: authorName }),
            onChange: (e) => setDraft(e.target.value),
            "aria-label": t("replyTree.replyTo", { author: authorName })
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-row gap-2 items-center", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "primary",
              size: "sm",
              leftIcon: "send",
              onClick: handleSubmitReply,
              disabled: !draft.trim(),
              children: t("replyTree.send")
            }
          ),
          /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleCancelReply, children: t("common.cancel") })
        ] })
      ] }),
      hasReplies && !isCollapsed && (atMaxDepth ? /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: handleContinue,
          rightIcon: "chevron-right",
          className: cn(
            "self-start gap-1 px-0 h-auto",
            "text-sm text-primary hover:underline hover:bg-transparent"
          ),
          children: t("replyTree.continueThread")
        }
      ) : /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-2 mt-1", children: replies.map((child) => /* @__PURE__ */ jsx(
        ReplyTreeNode,
        {
          node: child,
          depth: depth + 1,
          maxDepth,
          collapsedSet,
          toggleCollapse,
          onVote,
          onReply,
          onFlag,
          onContinueThread,
          voteEvent,
          replyEvent,
          flagEvent,
          continueThreadEvent,
          showActions
        },
        child.id
      )) }))
    ] })
  ] });
};
function collectInitiallyCollapsed(nodes, acc) {
  for (const n of nodes) {
    const replies = n.replies;
    if (n.collapsed) acc.add(n.id);
    if (replies && replies.length > 0) {
      collectInitiallyCollapsed(replies, acc);
    }
  }
}
var ReplyTree = ({
  nodes,
  maxDepth = 6,
  onVote,
  onReply,
  onFlag,
  onContinueThread,
  voteEvent,
  replyEvent,
  flagEvent,
  continueThreadEvent,
  showActions = true,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const nodeList = Array.isArray(nodes) ? nodes : nodes ? [nodes] : [];
  const [collapsedSet, setCollapsedSet] = useState(() => {
    const acc = /* @__PURE__ */ new Set();
    collectInitiallyCollapsed(nodeList, acc);
    return acc;
  });
  const toggleCollapse = useCallback((id) => {
    setCollapsedSet((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, []);
  if (nodeList.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("text-sm text-muted-foreground", className), children: t("replyTree.noRepliesYet") });
  }
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("flex flex-col gap-2 min-w-0", className), children: nodeList.map((node) => /* @__PURE__ */ jsx(
    ReplyTreeNode,
    {
      node,
      depth: 0,
      maxDepth,
      collapsedSet,
      toggleCollapse,
      onVote,
      onReply,
      onFlag,
      onContinueThread,
      voteEvent,
      replyEvent,
      flagEvent,
      continueThreadEvent,
      showActions
    },
    node.id
  )) });
};
ReplyTree.displayName = "ReplyTree";
var tableViewLog = createLogger("almadar:ui:table-view");
function renderIconInput3(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function columnLabel(col) {
  return col.header ?? col.label ?? col.key;
}
function asFieldValue(v) {
  if (v === void 0 || v === null) return v;
  const t = typeof v;
  if (t === "string" || t === "number" || t === "boolean") return v;
  if (v instanceof Date) return v;
  if (Array.isArray(v)) return v;
  if (t === "object") return v;
  return void 0;
}
var formatCell = (value, format, relationOptions, fmt2) => {
  const relationDisplay = resolveRelationCellDisplay(value, relationOptions);
  if (relationDisplay !== void 0) return relationDisplay;
  return formatValue(value, format, fmt2);
};
var MAX_MEASURED_COL_CH = 32;
var BADGE_CHROME_CH = 4;
var alignClass = {
  left: "@sm/table:justify-start @sm/table:text-left",
  center: "@sm/table:justify-center @sm/table:text-center",
  right: "@sm/table:justify-end @sm/table:text-right"
};
var weightClass = {
  normal: "",
  medium: "font-medium",
  semibold: "font-semibold"
};
var LOOKS = {
  dense: { rowPad: "px-card-md py-2", headPad: "px-card-md py-2", striped: false, divider: true },
  spacious: { rowPad: "px-card-lg py-card-md", headPad: "px-card-lg py-card-sm", striped: false, divider: true },
  striped: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: true, divider: false },
  borderless: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: false, divider: false },
  bordered: { rowPad: "px-card-md py-card-sm", headPad: "px-card-md py-card-sm", striped: false, divider: true }
};
function TableView({
  entity,
  columns,
  fields,
  itemActions,
  itemClickEvent,
  selectable = false,
  selectEvent,
  selectedIds,
  sortEvent,
  sortColumn,
  sortDirection,
  className,
  emptyMessage,
  emptyIcon,
  emptyTitle,
  emptyDescription,
  emptyAction,
  isLoading = false,
  skeleton = "table",
  error = null,
  groupBy,
  pageSize = 0,
  children,
  renderItem: _schemaRenderItem,
  look = "dense",
  surface = "auto",
  // DnD props consumed by useDataDnd.
  dragGroup,
  accepts: accepts2,
  sortable,
  dropEvent,
  reorderEvent,
  positionEvent,
  dndItemIdField,
  dndRoot,
  relationsData,
  ...rest
}) {
  const eventBus = useEventBus();
  const rowActions = useRowActions();
  const { t } = useTranslate();
  const fmt2 = useFormatContext();
  const [visibleCount, setVisibleCount] = React93__default.useState(pageSize > 0 ? pageSize : Infinity);
  const [localSelected, setLocalSelected] = React93__default.useState(/* @__PURE__ */ new Set());
  const colDefs = (Array.isArray(columns) ? columns : void 0) ?? (Array.isArray(fields) ? fields : void 0) ?? [];
  const actionDefs = Array.isArray(itemActions) ? itemActions : [];
  const { fire: fireRowAction, isRowPending } = useRowActionFire();
  const allDataRaw = entityRows(entity);
  const dnd = useDataDnd({
    items: allDataRaw,
    layout: "list",
    dragGroup,
    accepts: accepts2,
    sortable,
    dropEvent,
    reorderEvent,
    positionEvent,
    dndItemIdField,
    dndRoot
  });
  const ordered2 = dnd.orderedItems;
  const data = pageSize > 0 ? ordered2.slice(0, visibleCount) : ordered2;
  const hasMore = pageSize > 0 && visibleCount < ordered2.length;
  const hasRenderProp = typeof children === "function";
  const idField = dndItemIdField ?? "id";
  React93__default.useEffect(() => {
    tableViewLog.debug("render", {
      rowCount: data.length,
      colCount: colDefs.length,
      look,
      isLoading: Boolean(isLoading),
      hasError: Boolean(error),
      dnd: dnd.enabled
    });
    if (data.length > 0 && !hasRenderProp && colDefs.length === 0) {
      tableViewLog.warn("columns-unresolved", {
        rowCount: data.length,
        columnsIsArray: Array.isArray(columns),
        fieldsIsArray: Array.isArray(fields)
      });
    }
  }, [data, colDefs, look, isLoading, error, dnd.enabled, hasRenderProp, columns, fields]);
  const selected = selectedIds ? new Set(selectedIds) : localSelected;
  const emitSelection = (next) => {
    if (!selectedIds) setLocalSelected(next);
    if (selectEvent) {
      const payload = { selectedIds: Array.from(next) };
      eventBus.emit(`UI:${selectEvent}`, payload);
    }
  };
  const allSelected = selectable && data.length > 0 && data.every((r, i) => selected.has(String(r[idField] ?? i)));
  const toggleAll = () => {
    if (allSelected) emitSelection(/* @__PURE__ */ new Set());
    else emitSelection(new Set(data.map((r, i) => String(r[idField] ?? i))));
  };
  const toggleRow = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    emitSelection(next);
  };
  const handleSort = (col) => {
    if (!col.sortable || !sortEvent) return;
    const dir = sortColumn === (col.field ?? col.key) && sortDirection === "asc" ? "desc" : "asc";
    eventBus.emit(`UI:${sortEvent}`, { column: col.field ?? col.key, direction: dir });
  };
  const handleRowClick = (row) => () => {
    if (!itemClickEvent) return;
    const payload = {
      id: row.id,
      row
    };
    eventBus.emit(`UI:${itemClickEvent}`, payload);
  };
  const colFloors = React93__default.useMemo(
    () => colDefs.map((col) => {
      const longest = data.reduce((widest, row) => {
        const cell = formatCell(asFieldValue(getNestedValue(row, col.field ?? col.key)), col.format, relationsData?.[col.field ?? col.key], fmt2);
        return Math.max(widest, cell.length);
      }, columnLabel(col).length);
      const chrome = col.format === "badge" ? BADGE_CHROME_CH : 0;
      return Math.min(longest + chrome, MAX_MEASURED_COL_CH);
    }),
    [colDefs, data, relationsData, fmt2]
  );
  const statusNode = isLoading ? /* @__PURE__ */ jsx(Skeleton, { spec: skeleton }) : error ? /* @__PURE__ */ jsx(Box, { className: "text-center py-8", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) }) : data.length === 0 ? /* @__PURE__ */ jsx(
    EmptyState,
    {
      icon: emptyIcon,
      title: emptyTitle || emptyMessage || t("empty.noItems"),
      description: emptyDescription,
      actionLabel: emptyAction?.label,
      actionEvent: emptyAction?.event
    }
  ) : null;
  const contentSurface = useContentSurface(surface);
  const lk = LOOKS[look];
  const openColKey = (colDefs.find((c) => c.variant === "h3" || c.variant === "h4") ?? colDefs[0])?.key;
  const hasActions = actionDefs.length > 0;
  const actionsTrack = hasActions ? "3rem" : null;
  const gridTemplateColumns = [
    selectable ? "auto" : null,
    ...colDefs.map((c, i) => c.width ?? `minmax(${colFloors[i]}ch, 1fr)`),
    actionsTrack
  ].filter(Boolean).join(" ");
  const header = /* @__PURE__ */ jsxs(
    Box,
    {
      role: "row",
      style: { gridTemplateColumns },
      className: cn(
        "hidden @sm/table:grid items-center gap-3 sticky top-0 z-10",
        "bg-[var(--color-surface-subtle)] border-b border-[var(--color-border)]",
        // No font size here: track floors are `ch`, resolved per row, so the
        // header row must share the body's font size or columns drift.
        "text-muted-foreground uppercase font-semibold tracking-wide",
        lk.headPad
      ),
      children: [
        selectable && /* @__PURE__ */ jsx(Box, { role: "columnheader", className: "flex items-center", children: /* @__PURE__ */ jsx(Checkbox, { checked: allSelected, onChange: toggleAll, "aria-label": t("aria.selectAllRows") }) }),
        colDefs.map((col) => {
          const active = sortColumn === (col.field ?? col.key);
          return /* @__PURE__ */ jsx(
            Box,
            {
              role: "columnheader",
              "aria-sort": col.sortable && sortEvent ? active ? sortDirection === "asc" ? "ascending" : "descending" : "none" : void 0,
              className: cn("flex items-center min-w-0", alignClass[col.align ?? "left"]),
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  ...pressableProps(col.sortable && sortEvent ? () => handleSort(col) : void 0),
                  className: cn(
                    "flex items-center gap-1 min-w-0 text-xs",
                    col.sortable && sortEvent && "cursor-pointer select-none hover:text-foreground"
                  ),
                  children: [
                    col.icon && renderIconInput3(col.icon, { size: "xs" }),
                    /* @__PURE__ */ jsx("span", { className: "truncate", children: columnLabel(col) }),
                    col.sortable && sortEvent && /* @__PURE__ */ jsx(
                      Icon,
                      {
                        name: active ? sortDirection === "asc" ? "chevron-up" : "chevron-down" : "chevrons-up-down",
                        size: "xs",
                        className: cn("flex-shrink-0", active ? "text-foreground" : "opacity-40")
                      }
                    )
                  ]
                }
              )
            },
            col.key
          );
        }),
        hasActions && /* @__PURE__ */ jsx(Box, { "aria-hidden": true, className: "sticky right-0 bg-[var(--color-surface-subtle)] border-l border-[var(--color-border)] h-full" })
      ]
    }
  );
  const renderRow = (row, index) => {
    const id = String(row[idField] ?? index);
    const rowClickEvent = itemClickEvent || void 0;
    const onOpen = rowClickEvent ? handleRowClick(row) : void 0;
    const overflowActions = rowActions(actionDefs, row);
    const rowInner = /* @__PURE__ */ jsxs(
      Box,
      {
        role: "row",
        "data-entity-row": true,
        "data-entity-id": id,
        "data-row-pending": isRowPending(id) || void 0,
        "aria-busy": isRowPending(id) || void 0,
        "aria-selected": selectable ? selected.has(id) : void 0,
        onClick: onOpen,
        style: !hasRenderProp ? { gridTemplateColumns } : void 0,
        className: cn(
          "group relative transition-colors duration-fast",
          hasRenderProp ? "flex items-center gap-3" : "flex flex-col gap-1 @sm/table:grid @sm/table:items-center @sm/table:gap-3",
          rowClickEvent && "cursor-pointer",
          lk.rowPad,
          lk.divider && "border-b border-[var(--color-border)]",
          lk.striped && index % 2 === 1 && "bg-[var(--color-surface-subtle)]",
          "hover:bg-[var(--color-surface-subtle)]",
          look === "bordered" && "@sm/table:[&>*]:border-r @sm/table:[&>*]:border-[var(--color-border)] @sm/table:[&>*:last-child]:border-r-0"
        ),
        children: [
          selectable && /* @__PURE__ */ jsx(Box, { role: "cell", className: cn("flex items-center", STRETCHED_ABOVE), onClick: rowClickEvent ? (e) => e.stopPropagation() : void 0, children: /* @__PURE__ */ jsx(
            Checkbox,
            {
              checked: selected.has(id),
              onChange: () => toggleRow(id),
              "aria-label": t("table.selectRow", { id })
            }
          ) }),
          hasRenderProp ? /* @__PURE__ */ jsxs(Box, { role: "cell", className: "relative flex-1 min-w-0", children: [
            onOpen && /* @__PURE__ */ jsx(
              Box,
              {
                ...rowOpenControlProps(true),
                "aria-label": t("aria.openRow", { position: index + 1 }),
                className: "absolute inset-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset"
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: cn(onOpen && "relative"), children: children(row, index) })
          ] }) : colDefs.map((col) => {
            const raw = asFieldValue(getNestedValue(row, col.field ?? col.key));
            const opens = onOpen !== void 0 && col.key === openColKey;
            const asControl = (node) => opens ? /* @__PURE__ */ jsx(Box, { ...rowOpenControlProps(true), className: cn("min-w-0", STRETCHED_CONTROL), children: node }) : node;
            const isTitle = col.variant === "h3" || col.variant === "h4";
            const cellBase = cn(
              "flex items-center min-w-0 gap-3",
              isTitle ? "font-medium @sm/table:font-[inherit]" : "justify-between",
              isTitle && hasActions && "pr-10 @sm/table:pr-0",
              alignClass[col.align ?? "left"],
              weightClass[col.weight ?? "normal"],
              col.className
            );
            const stackedLabel = isTitle ? null : /* @__PURE__ */ jsx("span", { className: "@sm/table:hidden shrink-0 text-xs text-muted-foreground", "data-stacked-label": true, children: columnLabel(col) });
            if (col.format === "badge" && raw != null && raw !== "") {
              const relationDisplay = resolveRelationCellDisplay(raw, relationsData?.[col.field ?? col.key]);
              const label = relationDisplay ?? col.labels?.[String(raw)] ?? (typeof raw === "boolean" ? formatValue(raw, "boolean", fmt2) : valueLabelFor(String(raw), col.labels));
              return /* @__PURE__ */ jsxs(Box, { role: "cell", className: cellBase, children: [
                stackedLabel,
                asControl(/* @__PURE__ */ jsx(Badge, { variant: badgeVariantFor(String(raw), col.colorMap), size: "sm", className: "whitespace-nowrap", children: label }))
              ] }, col.key);
            }
            return /* @__PURE__ */ jsxs(Box, { role: "cell", className: cellBase, children: [
              stackedLabel,
              asControl(/* @__PURE__ */ jsx("span", { className: "truncate text-foreground", children: formatCell(raw, col.format, relationsData?.[col.field ?? col.key], fmt2) }))
            ] }, col.key);
          }),
          hasActions && /* @__PURE__ */ jsx(
            HStack,
            {
              role: "cell",
              gap: "xs",
              onClick: rowClickEvent ? (e) => e.stopPropagation() : void 0,
              className: cn(
                // Wide: pinned — the fixed column tracks routinely overflow the
                // caller's scroll container, which would leave the kebab
                // off-screen. Opaque + hairline edge so it reads as a pinned
                // column while scrolled cells pass underneath. Narrow: the
                // stacked card's top-right corner.
                "justify-end flex-shrink-0 z-[1] transition-colors",
                "absolute top-1 right-1 @sm/table:sticky @sm/table:top-auto @sm/table:right-0",
                "@sm/table:border-l @sm/table:border-[var(--color-border)]",
                lk.striped && index % 2 === 1 ? "bg-[var(--color-surface-subtle)]" : "bg-[var(--color-card)] group-hover:bg-[var(--color-surface-subtle)]"
              ),
              children: overflowActions.length > 0 && /* @__PURE__ */ jsx(
                Menu,
                {
                  position: "bottom-end",
                  trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, "data-row-id": String(row.id), children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
                  items: overflowActions.map((action) => ({
                    label: action.label,
                    icon: action.icon,
                    event: action.event,
                    variant: action.variant === "danger" ? "danger" : "default",
                    onClick: () => fireRowAction(action, row, id)
                  }))
                }
              )
            }
          )
        ]
      }
    );
    return dnd.isZone ? /* @__PURE__ */ jsx(dnd.SortableItem, { id: row[idField] ?? id, children: rowInner }, id) : /* @__PURE__ */ jsx(React93__default.Fragment, { children: rowInner }, id);
  };
  const items = Array.from(data);
  const groups = groupBy ? groupRows(items, groupBy) : [{ label: "", items }];
  let runningIndex = 0;
  const body = /* @__PURE__ */ jsx(Box, { role: "rowgroup", children: groups.map((group, gi) => /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
    group.label && /* @__PURE__ */ jsx(Divider, { label: group.label, className: gi > 0 ? "mt-3" : "mt-0" }),
    group.items.map((row) => renderRow(row, runningIndex++))
  ] }, gi)) });
  const showHeader = colDefs.length > 0 || hasRenderProp;
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(
      Box,
      {
        role: "table",
        ...domPassthrough(rest),
        className: cn("@container/table w-full text-sm", contentSurface.className && cn(contentSurface.className, "overflow-hidden"), className),
        children: [
          showHeader && header,
          dnd.wrapContainer(statusNode ? /* @__PURE__ */ jsx(Box, { role: "rowgroup", children: /* @__PURE__ */ jsx(Box, { role: "row", children: /* @__PURE__ */ jsx(Box, { role: "cell", className: "w-full", children: statusNode }) }) }) : body),
          !statusNode && hasMore && /* @__PURE__ */ jsx(Box, { className: "flex justify-center py-3", children: /* @__PURE__ */ jsxs(Button, { variant: "ghost", size: "sm", onClick: () => setVisibleCount((p) => p + (pageSize || 5)), children: [
            /* @__PURE__ */ jsx(Icon, { name: "chevron-down", size: "xs", className: "mr-1" }),
            t("common.showMore"),
            " (",
            t("common.remaining", { count: ordered2.length - visibleCount }),
            ")"
          ] }) })
        ]
      }
    )
  );
}
TableView.displayName = "TableView";
var lookStyles6 = {
  "vertical-compact": "gap-1 [&>*]:py-1",
  "vertical-spacious": "",
  horizontal: "flex-row [&>*]:flex-row [&>*]:items-center",
  swimlane: "flex-row gap-6 [&>*]:flex-row [&>*]:items-center"
};
var STATUS_STYLES = {
  complete: {
    dotColor: "text-success",
    lineColor: "bg-success",
    icon: CheckCircle2
  },
  active: {
    dotColor: "text-primary",
    lineColor: "bg-primary",
    icon: Clock
  },
  pending: {
    dotColor: "text-muted-foreground",
    lineColor: "bg-border",
    icon: Circle
  },
  error: {
    dotColor: "text-error",
    lineColor: "bg-error",
    icon: AlertCircle
  }
};
var Timeline = ({
  title,
  items: propItems,
  titleField,
  descriptionField,
  dateField,
  statusField,
  itemActions,
  entity,
  isLoading = false,
  skeleton = "list",
  error,
  className,
  look = "vertical-spacious",
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const { t } = useTranslate();
  const fmt2 = useFormatContext();
  const entityData = entityRows(entity);
  const items = React93__default.useMemo(() => {
    if (propItems && propItems.length > 0) return propItems;
    if (entityData.length === 0) return [];
    return entityData.map((record, idx) => {
      return {
        id: String(record.id ?? idx),
        title: titleField ? String(record[titleField] ?? "") : "",
        description: descriptionField && record[descriptionField] ? String(record[descriptionField]) : void 0,
        date: dateField && record[dateField] ? String(record[dateField]) : void 0,
        status: statusField ? record[statusField] || "pending" : "pending"
      };
    });
  }, [propItems, entityData, titleField, descriptionField, dateField, statusField]);
  const moves = useItemMoves(true);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className }) });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.timelineError"),
        message: error.message,
        className
      }
    ) });
  }
  if (items.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("display.noEvents"),
        description: t("display.noTimelineEvents"),
        className
      }
    ) });
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-6 rounded-container", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
      title && /* @__PURE__ */ jsx(Typography, { variant: "h5", children: title }),
      /* @__PURE__ */ jsx(VStack, { gap: "none", className: cn("relative", lookStyles6[look]), "data-item-move-root": moves.root, children: items.map((item, idx) => {
        const status = item.status || "pending";
        const style = STATUS_STYLES[status] || STATUS_STYLES.pending;
        const ItemIcon2 = item.icon || style.icon;
        const isLast = idx === items.length - 1;
        return /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "start", className: "relative", "data-entity-id": item.id, "data-item-key": item.id, "data-item-move": moves.row, children: [
          /* @__PURE__ */ jsxs(VStack, { align: "center", className: "flex-shrink-0 relative", style: { width: "24px" }, children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                icon: ItemIcon2,
                size: "sm",
                className: cn(style.dotColor, "z-10 bg-card")
              }
            ),
            !isLast && /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "w-0.5 flex-1 min-h-[24px]",
                  style.lineColor,
                  "opacity-40"
                )
              }
            )
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: cn("flex-1 min-w-0", !isLast && "pb-6"), children: [
            /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", wrap: true, children: [
              /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", children: item.title }),
              item.date && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "flex-shrink-0", children: formatValue(item.date, "date", fmt2) })
            ] }),
            item.description && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: item.description }),
            item.tags && item.tags.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: item.tags.map((tag, tagIdx) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: tag }, tagIdx)) }),
            itemActions && itemActions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "mt-1", children: itemActions.map((action, actionIdx) => {
              const { icon: _icon, ...rowSafe } = item;
              return /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  action: action.event,
                  actionPayload: { row: rowSafe },
                  children: action.label
                },
                actionIdx
              );
            }) })
          ] })
        ] }, item.id);
      }) })
    ] }) })
  );
};
Timeline.displayName = "Timeline";
function fieldString(record, name) {
  if (!record || !name) return void 0;
  const value = getNestedValue(record, name);
  return typeof value === "string" && value !== "" ? value : void 0;
}
function fieldNumber(record, name) {
  if (!record || !name) return void 0;
  const value = getNestedValue(record, name);
  if (typeof value === "number") return value;
  if (typeof value === "string" && value.trim() !== "" && !Number.isNaN(Number(value))) return Number(value);
  return void 0;
}
function mediaImages(value) {
  const one = (v) => {
    if (typeof v === "string") return v ? { src: v } : null;
    if (isFileValue(v)) return v.mimeType.startsWith("image/") ? { src: v.url, caption: v.name } : null;
    if (v && typeof v === "object" && !Array.isArray(v) && !(v instanceof Date)) {
      const src = v.src;
      const caption = v.caption;
      return typeof src === "string" && src ? { src, ...typeof caption === "string" ? { caption } : {} } : null;
    }
    return null;
  };
  if (Array.isArray(value)) return value.map(one).filter((i) => i !== null);
  if (value === void 0 || value === null) return [];
  const single = one(value);
  return single ? [single] : [];
}
function ShowcaseMedia({ images, title }) {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const { t } = useTranslate();
  const current = images[Math.min(index, images.length - 1)];
  if (!current?.src) return null;
  return /* @__PURE__ */ jsxs(VStack, { gap: "sm", "data-testid": "detail-media", children: [
    /* @__PURE__ */ jsx(Button, { variant: "ghost", className: "h-auto p-0 w-full", onClick: () => setOpen(true), "aria-label": t("detailPanel.openImage"), children: /* @__PURE__ */ jsx(Image2, { src: current.src, alt: current.alt ?? title ?? "", aspect: "4/3", fit: "cover", rounded: "lg" }) }),
    images.length > 1 && /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: images.map((img, i) => /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        className: i === index ? "h-auto p-0 ring-2 ring-primary rounded-md" : "h-auto p-0",
        onClick: () => setIndex(i),
        "aria-label": t("detailPanel.showImage", { index: i + 1 }),
        "aria-pressed": i === index,
        children: /* @__PURE__ */ jsx(Box, { className: "w-16", children: /* @__PURE__ */ jsx(Image2, { src: img.src ?? "", alt: "", aspect: "1/1", fit: "cover", rounded: "md" }) })
      },
      img.src ?? i
    )) }),
    /* @__PURE__ */ jsx(Lightbox, { images, currentIndex: index, isOpen: open, onClose: () => setOpen(false), onIndexChange: setIndex })
  ] });
}
var DetailLookLayout = ({ look, record, title, regions, pieces }) => {
  const { t } = useTranslate();
  const { header, figures, sections, prose, footer, totals, renderFields } = pieces;
  const lineItemsNode = regions.lineItemsContent || regions.lineItems && regions.lineItemColumns ? /* @__PURE__ */ jsxs(VStack, { gap: "sm", "data-testid": "detail-line-items", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "h5", as: "h3", color: "secondary", children: t("detailPanel.section.lineItems") }),
    regions.lineItemsContent ?? (regions.lineItems && regions.lineItemColumns && /* @__PURE__ */ jsx(TableView, { entity: regions.lineItems, columns: regions.lineItemColumns }))
  ] }) : null;
  if (look === "profile") {
    const cover = fieldString(record, regions.coverField);
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-profile", children: [
      cover && /* @__PURE__ */ jsx(Box, { className: "-mx-6 -mt-6 overflow-hidden", "data-testid": "detail-cover", children: /* @__PURE__ */ jsx(Image2, { src: cover, alt: "", aspect: "21/9", fit: "cover" }) }),
      header,
      figures,
      sections,
      prose,
      footer
    ] });
  }
  if (look === "showcase") {
    const images = mediaImages(record && regions.mediaField ? getNestedValue(record, regions.mediaField) : void 0);
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-showcase", children: [
      /* @__PURE__ */ jsxs(Box, { className: images.length > 0 ? "grid gap-6 md:grid-cols-2" : "grid gap-6", children: [
        /* @__PURE__ */ jsx(ShowcaseMedia, { images, title }),
        /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          header,
          figures,
          sections
        ] })
      ] }),
      prose,
      footer
    ] });
  }
  if (look === "workflow") {
    const stages = regions.stages ?? [];
    const currentValue = fieldString(record, regions.stageField);
    const current = stages.findIndex((s) => s.value === currentValue);
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-workflow", children: [
      header,
      current >= 0 && /* @__PURE__ */ jsx(Box, { "data-testid": "detail-stages", children: /* @__PURE__ */ jsx(WizardProgress, { steps: stages.map((s) => ({ id: s.value, title: s.label })), currentStep: current }) }),
      figures,
      sections,
      lineItemsNode,
      prose,
      (regions.activityContent || regions.activity && regions.activity.length > 0) && /* @__PURE__ */ jsxs(VStack, { gap: "sm", "data-testid": "detail-activity", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h5", as: "h3", color: "secondary", children: t("detailPanel.section.activity") }),
        regions.activityContent ?? (regions.activity && /* @__PURE__ */ jsx(Timeline, { items: regions.activity }))
      ] }),
      footer
    ] });
  }
  if (look === "map") {
    const lat = fieldNumber(record, regions.latitudeField);
    const lng = fieldNumber(record, regions.longitudeField);
    const located = lat !== void 0 && lng !== void 0;
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-map", children: [
      located && /* @__PURE__ */ jsx(Box, { className: "-mx-6 -mt-6 overflow-hidden", "data-testid": "detail-map", children: /* @__PURE__ */ jsx(
        MapView,
        {
          markers: [{ id: String(record?.id ?? "record"), lat, lng, label: title }],
          centerLat: lat,
          centerLng: lng,
          zoom: 14,
          height: "320px"
        }
      ) }),
      header,
      figures,
      sections,
      prose,
      footer
    ] });
  }
  if (look === "ledger") {
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-ledger", className: "print:shadow-none", children: [
      header,
      sections,
      lineItemsNode,
      totals,
      figures,
      prose,
      footer
    ] });
  }
  if (look === "conversation") {
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-conversation", children: [
      header,
      /* @__PURE__ */ jsxs(Box, { className: "grid gap-6 lg:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "md", "data-testid": "detail-thread", children: [
          regions.threadContent ?? (regions.thread && regions.thread.length > 0 ? /* @__PURE__ */ jsx(ReplyTree, { nodes: regions.thread, showActions: false }) : /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: t("detailPanel.thread.empty") })),
          footer
        ] }),
        /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
          figures,
          sections,
          prose
        ] })
      ] })
    ] });
  }
  if (look === "workspace") {
    const overview = /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
      figures,
      sections,
      prose
    ] });
    const items = [
      { id: "overview", label: t("detailPanel.tab.overview"), content: overview },
      ...(regions.tabs ?? []).map((tab) => ({ id: tab.id, label: tab.label, content: tab.content ?? renderFields(tab.fields ?? []) }))
    ];
    return /* @__PURE__ */ jsxs(VStack, { gap: "lg", "data-testid": "detail-look-workspace", children: [
      header,
      /* @__PURE__ */ jsx(Tabs, { items, defaultActiveTab: "overview", variant: "underline" }),
      footer
    ] });
  }
  return /* @__PURE__ */ jsxs(VStack, { gap: "lg", children: [
    header,
    figures,
    sections,
    prose,
    footer
  ] });
};
function useSafeEventBus5() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes}B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)}KB`;
  return `${Math.round(bytes / (1024 * 1024))}MB`;
}
var UploadDropZone = ({
  accept,
  maxSize,
  maxFiles = 1,
  label,
  description,
  icon,
  disabled = false,
  readAs = "dataUrl",
  action,
  actionPayload,
  onFiles,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const resolvedLabel = label ?? t("upload.dropOrBrowse");
  const [isDragOver, setIsDragOver] = useState(false);
  const [error, setError] = useState(null);
  const inputRef = useRef(null);
  const eventBus = useSafeEventBus5();
  const defaultDescription = [
    accept ? t("upload.accepted", { accept }) : null,
    maxSize ? t("upload.maxSize", { size: formatFileSize(maxSize) }) : null,
    maxFiles > 1 ? t("upload.maxFiles", { count: maxFiles }) : null
  ].filter(Boolean).join(". ");
  const validateFiles = useCallback(
    (files) => {
      if (files.length > maxFiles) {
        return { valid: [], error: t("upload.error.maxFiles", { count: maxFiles }) };
      }
      if (accept) {
        const acceptedTypes = accept.split(",").map((s) => s.trim());
        const invalid = files.filter((file) => {
          return !acceptedTypes.some((type) => {
            if (type.endsWith("/*")) {
              return file.type.startsWith(type.replace("/*", "/"));
            }
            return file.type === type || file.name.endsWith(type);
          });
        });
        if (invalid.length > 0) {
          return { valid: [], error: t("upload.error.invalidType", { name: invalid[0].name }) };
        }
      }
      if (maxSize) {
        const tooLarge = files.filter((file) => file.size > maxSize);
        if (tooLarge.length > 0) {
          return {
            valid: [],
            error: t("upload.error.tooLarge", { name: tooLarge[0].name, size: formatFileSize(maxSize) })
          };
        }
      }
      return { valid: files, error: null };
    },
    [accept, maxSize, maxFiles, t]
  );
  const handleFiles = useCallback(
    (files) => {
      const { valid, error: validationError } = validateFiles(files);
      setError(validationError);
      if (valid.length > 0) {
        onFiles?.(valid);
        if (action) {
          void Promise.all(
            valid.map(
              (f3) => new Promise(
                (resolvePayload, rejectPayload) => {
                  const reader = new FileReader();
                  reader.onload = () => resolvePayload({
                    name: f3.name,
                    size: f3.size,
                    type: f3.type,
                    content: String(reader.result ?? "")
                  });
                  reader.onerror = () => rejectPayload(reader.error);
                  if (readAs === "text") reader.readAsText(f3);
                  else reader.readAsDataURL(f3);
                }
              )
            )
          ).then((payloadFiles) => {
            eventBus.emit(`UI:${action}`, {
              ...actionPayload,
              files: payloadFiles
            });
          }).catch(() => {
            setError(t("upload.error.readFailed"));
          });
        }
      }
    },
    [validateFiles, onFiles, action, actionPayload, readAs, eventBus, t]
  );
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) setIsDragOver(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    if (disabled) return;
    const files = Array.from(e.dataTransfer.files);
    handleFiles(files);
  };
  const handleClick = () => {
    if (!disabled) inputRef.current?.click();
  };
  const handleInputChange = (e) => {
    const files = Array.from(e.target.files ?? []);
    if (files.length > 0) handleFiles(files);
    e.target.value = "";
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "relative flex flex-col items-center justify-center",
        "p-8 rounded-interactive",
        "border-heavy border-dashed",
        "transition-colors duration-fast",
        "cursor-pointer",
        isDragOver ? "border-primary bg-primary bg-opacity-5" : "border-border bg-surface",
        error && "border-error",
        disabled && "opacity-50 cursor-not-allowed",
        "hover:border-primary hover:bg-muted",
        className
      ),
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDrop: handleDrop,
      onClick: handleClick,
      role: "button",
      tabIndex: disabled ? -1 : 0,
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleClick();
        }
      },
      "aria-label": rest["aria-label"] ?? resolvedLabel,
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: inputRef,
            type: "file",
            accept,
            multiple: maxFiles > 1,
            onChange: handleInputChange,
            className: "hidden",
            disabled,
            "aria-hidden": "true"
          }
        ),
        error ? /* @__PURE__ */ jsx(Icon, { name: "file-warning", size: "lg", className: "text-error mb-2" }) : icon ? typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, size: "lg", className: "text-muted-foreground mb-2" }) : /* @__PURE__ */ jsx(Icon, { icon, size: "lg", className: "text-muted-foreground mb-2" }) : /* @__PURE__ */ jsx(Icon, { name: "upload", size: "lg", className: "text-muted-foreground mb-2" }),
        /* @__PURE__ */ jsx(Typography, { variant: "body1", className: "text-center font-medium mb-1", children: isDragOver ? t("upload.dropFilesHere") : resolvedLabel }),
        error ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", className: "text-center", children: error }) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-center", children: description ?? defaultDescription })
      ]
    }
  );
};
UploadDropZone.displayName = "UploadDropZone";
var formatFieldLabel = (name) => name;
function formatPlain(value, format, fmt2) {
  if (value instanceof Date && format === void 0) return formatValue(value, "date", fmt2);
  return formatValue(value, format, fmt2);
}
var ReactMarkdown2 = lazy(() => import('react-markdown'));
function renderRichFieldValue(value, field, ctx, meta) {
  if (value === void 0 || value === null) return "\u2014";
  const fieldName2 = field.name;
  const fieldType = field.type;
  const { locale, t, fmt: fmt2 } = ctx;
  const str2 = String(value);
  if (field.format) return formatValue(value, field.format, fmt2);
  switch (fieldType) {
    case "image": {
      if (!str2) return "\u2014";
      return /* @__PURE__ */ jsx(Box, { className: "mt-1 max-w-full max-h-64", children: /* @__PURE__ */ jsx(Image2, { src: str2, alt: formatFieldLabel(fieldName2), fit: "contain", rounded: "md" }) });
    }
    case "url": {
      if (/^https?:\/\//i.test(str2)) {
        return /* @__PURE__ */ jsx(
          "a",
          {
            href: str2,
            target: "_blank",
            rel: "noreferrer",
            className: "text-primary hover:underline break-all",
            children: str2
          }
        );
      }
      return str2;
    }
    case "markdown":
    case "richtext":
      return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "break-words", children: str2 }), children: /* @__PURE__ */ jsx(
        Box,
        {
          className: "prose prose-sm max-w-none",
          style: {
            color: "var(--color-foreground)",
            "--tw-prose-body": "var(--color-foreground)",
            "--tw-prose-headings": "var(--color-foreground)",
            "--tw-prose-bold": "var(--color-foreground)",
            "--tw-prose-links": "var(--color-primary)",
            "--tw-prose-code": "var(--color-foreground)",
            "--tw-prose-hr": "var(--color-border)",
            "--tw-prose-quotes": "var(--color-foreground)",
            "--tw-prose-quote-borders": "var(--color-primary)",
            "--tw-prose-captions": "var(--color-muted-foreground)",
            "--tw-prose-th-borders": "var(--color-border)",
            "--tw-prose-td-borders": "var(--color-border)"
          },
          children: /* @__PURE__ */ jsx(ReactMarkdown2, { children: str2 })
        }
      ) });
    case "code":
      return /* @__PURE__ */ jsx(Box, { className: "mt-1 rounded-container bg-muted p-3 overflow-x-auto", children: /* @__PURE__ */ jsx("pre", { className: "text-sm font-mono whitespace-pre-wrap break-words m-0", children: /* @__PURE__ */ jsx("code", { children: str2 }) }) });
    case "html":
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "mt-1 prose prose-sm max-w-none break-words",
          style: {
            color: "var(--color-foreground)",
            "--tw-prose-body": "var(--color-foreground)",
            "--tw-prose-headings": "var(--color-foreground)",
            "--tw-prose-bold": "var(--color-foreground)",
            "--tw-prose-links": "var(--color-primary)",
            "--tw-prose-code": "var(--color-foreground)",
            "--tw-prose-hr": "var(--color-border)",
            "--tw-prose-quotes": "var(--color-foreground)",
            "--tw-prose-quote-borders": "var(--color-primary)",
            "--tw-prose-captions": "var(--color-muted-foreground)",
            "--tw-prose-th-borders": "var(--color-border)",
            "--tw-prose-td-borders": "var(--color-border)"
          },
          children: /* @__PURE__ */ jsx(Typography, { variant: "body", children: str2 })
        }
      );
    case "date":
    case "datetime":
    case "timestamp": {
      const d = new Date(str2);
      if (!isNaN(d.getTime())) {
        return d.toLocaleDateString(locale, {
          year: "numeric",
          month: "long",
          day: "numeric",
          ...fieldType !== "date" ? { hour: "2-digit", minute: "2-digit" } : {}
        });
      }
      return str2;
    }
    case "money": {
      const n = typeof value === "number" ? value : Number(str2);
      if (!isNaN(n)) {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: "USD"
        }).format(n);
      }
      return str2;
    }
    case "relation": {
      const labels = relationDisplayLabels(value, meta?.options);
      if (labels.length === 0) return "\u2014";
      if (labels.length === 1) return labels[0];
      return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: labels.map((label, i) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: label }, i)) });
    }
    case "file": {
      if (value !== null && typeof value === "object" && !Array.isArray(value)) {
        const file = value;
        const label = typeof file.name === "string" && file.name ? file.name : "file";
        const size2 = typeof file.sizeBytes === "number" ? ` \xB7 ${formatFileSize(file.sizeBytes)}` : "";
        return /* @__PURE__ */ jsxs(
          "a",
          {
            href: typeof file.url === "string" ? file.url : void 0,
            download: label,
            className: "inline-flex items-center gap-1.5 rounded-interactive border border-border bg-muted px-2 py-1 text-sm text-foreground no-underline hover:bg-accent hover:text-accent-foreground",
            children: [
              /* @__PURE__ */ jsx(Icon, { icon: FileText, size: "sm", className: "text-muted-foreground" }),
              label,
              size2 && /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", color: "muted", children: size2 })
            ]
          }
        );
      }
      return str2;
    }
    case "boolean": {
      if (typeof value === "boolean") return value ? t("common.yes") : t("common.no");
      if (str2 === "true") return t("common.yes");
      if (str2 === "false") return t("common.no");
      return str2;
    }
    case "array": {
      if (Array.isArray(value) && value.length > 0) {
        return /* @__PURE__ */ jsx(HStack, { gap: "xs", wrap: true, children: value.map((item, i) => /* @__PURE__ */ jsx(Badge, { variant: "default", children: String(item) }, i)) });
      }
      if (Array.isArray(value)) return "\u2014";
      return str2;
    }
    case "email":
      return /* @__PURE__ */ jsx("a", { href: `mailto:${str2}`, className: "text-primary hover:underline break-all", children: str2 });
    case "phone":
      return /* @__PURE__ */ jsx("a", { href: `tel:${str2}`, className: "text-primary hover:underline", children: str2 });
    default:
      if (meta?.values && meta.values.length > 0 && meta.values.includes(str2)) {
        return /* @__PURE__ */ jsx(Badge, { variant: badgeVariantFor(str2, field.colorMap), children: valueLabelFor(str2, field.labels) });
      }
      return formatPlain(value, field.format, fmt2);
  }
}
function resolveFields(fields) {
  const out = [];
  for (const f3 of fields ?? []) {
    const base = normalizeDisplayField(f3);
    if (!base) continue;
    out.push(typeof f3 === "string" ? base : { ...base, variant: f3.variant, format: f3.format, colorMap: f3.colorMap, type: f3.type, values: f3.values, relation: f3.relation });
  }
  return out;
}
function slotOf(f3) {
  if (f3.variant === "badge") return "badge";
  if (f3.variant === "progress") return "progress";
  if (f3.variant === "body") return "body";
  if (f3.format === "date" || f3.format === "datetime") return "date";
  if (f3.format === "currency" || f3.format === "number" || f3.format === "percent") return "metric";
  return "other";
}
var DetailPanel = ({
  title: propTitle,
  onTitleCommit,
  subtitle,
  status,
  avatar,
  sections: propSections,
  actions,
  maxInlineActions = 2,
  backAction,
  closeEvent,
  footer,
  slideOver = false,
  surface = "auto",
  showActions = true,
  className,
  entity,
  fields: propFields,
  fieldNames,
  initialData,
  isLoading = false,
  skeleton = "detail",
  error,
  relationsData,
  look = "panel",
  avatarField,
  coverField,
  mediaField,
  stageField,
  stages,
  activity,
  latitudeField,
  longitudeField,
  lineItems,
  lineItemColumns,
  lineItemsContent,
  totals,
  thread,
  threadContent,
  activityContent,
  tabs,
  ...a11yRest
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const rowActions = useRowActions();
  const actionPayload = useRowActionPayload();
  const { t, locale } = useTranslate();
  const fmt2 = useFormatContext();
  const ctx = { locale, t, fmt: fmt2 };
  const contained = useContext(SlotContainedContext);
  const [titleDraft, setTitleDraft] = React93__default.useState(null);
  const isFieldDefArray = (arr) => {
    if (!arr || arr.length === 0) return false;
    const first = arr[0];
    return typeof first === "string" || typeof first === "object" && first !== null && ("key" in first || "name" in first);
  };
  const resolvedFields = isFieldDefArray(propFields) ? resolveFields(propFields) : fieldNames?.map((name) => ({ name }));
  const fieldByName = new Map((resolvedFields ?? []).map((f3) => [f3.name, f3]));
  const fieldFor = (name) => fieldByName.get(name) ?? { name };
  const labelFor = (name) => fieldByName.get(name)?.label ?? formatFieldLabel(name);
  const metaFor = (field) => {
    const hasSchema = field.type !== void 0 || field.values !== void 0 || field.relation !== void 0;
    const options = relationsData?.[field.name];
    if (!hasSchema && !options) return void 0;
    return { type: field.type, values: field.values, relation: field.relation, options };
  };
  const richValue = (field, value) => renderRichFieldValue(value, field, ctx, metaFor(field));
  const overflowBusy = usePendingAction();
  const handleActionClick = useCallback(
    (action, record, pendingKey) => {
      if (action.navigatesTo) {
        const url = action.navigatesTo.replace(
          /\{\{(\w+)\}\}/g,
          (_, key) => String(record?.[key] ?? "")
        );
        eventBus.emit("UI:NAVIGATE", { url, row: record });
        return;
      }
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, record ? actionPayload(action, record) : {}, pendingKey !== void 0 ? { pendingKey } : void 0);
      }
      if (action.onClick) {
        action.onClick();
      }
    },
    [eventBus, actionPayload]
  );
  const entityRecord = Array.isArray(entity) ? entity[0] : entity;
  const data = entityRecord ?? initialData;
  let title = propTitle;
  const hasDeclaredSections = Boolean(propSections && propSections.length > 0);
  let sections = hasDeclaredSections && propSections ? [...propSections] : void 0;
  const normalizedData = data && typeof data === "object" && !Array.isArray(data) ? data : void 0;
  if (sections && normalizedData) {
    sections = sections.map((section) => ({
      ...section,
      fields: section.fields.map((field) => {
        if (typeof field === "string") {
          const value = getNestedValue(normalizedData, field);
          return {
            label: labelFor(field),
            value: formatPlain(value, fieldFor(field).format, fmt2)
          };
        }
        return field;
      })
    }));
  }
  let keyFigures = [];
  let proseFields = [];
  if (normalizedData && resolvedFields) {
    const declaredTitle = titleFieldOf(resolvedFields);
    const titleDerived = Boolean(
      !title && declaredTitle && getNestedValue(normalizedData, declaredTitle.name)
    );
    if (titleDerived && declaredTitle) {
      title = String(getNestedValue(normalizedData, declaredTitle.name));
    }
    const tabClaimed = new Set(look === "workspace" ? (tabs ?? []).flatMap((tab) => tab.fields ?? []) : []);
    const slotted = (slot) => resolvedFields.filter((f3) => slotOf(f3) === slot && !(titleDerived && f3 === declaredTitle) && !tabClaimed.has(f3.name));
    const progressFields = slotted("progress");
    const metricFields = slotted("metric");
    const dateFields = slotted("date");
    const descriptionFields = slotted("body");
    const otherFields = slotted("other");
    const toDetailFields = (group) => {
      const out = [];
      for (const field of group) {
        const value = getNestedValue(normalizedData, field.name);
        if (value !== void 0 && value !== null) {
          out.push({ label: labelFor(field.name), value: richValue(field, value) });
        }
      }
      return out;
    };
    if (!hasDeclaredSections) {
      sections = [];
      const overviewFields = toDetailFields(otherFields);
      if (overviewFields.length > 0) sections.push({ title: t("detailPanel.section.overview"), fields: overviewFields });
      const timelineFields = toDetailFields(dateFields);
      if (timelineFields.length > 0) sections.push({ title: t("detailPanel.section.timeline"), fields: timelineFields });
    }
    keyFigures = [...progressFields, ...metricFields].filter((field) => {
      const value = getNestedValue(normalizedData, field.name);
      return value !== void 0 && value !== null && value !== "";
    });
    proseFields = toDetailFields(descriptionFields);
  }
  const renderSlot = useRenderSlot();
  const navStack = useNavStack();
  const { setCurrentLabel } = navStack;
  const resolvedTitle = normalizedData ? title : void 0;
  useEffect(() => {
    if (renderSlot === "main" && !slideOver && resolvedTitle) {
      setCurrentLabel(resolvedTitle);
    }
  }, [renderSlot, slideOver, resolvedTitle, setCurrentLabel]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("error.loadingData"),
        message: error.message || t("error.genericLoad"),
        retryEvent: "RETRY",
        className
      }
    );
  }
  if (!normalizedData && !isLoading && resolvedFields && resolvedFields.length > 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("error.notFound"),
        description: t("display.itemNotFound"),
        className
      }
    );
  }
  const renderedSections = (sections ?? []).map((section) => ({
    title: section.title,
    fields: section.fields.map((field) => {
      if (typeof field !== "string") return field;
      const value = normalizedData ? getNestedValue(normalizedData, field) : void 0;
      return { label: labelFor(field), value: richValue(fieldFor(field), value) };
    })
  })).filter((section) => section.fields.length > 0);
  const showSectionHeadings = renderedSections.length > 1;
  const shownActions = rowActions(actions ?? [], data ?? {});
  const closeAction = closeEvent ? shownActions.find((a) => a.event === closeEvent) : void 0;
  const otherActions = shownActions.filter((a) => a !== closeAction);
  const statusBadges = /* @__PURE__ */ jsxs(Fragment, { children: [
    normalizedData && resolvedFields && resolvedFields.filter((f3) => slotOf(f3) === "badge").map((field) => {
      const value = getNestedValue(normalizedData, field.name);
      if (value === void 0 || value === null || value === "") return null;
      return /* @__PURE__ */ jsx(
        Badge,
        {
          variant: badgeVariantFor(String(value), field.colorMap),
          children: valueLabelFor(String(value), field.labels)
        },
        field.name
      );
    }),
    status && /* @__PURE__ */ jsx(Badge, { variant: status.variant ?? "default", children: status.label })
  ] });
  const commitTitle = () => {
    if (!onTitleCommit) return;
    const next = (titleDraft ?? "").trim();
    setTitleDraft(null);
    if (!next || next === title) return;
    onTitleCommit(next, normalizedData?.id !== void 0 ? String(normalizedData.id) : "");
  };
  const titleNode = onTitleCommit && titleDraft !== null ? /* @__PURE__ */ jsx(
    Input,
    {
      value: titleDraft,
      autoFocus: true,
      "aria-label": t("common.title"),
      className: "h-auto py-1 heading-voice text-3xl",
      onChange: (e) => setTitleDraft(e.target.value),
      onBlur: commitTitle,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commitTitle();
        } else if (e.key === "Escape") {
          e.preventDefault();
          setTitleDraft(null);
        }
      },
      "data-testid": "detail-title-input"
    }
  ) : onTitleCommit ? /* @__PURE__ */ jsx(
    Box,
    {
      role: "button",
      tabIndex: 0,
      className: "cursor-text rounded-interactive px-1 -mx-1 transition-colors hover:bg-muted/40",
      onClick: () => setTitleDraft(title ?? ""),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setTitleDraft(title ?? "");
        }
      },
      "data-testid": "detail-title-editable",
      children: /* @__PURE__ */ jsx(Typography, { variant: "h2", children: title || t("display.details") })
    }
  ) : /* @__PURE__ */ jsx(Typography, { variant: "h2", children: title || t("display.details") });
  const avatarSrc = avatarField && normalizedData ? getNestedValue(normalizedData, avatarField) : void 0;
  const avatarNode = avatar ?? (avatarField || look === "profile" ? /* @__PURE__ */ jsx(Avatar, { src: typeof avatarSrc === "string" && avatarSrc ? avatarSrc : void 0, name: title, size: "xl" }) : null);
  const totalFields = resolveFields(totals);
  const totalsNode = totalFields.length > 0 && normalizedData ? /* @__PURE__ */ jsx(VStack, { gap: "xs", align: "end", className: "ms-auto min-w-[16rem] border-t border-border pt-3", "data-testid": "detail-totals", children: totalFields.map((field, idx) => {
    const value = getNestedValue(normalizedData, field.name);
    const last = idx === totalFields.length - 1;
    return /* @__PURE__ */ jsxs(HStack, { justify: "between", gap: "lg", className: "w-full", children: [
      /* @__PURE__ */ jsx(Typography, { variant: last ? "body" : "small", color: last ? void 0 : "secondary", weight: last ? "semibold" : void 0, children: field.label ?? field.name }),
      /* @__PURE__ */ jsx(Typography, { variant: last ? "h4" : "body", as: "span", className: "tabular-nums", children: value === void 0 || value === null ? "\u2014" : formatValue(value, field.format, fmt2) })
    ] }, field.name);
  }) }) : null;
  const renderFields = (names) => /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "192px", maxCols: 3, gap: "md", children: names.map((name) => {
    const value = normalizedData ? getNestedValue(normalizedData, name) : void 0;
    return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "min-w-0", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "medium", children: labelFor(name) }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", className: "break-words", children: richValue(fieldFor(name), value) })
    ] }, name);
  }) });
  const headerNode = /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "start", gap: "md", wrap: true, className: slideOver ? "sticky top-0 z-10 -mx-6 -mt-6 bg-card px-6 pt-6 pb-3 border-b border-border" : void 0, children: [
    /* @__PURE__ */ jsxs(HStack, { align: "start", gap: "sm", className: "min-w-0 flex-1", children: [
      backAction && /* @__PURE__ */ jsx(
        Button,
        {
          variant: backAction.variant || "ghost",
          size: "sm",
          action: backAction.navigatesTo ? void 0 : backAction.event,
          actionPayload: data ? actionPayload(backAction, data) : void 0,
          onClick: backAction.navigatesTo ? () => handleActionClick(backAction, data) : void 0,
          icon: backAction.icon ?? ArrowLeft,
          "data-testid": backAction.event ? actionTestId(backAction.event) : actionTestId("back"),
          children: backAction.label
        }
      ),
      avatarNode,
      /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "min-w-0", children: [
        /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", wrap: true, children: [
          titleNode,
          statusBadges
        ] }),
        subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "secondary", children: subtitle })
      ] })
    ] }),
    showActions && /* @__PURE__ */ jsxs(HStack, { justify: "end", align: "center", gap: "xs", className: "shrink-0", children: [
      otherActions.slice(0, maxInlineActions).map((action, idx) => /* @__PURE__ */ jsx(
        Button,
        {
          variant: action.variant || "secondary",
          size: "sm",
          action: action.navigatesTo ? void 0 : action.event,
          actionPayload: data ? actionPayload(action, data) : void 0,
          onClick: action.navigatesTo ? () => handleActionClick(action, data) : void 0,
          icon: action.icon,
          "data-testid": action.event ? actionTestId(action.event) : void 0,
          "data-row-id": normalizedData?.id !== void 0 ? String(normalizedData.id) : void 0,
          children: action.label
        },
        idx
      )),
      otherActions.length > maxInlineActions && /* @__PURE__ */ jsx(
        Menu,
        {
          position: "bottom-end",
          trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, isLoading: overflowBusy.pending, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
          items: otherActions.slice(maxInlineActions).map((action) => ({
            // ONE firing path: onClick → handleActionClick (emits with
            // the {id, row} payload). Passing `event` too would make
            // Menu emit a second, payload-less copy of the same event.
            label: action.label,
            icon: action.icon,
            variant: action.variant === "danger" ? "danger" : "default",
            onClick: () => overflowBusy.activate((pendingKey) => handleActionClick(action, data, pendingKey))
          }))
        }
      ),
      closeAction && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          action: closeAction.event,
          actionPayload: data ? actionPayload(closeAction, data) : void 0,
          onClick: closeAction.event ? void 0 : () => handleActionClick(closeAction, data),
          icon: X,
          "aria-label": t("aria.closePanel"),
          "data-testid": closeAction.event ? actionTestId(closeAction.event) : actionTestId("close")
        }
      )
    ] })
  ] }) });
  const figuresNode = /* @__PURE__ */ jsx(Fragment, { children: keyFigures.length > 0 && normalizedData && /* @__PURE__ */ jsx(HStack, { gap: "md", wrap: true, align: "stretch", "data-testid": "detail-key-figures", children: keyFigures.map((field) => {
    const value = getNestedValue(normalizedData, field.name);
    return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "min-w-[10rem] max-w-[18rem] flex-1 rounded-container border border-border bg-muted/30 p-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "medium", children: labelFor(field.name) }),
      /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "p", className: "tabular-nums break-words", children: formatValue(value, field.format, fmt2) }),
      slotOf(field) === "progress" && typeof value === "number" && /* @__PURE__ */ jsx(ProgressBar, { value })
    ] }, field.name);
  }) }) });
  const sectionsNode = /* @__PURE__ */ jsx(Fragment, { children: renderedSections.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: "lg", "data-testid": "detail-fields", children: renderedSections.map((section, sIdx) => /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    showSectionHeadings && /* @__PURE__ */ jsx(Typography, { variant: "h5", as: "h3", color: "secondary", children: section.title }),
    /* @__PURE__ */ jsx(SimpleGrid, { minChildWidth: "192px", maxCols: 3, gap: "md", children: section.fields.map((field, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", className: "min-w-0", children: [
      field.icon && /* @__PURE__ */ jsx(Icon, { icon: field.icon, size: "md", className: "text-muted-foreground mt-1" }),
      /* @__PURE__ */ jsxs(VStack, { gap: "none", flex: true, className: "min-w-0", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "medium", children: field.label }),
        /* @__PURE__ */ jsx(Typography, { variant: "body", className: "break-words", children: field.value || "\u2014" })
      ] })
    ] }, idx)) })
  ] }, sIdx)) }) });
  const proseNode = /* @__PURE__ */ jsx(Fragment, { children: proseFields.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: "md", "data-testid": "detail-prose", children: proseFields.map((field, idx) => /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", weight: "medium", children: field.label }),
    /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-line break-words", children: field.value })
  ] }, idx)) }) });
  const footerNode = /* @__PURE__ */ jsx(Fragment, { children: footer && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Divider, {}),
    footer
  ] }) });
  const content = /* @__PURE__ */ jsx(Box, { className: slideOver ? void 0 : "p-6", children: /* @__PURE__ */ jsx(
    DetailLookLayout,
    {
      look,
      record: data,
      title,
      regions: { coverField, mediaField, stageField, stages, activity, activityContent, latitudeField, longitudeField, lineItems, lineItemColumns, lineItemsContent, thread, threadContent, tabs },
      pieces: { header: headerNode, figures: figuresNode, sections: sectionsNode, prose: proseNode, footer: footerNode, totals: totalsNode, renderFields }
    }
  ) });
  if (!slideOver) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(a11yRest), className, children: contentSurface.provide(
      /* @__PURE__ */ jsx(Box, { className: cn(contentSurface.className, "rounded-container"), "data-testid": "detail-card", children: content })
    ) });
  }
  const dismiss = closeAction ? () => handleActionClick(closeAction, data) : void 0;
  const panel = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(contained ? "absolute" : "fixed", "inset-0 z-40 bg-scrim"),
        onClick: dismiss,
        "aria-hidden": "true",
        "data-testid": "detail-scrim"
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(a11yRest),
        role: "dialog",
        "aria-modal": "true",
        "aria-label": a11yRest["aria-label"] ?? (title || t("display.details")),
        className: cn(contained ? "absolute" : "fixed", "inset-y-0 right-0 z-50 w-full max-w-2xl overflow-y-auto bg-card surface-material shadow-elevation-dialog p-6", className),
        "data-testid": "detail-slide-over",
        children: /* @__PURE__ */ jsx(SurfaceBoundary, { children: content })
      }
    )
  ] });
  if (contained || typeof document === "undefined") return panel;
  return /* @__PURE__ */ jsx(ThemedPortal, { children: panel });
};
DetailPanel.displayName = "DetailPanel";
var DocBreadcrumb = ({
  items,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      className: cn("w-full", className),
      role: "navigation",
      "aria-label": rest["aria-label"] ?? t("aria.breadcrumb"),
      children: /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", wrap: true, children: items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
          idx > 0 && /* @__PURE__ */ jsx(
            Icon,
            {
              name: "chevron-right",
              size: "xs",
              className: "text-muted-foreground shrink-0"
            }
          ),
          isLast || !item.href ? /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: cn(
                isLast ? "text-foreground font-medium" : "text-muted-foreground"
              ),
              as: "span",
              children: item.label
            }
          ) : /* @__PURE__ */ jsx(
            Button,
            {
              variant: "link",
              href: item.href,
              className: "h-auto px-0 text-xs font-normal text-muted-foreground hover:text-primary",
              children: item.label
            }
          )
        ] }, idx);
      }) })
    }
  );
};
DocBreadcrumb.displayName = "DocBreadcrumb";

// lib/doc-nav-classes.ts
var DOC_NAV_ROW_HOVER = "hover:bg-muted hover:text-foreground hover:border-transparent";
var DOC_NAV_ROW_ACTIVE = "bg-accent/10 text-accent font-semibold hover:bg-accent/15 hover:text-accent hover:border-transparent";
var DOC_NAV_ROW_IDLE = "text-muted-foreground";
var DOC_NAV_RULE_HOVER = "hover:bg-transparent hover:text-foreground";
var DOC_NAV_CARD_HOVER = "hover:bg-card hover:text-foreground hover:border-accent";
var linkCardStyles = [
  "border border-border",
  "rounded-container",
  "p-4",
  "transition-all",
  "hover:shadow-elevation-dialog",
  "no-underline",
  "flex-1",
  "min-w-0",
  "cursor-pointer",
  DOC_NAV_CARD_HOVER
].join(" ");
function DocPagination({ prev, next, className, ...rest }) {
  if (!prev && !next) return null;
  return /* @__PURE__ */ jsxs(
    HStack,
    {
      ...domPassthrough(rest),
      justify: "between",
      align: "stretch",
      gap: "md",
      className: cn("w-full", className),
      children: [
        prev ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            href: prev.href,
            className: cn(linkCardStyles, "group", "h-auto justify-start whitespace-normal font-normal"),
            children: /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
              /* @__PURE__ */ jsx(Icon, { name: "arrow-left", size: "md", className: "text-muted-foreground group-hover:text-accent transition-colors flex-shrink-0" }),
              /* @__PURE__ */ jsxs(VStack, { gap: "none", align: "start", children: [
                prev.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: prev.category }) : null,
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body",
                    className: "group-hover:text-accent transition-colors",
                    children: prev.label
                  }
                )
              ] })
            ] })
          }
        ) : /* @__PURE__ */ jsx(Box, { className: "flex-1" }),
        next ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            href: next.href,
            className: cn(linkCardStyles, "group text-right", "h-auto justify-end whitespace-normal font-normal"),
            children: /* @__PURE__ */ jsxs(HStack, { align: "center", justify: "end", gap: "sm", children: [
              /* @__PURE__ */ jsxs(VStack, { gap: "none", align: "end", children: [
                next.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: next.category }) : null,
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "body",
                    className: "group-hover:text-accent transition-colors",
                    children: next.label
                  }
                )
              ] }),
              /* @__PURE__ */ jsx(Icon, { name: "arrow-right", size: "md", className: "text-muted-foreground group-hover:text-accent transition-colors flex-shrink-0" })
            ] })
          }
        ) : /* @__PURE__ */ jsx(Box, { className: "flex-1" })
      ]
    }
  );
}
function DocSearch({
  placeholder,
  onSearch,
  className,
  ...rest
}) {
  const { t } = useTranslate();
  const resolvedPlaceholder = placeholder ?? t("docSearch.placeholder");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const containerRef = useRef(null);
  const debounceRef = useRef(void 0);
  useEffect(() => {
    function handleClickOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const performSearch = useCallback(
    (value) => {
      if (!onSearch || !value.trim()) {
        setResults([]);
        setIsOpen(false);
        return;
      }
      const searchResult = onSearch(value.trim());
      if (searchResult instanceof Promise) {
        void searchResult.then((items) => {
          setResults(items);
          setIsOpen(items.length > 0);
          setActiveIndex(-1);
        });
      } else {
        setResults(searchResult);
        setIsOpen(searchResult.length > 0);
        setActiveIndex(-1);
      }
    },
    [onSearch]
  );
  const handleChange = useCallback(
    (e) => {
      const value = e.target.value;
      setQuery(value);
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = setTimeout(() => {
        performSearch(value);
      }, 300);
    },
    [performSearch]
  );
  const handleFocus = useCallback(() => {
    if (results.length > 0) {
      setIsOpen(true);
    }
  }, [results]);
  const navigateTo = useCallback((href) => {
    setIsOpen(false);
    setQuery("");
    setResults([]);
    window.location.href = href;
  }, []);
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
        return;
      }
      if (!isOpen || results.length === 0) return;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIndex(
          (prev) => prev < results.length - 1 ? prev + 1 : 0
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIndex(
          (prev) => prev > 0 ? prev - 1 : results.length - 1
        );
      } else if (e.key === "Enter") {
        e.preventDefault();
        const idx = activeIndex >= 0 ? activeIndex : 0;
        if (results[idx]) {
          navigateTo(results[idx].href);
        }
      }
    },
    [isOpen, results, activeIndex, navigateTo]
  );
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      position: "relative",
      className: cn("w-full", className),
      ref: containerRef,
      children: [
        /* @__PURE__ */ jsx(Box, { position: "relative", children: /* @__PURE__ */ jsx(
          Input,
          {
            inputType: "search",
            placeholder: resolvedPlaceholder,
            value: query,
            onChange: handleChange,
            onFocus: handleFocus,
            onKeyDown: handleKeyDown,
            leftIcon: "search",
            clearable: query.length > 0,
            onClear: () => {
              setQuery("");
              setResults([]);
              setIsOpen(false);
            }
          }
        ) }),
        isOpen && results.length > 0 ? /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            className: "top-full left-0 right-0 mt-1 z-50 bg-card border border-border rounded-container shadow-elevation-popover max-h-80 overflow-y-auto",
            children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: results.map((result, index) => /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "px-4 py-3 cursor-pointer transition-colors",
                  "hover:bg-muted",
                  index === activeIndex && "bg-muted",
                  index < results.length - 1 && "border-b border-border"
                ),
                onClick: () => navigateTo(result.href),
                role: "option",
                tabIndex: -1,
                children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
                  /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
                    result.category ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: result.category }) : null,
                    /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "medium", children: result.title })
                  ] }),
                  result.excerpt ? /* @__PURE__ */ jsx(
                    Typography,
                    {
                      variant: "caption",
                      color: "muted",
                      truncate: true,
                      children: result.excerpt
                    }
                  ) : null
                ] })
              },
              `${result.href}-${index}`
            )) })
          }
        ) : null
      ]
    }
  );
}
var DocSidebarCategory = ({ item, depth }) => {
  const [expanded, setExpanded] = useState(
    () => item.items?.some(function hasActive(child) {
      if (child.active) return true;
      return child.items?.some(hasActive) ?? false;
    }) ?? false
  );
  if (item.items && item.items.length > 0) {
    return /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
      /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          "aria-expanded": expanded,
          className: cn(
            "h-auto w-full justify-start gap-2 rounded-interactive px-2 py-1.5 font-normal",
            DOC_NAV_ROW_HOVER,
            depth > 0 && "pl-4"
          ),
          onClick: () => setExpanded((prev) => !prev),
          children: [
            /* @__PURE__ */ jsx(
              Icon,
              {
                name: expanded ? "chevron-down" : "chevron-right",
                size: "xs",
                className: "text-muted-foreground shrink-0"
              }
            ),
            /* @__PURE__ */ jsx(
              Typography,
              {
                variant: "caption",
                className: "text-xs uppercase tracking-wider text-muted-foreground font-semibold",
                as: "span",
                children: item.label
              }
            )
          ]
        }
      ),
      expanded && /* @__PURE__ */ jsx(VStack, { gap: "none", className: "pl-4", children: item.items.map((child, idx) => /* @__PURE__ */ jsx(DocSidebarCategory, { item: child, depth: depth + 1 }, idx)) })
    ] });
  }
  const label = /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "inherit", weight: item.active ? "semibold" : "normal", as: "span", children: item.label });
  if (!item.href) {
    return /* @__PURE__ */ jsx(Box, { className: cn("rounded-interactive px-3 py-1.5 text-sm", DOC_NAV_ROW_IDLE, depth > 0 && "ml-2"), children: label });
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      variant: "ghost",
      href: item.href,
      "aria-current": item.active ? "page" : void 0,
      className: cn(
        "h-auto w-full justify-start rounded-interactive px-3 py-1.5 text-sm font-normal",
        depth > 0 && "ml-2",
        item.active ? DOC_NAV_ROW_ACTIVE : cn(DOC_NAV_ROW_IDLE, DOC_NAV_ROW_HOVER)
      ),
      children: label
    }
  );
};
var DocSidebar = ({
  items,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn("w-full", className),
      role: "navigation",
      "aria-label": t("aria.docsSidebar"),
      ...domPassthrough(rest),
      children: /* @__PURE__ */ jsx(VStack, { gap: "xs", children: items.map((item, idx) => /* @__PURE__ */ jsx(DocSidebarCategory, { item, depth: 0 }, idx)) })
    }
  );
};
DocSidebar.displayName = "DocSidebar";
var DocTOC = ({
  items,
  activeId,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: cn("w-full", className),
      role: "navigation",
      "aria-label": t("aria.tableOfContents"),
      ...domPassthrough(rest),
      children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: items.map((item) => {
        const isActive = item.id === activeId;
        const indent = item.level >= 3 ? "pl-4" : "pl-0";
        return /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            href: `#${item.id}`,
            "aria-current": isActive ? "location" : void 0,
            className: cn(
              "h-auto w-full justify-start rounded-none py-1.5 pr-0 font-normal border-l-heavy",
              "pl-3",
              indent,
              DOC_NAV_RULE_HOVER,
              isActive ? "border-l-accent text-accent hover:text-accent" : "border-l-transparent text-muted-foreground hover:border-l-border"
            ),
            children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "inherit", weight: isActive ? "medium" : "normal", className: "transition-colors", as: "span", children: item.label })
          },
          item.id
        );
      }) })
    }
  );
};
DocTOC.displayName = "DocTOC";
function renderIconInput4(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function fieldName(field) {
  return field.name ?? field.key ?? "";
}
function relationId(value) {
  if (value !== null && typeof value === "object" && !Array.isArray(value) && !(value instanceof Date)) {
    const id = value.id;
    if (id !== void 0 && id !== null) return String(id);
  }
  return String(value);
}
function fieldKind(field, value) {
  if (field.kind) return field.kind;
  if (field.type === "image") return "image";
  if (field.options && field.options.length > 0) return "select";
  if (typeof value === "boolean" || field.format === "boolean") return "boolean";
  if (Array.isArray(value) || relationLabel(value ?? null) !== null) return "readonly";
  return "text";
}
function DocumentDetails({
  entity,
  fields,
  metaCommitEvent,
  relationEvent,
  title,
  className,
  ...rest
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const fmt2 = useFormatContext();
  const [fieldDraft, setFieldDraft] = useState(null);
  const recordId = entity?.id !== void 0 && entity?.id !== null ? String(entity.id) : "";
  const fieldDefs = (fields ?? []).filter((f3) => fieldName(f3) !== "");
  if (fieldDefs.length === 0) return null;
  const commitField = (name, next, current) => {
    setFieldDraft(null);
    if (!metaCommitEvent || next === current) return;
    eventBus.emit(`UI:${metaCommitEvent}`, { id: recordId, patch: { id: recordId, [name]: next } });
  };
  const relationChip = (item, name, labels, key) => {
    const label = relationLabel(item) ?? valueLabelFor(String(item), labels);
    if (!relationEvent) {
      return /* @__PURE__ */ jsx(Badge, { variant: "default", children: label }, key);
    }
    const emitClick = () => eventBus.emit(`UI:${relationEvent}`, { field: name, id: relationId(item), name: label });
    return /* @__PURE__ */ jsx(
      Badge,
      {
        variant: "default",
        role: "button",
        tabIndex: 0,
        className: "cursor-pointer transition-colors hover:bg-accent hover:text-accent-foreground",
        onClick: emitClick,
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            emitClick();
          }
        },
        "data-testid": `relation-chip-${name}`,
        children: label
      },
      key
    );
  };
  const renderValue = (field) => {
    const name = fieldName(field);
    const raw = getNestedValue(entity ?? {}, name);
    const kind = fieldKind(field, raw);
    const label = field.label ?? field.header ?? name;
    if (kind === "image") {
      const url = typeof raw === "string" ? raw : "";
      if (!url) return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: "\u2014" });
      return /* @__PURE__ */ jsx(
        "img",
        {
          src: url,
          alt: label,
          loading: "lazy",
          className: "max-h-32 w-full rounded-container border border-border object-cover",
          "data-testid": `document-property-image-${name}`
        }
      );
    }
    if (kind === "boolean") {
      return /* @__PURE__ */ jsx(
        Switch,
        {
          checked: Boolean(raw),
          disabled: !metaCommitEvent,
          "aria-label": label,
          onChange: (checked) => commitField(name, checked, Boolean(raw))
        }
      );
    }
    if (kind === "select") {
      return /* @__PURE__ */ jsx(
        Select,
        {
          value: raw !== void 0 && raw !== null ? String(raw) : "",
          disabled: !metaCommitEvent,
          "aria-label": label,
          className: "h-8 w-full",
          options: (field.options ?? []).map((opt) => ({ value: opt, label: valueLabelFor(opt, field.labels) })),
          onChange: (e) => commitField(name, e.target.value, raw)
        }
      );
    }
    if (kind === "readonly" || !metaCommitEvent) {
      if (Array.isArray(raw)) {
        if (raw.length === 0) {
          return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: "\u2014" });
        }
        return /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: raw.map((item, i) => relationChip(item, name, field.labels, i)) });
      }
      if (raw !== void 0 && raw !== null && raw !== "" && relationLabel(raw) !== null) {
        return relationChip(raw, name, field.labels);
      }
      const shown2 = raw === void 0 || raw === null || raw === "" ? "\u2014" : formatValue(raw, field.format, fmt2);
      return /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: shown2 });
    }
    if (fieldDraft?.name === name) {
      return /* @__PURE__ */ jsx(
        Input,
        {
          value: fieldDraft.value,
          autoFocus: true,
          "aria-label": label,
          className: "h-8 w-full",
          onChange: (e) => setFieldDraft({ name, value: e.target.value }),
          onBlur: () => commitField(name, fieldDraft.value.trim(), raw),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commitField(name, fieldDraft.value.trim(), raw);
            } else if (e.key === "Escape") {
              e.preventDefault();
              setFieldDraft(null);
            }
          },
          "data-testid": `document-property-input-${name}`
        }
      );
    }
    const shown = raw === void 0 || raw === null || raw === "" ? "\u2014" : relationLabel(raw) ?? formatValue(raw, field.format, fmt2);
    return /* @__PURE__ */ jsx(
      Box,
      {
        role: "button",
        tabIndex: 0,
        className: cn(
          "cursor-text rounded-interactive px-1 -mx-1 transition-colors hover:bg-muted/40",
          (raw === void 0 || raw === null || raw === "") && "text-muted-foreground"
        ),
        onClick: () => setFieldDraft({ name, value: raw !== void 0 && raw !== null ? String(raw) : "" }),
        onKeyDown: (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setFieldDraft({ name, value: raw !== void 0 && raw !== null ? String(raw) : "" });
          }
        },
        "data-testid": `document-property-${name}`,
        children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: shown })
      }
    );
  };
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), variant: "bordered", className: cn("w-full", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-4", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", weight: "medium", className: "uppercase tracking-wide", children: title ?? t("documentDetails.title") }),
    /* @__PURE__ */ jsx(VStack, { gap: "sm", children: fieldDefs.map((field) => {
      const name = fieldName(field);
      const label = field.label ?? field.header ?? name;
      return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          field.icon && renderIconInput4(field.icon, { size: "xs", className: "text-muted-foreground" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: label })
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "min-w-0", children: renderValue(field) })
      ] }, name);
    }) })
  ] }) });
}
var CHANGE_DEBOUNCE_MS = 400;
var ALLOWED_ATTRS = {
  p: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  ul: [],
  ol: [],
  li: [],
  blockquote: [],
  pre: [],
  code: [],
  b: [],
  strong: [],
  i: [],
  em: [],
  u: [],
  s: [],
  strike: [],
  br: [],
  hr: [],
  div: [],
  span: [],
  a: ["href"],
  img: ["src", "alt"]
};
var DROP_TAGS = /* @__PURE__ */ new Set(["script", "style", "iframe", "object", "embed", "link", "meta", "form", "input", "button", "textarea", "select"]);
function safeUrl(raw, kinds) {
  const url = raw.trim();
  if (url.startsWith("#") || url.startsWith("/")) return url;
  const lower = url.toLowerCase();
  for (const kind of kinds) {
    if (lower.startsWith(kind)) return url;
  }
  return null;
}
function sanitizeNode(el) {
  const children = Array.from(el.children);
  for (const child of children) {
    const tag = child.tagName.toLowerCase();
    if (DROP_TAGS.has(tag)) {
      child.remove();
      continue;
    }
    const allowed = ALLOWED_ATTRS[tag];
    if (!allowed) {
      sanitizeNode(child);
      child.replaceWith(...Array.from(child.childNodes));
      continue;
    }
    for (const attr of Array.from(child.attributes)) {
      const name = attr.name.toLowerCase();
      if (!allowed.includes(name)) {
        child.removeAttribute(attr.name);
        continue;
      }
      if (name === "href") {
        const url = safeUrl(attr.value, ["http://", "https://", "mailto:"]);
        if (url === null) child.removeAttribute(attr.name);
        else child.setAttribute("href", url);
      }
      if (name === "src") {
        const url = safeUrl(attr.value, ["http://", "https://", "data:image/"]);
        if (url === null) child.remove();
        else child.setAttribute("src", url);
      }
    }
    sanitizeNode(child);
  }
}
function sanitizeRichHtml(html) {
  if (!html || typeof html !== "string") return "";
  if (typeof window === "undefined" || typeof DOMParser === "undefined") return "";
  const doc = new DOMParser().parseFromString(html, "text/html");
  sanitizeNode(doc.body);
  if (!doc.body.querySelector("img, hr") && (doc.body.textContent ?? "").trim().length === 0) {
    return "";
  }
  return doc.body.innerHTML.replace(/​/g, "");
}
function htmlIsEmpty(el) {
  if (el.querySelector("img, hr")) return false;
  return (el.textContent ?? "").trim().length === 0;
}
var MD_BLOCK_PREFIXES = {
  "#": { kind: "block", tag: "h1" },
  "##": { kind: "block", tag: "h2" },
  "###": { kind: "block", tag: "h3" },
  ">": { kind: "block", tag: "blockquote" },
  "```": { kind: "block", tag: "pre" },
  "-": { kind: "list", command: "insertUnorderedList" },
  "*": { kind: "list", command: "insertUnorderedList" },
  "1.": { kind: "list", command: "insertOrderedList" }
};
var BLOCK_TAGS = /* @__PURE__ */ new Set(["P", "DIV", "LI", "H1", "H2", "H3", "H4", "BLOCKQUOTE", "PRE"]);
function closestBlock(node, root) {
  let cur = node;
  while (cur && cur !== root) {
    if (cur instanceof Element && BLOCK_TAGS.has(cur.tagName)) return cur;
    cur = cur.parentNode;
  }
  return null;
}
var MD_INLINE_RULES = [
  { pattern: /\*\*([^*\n]+)\*\*$/, wrap: "strong" },
  { pattern: /(^|[^*])\*([^*\n]+)\*$/, wrap: "em" },
  { pattern: /`([^`\n]+)`$/, wrap: "code" }
];
var RICH_TEXT_CSS = `
.almadar-rich-text { line-height: 1.7; color: var(--color-foreground); }
.almadar-rich-text h1 { font-size: 1.875rem; font-weight: 700; line-height: 1.25; margin: 1.25em 0 0.4em; }
.almadar-rich-text h2 { font-size: 1.5rem; font-weight: 650; line-height: 1.3; margin: 1.1em 0 0.4em; }
.almadar-rich-text h3 { font-size: 1.25rem; font-weight: 600; line-height: 1.35; margin: 1em 0 0.35em; }
.almadar-rich-text h1:first-child, .almadar-rich-text h2:first-child, .almadar-rich-text h3:first-child { margin-top: 0; }
.almadar-rich-text p { margin: 0.5em 0; }
.almadar-rich-text ul { list-style: disc; padding-inline-start: 1.5rem; margin: 0.5em 0; }
.almadar-rich-text ol { list-style: decimal; padding-inline-start: 1.5rem; margin: 0.5em 0; }
.almadar-rich-text li { margin: 0.25em 0; }
.almadar-rich-text blockquote { border-inline-start: 3px solid var(--color-primary); padding-inline-start: 1rem; font-style: italic; color: var(--color-muted-foreground); margin: 0.75em 0; }
.almadar-rich-text pre { background: var(--color-muted); border: 1px solid var(--color-border); border-radius: 0.375rem; padding: 0.75rem 1rem; font-family: ui-monospace, monospace; font-size: 0.875em; white-space: pre-wrap; margin: 0.75em 0; }
.almadar-rich-text code { font-family: ui-monospace, monospace; font-size: 0.875em; background: var(--color-muted); border-radius: 0.25rem; padding: 0.1em 0.35em; }
.almadar-rich-text pre code { background: transparent; padding: 0; }
.almadar-rich-text a { color: var(--color-primary); text-decoration: underline; }
.almadar-rich-text hr { border: none; border-top: 1px solid var(--color-border); margin: 1.25em 0; }
.almadar-rich-text img { max-width: 100%; border-radius: 0.375rem; }
`;
function RichTextStyles() {
  return /* @__PURE__ */ jsx("style", { children: RICH_TEXT_CSS });
}
var IDLE_TOOLBAR = {
  bold: false,
  italic: false,
  underline: false,
  strikeThrough: false,
  block: null,
  bullets: false,
  numbers: false,
  link: false
};
function readToolbarState(root) {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return IDLE_TOOLBAR;
  const anchor = sel.anchorNode;
  if (!anchor || !root.contains(anchor)) return IDLE_TOOLBAR;
  let block = null;
  let link = false;
  let node = anchor;
  while (node && node !== root) {
    if (node instanceof Element) {
      const tag = node.tagName.toLowerCase();
      if (!block && (tag === "h1" || tag === "h2" || tag === "h3" || tag === "blockquote" || tag === "pre")) {
        block = tag;
      }
      if (tag === "a") link = true;
    }
    node = node.parentNode;
  }
  return {
    bold: document.queryCommandState("bold"),
    italic: document.queryCommandState("italic"),
    underline: document.queryCommandState("underline"),
    strikeThrough: document.queryCommandState("strikeThrough"),
    block,
    bullets: document.queryCommandState("insertUnorderedList"),
    numbers: document.queryCommandState("insertOrderedList"),
    link
  };
}
function ToolbarButton({ icon: IconCmp, label, active, onExec }) {
  return /* @__PURE__ */ jsx(
    Button,
    {
      type: "button",
      variant: "ghost",
      size: "sm",
      "aria-label": label,
      "aria-pressed": active,
      title: label,
      className: cn(
        "h-8 w-8 p-0 gap-0 justify-center",
        active && "bg-muted text-foreground"
      ),
      onMouseDown: (e) => {
        e.preventDefault();
        onExec();
      },
      children: /* @__PURE__ */ jsx(IconCmp, { size: 15 })
    }
  );
}
var RichTextEditor = ({
  value,
  onChange,
  changeEvent,
  readOnly = false,
  placeholder,
  showToolbar = true,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const ref = useRef(null);
  const [toolbar, setToolbar] = useState(IDLE_TOOLBAR);
  const [empty, setEmpty] = useState(() => !value || !sanitizeRichHtml(value).trim());
  const eventBus = useEventBus();
  const onChangeRef = useRef(onChange);
  const changeEventRef = useRef(changeEvent);
  useEffect(() => {
    onChangeRef.current = onChange;
    changeEventRef.current = changeEvent;
  }, [onChange, changeEvent]);
  const emitTimerRef = useRef(null);
  const emitNow = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const html = sanitizeRichHtml(el.innerHTML);
    onChangeRef.current?.(html);
    const evt = changeEventRef.current;
    if (evt) eventBus.emit(`UI:${evt}`, { value: html });
  }, [eventBus]);
  const scheduleEmit = useCallback(() => {
    if (emitTimerRef.current) clearTimeout(emitTimerRef.current);
    emitTimerRef.current = setTimeout(() => {
      emitTimerRef.current = null;
      emitNow();
    }, CHANGE_DEBOUNCE_MS);
  }, [emitNow]);
  const flushEmit = useCallback(() => {
    if (!emitTimerRef.current) return;
    clearTimeout(emitTimerRef.current);
    emitTimerRef.current = null;
    emitNow();
  }, [emitNow]);
  useEffect(() => () => {
    if (emitTimerRef.current) {
      clearTimeout(emitTimerRef.current);
      emitTimerRef.current = null;
      emitNow();
    }
  }, [emitNow]);
  useEffect(() => {
    if (readOnly) return;
    const el = ref.current;
    if (!el) return;
    if (document.activeElement === el) return;
    const next = sanitizeRichHtml(value ?? "") || "<p><br></p>";
    if (el.innerHTML !== next) {
      el.innerHTML = next;
      setEmpty(htmlIsEmpty(el));
    }
  }, [readOnly, value]);
  useEffect(() => {
    if (readOnly) return;
    document.execCommand("defaultParagraphSeparator", false, "p");
  }, [readOnly]);
  useEffect(() => {
    if (readOnly || !showToolbar) return;
    const onSelectionChange = () => {
      const el = ref.current;
      if (!el) return;
      setToolbar(readToolbarState(el));
    };
    document.addEventListener("selectionchange", onSelectionChange);
    return () => document.removeEventListener("selectionchange", onSelectionChange);
  }, [readOnly, showToolbar]);
  const tryInlineMarkdown = useCallback(() => {
    const root = ref.current;
    if (!root) return false;
    const sel = window.getSelection();
    if (!sel || !sel.isCollapsed || sel.rangeCount === 0) return false;
    const node = sel.anchorNode;
    if (!node || node.nodeType !== Node.TEXT_NODE || !root.contains(node)) return false;
    if (node.parentElement?.closest("code, pre")) return false;
    const text = (node.textContent ?? "").slice(0, sel.anchorOffset);
    for (const rule of MD_INLINE_RULES) {
      const m = rule.pattern.exec(text);
      if (!m) continue;
      const inner = rule.wrap === "em" ? m[2] : m[1];
      if (!inner || !inner.trim()) continue;
      const lead = rule.wrap === "em" ? m[1]?.length ?? 0 : 0;
      const range = document.createRange();
      range.setStart(node, m.index + lead);
      range.setEnd(node, sel.anchorOffset);
      const el = document.createElement(rule.wrap);
      el.textContent = inner;
      range.deleteContents();
      range.insertNode(el);
      const after = document.createTextNode("\u200B");
      el.parentNode?.insertBefore(after, el.nextSibling);
      const caret = document.createRange();
      caret.setStart(after, 1);
      caret.collapse(true);
      sel.removeAllRanges();
      sel.addRange(caret);
      return true;
    }
    return false;
  }, []);
  const tryBlockMarkdown = useCallback(() => {
    const root = ref.current;
    if (!root) return false;
    const sel = window.getSelection();
    if (!sel || !sel.isCollapsed || sel.rangeCount === 0) return false;
    const node = sel.anchorNode;
    if (!node || node.nodeType !== Node.TEXT_NODE || !root.contains(node)) return false;
    const block = closestBlock(node, root);
    if (block ? block.firstChild !== node : root.firstChild !== node) return false;
    const prefix = (node.textContent ?? "").slice(0, sel.anchorOffset);
    const rule = MD_BLOCK_PREFIXES[prefix];
    if (!rule) return false;
    if (node.parentElement?.closest("pre, code")) return false;
    if (rule.kind === "list" && node.parentElement?.closest("li")) return false;
    node.deleteData(0, prefix.length);
    const caret = document.createRange();
    caret.setStart(node, 0);
    caret.collapse(true);
    sel.removeAllRanges();
    sel.addRange(caret);
    if (rule.kind === "list") {
      const container = block ?? node.parentElement;
      const list = document.createElement(rule.command === "insertOrderedList" ? "ol" : "ul");
      const li = document.createElement("li");
      if (block) {
        while (block.firstChild) li.appendChild(block.firstChild);
        list.appendChild(li);
        block.replaceWith(list);
      } else if (container) {
        li.appendChild(node);
        list.appendChild(li);
        container.appendChild(list);
      }
      if (!li.firstChild) li.appendChild(document.createElement("br"));
      const liCaret = document.createRange();
      liCaret.selectNodeContents(li);
      liCaret.collapse(true);
      sel.removeAllRanges();
      sel.addRange(liCaret);
    } else {
      document.execCommand("formatBlock", false, rule.tag);
    }
    return true;
  }, []);
  const afterEdit = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    tryInlineMarkdown();
    setEmpty(htmlIsEmpty(el));
    setToolbar(readToolbarState(el));
    scheduleEmit();
  }, [scheduleEmit, tryInlineMarkdown]);
  const handleKeyDown = useCallback((e) => {
    if (e.key === " " && tryBlockMarkdown()) {
      e.preventDefault();
      afterEdit();
    }
  }, [afterEdit, tryBlockMarkdown]);
  const execInline = useCallback((command) => {
    document.execCommand(command, false);
    afterEdit();
  }, [afterEdit]);
  const execBlock = useCallback((tag) => {
    const next = toolbar.block === tag ? "p" : tag;
    document.execCommand("formatBlock", false, next);
    afterEdit();
  }, [afterEdit, toolbar.block]);
  const execList = useCallback((command) => {
    document.execCommand(command, false);
    afterEdit();
  }, [afterEdit]);
  const execLink = useCallback(() => {
    if (toolbar.link) {
      document.execCommand("unlink", false);
      afterEdit();
      return;
    }
    const url = window.prompt(t("richTextEditor.linkPrompt"));
    if (!url) return;
    const safe = safeUrl(url, ["http://", "https://", "mailto:"]) ?? `https://${url}`;
    document.execCommand("createLink", false, safe);
    afterEdit();
  }, [afterEdit, t, toolbar.link]);
  const imageInputRef = useRef(null);
  const savedRangeRef = useRef(null);
  const execImage = useCallback(() => {
    const root = ref.current;
    const sel = window.getSelection();
    savedRangeRef.current = root && sel && sel.rangeCount > 0 && root.contains(sel.anchorNode) ? sel.getRangeAt(0).cloneRange() : null;
    imageInputRef.current?.click();
  }, []);
  const handleImageFile = useCallback((e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      const url = typeof reader.result === "string" ? reader.result : "";
      if (!url.startsWith("data:image/")) return;
      const root = ref.current;
      if (!root) return;
      root.focus();
      const sel = window.getSelection();
      if (sel && savedRangeRef.current && root.contains(savedRangeRef.current.startContainer)) {
        sel.removeAllRanges();
        sel.addRange(savedRangeRef.current);
      }
      document.execCommand("insertImage", false, url);
      afterEdit();
    };
    reader.readAsDataURL(file);
  }, [afterEdit]);
  const execRule = useCallback(() => {
    document.execCommand("insertHorizontalRule", false);
    afterEdit();
  }, [afterEdit]);
  if (readOnly) {
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("almadar-rich-text max-w-none", className), children: [
      /* @__PURE__ */ jsx(RichTextStyles, {}),
      /* @__PURE__ */ jsx(Box, { dangerouslySetInnerHTML: { __html: sanitizeRichHtml(value ?? "") } })
    ] });
  }
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex flex-col gap-2", className), children: [
    /* @__PURE__ */ jsx(RichTextStyles, {}),
    /* @__PURE__ */ jsx(
      "input",
      {
        ref: imageInputRef,
        type: "file",
        accept: "image/*",
        className: "hidden",
        "aria-hidden": "true",
        tabIndex: -1,
        onChange: handleImageFile
      }
    ),
    showToolbar && /* @__PURE__ */ jsxs(
      Box,
      {
        role: "toolbar",
        "aria-label": t("richTextEditor.editorToolbar"),
        className: cn(
          "sticky top-0 z-10 flex flex-wrap items-center gap-0.5 self-start",
          "rounded-container border border-border bg-background/95 px-1 py-0.5 shadow-elevation-popover"
        ),
        children: [
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Bold, label: t("richTextEditor.bold"), active: toolbar.bold, onExec: () => execInline("bold") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Italic, label: t("richTextEditor.italic"), active: toolbar.italic, onExec: () => execInline("italic") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Underline, label: t("richTextEditor.underline"), active: toolbar.underline, onExec: () => execInline("underline") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Strikethrough, label: t("richTextEditor.strikethrough"), active: toolbar.strikeThrough, onExec: () => execInline("strikeThrough") }),
          /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading1, label: t("richTextEditor.heading1"), active: toolbar.block === "h1", onExec: () => execBlock("h1") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading2, label: t("richTextEditor.heading2"), active: toolbar.block === "h2", onExec: () => execBlock("h2") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Heading3, label: t("richTextEditor.heading3"), active: toolbar.block === "h3", onExec: () => execBlock("h3") }),
          /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: List, label: t("richTextEditor.bulletList"), active: toolbar.bullets, onExec: () => execList("insertUnorderedList") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: ListOrdered, label: t("richTextEditor.numberedList"), active: toolbar.numbers, onExec: () => execList("insertOrderedList") }),
          /* @__PURE__ */ jsx(Box, { className: "mx-1 h-5 w-px bg-border" }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Quote, label: t("richTextEditor.quote"), active: toolbar.block === "blockquote", onExec: () => execBlock("blockquote") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Code, label: t("richTextEditor.code"), active: toolbar.block === "pre", onExec: () => execBlock("pre") }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Link, label: toolbar.link ? t("richTextEditor.removeLink") : t("richTextEditor.link"), active: toolbar.link, onExec: execLink }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Image$1, label: t("richTextEditor.image"), onExec: execImage }),
          /* @__PURE__ */ jsx(ToolbarButton, { icon: Minus, label: t("richTextEditor.divider"), onExec: execRule })
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        ref,
        contentEditable: true,
        suppressContentEditableWarning: true,
        role: "textbox",
        "aria-multiline": "true",
        "aria-label": t("richTextEditor.editorSurface"),
        "data-placeholder": placeholder ?? t("richTextEditor.placeholder"),
        "data-empty": empty ? "true" : "false",
        className: cn(
          "almadar-rich-text max-w-none min-h-[8rem] outline-none",
          "focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
          "data-[empty=true]:before:content-[attr(data-placeholder)]",
          "data-[empty=true]:before:text-muted-foreground/60",
          "data-[empty=true]:before:pointer-events-none",
          "data-[empty=true]:before:absolute",
          "relative cursor-text"
        ),
        onInput: afterEdit,
        onKeyDown: handleKeyDown,
        onBlur: flushEmit
      }
    )
  ] });
};
RichTextEditor.displayName = "RichTextEditor";
function renderIconInput5(icon, props) {
  return typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, ...props }) : /* @__PURE__ */ jsx(Icon, { icon, ...props });
}
function DocumentPanel({
  id,
  title,
  subtitle,
  coverImage,
  icon,
  value,
  actions,
  maxInlineActions,
  editing = false,
  titleCommitEvent,
  contentChangeEvent,
  editEvent,
  doneEvent,
  editLabel,
  doneLabel,
  autosaveHint,
  placeholder,
  className,
  ...rest
}) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [titleDraft, setTitleDraft] = useState(null);
  const recordId = id ?? "";
  const actionDefs = actions ?? [];
  const inlineCap = Math.min(maxInlineActions ?? 1, 1);
  const inlineActions = actionDefs.filter((a) => a.variant === "primary").slice(0, inlineCap);
  const menuActions = actionDefs.filter((a) => !inlineActions.includes(a));
  const fireAction = (action) => {
    if (!action.event) return;
    eventBus.emit(`UI:${action.event}`, { id: recordId, title: title ?? "" });
  };
  const commitTitle = () => {
    if (!titleCommitEvent) return;
    const next = (titleDraft ?? "").trim();
    setTitleDraft(null);
    if (!next || next === title) return;
    eventBus.emit(`UI:${titleCommitEvent}`, { title: next, id: recordId });
  };
  const untitled = t("documentPanel.untitled");
  const titleNode = titleCommitEvent && titleDraft !== null ? /* @__PURE__ */ jsx(
    Input,
    {
      value: titleDraft,
      autoFocus: true,
      "aria-label": t("common.title"),
      className: "h-auto py-1 heading-voice text-3xl",
      onFocus: (e) => e.currentTarget.select(),
      onChange: (e) => setTitleDraft(e.target.value),
      onBlur: commitTitle,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          commitTitle();
        } else if (e.key === "Escape") {
          e.preventDefault();
          setTitleDraft(null);
        }
      },
      "data-testid": "document-title-input"
    }
  ) : titleCommitEvent ? /* @__PURE__ */ jsx(
    Box,
    {
      role: "button",
      tabIndex: 0,
      className: "cursor-text rounded-interactive px-1 -mx-1 transition-colors hover:bg-muted/40",
      onClick: () => setTitleDraft(title ?? ""),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          setTitleDraft(title ?? "");
        }
      },
      "data-testid": "document-title-editable",
      children: /* @__PURE__ */ jsx(Typography, { variant: "h2", className: cn(!title && "text-muted-foreground"), children: title || untitled })
    }
  ) : /* @__PURE__ */ jsx(Typography, { variant: "h2", children: title || untitled });
  const emitWithId = (event) => () => {
    if (event) eventBus.emit(`UI:${event}`, { id: recordId });
  };
  return /* @__PURE__ */ jsxs(Card, { ...domPassthrough(rest), variant: "elevated", className: cn("w-full overflow-hidden", className), children: [
    coverImage ? /* @__PURE__ */ jsx(Box, { className: "h-44 w-full sm:h-52", "data-testid": "document-cover", children: /* @__PURE__ */ jsx(
      "img",
      {
        src: coverImage,
        alt: "",
        "aria-hidden": "true",
        className: "h-full w-full object-cover"
      }
    ) }) : null,
    /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-6 sm:p-8", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "justify-between items-start", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
          icon ? /* @__PURE__ */ jsx(Box, { className: "text-muted-foreground", "data-testid": "document-icon", children: renderIconInput5(icon, { size: "lg" }) }) : null,
          titleNode,
          subtitle ? /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle }) : null
        ] }),
        /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-shrink-0 pt-1 items-center", children: editing ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "hidden sm:block", children: autosaveHint ?? t("documentPanel.autosaveHint") }),
          /* @__PURE__ */ jsx(Button, { variant: "primary", size: "sm", onClick: emitWithId(doneEvent), "data-testid": "document-done", children: doneLabel ?? t("documentPanel.done") })
        ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          editEvent && /* @__PURE__ */ jsxs(Button, { variant: "ghost", size: "sm", onClick: emitWithId(editEvent), "data-testid": "document-edit", children: [
            /* @__PURE__ */ jsx(Icon, { name: "edit", size: "xs", className: "mr-1" }),
            editLabel ?? t("documentPanel.edit")
          ] }),
          inlineActions.map((action, idx) => /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "primary",
              size: "sm",
              onClick: () => fireAction(action),
              "data-testid": action.event ? actionTestId(action.event) : void 0,
              children: [
                action.icon && renderIconInput5(action.icon, { size: "xs", className: "mr-1" }),
                action.label
              ]
            },
            idx
          )),
          menuActions.length > 0 && /* @__PURE__ */ jsx(
            Menu,
            {
              position: "bottom-end",
              trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": ACTION_OVERFLOW_TESTID, children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "xs" }) }),
              items: menuActions.map((action) => ({
                label: action.label,
                icon: action.icon,
                variant: action.variant === "danger" ? "danger" : "default",
                onClick: () => fireAction(action)
              }))
            }
          )
        ] }) })
      ] }),
      editing ? /* @__PURE__ */ jsx(RichTextEditor, { value, changeEvent: contentChangeEvent, placeholder }) : /* @__PURE__ */ jsx(
        Box,
        {
          ...pressableProps(editEvent ? emitWithId(editEvent) : void 0),
          "aria-label": editEvent ? editLabel ?? t("documentPanel.edit") : void 0,
          className: cn(
            "rounded-interactive px-1 -mx-1 min-h-[16rem]",
            editEvent && "cursor-text transition-colors hover:bg-muted/30"
          ),
          "data-testid": "document-body",
          children: value && value !== "" ? /* @__PURE__ */ jsx(RichTextEditor, { value, readOnly: true }) : /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: placeholder ?? t("documentPanel.placeholder") })
        }
      )
    ] })
  ] });
}
var DocumentViewer = ({
  title,
  src,
  content,
  documentType = "pdf",
  currentPage: propPage,
  totalPages,
  height = 600,
  showToolbar = true,
  showDownload = false,
  showPrint = false,
  actions,
  documents,
  isLoading = false,
  error,
  className,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [zoom, setZoom] = useState(100);
  const [currentPage, setCurrentPage] = useState(propPage ?? 1);
  const [activeDocIndex, setActiveDocIndex] = useState(0);
  const handleAction = useCallback(
    (action) => {
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, { page: currentPage });
      }
    },
    [eventBus, currentPage]
  );
  const handleDownload = useCallback(() => {
    const downloadSrc = documents?.[activeDocIndex]?.src ?? src;
    if (downloadSrc) {
      eventBus.emit("UI:DOCUMENT_DOWNLOAD", { src: downloadSrc });
      window.open(downloadSrc, "_blank");
    }
  }, [documents, activeDocIndex, src, eventBus]);
  const handlePrint = useCallback(() => {
    eventBus.emit("UI:DOCUMENT_PRINT", {});
    window.print();
  }, [eventBus]);
  const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z + 25, 200)), []);
  const handleZoomOut = useCallback(() => setZoom((z) => Math.max(z - 25, 50)), []);
  const handlePagePrev = useCallback(() => {
    setCurrentPage((p) => Math.max(p - 1, 1));
    eventBus.emit("UI:DOCUMENT_PAGE_CHANGE", { page: currentPage - 1 });
  }, [eventBus, currentPage]);
  const handlePageNext = useCallback(() => {
    if (totalPages) {
      setCurrentPage((p) => Math.min(p + 1, totalPages));
      eventBus.emit("UI:DOCUMENT_PAGE_CHANGE", { page: currentPage + 1 });
    }
  }, [totalPages, eventBus, currentPage]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.documentError"),
        message: error.message,
        className
      }
    );
  }
  const activeDoc = documents?.[activeDocIndex];
  const activeSrc = activeDoc?.src ?? src;
  const activeContent = activeDoc?.content ?? content;
  const activeDocType = activeDoc?.documentType ?? documentType;
  if (!activeSrc && !activeContent) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        icon: FileText,
        title: t("display.noDocument"),
        description: t("documentViewer.noDocumentDescription"),
        className
      }
    );
  }
  const tabItems = documents?.map((doc, idx) => ({
    id: `doc-${idx}`,
    label: doc.label,
    content: null
    // We handle content rendering separately
  }));
  const renderContent = () => {
    if (activeDocType === "pdf" && activeSrc) {
      return /* @__PURE__ */ jsx(
        "iframe",
        {
          src: activeSrc,
          title: title || t("documentViewer.iframeTitle"),
          className: "w-full border-0",
          style: {
            height: typeof height === "number" ? height : height,
            transform: `scale(${zoom / 100})`,
            transformOrigin: "top left",
            width: `${1e4 / zoom}%`
          }
        }
      );
    }
    if (activeDocType === "html" && activeContent) {
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "w-full overflow-auto p-4",
          style: { height, fontSize: `${zoom}%` },
          dangerouslySetInnerHTML: { __html: activeContent }
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "w-full overflow-auto p-4 font-mono text-sm",
        style: { height, fontSize: `${zoom}%` },
        children: /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap break-words", children: activeContent })
      }
    );
  };
  return contentSurface.provide(
    /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-card-md rounded-container overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
      tabItems && tabItems.length > 1 && /* @__PURE__ */ jsx(Box, { className: "border-b border-border", children: /* @__PURE__ */ jsx(
        Tabs,
        {
          tabs: tabItems,
          activeTab: `doc-${activeDocIndex}`,
          onTabChange: (id) => {
            const idx = parseInt(id.replace("doc-", ""), 10);
            setActiveDocIndex(idx);
          }
        }
      ) }),
      showToolbar && /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          align: "center",
          justify: "between",
          className: "px-4 py-2 border-b border-border bg-muted/30",
          children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
              /* @__PURE__ */ jsx(Icon, { icon: FileText, size: "sm", className: "text-muted-foreground" }),
              title && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "truncate max-w-[200px]", children: title })
            ] }),
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomOut, onClick: handleZoomOut, "aria-label": t("aria.zoomOut") }),
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "tabular-nums w-10 text-center", children: [
                zoom,
                "%"
              ] }),
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomIn, onClick: handleZoomIn, "aria-label": t("aria.zoomIn") }),
              totalPages && totalPages > 1 && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(Box, { className: "w-px h-4 bg-border mx-1" }),
                /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ChevronLeft, onClick: handlePagePrev, disabled: currentPage <= 1, "aria-label": t("aria.previousPage") }),
                /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "tabular-nums", children: [
                  currentPage,
                  " / ",
                  totalPages
                ] }),
                /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ChevronRight, onClick: handlePageNext, disabled: currentPage >= totalPages, "aria-label": t("aria.nextPage") })
              ] }),
              /* @__PURE__ */ jsx(Box, { className: "w-px h-4 bg-border mx-1" }),
              showDownload && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: Download, onClick: handleDownload, "aria-label": t("aria.downloadDocument") }),
              showPrint && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: Printer, onClick: handlePrint, "aria-label": t("aria.printDocument") }),
              actions?.map((action, idx) => /* @__PURE__ */ jsx(
                Badge,
                {
                  variant: "default",
                  className: "cursor-pointer hover:opacity-80 transition-opacity",
                  onClick: () => handleAction(action),
                  children: action.label
                },
                idx
              ))
            ] })
          ]
        }
      ),
      /* @__PURE__ */ jsx(Box, { className: "w-full overflow-hidden bg-muted/20", children: renderContent() })
    ] }) })
  );
};
DocumentViewer.displayName = "DocumentViewer";
function extractTitle(children) {
  if (!React93__default.isValidElement(children)) return void 0;
  const props = children.props;
  if (typeof props.title === "string") {
    return props.title;
  }
  return void 0;
}
var DrawerSlot = ({
  children,
  title: overrideTitle,
  position = "right",
  size: size2 = "md",
  className,
  sourceTrait
}) => {
  const eventBus = useEventBus();
  const schemaCtx = useEntitySchemaOptional();
  const isOpen = Boolean(children);
  const title = overrideTitle || extractTitle(children);
  const handleClose = () => {
    const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
    const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
    eventBus.emit(`${prefix}CLOSE`);
    eventBus.emit(`${prefix}CANCEL`);
  };
  if (!isOpen) return null;
  return /* @__PURE__ */ jsx(
    Drawer,
    {
      isOpen,
      onClose: handleClose,
      title,
      position,
      width: size2,
      className,
      children: /* @__PURE__ */ jsx(RenderSlotProvider, { slot: "drawer", children })
    }
  );
};
DrawerSlot.displayName = "DrawerSlot";
var colorTokenVars = {
  primary: "var(--color-primary)",
  secondary: "var(--color-secondary)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  error: "var(--color-error)",
  muted: "var(--color-muted)"
};
function ArchSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const archCount = 3;
  const archH = h / archCount;
  const rings = 5;
  for (let a = 0; a < archCount; a++) {
    const baseY = a * archH + archH;
    const topY = a * archH + archH * 0.05;
    for (let r = 0; r < rings; r++) {
      const scale = 1 - r * 0.17;
      const archW = w * 0.95 * scale;
      const aTopY = topY + (1 - scale) * (baseY - topY) * 0.5;
      const aBaseY = baseY - (1 - scale) * archH * 0.05;
      const edgeX2 = facing === "right" ? w : 0;
      const innerX2 = facing === "right" ? w - archW : archW;
      const midY = (aTopY + aBaseY) / 2;
      const radius = Math.sqrt(archW * archW + (aBaseY - midY) * (aBaseY - midY));
      if (facing === "right") {
        paths.push(
          `M ${f2(edgeX2)},${f2(aBaseY)} A ${f2(radius)} ${f2(radius)} 0 0 0 ${f2(innerX2)},${f2(aTopY + (aBaseY - aTopY) * 0.5)} A ${f2(radius)} ${f2(radius)} 0 0 0 ${f2(edgeX2)},${f2(aTopY)}`
        );
      } else {
        paths.push(
          `M ${f2(edgeX2)},${f2(aBaseY)} A ${f2(radius)} ${f2(radius)} 0 0 1 ${f2(innerX2)},${f2(aTopY + (aBaseY - aTopY) * 0.5)} A ${f2(radius)} ${f2(radius)} 0 0 1 ${f2(edgeX2)},${f2(aTopY)}`
        );
      }
    }
    const edgeX = facing === "right" ? w : 0;
    const innerX = facing === "right" ? w * 0.05 : w * 0.95;
    paths.push(`M ${f2(edgeX)},${f2(baseY)} L ${f2(innerX)},${f2(baseY)}`);
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function VineSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const dir = facing === "right" ? -1 : 1;
  const edgeX = facing === "right" ? w * 0.85 : w * 0.15;
  const segments = 5;
  const segH = h / segments;
  for (let i = 0; i < segments; i++) {
    const y0 = i * segH;
    const y1 = y0 + segH;
    const sway = w * 0.12 * (i % 2 === 0 ? 1 : -1);
    paths.push(
      `M ${f2(edgeX + sway)},${f2(y0)} C ${f2(edgeX - sway)},${f2(y0 + segH * 0.33)} ${f2(edgeX + sway)},${f2(y0 + segH * 0.66)} ${f2(edgeX - sway)},${f2(y1)}`
    );
    const branchY = y0 + segH * 0.35;
    const branchX = edgeX;
    const leafW = w * 0.55;
    const leafH = segH * 0.35;
    const leafTipX = branchX + dir * leafW;
    const leafTipY = branchY - leafH * 0.2;
    paths.push(
      `M ${f2(branchX)},${f2(branchY)} C ${f2(branchX + dir * leafW * 0.3)},${f2(branchY - leafH)} ${f2(leafTipX - dir * leafW * 0.1)},${f2(leafTipY - leafH * 0.3)} ${f2(leafTipX)},${f2(leafTipY)}`
    );
    paths.push(
      `M ${f2(leafTipX)},${f2(leafTipY)} C ${f2(leafTipX - dir * leafW * 0.2)},${f2(leafTipY + leafH * 0.6)} ${f2(branchX + dir * leafW * 0.15)},${f2(branchY + leafH * 0.4)} ${f2(branchX)},${f2(branchY + leafH * 0.1)}`
    );
    const tendrilY = y0 + segH * 0.7;
    const tendrilW = w * 0.35;
    const tendrilTipX = edgeX + dir * tendrilW;
    paths.push(
      `M ${f2(edgeX)},${f2(tendrilY)} Q ${f2(edgeX + dir * tendrilW * 0.6)},${f2(tendrilY - segH * 0.12)} ${f2(tendrilTipX)},${f2(tendrilY + segH * 0.05)}`
    );
    const spR = leafW * 0.08;
    paths.push(
      `M ${f2(leafTipX)},${f2(leafTipY)} A ${f2(spR)} ${f2(spR)} 0 1 ${facing === "right" ? 0 : 1} ${f2(leafTipX + dir * spR * 0.5)},${f2(leafTipY + spR)}`
    );
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function LatticeSVG({
  facing,
  w,
  h,
  color,
  strokeWidth
}) {
  const paths = [];
  const cols = 5;
  const rows2 = Math.ceil(h / (w / cols));
  const cellW = w / cols;
  const cellH = cellW;
  const bulge = cellW * 0.3;
  for (let row = 0; row < rows2; row++) {
    for (let col = 0; col < cols; col++) {
      const cx = col * cellW + cellW / 2;
      const cy = row * cellH + cellH / 2;
      const hw = cellW * 0.5;
      const hh = cellH * 0.5;
      paths.push(
        `M ${f2(cx)},${f2(cy - hh)} Q ${f2(cx + bulge)},${f2(cy)} ${f2(cx)},${f2(cy + hh)}`
      );
      paths.push(
        `M ${f2(cx)},${f2(cy - hh)} Q ${f2(cx - bulge)},${f2(cy)} ${f2(cx)},${f2(cy + hh)}`
      );
      paths.push(
        `M ${f2(cx - hw)},${f2(cy)} Q ${f2(cx)},${f2(cy - bulge * 0.5)} ${f2(cx + hw)},${f2(cy)}`
      );
      paths.push(
        `M ${f2(cx - hw)},${f2(cy)} Q ${f2(cx)},${f2(cy + bulge * 0.5)} ${f2(cx + hw)},${f2(cy)}`
      );
    }
  }
  return /* @__PURE__ */ jsx("g", { fill: "none", stroke: color, strokeWidth, children: paths.map((d, i) => /* @__PURE__ */ jsx("path", { d }, i)) });
}
function f2(n) {
  return n.toFixed(2);
}
var VARIANT_MAP2 = {
  arch: ArchSVG,
  vine: VineSVG,
  lattice: LatticeSVG
};
var EdgeDecoration = ({
  variant = "arch",
  side = "both",
  opacity = 0.15,
  color = "primary",
  strokeWidth = 0.5,
  width = 15,
  className
}) => {
  const id = useId();
  const Variant = VARIANT_MAP2[variant];
  const resolvedColor = color in colorTokenVars ? colorTokenVars[color] : color;
  const sides = side === "both" ? ["left", "right"] : [side];
  return /* @__PURE__ */ jsx(Fragment, { children: sides.map((s) => /* @__PURE__ */ jsx(
    "svg",
    {
      className: cn(
        "absolute top-0 h-full pointer-events-none",
        s === "left" ? "left-0" : "right-0",
        className
      ),
      style: {
        width: `${width}%`,
        opacity
      },
      viewBox: `0 0 200 ${200 * 3}`,
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: /* @__PURE__ */ jsx(
        Variant,
        {
          facing: s,
          w: 200,
          h: 600,
          color: resolvedColor,
          strokeWidth
        }
      )
    },
    `${id}-${s}`
  )) });
};
EdgeDecoration.displayName = "EdgeDecoration";
var ALL_CATEGORY = "__all__";
var MAX_RENDERED = 300;
var GridPicker = ({
  items,
  value,
  onChange,
  categories,
  searchPlaceholder,
  renderThumbnail,
  cellSize = 32,
  className
}) => {
  const { t } = useTranslate();
  const [search, setSearch] = useState("");
  const [activeCategory, setActiveCategory] = useState(ALL_CATEGORY);
  const gridRef = useRef(null);
  const categoryChips = useMemo(() => {
    if (categories !== void 0) return categories;
    const seen = [];
    for (const item of items) {
      if (!seen.includes(item.category)) seen.push(item.category);
    }
    return seen;
  }, [categories, items]);
  const filtered = useMemo(() => {
    const needle = search.trim().toLowerCase();
    return items.filter((item) => {
      const matchesCategory = activeCategory === ALL_CATEGORY || item.category === activeCategory;
      const matchesSearch = needle === "" || item.label.toLowerCase().includes(needle) || item.keywords !== void 0 && item.keywords.some((k) => k.toLowerCase().includes(needle));
      return matchesCategory && matchesSearch;
    });
  }, [items, search, activeCategory]);
  const visible = useMemo(() => filtered.slice(0, MAX_RENDERED), [filtered]);
  const truncated = filtered.length - visible.length;
  const select = useCallback(
    (item) => {
      onChange(item.id);
    },
    [onChange]
  );
  const handleKeyDown = useCallback(
    (e, index) => {
      const cells = gridRef.current?.querySelectorAll(
        "[data-gridpicker-cell]"
      );
      if (cells === void 0 || cells.length === 0) return;
      const columns = (() => {
        const grid = gridRef.current;
        if (grid === null) return 1;
        const style = window.getComputedStyle(grid);
        const cols = style.gridTemplateColumns.split(" ").filter(Boolean).length;
        return cols > 0 ? cols : 1;
      })();
      let next = -1;
      if (e.key === "ArrowRight") next = index + 1;
      else if (e.key === "ArrowLeft") next = index - 1;
      else if (e.key === "ArrowDown") next = index + columns;
      else if (e.key === "ArrowUp") next = index - columns;
      else if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        select(filtered[index]);
        return;
      } else {
        return;
      }
      e.preventDefault();
      if (next >= 0 && next < cells.length) {
        cells[next].focus();
      }
    },
    [filtered, select]
  );
  return /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: cn("w-full", className), children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        type: "search",
        icon: "search",
        value: search,
        placeholder: searchPlaceholder,
        clearable: true,
        onClear: () => setSearch(""),
        onChange: (e) => setSearch(e.target.value)
      }
    ),
    categoryChips.length > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "xs", wrap: true, children: [
      /* @__PURE__ */ jsx(
        Badge,
        {
          variant: activeCategory === ALL_CATEGORY ? "primary" : "neutral",
          size: "sm",
          role: "button",
          tabIndex: 0,
          "aria-pressed": activeCategory === ALL_CATEGORY,
          className: "cursor-pointer",
          onClick: () => setActiveCategory(ALL_CATEGORY),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setActiveCategory(ALL_CATEGORY);
            }
          },
          children: t("gridPicker.all")
        }
      ),
      categoryChips.map((category) => /* @__PURE__ */ jsx(
        Badge,
        {
          variant: activeCategory === category ? "primary" : "neutral",
          size: "sm",
          role: "button",
          tabIndex: 0,
          "aria-pressed": activeCategory === category,
          className: "cursor-pointer",
          onClick: () => setActiveCategory(category),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setActiveCategory(category);
            }
          },
          children: category
        },
        category
      ))
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: gridRef,
        role: "listbox",
        className: "grid gap-1 overflow-y-auto max-h-64 p-1",
        style: {
          gridTemplateColumns: `repeat(auto-fill, minmax(${cellSize}px, 1fr))`
        },
        children: visible.map((item, index) => {
          const selected = item.id === value;
          return /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              role: "option",
              "aria-selected": selected,
              "aria-label": item.label,
              title: item.label,
              "data-gridpicker-cell": true,
              tabIndex: selected || value === void 0 && index === 0 ? 0 : -1,
              onClick: () => select(item),
              onKeyDown: (e) => handleKeyDown(e, index),
              className: cn(
                "flex items-center justify-center rounded-interactive",
                "transition-colors hover:bg-muted",
                "focus:outline-none focus:ring-1 focus:ring-ring",
                selected && "bg-primary/10 ring-1 ring-primary"
              ),
              style: { width: cellSize, height: cellSize },
              children: renderThumbnail(item)
            },
            item.id
          );
        })
      }
    ),
    truncated > 0 && /* @__PURE__ */ jsx("div", { className: "px-1 text-xs text-muted-foreground", children: t("gridPicker.moreRefine", { count: truncated }) })
  ] });
};
GridPicker.displayName = "GridPicker";
var { lib, ordered } = emojilib;
var EMOJI_ITEMS = (() => {
  const items = [];
  for (const name of ordered) {
    const entry = lib[name];
    if (entry === void 0 || entry.char === null || entry.char === "") continue;
    items.push({
      id: entry.char,
      label: name.replace(/_/g, " "),
      category: entry.category.replace(/_/g, " "),
      keywords: entry.keywords
    });
  }
  return items;
})();
var EmojiPicker = ({
  pickEvent,
  position = "top",
  triggerIcon = "smile",
  triggerLabel,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const label = triggerLabel ?? t("emojiPicker.addEmoji");
  const [open, setOpen] = useState(false);
  const handlePick = (glyph) => {
    if (pickEvent !== void 0) {
      const payload = { emoji: glyph };
      eventBus.emit(`UI:${pickEvent}`, payload);
    }
    setOpen(false);
  };
  return /* @__PURE__ */ jsx(
    Popover,
    {
      ...domPassthrough(rest),
      position,
      trigger: "click",
      showArrow: false,
      open,
      onOpenChange: setOpen,
      content: /* @__PURE__ */ jsx(
        GridPicker,
        {
          items: EMOJI_ITEMS,
          onChange: handlePick,
          searchPlaceholder: t("emojiPicker.search"),
          renderThumbnail: (item) => /* @__PURE__ */ jsx("span", { className: "text-xl leading-none", "aria-hidden": "true", children: item.id }),
          cellSize: 32,
          className: "w-80"
        }
      ),
      children: /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          icon: triggerIcon,
          "aria-label": label,
          title: label,
          className,
          "data-testid": "emoji-picker-trigger"
        }
      )
    }
  );
};
EmojiPicker.displayName = "EmojiPicker";
var iconSizeMap = {
  sm: "lg",
  md: "xl",
  lg: "xl"
};
var gapMap = {
  sm: "sm",
  md: "md",
  lg: "lg"
};
var FeatureCard = ({
  icon,
  title,
  description,
  href,
  linkLabel,
  variant = "bordered",
  size: size2 = "md",
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const renderIcon = () => {
    if (!icon) return null;
    return /* @__PURE__ */ jsx(
      Icon,
      {
        icon: typeof icon === "string" ? void 0 : icon,
        name: typeof icon === "string" ? icon : void 0,
        size: iconSizeMap[size2],
        className: "text-accent"
      }
    );
  };
  const handleLinkClick = () => {
    if (href) {
      window.open(href, "_blank", "noopener,noreferrer");
    }
  };
  return /* @__PURE__ */ jsx(
    Card,
    {
      ...domPassthrough(rest),
      variant,
      padding: size2,
      className: cn(
        variant === "interactive" && "hover:border-primary",
        className
      ),
      ...pressableProps(variant === "interactive" && href ? handleLinkClick : void 0),
      children: /* @__PURE__ */ jsxs(VStack, { gap: gapMap[size2], align: "start", children: [
        renderIcon(),
        /* @__PURE__ */ jsx(Typography, { variant: "h4", className: size2 === "sm" ? "text-base" : void 0, children: title }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: description }),
        href && variant !== "interactive" && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: handleLinkClick,
            className: "text-primary -ml-2",
            children: linkLabel ?? t("featureCard.learnMore")
          }
        )
      ] })
    }
  );
};
FeatureCard.displayName = "FeatureCard";
var FeatureGrid = ({
  items,
  columns = 3,
  gap = "md",
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(
    SimpleGrid,
    {
      ...domPassthrough(rest),
      cols: columns,
      gap,
      className: cn(className),
      children: (Array.isArray(items) ? items : []).map((item, index) => /* @__PURE__ */ jsx(FeatureCard, { ...item }, `${item.title}-${index}`))
    }
  );
};
FeatureGrid.displayName = "FeatureGrid";
function fileIcon(name) {
  const ext = name.split(".").pop()?.toLowerCase() ?? "";
  switch (ext) {
    case "ts":
    case "tsx":
      return "file-code";
    case "js":
    case "jsx":
      return "file-code";
    case "json":
    case "orb":
      return "file-json";
    case "css":
    case "scss":
      return "file-text";
    case "md":
      return "file-text";
    case "py":
      return "file-code";
    case "html":
      return "file-code";
    default:
      return "file";
  }
}
var TreeNavContext = createContext({ activeKey: void 0, setActive: () => {
} });
function levelOf(el) {
  return Number(el.getAttribute("aria-level") ?? "1");
}
function treeRowKeyDown(e, state) {
  if (e.target !== e.currentTarget) return;
  const row = e.currentTarget;
  const tree = row.closest('[role="tree"]');
  if (!tree) return;
  const rows2 = Array.from(tree.querySelectorAll('[role="treeitem"]'));
  const idx = rows2.indexOf(row);
  const focusRow = (target) => {
    if (!target) return;
    e.preventDefault();
    target.focus();
  };
  switch (e.key) {
    case "Enter":
    case " ":
      e.preventDefault();
      row.click();
      return;
    case "ArrowDown":
      focusRow(rows2[idx + 1]);
      return;
    case "ArrowUp":
      focusRow(rows2[idx - 1]);
      return;
    case "Home":
      focusRow(rows2[0]);
      return;
    case "End":
      focusRow(rows2[rows2.length - 1]);
      return;
    case "ArrowRight":
      if (state.expanded === false) {
        e.preventDefault();
        state.toggle();
      } else if (state.expanded === true) {
        const next = rows2[idx + 1];
        if (next && levelOf(next) > levelOf(row)) focusRow(next);
      }
      return;
    case "ArrowLeft":
      if (state.expanded === true) {
        e.preventDefault();
        state.toggle();
      } else {
        const level = levelOf(row);
        focusRow(rows2.slice(0, idx).reverse().find((r) => levelOf(r) < level));
      }
      return;
  }
}
function TreeRoot({
  defaultKey,
  className,
  rest,
  children
}) {
  const [active, setActive] = useState(void 0);
  const rootRef = useRef(null);
  useEffect(() => {
    if (active === void 0) return;
    if (!rootRef.current?.querySelector('[role="treeitem"][tabindex="0"]')) setActive(void 0);
  });
  const value = React93__default.useMemo(() => ({ activeKey: active ?? defaultKey, setActive }), [active, defaultKey]);
  return /* @__PURE__ */ jsx(TreeNavContext.Provider, { value, children: /* @__PURE__ */ jsx(Box, { ref: rootRef, className: `py-1 overflow-y-auto ${className ?? ""}`, ...domPassthrough(rest), role: "tree", children }) });
}
var TreeNodeItem = ({
  node,
  depth,
  indent,
  selectedPath,
  onFileSelect,
  onNodeExpand,
  expandedPaths,
  defaultExpanded = false
}) => {
  const isDir = node.type === "dir";
  const hasDerived = !isDir && ((node.children?.length ?? 0) > 0 || node.expandable === true);
  const askedRef = useRef(false);
  const revealed = expandedPaths?.includes(node.path) === true;
  useEffect(() => {
    if (!revealed) return;
    setExpanded(true);
    if (node.expandable === true && !askedRef.current) {
      askedRef.current = true;
      onNodeExpand?.(node.path);
    }
  }, [revealed, node.expandable, node.path, onNodeExpand]);
  const [expanded, setExpanded] = useState(isDir && (defaultExpanded || depth < 1));
  const isSelected = node.path === selectedPath;
  const { t } = useTranslate();
  const nav = useContext(TreeNavContext);
  const toggleDerived = useCallback(() => {
    if (!expanded && node.expandable === true && !askedRef.current) {
      askedRef.current = true;
      onNodeExpand?.(node.path);
    }
    setExpanded((prev) => !prev);
  }, [expanded, node.expandable, node.path, onNodeExpand]);
  const handleClick = useCallback(() => {
    if (isDir) {
      setExpanded((prev) => !prev);
    } else {
      onFileSelect?.(node.path);
    }
  }, [isDir, node.path, onFileSelect]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        className: `flex items-center gap-1.5 py-0.5 px-2 cursor-pointer rounded-interactive transition-colors ${isSelected ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`,
        style: { paddingLeft: depth * indent + 8 },
        onClick: handleClick,
        role: "treeitem",
        tabIndex: nav.activeKey === node.path ? 0 : -1,
        "aria-level": depth + 1,
        "aria-selected": isSelected,
        "aria-expanded": isDir || hasDerived ? expanded : void 0,
        onFocus: () => nav.setActive(node.path),
        onKeyDown: (e) => treeRowKeyDown(e, {
          expanded: isDir || hasDerived ? expanded : void 0,
          toggle: isDir ? () => setExpanded((prev) => !prev) : toggleDerived
        }),
        children: [
          isDir ? /* @__PURE__ */ jsx(
            Icon,
            {
              name: expanded ? "chevron-down" : "chevron-right",
              size: "xs",
              className: "text-[var(--color-muted-foreground)] flex-shrink-0"
            }
          ) : hasDerived ? /* @__PURE__ */ jsx(
            Box,
            {
              ...pressableProps((e) => {
                e.stopPropagation();
                toggleDerived();
              }),
              tabIndex: -1,
              "aria-expanded": expanded,
              "aria-label": expanded ? t("fileTree.collapse") : t("fileTree.expand"),
              "data-testid": `file-tree-toggle-${node.path}`,
              className: "flex-shrink-0 flex items-center",
              children: /* @__PURE__ */ jsx(Icon, { name: expanded ? "chevron-down" : "chevron-right", size: "xs", className: "text-[var(--color-muted-foreground)]" })
            }
          ) : /* @__PURE__ */ jsx(Box, { style: { width: 12, flexShrink: 0 } }),
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: isDir ? expanded ? "folder-open" : "folder" : fileIcon(node.name),
              size: "xs",
              className: isSelected ? "text-inherit" : isDir ? "text-[var(--color-warning)]" : "text-[var(--color-muted-foreground)]"
            }
          ),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: `truncate font-mono text-xs !text-inherit ${isSelected ? "font-semibold" : ""}`,
              children: node.name
            }
          ),
          node.note !== void 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: `text-[9px] flex-shrink-0 ${isSelected ? "!text-inherit opacity-80" : "text-[var(--color-muted-foreground)]"}`, children: node.note }),
          !isDir && node.size !== void 0 && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: `text-[9px] ml-auto flex-shrink-0 ${isSelected ? "!text-inherit opacity-80" : "text-[var(--color-muted-foreground)]"}`,
              children: node.size < 1024 ? `${node.size}B` : `${Math.round(node.size / 1024)}KB`
            }
          )
        ]
      }
    ),
    (isDir || hasDerived) && expanded && node.children && /* @__PURE__ */ jsx(Box, { role: "group", children: node.children.map((child) => /* @__PURE__ */ jsx(
      TreeNodeItem,
      {
        node: child,
        depth: depth + 1,
        indent,
        selectedPath,
        onFileSelect,
        onNodeExpand,
        expandedPaths,
        defaultExpanded: depth < 0
      },
      child.path
    )) })
  ] });
};
function siblingsOf(target, roots, childrenByParent) {
  if (target.parentId) {
    const parentSiblings = childrenByParent.get(target.parentId);
    if (parentSiblings?.some((sibling) => sibling.id === target.id)) return parentSiblings;
  }
  return roots;
}
var FlatTreeNodeItem = ({
  item,
  depth,
  indent,
  childrenByParent,
  roots,
  onNodeSelect,
  onNodeAction,
  nodeActionIcon,
  nodeActionLabel,
  onNodeReorder,
  selectedId,
  look,
  isExpanded,
  onToggle
}) => {
  const { t } = useTranslate();
  const children = childrenByParent.get(item.id);
  const hasChildren = !!children && children.length > 0;
  const expanded = hasChildren && isExpanded(item.id, depth);
  const isSelected = selectedId !== void 0 && selectedId !== "" && item.id === selectedId;
  const nav = look === "nav";
  const rowRef = useRef(null);
  const treeNav = useContext(TreeNavContext);
  const handleClick = useCallback(() => {
    if (hasChildren && !onNodeSelect) onToggle(item.id, expanded);
    onNodeSelect?.(item.id);
  }, [hasChildren, expanded, item.id, onNodeSelect, onToggle]);
  const handleChevron = useCallback((e) => {
    e.stopPropagation();
    onToggle(item.id, expanded);
  }, [item.id, expanded, onToggle]);
  const handleAction = useCallback((e) => {
    e.stopPropagation();
    onNodeAction?.(item.id);
  }, [item.id, onNodeAction]);
  const { dragProps } = useDraggable$1({
    payload: { kind: "tree-node", data: { id: item.id } },
    disabled: !onNodeReorder
  });
  const handleRowDrop = useCallback(
    (payload, position) => {
      if (!onNodeReorder) return;
      const draggedId = typeof payload.data.id === "string" ? payload.data.id : void 0;
      if (!draggedId || draggedId === item.id) return;
      const rect = rowRef.current?.getBoundingClientRect();
      if (!rect || rect.height === 0) return;
      const relY = position.y - rect.top;
      const third = rect.height / 3;
      if (relY >= third && relY <= third * 2) {
        const existingChildren = childrenByParent.get(item.id);
        onNodeReorder(draggedId, item.id, existingChildren ? existingChildren.length : 0);
        return;
      }
      const siblings = siblingsOf(item, roots, childrenByParent);
      const newParentId = siblings === roots ? null : item.parentId ?? null;
      const targetIndex = siblings.findIndex((sibling) => sibling.id === item.id);
      const index = relY < third ? targetIndex < 0 ? 0 : targetIndex : targetIndex < 0 ? siblings.length : targetIndex + 1;
      onNodeReorder(draggedId, newParentId, index);
    },
    [onNodeReorder, item, roots, childrenByParent]
  );
  const { dropProps } = useDropZone({
    accepts: ["tree-node"],
    onDrop: handleRowDrop,
    disabled: !onNodeReorder
  });
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        ref: rowRef,
        className: `group/treerow flex items-center gap-1.5 px-2 cursor-pointer rounded-interactive transition-colors ${nav ? "py-1" : "py-0.5"} ${isSelected ? "bg-primary text-primary-foreground" : nav ? "text-foreground hover:bg-muted" : "hover:bg-muted"}`,
        style: { paddingLeft: depth * indent + 8 },
        onClick: handleClick,
        role: "treeitem",
        tabIndex: treeNav.activeKey === item.id ? 0 : -1,
        "aria-level": depth + 1,
        "aria-selected": isSelected,
        "aria-expanded": hasChildren ? expanded : void 0,
        onFocus: () => treeNav.setActive(item.id),
        onKeyDown: (e) => treeRowKeyDown(e, {
          expanded: hasChildren ? expanded : void 0,
          toggle: () => onToggle(item.id, expanded)
        }),
        ...dragProps,
        ...dropProps,
        children: [
          hasChildren ? /* @__PURE__ */ jsx(Box, { ...pressableProps(handleChevron), tabIndex: -1, className: "flex items-center flex-shrink-0", "aria-label": expanded ? t("fileTree.collapse") : t("fileTree.expand"), children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: expanded ? "chevron-down" : "chevron-right",
              size: "xs",
              className: isSelected ? "text-inherit" : "text-[var(--color-muted-foreground)]"
            }
          ) }) : /* @__PURE__ */ jsx(Box, { style: { width: 12, flexShrink: 0 } }),
          /* @__PURE__ */ jsx(
            Icon,
            {
              name: item.icon || (nav ? "file-text" : hasChildren ? expanded ? "folder-open" : "folder" : "file"),
              size: "xs",
              className: isSelected ? "text-inherit" : nav || !hasChildren ? "text-[var(--color-muted-foreground)]" : "text-[var(--color-warning)]"
            }
          ),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: `truncate ${nav ? "text-sm" : "font-mono text-xs"} !text-inherit ${isSelected ? "font-semibold" : ""}`,
              children: item.label
            }
          ),
          onNodeAction && /* @__PURE__ */ jsx(
            Box,
            {
              ...pressableProps(handleAction),
              tabIndex: treeNav.activeKey === item.id ? 0 : -1,
              "aria-label": nodeActionLabel ?? t("fileTree.nodeAction"),
              title: nodeActionLabel,
              className: `ml-auto flex-shrink-0 rounded-interactive p-0.5 opacity-0 group-hover/treerow:opacity-100 group-focus-within/treerow:opacity-100 transition-opacity ${isSelected ? "hover:bg-primary-foreground/20" : "hover:bg-border"}`,
              children: /* @__PURE__ */ jsx(Icon, { name: nodeActionIcon ?? "plus", size: "xs", className: "text-inherit" })
            }
          )
        ]
      }
    ),
    hasChildren && expanded && /* @__PURE__ */ jsx(Box, { role: "group", children: children.map((child) => /* @__PURE__ */ jsx(
      FlatTreeNodeItem,
      {
        item: child,
        depth: depth + 1,
        indent,
        childrenByParent,
        roots,
        onNodeSelect,
        onNodeAction,
        nodeActionIcon,
        nodeActionLabel,
        onNodeReorder,
        selectedId,
        look,
        isExpanded,
        onToggle
      },
      child.id
    )) })
  ] });
};
function ancestorsOf(id, byId) {
  const out = /* @__PURE__ */ new Set();
  if (!id) return out;
  let cur = byId.get(id)?.parentId;
  while (cur && byId.has(cur) && !out.has(cur)) {
    out.add(cur);
    cur = byId.get(cur)?.parentId;
  }
  return out;
}
var FlatFileTree = ({
  items,
  selectedId,
  look = "files",
  onNodeSelect,
  onNodeAction,
  nodeActionIcon,
  nodeActionLabel,
  onNodeReorder,
  className,
  indent = 16,
  ...rest
}) => {
  const [overrides, setOverrides] = useState(() => /* @__PURE__ */ new Map());
  const byId = React93__default.useMemo(() => new Map(items.map((node) => [node.id, node])), [items]);
  const selectedAncestors = React93__default.useMemo(() => ancestorsOf(selectedId, byId), [selectedId, byId]);
  const lastSelectedRef = React93__default.useRef(selectedId);
  React93__default.useEffect(() => {
    if (selectedId === lastSelectedRef.current) return;
    lastSelectedRef.current = selectedId;
    setOverrides((prev) => {
      if (![...selectedAncestors].some((a) => prev.get(a) === false)) return prev;
      const next = new Map(prev);
      for (const a of selectedAncestors) if (next.get(a) === false) next.delete(a);
      return next;
    });
  }, [selectedId, selectedAncestors]);
  const isExpanded = useCallback(
    (id, depth) => overrides.get(id) ?? (depth < 1 || selectedAncestors.has(id)),
    [overrides, selectedAncestors]
  );
  const onToggle = useCallback((id, effective) => {
    setOverrides((prev) => {
      const next = new Map(prev);
      next.set(id, !effective);
      return next;
    });
  }, []);
  if (items.length === 0) return null;
  const ids = new Set(items.map((node) => node.id));
  const childrenByParent = /* @__PURE__ */ new Map();
  const roots = [];
  for (const item of items) {
    if (item.parentId && ids.has(item.parentId)) {
      const siblings = childrenByParent.get(item.parentId);
      if (siblings) siblings.push(item);
      else childrenByParent.set(item.parentId, [item]);
    } else {
      roots.push(item);
    }
  }
  return /* @__PURE__ */ jsx(TreeRoot, { defaultKey: roots[0]?.id, className, rest, children: roots.map((item) => /* @__PURE__ */ jsx(
    FlatTreeNodeItem,
    {
      item,
      depth: 0,
      indent,
      childrenByParent,
      roots,
      onNodeSelect,
      onNodeAction,
      nodeActionIcon,
      nodeActionLabel,
      onNodeReorder,
      selectedId,
      look,
      isExpanded,
      onToggle
    },
    item.id
  )) });
};
var FileTree = ({
  tree,
  items,
  selectedPath,
  selectedId,
  look = "files",
  onFileSelect,
  onNodeExpand,
  expandedPaths,
  onNodeSelect,
  onNodeAction,
  nodeActionIcon,
  nodeActionLabel,
  onNodeReorder,
  className,
  indent = 16,
  ...rest
}) => {
  if (items) {
    return /* @__PURE__ */ jsx(
      FlatFileTree,
      {
        ...rest,
        items,
        selectedId,
        look,
        onNodeSelect,
        onNodeAction,
        nodeActionIcon,
        nodeActionLabel,
        onNodeReorder,
        className,
        indent
      }
    );
  }
  if (!tree || tree.length === 0) return null;
  return /* @__PURE__ */ jsx(TreeRoot, { defaultKey: tree[0]?.path, className, rest, children: tree.map((node) => /* @__PURE__ */ jsx(
    TreeNodeItem,
    {
      node,
      depth: 0,
      indent,
      selectedPath,
      onFileSelect,
      onNodeExpand,
      expandedPaths,
      defaultExpanded: true
    },
    node.path
  )) });
};
FileTree.displayName = "FileTree";
var resolveFilterType = (filter) => filter.filterType ?? filter.type;
var lookStyles7 = {
  toolbar: "",
  chips: "gap-1 [&_input]:rounded-pill [&_select]:rounded-pill [&_button]:rounded-pill [&_input]:!px-3 [&_select]:!px-3 [&_input]:bg-muted [&_select]:bg-muted [&_label]:hidden",
  pills: "gap-2 [&_input]:rounded-pill [&_select]:rounded-pill [&_button]:rounded-pill",
  "popover-trigger": "",
  "inline-column-header": "hidden"
};
var FilterGroupControls = ({
  entity,
  filters,
  onFilterChange,
  onClearAll,
  className,
  variant = "default",
  showIcon = true,
  query,
  isLoading,
  look = "toolbar",
  event,
  clearEvent,
  ...rest
}) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const queryState = useQuerySingleton(query);
  const [selectedValues, setSelectedValues] = useState(
    () => {
      if (queryState?.filters) {
        return Object.fromEntries(
          Object.entries(queryState.filters).filter(([_, v]) => v !== null && v !== void 0).map(([k, v]) => [k, String(v)])
        );
      }
      return {};
    }
  );
  useEffect(() => {
    if (queryState?.filters) {
      const newValues = Object.fromEntries(
        Object.entries(queryState.filters).filter(([_, v]) => v !== null && v !== void 0).map(([k, v]) => [k, String(v)])
      );
      setSelectedValues(newValues);
    }
  }, [queryState?.filters]);
  const handleFilterSelect = useCallback(
    (field, value) => {
      setSelectedValues((prev) => {
        if (value === null || value === "" || value === "all") {
          const next = { ...prev };
          delete next[field];
          return next;
        }
        return { ...prev, [field]: value };
      });
      if (queryState) {
        queryState.setFilter(field, value === "all" ? null : value);
      }
      onFilterChange?.(field, value === "all" ? null : value);
      const payload = {
        entity,
        field,
        value: value === "all" || value === null ? "" : value,
        query
      };
      if (event && event !== "FILTER") {
        eventBus.emit(`UI:${event}`, payload);
      }
      eventBus.emit("UI:FILTER", payload);
    },
    [onFilterChange, queryState, eventBus, entity, query, event]
  );
  const handleClearAll = useCallback(() => {
    setSelectedValues({});
    if (queryState) {
      queryState.clearFilters();
    }
    onClearAll?.();
    if (clearEvent && clearEvent !== "CLEAR_FILTERS") {
      eventBus.emit(`UI:${clearEvent}`, { entity, query });
    }
    eventBus.emit("UI:CLEAR_FILTERS", { entity, query });
  }, [onClearAll, queryState, eventBus, entity, query, clearEvent]);
  const activeFilterCount = Object.keys(selectedValues).length;
  if (variant === "pills") {
    return /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "md",
        align: "center",
        className: cn("flex-wrap", lookStyles7[look], className),
        ...domPassthrough(rest),
        children: [
          showIcon && /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4 text-muted-foreground" }),
          filters.map((filter) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsxs("span", { className: "text-sm font-medium text-muted-foreground", children: [
              filter.label,
              ":"
            ] }),
            /* @__PURE__ */ jsxs(
              HStack,
              {
                gap: "none",
                className: "rounded-interactive overflow-hidden border-[length:var(--border-width)] border-border",
                children: [
                  /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: () => handleFilterSelect(filter.field, null),
                      "aria-pressed": !selectedValues[filter.field],
                      className: cn(
                        "px-3 py-1.5 text-sm font-medium transition-all duration-fast",
                        !selectedValues[filter.field] ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:bg-muted"
                      ),
                      children: t("filterGroup.all")
                    }
                  ),
                  filter.options?.map((option) => /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      onClick: () => handleFilterSelect(filter.field, option),
                      "aria-pressed": selectedValues[filter.field] === option,
                      className: cn(
                        "px-3 py-1.5 text-sm font-medium transition-all duration-fast",
                        "border-l-[length:var(--border-width)] border-border",
                        selectedValues[filter.field] === option ? "bg-primary text-primary-foreground" : "bg-card text-muted-foreground hover:bg-muted"
                      ),
                      children: option
                    },
                    option
                  ))
                ]
              }
            )
          ] }, filter.field)),
          activeFilterCount > 0 && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleClearAll,
              leftIcon: "x",
              children: t("filterGroup.clear")
            }
          )
        ]
      }
    );
  }
  if (variant === "vertical") {
    return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col gap-4", lookStyles7[look], className), ...domPassthrough(rest), children: [
      showIcon && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-muted-foreground", children: [
        /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4" }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-bold uppercase tracking-wide", children: t("filterGroup.filters") })
      ] }),
      filters.map((filter) => /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx("label", { className: "text-xs font-bold text-muted-foreground uppercase tracking-wide", children: filter.label }),
        resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
          Input,
          {
            type: "date",
            value: selectedValues[filter.field] || "",
            onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
            clearable: true,
            onClear: () => handleFilterSelect(filter.field, null)
          }
        ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "date",
              value: selectedValues[`${filter.field}_from`] || "",
              onChange: (e) => handleFilterSelect(
                `${filter.field}_from`,
                e.target.value || null
              ),
              placeholder: t("filterGroup.from"),
              clearable: true,
              onClear: () => handleFilterSelect(`${filter.field}_from`, null)
            }
          ),
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "date",
              value: selectedValues[`${filter.field}_to`] || "",
              onChange: (e) => handleFilterSelect(
                `${filter.field}_to`,
                e.target.value || null
              ),
              placeholder: t("filterGroup.to"),
              clearable: true,
              onClear: () => handleFilterSelect(`${filter.field}_to`, null)
            }
          )
        ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ jsx(
            RangeSlider,
            {
              min: filter.min ?? 0,
              max: filter.max ?? 100,
              step: filter.step ?? 1,
              value: Number(
                selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
              ),
              onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
              showTooltip: true,
              "aria-label": t("filterGroup.from")
            }
          ),
          /* @__PURE__ */ jsx(
            RangeSlider,
            {
              min: filter.min ?? 0,
              max: filter.max ?? 100,
              step: filter.step ?? 1,
              value: Number(
                selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
              ),
              onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
              showTooltip: true,
              "aria-label": t("filterGroup.to")
            }
          )
        ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
          Input,
          {
            value: selectedValues[filter.field] || "",
            onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
            placeholder: filter.label,
            clearable: true,
            onClear: () => handleFilterSelect(filter.field, null)
          }
        ) : /* @__PURE__ */ jsx(
          Select,
          {
            "aria-label": filter.label,
            value: selectedValues[filter.field] || "all",
            onValueChange: (v) => handleFilterSelect(filter.field, v),
            options: [
              { value: "all", label: t("filterGroup.all") },
              ...filter.options?.map((opt) => ({
                value: opt,
                label: opt
              })) || []
            ]
          }
        )
      ] }, filter.field)),
      activeFilterCount > 0 && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          onClick: handleClearAll,
          leftIcon: "x",
          className: "self-start",
          children: t("filterGroup.clearAll")
        }
      )
    ] });
  }
  if (variant === "compact") {
    return /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        align: "center",
        className: cn("flex-wrap", lookStyles7[look], className),
        ...domPassthrough(rest),
        children: [
          showIcon && /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4 text-muted-foreground" }),
          filters.map((filter) => /* @__PURE__ */ jsx("div", { className: "min-w-[120px]", children: resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
            Input,
            {
              type: "date",
              value: selectedValues[filter.field] || "",
              onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
              clearable: true,
              onClear: () => handleFilterSelect(filter.field, null),
              className: "text-sm"
            }
          ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: selectedValues[`${filter.field}_from`] || "",
                onChange: (e) => handleFilterSelect(
                  `${filter.field}_from`,
                  e.target.value || null
                ),
                className: "text-sm min-w-[100px]"
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: selectedValues[`${filter.field}_to`] || "",
                onChange: (e) => handleFilterSelect(
                  `${filter.field}_to`,
                  e.target.value || null
                ),
                className: "text-sm min-w-[100px]"
              }
            )
          ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              RangeSlider,
              {
                min: filter.min ?? 0,
                max: filter.max ?? 100,
                step: filter.step ?? 1,
                value: Number(
                  selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
                ),
                onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
                className: "min-w-[100px]",
                "aria-label": t("filterGroup.from")
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
            /* @__PURE__ */ jsx(
              RangeSlider,
              {
                min: filter.min ?? 0,
                max: filter.max ?? 100,
                step: filter.step ?? 1,
                value: Number(
                  selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
                ),
                onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
                className: "min-w-[100px]",
                "aria-label": t("filterGroup.to")
              }
            )
          ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
            Input,
            {
              value: selectedValues[filter.field] || "",
              onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
              placeholder: filter.label,
              clearable: true,
              onClear: () => handleFilterSelect(filter.field, null),
              className: "text-sm"
            }
          ) : /* @__PURE__ */ jsx(
            Select,
            {
              "aria-label": filter.label,
              value: selectedValues[filter.field] || "all",
              onValueChange: (v) => handleFilterSelect(filter.field, v),
              options: [
                { value: "all", label: t("filterGroup.allOf", { label: filter.label }) },
                ...filter.options?.map((opt) => ({
                  value: opt,
                  label: opt
                })) || []
              ],
              className: "text-sm"
            }
          ) }, filter.field)),
          activeFilterCount > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            Object.entries(selectedValues).map(([field, value]) => {
              const filterDef = filters.find((f3) => f3.field === field);
              return /* @__PURE__ */ jsxs(
                Badge,
                {
                  variant: "primary",
                  size: "md",
                  className: "cursor-pointer",
                  onClick: () => handleFilterSelect(field, null),
                  children: [
                    filterDef?.label,
                    ": ",
                    value,
                    /* @__PURE__ */ jsx(Icon, { name: "x", className: "ml-1 h-3 w-3" })
                  ]
                },
                field
              );
            }),
            /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleClearAll, children: t("filterGroup.clearAll") })
          ] })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        lookStyles7[look],
        className
      ),
      ...domPassthrough(rest),
      children: /* @__PURE__ */ jsxs(HStack, { gap: "md", align: "center", className: "flex-wrap", children: [
        showIcon && /* @__PURE__ */ jsxs(
          HStack,
          {
            gap: "xs",
            align: "center",
            className: "text-muted-foreground",
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "filter", className: "h-4 w-4" }),
              /* @__PURE__ */ jsx("span", { className: "text-xs font-bold uppercase tracking-wide", children: t("filterGroup.filters") })
            ]
          }
        ),
        filters.map((filter) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("label", { className: "text-xs font-bold text-muted-foreground uppercase tracking-wide whitespace-nowrap", children: filter.label }),
          resolveFilterType(filter) === "date" ? /* @__PURE__ */ jsx(
            Input,
            {
              type: "date",
              value: selectedValues[filter.field] || "",
              onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
              clearable: true,
              onClear: () => handleFilterSelect(filter.field, null),
              className: "min-w-[160px]"
            }
          ) : resolveFilterType(filter) === "daterange" || resolveFilterType(filter) === "date-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: selectedValues[`${filter.field}_from`] || "",
                onChange: (e) => handleFilterSelect(
                  `${filter.field}_from`,
                  e.target.value || null
                ),
                placeholder: t("filterGroup.from"),
                clearable: true,
                onClear: () => handleFilterSelect(`${filter.field}_from`, null),
                className: "min-w-[130px]"
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
            /* @__PURE__ */ jsx(
              Input,
              {
                type: "date",
                value: selectedValues[`${filter.field}_to`] || "",
                onChange: (e) => handleFilterSelect(
                  `${filter.field}_to`,
                  e.target.value || null
                ),
                placeholder: t("filterGroup.to"),
                clearable: true,
                onClear: () => handleFilterSelect(`${filter.field}_to`, null),
                className: "min-w-[130px]"
              }
            )
          ] }) : resolveFilterType(filter) === "numberrange" || resolveFilterType(filter) === "number-range" ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              RangeSlider,
              {
                min: filter.min ?? 0,
                max: filter.max ?? 100,
                step: filter.step ?? 1,
                value: Number(
                  selectedValues[`${filter.field}_min`] ?? filter.min ?? 0
                ),
                onChange: (v) => handleFilterSelect(`${filter.field}_min`, String(v)),
                showTooltip: true,
                className: "min-w-[130px]",
                "aria-label": t("filterGroup.from")
              }
            ),
            /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "-" }),
            /* @__PURE__ */ jsx(
              RangeSlider,
              {
                min: filter.min ?? 0,
                max: filter.max ?? 100,
                step: filter.step ?? 1,
                value: Number(
                  selectedValues[`${filter.field}_max`] ?? filter.max ?? 100
                ),
                onChange: (v) => handleFilterSelect(`${filter.field}_max`, String(v)),
                showTooltip: true,
                className: "min-w-[130px]",
                "aria-label": t("filterGroup.to")
              }
            )
          ] }) : resolveFilterType(filter) === "text" ? /* @__PURE__ */ jsx(
            Input,
            {
              value: selectedValues[filter.field] || "",
              onChange: (e) => handleFilterSelect(filter.field, e.target.value || null),
              placeholder: filter.label,
              clearable: true,
              onClear: () => handleFilterSelect(filter.field, null),
              className: "min-w-[160px]"
            }
          ) : /* @__PURE__ */ jsx(
            Select,
            {
              "aria-label": filter.label,
              value: selectedValues[filter.field] || "all",
              onValueChange: (v) => handleFilterSelect(filter.field, v),
              options: [
                { value: "all", label: t("filterGroup.all") },
                ...filter.options?.map((opt) => ({
                  value: opt,
                  label: opt
                })) || []
              ],
              className: "min-w-[140px]"
            }
          )
        ] }, filter.field)),
        activeFilterCount > 0 && /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "ml-auto", children: [
          /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "md", children: t("filterGroup.activeCount", { count: activeFilterCount }) }),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleClearAll,
              leftIcon: "x",
              children: t("filterGroup.clearAll")
            }
          )
        ] })
      ] })
    }
  );
};
FilterGroupControls.displayName = "FilterGroupControls";
var FilterGroupPopover = (props) => {
  const { t } = useTranslate();
  const [open, setOpen] = useState(false);
  const queryState = useQuerySingleton(props.query);
  const activeFilterCount = queryState?.filters ? Object.values(queryState.filters).filter((v) => v !== null && v !== void 0).length : 0;
  return /* @__PURE__ */ jsxs("div", { className: cn("relative inline-block", props.className), children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: activeFilterCount > 0 ? "secondary" : "ghost",
        size: "sm",
        leftIcon: "filter",
        onClick: () => setOpen((o) => !o),
        "aria-expanded": open,
        "aria-haspopup": "true",
        children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
          /* @__PURE__ */ jsx("span", { children: t("filterGroup.filters") }),
          activeFilterCount > 0 && /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: activeFilterCount })
        ] })
      }
    ),
    open && /* @__PURE__ */ jsx("div", { className: "absolute left-0 z-50 mt-2 min-w-[16rem] rounded-container border border-[var(--color-border)] bg-[var(--color-card)] p-card-md shadow-elevation-popover surface-material", children: /* @__PURE__ */ jsx(
      FilterGroupControls,
      {
        ...props,
        className: void 0,
        look: "toolbar",
        variant: "vertical",
        showIcon: false
      }
    ) })
  ] });
};
FilterGroupPopover.displayName = "FilterGroupPopover";
var NARROW_QUERY = "(max-width: 767px)";
var FilterGroup = (props) => {
  const narrow = useMediaQuery(NARROW_QUERY);
  const defaultToolbar = (props.look ?? "toolbar") === "toolbar" && (props.variant ?? "default") === "default";
  return props.look === "popover-trigger" || defaultToolbar && narrow ? /* @__PURE__ */ jsx(FilterGroupPopover, { ...props }) : /* @__PURE__ */ jsx(FilterGroupControls, { ...props });
};
FilterGroup.displayName = "FilterGroup";
var directionStyles = {
  row: "flex-row",
  "row-reverse": "flex-row-reverse",
  col: "flex-col",
  "col-reverse": "flex-col-reverse"
};
var wrapStyles = {
  nowrap: "flex-nowrap",
  wrap: "flex-wrap",
  "wrap-reverse": "flex-wrap-reverse"
};
var alignStyles = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
};
var justifyStyles = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
};
var gapStyles4 = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8",
  "2xl": "gap-12"
};
var Flex = ({
  direction = "row",
  wrap = "nowrap",
  align = "stretch",
  justify = "start",
  gap = "none",
  inline = false,
  grow,
  shrink,
  basis,
  className,
  children,
  as: Component = "div",
  ...rest
}) => {
  const flexStyle = {};
  if (grow !== void 0 || shrink !== void 0 || basis !== void 0) {
    const growValue = grow === true ? 1 : grow === false ? 0 : grow;
    const shrinkValue = shrink === true ? 1 : shrink === false ? 0 : shrink;
    flexStyle.flexGrow = growValue;
    flexStyle.flexShrink = shrinkValue;
    if (basis !== void 0) {
      flexStyle.flexBasis = typeof basis === "number" ? `${basis}px` : basis;
    }
  }
  return React93__default.createElement(Component, {
    ...domPassthrough(rest),
    className: cn(
      inline ? "inline-flex" : "flex",
      directionStyles[direction],
      wrapStyles[wrap],
      alignStyles[align],
      justifyStyles[justify],
      gapStyles4[gap],
      className
    ),
    style: Object.keys(flexStyle).length > 0 ? flexStyle : void 0,
    children
  });
};
Flex.displayName = "Flex";
var FlipCard = ({
  front,
  back,
  flipped = false,
  onFlip,
  className,
  height = "h-64",
  ...rest
}) => {
  return /* @__PURE__ */ jsxs(
    FlipContainer,
    {
      ...domPassthrough(rest),
      flipped,
      className: cn(height, className),
      onClick: onFlip,
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute inset-0 w-full h-full rounded-container shadow-elevation-dialog flex items-center justify-center p-6",
            style: { backfaceVisibility: "hidden", transform: "rotateY(0deg)" },
            children: front
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute inset-0 w-full h-full rounded-container shadow-elevation-dialog flex items-center justify-center p-6",
            style: { backfaceVisibility: "hidden", transform: "rotateY(180deg)" },
            children: back
          }
        )
      ]
    }
  );
};
FlipCard.displayName = "FlipCard";
var positionClasses = {
  "bottom-center": "bottom-6 left-1/2 -translate-x-1/2",
  "bottom-left": "bottom-6 left-6",
  "bottom-right": "bottom-6 right-6",
  "top-center": "top-6 left-1/2 -translate-x-1/2",
  "top-left": "top-6 left-6",
  "top-right": "top-6 right-6"
};
var FloatingToolbar = ({
  items,
  position = "bottom-center",
  children,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("fixed z-50", positionClasses[position]), children: /* @__PURE__ */ jsxs(
    ButtonGroup,
    {
      variant: "default",
      orientation: "horizontal",
      className: cn(
        "items-center gap-1 rounded-full border border-border",
        "bg-card/95 backdrop-blur-sm shadow-elevation-popover p-1",
        className
      ),
      children: [
        items.map((item) => /* @__PURE__ */ jsx(
          Button,
          {
            variant: item.active ? "primary" : "ghost",
            size: "sm",
            icon: item.icon,
            action: item.action,
            actionPayload: item.actionPayload,
            disabled: item.disabled,
            "aria-pressed": item.active,
            "aria-label": item.label,
            className: "rounded-full",
            "data-testid": item.testId ?? `floating-toolbar-item-${item.id}`,
            onClick: () => {
              if (item.event) eventBus.emit(`UI:${item.event}`, { actionId: item.id });
            },
            children: /* @__PURE__ */ jsx(Typography, { as: "span", className: "sr-only", children: item.label })
          },
          item.id
        )),
        children && items.length > 0 && /* @__PURE__ */ jsx(Divider, { orientation: "vertical", className: "h-6 mx-1" }),
        children
      ]
    }
  ) });
};
FloatingToolbar.displayName = "FloatingToolbar";
var EDITABLE = { editable: true };
var ElementEditAccessContext = createContext(null);
function propAccessAt(resolver, focus, prop) {
  if (!resolver || !focus) return EDITABLE;
  return resolver(focus).prop(prop);
}

// lib/canvas-tools.ts
var CANVAS_TOOLS = [
  /** Shift-click and drag-a-box selection. */
  "multiSelect",
  /** Copy / cut / paste elements. */
  "clipboard",
  /** Double-click text to edit it in place. */
  "inlineText",
  /** ⇧2 zoom to selection, ⇧1 fit all. */
  "zoomToSelection",
  /** Resize and spacing handles on the selection. */
  "designHandles",
  /** Auto-layout direction, alignment, space-between and wrap. */
  "autoLayout",
  /** Min / max width and height. */
  "sizeLimits",
  /** Absolute position and constraints. */
  "absolute",
  /** Smart guides while moving or resizing. */
  "guides",
  /** ⌥-hover distances between elements. */
  "measure"
];
function hasCanvasTool(tools, tool) {
  return tools.includes(tool);
}
var SCREEN_SIZE_PRESETS = {
  mobile: { width: 375, minHeight: 320, labelKey: "screenSize.mobile", icon: "smartphone" },
  tablet: { width: 768, minHeight: 320, labelKey: "screenSize.tablet", icon: "tablet" },
  laptop: { width: 1280, minHeight: 360, labelKey: "screenSize.laptop", icon: "monitor" },
  wide: { width: 1600, minHeight: 360, labelKey: "screenSize.wide", icon: "monitor-up" }
};
function detectScreenSize(viewportWidth) {
  if (viewportWidth <= 640) return "mobile";
  if (viewportWidth <= 1024) return "tablet";
  if (viewportWidth <= 1440) return "laptop";
  return "wide";
}
var OVERVIEW_GAP_X = 160;
var OVERVIEW_GAP_Y = 240;
var CARD_CHROME_Y = 120;
function computeSpacing(screenSize = "wide") {
  const preset = SCREEN_SIZE_PRESETS[screenSize];
  return {
    x: preset.width + OVERVIEW_GAP_X,
    y: preset.minHeight + CARD_CHROME_Y + OVERVIEW_GAP_Y
  };
}
function getOrbitals(schema) {
  return schema.orbitals ?? [];
}
function getTraits(orbital) {
  if (!orbital.traits) return [];
  return orbital.traits.map((t) => {
    if (typeof t === "string") return { name: t };
    if (typeof t === "object" && t !== null && "ref" in t) return { name: t.ref };
    return t;
  });
}
function getStateMachine(trait) {
  const sm = trait.stateMachine;
  if (!sm) return null;
  return {
    states: sm.states ?? [],
    transitions: sm.transitions ?? []
  };
}
function getEntityInfo(orbital) {
  const entity = orbital.entity;
  if (typeof entity === "string") {
    return { name: entity, persistence: "runtime", fieldCount: 0 };
  }
  const e = entity;
  const fields = e.fields ?? [];
  return {
    name: e.name ?? orbital.name,
    persistence: e.persistence ?? "runtime",
    fieldCount: fields.length
  };
}
function getPages(orbital) {
  if (!orbital.pages) return [];
  return orbital.pages.map((p) => {
    if (typeof p === "string") return `/${p.toLowerCase()}`;
    if ("ref" in p) return p.path ?? `/${p.ref}`.toLowerCase();
    return p.path ?? `/${p.name}`.toLowerCase();
  });
}
function getEmits(trait) {
  const emits = trait.emits;
  if (!emits) return [];
  return emits.map((e) => typeof e === "string" ? e : e.event ?? "");
}
function getListens(trait) {
  const listens = trait.listens;
  if (!listens) return [];
  return listens.map((l) => typeof l === "string" ? l : l.event ?? "");
}
function extractRenderUI(effects) {
  return renderUiEntriesOf(effects).map(({ slot, pattern }) => ({ slot, pattern }));
}
function extractEffectTypes(effects) {
  const types = /* @__PURE__ */ new Set();
  for (const eff of effects) {
    if (Array.isArray(eff) && typeof eff[0] === "string") {
      types.add(eff[0]);
    }
  }
  return Array.from(types);
}
function findEventSources(config, path = "root", depth = 0, totalSiblings = 1, siblingIndex = 0) {
  const sources = [];
  if (depth > 10) return sources;
  const patternType = typeof config.type === "string" ? config.type : void 0;
  const events = [];
  if (patternType) {
    for (const prop of eventKeyPropsOf(patternType)) {
      const value = config[prop];
      if (typeof value === "string" && value) events.push(value);
    }
    for (const [prop, field] of eventListPropsOf(patternType)) {
      const items = config[prop];
      if (!Array.isArray(items)) continue;
      for (const item of items) {
        if (item === null || typeof item !== "object" || Array.isArray(item)) continue;
        const value = item[field];
        if (typeof value === "string" && value) events.push(value);
      }
    }
  }
  if (patternType && events.length > 0) {
    const positionHint = totalSiblings > 1 ? (siblingIndex + 0.5) / totalSiblings : 0.5 + depth * 0.1;
    const label = typeof config.label === "string" ? config.label : typeof config.content === "string" ? config.content : typeof config.text === "string" ? config.text : void 0;
    for (const event of events) {
      sources.push({ event, patternType, label, path, positionHint: Math.min(Math.max(positionHint, 0.1), 0.9) });
    }
  }
  const children = config.children;
  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child !== null && typeof child === "object" && !Array.isArray(child)) {
        sources.push(
          ...findEventSources(child, `${path}.children.${i}`, depth + 1, children.length, i)
        );
      }
    }
  }
  for (const [key, value] of Object.entries(config)) {
    if (key === "children" || key === "type") continue;
    if (value !== null && typeof value === "object" && !Array.isArray(value) && "type" in value) {
      sources.push(
        ...findEventSources(value, `${path}.${key}`, depth + 1, totalSiblings, siblingIndex)
      );
    }
  }
  return sources;
}
function collectEventSources(patterns) {
  const allSources = [];
  for (const entry of patterns) {
    allSources.push(...findEventSources(entry.pattern));
  }
  const seen = /* @__PURE__ */ new Set();
  return allSources.filter((s) => {
    if (seen.has(s.event)) return false;
    seen.add(s.event);
    return true;
  });
}
function detectStateRole(stateName, states, transitions) {
  const stateInfo = states.find((s) => s.name === stateName);
  const counts = /* @__PURE__ */ new Map();
  for (const t of transitions) {
    counts.set(t.from, (counts.get(t.from) ?? 0) + 1);
    counts.set(t.to, (counts.get(t.to) ?? 0) + 1);
  }
  const maxCount = Math.max(0, ...counts.values());
  return getStateRole(stateInfo?.isInitial, stateInfo?.isTerminal || stateInfo?.isFinal, counts.get(stateName) ?? 0, maxCount);
}
function extractTraitWires(orbitals, scope) {
  const seen = /* @__PURE__ */ new Set();
  return traitEventWires({ name: "", orbitals }).filter((w) => {
    const cross = w.emitterOrbital !== w.listenerOrbital;
    if (cross !== (scope === "cross-orbital")) return false;
    const key = cross ? `${w.emitterOrbital}\u241F${w.listenerOrbital}\u241F${w.event}` : `${w.emitterOrbital}\u241F${w.emitterTrait}\u241F${w.listenerTrait}\u241F${w.event}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
function schemaToOverviewGraph(schema, mockData, behaviorMeta, layoutHint, orbitalStatus, screenSize) {
  const orbitals = getOrbitals(schema);
  const nodes = [];
  const edges = [];
  const count = orbitals.length;
  const cols = layoutHint === "pipeline" ? count : Math.ceil(Math.sqrt(count));
  const spacing = computeSpacing(screenSize);
  for (let i = 0; i < orbitals.length; i++) {
    const orb = orbitals[i];
    const entityInfo = getEntityInfo(orb);
    const pageRoutes = getPages(orb);
    const traits = getTraits(orb);
    let initPatterns = [];
    let initEffectTypes = [];
    for (const trait of traits) {
      const sm = getStateMachine(trait);
      if (!sm) continue;
      const initT = sm.transitions.find((t) => t.event === "INIT");
      if (initT?.effects) {
        const patterns = extractRenderUI(initT.effects);
        if (patterns.length > 0) {
          initPatterns = patterns;
          initEffectTypes = extractEffectTypes(initT.effects);
          break;
        }
      }
    }
    if (initPatterns.length === 0) {
      for (const trait of traits) {
        const sm = getStateMachine(trait);
        if (!sm) continue;
        for (const t of sm.transitions) {
          if (t.effects) {
            const patterns = extractRenderUI(t.effects);
            if (patterns.length > 0) {
              initPatterns = patterns;
              initEffectTypes = extractEffectTypes(t.effects);
              break;
            }
          }
        }
        if (initPatterns.length > 0) break;
      }
    }
    const eventSources = collectEventSources(initPatterns);
    for (const source of eventSources) {
      for (const trait of traits) {
        const sm = getStateMachine(trait);
        if (!sm) continue;
        const smEvents = trait.stateMachine?.events ?? [];
        const matchingEvent = smEvents.find((ev) => ev.key === source.event);
        if (matchingEvent?.payloadSchema && Array.isArray(matchingEvent.payloadSchema)) {
          source.payloadFields = matchingEvent.payloadSchema.map((p) => ({
            name: p.name ?? "",
            type: p.type ?? "string",
            ...p.required ? { required: true } : {}
          }));
          break;
        }
      }
    }
    const col = i % cols;
    const row = Math.floor(i / cols);
    nodes.push({
      id: orb.name,
      type: "preview",
      position: { x: col * spacing.x, y: row * spacing.y },
      data: {
        orbitalName: orb.name,
        patterns: initPatterns,
        eventSources,
        effectTypes: initEffectTypes,
        layer: behaviorMeta?.[orb.name]?.layer,
        stateRole: "initial",
        entityName: entityInfo.name,
        persistence: entityInfo.persistence,
        fieldCount: entityInfo.fieldCount,
        traitCount: traits.length,
        pageRoutes,
        status: orbitalStatus?.[orb.name] ?? "idle",
        _fullSchema: schema,
        _mockData: mockData
      }
    });
  }
  for (const link of extractTraitWires(orbitals, "cross-orbital")) {
    const sourceNode = nodes.find((n) => n.id === link.emitterOrbital);
    const sourceData = sourceNode?.data;
    const triggerSource = sourceData?.eventSources.find((s) => s.event === link.event);
    edges.push({
      id: `ew-${link.emitterOrbital}-${link.listenerOrbital}-${link.event}`,
      source: link.emitterOrbital,
      target: link.listenerOrbital,
      sourceHandle: triggerSource ? `event-${link.event}` : void 0,
      type: "eventFlow",
      data: {
        event: link.event,
        isCrossOrbital: true,
        fromTrait: link.emitterTrait,
        toTrait: link.listenerTrait,
        triggerPatternType: triggerSource?.patternType,
        triggerLabel: triggerSource?.label
      }
    });
  }
  return { nodes, edges };
}
function collectUITransitions(orbital, filter) {
  const out = [];
  for (const trait of getTraits(orbital)) {
    if (!filter(trait)) continue;
    const sm = getStateMachine(trait);
    if (!sm) continue;
    for (const t of sm.transitions) {
      if (!t.effects) continue;
      const patterns = extractRenderUI(t.effects);
      if (patterns.length === 0) continue;
      out.push({
        trait,
        traitName: trait.name,
        transition: t,
        patterns,
        eventSources: collectEventSources(patterns),
        states: sm.states,
        allTransitions: sm.transitions
      });
    }
  }
  return out;
}
var LIVE_STATE = "live";
function collapseToScreens(transitions) {
  const screens = [];
  const byRender = /* @__PURE__ */ new Map();
  for (const entry of transitions) {
    const key = `${entry.traitName}|${JSON.stringify(entry.patterns)}`;
    const screen = byRender.get(key);
    if (screen) {
      screen.enteredBy.push(entry.transition.event);
      continue;
    }
    const fresh = { entry, enteredBy: [entry.transition.event] };
    byRender.set(key, fresh);
    screens.push(fresh);
  }
  return screens;
}
function stateOptionsFor(schema, orbitalName, entityName, transitions, view, mockData) {
  const screens = view === "screens" ? collapseToScreens(transitions) : transitions.map((entry) => ({ entry, enteredBy: [entry.transition.event] }));
  const manyTraits = new Set(screens.map((s) => s.entry.traitName)).size > 1;
  const stateUses = /* @__PURE__ */ new Map();
  for (const s of screens) {
    const key = `${s.entry.traitName}|${s.entry.transition.to}`;
    stateUses.set(key, (stateUses.get(key) ?? 0) + 1);
  }
  const armsSeen = /* @__PURE__ */ new Map();
  return screens.map(({ entry, enteredBy }) => {
    const t = entry.transition;
    const from = String(t.from);
    const state = view === "screens" ? (stateUses.get(`${entry.traitName}|${t.to}`) ?? 0) > 1 ? `${t.to} \xB7 ${t.event}` : t.to : `${t.event}: ${from} \u2192 ${t.to}`;
    const baseId = `${entry.traitName}:${t.event}:${from}:${t.to}`;
    const arm = (armsSeen.get(baseId) ?? 0) + 1;
    armsSeen.set(baseId, arm);
    const named = manyTraits ? `${entry.traitName} \xB7 ${state}` : state;
    const label = arm > 1 ? `${named} (guard ${arm})` : named;
    return {
      id: arm > 1 ? `${baseId}#${arm}` : baseId,
      label,
      hint: view === "screens" ? enteredBy.join(" \xB7 ") : entry.traitName,
      data: {
        orbitalName,
        traitName: entry.traitName,
        stateName: t.to,
        transitionEvent: t.event,
        fromState: from,
        toState: t.to,
        patterns: entry.patterns,
        eventSources: entry.eventSources,
        stateRole: detectStateRole(t.to, entry.states, entry.allTransitions),
        effectTypes: t.effects ? extractEffectTypes(t.effects) : [],
        guard: t.guard,
        entityName,
        _fullSchema: schema,
        _mockData: mockData,
        ...view === "screens" ? { cardLabel: "screen", enteredBy } : {}
      }
    };
  });
}
function stateOptionsOf(schema, orbitalName, view, mockData) {
  const orbital = getOrbitals(schema).find((o) => o.name === orbitalName);
  if (!orbital) return { own: [], groups: [] };
  const entityName = getEntityInfo(orbital).name;
  const embedded = collectEmbeddedTraits({ ...schema, orbitals: [orbital] });
  const own = stateOptionsFor(
    schema,
    orbitalName,
    entityName,
    collectUITransitions(orbital, (trait) => trait.sourceBehavior === void 0 && !embedded.has(trait.name)),
    view,
    mockData
  );
  const aliases = /* @__PURE__ */ new Map();
  for (const trait of getTraits(orbital)) {
    if (embedded.has(trait.name)) continue;
    if (trait.sourceBehavior && !aliases.has(trait.sourceBehavior.alias)) {
      aliases.set(trait.sourceBehavior.alias, trait.sourceBehavior.behavior);
    }
  }
  const groups = [...aliases].flatMap(([alias, behaviorName2]) => {
    const options = stateOptionsFor(
      schema,
      orbitalName,
      entityName,
      collectUITransitions(orbital, (trait) => trait.sourceBehavior?.alias === alias && !embedded.has(trait.name)),
      view,
      mockData
    );
    return options.length > 0 ? [{ alias, behaviorName: behaviorName2, options }] : [];
  });
  return { own, groups };
}
function initialStateOf(options) {
  const isInit = (o) => o.data.transitionEvent === "INIT" || (o.data.enteredBy ?? []).includes("INIT");
  const groupOptions = options.groups.flatMap((g) => g.options);
  const pick = options.own.find(isInit) ?? groupOptions.find(isInit) ?? options.own[0] ?? groupOptions[0];
  return pick?.id ?? LIVE_STATE;
}
function optionForPlayedStep(options, step) {
  const all = [...options.own, ...options.groups.flatMap((g) => g.options)];
  const exact = all.find((o) => o.id === `${step.trait}:${step.event}:${step.from}:${step.to}`);
  if (exact) return exact.id;
  return all.find((o) => o.data.traitName === step.trait && o.data.toState === step.to)?.id;
}
function canvasViewChanged(previous, next) {
  return previous === null || previous.scope !== next.scope || previous.focusedOrbital !== next.focusedOrbital || previous.screenSize !== next.screenSize || previous.level !== next.level;
}
function canvasViewGraph(schema, opts) {
  const overview = schemaToOverviewGraph(schema, opts.mockData, opts.behaviorMeta, opts.layoutHint, opts.orbitalStatus, opts.screenSize);
  const ids = overview.nodes.map((n) => n.id);
  const worldPositions = Object.fromEntries(overview.nodes.map((n) => [n.id, n.position]));
  const focusedOrbital = opts.focusedOrbital !== void 0 && ids.includes(opts.focusedOrbital) ? opts.focusedOrbital : ids[0];
  const withState = overview.nodes.map((node) => {
    const options = stateOptionsOf(schema, node.id, opts.view, opts.mockData);
    const all = [...options.own, ...options.groups.flatMap((g) => g.options)];
    const asked = opts.stateByOrbital?.[node.id];
    const chosen = asked === LIVE_STATE || all.some((o) => o.id === asked) ? asked : initialStateOf(options);
    const picked = all.find((o) => o.id === chosen);
    const data = picked ? { ...node.data, ...picked.data } : node.data;
    return { ...node, data: { ...data, focused: opts.scope === "world" && node.id === focusedOrbital } };
  });
  if (opts.scope === "local") {
    const focused = withState.filter((n) => n.id === focusedOrbital).map((n) => ({ ...n, position: { x: 0, y: 0 } }));
    return { nodes: focused, edges: [], focusedOrbital, worldPositions };
  }
  const byId = new Map(withState.map((n) => [n.id, n]));
  const edges = overview.edges.map((edge) => {
    const event = edge.data?.event;
    const renders = event !== void 0 && byId.get(edge.source)?.data.eventSources.some((s) => s.event === event);
    return renders ? edge : { ...edge, sourceHandle: void 0 };
  });
  return { nodes: withState, edges, focusedOrbital, worldPositions };
}
var TRAIT_CARD_SPACING_X = 480;
var TRAIT_CARD_SPACING_Y = 380;
var SYSTEM_CHIP = { width: 280, height: 88, gapX: 160, gapY: 36, bandGap: 72, bandLabel: 36 };
function schemaToSystemGraph(schema) {
  const orbitals = getOrbitals(schema);
  const pairs = /* @__PURE__ */ new Map();
  const eventsOf = /* @__PURE__ */ new Map();
  for (const w of extractTraitWires(orbitals, "cross-orbital")) {
    const key = `${w.emitterOrbital}\u241F${w.listenerOrbital}`;
    const pair = pairs.get(key) ?? { source: w.emitterOrbital, target: w.listenerOrbital, events: [] };
    if (!pair.events.includes(w.event)) pair.events.push(w.event);
    pairs.set(key, pair);
    for (const o of [w.emitterOrbital, w.listenerOrbital]) eventsOf.set(o, (eventsOf.get(o) ?? /* @__PURE__ */ new Set()).add(w.event));
  }
  const connected = orbitals.filter((o) => eventsOf.has(o.name)).map((o) => o.name);
  const layer = new Map(connected.map((n) => [n, 0]));
  for (let round = 0; round < connected.length; round++) {
    let moved = false;
    for (const { source, target } of pairs.values()) {
      const next = (layer.get(source) ?? 0) + 1;
      if (source !== target && next < connected.length && next > (layer.get(target) ?? 0)) {
        layer.set(target, next);
        moved = true;
      }
    }
    if (!moved) break;
  }
  const { width: W, height: H, gapX, gapY, bandGap, bandLabel } = SYSTEM_CHIP;
  const nodes = [];
  const band = (bandKind, count, y2) => {
    nodes.push({
      id: `__band_${bandKind}`,
      type: "systemBand",
      position: { x: 0, y: y2 },
      draggable: false,
      selectable: false,
      data: { orbitalName: `__band_${bandKind}`, kind: "system-band", bandKind, bandCount: count, patterns: [], eventSources: [] }
    });
  };
  const chip = (orb, x, y2) => {
    const entity = getEntityInfo(orb);
    nodes.push({
      id: orb.name,
      type: "system",
      position: { x, y: y2 },
      data: {
        orbitalName: orb.name,
        kind: "system-orbital",
        entityName: entity.name,
        persistence: entity.persistence,
        fieldCount: entity.fieldCount,
        traitCount: getTraits(orb).length,
        pageRoutes: getPages(orb),
        wireEvents: [...eventsOf.get(orb.name) ?? []],
        patterns: [],
        eventSources: []
      }
    });
  };
  let y = 0;
  if (connected.length > 0) {
    band("connected", connected.length, y);
    y += bandLabel;
    const rows2 = /* @__PURE__ */ new Map();
    let bottom = y;
    for (const name of connected) {
      const l = layer.get(name) ?? 0;
      const row = rows2.get(l) ?? 0;
      rows2.set(l, row + 1);
      const orb = orbitals.find((o) => o.name === name);
      if (!orb) continue;
      chip(orb, l * (W + gapX), y + row * (H + gapY));
      bottom = Math.max(bottom, y + row * (H + gapY) + H);
    }
    y = bottom + bandGap;
  }
  const standalone = orbitals.filter((o) => !eventsOf.has(o.name));
  if (standalone.length > 0) {
    band("standalone", standalone.length, y);
    y += bandLabel;
    const cellW = W + gapX / 4;
    const cellH = H + gapY;
    const cols = Math.max(1, Math.ceil(Math.sqrt(standalone.length * 1.6 * cellH / cellW)));
    standalone.forEach((orb, i) => chip(orb, i % cols * cellW, y + Math.floor(i / cols) * cellH));
  }
  const edges = [...pairs.values()].map((p) => ({
    id: `sys-${p.source}-${p.target}`,
    source: p.source,
    target: p.target,
    type: "eventFlow",
    data: { event: p.events.join(", "), isCrossOrbital: true }
  }));
  return { nodes, edges };
}
function orbitalToTraitGraph(schema, orbitalName, _mockData) {
  const orbital = getOrbitals(schema).find((o) => o.name === orbitalName);
  if (!orbital) return { nodes: [], edges: [] };
  const traits = getTraits(orbital);
  const nodes = [];
  const count = traits.length;
  const cols = Math.max(1, Math.ceil(Math.sqrt(count)));
  for (let i = 0; i < traits.length; i++) {
    const trait = traits[i];
    const sm = getStateMachine(trait);
    const transitions = (sm?.transitions ?? []).map((t) => ({
      event: t.event,
      fromState: Array.isArray(t.from) ? t.from.join("|") : t.from,
      toState: t.to
    }));
    const emits = getEmits(trait);
    const listens = getListens(trait);
    const linkedEntity = trait.linkedEntity ?? "";
    const row = Math.floor(i / cols);
    const col = i % cols;
    nodes.push({
      id: `trait-${orbitalName}-${trait.name}`,
      type: "traitCard",
      position: {
        x: col * TRAIT_CARD_SPACING_X,
        y: row * TRAIT_CARD_SPACING_Y
      },
      data: {
        kind: "trait-card",
        orbitalName,
        traitName: trait.name,
        linkedEntity,
        transitions,
        emits,
        listens,
        // `_fullSchema` carries the parsed schema to `TraitCardNode` so it
        // can run `parseTraitLevel(...)` and render the ELK-laid-out
        // state-machine flow chart inside the card. Mirrors the same
        // convention `OrbPreviewNode` uses for its embedded UI preview.
        _fullSchema: schema,
        // Required fields on PreviewNodeData — keep empty for trait cards.
        patterns: [],
        eventSources: []
      }
    });
  }
  const wires = extractTraitWires([orbital], "intra-orbital");
  const edges = wires.map((w) => ({
    id: `wire-${orbitalName}-${w.emitterTrait}-${w.listenerTrait}-${w.event}`,
    source: `trait-${orbitalName}-${w.emitterTrait}`,
    target: `trait-${orbitalName}-${w.listenerTrait}`,
    sourceHandle: `emit-${w.event}`,
    targetHandle: `listen-${w.event}`,
    type: "eventFlow",
    data: {
      event: w.event,
      isCrossOrbital: false,
      fromTrait: w.emitterTrait,
      toTrait: w.listenerTrait
    }
  }));
  return { nodes, edges };
}
var inspectorLog = createLogger("almadar:ui:inspector");
function findTransition(schema, orbitalName, traitName, event) {
  const orbital = (schema.orbitals ?? []).find((o) => o.name === orbitalName);
  if (!orbital) return null;
  const traits = orbital.traits ?? [];
  const trait = traits.find((t) => typeof t !== "string" && t.name === traitName);
  if (!trait || typeof trait === "string") return null;
  const sm = trait.stateMachine;
  if (!sm) return null;
  return sm.transitions?.find((t) => t.event === event) ?? null;
}
function resolvePatternConfig(schema, address) {
  const patternId = address.patternId ?? "root";
  const transition = address.traitName && address.transitionEvent ? findTransition(schema, address.orbitalName, address.traitName, address.transitionEvent) : null;
  const tryEffects = (effects) => {
    for (const { pattern: root } of renderUiEntriesOf(effects)) {
      const found = navigatePatternPath(root, patternId);
      if (!found) continue;
      if (address.patternType && typeof found.type === "string" && found.type !== address.patternType) {
        continue;
      }
      const nested = found.props;
      if (nested && typeof nested === "object" && !Array.isArray(nested)) {
        const { props: _stripped, ...rest } = found;
        return { ...nested, ...rest };
      }
      return found;
    }
    return null;
  };
  if (transition) {
    const direct = tryEffects(transition.effects ?? []);
    if (direct) return direct;
  }
  const orbital = schema.orbitals.find((o) => o.name === address.orbitalName);
  if (orbital) {
    const orderedTraits = [...orbital.traits ?? []].sort((a, b) => {
      const aName = typeof a === "string" ? a : a.name;
      const bName = typeof b === "string" ? b : b.name;
      const src = address.sourceTrait;
      if (src && aName === src) return -1;
      if (src && bName === src) return 1;
      return 0;
    });
    for (const traitRef of orderedTraits) {
      if (typeof traitRef === "string") continue;
      const inline = "stateMachine" in traitRef ? traitRef.stateMachine : void 0;
      const resolved = "_resolved" in traitRef ? traitRef._resolved?.stateMachine : void 0;
      const sm = inline ?? resolved;
      const traitTransitions = sm?.transitions;
      if (!Array.isArray(traitTransitions)) continue;
      for (const tx of traitTransitions) {
        const hit = tryEffects(tx.effects ?? []);
        if (hit) return hit;
      }
    }
  }
  if (address.patternId) {
    inspectorLog.warn("pattern-config-unresolved", () => ({
      patternId: address.patternId,
      patternType: address.patternType,
      sourceTrait: address.sourceTrait,
      orbitalName: address.orbitalName,
      traitName: address.traitName,
      transitionEvent: address.transitionEvent
    }));
  }
  return null;
}
function patternNodeAt(schema, orbitalName, traitName, event, path) {
  const transition = findTransition(schema, orbitalName, traitName, event);
  if (!transition?.effects) return null;
  for (const { pattern: root } of renderUiEntriesOf(transition.effects)) {
    const found = navigatePatternPath(root, path);
    if (found) return found;
  }
  return null;
}
var PATTERN_CLIPBOARD_TYPE = "application/x-almadar-patterns";
function parseClipboardPatterns(text) {
  if (!text) return null;
  let value;
  try {
    value = JSON.parse(text);
  } catch {
    return null;
  }
  const nodes = Array.isArray(value) ? value : value?.["almadar/patterns"];
  if (!Array.isArray(nodes) || nodes.length === 0) return null;
  return nodes.every((n) => n !== null && typeof n === "object" && typeof n.type === "string") ? nodes : null;
}

// lib/derive-edit-focus.ts
function traitOfElement(el) {
  const traitEl = el.closest("[data-orb-trait],[data-source-trait]");
  return traitEl?.getAttribute("data-orb-trait") ?? traitEl?.getAttribute("data-source-trait") ?? null;
}
function deriveEditFocusFromElement(el) {
  const orbitalEl = el.getAttribute("data-orb-orbital") !== null ? el : el.closest("[data-orb-orbital]");
  const orbital = orbitalEl?.getAttribute("data-orb-orbital") ?? "";
  if (!orbital) return null;
  const path = el.getAttribute("data-orb-path") ?? el.getAttribute("data-pattern-path");
  const patternType = el.getAttribute("data-orb-pattern") ?? el.getAttribute("data-pattern");
  const nearest = (attr) => el.closest(`[${attr}]`)?.getAttribute(attr) ?? null;
  const trait = traitOfElement(el);
  const focus = {
    level: "node",
    orbital,
    label: patternType ?? trait ?? el.tagName.toLowerCase()
  };
  if (path !== null) focus.path = path;
  if (trait !== null) focus.trait = trait;
  if (patternType !== null) focus.patternType = patternType;
  const transition = nearest("data-orb-transition");
  if (transition !== null) focus.transition = transition;
  const state = nearest("data-orb-state");
  if (state !== null) focus.state = state;
  const slot = nearest("data-orb-slot");
  if (slot !== null) focus.slot = slot;
  const entity = nearest("data-orb-entity");
  if (entity !== null) focus.entity = entity;
  return focus;
}
function withNodeTransition(focus, node) {
  const ownsElement = focus.trait === void 0 || focus.trait === node.traitName;
  const transition = ownsElement ? node.transitionEvent ?? focus.transition : focus.transition;
  return transition ? { ...focus, transition } : { ...focus };
}

// hooks/useInlineTextEdit.ts
function useInlineTextEdit({ schema, enabled, node }) {
  const { emit } = useEventBus();
  const { t } = useTranslate$1();
  const access = useContext(ElementEditAccessContext);
  const nodeTrait = node?.traitName;
  const nodeTransition = node?.transitionEvent;
  return useCallback((e) => {
    if (!enabled || !schema || !(e.target instanceof Element)) return;
    const text = e.target.closest(`[${INLINE_TEXT_ATTR}]`);
    const propName = text?.getAttribute(INLINE_TEXT_ATTR);
    const patternEl = text?.closest("[data-pattern-path],[data-orb-path]");
    if (!(text instanceof HTMLElement) || !propName || !(patternEl instanceof HTMLElement)) return;
    const derived = deriveEditFocusFromElement(patternEl);
    const focus = derived ? withNodeTransition(derived, { traitName: nodeTrait, transitionEvent: nodeTransition }) : null;
    if (!focus?.trait || !focus.transition || !focus.path) return;
    e.preventDefault();
    e.stopPropagation();
    const allowed = propAccessAt(access, focus, propName);
    if (!allowed.editable) {
      const message = allowed.reason === "fixed" ? t("inlineText.fixedValue", { behavior: allowed.detail }) : allowed.reason === "loading" ? t("inlineText.loading") : t("inlineText.boundValue");
      emit("UI:NOTIFY", { severity: "info", message });
      return;
    }
    const node2 = resolvePatternConfig(schema, {
      orbitalName: focus.orbital,
      traitName: focus.trait,
      transitionEvent: focus.transition,
      patternId: focus.path
    });
    const current = node2?.[propName];
    if (typeof current !== "string" || current.startsWith("@")) {
      emit("UI:NOTIFY", { severity: "info", message: t("inlineText.boundValue") });
      return;
    }
    const original = text.textContent ?? "";
    const selection = { patternPath: focus.path, orbitalName: focus.orbital, traitName: focus.trait, transitionEvent: focus.transition, ...focus.slot ? { slot: focus.slot } : {} };
    let done = false;
    const finish = (save) => {
      if (done) return;
      done = true;
      text.removeEventListener("keydown", onKey);
      text.removeEventListener("blur", onBlur);
      text.removeAttribute("contenteditable");
      const value = text.textContent ?? "";
      if (!save) text.textContent = original;
      else if (value !== original) emit("UI:PROP_CHANGE", { scope: "local", propName, value, selection });
    };
    const onKey = (ev) => {
      if (ev.key === "Enter" && !ev.shiftKey) {
        ev.preventDefault();
        finish(true);
      } else if (ev.key === "Escape") {
        ev.preventDefault();
        finish(false);
      }
      ev.stopPropagation();
    };
    const onBlur = () => finish(true);
    text.setAttribute("contenteditable", "true");
    text.addEventListener("keydown", onKey);
    text.addEventListener("blur", onBlur);
    text.focus();
    const range = document.createRange();
    range.selectNodeContents(text);
    const selected = window.getSelection();
    selected?.removeAllRanges();
    selected?.addRange(range);
  }, [enabled, schema, access, nodeTrait, nodeTransition, emit, t]);
}

// lib/design-classes.ts
var DESIGN_COLOR_TOKENS = [
  "primary",
  "primary-foreground",
  "primary-hover",
  "secondary",
  "secondary-foreground",
  "secondary-hover",
  "muted",
  "muted-foreground",
  "accent",
  "accent-foreground",
  "background",
  "foreground",
  "card",
  "card-foreground",
  "surface",
  "border",
  "input",
  "ring",
  "error",
  "error-foreground",
  "success",
  "success-foreground",
  "warning",
  "warning-foreground",
  "info",
  "info-foreground"
];
var DESIGN_COLOR_UTILITIES = ["bg", "text", "border"];
var DESIGN_RADIUS_TOKENS = ["none", "sm", "md", "lg", "xl", "full"];
var DESIGN_SPACING_SCALE = [
  0,
  0.5,
  1,
  1.5,
  2,
  2.5,
  3,
  3.5,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  14,
  16,
  20,
  24,
  28,
  32,
  36,
  40,
  44,
  48,
  52,
  56,
  60,
  64,
  72,
  80,
  96
];
var DESIGN_SPACING_UTILITIES = [
  "w",
  "h",
  "min-w",
  "max-w",
  "min-h",
  "max-h",
  "p",
  "px",
  "py",
  "pt",
  "pr",
  "pb",
  "pl",
  "m",
  "mx",
  "my",
  "gap"
];
var DESIGN_SPACING_STEP_PX = 4;
var defaultSpacingStepPx = (step) => step * DESIGN_SPACING_STEP_PX;
var DESIGN_SPACING_TOKEN_STEPS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
function spacingTokenOf(step) {
  return DESIGN_SPACING_TOKEN_STEPS.includes(step) ? `--space-${step}` : null;
}
function snapToSpacingStep(px, pxOf = defaultSpacingStepPx) {
  const target = Math.max(0, px);
  let best = DESIGN_SPACING_SCALE[0];
  for (const step of DESIGN_SPACING_SCALE) {
    const d = Math.abs(pxOf(step) - target);
    const bestD = Math.abs(pxOf(best) - target);
    if (d < bestD || d === bestD && spacingTokenOf(step) !== null && spacingTokenOf(best) === null) best = step;
  }
  return best;
}
var SPACING_STEP_BY_TEXT = new Map(
  DESIGN_SPACING_SCALE.map((step) => [String(step), step])
);
function stepOf(className, utility) {
  if (!className.startsWith(`${utility}-`)) return void 0;
  return SPACING_STEP_BY_TEXT.get(className.slice(utility.length + 1));
}
function isAxisSizeClass(className, axis) {
  return className.startsWith(`${axis}-`);
}
function sizingOf(classes, axis) {
  for (const c of classes) {
    if (c === `${axis}-full`) return { mode: "fill" };
    if (c === `${axis}-fit`) return { mode: "hug" };
    const step = stepOf(c, axis);
    if (step !== void 0) return { mode: "fixed", step };
  }
  return { mode: "hug" };
}
function withSizing(classes, axis, sizing) {
  const kept = classes.filter((c) => !isAxisSizeClass(c, axis));
  const next = sizing.mode === "fixed" ? `${axis}-${sizing.step}` : sizing.mode === "hug" ? `${axis}-fit` : `${axis}-full`;
  return [...kept, next];
}
function sizeLimitOf(classes, axis, limit) {
  for (const c of classes) {
    const step = stepOf(c, `${limit}-${axis}`);
    if (step !== void 0) return step;
  }
  return null;
}
function withSizeLimit(classes, axis, limit, step) {
  const kept = classes.filter((c) => !c.startsWith(`${limit}-${axis}-`));
  return step === null ? kept : [...kept, `${limit}-${axis}-${step}`];
}
var PADDING_UTILITIES = ["p", "px", "py", "pt", "pr", "pb", "pl"];
function isSpacingClass(className) {
  return stepOf(className, "gap") !== void 0 || PADDING_UTILITIES.some((u) => stepOf(className, u) !== void 0);
}
function spacingOf(classes) {
  const find = (utility) => {
    for (const c of classes) {
      const step = stepOf(c, utility);
      if (step !== void 0) return step;
    }
    return void 0;
  };
  const all = find("p") ?? 0;
  const x = find("px") ?? all;
  const y = find("py") ?? all;
  return {
    gap: find("gap") ?? 0,
    top: find("pt") ?? y,
    right: find("pr") ?? x,
    bottom: find("pb") ?? y,
    left: find("pl") ?? x
  };
}
function withSpacing(classes, change) {
  const next = { ...spacingOf(classes), ...change };
  const kept = classes.filter((c) => !isSpacingClass(c));
  const out = [...kept];
  if (next.gap !== 0) out.push(`gap-${next.gap}`);
  const { top, right, bottom, left } = next;
  if (top === right && right === bottom && bottom === left) {
    if (top !== 0) out.push(`p-${top}`);
  } else if (top === bottom && left === right) {
    out.push(`px-${left}`, `py-${top}`);
  } else {
    out.push(`pt-${top}`, `pr-${right}`, `pb-${bottom}`, `pl-${left}`);
  }
  return out;
}
var DIRECTION_CLASSES = ["flex-row", "flex-row-reverse", "flex-col", "flex-col-reverse"];
var ALIGNMENTS = ["start", "center", "end"];
var JUSTIFIES = [...ALIGNMENTS, "between"];
var WRAP_CLASSES = ["flex-wrap", "flex-nowrap", "flex-wrap-reverse"];
function firstOf(classes, utility, values) {
  for (const c of classes) {
    for (const v of values) if (c === `${utility}-${v}`) return v;
  }
  return null;
}
function layoutOf(classes) {
  const direction = classes.find((c) => DIRECTION_CLASSES.includes(c));
  return {
    direction: direction === void 0 ? null : direction.startsWith("flex-row") ? "horizontal" : "vertical",
    align: firstOf(classes, "items", ALIGNMENTS),
    justify: firstOf(classes, "justify", JUSTIFIES),
    wrap: classes.includes("flex-wrap")
  };
}
function withLayout(classes, change) {
  let next = [...classes];
  if (change.direction) {
    next = next.filter((c) => !DIRECTION_CLASSES.includes(c));
    next.push(change.direction === "horizontal" ? "flex-row" : "flex-col");
  }
  if (change.align) {
    next = next.filter((c) => !c.startsWith("items-"));
    next.push(`items-${change.align}`);
  }
  if (change.justify) {
    next = next.filter((c) => !c.startsWith("justify-"));
    next.push(`justify-${change.justify}`);
  }
  if (change.wrap !== void 0) {
    next = next.filter((c) => !WRAP_CLASSES.includes(c));
    if (change.wrap) next.push("flex-wrap");
  }
  return next;
}
var AXIS_SIDES = { x: ["left", "right"], y: ["top", "bottom"] };
var CENTER_CLASSES = { x: ["left-1/2", "-translate-x-1/2"], y: ["top-1/2", "-translate-y-1/2"] };
function offsetOf(classes, side) {
  for (const c of classes) {
    if (!c.startsWith(`${side}-`)) continue;
    const step = stepOf(c, side);
    if (step !== void 0) return { value: defaultSpacingStepPx(step), unit: "px" };
    const m = /^\[(-?\d+(?:\.\d+)?)(px|%)\]$/.exec(c.slice(side.length + 1));
    if (m) return { value: Number(m[1]), unit: m[2] === "%" ? "%" : "px" };
  }
  return null;
}
function centerOffsetOf(classes, side) {
  for (const c of classes) {
    if (c === `${side}-1/2`) return 0;
    const m = new RegExp(`^${side}-\\[calc\\(50%([+-])(\\d+(?:\\.\\d+)?)px\\)\\]$`).exec(c);
    if (m) return (m[1] === "-" ? -1 : 1) * Number(m[2]);
  }
  return null;
}
function axisPositionOf(classes, axis) {
  const [startSide, endSide] = AXIS_SIDES[axis];
  const center = centerOffsetOf(classes, startSide);
  if (center !== null && classes.includes(CENTER_CLASSES[axis][1])) return { constraint: "center", start: center, end: 0 };
  const start = offsetOf(classes, startSide);
  const end = offsetOf(classes, endSide);
  if (start?.unit === "%" || end?.unit === "%") {
    return { constraint: "scale", start: start?.value ?? 0, end: end?.value ?? 0 };
  }
  if (start && end) return { constraint: "both", start: start.value, end: end.value };
  if (end) return { constraint: "end", start: 0, end: end.value };
  return { constraint: "start", start: start?.value ?? 0, end: 0 };
}
function positionOf(classes) {
  return {
    absolute: classes.includes("absolute"),
    x: axisPositionOf(classes, "x"),
    y: axisPositionOf(classes, "y")
  };
}
function isPositionClass(className) {
  if (className === "absolute") return true;
  if (CENTER_CLASSES.x.some((c) => c === className) || CENTER_CLASSES.y.some((c) => c === className)) return true;
  return [...AXIS_SIDES.x, ...AXIS_SIDES.y].some((side) => className.startsWith(`${side}-`));
}
function offsetClass(side, value, unit) {
  const rounded = unit === "%" ? Math.round(value * 10) / 10 : Math.round(value);
  return rounded === 0 ? `${side}-0` : `${side}-[${rounded}${unit}]`;
}
function axisClasses(axis, p) {
  const [startSide, endSide] = AXIS_SIDES[axis];
  switch (p.constraint) {
    case "center": {
      const offset = Math.round(p.start);
      const pin = offset === 0 ? CENTER_CLASSES[axis][0] : `${startSide}-[calc(50%${offset < 0 ? "-" : "+"}${Math.abs(offset)}px)]`;
      return [pin, CENTER_CLASSES[axis][1]];
    }
    case "end":
      return [offsetClass(endSide, p.end, "px")];
    case "both":
      return [offsetClass(startSide, p.start, "px"), offsetClass(endSide, p.end, "px")];
    case "scale":
      return [offsetClass(startSide, p.start, "%"), offsetClass(endSide, p.end, "%")];
    case "start":
      return [offsetClass(startSide, p.start, "px")];
  }
}
function withPosition(classes, position) {
  const kept = classes.filter((c) => !isPositionClass(c));
  if (!position.absolute) return kept;
  return [...kept, "absolute", ...axisClasses("x", position.x), ...axisClasses("y", position.y)];
}
var COLOR_TOKEN_SET = new Set(DESIGN_COLOR_TOKENS);
var RADIUS_TOKEN_SET = new Set(DESIGN_RADIUS_TOKENS);
function isColorToken(value) {
  return COLOR_TOKEN_SET.has(value);
}
function isRadiusToken(value) {
  return RADIUS_TOKEN_SET.has(value);
}
function tokenOfDesignClass(className) {
  const base = className.slice(className.lastIndexOf(":") + 1);
  if (base.startsWith("rounded-")) {
    const key = base.slice("rounded-".length);
    return isRadiusToken(key) ? { group: "radii", key } : null;
  }
  for (const utility of DESIGN_COLOR_UTILITIES) {
    const prefix = `${utility}-`;
    if (!base.startsWith(prefix)) continue;
    const key = base.slice(prefix.length);
    if (isColorToken(key)) return { group: "colors", key };
  }
  for (const utility of DESIGN_SPACING_UTILITIES) {
    const step = stepOf(base, utility);
    if (step !== void 0 && spacingTokenOf(step) !== null) return { group: "spacing", key: String(step) };
  }
  return null;
}
function isArbitraryClass(className) {
  return /^[a-z0-9:@/-]*-\[[^\]\s]+\]$/i.test(className);
}
function collectClasses(value, found) {
  if (Array.isArray(value)) {
    for (const item of value) collectClasses(item, found);
    return;
  }
  if (value === null || typeof value !== "object") return;
  for (const [key, child] of Object.entries(value)) {
    if (key === "className" && typeof child === "string") {
      for (const cls of child.split(/\s+/)) if (cls && isArbitraryClass(cls)) found.add(cls);
    } else {
      collectClasses(child, found);
    }
  }
}
function classesOfPart(part) {
  const found = /* @__PURE__ */ new Set();
  collectClasses(JSON.parse(JSON.stringify(part)), found);
  return [...found];
}
var classesByOrbital = /* @__PURE__ */ new WeakMap();
function arbitraryClassesOf(schema) {
  const { orbitals, _metadata: _provenance, ledger: _identities, ...rest } = schema;
  const found = new Set(classesOfPart(rest));
  for (const orbital of orbitals ?? []) {
    let classes = classesByOrbital.get(orbital);
    if (!classes) {
      classes = classesOfPart(orbital);
      classesByOrbital.set(orbital, classes);
    }
    for (const cls of classes) found.add(cls);
  }
  return [...found].sort();
}

// lib/selection-geometry.ts
function gapHandleRects(children, axis) {
  const out = [];
  for (let i = 0; i + 1 < children.length; i++) {
    const a = children[i];
    const b = children[i + 1];
    if (axis === "vertical") {
      const top = a.top + a.height;
      const left = Math.min(a.left, b.left);
      out.push({ top, left, width: Math.max(a.left + a.width, b.left + b.width) - left, height: Math.max(0, b.top - top) });
    } else {
      const left = a.left + a.width;
      const top = Math.min(a.top, b.top);
      out.push({ top, left, width: Math.max(0, b.left - left), height: Math.max(a.top + a.height, b.top + b.height) - top });
    }
  }
  return out;
}
function paddingHandleRects(container, children) {
  const inner = children.length === 0 ? container : children.reduce((u, c) => {
    const top = Math.min(u.top, c.top);
    const left = Math.min(u.left, c.left);
    const bottom = Math.max(u.top + u.height, c.top + c.height);
    const right = Math.max(u.left + u.width, c.left + c.width);
    return { top, left, width: right - left, height: bottom - top };
  });
  const cRight = container.left + container.width;
  const cBottom = container.top + container.height;
  const iRight = inner.left + inner.width;
  const iBottom = inner.top + inner.height;
  return {
    top: { top: container.top, left: container.left, width: container.width, height: Math.max(0, inner.top - container.top) },
    bottom: { top: iBottom, left: container.left, width: container.width, height: Math.max(0, cBottom - iBottom) },
    left: { top: container.top, left: container.left, width: Math.max(0, inner.left - container.left), height: container.height },
    right: { top: container.top, left: iRight, width: Math.max(0, cRight - iRight), height: container.height }
  };
}
var INSERTION_LINE_PX = 2;
function insertionLineRect(container, children, index, axis) {
  const half = INSERTION_LINE_PX / 2;
  if (children.length === 0) {
    return axis === "vertical" ? { top: container.top, left: container.left, width: container.width, height: INSERTION_LINE_PX } : { top: container.top, left: container.left, width: INSERTION_LINE_PX, height: container.height };
  }
  const clamped = Math.max(0, Math.min(index, children.length));
  const before = children[clamped];
  const after = children[clamped - 1];
  const ref = before ?? after ?? container;
  if (axis === "vertical") {
    const edge2 = before && after ? (after.top + after.height + before.top) / 2 : before ? before.top : after ? after.top + after.height : container.top;
    return { top: edge2 - half, left: ref.left, width: ref.width, height: INSERTION_LINE_PX };
  }
  const edge = before && after ? (after.left + after.width + before.left) / 2 : before ? before.left : after ? after.left + after.width : container.left;
  return { top: ref.top, left: edge - half, width: INSERTION_LINE_PX, height: ref.height };
}
var GRID_POSITION = {
  "flex-start": "start",
  start: "start",
  "self-start": "start",
  left: "start",
  center: "center",
  "flex-end": "end",
  end: "end",
  "self-end": "end",
  right: "end"
};
function renderedAlignment(style) {
  const justify = style.justifyContent === "normal" ? "start" : style.justifyContent === "space-between" ? "between" : GRID_POSITION[style.justifyContent] ?? null;
  return { align: GRID_POSITION[style.alignItems] ?? null, justify };
}
function offsetWithin(child, parent) {
  return {
    left: child.left - parent.left,
    top: child.top - parent.top,
    right: parent.left + parent.width - (child.left + child.width),
    bottom: parent.top + parent.height - (child.top + child.height),
    parentWidth: parent.width,
    parentHeight: parent.height
  };
}
function spacingScaleOf(el) {
  const style = getComputedStyle(el);
  const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const rem = Number.isFinite(rootPx) && rootPx > 0 ? rootPx : 16;
  const toPx = (value) => {
    const n = parseFloat(value);
    if (!Number.isFinite(n)) return null;
    return value.trim().endsWith("rem") ? n * rem : n;
  };
  return (step) => {
    const token = spacingTokenOf(step);
    const themed = token ? toPx(style.getPropertyValue(token)) : null;
    return themed ?? step * rem / 4;
  };
}
var pxOrZero = (value) => {
  const px = parseFloat(value);
  return Number.isFinite(px) ? px : 0;
};
function renderedSpacing(style, axis) {
  return {
    gap: pxOrZero(axis === "vertical" ? style.rowGap : style.columnGap),
    top: pxOrZero(style.paddingTop),
    right: pxOrZero(style.paddingRight),
    bottom: pxOrZero(style.paddingBottom),
    left: pxOrZero(style.paddingLeft)
  };
}
function layoutBoxOf(el) {
  let cur = el;
  while (getComputedStyle(cur).display === "contents" && cur.firstElementChild) {
    cur = cur.firstElementChild;
  }
  return cur;
}
function marqueeRect(from, to) {
  return {
    top: Math.min(from.y, to.y),
    left: Math.min(from.x, to.x),
    width: Math.abs(to.x - from.x),
    height: Math.abs(to.y - from.y)
  };
}
function marqueeHits(marquee, boxes) {
  return boxes.flatMap(
    (box, index) => box.left < marquee.left + marquee.width && marquee.left < box.left + box.width && box.top < marquee.top + marquee.height && marquee.top < box.top + box.height ? [index] : []
  );
}
function axisPositionFrom(axis, constraint, offset) {
  const start = axis === "x" ? offset.left : offset.top;
  const end = axis === "x" ? offset.right : offset.bottom;
  if (constraint === "center") return { constraint, start: (start - end) / 2, end: 0 };
  if (constraint !== "scale") return { constraint, start, end };
  const size2 = axis === "x" ? offset.parentWidth : offset.parentHeight;
  return size2 > 0 ? { constraint, start: start / size2 * 100, end: end / size2 * 100 } : { constraint, start: 0, end: 0 };
}
var edgesX = (r) => [r.left, r.left + r.width / 2, r.left + r.width];
var edgesY = (r) => [r.top, r.top + r.height / 2, r.top + r.height];
function nearestSnap(mine, moving, targets, threshold) {
  let best = 0;
  let bestAbs = Infinity;
  for (const t of targets) {
    for (const a of mine(moving)) {
      for (const b of mine(t)) {
        const d = b - a;
        if (Math.abs(d) <= threshold && Math.abs(d) < bestAbs) {
          best = d;
          bestAbs = Math.abs(d);
        }
      }
    }
  }
  return bestAbs === Infinity ? 0 : best;
}
function snapMove(moving, targets, threshold) {
  const dx = nearestSnap(edgesX, moving, targets, threshold);
  const dy = nearestSnap(edgesY, moving, targets, threshold);
  const snapped = { ...moving, left: moving.left + dx, top: moving.top + dy };
  const guides = [];
  for (const t of targets) {
    for (const x of edgesX(t)) {
      if (edgesX(snapped).includes(x)) {
        guides.push({ orientation: "vertical", at: x, from: Math.min(snapped.top, t.top), to: Math.max(snapped.top + snapped.height, t.top + t.height) });
      }
    }
    for (const y of edgesY(t)) {
      if (edgesY(snapped).includes(y)) {
        guides.push({ orientation: "horizontal", at: y, from: Math.min(snapped.left, t.left), to: Math.max(snapped.left + snapped.width, t.left + t.width) });
      }
    }
  }
  return { dx, dy, guides };
}
function line(x1, y1, x2, y2) {
  return { x1, y1, x2, y2, length: Math.round(Math.hypot(x2 - x1, y2 - y1)) };
}
function distanceLines(selected, other) {
  const s = { l: selected.left, t: selected.top, r: selected.left + selected.width, b: selected.top + selected.height };
  const o = { l: other.left, t: other.top, r: other.left + other.width, b: other.top + other.height };
  const cx = (s.l + s.r) / 2;
  const cy = (s.t + s.b) / 2;
  const lines = [];
  if (o.l <= s.l && o.t <= s.t && o.r >= s.r && o.b >= s.b) {
    lines.push(line(cx, s.t, cx, o.t), line(s.r, cy, o.r, cy), line(cx, s.b, cx, o.b), line(s.l, cy, o.l, cy));
    return lines.filter((l) => l.length > 0);
  }
  const overlapY = Math.max(s.t, o.t) < Math.min(s.b, o.b);
  const overlapX = Math.max(s.l, o.l) < Math.min(s.r, o.r);
  const y = overlapY ? (Math.max(s.t, o.t) + Math.min(s.b, o.b)) / 2 : cy;
  const x = overlapX ? (Math.max(s.l, o.l) + Math.min(s.r, o.r)) / 2 : cx;
  if (o.l >= s.r) lines.push(line(s.r, y, o.l, y));
  else if (o.r <= s.l) lines.push(line(s.l, y, o.r, y));
  if (o.t >= s.b) lines.push(line(x, s.b, x, o.t));
  else if (o.b <= s.t) lines.push(line(x, s.t, x, o.b));
  return lines.filter((l) => l.length > 0);
}
var CLICK_SLOP_PX = 3;
var OPPOSITE = { top: "bottom", bottom: "top", left: "right", right: "left" };
function sizeLabel(classes, axis, px) {
  const sizing = sizingOf(classes, axis);
  return sizing.mode === "hug" ? "Hug" : sizing.mode === "fill" ? "Fill" : String(Math.round(px));
}
var GRID = ["start", "center", "end"];
var ROW_LABEL = ["designOverlay.top", "designOverlay.middle", "designOverlay.bottom"];
var COLUMN_LABEL = ["designOverlay.left", "designOverlay.center", "designOverlay.right"];
function DesignSelectionOverlay({ rect, childRects, axis, alignment, classes, zoom, layoutBar = true, pxOfStep = defaultSpacingStepPx, renderedSpacing: renderedSpacing2, onChange }) {
  const { t } = useTranslate();
  const [drag, setDrag] = useState(null);
  const [typing, setTyping] = useState(null);
  const scale = zoom > 0 ? zoom : 1;
  const spacing = !classes ? null : renderedSpacing2 ? {
    gap: snapToSpacingStep(renderedSpacing2.gap, pxOfStep),
    top: snapToSpacingStep(renderedSpacing2.top, pxOfStep),
    right: snapToSpacingStep(renderedSpacing2.right, pxOfStep),
    bottom: snapToSpacingStep(renderedSpacing2.bottom, pxOfStep),
    left: snapToSpacingStep(renderedSpacing2.left, pxOfStep)
  } : spacingOf(classes);
  const pxOf = (key) => renderedSpacing2 ? renderedSpacing2[key] : pxOfStep(spacing?.[key] ?? 0);
  const begin = useCallback((next) => (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.setPointerCapture?.(e.pointerId);
    setDrag({ ...next, startX: e.clientX, startY: e.clientY });
  }, []);
  const move = useCallback((e) => {
    if (!drag) return;
    const dx = (e.clientX - drag.startX) / scale;
    const dy = (e.clientY - drag.startY) / scale;
    if (drag.kind === "resize") {
      setDrag({
        ...drag,
        width: drag.edge === "s" ? rect.width : Math.max(0, rect.width + dx),
        height: drag.edge === "e" ? rect.height : Math.max(0, rect.height + dy)
      });
    } else if (drag.kind === "gap") {
      const moved = drag.moved || Math.hypot(e.clientX - drag.startX, e.clientY - drag.startY) >= CLICK_SLOP_PX;
      setDrag({ ...drag, moved, px: Math.max(0, drag.startPx + (axis === "vertical" ? dy : dx)) });
    } else {
      const delta = drag.side === "top" ? dy : drag.side === "bottom" ? -dy : drag.side === "left" ? dx : -dx;
      const moved = drag.moved || Math.hypot(e.clientX - drag.startX, e.clientY - drag.startY) >= CLICK_SLOP_PX;
      setDrag({ ...drag, moved, px: Math.max(0, drag.startPx + delta) });
    }
  }, [drag, scale, rect, axis]);
  const end = useCallback(() => {
    if (!drag || !classes) {
      setDrag(null);
      return;
    }
    if (drag.kind !== "resize" && !drag.moved) {
      const text = String(drag.startPx);
      setTyping(drag.kind === "padding" ? { kind: "padding", side: drag.side, box: drag.box, text } : { kind: "gap", box: drag.box, text });
      setDrag(null);
      return;
    }
    if (drag.kind === "resize") {
      let next = [...classes];
      if (drag.edge !== "s") next = withSizing(next, "w", { mode: "fixed", step: snapToSpacingStep(drag.width, pxOfStep) });
      if (drag.edge !== "e") next = withSizing(next, "h", { mode: "fixed", step: snapToSpacingStep(drag.height, pxOfStep) });
      onChange(next);
    } else if (drag.kind === "gap") {
      onChange(withSpacing(classes, { ...spacing, gap: snapToSpacingStep(drag.px, pxOfStep) }));
    } else {
      const step = snapToSpacingStep(drag.px, pxOfStep);
      const change = { [drag.side]: step };
      if (drag.mirror) change[OPPOSITE[drag.side]] = step;
      onChange(withSpacing(classes, { ...spacing, ...change }));
    }
    setDrag(null);
  }, [drag, classes, onChange, pxOfStep, renderedSpacing2]);
  const commitTyping = useCallback(() => {
    if (!typing || !classes) return;
    const px = Number(typing.text);
    if (typing.text.trim() === "" || !Number.isFinite(px) || px < 0) return;
    const step = snapToSpacingStep(px, pxOfStep);
    onChange(withSpacing(classes, { ...spacing, ...typing.kind === "gap" ? { gap: step } : { [typing.side]: step } }));
    setTyping(null);
  }, [typing, classes, onChange, pxOfStep, renderedSpacing2]);
  const toMode = useCallback((edge) => (e) => {
    e.stopPropagation();
    if (!classes) return;
    const sizing = e.altKey ? { mode: "fill" } : { mode: "hug" };
    let next = [...classes];
    if (edge !== "s") next = withSizing(next, "w", sizing);
    if (edge !== "e") next = withSizing(next, "h", sizing);
    onChange(next);
  }, [classes, onChange]);
  const width = drag?.kind === "resize" ? drag.width : rect.width;
  const height = drag?.kind === "resize" ? drag.height : rect.height;
  const editable = classes !== null;
  const handleProps = {
    className: "nodrag nopan absolute",
    onPointerMove: move,
    onPointerUp: end
  };
  const resizeHandle = (edge, style) => /* @__PURE__ */ jsx(
    Box,
    {
      ...handleProps,
      "data-testid": `design-resize-${edge}`,
      className: `${handleProps.className} rounded-sm border border-primary bg-card`,
      style: { width: 8, height: 8, pointerEvents: "auto", cursor: edge === "e" ? "ew-resize" : edge === "s" ? "ns-resize" : "nwse-resize", ...style },
      onPointerDown: begin({ kind: "resize", edge, startX: 0, startY: 0, width: rect.width, height: rect.height }),
      onDoubleClick: toMode(edge)
    }
  );
  const spacingBand = (testId, box, onDown, cursor, label) => /* @__PURE__ */ jsx(
    Box,
    {
      ...handleProps,
      "data-testid": testId,
      title: label,
      className: `${handleProps.className} flex items-center justify-center bg-accent/20 hover:bg-accent/40`,
      style: {
        top: box.top - rect.top,
        left: box.left - rect.left,
        width: Math.max(box.width, 4),
        height: Math.max(box.height, 4),
        pointerEvents: "auto",
        cursor
      },
      onPointerDown: onDown
    },
    testId
  );
  const bands = axis && spacing ? paddingHandleRects(rect, childRects) : null;
  const layout = classes ? layoutOf(classes) : null;
  const align = layout?.align ?? alignment?.align ?? null;
  const justify = layout?.justify ?? alignment?.justify ?? null;
  const between = justify === "between";
  const cellOf = (row, column) => axis === "vertical" ? { justify: GRID[row], align: GRID[column] } : { justify: GRID[column], align: GRID[row] };
  const wrap = layout?.wrap ?? false;
  const stop = (e) => e.stopPropagation();
  const layoutControls = layoutBar && editable && axis && classes && /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": "design-layout-bar",
      className: "nodrag nopan absolute flex items-center gap-1 rounded bg-card border border-border shadow-sm p-1",
      style: { bottom: "100%", left: 0, transform: "translateY(-6px)", pointerEvents: "auto" },
      onPointerDown: stop,
      children: [
        ["vertical", "horizontal"].map((direction) => /* @__PURE__ */ jsx(
          Box,
          {
            role: "button",
            "data-testid": `design-layout-direction-${direction}`,
            "aria-pressed": axis === direction,
            "aria-label": t(direction === "vertical" ? "designOverlay.layoutVertical" : "designOverlay.layoutHorizontal"),
            title: t(direction === "vertical" ? "designOverlay.layoutVertical" : "designOverlay.layoutHorizontal"),
            className: `flex items-center justify-center rounded w-5 h-5 cursor-pointer ${axis === direction ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`,
            onClick: (e) => {
              e.stopPropagation();
              onChange(withLayout(classes, { direction }));
            },
            children: /* @__PURE__ */ jsx(Icon, { name: direction === "vertical" ? "arrow-down" : "arrow-right", size: "xs" })
          },
          direction
        )),
        /* @__PURE__ */ jsx(Box, { className: "grid grid-cols-3 gap-px ml-1", children: GRID.map((_, row) => GRID.map((__, column) => {
          const cell = cellOf(row, column);
          const active = cell.align === align && (between || cell.justify === justify);
          return /* @__PURE__ */ jsx(
            Box,
            {
              role: "button",
              "data-testid": `design-align-${row}-${column}`,
              "aria-pressed": active,
              "aria-label": t("designOverlay.align", { row: t(ROW_LABEL[row]), column: t(COLUMN_LABEL[column]) }),
              className: `w-2 h-2 rounded-sm cursor-pointer ${active ? "bg-primary" : "bg-muted hover:bg-accent"}`,
              onClick: (e) => {
                e.stopPropagation();
                onChange(withLayout(classes, between ? { align: cell.align } : cell));
              }
            },
            `${row}-${column}`
          );
        })) }),
        [
          {
            id: "space-between",
            pressed: between,
            label: "designOverlay.spaceBetween",
            icon: axis === "vertical" ? "align-vertical-space-between" : "align-horizontal-space-between",
            change: { justify: between ? "start" : "between" }
          },
          { id: "wrap", pressed: wrap, label: "designOverlay.wrap", icon: "wrap-text", change: { wrap: !wrap } }
        ].map((toggle) => /* @__PURE__ */ jsx(
          Box,
          {
            role: "button",
            "data-testid": `design-layout-${toggle.id}`,
            "aria-pressed": toggle.pressed,
            "aria-label": t(toggle.label),
            title: t(toggle.label),
            className: `flex items-center justify-center rounded w-5 h-5 cursor-pointer ${toggle.id === "space-between" ? "ml-1" : ""} ${toggle.pressed ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`,
            onClick: (e) => {
              e.stopPropagation();
              onChange(withLayout(classes, toggle.change));
            },
            children: /* @__PURE__ */ jsx(Icon, { name: toggle.icon, size: "xs" })
          },
          toggle.id
        ))
      ]
    }
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": "orb-preview-selection",
      "data-design-overlay": "",
      style: {
        position: "absolute",
        pointerEvents: "none",
        top: rect.top,
        left: rect.left,
        width,
        height,
        outline: "2px solid var(--color-primary)",
        outlineOffset: "1px",
        borderRadius: "2px",
        zIndex: 21
      },
      children: [
        editable && axis && spacing && gapHandleRects(childRects, axis).map(
          (box, i) => spacingBand(
            `design-gap-${i}`,
            box,
            begin({ kind: "gap", box, startX: 0, startY: 0, startPx: pxOf("gap"), px: pxOf("gap") }),
            axis === "vertical" ? "ns-resize" : "ew-resize",
            `gap-${spacing.gap}`
          )
        ),
        editable && bands && spacing && ["top", "right", "bottom", "left"].map(
          (side) => spacingBand(
            `design-padding-${side}`,
            bands[side],
            (e) => begin({
              kind: "padding",
              side,
              box: bands[side],
              mirror: e.altKey,
              startX: 0,
              startY: 0,
              startPx: pxOf(side),
              px: pxOf(side)
            })(e),
            side === "top" || side === "bottom" ? "ns-resize" : "ew-resize",
            `padding-${side}: ${spacing[side]}`
          )
        ),
        layoutControls,
        typing && /* @__PURE__ */ jsx(
          Box,
          {
            className: "nodrag nopan absolute",
            style: { top: typing.box.top - rect.top, left: typing.box.left - rect.left, width: 56, pointerEvents: "auto", zIndex: 22 },
            onPointerDown: (e) => e.stopPropagation(),
            children: /* @__PURE__ */ jsx(
              Input,
              {
                "data-testid": "design-spacing-input",
                inputType: "number",
                autoFocus: true,
                value: typing.text,
                className: "h-6 px-1 text-xs",
                onChange: (e) => setTyping({ ...typing, text: e.target.value }),
                onKeyDown: (e) => {
                  e.stopPropagation();
                  if (e.key === "Enter") commitTyping();
                  else if (e.key === "Escape") setTyping(null);
                },
                onBlur: () => setTyping(null)
              }
            )
          }
        ),
        editable && resizeHandle("e", { right: -5, top: "50%", marginTop: -4 }),
        editable && resizeHandle("s", { bottom: -5, left: "50%", marginLeft: -4 }),
        editable && resizeHandle("se", { right: -5, bottom: -5 }),
        editable && classes && /* @__PURE__ */ jsx(
          Box,
          {
            "data-testid": "orb-preview-size-label",
            className: "absolute rounded px-1 text-[10px] font-mono bg-primary text-primary-foreground whitespace-nowrap",
            style: { top: "100%", left: "50%", transform: "translate(-50%, 6px)" },
            children: drag?.kind === "resize" ? `${Math.round(width)} \xD7 ${Math.round(height)}` : drag?.kind === "gap" ? `gap ${pxOfStep(snapToSpacingStep(drag.px, pxOfStep))}` : drag?.kind === "padding" ? `${drag.side} ${pxOfStep(snapToSpacingStep(drag.px, pxOfStep))}` : `${sizeLabel(classes, "w", rect.width)} \xD7 ${sizeLabel(classes, "h", rect.height)}`
          }
        )
      ]
    }
  );
}
DesignSelectionOverlay.displayName = "DesignSelectionOverlay";
var GUIDE_COLOR = "var(--color-error)";
function DesignGuidesOverlay({ guides, measures, zoom }) {
  if (guides.length === 0 && measures.length === 0) return null;
  const scale = zoom > 0 ? 1 / zoom : 1;
  return /* @__PURE__ */ jsxs(Box, { className: "absolute inset-0 pointer-events-none", style: { zIndex: 24 }, children: [
    guides.map((g, i) => /* @__PURE__ */ jsx(
      Box,
      {
        "data-testid": "design-guide",
        className: "absolute",
        style: g.orientation === "vertical" ? { left: g.at, top: g.from, width: 1, height: g.to - g.from, background: GUIDE_COLOR } : { top: g.at, left: g.from, height: 1, width: g.to - g.from, background: GUIDE_COLOR }
      },
      `g${i}`
    )),
    measures.map((m, i) => {
      const vertical = m.x1 === m.x2;
      const left = Math.min(m.x1, m.x2);
      const top = Math.min(m.y1, m.y2);
      return /* @__PURE__ */ jsx(
        Box,
        {
          "data-testid": "design-measure",
          className: "absolute flex items-center justify-center",
          style: vertical ? { left, top, width: 1, height: Math.abs(m.y2 - m.y1), background: GUIDE_COLOR } : { left, top, height: 1, width: Math.abs(m.x2 - m.x1), background: GUIDE_COLOR },
          children: /* @__PURE__ */ jsx(
            Box,
            {
              "data-testid": "design-measure-label",
              className: "rounded px-1 text-[10px] font-mono whitespace-nowrap bg-error text-error-foreground",
              style: { transform: `scale(${scale})` },
              children: m.length
            }
          )
        },
        `m${i}`
      );
    })
  ] });
}
DesignGuidesOverlay.displayName = "DesignGuidesOverlay";
var resolvedSchemaLog = createLogger("almadar:ui:resolved-schema");
function useResolvedSchema(schema, pageName) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const ir = useMemo(() => {
    if (!schema) return null;
    try {
      const resolved = schemaToIR(schema);
      const callSiteListensByTrait = /* @__PURE__ */ new Map();
      for (const orb of schema.orbitals) {
        for (const traitRef of orb.traits ?? []) {
          if (typeof traitRef === "string") continue;
          const t = traitRef;
          const inlineListens = t.listens?.length ? t.listens : void 0;
          const resolvedListens = t._resolved?.listens?.length ? t._resolved.listens : void 0;
          const listens = inlineListens ?? resolvedListens;
          const traitName = t.name ?? t._resolved?.name;
          if (typeof traitName !== "string" || !listens) continue;
          callSiteListensByTrait.set(traitName, listens);
        }
      }
      for (const [traitName, trait] of resolved.traits) {
        const callSiteListens = callSiteListensByTrait.get(traitName);
        if (!callSiteListens) continue;
        const beforeCount = trait.listens.length;
        trait.listens = callSiteListens.map((l) => ({
          event: l.event,
          triggers: l.triggers,
          source: l.source,
          guard: l.guard,
          payloadMapping: l.payloadMapping
        }));
        resolvedSchemaLog.info("listens:restored", {
          trait: traitName,
          beforeCount,
          afterCount: trait.listens.length,
          listens: callSiteListens.map((l) => {
            const src = l.source;
            const label = !src ? "(no-source)" : src.kind === "any" ? "*" : src.trait;
            return `${label}.${l.event}->${l.triggers}`;
          }).join(",")
        });
      }
      return resolved;
    } catch (err) {
      setError(err instanceof Error ? err.message : "Schema resolution failed");
      return null;
    }
  }, [schema]);
  useEffect(() => {
    setLoading(false);
  }, [ir]);
  const result = useMemo(() => {
    if (!ir) {
      return {
        page: void 0,
        traits: [],
        entities: /* @__PURE__ */ new Map(),
        allEntities: /* @__PURE__ */ new Map(),
        allTraits: /* @__PURE__ */ new Map(),
        loading,
        error: error || (schema ? null : "No schema provided"),
        ir: null
      };
    }
    const page = getPage(ir, pageName);
    resolvedSchemaLog.debug("Resolved page", () => ({
      name: page?.name,
      path: page?.path,
      traits: page?.traits.length
    }));
    const traits = page?.traits || [];
    const entities = /* @__PURE__ */ new Map();
    if (page) {
      for (const binding of page.entityBindings) {
        entities.set(binding.entity.name, binding.entity);
      }
    }
    return {
      page,
      traits,
      entities,
      allEntities: ir.entities,
      allTraits: ir.traits,
      loading,
      error,
      ir
    };
  }, [ir, pageName, loading, error, schema]);
  return result;
}
function clearSchemaCache() {
  clearSchemaCache$1();
}

// lib/circuitVerificationObserver.ts
function createCircuitVerificationObserver() {
  return {
    onTransition(trace) {
      const effects = trace.effects.map((effect) => ({
        type: effect.type,
        args: effect.args,
        status: effect.status,
        ...effect.error !== void 0 ? { error: effect.error } : {},
        ...effect.durationMs !== void 0 ? { durationMs: effect.durationMs } : {}
      }));
      recordTransition({
        traitName: trace.traitName,
        from: trace.from,
        to: trace.to,
        event: trace.event,
        effects,
        timestamp: Date.now(),
        ...trace.guardResult !== void 0 ? { guardResult: trace.guardResult } : {}
      });
    }
  };
}
function recordDispatchVerdict(orbitalName, event, verdict) {
  if ("error" in verdict) {
    recordServerResponse(orbitalName, event, {
      success: false,
      clientEffects: 0,
      dataEntities: {},
      emittedEvents: [],
      error: verdict.error instanceof Error ? `${verdict.error.name}: ${verdict.error.message}` : verdict.error
    });
    return;
  }
  const { response } = verdict;
  const dataEntities = {};
  for (const [entity, rows2] of Object.entries(response.data ?? {})) dataEntities[entity] = rows2.length;
  const effectFailures = (response.rejections ?? []).filter((r) => r.code === "effect-failed").map((r) => `${r.trait ?? orbitalName}.${r.event ?? event}: ${r.error ?? "effect failed"}`);
  const error = [...response.error !== void 0 ? [response.error] : [], ...effectFailures].join("; ");
  recordServerResponse(orbitalName, event, {
    success: response.success && effectFailures.length === 0,
    transitioned: response.transitioned,
    clientEffects: response.clientEffects?.length ?? 0,
    dataEntities,
    emittedEvents: response.emittedEvents.map((e) => e.event),
    emitted: response.emittedEvents.map((e) => e.payload !== void 0 ? { event: e.event, payload: e.payload } : { event: e.event }),
    ...error !== "" ? { error } : {},
    effectResults: serverEffectTraces(response.effectResults)
  });
}
var tabClientId;
function getTabClientId() {
  if (tabClientId === void 0) tabClientId = crypto.randomUUID();
  return tabClientId;
}
var log6 = createLogger("almadar:ui:circuit-kernel");
function postUnmounts(transport, traits, locale) {
  for (const [traitName, orbitalName] of traits) {
    transport.send(orbitalName, { event: UNMOUNT_EVENT, targetTrait: traitName, clientId: getTabClientId(), locale }).catch((err) => log6.warn("unmount-post-failed", { trait: traitName, orbital: orbitalName, error: String(err) }));
  }
}
function restrictTraitIndex(full, activeNames) {
  const byName = /* @__PURE__ */ new Map();
  for (const [name, entry] of full.byName) {
    if (activeNames.has(name)) byName.set(name, entry);
  }
  return { byName, allEntities: full.allEntities, orbitals: full.orbitals };
}
function useCircuitKernel(traitBindings, options) {
  const hostRunsProgram = options.transport?.hostsBrowserStore === true;
  const fullTraitIndex = useMemo(
    () => buildTraitIndex(options.orbitals, options.traitConfigsByName, { hostRunsProgram }),
    [options.orbitals, options.traitConfigsByName, hostRunsProgram]
  );
  const appTraitNames = useMemo(() => new Set(fullTraitIndex.byName.keys()), [fullTraitIndex]);
  const activeTraitKey = traitBindings.map((b) => b.trait.name).filter((n) => !!n).sort().join("\0");
  const traitIndex = useMemo(
    () => restrictTraitIndex(fullTraitIndex, new Set(activeTraitKey === "" ? [] : activeTraitKey.split("\0"))),
    [activeTraitKey, fullTraitIndex]
  );
  const mountedRef = useRef(/* @__PURE__ */ new Map());
  const { locale } = useTranslate$1();
  const i18n = useRenderI18n();
  const localeRef = useRef(locale);
  localeRef.current = locale;
  const transport = options.transport;
  const topologyPending = options.awaitTopology === true;
  useEffect(() => {
    if (transport === void 0 || topologyPending) return;
    const mounted = mountedRef.current;
    const dropped = [...mounted].filter(([name]) => !traitIndex.byName.has(name));
    mounted.clear();
    for (const [name, entry] of traitIndex.byName) mounted.set(name, entry.orbitalName);
    postUnmounts(transport, dropped, localeRef.current);
  }, [traitIndex, transport, topologyPending]);
  useEffect(() => {
    if (transport === void 0) return;
    const mounted = mountedRef.current;
    return () => postUnmounts(transport, [...mounted], localeRef.current);
  }, [transport]);
  const store = useMemo(() => {
    const traitDefs = Array.from(traitIndex.byName.values(), (entry) => entry.traitDef);
    const config = {
      ...options.guardMode !== void 0 ? { guardMode: options.guardMode } : {},
      ...options.strictBindings !== void 0 ? { strictBindings: options.strictBindings } : {},
      ...options.contextExtensions !== void 0 ? { contextExtensions: options.contextExtensions } : {}
    };
    return createMemoryCircuitStore(traitDefs, config, options.observer);
  }, [traitIndex, options.guardMode, options.strictBindings, options.contextExtensions, options.observer]);
  const localTransportOptions = {
    traitIndex,
    store,
    ...options.callService !== void 0 ? { callService: options.callService } : {},
    ...options.user !== void 0 ? { user: options.user } : {},
    ...options.guardMode !== void 0 ? { guardMode: options.guardMode } : {},
    ...options.strictBindings !== void 0 ? { strictBindings: options.strictBindings } : {},
    ...options.contextExtensions !== void 0 ? { contextExtensions: options.contextExtensions } : {},
    ...options.debug !== void 0 ? { debug: options.debug } : {},
    ...options.logContext !== void 0 ? { logContext: options.logContext } : {},
    // A local leg evaluates `i18n/t` like a server: with the viewer's catalog, as the kernel does.
    ...i18n !== void 0 ? { messages: { [i18n.locale]: i18n.messages } } : {}
  };
  const offlineTransport = useMemo(
    () => options.transport !== void 0 || options.persistence === void 0 ? void 0 : createLocalStoreTransport({ ...localTransportOptions, persistence: options.persistence }),
    [
      options.transport,
      options.persistence,
      traitIndex,
      store,
      options.callService,
      options.user,
      options.guardMode,
      options.strictBindings,
      options.contextExtensions,
      options.debug,
      options.logContext,
      i18n
    ]
  );
  const routedTransport = useMemo(() => {
    if (options.browserStore === void 0) return void 0;
    const local = createLocalStoreTransport({ ...localTransportOptions, traitIndex: fullTraitIndex, persistence: options.browserStore, clientRelays: true });
    const remote = options.transport ?? offlineTransport;
    return createResidenceTransport({ local, ...remote !== void 0 ? { remote } : {}, traitIndex: fullTraitIndex });
  }, [
    options.browserStore,
    options.transport,
    offlineTransport,
    fullTraitIndex,
    store,
    options.callService,
    options.user,
    options.guardMode,
    options.strictBindings,
    options.contextExtensions,
    options.debug,
    options.logContext,
    i18n
  ]);
  const baseTransport = routedTransport ?? options.transport ?? offlineTransport;
  const effectiveTransport = useMemo(
    () => baseTransport === void 0 ? void 0 : recordingTransport(baseTransport),
    [baseTransport]
  );
  const orbitalName = options.orbitals[0]?.name ?? "";
  const topology = useMemo(() => {
    let resolve = () => void 0;
    const promise = new Promise((r) => {
      resolve = r;
    });
    return { promise, resolve };
  }, [effectiveTransport]);
  const awaitTopology = options.awaitTopology === true;
  const confirmedCarries = options.carriesCircuitState ?? false;
  useEffect(() => {
    if (!awaitTopology) topology.resolve({ carriesCircuitState: confirmedCarries });
  }, [awaitTopology, confirmedCarries, topology]);
  const rawKernel = useMemo(() => createClientKernel({
    orbitalName,
    traitIndex,
    fullTraitIndex,
    store,
    ...options.persistence !== void 0 ? { persistence: options.persistence } : {},
    ...options.user !== void 0 ? { user: options.user } : {},
    locale,
    ...i18n !== void 0 ? { messages: { [i18n.locale]: i18n.messages } } : {},
    ...options.guardMode !== void 0 ? { guardMode: options.guardMode } : {},
    ...options.strictBindings !== void 0 ? { strictBindings: options.strictBindings } : {},
    ...options.contextExtensions !== void 0 ? { contextExtensions: options.contextExtensions } : {},
    ...options.debug !== void 0 ? { debug: options.debug } : {},
    ...options.logContext !== void 0 ? { logContext: options.logContext } : {},
    carriesCircuitState: false,
    topology: topology.promise,
    ...effectiveTransport !== void 0 ? { transport: effectiveTransport } : {}
  }), [
    orbitalName,
    traitIndex,
    fullTraitIndex,
    store,
    options.persistence,
    options.user,
    locale,
    i18n,
    options.guardMode,
    options.strictBindings,
    options.contextExtensions,
    options.debug,
    options.logContext,
    topology,
    effectiveTransport
  ]);
  const kernel = useMemo(() => {
    const stamp = (request) => ({
      ...request,
      clientId: request.clientId ?? getTabClientId(),
      locale: request.locale ?? locale
    });
    return {
      store: rawKernel.store,
      dispatch: (request, hooks) => rawKernel.dispatch(stamp(request), hooks),
      dispatchMount: (seeds, hooks, base = {}) => rawKernel.dispatchMount(seeds, hooks, stamp(base)),
      dispatchProgress: (request) => rawKernel.dispatchProgress(stamp(request)),
      foldHostDispatch: (request, response) => rawKernel.foldHostDispatch(request, response)
    };
  }, [rawKernel, locale]);
  return { kernel, store, traitIndex, appTraitNames, transport: effectiveTransport };
}
var log7 = createLogger("almadar:ui:circuit:bus-ingress");
function useBusIngress(traitBindings, traitIndex, settle, eventBus, appTraitNames) {
  useEffect(() => {
    const unsubscribes = [];
    const subscribedQualified = /* @__PURE__ */ new Set();
    const subscribedBare = /* @__PURE__ */ new Set();
    const deliveredHere = (source) => source?.dispatched === true && source.trait !== void 0 && (traitIndex.byName.has(source.trait) || appTraitNames.has(source.trait));
    const dispatch = (traitName, eventKey, payload, source) => {
      if (!claimDelivery(source, traitName, eventKey)) return;
      const tick = source?.tick;
      const pendingKey = source?.pendingKey;
      if (pendingKey !== void 0) beginPending(pendingKey);
      void settle(traitName, eventKey, payload, tick).catch((err) => {
        log7.error("dispatch:failed", { trait: traitName, event: eventKey, error: String(err) });
      }).finally(() => {
        if (pendingKey !== void 0) endPending(pendingKey);
      });
    };
    for (const binding of traitBindings) {
      const traitName = binding.trait.name;
      const orbitalName = traitIndex.byName.get(traitName)?.orbitalName;
      if (orbitalName === void 0) continue;
      for (const transition of binding.trait.transitions) {
        const eventKey = transition.event;
        if (LIFECYCLE_EVENTS.includes(eventKey)) continue;
        const qualifiedKey = `UI:${orbitalName}.${traitName}.${eventKey}`;
        if (!subscribedQualified.has(qualifiedKey)) {
          subscribedQualified.add(qualifiedKey);
          const unsub = eventBus.on(qualifiedKey, (event) => {
            if (deliveredHere(event.source)) return;
            log7.debug("qualified:fire", { key: qualifiedKey });
            dispatch(traitName, eventKey, event.payload, event.source);
          });
          unsubscribes.push(unsub);
        }
        const bareKey = `UI:${eventKey}`;
        if (!subscribedBare.has(bareKey)) {
          subscribedBare.add(bareKey);
          const unsub = eventBus.on(bareKey, (event) => {
            if (deliveredHere(event.source)) return;
            const routed = event.source?.dispatched === true ? new Set(collectListenerTargets(traitIndex, event.source, eventKey, event.payload).map((t) => t.listenerTrait)) : void 0;
            for (const [name, entry] of traitIndex.byName) {
              if (!entry.traitDef.transitions.some((t) => t.event === eventKey)) continue;
              if (routed?.has(name) === true) continue;
              log7.debug("bare:fire", { key: bareKey, trait: name });
              dispatch(name, eventKey, event.payload, event.source);
            }
          });
          unsubscribes.push(unsub);
        }
      }
    }
    const listenRoutesByKey = /* @__PURE__ */ new Map();
    for (const binding of traitBindings) {
      const listenerName = binding.trait.name;
      const ownOrbital = traitIndex.byName.get(listenerName)?.orbitalName;
      if (ownOrbital === void 0) continue;
      for (const listen of binding.trait.listens ?? []) {
        const src = listen.source;
        if (src === void 0 || src.kind === "any") continue;
        const sourceOrbital = (src.kind === "orbital" ? src.orbital : void 0) ?? ownOrbital;
        const sourceKey = `UI:${sourceOrbital}.${src.trait}.${listen.event}`;
        const route = {
          listenerTrait: listenerName,
          triggers: listen.triggers,
          payloadMapping: listen.payloadMapping
        };
        const routes = listenRoutesByKey.get(sourceKey);
        if (routes) routes.push(route);
        else listenRoutesByKey.set(sourceKey, [route]);
      }
    }
    for (const [sourceKey, routes] of listenRoutesByKey) {
      const unsub = eventBus.on(sourceKey, (event) => {
        if (deliveredHere(event.source)) return;
        for (const route of routes) {
          log7.debug("listen-source:fire", { key: sourceKey, listener: route.listenerTrait, triggers: route.triggers });
          dispatch(
            route.listenerTrait,
            route.triggers,
            applyListenPayloadMapping(route.payloadMapping, event.payload, evaluateListenPayloadExpr),
            event.source
          );
        }
      });
      unsubscribes.push(unsub);
    }
    const routedBareEvents = /* @__PURE__ */ new Set();
    for (const binding of traitBindings) {
      for (const listen of binding.trait.listens ?? []) {
        if (listen.source !== void 0 && listen.source.kind !== "any") routedBareEvents.add(listen.event);
      }
    }
    for (const eventKey of routedBareEvents) {
      const unsub = eventBus.on(`UI:${eventKey}`, (event) => {
        if (deliveredHere(event.source) || event.source?.trait === void 0) return;
        for (const target of collectListenerTargets(traitIndex, event.source, eventKey, event.payload)) {
          log7.debug("listen-bare:fire", { event: eventKey, source: event.source.trait, listener: target.listenerTrait, triggers: target.triggers });
          dispatch(target.listenerTrait, target.triggers, target.payload, event.source);
        }
      });
      unsubscribes.push(unsub);
    }
    return () => {
      for (const unsub of unsubscribes) unsub();
    };
  }, [traitBindings, traitIndex, settle, eventBus, appTraitNames]);
}
var lambdaLog = createLogger("almadar:ui:fn-form-lambda");
function readsI18n(value) {
  if (typeof value === "string") return value === "@locale" || value.startsWith("@locale.");
  if (Array.isArray(value)) {
    const arr = value;
    return arr[0] === "i18n/t" || arr.some((v) => readsI18n(v));
  }
  return false;
}
function needsRenderContext(value) {
  return readsI18n(value) || (typeof value === "string" || Array.isArray(value)) && containsEntityBinding(value);
}
function patternPropsSchema(patternType) {
  return typeof patternType === "string" ? getPatternDefinition(patternType)?.propsSchema : void 0;
}
function isDeclaredSExpr(def) {
  return def?.types?.includes("sexpr") ?? false;
}
function isOperatorCall(value) {
  const first = value[0];
  if (typeof first !== "string") return false;
  return isKnownStdOperator(first) || first.includes("/") || first === "lambda" || first === "let";
}
function isFnFormLambda(value) {
  if (!Array.isArray(value)) return false;
  const arr = value;
  if (arr.length !== 3 || arr[0] !== "fn" || arr[2] === null || typeof arr[2] !== "object") {
    return false;
  }
  const params = arr[1];
  return typeof params === "string" || Array.isArray(params) && params.length > 0 && params.every((p) => typeof p === "string");
}
function fnFormParams(value) {
  const p = value[1];
  if (typeof p === "string") return [p];
  if (Array.isArray(p)) return p.filter((x) => typeof x === "string");
  return [];
}
function resolveLambdaBindings(body, params, item, index) {
  const itemName = params[0];
  const indexName = params[1];
  const itemPrefix = itemName ? `@${itemName}.` : null;
  const lookup = (path) => {
    let cur = item;
    for (const seg of path.split(".")) {
      if (cur === null || cur === void 0) return void 0;
      if (typeof cur !== "object" || Array.isArray(cur)) return void 0;
      cur = cur[seg];
    }
    return cur;
  };
  const recur = (b) => resolveLambdaBindings(b, params, item, index);
  if (typeof body === "string") {
    if (indexName && body === `@${indexName}`) return index;
    if (itemName && body === `@${itemName}`) return item;
    if (itemPrefix && body.startsWith(itemPrefix)) {
      const v = lookup(body.slice(itemPrefix.length));
      return v === void 0 || v === null ? "" : v;
    }
    return body;
  }
  if (Array.isArray(body)) {
    if (isFnFormLambda(body)) return body;
    const arr = body;
    const substituted = arr.map((b) => recur(b));
    if (isOperatorCall(substituted) && isSExpr(substituted)) {
      if (needsRenderContext(substituted)) {
        return substituted;
      }
      const evaluated = evaluate(substituted, createMinimalContext());
      return isEventPayloadValue(evaluated) ? evaluated : String(evaluated);
    }
    return substituted;
  }
  if (body !== null && typeof body === "object" && !React93__default.isValidElement(body) && !(body instanceof Date) && typeof body !== "function") {
    const out = {};
    for (const [k, v] of Object.entries(body)) {
      out[k] = recur(v);
    }
    return out;
  }
  return body;
}
var LazySlotContentRenderer2 = React93__default.lazy(
  () => import('./UISlotRenderer-ERKBTKWI.js').then((m) => ({ default: m.SlotContentRenderer }))
);
function deferLambdaEntityExprs(value) {
  if (typeof value === "string") {
    if (needsRenderContext(value)) {
      const marker = { [RENDER_BINDING_MARKER]: true, expression: value };
      return marker;
    }
    return value;
  }
  if (Array.isArray(value)) {
    if (isFnFormLambda(value)) return value;
    const arr = value;
    if (isOperatorCall(arr) && isSExpr(arr) && needsRenderContext(arr)) {
      const marker = { [RENDER_BINDING_MARKER]: true, expression: arr };
      return marker;
    }
    return arr.map((v) => deferLambdaEntityExprs(v));
  }
  if (value !== null && typeof value === "object" && !React93__default.isValidElement(value) && !(value instanceof Date) && typeof value !== "function" && !isRenderBindingMarker(value)) {
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = deferLambdaEntityExprs(v);
    }
    return out;
  }
  return value;
}
function makeLambdaFn(params, lambdaBody, callerKey) {
  return (item, index) => {
    const resolvedBody = deferLambdaEntityExprs(
      resolveLambdaBindings(lambdaBody, params, item, index)
    );
    if (resolvedBody === null || typeof resolvedBody !== "object" || Array.isArray(resolvedBody) || typeof resolvedBody === "function" || React93__default.isValidElement(resolvedBody) || resolvedBody instanceof Date) {
      return null;
    }
    const record = resolvedBody;
    if (typeof record.type !== "string") {
      return null;
    }
    const rawChildProps = {};
    for (const [k, v] of Object.entries(record)) {
      if (k !== "type") rawChildProps[k] = v;
    }
    const childProps = convertObjectProps(rawChildProps, patternPropsSchema(record.type));
    const childContent = {
      id: `lambda-${callerKey}-${index}`,
      pattern: record.type,
      props: childProps,
      priority: 0
    };
    return React93__default.createElement(
      React93__default.Suspense,
      { fallback: null },
      React93__default.createElement(LazySlotContentRenderer2, { content: childContent, onDismiss: () => void 0 })
    );
  };
}
function convertNode(node, callerKey, def) {
  if (node === null || node === void 0) return node;
  if (isRenderBindingMarker(node)) return node;
  if (Array.isArray(node)) {
    if (isFnFormLambda(node)) {
      const arr2 = node;
      return makeLambdaFn(fnFormParams(arr2), arr2[2], callerKey);
    }
    const arr = node;
    let anyChanged = false;
    const mapped = arr.map((item, i) => {
      const next = convertNode(item, `${callerKey}[${i}]`, def?.items);
      if (next !== item) anyChanged = true;
      return next;
    });
    return anyChanged ? mapped : node;
  }
  if (typeof node === "object" && !React93__default.isValidElement(node) && !(node instanceof Date)) {
    return convertObjectProps(node, def?.properties);
  }
  return node;
}
function convertObjectProps(props, inherited) {
  let convertedAny = false;
  const out = {};
  const schema = patternPropsSchema(props.type) ?? inherited;
  for (const [key, value] of Object.entries(props)) {
    const def = schema?.[key];
    if (isDeclaredSExpr(def)) {
      out[key] = value;
      continue;
    }
    if (isFnFormLambda(value)) {
      convertedAny = true;
      const arr = value;
      const compiled = makeLambdaFn(fnFormParams(arr), arr[2], key);
      out[key] = compiled;
      if (key === "renderItem") out.children = compiled;
      lambdaLog.debug(`convert key=${key}${key === "renderItem" ? " (+children)" : ""}`);
      continue;
    }
    const next = convertNode(value, key, def);
    if (next !== value) convertedAny = true;
    out[key] = next;
  }
  return convertedAny ? out : props;
}
function convertFnFormLambdasInProps(props, patternType) {
  if (props === null || typeof props !== "object") return props;
  return convertObjectProps(props, patternType !== void 0 ? patternPropsSchema(patternType) : void 0);
}

// hooks/circuit/useSlotFlush.ts
var flushLog = createLogger("almadar:ui:circuit:slot-flush");
function unwrapPattern(record) {
  if (typeof record === "string") return { bareTraitRef: record };
  if (record === null) return {};
  const { type, children, ...inlineProps } = record;
  const props = { ...inlineProps, ...children !== void 0 ? { children } : {} };
  return { patternType: type, props };
}
function useSlotFlush(uiSlots, embeddedTraits) {
  const uiSlotsRef = useRef(uiSlots);
  uiSlotsRef.current = uiSlots;
  const embeddedTraitsRef = useRef(embeddedTraits);
  embeddedTraitsRef.current = embeddedTraits;
  const writtenRef = useRef(/* @__PURE__ */ new Map());
  const keyOf2 = (slot, trait) => `${slot}\0${trait}`;
  const flushSlot = useCallback((traitName, slot, patterns, source) => {
    const slots = uiSlotsRef.current;
    const embedded = embeddedTraitsRef.current;
    if (patterns.length === 0) {
      flushLog.debug("clear", { traitName, slot });
      slots.clearBySource(slot, traitName);
      writtenRef.current.set(keyOf2(slot, traitName), { kind: "clear", slot, trait: traitName });
      return;
    }
    const last = patterns[patterns.length - 1];
    const { bareTraitRef, patternType, props: unwrapped } = unwrapPattern(last.pattern);
    const rawProps = bareTraitRef !== void 0 ? bareTraitRef : { ...unwrapped ?? {}, ...last.props };
    const props = convertFnFormLambdasInProps(rawProps, typeof patternType === "string" ? patternType : void 0);
    const isEmbedded = (embedded?.has(traitName) ?? false) && !isNotificationSlot(slot);
    if (isEmbedded) {
      const content = {
        pattern: patternType,
        props,
        slot,
        priority: 0,
        transitionEvent: source?.event,
        fromState: source?.state,
        entity: source?.entity
      };
      slots.updateTraitContent(traitName, content);
      writtenRef.current.set(keyOf2(slot, traitName), { kind: "trait", trait: traitName, content });
      return;
    }
    const config = {
      target: slot,
      pattern: patternType,
      props,
      sourceTrait: traitName,
      transitionEvent: source?.event,
      fromState: source?.state,
      entity: source?.entity
    };
    slots.render(config);
    writtenRef.current.set(keyOf2(slot, traitName), { kind: "render", config });
  }, []);
  const applyClientEffects = useCallback((clientEffects, clientEffectsByTrait, onNavigate, onNavigateBack, activeTraits) => {
    const slots = uiSlotsRef.current;
    const embedded = embeddedTraitsRef.current;
    const tuples = clientEffectsByTrait ? [...clientEffectsByTrait] : clientEffects.map((effect) => ({ effect }));
    for (const { effect, traitName, event, fromState } of tuples) {
      if (traitName !== void 0 && activeTraits !== void 0 && !activeTraits.has(traitName)) continue;
      const kind = effect[0];
      if (kind === "render-ui") {
        const [, slot, pattern, rawProps] = effect;
        const sourceTrait = traitName ?? "kernel";
        const { bareTraitRef, patternType, props: unwrapped } = unwrapPattern(pattern);
        const isEmbedded = (embedded?.has(sourceTrait) ?? false) && !isNotificationSlot(slot);
        const propsValue = bareTraitRef !== void 0 ? bareTraitRef : { ...unwrapped ?? {}, ...rawProps };
        const props = convertFnFormLambdasInProps(propsValue, typeof patternType === "string" ? patternType : void 0);
        if (pattern === null) {
          slots.clearBySource(slot, sourceTrait);
          writtenRef.current.set(keyOf2(slot, sourceTrait), { kind: "clear", slot, trait: sourceTrait });
        } else if (isEmbedded) {
          const content = { pattern: patternType, props, slot, priority: 0, transitionEvent: event, fromState };
          slots.updateTraitContent(sourceTrait, content);
          writtenRef.current.set(keyOf2(slot, sourceTrait), { kind: "trait", trait: sourceTrait, content });
        } else {
          const config = { target: slot, pattern: patternType, props, sourceTrait, transitionEvent: event, fromState };
          slots.render(config);
          writtenRef.current.set(keyOf2(slot, sourceTrait), { kind: "render", config });
        }
      } else if (kind === "navigate") {
        const [, route, params, options] = effect;
        onNavigate?.(route, params, options?.crumb);
      } else if (kind === "navigate-back") {
        onNavigateBack?.();
      }
    }
  }, []);
  const checkpoint = useCallback(() => new Map(writtenRef.current), []);
  const rollback = useCallback((cp) => {
    const slots = uiSlotsRef.current;
    for (const [key, now] of writtenRef.current) {
      const then = cp.get(key);
      if (then === now) continue;
      if (then === void 0 || then.kind === "clear") {
        if (now.kind === "render") slots.clearBySource(now.config.target, now.config.sourceTrait ?? "kernel");
        else if (now.kind === "trait") {
          flushLog.warn("rollback:embedded-frame-kept", { trait: now.trait });
        }
      } else if (then.kind === "render") {
        slots.render(then.config);
      } else {
        slots.updateTraitContent(then.trait, then.content);
      }
    }
    writtenRef.current = new Map(cp);
  }, []);
  return useMemo(() => ({ flushSlot, applyClientEffects, checkpoint, rollback }), [flushSlot, applyClientEffects, checkpoint, rollback]);
}
var log8 = createLogger("almadar:ui:circuit:effect-runner");
async function runCircuitEffects(params) {
  const { store, eventBus, traitName, frameKey, effects, payload, callsitePayload, config, user, tickName } = params;
  if (effects.length === 0) return { emitted: [], didWrite: false };
  let frame = store.frames.get(frameKey);
  if (frame === void 0) {
    frame = {};
    store.frames.set(frameKey, frame);
  }
  const emitted = [];
  let didWrite = false;
  const handlers = createClientEffectHandlers({
    eventBus: {
      emit: (type, emitPayload, source) => {
        const event = type.startsWith("UI:") ? type.slice(3) : type;
        emitted.push(event);
        eventBus.emit(type, emitPayload, tickName !== void 0 ? { ...source, tick: tickName } : source);
      }
    },
    slotSetter: {
      addPattern: (slot, pattern, props, priority) => params.onPattern(slot, pattern, props, priority),
      clearSlot: (slot) => params.onPattern(slot, null)
    },
    navigate: params.navigate,
    navigateBack: params.navigateBack,
    liveEntity: frame,
    // Ticks and callsite re-runs never carry a persistence adapter — the
    // same bridge-mode placeholder the composition's client env delegates
    // to a leg; here there is no leg to delegate to, so the write is a
    // documented no-op (persist/call-service were never reachable from a
    // tick's SYNC_TICK_OPERATORS filter or a lifecycle re-run's effects).
    persistDelegated: true,
    callServiceDelegated: true,
    orbitalName: params.orbitalName
  });
  const baseSet = handlers.set;
  const tracked = {
    ...handlers,
    set: async (targetId, field, value) => {
      if (baseSet) await baseSet(targetId, field, value);
      didWrite = true;
    }
  };
  const bindingCtx = {
    entity: frame,
    payload: payload ?? {},
    state: params.state,
    ...user !== void 0 ? { user } : {},
    ...config !== void 0 ? { config } : {},
    ...callsitePayload !== void 0 ? { callsitePayload } : {}
  };
  const effectContext = {
    traitName,
    ...params.orbitalName !== void 0 ? { orbitalName: params.orbitalName } : {},
    ...params.traitId !== void 0 ? { traitId: params.traitId } : {},
    ...params.orbitalId !== void 0 ? { orbitalId: params.orbitalId } : {},
    ...params.emits !== void 0 ? { emits: params.emits } : {},
    state: params.state,
    transition: params.transitionLabel
  };
  const executor = new EffectExecutor({ handlers: tracked, bindings: bindingCtx, context: effectContext, deferRenderBindings: true });
  try {
    await executor.executeAll(effects);
  } catch (error) {
    log8.error("effects:error", {
      traitName,
      transition: params.transitionLabel,
      error: error instanceof Error ? error.message : String(error)
    });
  }
  return { emitted, didWrite };
}

// hooks/circuit/useCallsiteCapture.ts
var log9 = createLogger("almadar:ui:circuit:callsite-capture");
function useCallsiteCapture(traitBindings, store, traitIndex, slotFlush, options) {
  return useCallback(async function reRender(traitName, callsitePayload, entityByTrait, visited = /* @__PURE__ */ new Set(), serverComposed = /* @__PURE__ */ new Set(), keepComposed = false, composedBy) {
    const children = options.callsiteCaptureChildrenByTrait?.get(traitName);
    if (!children || children.size === 0) return;
    const bindingMap = new Map(traitBindings.map((b) => [b.trait.name, b]));
    for (const childName of children) {
      if (composedBy !== void 0 && !composedBy.has(childName)) continue;
      if (visited.has(childName)) continue;
      visited.add(childName);
      const childBinding = bindingMap.get(childName);
      if (!childBinding) continue;
      const composedWith = serverComposed.has(childName) || keepComposed ? store.callsitePayloads.get(childName) ?? callsitePayload : callsitePayload;
      const lifecycleEvent = store.manager.repaintLifecycleEvent(childName);
      const indexed = traitIndex.byName.get(childName);
      const [entry] = lifecycleEvent === void 0 || indexed === void 0 ? [] : store.manager.sendEvent(lifecycleEvent, {}, void 0, entityByTrait, void 0, childName);
      if (lifecycleEvent === void 0 || indexed === void 0 || !entry || !entry.result.executed) {
        await reRender(childName, composedWith, entityByTrait, visited, serverComposed, true);
        continue;
      }
      const frameKey = indexed.frameKey;
      log9.debug("rerender", { referrer: traitName, child: childName, lifecycleEvent });
      store.callsitePayloads.set(childName, composedWith);
      const pendingSlots = /* @__PURE__ */ new Map();
      await runCircuitEffects({
        store,
        eventBus: options.eventBus,
        traitName: childName,
        frameKey,
        effects: entry.result.effects,
        state: entry.result.previousState,
        transitionLabel: `${entry.result.previousState}->${entry.result.newState}`,
        payload: {},
        callsitePayload: composedWith,
        config: indexed.config,
        user: options.user,
        orbitalName: indexed.orbitalName,
        orbitalId: indexed.orbitalId,
        traitId: indexed.irTrait.id,
        emits: indexed.irTrait.emits,
        navigate: options.navigate,
        navigateBack: options.navigateBack,
        onPattern: (slot, pattern, props) => {
          if (pattern === null) {
            pendingSlots.set(slot, []);
            return;
          }
          const existing = pendingSlots.get(slot) ?? [];
          existing.push({ pattern, props });
          pendingSlots.set(slot, existing);
        }
      });
      store.notify();
      for (const [slot, patterns] of pendingSlots) {
        slotFlush.flushSlot(
          childName,
          slot,
          patterns,
          { event: lifecycleEvent, state: entry.result.previousState, entity: childBinding.linkedEntity }
        );
      }
      await reRender(childName, composedWith, entityByTrait, visited, serverComposed, keepComposed, traitsEmbeddedByEffects(indexed.irTrait, entry.result.effects));
    }
  }, [traitBindings, store, traitIndex, slotFlush, options.callsiteCaptureChildrenByTrait, options.eventBus, options.navigate, options.navigateBack, options.user]);
}
var tickLog = createLogger("almadar:ui:circuit:tick-effects");
var SHARED_ENTITY_WRITE_OPS = /* @__PURE__ */ new Set(["set"]);
var SHARED_ENTITY_RENDER_OPS = /* @__PURE__ */ new Set(["render-ui", "render"]);
function effectsCallOp(effects, ops) {
  for (const effect of effects) {
    let found = false;
    walkSExpr(effect, (node) => {
      if (!found && Array.isArray(node) && typeof node[0] === "string" && ops.has(node[0])) found = true;
    });
    if (found) return true;
  }
  return false;
}
function classifySharedTick(tick) {
  const writes = effectsCallOp(tick.effects, SHARED_ENTITY_WRITE_OPS);
  const renders = effectsCallOp(tick.effects, SHARED_ENTITY_RENDER_OPS);
  if (writes && renders) return "both";
  if (writes) return "writer";
  if (renders) return "renderer";
  return "neither";
}
function containsConfigForward(value) {
  if (typeof value === "string") return value.startsWith("@config.");
  if (Array.isArray(value)) return value.some(containsConfigForward);
  if (value !== null && typeof value === "object") return Object.values(value).some(containsConfigForward);
  return false;
}
function getBindingConfig(binding) {
  return normalizeCallSiteConfigToValues(binding.config);
}
function evalFieldDefault(value) {
  if (!Array.isArray(value) || !isSExpression(value)) return value;
  return evaluate(value, createMinimalContext({}, {}, ""));
}
function createSharedEntityWriter(binding, tick, traitStatesRef, emit, traitConfigsByName, orbitalsByTrait, orbitalIdsByTrait) {
  return (scratch) => {
    const traitName = binding.trait.name;
    const currentState = traitStatesRef.current.get(traitName)?.currentState ?? "";
    if (tick.appliesTo.length > 0 && !tick.appliesTo.includes(currentState)) return [];
    const scratchEntity = { ...scratch };
    const writes = [];
    const ctx = createMinimalContext(scratchEntity, {}, currentState);
    const declaredDefaults = collectDeclaredConfigDefaults(binding.trait);
    const resolvedByName = traitConfigsByName?.[traitName];
    const callSiteRaw = getBindingConfig(binding);
    const callSiteConfig = callSiteRaw ? Object.fromEntries(Object.entries(callSiteRaw).filter(([, v]) => !containsConfigForward(v))) : void 0;
    if (declaredDefaults || resolvedByName || callSiteConfig) {
      ctx.config = { ...declaredDefaults ?? {}, ...resolvedByName ?? {}, ...callSiteConfig ?? {} };
    }
    ctx.mutateEntity = (changes) => {
      for (const [field, value] of Object.entries(changes)) {
        const fieldValue = value;
        scratchEntity[field] = fieldValue;
        writes.push({ field, value: fieldValue });
      }
    };
    ctx.emit = (event, payload) => {
      emit(event, payload, {
        orbital: orbitalsByTrait?.[traitName],
        trait: traitName,
        tick: tick.name,
        orbitalId: orbitalIdsByTrait?.[traitName],
        traitId: binding.trait.id
      });
    };
    if (tick.guard !== void 0 && !evaluateGuard(tick.guard, ctx)) {
      tickLog.debug("guard-blocked", { traitName, tick: tick.name, state: currentState });
      return [];
    }
    executeEffects(tick.effects, ctx);
    return writes;
  };
}
function useClientTicks(traitBindings, store, traitIndex, options) {
  useEffect(() => {
    if (options.hostRunsProgram === true) return;
    const scheduler = createTickScheduler();
    const traitStatesRef = { current: store.manager.getAllStates() };
    const refreshStates = () => {
      traitStatesRef.current = store.manager.getAllStates();
    };
    const orbitalsByTrait = {};
    const orbitalIdsByTrait = {};
    for (const [name, entry] of traitIndex.byName) {
      orbitalsByTrait[name] = entry.orbitalName;
      if (entry.orbitalId !== void 0) orbitalIdsByTrait[name] = entry.orbitalId;
    }
    const emitFromWriter = (event, payload, source) => {
      const prefixed = event.startsWith("UI:") ? event : `UI:${event}`;
      options.eventBus.emit(prefixed, payload, source);
    };
    const frameAdapter = {
      getSnapshot: (frameKey) => store.frames.get(frameKey) ?? {},
      subscribe: (_frameKey, callback) => store.subscribe(callback),
      commit: (frameKey, next) => {
        store.frames.set(frameKey, next);
        store.notify();
      },
      seed: (frameKey, initial) => {
        if (!store.frames.has(frameKey)) store.frames.set(frameKey, initial);
      }
    };
    const writerTicksByFrame = /* @__PURE__ */ new Map();
    const pureWriterTickKeys = /* @__PURE__ */ new Set();
    const seededFrames = /* @__PURE__ */ new Set();
    for (const binding of traitBindings) {
      const entry = traitIndex.byName.get(binding.trait.name);
      if (!entry?.isSharedEntity) continue;
      if (!seededFrames.has(entry.frameKey)) {
        seededFrames.add(entry.frameKey);
        let defaults;
        for (const field of entry.entity.fields) {
          if (field.name !== void 0 && field.default !== void 0 && field.default !== null) {
            (defaults ?? (defaults = {}))[field.name] = evalFieldDefault(field.default);
          }
        }
        if (defaults) frameAdapter.seed(entry.frameKey, defaults);
      }
      for (const tick of binding.trait.ticks ?? []) {
        if (classifySharedTick(tick) !== "writer") continue;
        pureWriterTickKeys.add(`${binding.trait.name}::${tick.name}`);
        const list = writerTicksByFrame.get(entry.frameKey) ?? [];
        list.push({ binding, tick });
        writerTicksByFrame.set(entry.frameKey, list);
      }
    }
    for (const [frameKey, entries] of writerTicksByFrame) {
      const byInterval = /* @__PURE__ */ new Map();
      for (const item of entries) {
        const key = String(item.tick.interval);
        const list = byInterval.get(key) ?? [];
        list.push(item);
        byInterval.set(key, list);
      }
      for (const group of byInterval.values()) {
        const interval = group[0].tick.interval;
        const onDue = () => perfTimeAsync(`tick:shared:${frameKey}@${String(interval)}`, () => {
          const writers = group.map(
            ({ binding, tick }) => createSharedEntityWriter(binding, tick, traitStatesRef, emitFromWriter, options.traitConfigsByName, orbitalsByTrait, orbitalIdsByTrait)
          );
          runTickFrame(frameKey, writers, frameAdapter);
        });
        if (interval === "frame") scheduler.add(0, onDue);
        else if (typeof interval === "number") scheduler.add(interval, onDue);
        else if (isValidCronExpression(interval)) scheduler.addCron(interval, onDue);
        else scheduler.add(parseDurationString(interval), onDue);
      }
    }
    const runNonWriterTick = (binding, tick) => {
      refreshStates();
      const traitName = binding.trait.name;
      const currentState = traitStatesRef.current.get(traitName)?.currentState ?? "";
      if (tick.appliesTo.length > 0 && !tick.appliesTo.includes(currentState)) return;
      const entry = traitIndex.byName.get(traitName);
      const frameKey = entry?.frameKey ?? traitName;
      if (tick.guard !== void 0) {
        const entity = store.frames.get(frameKey) ?? {};
        const guardCtx = {
          entity,
          payload: {},
          state: currentState,
          ...options.user ? { user: options.user } : {},
          ...entry?.config !== void 0 ? { config: entry.config } : {}
        };
        if (!evaluateGuard(tick.guard, createContextFromBindings(guardCtx))) {
          tickLog.debug("guard-blocked", { traitName, tick: tick.name, state: currentState });
          return;
        }
      }
      const pendingSlots = /* @__PURE__ */ new Map();
      void runCircuitEffects({
        store,
        eventBus: options.eventBus,
        traitName,
        frameKey,
        effects: tick.effects,
        state: currentState,
        transitionLabel: `${currentState}->${currentState}`,
        config: entry?.config,
        user: options.user,
        orbitalName: entry?.orbitalName,
        orbitalId: entry?.orbitalId,
        traitId: entry?.irTrait.id,
        emits: entry?.irTrait.emits,
        navigate: options.navigate,
        navigateBack: options.navigateBack,
        tickName: tick.name,
        onPattern: (slot, pattern, props) => {
          if (pattern === null) {
            pendingSlots.set(slot, []);
            return;
          }
          const existing = pendingSlots.get(slot) ?? [];
          existing.push({ pattern, props });
          pendingSlots.set(slot, existing);
        }
      }).then(() => {
        store.notify();
        for (const [slot, patterns] of pendingSlots) {
          options.slotFlush.flushSlot(
            traitName,
            slot,
            patterns,
            { event: `tick:${tick.name}`, state: currentState, entity: binding.linkedEntity }
          );
        }
      });
    };
    for (const binding of traitBindings) {
      const entry = traitIndex.byName.get(binding.trait.name);
      for (const tick of binding.trait.ticks ?? []) {
        if (entry?.isSharedEntity && pureWriterTickKeys.has(`${binding.trait.name}::${tick.name}`)) continue;
        const key = `tick:${binding.trait.name}::${tick.name}`;
        const onDue = () => perfTimeAsync(key, () => runNonWriterTick(binding, tick));
        if (tick.interval === "frame") scheduler.add(0, onDue);
        else if (typeof tick.interval === "number") scheduler.add(tick.interval, onDue);
        else if (isValidCronExpression(tick.interval)) scheduler.addCron(tick.interval, onDue);
        else scheduler.add(parseDurationString(tick.interval), onDue);
      }
    }
    return () => scheduler.stopAll();
  }, [traitBindings, store, traitIndex, options.eventBus, options.slotFlush, options.traitConfigsByName, options.navigate, options.navigateBack, options.user, options.hostRunsProgram]);
}
var EMPTY_ENTITY = {};
function useEntityBindingSource(store, traitIndex) {
  useSyncExternalStore(store.subscribe, store.getVersion);
  return useMemo(() => {
    const snapshots = /* @__PURE__ */ new Map();
    return {
      getEntitySnapshot: (traitName) => {
        const entry = traitIndex.byName.get(traitName);
        const frameKey = entry?.frameKey ?? traitName;
        const frame = store.frames.get(frameKey);
        if (frame === void 0) return EMPTY_ENTITY;
        const previous = snapshots.get(frameKey);
        if (previous !== void 0 && sameFields(previous, frame)) return previous;
        const next = { ...frame };
        snapshots.set(frameKey, next);
        return next;
      },
      getConfig: (traitName) => traitIndex.byName.get(traitName)?.config,
      getState: (traitName) => store.manager.getState(traitName)?.currentState ?? "",
      subscribe: (_traitName, callback) => store.subscribe(callback)
    };
  }, [store, traitIndex]);
}
function sameFields(a, b) {
  const keys = Object.keys(b);
  if (Object.keys(a).length !== keys.length) return false;
  for (const key of keys) {
    if (!Object.is(a[key], b[key])) return false;
  }
  return true;
}
function useAwaitingSkeletonSource(store, traitIndex, embeddedTraits) {
  return useMemo(() => {
    const activeRenders = () => {
      const renders = [];
      for (const awaiting of store.awaiting.list()) {
        const transitions = traitIndex.byName.get(awaiting.trait)?.irTrait.stateMachine?.transitions ?? [];
        const taken = transitions.find((t) => t.event === awaiting.event && t.from === awaiting.from);
        if (taken?.awaitRender) renders.push(...taken.awaitRender);
      }
      return renders;
    };
    return {
      forSlot: (slot) => activeRenders().find((r) => r.slot === slot && !(embeddedTraits?.has(r.trait) ?? false))?.skeleton,
      forTrait: (traitName) => activeRenders().find((r) => r.trait === traitName)?.skeleton,
      subscribe: (callback) => store.awaiting.subscribeAll(callback),
      getVersion: () => store.awaiting.getVersion()
    };
  }, [store, traitIndex, embeddedTraits]);
}

// hooks/useTraitStateMachine.ts
var MOUNT_ERROR_SOURCE = "$mount";
var stateLog = createLogger("almadar:ui:state-transitions");
function diffDroppedTraitNames(prev, next) {
  const dropped = [];
  for (const name of prev) {
    if (!next.has(name)) dropped.push(name);
  }
  return dropped;
}
function normalizeEventKey(eventKey) {
  return eventKey.startsWith("UI:") ? eventKey.slice(3) : eventKey;
}
function useTraitStateMachine(traitBindings, uiSlots, options) {
  const eventBus = useEventBus();
  const { user: contextViewer } = useUser();
  const { t } = useTranslate$1();
  const userContext = options.user ?? contextViewer ?? void 0;
  const observer2 = useMemo(() => createCircuitVerificationObserver(), []);
  const { kernel, store, traitIndex, appTraitNames, transport } = useCircuitKernel(traitBindings, {
    orbitals: options.orbitals,
    ...options.traitConfigsByName !== void 0 ? { traitConfigsByName: options.traitConfigsByName } : {},
    ...options.transport !== void 0 ? { transport: options.transport } : {},
    ...options.carriesCircuitState !== void 0 ? { carriesCircuitState: options.carriesCircuitState } : {},
    ...options.awaitTopology !== void 0 ? { awaitTopology: options.awaitTopology } : {},
    ...options.persistence !== void 0 ? { persistence: options.persistence } : {},
    ...options.browserStore !== void 0 ? { browserStore: options.browserStore } : {},
    ...options.callService !== void 0 ? { callService: options.callService } : {},
    ...userContext !== void 0 ? { user: userContext } : {},
    ...options.debug !== void 0 ? { debug: options.debug } : {},
    ...options.logContext !== void 0 ? { logContext: options.logContext } : {},
    observer: observer2
  });
  const slotFlush = useSlotFlush(uiSlots, options.embeddedTraits);
  const reRenderCallsiteCaptureChildren = useCallsiteCapture(traitBindings, store, traitIndex, slotFlush, {
    ...options.callsiteCaptureChildrenByTrait !== void 0 ? { callsiteCaptureChildrenByTrait: options.callsiteCaptureChildrenByTrait } : {},
    eventBus,
    ...options.navigate !== void 0 ? { navigate: options.navigate } : {},
    ...options.navigateBack !== void 0 ? { navigateBack: options.navigateBack } : {},
    ...userContext !== void 0 ? { user: userContext } : {}
  });
  useClientTicks(traitBindings, store, traitIndex, {
    eventBus,
    slotFlush,
    hostRunsProgram: transport?.hostsBrowserStore === true,
    ...options.traitConfigsByName !== void 0 ? { traitConfigsByName: options.traitConfigsByName } : {},
    ...options.navigate !== void 0 ? { navigate: options.navigate } : {},
    ...options.navigateBack !== void 0 ? { navigateBack: options.navigateBack } : {},
    ...userContext !== void 0 ? { user: userContext } : {}
  });
  const entityBindingSource = useEntityBindingSource(store, traitIndex);
  const awaitingSkeletonSource = useAwaitingSkeletonSource(store, traitIndex, options.embeddedTraits);
  const activeTraitNamesRef = useRef(/* @__PURE__ */ new Set());
  useEffect(() => {
    activeTraitNamesRef.current = new Set(traitIndex.byName.keys());
  }, [traitIndex]);
  useEffect(() => {
    const ids = [];
    for (const binding of traitBindings) {
      const trait = binding.trait;
      const state = store.manager.getState(trait.name);
      const info = {
        id: trait.name,
        name: trait.name,
        currentState: state?.currentState ?? trait.states[0]?.name ?? "unknown",
        states: trait.states.map((s) => s.name),
        transitions: trait.transitions.flatMap((t2) => {
          const froms = Array.isArray(t2.from) ? t2.from : [t2.from];
          return froms.map((f3) => ({ from: f3, to: t2.to, event: t2.event, guard: t2.guard ? String(t2.guard) : void 0 }));
        }),
        guards: trait.transitions.filter((t2) => t2.guard).map((t2) => ({ name: String(t2.guard) })),
        transitionCount: 0
      };
      registerTrait(info);
      ids.push(trait.name);
    }
    bindTraitStateGetter((traitName) => store.manager.getState(traitName)?.currentState);
    const snapshotData = (traitName) => {
      const entry = traitIndex.byName.get(traitName);
      const frame = entry !== void 0 ? store.frames.get(entry.frameKey) : void 0;
      const entityName = entry?.entity.name;
      return frame !== void 0 && entityName !== void 0 ? { [entityName]: [{ ...frame }] } : {};
    };
    const snapshotUnregs = traitBindings.map((binding) => registerTraitSnapshot(binding.trait.name, () => {
      const currentState = store.manager.getState(binding.trait.name)?.currentState ?? binding.trait.states[0]?.name ?? "unknown";
      return {
        traitName: binding.trait.name,
        currentState,
        states: binding.trait.states.map((s) => s.name),
        events: binding.trait.events.map((e) => e.key),
        data: snapshotData(binding.trait.name),
        cascadeReceived: []
      };
    }));
    return () => {
      for (const id of ids) unregisterTrait(id);
      for (const unreg of snapshotUnregs) unreg();
    };
  }, [traitBindings, store, traitIndex]);
  const afterSettle = useCallback(async (traitName, eventKey, payload, transitioned, repaints, composedBefore) => {
    if (transitioned) {
      const entityByTrait = {};
      for (const [name, entry] of traitIndex.byName) {
        const row = store.frames.get(entry.frameKey);
        if (row !== void 0) entityByTrait[name] = row;
      }
      const repainted = new Set(repaints.map((e) => e.traitName));
      const serverComposed = new Set([...store.callsitePayloads].filter(([child, composed]) => composedBefore.get(child) !== composed).map(([child]) => child));
      const irTrait = traitIndex.byName.get(traitName)?.irTrait;
      const composedBy = irTrait !== void 0 ? traitsEmbeddedByEvent(irTrait, eventKey) : void 0;
      await reRenderCallsiteCaptureChildren(traitName, payload ?? {}, entityByTrait, repainted, serverComposed, false, composedBy);
    }
    options.onEventProcessed?.(eventKey, payload);
  }, [traitIndex, store, reRenderCallsiteCaptureChildren, options.onEventProcessed]);
  const settleOutcome = useCallback(async (traitName, eventKey, payload, outcome, composedBefore) => {
    recordDispatchVerdict(traitIndex.byName.get(traitName)?.orbitalName ?? traitName, eventKey, { response: outcome.response });
    const settledEffects = outcome.localPainted && outcome.serverEffects !== void 0 ? outcome.serverEffects : outcome.response;
    slotFlush.applyClientEffects(
      settledEffects.clientEffects ?? [],
      settledEffects.clientEffectsByTrait,
      options.navigate,
      options.navigateBack,
      activeTraitNamesRef.current
    );
    void outcome.tickSettled?.then((later) => {
      if (later === void 0) return;
      slotFlush.applyClientEffects(later.clientEffects ?? [], later.clientEffectsByTrait, options.navigate, options.navigateBack, activeTraitNamesRef.current);
    });
    for (const emitted of outcome.response.emittedEvents) {
      eventBus.emit(`UI:${emitted.event}`, emitted.payload, { ...emitted.source ?? {}, dispatched: true });
    }
    stateLog.debug("dispatch:settled", { traitName, eventKey, mode: outcome.mode, transitioned: outcome.response.transitioned });
    await afterSettle(traitName, eventKey, payload, outcome.response.transitioned, outcome.response.clientEffectsByTrait ?? [], composedBefore);
  }, [slotFlush, traitIndex, eventBus, options.navigate, options.navigateBack, afterSettle]);
  const dispatchAndSettle = useCallback(async (traitName, eventKey, payload, tick) => {
    const entityId = typeof payload?.entityId === "string" ? payload.entityId : void 0;
    const orbitalName = traitIndex.byName.get(traitName)?.orbitalName ?? traitName;
    let outcome;
    const composedBefore = new Map(store.callsitePayloads);
    let beforeLocalPaint;
    try {
      outcome = await kernel.dispatch({
        event: eventKey,
        ...payload !== void 0 ? { payload } : {},
        ...entityId !== void 0 ? { entityId } : {},
        ...tick !== void 0 ? { tick } : {},
        targetTrait: traitName
      }, {
        onLocal: (local) => {
          beforeLocalPaint = slotFlush.checkpoint();
          slotFlush.applyClientEffects(
            local.clientEffects ?? [],
            local.clientEffectsByTrait,
            options.navigate,
            options.navigateBack,
            activeTraitNamesRef.current
          );
        }
      });
    } catch (err) {
      if (beforeLocalPaint !== void 0) slotFlush.rollback(beforeLocalPaint);
      recordDispatchVerdict(orbitalName, eventKey, { error: err instanceof Error ? err : String(err) });
      throw err;
    }
    if (outcome.localPainted && !outcome.response.success && beforeLocalPaint !== void 0) {
      slotFlush.rollback(beforeLocalPaint);
    }
    await settleOutcome(traitName, eventKey, payload, outcome, composedBefore);
  }, [kernel, slotFlush, traitIndex, store, options.navigate, options.navigateBack, settleOutcome]);
  const progressAndSettle = useCallback(async (traitName, eventKey, payload) => {
    const entityId = typeof payload?.entityId === "string" ? payload.entityId : void 0;
    const composedBefore = new Map(store.callsitePayloads);
    const outcome = await kernel.dispatchProgress({
      event: eventKey,
      ...payload !== void 0 ? { payload } : {},
      ...entityId !== void 0 ? { entityId } : {},
      targetTrait: traitName
    });
    await settleOutcome(traitName, eventKey, payload, outcome, composedBefore);
  }, [kernel, store, settleOutcome]);
  useEffect(() => {
    if (!transport?.subscribe) return;
    return transport.subscribe((emitted, target) => {
      const listeners2 = collectListenerTargets(traitIndex, emitted.source, emitted.event, emitted.payload);
      if (target !== "origin") {
        for (const t2 of listeners2) void dispatchAndSettle(t2.listenerTrait, t2.triggers, t2.payload);
        return;
      }
      const caller = emitted.source?.trait;
      if (caller !== void 0 && traitIndex.byName.has(caller) && !listeners2.some((t2) => t2.listenerTrait === caller && t2.triggers === emitted.event)) {
        void progressAndSettle(caller, emitted.event, emitted.payload);
      }
      for (const t2 of listeners2) void progressAndSettle(t2.listenerTrait, t2.triggers, t2.payload);
    }, { clientId: getTabClientId() });
  }, [transport, traitIndex, progressAndSettle, dispatchAndSettle]);
  useEffect(() => {
    if (!transport?.subscribeHostDispatches) return;
    return transport.subscribeHostDispatches((_orbitalName, request, response) => {
      const traitName = request.targetTrait;
      if (traitName === void 0 || !traitIndex.byName.has(traitName)) return;
      const composedBefore = new Map(store.callsitePayloads);
      void kernel.foldHostDispatch(request, response).then((outcome) => settleOutcome(traitName, request.event, request.payload, outcome, composedBefore));
    }, { clientId: getTabClientId() });
  }, [transport, traitIndex, kernel, store, settleOutcome]);
  const mountAndSettle = useCallback(async (seeds, payload) => {
    const composedBefore = new Map(store.callsitePayloads);
    let beforeLocalPaint;
    let outcome;
    try {
      outcome = await kernel.dispatchMount(seeds, {
        onLocal: (_trait, local) => {
          if (beforeLocalPaint === void 0) beforeLocalPaint = slotFlush.checkpoint();
          slotFlush.applyClientEffects(local.clientEffects ?? [], local.clientEffectsByTrait, options.navigate, options.navigateBack, activeTraitNamesRef.current);
        }
      }, { payload });
    } catch (err) {
      if (beforeLocalPaint !== void 0) slotFlush.rollback(beforeLocalPaint);
      for (const seed of seeds) {
        recordDispatchVerdict(traitIndex.byName.get(seed.trait)?.orbitalName ?? seed.trait, seed.event, { error: err instanceof Error ? err : String(err) });
      }
      throw err;
    }
    if (!outcome.success && beforeLocalPaint !== void 0) slotFlush.rollback(beforeLocalPaint);
    slotFlush.applyClientEffects(outcome.serverEffects.clientEffects ?? [], outcome.serverEffects.clientEffectsByTrait, options.navigate, options.navigateBack, activeTraitNamesRef.current);
    const emitted = [...outcome.seeds.flatMap((seed) => seed.local.emittedEvents), ...outcome.emittedEvents];
    for (const e of emitted) {
      eventBus.emit(`UI:${e.event}`, e.payload, { ...e.source ?? {}, dispatched: true });
    }
    const serverRepaints = outcome.serverEffects.clientEffectsByTrait ?? [];
    for (const seed of outcome.seeds) {
      recordDispatchVerdict(traitIndex.byName.get(seed.trait)?.orbitalName ?? seed.trait, seed.event, {
        response: {
          ...seed.local,
          success: outcome.success,
          ...outcome.error !== void 0 ? { error: outcome.error } : {},
          rejections: [...seed.local.rejections ?? [], ...outcome.rejections.filter((r) => r.trait === seed.trait)]
        }
      });
      stateLog.debug("mount:settled", { traitName: seed.trait, eventKey: seed.event, mode: seed.mode, transitioned: seed.local.transitioned });
      await afterSettle(seed.trait, seed.event, payload, seed.local.transitioned, [...seed.local.clientEffectsByTrait ?? [], ...serverRepaints], composedBefore);
    }
  }, [kernel, slotFlush, traitIndex, store, eventBus, options.navigate, options.navigateBack, afterSettle]);
  useBusIngress(traitBindings, traitIndex, dispatchAndSettle, eventBus, appTraitNames);
  const sendEvent = useCallback((eventKey, payload) => {
    const normalized = normalizeEventKey(eventKey);
    for (const [traitName] of traitIndex.byName) {
      if (!store.manager.canHandleEvent(traitName, normalized)) continue;
      void dispatchAndSettle(traitName, normalized, payload);
    }
  }, [traitIndex, store, dispatchAndSettle]);
  const getTraitState = useCallback((traitName) => store.manager.getState(traitName), [store]);
  const canHandleEvent = useCallback((traitName, eventKey) => store.manager.canHandleEvent(traitName, normalizeEventKey(eventKey)), [store]);
  const prevActiveTraitNamesRef = useRef(/* @__PURE__ */ new Set());
  useEffect(() => {
    const nextActiveTraitNames = new Set(
      traitBindings.map((b) => b.trait.name).filter((n) => !!n)
    );
    const dropped = diffDroppedTraitNames(prevActiveTraitNamesRef.current, nextActiveTraitNames);
    if (dropped.length > 0) {
      for (const traitName of dropped) {
        for (const slot of ALL_SLOTS) {
          uiSlots.clearBySource(slot, traitName);
        }
      }
    }
    prevActiveTraitNamesRef.current = nextActiveTraitNames;
  }, [traitBindings, uiSlots]);
  const mountedRef = useRef(null);
  const aliveRef = useRef(true);
  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
    };
  }, []);
  const mountKey = `${options.mountKey ?? ""}\0${JSON.stringify(Object.entries(options.initPayload ?? {}).sort(([a], [b]) => a.localeCompare(b)))}`;
  useEffect(() => {
    const prev = mountedRef.current;
    const mount = prev !== null && prev.key === mountKey && prev.store === store ? prev : { key: mountKey, store, initialized: /* @__PURE__ */ new Set() };
    const active = new Set(traitBindings.map((b) => b.trait.name));
    const left = [...mount.initialized].filter((traitName) => !active.has(traitName));
    for (const traitName of left) mount.initialized.delete(traitName);
    store.mount.unmounted(left);
    const entering = [];
    const embeddedChildren = new Set([...options.callsiteCaptureChildrenByTrait?.values() ?? []].flatMap((c) => [...c]));
    for (const binding of traitBindings) {
      const traitName = binding.trait.name;
      if (mount.initialized.has(traitName)) continue;
      mount.initialized.add(traitName);
      const indexed = traitIndex.byName.get(traitName);
      if (embeddedChildren.has(traitName) && indexed !== void 0 && (traitReferencesCallsitePayload(indexed.irTrait) || configReferencesCallsitePayload(indexed.config)) && store.manager.repaintLifecycleEvent(traitName) !== void 0 && !store.callsitePayloads.has(traitName)) {
        continue;
      }
      const lifecycleEvent = LIFECYCLE_EVENTS.find((evt) => store.manager.canHandleEvent(traitName, evt));
      if (lifecycleEvent !== void 0) entering.push({ trait: traitName, event: lifecycleEvent });
    }
    store.mount.mounting(entering.map((e) => e.trait));
    if (entering.length > 0) {
      uiSlots.clearBySource("main", MOUNT_ERROR_SOURCE);
      void mountAndSettle(entering, { ...options.initPayload ?? {} }).catch((err) => {
        const traits = entering.map((e) => e.trait);
        const message = err instanceof Error ? err.message : String(err);
        const failed = err instanceof TraitMountError ? err.trait : traits.join(", ");
        const cause = err instanceof TraitMountError ? err.original : err;
        stateLog.warn("mount:failed", { traits, failed, error: message, stack: cause instanceof Error ? cause.stack : void 0 });
        if (!aliveRef.current) return;
        uiSlots.render({
          target: "main",
          pattern: "error-state",
          props: { title: t("error.traitMountFailed", { trait: failed }), message, "data-testid": TRAIT_MOUNT_ERROR_TESTID },
          sourceTrait: MOUNT_ERROR_SOURCE
        });
      });
    }
    mountedRef.current = mount;
  }, [traitBindings, store, mountAndSettle, mountKey, uiSlots, traitIndex, options.callsiteCaptureChildrenByTrait, t]);
  useSyncExternalStore(store.subscribe, store.getVersion, store.getVersion);
  const traitStates = useMemo(() => store.manager.getAllStates(), [store, store.getVersion()]);
  return { traitStates, sendEvent, getTraitState, canHandleEvent, entityBindingSource, awaitingSkeletonSource };
}
function useBrowserStore(appName, orbitals, locale) {
  const entities = useMemo(() => orbitals.flatMap(orbitalInlineEntities).filter(storesRowsInBrowser), [orbitals]);
  const [state, setState] = useState(() => entities.length === 0 ? { status: "none" } : { status: "opening" });
  useEffect(() => {
    if (entities.length === 0) {
      setState({ status: "none" });
      return;
    }
    let cancelled = false;
    let opened;
    setState({ status: "opening" });
    const open = async () => {
      try {
        const store = await openBrowserStore(browserStoreName(appName, locale), orbitals, void 0, locale);
        if (store === null) return;
        opened = store;
        if (!cancelled) setState({ status: "ready", store });
      } catch (err) {
        if (!cancelled) setState({ status: "failed", error: err instanceof Error ? err : new Error(String(err)) });
      }
    };
    void open();
    return () => {
      cancelled = true;
      opened?.close();
    };
  }, [appName, locale, entities, orbitals]);
  return state;
}

// runtime/fitContent.ts
var IDENTITY = { scale: 1, x: 0, y: 0 };
function fitContentTransform(box, content) {
  if (box.width <= 0 || box.height <= 0 || content.width <= 0 || content.height <= 0) return IDENTITY;
  const scale = Math.min(1, box.width / content.width, box.height / content.height);
  return {
    scale,
    x: box.width / 2 - (content.x + content.width / 2) * scale,
    y: box.height / 2 - (content.y + content.height / 2) * scale
  };
}
function slotContentRect(inner, scale) {
  const origin = inner.getBoundingClientRect();
  let left = Infinity;
  let top = Infinity;
  let right = -Infinity;
  let bottom = -Infinity;
  for (const slot of Array.from(inner.querySelectorAll("[data-orb-slot]"))) {
    for (const child of Array.from(slot.querySelectorAll("*"))) {
      const r = child.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) continue;
      left = Math.min(left, r.left);
      top = Math.min(top, r.top);
      right = Math.max(right, r.right);
      bottom = Math.max(bottom, r.bottom);
    }
  }
  if (left === Infinity) return null;
  return {
    x: (left - origin.left) / scale,
    y: (top - origin.top) / scale,
    width: (right - left) / scale,
    height: (bottom - top) / scale
  };
}
var xOrbitalLog = createLogger("almadar:runtime:cross-orbital");
var navLog = createLogger("almadar:runtime:navigation");
function NavStackRefBridge({ apiRef }) {
  const api = useNavStack();
  useEffect(() => {
    apiRef.current = api;
    return () => {
      apiRef.current = null;
    };
  }, [api, apiRef]);
  return null;
}
function HostHrefBaseProbe({ onBase }) {
  const base = useHref("/");
  useEffect(() => onBase(base), [base, onBase]);
  return null;
}
function appPathFromHref(href, hostHrefBase) {
  const root = hostHrefBase.endsWith("/") ? hostHrefBase.slice(0, -1) : hostHrefBase;
  if (href === root) return "/";
  if (!href.startsWith(`${root}/`)) return null;
  return href.slice(root.length);
}
function TraitInitializer({ traits, routeParams, mountKey, orbitals, onNavigate, onNavigateBack, onLocalFallback, localFallbackTimeoutMs, persistence, browserStore, traitConfigsByName, embeddedTraits, callsiteCaptureChildrenByTrait, hasBridge, children }) {
  const bridge = useServerBridge();
  const uiSlots = useUISlots();
  useEffect(() => {
    if (!hasBridge) return;
    const timer = setTimeout(() => {
      if (!bridge.connected) onLocalFallback?.();
    }, localFallbackTimeoutMs ?? 5e3);
    return () => clearTimeout(timer);
  }, [hasBridge, bridge.connected, onLocalFallback, localFallbackTimeoutMs]);
  const { entityBindingSource, awaitingSkeletonSource } = useTraitStateMachine(traits, uiSlots, {
    orbitals,
    ...onNavigate !== void 0 ? { navigate: onNavigate } : {},
    ...onNavigateBack !== void 0 ? { navigateBack: onNavigateBack } : {},
    ...traitConfigsByName !== void 0 ? { traitConfigsByName } : {},
    ...embeddedTraits !== void 0 ? { embeddedTraits } : {},
    ...callsiteCaptureChildrenByTrait !== void 0 ? { callsiteCaptureChildrenByTrait } : {},
    initPayload: routeParams,
    ...mountKey !== void 0 ? { mountKey } : {},
    ...hasBridge ? { transport: bridge.transport, carriesCircuitState: bridge.carriesCircuitState, awaitTopology: !bridge.topologyKnown } : { persistence },
    ...browserStore !== void 0 ? { browserStore } : {}
  });
  return /* @__PURE__ */ jsx(EntityBindingContext.Provider, { value: entityBindingSource, children: /* @__PURE__ */ jsx(AwaitingSkeletonContext.Provider, { value: awaitingSkeletonSource, children }) });
}
var CONTENT_STAGE_WIDTH = 480;
var NO_ORBITALS = [];
var LazyPageOfRegisteredProgram = createContext(false);
function FitToBox({ children, mode = "box" }) {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [fitted, setFitted] = useState({ scale: 1, x: 0, y: 0 });
  const scaleRef = useRef(1);
  useEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    if (!outer || !inner) return;
    const update = () => {
      const cw = outer.clientWidth;
      const ch = outer.clientHeight;
      if (mode === "content") {
        const rect = slotContentRect(inner, scaleRef.current);
        if (!rect) return;
        const next = fitContentTransform({ width: cw, height: ch }, rect);
        scaleRef.current = next.scale;
        setFitted(next);
        return;
      }
      const sw = inner.scrollWidth;
      const sh = inner.scrollHeight;
      if (!sw || !sh || !cw || !ch) return;
      setFitted({ scale: Math.min(1, cw / sw, ch / sh), x: 0, y: 0 });
    };
    update();
    const cleanups = [];
    if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(update);
      ro.observe(outer);
      ro.observe(inner);
      cleanups.push(() => ro.disconnect());
    }
    if (mode === "content" && typeof MutationObserver !== "undefined") {
      let frame = 0;
      const schedule = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(update);
      };
      const mo = new MutationObserver(schedule);
      mo.observe(inner, { childList: true, subtree: true, attributes: true, characterData: true });
      schedule();
      cleanups.push(() => {
        mo.disconnect();
        cancelAnimationFrame(frame);
      });
    }
    return () => cleanups.forEach((c) => c());
  }, [mode]);
  return /* @__PURE__ */ jsx("div", { ref: outerRef, className: "relative h-full w-full overflow-hidden", "data-fit-mode": mode, children: /* @__PURE__ */ jsx(
    "div",
    {
      ref: innerRef,
      style: {
        transform: `translate(${fitted.x}px, ${fitted.y}px) scale(${fitted.scale})`,
        transformOrigin: "top left",
        width: mode === "content" ? CONTENT_STAGE_WIDTH : "fit-content"
      },
      children
    }
  ) });
}
function SchemaRunner({ schema, serverUrl, transport, getAccessToken, mockData, pageName, routeParams, onNavigate, onNavigateBack, onLocalFallback, localFallbackTimeoutMs, persistence, themeOverride }) {
  const { traits, allEntities, allTraits, ir } = useResolvedSchema(schema, pageName);
  const allPageTraits = useMemo(() => {
    let base;
    if (pageName && traits.length > 0) {
      base = traits;
    } else if (!ir?.pages || ir.pages.size <= 1) {
      base = traits;
    } else {
      const firstPage = ir.pages.values().next().value;
      if (!firstPage) {
        base = traits;
      } else {
        const firstPageTraits = [];
        const seen = /* @__PURE__ */ new Set();
        for (const binding of firstPage.traits) {
          const name = binding.trait.name;
          if (name && !seen.has(name)) {
            seen.add(name);
            firstPageTraits.push(binding);
          }
        }
        base = firstPageTraits.length > 0 ? firstPageTraits : traits;
      }
    }
    const byName = new Set(base.map((b) => b.trait.name));
    const extra = [];
    const queue = [...base];
    while (queue.length > 0) {
      const binding = queue.shift();
      if (!binding) continue;
      for (const refName of collectTraitRefsFromResolvedTrait(binding.trait)) {
        if (byName.has(refName)) continue;
        const rt = allTraits.get(refName);
        if (!rt) continue;
        byName.add(refName);
        const sibling = { trait: rt, linkedEntity: rt.linkedEntity };
        extra.push(sibling);
        queue.push(sibling);
      }
    }
    return extra.length > 0 ? [...base, ...extra] : base;
  }, [ir, traits, pageName, allTraits]);
  const orbitalsByTrait = useMemo(
    () => buildOrbitalsByTrait(
      schema,
      ir ? Array.from(ir.pages.values()).map((p) => ({
        path: p.path,
        traitNames: p.traits.map((b) => b.trait.name)
      })) : []
    ),
    [schema, ir]
  );
  const traitLinkedEntitiesMap = useMemo(
    () => ir ? buildTraitLinkedEntities(ir) : /* @__PURE__ */ new Map(),
    [ir]
  );
  const orbitalsByTraitMap = useMemo(
    () => new Map(Object.entries(orbitalsByTrait)),
    [orbitalsByTrait]
  );
  const entitiesArray = useMemo(() => Array.from(allEntities.values()), [allEntities]);
  const pageOrbitalNames = useMemo(() => {
    const set = /* @__PURE__ */ new Set();
    for (const binding of allPageTraits) {
      const orb = orbitalsByTrait[binding.trait.name];
      if (orb) set.add(orb);
    }
    return Array.from(set);
  }, [allPageTraits, orbitalsByTrait]);
  useEffect(() => {
    const traitNames = allPageTraits.map((b) => b.trait.name);
    const orbitalsByTraitForPage = {};
    for (const name of traitNames) {
      const orb = orbitalsByTrait[name];
      if (orb) orbitalsByTraitForPage[name] = orb;
    }
    xOrbitalLog.info("SchemaRunner:mount", {
      pageName,
      traitNames: traitNames.join(","),
      orbitalsByTraitForPage,
      pageOrbitalNames: pageOrbitalNames.join(",")
    });
  }, [pageName, allPageTraits, orbitalsByTrait, pageOrbitalNames]);
  const traitConfigsByName = useMemo(
    () => buildResolvedTraitConfigs(schema),
    [schema]
  );
  const callsiteCaptureChildrenByTrait = useMemo(() => {
    const merged = /* @__PURE__ */ new Map();
    const orbitals = schema?.orbitals;
    if (orbitals) {
      for (const orbital of orbitals) {
        for (const [referrer, children] of collectCallsiteCaptureChildren(orbital)) {
          merged.set(referrer, children);
        }
      }
    }
    return merged;
  }, [schema]);
  const embeddedTraits = useMemo(() => {
    const set = collectEmbeddedTraits(schema);
    xOrbitalLog.info("SchemaRunner:embeddedTraits", {
      pageName,
      embedded: Array.from(set),
      embeddedCount: set.size
    });
    return set;
  }, [schema, pageName]);
  const activeOrbitalTheme = useMemo(() => resolvePreviewTheme(schema, pageName), [schema, pageName]);
  const { locale } = useTranslate();
  const browserStore = useBrowserStore(schema.name ?? "app", transport?.hostsBrowserStore === true ? NO_ORBITALS : schema.orbitals, locale);
  const inner = /* @__PURE__ */ jsx(VerificationProvider, { enabled: true, children: /* @__PURE__ */ jsx(
    EntitySchemaProvider,
    {
      entities: entitiesArray,
      traitLinkedEntities: traitLinkedEntitiesMap,
      orbitalsByTrait: orbitalsByTraitMap,
      children: /* @__PURE__ */ jsx(
        TraitInitializer,
        {
          traits: allPageTraits,
          routeParams,
          mountKey: pageName,
          orbitals: schema.orbitals,
          hasBridge: Boolean(serverUrl || transport),
          traitConfigsByName,
          embeddedTraits,
          callsiteCaptureChildrenByTrait,
          onNavigate,
          onNavigateBack,
          onLocalFallback,
          localFallbackTimeoutMs,
          persistence,
          ...browserStore.status === "ready" ? { browserStore: browserStore.store } : {},
          children: /* @__PURE__ */ jsx(OrbitalThemeProvider, { theme: activeOrbitalTheme, override: themeOverride, children: /* @__PURE__ */ jsx(Box, { className: "h-full min-h-full overflow-auto p-4", children: /* @__PURE__ */ jsx(UISlotRenderer, { includeHud: true, hudMode: "inline", includeFloating: true, pageKey: pageName }) }) })
        }
      )
    }
  ) });
  if (browserStore.status === "opening") return /* @__PURE__ */ jsx(LoadingState, {});
  if (browserStore.status === "failed") {
    return /* @__PURE__ */ jsx(ErrorState, { "data-testid": "browser-store-error", message: browserStore.error.message });
  }
  return inner;
}
function resolvePreviewTheme(schema, pageName) {
  if (!schema.orbitals?.length) return schema.theme;
  if (pageName) {
    for (const orb of schema.orbitals) {
      for (const pageRef of orb.pages ?? []) {
        const name = typeof pageRef === "object" && pageRef !== null && "name" in pageRef ? pageRef.name : void 0;
        if (name === pageName) return orb.theme ?? schema.theme;
      }
    }
  }
  return schema.orbitals[0]?.theme ?? schema.theme;
}
function NavigateListener({ onNavigate }) {
  const bus = useEventBus();
  useEffect(
    () => bus.on("UI:NAVIGATE", (event) => {
      const url = event.payload?.url;
      if (typeof url === "string" && url.length > 0) onNavigate(url);
    }),
    [bus, onNavigate]
  );
  return null;
}
function OrbPreview({
  schema,
  mockData,
  autoMock = false,
  height = "400px",
  className,
  serverUrl,
  transport,
  getAccessToken,
  initialPagePath,
  isolated = false,
  fit = false,
  onPageChange,
  user = null,
  authority = "unavailable",
  localFallbackTimeoutMs,
  themeOverride,
  lazyLoader,
  schemaPath,
  onUnmatchedNavigate,
  onSignIn
}) {
  if (serverUrl && transport) {
    throw new Error("OrbPreview accepts serverUrl OR transport, not both");
  }
  const { t } = useTranslate();
  const [localFallback, setLocalFallback] = useState(false);
  const inHostRouter = useInRouterContext();
  const [hostHrefBase, setHostHrefBase] = useState("/");
  const handleLocalFallback = useCallback(() => {
    if (localFallback) return;
    setLocalFallback(true);
  }, [localFallback]);
  const isLazyPageOfRegisteredProgram = useContext(LazyPageOfRegisteredProgram);
  const parseResult = useMemo(() => {
    let parsed;
    if (typeof schema === "string") {
      try {
        parsed = JSON.parse(schema);
      } catch (e) {
        return { ok: false, error: String(e) };
      }
    } else {
      parsed = schema;
    }
    if (autoMock && !serverUrl && !transport) {
      const prepared = prepareSchemaForPreview(parsed);
      return { ok: true, schema: prepared.schema, mockData: prepared.mockData };
    }
    return { ok: true, schema: parsed, mockData: mockData ?? {} };
  }, [schema, autoMock, serverUrl, transport, mockData]);
  const parsedSchema = parseResult.ok ? parseResult.schema : null;
  useArbitraryClassStyles(parsedSchema);
  const effectiveMockData = parseResult.ok ? parseResult.mockData : {};
  const persistence = useMemo(() => {
    if (!parsedSchema || serverUrl || transport) return void 0;
    if (!autoMock) return void 0;
    const adapter = new InMemoryPersistence();
    adapter.seed(effectiveMockData);
    return adapter;
  }, [parsedSchema, serverUrl, transport, autoMock, effectiveMockData]);
  const pages = useMemo(() => {
    if (!parsedSchema) return [];
    try {
      return getAllPages(parsedSchema);
    } catch {
      return [];
    }
  }, [parsedSchema]);
  const lazyPages = useMemo(() => parsedSchema?.lazyPages ?? [], [parsedSchema]);
  const matchRoute = useCallback((path) => {
    const candidates = [
      ...pages.map((entry) => ({ kind: "page", entry, path: entry.page.path })),
      ...lazyPages.map((page) => ({ kind: "lazy", page, path: page.path }))
    ];
    const hit = matchPathAmong(candidates, path, (c) => c.path);
    if (!hit) return null;
    return hit.candidate.kind === "page" ? { kind: "page", entry: hit.candidate.entry, params: hit.params } : { kind: "lazy", page: hit.candidate.page, params: hit.params };
  }, [pages, lazyPages]);
  const initialRoute = useMemo(
    () => initialPagePath ? matchRoute(initialPagePath) : null,
    [matchRoute, initialPagePath]
  );
  const initialPageMatch = useMemo(() => {
    if (initialRoute?.kind !== "page" || !initialRoute.entry.page.name) return void 0;
    return { name: initialRoute.entry.page.name, params: initialRoute.params };
  }, [initialRoute]);
  const [lazyRoute, setLazyRoute] = useState(
    initialRoute?.kind === "lazy" && initialPagePath ? { page: initialRoute.page, path: initialPagePath } : null
  );
  const [lazyLoad, setLazyLoad] = useState({ status: "loading" });
  useEffect(() => {
    if (!lazyRoute) return;
    if (!lazyLoader) {
      setLazyLoad({ status: "error", error: `No loader for lazy page ${lazyRoute.page.path} (${lazyRoute.page.orbRef})` });
      return;
    }
    let cancelled = false;
    setLazyLoad({ status: "loading" });
    void loadLazyPage(lazyLoader, lazyRoute.page, schemaPath).then((result) => {
      if (cancelled) return;
      setLazyLoad(result.success ? { status: "ready", schema: result.data } : { status: "error", error: result.error });
    });
    return () => {
      cancelled = true;
    };
  }, [lazyRoute?.page, lazyLoader, schemaPath]);
  const initialPageName = initialPageMatch?.name;
  const [currentPage, setCurrentPage] = useState(initialPageName);
  const [routeParams, setRouteParams] = useState(initialPageMatch?.params ?? {});
  const prevInitialPagePathRef = useRef(initialPagePath);
  useEffect(() => {
    if (prevInitialPagePathRef.current !== initialPagePath) {
      prevInitialPagePathRef.current = initialPagePath;
      setCurrentPage(initialPageName);
      setRouteParams(initialPageMatch?.params ?? {});
      setLazyRoute(initialRoute?.kind === "lazy" && initialPagePath ? { page: initialRoute.page, path: initialPagePath } : null);
    }
  }, [initialPagePath, initialPageName, initialPageMatch, initialRoute]);
  const currentPagePath = useMemo(() => {
    const activePageName = currentPage ?? pages[0]?.page.name;
    const resolved = pages.find((p) => p.page.name === activePageName)?.page.path;
    return resolved ?? initialPagePath;
  }, [pages, currentPage, initialPagePath]);
  const navPages = useMemo(
    () => pages.filter((p) => typeof p.page.path === "string" && p.page.path.length > 0).map((p) => ({ path: p.page.path, name: p.page.name, orbital: p.orbitalName, label: p.page.label })),
    [pages]
  );
  const concreteCurrentPath = useMemo(() => {
    const pattern = currentPagePath ?? "/";
    return pattern.replace(/:([A-Za-z0-9_]+)/g, (whole, key) => routeParams[key] ?? whole);
  }, [currentPagePath, routeParams]);
  const navStackRef = useRef(null);
  const announcePage = useCallback((path) => {
    if (onPageChange) {
      onPageChange(path);
    } else if (!isolated && typeof window !== "undefined") {
      const url = new URL(window.location.href);
      url.searchParams.set("page", path);
      window.history.pushState({}, "", url.toString());
      window.dispatchEvent(new PopStateEvent("popstate"));
    }
  }, [isolated, onPageChange]);
  const handleNavigate = useCallback((path, navState) => {
    if (isHostSignInRoute(path)) {
      onSignIn?.(navState?.returnTo);
      return;
    }
    const route = matchRoute(path);
    if (!route) {
      onUnmatchedNavigate?.(path);
      return;
    }
    if (route.kind === "lazy") {
      setLazyRoute({ page: route.page, path });
      announcePage(path);
      return;
    }
    setLazyRoute(null);
    const match = route.entry;
    const params = { ...route.params, ...navState ?? {} };
    navLog.debug("handleNavigate", () => ({
      path,
      matched: match?.page.name ?? null,
      params,
      navState: navState ? JSON.stringify(navState) : void 0,
      availablePaths: pages.map((p) => p.page.path)
    }));
    if (match.page.name) {
      setRouteParams(params);
      setCurrentPage(match.page.name);
      announcePage(path);
    }
  }, [pages, matchRoute, announcePage, onUnmatchedNavigate, onSignIn]);
  const activePage = useMemo(() => {
    const activePageName = currentPage ?? pages[0]?.page.name;
    return pages.find((p) => p.page.name === activePageName)?.page;
  }, [pages, currentPage]);
  const handleAccessDenied = useCallback(
    (signIn, returnTo) => handleNavigate(signIn, { returnTo }),
    [handleNavigate]
  );
  const site = parsedSchema?.site;
  const locales = parsedSchema?.locales;
  const alternates = useMemo(
    () => activePage === void 0 ? void 0 : localeAlternates(pages.map((p) => p.page), activePage, locales ?? []),
    [pages, activePage, locales]
  );
  const declaresHead = activePage !== void 0 && (activePage.title !== void 0 || activePage.description !== void 0 || activePage.access !== void 0 || activePage.indexing !== void 0);
  usePageHead(
    !isolated && !lazyRoute && declaresHead ? {
      title: activePage.title,
      description: activePage.description,
      access: activePage.access,
      indexing: activePage.indexing,
      origin: site?.origin,
      siteName: site?.name,
      path: concreteCurrentPath,
      ...alternates !== void 0 ? { alternates, defaultLocale: locales?.[0] } : {}
    } : null
  );
  const handleNavigateEffect = useCallback(
    (path, params, crumb) => {
      navStackRef.current?.beginNavigate(path, crumb);
      handleNavigate(path, params);
    },
    [handleNavigate]
  );
  const handleNavigateBack = useCallback(() => {
    navStackRef.current?.back();
  }, []);
  if (!parseResult.ok) {
    return /* @__PURE__ */ jsx(Box, { className, style: { height }, children: /* @__PURE__ */ jsxs(Typography, { as: "pre", color: "error", variant: "small", className: "font-mono whitespace-pre-wrap break-all m-0 p-4", children: [
      "Parse error: ",
      parseResult.error
    ] }) });
  }
  const containerRef = useRef(null);
  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    if (pages.length <= 1 && !isolated) {
      navLog.debug("interceptor:skipped", { reason: "single-page schema", pageCount: pages.length });
      return;
    }
    const handler = (e) => {
      const anchor = e.target.closest("a");
      if (!anchor) return;
      const href = anchor.getAttribute("href") ?? anchor.getAttribute("to") ?? "";
      navLog.debug("click:intercepted", {
        href,
        anchorText: anchor.textContent?.trim().slice(0, 40)
      });
      const external = href.startsWith("http") || href.startsWith("mailto:");
      const appPath = external ? null : appPathFromHref(href, hostHrefBase);
      if (isolated && appPath === null) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (external) window.open(href, "_blank", "noopener,noreferrer");
        navLog.debug("click:sandboxed", { href, external });
        return;
      }
      if (appPath === null) {
        navLog.debug("click:skipped", { href, reason: "not an in-app href", hostHrefBase });
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleNavigate(appPath);
    };
    el.addEventListener("click", handler, true);
    navLog.info("interceptor:installed", { pageCount: pages.length, paths: pages.map((p) => p.page.path) });
    return () => el.removeEventListener("click", handler, true);
  }, [pages, handleNavigate, isolated, hostHrefBase]);
  const withBridge = (node) => (serverUrl || transport) && !isLazyPageOfRegisteredProgram ? /* @__PURE__ */ jsx(ServerBridgeProvider, { schema: parseResult.schema, serverUrl, transport, getAccessToken, children: node }) : node;
  if (lazyRoute) {
    return withBridge(
      /* @__PURE__ */ jsxs(Box, { ref: containerRef, className: `overflow-auto ${className ?? ""}`, style: { height }, children: [
        lazyLoad.status === "loading" && /* @__PURE__ */ jsx(LoadingState, {}),
        lazyLoad.status === "error" && /* @__PURE__ */ jsx(ErrorState, { "data-testid": "lazy-page-error", message: lazyLoad.error }),
        lazyLoad.status === "ready" && /* @__PURE__ */ jsx(LazyPageOfRegisteredProgram.Provider, { value: true, children: /* @__PURE__ */ jsx(
          OrbPreview,
          {
            schema: lazyLoad.schema,
            autoMock,
            height: "100%",
            className: "border-0",
            serverUrl,
            transport,
            getAccessToken,
            initialPagePath: lazyRoute.path,
            user,
            authority,
            isolated,
            fit,
            onPageChange: announcePage,
            themeOverride,
            lazyLoader,
            onUnmatchedNavigate: handleNavigate
          },
          lazyRoute.page.orbRef
        ) })
      ] })
    );
  }
  return withBridge(
    /* @__PURE__ */ jsxs(
      Box,
      {
        ref: containerRef,
        className: `${fit ? "overflow-hidden" : "overflow-auto"} border border-[var(--color-border)] rounded-[var(--radius-md)] ${className ?? ""}`,
        style: { height },
        children: [
          localFallback && /* @__PURE__ */ jsx(Box, { className: "px-3 py-2 bg-[var(--color-warning)] bg-opacity-10 border-b border-[var(--color-warning)] flex items-center gap-2", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-[var(--color-warning-foreground)] flex-1", children: t("orbPreview.serverUnreachable") }) }),
          inHostRouter ? /* @__PURE__ */ jsx(HostHrefBaseProbe, { onBase: setHostHrefBase }) : null,
          /* @__PURE__ */ jsx(CurrentPagePathProvider, { value: currentPagePath, children: /* @__PURE__ */ jsxs(
            NavStackProvider,
            {
              pages: navPages,
              currentPath: concreteCurrentPath,
              navigate: handleNavigate,
              storageKey: `almadar:navstack:${parseResult.schema.name ?? "preview"}`,
              children: [
                /* @__PURE__ */ jsx(NavStackRefBridge, { apiRef: navStackRef }),
                /* @__PURE__ */ jsxs(OrbitalProvider, { initialData: effectiveMockData, skipTheme: true, verification: true, isolated, user, children: [
                  /* @__PURE__ */ jsx(NavigateListener, { onNavigate: handleNavigate }),
                  /* @__PURE__ */ jsx(UISlotProvider, { children: /* @__PURE__ */ jsx(
                    PageAccessHost,
                    {
                      access: activePage?.access,
                      authority,
                      viewerId: user?.id,
                      signIn: parseResult.schema.site?.signIn,
                      path: concreteCurrentPath,
                      onDenied: handleAccessDenied,
                      children: fit ? /* @__PURE__ */ jsx(FitToBox, { mode: fit === "content" ? "content" : "box", children: /* @__PURE__ */ jsx(
                        SchemaRunner,
                        {
                          schema: parseResult.schema,
                          serverUrl,
                          transport,
                          getAccessToken,
                          mockData: effectiveMockData,
                          pageName: currentPage,
                          routeParams,
                          onNavigate: handleNavigateEffect,
                          onNavigateBack: handleNavigateBack,
                          onLocalFallback: handleLocalFallback,
                          localFallbackTimeoutMs,
                          persistence,
                          themeOverride
                        }
                      ) }) : /* @__PURE__ */ jsx(
                        SchemaRunner,
                        {
                          schema: parseResult.schema,
                          serverUrl,
                          transport,
                          getAccessToken,
                          mockData: effectiveMockData,
                          pageName: currentPage,
                          routeParams,
                          onNavigate: handleNavigateEffect,
                          onNavigateBack: handleNavigateBack,
                          onLocalFallback: handleLocalFallback,
                          localFallbackTimeoutMs,
                          persistence,
                          themeOverride
                        }
                      )
                    }
                  ) })
                ] })
              ]
            }
          ) })
        ]
      }
    )
  );
}
OrbPreview.displayName = "OrbPreview";
var playgroundLog = createLogger("almadar:ui:browser-playground");
function BrowserPlayground({
  schema,
  mode = "mock",
  initialPagePath,
  height,
  className,
  paused,
  fit,
  onPageChange,
  viewer,
  messages,
  locale,
  lazyLoader,
  schemaPath
}) {
  const [runtime] = useState(
    () => new OrbitalServerRuntime({ mode, debug: false, ...viewer !== void 0 ? { defaultUser: viewer } : {} })
  );
  useEffect(() => {
    if (paused === void 0) return;
    if (paused) {
      runtime.pauseTicks();
    } else {
      runtime.resumeTicks();
    }
  }, [runtime, paused]);
  const lazySchemas = useMemo(() => {
    const lazyPages = schema.lazyPages ?? [];
    if (lazyPages.length === 0 || lazyLoader === void 0) return Promise.resolve([]);
    return Promise.all(lazyPages.map(async (page) => {
      const loaded = await loadLazyPage(lazyLoader, page, schemaPath);
      if (!loaded.success) throw new Error(loaded.error);
      return loaded.data;
    }));
  }, [schema.lazyPages, lazyLoader, schemaPath]);
  const registerProgram = useCallback((program) => {
    const orbitalNames = program.orbitals.map((o) => o.name);
    playgroundLog.debug("register:start", { schema: program.name, orbitalNames });
    return lazySchemas.then((lazy6) => runtime.register(program, { ...messages !== void 0 ? { messages } : {}, lazy: lazy6 })).then(() => {
      playgroundLog.debug("register:done", { schema: program.name, orbitalNames });
    });
  }, [runtime, lazySchemas, messages]);
  const latestRegistration = useRef(Promise.resolve());
  const registrationReady = useMemo(() => {
    const ready = registerProgram(schema);
    latestRegistration.current = ready;
    return ready;
  }, [registerProgram, schema]);
  const teardownTimerRef = useRef(null);
  useEffect(() => {
    if (teardownTimerRef.current !== null) {
      clearTimeout(teardownTimerRef.current);
      teardownTimerRef.current = null;
    }
    return () => {
      teardownTimerRef.current = setTimeout(() => {
        teardownTimerRef.current = null;
        playgroundLog.debug("unregisterAll:unmount");
        runtime.unregisterAll();
      }, 0);
    };
  }, [runtime]);
  const transport = useMemo(
    () => createInProcessTransport(
      async (orbitalName, request) => {
        await latestRegistration.current;
        return runtime.processOrbitalEvent(orbitalName, request);
      },
      {
        // Registers what the bridge hands over (lazy behaviors included): a bridge that unregistered first gets it back.
        onRegister: (program) => {
          const ready = registerProgram(program);
          latestRegistration.current = ready;
          return ready;
        },
        onUnregister: () => {
          runtime.unregisterAll();
        }
      }
    ),
    [runtime, registerProgram, registrationReady]
  );
  const viewerLocale = locale ?? schema.locales?.[0];
  const i18n = useMemo(() => {
    if (viewerLocale === void 0 || messages === void 0) return void 0;
    const catalog = messages[viewerLocale] ?? {};
    return { locale: viewerLocale, direction: localeDirection(viewerLocale), t: createTranslate(catalog, viewerLocale), messages: catalog };
  }, [viewerLocale, messages]);
  const preview = /* @__PURE__ */ jsx(
    OrbPreview,
    {
      schema,
      transport,
      initialPagePath,
      height,
      className,
      fit,
      onPageChange,
      user: viewer ?? null,
      lazyLoader,
      schemaPath,
      isolated: true
    }
  );
  return i18n !== void 0 ? /* @__PURE__ */ jsx(I18nProvider, { value: i18n, children: preview }) : preview;
}
var log10 = createLogger("almadar:ui:canvas-dnd");
function useCanvasDraggable({
  id,
  payload,
  disabled
}) {
  const { setNodeRef, attributes, listeners: listeners2, isDragging, transform } = useDraggable({
    id,
    data: { payload },
    disabled
  });
  const style = {
    cursor: disabled ? "not-allowed" : isDragging ? "grabbing" : "grab",
    opacity: isDragging ? 0.5 : 1,
    touchAction: "none"
  };
  const { role, ...ariaAttributes } = attributes;
  return {
    setNodeRef,
    attributes: { ...ariaAttributes, ...isAriaRole(role) ? { role } : {} },
    listeners: listeners2,
    isDragging,
    style
  };
}
var DEFAULT_ACCEPTS = ["pattern", "behavior"];
function useCanvasDroppable({
  id,
  target,
  accepts: accepts2,
  disabled
}) {
  const acceptsList = accepts2 ?? DEFAULT_ACCEPTS;
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: { target, accepts: acceptsList },
    disabled
  });
  return { setNodeRef, isOver };
}
function dropBusEvent(drop) {
  const { payload, target, resolved } = drop;
  const at = resolved ? { parentPath: resolved.parentPath, index: resolved.index, ...resolved.container ? { container: { ...resolved.container } } : {} } : {};
  if (payload.kind === "pattern") {
    const patternType = payload.data["type"];
    if (typeof patternType !== "string") {
      log10.warn("drop:pattern:missing-type");
      return null;
    }
    return { event: "UI:PATTERN_DROP", payload: { patternType, containerNode: target.containerNode, ...at } };
  }
  if (payload.kind === "behavior") {
    const behaviorName2 = payload.data["name"];
    if (typeof behaviorName2 !== "string") {
      log10.warn("drop:behavior:missing-name");
      return null;
    }
    return { event: "UI:BEHAVIOR_DROP", payload: { behaviorName: behaviorName2, containerNode: target.containerNode, ...at } };
  }
  if (payload.kind === "pattern-instance") {
    const fromPath = payload.data["fromPath"];
    if (typeof fromPath !== "string") {
      log10.warn("drop:pattern-instance:missing-fromPath");
      return null;
    }
    const out = { fromPath, loc: payload.data["loc"] };
    if (resolved) {
      out.toParentPath = resolved.parentPath;
      out.toIndex = resolved.index;
    }
    return { event: "UI:PATTERN_MOVE", payload: out };
  }
  log10.debug("drop:unhandled-kind", { kind: payload.kind });
  return null;
}
function defaultEmit(eventBus, drop) {
  const out = dropBusEvent(drop);
  if (!out) return;
  eventBus.emit(out.event, out.payload);
  log10.info("default-emit", { event: out.event, level: drop.target.level });
}
function CanvasDndProvider({
  children,
  onDrop,
  renderOverlay
}) {
  const eventBus = useEventBus();
  const sensors = useAlmadarDndSensors(false);
  const [activePayload, setActivePayload] = React93__default.useState(null);
  const lastPointerRef = React93__default.useRef(null);
  const trackPointer = React93__default.useCallback((ev) => {
    lastPointerRef.current = { x: ev.clientX, y: ev.clientY };
  }, []);
  const handleDragStart = React93__default.useCallback((e) => {
    const data = e.active.data.current;
    const payload = data?.payload;
    const activator = e.activatorEvent;
    lastPointerRef.current = activator instanceof MouseEvent ? { x: activator.clientX, y: activator.clientY } : null;
    document.addEventListener("pointermove", trackPointer);
    if (payload) {
      setActivePayload(payload);
      eventBus.emit("UI:DRAG_START", { kind: payload.kind, data: payload.data });
      log10.info("dragStart", { id: e.active.id, kind: payload.kind });
    } else {
      log10.warn("dragStart:missing-payload", { id: e.active.id });
    }
  }, [eventBus, trackPointer]);
  const handleDragEnd = React93__default.useCallback((e) => {
    setActivePayload(null);
    document.removeEventListener("pointermove", trackPointer);
    const activeData = e.active.data.current;
    const payload = activeData?.payload;
    const overData = e.over?.data.current;
    const target = overData?.target;
    const accepts2 = overData?.accepts;
    log10.info("dragEnd", {
      activeId: e.active.id,
      overId: e.over?.id,
      hasPayload: !!payload,
      hasTarget: !!target,
      targetLevel: target?.level
    });
    if (payload) {
      eventBus.emit("UI:DRAG_END", { kind: payload.kind, data: payload.data });
    }
    if (!payload || !target) return;
    if (accepts2 && !accepts2.includes(payload.kind)) {
      log10.debug("dragEnd:rejected:kind", { kind: payload.kind, accepts: [...accepts2] });
      return;
    }
    const cursor = lastPointerRef.current;
    const resolved = target.resolvePath && cursor ? target.resolvePath(cursor) : null;
    log10.debug("dragEnd:resolve", {
      hasResolver: !!target.resolvePath,
      cursorX: cursor?.x,
      cursorY: cursor?.y,
      resolvedParent: resolved?.parentPath ?? null,
      resolvedIndex: resolved?.index ?? null
    });
    const drop = { payload, target, cursor, resolved };
    const suppressed = onDrop ? onDrop(drop) === true : false;
    if (!suppressed) defaultEmit(eventBus, drop);
  }, [eventBus, onDrop, trackPointer]);
  const handleDragCancel = React93__default.useCallback(() => {
    setActivePayload(null);
    document.removeEventListener("pointermove", trackPointer);
    log10.info("dragCancel");
  }, [trackPointer]);
  return /* @__PURE__ */ jsxs(
    DndContext,
    {
      sensors,
      collisionDetection: almadarDndCollisionDetection,
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd,
      onDragCancel: handleDragCancel,
      children: [
        children,
        renderOverlay ? (
          /* pointer-events none on the WRAPPER, not just the rendered content:
             dnd-kit doesn't default it, and the overlay rides exactly under the
             cursor — with hit-testing on, `resolvePath`'s elementFromPoint sees
             the overlay instead of the drop target and every drop degrades to
             the caller's fallback position. */
          /* @__PURE__ */ jsx(DragOverlay, { dropAnimation: null, style: { pointerEvents: "none" }, children: activePayload ? renderOverlay(activePayload) : null })
        ) : null
      ]
    }
  );
}

// lib/wire-validation.ts
function validateWire(sourcePayload, targetPayload) {
  const warnings = [];
  if (!sourcePayload?.length && !targetPayload?.length) {
    return { valid: true, warnings };
  }
  if (sourcePayload?.length && !targetPayload?.length) {
    return { valid: true, warnings };
  }
  if (!sourcePayload?.length && targetPayload?.length) {
    const requiredFields = targetPayload.filter((f3) => f3.required);
    if (requiredFields.length > 0) {
      warnings.push(`Missing required fields: ${requiredFields.map((f3) => f3.name).join(", ")}`);
    }
    return { valid: warnings.length === 0, warnings };
  }
  const sourceFields = new Map(sourcePayload.map((f3) => [f3.name, f3]));
  for (const targetField of targetPayload) {
    const sourceField = sourceFields.get(targetField.name);
    if (!sourceField) {
      if (targetField.required) {
        warnings.push(`Missing required field: ${targetField.name} (${targetField.type})`);
      }
    } else if (sourceField.type !== targetField.type) {
      warnings.push(`Type mismatch: ${targetField.name} (source: ${sourceField.type}, target: ${targetField.type})`);
    }
  }
  return { valid: warnings.length === 0, warnings };
}
function formatPayloadTooltip(fields) {
  if (fields.length === 0) return "";
  const parts = fields.map(
    (f3) => `${f3.name}: ${f3.type}${f3.required ? " (req)" : ""}`
  );
  return `{ ${parts.join(", ")} }`;
}

// lib/compute-insertion-index.ts
function computeInsertionIndex(childRects, pointer, axis) {
  if (axis === "vertical") {
    const at = childRects.findIndex((rect) => pointer.y < rect.top + rect.height / 2);
    return at === -1 ? childRects.length : at;
  }
  for (const line2 of wrappedLines(childRects)) {
    if (pointer.y > line2.bottom) continue;
    const at = line2.indices.find((i) => pointer.x < childRects[i].left + childRects[i].width / 2);
    return at ?? line2.indices[line2.indices.length - 1] + 1;
  }
  return childRects.length;
}
function wrappedLines(childRects) {
  const lines = [];
  childRects.forEach((rect, i) => {
    const line2 = lines[lines.length - 1];
    if (line2 && rect.top < line2.bottom && rect.bottom > line2.top) {
      line2.indices.push(i);
      line2.top = Math.min(line2.top, rect.top);
      line2.bottom = Math.max(line2.bottom, rect.bottom);
    } else {
      lines.push({ indices: [i], top: rect.top, bottom: rect.bottom });
    }
  });
  return lines;
}

// lib/resolve-direct-children.ts
function resolveDirectChildren(containerPath, candidates) {
  const prefix = `${containerPath}.children.`;
  return candidates.reduce((acc, { path, ref }) => {
    if (!path.startsWith(prefix)) return acc;
    const rest = path.slice(prefix.length);
    if (!rest || rest.includes(".")) return acc;
    const index = Number(rest);
    if (Number.isFinite(index)) acc.push({ index, ref });
    return acc;
  }, []).sort((a, b) => a.index - b.index).map(({ ref }) => ref);
}
function directPatternChildren(container) {
  return Array.from(container.querySelectorAll("[data-pattern-path]")).filter(
    (child) => child instanceof HTMLElement && child.parentElement?.closest("[data-pattern-path]") === container
  );
}
function entityNameOf(ref) {
  if (!ref) return void 0;
  if (typeof ref === "string") return ref;
  return "name" in ref ? ref.name : void 0;
}
var eventHandleLog = createLogger("almadar:ui:nan-coord");
var orbPreviewLog = createLogger("almadar:ui:orb-preview-node");
orbPreviewLog.debug("module-init", () => ({ browserPlayground: typeof BrowserPlayground }));
var ScreenSizeContext = createContext("tablet");
var CARD_MIN_WIDTH = 240;
var CARD_MAX_WIDTH = 1600;
var PatternSelectionContext = createContext({ selected: null, select: () => {
} });
var CanvasToolsContext = createContext(CANVAS_TOOLS);
var CanvasStatePickerContext = createContext(null);
var CanvasVerifyContext = createContext(null);
var VERDICT_VARIANT = {
  pass: "success",
  fail: "error",
  stale: "warning",
  running: "info"
};
var ROLE_COLORS = {
  initial: { border: STATE_COLORS.initial.border, dot: STATE_COLORS.initial.border },
  terminal: { border: STATE_COLORS.terminal.border, dot: STATE_COLORS.terminal.border },
  hub: { border: STATE_COLORS.hub.border, dot: STATE_COLORS.hub.border },
  default: { border: "var(--color-border)", dot: STATE_COLORS.default.border }
};
var LAYER_ORDER = ["Infrastructure", "Services", "UI Patterns", "Game", "ML", "Domain", "Community"];
var LAYER_LABEL_KEYS = {
  Infrastructure: "orbPreview.layer.infrastructure",
  Services: "orbPreview.layer.services",
  "UI Patterns": "orbPreview.layer.uiPatterns",
  Game: "orbPreview.layer.game",
  ML: "orbPreview.layer.ml",
  Domain: "orbPreview.layer.domain",
  Community: "orbPreview.layer.community"
};
var LAYER_COLORS = Object.fromEntries(LAYER_ORDER.map((layer, i) => [layer, avlSeries(i)]));
var TARGET_HANDLE_STYLE = {
  background: "var(--color-primary)",
  width: 8,
  height: 8,
  border: "2px solid var(--color-card)"
};
function eventHandleStyle(source) {
  const hint = Number.isFinite(source.positionHint) ? source.positionHint : 0.5;
  if (hint !== source.positionHint) {
    eventHandleLog.warn("orb-preview-handle: non-finite positionHint on PatternEventSource", {
      event: source.event,
      patternType: source.patternType,
      label: source.label,
      positionHint: source.positionHint
    });
  }
  return {
    background: CONNECTION_COLORS.emitListen.color,
    width: 10,
    height: 10,
    border: "2px solid var(--color-card)",
    top: `${hint * 100}%`,
    right: -5
  };
}
function buildOrbitalSchema(fullSchema, orbitalName) {
  const orbital = (fullSchema.orbitals ?? []).find((o) => o.name === orbitalName);
  if (!orbital) return fullSchema;
  return { ...fullSchema, name: `${fullSchema.name}__${orbitalName}`, orbitals: [orbital] };
}
function generateMockPayload(payloadSchema, schema, linkedEntity, mockData) {
  const payload = {};
  if (!payloadSchema || payloadSchema.length === 0) return payload;
  const entityNames = /* @__PURE__ */ new Set();
  for (const orb of schema.orbitals ?? []) {
    const name = entityNameOf(orb.entity);
    if (name) entityNames.add(name);
  }
  const linkedRows = linkedEntity ? mockData?.[linkedEntity] ?? [] : [];
  const linkedFirstRow = linkedRows[0];
  const valueForType = (rawType, entityType) => {
    const type = rawType.replace(/!$/, "").trim();
    const arrayMatch = /^\[\s*(\w+)\s*\]$/.exec(type);
    if (arrayMatch) {
      return mockData?.[arrayMatch[1]] ?? linkedRows;
    }
    if (type === "array") return linkedRows;
    if (type === "entity") {
      const target = entityType && mockData?.[entityType] ? entityType : linkedEntity;
      return (target && mockData?.[target]?.[0]) ?? linkedFirstRow ?? {};
    }
    if (entityNames.has(type)) {
      return mockData?.[type]?.[0] ?? linkedFirstRow ?? {};
    }
    switch (type) {
      case "string":
        return "Sample";
      case "number":
        return 1;
      case "boolean":
        return false;
      case "object":
        return {};
      case "date":
      case "datetime":
      case "timestamp":
        return (/* @__PURE__ */ new Date()).toISOString();
      default:
        return void 0;
    }
  };
  const setByPath = (target, path, value) => {
    const parts = path.split(".");
    let cur = target;
    for (let i = 0; i < parts.length - 1; i++) {
      const k = parts[i];
      const next = cur[k];
      if (next === null || typeof next !== "object" || Array.isArray(next)) {
        cur[k] = {};
      }
      cur = cur[k];
    }
    cur[parts[parts.length - 1]] = value;
  };
  for (const field of payloadSchema) {
    let value = valueForType(field.type, field.entity);
    if (linkedFirstRow !== void 0 && field.name.includes(".") && (typeof value === "string" || typeof value === "number" || typeof value === "boolean")) {
      const tail = field.name.split(".").pop();
      const fromRow = linkedFirstRow[tail];
      if (fromRow !== void 0) value = fromRow;
    }
    setByPath(payload, field.name, value);
  }
  return payload;
}
function substitutePayloadBindings(effects, payload) {
  const isPayloadObject = (v) => v !== null && typeof v === "object" && !Array.isArray(v) && !(v instanceof Date);
  const getByPath = (path) => {
    let cur = payload;
    for (const k of path.split(".")) {
      if (!isPayloadObject(cur)) return void 0;
      cur = cur[k];
    }
    return cur;
  };
  const replaceValue = (v) => {
    if (typeof v === "string" && v.startsWith("@payload.")) {
      const resolved = getByPath(v.slice("@payload.".length));
      return resolved === void 0 ? v : resolved;
    }
    if (Array.isArray(v)) return v.map(replaceValue);
    if (v && typeof v === "object" && !(v instanceof Date)) {
      const out = {};
      for (const [k, inner] of Object.entries(v)) {
        out[k] = replaceValue(inner);
      }
      return out;
    }
    return v;
  };
  const tree = JSON.parse(JSON.stringify(effects));
  const substituted = replaceValue(tree);
  return substituted;
}
function findEmitContract(trait, event) {
  return trait.emits?.find((e) => e.event === event);
}
function elementIn(container, path, trait) {
  const candidates = Array.from(container?.querySelectorAll(`[data-pattern-path="${CSS.escape(path)}"]`) ?? []);
  const el = candidates.find((c) => trait === void 0 || traitOfElement(c) === trait);
  return el instanceof HTMLElement ? el : null;
}
function sameElement(a, b) {
  return a.trait === b.trait && a.path === b.path;
}
function elementAddressOf(focus) {
  const { orbital, trait, transition, slot, path } = focus;
  return trait && transition !== void 0 && slot && path ? { orbital, trait, transition, slot, path } : null;
}
function renderedElementAt(content, point) {
  const stack = document.elementsFromPoint(point.x, point.y);
  const rendered = stack.find((el) => el instanceof HTMLElement && content?.contains(el) === true && el.closest("[data-pattern-path]") !== null);
  if (rendered) return rendered;
  const top = stack[0];
  return top instanceof HTMLElement ? top : null;
}
function embeddedClosure(traits, traitName) {
  const byName = new Map(traits.flatMap((t) => typeof t !== "string" && "name" in t && t.name ? [[t.name, t]] : []));
  const kept = /* @__PURE__ */ new Set([traitName]);
  let frontier = [traitName];
  while (frontier.length > 0) {
    const scan = frontier.flatMap((n) => {
      const t = byName.get(n);
      return t ? [t] : [];
    });
    const refs = collectEmbeddedTraits({ name: "closure", orbitals: [{ name: "closure", entity: { name: "closure", fields: [] }, traits: scan, pages: [] }] });
    frontier = [...refs].filter((n) => byName.has(n) && !kept.has(n));
    frontier.forEach((n) => kept.add(n));
  }
  return kept;
}
function buildTransitionSchema(fullSchema, orbitalName, traitName, transitionEvent, fromState, toState, mockData) {
  const orbital = (fullSchema.orbitals ?? []).find((o) => o.name === orbitalName);
  if (!orbital) return fullSchema;
  const clonedOrbital = JSON.parse(JSON.stringify(orbital));
  const traits = clonedOrbital.traits ?? [];
  for (let ti = 0; ti < traits.length; ti++) {
    const trait = traits[ti];
    if (!isInlineTrait(trait)) continue;
    const traitObj = trait;
    if (traitObj.name !== traitName) continue;
    const sm = traitObj.stateMachine;
    if (!sm) continue;
    const allTransitions = sm.transitions ?? [];
    const targetTransition = fromState && toState ? allTransitions.find((t) => t.event === transitionEvent && t.from === fromState && t.to === toState) ?? allTransitions.find((t) => t.event === transitionEvent) : allTransitions.find((t) => t.event === transitionEvent);
    if (!targetTransition?.effects) continue;
    const previewEffects = [];
    let hasRenderUI = false;
    for (const eff of targetTransition.effects) {
      if (!Array.isArray(eff)) continue;
      const op = eff[0];
      if (op === "render-ui") {
        const slotTarget = eff[1];
        const PORTAL_SLOTS = /* @__PURE__ */ new Set(["modal", "drawer", "overlay", "center"]);
        const rewritten = typeof slotTarget === "string" && PORTAL_SLOTS.has(slotTarget) ? ["render-ui", "main", ...eff.slice(2)] : eff;
        previewEffects.push(rewritten);
        hasRenderUI = true;
        continue;
      }
      if (op === "set") {
        const target = eff[1];
        if (typeof target === "string" && target.startsWith("@entity.")) {
          previewEffects.push(eff);
        }
      }
    }
    if (!hasRenderUI) continue;
    const linkedEntity = traitObj.linkedEntity ?? entityNameOf(clonedOrbital.entity);
    const emitContract = findEmitContract(traitObj, transitionEvent);
    const mockPayload = generateMockPayload(
      emitContract?.payloadSchema,
      fullSchema,
      linkedEntity,
      mockData
    );
    const seededEffects = substitutePayloadBindings(previewEffects, mockPayload);
    traitObj.stateMachine = {
      states: [{ name: "preview", isInitial: true }],
      events: [{ key: "INIT", name: "INIT" }],
      transitions: [{ from: "preview", to: "preview", event: "INIT", effects: seededEffects }]
    };
    traitObj.emits = [];
    traitObj.listens = [];
    break;
  }
  const targetTrait = traits.find((t) => {
    if (typeof t === "string") return t === traitName;
    if ("name" in t) return t.name === traitName;
    if ("ref" in t) return t.ref === traitName;
    return false;
  });
  const kept = targetTrait ? embeddedClosure(traits, traitName) : /* @__PURE__ */ new Set();
  if (targetTrait) {
    clonedOrbital.traits = traits.filter((t) => typeof t !== "string" && "name" in t && t.name !== void 0 && kept.has(t.name));
  }
  if (Array.isArray(clonedOrbital.pages)) {
    const linkedEntityForTrait = isInlineTrait(targetTrait) ? targetTrait.linkedEntity ?? entityNameOf(clonedOrbital.entity) : entityNameOf(clonedOrbital.entity);
    clonedOrbital.pages = clonedOrbital.pages.map((page) => {
      if (isPageReference(page)) return page;
      const inline = page;
      if (!Array.isArray(inline.traits)) return inline;
      const filteredTraits = inline.traits.filter((t) => kept.has(t.ref)).map((t) => t.ref === traitName ? { ...t, linkedEntity: t.linkedEntity ?? linkedEntityForTrait } : t);
      return { ...inline, traits: filteredTraits };
    }).filter((page) => {
      if (isPageReference(page)) return true;
      return Array.isArray(page.traits) && page.traits.length > 0;
    });
  }
  return { ...fullSchema, name: `${fullSchema.name}__${orbitalName}__${traitName}__${transitionEvent}`, orbitals: [clonedOrbital] };
}
var SELECTION_STYLES = `
  .orb-preview-live [data-pattern] {
    cursor: pointer;
  }
  .orb-preview-live.drag-active [data-accepts-children="true"] {
    outline: 2px dashed var(--color-primary);
    outline-offset: -2px;
    transition: outline-color 0.15s, background-color 0.15s;
  }
  .orb-preview-live.drag-active [data-accepts-children="true"].drag-hover {
    outline-color: var(--color-primary);
    background-color: color-mix(in srgb, var(--color-primary) 5%, transparent);
  }
  .orb-preview-live .drop-indicator {
    height: 2px;
    background: var(--color-primary);
    border-radius: 1px;
    pointer-events: none;
  }
`;
function absUnion(el) {
  const own = el.getBoundingClientRect();
  if (own.width > 0 || own.height > 0) {
    return { top: own.top, left: own.left, right: own.right, bottom: own.bottom };
  }
  let r = null;
  for (const child of Array.from(el.children)) {
    const box = absUnion(child);
    if (!box) continue;
    r = r ? {
      top: Math.min(r.top, box.top),
      left: Math.min(r.left, box.left),
      right: Math.max(r.right, box.right),
      bottom: Math.max(r.bottom, box.bottom)
    } : box;
  }
  return r;
}
function childPosition(path) {
  const match = /^(.*)\.children\.(\d+)$/.exec(path);
  return match ? { parentPath: match[1], index: Number(match[2]) } : null;
}
function measureLayout(el, container, zoom) {
  if (el.getAttribute("data-accepts-children") !== "true") return null;
  const path = el.getAttribute("data-pattern-path") ?? "root";
  const children = resolveDirectChildren(
    path,
    Array.from(el.querySelectorAll("[data-pattern-path]")).map((child) => ({
      path: child.getAttribute("data-pattern-path") ?? "",
      ref: child
    }))
  );
  const childRects = children.map((child) => rectRelativeTo(child, container, zoom)).filter((r) => r !== null);
  const axis = resolveLayoutAxis(el);
  const style = getComputedStyle(layoutBoxOf(el));
  return { axis, alignment: renderedAlignment(style), spacing: renderedSpacing(style, axis), childRects };
}
function rectRelativeTo(el, container, zoom) {
  const u = absUnion(el);
  if (!u) return null;
  const base = container.getBoundingClientRect();
  const z = zoom > 0 ? zoom : 1;
  return {
    top: (u.top - base.top) / z,
    left: (u.left - base.left) / z,
    width: (u.right - u.left) / z,
    height: (u.bottom - u.top) / z
  };
}
function offsetInParentOf(el, rect, container, zoom) {
  const parent = rect ? parentBoxOf(el, container, zoom) : null;
  return rect && parent ? offsetWithin(rect, parent.box) : void 0;
}
function parentBoxOf(el, container, zoom) {
  const parentPattern = el.parentElement?.closest("[data-pattern-path]");
  if (!parentPattern || !container.contains(parentPattern)) return null;
  const box = layoutBoxOf(parentPattern);
  if (!(box instanceof HTMLElement)) return null;
  const z = zoom > 0 ? zoom : 1;
  const b = box.getBoundingClientRect();
  const base = container.getBoundingClientRect();
  return {
    el: parentPattern,
    box: {
      top: (b.top - base.top) / z + box.clientTop,
      left: (b.left - base.left) / z + box.clientLeft,
      width: box.clientWidth,
      height: box.clientHeight
    }
  };
}
function resolveLayoutAxis(el) {
  return getComputedStyle(layoutBoxOf(el)).flexDirection === "row" ? "horizontal" : "vertical";
}
var OrbPreviewNodeInner = (props) => {
  const data = props.data;
  const screenSize = useContext(ScreenSizeContext);
  const preset = SCREEN_SIZE_PRESETS[screenSize];
  const { select } = useContext(PatternSelectionContext);
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const reactFlow = useReactFlow();
  const cameraMs = usePrefersReducedMotion() ? 0 : 200;
  const contentRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [playing, setPlaying] = useState(false);
  const tools = useContext(CanvasToolsContext);
  const [selectedPaths, setSelectedPaths] = useState([]);
  const [selectedFocuses, setSelectedFocuses] = useState([]);
  const [extraRects, setExtraRects] = useState([]);
  const [marquee, setMarquee] = useState(null);
  const [guides, setGuides] = useState([]);
  const [measures, setMeasures] = useState([]);
  const suppressClickRef = useRef(false);
  const togglePlaying = useCallback((e) => {
    e.stopPropagation();
    setPlaying((p) => !p);
  }, []);
  const handleMouseEnter = useCallback(() => setHovered(true), []);
  const handleMouseLeave = useCallback(() => setHovered(false), []);
  const [selectedRect, setSelectedRect] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedLayout, setSelectedLayout] = useState(null);
  const [selectedScale, setSelectedScale] = useState(void 0);
  const [hoverRect, setHoverRect] = useState(null);
  const lastHoverElRef = useRef(null);
  const role = data.stateRole ?? "default";
  const colors = ROLE_COLORS[role] ?? ROLE_COLORS.default;
  const eventSources = data.eventSources ?? [];
  const layerColor = data.layer ? LAYER_COLORS[data.layer] : void 0;
  const isExpanded = Boolean(data.traitName);
  const status = data.status ?? "idle";
  const isRunning = status === "running";
  const isSuccess = status === "success";
  const isError = status === "error";
  const statePicker = useContext(CanvasStatePickerContext);
  const verify = useContext(CanvasVerifyContext);
  const stateOptions = useMemo(() => {
    if (!statePicker || data.kind === "trait-card") return null;
    const { own, groups } = statePicker.optionsOf(data.orbitalName);
    return {
      options: [{ value: LIVE_STATE, label: t("canvas.liveState") }, ...own.map((o) => ({ value: o.id, label: o.label }))],
      groups: groups.map((g) => ({ label: `${g.alias} \xB7 ${g.behaviorName}`, options: g.options.map((o) => ({ value: o.id, label: o.label })) }))
    };
  }, [statePicker, data.orbitalName, data.kind, t]);
  const shownStep = useMemo(() => {
    if (!verify || !statePicker || data.kind === "trait-card") return null;
    const { own, groups } = statePicker.optionsOf(data.orbitalName);
    const chosen = statePicker.chosen(data.orbitalName);
    const option = [...own, ...groups.flatMap((g) => g.options)].find((o) => o.id === chosen);
    const trait = option?.data.traitName;
    if (!option || !trait) return null;
    return { trait, event: option.data.transitionEvent ?? "", from: option.data.fromState ?? "" };
  }, [verify, statePicker, data.orbitalName, data.kind]);
  const verdict = shownStep ? verify?.verdictOf(data.orbitalName, shownStep.trait) : void 0;
  const verifyPlaying = verify?.playing(data.orbitalName) ?? false;
  const sublabel = data.entityName ?? "";
  const orbitalSchema = useMemo(() => {
    const fullSchema = data._fullSchema;
    if (!fullSchema) return void 0;
    if (isExpanded && data.traitName && data.transitionEvent) {
      return buildTransitionSchema(
        fullSchema,
        data.orbitalName,
        data.traitName,
        data.transitionEvent,
        data.fromState,
        data.toState,
        data._mockData
      );
    }
    return buildOrbitalSchema(fullSchema, data.orbitalName);
  }, [data._fullSchema, data._mockData, data.orbitalName, data.traitName, data.transitionEvent, data.fromState, data.toState, isExpanded]);
  const focusOfElement = useCallback((el) => {
    const derived = deriveEditFocusFromElement(el);
    return derived ? withNodeTransition(derived, data) : null;
  }, [data]);
  const selectPatternElement = useCallback((patternEl, selection) => {
    const container = contentRef.current;
    container?.querySelectorAll(".pattern-selected").forEach((el) => {
      el.classList.remove("pattern-selected");
    });
    const zoom = reactFlow.getViewport().zoom;
    if (patternEl && container) {
      patternEl.classList.add("pattern-selected");
      const rect = rectRelativeTo(patternEl, container, zoom);
      setSelectedRect(rect);
      setSelectedLayout(measureLayout(patternEl, container, zoom));
      setSelectedScale(() => spacingScaleOf(layoutBoxOf(patternEl)));
      const primaryPath = patternEl.getAttribute("data-pattern-path") ?? "root";
      const focus = focusOfElement(patternEl);
      setSelectedAddress({
        patternId: primaryPath,
        patternType: patternEl.getAttribute("data-pattern") ?? "unknown",
        focus
      });
      const selectedEls = selection ?? [patternEl];
      const paths = selectedEls.map((el) => el.getAttribute("data-pattern-path") ?? "root");
      const elements = selectedEls.flatMap((el) => {
        const f3 = focusOfElement(el);
        return f3 ? [f3] : [];
      });
      setSelectedPaths(paths);
      setSelectedFocuses(elements);
      setExtraRects(selectedEls.filter((el) => el !== patternEl).flatMap((el) => {
        const r = rectRelativeTo(el, container, zoom);
        return r ? [r] : [];
      }));
      select({
        patternType: patternEl.getAttribute("data-pattern") ?? "unknown",
        // `data-pattern-path` is the SExpr tree path (`children.0.…`) emitted by
        // UISlotRenderer; `data-id` is the runtime content id. `OrbInspector`
        // resolves pattern config by walking the render-ui SExpr tree, so the
        // path is the correct key — reading `data-id` silently broke prop
        // resolution and rendered every value as '—'.
        patternId: patternEl.getAttribute("data-pattern-path") ?? void 0,
        sourceTrait: patternEl.getAttribute("data-source-trait") ?? void 0,
        nodeData: data,
        rect: rect ?? void 0,
        offsetInParent: offsetInParentOf(patternEl, rect, container, zoom),
        selection: paths,
        elements,
        ...focus ? { focus } : {}
      });
      if (focus) {
        eventBus.emit("UI:ELEMENT_SELECTED", {
          focus: { ...focus }
        });
      }
    } else {
      setSelectedRect(null);
      setSelectedLayout(null);
      setSelectedScale(void 0);
      setSelectedAddress(null);
      setSelectedPaths([]);
      setSelectedFocuses([]);
      setExtraRects([]);
      select(null);
      eventBus.emit("UI:ELEMENT_SELECTED", { focus: null });
    }
  }, [focusOfElement, select, eventBus, reactFlow]);
  const pickElement = useCallback((el, additive) => {
    const picked = el ? focusOfElement(el) : null;
    if (!el || !picked || !additive || !hasCanvasTool(tools, "multiSelect") || selectedFocuses.length === 0) {
      selectPatternElement(el);
      return;
    }
    const container = contentRef.current;
    const current = selectedFocuses.flatMap((f3) => {
      const e = f3.path ? elementIn(container, f3.path, f3.trait) : null;
      return e ? [e] : [];
    });
    if (selectedFocuses.some((f3) => sameElement(f3, picked))) {
      const rest = current.filter((e) => {
        const f3 = focusOfElement(e);
        return !f3 || !sameElement(f3, picked);
      });
      selectPatternElement(rest[rest.length - 1] ?? null, rest.length > 0 ? rest : void 0);
      return;
    }
    selectPatternElement(el, [...current, el]);
  }, [tools, selectedFocuses, selectPatternElement, focusOfElement]);
  const handleContentClick = useCallback((e) => {
    e.stopPropagation();
    const target = e.target;
    pickElement(target.closest("[data-pattern]"), e.shiftKey);
  }, [pickElement]);
  const selectedTrait = selectedAddress?.focus?.trait;
  const patternElementAt = useCallback(
    (path) => elementIn(contentRef.current, path, selectedTrait),
    [selectedTrait]
  );
  const handlePausedClickCapture = useCallback((e) => {
    if (e.target instanceof Element && e.target.closest("[data-design-overlay]")) return;
    if (isEditableTarget(e.target)) return;
    if (suppressClickRef.current) {
      suppressClickRef.current = false;
      e.preventDefault();
      return;
    }
    handleContentClick(e);
    e.preventDefault();
    contentRef.current?.focus({ preventScroll: true });
  }, [handleContentClick]);
  const swallowWhilePaused = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  const handlePausedKeyDown = useCallback((e) => {
    if (e.target instanceof Element && e.target.closest("[data-design-overlay]")) return;
    if (isEditableTarget(e.target)) return;
    const path = selectedAddress?.patternId;
    const position = path ? childPosition(path) : null;
    const handled = () => {
      e.preventDefault();
      e.stopPropagation();
    };
    if (e.key === "Delete" || e.key === "Backspace") {
      e.preventDefault();
      return;
    }
    if ((e.metaKey || e.ctrlKey) && ["c", "x", "v"].includes(e.key.toLowerCase())) return;
    if (e.shiftKey && (e.code === "Digit1" || e.code === "Digit2") && hasCanvasTool(tools, "zoomToSelection")) {
      handled();
      if (e.code === "Digit1") {
        void reactFlow.fitView({ padding: 0.1, duration: cameraMs });
        return;
      }
      const container = contentRef.current;
      const targets = selectedFocuses.length > 0 ? selectedFocuses : selectedAddress?.focus ? [selectedAddress.focus] : [];
      const paths = targets.flatMap((f3) => f3.path ? [f3.path] : []);
      const boxes = targets.flatMap((f3) => {
        const el = f3.path ? elementIn(container, f3.path, f3.trait) : null;
        const box = el ? absUnion(el) : null;
        return box ? [box] : [];
      });
      if (boxes.length === 0) return;
      const topLeft = reactFlow.screenToFlowPosition({ x: Math.min(...boxes.map((b) => b.left)), y: Math.min(...boxes.map((b) => b.top)) });
      const bottomRight = reactFlow.screenToFlowPosition({ x: Math.max(...boxes.map((b) => b.right)), y: Math.max(...boxes.map((b) => b.bottom)) });
      orbPreviewLog.info("zoom-to-selection", { paths, boxes, topLeft, bottomRight });
      void reactFlow.fitBounds(
        { x: topLeft.x, y: topLeft.y, width: bottomRight.x - topLeft.x, height: bottomRight.y - topLeft.y },
        { padding: 0.2, duration: cameraMs }
      );
      return;
    }
    if (e.key === "Escape" || e.key === "Enter" && e.shiftKey) {
      if (!path) return;
      handled();
      selectPatternElement(position ? patternElementAt(position.parentPath) : null);
      return;
    }
    if (e.key === "Enter") {
      handled();
      const child = path ? patternElementAt(`${path}.children.0`) : null;
      if (child) selectPatternElement(child);
      return;
    }
    const focuses = selectedFocuses.length > 0 ? selectedFocuses : selectedAddress?.focus ? [selectedAddress.focus] : [];
    const addresses = focuses.map(elementAddressOf);
    const elements = focuses.length > 0 && addresses.every((a) => a !== null) ? addresses : null;
    const embedded = elements !== null && elements.some((a) => a.trait !== data.traitName);
    const duplicate = (e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "d";
    const wrap = e.shiftKey && !e.metaKey && !e.ctrlKey && e.key.toLowerCase() === "a";
    if (duplicate || wrap) {
      handled();
      if (embedded && elements) {
        eventBus.emit("UI:STRUCTURE_EDIT", { op: duplicate ? "duplicate" : "wrap", elements });
        return;
      }
      if (!path || !position || !selectedAddress || !data.traitName || !data.transitionEvent) return;
      const loc = { orbitalName: data.orbitalName, traitName: data.traitName, transitionEvent: data.transitionEvent };
      const paths = selectedPaths.length > 0 ? selectedPaths : [path];
      const withElements = elements ? { elements } : {};
      if (duplicate) {
        eventBus.emit("UI:PATTERN_DUPLICATE", { paths, loc, ...withElements });
        if (paths.length > 1) {
          selectPatternElement(null);
          return;
        }
        const copy = `${position.parentPath}.children.${position.index + 1}`;
        const copyFocus = selectedAddress.focus && { ...selectedAddress.focus, path: copy };
        setSelectedAddress({ patternId: copy, patternType: selectedAddress.patternType, focus: copyFocus });
        setSelectedPaths([copy]);
        setSelectedFocuses(copyFocus ? [copyFocus] : []);
      } else {
        eventBus.emit("UI:PATTERN_WRAP", { paths, loc, ...withElements });
        const first = [...paths].sort((a, b) => (childPosition(a)?.index ?? 0) - (childPosition(b)?.index ?? 0))[0];
        const wrapperFocus = selectedAddress.focus && { ...selectedAddress.focus, path: first, patternType: "stack" };
        setSelectedAddress({ patternId: first, patternType: "stack", focus: wrapperFocus });
        setSelectedPaths([first]);
        setSelectedFocuses(wrapperFocus ? [wrapperFocus] : []);
        setExtraRects([]);
      }
      return;
    }
    const step = e.key === "ArrowUp" || e.key === "ArrowLeft" ? -1 : e.key === "ArrowDown" || e.key === "ArrowRight" ? 1 : 0;
    handled();
    if (step === 0) return;
    if (embedded && elements) {
      if (elements.length === 1) eventBus.emit("UI:STRUCTURE_EDIT", { op: "move", elements, by: step });
      return;
    }
    if (!path || !position || !selectedAddress || !data.traitName || !data.transitionEvent) return;
    const target = position.index + step;
    if (target < 0 || !patternElementAt(`${position.parentPath}.children.${target}`)) return;
    eventBus.emit("UI:PATTERN_MOVE", {
      fromPath: path,
      loc: { orbitalName: data.orbitalName, traitName: data.traitName, transitionEvent: data.transitionEvent },
      toParentPath: position.parentPath,
      // PATTERN_MOVE inserts before `toIndex` in the pre-move list.
      toIndex: step > 0 ? target + 1 : target,
      ...elements ? { elements } : {}
    });
    const moved = `${position.parentPath}.children.${target}`;
    const movedFocus = selectedAddress.focus && { ...selectedAddress.focus, path: moved };
    setSelectedAddress({ patternId: moved, patternType: selectedAddress.patternType, focus: movedFocus });
    setSelectedPaths([moved]);
    setSelectedFocuses(movedFocus ? [movedFocus] : []);
    setExtraRects([]);
  }, [selectedAddress, selectedPaths, selectedFocuses, eventBus, patternElementAt, selectPatternElement, data.orbitalName, data.traitName, data.transitionEvent, tools, reactFlow]);
  const clipboardPaths = useCallback(() => {
    const paths = selectedPaths.length > 0 ? selectedPaths : selectedAddress ? [selectedAddress.patternId] : [];
    return paths.filter((p) => p !== "root");
  }, [selectedPaths, selectedAddress]);
  const copySelection = useCallback((e) => {
    const fullSchema = data._fullSchema;
    const paths = clipboardPaths();
    if (!fullSchema || !data.traitName || !data.transitionEvent || paths.length === 0) return [];
    const nodes = paths.flatMap((path) => {
      const node = patternNodeAt(fullSchema, data.orbitalName, data.traitName ?? "", data.transitionEvent ?? "", path);
      return node ? [node] : [];
    });
    if (nodes.length === 0) return [];
    e.preventDefault();
    e.clipboardData.setData(PATTERN_CLIPBOARD_TYPE, JSON.stringify(nodes));
    e.clipboardData.setData("text/plain", JSON.stringify({ "almadar/patterns": nodes }));
    return paths;
  }, [data._fullSchema, data.orbitalName, data.traitName, data.transitionEvent, clipboardPaths]);
  const handleInlineText = useInlineTextEdit({
    schema: data._fullSchema,
    enabled: !playing && isExpanded && hasCanvasTool(tools, "inlineText"),
    node: data
  });
  const handleCopy = useCallback((e) => {
    if (!hasCanvasTool(tools, "clipboard") || isEditableTarget(e.target)) return;
    copySelection(e);
  }, [tools, copySelection]);
  const handleCut = useCallback((e) => {
    if (!hasCanvasTool(tools, "clipboard") || isEditableTarget(e.target)) return;
    const paths = copySelection(e);
    if (paths.length === 0) return;
    const elements = selectedFocuses.flatMap((f3) => {
      const a = f3.path && paths.includes(f3.path) ? elementAddressOf(f3) : null;
      return a ? [a] : [];
    });
    eventBus.emit("UI:DELETE_PATTERN", { patternIds: paths, ...elements.length === paths.length ? { elements } : {} });
    selectPatternElement(null);
  }, [tools, copySelection, selectedFocuses, eventBus, selectPatternElement]);
  const handlePaste = useCallback((e) => {
    if (!hasCanvasTool(tools, "clipboard") || isEditableTarget(e.target)) return;
    if (!data.traitName || !data.transitionEvent) return;
    const patterns = parseClipboardPatterns(e.clipboardData.getData(PATTERN_CLIPBOARD_TYPE)) ?? parseClipboardPatterns(e.clipboardData.getData("text/plain"));
    if (!patterns) return;
    e.preventDefault();
    const container = contentRef.current;
    const childCount = (path) => resolveDirectChildren(
      path,
      Array.from(container?.querySelectorAll("[data-pattern-path]") ?? []).map((el) => ({ path: el.getAttribute("data-pattern-path") ?? "", ref: el }))
    ).length;
    const primary = selectedAddress?.patternId;
    const primaryEl = primary ? patternElementAt(primary) : null;
    const position = primary ? childPosition(primary) : null;
    const target = primary && primaryEl?.getAttribute("data-accepts-children") === "true" ? { parentPath: primary, index: childCount(primary) } : position ? { parentPath: position.parentPath, index: position.index + 1 } : { parentPath: "root", index: childCount("root") };
    eventBus.emit("UI:PATTERN_PASTE", {
      loc: { orbitalName: data.orbitalName, traitName: data.traitName, transitionEvent: data.transitionEvent },
      ...target,
      patternsJson: JSON.stringify(patterns)
    });
  }, [tools, data.orbitalName, data.traitName, data.transitionEvent, selectedAddress, patternElementAt, eventBus]);
  const measureFromSelection = useCallback((hovered2) => {
    const container = contentRef.current;
    const selectedEl = selectedAddress ? patternElementAt(selectedAddress.patternId) : null;
    if (!hovered2 || !container || !selectedEl || !selectedRect || playing || !hasCanvasTool(tools, "measure")) {
      setMeasures((prev) => prev.length === 0 ? prev : []);
      return;
    }
    const zoom = reactFlow.getViewport().zoom;
    const other = hovered2 === selectedEl ? parentBoxOf(selectedEl, container, zoom)?.box ?? null : rectRelativeTo(hovered2, container, zoom);
    setMeasures(other ? distanceLines(selectedRect, other) : []);
  }, [selectedAddress, selectedRect, playing, tools, reactFlow, patternElementAt]);
  useEffect(() => {
    if (measures.length === 0) return;
    const up = (e) => {
      if (e.key === "Alt") setMeasures([]);
    };
    window.addEventListener("keyup", up);
    return () => window.removeEventListener("keyup", up);
  }, [measures.length]);
  const handleContentMouseMove = useCallback((e) => {
    const container = contentRef.current;
    if (!container) return;
    const el = e.target.closest("[data-pattern]");
    measureFromSelection(e.altKey ? el : null);
    if (el === lastHoverElRef.current) return;
    lastHoverElRef.current = el;
    setHoverRect(el ? rectRelativeTo(el, container, reactFlow.getViewport().zoom) : null);
  }, [reactFlow, measureFromSelection]);
  const handleContentMouseLeave = useCallback(() => {
    lastHoverElRef.current = null;
    setHoverRect(null);
    setMeasures([]);
  }, []);
  const selectedAddressRef = useRef(selectedAddress);
  selectedAddressRef.current = selectedAddress;
  useEffect(() => {
    setSelectedRect(null);
    setHoverRect(null);
    lastHoverElRef.current = null;
    const address = selectedAddressRef.current;
    if (!address) return;
    const frame = requestAnimationFrame(() => {
      const container = contentRef.current;
      const el = elementIn(container, address.patternId, address.focus?.trait);
      if (container && el) {
        const zoom = reactFlow.getViewport().zoom;
        setSelectedRect(rectRelativeTo(el, container, zoom));
        setSelectedLayout(measureLayout(el, container, zoom));
        setSelectedScale(() => spacingScaleOf(layoutBoxOf(el)));
      }
    });
    return () => cancelAnimationFrame(frame);
  }, [orbitalSchema, reactFlow]);
  const selectedClasses = useMemo(() => {
    const fullSchema = data._fullSchema;
    const focus = selectedAddress?.focus;
    if (!selectedAddress || !fullSchema || !focus?.trait || !focus.transition) return null;
    const config = resolvePatternConfig(fullSchema, {
      orbitalName: focus.orbital,
      traitName: focus.trait,
      transitionEvent: focus.transition,
      patternId: selectedAddress.patternId,
      patternType: selectedAddress.patternType
    });
    const current = config?.className;
    if (current === void 0 || current === null) return [];
    return typeof current === "string" ? current.split(/\s+/).filter(Boolean) : null;
  }, [data, selectedAddress]);
  const editAccess = useContext(ElementEditAccessContext);
  const selectedFocus = selectedAddress?.focus ?? null;
  const classesEditable = propAccessAt(editAccess, selectedFocus, "className").editable;
  const selectedPartOf = editAccess && selectedFocus ? editAccess(selectedFocus).partOf : void 0;
  const handleClassesChange = useCallback((next) => {
    const focus = selectedAddress?.focus;
    if (!selectedAddress || !focus?.trait || !focus.transition) return;
    eventBus.emit("UI:PROP_CHANGE", {
      scope: "local",
      propName: "className",
      value: next.join(" "),
      selection: {
        patternPath: selectedAddress.patternId,
        orbitalName: focus.orbital,
        traitName: focus.trait,
        transitionEvent: focus.transition,
        ...focus.slot ? { slot: focus.slot } : {}
      }
    });
  }, [selectedAddress, eventBus]);
  const [dragActive, setDragActive] = useState(false);
  useEffect(() => {
    const unsub1 = eventBus.on("UI:DRAG_START", (e) => {
      const kind = e.payload?.kind;
      if (kind === "pattern") setDragActive(true);
    });
    const unsub2 = eventBus.on("UI:DRAG_END", () => setDragActive(false));
    return () => {
      unsub1();
      unsub2();
    };
  }, [eventBus]);
  const [reorderDragActive, setReorderDragActive] = useState(false);
  useEffect(() => {
    const unsub1 = eventBus.on("UI:DRAG_START", (e) => {
      if (e.payload?.kind === "pattern-instance") setReorderDragActive(true);
    });
    const unsub2 = eventBus.on("UI:DRAG_END", () => setReorderDragActive(false));
    return () => {
      unsub1();
      unsub2();
    };
  }, [eventBus]);
  const resolveInsertion = useCallback(
    (cursor) => {
      const hit = renderedElementAt(contentRef.current, cursor);
      if (!hit) return null;
      let el = hit;
      while (el && el.dataset.acceptsChildren !== "true") {
        if (el === contentRef.current) break;
        el = el.parentElement;
      }
      if (!el) return null;
      const containerPath = el.dataset?.patternPath ?? "root";
      if (!el.dataset?.patternPath) {
        const rootEl = el.querySelector('[data-pattern-path="root"]');
        if (rootEl instanceof HTMLElement) el = rootEl;
      }
      const directChildren = directPatternChildren(el);
      const childRects = directChildren.map((child) => {
        const u = absUnion(child);
        if (u) return { ...u, width: u.right - u.left, height: u.bottom - u.top };
        const raw = child.getBoundingClientRect();
        return { top: raw.top, left: raw.left, right: raw.right, bottom: raw.bottom, width: raw.width, height: raw.height };
      });
      const axis = resolveLayoutAxis(el);
      const insertIndex = computeInsertionIndex(childRects, cursor, axis);
      orbPreviewLog.debug("resolveL2Path", {
        containerPath,
        childCount: childRects.length,
        axis,
        cursorY: cursor.y,
        mids: childRects.map((r) => axis === "vertical" ? r.top + r.height / 2 : r.left + r.width / 2),
        insertIndex
      });
      const own = absUnion(el);
      const containerBox = own ? { ...own, width: own.right - own.left, height: own.bottom - own.top } : (() => {
        const raw = el.getBoundingClientRect();
        return { top: raw.top, left: raw.left, right: raw.right, bottom: raw.bottom, width: raw.width, height: raw.height };
      })();
      const focus = focusOfElement(el);
      const container = focus ? elementAddressOf(focus) : null;
      return { parentPath: containerPath, index: insertIndex, container, containerBox, childRects, axis };
    },
    [focusOfElement]
  );
  const resolveL2Path = useCallback(
    (cursor) => {
      const hit = resolveInsertion(cursor);
      return hit ? { parentPath: hit.parentPath, index: hit.index, ...hit.container ? { container: hit.container } : {} } : null;
    },
    [resolveInsertion]
  );
  const [insertionLine, setInsertionLine] = useState(null);
  const trackInsertion = useCallback((e) => {
    if (!(dragActive || reorderDragActive) || !isExpanded) return;
    const content = contentRef.current;
    const hit = resolveInsertion({ x: e.clientX, y: e.clientY });
    if (!content || !hit) {
      setInsertionLine(null);
      return;
    }
    const base = content.getBoundingClientRect();
    const z = reactFlow.getViewport().zoom || 1;
    const toContent = (r) => ({
      top: (r.top - base.top) / z,
      left: (r.left - base.left) / z,
      width: r.width / z,
      height: r.height / z
    });
    setInsertionLine(insertionLineRect(toContent(hit.containerBox), hit.childRects.map(toContent), hit.index, hit.axis));
  }, [dragActive, reorderDragActive, isExpanded, resolveInsertion, reactFlow]);
  useEffect(() => {
    if (!dragActive && !reorderDragActive) setInsertionLine(null);
  }, [dragActive, reorderDragActive]);
  const l2Target = useMemo(
    () => ({
      level: "l2",
      containerNode: {
        orbitalName: data.orbitalName,
        traitName: data.traitName,
        transitionEvent: data.transitionEvent
      },
      resolvePath: resolveL2Path
    }),
    [data.orbitalName, data.traitName, data.transitionEvent, resolveL2Path]
  );
  const { setNodeRef: l2SetNodeRef, isOver: l2IsOver } = useCanvasDroppable({
    // Keyed by the card, not its trait/transition: several screen cards can share those.
    id: `orb-l2-${props.id}`,
    target: l2Target,
    accepts: ["pattern", "pattern-instance", "behavior"],
    disabled: !isExpanded
  });
  const reorderDataRef = useRef({ fromPath: "", loc: {} });
  const {
    setNodeRef: reorderSetNodeRef,
    listeners: reorderListeners
  } = useCanvasDraggable({
    id: `orb-l2-reorder-${props.id}`,
    payload: { kind: "pattern-instance", data: reorderDataRef.current },
    disabled: !isExpanded
  });
  const startMarquee = useCallback((e) => {
    const container = contentRef.current;
    if (!container) return;
    const zoom = reactFlow.getViewport().zoom || 1;
    const toContent = (clientX, clientY) => {
      const base = container.getBoundingClientRect();
      return { x: (clientX - base.left) / zoom, y: (clientY - base.top) / zoom };
    };
    const from = toContent(e.clientX, e.clientY);
    let box = null;
    const move = (ev) => {
      const to = toContent(ev.clientX, ev.clientY);
      if (!box && Math.hypot(to.x - from.x, to.y - from.y) < 3) return;
      box = marqueeRect(from, to);
      setMarquee(box);
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      setMarquee(null);
      if (!box) return;
      const children = resolveDirectChildren(
        "root",
        Array.from(container.querySelectorAll("[data-pattern-path]")).map((el) => ({ path: el.getAttribute("data-pattern-path") ?? "", ref: el }))
      );
      const rects = children.map((el) => rectRelativeTo(el, container, zoom));
      const hits = marqueeHits(box, rects.map((r) => r ?? { top: 0, left: 0, width: 0, height: 0 })).filter((i) => rects[i] !== null).map((i) => children[i]);
      suppressClickRef.current = true;
      const selected = hits.filter((el) => el instanceof HTMLElement && el.hasAttribute("data-pattern-path"));
      const primary = selected[selected.length - 1];
      selectPatternElement(primary ?? null, selected.length > 0 ? selected : void 0);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  }, [reactFlow, selectPatternElement]);
  const startAbsoluteMove = useCallback((e, el, classes) => {
    const container = contentRef.current;
    const zoom = reactFlow.getViewport().zoom || 1;
    const start = container ? rectRelativeTo(el, container, zoom) : null;
    const parent = container ? parentBoxOf(el, container, zoom) : null;
    if (!container || !start || !parent) return;
    const parentPath = parent.el.getAttribute("data-pattern-path") ?? "root";
    const siblings = resolveDirectChildren(
      parentPath,
      Array.from(parent.el.querySelectorAll("[data-pattern-path]")).map((c) => ({ path: c.getAttribute("data-pattern-path") ?? "", ref: c }))
    ).filter((c) => c !== el).map((c) => rectRelativeTo(c, container, zoom)).filter((r) => r !== null);
    const targets = [...siblings, parent.box];
    const moved = layoutBoxOf(el);
    const painted = moved instanceof HTMLElement ? moved : null;
    const before = painted?.style.translate ?? "";
    let current = start;
    let dragging = false;
    const move = (ev) => {
      const dx = (ev.clientX - e.clientX) / zoom;
      const dy = (ev.clientY - e.clientY) / zoom;
      if (!dragging && Math.hypot(ev.clientX - e.clientX, ev.clientY - e.clientY) < 3) return;
      dragging = true;
      const raw = { ...start, left: start.left + dx, top: start.top + dy };
      const snap = snapMove(raw, targets, 4 / zoom);
      current = { ...raw, left: raw.left + snap.dx, top: raw.top + snap.dy };
      if (painted) painted.style.translate = `${current.left - start.left}px ${current.top - start.top}px`;
      setGuides(snap.guides);
      setSelectedRect(current);
    };
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      setGuides([]);
      if (!dragging) return;
      if (painted) painted.style.translate = before;
      suppressClickRef.current = true;
      const position = positionOf(classes);
      const offset = offsetWithin(current, parent.box);
      handleClassesChange(withPosition(classes, {
        absolute: true,
        x: axisPositionFrom("x", position.x.constraint, offset),
        y: axisPositionFrom("y", position.y.constraint, offset)
      }));
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  }, [reactFlow, handleClassesChange]);
  const handleContentPointerDown = useCallback((e) => {
    const patternEl = e.target.closest("[data-pattern]");
    const fromPath = patternEl?.getAttribute("data-pattern-path");
    const selectedEl = selectedAddress ? patternElementAt(selectedAddress.patternId) : null;
    if (!playing && isExpanded && e.button === 0 && hasCanvasTool(tools, "absolute") && selectedEl && selectedClasses?.includes("absolute") && e.target instanceof Node && selectedEl.contains(e.target) && !(e.target instanceof Element && e.target.closest("[data-design-overlay]"))) {
      startAbsoluteMove(e, selectedEl, selectedClasses);
      return;
    }
    if (!playing && isExpanded && hasCanvasTool(tools, "multiSelect") && (fromPath === "root" || !fromPath) && !(e.target instanceof Element && e.target.closest("[data-design-overlay]"))) {
      startMarquee(e);
      return;
    }
    if (!fromPath) return;
    reorderDataRef.current.fromPath = fromPath;
    reorderDataRef.current.loc = {
      orbitalName: data.orbitalName,
      traitName: data.traitName,
      transitionEvent: data.transitionEvent
    };
    reorderListeners?.onPointerDown?.(e);
  }, [reorderListeners, data.orbitalName, data.traitName, data.transitionEvent, playing, isExpanded, tools, startMarquee, selectedAddress, selectedClasses, patternElementAt, startAbsoluteMove]);
  const setContentRef = useCallback((el) => {
    contentRef.current = el;
    l2SetNodeRef(el);
    reorderSetNodeRef(el);
  }, [l2SetNodeRef, reorderSetNodeRef]);
  const statusBorder = isRunning ? "var(--color-primary)" : isError ? "var(--color-danger)" : isSuccess ? "var(--color-success)" : null;
  const borderWidth = isRunning || isError || isSuccess || data.focused ? "2px" : "1.5px";
  const borderColor = statusBorder ?? (hovered || data.focused ? "var(--color-primary)" : colors.border);
  const l1Target = useMemo(
    () => ({ level: "l1", containerNode: { orbitalName: data.orbitalName } }),
    [data.orbitalName]
  );
  const { setNodeRef: l1SetNodeRef, isOver: l1IsOver } = useCanvasDroppable({
    id: `orb-l1-${data.orbitalName}`,
    target: l1Target,
    accepts: ["pattern"],
    disabled: isExpanded
  });
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: isExpanded ? void 0 : l1SetNodeRef,
      className: `@container/preview rounded-lg border shadow-sm bg-card transition-all duration-200 overflow-hidden relative${isRunning ? " orb-preview-running" : ""}`,
      style: {
        borderColor: l1IsOver ? "var(--color-primary)" : borderColor,
        borderWidth: l1IsOver ? "2px" : borderWidth,
        width: typeof data.cardWidth === "number" ? data.cardWidth : preset.width,
        boxShadow: l1IsOver ? "0 0 0 3px var(--color-primary), 0 0 12px var(--color-primary)" : void 0
      },
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      children: [
        /* @__PURE__ */ jsx("style", { children: SELECTION_STYLES }),
        !isExpanded && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute top-1.5 right-1.5 rounded px-1 py-[1px] text-xs font-mono uppercase tracking-wider pointer-events-none",
              style: {
                backgroundColor: "var(--color-muted)",
                color: "var(--color-muted-foreground)",
                zIndex: 3
              },
              children: t("orbPreview.previewBadge")
            }
          ),
          hovered && !dragActive && !l1IsOver && /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute inset-0 flex items-center justify-center pointer-events-none",
              style: {
                backgroundColor: avlTint("var(--color-foreground)", 4),
                zIndex: 2
              },
              children: /* @__PURE__ */ jsxs(
                Box,
                {
                  className: "rounded-md px-2 py-1 text-xs font-medium flex items-center gap-1",
                  style: {
                    backgroundColor: "var(--color-card)",
                    color: "var(--color-foreground)",
                    boxShadow: "var(--shadow-main)"
                  },
                  children: [
                    /* @__PURE__ */ jsx("span", { style: { fontSize: 12 }, children: "\u279E" }),
                    t("orbPreview.doubleClickToOpen")
                  ]
                }
              )
            }
          ),
          (dragActive || l1IsOver) && /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute inset-0 flex items-center justify-center pointer-events-none",
              style: {
                backgroundColor: l1IsOver ? avlTint("var(--color-primary)", 15) : avlTint("var(--color-primary)", 6),
                zIndex: 2
              },
              children: /* @__PURE__ */ jsx(
                Box,
                {
                  className: "rounded-md px-2 py-1 text-xs font-semibold",
                  style: {
                    backgroundColor: "var(--color-primary)",
                    color: "var(--color-primary-foreground)",
                    boxShadow: "var(--shadow-lg)"
                  },
                  children: t("orbPreview.dropToAddAndOpen")
                }
              )
            }
          )
        ] }),
        isRunning && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("style", { children: `
            @keyframes orb-preview-running-pulse {
              0%, 100% { box-shadow: 0 0 0 0 var(--color-primary); opacity: 0.6; }
              50%      { box-shadow: 0 0 0 4px var(--color-primary); opacity: 0.15; }
            }
            .orb-preview-running {
              animation: orb-preview-running-pulse 1.8s ease-in-out infinite;
            }
            @keyframes orb-preview-spinner {
              from { transform: rotate(0deg); }
              to   { transform: rotate(360deg); }
            }
            .orb-preview-spinner {
              animation: orb-preview-spinner 0.9s linear infinite;
            }
          ` }),
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "orb-preview-spinner absolute top-2 right-2 rounded-full pointer-events-none",
              style: {
                width: 14,
                height: 14,
                border: "2px solid var(--color-primary)",
                borderTopColor: "transparent",
                zIndex: 2
              },
              title: t("orbPreview.dispatching")
            }
          )
        ] }),
        isError && /* @__PURE__ */ jsx(
          Box,
          {
            "data-testid": "orb-preview-error-badge",
            className: "absolute top-2 right-2 flex items-center justify-center rounded-full pointer-events-none",
            style: { width: 18, height: 18, background: "var(--color-error)", color: "var(--color-background)", zIndex: 2 },
            title: t("orbPreview.hasProblems"),
            children: /* @__PURE__ */ jsx(Icon, { name: "alert-triangle", size: "xs" })
          }
        ),
        layerColor && /* @__PURE__ */ jsx(
          Box,
          {
            style: { height: 3, backgroundColor: layerColor },
            title: data.layer && LAYER_LABEL_KEYS[data.layer] ? t(LAYER_LABEL_KEYS[data.layer]) : data.layer
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 px-3 py-1.5 border-b border-border/40 drag-handle cursor-grab", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "rounded-full shrink-0",
              style: { width: 8, height: 8, backgroundColor: colors.dot }
            }
          ),
          /* @__PURE__ */ jsxs(Box, { className: "flex flex-col min-w-0 flex-1", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold truncate leading-tight", children: data.orbitalName }),
            sublabel && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground truncate text-xs leading-tight", children: sublabel })
          ] }),
          stateOptions && statePicker && /* @__PURE__ */ jsx(Box, { className: "nodrag shrink-0 max-w-[55%]", onClick: (e) => e.stopPropagation(), children: /* @__PURE__ */ jsx(
            Select,
            {
              options: stateOptions.options,
              groups: stateOptions.groups,
              value: statePicker.chosen(data.orbitalName),
              onValueChange: (value) => {
                if (typeof value === "string") statePicker.choose(data.orbitalName, value);
              },
              "aria-label": t("canvas.stateOf", { orbital: data.orbitalName }),
              "data-testid": `canvas-state-${data.orbitalName}`,
              className: "h-7 py-0 text-xs"
            }
          ) }),
          shownStep && /* @__PURE__ */ jsxs(Box, { className: "nodrag flex shrink-0 items-center gap-0.5", onClick: (e) => e.stopPropagation(), children: [
            verdict && /* @__PURE__ */ jsx(
              Badge,
              {
                variant: VERDICT_VARIANT[verdict.status],
                size: "sm",
                "data-testid": `card-verdict-${data.orbitalName}`,
                "data-status": verdict.status,
                title: verdict.detail,
                children: t(`canvas.verdict.${verdict.status}`)
              }
            ),
            /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: "check-circle",
                label: t("canvas.verifyTransition"),
                tooltipPosition: "top",
                className: "w-6 h-6",
                "data-testid": `card-verify-transition-${data.orbitalName}`,
                onClick: () => eventBus.emit("UI:CARD_VERIFY_STEP", { orbital: data.orbitalName, trait: shownStep.trait, from: shownStep.from, event: shownStep.event, payload: {} })
              }
            ),
            verifyPlaying ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(IconButton, { icon: "pause", label: t("canvas.verifyPause"), tooltipPosition: "top", className: "w-6 h-6", "data-testid": `card-verify-pause-${data.orbitalName}`, onClick: () => eventBus.emit("UI:CARD_VERIFY_PAUSE", { orbital: data.orbitalName, trait: shownStep.trait }) }),
              /* @__PURE__ */ jsx(IconButton, { icon: "square", label: t("canvas.verifyStop"), tooltipPosition: "top", className: "w-6 h-6", "data-testid": `card-verify-stop-${data.orbitalName}`, onClick: () => eventBus.emit("UI:CARD_VERIFY_STOP", { orbital: data.orbitalName, trait: shownStep.trait }) })
            ] }) : /* @__PURE__ */ jsx(
              IconButton,
              {
                icon: "list-checks",
                label: t("canvas.verifyTrait"),
                tooltipPosition: "top",
                className: "w-6 h-6",
                "data-testid": `card-verify-trait-${data.orbitalName}`,
                onClick: () => eventBus.emit("UI:CARD_VERIFY_TRAIT", { orbital: data.orbitalName, trait: shownStep.trait })
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            IconButton,
            {
              icon: playing ? "pause" : "play",
              label: t(playing ? "orbPreview.pause" : "orbPreview.play"),
              tooltipPosition: "top",
              className: "nodrag shrink-0 w-6 h-6",
              "aria-pressed": playing,
              "data-testid": "orb-preview-play-toggle",
              onClick: togglePlaying
            }
          ),
          eventSources.length > 0 && /* @__PURE__ */ jsx(Box, { className: "flex gap-0.5 shrink-0", children: eventSources.slice(0, 3).map((src) => /* @__PURE__ */ jsx(
            Box,
            {
              className: "rounded-full px-1 py-0 text-xs font-medium leading-tight",
              style: {
                backgroundColor: avlTint(CONNECTION_COLORS.emitListen.color, 8),
                color: CONNECTION_COLORS.emitListen.color,
                border: `1px solid ${avlTint(CONNECTION_COLORS.emitListen.color, 19)}`
              },
              title: `${src.label ?? src.patternType} \u2192 ${src.event}${src.payloadFields?.length ? ` ${formatPayloadTooltip(src.payloadFields)}` : ""}`,
              children: src.label ?? src.event
            },
            src.event
          )) })
        ] }),
        /* @__PURE__ */ jsxs(
          Box,
          {
            ref: setContentRef,
            className: `orb-preview-live nodrag nopan relative outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset${dragActive || reorderDragActive || l2IsOver ? " drag-active" : ""}`,
            "data-playing": playing,
            onClick: playing ? handleContentClick : void 0,
            onClickCapture: playing ? void 0 : handlePausedClickCapture,
            onKeyDownCapture: playing ? void 0 : handlePausedKeyDown,
            tabIndex: playing ? void 0 : -1,
            onSubmitCapture: playing ? void 0 : swallowWhilePaused,
            onDoubleClickCapture: playing ? void 0 : handleInlineText,
            onCopyCapture: playing ? void 0 : handleCopy,
            onCutCapture: playing ? void 0 : handleCut,
            onPasteCapture: playing ? void 0 : handlePaste,
            onMouseMove: handleContentMouseMove,
            onMouseLeave: handleContentMouseLeave,
            onPointerDown: handleContentPointerDown,
            onPointerMove: trackInsertion,
            children: [
              hoverRect && /* @__PURE__ */ jsx(
                "div",
                {
                  "aria-hidden": true,
                  style: {
                    position: "absolute",
                    pointerEvents: "none",
                    top: hoverRect.top,
                    left: hoverRect.left,
                    width: hoverRect.width,
                    height: hoverRect.height,
                    outline: "2px dashed var(--color-primary)",
                    outlineOffset: "1px",
                    borderRadius: "2px",
                    zIndex: 20
                  }
                }
              ),
              insertionLine && /* @__PURE__ */ jsx(
                Box,
                {
                  "aria-hidden": true,
                  "data-testid": "orb-preview-insertion-line",
                  className: "rounded-full bg-primary",
                  style: {
                    position: "absolute",
                    pointerEvents: "none",
                    top: insertionLine.top,
                    left: insertionLine.left,
                    width: insertionLine.width,
                    height: insertionLine.height,
                    zIndex: 22
                  }
                }
              ),
              extraRects.map((r, i) => /* @__PURE__ */ jsx(
                Box,
                {
                  "data-testid": "orb-preview-selection-extra",
                  style: { position: "absolute", pointerEvents: "none", top: r.top, left: r.left, width: r.width, height: r.height, outline: "2px solid var(--color-primary)", outlineOffset: "1px", borderRadius: "2px", zIndex: 21 }
                },
                `extra-${i}`
              )),
              marquee && /* @__PURE__ */ jsx(
                Box,
                {
                  "data-testid": "orb-preview-marquee",
                  className: "border border-primary bg-primary/10",
                  style: { position: "absolute", pointerEvents: "none", top: marquee.top, left: marquee.left, width: marquee.width, height: marquee.height, zIndex: 23 }
                }
              ),
              /* @__PURE__ */ jsx(DesignGuidesOverlay, { guides, measures, zoom: reactFlow.getViewport().zoom }),
              selectedRect && /* @__PURE__ */ jsx(
                DesignSelectionOverlay,
                {
                  rect: selectedRect,
                  childRects: selectedLayout?.childRects ?? [],
                  axis: selectedLayout?.axis ?? null,
                  alignment: selectedLayout?.alignment,
                  pxOfStep: selectedScale,
                  renderedSpacing: selectedLayout?.spacing,
                  classes: !playing && isExpanded && hasCanvasTool(tools, "designHandles") && classesEditable ? selectedClasses : null,
                  layoutBar: hasCanvasTool(tools, "autoLayout"),
                  zoom: reactFlow.getViewport().zoom,
                  onChange: handleClassesChange
                }
              ),
              selectedRect && selectedPartOf && /* @__PURE__ */ jsx(
                Box,
                {
                  "data-testid": "orb-preview-part-of",
                  className: "rounded bg-muted px-1.5 py-0.5 text-muted-foreground shadow-sm",
                  style: { position: "absolute", pointerEvents: "none", top: Math.max(0, selectedRect.top - 22), left: selectedRect.left, zIndex: 24 },
                  children: /* @__PURE__ */ jsx(Typography, { variant: "caption", children: t("orbPreview.partOf", { behavior: selectedPartOf }) })
                }
              ),
              orbitalSchema ? (
                // L1 and L2 both auto-grow with content. L2's `buildTransitionSchema`
                // rewrites portal slots (modal/drawer/overlay/center) to `main`, so
                // the rendered pattern lands inline in the main slot and contributes
                // to the card's height — same height model as L1 orbital cards.
                /* @__PURE__ */ jsx(Box, { style: { minHeight: preset.minHeight }, children: /* @__PURE__ */ jsx(
                  BrowserPlayground,
                  {
                    schema: orbitalSchema,
                    mode: "mock",
                    height: "auto",
                    paused: !playing
                  }
                ) })
              ) : /* @__PURE__ */ jsx(Box, { className: "flex items-center justify-center", style: { minHeight: preset.minHeight }, children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("orbPreview.noPreview") }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          NodeResizeControl,
          {
            position: "right",
            variant: ResizeControlVariant.Line,
            minWidth: CARD_MIN_WIDTH,
            maxWidth: CARD_MAX_WIDTH,
            shouldResize: (_event, params) => params.direction[0] !== 0,
            onResizeEnd: (_event, params) => {
              eventBus.emit("UI:CANVAS_CARD_RESIZED", { nodeId: props.id, width: Math.round(params.width) });
            }
          }
        ),
        /* @__PURE__ */ jsx(Handle, { type: "target", position: Position.Left, style: TARGET_HANDLE_STYLE }),
        eventSources.length === 0 && /* @__PURE__ */ jsx(Handle, { type: "source", position: Position.Right, style: TARGET_HANDLE_STYLE }),
        eventSources.map((src) => /* @__PURE__ */ jsx(
          Handle,
          {
            id: `event-${src.event}`,
            type: "source",
            position: Position.Right,
            style: eventHandleStyle(src),
            title: `${src.label ?? src.patternType}: ${src.event}${src.payloadFields?.length ? ` ${formatPayloadTooltip(src.payloadFields)}` : ""}`
          },
          `event-${src.event}`
        ))
      ]
    }
  );
};
var OrbPreviewNode = React93__default.memo(OrbPreviewNodeInner);
OrbPreviewNode.displayName = "OrbPreviewNode";
orbPreviewLog.debug("export-resolved", () => ({
  type: typeof OrbPreviewNode,
  displayName: OrbPreviewNode.displayName ?? null,
  innerDefined: typeof OrbPreviewNodeInner === "function"
}));

// lib/avl-play.ts
function armsOf(trait, from, event) {
  return trait.transitions.filter((t) => t.from === from && t.event === event);
}
function armPosition(trait, transition) {
  return armsOf(trait, transition.from, transition.event).findIndex((t) => t.index === transition.index);
}
function firedTransition(trait, step) {
  if (step.result.firedArm === void 0 || !step.result.transitionFired) return void 0;
  return armsOf(trait, step.from, step.result.event)[step.result.firedArm];
}
var ofTrait = (steps, orbital, trait) => steps.filter((s) => s.orbital === orbital && s.trait === trait);
function stateMachinePlayback(trait, orbital, steps, cursor) {
  const played = ofTrait(steps.slice(0, cursor + 1), orbital, trait.name);
  const visitedStates = [];
  for (const step of played) {
    for (const state of [step.result.state.before, step.result.state.after]) {
      if (state !== null && visitedStates[visitedStates.length - 1] !== state) visitedStates.push(state);
    }
  }
  const last = played[played.length - 1];
  if (!last) return { visitedStates };
  return {
    activeState: last.result.state.after ?? last.result.state.before ?? void 0,
    activeTransition: firedTransition(trait, last)?.index,
    visitedStates
  };
}
function transitionPlayback(trait, orbital, transition, steps, cursor) {
  const arm = armPosition(trait, transition);
  const played = ofTrait(steps.slice(0, cursor + 1), orbital, trait.name);
  for (let i = played.length - 1; i >= 0; i--) {
    const step = played[i];
    if (step.from !== transition.from || step.result.event !== transition.event) continue;
    const fired = step.result.transitionFired && step.result.firedArm === arm;
    const guard = step.result.guards?.find((g) => g.arm === arm);
    if (fired || guard) return { step, fired, ...guard ? { guard } : {}, effects: fired ? step.result.effects : [] };
  }
  return void 0;
}
var TraitCardSelectionContext = createContext({
  selectTransition: () => {
  }
});
var CARD_WIDTH = 540;
var TraitCardNodeInner = (props) => {
  const data = props.data;
  const { t } = useTranslate();
  const { selectTransition, scene } = useContext(TraitCardSelectionContext);
  const orbitalName = data.orbitalName;
  const traitName = data.traitName ?? "";
  const linkedEntity = data.linkedEntity ?? "";
  const emits = data.emits ?? [];
  const listens = data.listens ?? [];
  const fullSchema = data._fullSchema;
  const traitLevelData = useMemo(() => {
    if (!fullSchema) return null;
    return parseTraitLevel(fullSchema, orbitalName, traitName);
  }, [fullSchema, orbitalName, traitName]);
  const playback = useMemo(
    () => traitLevelData && scene ? stateMachinePlayback(traitLevelData, orbitalName, scene.steps, scene.cursor) : null,
    [traitLevelData, scene, orbitalName]
  );
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: "bg-card border-2 border-border rounded-lg shadow-md p-4",
      style: { width: CARD_WIDTH, position: "relative" },
      children: [
        listens.map((event, i) => /* @__PURE__ */ jsx(
          Handle,
          {
            type: "target",
            position: Position.Left,
            id: `listen-${event}`,
            style: { top: `${(i + 1) / (listens.length + 1) * 100}%` },
            "aria-label": t("avl.listensFor", { event })
          },
          `listen-${event}`
        )),
        emits.map((event, i) => /* @__PURE__ */ jsx(
          Handle,
          {
            type: "source",
            position: Position.Right,
            id: `emit-${event}`,
            style: { top: `${(i + 1) / (emits.length + 1) * 100}%` },
            "aria-label": t("avl.emits", { event })
          },
          `emit-${event}`
        )),
        /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", justify: "between", align: "center", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h6", children: traitName }),
            linkedEntity ? /* @__PURE__ */ jsx(Badge, { variant: "secondary", children: linkedEntity }) : null
          ] }),
          traitLevelData ? (
            // xyflow skips drag/pan/wheel on these classes, so label clicks reach the machine.
            /* @__PURE__ */ jsx(Box, { className: "nodrag nopan nowheel", children: /* @__PURE__ */ jsx(
              AvlStateMachine,
              {
                trait: traitLevelData,
                showHeader: false,
                activeState: playback?.activeState,
                activeTransition: playback?.activeTransition,
                visitedStates: playback?.visitedStates,
                onTransitionClick: (tr) => selectTransition({
                  orbitalName,
                  traitName,
                  transitionEvent: tr.event,
                  fromState: tr.from,
                  toState: tr.to,
                  index: tr.index
                })
              }
            ) })
          ) : /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", children: t("avl.noStateMachine") })
        ] })
      ]
    }
  );
};
var TraitCardNode = React93__default.memo(TraitCardNodeInner);
TraitCardNode.displayName = "TraitCardNode";
var SystemMapContext = createContext({ openTraits: () => void 0 });
var HIDDEN_HANDLE = { opacity: 0, width: 1, height: 1, border: 0 };
var SystemNodeInner = ({ data }) => {
  const d = data;
  const { t } = useTranslate();
  const map = useContext(SystemMapContext);
  const [open, setOpen] = useState(false);
  const orbital = d.orbitalName;
  const highlighted = map.highlighted === orbital;
  const chip = /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": "avl-system-node",
      "data-orbital": orbital,
      role: "button",
      tabIndex: 0,
      onClick: () => map.openTraits(orbital),
      onKeyDown: (e) => {
        if (e.key === "Enter") map.openTraits(orbital);
      },
      className: `cursor-pointer rounded-lg border bg-card px-3 py-2.5 shadow-sm transition-shadow hover:shadow-md ${highlighted ? "border-primary ring-2 ring-primary/30" : "border-border"}`,
      style: { width: 280, height: 88 },
      children: [
        /* @__PURE__ */ jsx(Handle, { type: "target", position: Position.Left, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsx(Handle, { type: "source", position: Position.Right, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "h-full min-w-0", children: [
          /* @__PURE__ */ jsx(AvlGlyph, { kind: "orbital", size: "sm", showCaption: false }),
          /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ jsx(Box, { className: "min-w-0", title: orbital, children: /* @__PURE__ */ jsx(Typography, { variant: "body1", weight: "semibold", className: "truncate", children: orbital }) }),
            /* @__PURE__ */ jsx(Box, { className: "min-w-0", title: d.entityName, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "truncate", children: d.entityName }) }),
            /* @__PURE__ */ jsx(Box, { "data-testid": "avl-system-node-counts", className: "min-w-0", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "truncate", children: t("avl.system.counts", { traits: d.traitCount ?? 0, pages: d.pageRoutes?.length ?? 0, fields: d.fieldCount ?? 0 }) }) })
          ] })
        ] })
      ]
    }
  );
  if (!map.renderPreview) return chip;
  return /* @__PURE__ */ jsx(
    Popover,
    {
      trigger: "hover",
      position: "right",
      showArrow: false,
      open,
      onOpenChange: setOpen,
      content: /* @__PURE__ */ jsx(Box, { "data-testid": "avl-system-preview", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "p-2", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", children: orbital }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.system.counts", { traits: d.traitCount ?? 0, pages: d.pageRoutes?.length ?? 0, fields: d.fieldCount ?? 0 }) }),
          d.wireEvents && d.wireEvents.length > 0 ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.system.exchanges", { events: d.wireEvents.join(", ") }) }) : null
        ] }),
        map.renderPreview(orbital),
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", children: [
          /* @__PURE__ */ jsx(Button, { variant: "primary", size: "sm", rightIcon: "chevron-right", onClick: () => {
            setOpen(false);
            map.openTraits(orbital);
          }, "data-testid": "avl-system-open-traits", children: t("avl.system.openTraits") }),
          map.openCodeEvent ? /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "sm", leftIcon: "code", action: map.openCodeEvent, actionPayload: { orbital }, onClick: () => setOpen(false), children: t("avl.system.openCode") }) : null,
          map.previewEvent ? /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "sm", leftIcon: "maximize", action: map.previewEvent, actionPayload: { orbital }, onClick: () => setOpen(false), children: t("avl.system.preview") }) : null
        ] })
      ] }) }),
      children: chip
    }
  );
};
var SystemNode = React93__default.memo(SystemNodeInner);
SystemNode.displayName = "SystemNode";
var SystemBandNodeInner = ({ data }) => {
  const d = data;
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(Box, { "data-testid": `avl-system-band-${d.bandKind}`, className: "pointer-events-none whitespace-nowrap", children: /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "muted", children: t(d.bandKind === "connected" ? "avl.system.connected" : "avl.system.standalone", { count: d.bandCount ?? 0 }) }) });
};
var SystemBandNode = React93__default.memo(SystemBandNodeInner);
SystemBandNode.displayName = "SystemBandNode";
var DEPENDENCY_ROLE_CLASS = {
  selected: "border-primary bg-primary/25 text-foreground ring-2 ring-primary/40",
  upstream: "border-primary bg-primary/10 text-foreground",
  downstream: "border-warning bg-warning/10 text-foreground",
  both: "border-primary bg-warning/10 text-foreground",
  dim: "border-border bg-card text-muted-foreground opacity-40",
  none: "border-border bg-card text-foreground"
};
var UNIT_STATUS_CLASS = {
  ok: "bg-success",
  degraded: "bg-warning",
  down: "bg-error",
  idle: "bg-muted-foreground"
};
var DependencyNodeInner = ({ id, data }) => {
  const d = data;
  const { t } = useTranslate();
  const map = useContext(SystemMapContext);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": "avl-dependency-node",
      "data-dependency": id,
      "data-role": d.dependencyRole ?? "none",
      role: "button",
      tabIndex: 0,
      title: d.orbitalName,
      onClick: () => map.selectDependency?.(id),
      onKeyDown: (e) => {
        if (e.key === "Enter") map.selectDependency?.(id);
      },
      className: `flex cursor-pointer items-center rounded-md border px-2.5 transition-colors ${DEPENDENCY_ROLE_CLASS[d.dependencyRole ?? "none"]}`,
      style: { width: d.cardWidth ?? 220, height: 28 },
      children: [
        /* @__PURE__ */ jsx(Handle, { id: "in-left", type: "target", position: Position.Left, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsx(Handle, { id: "out-right", type: "source", position: Position.Right, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsx(Handle, { id: "out-left", type: "source", position: Position.Left, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsx(Handle, { id: "in-right", type: "target", position: Position.Right, style: HIDDEN_HANDLE, isConnectable: false }),
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate font-mono", children: d.flowTraits === void 0 ? d.orbitalName : [d.orbitalName, [
          d.flowTraits > 0 ? t(d.flowTraits === 1 ? "avl.flow.traitsCountOne" : "avl.flow.traitsCount", { count: d.flowTraits }) : null,
          (d.flowRenderPieces ?? 0) > 0 ? t(d.flowRenderPieces === 1 ? "avl.flow.piecesCountOne" : "avl.flow.piecesCount", { count: d.flowRenderPieces ?? 0 }) : null
        ].filter((part) => part !== null).join(" + ")].join(" \xB7 ") }),
        d.unitMetric !== void 0 ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "ml-auto shrink-0 pl-2 font-mono", children: d.unitMetric }) : null,
        d.unitStatus !== void 0 ? /* @__PURE__ */ jsx(
          Box,
          {
            "data-testid": "avl-unit-status",
            "data-status": d.unitStatus,
            title: t(`avl.unit.status.${d.unitStatus}`),
            className: `${d.unitMetric !== void 0 ? "ml-2" : "ml-auto"} h-2 w-2 shrink-0 rounded-full ${UNIT_STATUS_CLASS[d.unitStatus]}`
          }
        ) : null
      ]
    }
  );
};
var DependencyNode = React93__default.memo(DependencyNodeInner);
DependencyNode.displayName = "DependencyNode";
var DependencyColumnNodeInner = ({ data }) => {
  const d = data;
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx(Box, { "data-testid": `avl-dependency-column-${d.dependencyColumn}`, className: "pointer-events-none whitespace-nowrap", children: /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "muted", children: t(`avl.deps.column.${d.dependencyColumn ?? "unknown"}`) }) });
};
var DependencyColumnNode = React93__default.memo(DependencyColumnNodeInner);
DependencyColumnNode.displayName = "DependencyColumnNode";

// lib/avl-layered-graph.ts
var EDGE_STROKE = {
  down: "var(--color-error)",
  degraded: "var(--color-warning)"
};
function edgeExtras(e) {
  const stroke = e.status !== void 0 ? EDGE_STROKE[e.status] : void 0;
  return {
    ...e.label !== void 0 ? { label: e.label } : {},
    ...e.status !== void 0 ? { data: { status: e.status } } : {},
    ...stroke !== void 0 ? { style: { stroke } } : {}
  };
}
function layeredGraph(input) {
  const nodes = [];
  let x = 0;
  for (const column of input.columns) {
    const units = input.units.filter((u) => u.column === column.id);
    if (units.length === 0) continue;
    nodes.push({
      id: `__column_${column.id}`,
      type: "dependencyColumn",
      position: { x, y: 0 },
      draggable: false,
      selectable: false,
      data: { orbitalName: `__column_${column.id}`, kind: "dependency-column", dependencyColumn: column.id, patterns: [], eventSources: [] }
    });
    units.forEach((u, row) => {
      nodes.push({
        id: u.id,
        type: "dependency",
        position: { x, y: input.row.headerHeight + row * (input.row.height + input.row.gap) },
        draggable: false,
        data: {
          orbitalName: u.label,
          kind: "dependency",
          dependencyColumn: column.id,
          cardWidth: column.width,
          ...u.flowTraits !== void 0 ? { flowTraits: u.flowTraits } : {},
          ...u.flowRenderPieces !== void 0 ? { flowRenderPieces: u.flowRenderPieces } : {},
          ...u.status !== void 0 ? { unitStatus: u.status } : {},
          ...u.metric !== void 0 ? { unitMetric: u.metric } : {},
          patterns: [],
          eventSources: []
        }
      });
    });
    x += column.width + input.row.columnGap;
  }
  if (input.handles === "default") {
    return { nodes, edges: input.edges.map((e) => ({ id: e.id, source: e.source, target: e.target, ...edgeExtras(e) })) };
  }
  const xOf = new Map(nodes.map((n) => [n.id, n.position.x]));
  const edges = input.edges.map((e) => {
    const from = xOf.get(e.source) ?? 0;
    const to = xOf.get(e.target) ?? 0;
    const handles = to > from ? { sourceHandle: "out-right", targetHandle: "in-left" } : to < from ? { sourceHandle: "out-left", targetHandle: "in-right" } : { sourceHandle: "out-right", targetHandle: "in-right" };
    return { id: e.id, source: e.source, target: e.target, ...handles, ...edgeExtras(e) };
  });
  return { nodes, edges };
}

// lib/avl-dependency-graph.ts
var COLUMNS = ["app", "io", "std", "primitive", "unknown"];
var WIDTH = { app: 240, io: 220, std: 250, primitive: 200, unknown: 220 };
var DEPENDENCY_ROW = { height: 26, gap: 8, columnGap: 120, headerHeight: 30 };
var orbitalNodeId = (name) => `orbital:${name}`;
var behaviorNodeId = (name) => `behavior:${name}`;
function importEdges(deps) {
  const edges = [];
  for (const [orbital, imports] of Object.entries(deps.orbitals)) {
    for (const b of new Set(imports)) edges.push([orbitalNodeId(orbital), behaviorNodeId(b)]);
  }
  for (const [name, b] of Object.entries(deps.behaviors)) {
    for (const i of new Set(b.imports)) if (i !== name) edges.push([behaviorNodeId(name), behaviorNodeId(i)]);
  }
  return edges;
}
function schemaToDependencyGraph(deps) {
  const units = Object.keys(deps.orbitals).map((orbital) => ({ id: orbitalNodeId(orbital), column: "app", label: orbital }));
  for (const [name, b] of Object.entries(deps.behaviors).sort(([a], [z]) => a.localeCompare(z))) {
    units.push({ id: behaviorNodeId(name), column: b.layer, label: name });
  }
  return layeredGraph({
    columns: COLUMNS.map((id) => ({ id, width: WIDTH[id] })),
    units,
    edges: importEdges(deps).map(([source, target]) => ({ id: `dep-${source}-${target}`, source, target })),
    row: DEPENDENCY_ROW,
    handles: "default"
  });
}
function dependencyReach(deps, selected) {
  const edges = importEdges(deps);
  const walk = (from, next) => {
    const seen = /* @__PURE__ */ new Set();
    const stack = [from];
    while (stack.length > 0) {
      const at = stack.pop();
      for (const e of edges) {
        const hop = next(e);
        if (hop && hop[0] === at && hop[1] !== selected && !seen.has(hop[1])) {
          seen.add(hop[1]);
          stack.push(hop[1]);
        }
      }
    }
    return seen;
  };
  return { upstream: walk(selected, (e) => e), downstream: walk(selected, ([a, b]) => [b, a]) };
}
var behaviorName = (from) => from.slice(from.lastIndexOf("/") + 1);
function traitsOf(schema, orbital) {
  const found = schema.orbitals?.find((o) => o.name === orbital);
  return (found?.traits ?? []).flatMap((ref) => isInlineTrait(ref) ? [ref] : typeof ref === "object" && ref._resolved ? [ref._resolved] : []);
}
function traitFlowGraph(schema, orbital, layers = {}) {
  const traits = traitsOf(schema, orbital);
  const embedded = new Set(traits.flatMap((t) => Object.values(t.traitEmbedIds ?? {})));
  const unitOf = (t) => t.sourceBehavior ? `behavior:${behaviorName(t.sourceBehavior.behavior)}` : `trait:${t.name}`;
  const own = [];
  const groups = /* @__PURE__ */ new Map();
  for (const t of traits) {
    const isPiece = t.id !== void 0 && embedded.has(t.id);
    if (!t.sourceBehavior) {
      own.push({ id: unitOf(t), name: t.name, column: "own", traits: isPiece ? [] : [t.name], renderPieces: isPiece ? [t.name] : [] });
      continue;
    }
    const name = behaviorName(t.sourceBehavior.behavior);
    const unit = groups.get(name) ?? { id: unitOf(t), name, column: layers[name] ?? "unknown", traits: [], renderPieces: [] };
    (isPiece ? unit.renderPieces : unit.traits).push(t.name);
    groups.set(name, unit);
  }
  const unitByTrait = new Map(traits.map((t) => [t.name, unitOf(t)]));
  const rolled = /* @__PURE__ */ new Map();
  for (const w of traitEventWires({ name: schema.name, orbitals: schema.orbitals?.filter((o) => o.name === orbital) ?? [] })) {
    const source = unitByTrait.get(w.emitterTrait);
    const target = unitByTrait.get(w.listenerTrait);
    if (!source || !target || source === target) continue;
    const key = `${source}\u241F${target}`;
    const edge = rolled.get(key) ?? { source, target, events: [] };
    if (!edge.events.includes(w.event)) edge.events.push(w.event);
    rolled.set(key, edge);
  }
  return { units: [...own, ...groups.values()], edges: [...rolled.values()] };
}
function flowNeighbors(edges, selected) {
  return {
    triggeredBy: new Set(edges.filter((e) => e.target === selected).map((e) => e.source)),
    triggers: new Set(edges.filter((e) => e.source === selected).map((e) => e.target))
  };
}
var COLUMNS2 = ["own", "io", "std", "primitive", "unknown"];
var WIDTH2 = { own: 240, io: 340, std: 340, primitive: 260, unknown: 340 };
var ROW2 = { height: 28, gap: 12, columnGap: 96, headerHeight: 30 };
function traitFlowCanvas(flow) {
  return layeredGraph({
    columns: COLUMNS2.map((id) => ({ id, width: WIDTH2[id] })),
    units: flow.units.map((u) => ({
      id: u.id,
      column: u.column,
      label: u.name,
      ...u.column === "own" ? {} : { flowTraits: u.traits.length, flowRenderPieces: u.renderPieces.length }
    })),
    edges: flow.edges.map((e) => ({ id: `flow-${e.source}-${e.target}`, source: e.source, target: e.target })),
    row: ROW2,
    handles: "facing"
  });
}
var edgeLog = createLogger("almadar:ui:nan-coord");
var EventFlowEdgeInner = (props) => {
  const {
    id,
    source,
    target,
    sourceHandleId,
    targetHandleId,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    markerEnd
  } = props;
  const data = props.data;
  const isBackward = data?.isBackward ?? false;
  const isCrossOrbital = data?.isCrossOrbital ?? false;
  if (!Number.isFinite(sourceX) || !Number.isFinite(sourceY) || !Number.isFinite(targetX) || !Number.isFinite(targetY)) {
    edgeLog.warn("event-flow-edge: non-finite edge coordinates", {
      edgeId: id,
      source,
      target,
      sourceHandleId,
      targetHandleId,
      sourceX,
      sourceY,
      targetX,
      targetY,
      sourcePosition,
      targetPosition,
      eventName: data?.event,
      fromState: data?.fromState,
      toState: data?.toState
    });
  }
  const [edgePath2, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition
  });
  const strokeColor = isCrossOrbital ? CONNECTION_COLORS.emitListen.color : isBackward ? CONNECTION_COLORS.backward.color : CONNECTION_COLORS.forward.color;
  const strokeDash = isCrossOrbital ? "6 4" : isBackward ? "6 3" : "none";
  const strokeWidth = isCrossOrbital ? 1.5 : 2;
  let labelText2 = data?.event ?? "";
  if (data?.triggerLabel) {
    labelText2 = `${data.triggerLabel} \u2192 ${data.event}`;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        id,
        d: edgePath2,
        fill: "none",
        stroke: strokeColor,
        strokeWidth,
        strokeDasharray: strokeDash,
        markerEnd,
        style: { pointerEvents: "stroke" }
      }
    ),
    labelText2 && /* @__PURE__ */ jsx(EdgeLabelRenderer, { children: /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          position: "absolute",
          transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
          pointerEvents: "all",
          fontSize: isCrossOrbital ? 11 : 12,
          fontWeight: 600,
          color: strokeColor,
          backgroundColor: "var(--color-card)",
          padding: "2px 8px",
          borderRadius: "var(--radius-sm)",
          border: `1px solid ${avlTint(strokeColor, 19)}`,
          whiteSpace: "nowrap",
          display: "flex",
          alignItems: "center",
          gap: 4
        },
        className: "nodrag nopan",
        children: [
          data?.triggerPatternType && /* @__PURE__ */ jsxs("span", { style: { opacity: 0.5, fontSize: 10 }, children: [
            "[",
            data.triggerPatternType,
            "]"
          ] }),
          labelText2
        ]
      }
    ) })
  ] });
};
var EventFlowEdge = React93__default.memo(EventFlowEdgeInner);
EventFlowEdge.displayName = "EventFlowEdge";
var FormField = ({
  label,
  required,
  error,
  hint,
  className,
  children,
  ...rest
}) => {
  const generatedId = React93__default.useId();
  const field = React93__default.Children.count(children) === 1 && React93__default.isValidElement(children) ? children : null;
  const fieldId = field ? field.props.id ?? generatedId : void 0;
  const baseId = fieldId ?? generatedId;
  const hintId = `${baseId}-hint`;
  const errorId = `${baseId}-error`;
  const describedBy = [field?.props["aria-describedby"], error ? errorId : hint ? hintId : void 0].filter(Boolean).join(" ") || void 0;
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), gap: "xs", className, children: [
    /* @__PURE__ */ jsx(Label, { required, htmlFor: fieldId, children: label }),
    field ? React93__default.cloneElement(field, {
      id: fieldId,
      "aria-describedby": describedBy,
      "aria-invalid": error ? true : field.props["aria-invalid"]
    }) : children,
    error && /* @__PURE__ */ jsx(Typography, { id: errorId, variant: "caption", color: "error", "data-field-error": true, children: error }),
    hint && !error && /* @__PURE__ */ jsx(Typography, { id: hintId, variant: "caption", color: "muted", children: hint })
  ] });
};
FormField.displayName = "FormField";
var TagInput = ({
  value,
  onChange,
  placeholder,
  disabled = false,
  variant = "default",
  unique = true,
  helperText,
  className,
  addEvent,
  removeEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [draft, setDraft] = useState("");
  const commit = useCallback(() => {
    const tag = draft.trim();
    if (!tag) return;
    if (unique && value.includes(tag)) {
      setDraft("");
      return;
    }
    const next = [...value, tag];
    onChange?.(next);
    if (addEvent) {
      eventBus.emit(`UI:${addEvent}`, { tag, value: next });
    }
    setDraft("");
  }, [draft, value, onChange, unique, addEvent, eventBus]);
  const removeAt = useCallback(
    (index) => {
      if (disabled) return;
      const tag = value[index];
      const next = value.slice();
      next.splice(index, 1);
      onChange?.(next);
      if (removeEvent) {
        eventBus.emit(`UI:${removeEvent}`, { tag, index, value: next });
      }
    },
    [value, onChange, disabled, removeEvent, eventBus]
  );
  const handleKeyDown = useCallback(
    (e) => {
      if (disabled) return;
      if (e.key === "Enter") {
        e.preventDefault();
        commit();
      } else if (e.key === "Backspace" && draft.length === 0 && value.length > 0) {
        e.preventDefault();
        removeAt(value.length - 1);
      }
    },
    [commit, draft.length, value, removeAt, disabled]
  );
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), gap: "xs", className: cn("w-full", className), children: [
    value.length > 0 ? /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: value.map((tag, index) => /* @__PURE__ */ jsx(
      Badge,
      {
        variant,
        size: "sm",
        onRemove: disabled ? void 0 : () => removeAt(index),
        removeLabel: t("tagInput.removeTag", { tag }),
        children: tag
      },
      `${tag}-${index}`
    )) }) : null,
    /* @__PURE__ */ jsx(
      Input,
      {
        value: draft,
        placeholder: placeholder ?? t("tagInput.placeholder"),
        disabled,
        onChange: (e) => setDraft(e.target.value),
        onKeyDown: handleKeyDown
      }
    ),
    helperText ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: helperText }) : null
  ] });
};
TagInput.displayName = "TagInput";
function asString2(v) {
  return typeof v === "string" ? v : "";
}
function asNumberInput(v) {
  return typeof v === "number" && Number.isFinite(v) ? v : "";
}
function asBoolean(v) {
  return v === true;
}
function asStringArray(v) {
  if (!Array.isArray(v)) return [];
  return v.filter((x) => typeof x === "string");
}
function asObjectArray(v) {
  if (!Array.isArray(v)) return [];
  return v.filter(
    (x) => typeof x === "object" && x !== null && !Array.isArray(x)
  );
}
function asObject(v) {
  if (typeof v === "object" && v !== null && !Array.isArray(v)) {
    return v;
  }
  return {};
}
function EntityFieldInput({
  field,
  value,
  onChange
}) {
  const fieldType = field.type;
  if (fieldType === "enum") {
    const choices = field.values ?? [];
    return /* @__PURE__ */ jsx(
      Select,
      {
        options: choices.map((v) => ({ value: v, label: v })),
        value: typeof value === "string" ? value : "",
        onChange: (e) => onChange(e.target.value)
      }
    );
  }
  if (fieldType === "boolean") {
    return /* @__PURE__ */ jsx(Switch, { checked: value === true, onChange: (checked) => onChange(checked) });
  }
  if (fieldType === "number") {
    return /* @__PURE__ */ jsx(
      Input,
      {
        inputType: "number",
        value: typeof value === "number" ? value : "",
        onChange: (e) => {
          const raw = e.target.value;
          if (raw === "") {
            onChange("");
            return;
          }
          const n = parseFloat(raw);
          onChange(Number.isFinite(n) ? n : "");
        }
      }
    );
  }
  if (fieldType === "date" || fieldType === "datetime" || fieldType === "timestamp") {
    return /* @__PURE__ */ jsx(
      Input,
      {
        inputType: fieldType === "date" ? "date" : "datetime-local",
        value: typeof value === "string" ? value : "",
        onChange: (e) => onChange(e.target.value)
      }
    );
  }
  if (fieldType === "array" && field.items) {
    return /* @__PURE__ */ jsx(
      NestedArrayEditor,
      {
        itemSchema: field.items,
        value: Array.isArray(value) ? value : [],
        onChange: (next) => onChange(next)
      }
    );
  }
  if (fieldType === "object" && field.properties) {
    return /* @__PURE__ */ jsx(
      ObjectFormEditor,
      {
        schema: field.properties,
        value: typeof value === "object" && value !== null && !Array.isArray(value) ? value : {},
        onChange: (next) => onChange(next)
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Input,
    {
      value: typeof value === "string" ? value : "",
      onChange: (e) => onChange(e.target.value)
    }
  );
}
function ObjectFormEditor({
  schema,
  value,
  onChange
}) {
  const entries = useMemo(() => Object.entries(schema), [schema]);
  return /* @__PURE__ */ jsx(VStack, { gap: "sm", children: entries.map(([key, field]) => /* @__PURE__ */ jsx(
    FormField,
    {
      label: field.name ?? key,
      required: field.required,
      hint: field.description,
      children: /* @__PURE__ */ jsx(
        EntityFieldInput,
        {
          field,
          value: value[key],
          onChange: (fieldValue) => onChange({ ...value, [key]: fieldValue })
        }
      )
    },
    key
  )) });
}
function ListOfObjectsEditor({
  itemSchema,
  value,
  onChange,
  title
}) {
  const { t } = useTranslate();
  const properties = itemSchema.properties;
  const label = title ?? itemSchema.name ?? t("knobField.items");
  const handleAdd = useCallback(() => {
    onChange([...value, {}]);
  }, [value, onChange]);
  const handleRemove = useCallback(
    (index) => {
      const next = value.slice();
      next.splice(index, 1);
      onChange(next);
    },
    [value, onChange]
  );
  const updateAt = useCallback(
    (index, entry) => {
      const next = value.slice();
      next[index] = entry;
      onChange(next);
    },
    [value, onChange]
  );
  const items = value.map((entry, index) => ({
    id: `item-${index}`,
    header: `${label} ${index + 1}`,
    content: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      /* @__PURE__ */ jsx(
        ObjectFormEditor,
        {
          schema: properties ?? {},
          value: entry,
          onChange: (next) => updateAt(index, next)
        }
      ),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          onClick: () => handleRemove(index),
          className: "self-start text-[10px]",
          children: t("knobField.removeItem")
        }
      )
    ] })
  }));
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
    items.length > 0 ? /* @__PURE__ */ jsx(Accordion, { items }) : null,
    /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: handleAdd, className: "self-start text-[10px]", children: t("knobField.addItem", { label }) })
  ] });
}
function NestedArrayEditor({
  itemSchema,
  value,
  onChange
}) {
  if (itemSchema.type === "object" && itemSchema.properties) {
    const objectArray = value.filter(
      (x) => typeof x === "object" && x !== null && !Array.isArray(x)
    );
    return /* @__PURE__ */ jsx(
      ListOfObjectsEditor,
      {
        itemSchema,
        value: objectArray,
        onChange: (next) => onChange(next)
      }
    );
  }
  const stringArray = value.filter((x) => typeof x === "string");
  return /* @__PURE__ */ jsx(
    TagInput,
    {
      value: stringArray,
      onChange: (next) => onChange([...next])
    }
  );
}
var FIELD_TYPE_OPTIONS = [
  { value: "string", label: "string" },
  { value: "number", label: "number" },
  { value: "boolean", label: "boolean" },
  { value: "date", label: "date" },
  { value: "datetime", label: "datetime" },
  { value: "enum", label: "enum" }
];
function FieldListEditor({
  value,
  onChange
}) {
  const { t } = useTranslate();
  const handleAdd = useCallback(() => {
    onChange([...value, { name: "", type: "string" }]);
  }, [value, onChange]);
  const handleRemove = useCallback(
    (index) => {
      const next = value.slice();
      next.splice(index, 1);
      onChange(next);
    },
    [value, onChange]
  );
  const updateAt = useCallback(
    (index, patch) => {
      const next = value.slice();
      const current = next[index] ?? { name: "", type: "string" };
      next[index] = { ...current, ...patch };
      onChange(next);
    },
    [value, onChange]
  );
  const items = value.map((field, index) => ({
    id: `field-${index}`,
    header: field.name || `#${index + 1}`,
    content: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "w-full", children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            placeholder: t("knobField.fieldNamePlaceholder"),
            value: field.name ?? "",
            onChange: (e) => updateAt(index, { name: e.target.value })
          }
        ),
        /* @__PURE__ */ jsx(
          Select,
          {
            value: field.type ?? "string",
            onChange: (e) => updateAt(index, fieldOfType(e.target.value)),
            options: FIELD_TYPE_OPTIONS
          }
        )
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          onClick: () => handleRemove(index),
          className: "self-start text-[10px]",
          children: t("knobField.removeItem")
        }
      )
    ] })
  }));
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-medium", children: t("knobField.entityFields") }),
    items.length > 0 ? /* @__PURE__ */ jsx(Accordion, { items }) : null,
    /* @__PURE__ */ jsx(Button, { variant: "secondary", onClick: handleAdd, className: "self-start text-[10px]", children: t("knobField.addField") })
  ] });
}
function EnumRadio({
  suggested,
  value,
  onChange,
  placeholder
}) {
  const { t } = useTranslate();
  if (suggested.length === 0) {
    return /* @__PURE__ */ jsx(
      Input,
      {
        value,
        placeholder: placeholder ?? t("knobField.yourAnswer"),
        onChange: (e) => onChange(e.target.value)
      }
    );
  }
  const isOther = !!value && !suggested.includes(value);
  const radioOptions = [...suggested, t("knobField.other")];
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
    /* @__PURE__ */ jsx(
      Radio,
      {
        options: radioOptions,
        value: isOther ? t("knobField.other") : value,
        onChange: (e) => {
          const v = e.target.value;
          onChange(v === t("knobField.other") ? "" : v);
        }
      }
    ),
    isOther ? /* @__PURE__ */ jsx(
      Input,
      {
        placeholder: t("knobField.specifyPlaceholder"),
        value,
        onChange: (e) => onChange(e.target.value)
      }
    ) : null
  ] });
}
function asEntityFieldArray(v) {
  if (!Array.isArray(v)) return [];
  return v.filter(
    (x) => typeof x === "object" && x !== null && !Array.isArray(x) && typeof x.name === "string" && typeof x.type === "string"
  );
}
function EntityFieldMultiselect({
  question,
  value,
  onChange
}) {
  const { t } = useTranslate();
  const candidates = question.fieldCandidates ?? {};
  const descriptions = question.fieldDescriptions ?? {};
  const suggested = question.suggestedAnswers ?? [];
  const currentFields = asEntityFieldArray(value ?? question.defaultValue);
  const selectedNames = useMemo(
    () => new Set(currentFields.map((f3) => f3.name)),
    [currentFields]
  );
  const knownFields = useMemo(
    () => currentFields.filter((f3) => !!candidates[f3.name ?? ""]),
    [currentFields, candidates]
  );
  const customFieldNames = useMemo(
    () => currentFields.filter((f3) => !candidates[f3.name ?? ""]).map((f3) => f3.name ?? ""),
    [currentFields, candidates]
  );
  const handleToggle = useCallback(
    (name) => {
      const next = selectedNames.has(name) ? currentFields.filter((f3) => f3.name !== name) : [...currentFields, candidates[name] ?? { name, type: "string" }];
      onChange(next);
    },
    [selectedNames, currentFields, candidates, onChange]
  );
  const handleCustomFieldNamesChange = useCallback(
    (names) => {
      const customEntityFields = names.filter((n) => n.trim().length > 0).map((name) => ({ name, type: "string" }));
      onChange([...knownFields, ...customEntityFields]);
    },
    [knownFields, onChange]
  );
  return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    /* @__PURE__ */ jsx(VStack, { gap: "xs", children: suggested.map((name) => /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "pl-1", children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          label: name,
          checked: selectedNames.has(name),
          onChange: () => handleToggle(name)
        }
      ),
      descriptions[name] ? /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] pl-6", children: descriptions[name] }) : null
    ] }, name)) }),
    /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-medium", children: t("knobField.addOwnField") }),
      /* @__PURE__ */ jsx(
        TagInput,
        {
          value: customFieldNames,
          onChange: handleCustomFieldNamesChange,
          placeholder: t("knobField.fieldNamePlaceholder")
        }
      )
    ] })
  ] });
}
function fieldOfType(type) {
  switch (type) {
    case "enum":
      return { type };
    case "relation":
      return { type };
    case "union":
      return { type };
    case "array":
      return { type };
    case "object":
      return { type };
    default:
      return { type };
  }
}
function KnobField({
  question,
  value,
  onChange
}) {
  const { t } = useTranslate();
  const suggested = question.suggestedAnswers ?? [];
  switch (question.inputType) {
    case "boolean":
      return /* @__PURE__ */ jsx(
        Switch,
        {
          checked: asBoolean(value),
          onChange: (checked) => onChange(checked)
        }
      );
    case "number":
      return /* @__PURE__ */ jsx(
        Input,
        {
          inputType: "number",
          value: asNumberInput(value),
          placeholder: question.helpText ?? t("knobField.number"),
          onChange: (e) => {
            const raw = e.target.value;
            if (raw === "") {
              onChange("");
              return;
            }
            const n = parseFloat(raw);
            onChange(Number.isFinite(n) ? n : "");
          }
        }
      );
    case "multiselect": {
      if (question.mutationTemplate.kind === "set-orbital-entity-fields" && question.fieldCandidates) {
        return /* @__PURE__ */ jsx(
          EntityFieldMultiselect,
          {
            question,
            value,
            onChange
          }
        );
      }
      const selected = asStringArray(value);
      return /* @__PURE__ */ jsx(VStack, { gap: "xs", children: suggested.map((option) => {
        const isChecked = selected.includes(option);
        return /* @__PURE__ */ jsx(
          Checkbox,
          {
            label: option,
            checked: isChecked,
            onChange: () => {
              const next = isChecked ? selected.filter((s) => s !== option) : [...selected, option];
              onChange(next);
            }
          },
          option
        );
      }) });
    }
    case "tagList":
      return /* @__PURE__ */ jsx(
        TagInput,
        {
          value: asStringArray(value),
          onChange: (next) => onChange([...next]),
          placeholder: question.helpText ?? t("knobField.addAValue")
        }
      );
    case "enum":
    case "persistence":
      return /* @__PURE__ */ jsx(
        EnumRadio,
        {
          suggested,
          value: asString2(value),
          onChange: (v) => onChange(v),
          placeholder: question.helpText
        }
      );
    case "listOfObjects":
      return question.itemSchema ? /* @__PURE__ */ jsx(
        ListOfObjectsEditor,
        {
          itemSchema: question.itemSchema,
          value: asObjectArray(value),
          onChange: (next) => onChange([...next])
        }
      ) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("knobField.missingItemSchema") });
    case "objectForm":
      return question.objectSchema ? /* @__PURE__ */ jsx(
        ObjectFormEditor,
        {
          schema: question.objectSchema,
          value: asObject(value),
          onChange: (next) => onChange({ ...next })
        }
      ) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("knobField.missingObjectSchema") });
    case "fieldList":
      return /* @__PURE__ */ jsx(
        FieldListEditor,
        {
          value: Array.isArray(value) ? value : [],
          onChange: (next) => onChange([...next])
        }
      );
    case "urlPath":
    case "text":
    default:
      return /* @__PURE__ */ jsx(
        Input,
        {
          placeholder: question.helpText ?? t("knobField.yourAnswer"),
          value: asString2(value),
          onChange: (e) => onChange(e.target.value)
        }
      );
  }
}
var COMMIT_ON_CHANGE = /* @__PURE__ */ new Set(["boolean", "enum", "persistence", "multiselect"]);
function KnobSettingRow({ knob, editable }) {
  const eventBus = useEventBus();
  const [draft, setDraft] = useState(knob.value);
  const [dirty, setDirty] = useState(false);
  const commit = useCallback((value) => {
    for (const m of answerToMutations(knob.question.mutationTemplate, value, knob.question)) {
      if (m.kind !== "set-trait-override-config") continue;
      eventBus.emit("UI:TRAIT_CONFIG_CHANGE", { orbitalName: m.orbitalName, traitName: m.traitName, key: m.key, valueJson: JSON.stringify(m.value) });
    }
  }, [eventBus, knob.question]);
  const handleChange = useCallback((next) => {
    setDraft(next);
    if (COMMIT_ON_CHANGE.has(knob.question.inputType)) {
      commit(next);
      return;
    }
    setDirty(true);
  }, [knob.question.inputType, commit]);
  const handleBlur = useCallback(() => {
    if (!dirty || draft === void 0) return;
    setDirty(false);
    commit(draft);
  }, [dirty, draft, commit]);
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1", onBlur: handleBlur, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs", children: knob.question.question }),
    knob.question.helpText ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground text-[10px]", children: knob.question.helpText }) : null,
    editable ? /* @__PURE__ */ jsx(KnobField, { question: knob.question, value: draft, onChange: handleChange }) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: draft === void 0 || draft === null ? "\u2014" : typeof draft === "object" ? JSON.stringify(draft) : String(draft) })
  ] });
}
KnobSettingRow.displayName = "KnobSettingRow";
var inspectorLog2 = createLogger("almadar:ui:inspector");
function formatExpression(expr) {
  if (!expr) return "";
  if (typeof expr === "string") return expr;
  if (Array.isArray(expr)) return `(${expr.map(formatExpression).join(" ")})`;
  return String(expr);
}
function effectSummary(type) {
  return type;
}
function findEntity(schema, orbitalName) {
  const orbital = (schema.orbitals ?? []).find((o) => o.name === orbitalName);
  if (!orbital || typeof orbital.entity === "string") return null;
  const e = orbital.entity;
  const fields = (e.fields ?? []).map((f3) => ({
    name: f3.name ?? "",
    type: f3.type,
    required: f3.required
  }));
  return { name: e.name ?? orbitalName, persistence: e.persistence ?? "runtime", fields };
}
function findTraits(schema, orbitalName) {
  const orbital = (schema.orbitals ?? []).find((o) => o.name === orbitalName);
  if (!orbital) return [];
  return (orbital.traits ?? []).filter((t) => typeof t !== "string").map((t) => ({
    name: t.name,
    stateCount: t.stateMachine?.states?.length ?? 0
  }));
}
var FIELD_TYPE_OPTIONS2 = FieldTypeSchema.options.map((v) => ({ value: v, label: v }));
var EFFECT_TYPE_OPTIONS = EFFECT_OPERATORS.map((v) => ({ value: v, label: v }));
function propAccessText(access, t) {
  if (access.reason === "bound") return t("avl.propBound", { binding: access.detail });
  if (access.reason === "fixed") return t("avl.propFixed", { behavior: access.detail });
  return t("avl.propChecking");
}
function OrbInspector({ node, schema, editable = false, userType = "builder", themeManifest, defaultTab, onTabChange, onSchemaChange, onClose, selectedPattern: selectedPatternProp, elementAccess: elementAccessProp }) {
  const { selected: contextSelectedPattern } = useContext(PatternSelectionContext);
  const selectedPattern = selectedPatternProp !== void 0 ? selectedPatternProp : contextSelectedPattern;
  const [activeTab, setActiveTab] = useState(defaultTab ?? "inspector");
  const [showMoreProps, setShowMoreProps] = useState(false);
  const selectedPatternKey = `${selectedPattern?.focus?.trait ?? ""}:${selectedPattern?.patternId ?? ""}`;
  const [shownFor, setShownFor] = useState(selectedPatternKey);
  if (shownFor !== selectedPatternKey) {
    setShownFor(selectedPatternKey);
    setShowMoreProps(false);
  }
  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab);
    onTabChange?.(tab);
  }, [onTabChange]);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const orbitalName = node.orbitalName ?? "";
  const traitName = node.traitName ?? "";
  const transitionEvent = node.transitionEvent ?? "";
  const fromState = node.fromState ?? "";
  const toState = node.toState ?? "";
  const entityName = node.entityName ?? "";
  const patterns = node.patterns ?? [];
  const effectTypes = node.effectTypes ?? [];
  const guard = node.guard;
  const isExpanded = Boolean(traitName);
  const hasRenderUi = effectTypes.includes("render-ui");
  const patternType = selectedPattern?.patternType;
  const patternDef = useMemo(() => patternType ? getPatternDefinition(patternType) : null, [patternType]);
  const isEntityPattern = patternType ? isEntityAwarePattern(patternType) : false;
  const entity = useMemo(() => findEntity(schema, orbitalName), [schema, orbitalName]);
  const transition = useMemo(() => {
    if (!traitName || !transitionEvent) return null;
    return findTransition(schema, orbitalName, traitName, transitionEvent);
  }, [schema, orbitalName, traitName, transitionEvent]);
  const traits = useMemo(() => findTraits(schema, orbitalName), [schema, orbitalName]);
  const showEntityFields = userType === "architect" && (Boolean(selectedPattern) && isEntityPattern || !selectedPattern && !isExpanded) && Boolean(entity);
  const showServiceMode = editable && !selectedPattern && !isExpanded && node.layer === "Services";
  const showTraits = !selectedPattern && !isExpanded && traits.length > 0;
  const inspectorHasContent = showEntityFields || showServiceMode || showTraits;
  const shownTab = activeTab === "inspector" && !inspectorHasContent ? "design" : activeTab;
  const elementFocus = selectedPattern?.focus;
  const elementOrbital = elementFocus?.orbital ?? orbitalName;
  const elementTrait = elementFocus?.trait ?? traitName;
  const elementTransition = elementFocus?.transition ?? transitionEvent;
  const elementSlot = elementFocus?.slot;
  const contextAccess = useContext(ElementEditAccessContext);
  const accessResolver = elementAccessProp ?? contextAccess;
  const elementAccess = accessResolver && elementFocus ? accessResolver(elementFocus) : null;
  const propAccess = useCallback(
    (propName) => elementAccess?.prop(propName) ?? { editable: true },
    [elementAccess]
  );
  const patternConfig = useMemo(
    () => selectedPattern ? resolvePatternConfig(schema, {
      orbitalName: elementOrbital,
      traitName: elementTrait,
      transitionEvent: elementTransition,
      sourceTrait: selectedPattern.sourceTrait,
      patternId: selectedPattern.patternId,
      patternType: selectedPattern.patternType
    }) : null,
    [selectedPattern, schema, elementOrbital, elementTrait, elementTransition]
  );
  const orbCode = useMemo(() => {
    const orbital = (schema.orbitals ?? []).find((o) => o.name === orbitalName);
    if (!orbital) return "{}";
    if (isExpanded && traitName) {
      const traitList = orbital.traits ?? [];
      const trait = traitList.find((tr) => typeof tr !== "string" && tr.name === traitName);
      if (trait && typeof trait !== "string" && trait.stateMachine) {
        if (transitionEvent) {
          const tx = trait.stateMachine.transitions?.find((txn) => txn.event === transitionEvent);
          if (tx) return JSON.stringify(tx, null, 2);
        }
        return JSON.stringify({ name: trait.name, stateMachine: trait.stateMachine }, null, 2);
      }
    }
    return JSON.stringify(orbital, null, 2);
  }, [schema, orbitalName, traitName, transitionEvent, isExpanded]);
  const handlePropChange = useCallback((propName, value) => {
    if (!editable) return;
    const access = propAccess(propName);
    if (!access.editable) {
      eventBus.emit("UI:NOTIFY", { severity: "info", message: propAccessText(access, t) });
      return;
    }
    eventBus.emit("UI:PROP_CHANGE", {
      scope: "local",
      propName,
      value,
      selection: {
        sourceSchemaName: selectedPattern?.nodeData.sourceSchemaName,
        patternPath: selectedPattern?.patternId,
        orbitalName: elementOrbital,
        traitName: elementTrait,
        transitionEvent: elementTransition,
        ...elementSlot ? { slot: elementSlot } : {}
      }
    });
  }, [editable, propAccess, eventBus, t, selectedPattern, elementOrbital, elementTrait, elementTransition, elementSlot]);
  const handleTokenChange = useCallback((token, value) => {
    if (!editable) return;
    eventBus.emit("UI:PROP_CHANGE", {
      scope: "global",
      tokenGroup: token.group,
      tokenKey: token.key,
      value,
      selection: {
        sourceSchemaName: selectedPattern?.nodeData.sourceSchemaName,
        patternPath: selectedPattern?.patternId,
        orbitalName: elementOrbital,
        traitName: elementTrait,
        transitionEvent: elementTransition,
        ...elementSlot ? { slot: elementSlot } : {}
      }
    });
  }, [editable, eventBus, selectedPattern, elementOrbital, elementTrait, elementTransition, elementSlot]);
  const handleAddField = useCallback(() => {
    eventBus.emit("UI:ADD_FIELD", {});
  }, [eventBus]);
  const handleUpdateField = useCallback((fieldName2, updates) => {
    eventBus.emit("UI:UPDATE_FIELD", { fieldName: fieldName2, updates });
  }, [eventBus]);
  const handleRemoveField = useCallback((fieldName2) => {
    eventBus.emit("UI:REMOVE_FIELD", { fieldName: fieldName2 });
  }, [eventBus]);
  const handleGuardChange = useCallback((guardExpr) => {
    if (!editable) return;
    eventBus.emit("UI:GUARD_CHANGE", { guard: guardExpr || null });
  }, [editable, eventBus]);
  const handleAddEffect = useCallback((effectType) => {
    eventBus.emit("UI:ADD_EFFECT", { effectType });
  }, [eventBus]);
  const handleRemoveEffect = useCallback((effectIndex) => {
    eventBus.emit("UI:REMOVE_EFFECT", { effectIndex });
  }, [eventBus]);
  const knobKeys = new Set(elementAccess?.settings?.knobs.map((k) => k.key) ?? []);
  const setInSettings = (propName) => {
    const access = propAccess(propName);
    return access.editable && access.knob !== void 0 && knobKeys.has(access.knob);
  };
  const propEntries = patternDef?.propsSchema ? Object.entries(patternDef.propsSchema).filter(([propName]) => !setInSettings(propName)) : [];
  const setProps = propEntries.filter(([propName]) => patternConfig?.[propName] !== void 0);
  const moreProps = propEntries.filter(([propName]) => patternConfig?.[propName] === void 0);
  const renderPropRow = ([propName, propSchema]) => {
    const ps = propSchema;
    const explicitValue = patternConfig ? patternConfig[propName] : void 0;
    const defaultValue = ps.default;
    const isImplicit = explicitValue === void 0 && defaultValue !== void 0;
    const currentValue = explicitValue !== void 0 ? explicitValue : defaultValue;
    const displayValue = currentValue !== void 0 ? typeof currentValue === "object" ? JSON.stringify(currentValue) : String(currentValue) : "";
    inspectorLog2.debug("prop-row", () => ({
      patternType: patternDef?.type ?? "",
      patternId: selectedPattern?.patternId ?? "",
      propName,
      explicitValue: explicitValue === void 0 ? "<unset>" : JSON.stringify(explicitValue),
      defaultValue: defaultValue === void 0 ? "<unset>" : JSON.stringify(defaultValue),
      isImplicit: String(isImplicit)
    }));
    const access = propAccess(propName);
    return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs w-20 shrink-0 font-mono", children: propName }),
      editable && !access.editable ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground italic truncate", children: propAccessText(access, t) }) : editable ? /* @__PURE__ */ jsx(
        Input,
        {
          defaultValue: displayValue,
          placeholder: ps.types?.join(" | ") ?? "string",
          className: "flex-1 text-xs h-6",
          onBlur: (e) => handlePropChange(propName, e.target.value)
        }
      ) : /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: [
        displayValue || "\u2014",
        ps.required ? " *" : ""
      ] })
    ] }, propName);
  };
  const headerTitle = selectedPattern ? selectedPattern.patternType : isExpanded ? transitionEvent || t("avl.transition") : orbitalName;
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col bg-card border-l border-border h-full w-full sm:w-[340px]", children: [
    /* @__PURE__ */ jsxs(Box, { className: "shrink-0 border-b border-border", children: [
      /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-between px-4 py-2", children: [
        /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2", children: selectedPattern ? /* @__PURE__ */ jsx(
          Box,
          {
            className: "rounded px-2 py-0.5 text-xs font-mono font-semibold",
            style: { backgroundColor: "var(--color-primary)", color: "var(--color-primary-foreground)" },
            children: headerTitle
          }
        ) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold", children: headerTitle }) }),
        /* @__PURE__ */ jsx(
          "button",
          {
            onClick: onClose,
            className: "text-muted-foreground hover:text-foreground text-sm cursor-pointer bg-transparent border-none p-1",
            "aria-label": t("common.close"),
            children: "\xD7"
          }
        )
      ] }),
      /* @__PURE__ */ jsx(Box, { className: "flex px-4 gap-4", children: ["inspector", "design", "prototype", "code"].filter((tab) => tab !== "code" || userType === "architect").filter((tab) => tab !== "inspector" || inspectorHasContent).map((tab) => /* @__PURE__ */ jsx(
        "button",
        {
          onClick: () => handleTabChange(tab),
          className: `pb-2 text-xs font-medium border-b-2 cursor-pointer bg-transparent border-x-0 border-t-0 px-0 capitalize ${shownTab === tab ? "border-[var(--color-primary)] text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"}`,
          children: t(`orbInspector.tab.${tab}`)
        },
        tab
      )) })
    ] }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto", children: shownTab === "code" && userType === "architect" ? (
      /* ── Code Tab (architect only) ── */
      /* GAP-51: when editable, the CodeBlock molecule renders the existing
         Textarea atom internally and forwards keystrokes via UI:CODE_CHANGE
         on the EventBus. The consumer (builder workspace) listens, debounces,
         parses via safeParseOrbitalSchema, and calls setSchema. Read-only
         consumers (editable=false) see the existing syntax-highlighted view. */
      /* @__PURE__ */ jsx(Box, { className: "p-2", children: /* @__PURE__ */ jsx(
        CodeBlock,
        {
          code: orbCode,
          language: "orb",
          showCopyButton: true,
          showLanguageBadge: true,
          maxHeight: "100%",
          editable,
          onChange: editable ? (code) => eventBus.emit("UI:CODE_CHANGE", { code }) : void 0
        }
      ) })
    ) : shownTab === "design" ? (
      /* ── Design Tab ── Pattern Props + Styles + render-ui source. */
      /* @__PURE__ */ jsxs(Fragment, { children: [
        selectedPattern && patternDef?.propsSchema && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("avl.props") }),
          elementAccess?.partOf && /* @__PURE__ */ jsx(Badge, { variant: "neutral", size: "sm", className: "mb-2", "data-testid": "orb-inspector-part-of", children: t("orbPreview.partOf", { behavior: elementAccess.partOf }) }),
          /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1.5", children: [
            setProps.map(renderPropRow),
            moreProps.length > 0 && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                className: "self-start text-xs h-6 px-1",
                onClick: () => setShowMoreProps((open) => !open),
                "data-testid": "orb-inspector-more-props",
                children: t("avl.moreProps", { count: String(moreProps.length) })
              }
            ),
            showMoreProps && moreProps.map(renderPropRow)
          ] })
        ] }),
        elementAccess?.settings && elementAccess.settings.knobs.length > 0 && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", "data-testid": "orb-inspector-settings", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: elementAccess.partOf ? t("avl.settingsOf", { behavior: elementAccess.partOf }) : t("avl.settings") }),
          /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-3", children: elementAccess.settings.knobs.map((knob) => /* @__PURE__ */ jsx(KnobSettingRow, { knob, editable }, `${elementAccess.settings?.trait}.${knob.key}`)) })
        ] }),
        /* @__PURE__ */ jsx(
          StylesTab,
          {
            patternType,
            patternDef,
            patternConfig,
            editable,
            onPropChange: handlePropChange,
            onTokenChange: handleTokenChange,
            themeManifest,
            isDesignSystem: selectedPattern?.nodeData.sourceSchemaName === "__design_system__",
            offsetInParent: selectedPattern?.offsetInParent
          }
        ),
        userType === "architect" && patterns.length > 0 && !selectedPattern && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: "render-ui" }),
          /* @__PURE__ */ jsx(Box, { className: "bg-muted/20 rounded-md p-3 font-mono text-xs leading-relaxed overflow-x-auto", children: patterns.map((entry, i) => /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: t("orbInspector.slotLabel", { slot: entry.slot }) }),
            /* @__PURE__ */ jsx(OrbPatternTree, { config: entry.pattern, depth: 0 })
          ] }, i)) })
        ] })
      ] })
    ) : shownTab === "prototype" ? (
      /* ── Prototype Tab ── State Transition + Trigger + Guard + Effects. */
      /* @__PURE__ */ jsxs(Fragment, { children: [
        isExpanded && fromState && toState && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("avl.transition") }),
          /* @__PURE__ */ jsxs("svg", { width: "100%", height: 44, viewBox: "0 0 280 44", children: [
            /* @__PURE__ */ jsx(AvlState, { x: 8, y: 8, name: fromState, role: getStateRole(), width: 90, height: 26 }),
            /* @__PURE__ */ jsx("line", { x1: 104, y1: 21, x2: 158, y2: 21, stroke: "var(--color-foreground)", strokeWidth: 2, markerEnd: "url(#orb-arrow)" }),
            /* @__PURE__ */ jsx(AvlState, { x: 164, y: 8, name: toState, role: getStateRole(), width: 90, height: 26 }),
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("marker", { id: "orb-arrow", markerWidth: 8, markerHeight: 6, refX: 8, refY: 3, orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,3 L0,6 Z", fill: "var(--color-foreground)" }) }) })
          ] }),
          traitName && /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: [
            traitName,
            entityName ? t("orbInspector.onEntity", { entity: entityName }) : ""
          ] })
        ] }),
        isExpanded && transitionEvent && /* @__PURE__ */ jsx(Box, { className: "px-4 py-2 border-b border-border/40", children: /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("svg", { width: 16, height: 16, children: /* @__PURE__ */ jsx(AvlEvent, { x: 8, y: 8, size: 12 }) }),
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold text-xs", children: transitionEvent })
        ] }) }),
        userType === "architect" && (transition?.guard ?? guard ?? editable) && isExpanded && /* @__PURE__ */ jsx(Box, { className: "px-4 py-2 border-b border-border/40", children: /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          /* @__PURE__ */ jsx("svg", { width: 16, height: 16, children: /* @__PURE__ */ jsx(AvlGuard, { x: 8, y: 8, size: 12 }) }),
          editable ? /* @__PURE__ */ jsx(
            Input,
            {
              defaultValue: formatExpression(transition?.guard ?? guard),
              placeholder: t("orbInspector.guardExpression"),
              className: "flex-1 text-xs font-mono h-6",
              onBlur: (e) => handleGuardChange(e.target.value)
            }
          ) : /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-mono text-xs text-muted-foreground", children: formatExpression(transition?.guard ?? guard) })
        ] }) }),
        userType === "architect" && (effectTypes.length > 0 || editable) && isExpanded && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: [
            t("avl.effects"),
            " (",
            effectTypes.length,
            ")"
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-1.5", children: effectTypes.map((type, i) => {
            const category = effectCategoryOf(type);
            const isKnown = category !== null;
            const catColor = category ? EFFECT_CATEGORY_COLORS[category] : void 0;
            return /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground text-xs w-4 text-right shrink-0", children: [
                i + 1,
                "."
              ] }),
              isKnown && /* @__PURE__ */ jsx("svg", { width: 16, height: 16, children: /* @__PURE__ */ jsx(AvlEffect, { x: 8, y: 8, effectType: type, size: 6, showBackground: true }) }),
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs flex-1", style: { color: catColor?.color }, children: effectSummary(type) }),
              editable && /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => handleRemoveEffect(i),
                  className: "shrink-0 p-0.5 h-6 w-6",
                  children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" })
                }
              )
            ] }, i);
          }) }),
          editable && /* @__PURE__ */ jsx(AddEffectButton, { onAdd: handleAddEffect })
        ] })
      ] })
    ) : (
      /* ── Inspector Tab (overview) ── orbital-scoped sections only. */
      /* @__PURE__ */ jsxs(Fragment, { children: [
        showEntityFields && entity && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("avl.entity") }),
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 mb-2", children: [
            /* @__PURE__ */ jsx("svg", { width: 14, height: 14, children: /* @__PURE__ */ jsx("circle", { cx: 7, cy: 7, r: 5, fill: "var(--color-primary)" }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold text-xs", children: entity.name }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: entity.persistence })
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-1", children: entity.fields.map((f3) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
            /* @__PURE__ */ jsx("svg", { width: 12, height: 12, children: /* @__PURE__ */ jsx(AvlFieldType, { x: 6, y: 6, kind: f3.type, size: 4 }) }),
            editable ? /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  defaultValue: f3.name,
                  className: "flex-1 text-xs font-mono h-6",
                  onBlur: (e) => {
                    if (e.target.value !== f3.name) {
                      handleUpdateField(f3.name, { name: e.target.value });
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsx(
                Select,
                {
                  value: f3.type,
                  options: FIELD_TYPE_OPTIONS2,
                  onValueChange: (v) => handleUpdateField(f3.name, { type: v }),
                  className: "w-20 text-xs h-6"
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => handleRemoveField(f3.name),
                  className: "shrink-0 p-0.5 h-6 w-6",
                  children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" })
                }
              )
            ] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono flex-1", children: f3.name }),
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: f3.type }),
              f3.required && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary text-[9px]", children: t("orbInspector.required") })
            ] })
          ] }, f3.name)) }),
          editable && /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "ghost",
              size: "sm",
              onClick: handleAddField,
              className: "mt-2 text-xs w-full",
              children: [
                /* @__PURE__ */ jsx(Icon, { name: "plus", size: "xs", className: "mr-1" }),
                t("orbInspector.addField")
              ]
            }
          )
        ] }),
        showServiceMode && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("orbInspector.serviceMode") }),
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center", children: [
            /* @__PURE__ */ jsxs(
              Button,
              {
                variant: hasRenderUi ? "primary" : "ghost",
                size: "sm",
                className: "flex-1 text-xs",
                onClick: () => {
                  if (!hasRenderUi) eventBus.emit("UI:SERVICE_MODE_TOGGLE", { orbitalName: node.orbitalName, standalone: true });
                },
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "monitor", size: "xs", className: "mr-1" }),
                  t("orbInspector.standalone")
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              Button,
              {
                variant: hasRenderUi ? "ghost" : "primary",
                size: "sm",
                className: "flex-1 text-xs",
                onClick: () => {
                  if (hasRenderUi) eventBus.emit("UI:SERVICE_MODE_TOGGLE", { orbitalName: node.orbitalName, standalone: false });
                },
                children: [
                  /* @__PURE__ */ jsx(Icon, { name: "cpu", size: "xs", className: "mr-1" }),
                  t("orbInspector.embedded")
                ]
              }
            )
          ] }),
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs mt-1", children: hasRenderUi ? t("orbInspector.rendersOwnUi") : t("orbInspector.headless") })
        ] }),
        showTraits && /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 border-b border-border/40", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("avl.traits") }),
          /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-1", children: traits.map((tr) => /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-semibold", children: tr.name }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: t("orbInspector.statesCount", { count: tr.stateCount }) })
          ] }, tr.name)) })
        ] })
      ] })
    ) })
  ] });
}
function AddEffectButton({ onAdd }) {
  const [open, setOpen] = useState(false);
  const { t } = useTranslate();
  return /* @__PURE__ */ jsxs(Box, { className: "relative mt-2", children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        variant: "ghost",
        size: "sm",
        onClick: () => setOpen((prev) => !prev),
        className: "text-xs w-full",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "plus", size: "xs", className: "mr-1" }),
          t("orbInspector.addEffect")
        ]
      }
    ),
    open && /* @__PURE__ */ jsx(Box, { className: "absolute z-20 top-full left-0 right-0 mt-1 bg-card border border-border rounded-md shadow-lg overflow-hidden", children: EFFECT_TYPE_OPTIONS.map((opt) => /* @__PURE__ */ jsxs(
      Box,
      {
        className: "px-3 py-1.5 text-xs cursor-pointer hover:bg-muted/50 flex items-center gap-2",
        ...pressableProps(() => {
          onAdd(opt.value);
          setOpen(false);
        }),
        children: [
          effectCategoryOf(opt.value) !== null && /* @__PURE__ */ jsx("svg", { width: 14, height: 14, children: /* @__PURE__ */ jsx(AvlEffect, { x: 7, y: 7, effectType: opt.value, size: 5, showBackground: true }) }),
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs", children: opt.label })
        ]
      },
      opt.value
    )) })
  ] });
}
function OrbPatternTree({ config, depth }) {
  if (!config || typeof config !== "object") return null;
  const { type, children, ...props } = config;
  if (typeof type !== "string") return null;
  const propEntries = Object.entries(props).filter(([k]) => k !== "type");
  return /* @__PURE__ */ jsxs(Box, { style: { paddingLeft: depth * 12 }, children: [
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary font-semibold text-xs", children: type }),
    propEntries.slice(0, 5).map(([key, val]) => {
      const display = typeof val === "string" ? val.startsWith("@") ? /* @__PURE__ */ jsx("span", { className: "text-primary", children: val }) : `"${val}"` : Array.isArray(val) && val.length > 0 && typeof val[0] === "string" && val[0].includes("/") ? /* @__PURE__ */ jsxs("span", { className: "text-warning", children: [
        "(",
        val.map(String).join(" "),
        ")"
      ] }) : String(val);
      return /* @__PURE__ */ jsxs(Box, { className: "flex gap-1 text-xs", children: [
        /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          key,
          ":"
        ] }),
        /* @__PURE__ */ jsx("span", { children: display })
      ] }, key);
    }),
    Array.isArray(children) && children.map((child, i) => /* @__PURE__ */ jsx(OrbPatternTree, { config: child, depth: depth + 1 }, i))
  ] });
}
OrbInspector.displayName = "OrbInspector";
var PHASE_2_TOKEN_FALLBACK = {
  button: ["--color-primary", "--color-primary-foreground", "--radius-md", "--shadow-sm"],
  badge: ["--color-primary", "--radius-full"],
  card: ["--color-card", "--color-border", "--radius-lg", "--shadow-main"],
  input: ["--color-input", "--color-border", "--radius-md"],
  typography: ["--color-foreground", "--color-muted-foreground"],
  divider: ["--color-border"],
  avatar: ["--radius-full", "--color-muted"],
  alert: ["--color-warning", "--color-success", "--color-danger", "--radius-md"],
  modal: ["--color-card", "--shadow-lg", "--radius-lg"],
  toast: ["--color-card", "--shadow-lg", "--radius-md"]
};
function StylesTab({ patternType, patternDef, patternConfig, editable, onPropChange, onTokenChange, themeManifest, isDesignSystem, offsetInParent }) {
  const { t } = useTranslate();
  if (!patternType) {
    return /* @__PURE__ */ jsx(Box, { className: "p-4", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: t("orbInspector.selectPatternForStyles") }) });
  }
  const tier = patternDef?.category ?? t("orbInspector.pattern");
  const tokens = PHASE_2_TOKEN_FALLBACK[patternType] ?? [];
  const variantEnum = patternDef?.propsSchema?.variant?.enumValues;
  const sizeEnum = patternDef?.propsSchema?.size?.enumValues;
  const currentVariant = patternConfig && typeof patternConfig.variant === "string" ? patternConfig.variant : void 0;
  const currentSize = patternConfig && typeof patternConfig.size === "string" ? patternConfig.size : void 0;
  return /* @__PURE__ */ jsxs(Box, { className: "px-4 py-3 flex flex-col gap-4", children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-semibold text-xs", children: patternType }),
      /* @__PURE__ */ jsx(
        Box,
        {
          className: "rounded px-1.5 py-0.5 text-[9px] font-mono uppercase tracking-wider",
          style: { backgroundColor: "var(--color-muted)", color: "var(--color-muted-foreground)" },
          children: tier
        }
      )
    ] }),
    /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("orbInspector.tokens") }),
      tokens.length === 0 ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs italic", children: t("orbInspector.noTokenContract") }) : /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-1", children: tokens.map((token) => /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-mono text-xs", children: token }) }, token)) })
    ] }),
    variantEnum && variantEnum.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("orbInspector.variant") }),
      /* @__PURE__ */ jsx(Box, { className: "flex flex-wrap gap-1", children: variantEnum.map((variant) => {
        const isActive = variant === currentVariant || !currentVariant && variant === "default";
        return /* @__PURE__ */ jsx(
          Box,
          {
            as: editable ? "button" : "div",
            onClick: editable ? () => onPropChange("variant", variant) : void 0,
            "aria-pressed": editable ? isActive : void 0,
            className: `rounded px-2 py-0.5 text-xs font-mono ${editable ? "cursor-pointer hover:opacity-80 transition-opacity" : ""}`,
            style: {
              backgroundColor: isActive ? "var(--color-primary)" : "var(--color-muted)",
              color: isActive ? "var(--color-primary-foreground)" : "var(--color-muted-foreground)"
            },
            children: variant
          },
          variant
        );
      }) })
    ] }),
    sizeEnum && sizeEnum.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-xs uppercase tracking-wider mb-2", children: t("orbInspector.size") }),
      /* @__PURE__ */ jsx(Box, { className: "flex flex-wrap gap-1", children: sizeEnum.map((size2) => {
        const isActive = size2 === currentSize || !currentSize && size2 === "md";
        return /* @__PURE__ */ jsx(
          Box,
          {
            as: editable ? "button" : "div",
            onClick: editable ? () => onPropChange("size", size2) : void 0,
            "aria-pressed": editable ? isActive : void 0,
            className: `rounded px-2 py-0.5 text-xs font-mono ${editable ? "cursor-pointer hover:opacity-80 transition-opacity" : ""}`,
            style: {
              backgroundColor: isActive ? "var(--color-primary)" : "var(--color-muted)",
              color: isActive ? "var(--color-primary-foreground)" : "var(--color-muted-foreground)"
            },
            children: size2
          },
          size2
        );
      }) })
    ] }),
    editable && !isDesignSystem && /* @__PURE__ */ jsx(
      AppearanceSection,
      {
        patternConfig,
        themeManifest,
        onPropChange,
        onTokenChange,
        offsetInParent
      }
    ),
    isDesignSystem && themeManifest && editable && /* @__PURE__ */ jsx(TokenEditorSection, { themeManifest, onTokenChange })
  ] });
}
var TOKEN_GROUPS = [
  { group: "colors", labelKey: "orbInspector.tokenGroup.colors" },
  { group: "radii", labelKey: "orbInspector.tokenGroup.radii" },
  { group: "spacing", labelKey: "orbInspector.tokenGroup.spacing" },
  { group: "shadows", labelKey: "orbInspector.tokenGroup.shadows" }
];
function TokenEditorSection({ themeManifest, onTokenChange }) {
  const { t } = useTranslate();
  const tokens = themeManifest.tokens ?? {};
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-3 pt-2 border-t border-border/40", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs uppercase tracking-wider text-muted-foreground", children: t("orbInspector.projectThemeTokens") }),
    TOKEN_GROUPS.map(({ group, labelKey }) => {
      const entries = Object.entries(tokens[group] ?? {});
      if (entries.length === 0) return null;
      return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1.5", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground", children: t(labelKey) }),
        entries.map(([key, value]) => /* @__PURE__ */ jsx(
          TokenRow,
          {
            group,
            tokenKey: key,
            value: String(value),
            isColor: group === "colors",
            onTokenChange
          },
          key
        ))
      ] }, group);
    })
  ] });
}
function TokenRow({ group, tokenKey, value, isColor, onTokenChange }) {
  return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
    isColor && /* @__PURE__ */ jsx(
      Box,
      {
        className: "w-4 h-4 rounded border border-border/40 shrink-0",
        style: { backgroundColor: value }
      }
    ),
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-mono text-xs text-muted-foreground w-24 shrink-0 truncate", children: tokenKey }),
    /* @__PURE__ */ jsx(
      Input,
      {
        value,
        onChange: (e) => onTokenChange({ group, key: tokenKey }, e.target.value),
        className: "flex-1 text-xs font-mono"
      }
    )
  ] });
}
var COLOR_ROWS = [
  { utility: "bg", labelKey: "orbInspector.fill" },
  { utility: "text", labelKey: "orbInspector.textColor" },
  { utility: "border", labelKey: "orbInspector.borderColor" }
];
var SIZE_ROWS = [
  { utility: "w", labelKey: "orbInspector.width" },
  { utility: "h", labelKey: "orbInspector.height" }
];
var LIMIT_ROWS = [
  { axis: "w", limit: "min", labelKey: "orbInspector.minWidth" },
  { axis: "w", limit: "max", labelKey: "orbInspector.maxWidth" },
  { axis: "h", limit: "min", labelKey: "orbInspector.minHeight" },
  { axis: "h", limit: "max", labelKey: "orbInspector.maxHeight" }
];
var CONSTRAINTS = ["start", "end", "both", "center", "scale"];
var CONSTRAINT_LABELS = {
  x: { start: "orbInspector.pinLeft", end: "orbInspector.pinRight", both: "orbInspector.pinLeftRight", center: "orbInspector.pinCenter", scale: "orbInspector.pinScale" },
  y: { start: "orbInspector.pinTop", end: "orbInspector.pinBottom", both: "orbInspector.pinTopBottom", center: "orbInspector.pinCenter", scale: "orbInspector.pinScale" }
};
function classesOf(config) {
  const value = config?.className;
  if (value === void 0 || value === null) return [];
  return typeof value === "string" ? value.split(/\s+/).filter(Boolean) : null;
}
function classFor(classes, prefix) {
  return classes.find((c) => !c.includes(":") && c.startsWith(prefix));
}
function AppearanceSection({ patternConfig, themeManifest, onPropChange, onTokenChange, offsetInParent }) {
  const { t } = useTranslate();
  const [scope, setScope] = useState("local");
  const [custom, setCustom] = useState("");
  const [customRefused, setCustomRefused] = useState(false);
  const classes = classesOf(patternConfig);
  if (classes === null) {
    return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-2 pt-2 border-t border-border/40", "data-testid": "inspector-appearance", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs uppercase tracking-wider text-muted-foreground", children: t("orbInspector.appearance") }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: t("orbInspector.classNameIsBinding") })
    ] });
  }
  const setClass = (next) => onPropChange("className", cn(classes.join(" "), next));
  const tokenValue = (token) => {
    const group = themeManifest?.tokens?.[token.group];
    return group ? String(group[token.key] ?? "") : "";
  };
  const globalEditor = (current) => {
    const token = current ? tokenOfDesignClass(current) : null;
    if (!token) {
      return /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: t("orbInspector.notThemeBacked") });
    }
    return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: t("orbInspector.globalAffects", { token: `${token.group}.${token.key}` }) }),
      /* @__PURE__ */ jsx(
        Input,
        {
          value: tokenValue(token),
          "aria-label": `${token.group}.${token.key}`,
          onChange: (e) => onTokenChange({ group: token.group, key: token.key }, e.target.value),
          className: "text-xs font-mono"
        }
      )
    ] });
  };
  return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-3 pt-2 border-t border-border/40", "data-testid": "inspector-appearance", children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs uppercase tracking-wider text-muted-foreground", children: t("orbInspector.appearance") }),
      /* @__PURE__ */ jsx(Box, { className: "flex rounded-md border border-border/60 overflow-hidden", role: "group", "aria-label": t("orbInspector.editScope"), children: ["local", "global"].map((s) => /* @__PURE__ */ jsx(
        Button,
        {
          variant: scope === s ? "primary" : "ghost",
          size: "sm",
          "aria-pressed": scope === s,
          "data-testid": `inspector-scope-${s}`,
          onClick: () => setScope(s),
          className: "rounded-none h-6 px-2 text-xs",
          children: t(s === "local" ? "orbInspector.scopeLocal" : "orbInspector.scopeGlobal")
        },
        s
      )) })
    ] }),
    COLOR_ROWS.map(({ utility, labelKey }) => {
      const current = classFor(classes, `${utility}-`);
      return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1.5", "data-testid": `inspector-${utility}`, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground", children: t(labelKey) }),
        scope === "global" ? globalEditor(current) : /* @__PURE__ */ jsx(Box, { className: "flex flex-wrap gap-1", children: DESIGN_COLOR_TOKENS.map((token) => {
          const cls = `${utility}-${token}`;
          return /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              title: cls,
              "aria-label": cls,
              "aria-pressed": current === cls,
              onClick: () => setClass(cls),
              className: `w-5 h-5 p-0 min-w-0 rounded border ${current === cls ? "ring-2 ring-primary" : "border-border/60"}`,
              style: { backgroundColor: `var(--color-${token})` }
            },
            token
          );
        }) })
      ] }, utility);
    }),
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1.5", "data-testid": "inspector-radius", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground", children: t("orbInspector.radius") }),
      scope === "global" ? globalEditor(classFor(classes, "rounded-")) : /* @__PURE__ */ jsx(Box, { className: "flex flex-wrap gap-1", children: DESIGN_RADIUS_TOKENS.map((token) => {
        const cls = `rounded-${token}`;
        const active = classFor(classes, "rounded-") === cls;
        return /* @__PURE__ */ jsx(
          Button,
          {
            variant: active ? "primary" : "secondary",
            size: "sm",
            "aria-pressed": active,
            onClick: () => setClass(cls),
            className: "h-6 px-2 text-xs font-mono",
            children: token
          },
          token
        );
      }) })
    ] }),
    SIZE_ROWS.map(({ utility, labelKey }) => {
      const sizing = sizingOf(classes, utility);
      const current = sizing.mode === "fixed" ? `${utility}-${sizing.step}` : sizing.mode;
      return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", "data-testid": `inspector-${utility}`, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground w-12 shrink-0", children: t(labelKey) }),
        scope === "global" ? globalEditor(sizing.mode === "fixed" ? `${utility}-${sizing.step}` : void 0) : /* @__PURE__ */ jsx(
          Select,
          {
            value: current,
            "aria-label": t(labelKey),
            options: [
              { value: "hug", label: t("orbInspector.sizingHug") },
              { value: "fill", label: t("orbInspector.sizingFill") },
              ...DESIGN_SPACING_SCALE.map((step) => ({ value: `${utility}-${step}`, label: String(step) }))
            ],
            onValueChange: (v) => {
              if (v === "hug" || v === "fill") {
                onPropChange("className", withSizing(classes, utility, { mode: v }).join(" "));
                return;
              }
              const step = DESIGN_SPACING_SCALE.find((s) => `${utility}-${s}` === v);
              if (step !== void 0) onPropChange("className", withSizing(classes, utility, { mode: "fixed", step }).join(" "));
            },
            className: "flex-1 text-xs h-6"
          }
        )
      ] }, utility);
    }),
    LIMIT_ROWS.map(({ axis, limit, labelKey }) => {
      const prefix = `${limit}-${axis}-`;
      const step = sizeLimitOf(classes, axis, limit);
      const current = step !== null ? String(step) : classFor(classes, prefix) ? "custom" : "none";
      return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", "data-testid": `inspector-${limit}-${axis}`, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground w-12 shrink-0", children: t(labelKey) }),
        scope === "global" ? globalEditor(classFor(classes, prefix)) : /* @__PURE__ */ jsx(
          Select,
          {
            value: current,
            "aria-label": t(labelKey),
            options: [
              { value: "none", label: t("orbInspector.limitNone") },
              ...current === "custom" ? [{ value: "custom", label: t("orbInspector.custom") }] : [],
              ...DESIGN_SPACING_SCALE.map((s) => ({ value: String(s), label: String(s) }))
            ],
            onValueChange: (v) => {
              if (v === "none") {
                onPropChange("className", withSizeLimit(classes, axis, limit, null).join(" "));
                return;
              }
              const next = DESIGN_SPACING_SCALE.find((s) => String(s) === v);
              if (next !== void 0) onPropChange("className", withSizeLimit(classes, axis, limit, next).join(" "));
            },
            className: "flex-1 text-xs h-6"
          }
        )
      ] }, prefix);
    }),
    (() => {
      const position = positionOf(classes);
      const write = (next) => onPropChange("className", withPosition(classes, next).join(" "));
      return /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1.5", "data-testid": "inspector-position", children: [
        /* @__PURE__ */ jsx(
          Switch,
          {
            checked: position.absolute,
            label: t("orbInspector.absolute"),
            disabled: !offsetInParent && !position.absolute,
            onChange: (on) => {
              if (!on) write({ ...position, absolute: false });
              else if (offsetInParent) write({ absolute: true, x: axisPositionFrom("x", "start", offsetInParent), y: axisPositionFrom("y", "start", offsetInParent) });
            }
          }
        ),
        position.absolute && ["x", "y"].map((axis) => /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", "data-testid": `inspector-constraint-${axis}`, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground w-12 shrink-0", children: t(axis === "x" ? "orbInspector.constraintHorizontal" : "orbInspector.constraintVertical") }),
          /* @__PURE__ */ jsx(
            Select,
            {
              value: position[axis].constraint,
              "aria-label": t(axis === "x" ? "orbInspector.constraintHorizontal" : "orbInspector.constraintVertical"),
              options: CONSTRAINTS.map((c) => ({ value: c, label: t(CONSTRAINT_LABELS[axis][c]) })),
              disabled: !offsetInParent,
              onValueChange: (v) => {
                const constraint = CONSTRAINTS.find((c) => c === v);
                if (constraint && offsetInParent) write({ ...position, [axis]: axisPositionFrom(axis, constraint, offsetInParent) });
              },
              className: "flex-1 text-xs h-6"
            }
          )
        ] }, axis))
      ] });
    })(),
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-col gap-1", "data-testid": "inspector-custom", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground", children: t("orbInspector.custom") }),
      scope === "global" ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-muted-foreground", children: t("orbInspector.notThemeBacked") }) : /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            value: custom,
            placeholder: "w-[243px]",
            "aria-label": t("orbInspector.custom"),
            onChange: (e) => {
              setCustom(e.target.value);
              setCustomRefused(false);
            },
            onKeyDown: (e) => {
              if (e.key !== "Enter") return;
              const value = custom.trim();
              if (!isArbitraryClass(value)) {
                setCustomRefused(true);
                return;
              }
              setClass(value);
              setCustom("");
            },
            className: "text-xs font-mono"
          }
        ),
        customRefused && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs text-error", children: t("orbInspector.customRefused") })
      ] })
    ] }),
    ["gap", "padding"].map((row) => {
      const spacing = spacingOf(classes);
      const uniform = spacing.top === spacing.right && spacing.right === spacing.bottom && spacing.bottom === spacing.left;
      const current = row === "gap" ? String(spacing.gap) : uniform ? String(spacing.top) : "mixed";
      const tokenClass = classFor(classes, row === "gap" ? "gap-" : "p-");
      const label = t(row === "gap" ? "orbInspector.gap" : "orbInspector.padding");
      return /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", "data-testid": `inspector-${row}`, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-xs font-mono text-muted-foreground w-12 shrink-0", children: label }),
        scope === "global" ? globalEditor(tokenClass) : /* @__PURE__ */ jsx(
          Select,
          {
            value: current,
            "aria-label": label,
            options: [
              ...current === "mixed" ? [{ value: "mixed", label: t("orbInspector.mixed") }] : [],
              ...DESIGN_SPACING_SCALE.map((step) => ({ value: String(step), label: String(step) }))
            ],
            onValueChange: (v) => {
              const step = DESIGN_SPACING_SCALE.find((s) => String(s) === v);
              if (step === void 0) return;
              const change = row === "gap" ? { gap: step } : { top: step, right: step, bottom: step, left: step };
              onPropChange("className", withSpacing(classes, change).join(" "));
            },
            className: "flex-1 text-xs h-6"
          }
        )
      ] }, row);
    })
  ] });
}
var AVL_GRAPH_NODE_TYPES = {
  dependency: DependencyNode,
  dependencyColumn: DependencyColumnNode
};
function AvlGraphCanvas({ fitPadding, compact = false, children, ...flow }) {
  return /* @__PURE__ */ jsxs(
    ReactFlow,
    {
      zoomOnDoubleClick: false,
      minZoom: 0.1,
      maxZoom: 2,
      fitView: true,
      fitViewOptions: { padding: fitPadding },
      proOptions: { hideAttribution: true },
      style: { background: "var(--color-background)" },
      ...flow,
      children: [
        !compact && /* @__PURE__ */ jsx(
          Controls,
          {
            showInteractive: false,
            style: {
              background: "var(--color-card)",
              border: "1px solid var(--color-border)",
              borderRadius: "var(--radius-md)"
            }
          }
        ),
        /* @__PURE__ */ jsx(Background, { variant: BackgroundVariant.Dots, gap: 20, size: 1, color: "var(--color-border)" }),
        children
      ]
    }
  );
}
var flowCanvasLog = createLogger("almadar:ui:flow-canvas");
var NODE_TYPES = {
  preview: OrbPreviewNode,
  traitCard: TraitCardNode
};
flowCanvasLog.debug("node-type-registry", () => ({
  registered: Object.keys(NODE_TYPES),
  preview: typeof OrbPreviewNode,
  previewIsValid: typeof OrbPreviewNode === "function" || typeof OrbPreviewNode === "object" && OrbPreviewNode !== null
}));
var DEFAULT_EDGE_OPTIONS = {
  markerEnd: { type: MarkerType.ArrowClosed, width: 12, height: 12 }
};
var NO_SYSTEM_MAP = { openTraits: () => void 0 };
var DEFAULT_TRAIT_VIEW = { lens: "flow", filter: null };
function isPreviewCard(n) {
  return n.type === "preview";
}
function withCardWidth(n, width) {
  return isPreviewCard(n) ? { ...n, data: { ...n.data, cardWidth: width } } : n;
}
function FlowCanvasInner({
  schema: schemaProp,
  mockData,
  className,
  width = "100%",
  height = 500,
  onNodeClick,
  onFocusChange,
  initialOrbital,
  initialLevel,
  focusedOrbital: focusedOrbitalProp,
  initialSelectedNode,
  editable,
  onSchemaChange,
  onPatternDelete,
  tools = CANVAS_TOOLS,
  elementAccess,
  onEventWire,
  behaviorMeta,
  orbitalStatus,
  layoutHint,
  onNodeSelect,
  userType = "builder",
  verify,
  themeManifest,
  nodePositions,
  onPositionsChange,
  onSelectedNodeChange,
  onSelectedPatternChange,
  externalInspector = false,
  scene,
  systemMap,
  systemDependencies,
  openBehaviorEvent,
  traitView: traitViewProp,
  onTraitViewChange
}) {
  const { t } = useTranslate();
  const NODE_TYPES2 = useMemo(() => ({
    preview: OrbPreviewNode,
    traitCard: TraitCardNode,
    system: SystemNode,
    systemBand: SystemBandNode,
    dependency: DependencyNode,
    dependencyColumn: DependencyColumnNode
  }), []);
  const EDGE_TYPES_LOCAL = useMemo(() => ({
    eventFlow: EventFlowEdge
  }), []);
  flowCanvasLog.debug("node-type-registry:render", () => ({
    registered: Object.keys(NODE_TYPES2),
    preview: typeof OrbPreviewNode,
    previewIsValid: typeof OrbPreviewNode === "function" || typeof OrbPreviewNode === "object" && OrbPreviewNode !== null
  }));
  const parsedSchema = useMemo(() => {
    if (typeof schemaProp === "string") return JSON.parse(schemaProp);
    return schemaProp;
  }, [schemaProp]);
  const traitLevel = initialLevel === "trait-expanded";
  const systemLevel = initialLevel === "system";
  const [systemQuery, setSystemQuery] = useState("");
  const [wiresOnly, setWiresOnly] = useState(false);
  const [lens, setLens] = useState("events");
  const [dependencySelection, setDependencySelection] = useState(null);
  const dependencyLens = systemLevel && lens === "dependencies" && systemDependencies !== void 0;
  const [ownTraitView, setOwnTraitView] = useState(DEFAULT_TRAIT_VIEW);
  const traitView = traitViewProp ?? ownTraitView;
  const setTraitView = useCallback((next) => {
    setOwnTraitView(next);
    onTraitViewChange?.(next);
  }, [onTraitViewChange]);
  const traitLens = traitView.lens;
  const traitFilter = useMemo(() => traitView.filter ? { unit: traitView.filter.unit, traits: new Set(traitView.filter.traits) } : null, [traitView.filter]);
  const flowLens = traitLevel && traitLens === "flow";
  const fitPadding = systemLevel || flowLens ? 0.08 : 0.25;
  const compact = useCompactLayout();
  const [scope, setScope] = useState("local");
  const scopeRef = React93__default.useRef(scope);
  scopeRef.current = scope;
  const [focusRequest, setFocusRequest] = useState(focusedOrbitalProp ?? initialOrbital);
  const [stateByOrbital, setStateByOrbital] = useState({});
  const fitFocusedRef = React93__default.useRef(false);
  const pendingFitRef = React93__default.useRef(null);
  const fittedViewRef = React93__default.useRef(null);
  useEffect(() => {
    if (focusedOrbitalProp === void 0) return;
    fitFocusedRef.current = true;
    setFocusRequest(focusedOrbitalProp);
  }, [focusedOrbitalProp]);
  const screenSizeUserOverrideRef = React93__default.useRef(false);
  const [screenSize, setScreenSize] = useState(
    () => typeof window === "undefined" ? "laptop" : detectScreenSize(window.innerWidth)
  );
  useEffect(() => {
    if (typeof window === "undefined") return void 0;
    const onResize = () => {
      if (screenSizeUserOverrideRef.current) return;
      setScreenSize(detectScreenSize(window.innerWidth));
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const pickScreenSize = useCallback((size2) => {
    screenSizeUserOverrideRef.current = true;
    setScreenSize(size2);
  }, []);
  const [selectedNode, setSelectedNodeInternal] = useState(initialSelectedNode ?? null);
  const setSelectedNode = useCallback((node) => {
    setSelectedNodeInternal(node);
    onSelectedNodeChange?.(node);
  }, [onSelectedNodeChange]);
  const [selectedPattern, setSelectedPatternInternal] = useState(null);
  const setSelectedPattern = useCallback((p) => {
    setSelectedPatternInternal(p);
    onSelectedPatternChange?.(p);
  }, [onSelectedPatternChange]);
  const patternSelectionValue = useMemo(() => ({
    selected: selectedPattern,
    select: (p) => {
      setSelectedPattern(p);
      if (p) setSelectedNode(p.nodeData);
    }
  }), [selectedPattern, setSelectedNode, setSelectedPattern]);
  const stateView = userType === "designer" ? "screens" : "transitions";
  const { canvas, traitExpandedNodes, traitExpandedEdges } = useMemo(() => {
    const t2 = perfStart("canvas-graph");
    const view = canvasViewGraph(parsedSchema, {
      scope,
      focusedOrbital: focusRequest,
      stateByOrbital,
      view: stateView,
      mockData,
      behaviorMeta,
      layoutHint,
      orbitalStatus,
      screenSize
    });
    const traitExpanded = traitLevel && initialOrbital ? orbitalToTraitGraph(parsedSchema, initialOrbital) : { nodes: [], edges: [] };
    perfEnd("canvas-graph", t2, {
      canvasNodes: view.nodes.length,
      traitExpandedNodes: traitExpanded.nodes.length,
      orbitalCount: parsedSchema.orbitals?.length ?? 0
    });
    return {
      canvas: view,
      traitExpandedNodes: traitExpanded.nodes,
      traitExpandedEdges: traitExpanded.edges
    };
  }, [parsedSchema, scope, focusRequest, stateByOrbital, stateView, traitLevel, initialOrbital, behaviorMeta, layoutHint, mockData, orbitalStatus, screenSize]);
  const focusedOrbital = canvas.focusedOrbital;
  const orbitalNames = useMemo(() => (parsedSchema.orbitals ?? []).map((o) => o.name), [parsedSchema]);
  const systemGraph = useMemo(() => systemLevel ? schemaToSystemGraph(parsedSchema) : null, [systemLevel, parsedSchema]);
  const systemNodes = useMemo(() => {
    if (!systemGraph) return [];
    const q = systemQuery.trim().toLowerCase();
    const matches = (d) => [d.orbitalName, d.entityName ?? "", ...d.wireEvents ?? []].some((text) => text.toLowerCase().includes(q));
    return systemGraph.nodes.filter((n) => !wiresOnly || n.data.bandKind === "connected" || n.data.kind === "system-orbital" && (n.data.wireEvents?.length ?? 0) > 0).map((n) => q && n.data.kind === "system-orbital" && !matches(n.data) ? { ...n, style: { opacity: 0.25 } } : n);
  }, [systemGraph, systemQuery, wiresOnly]);
  const dependencyGraph = useMemo(() => dependencyLens && systemDependencies ? schemaToDependencyGraph(systemDependencies) : null, [dependencyLens, systemDependencies]);
  const reach = useMemo(
    () => dependencySelection && systemDependencies ? dependencyReach(systemDependencies, dependencySelection) : null,
    [dependencySelection, systemDependencies]
  );
  const dependencyNodes = useMemo(() => {
    if (!dependencyGraph) return [];
    const q = systemQuery.trim().toLowerCase();
    return dependencyGraph.nodes.map((n) => {
      if (n.data.kind !== "dependency") return n;
      const role = !reach ? q && !n.data.orbitalName.toLowerCase().includes(q) ? "dim" : void 0 : n.id === dependencySelection ? "selected" : reach.upstream.has(n.id) ? "upstream" : reach.downstream.has(n.id) ? "downstream" : "dim";
      return role ? { ...n, data: { ...n.data, dependencyRole: role } } : n;
    });
  }, [dependencyGraph, reach, dependencySelection, systemQuery]);
  const dependencyEdges = useMemo(() => {
    if (!dependencyGraph) return [];
    const inUp = (id) => id === dependencySelection || (reach?.upstream.has(id) ?? false);
    const inDown = (id) => id === dependencySelection || (reach?.downstream.has(id) ?? false);
    return dependencyGraph.edges.map((e) => {
      const up = reach !== null && inUp(e.source) && reach.upstream.has(e.target);
      const down = reach !== null && inDown(e.target) && reach.downstream.has(e.source);
      const stroke = up ? "var(--color-primary)" : down ? "var(--color-warning)" : "var(--color-border)";
      return {
        ...e,
        type: "default",
        markerEnd: void 0,
        selectable: false,
        style: { stroke, strokeWidth: up || down ? 1.6 : 1, opacity: up || down ? 0.95 : reach ? 0.12 : 0.35 },
        data: { event: "" }
      };
    });
  }, [dependencyGraph, reach, dependencySelection]);
  const flow = useMemo(() => {
    if (!traitLevel || !initialOrbital) return null;
    const layers = Object.fromEntries(Object.entries(systemDependencies?.behaviors ?? {}).map(([name, b]) => [name, b.layer]));
    return traitFlowGraph(parsedSchema, initialOrbital, layers);
  }, [traitLevel, initialOrbital, parsedSchema, systemDependencies]);
  const flowCanvas = useMemo(() => flow ? traitFlowCanvas(flow) : null, [flow]);
  const flowReach = useMemo(() => flow && dependencySelection && flowLens ? flowNeighbors(flow.edges, dependencySelection) : null, [flow, dependencySelection, flowLens]);
  const flowNodes = useMemo(() => {
    if (!flowCanvas) return [];
    return flowCanvas.nodes.map((n) => {
      if (n.data.kind !== "dependency" || !flowReach) return n;
      const role = n.id === dependencySelection ? "selected" : flowReach.triggeredBy.has(n.id) && flowReach.triggers.has(n.id) ? "both" : flowReach.triggeredBy.has(n.id) ? "upstream" : flowReach.triggers.has(n.id) ? "downstream" : "dim";
      return { ...n, data: { ...n.data, dependencyRole: role } };
    });
  }, [flowCanvas, flowReach, dependencySelection]);
  const flowEdges = useMemo(() => {
    if (!flow) return [];
    return flow.edges.map((e) => {
      const into = dependencySelection !== null && e.target === dependencySelection;
      const out = dependencySelection !== null && e.source === dependencySelection;
      const stroke = into ? "var(--color-primary)" : out ? "var(--color-warning)" : "var(--color-border)";
      const drawn = flowCanvas?.edges.find((c) => c.id === `flow-${e.source}-${e.target}`);
      return {
        id: `flow-${e.source}-${e.target}`,
        source: e.source,
        target: e.target,
        ...drawn?.sourceHandle ? { sourceHandle: drawn.sourceHandle } : {},
        ...drawn?.targetHandle ? { targetHandle: drawn.targetHandle } : {},
        type: "default",
        selectable: false,
        style: { stroke, strokeWidth: into || out ? 1.8 : 1, opacity: into || out ? 0.95 : dependencySelection ? 0.14 : 0.4 },
        ...into || out ? {
          label: e.events.join(", "),
          labelStyle: { fill: stroke, fontSize: 10, fontFamily: "var(--font-mono, monospace)" },
          labelBgStyle: { fill: "var(--color-background)", stroke, strokeWidth: 0.8 },
          labelBgPadding: [6, 3],
          labelBgBorderRadius: 8
        } : {},
        data: { event: "" }
      };
    });
  }, [flow, flowCanvas, dependencySelection]);
  const selectedUnit = flowLens && flow ? flow.units.find((u) => u.id === dependencySelection) : void 0;
  const systemWireCount = systemGraph?.edges.length ?? 0;
  const systemOrbitalCount = systemGraph?.nodes.filter((n) => n.data.kind === "system-orbital").length ?? 0;
  const filteredTraitNodes = useMemo(
    () => traitFilter ? traitExpandedNodes.filter((n) => traitFilter.traits.has(n.data.traitName ?? "")) : traitExpandedNodes,
    [traitExpandedNodes, traitFilter]
  );
  const activeNodes = dependencyLens ? dependencyNodes : systemLevel ? systemNodes : flowLens ? flowNodes : traitLevel ? filteredTraitNodes : canvas.nodes;
  const activeEdges = dependencyLens ? dependencyEdges : systemGraph ? systemGraph.edges : flowLens ? flowEdges : traitLevel ? traitExpandedEdges : canvas.edges;
  const [nodes, setNodes, onNodesChange] = useNodesState(activeNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(activeEdges);
  const reactFlow = useReactFlow();
  const cameraMs = usePrefersReducedMotion() ? 0 : 300;
  const savedPositionsRef = React93__default.useRef(nodePositions);
  savedPositionsRef.current = nodePositions;
  const nodesRef = React93__default.useRef(nodes);
  nodesRef.current = nodes;
  useEffect(() => {
    setEdges([]);
    const saved = savedPositionsRef.current;
    const merged = saved ? activeNodes.map((n) => {
      const placement = saved[n.id];
      if (!placement) return n;
      const placed = scope === "world" ? { ...n, position: { x: placement.x, y: placement.y } } : n;
      return placement.width !== void 0 ? withCardWidth(placed, placement.width) : placed;
    }) : activeNodes;
    setNodes(merged);
    setEdges(activeEdges);
    const viewport = { scope, focusedOrbital, screenSize, ...systemLevel ? { level: dependencyLens ? "system-dependencies" : wiresOnly ? "system-wires" : "system" } : traitLevel ? { level: flowLens ? "trait-flow" : traitFilter ? `trait-cards:${traitFilter.unit}` : "trait-cards" } : {} };
    if (canvasViewChanged(fittedViewRef.current, viewport)) {
      pendingFitRef.current = { centreOn: fitFocusedRef.current && scope === "world" ? focusedOrbital : void 0 };
      fittedViewRef.current = viewport;
    }
    fitFocusedRef.current = false;
  }, [activeNodes, activeEdges, setNodes, setEdges, scope, focusedOrbital, screenSize, systemLevel, wiresOnly, dependencyLens, traitLevel, flowLens, traitFilter]);
  const nodesInitialized = useNodesInitialized();
  useEffect(() => {
    const pending = pendingFitRef.current;
    if (!nodesInitialized || !pending) return;
    pendingFitRef.current = null;
    void reactFlow.fitView({ duration: cameraMs, padding: fitPadding, ...pending.centreOn ? { nodes: [{ id: pending.centreOn }] } : {} });
  }, [nodesInitialized, nodes, reactFlow, fitPadding, cameraMs]);
  const visibleEdges = useMemo(() => {
    const nodeIds = new Set(nodes.map((n) => n.id));
    return edges.filter((e) => nodeIds.has(e.source) && nodeIds.has(e.target));
  }, [nodes, edges]);
  const focusOrbital = useCallback((orbital) => {
    fitFocusedRef.current = true;
    setFocusRequest(orbital);
  }, []);
  const stepFocus = useCallback((step) => {
    if (orbitalNames.length === 0) return;
    const at = focusedOrbital ? orbitalNames.indexOf(focusedOrbital) : -1;
    focusOrbital(orbitalNames[(at + step + orbitalNames.length) % orbitalNames.length]);
  }, [orbitalNames, focusedOrbital, focusOrbital]);
  const stateOptionsCache = useMemo(() => /* @__PURE__ */ new Map(), [parsedSchema, stateView, mockData]);
  const optionsOf = useCallback((orbital) => {
    const cached = stateOptionsCache.get(orbital);
    if (cached) return cached;
    const options = stateOptionsOf(parsedSchema, orbital, stateView, mockData);
    stateOptionsCache.set(orbital, options);
    return options;
  }, [stateOptionsCache, parsedSchema, stateView, mockData]);
  const chosenStateOf = useCallback((orbital) => {
    const asked = stateByOrbital[orbital];
    const options = optionsOf(orbital);
    const exists = asked === LIVE_STATE || [...options.own, ...options.groups.flatMap((g) => g.options)].some((o) => o.id === asked);
    return exists && asked !== void 0 ? asked : initialStateOf(options);
  }, [stateByOrbital, optionsOf]);
  useEffect(() => {
    if (!focusedOrbital || traitLevel || systemLevel) return;
    onFocusChange?.({ orbital: focusedOrbital, scope, state: chosenStateOf(focusedOrbital) });
  }, [focusedOrbital, scope, chosenStateOf, traitLevel, systemLevel, onFocusChange]);
  const statePicker = useMemo(() => ({
    optionsOf,
    chosen: chosenStateOf,
    choose: (orbital, stateId) => {
      setSelectedPattern(null);
      setSelectedNode(null);
      setStateByOrbital((prev) => ({ ...prev, [orbital]: stateId }));
    }
  }), [optionsOf, chosenStateOf, setSelectedPattern, setSelectedNode]);
  const handleNodeClick = useCallback((_, node) => {
    if (traitLevel || systemLevel) return;
    const nodeData = node.data;
    const orbitalName = nodeData.orbitalName ?? node.id;
    if (scope === "world" && orbitalName !== focusedOrbital) setFocusRequest(orbitalName);
    if (nodeData.traitName) {
      setSelectedNode(nodeData);
      onNodeClick?.({
        level: "code",
        orbital: orbitalName,
        trait: nodeData.traitName,
        transition: nodeData.transitionEvent
      });
      return;
    }
    onNodeClick?.({ level: "overview", orbital: orbitalName });
    onNodeSelect?.(orbitalName);
  }, [traitLevel, systemLevel, scope, focusedOrbital, onNodeClick, onNodeSelect, setSelectedNode]);
  const handleClosePanel = useCallback(() => {
    setSelectedNode(null);
  }, [setSelectedNode]);
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") {
      if (selectedNode) setSelectedNode(null);
    } else if (e.key === "Delete" || e.key === "Backspace") {
      if (isEditableTarget(e.target)) return;
      if (selectedPattern && selectedPattern.nodeData) {
        const patternIds = selectedPattern.selection ?? (selectedPattern.patternId ? [selectedPattern.patternId] : []);
        if (patternIds.length > 0) {
          onPatternDelete?.({ patternIds, nodeData: selectedPattern.nodeData, ...selectedPattern.elements ? { elements: selectedPattern.elements } : {} });
        }
        setSelectedPattern(null);
      }
    }
  }, [selectedNode, selectedPattern, onPatternDelete, setSelectedNode, setSelectedPattern]);
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);
  const handleCanvasKeyDown = useCallback((e) => {
    if (traitLevel || systemLevel || isEditableTarget(e.target)) return;
    if (e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey && orbitalNames.length > 1) {
      e.preventDefault();
      stepFocus(e.shiftKey ? -1 : 1);
    } else if (e.key === "Escape" && !selectedNode && !selectedPattern) {
      e.currentTarget.blur();
    }
  }, [traitLevel, systemLevel, orbitalNames.length, stepFocus, selectedNode, selectedPattern]);
  const eventBus = useEventBus();
  const handleConnect = useCallback((connection) => {
    if (!connection.sourceHandle?.startsWith("event-") || !onEventWire) return;
    const eventName = connection.sourceHandle.replace("event-", "");
    const sourceNode = nodes.find((n) => n.id === connection.source);
    const targetNode = nodes.find((n) => n.id === connection.target);
    if (!sourceNode || !targetNode) return;
    const srcData = sourceNode.data;
    const tgtData = targetNode.data;
    const sourceEventSource = srcData.eventSources?.find((es) => es.event === eventName);
    const sourcePayload = sourceEventSource?.payloadFields;
    const targetEventSource = tgtData.eventSources?.find((es) => es.event === eventName);
    const targetPayload = targetEventSource?.payloadFields;
    const validation = validateWire(sourcePayload, targetPayload);
    if (validation.warnings.length > 0) {
      eventBus.emit("UI:WIRE_VALIDATION_WARNING", {
        eventName,
        sourceOrbital: srcData.orbitalName,
        targetOrbital: tgtData.orbitalName,
        warnings: validation.warnings
      });
    }
    onEventWire({
      eventName,
      sourceOrbital: srcData.orbitalName ?? "",
      targetOrbital: tgtData.orbitalName ?? "",
      sourceTraitName: srcData.traitName,
      targetTraitName: tgtData.traitName
    });
  }, [nodes, onEventWire, eventBus]);
  const worldPositionsRef = React93__default.useRef(canvas.worldPositions);
  worldPositionsRef.current = canvas.worldPositions;
  const placementsOf = useCallback((list) => {
    const positions = { ...savedPositionsRef.current };
    for (const n of list) {
      const width2 = isPreviewCard(n) ? n.data.cardWidth : void 0;
      const at = scopeRef.current === "world" ? n.position : savedPositionsRef.current?.[n.id] ?? worldPositionsRef.current[n.id] ?? n.position;
      positions[n.id] = { x: at.x, y: at.y, ...typeof width2 === "number" ? { width: width2 } : {} };
    }
    return positions;
  }, []);
  const handleNodeDragStop = useCallback(() => {
    onPositionsChange?.(placementsOf(nodesRef.current));
  }, [onPositionsChange, placementsOf]);
  useEffect(() => eventBus.on("UI:CANVAS_SHOW_STATE", (e) => {
    const p = e.payload;
    const orbital = p?.orbital;
    const trait = p?.trait;
    const event = p?.event;
    const from = p?.from;
    const to = p?.to;
    if (typeof orbital !== "string" || typeof trait !== "string" || typeof event !== "string" || typeof from !== "string" || typeof to !== "string") return;
    const option = optionForPlayedStep(optionsOf(orbital), { trait, event, from, to });
    if (option) statePicker.choose(orbital, option);
  }), [eventBus, optionsOf, statePicker]);
  useEffect(() => eventBus.on("UI:CANVAS_CARD_RESIZED", (e) => {
    const nodeId = e.payload?.nodeId;
    const width2 = e.payload?.width;
    if (typeof nodeId !== "string" || typeof width2 !== "number") return;
    if (!nodesRef.current.some((n) => n.id === nodeId)) return;
    const next = nodesRef.current.map((n) => n.id === nodeId ? withCardWidth(n, width2) : n);
    setNodes(next);
    onPositionsChange?.(placementsOf(next));
  }), [eventBus, setNodes, onPositionsChange, placementsOf]);
  const screenSizeKeys = ["mobile", "tablet", "laptop", "wide"];
  const isScreenSize = (value) => screenSizeKeys.some((k) => k === value);
  const applyScreenSize = (size2) => {
    pickScreenSize(size2);
    requestAnimationFrame(() => {
      reactFlow.fitView({ duration: cameraMs, padding: 0.25 });
    });
  };
  const traitCardSelectionValue = useMemo(() => ({
    selectTransition: (sel) => {
      onNodeClick?.({
        level: "transition",
        orbital: sel.orbitalName,
        trait: sel.traitName,
        transition: sel.transitionEvent,
        transitionIndex: sel.index
      });
    },
    scene
  }), [onNodeClick, scene]);
  const showOrbitalNav = !traitLevel && !systemLevel && orbitalNames.length > 0;
  const systemMapValue = useMemo(() => ({
    ...systemMap ?? NO_SYSTEM_MAP,
    selectDependency: (id) => setDependencySelection((current) => current === id ? null : id)
  }), [systemMap]);
  const selectedDependency = dependencyGraph?.nodes.find((n) => n.id === dependencySelection)?.data;
  const selectedOrbital = selectedDependency?.dependencyColumn === "app" ? selectedDependency.orbitalName : null;
  const selectedBehavior = selectedDependency && selectedDependency.dependencyColumn !== "app" ? selectedDependency.orbitalName : null;
  return /* @__PURE__ */ jsx(ScreenSizeContext.Provider, { value: screenSize, children: /* @__PURE__ */ jsx(CanvasToolsContext.Provider, { value: tools, children: /* @__PURE__ */ jsx(CanvasStatePickerContext.Provider, { value: traitLevel || systemLevel ? null : statePicker, children: /* @__PURE__ */ jsx(CanvasVerifyContext.Provider, { value: verify ?? null, children: /* @__PURE__ */ jsx(SystemMapContext.Provider, { value: systemMapValue, children: /* @__PURE__ */ jsx(ElementEditAccessContext.Provider, { value: elementAccess ?? null, children: /* @__PURE__ */ jsx(PatternSelectionContext.Provider, { value: patternSelectionValue, children: /* @__PURE__ */ jsx(TraitCardSelectionContext.Provider, { value: traitCardSelectionValue, children: /* @__PURE__ */ jsxs(
    Box,
    {
      className: `flex flex-col h-full ${className ?? ""}`,
      style: { width, height },
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: "flex-shrink-0 flex flex-wrap items-center gap-2 px-3 py-2 border-b border-border/40 bg-background",
            "data-testid": "flow-canvas-toolbar",
            children: [
              systemLevel ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(ButtonGroup, { variant: "segmented", children: ["events", "dependencies"].map((l) => /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: lens === l ? "primary" : "ghost",
                    size: "sm",
                    "aria-pressed": lens === l,
                    disabled: l === "dependencies" && systemDependencies === void 0,
                    "data-testid": `system-map-lens-${l}`,
                    onClick: () => setLens(l),
                    children: t(l === "events" ? "avl.system.lensEvents" : "avl.system.lensDependencies")
                  },
                  l
                )) }),
                /* @__PURE__ */ jsx(Box, { className: "w-64 max-w-full", children: /* @__PURE__ */ jsx(
                  Input,
                  {
                    leftIcon: "search",
                    value: systemQuery,
                    onChange: (e) => setSystemQuery(e.target.value),
                    placeholder: t(dependencyLens ? "avl.deps.search" : "avl.system.search"),
                    "aria-label": t(dependencyLens ? "avl.deps.search" : "avl.system.search"),
                    "data-testid": "system-map-search",
                    className: "h-10 sm:h-7 py-0 text-sm"
                  }
                ) }),
                dependencyLens ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40 min-w-0", "data-testid": "dependency-summary", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate", children: selectedDependency ? t("avl.deps.selected", { name: selectedDependency.orbitalName, upstream: reach?.upstream.size ?? 0, downstream: reach?.downstream.size ?? 0 }) : t("avl.deps.hint") }) }),
                  selectedOrbital && systemMap ? /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "sm", rightIcon: "chevron-right", onClick: () => systemMap.openTraits(selectedOrbital), "data-testid": "dependency-open-traits", children: t("avl.system.openTraits") }) : null,
                  selectedOrbital && systemMap?.openCodeEvent ? /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "sm", leftIcon: "code", action: systemMap.openCodeEvent, actionPayload: { orbital: selectedOrbital }, children: t("avl.system.openCode") }) : null,
                  selectedBehavior && openBehaviorEvent ? /* @__PURE__ */ jsx(Button, { variant: "secondary", size: "sm", leftIcon: "code", action: openBehaviorEvent, actionPayload: { name: selectedBehavior }, children: t("avl.system.openCode") }) : null,
                  /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "ml-auto", "data-testid": "dependency-legend", children: [
                    /* @__PURE__ */ jsx(Box, { className: "w-2.5 h-2.5 rounded-sm bg-primary" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.deps.legendUpstream") }),
                    /* @__PURE__ */ jsx(Box, { className: "w-2.5 h-2.5 rounded-sm bg-warning" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.deps.legendDownstream") })
                  ] })
                ] }) : null,
                !dependencyLens ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40", "data-testid": "system-map-summary", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("avl.system.summary", { orbitals: systemOrbitalCount, wires: systemWireCount }) }) }),
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: wiresOnly ? "primary" : "ghost",
                      size: "sm",
                      "aria-pressed": wiresOnly,
                      disabled: systemWireCount === 0,
                      "data-testid": "system-map-wires-only",
                      onClick: () => setWiresOnly((w) => !w),
                      children: t("avl.system.wiresOnly")
                    }
                  )
                ] }) : null
              ] }) : showOrbitalNav ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsxs(Box, { "data-testid": "canvas-orbital-nav", className: "flex flex-nowrap items-center gap-1 min-w-0", children: [
                  /* @__PURE__ */ jsx(
                    IconButton,
                    {
                      icon: "chevron-left",
                      label: t("canvas.previousOrbital"),
                      tooltipPosition: "bottom",
                      className: "w-10 h-10 sm:w-7 sm:h-7",
                      "data-testid": "canvas-orbital-prev",
                      disabled: orbitalNames.length < 2,
                      onClick: () => stepFocus(-1)
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Select,
                    {
                      options: orbitalNames.map((name) => ({ value: name, label: name })),
                      value: focusedOrbital ?? "",
                      onValueChange: (value) => {
                        if (typeof value === "string") focusOrbital(value);
                      },
                      "aria-label": t("canvas.focusedOrbital"),
                      "data-testid": "canvas-orbital-picker",
                      className: "h-10 sm:h-7 py-0 text-sm min-w-0 max-w-[12rem]"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    IconButton,
                    {
                      icon: "chevron-right",
                      label: t("canvas.nextOrbital"),
                      tooltipPosition: "bottom",
                      className: "w-10 h-10 sm:w-7 sm:h-7",
                      "data-testid": "canvas-orbital-next",
                      disabled: orbitalNames.length < 2,
                      onClick: () => stepFocus(1)
                    }
                  )
                ] }),
                /* @__PURE__ */ jsx(ButtonGroup, { variant: "segmented", children: ["local", "world"].map((s) => /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: scope === s ? "primary" : "ghost",
                    size: "sm",
                    className: "h-10 sm:h-button-sm",
                    "aria-pressed": scope === s,
                    "data-testid": `canvas-scope-${s}`,
                    title: t(s === "local" ? "canvas.scopeLocalHint" : "canvas.scopeWorldHint"),
                    onClick: () => setScope(s),
                    children: t(s === "local" ? "canvas.scopeLocal" : "canvas.scopeWorld")
                  },
                  s
                )) })
              ] }) : traitLevel ? /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(ButtonGroup, { variant: "segmented", children: ["flow", "traits"].map((l) => /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: traitLens === l ? "primary" : "ghost",
                    size: "sm",
                    "aria-pressed": traitLens === l,
                    "data-testid": `trait-lens-${l}`,
                    onClick: () => setTraitView({ lens: l, filter: l === "flow" ? null : traitView.filter }),
                    children: t(l === "flow" ? "avl.flow.lensFlow" : "avl.flow.lensTraits")
                  },
                  l
                )) }),
                flowLens && flow ? /* @__PURE__ */ jsxs(Fragment, { children: [
                  /* @__PURE__ */ jsx(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40 min-w-0", "data-testid": "flow-summary", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate", children: selectedUnit ? t("avl.flow.selected", { name: selectedUnit.name, into: flowReach?.triggeredBy.size ?? 0, out: flowReach?.triggers.size ?? 0 }) : t("avl.flow.summary", {
                    traits: flow.units.reduce((n, u) => n + u.traits.length + u.renderPieces.length, 0),
                    own: flow.units.filter((u) => u.column === "own").length,
                    composed: flow.units.filter((u) => u.column !== "own").length,
                    pieces: flow.units.reduce((n, u) => n + u.renderPieces.length, 0)
                  }) }) }),
                  selectedUnit ? /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: "secondary",
                      size: "sm",
                      rightIcon: "chevron-right",
                      "data-testid": "flow-show-traits",
                      onClick: () => setTraitView({ lens: "traits", filter: { unit: selectedUnit.name, traits: [...selectedUnit.traits, ...selectedUnit.renderPieces] } }),
                      children: t("avl.flow.showTraits")
                    }
                  ) : null,
                  /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "ml-auto", children: [
                    /* @__PURE__ */ jsx(Box, { className: "w-2.5 h-2.5 rounded-sm bg-primary" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.flow.legendInto") }),
                    /* @__PURE__ */ jsx(Box, { className: "w-2.5 h-2.5 rounded-sm bg-warning" }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("avl.flow.legendOut") })
                  ] })
                ] }) : traitFilter ? /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40", "data-testid": "trait-filter", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "small", children: t("avl.flow.showing", { name: traitFilter.unit, count: traitFilter.traits.size }) }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: () => setTraitView({ lens: "traits", filter: null }), "data-testid": "trait-filter-clear", children: t("avl.flow.showAll") })
                ] }) : /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-medium", children: initialOrbital ?? t("canvas.overview") }),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("canvas.modulesCount", { count: nodes.length }) })
                ] })
              ] }) : /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 px-3 py-1.5 rounded-md bg-card/80 border border-border/40 backdrop-blur-sm", children: [
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "font-medium", children: traitLevel ? initialOrbital ?? t("canvas.overview") : t("canvas.overview") }),
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("canvas.modulesCount", { count: nodes.length }) })
              ] }),
              !systemLevel && !flowLens && /* @__PURE__ */ jsxs(Fragment, { children: [
                /* @__PURE__ */ jsx(Box, { className: "sm:hidden ml-auto", children: /* @__PURE__ */ jsx(
                  Select,
                  {
                    options: screenSizeKeys.map((size2) => ({ value: size2, label: t("flowCanvas.presetSize", { label: t(SCREEN_SIZE_PRESETS[size2].labelKey), width: SCREEN_SIZE_PRESETS[size2].width }) })),
                    value: screenSize,
                    onValueChange: (value) => {
                      if (typeof value === "string" && isScreenSize(value)) applyScreenSize(value);
                    },
                    "aria-label": t("canvas.screenSize"),
                    "data-testid": "canvas-screen-size-picker",
                    className: "h-10 py-0 text-sm bg-card/80"
                  }
                ) }),
                /* @__PURE__ */ jsx(Box, { className: "hidden sm:flex ml-auto", "data-testid": "canvas-screen-size-buttons", children: /* @__PURE__ */ jsx(ButtonGroup, { variant: "segmented", className: "bg-card/80 backdrop-blur-sm rounded-md", children: screenSizeKeys.map((size2) => {
                  const p = SCREEN_SIZE_PRESETS[size2];
                  return /* @__PURE__ */ jsx(
                    Button,
                    {
                      variant: screenSize === size2 ? "primary" : "ghost",
                      size: "sm",
                      onClick: () => applyScreenSize(size2),
                      title: t("flowCanvas.presetSize", { label: t(p.labelKey), width: p.width }),
                      "aria-label": t("canvas.switchToView", { label: t(p.labelKey) }),
                      "aria-pressed": screenSize === size2,
                      children: t(p.labelKey)
                    },
                    size2
                  );
                }) }) })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "flex flex-1 min-h-0", children: [
          /* @__PURE__ */ jsx(
            Box,
            {
              className: "relative flex-1 min-w-0 h-full outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset flex flex-col",
              tabIndex: 0,
              onKeyDown: handleCanvasKeyDown,
              "data-testid": "flow-canvas",
              children: /* @__PURE__ */ jsx(Box, { className: "relative flex-1 min-h-0", children: /* @__PURE__ */ jsx(
                AvlGraphCanvas,
                {
                  nodes,
                  edges: visibleEdges,
                  nodeTypes: NODE_TYPES2,
                  edgeTypes: EDGE_TYPES_LOCAL,
                  defaultEdgeOptions: DEFAULT_EDGE_OPTIONS,
                  onNodesChange,
                  onEdgesChange,
                  onNodeClick: handleNodeClick,
                  onConnect: handleConnect,
                  onNodeDragStop: handleNodeDragStop,
                  fitPadding,
                  compact,
                  nodesDraggable: scope === "world",
                  elementsSelectable: true
                }
              ) })
            }
          ),
          !externalInspector && selectedNode && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              Box,
              {
                className: "fixed inset-0 bg-foreground/40 z-40 lg:hidden",
                onClick: handleClosePanel
              }
            ),
            /* @__PURE__ */ jsx(Box, { className: "fixed inset-y-0 right-0 z-50 max-w-full lg:static lg:z-auto lg:max-w-none lg:flex-shrink-0", children: /* @__PURE__ */ jsx(
              OrbInspector,
              {
                node: selectedNode,
                schema: parsedSchema,
                editable,
                userType,
                themeManifest,
                onSchemaChange,
                onClose: handleClosePanel
              }
            ) })
          ] })
        ] })
      ]
    }
  ) }) }) }) }) }) }) }) });
}
var FlowCanvas = (props) => {
  return /* @__PURE__ */ jsx(Profiler, { id: "flow-canvas", onRender: profilerOnRender, children: /* @__PURE__ */ jsx(ReactFlowProvider, { children: /* @__PURE__ */ jsx(FlowCanvasInner, { ...props }) }) });
};
FlowCanvas.displayName = "FlowCanvas";
var isRelationsDebugEnabled = () => isDebugEnabled();
var MANY_CARDINALITIES = [
  "many",
  "one-to-many",
  "many-to-many"
];
var RelationSelect = ({
  value,
  onChange,
  options = [],
  placeholder,
  required = false,
  disabled = false,
  isLoading = false,
  error,
  clearable = true,
  name,
  className,
  searchPlaceholder,
  emptyMessage,
  ...rest
}) => {
  const { t } = useTranslate();
  const resolvedPlaceholder = placeholder ?? t("relationSelect.selectPlaceholder");
  const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.search");
  const resolvedEmptyMessage = emptyMessage ?? t("empty.noOptionsFound");
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeIndex, setActiveIndex] = useState(-1);
  const listboxId = useId();
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);
  useEffect(() => {
    if (isRelationsDebugEnabled()) {
      debugGroup(`RelationSelect: ${name || "unnamed"}`);
      debug(`Options count: ${options.length}`);
      debug(`Current value: ${value || "none"}`);
      debug(`Is loading: ${isLoading}`);
      if (options.length > 0) {
        debug("Sample options:", options.slice(0, 3));
      } else {
        debug("\u26A0\uFE0F No options available!");
      }
      debugGroupEnd();
    }
  }, [name, options.length, value, isLoading]);
  const selectedOption = useMemo(() => {
    const found = options.find((opt) => opt.value === value);
    if (isRelationsDebugEnabled() && value && !found) {
      debug(`\u26A0\uFE0F Value "${value}" not found in options for ${name}`);
    }
    return found;
  }, [options, value, name]);
  const filteredOptions = useMemo(() => {
    if (!searchQuery.trim()) return options;
    const query = searchQuery.toLowerCase();
    return options.filter(
      (opt) => opt.label.toLowerCase().includes(query) || opt.description?.toLowerCase().includes(query)
    );
  }, [options, searchQuery]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchQuery("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    if (isOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isOpen]);
  const handleToggle = useCallback(() => {
    if (!disabled) {
      setIsOpen((prev) => !prev);
      if (!isOpen) {
        setSearchQuery("");
      }
    }
  }, [disabled, isOpen]);
  const handleSelect = useCallback(
    (option) => {
      if (option.disabled) return;
      onChange?.(option.value);
      setIsOpen(false);
      setSearchQuery("");
    },
    [onChange]
  );
  const handleClear = useCallback(
    (e) => {
      e.stopPropagation();
      onChange?.(void 0);
    },
    [onChange]
  );
  useEffect(() => {
    setActiveIndex(-1);
  }, [searchQuery, isOpen]);
  const stepActive = useCallback(
    (step) => {
      const n = filteredOptions.length;
      for (let i = 1; i <= n; i++) {
        const next = (((activeIndex === -1 && step === -1 ? 0 : activeIndex) + step * i) % n + n) % n;
        if (!filteredOptions[next].disabled) {
          setActiveIndex(next);
          return;
        }
      }
    },
    [filteredOptions, activeIndex]
  );
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
        setSearchQuery("");
      } else if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        e.preventDefault();
        stepActive(e.key === "ArrowDown" ? 1 : -1);
      } else if (e.key === "Enter") {
        const active = filteredOptions[activeIndex];
        if (active) {
          e.preventDefault();
          handleSelect(active);
        } else if (filteredOptions.length === 1) {
          handleSelect(filteredOptions[0]);
        }
      }
    },
    [filteredOptions, activeIndex, handleSelect, stepActive]
  );
  const showClear = clearable && !!selectedOption && !disabled;
  const optionId = (index) => `${listboxId}-option-${index}`;
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), ref: containerRef, className: cn("relative", className), children: [
    /* @__PURE__ */ jsx(Input, { type: "hidden", name, value: value || "" }),
    /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        variant: "secondary",
        onClick: handleToggle,
        disabled,
        className: cn(
          "w-full justify-between font-normal",
          error && "border-error/50 focus:border-error focus:ring-error",
          isOpen && "ring-2 ring-primary border-primary",
          showClear && "pe-12"
        ),
        "aria-haspopup": "listbox",
        "aria-expanded": isOpen,
        children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body",
              className: cn(
                !selectedOption && "text-muted-foreground"
              ),
              children: isLoading ? /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
                /* @__PURE__ */ jsx(Spinner, { size: "sm" }),
                /* @__PURE__ */ jsx(Typography, { as: "span", children: t("common.loading") })
              ] }) : selectedOption ? selectedOption.label : resolvedPlaceholder
            }
          ),
          /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", children: /* @__PURE__ */ jsx(
            Icon,
            {
              name: "chevron-down",
              className: cn(
                "h-4 w-4 text-muted-foreground transition-transform",
                isOpen && "transform rotate-180"
              )
            }
          ) })
        ]
      }
    ),
    showClear && /* @__PURE__ */ jsx(
      Button,
      {
        type: "button",
        variant: "ghost",
        size: "sm",
        icon: "x",
        onClick: handleClear,
        "aria-label": t("common.clear"),
        className: "absolute top-1/2 -translate-y-1/2 end-8 h-6 w-6 p-0 text-muted-foreground"
      }
    ),
    isOpen && /* @__PURE__ */ jsxs(
      Box,
      {
        position: "absolute",
        bg: "surface",
        border: true,
        rounded: "md",
        className: "shadow-elevation-popover surface-material z-50 w-full mt-1",
        children: [
          /* @__PURE__ */ jsx(Box, { padding: "sm", className: "border-b border-border", children: /* @__PURE__ */ jsx(
            Input,
            {
              ref: searchInputRef,
              type: "text",
              value: searchQuery,
              onChange: (e) => setSearchQuery(e.target.value),
              onKeyDown: handleKeyDown,
              role: "combobox",
              "aria-expanded": isOpen,
              "aria-controls": listboxId,
              "aria-autocomplete": "list",
              "aria-activedescendant": activeIndex >= 0 ? optionId(activeIndex) : void 0,
              "aria-label": resolvedSearchPlaceholder,
              placeholder: resolvedSearchPlaceholder,
              icon: Search,
              className: "text-sm"
            }
          ) }),
          /* @__PURE__ */ jsx(Box, { overflow: "auto", className: "max-h-60", id: listboxId, role: "listbox", children: isLoading ? /* @__PURE__ */ jsx(Box, { padding: "md", display: "flex", className: "justify-center", children: /* @__PURE__ */ jsx(Spinner, { size: "md", color: "primary" }) }) : filteredOptions.length === 0 ? /* @__PURE__ */ jsx(Box, { padding: "md", children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body",
              color: "muted",
              className: "text-center",
              children: resolvedEmptyMessage
            }
          ) }) : /* @__PURE__ */ jsx(VStack, { gap: "none", children: filteredOptions.map((option, index) => /* @__PURE__ */ jsxs(
            Box,
            {
              id: optionId(index),
              role: "option",
              "aria-selected": option.value === value,
              "aria-disabled": option.disabled || void 0,
              fullWidth: true,
              paddingX: "sm",
              paddingY: "sm",
              className: cn(
                "text-start text-sm cursor-pointer hover:bg-muted",
                index === activeIndex && "bg-muted",
                option.value === value && "bg-primary/10 text-foreground",
                option.disabled && "opacity-50 cursor-not-allowed"
              ),
              onMouseEnter: () => !option.disabled && setActiveIndex(index),
              onClick: () => handleSelect(option),
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "body", className: "font-medium", children: option.label }),
                option.description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: option.description })
              ]
            },
            option.value
          )) }) })
        ]
      }
    ),
    error && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", className: "mt-1", children: error })
  ] });
};
RelationSelect.displayName = "RelationSelect";
function toSharedContext2(formCtx) {
  return createMinimalContext(
    {
      formValues: formCtx.formValues,
      globalVariables: formCtx.globalVariables,
      localVariables: formCtx.localVariables ?? {},
      ...formCtx.entity
    },
    {},
    "active"
  );
}
function evaluateFormExpression(expr, formCtx) {
  const ctx = toSharedContext2(formCtx);
  return evaluate(expr, ctx);
}
function isOrbitalEntitySchema(value) {
  if (value === null || value === void 0 || typeof value !== "object" || Array.isArray(value)) return false;
  const fields = value.fields;
  return Array.isArray(fields);
}
function isPlainEntityRow(value) {
  if (value === null || value === void 0 || typeof value !== "object" || Array.isArray(value)) return false;
  const fields = value.fields;
  return !Array.isArray(fields);
}
var layoutStyles = {
  vertical: "flex flex-col",
  horizontal: "flex flex-row flex-wrap items-end",
  inline: "flex flex-row flex-wrap items-center"
};
var gapStyles5 = {
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6"
};
function getEnumOptions(field) {
  if (field.options && field.options.length > 0) {
    return [...field.options];
  }
  if (field.values && field.values.length > 0) {
    return field.values.map((v) => ({
      value: v,
      label: field.labels?.[v] ?? v
    }));
  }
  const validation = field.validation;
  if (validation?.enum && validation.enum.length > 0) {
    return validation.enum.map((v) => ({
      value: v,
      label: field.labels?.[v] ?? v
    }));
  }
  return [];
}
function determineInputType(field) {
  if (field.inputType) {
    return field.inputType;
  }
  if (field.type === "relation" || field.relation) {
    return "relation";
  }
  if (field.type === "array") {
    return "array";
  }
  if (field.type === "enum" || field.values || getEnumOptions(field).length > 0) {
    return "select";
  }
  switch (field.type?.toLowerCase()) {
    case "email":
      return "email";
    case "password":
      return "password";
    case "url":
      return "url";
    case "file":
      return "file";
    case "image":
      return "image";
    case "money":
      return "currency";
    case "number":
    case "integer":
    case "float":
      return "number";
    case "date":
      return "date";
    case "datetime":
    case "timestamp":
      return "datetime-local";
    case "boolean":
      return "checkbox";
    case "textarea":
    case "text":
      return field.max && field.max > 200 ? "textarea" : "text";
    default:
      return "text";
  }
}
var Form = ({
  children,
  onSubmit,
  onCancel,
  layout = "vertical",
  gap = "md",
  surface = "auto",
  className,
  // Schema-based props
  entity,
  fields,
  // No `= {}` default: a fresh `{}` evaluated inline on every render
  // would change the prop reference every tick and bust the useMemo
  // cache below (`[entity, initialData]` deps), reigniting the
  // setFormData useEffect on every keystroke and producing an
  // infinite re-render loop with stuck form inputs. The memo and
  // submit handler both handle `undefined` already via the
  // `typeof initialData === 'object'` guard.
  initialData,
  isLoading: isLoadingProp = false,
  error,
  submitLabel,
  cancelLabel,
  showCancel,
  showSubmit = true,
  title,
  submitEvent = "SAVE",
  cancelEvent = "CANCEL",
  relationsData = {},
  relationsLoading = {},
  fieldOverrides,
  // Inspection form extensions - may come as boolean true from generated code (meaning enabled but config loaded separately)
  conditionalFields: conditionalFieldsRaw = {},
  hiddenCalculations: hiddenCalculationsRaw = [],
  violationTriggers: violationTriggersRaw = [],
  evaluationContext: externalContext,
  sections = [],
  onFieldChange,
  // Feeds the awaiting-skeleton prediction only; never forwarded to the <form>.
  skeleton: _skeleton,
  ...props
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const submitBusy = usePendingAction();
  const isLoading = isLoadingProp || submitBusy.pending;
  const { t } = useTranslate();
  const resolvedSubmitLabel = submitLabel ?? t("common.save");
  const resolvedCancelLabel = cancelLabel ?? t("common.cancel");
  const isSchemaEntity = isOrbitalEntitySchema(entity);
  const resolvedEntity = isSchemaEntity ? entity : void 0;
  const entityName = typeof entity === "string" ? entity : resolvedEntity?.name;
  const normalizedInitialData = React93__default.useMemo(() => {
    const entityRowAsInitial = isPlainEntityRow(entity) ? entity : void 0;
    const callerInitial = initialData !== null && typeof initialData === "object" && !Array.isArray(initialData) ? initialData : {};
    const merged = entityRowAsInitial !== void 0 ? { ...entityRowAsInitial, ...callerInitial } : callerInitial;
    const toId = (value) => {
      if (value === null || value === void 0 || typeof value !== "object" || value instanceof Date) return value;
      if (Array.isArray(value)) {
        return value.map(
          (item) => item !== null && typeof item === "object" && !Array.isArray(item) && !(item instanceof Date) && item.id !== void 0 && item.id !== null ? String(item.id) : item
        );
      }
      return value.id !== void 0 && value.id !== null ? String(value.id) : value;
    };
    const normalized = {};
    for (const [key, value] of Object.entries(merged)) {
      normalized[key] = key === "id" ? value : toId(value);
    }
    return normalized;
  }, [entity, initialData]);
  const entityDerivedFields = React93__default.useMemo(() => {
    if (fields && fields.length > 0) return void 0;
    if (!resolvedEntity) return void 0;
    return resolvedEntity.fields.map(
      (f3) => ({
        name: f3.name,
        type: f3.type,
        required: f3.required,
        // EntityField.default is typed `unknown` upstream — safe cast: schema defaults are always FieldValues.
        defaultValue: f3.default,
        // EntityField is a discriminated union — `values` lives on Scalar/Enum, `relation` lives on Relation.
        values: "values" in f3 ? f3.values : void 0,
        min: f3.min,
        max: f3.max,
        relation: "relation" in f3 ? { entity: f3.relation.entity, cardinality: f3.relation.cardinality } : void 0
      })
    );
  }, [entity, fields]);
  const conditionalFields = typeof conditionalFieldsRaw === "boolean" ? {} : conditionalFieldsRaw;
  const hiddenCalculations = typeof hiddenCalculationsRaw === "boolean" ? [] : hiddenCalculationsRaw;
  const violationTriggers = typeof violationTriggersRaw === "boolean" ? [] : violationTriggersRaw;
  const [formData, setFormData] = React93__default.useState(
    normalizedInitialData
  );
  const [collapsedSections, setCollapsedSections] = React93__default.useState(
    /* @__PURE__ */ new Set()
  );
  const [submitError, setSubmitError] = React93__default.useState(null);
  const formRef = React93__default.useRef(null);
  const formUid = React93__default.useId();
  const fieldDomId = (name) => `${formUid}-${name}`;
  const [fieldErrors, setFieldErrors] = React93__default.useState({});
  const [invalidFields, setInvalidFields] = React93__default.useState([]);
  const fieldElement = (name) => formRef.current?.querySelector(
    `[data-field-name=${JSON.stringify(name)}]`
  ) ?? null;
  const validateField = (name) => {
    const el = fieldElement(name);
    if (!el) return;
    const message = el.validity.valid ? null : el.validationMessage || t("form.invalidValue");
    setFieldErrors((prev) => {
      if (message === null) {
        if (!(name in prev)) return prev;
        const next = { ...prev };
        delete next[name];
        return next;
      }
      return prev[name] === message ? prev : { ...prev, [name]: message };
    });
    if (message === null) setInvalidFields((prev) => prev.includes(name) ? prev.filter((n) => n !== name) : prev);
  };
  const formMode = props.mode;
  const mountedRef = React93__default.useRef(false);
  if (!mountedRef.current) {
    mountedRef.current = true;
    debug("forms", "mount", {
      mode: formMode,
      submitEvent,
      cancelEvent,
      fieldNames: (fields ?? []).map((f3) => f3.name ?? f3.field).filter(Boolean),
      initialDataKeys: Object.keys(normalizedInitialData),
      initialData: normalizedInitialData
    });
  }
  const shouldShowCancel = showCancel ?? (fields && fields.length > 0);
  const evalContext = React93__default.useMemo(
    () => ({
      formValues: formData,
      globalVariables: externalContext?.globalVariables ?? {},
      localVariables: externalContext?.localVariables ?? {},
      entity: externalContext?.entity ?? {}
    }),
    [formData, externalContext]
  );
  React93__default.useEffect(() => {
    debug("forms", "initialData-sync", {
      mode: formMode,
      normalizedInitialData,
      prevFormData: formData,
      willSet: Object.keys(normalizedInitialData).length > 0
    });
    if (Object.keys(normalizedInitialData).length > 0) {
      setFormData(normalizedInitialData);
    }
  }, [normalizedInitialData]);
  const processCalculations = React93__default.useCallback(
    (changedFieldId, newFormData) => {
      if (!hiddenCalculations.length) return;
      const context = {
        formValues: newFormData,
        globalVariables: externalContext?.globalVariables ?? {},
        localVariables: externalContext?.localVariables ?? {},
        entity: externalContext?.entity ?? {}
      };
      hiddenCalculations.forEach((calc) => {
        if (calc.triggerFields.includes(changedFieldId)) {
          const value = evaluateFormExpression(calc.expression, context);
          eventBus.emit("UI:GLOBAL_VARIABLE_SET", {
            variable: calc.variableName,
            value
          });
          debug(
            "forms",
            `Calculation triggered: ${calc.variableName} = ${String(value)}`
          );
        }
      });
    },
    [hiddenCalculations, externalContext, eventBus]
  );
  const checkViolations = React93__default.useCallback(
    (changedFieldId, newFormData) => {
      if (!violationTriggers.length) return;
      const context = {
        formValues: newFormData,
        globalVariables: externalContext?.globalVariables ?? {},
        localVariables: externalContext?.localVariables ?? {},
        entity: externalContext?.entity ?? {}
      };
      violationTriggers.forEach((trigger) => {
        const conditionMet = evaluateFormExpression(trigger.condition, context);
        if (conditionMet) {
          eventBus.emit("UI:VIOLATION_DETECTED", {
            fieldId: trigger.fieldId ?? changedFieldId,
            ...trigger.violation
          });
          debug(
            "forms",
            `Violation detected: ${trigger.violation.law} ${trigger.violation.article}`
          );
        }
      });
    },
    [violationTriggers, externalContext, eventBus]
  );
  const handleChange = (name, value) => {
    const newFormData = { ...formData, [name]: value };
    debug("forms", "field-change", { mode: formMode, name, value, prevFormData: formData, newFormData });
    setFormData(newFormData);
    if (fieldErrors[name] !== void 0) queueMicrotask(() => validateField(name));
    eventBus.emit("UI:FIELD_CHANGED", {
      fieldId: name,
      value,
      formValues: newFormData
    });
    onFieldChange?.({ fieldId: name, value, formValues: newFormData });
    processCalculations(name, newFormData);
    checkViolations(name, newFormData);
  };
  const isFieldVisible = React93__default.useCallback(
    (fieldName2) => {
      const condition = conditionalFields[fieldName2];
      if (!condition) return true;
      return Boolean(evaluateFormExpression(condition, evalContext));
    },
    [conditionalFields, evalContext]
  );
  const isSectionVisible = React93__default.useCallback(
    (section) => {
      if (!section.condition) return true;
      return Boolean(evaluateFormExpression(section.condition, evalContext));
    },
    [evalContext]
  );
  const toggleSection = (sectionId) => {
    setCollapsedSections((prev) => {
      const next = new Set(prev);
      if (next.has(sectionId)) {
        next.delete(sectionId);
      } else {
        next.add(sectionId);
      }
      return next;
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitError(null);
    setInvalidFields([]);
    debug("forms", "submit-enter", {
      mode: formMode,
      submitEvent,
      formData,
      normalizedInitialData
    });
    const mergedData = {
      ...normalizedInitialData,
      ...formData
    };
    const payload = { data: mergedData };
    debug("forms", "submit-emit", { mode: formMode, submitEvent: `UI:${submitEvent}`, payloadData: payload.data });
    submitBusy.activate((pendingKey) => {
      eventBus.emit(`UI:${submitEvent}`, payload, { pendingKey });
      if (onSubmit) {
        eventBus.emit(`UI:${onSubmit}`, payload, { pendingKey });
      }
    });
  };
  const invalidScheduled = React93__default.useRef(false);
  const handleInvalid = (e) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;
    debug("forms", "invalid", { mode: formMode, fieldName: target.getAttribute("data-field-name") ?? "" });
    if (invalidScheduled.current) return;
    invalidScheduled.current = true;
    queueMicrotask(() => {
      invalidScheduled.current = false;
      const form = formRef.current;
      if (!form) return;
      const invalidEls = Array.from(
        form.querySelectorAll("[data-field-name]")
      ).filter((el) => el.validity !== void 0 && !el.validity.valid);
      if (invalidEls.length === 0) return;
      const messages = invalidEls.map((el) => ({
        field: el.getAttribute("data-field-name") ?? "",
        message: el.validationMessage || t("form.invalidValue")
      }));
      const missing = messages.map((m) => m.field);
      setFieldErrors((prev) => {
        const next = { ...prev };
        for (const m of messages) next[m.field] = m.message;
        return next;
      });
      setInvalidFields(missing);
      eventBus.emit("UI:VALIDATION_FAILED", {
        submitEvent,
        missing,
        messages,
        summary: t("form.fixFields", { count: missing.length })
      });
    });
  };
  const handleInvalidRef = React93__default.useRef(handleInvalid);
  handleInvalidRef.current = handleInvalid;
  React93__default.useEffect(() => {
    const form = formRef.current;
    if (!form) return;
    const listener = (e) => handleInvalidRef.current(e);
    form.addEventListener("invalid", listener, true);
    return () => form.removeEventListener("invalid", listener, true);
  }, []);
  const focusField = (name) => fieldElement(name)?.focus();
  const handleCancel = () => {
    eventBus.emit(`UI:${cancelEvent}`);
    eventBus.emit("UI:CLOSE");
    if (onCancel) {
      eventBus.emit(`UI:${onCancel}`);
    }
  };
  const renderField = React93__default.useCallback(
    (field) => {
      const fieldName2 = field.name || field.field;
      if (!fieldName2) return null;
      if (!isFieldVisible(fieldName2)) {
        return null;
      }
      const inputType = determineInputType(field);
      const label = field.label || fieldName2;
      const currentValue = formData[fieldName2] ?? field.defaultValue ?? "";
      const error2 = fieldErrors[fieldName2];
      const domId = fieldDomId(fieldName2);
      if (inputType === "checkbox" || inputType === "image") {
        return /* @__PURE__ */ jsxs(VStack, { gap: "xs", "data-field": fieldName2, children: [
          inputType === "image" && /* @__PURE__ */ jsx(Label, { htmlFor: domId, required: field.required, children: label }),
          renderFieldInput(field, fieldName2, inputType, currentValue, label),
          error2 ? /* @__PURE__ */ jsx(Typography, { id: `${domId}-error`, variant: "caption", color: "error", "data-field-error": true, children: error2 }) : field.hint ? /* @__PURE__ */ jsx(Typography, { id: `${domId}-hint`, variant: "caption", color: "muted", children: field.hint }) : null
        ] }, fieldName2);
      }
      return /* @__PURE__ */ jsx(Box, { "data-field": fieldName2, children: /* @__PURE__ */ jsx(FormField, { label, required: field.required, hint: field.hint, error: error2, children: renderFieldInput(field, fieldName2, inputType, currentValue, label) }) }, fieldName2);
    },
    [formData, fieldErrors, isFieldVisible, relationsData, relationsLoading, isLoading]
  );
  const effectiveFields = entityDerivedFields ?? fields;
  const normalizedFields = React93__default.useMemo(() => {
    if (!effectiveFields || effectiveFields.length === 0) return [];
    return effectiveFields.map((field) => {
      if (typeof field === "string") {
        const entityField = resolvedEntity?.fields?.find((f3) => f3.name === field);
        if (entityField) {
          return {
            name: field,
            type: entityField.type,
            required: entityField.required,
            hint: entityField.description,
            // EntityField.default is typed `unknown` upstream — safe cast: schema defaults are always FieldValues.
            defaultValue: entityField.default,
            // EntityField is a discriminated union — `values` lives on Scalar/Enum, `relation` lives on Relation.
            values: "values" in entityField ? entityField.values : void 0,
            min: entityField.min,
            max: entityField.max,
            relation: "relation" in entityField ? { entity: entityField.relation.entity, cardinality: entityField.relation.cardinality } : void 0
          };
        }
        return { name: field, type: "string" };
      }
      return field;
    }).map((field) => {
      const fieldName2 = field.name || field.field;
      const override = fieldOverrides?.find((o) => o.name === fieldName2);
      if (!override) return field;
      return {
        ...field,
        ...override.label !== void 0 ? { label: override.label } : {},
        ...override.placeholder !== void 0 ? { placeholder: override.placeholder } : {},
        ...override.hint !== void 0 ? { hint: override.hint } : {}
      };
    });
  }, [effectiveFields, resolvedEntity, fieldOverrides]);
  const schemaFields = React93__default.useMemo(() => {
    if (normalizedFields.length === 0) return null;
    if (isDebugEnabled()) {
      debugGroup(`Form: ${entityName || "unknown"}`);
      debug(`Fields count: ${normalizedFields.length}`);
      debug("Conditional fields:", Object.keys(conditionalFields));
      debugGroupEnd();
    }
    return normalizedFields.map(renderField).filter(Boolean);
  }, [normalizedFields, renderField, entityName, conditionalFields]);
  const sectionElements = React93__default.useMemo(() => {
    if (!sections || sections.length === 0) return null;
    return sections.map((section) => {
      if (!isSectionVisible(section)) {
        return null;
      }
      const isCollapsed = collapsedSections.has(section.id);
      return /* @__PURE__ */ jsxs(Box, { as: "fieldset", className: "m-0 min-w-0 p-0 border border-border rounded-container overflow-hidden", children: [
        /* @__PURE__ */ jsx(Box, { as: "legend", className: "sr-only", children: section.title }),
        /* @__PURE__ */ jsxs(
          Box,
          {
            ...pressableProps(section.collapsible ? () => toggleSection(section.id) : void 0),
            "aria-expanded": section.collapsible ? !isCollapsed : void 0,
            className: cn(
              "px-4 py-3 bg-muted flex items-center justify-between",
              section.collapsible && "cursor-pointer hover:bg-muted/80"
            ),
            children: [
              /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "semibold", children: section.title }),
              section.collapsible && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "chevron-down",
                  size: "md",
                  className: cn(
                    "text-muted-foreground transition-transform",
                    isCollapsed && "rotate-180"
                  )
                }
              )
            ]
          }
        ),
        !isCollapsed && /* @__PURE__ */ jsx(Box, { padding: "md", children: /* @__PURE__ */ jsx(VStack, { gap: gap === "sm" ? "sm" : gap === "lg" ? "lg" : "md", children: section.fields.map(renderField).filter(Boolean) }) })
      ] }, section.id);
    }).filter(Boolean);
  }, [sections, isSectionVisible, collapsedSections, renderField, gap]);
  function renderFieldInput(field, fieldName2, inputType, currentValue, label) {
    const domId = fieldDomId(fieldName2);
    const selfDescribed = inputType === "checkbox" || inputType === "image";
    const commonProps = {
      id: domId,
      ...selfDescribed ? {
        "aria-invalid": fieldErrors[fieldName2] ? true : void 0,
        "aria-describedby": fieldErrors[fieldName2] ? `${domId}-error` : field.hint ? `${domId}-hint` : void 0
      } : void 0,
      name: fieldName2,
      "data-field-name": fieldName2,
      required: field.required,
      disabled: isLoading,
      placeholder: field.placeholder,
      pattern: field.pattern
    };
    switch (inputType) {
      case "checkbox":
        return /* @__PURE__ */ jsx(
          Checkbox,
          {
            ...commonProps,
            label,
            checked: Boolean(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.checked)
          }
        );
      case "textarea":
        return /* @__PURE__ */ jsx(
          Textarea,
          {
            ...commonProps,
            value: String(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value),
            minLength: field.min,
            maxLength: field.max
          }
        );
      case "select": {
        const options = getEnumOptions(field);
        return /* @__PURE__ */ jsx(
          Select,
          {
            ...commonProps,
            options,
            value: String(currentValue),
            onValueChange: (v) => handleChange(fieldName2, v),
            placeholder: field.placeholder || t("form.selectPlaceholder", { label })
          }
        );
      }
      case "relation": {
        const relationOptions = relationsData[fieldName2] || [];
        const relationLoading = relationsLoading[fieldName2] || false;
        if (field.relation?.cardinality !== void 0 && MANY_CARDINALITIES.includes(field.relation.cardinality)) {
          const selectedValues = Array.isArray(currentValue) ? currentValue.map((v) => String(v)) : [];
          return /* @__PURE__ */ jsx(
            Select,
            {
              ...commonProps,
              multiple: true,
              searchable: true,
              clearable: true,
              options: [...relationOptions],
              value: selectedValues,
              onValueChange: (value) => handleChange(fieldName2, Array.isArray(value) ? value : [value]),
              placeholder: field.placeholder || t("form.selectPlaceholder", { label })
            }
          );
        }
        return /* @__PURE__ */ jsx(
          RelationSelect,
          {
            ...commonProps,
            value: currentValue ? String(currentValue) : void 0,
            onChange: (value) => handleChange(fieldName2, value),
            options: relationOptions,
            isLoading: relationLoading,
            placeholder: field.placeholder || t("form.selectPlaceholder", { label }),
            searchPlaceholder: t("form.searchPlaceholder", { entity: field.relation?.entity || label }),
            clearable: !field.required
          }
        );
      }
      case "array": {
        const arrayValue = Array.isArray(currentValue) ? currentValue.map((v) => String(v)) : currentValue != null && currentValue !== "" ? [String(currentValue)] : [];
        return /* @__PURE__ */ jsx(
          TagInput,
          {
            placeholder: field.placeholder,
            disabled: isLoading,
            value: arrayValue,
            onChange: (next) => handleChange(fieldName2, [...next])
          }
        );
      }
      case "number":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "number",
            value: currentValue !== void 0 && currentValue !== "" ? String(currentValue) : "",
            onChange: (e) => handleChange(
              fieldName2,
              e.target.value ? Number(e.target.value) : void 0
            ),
            min: field.min,
            max: field.max
          }
        );
      case "currency":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "number",
            step: "0.01",
            icon: DollarSign,
            value: currentValue !== void 0 && currentValue !== "" ? String(currentValue) : "",
            onChange: (e) => handleChange(
              fieldName2,
              e.target.value ? Number(e.target.value) : void 0
            ),
            min: field.min,
            max: field.max
          }
        );
      case "file":
        return /* @__PURE__ */ jsx(
          UploadDropZone,
          {
            accept: field.pattern,
            maxFiles: 1,
            disabled: isLoading,
            onFiles: (files) => {
              const f3 = files[0];
              if (!f3) return;
              const reader = new FileReader();
              reader.onload = () => handleChange(fieldName2, {
                name: f3.name,
                mimeType: f3.type,
                sizeBytes: f3.size,
                url: typeof reader.result === "string" ? reader.result : ""
              });
              reader.readAsDataURL(f3);
            }
          }
        );
      case "image": {
        const imageUrl = typeof currentValue === "string" ? currentValue : "";
        return /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
          imageUrl ? /* @__PURE__ */ jsx(
            "img",
            {
              src: imageUrl,
              alt: "",
              "aria-hidden": "true",
              className: "h-24 w-full max-w-xs rounded-container border border-border object-cover",
              "data-testid": `image-preview-${fieldName2}`
            }
          ) : null,
          /* @__PURE__ */ jsx(
            UploadDropZone,
            {
              accept: "image/*",
              maxFiles: 1,
              maxSize: 2 * 1024 * 1024,
              disabled: isLoading,
              onFiles: (files) => {
                const f3 = files[0];
                if (!f3) return;
                const reader = new FileReader();
                reader.onload = () => handleChange(
                  fieldName2,
                  typeof reader.result === "string" ? reader.result : ""
                );
                reader.readAsDataURL(f3);
              }
            }
          ),
          /* @__PURE__ */ jsx(
            Input,
            {
              ...commonProps,
              type: "url",
              placeholder: t("form.imageUrlFallback"),
              value: imageUrl,
              onChange: (e) => handleChange(fieldName2, e.target.value)
            }
          )
        ] });
      }
      case "date":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "date",
            value: toDateInputValue(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value)
          }
        );
      case "datetime-local":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "datetime-local",
            value: toDateTimeInputValue(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value)
          }
        );
      case "email":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "email",
            value: String(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value),
            minLength: field.min,
            maxLength: field.max
          }
        );
      case "url":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "url",
            value: String(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value),
            minLength: field.min,
            maxLength: field.max
          }
        );
      case "password":
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "password",
            value: String(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value),
            minLength: field.min,
            maxLength: field.max
          }
        );
      case "text":
      default:
        return /* @__PURE__ */ jsx(
          Input,
          {
            ...commonProps,
            type: "text",
            value: String(currentValue),
            onChange: (e) => handleChange(fieldName2, e.target.value),
            minLength: field.min,
            maxLength: field.max
          }
        );
    }
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(
      "form",
      {
        ref: formRef,
        "data-pattern": FORM_PATTERN,
        className: cn(layoutStyles[layout], gapStyles5[gap], layout === "vertical" && "w-full max-w-xl", contentSurface.className && cn(contentSurface.className, "p-card-md"), className),
        onSubmit: handleSubmit,
        onBlur: (e) => {
          const name = e.target instanceof HTMLElement ? e.target.getAttribute("data-field-name") : null;
          if (name) validateField(name);
        },
        ...props,
        children: [
          submitError && /* @__PURE__ */ jsx(Alert, { variant: "error", className: "mb-4", children: submitError }),
          invalidFields.length > 0 && /* @__PURE__ */ jsx(Alert, { variant: "error", title: t("form.fixFields", { count: invalidFields.length }), children: /* @__PURE__ */ jsx(HStack, { gap: "sm", wrap: true, children: invalidFields.map((name) => {
            const def = normalizedFields.find((f3) => (f3.name || f3.field) === name) ?? sections.flatMap((sec) => sec.fields).find((f3) => (f3.name || f3.field) === name);
            return /* @__PURE__ */ jsx(Button, { variant: "link", className: "h-auto p-0", onClick: () => focusField(name), children: def?.label ?? name }, name);
          }) }) }),
          error && /* @__PURE__ */ jsx(Alert, { variant: "error", className: "mb-4", children: error.message || t("error.occurred") }),
          sectionElements && sectionElements.length > 0 && /* @__PURE__ */ jsx(VStack, { gap: gap === "sm" ? "sm" : gap === "lg" ? "lg" : "md", children: sectionElements }),
          schemaFields,
          children,
          (schemaFields && schemaFields.length > 0 || sectionElements && sectionElements.length > 0) && (showSubmit || shouldShowCancel) && /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              justify: "end",
              wrap: true,
              className: "sticky bottom-0 z-10 -mx-1 px-1 pt-4 pb-1 bg-card/95 surface-material",
              children: [
                shouldShowCancel && /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "button",
                    variant: "secondary",
                    onClick: handleCancel,
                    disabled: isLoading,
                    "data-event": cancelEvent,
                    "data-testid": actionTestId(cancelEvent),
                    children: resolvedCancelLabel
                  }
                ),
                showSubmit && /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "submit",
                    variant: "primary",
                    isLoading,
                    "data-event": submitEvent,
                    "data-testid": actionTestId(submitEvent),
                    children: resolvedSubmitLabel
                  }
                )
              ]
            }
          )
        ]
      }
    )
  );
};
Form.displayName = "Form";
var FormSection = ({
  title,
  description,
  children,
  collapsible = false,
  defaultCollapsed = false,
  card = false,
  columns = 1,
  className,
  ...rest
}) => {
  const [collapsed, setCollapsed] = React93__default.useState(defaultCollapsed);
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const gridClass = {
    1: "grid-cols-1",
    2: "grid-cols-1 md:grid-cols-2",
    3: "grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
  }[columns];
  React93__default.useCallback(() => {
    if (collapsible) {
      setCollapsed((prev) => !prev);
      eventBus.emit("UI:TOGGLE_COLLAPSE", { collapsed: !collapsed });
    }
  }, [collapsible, collapsed, eventBus]);
  const content = /* @__PURE__ */ jsxs(Fragment, { children: [
    (title || description) && /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "mb-4", children: [
      title && /* @__PURE__ */ jsxs(
        HStack,
        {
          justify: "between",
          align: "center",
          className: cn(collapsible && "cursor-pointer"),
          action: collapsible ? "TOGGLE_COLLAPSE" : void 0,
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h3", children: title }),
            collapsible && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                action: "TOGGLE_COLLAPSE",
                children: /* @__PURE__ */ jsx(
                  Icon,
                  {
                    icon: ChevronDown,
                    size: "sm",
                    className: cn(
                      "text-muted-foreground transition-transform",
                      collapsed && "rotate-180"
                    )
                  }
                )
              }
            )
          ]
        }
      ),
      description && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: description })
    ] }),
    (!collapsible || !collapsed) && /* @__PURE__ */ jsx(Box, { className: cn("grid gap-4", gridClass), children })
  ] });
  if (card) {
    return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className: cn("p-6", className), children: content });
  }
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className, children: content });
};
FormSection.displayName = "FormSection";
var FormLayout = ({
  children,
  dividers = true,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(
    VStack,
    {
      ...domPassthrough(rest),
      gap: "lg",
      className: cn(
        dividers && "[&>*+*]:pt-8 [&>*+*]:border-t [&>*+*]:border-border",
        className
      ),
      children
    }
  );
};
FormLayout.displayName = "FormLayout";
var FormActions = ({
  children,
  sticky = false,
  align = "right",
  className,
  ...rest
}) => {
  const alignClass2 = {
    left: "justify-start",
    right: "justify-end",
    between: "justify-between",
    center: "justify-center"
  }[align];
  return /* @__PURE__ */ jsx(
    HStack,
    {
      ...domPassthrough(rest),
      gap: "sm",
      align: "center",
      className: cn(
        "pt-6 border-t border-border",
        alignClass2,
        sticky && "sticky bottom-0 bg-card py-4 -mx-6 px-6 shadow-[0_-4px_6px_-1px_rgb(0,0,0,0.05)]",
        className
      ),
      children
    }
  );
};
FormActions.displayName = "FormActions";
var FormSectionHeader = ({
  title,
  subtitle,
  isCollapsed = false,
  onToggle,
  badge,
  badgeVariant = "default",
  icon,
  hasErrors = false,
  isComplete = false,
  className,
  ...rest
}) => {
  const isClickable = !!onToggle;
  const effectiveBadgeVariant = hasErrors ? "danger" : isComplete ? "success" : badgeVariant;
  const statusIcon = hasErrors ? "alert-circle" : isComplete ? "check-circle" : null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      className: cn(
        "px-5 py-4 bg-muted/60 rounded-container",
        "border border-border border-s-heavy border-s-primary",
        isClickable && "cursor-pointer hover:bg-muted transition-colors",
        className
      ),
      ...pressableProps(onToggle),
      "aria-expanded": isClickable ? !isCollapsed : rest["aria-expanded"],
      children: /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
          icon && (typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, size: "md", className: "text-primary shrink-0" }) : /* @__PURE__ */ jsx(Icon, { icon, size: "md", className: "text-primary shrink-0" })),
          statusIcon && /* @__PURE__ */ jsx(
            Icon,
            {
              name: statusIcon,
              size: "md",
              className: cn(
                "shrink-0",
                hasErrors ? "text-error" : "text-success"
              )
            }
          ),
          /* @__PURE__ */ jsxs(Box, { className: "space-y-0.5", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "subheading", weight: "semibold", className: "text-foreground", children: title }),
            subtitle && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "leading-snug", children: subtitle })
          ] })
        ] }),
        /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
          badge && /* @__PURE__ */ jsx(Badge, { variant: effectiveBadgeVariant, size: "sm", children: badge }),
          isClickable && /* @__PURE__ */ jsx(
            Icon,
            {
              name: "chevron-down",
              size: "sm",
              className: cn(
                "text-muted-foreground transition-transform duration-fast shrink-0",
                isCollapsed && "-rotate-90"
              )
            }
          )
        ] })
      ] })
    }
  );
};
FormSectionHeader.displayName = "FormSectionHeader";
var DEFAULT_TICK_MS = 500;
var FX_OVERLAY_KEYFRAMES = `
${CONFETTI_BURST_KEYFRAMES}
@keyframes fx-overlay-flash {
  0% { opacity: 0.75; }
  100% { opacity: 0; }
}
@keyframes fx-overlay-glow {
  0% { opacity: 0.9; }
  60% { opacity: 0.6; }
  100% { opacity: 0; }
}
@keyframes fx-overlay-sparkle {
  0% { opacity: 0; transform: scale(0); }
  30% { opacity: 1; transform: scale(1); }
  100% { opacity: 0; transform: scale(0.3); }
}
@keyframes fx-overlay-float {
  0% { opacity: 0; transform: translate(-50%, 8px); }
  15% { opacity: 1; }
  100% { opacity: 0; transform: translate(-50%, -40px); }
}
@keyframes fx-overlay-shake {
  0% { transform: translateX(0); }
  15% { transform: translateX(-6px); }
  30% { transform: translateX(5px); }
  45% { transform: translateX(-4px); }
  60% { transform: translateX(3px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}
`;
var lifeMsOf = (it, tickMs) => Math.max(it.maxTtl ?? it.ttl, it.ttl, 1) * tickMs;
function ConfettiBurst({ item, lifeMs }) {
  const particles = createConfettiParticles(item.particleCount ?? 30, item.id);
  const left = (item.x ?? 0.5) * 100;
  const top = (item.z ?? item.y ?? 0.4) * 100;
  return /* @__PURE__ */ jsx(Box, { position: "absolute", style: { left: `${left}%`, top: `${top}%` }, children: particles.map((p) => {
    const rad = p.angle * Math.PI / 180;
    const tx = Math.cos(rad) * p.distance * (item.size ?? 1);
    const ty = Math.sin(rad) * p.distance * (item.size ?? 1) - 20;
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "absolute rounded-sm",
        style: {
          left: (p.left - 50) * 2,
          top: -10,
          width: p.size,
          height: p.size,
          backgroundColor: item.color ?? p.color,
          animation: `confetti-burst ${Math.max(lifeMs - p.delay, 200)}ms ease-out ${p.delay}ms forwards`,
          opacity: 0,
          "--confetti-tx": `${tx}px`,
          "--confetti-ty": `${ty}px`,
          "--confetti-rotate": `${p.rotation}deg`
        }
      },
      p.id
    );
  }) });
}
function SparkleBurst({ item, lifeMs }) {
  const count = item.particleCount ?? 8;
  const scale = item.size ?? 1;
  const left = (item.x ?? 0.5) * 100;
  const top = (item.z ?? item.y ?? 0.4) * 100;
  return /* @__PURE__ */ jsx(Box, { position: "absolute", style: { left: `${left}%`, top: `${top}%` }, children: Array.from({ length: count }, (_, i) => {
    const dx = (fxHash01(item.id, i * 4) - 0.5) * 160 * scale;
    const dy = (fxHash01(item.id, i * 4 + 1) - 0.5) * 120 * scale;
    const dot = (4 + fxHash01(item.id, i * 4 + 2) * 5) * scale;
    const delay = fxHash01(item.id, i * 4 + 3) * lifeMs * 0.4;
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "absolute rounded-full",
        style: {
          left: dx,
          top: dy,
          width: dot,
          height: dot,
          backgroundColor: item.color ?? "gold",
          opacity: 0,
          animation: `fx-overlay-sparkle ${Math.max(lifeMs - delay, 200)}ms ease-in-out ${delay}ms forwards`
        }
      },
      i
    );
  }) });
}
function OverlayFxNode({ item, tickMs }) {
  const lifeMs = lifeMsOf(item, tickMs);
  switch (item.effect ?? "sparkle") {
    case "confetti":
      return /* @__PURE__ */ jsx(ConfettiBurst, { item, lifeMs });
    case "flash":
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          className: "inset-0",
          style: {
            backgroundColor: item.color ?? "#ffffff",
            opacity: 0,
            animation: `fx-overlay-flash ${lifeMs}ms ease-out forwards`
          }
        }
      );
    case "streak-glow":
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          className: "inset-0",
          style: {
            boxShadow: `inset 0 0 ${60 * (item.size ?? 1)}px ${item.color ?? "var(--color-warning)"}`,
            opacity: 0,
            animation: `fx-overlay-glow ${lifeMs}ms ease-in-out forwards`
          }
        }
      );
    case "float-text": {
      if (!item.message) return null;
      return /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          style: {
            left: `${(item.x ?? 0.5) * 100}%`,
            top: `${(item.z ?? item.y ?? 0.4) * 100}%`,
            color: item.color ?? "var(--color-success)",
            fontWeight: 700,
            fontSize: 16 * (item.size ?? 1),
            textShadow: "0 1px 2px rgba(0,0,0,0.4)",
            opacity: 0,
            animation: `fx-overlay-float ${lifeMs}ms ease-out forwards`,
            whiteSpace: "nowrap"
          },
          children: item.message
        }
      );
    }
    case "shake":
      return null;
    default:
      return /* @__PURE__ */ jsx(SparkleBurst, { item, lifeMs });
  }
}
var FxOverlay = ({ items, tickMs = DEFAULT_TICK_MS, children, className, ...rest }) => {
  const screenItems = (Array.isArray(items) ? items : []).filter(
    (it) => Boolean(it) && typeof it.id === "string" && it.space !== "world"
  );
  const shakeItem = [...screenItems].reverse().find((it) => it.effect === "shake");
  const hasChildren = children !== void 0 && children !== null;
  const overlay = /* @__PURE__ */ jsxs(
    Box,
    {
      ...hasChildren ? void 0 : domPassthrough(rest),
      position: "absolute",
      className: cn("inset-0 pointer-events-none overflow-hidden z-50", !children && className),
      "aria-hidden": "true",
      children: [
        screenItems.map((it) => /* @__PURE__ */ jsx(OverlayFxNode, { item: it, tickMs }, it.id)),
        /* @__PURE__ */ jsx("style", { children: FX_OVERLAY_KEYFRAMES })
      ]
    }
  );
  if (hasChildren) {
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), position: "relative", className, children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          style: shakeItem ? { animation: `fx-overlay-shake ${Math.min(lifeMsOf(shakeItem, tickMs), 600)}ms ease-in-out` } : void 0,
          children
        },
        shakeItem?.id ?? "steady"
      ),
      overlay
    ] });
  }
  return overlay;
};
FxOverlay.displayName = "FxOverlay";
var DAY_MS = 24 * 60 * 60 * 1e3;
var ROW_HEIGHT = 36;
var HEADER_HEIGHT = 44;
var LABEL_WIDTH = 192;
var BAR_CLASS = {
  default: "bg-primary/80 hover:bg-primary",
  primary: "bg-primary/80 hover:bg-primary",
  secondary: "bg-secondary/80 hover:bg-secondary",
  success: "bg-success/80 hover:bg-success",
  warning: "bg-warning/80 hover:bg-warning",
  danger: "bg-error/80 hover:bg-error",
  error: "bg-error/80 hover:bg-error",
  info: "bg-info/80 hover:bg-info",
  neutral: "bg-muted-foreground/50 hover:bg-muted-foreground/70"
};
function parseDay(value) {
  if (value === void 0 || value === null || value === "") return null;
  const d = value instanceof Date ? new Date(value.getTime()) : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}
function Gantt({
  tasks = [],
  links = [],
  titleField = "title",
  startField = "start",
  endField = "end",
  durationField,
  statusField = "status",
  statusColorMap,
  groupField = "",
  rangeStart,
  rangeEnd,
  showToday = true,
  dayWidth = 28,
  barClickEvent,
  className,
  isLoading = false,
  error = null,
  surface = "auto",
  ...rest
}) {
  const contentSurface = useContentSurface(surface);
  const { t } = useTranslate();
  const placed = useMemo(() => {
    const rows2 = Array.isArray(tasks) ? tasks : tasks ? [tasks] : [];
    const out = [];
    rows2.forEach((row, idx) => {
      const declaredEnd = parseDay(getNestedValue(row, endField));
      const declaredStart = parseDay(getNestedValue(row, startField)) ?? declaredEnd;
      if (!declaredStart) return;
      let start = declaredStart;
      let end;
      let reversed = false;
      if (declaredEnd) {
        reversed = declaredEnd.getTime() < declaredStart.getTime();
        if (reversed) start = declaredEnd;
        end = new Date((reversed ? declaredStart : declaredEnd).getTime() + DAY_MS);
      } else {
        const days2 = durationField ? Number(getNestedValue(row, durationField)) : NaN;
        end = new Date(start.getTime() + (Number.isFinite(days2) && days2 > 0 ? days2 : 1) * DAY_MS);
      }
      out.push({
        row,
        id: String(row.id ?? idx),
        label: String(getNestedValue(row, titleField) ?? ""),
        status: String(getNestedValue(row, statusField) ?? ""),
        group: groupField ? String(getNestedValue(row, groupField) ?? "") : "",
        start,
        end,
        reversed
      });
    });
    return out;
  }, [tasks, titleField, startField, endField, durationField, statusField, groupField]);
  const [axisStart, axisEnd] = useMemo(() => {
    const lo = parseDay(rangeStart) ?? (placed.length ? new Date(Math.min(...placed.map((p) => p.start.getTime())) - 2 * DAY_MS) : new Date((/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0)));
    const hi = parseDay(rangeEnd) ?? (placed.length ? new Date(Math.max(...placed.map((p) => p.end.getTime())) + 2 * DAY_MS) : new Date(lo.getTime() + 30 * DAY_MS));
    return hi.getTime() > lo.getTime() ? [lo, hi] : [lo, new Date(lo.getTime() + DAY_MS)];
  }, [rangeStart, rangeEnd, placed]);
  const totalDays = Math.round((axisEnd.getTime() - axisStart.getTime()) / DAY_MS);
  const chartWidth = totalDays * dayWidth;
  const dayOffset = (d) => (d.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
  const displayItems = useMemo(() => {
    if (!groupField) return placed.map((task) => ({ kind: "task", task }));
    const items = [];
    const seen = /* @__PURE__ */ new Set();
    for (const task of placed) {
      if (!seen.has(task.group)) {
        seen.add(task.group);
        items.push({ kind: "group", label: task.group || "\u2014" });
      }
      items.push({ kind: "task", task });
    }
    return items;
  }, [placed, groupField]);
  const barGeometry = useMemo(() => {
    const offset = (d) => (d.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
    const map = /* @__PURE__ */ new Map();
    displayItems.forEach((item, idx) => {
      if (item.kind !== "task") return;
      const x0 = offset(item.task.start);
      const x1 = Math.max(offset(item.task.end), x0 + dayWidth / 2);
      map.set(item.task.id, { x0, x1, y: HEADER_HEIGHT + idx * ROW_HEIGHT + ROW_HEIGHT / 2 });
    });
    return map;
  }, [displayItems, axisStart, dayWidth]);
  const days = useMemo(() => {
    const out = [];
    for (let i = 0; i < totalDays; i++) out.push(new Date(axisStart.getTime() + i * DAY_MS));
    return out;
  }, [axisStart, totalDays]);
  const todayOffset = useMemo(() => {
    const today = parseDay(/* @__PURE__ */ new Date());
    if (!today || today < axisStart || today > axisEnd) return null;
    return (today.getTime() - axisStart.getTime()) / DAY_MS * dayWidth;
  }, [axisStart, axisEnd, dayWidth]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { ...domPassthrough(rest), message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("p-4", className), children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "error", children: error.message }) });
  }
  if (placed.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        ...domPassthrough(rest),
        title: t("empty.noData"),
        className
      }
    );
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(rest),
        className: cn("w-full overflow-auto", contentSurface.className, className),
        children: /* @__PURE__ */ jsxs(Box, { className: "relative", style: { width: LABEL_WIDTH + chartWidth, minWidth: "100%" }, children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "none", className: "sticky top-0 z-20 bg-card border-b border-border", style: { height: HEADER_HEIGHT }, children: [
            /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-card border-r border-border", style: { width: LABEL_WIDTH, height: HEADER_HEIGHT } }),
            /* @__PURE__ */ jsx(Box, { className: "relative", style: { width: chartWidth, height: HEADER_HEIGHT }, children: days.map((day, i) => /* @__PURE__ */ jsx(
              Box,
              {
                className: cn(
                  "absolute top-0 bottom-0 border-l border-border/50 flex items-end justify-center pb-1",
                  day.getDay() === 0 || day.getDay() === 6 ? "bg-muted/40" : void 0
                ),
                style: { left: i * dayWidth, width: dayWidth },
                children: dayWidth >= 20 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: day.getDate() })
              },
              i
            )) })
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "relative", children: [
            displayItems.map(
              (item, idx) => item.kind === "group" ? /* @__PURE__ */ jsxs(
                HStack,
                {
                  gap: "none",
                  className: "border-b border-border bg-muted/30",
                  style: { height: ROW_HEIGHT },
                  children: [
                    /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-muted/30 px-3 flex items-center border-r border-border", style: { width: LABEL_WIDTH, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", children: item.label }) }),
                    /* @__PURE__ */ jsx(Box, { style: { width: chartWidth, height: ROW_HEIGHT } })
                  ]
                },
                `g-${idx}`
              ) : /* @__PURE__ */ jsxs(
                HStack,
                {
                  gap: "none",
                  className: "border-b border-border/50",
                  style: { height: ROW_HEIGHT },
                  children: [
                    /* @__PURE__ */ jsx(Box, { className: "sticky left-0 z-10 shrink-0 bg-card px-3 flex items-center border-r border-border", style: { width: LABEL_WIDTH, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "truncate", children: item.task.label }) }),
                    /* @__PURE__ */ jsx(Box, { className: "relative", style: { width: chartWidth, height: ROW_HEIGHT }, children: /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: cn(
                          "absolute top-1/2 -translate-y-1/2 h-4 rounded-sm transition-colors",
                          item.task.reversed ? "bg-error/30 border border-dashed border-error" : BAR_CLASS[badgeVariantFor(item.task.status, statusColorMap)],
                          barClickEvent ? "cursor-pointer" : void 0
                        ),
                        style: {
                          left: dayOffset(item.task.start),
                          width: dayOffset(item.task.end) - dayOffset(item.task.start)
                        },
                        "data-gantt-bar": item.task.id,
                        "data-dates-reversed": item.task.reversed ? "true" : void 0,
                        title: item.task.reversed ? t("gantt.datesReversed") : void 0,
                        action: barClickEvent,
                        actionPayload: { id: item.task.id }
                      }
                    ) })
                  ]
                },
                item.task.id
              )
            ),
            links.length > 0 && /* @__PURE__ */ jsxs(
              "svg",
              {
                className: "absolute pointer-events-none",
                style: { left: LABEL_WIDTH, top: 0 },
                width: chartWidth,
                height: HEADER_HEIGHT + displayItems.length * ROW_HEIGHT,
                children: [
                  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("marker", { id: "gantt-arrow", markerWidth: "8", markerHeight: "8", refX: "7", refY: "4", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L8,4 L0,8 z", fill: "var(--muted-foreground, currentColor)" }) }) }),
                  links.map((link, i) => {
                    const from = barGeometry.get(link.from);
                    const to = barGeometry.get(link.to);
                    if (!from || !to) return null;
                    const midX = from.x1 + Math.max(8, (to.x0 - from.x1) / 2);
                    return /* @__PURE__ */ jsx(
                      "path",
                      {
                        d: `M ${from.x1} ${from.y} L ${midX} ${from.y} L ${midX} ${to.y} L ${to.x0} ${to.y}`,
                        fill: "none",
                        stroke: "var(--muted-foreground, currentColor)",
                        strokeWidth: 1.5,
                        markerEnd: "url(#gantt-arrow)"
                      },
                      i
                    );
                  })
                ]
              }
            ),
            showToday && todayOffset !== null && /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute top-0 bottom-0 w-0.5 bg-error/70 pointer-events-none",
                style: { left: LABEL_WIDTH + todayOffset }
              }
            )
          ] })
        ] })
      }
    )
  );
}
Gantt.displayName = "Gantt";
var GenericAppTemplate = ({
  entity,
  title,
  subtitle,
  children,
  headerActions,
  footer,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs(Box, { display: "flex", fullHeight: true, ...domPassthrough(rest), className: cn("flex-col", className), children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        padding: "md",
        border: true,
        className: "border-b-heavy border-x-0 border-t-0 border-border flex items-center justify-between flex-shrink-0",
        children: [
          /* @__PURE__ */ jsxs(Box, { children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h3", children: title }),
            subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "secondary", className: "mt-1", children: subtitle })
          ] }),
          headerActions && /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: headerActions })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Box, { fullWidth: true, overflow: "auto", className: "flex-1", children: /* @__PURE__ */ jsx(Box, { padding: "lg", children }) }),
    footer && /* @__PURE__ */ jsx(
      Box,
      {
        padding: "md",
        border: true,
        bg: "muted",
        className: "border-t-heavy border-x-0 border-b-0 border-border flex-shrink-0",
        children: footer
      }
    )
  ] });
};
GenericAppTemplate.displayName = "GenericAppTemplate";
function PatternDefs({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth
}) {
  const dims = getTileDimensions(variant, size2);
  return /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
    "pattern",
    {
      id: patternId,
      x: "0",
      y: "0",
      width: dims.width,
      height: dims.height,
      patternUnits: "userSpaceOnUse",
      children: /* @__PURE__ */ jsx(
        PatternTile,
        {
          variant,
          size: size2,
          color,
          strokeWidth
        }
      )
    }
  ) });
}
function BackgroundMode({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth,
  opacity,
  className
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size: size2,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            opacity
          }
        )
      ]
    }
  );
}
function SideMode({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth,
  opacity,
  side,
  className
}) {
  const maskId = `${patternId}-mask`;
  const gradientId = `${patternId}-grad`;
  const x1 = side === "left" ? "0%" : "100%";
  const x2 = side === "left" ? "60%" : "40%";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size: size2,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1, y1: "0%", x2, y2: "0%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "0" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function DualMode({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth,
  opacity,
  className
}) {
  const maskId = `${patternId}-dmask`;
  const gradientId = `${patternId}-dgrad`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size: size2,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "35%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "65%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "1" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function AroundMode({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth,
  opacity,
  className
}) {
  const maskId = `${patternId}-amask`;
  const gradientId = `${patternId}-agrad`;
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: cn("absolute inset-0 w-full h-full pointer-events-none", className),
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size: size2,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("radialGradient", { id: gradientId, cx: "50%", cy: "50%", r: "50%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "55%", stopColor: "white", stopOpacity: "0" }),
            /* @__PURE__ */ jsx("stop", { offset: "85%", stopColor: "white", stopOpacity: "1" }),
            /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: "white", stopOpacity: "1" })
          ] }),
          /* @__PURE__ */ jsx("mask", { id: maskId, children: /* @__PURE__ */ jsx("rect", { width: "100%", height: "100%", fill: `url(#${gradientId})` }) })
        ] }),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            mask: `url(#${maskId})`,
            opacity
          }
        )
      ]
    }
  );
}
function FrameStrip({
  patternId,
  variant,
  size: size2,
  color,
  strokeWidth,
  opacity,
  height
}) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: "w-full pointer-events-none",
      style: { height },
      preserveAspectRatio: "none",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ jsx(
          PatternDefs,
          {
            patternId,
            variant,
            size: size2,
            color,
            strokeWidth
          }
        ),
        /* @__PURE__ */ jsx(
          "rect",
          {
            width: "100%",
            height: "100%",
            fill: `url(#${patternId})`,
            opacity
          }
        )
      ]
    }
  );
}
var GeometricPattern = ({
  variant = "star8",
  mode = "background",
  opacity = 0.06,
  color = "var(--color-primary)",
  scale = 1,
  strokeWidth = 0.5,
  children,
  className
}) => {
  const reactId = useId();
  const patternId = `gp${reactId.replace(/:/g, "")}`;
  const size2 = 60 * scale;
  const stripHeight = 40 * scale;
  if (mode === "frame") {
    const topId = `${patternId}-top`;
    const botId = `${patternId}-bot`;
    return /* @__PURE__ */ jsxs(Box, { className: cn("relative", className), children: [
      /* @__PURE__ */ jsx(
        FrameStrip,
        {
          patternId: topId,
          variant,
          size: size2,
          color,
          strokeWidth,
          opacity,
          height: stripHeight
        }
      ),
      children,
      /* @__PURE__ */ jsx(
        FrameStrip,
        {
          patternId: botId,
          variant,
          size: size2,
          color,
          strokeWidth,
          opacity,
          height: stripHeight
        }
      )
    ] });
  }
  if (mode === "around") {
    return /* @__PURE__ */ jsx(
      AroundMode,
      {
        patternId,
        variant,
        size: size2,
        color,
        strokeWidth,
        opacity,
        className
      }
    );
  }
  if (mode === "dual") {
    return /* @__PURE__ */ jsx(
      DualMode,
      {
        patternId,
        variant,
        size: size2,
        color,
        strokeWidth,
        opacity,
        className
      }
    );
  }
  if (mode === "left" || mode === "right") {
    return /* @__PURE__ */ jsx(
      SideMode,
      {
        patternId,
        variant,
        size: size2,
        color,
        strokeWidth,
        opacity,
        side: mode,
        className
      }
    );
  }
  return /* @__PURE__ */ jsx(
    BackgroundMode,
    {
      patternId,
      variant,
      size: size2,
      color,
      strokeWidth,
      opacity,
      className
    }
  );
};
GeometricPattern.displayName = "GeometricPattern";
var colorTokenVars2 = {
  primary: "var(--color-primary)",
  secondary: "var(--color-secondary)",
  success: "var(--color-success)",
  warning: "var(--color-warning)",
  error: "var(--color-error)",
  muted: "var(--color-muted)"
};
var GradientDivider = ({
  color,
  className,
  ...rest
}) => {
  const centerColor = color ? color in colorTokenVars2 ? colorTokenVars2[color] : color : "var(--color-primary)";
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      className: cn("w-full h-px", className),
      style: {
        background: `linear-gradient(to right, transparent, ${centerColor}, transparent)`
      }
    }
  );
};
GradientDivider.displayName = "GradientDivider";
var GROUP_COLORS = THEME_SERIES;
var GROUP_GRAVITY = 0.3;
var UNGROUPED_GRAVITY = 0.02;
var labelMeasureCtx = null;
function measureLabelWidth(text, fontFamily = "system-ui") {
  if (typeof document === "undefined") return text.length * 6;
  if (!labelMeasureCtx) labelMeasureCtx = document.createElement("canvas").getContext("2d");
  if (!labelMeasureCtx) return text.length * 6;
  labelMeasureCtx.font = `12px ${fontFamily}`;
  return labelMeasureCtx.measureText(text).width + 4;
}
function getGroupColor(group, groups) {
  if (!group) return groups.length > 0 ? "var(--color-muted-foreground)" : GROUP_COLORS[0];
  const idx = groups.indexOf(group);
  return GROUP_COLORS[idx % GROUP_COLORS.length];
}
function hashSeed(str2) {
  let h = 1779033703 ^ str2.length;
  for (let i = 0; i < str2.length; i++) {
    h = Math.imul(h ^ str2.charCodeAt(i), 3432918353);
    h = h << 13 | h >>> 19;
  }
  return (h ^= h >>> 16) >>> 0;
}
function mulberry32(a) {
  return function() {
    a |= 0;
    a = a + 1831565813 | 0;
    let t = Math.imul(a ^ a >>> 15, 1 | a);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function edgeStroke(weight, linkOpacity, strokes) {
  if (weight === void 0) return { alpha: linkOpacity, width: strokes.thin };
  const w = Math.min(1, Math.max(0, weight));
  return { alpha: linkOpacity, width: strokes.thin + (strokes.normal - strokes.thin) * w };
}
function edgeKeyOf(a, b) {
  return a < b ? `${a}\0${b}` : `${b}\0${a}`;
}
var MAX_LABEL_CHARS = 22;
function truncateLabel(label) {
  return label.length > MAX_LABEL_CHARS ? label.slice(0, MAX_LABEL_CHARS - 1) + "\u2026" : label;
}
var NO_NODES = [];
var NO_EDGES = [];
var NO_SIM = [];
var GraphCanvas = ({
  title,
  nodes: propNodes = NO_NODES,
  edges: propEdges = NO_EDGES,
  proposedEdges = NO_EDGES,
  similarity: propSimilarity = NO_SIM,
  height = 400,
  showLabels = true,
  interactive = true,
  draggable = true,
  actions,
  onNodeClick,
  onMarkClick,
  onNodeDoubleClick,
  onBadgeClick,
  nodeClickEvent,
  selectedNodeId,
  repulsion = 800,
  linkDistance = 100,
  nodeSpacing = 28,
  linkOpacity = 0.18,
  layout = "force",
  isLoading = false,
  error,
  className,
  description,
  ...rest
}) => {
  const descId = React93__default.useId();
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const canvasRef = useRef(null);
  const { theme: canvasTheme } = useCanvasTheme(canvasRef);
  const animRef = useRef(0);
  const [zoom, setZoom] = useState(1);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const zoomRef = useRef(zoom);
  zoomRef.current = zoom;
  const offsetRef = useRef(offset);
  offsetRef.current = offset;
  const [hoveredNode, setHoveredNode] = useState(null);
  const nodesRef = useRef([]);
  const laidOutRef = useRef(false);
  const [, forceUpdate] = useState(0);
  const [logicalW, setLogicalW] = useState(800);
  const hasProposed = useMemo(() => propNodes.some((n) => n.mark?.kind === "proposed"), [propNodes]);
  const [pulseTick, setPulseTick] = useState(0);
  const motionOn = canvasTheme?.motion.enabled !== false;
  useEffect(() => {
    if (!hasProposed || !motionOn) return;
    let raf = 0;
    const loop = () => {
      setPulseTick((t2) => (t2 + 1) % 1e6);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, [hasProposed, motionOn]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || typeof ResizeObserver === "undefined") return;
    const measure = () => {
      const width = Math.round(canvas.clientWidth);
      if (width > 0) setLogicalW(width);
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(canvas);
    return () => ro.disconnect();
  }, []);
  const interactionRef = useRef({
    mode: "none",
    dragNodeId: null,
    pressedNodeId: null,
    startMouse: { x: 0, y: 0 },
    startOffset: { x: 0, y: 0 },
    downPos: { x: 0, y: 0 }
  });
  const toCoords = useCallback(
    (e) => {
      const canvas = canvasRef.current;
      if (!canvas) return null;
      const rect = canvas.getBoundingClientRect();
      const screenX = e.clientX - rect.left;
      const screenY = e.clientY - rect.top;
      return {
        screenX,
        screenY,
        graphX: (screenX - offset.x) / zoom,
        graphY: (screenY - offset.y) / zoom
      };
    },
    [offset, zoom]
  );
  const nodeAt = useCallback((graphX, graphY) => {
    return nodesRef.current.find((n) => {
      const dist = Math.sqrt((n.x - graphX) ** 2 + (n.y - graphY) ** 2);
      return dist < (n.size || 8) + 4;
    });
  }, []);
  const handleAction = useCallback(
    (action) => {
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, {});
      }
    },
    [eventBus]
  );
  const handleNodeClick = useCallback(
    (node) => {
      if (nodeClickEvent) {
        eventBus.emit(`UI:${nodeClickEvent}`, { id: node.id, row: node });
      }
      onNodeClick?.(node);
    },
    [nodeClickEvent, eventBus, onNodeClick]
  );
  const groups = useMemo(
    () => [...new Set(propNodes.map((n) => n.group).filter(Boolean))],
    [propNodes]
  );
  const nodesKey = useMemo(() => propNodes.map((n) => n.id).join(""), [propNodes]);
  const edgesKey = useMemo(
    () => propEdges.map((e) => `${e.source}${e.target}`).join(""),
    [propEdges]
  );
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || propNodes.length === 0) return;
    const viewW = logicalW;
    const viewH = height;
    const layoutScale2 = Math.max(1, Math.min(3, Math.sqrt(propNodes.length / 12)));
    const w = viewW * layoutScale2;
    const h = viewH * layoutScale2;
    const labelFont2 = canvasTheme ? canvasTheme.faces[canvasTheme.label.font] : "system-ui";
    const clamp01 = (v) => Math.min(1, Math.max(0, v));
    const prevPos = /* @__PURE__ */ new Map();
    for (const pn of nodesRef.current) if (pn.x != null && pn.y != null) prevPos.set(pn.id, { x: pn.x, y: pn.y });
    const simNodes = propNodes.map((n, idx) => {
      const prev = prevPos.get(n.id);
      let x = prev?.x ?? n.x ?? 0;
      let y = prev?.y ?? n.y ?? 0;
      if (!prev && (!n.x || !n.y)) {
        if (layout === "circular") {
          const angle = idx / propNodes.length * 2 * Math.PI;
          const radius = Math.min(w, h) * 0.35;
          x = w / 2 + radius * Math.cos(angle);
          y = h / 2 + radius * Math.sin(angle);
        } else if (layout === "grid") {
          const cols = Math.ceil(Math.sqrt(propNodes.length));
          const gapX = w / (cols + 1);
          const gapY = h / (Math.ceil(propNodes.length / cols) + 1);
          x = gapX * (idx % cols + 1);
          y = gapY * (Math.floor(idx / cols) + 1);
        } else {
          const rand = mulberry32(hashSeed(n.id));
          x = w * 0.2 + rand() * w * 0.6;
          y = h * 0.2 + rand() * h * 0.6;
        }
      }
      return { ...n, x, y, vx: 0, vy: 0 };
    });
    nodesRef.current = simNodes;
    const prevIds = /* @__PURE__ */ new Set([...prevPos.keys()]);
    const newIdList = simNodes.map((n) => n.id);
    const kept = newIdList.filter((id) => prevIds.has(id)).length;
    const overlap = prevIds.size === 0 ? 0 : kept / Math.max(prevIds.size, newIdList.length);
    const fullRelayout = !laidOutRef.current || overlap < 0.5;
    if (layout === "force") {
      if (fullRelayout) {
        const LABEL_GAP = 12;
        const LABEL_H = 16;
        for (const n of simNodes) n.labelW = showLabels && n.label ? measureLabelWidth(truncateLabel(n.label), labelFont2) : 0;
        const SIMILARITY_NEIGHBORS = 5;
        const SIMILARITY_MIN_WEIGHT = 0.25;
        const drawnPairs = /* @__PURE__ */ new Set();
        for (const edge of propEdges) drawnPairs.add(edgeKeyOf(edge.source, edge.target));
        const similarityNeighbors = /* @__PURE__ */ new Map();
        const bySource = /* @__PURE__ */ new Map();
        for (const pair of propSimilarity) {
          if (pair.weight < SIMILARITY_MIN_WEIGHT) continue;
          if (drawnPairs.has(edgeKeyOf(pair.source, pair.target))) continue;
          const arr = bySource.get(pair.source) ?? [];
          arr.push(pair);
          bySource.set(pair.source, arr);
        }
        for (const [id, arr] of bySource) {
          arr.sort((a, b) => b.weight - a.weight);
          similarityNeighbors.set(id, new Set(arr.slice(0, SIMILARITY_NEIGHBORS).map((p) => p.target)));
        }
        const activeSimilarity = propSimilarity.filter((pair) => {
          if (drawnPairs.has(edgeKeyOf(pair.source, pair.target))) return false;
          const a = similarityNeighbors.get(pair.source);
          const b = similarityNeighbors.get(pair.target);
          return (a?.has(pair.target) ?? false) || (b?.has(pair.source) ?? false);
        });
        const groupTarget = /* @__PURE__ */ new Map();
        const multiCluster = groups.length > 1;
        if (multiCluster) {
          const ring = Math.min(w, h) * 0.34;
          groups.forEach((g, i) => {
            const a = i / groups.length * 2 * Math.PI;
            groupTarget.set(g, { x: w / 2 + ring * Math.cos(a), y: h / 2 + ring * Math.sin(a) });
          });
        }
        const present = new Set(simNodes.map((n) => n.id));
        const edgeLinks = propEdges.filter((e) => present.has(e.source) && present.has(e.target)).map((e) => ({ source: e.source, target: e.target, weight: clamp01(e.weight ?? 1) }));
        const simLinks = activeSimilarity.filter((p) => present.has(p.source) && present.has(p.target)).map((p) => ({ source: p.source, target: p.target, weight: clamp01(p.weight) }));
        const collideRadius = (n) => Math.max(n.size || 8, (n.labelW ?? 0) / 2) + nodeSpacing / 2;
        const simulation = forceSimulation(simNodes).force("edge", forceLink(edgeLinks).id((d) => d.id).distance((l) => linkDistance * (0.35 + (1 - l.weight) * 0.3)).strength(0.9)).force("similarity", forceLink(simLinks).id((d) => d.id).distance((l) => linkDistance * (1.35 - 0.55 * l.weight)).strength(0.03)).force("charge", forceManyBody().strength(-repulsion * 0.5)).force("collide", forceCollide().radius(collideRadius).strength(0.9)).force("x", forceX((n) => groupTarget.get(n.group ?? "")?.x ?? w / 2).strength((n) => multiCluster && n.group ? GROUP_GRAVITY : UNGROUPED_GRAVITY)).force("y", forceY((n) => groupTarget.get(n.group ?? "")?.y ?? h / 2).strength((n) => multiCluster && n.group ? GROUP_GRAVITY : UNGROUPED_GRAVITY)).stop();
        for (let i = 0; i < 300; i++) simulation.tick();
        const pad = nodeSpacing / 2;
        const rectsOf = (n) => {
          const r = n.size || 8;
          const lw = showLabels ? n.labelW ?? 0 : 0;
          return {
            circle: [n.x - r - pad, n.y - r - pad, n.x + r + pad, n.y + r + pad],
            label: [n.x - lw / 2 - pad, n.y + r + LABEL_GAP - 8, n.x + lw / 2 + pad, n.y + r + LABEL_GAP + LABEL_H]
          };
        };
        const sep = (r1, r2) => {
          const ox = Math.min(r1[2], r2[2]) - Math.max(r1[0], r2[0]);
          const oy = Math.min(r1[3], r2[3]) - Math.max(r1[1], r2[1]);
          if (ox <= 0 || oy <= 0) return null;
          return ox <= oy ? { axis: "x", depth: ox, sign: r1[0] + r1[2] < r2[0] + r2[2] ? 1 : -1 } : { axis: "y", depth: oy, sign: r1[1] + r1[3] < r2[1] + r2[3] ? 1 : -1 };
        };
        for (let pass = 0; pass < 24; pass++) {
          let moved = false;
          for (let i = 0; i < simNodes.length; i++) {
            for (let j = i + 1; j < simNodes.length; j++) {
              const a = simNodes[i];
              const b = simNodes[j];
              const ra = rectsOf(a);
              const rb = rectsOf(b);
              let best = null;
              for (const [r1, r2] of [[ra.circle, rb.circle], [ra.circle, rb.label], [ra.label, rb.circle], [ra.label, rb.label]]) {
                const s = sep(r1, r2);
                if (s && (!best || s.depth < best.depth)) best = s;
              }
              if (best) {
                moved = true;
                const push = best.depth / 2;
                if (best.axis === "x") {
                  a.x = Math.max(30, Math.min(w - 30, a.x - push * best.sign));
                  b.x = Math.max(30, Math.min(w - 30, b.x + push * best.sign));
                } else {
                  a.y = Math.max(30, Math.min(h - 30, a.y - push * best.sign));
                  b.y = Math.max(30, Math.min(h - 30, b.y + push * best.sign));
                }
              }
            }
          }
          if (!moved) break;
        }
        const fitPad = 40;
        let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for (const node of nodesRef.current) {
          const r = node.size || 8;
          const lw = showLabels ? node.labelW ?? 0 : 0;
          minX = Math.min(minX, node.x - r, node.x - lw / 2);
          minY = Math.min(minY, node.y - r);
          maxX = Math.max(maxX, node.x + r, node.x + lw / 2);
          maxY = Math.max(maxY, node.y + r + LABEL_GAP + LABEL_H);
        }
        const bboxW = Math.max(1, maxX - minX + fitPad * 2);
        const bboxH = Math.max(1, maxY - minY + fitPad * 2);
        const nextZoom = Math.min(1, viewW / bboxW, viewH / bboxH);
        setZoom(nextZoom);
        setOffset({ x: fitPad - minX * nextZoom, y: fitPad - minY * nextZoom });
        laidOutRef.current = true;
      } else {
        const centroids = /* @__PURE__ */ new Map();
        for (const node of simNodes) {
          if (!prevPos.has(node.id)) continue;
          const g = node.group ?? "__none__";
          let c = centroids.get(g);
          if (!c) {
            c = { x: 0, y: 0, n: 0 };
            centroids.set(g, c);
          }
          c.x += node.x;
          c.y += node.y;
          c.n += 1;
        }
        const ringCount = /* @__PURE__ */ new Map();
        for (const node of simNodes) {
          if (prevPos.has(node.id)) continue;
          const g = node.group ?? "__none__";
          const c = centroids.get(g);
          const cx = c && c.n > 0 ? c.x / c.n : w / 2;
          const cy = c && c.n > 0 ? c.y / c.n : h / 2;
          const k = ringCount.get(g) ?? 0;
          ringCount.set(g, k + 1);
          const angle = k * 2.399963;
          const r = 22 + k * 8;
          node.x = Math.max(30, Math.min(w - 30, cx + r * Math.cos(angle)));
          node.y = Math.max(30, Math.min(h - 30, cy + r * Math.sin(angle)));
        }
      }
      forceUpdate((n) => n + 1);
    } else {
      forceUpdate((n) => n + 1);
    }
    return () => {
      cancelAnimationFrame(animRef.current);
    };
  }, [nodesKey, edgesKey, propSimilarity, layout, repulsion, linkDistance, nodeSpacing, showLabels]);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;
    const w = logicalW;
    const h = height;
    const nodes = nodesRef.current;
    if (!canvasTheme) return;
    const theme = canvasTheme;
    const accentColor = theme.tones.highlight;
    const fgColor = theme.tones.ink;
    const mutedColor = theme.tones.guide;
    const bgColor = theme.ground;
    const accentFg = theme.ground;
    const strokes = theme.strokes;
    const font = (role, weight) => {
      const f3 = labelFont(theme, { textSize: role });
      return weight ? f3.font.replace(/^\S+/, weight) : f3.font;
    };
    const fgResolved = resolveThemeColor("var(--color-diagram-ink)", canvas);
    const nodeRingColor = fgResolved ? `rgba(${fgResolved.r}, ${fgResolved.g}, ${fgResolved.b}, 0.13)` : fgColor;
    const dpr = typeof window !== "undefined" && window.devicePixelRatio || 1;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, w, h);
    ctx.save();
    ctx.translate(offset.x, offset.y);
    ctx.scale(zoom, zoom);
    const neighbors = /* @__PURE__ */ new Set();
    if (hoveredNode) {
      neighbors.add(hoveredNode);
      for (const edge of propEdges) {
        if (edge.source === hoveredNode) neighbors.add(String(edge.target));
        else if (edge.target === hoveredNode) neighbors.add(String(edge.source));
      }
    }
    for (const edge of propEdges) {
      const source = nodes.find((n) => n.id === edge.source);
      const target = nodes.find((n) => n.id === edge.target);
      if (!source || !target) continue;
      const incident = !!hoveredNode && (edge.source === hoveredNode || edge.target === hoveredNode);
      const stroke = edgeStroke(edge.weight, linkOpacity, strokes);
      ctx.globalAlpha = hoveredNode ? incident ? 1 : 0.05 : stroke.alpha;
      ctx.beginPath();
      ctx.moveTo(source.x, source.y);
      ctx.lineTo(target.x, target.y);
      const edgeColor = incident ? accentColor : edge.color ? markColor(theme, edge.color, canvas, "guide") : mutedColor;
      applyLineCharacter(ctx, theme, edgeColor);
      ctx.strokeStyle = edgeColor;
      ctx.lineWidth = incident ? strokes.bold : stroke.width;
      ctx.stroke();
      ctx.shadowBlur = 0;
      if (edge.label && showLabels) {
        const mx = (source.x + target.x) / 2;
        const my = (source.y + target.y) / 2;
        ctx.fillStyle = mutedColor;
        ctx.font = font("xs");
        ctx.textAlign = "center";
        ctx.textBaseline = "alphabetic";
        fillLabel(ctx, theme, labelText(theme, edge.label), mx, my - 4);
      }
    }
    ctx.globalAlpha = 1;
    ctx.setLineDash([...theme.dash]);
    for (const edge of proposedEdges) {
      const source = nodes.find((n) => n.id === edge.source);
      const target = nodes.find((n) => n.id === edge.target);
      if (!source || !target) continue;
      ctx.globalAlpha = 0.4;
      ctx.beginPath();
      ctx.moveTo(source.x, source.y);
      ctx.lineTo(target.x, target.y);
      ctx.strokeStyle = edge.color ? markColor(theme, edge.color, canvas, "guide") : mutedColor;
      ctx.lineWidth = strokes.thin;
      ctx.stroke();
    }
    ctx.setLineDash([]);
    ctx.globalAlpha = 1;
    for (const node of nodes) {
      const size2 = node.size || 8;
      const color = markColor(theme, node.color || getGroupColor(node.group, groups), canvas, "series-1");
      const isHovered = hoveredNode === node.id;
      const isSelected = selectedNodeId !== void 0 && node.id === selectedNodeId;
      const mark = node.mark;
      ctx.globalAlpha = hoveredNode && !neighbors.has(node.id) ? 0.2 : mark?.kind === "proposed" ? 0.55 : 1;
      const radius = isSelected ? size2 + 4 : isHovered ? size2 + 2 : size2;
      ctx.beginPath();
      ctx.arc(node.x, node.y, radius, 0, Math.PI * 2);
      ctx.fillStyle = mark?.kind === "proposed" ? mutedColor : color;
      ctx.fill();
      if (mark?.kind === "proposed") {
        ctx.setLineDash([...theme.dot]);
        ctx.strokeStyle = markColor(theme, mark.tint, canvas, "warning");
        ctx.lineWidth = strokes.normal;
      } else if (isSelected) {
        ctx.strokeStyle = accentColor;
        ctx.lineWidth = strokes.bold;
      } else {
        ctx.strokeStyle = isHovered ? bgColor : nodeRingColor;
        ctx.lineWidth = isHovered ? strokes.normal : strokes.thin;
      }
      ctx.stroke();
      ctx.setLineDash([]);
      if (mark?.kind === "suggested") {
        ctx.beginPath();
        ctx.arc(node.x, node.y, radius + 3, 0, Math.PI * 2);
        ctx.strokeStyle = accentColor;
        ctx.lineWidth = strokes.normal;
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(node.x + radius * 0.7, node.y - radius * 0.7, 2.5, 0, Math.PI * 2);
        ctx.fillStyle = accentColor;
        ctx.fill();
      } else if (mark?.kind === "proposed") {
        const phase = pulseTick % 60 / 60;
        const baseAlpha = hoveredNode && !neighbors.has(node.id) ? 0.2 : 0.55;
        ctx.globalAlpha = baseAlpha * (0.4 + 0.4 * (1 - Math.abs(phase * 2 - 1)));
        ctx.beginPath();
        ctx.arc(node.x, node.y, radius + 6 + Math.sin(phase * Math.PI * 2) * 3, 0, Math.PI * 2);
        ctx.strokeStyle = markColor(theme, mark.tint, canvas, "warning");
        ctx.lineWidth = strokes.normal;
        ctx.stroke();
        ctx.globalAlpha = baseAlpha;
      }
      if (showLabels && node.label) {
        const displayLabel = labelText(theme, truncateLabel(node.label));
        ctx.font = font("sm", isSelected || isHovered ? "700" : void 0);
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillStyle = fgColor;
        fillLabel(ctx, theme, displayLabel, node.x, node.y + radius + 14);
      }
      if (node.badge && node.badge > 1) {
        const bx = node.x + radius * 0.7;
        const by = node.y - radius * 0.7;
        const br = Math.max(7, Math.min(11, radius * 0.45));
        ctx.beginPath();
        ctx.arc(bx, by, br, 0, Math.PI * 2);
        ctx.fillStyle = accentColor;
        ctx.fill();
        ctx.strokeStyle = bgColor;
        ctx.lineWidth = strokes.normal;
        ctx.stroke();
        ctx.fillStyle = accentFg;
        ctx.font = font("xs", "600");
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(String(node.badge), bx, by + 0.5);
      }
    }
    ctx.restore();
  });
  const handleZoomIn = useCallback(() => setZoom((z) => Math.min(z * 1.2, 3)), []);
  const handleZoomOut = useCallback(() => setZoom((z) => Math.max(z / 1.2, 0.3)), []);
  const handleReset = useCallback(() => {
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  }, []);
  const applyZoom = useCallback((factor, cx, cy) => {
    if (!interactive) return;
    const oldZoom = zoomRef.current;
    const newZoom = Math.max(0.3, Math.min(3, oldZoom * factor));
    if (newZoom === oldZoom) return;
    const o = offsetRef.current;
    setOffset({
      x: cx - (cx - o.x) * (newZoom / oldZoom),
      y: cy - (cy - o.y) * (newZoom / oldZoom)
    });
    setZoom(newZoom);
  }, [interactive]);
  const applyPanDelta = useCallback((dx, dy) => {
    if (!interactive) return;
    setOffset((o) => ({ x: o.x + dx, y: o.y + dy }));
  }, [interactive]);
  const cancelSinglePointer = useCallback(() => {
    interactionRef.current.mode = "none";
    interactionRef.current.dragNodeId = null;
    interactionRef.current.pressedNodeId = null;
  }, []);
  const handlePointerDown = useCallback(
    (e) => {
      const coords = toCoords(e);
      if (!coords) return;
      const node = nodeAt(coords.graphX, coords.graphY);
      const state = interactionRef.current;
      state.downPos = { x: e.clientX, y: e.clientY };
      state.startMouse = { x: e.clientX, y: e.clientY };
      state.startOffset = { ...offset };
      state.pressedNodeId = node?.id ?? null;
      if (draggable && node) {
        state.mode = "dragging";
        state.dragNodeId = node.id;
      } else if (interactive) {
        state.mode = "panning";
        state.dragNodeId = null;
      } else {
        state.mode = "none";
        state.dragNodeId = null;
      }
    },
    [toCoords, nodeAt, draggable, interactive, offset]
  );
  const handlePointerMove = useCallback(
    (e) => {
      const state = interactionRef.current;
      if (state.mode === "panning") {
        const dx = e.clientX - state.startMouse.x;
        const dy = e.clientY - state.startMouse.y;
        setOffset({ x: state.startOffset.x + dx, y: state.startOffset.y + dy });
        return;
      }
      if (state.mode === "dragging" && state.dragNodeId) {
        const coords2 = toCoords(e);
        if (!coords2) return;
        const node2 = nodesRef.current.find((n) => n.id === state.dragNodeId);
        if (node2) {
          node2.x = coords2.graphX;
          node2.y = coords2.graphY;
          node2.vx = 0;
          node2.vy = 0;
          forceUpdate((n) => n + 1);
        }
        return;
      }
      const coords = toCoords(e);
      if (!coords) return;
      const node = nodeAt(coords.graphX, coords.graphY);
      setHoveredNode(node?.id ?? null);
    },
    [toCoords, nodeAt]
  );
  const handlePointerUp = useCallback(
    (e) => {
      const state = interactionRef.current;
      const moved = Math.abs(e.clientX - state.downPos.x) + Math.abs(e.clientY - state.downPos.y);
      state.mode = "none";
      state.dragNodeId = null;
      if (moved < 4) {
        const coords = toCoords(e);
        if (!coords) return;
        const node = (state.pressedNodeId ? nodesRef.current.find((n) => n.id === state.pressedNodeId) : void 0) ?? nodeAt(coords.graphX, coords.graphY);
        state.pressedNodeId = null;
        if (node) {
          if (node.badge && node.badge > 1 && onBadgeClick) {
            const r = (node.size || 8) + (selectedNodeId === node.id ? 4 : 0);
            const bx = node.x + r * 0.7;
            const by = node.y - r * 0.7;
            const br = Math.max(7, Math.min(11, r * 0.45)) + 3;
            if (Math.hypot(coords.graphX - bx, coords.graphY - by) <= br) {
              onBadgeClick(node);
              return;
            }
          }
          if (node.mark && onMarkClick) {
            onMarkClick(node);
            return;
          }
          handleNodeClick(node);
        }
      }
    },
    [toCoords, nodeAt, handleNodeClick, onBadgeClick, onMarkClick, selectedNodeId]
  );
  const handlePointerLeave = useCallback(() => {
    setHoveredNode(null);
    interactionRef.current.pressedNodeId = null;
  }, []);
  const gestureHandlers = useCanvasGestures({
    canvasRef,
    enabled: interactive || draggable,
    onPointerDown: handlePointerDown,
    onPointerMove: handlePointerMove,
    onPointerUp: handlePointerUp,
    onZoom: applyZoom,
    onPanDelta: applyPanDelta,
    onMultiTouchStart: cancelSinglePointer
  });
  const wheelHandler = gestureHandlers.onWheel;
  useEffect(() => {
    const el = canvasRef.current;
    if (!el) return;
    el.addEventListener("wheel", wheelHandler, { passive: false });
    return () => el.removeEventListener("wheel", wheelHandler);
  }, [wheelHandler]);
  const handleDoubleClick = useCallback(
    (e) => {
      const coords = toCoords(e);
      if (!coords) return;
      const node = nodeAt(coords.graphX, coords.graphY);
      if (node) onNodeDoubleClick?.(node);
    },
    [toCoords, nodeAt, onNodeDoubleClick]
  );
  const hoveredObj = hoveredNode ? nodesRef.current.find((n) => n.id === hoveredNode) : void 0;
  const canvasEl = canvasRef.current;
  const showLabelTooltip = Boolean(
    hoveredObj?.label && hoveredObj.label.length > MAX_LABEL_CHARS && hoveredObj.x != null && canvasEl
  );
  const labelTooltipStyle = (() => {
    if (!showLabelTooltip || !canvasEl || !hoveredObj || hoveredObj.x == null || hoveredObj.y == null) return void 0;
    const rect = canvasEl.getBoundingClientRect();
    return {
      left: rect.left + offset.x + hoveredObj.x * zoom,
      top: rect.top + offset.y + hoveredObj.y * zoom - 10,
      transform: "translate(-50%, -100%)"
    };
  })();
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.graphError"),
        message: error.message,
        className
      }
    );
  }
  if (propNodes.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("display.noGraphData"),
        description: t("graphCanvas.noNodes"),
        className
      }
    );
  }
  return /* @__PURE__ */ jsx(Card, { className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
    (title || actions && actions.length > 0 || interactive) && /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        align: "center",
        justify: "between",
        className: "px-4 py-2 border-b border-border",
        children: [
          title && /* @__PURE__ */ jsx(Typography, { variant: "h6", children: title }),
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            interactive && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomOut, onClick: handleZoomOut, "aria-label": t("avl.zoomOut") }),
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: ZoomIn, onClick: handleZoomIn, "aria-label": t("avl.zoomIn") }),
              /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: RotateCcw, onClick: handleReset, "aria-label": t("common.reset") })
            ] }),
            actions?.map((action, idx) => /* @__PURE__ */ jsx(
              Badge,
              {
                variant: "default",
                className: "cursor-pointer hover:opacity-80 transition-opacity",
                onClick: () => handleAction(action),
                children: action.label
              },
              idx
            ))
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(Box, { className: "w-full bg-background", children: [
      /* @__PURE__ */ jsx(
        "canvas",
        {
          ref: canvasRef,
          width: Math.round(logicalW * (typeof window !== "undefined" && window.devicePixelRatio || 1)),
          height: Math.round(height * (typeof window !== "undefined" && window.devicePixelRatio || 1)),
          className: "w-full cursor-grab active:cursor-grabbing touch-none",
          style: { height },
          onPointerDown: gestureHandlers.onPointerDown,
          onPointerMove: gestureHandlers.onPointerMove,
          onPointerUp: gestureHandlers.onPointerUp,
          onPointerCancel: gestureHandlers.onPointerCancel,
          onPointerLeave: handlePointerLeave,
          onDoubleClick: handleDoubleClick,
          role: "img",
          "aria-label": title ?? t("aria.graphCanvas"),
          "aria-describedby": description ? descId : void 0,
          ...domPassthrough(rest)
        }
      ),
      description && /* @__PURE__ */ jsx(Box, { id: descId, className: "sr-only", children: description }),
      typeof window !== "undefined" && showLabelTooltip && labelTooltipStyle && /* @__PURE__ */ jsx(ThemedPortal, { children: /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "fixed z-50 px-3 py-2 max-w-xs",
            "bg-primary text-primary-foreground",
            "shadow-elevation-popover rounded-container",
            "text-sm pointer-events-none",
            "break-words whitespace-normal"
          ),
          style: labelTooltipStyle,
          role: "tooltip",
          children: hoveredObj?.label
        }
      ) })
    ] }),
    groups.length > 1 && /* @__PURE__ */ jsx(HStack, { gap: "md", className: "px-4 py-2 border-t border-border", wrap: true, children: groups.map((group, idx) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          className: "w-3 h-3 rounded-full flex-shrink-0",
          style: { backgroundColor: GROUP_COLORS[idx % GROUP_COLORS.length] }
        }
      ),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: group })
    ] }, group)) })
  ] }) });
};
GraphCanvas.displayName = "GraphCanvas";

// lib/graphViewLayouts.ts
function buildAdjacency(nodeIds, edges) {
  const known = new Set(nodeIds);
  const out = /* @__PURE__ */ new Map();
  const inMap = /* @__PURE__ */ new Map();
  for (const id of nodeIds) {
    out.set(id, []);
    inMap.set(id, []);
  }
  for (const edge of edges) {
    if (!known.has(edge.source) || !known.has(edge.target)) continue;
    out.get(edge.source)?.push(edge.target);
    inMap.get(edge.target)?.push(edge.source);
  }
  return { out, in: inMap };
}
function findRoots(nodeIds, adjacency) {
  return nodeIds.filter((id) => (adjacency.in.get(id)?.length ?? 0) === 0);
}
function assignLayers(nodeIds, adjacency, roots) {
  const layer = new Map(nodeIds.map((id) => [id, 0]));
  const onStack = /* @__PURE__ */ new Set();
  const visit = (id) => {
    onStack.add(id);
    const currentLayer = layer.get(id) ?? 0;
    for (const next of adjacency.out.get(id) ?? []) {
      if (onStack.has(next)) continue;
      const candidate = currentLayer + 1;
      if (candidate > (layer.get(next) ?? 0)) {
        layer.set(next, candidate);
      }
      visit(next);
    }
    onStack.delete(id);
  };
  for (const root of roots) visit(root);
  return layer;
}
function computeVisitOrder(nodeIds, adjacency, roots) {
  const order = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  let counter = 0;
  const visit = (id) => {
    if (visited.has(id)) return;
    visited.add(id);
    order.set(id, counter++);
    for (const next of adjacency.out.get(id) ?? []) visit(next);
  };
  for (const root of roots) visit(root);
  for (const id of nodeIds) {
    if (!visited.has(id)) order.set(id, counter++);
  }
  return order;
}
function bfsDepthAndOrder(nodeIds, adjacency, roots) {
  const depth = new Map(nodeIds.map((id) => [id, 0]));
  const visitOrder = /* @__PURE__ */ new Map();
  const visited = /* @__PURE__ */ new Set();
  const queue = [];
  let counter = 0;
  for (const root of roots) {
    if (visited.has(root)) continue;
    visited.add(root);
    depth.set(root, 0);
    visitOrder.set(root, counter++);
    queue.push(root);
  }
  let head = 0;
  while (head < queue.length) {
    const id = queue[head++];
    const d = depth.get(id) ?? 0;
    for (const next of adjacency.out.get(id) ?? []) {
      if (visited.has(next)) continue;
      visited.add(next);
      depth.set(next, d + 1);
      visitOrder.set(next, counter++);
      queue.push(next);
    }
  }
  for (const id of nodeIds) {
    if (!visited.has(id)) visitOrder.set(id, counter++);
  }
  return { depth, visitOrder };
}
function edgeWalkOrder(nodeIds, adjacency) {
  const visited = /* @__PURE__ */ new Set();
  const result = [];
  for (const start of nodeIds) {
    if (visited.has(start)) continue;
    let current = start;
    while (current !== void 0 && !visited.has(current)) {
      visited.add(current);
      result.push(current);
      const outs = adjacency.out.get(current) ?? [];
      current = outs.find((next) => !visited.has(next));
    }
  }
  return result;
}
function groupByTier(nodeIds, tierOf, maxTier) {
  const groups = Array.from({ length: maxTier + 1 }, () => []);
  for (const id of nodeIds) {
    groups[tierOf.get(id) ?? 0].push(id);
  }
  return groups;
}
function distributeAxis(count, start, end) {
  if (count <= 0) return [];
  const slot = (end - start) / count;
  return Array.from({ length: count }, (_, i) => start + slot * (i + 0.5));
}
function orderByParentPositionThenInput(group, adjacency, positioned, inputIndex) {
  const withKey = group.map((id) => {
    const parentValues = (adjacency.in.get(id) ?? []).map((p) => positioned.get(p)).filter((v) => v !== void 0);
    const avg = parentValues.length > 0 ? parentValues.reduce((a, b) => a + b, 0) / parentValues.length : Number.POSITIVE_INFINITY;
    return { id, avg, idx: inputIndex.get(id) ?? 0 };
  });
  withKey.sort((a, b) => a.avg !== b.avg ? a.avg - b.avg : a.idx - b.idx);
  return withKey.map((k) => k.id);
}
function layoutFlow(nodeIds, adjacency, roots, width, height, margin) {
  const inputIndex = new Map(nodeIds.map((id, i) => [id, i]));
  const layers = assignLayers(nodeIds, adjacency, roots);
  const maxLayer = Math.max(...Array.from(layers.values()));
  const layerGroups = groupByTier(nodeIds, layers, maxLayer);
  const positions = /* @__PURE__ */ new Map();
  const yById = /* @__PURE__ */ new Map();
  for (let l = 0; l <= maxLayer; l++) {
    const x = margin + l * (width - 2 * margin) / Math.max(1, maxLayer);
    const ordered2 = orderByParentPositionThenInput(layerGroups[l], adjacency, yById, inputIndex);
    const ys = distributeAxis(ordered2.length, margin, height - margin);
    ordered2.forEach((id, i) => {
      positions.set(id, { id, x, y: ys[i] });
      yById.set(id, ys[i]);
    });
  }
  return nodeIds.map((id) => positions.get(id));
}
function layoutTree2(nodeIds, adjacency, roots, width, height, margin) {
  const effectiveRoots = roots.length > 0 ? roots : [nodeIds[0]];
  const layers = assignLayers(nodeIds, adjacency, effectiveRoots);
  const maxLayer = Math.max(...Array.from(layers.values()));
  const visitOrder = computeVisitOrder(nodeIds, adjacency, effectiveRoots);
  const layerGroups = groupByTier(nodeIds, layers, maxLayer);
  const positions = /* @__PURE__ */ new Map();
  for (let l = 0; l <= maxLayer; l++) {
    const ordered2 = [...layerGroups[l]].sort(
      (a, b) => (visitOrder.get(a) ?? 0) - (visitOrder.get(b) ?? 0)
    );
    const y = margin + l * (height - 2 * margin) / Math.max(1, maxLayer);
    const xs = distributeAxis(ordered2.length, margin, width - margin);
    ordered2.forEach((id, i) => positions.set(id, { id, x: xs[i], y }));
  }
  return nodeIds.map((id) => positions.get(id));
}
function layoutRadial(nodeIds, adjacency, roots, width, height, margin) {
  const cx = width / 2;
  const cy = height / 2;
  const maxRadius = Math.min(width, height) / 2 - margin;
  if (roots.length === 0) {
    const order = edgeWalkOrder(nodeIds, adjacency);
    const k = order.length;
    const positions2 = /* @__PURE__ */ new Map();
    order.forEach((id, i) => {
      const angle = i / k * 2 * Math.PI;
      positions2.set(id, { id, x: cx + maxRadius * Math.cos(angle), y: cy + maxRadius * Math.sin(angle) });
    });
    return nodeIds.map((id) => positions2.get(id));
  }
  const { depth, visitOrder } = bfsDepthAndOrder(nodeIds, adjacency, roots);
  const maxDepth = Math.max(...Array.from(depth.values()));
  const ringGroups = groupByTier(nodeIds, depth, maxDepth);
  const positions = /* @__PURE__ */ new Map();
  for (let d = 0; d <= maxDepth; d++) {
    const ordered2 = [...ringGroups[d]].sort(
      (a, b) => (visitOrder.get(a) ?? 0) - (visitOrder.get(b) ?? 0)
    );
    const radius = d * maxRadius / Math.max(1, maxDepth);
    const k = ordered2.length;
    ordered2.forEach((id, i) => {
      const angle = i / k * 2 * Math.PI;
      positions.set(id, { id, x: cx + radius * Math.cos(angle), y: cy + radius * Math.sin(angle) });
    });
  }
  return nodeIds.map((id) => positions.get(id));
}
function computeStaticLayout(mode, input) {
  const { nodeIds, edges, width, height } = input;
  const margin = input.margin ?? 40;
  if (nodeIds.length === 0) return [];
  if (nodeIds.length === 1) return [{ id: nodeIds[0], x: width / 2, y: height / 2 }];
  const adjacency = buildAdjacency(nodeIds, edges);
  const roots = findRoots(nodeIds, adjacency);
  if (mode === "flow") return layoutFlow(nodeIds, adjacency, roots, width, height, margin);
  if (mode === "tree") return layoutTree2(nodeIds, adjacency, roots, width, height, margin);
  return layoutRadial(nodeIds, adjacency, roots, width, height, margin);
}
var GROUP_COLORS2 = THEME_SERIES;
var DEFAULT_NODE_COLOR = "var(--color-muted-foreground)";
var DEFAULT_EDGE_COLOR = "var(--color-border)";
var DEFAULT_NODE_SIZE = 8;
function resolveNodeColor(node, groups) {
  if (node.color) return node.color;
  if (node.group) {
    const idx = groups.indexOf(node.group);
    return GROUP_COLORS2[idx % GROUP_COLORS2.length];
  }
  return DEFAULT_NODE_COLOR;
}
var GraphView = ({
  nodes,
  edges,
  onNodeClick,
  onNodeHover,
  width: propWidth,
  height: propHeight,
  className,
  showLabels = true,
  zoomToFit = true,
  layout = "force",
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const { t } = useTranslate();
  const containerRef = useRef(null);
  const animRef = useRef(0);
  const arrowMarkerId = useId();
  const [simNodes, setSimNodes] = useState([]);
  const [settled, setSettled] = useState(false);
  const [hoveredId, setHoveredId] = useState(null);
  const [dimensions, setDimensions] = useState({ width: propWidth ?? 600, height: propHeight ?? 400 });
  const w = propWidth ?? dimensions.width;
  const h = propHeight ?? dimensions.height;
  const groups = useMemo(
    () => [...new Set(nodes.map((n) => n.group).filter((g) => Boolean(g)))],
    [nodes]
  );
  const connectedIds = useMemo(() => {
    if (!hoveredId) return /* @__PURE__ */ new Set();
    const connected = /* @__PURE__ */ new Set([hoveredId]);
    for (const edge of edges) {
      if (edge.source === hoveredId) connected.add(edge.target);
      if (edge.target === hoveredId) connected.add(edge.source);
    }
    return connected;
  }, [hoveredId, edges]);
  useEffect(() => {
    if (propWidth && propHeight) return;
    const el = containerRef.current;
    if (!el) return;
    const update = () => {
      setDimensions({
        width: el.clientWidth || 600,
        height: el.clientHeight || 400
      });
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [propWidth, propHeight]);
  useEffect(() => {
    if (nodes.length === 0) {
      setSimNodes([]);
      setSettled(true);
      return;
    }
    const initialNodes = nodes.map((n, idx) => {
      const angle = idx / nodes.length * 2 * Math.PI;
      const radius = Math.min(w, h) * 0.3;
      return {
        id: n.id,
        label: n.label,
        color: resolveNodeColor(n, groups),
        size: n.size ?? DEFAULT_NODE_SIZE,
        group: n.group,
        x: w / 2 + radius * Math.cos(angle) + (Math.random() - 0.5) * 20,
        y: h / 2 + radius * Math.sin(angle) + (Math.random() - 0.5) * 20,
        vx: 0,
        vy: 0,
        fx: 0,
        fy: 0
      };
    });
    if (layout !== "force") {
      const points = computeStaticLayout(layout, {
        nodeIds: nodes.map((n) => n.id),
        edges,
        width: w,
        height: h
      });
      const pointById = new Map(points.map((p) => [p.id, p]));
      const laidOut = initialNodes.map((node) => {
        const point = pointById.get(node.id);
        return point ? { ...node, x: point.x, y: point.y } : node;
      });
      setSimNodes(laidOut);
      setSettled(true);
      return;
    }
    let iterations = 0;
    const maxIterations = 120;
    let currentNodes = initialNodes;
    const tick = () => {
      const centerX = w / 2;
      const centerY = h / 2;
      for (const node of currentNodes) {
        node.fx = 0;
        node.fy = 0;
      }
      for (let i = 0; i < currentNodes.length; i++) {
        for (let j = i + 1; j < currentNodes.length; j++) {
          const a = currentNodes[i];
          const b = currentNodes[j];
          const dx = b.x - a.x;
          const dy = b.y - a.y;
          const dist = Math.sqrt(dx * dx + dy * dy) || 1;
          const force = 800 / (dist * dist);
          const fx = dx / dist * force;
          const fy = dy / dist * force;
          a.fx -= fx;
          a.fy -= fy;
          b.fx += fx;
          b.fy += fy;
        }
      }
      for (const edge of edges) {
        const source = currentNodes.find((n) => n.id === edge.source);
        const target = currentNodes.find((n) => n.id === edge.target);
        if (!source || !target) continue;
        const dx = target.x - source.x;
        const dy = target.y - source.y;
        const dist = Math.sqrt(dx * dx + dy * dy) || 1;
        const force = (dist - 100) * 0.05;
        const fx = dx / dist * force;
        const fy = dy / dist * force;
        source.fx += fx;
        source.fy += fy;
        target.fx -= fx;
        target.fy -= fy;
      }
      for (const node of currentNodes) {
        node.fx += (centerX - node.x) * 0.01;
        node.fy += (centerY - node.y) * 0.01;
      }
      const damping = 0.85;
      const margin = 40;
      for (const node of currentNodes) {
        node.vx = (node.vx + node.fx) * damping;
        node.vy = (node.vy + node.fy) * damping;
        node.x += node.vx;
        node.y += node.vy;
        node.x = Math.max(margin, Math.min(w - margin, node.x));
        node.y = Math.max(margin, Math.min(h - margin, node.y));
      }
      iterations++;
      setSimNodes([...currentNodes]);
      if (iterations < maxIterations) {
        animRef.current = requestAnimationFrame(tick);
      } else {
        setSettled(true);
      }
    };
    setSettled(false);
    animRef.current = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(animRef.current);
    };
  }, [nodes, edges, w, h, groups, layout]);
  const viewBox = useMemo(() => {
    if (!zoomToFit || !settled || simNodes.length === 0) {
      return `0 0 ${w} ${h}`;
    }
    const pad = 60;
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for (const node of simNodes) {
      minX = Math.min(minX, node.x - node.size);
      minY = Math.min(minY, node.y - node.size);
      maxX = Math.max(maxX, node.x + node.size);
      maxY = Math.max(maxY, node.y + node.size);
    }
    const fitW = maxX - minX + pad * 2;
    const fitH = maxY - minY + pad * 2;
    return `${minX - pad} ${minY - pad} ${fitW} ${fitH}`;
  }, [zoomToFit, settled, simNodes, w, h]);
  const nodeMap = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    for (const n of simNodes) {
      map.set(n.id, n);
    }
    return map;
  }, [simNodes]);
  const handleNodeMouseEnter = useCallback(
    (node) => {
      setHoveredId(node.id);
      if (onNodeHover) {
        onNodeHover({ id: node.id, label: node.label, color: node.color, size: node.size, group: node.group });
      }
    },
    [onNodeHover]
  );
  const handleNodeMouseLeave = useCallback(() => {
    setHoveredId(null);
    if (onNodeHover) {
      onNodeHover(null);
    }
  }, [onNodeHover]);
  const handleNodeClickInternal = useCallback(
    (node) => {
      if (onNodeClick) {
        onNodeClick({ id: node.id, label: node.label, color: node.color, size: node.size, group: node.group });
      }
    },
    [onNodeClick]
  );
  const handleNodePointerDown = useCallback(
    (e, node) => {
      if (e.pointerType === "mouse") return;
      handleNodeMouseEnter(node);
      handleNodeClickInternal(node);
    },
    [handleNodeMouseEnter, handleNodeClickInternal]
  );
  if (nodes.length === 0) {
    return /* @__PURE__ */ jsx(Box, { className: cn("flex items-center justify-center", className), style: { width: w, height: h }, children: /* @__PURE__ */ jsx(Box, { className: "text-muted-foreground text-sm", children: t("display.noGraphData") }) });
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsx(
      Box,
      {
        ref: containerRef,
        role: onNodeClick ? "group" : rest["aria-label"] ? "img" : void 0,
        ...domPassthrough(rest),
        className: cn("relative overflow-hidden", contentSurface.className, className),
        style: { width: propWidth ?? "100%", height: h },
        children: /* @__PURE__ */ jsxs(
          "svg",
          {
            width: "100%",
            height: "100%",
            viewBox,
            preserveAspectRatio: "xMidYMid meet",
            children: [
              layout !== "force" && /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx(
                "marker",
                {
                  id: arrowMarkerId,
                  viewBox: "0 0 10 10",
                  refX: "9",
                  refY: "5",
                  markerWidth: "6",
                  markerHeight: "6",
                  orient: "auto-start-reverse",
                  children: /* @__PURE__ */ jsx("path", { d: "M0,0 L10,5 L0,10 z", fill: "currentColor" })
                }
              ) }),
              edges.map((edge, idx) => {
                const source = nodeMap.get(edge.source);
                const target = nodeMap.get(edge.target);
                if (!source || !target) return null;
                const isHighlighted = hoveredId ? connectedIds.has(edge.source) && connectedIds.has(edge.target) : true;
                return /* @__PURE__ */ jsxs("g", { children: [
                  /* @__PURE__ */ jsx(
                    "line",
                    {
                      x1: source.x,
                      y1: source.y,
                      x2: target.x,
                      y2: target.y,
                      stroke: edge.color ?? DEFAULT_EDGE_COLOR,
                      color: edge.color ?? DEFAULT_EDGE_COLOR,
                      strokeWidth: 1.5,
                      opacity: isHighlighted ? 0.8 : 0.15,
                      markerEnd: layout !== "force" ? `url(#${arrowMarkerId})` : void 0
                    }
                  ),
                  showLabels && edge.label && /* @__PURE__ */ jsx(
                    "text",
                    {
                      x: (source.x + target.x) / 2,
                      y: (source.y + target.y) / 2 - 6,
                      textAnchor: "middle",
                      fill: "var(--color-muted-foreground)",
                      fontSize: 9,
                      opacity: isHighlighted ? 0.9 : 0.2,
                      children: edge.label
                    }
                  )
                ] }, `edge-${idx}`);
              }),
              simNodes.map((node) => {
                const isHighlighted = hoveredId ? connectedIds.has(node.id) : true;
                const isHovered = hoveredId === node.id;
                return /* @__PURE__ */ jsxs(
                  "g",
                  {
                    style: { cursor: onNodeClick ? "pointer" : "default" },
                    onMouseEnter: () => handleNodeMouseEnter(node),
                    onMouseLeave: handleNodeMouseLeave,
                    ...pressableProps(onNodeClick ? () => handleNodeClickInternal(node) : void 0),
                    ...onNodeClick ? {
                      "aria-label": node.group ? `${node.label ?? node.id}, ${node.group}` : node.label ?? node.id,
                      onFocus: () => handleNodeMouseEnter(node),
                      onBlur: handleNodeMouseLeave
                    } : void 0,
                    onPointerDown: (e) => handleNodePointerDown(e, node),
                    children: [
                      /* @__PURE__ */ jsx(
                        "circle",
                        {
                          cx: node.x,
                          cy: node.y,
                          r: isHovered ? node.size * 1.4 : node.size,
                          fill: node.color,
                          opacity: isHighlighted ? 1 : 0.3,
                          stroke: isHovered ? "var(--color-background)" : "none",
                          strokeWidth: isHovered ? 2 : 0
                        }
                      ),
                      showLabels && /* @__PURE__ */ jsx(
                        "text",
                        {
                          x: node.x,
                          y: node.y + node.size + 12,
                          textAnchor: "middle",
                          fill: "var(--color-foreground)",
                          fontSize: 11,
                          fontWeight: isHovered ? "bold" : "normal",
                          opacity: isHighlighted ? 0.9 : 0.2,
                          children: node.label ?? node.id
                        }
                      )
                    ]
                  },
                  node.id
                );
              })
            ]
          }
        )
      }
    )
  );
};
GraphView.displayName = "GraphView";
var colStyles2 = {
  none: "grid-cols-none",
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  7: "grid-cols-7",
  8: "grid-cols-8",
  9: "grid-cols-9",
  10: "grid-cols-10",
  11: "grid-cols-11",
  12: "grid-cols-12"
};
var gapStyles6 = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8",
  "2xl": "gap-12"
};
var rowGapStyles = {
  none: "gap-y-0",
  xs: "gap-y-1",
  sm: "gap-y-2",
  md: "gap-y-4",
  lg: "gap-y-6",
  xl: "gap-y-8",
  "2xl": "gap-y-12"
};
var colGapStyles = {
  none: "gap-x-0",
  xs: "gap-x-1",
  sm: "gap-x-2",
  md: "gap-x-4",
  lg: "gap-x-6",
  xl: "gap-x-8",
  "2xl": "gap-x-12"
};
var alignStyles2 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
};
var justifyStyles2 = {
  start: "justify-items-start",
  center: "justify-items-center",
  end: "justify-items-end",
  stretch: "justify-items-stretch"
};
var flowStyles = {
  row: "grid-flow-row",
  col: "grid-flow-col",
  "row-dense": "grid-flow-row-dense",
  "col-dense": "grid-flow-col-dense"
};
function getColsClass(cols) {
  if (typeof cols === "number" || cols === "none") {
    return colStyles2[cols];
  }
  const classes = [];
  if (cols.base !== void 0) {
    classes.push(colStyles2[cols.base]);
  }
  if (cols.sm !== void 0) {
    classes.push(`sm:${colStyles2[cols.sm]}`);
  }
  if (cols.md !== void 0) {
    classes.push(`md:${colStyles2[cols.md]}`);
  }
  if (cols.lg !== void 0) {
    classes.push(`lg:${colStyles2[cols.lg]}`);
  }
  if (cols.xl !== void 0) {
    classes.push(`xl:${colStyles2[cols.xl]}`);
  }
  return classes.join(" ");
}
var Grid = ({
  cols = 1,
  rows: rows2,
  gap = "md",
  rowGap,
  colGap,
  alignItems,
  justifyItems,
  flow,
  className,
  style,
  children,
  as: Component = "div",
  ...rest
}) => {
  const mergedStyle = rows2 ? { gridTemplateRows: `repeat(${rows2}, minmax(0, 1fr))`, ...style } : style;
  return React93__default.createElement(
    Component,
    {
      ...domPassthrough(rest),
      className: cn(
        "grid",
        getColsClass(cols),
        rowGap ? rowGapStyles[rowGap] : colGap ? void 0 : gapStyles6[gap],
        colGap ? colGapStyles[colGap] : rowGap ? void 0 : void 0,
        rowGap && colGap ? `${rowGapStyles[rowGap]} ${colGapStyles[colGap]}` : void 0,
        alignItems && alignStyles2[alignItems],
        justifyItems && justifyStyles2[justifyItems],
        flow && flowStyles[flow],
        className
      ),
      style: mergedStyle
    },
    children
  );
};
Grid.displayName = "Grid";
var SearchInput = ({
  value,
  onSearch,
  debounceMs = 300,
  isLoading = false,
  placeholder,
  clearable = true,
  className,
  event,
  entity,
  query,
  ...props
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const resolvedPlaceholder = placeholder ?? t("common.search");
  const queryState = useQuerySingleton(query);
  const initialValue = queryState?.search ?? value ?? "";
  const [searchValue, setSearchValue] = useState(initialValue);
  const [debounceTimer, setDebounceTimer] = useState(null);
  useEffect(() => {
    if (queryState && queryState.search !== searchValue) {
      setSearchValue(queryState.search);
    }
  }, [queryState?.search]);
  const handleChange = useCallback((e) => {
    const newValue = e.target.value;
    setSearchValue(newValue);
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
    const timer = setTimeout(() => {
      if (queryState) {
        queryState.setSearch(newValue);
      }
      onSearch?.(newValue);
      if (event && event !== "SEARCH") {
        eventBus.emit(`UI:${event}`, { searchTerm: newValue, entity });
      }
      if (event || entity || query) {
        eventBus.emit("UI:SEARCH", { searchTerm: newValue, entity, query });
      }
    }, debounceMs);
    setDebounceTimer(timer);
  }, [onSearch, debounceMs, debounceTimer, event, entity, query, eventBus, queryState]);
  const handleClear = useCallback(() => {
    setSearchValue("");
    if (queryState) {
      queryState.setSearch("");
    }
    onSearch?.("");
    if (event || query) {
      eventBus.emit("UI:CLEAR_SEARCH", { searchTerm: "", entity, query });
    }
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
  }, [onSearch, debounceTimer, event, query, entity, eventBus, queryState]);
  useEffect(() => {
    if (value !== void 0 && value !== searchValue && !query) {
      setSearchValue(value);
    }
  }, [value, query]);
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);
  return /* @__PURE__ */ jsxs(Box, { className: cn("relative", className), children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        type: "search",
        value: searchValue,
        onChange: handleChange,
        placeholder: resolvedPlaceholder,
        icon: Search,
        clearable: clearable && !isLoading,
        onClear: handleClear,
        "aria-busy": isLoading || void 0,
        className: "pr-10",
        ...props
      }
    ),
    isLoading && /* @__PURE__ */ jsx(Box, { className: "absolute right-3 top-1/2 -translate-y-1/2", children: /* @__PURE__ */ jsx(Spinner, { size: "sm", color: "primary" }) })
  ] });
};
SearchInput.displayName = "SearchInput";
var lookStyles8 = {
  "compact-bar": "",
  hero: "py-section min-h-[200px] [&_h1]:text-display-1",
  breadcrumb: "py-2 text-sm [&_h1]:text-base [&_h1]:font-medium",
  contextual: "py-3 [&_h1]:text-lg",
  "editorial-banner": "py-12 [&_h1]:text-display-2 [&_h1]:font-display-bold border-b border-border"
};
var Header = ({
  logo,
  logoSrc,
  brandName = "KFlow",
  navigationItems,
  showMenuToggle = true,
  isMenuOpen = false,
  onMenuToggle,
  showSearch = false,
  searchPlaceholder,
  onSearch,
  userAvatar,
  userName,
  onUserClick,
  actions,
  sticky = true,
  variant = "mobile",
  look = "compact-bar",
  onLogoClick,
  brandHref,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const resolvedSearchPlaceholder = searchPlaceholder ?? t("common.search");
  const brandContent = /* @__PURE__ */ jsxs(Fragment, { children: [
    logo ? typeof logo === "string" ? /* @__PURE__ */ jsx(Image2, { src: logo, alt: brandName ?? "", fit: "contain", rounded: "none", loading: "eager", className: "h-8 w-auto max-w-32" }) : logo : logoSrc ? /* @__PURE__ */ jsx(Image2, { src: logoSrc, alt: brandName ?? "", fit: "contain", rounded: "none", loading: "eager", className: "h-8 w-auto max-w-32" }) : null,
    brandName && /* @__PURE__ */ jsx(
      Typography,
      {
        variant: "h5",
        className: "text-lg text-foreground",
        children: brandName
      }
    )
  ] });
  const userInitials = userAvatar?.initials || userName?.[0]?.toUpperCase() || "U";
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      as: "header",
      className: cn(
        "h-16 border-b border-border",
        "flex items-center px-4 justify-between bg-card",
        sticky && "sticky top-0 z-50",
        variant === "mobile" && "lg:hidden",
        lookStyles8[look],
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "center", className: "gap-3", children: [
          showMenuToggle && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: onMenuToggle,
              className: "p-2 -ml-2 text-foreground hover:bg-muted transition-colors",
              "aria-label": isMenuOpen ? t("aria.closeMenu") : t("aria.openMenu"),
              children: isMenuOpen ? /* @__PURE__ */ jsx(X, { size: 24 }) : /* @__PURE__ */ jsx(Menu$1, { size: 24 })
            }
          ),
          brandHref ? /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              href: brandHref,
              "aria-label": brandName,
              className: "gap-2 px-0 hover:bg-transparent",
              children: brandContent
            }
          ) : /* @__PURE__ */ jsx(
            HStack,
            {
              gap: "none",
              align: "center",
              className: cn(
                "gap-2",
                onLogoClick && "cursor-pointer"
              ),
              ...pressableProps(onLogoClick),
              "aria-label": onLogoClick ? brandName : void 0,
              children: brandContent
            }
          )
        ] }),
        variant === "desktop" && navigationItems && navigationItems.length > 0 && /* @__PURE__ */ jsx(
          Box,
          {
            role: "navigation",
            className: "hidden md:flex items-center gap-1 flex-1 justify-center",
            children: navigationItems.map((item, index) => /* @__PURE__ */ jsx(TopNavItem, { item, tone: "soft" }, item.href ?? `${item.label}-${index}`))
          }
        ),
        showSearch && /* @__PURE__ */ jsx(Box, { className: "hidden lg:block flex-1 max-w-md mx-4", children: /* @__PURE__ */ jsx(SearchInput, { placeholder: resolvedSearchPlaceholder, onSearch }) }),
        /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "center", className: "gap-3", children: [
          actions,
          (userAvatar || userName) && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: onUserClick,
              className: cn(
                "w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center",
                "text-primary font-bold text-xs",
                "hover:ring-2 hover:ring-ring transition-all",
                onUserClick && "cursor-pointer"
              ),
              children: userAvatar?.src ? /* @__PURE__ */ jsx(
                Avatar,
                {
                  src: userAvatar.src,
                  alt: userAvatar.alt || userName,
                  size: "sm"
                }
              ) : userInitials
            }
          )
        ] })
      ]
    }
  );
};
Header.displayName = "Header";
function formatFieldValue(value) {
  if (value === null) return "\u2014";
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(formatFieldValue).join(", ");
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
function unitTitle(unit) {
  return unit.title || unit.ref;
}
function fieldSummary(unit) {
  return Object.entries(unit.fields).map(([key, value]) => `${key}: ${formatFieldValue(value)}`).join(" \xB7 ");
}
var ImportPreviewTree = ({
  units,
  skipped = [],
  entityDisplay,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  indent = 16,
  className,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const tileClass = cn(contentSurface.className ?? "rounded-container border border-border", "p-3");
  const { t } = useTranslate();
  const groups = /* @__PURE__ */ new Map();
  for (const unit of units) {
    const group = groups.get(unit.targetEntity);
    if (group) group.push(unit);
    else groups.set(unit.targetEntity, [unit]);
  }
  const renderUnit = (unit, childrenByParent, depth) => {
    const summary = fieldSummary(unit);
    const children = childrenByParent.get(unit.ref) ?? [];
    return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
      /* @__PURE__ */ jsxs(
        Box,
        {
          className: "flex flex-col py-1",
          style: { paddingLeft: depth * indent },
          "data-testid": `import-preview-unit-${unit.ref}`,
          children: [
            /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ jsx(Icon, { icon: "file-text", size: "xs", className: "text-muted-foreground" }),
              /* @__PURE__ */ jsx(Typography, { variant: "body2", children: unitTitle(unit) })
            ] }),
            summary ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: summary }) : null
          ]
        }
      ),
      children.map((child) => renderUnit(child, childrenByParent, depth + 1))
    ] }, unit.ref);
  };
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex flex-col gap-4", className), children: [
      units.length === 0 ? /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-muted-foreground", children: t("import.noUnitsStaged") }) : null,
      Array.from(groups.entries()).map(([entity, groupUnits]) => {
        const refs = new Set(groupUnits.map((unit) => unit.ref));
        const childrenByParent = /* @__PURE__ */ new Map();
        const roots = [];
        for (const unit of groupUnits) {
          if (unit.parentRef && refs.has(unit.parentRef)) {
            const siblings = childrenByParent.get(unit.parentRef);
            if (siblings) siblings.push(unit);
            else childrenByParent.set(unit.parentRef, [unit]);
          } else {
            roots.push(unit);
          }
        }
        const label = entityDisplay[entity]?.plural ?? entity;
        return /* @__PURE__ */ jsxs(Box, { className: tileClass, children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 pb-2", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "label", children: label }),
            /* @__PURE__ */ jsx(Badge, { amount: groupUnits.length })
          ] }),
          roots.map((unit) => renderUnit(unit, childrenByParent, 0))
        ] }, entity);
      }),
      skipped.length > 0 ? /* @__PURE__ */ jsxs(Box, { className: tileClass, children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 pb-2", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "label", children: t("import.skipped") }),
          /* @__PURE__ */ jsx(Badge, { amount: skipped.length })
        ] }),
        skipped.map((element) => /* @__PURE__ */ jsxs(Box, { className: "flex items-baseline gap-2 py-1", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body2", children: element.ref }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: element.reason })
        ] }, element.ref))
      ] }) : null,
      onConfirm || onCancel ? /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-end gap-2", children: [
        onCancel ? /* @__PURE__ */ jsx(Button, { variant: "default", label: cancelLabel ?? t("common.cancel"), onClick: onCancel }) : null,
        onConfirm ? /* @__PURE__ */ jsx(Button, { variant: "primary", label: confirmLabel ?? t("import.confirmImport"), onClick: onConfirm }) : null
      ] }) : null
    ] })
  );
};
var PIPELINE = [
  "fetching",
  "mapping",
  "reviewing",
  "committing"
];
var DEFAULT_LABEL_KEYS = {
  fetching: "import.phase.fetching",
  mapping: "import.phase.mapping",
  reviewing: "import.phase.reviewing",
  committing: "import.phase.committing",
  done: "import.phase.done",
  failed: "import.phase.failed"
};
var ImportProgress = ({
  step,
  counts,
  labels,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const label = (key) => labels?.[key] ?? t(DEFAULT_LABEL_KEYS[key]);
  const currentIndex = step === "done" || step === "failed" ? PIPELINE.length : PIPELINE.indexOf(step);
  return /* @__PURE__ */ jsxs(Box, { className: cn("flex flex-col gap-3", className), ...domPassthrough(rest), children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
      PIPELINE.map((key, index) => {
        const isComplete = index < currentIndex;
        const isActive = index === currentIndex;
        return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
          index > 0 ? /* @__PURE__ */ jsx(Box, { className: "h-px w-4 bg-border" }) : null,
          /* @__PURE__ */ jsxs(
            Box,
            {
              className: "flex items-center gap-1",
              "data-testid": `import-progress-step-${key}`,
              "aria-current": isActive ? "step" : void 0,
              children: [
                /* @__PURE__ */ jsx(
                  Icon,
                  {
                    icon: isComplete ? "check" : isActive ? "loader" : "circle",
                    size: "sm",
                    className: cn(
                      isComplete ? "text-success" : isActive ? "text-primary" : "text-muted-foreground"
                    )
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    className: cn(isActive ? "text-foreground" : "text-muted-foreground"),
                    children: label(key)
                  }
                )
              ]
            }
          )
        ] }, key);
      }),
      step === "done" || step === "failed" ? /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Box, { className: "h-px w-4 bg-border" }),
        /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1", "data-testid": `import-progress-step-${step}`, children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              icon: step === "done" ? "check" : "x",
              size: "sm",
              className: step === "done" ? "text-success" : "text-error"
            }
          ),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: step === "done" ? "text-success" : "text-error",
              children: label(step)
            }
          )
        ] })
      ] }) : null
    ] }),
    counts ? /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2", children: [
      counts.staged !== void 0 ? /* @__PURE__ */ jsx(Badge, { label: t("import.staged", { count: counts.staged }) }) : null,
      counts.committed !== void 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", label: t("import.committed", { count: counts.committed }) }) : null,
      counts.failed !== void 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", label: t("import.failedCount", { count: counts.failed }) }) : null
    ] }) : null
  ] });
};
var log11 = createLogger("almadar:ui:import-source-picker");
function readText(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === "string" ? reader.result : "");
    reader.onerror = () => reject(reader.error ?? new Error(`could not read ${file.name}`));
    reader.readAsText(file);
  });
}
var ImportSourcePicker = ({
  sources,
  onSelect,
  onFilesSelected,
  title,
  moreSources,
  className,
  ...rest
}) => {
  const fileInputRef = useRef(null);
  const handlePick = (source) => {
    if (source.disabled) return;
    if (source.kind === "file") {
      const input = fileInputRef.current;
      if (!input) return;
      input.accept = source.accept ?? "";
      input.multiple = source.multiple ?? false;
      input.click();
      return;
    }
    onSelect?.(source.id);
  };
  const handleFiles = (event) => {
    const files = event.target.files ? Array.from(event.target.files) : [];
    event.target.value = "";
    if (files.length === 0 || !onFilesSelected) return;
    void Promise.all(
      files.map(async (file) => ({
        name: file.name,
        size: file.size,
        type: file.type,
        text: await readText(file)
      }))
    ).then(onFilesSelected, (error) => log11.error("file-read-failed", { message: error.message }));
  };
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex flex-col gap-2", className), children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    sources.map((source) => /* @__PURE__ */ jsxs(
      Box,
      {
        role: "button",
        tabIndex: source.disabled ? -1 : 0,
        "aria-disabled": source.disabled,
        onClick: () => handlePick(source),
        onKeyDown: (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handlePick(source);
          }
        },
        className: cn(
          "flex items-center gap-3 rounded-interactive border border-border bg-card px-4 py-3 text-left",
          source.disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-accent hover:text-accent-foreground"
        ),
        children: [
          source.icon ? /* @__PURE__ */ jsx(Icon, { icon: source.icon, size: "md" }) : null,
          /* @__PURE__ */ jsxs(Box, { className: "flex flex-col", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "label", children: source.label }),
            source.description ? /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: source.description }) : null
          ] })
        ]
      },
      source.id
    )),
    moreSources,
    /* @__PURE__ */ jsx(
      "input",
      {
        ref: fileInputRef,
        type: "file",
        className: "hidden",
        onChange: handleFiles,
        "data-testid": "import-source-file-input"
      }
    )
  ] });
};
var InputGroup = ({
  leftAddon,
  rightAddon,
  className: groupClassName,
  ...inputProps
}) => {
  const { className: inputClassName, ...restInputProps } = inputProps;
  const renderAddon = (addon, position) => {
    if (!addon) return null;
    if (typeof addon === "function" || typeof addon === "object" && addon !== null && "render" in addon) {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "flex items-center justify-center px-3",
            "bg-muted",
            "border border-border",
            position === "left" ? "rounded-l-interactive border-r-0" : "rounded-r-interactive border-l-0"
          ),
          children: /* @__PURE__ */ jsx(Icon, { icon: addon, size: "sm" })
        }
      );
    }
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: cn(
          "flex items-center justify-center px-3",
          "bg-muted",
          "border border-border",
          "text-foreground",
          position === "left" ? "rounded-l-interactive border-r-0" : "rounded-r-interactive border-l-0"
        ),
        children: typeof addon === "string" ? /* @__PURE__ */ jsx(Typography, { variant: "small", children: addon }) : addon
      }
    );
  };
  return /* @__PURE__ */ jsxs("div", { className: cn("flex items-stretch", groupClassName), children: [
    leftAddon && renderAddon(leftAddon, "left"),
    /* @__PURE__ */ jsx("div", { className: "flex-1", children: /* @__PURE__ */ jsx(
      Input,
      {
        ...restInputProps,
        className: cn(
          leftAddon ? "rounded-l-none" : "",
          rightAddon ? "rounded-r-none" : "",
          inputClassName
        )
      }
    ) }),
    rightAddon && renderAddon(rightAddon, "right")
  ] });
};
InputGroup.displayName = "InputGroup";
function isSExprObject(value) {
  return value !== null && value !== void 0 && typeof value === "object" && !Array.isArray(value);
}
function normalizeChildren(children) {
  if (children === void 0 || children === null) return [];
  return Array.isArray(children) ? children : [children];
}
function distinguishingSuffix(config) {
  if (typeof config.label === "string" && config.label.length > 0) return config.label;
  if (typeof config.text === "string" && config.text.length > 0) return config.text;
  if (typeof config.content === "string" && config.content.length > 0) return config.content;
  return void 0;
}
function patternRowLabel(value) {
  if (isSExprObject(value)) {
    const type = typeof value.type === "string" ? value.type : "unknown";
    const suffix = distinguishingSuffix(value);
    return suffix ? `${type} \u2014 ${suffix}` : type;
  }
  return value === void 0 || value === null ? "unknown" : String(value);
}
function pushPatternRows(items, slotId, slotIndex, parentRowId, patternPath, config) {
  const id = `${slotId}/pattern:${slotIndex}:${patternPath}`;
  items.push({ id, label: patternRowLabel(config), parentId: parentRowId, icon: "component" });
  if (!isSExprObject(config)) return;
  normalizeChildren(config.children).forEach((child, index) => {
    if (!isSExprObject(child)) return;
    pushPatternRows(items, slotId, slotIndex, id, `${patternPath}.children.${index}`, child);
  });
}
function schemaToLayerItems(schema) {
  const items = [];
  const seenSlotIds = /* @__PURE__ */ new Set();
  for (const appOrbital of parseApplicationLevel(schema).orbitals) {
    const orbitalId = `orbital:${appOrbital.name}`;
    items.push({ id: orbitalId, label: appOrbital.name, icon: "box" });
    const orbitalData = parseOrbitalLevel(schema, appOrbital.name);
    if (!orbitalData) continue;
    for (const page of orbitalData.pages) {
      items.push({
        id: `${orbitalId}/page:${page.name}`,
        label: page.name,
        parentId: orbitalId,
        icon: "file-text"
      });
    }
    for (const traitInfo of orbitalData.traits) {
      const traitId = `${orbitalId}/trait:${traitInfo.name}`;
      items.push({ id: traitId, label: traitInfo.name, parentId: orbitalId, icon: "git-branch" });
      const traitData = parseTraitLevel(schema, appOrbital.name, traitInfo.name);
      if (!traitData) continue;
      const renderUi = traitTransitionRenderUi(schema, appOrbital.name, traitInfo.name);
      traitData.transitions.forEach((transition, transitionIndex) => {
        const transitionId = `${traitId}/transition:${transitionIndex}`;
        items.push({
          id: transitionId,
          label: transition.event || `${transition.from} \u2192 ${transition.to}`,
          parentId: traitId,
          icon: "zap"
        });
        (renderUi[transitionIndex] ?? []).forEach((entry, slotIndex) => {
          const slotName = entry.slot;
          const slotId = `${transitionId}/slot:${slotName}`;
          if (!seenSlotIds.has(slotId)) {
            seenSlotIds.add(slotId);
            items.push({ id: slotId, label: slotName, parentId: transitionId, icon: "layout-panel-top" });
          }
          pushPatternRows(items, slotId, slotIndex, slotId, "root", entry.pattern);
        });
      });
    }
  }
  return items;
}
function parseLayerId(id) {
  const [head, ...rest] = id.split("/");
  const orbitalMatch = /^orbital:(.+)$/.exec(head ?? "");
  if (!orbitalMatch) return null;
  const parts = { orbitalName: orbitalMatch[1] };
  for (const segment of rest) {
    const pageMatch = /^page:(.+)$/.exec(segment);
    if (pageMatch) {
      parts.pageName = pageMatch[1];
      continue;
    }
    const traitMatch = /^trait:(.+)$/.exec(segment);
    if (traitMatch) {
      parts.traitName = traitMatch[1];
      continue;
    }
    const transitionMatch = /^transition:(\d+)$/.exec(segment);
    if (transitionMatch) {
      parts.transitionIndex = Number(transitionMatch[1]);
      continue;
    }
    const slotMatch = /^slot:(.+)$/.exec(segment);
    if (slotMatch) {
      parts.slotName = slotMatch[1];
      continue;
    }
    const patternMatch = /^pattern:(\d+):(.+)$/.exec(segment);
    if (patternMatch) {
      parts.patternSlotIndex = Number(patternMatch[1]);
      parts.patternPath = patternMatch[2];
      continue;
    }
    return null;
  }
  return parts;
}
var LayersPanel = ({ schema, selectedId, onSelect, onReorder }) => {
  const items = useMemo(() => schemaToLayerItems(schema), [schema]);
  return /* @__PURE__ */ jsx(
    FileTree,
    {
      items,
      look: "nav",
      selectedId,
      onNodeSelect: onSelect,
      onNodeReorder: onReorder
    }
  );
};
LayersPanel.displayName = "LayersPanel";
var DEFAULT_LIKERT_OPTION_KEYS = [
  { value: 1, labelKey: "likert.stronglyDisagree" },
  { value: 2, labelKey: "likert.disagree" },
  { value: 3, labelKey: "likert.neutral" },
  { value: 4, labelKey: "likert.agree" },
  { value: 5, labelKey: "likert.stronglyAgree" }
];
var radioSizes = {
  sm: { label: "text-xs", gap: "gap-1.5" },
  md: { label: "text-sm", gap: "gap-2" },
  lg: { label: "text-base", gap: "gap-2.5" }
};
var buttonSizes = {
  sm: "px-2 py-1 text-xs",
  md: "px-3 py-1.5 text-sm",
  lg: "px-4 py-2 text-base"
};
var questionSizes = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg"
};
var LikertScale = React93__default.forwardRef(
  ({
    question,
    options: optionsProp,
    value = null,
    onChange,
    changeEvent,
    disabled = false,
    size: size2 = "md",
    variant = "radios",
    className,
    ...rest
  }, ref) => {
    const groupId = React93__default.useId();
    const eventBus = useEventBus();
    const { t } = useTranslate();
    const options = optionsProp ?? DEFAULT_LIKERT_OPTION_KEYS.map((o) => ({ value: o.value, label: t(o.labelKey) }));
    const handleSelect = useCallback(
      (next) => {
        if (disabled) return;
        onChange?.(next);
        if (changeEvent) {
          eventBus.emit(`UI:${changeEvent}`, { value: next });
        }
      },
      [disabled, onChange, changeEvent, eventBus]
    );
    return /* @__PURE__ */ jsxs(
      Box,
      {
        ref,
        ...domPassthrough(rest),
        className: cn(
          "w-full",
          disabled && "opacity-50 cursor-not-allowed",
          className
        ),
        role: "radiogroup",
        "aria-label": rest["aria-label"] ?? question ?? t("likert.ariaLabel"),
        children: [
          question && /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "mb-3 font-medium text-foreground",
                questionSizes[size2]
              ),
              children: question
            }
          ),
          variant === "buttons" ? /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "inline-flex w-full items-stretch rounded-interactive overflow-hidden",
                "border-[length:var(--border-width)] border-border",
                "bg-surface"
              ),
              children: options.map((opt, idx) => {
                const selected = value !== null && value !== void 0 && value === opt.value;
                return /* @__PURE__ */ jsx(
                  Button,
                  {
                    type: "button",
                    role: "radio",
                    "aria-checked": selected,
                    disabled,
                    onClick: () => handleSelect(opt.value),
                    className: cn(
                      "flex-1 text-center font-medium transition-colors duration-instant",
                      "focus:outline-none focus:ring-[length:var(--focus-ring-width)] focus:ring-ring focus:ring-inset",
                      "disabled:cursor-not-allowed",
                      "rounded-none gap-0 shadow-none border-none",
                      idx > 0 && "border-l-[length:var(--border-width)] border-border",
                      buttonSizes[size2],
                      selected ? "bg-primary text-primary-foreground" : "bg-surface text-foreground hover:bg-muted"
                    ),
                    children: opt.label
                  },
                  String(opt.value)
                );
              })
            }
          ) : /* @__PURE__ */ jsx(
            Box,
            {
              className: cn(
                "flex w-full items-start justify-between",
                radioSizes[size2].gap
              ),
              children: options.map((opt) => {
                const selected = value !== null && value !== void 0 && value === opt.value;
                const inputId = `${groupId}-${String(opt.value)}`;
                return /* @__PURE__ */ jsxs(
                  Box,
                  {
                    className: cn(
                      "flex flex-1 flex-col items-center",
                      radioSizes[size2].gap
                    ),
                    children: [
                      /* @__PURE__ */ jsx(
                        Radio,
                        {
                          id: inputId,
                          name: groupId,
                          size: size2,
                          checked: selected,
                          disabled,
                          onChange: () => handleSelect(opt.value)
                        }
                      ),
                      /* @__PURE__ */ jsx(
                        Label,
                        {
                          htmlFor: inputId,
                          className: cn(
                            "text-center select-none",
                            radioSizes[size2].label,
                            selected ? "text-foreground font-medium" : "text-muted-foreground",
                            disabled ? "cursor-not-allowed" : "cursor-pointer"
                          ),
                          children: opt.label
                        }
                      )
                    ]
                  },
                  String(opt.value)
                );
              })
            }
          )
        ]
      }
    );
  }
);
LikertScale.displayName = "LikertScale";
var LineChart2 = ({
  data,
  width = 400,
  height = 200,
  showGrid = true,
  showValues = false,
  showArea = true,
  lineColor = "var(--color-primary)",
  areaColor = "var(--color-primary)",
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const gradientId = useId();
  const safeData = data ?? [];
  const sortedData = useMemo(() => {
    if (safeData.length === 0) return [];
    if (safeData.some((d) => d.date != null)) {
      return [...safeData].sort(
        (a, b) => new Date(a.date ?? 0).getTime() - new Date(b.date ?? 0).getTime()
      );
    }
    if (safeData.some((d) => d.x != null)) {
      return [...safeData].sort((a, b) => (a.x ?? 0) - (b.x ?? 0));
    }
    return [...safeData];
  }, [safeData]);
  const points = useMemo(() => {
    if (sortedData.length === 0) return [];
    const values = sortedData.map((d) => d.value);
    const minVal = Math.min(...values);
    const maxVal = Math.max(...values);
    const range = maxVal - minVal || 1;
    const padding = 20;
    const chartWidth = width - padding * 2;
    const chartHeight = height - padding * 2;
    const hasNumericX = !sortedData.some((d) => d.date != null) && sortedData.some((d) => d.x != null);
    const xValues = hasNumericX ? sortedData.map((d) => d.x ?? 0) : [];
    const minX = hasNumericX ? Math.min(...xValues) : 0;
    const xRange = hasNumericX ? Math.max(...xValues) - minX || 1 : 1;
    if (sortedData.length === 1) {
      const only = sortedData[0];
      return [{ x: width / 2, y: height / 2, value: only.value, label: only.label }];
    }
    return sortedData.map((point, index) => ({
      x: hasNumericX ? padding + ((point.x ?? 0) - minX) / xRange * chartWidth : padding + index / (sortedData.length - 1 || 1) * chartWidth,
      y: padding + chartHeight - (point.value - minVal) / range * chartHeight,
      value: point.value,
      label: point.label
    }));
  }, [sortedData, width, height]);
  const linePath = useMemo(() => {
    if (points.length === 0) return "";
    return points.map((p, i) => `${i === 0 ? "M" : "L"} ${p.x} ${p.y}`).join(" ");
  }, [points]);
  const areaPath = useMemo(() => {
    if (points.length === 0 || !showArea) return "";
    const bottom = height - 20;
    const first = points[0];
    const last = points[points.length - 1];
    return `${linePath} L ${last.x} ${bottom} L ${first.x} ${bottom} Z`;
  }, [linePath, points, height, showArea]);
  if (safeData.length === 0) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("flex items-center justify-center text-muted-foreground", className), style: { width, height }, children: t("empty.noData") });
  }
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(className), children: /* @__PURE__ */ jsxs(
    "svg",
    {
      viewBox: `0 0 ${width} ${height}`,
      width: "100%",
      height: "100%",
      preserveAspectRatio: "xMidYMid meet",
      children: [
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", { id: gradientId, x1: "0", y1: "0", x2: "0", y2: "1", children: [
          /* @__PURE__ */ jsx("stop", { offset: "0%", stopColor: areaColor, stopOpacity: "0.3" }),
          /* @__PURE__ */ jsx("stop", { offset: "100%", stopColor: areaColor, stopOpacity: "0" })
        ] }) }),
        showGrid && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.25, x2: width - 20, y2: height * 0.25, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" }),
          /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.5, x2: width - 20, y2: height * 0.5, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" }),
          /* @__PURE__ */ jsx("line", { x1: "20", y1: height * 0.75, x2: width - 20, y2: height * 0.75, stroke: "var(--color-border, #e5e7eb)", strokeWidth: "1" })
        ] }),
        showArea && areaPath && /* @__PURE__ */ jsx("path", { d: areaPath, fill: `url(#${gradientId})` }),
        linePath && /* @__PURE__ */ jsx(
          "path",
          {
            d: linePath,
            fill: "none",
            stroke: lineColor,
            strokeWidth: "2",
            strokeLinejoin: "round",
            strokeLinecap: "round"
          }
        ),
        points.map((point, index) => /* @__PURE__ */ jsx(
          "circle",
          {
            cx: point.x,
            cy: point.y,
            r: "4",
            fill: lineColor,
            stroke: "var(--color-background, white)",
            strokeWidth: "2"
          },
          index
        )),
        points.length === 1 && /* @__PURE__ */ jsx(
          "text",
          {
            x: points[0].x,
            y: points[0].y - 12,
            textAnchor: "middle",
            fontSize: "12",
            fill: "var(--color-foreground, currentColor)",
            children: points[0].label !== void 0 ? `${points[0].label}: ${points[0].value}` : points[0].value
          }
        ),
        showValues && points.length > 1 && points.map((point, index) => /* @__PURE__ */ jsx(
          "text",
          {
            x: point.x,
            y: point.y - 10,
            textAnchor: "middle",
            fontSize: "11",
            fill: "var(--color-foreground, currentColor)",
            children: point.label ?? point.value
          },
          `label-${index}`
        ))
      ]
    }
  ) });
};
LineChart2.displayName = "LineChart";
var DefaultEmptyDetail = () => {
  const { t } = useTranslate();
  return /* @__PURE__ */ jsx("div", { className: "flex items-center justify-center h-full border-heavy border-dashed border-border", children: /* @__PURE__ */ jsx(
    Typography,
    {
      variant: "body2",
      className: "text-muted-foreground",
      children: t("masterDetail.selectItem")
    }
  ) });
};
var MasterDetailLayout = ({
  master,
  detail,
  emptyDetail,
  hasSelection = false,
  masterWidth = "350px",
  className,
  masterClassName,
  detailClassName,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("@container w-full h-full", className), children: /* @__PURE__ */ jsxs(
    Box,
    {
      className: "w-full h-full @md:grid @md:grid-cols-[var(--master-detail-cols)]",
      style: { "--master-detail-cols": `${masterWidth} 1fr` },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "border-e border-border overflow-auto",
              hasSelection && "hidden @md:block",
              masterClassName
            ),
            children: master
          }
        ),
        /* @__PURE__ */ jsx(Box, { className: cn("overflow-auto", !hasSelection && "hidden @md:block", detailClassName), children: hasSelection ? detail : emptyDetail || /* @__PURE__ */ jsx(DefaultEmptyDetail, {}) })
      ]
    }
  ) });
};
MasterDetailLayout.displayName = "MasterDetailLayout";
function formatTick(v) {
  if (Number.isInteger(v)) return String(v);
  return v.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
}
function plotTransform(width, height, xMin, xMax, yMin, yMax, aspect) {
  const margin = 24;
  const fitW = width - margin * 2;
  const fitH = height - margin * 2;
  const fitSx = fitW / (xMax - xMin);
  const fitSy = fitH / (yMax - yMin);
  const sx = aspect === "equal" ? Math.min(fitSx, fitSy) : fitSx;
  const sy = aspect === "equal" ? Math.min(fitSx, fitSy) : fitSy;
  const left = margin + (fitW - sx * (xMax - xMin)) / 2;
  const bottom = height - margin - (fitH - sy * (yMax - yMin)) / 2;
  return {
    sx,
    sy,
    left,
    right: left + sx * (xMax - xMin),
    top: bottom - sy * (yMax - yMin),
    bottom,
    plotH: sy * (yMax - yMin),
    mapX: (x) => left + (x - xMin) * sx,
    mapY: (y) => bottom - (y - yMin) * sy
  };
}
var MathCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  xMin = -10,
  xMax = 10,
  yMin = -10,
  yMax = 10,
  showAxes = true,
  showGrid = true,
  gridStep = 1,
  backgroundColor,
  series,
  gridColor = "grid",
  axisColor = "axis",
  aspect = "fit",
  showTickLabels = false,
  tickLabelFontSize,
  labelFontSize,
  fontFamily: fontFamilyProp,
  showCurveLabels = false,
  curves = [],
  points = [],
  vectors = [],
  regions = [],
  bars = [],
  guides = [],
  angles = [],
  hops = [],
  shapes = [],
  drawables,
  readouts,
  traces,
  interactive = false,
  animate = false,
  onShapeClick,
  keyMap,
  keyUpMap,
  isLoading,
  error,
  ...rest
}) => {
  const fontFamily = resolveGameFontFamily(fontFamilyProp);
  const derivedShapes = useMemo(() => {
    const _perfT = perfStart("mathcanvas:derive");
    const out = [];
    const { sx, sy, left, right, top, bottom, plotH, mapX, mapY } = plotTransform(width, height, xMin, xMax, yMin, yMax, aspect);
    const plotW = right - left;
    const xAxisY = Math.max(top, Math.min(bottom, mapY(0)));
    const yAxisX = Math.max(left, Math.min(right, mapX(0)));
    if (showGrid) {
      for (let x = Math.ceil(xMin / gridStep) * gridStep; x <= xMax; x += gridStep) {
        const px = mapX(x);
        out.push({ type: "line", x1: px, y1: top, x2: px, y2: bottom, color: gridColor, stroke: "thin" });
      }
      for (let y = Math.ceil(yMin / gridStep) * gridStep; y <= yMax; y += gridStep) {
        const py = mapY(y);
        out.push({ type: "line", x1: left, y1: py, x2: right, y2: py, color: gridColor, stroke: "thin" });
      }
    }
    if (showTickLabels) {
      const labelEveryX = Math.max(1, Math.ceil((xMax - xMin) / gridStep / Math.floor(plotW / 40)));
      let kx = 0;
      for (let x = Math.ceil(xMin / gridStep) * gridStep; x <= xMax; x += gridStep, kx++) {
        if (kx % labelEveryX === 0 && x !== 0) {
          out.push({ type: "text", textCase: "verbatim", fontFamily, x: mapX(x), y: xAxisY + 12, text: formatTick(x), tone: "label", textSize: "xs", fontSize: tickLabelFontSize, align: "center" });
        }
      }
      const labelEveryY = Math.max(1, Math.ceil((yMax - yMin) / gridStep / Math.floor(plotH / 28)));
      let ky = 0;
      for (let y = Math.ceil(yMin / gridStep) * gridStep; y <= yMax; y += gridStep, ky++) {
        if (ky % labelEveryY === 0 && y !== 0) {
          out.push({ type: "text", textCase: "verbatim", fontFamily, x: yAxisX - 6, y: mapY(y), text: formatTick(y), tone: "label", textSize: "xs", fontSize: tickLabelFontSize, align: "right" });
        }
      }
      if (xMin <= 0 && xMax >= 0 && yMin <= 0 && yMax >= 0) {
        out.push({ type: "text", textCase: "verbatim", fontFamily, x: yAxisX - 6, y: xAxisY + 12, text: "0", tone: "label", textSize: "xs", fontSize: tickLabelFontSize, align: "right" });
      }
    }
    for (const region of regions) {
      if (!region.samples || region.samples.length === 0) continue;
      const baseline = region.baseline ?? 0;
      const clampedPoint = (p) => ({
        x: mapX(Math.min(xMax, Math.max(xMin, p.x))),
        y: mapY(Math.min(yMax, Math.max(yMin, p.y)))
      });
      const upper = region.samples.map(clampedPoint);
      const first = region.samples[0];
      const last = region.samples[region.samples.length - 1];
      const closing = region.samples2 && region.samples2.length > 0 ? [...region.samples2].reverse().map(clampedPoint) : [clampedPoint({ x: last.x, y: baseline }), clampedPoint({ x: first.x, y: baseline })];
      const color = region.color ?? "series-1";
      out.push({
        type: "polygon",
        points: [...upper, ...closing],
        fill: color,
        color,
        fillStyle: "tint",
        opacity: region.opacity,
        stroke: "thin"
      });
      if (region.label) {
        const mid = Math.floor(region.samples.length / 2);
        out.push({
          type: "text",
          textCase: "verbatim",
          fontFamily,
          x: mapX((first.x + last.x) / 2),
          y: (mapY(region.samples[mid].y) + mapY(baseline)) / 2,
          text: region.label,
          color,
          fontSize: labelFontSize
        });
      }
    }
    for (const bar of bars) {
      if (bar.x + bar.width < xMin || bar.x > xMax) continue;
      const y0 = bar.y0 ?? 0;
      const color = bar.color ?? "series-2";
      out.push({
        type: "rect",
        x: mapX(bar.x),
        y: mapY(Math.max(y0, bar.y1)),
        width: mapX(bar.x + bar.width) - mapX(bar.x),
        height: Math.abs(mapY(bar.y1) - mapY(y0)),
        color,
        fill: color,
        fillStyle: "tint",
        opacity: bar.opacity,
        stroke: "thin"
      });
    }
    if (showAxes) {
      out.push({ type: "line", x1: left, y1: xAxisY, x2: right, y2: xAxisY, color: axisColor, stroke: "normal" });
      out.push({ type: "line", x1: yAxisX, y1: top, x2: yAxisX, y2: bottom, color: axisColor, stroke: "normal" });
    }
    for (const guide of guides) {
      const color = guide.color ?? "guide";
      const dash = guide.dash ?? "dashed";
      if (guide.kind === "vline") {
        if (guide.at < xMin || guide.at > xMax) continue;
        const px = mapX(guide.at);
        out.push({ type: "line", x1: px, y1: top, x2: px, y2: bottom, color, dash, stroke: "thin" });
        if (guide.label) {
          out.push({ type: "text", textCase: "verbatim", fontFamily, x: px + 4, y: top + 10, text: guide.label, color, fontSize: labelFontSize });
        }
      } else {
        if (guide.at < yMin || guide.at > yMax) continue;
        const py = mapY(guide.at);
        out.push({ type: "line", x1: left, y1: py, x2: right, y2: py, color, dash, stroke: "thin" });
        if (guide.label) {
          out.push({ type: "text", textCase: "verbatim", fontFamily, x: right - 4, y: py - 8, text: guide.label, color, fontSize: labelFontSize, align: "right" });
        }
      }
    }
    for (const [curveIndex, curve] of curves.entries()) {
      if (!curve.samples || curve.samples.length < 2) continue;
      const curveColor = curve.color ?? `series-${curveIndex % 8 + 1}`;
      let d = "";
      let penDown = false;
      let lastInRange;
      for (let i = 1; i < curve.samples.length; i++) {
        const a = curve.samples[i - 1];
        const b = curve.samples[i];
        if (a.x < xMin && b.x < xMin || a.x > xMax && b.x > xMax) {
          penDown = false;
          continue;
        }
        const clip = (p, q, xLim) => {
          const t = q.x === p.x ? 0 : (xLim - p.x) / (q.x - p.x);
          return { x: xLim, y: p.y + t * (q.y - p.y) };
        };
        const ca = a.x < xMin ? clip(a, b, xMin) : a.x > xMax ? clip(a, b, xMax) : a;
        const cb = b.x < xMin ? clip(a, b, xMin) : b.x > xMax ? clip(a, b, xMax) : b;
        const pax = mapX(ca.x);
        const pay = mapY(ca.y);
        d += `${penDown ? "L" : "M"} ${pax} ${pay} L ${mapX(cb.x)} ${mapY(cb.y)} `;
        penDown = true;
        if (b.x >= xMin && b.x <= xMax) lastInRange = b;
      }
      if (!d) continue;
      out.push({
        type: "path",
        path: d,
        color: curveColor,
        stroke: "bold",
        dash: curve.dash
      });
      if (showCurveLabels && curve.label && lastInRange) {
        out.push({
          type: "text",
          textCase: "verbatim",
          fontFamily,
          x: mapX(lastInRange.x) + 6,
          y: mapY(lastInRange.y) - 6,
          text: curve.label,
          color: curveColor,
          fontSize: labelFontSize
        });
      }
    }
    for (const hop of hops) {
      const x1 = mapX(hop.from);
      const x2 = mapX(hop.to);
      const peak = Math.min(36, plotH * 0.3);
      const color = hop.color ?? "series-3";
      out.push({
        type: "ellipse",
        x: (x1 + x2) / 2,
        y: xAxisY,
        width: Math.abs(x2 - x1),
        height: 2 * peak,
        startAngle: 180,
        endAngle: 360,
        color
      });
      const s = Math.sign(hop.to - hop.from);
      out.push({
        type: "polygon",
        points: [
          { x: x2, y: xAxisY },
          { x: x2 - 4 * s, y: xAxisY - 7 },
          { x: x2 + 2 * s, y: xAxisY - 7 }
        ],
        fill: color,
        color
      });
      if (hop.label) {
        out.push({
          type: "text",
          textCase: "verbatim",
          fontFamily,
          x: (x1 + x2) / 2,
          y: xAxisY - peak - 8,
          text: hop.label,
          color,
          fontSize: labelFontSize,
          align: "center"
        });
      }
    }
    for (const angle of angles) {
      const radius = angle.radius ?? 0.8;
      const color = angle.color ?? "series-4";
      out.push({
        type: "ellipse",
        x: mapX(angle.x),
        y: mapY(angle.y),
        width: 2 * radius * sx,
        height: 2 * radius * sy,
        startAngle: -angle.to,
        endAngle: -angle.from,
        color
      });
      if (angle.label) {
        const mid = (angle.from + angle.to) / 2;
        const rad = mid * Math.PI / 180;
        out.push({
          type: "text",
          textCase: "verbatim",
          fontFamily,
          x: mapX(angle.x + 1.35 * radius * Math.cos(rad)),
          y: mapY(angle.y + 1.35 * radius * Math.sin(rad)),
          text: angle.label,
          color,
          fontSize: labelFontSize,
          align: "center"
        });
      }
    }
    for (const p of points) {
      if (p.x < xMin || p.x > xMax || p.y < yMin || p.y > yMax) continue;
      const isOpen = p.style === "open";
      out.push({
        type: "circle",
        x: mapX(p.x),
        y: mapY(p.y),
        radius: p.radius ?? 4,
        color: p.color ?? "highlight",
        fill: p.color ?? "highlight",
        fillStyle: isOpen ? "outline" : "solid",
        stroke: "normal"
      });
      if (p.label) {
        out.push({ type: "text", textCase: "verbatim", fontFamily, x: mapX(p.x) + 8, y: mapY(p.y) - 8, text: p.label, tone: "ink", fontSize: labelFontSize });
      }
    }
    for (const v of vectors) {
      if (v.x < xMin || v.x > xMax || v.y < yMin || v.y > yMax) continue;
      const x1 = mapX(v.x);
      const y1 = mapY(v.y);
      const x2 = mapX(v.x + v.vx);
      const y2 = mapY(v.y + v.vy);
      out.push({ type: "arrow", x1, y1, x2, y2, color: v.color ?? "series-5", stroke: "bold" });
      if (v.label) {
        out.push({ type: "text", textCase: "verbatim", fontFamily, x: x2 + 6, y: y2 - 6, text: v.label, color: v.color ?? "series-5", fontSize: labelFontSize });
      }
    }
    out.push(...shapes);
    perfEnd("mathcanvas:derive", _perfT);
    return out;
  }, [
    width,
    height,
    xMin,
    xMax,
    yMin,
    yMax,
    showAxes,
    showGrid,
    gridStep,
    aspect,
    gridColor,
    axisColor,
    showTickLabels,
    tickLabelFontSize,
    labelFontSize,
    fontFamily,
    showCurveLabels,
    curves,
    points,
    vectors,
    regions,
    bars,
    guides,
    angles,
    hops,
    shapes
  ]);
  const projector = useMemo(() => {
    if (!drawables?.length) return void 0;
    const { sx: xScale, mapX, mapY } = plotTransform(width, height, xMin, xMax, yMin, yMax, aspect);
    const project = (pos) => ({ x: mapX(pos.x), y: mapY(pos.y) });
    const anchorPoint = (pos, anchor) => {
      const base = project(pos);
      if (anchor === "top-left") return base;
      const cx = base.x + xScale / 2;
      if (anchor === "ground") return { x: cx, y: base.y + xScale * 0.92 };
      return { x: cx, y: base.y + xScale / 2 };
    };
    const cellPath = (pos) => {
      const base = project(pos);
      return [
        { x: base.x, y: base.y },
        { x: base.x + xScale, y: base.y },
        { x: base.x + xScale, y: base.y + xScale },
        { x: base.x, y: base.y + xScale }
      ];
    };
    return {
      project,
      anchorPoint,
      cellPath,
      tileWidth: xScale,
      floorHeight: xScale / 2,
      diamondTopY: 0,
      squareGrid: true,
      worldPixelDirect: false
    };
  }, [drawables?.length, width, height, xMin, xMax, yMin, yMax, aspect]);
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        fontFamily,
        shapes: derivedShapes,
        drawables,
        projector,
        readouts,
        traces,
        interactive,
        animate,
        onShapeClick,
        isLoading,
        error
      }
    )
  ] }) });
};
var DEFAULT_MATRIX_COLUMN_KEYS = [
  { value: 1, labelKey: "likert.stronglyDisagree" },
  { value: 2, labelKey: "likert.disagree" },
  { value: 3, labelKey: "likert.neutral" },
  { value: 4, labelKey: "likert.agree" },
  { value: 5, labelKey: "likert.stronglyAgree" }
];
var sizeStyles10 = {
  sm: {
    cell: "px-2 py-1.5 text-xs",
    radio: "sm",
    label: "text-xs"
  },
  md: {
    cell: "px-3 py-2 text-sm",
    radio: "md",
    label: "text-sm"
  }
};
var MatrixQuestion = ({
  title,
  rows: rows2,
  columns: columnsProp,
  values,
  onChange,
  changeEvent,
  disabled = false,
  size: size2 = "md",
  className,
  ...rest
}) => {
  const styles = sizeStyles10[size2];
  const safeRows = rows2 ?? [];
  const safeValues = values ?? {};
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const columns = columnsProp ?? DEFAULT_MATRIX_COLUMN_KEYS.map((c) => ({ value: c.value, label: t(c.labelKey) }));
  const handleChange = useCallback(
    (rowId, value) => {
      if (disabled) return;
      onChange?.(rowId, value);
      if (changeEvent) {
        eventBus.emit(`UI:${changeEvent}`, { rowId, value });
      }
    },
    [onChange, changeEvent, eventBus, disabled]
  );
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("w-full", className), children: [
    title && /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "mb-3", children: title }),
    /* @__PURE__ */ jsx(Box, { overflow: "auto", className: "overflow-x-auto", children: /* @__PURE__ */ jsxs(Box, { as: "table", className: "w-full border-collapse", children: [
      /* @__PURE__ */ jsx(Box, { as: "thead", children: /* @__PURE__ */ jsxs(Box, { as: "tr", className: "border-b border-border", children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            as: "th",
            role: "columnheader",
            className: cn("text-left font-medium text-muted-foreground", styles.cell)
          }
        ),
        columns.map((col) => /* @__PURE__ */ jsx(
          Box,
          {
            as: "th",
            role: "columnheader",
            className: cn(
              "text-center font-medium text-muted-foreground",
              styles.cell
            ),
            children: col.label
          },
          String(col.value)
        ))
      ] }) }),
      /* @__PURE__ */ jsx(Box, { as: "tbody", children: safeRows.map((row, idx) => {
        const groupName = `matrix-${row.id}`;
        const selected = safeValues[row.id];
        return /* @__PURE__ */ jsxs(
          Box,
          {
            as: "tr",
            className: cn(
              "border-b border-border",
              idx % 2 === 1 && "bg-muted/30"
            ),
            children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  as: "th",
                  role: "rowheader",
                  className: cn(
                    "text-left font-normal text-foreground",
                    styles.cell,
                    styles.label
                  ),
                  children: row.label
                }
              ),
              columns.map((col) => {
                const isChecked = selected !== void 0 && selected === col.value;
                const inputId = `${groupName}-${String(col.value)}`;
                return /* @__PURE__ */ jsx(
                  Box,
                  {
                    as: "td",
                    className: cn("text-center", styles.cell),
                    children: /* @__PURE__ */ jsx(
                      Box,
                      {
                        display: "inline-flex",
                        className: cn(
                          "items-center justify-center",
                          disabled && "opacity-60"
                        ),
                        children: /* @__PURE__ */ jsx(
                          Radio,
                          {
                            id: inputId,
                            name: groupName,
                            value: String(col.value),
                            checked: isChecked,
                            disabled,
                            size: styles.radio,
                            onChange: () => handleChange(row.id, col.value),
                            "aria-label": `${row.label}: ${col.label}`
                          }
                        )
                      }
                    )
                  },
                  String(col.value)
                );
              })
            ]
          },
          row.id
        );
      }) })
    ] }) })
  ] });
};
MatrixQuestion.displayName = "MatrixQuestion";
var COLUMN_CLASSES = {
  2: "grid-cols-2",
  3: "grid-cols-2 sm:grid-cols-3",
  4: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4",
  5: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5",
  6: "grid-cols-3 sm:grid-cols-4 lg:grid-cols-6"
};
var ASPECT_CLASSES = {
  square: "aspect-square",
  landscape: "aspect-video",
  portrait: "aspect-[3/4]"
};
var MediaGallery = ({
  title,
  items: propItems,
  columns = 3,
  selectable = false,
  selectedItems = [],
  selectionEvent = "SELECTION_CHANGE",
  showUpload = false,
  actions,
  aspectRatio = "square",
  srcField = "src",
  captionField = "caption",
  entity,
  isLoading = false,
  error,
  className,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [failedIds, setFailedIds] = useState(/* @__PURE__ */ new Set());
  const closeLightbox = useCallback(() => setLightboxIndex(null), []);
  useEventListener("UI:LIGHTBOX_CLOSE", closeLightbox);
  const handleImageError = useCallback((id) => {
    setFailedIds((prev) => {
      if (prev.has(id)) return prev;
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  }, []);
  const handleItemClick = useCallback(
    (item, index) => {
      if (selectable) {
        const isSelected = selectedItems.includes(item.id);
        const newSelection = isSelected ? selectedItems.filter((id) => id !== item.id) : [...selectedItems, item.id];
        eventBus.emit(`UI:${selectionEvent}`, { selection: newSelection });
      } else {
        setLightboxIndex(index);
      }
      eventBus.emit("UI:MEDIA_SELECT", { row: item });
    },
    [selectable, selectedItems, selectionEvent, eventBus]
  );
  const entityData = Array.isArray(entity) ? entity : [];
  const items = React93__default.useMemo(() => {
    if (propItems && propItems.length > 0) return propItems;
    if (entityData.length === 0) return [];
    return entityData.map((record, idx) => {
      return {
        id: String(record.id ?? idx),
        src: resolveImageUrl(record[srcField]) ?? "",
        alt: record.alt ? String(record.alt) : void 0,
        thumbnail: resolveImageUrl(record.thumbnail),
        caption: record[captionField] != null ? String(record[captionField]) : void 0
      };
    });
  }, [propItems, entityData, srcField, captionField]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className }) });
  }
  if (error) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.galleryError"),
        message: error.message,
        className
      }
    ) });
  }
  if (items.length === 0 && !showUpload) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), children: /* @__PURE__ */ jsx(
      EmptyState,
      {
        icon: Image$1,
        title: t("display.noMedia"),
        description: t("mediaGallery.noMediaDescription"),
        className
      }
    ) });
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-6 rounded-container", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        (title || showUpload || actions && actions.length > 0) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
          title && /* @__PURE__ */ jsx(Typography, { variant: "h5", children: title }),
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", children: [
            showUpload && /* @__PURE__ */ jsx(
              Button,
              {
                variant: "secondary",
                size: "sm",
                icon: Upload,
                action: "MEDIA_UPLOAD",
                children: t("mediaGallery.upload")
              }
            ),
            actions?.map((action, idx) => /* @__PURE__ */ jsx(
              Box,
              {
                action: action.event,
                className: "cursor-pointer hover:opacity-80 transition-opacity",
                children: /* @__PURE__ */ jsx(Badge, { variant: "default", children: action.label })
              },
              idx
            ))
          ] })
        ] }),
        selectable && selectedItems.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: /* @__PURE__ */ jsx(Badge, { variant: "info", children: t("table.bulk.selected", { count: selectedItems.length }) }) }),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "grid gap-3",
              COLUMN_CLASSES[columns]
            ),
            children: items.map((item, index) => {
              const isSelected = selectedItems.includes(item.id);
              return /* @__PURE__ */ jsxs(
                Box,
                {
                  className: cn(
                    "group relative overflow-hidden rounded-container cursor-pointer",
                    "border-heavy transition-all duration-fast",
                    isSelected ? "border-primary ring-2 ring-primary/30" : "border-transparent hover:border-border",
                    ASPECT_CLASSES[aspectRatio]
                  ),
                  role: "button",
                  tabIndex: 0,
                  "aria-label": item.alt || item.caption || item.id,
                  "aria-pressed": selectable ? isSelected : void 0,
                  onClick: () => handleItemClick(item, index),
                  onKeyDown: (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleItemClick(item, index);
                    }
                  },
                  children: [
                    failedIds.has(item.id) ? /* @__PURE__ */ jsx(Box, { className: "w-full h-full flex items-center justify-center bg-muted text-muted-foreground", children: /* @__PURE__ */ jsx(Icon, { icon: Image$1, size: "lg" }) }) : /* @__PURE__ */ jsx(
                      "img",
                      {
                        src: item.thumbnail || item.src,
                        alt: item.alt || item.caption || "",
                        className: "w-full h-full object-cover",
                        loading: "lazy",
                        onError: () => handleImageError(item.id)
                      }
                    ),
                    /* @__PURE__ */ jsx(
                      Box,
                      {
                        className: cn(
                          "absolute inset-0 bg-foreground/0 group-hover:bg-foreground/20",
                          "transition-colors duration-fast flex items-center justify-center"
                        ),
                        children: /* @__PURE__ */ jsx(
                          Icon,
                          {
                            icon: ZoomIn,
                            size: "md",
                            className: "text-white opacity-0 group-hover:opacity-100 transition-opacity duration-fast"
                          }
                        )
                      }
                    ),
                    item.caption && // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: caption scrim over image
                    /* @__PURE__ */ jsx(Box, { className: "absolute bottom-0 left-0 right-0 p-2 bg-gradient-to-t from-black/60 to-transparent", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-white truncate", children: item.caption }) }),
                    selectable && isSelected && /* @__PURE__ */ jsx(Box, { className: "absolute top-2 right-2 w-5 h-5 rounded-full bg-primary flex items-center justify-center", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-primary-foreground text-xs", children: "\u2713" }) })
                  ]
                },
                item.id
              );
            })
          }
        )
      ] }) }),
      /* @__PURE__ */ jsx(
        Lightbox,
        {
          images: items.map((it) => ({ src: it.src, alt: it.alt || it.caption, caption: it.caption })),
          currentIndex: lightboxIndex ?? 0,
          isOpen: lightboxIndex !== null,
          onClose: closeLightbox,
          closeAction: "LIGHTBOX_CLOSE"
        }
      )
    ] })
  );
};
MediaGallery.displayName = "MediaGallery";
var DEFAULT_THRESHOLDS = [
  { value: 30, color: "var(--color-error)" },
  { value: 70, color: "var(--color-warning)" },
  { value: 100, color: "var(--color-success)" }
];
function getColorForValue(value, max, thresholds) {
  const percentage = value / max * 100;
  for (const threshold of thresholds) {
    if (percentage <= threshold.value) {
      return threshold.color;
    }
  }
  return thresholds[thresholds.length - 1]?.color ?? "var(--color-primary)";
}
var radialSizes = {
  sm: { size: 80, stroke: 6, fontSize: "12px" },
  md: { size: 120, stroke: 8, fontSize: "16px" },
  lg: { size: 160, stroke: 10, fontSize: "20px" }
};
var Meter = ({
  value,
  min = 0,
  max = 100,
  label,
  unit,
  variant = "linear",
  thresholds = DEFAULT_THRESHOLDS,
  segments = 5,
  showValue = true,
  size: size2 = "md",
  actions,
  isLoading = false,
  error,
  className,
  "aria-label": ariaLabel,
  ...rest
}) => {
  const passthrough = domPassthrough(rest);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleAction = useCallback(
    (action) => {
      if (action.event) {
        eventBus.emit(`UI:${action.event}`, { value });
      }
    },
    [eventBus, value]
  );
  const safeVal = value ?? 0;
  const percentage = useMemo(() => {
    const range = max - min;
    if (range <= 0) return 0;
    return Math.min(Math.max((safeVal - min) / range * 100, 0), 100);
  }, [safeVal, min, max]);
  const activeColor = useMemo(
    () => getColorForValue(safeVal, max, thresholds),
    [safeVal, max, thresholds]
  );
  const displayValue = useMemo(() => {
    const formatted = Number.isInteger(safeVal) ? safeVal : safeVal.toFixed(1);
    return unit ? `${formatted}${unit}` : `${formatted}`;
  }, [safeVal, unit]);
  const meterProps = {
    role: "meter",
    "aria-label": ariaLabel ?? label,
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": Math.min(Math.max(safeVal, min), max),
    "aria-valuetext": displayValue
  };
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.meterError"),
        message: error.message,
        className
      }
    );
  }
  if (variant === "radial") {
    const dims = radialSizes[size2];
    const radius = (dims.size - dims.stroke * 2) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - percentage / 100 * circumference;
    const center = dims.size / 2;
    return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), ...passthrough, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "center", children: [
      label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
      /* @__PURE__ */ jsxs(Box, { className: "relative inline-flex items-center justify-center", ...meterProps, children: [
        /* @__PURE__ */ jsxs(
          "svg",
          {
            width: dims.size,
            height: dims.size,
            viewBox: `0 0 ${dims.size} ${dims.size}`,
            className: "transform -rotate-90",
            children: [
              /* @__PURE__ */ jsx(
                "circle",
                {
                  cx: center,
                  cy: center,
                  r: radius,
                  fill: "none",
                  stroke: "var(--color-muted)",
                  strokeWidth: dims.stroke
                }
              ),
              /* @__PURE__ */ jsx(
                "circle",
                {
                  cx: center,
                  cy: center,
                  r: radius,
                  fill: "none",
                  stroke: activeColor,
                  strokeWidth: dims.stroke,
                  strokeDasharray: circumference,
                  strokeDashoffset: offset,
                  strokeLinecap: "round",
                  className: "transition-all duration-slow ease-emphasized"
                }
              )
            ]
          }
        ),
        showValue && /* @__PURE__ */ jsx(Box, { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "h5",
            className: "tabular-nums",
            style: { fontSize: dims.fontSize },
            children: displayValue
          }
        ) })
      ] }),
      actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
        Badge,
        {
          variant: "default",
          className: "cursor-pointer hover:opacity-80 transition-opacity",
          onClick: () => handleAction(action),
          children: action.label
        },
        idx
      )) })
    ] }) });
  }
  if (variant === "segmented") {
    const activeSegments = Math.round(percentage / 100 * segments);
    return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), ...passthrough, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      (label || showValue) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
        label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
        showValue && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "bold", className: "tabular-nums", children: displayValue })
      ] }),
      /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "w-full", ...meterProps, children: Array.from({ length: segments }).map((_, idx) => {
        const isActive = idx < activeSegments;
        const segColor = isActive ? getColorForValue((idx + 1) / segments * max, max, thresholds) : void 0;
        return /* @__PURE__ */ jsx(
          Box,
          {
            className: cn(
              "h-2 flex-1 rounded-sm transition-all duration-normal",
              !isActive && "bg-muted"
            ),
            style: isActive ? { backgroundColor: segColor } : void 0
          },
          idx
        );
      }) }),
      thresholds.some((t2) => t2.label) && /* @__PURE__ */ jsx(HStack, { justify: "between", className: "w-full", children: thresholds.map((t2, idx) => /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: t2.label || "" }, idx)) })
    ] }) });
  }
  return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), ...passthrough, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    (label || showValue) && /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
      label && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", weight: "medium", children: label }),
      showValue && /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "bold", className: "tabular-nums", children: displayValue })
    ] }),
    /* @__PURE__ */ jsx(Box, { className: "w-full h-3 bg-muted rounded-full overflow-hidden", ...meterProps, children: /* @__PURE__ */ jsx(
      Box,
      {
        className: "h-full rounded-full transition-all duration-slow ease-emphasized",
        style: {
          width: `${percentage}%`,
          backgroundColor: activeColor
        }
      }
    ) }),
    /* @__PURE__ */ jsxs(HStack, { justify: "between", className: "w-full", children: [
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", children: [
        min,
        unit ? ` ${unit}` : ""
      ] }),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", children: [
        max,
        unit ? ` ${unit}` : ""
      ] })
    ] }),
    actions && actions.length > 0 && /* @__PURE__ */ jsx(HStack, { gap: "xs", children: actions.map((action, idx) => /* @__PURE__ */ jsx(
      Badge,
      {
        variant: "default",
        className: "cursor-pointer hover:opacity-80 transition-opacity",
        onClick: () => handleAction(action),
        children: action.label
      },
      idx
    )) })
  ] }) });
};
Meter.displayName = "Meter";
function extractTitle2(children) {
  if (!React93__default.isValidElement(children)) return void 0;
  const props = children.props;
  if (typeof props.title === "string") {
    return props.title;
  }
  return void 0;
}
var ModalSlot = ({
  children,
  title: overrideTitle,
  size: size2 = "md",
  className,
  sourceTrait
}) => {
  const eventBus = useEventBus();
  const schemaCtx = useEntitySchemaOptional();
  const isOpen = Boolean(children);
  const title = overrideTitle || extractTitle2(children);
  const handleClose = () => {
    const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
    const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
    eventBus.emit(`${prefix}CLOSE`);
    eventBus.emit(`${prefix}CANCEL`);
  };
  if (!isOpen) return null;
  return /* @__PURE__ */ jsx(
    Modal,
    {
      isOpen,
      onClose: handleClose,
      title,
      size: size2,
      className,
      children: /* @__PURE__ */ jsx(RenderSlotProvider, { slot: "modal", children })
    }
  );
};
ModalSlot.displayName = "ModalSlot";
var hitStyle = (b) => ({ position: "absolute", left: b.left, top: b.top, width: b.width, height: b.height });
var HIT_CLASS = "rounded-full cursor-help focus:outline-none focus-visible:ring-2 focus-visible:ring-ring";
var EffectHit = ({ effectType, box, note }) => {
  const lines = useEffectLines(effectType);
  return /* @__PURE__ */ jsx(AvlExplain, { lines, note, children: /* @__PURE__ */ jsx(Box, { as: "span", role: "img", tabIndex: 0, "aria-label": effectType, className: HIT_CLASS, style: hitStyle(box) }) });
};
var NODE_W = 24;
var NODE_H2 = 16;
var GAP = 8;
var ARROW_W = 16;
var INITIAL_MARGIN = 24;
var TERMINAL_OUTSET = 4;
var EFFECT_SIZE = 5;
var EFFECT_R = EFFECT_SIZE * 1.2;
var EFFECT_GAP2 = 4;
var ROW_GAP = 6;
var EDGE = 2;
var MiniStateMachine = ({ data, annotations, className }) => {
  const { t } = useTranslate();
  const states = data.states;
  if (states.length === 0) return null;
  const transitionCounts = {};
  for (const s of states) transitionCounts[s.name] = 0;
  for (const t2 of data.transitions) {
    transitionCounts[t2.from] = (transitionCounts[t2.from] ?? 0) + 1;
    transitionCounts[t2.to] = (transitionCounts[t2.to] ?? 0) + 1;
  }
  const maxTC = Math.max(...Object.values(transitionCounts), 0);
  const effectTypes = /* @__PURE__ */ new Set();
  for (const t2 of data.transitions) {
    for (const e of t2.effects) effectTypes.add(e.type);
  }
  const effectList = Array.from(effectTypes).slice(0, 6);
  const stateStep = NODE_W + GAP + ARROW_W + GAP;
  const rowTop = TERMINAL_OUTSET + EDGE;
  const statesRight = INITIAL_MARGIN + (states.length - 1) * stateStep + NODE_W + TERMINAL_OUTSET;
  const effectTop = rowTop + NODE_H2 + TERMINAL_OUTSET + ROW_GAP;
  const effectCy = effectTop + EFFECT_R;
  const effectStep = EFFECT_R * 2 + EFFECT_GAP2;
  const effectsRight = EDGE + effectList.length * effectStep - EFFECT_GAP2;
  const svgW = Math.max(statesRight, effectsRight) + EDGE;
  const svgH = (effectList.length > 0 ? effectTop + EFFECT_R * 2 : rowTop + NODE_H2 + TERMINAL_OUTSET) + EDGE;
  return /* @__PURE__ */ jsxs(Box, { className: cn("relative inline-block", className), style: { width: svgW, height: svgH }, children: [
    /* @__PURE__ */ jsxs("svg", { width: svgW, height: svgH, viewBox: `0 0 ${svgW} ${svgH}`, "aria-hidden": "true", children: [
      states.map((s, i) => {
        const x = INITIAL_MARGIN + i * stateStep;
        const tc = transitionCounts[s.name] ?? 0;
        const role = getStateRole(s.isInitial ?? void 0, s.isTerminal ?? void 0, tc, maxTC);
        return /* @__PURE__ */ jsxs(React93__default.Fragment, { children: [
          /* @__PURE__ */ jsx(
            AvlState,
            {
              x,
              y: rowTop,
              width: NODE_W,
              height: NODE_H2,
              name: "",
              role,
              isInitial: s.isInitial ?? void 0,
              isTerminal: s.isTerminal ?? void 0
            }
          ),
          i < states.length - 1 && /* @__PURE__ */ jsxs("g", { children: [
            /* @__PURE__ */ jsx(
              "line",
              {
                x1: x + NODE_W + GAP,
                y1: rowTop + NODE_H2 / 2,
                x2: x + NODE_W + GAP + ARROW_W - 3,
                y2: rowTop + NODE_H2 / 2,
                stroke: "var(--color-muted-foreground)",
                strokeWidth: 1,
                opacity: 0.4
              }
            ),
            /* @__PURE__ */ jsx(
              "polygon",
              {
                points: `${x + NODE_W + GAP + ARROW_W - 3},${rowTop + NODE_H2 / 2 - 2.5} ${x + NODE_W + GAP + ARROW_W},${rowTop + NODE_H2 / 2} ${x + NODE_W + GAP + ARROW_W - 3},${rowTop + NODE_H2 / 2 + 2.5}`,
                fill: "var(--color-muted-foreground)",
                opacity: 0.4
              }
            )
          ] })
        ] }, s.name);
      }),
      effectList.length > 0 && /* @__PURE__ */ jsx("g", { children: effectList.map((et, i) => /* @__PURE__ */ jsx("g", { "data-testid": "mini-sm-effect", children: /* @__PURE__ */ jsx(
        AvlEffect,
        {
          x: EDGE + EFFECT_R + i * effectStep,
          y: effectCy,
          effectType: et,
          size: EFFECT_SIZE,
          showBackground: true
        }
      ) }, et)) })
    ] }),
    states.map((s, i) => {
      const marks = [...s.isInitial ? [t("avl.stateInitial")] : [], ...s.isTerminal ? [t("avl.stateTerminal")] : []];
      return /* @__PURE__ */ jsx(AvlExplain, { lines: marks.length > 0 ? [s.name, marks.join(" \xB7 ")] : [s.name], note: annotations?.states?.[s.name], children: /* @__PURE__ */ jsx(
        Box,
        {
          as: "span",
          role: "img",
          tabIndex: 0,
          "aria-label": s.name,
          className: HIT_CLASS,
          style: hitStyle({ left: INITIAL_MARGIN + i * stateStep, top: rowTop, width: NODE_W, height: NODE_H2 })
        }
      ) }, `hit-${s.name}`);
    }),
    effectList.map((et, i) => /* @__PURE__ */ jsx(
      EffectHit,
      {
        effectType: et,
        note: annotations?.effects?.[et],
        box: { left: EDGE + i * effectStep, top: effectTop, width: EFFECT_R * 2, height: EFFECT_R * 2 }
      },
      `hit-${et}`
    ))
  ] });
};
MiniStateMachine.displayName = "MiniStateMachine";
function toFieldKind(type) {
  const normalized = type.toLowerCase();
  if (["string", "number", "boolean", "date", "enum", "object", "array"].includes(normalized)) {
    return normalized;
  }
  return "string";
}
var PERSISTENCE_BORDER = {
  persistent: "border-l-[3px] border-l-primary border-solid",
  runtime: "border-l-[3px] border-l-primary border-dashed",
  singleton: "border-l-[3px] border-l-primary border-double",
  instance: "border-l-[3px] border-l-primary border-dotted"
};
var PERSISTENCE_ICON = {
  persistent: "\u26C1",
  // ⛁ cylinder
  runtime: "\u27F3",
  // ⟳ cycle
  singleton: "\u25CE",
  // ◎ double ring
  instance: "\u22A1"
  // ⊡ box
};
var ModuleCardInner = ({ data, annotations, ...rest }) => {
  const {
    orbitalName,
    entityName,
    persistence,
    fields,
    traits,
    pages,
    traitDetails,
    externalLinks
  } = data;
  const cols = Math.min(3, Math.max(2, Math.ceil(fields.length / 3)));
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...domPassthrough(rest),
      className: "rounded-lg border border-[var(--color-border)] bg-[var(--color-card)] shadow-sm overflow-hidden",
      style: { minWidth: 280, maxWidth: 400 },
      children: [
        /* @__PURE__ */ jsx(Handle, { type: "target", position: Position.Left, className: "!w-2.5 !h-2.5 !bg-warning" }),
        /* @__PURE__ */ jsx(Handle, { type: "source", position: Position.Right, className: "!w-2.5 !h-2.5 !bg-warning" }),
        /* @__PURE__ */ jsx("div", { className: "px-3 py-2 border-b border-[var(--color-border)]", children: /* @__PURE__ */ jsx("span", { className: "text-base font-bold text-[var(--color-foreground)]", children: orbitalName }) }),
        /* @__PURE__ */ jsxs("div", { className: `px-3 py-2 border-b border-[var(--color-border)] ${PERSISTENCE_BORDER[persistence] ?? ""}`, children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5 mb-1.5", children: [
            /* @__PURE__ */ jsx("svg", { width: 18, height: 18, viewBox: "0 0 20 20", children: /* @__PURE__ */ jsx(AvlEntity, { x: 10, y: 10, r: 8, persistence }) }),
            /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold text-[var(--color-foreground)]", children: entityName }),
            /* @__PURE__ */ jsx("span", { className: "ml-auto text-xs opacity-50", title: persistence, children: PERSISTENCE_ICON[persistence] ?? "" })
          ] }),
          fields.length > 0 && /* @__PURE__ */ jsx("div", { className: `grid gap-x-3 gap-y-0.5`, style: { gridTemplateColumns: `repeat(${cols}, 1fr)` }, children: fields.map((f3) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ jsx(AvlExplain, { lines: [f3.name, f3.type], children: /* @__PURE__ */ jsx(Box, { as: "span", role: "img", tabIndex: 0, "aria-label": `${f3.name}: ${f3.type}`, className: "inline-flex cursor-help rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-ring", children: /* @__PURE__ */ jsx("svg", { width: 14, height: 14, viewBox: "0 0 16 16", "aria-hidden": "true", children: /* @__PURE__ */ jsx(AvlFieldType, { x: 8, y: 8, kind: toFieldKind(f3.type), size: 6 }) }) }) }),
            /* @__PURE__ */ jsx("span", { className: "text-xs text-[var(--color-muted-foreground)] truncate", children: f3.name })
          ] }, f3.name)) })
        ] }),
        traits.map((trait) => {
          const detail = traitDetails[trait.name];
          const traitEmits = externalLinks.filter((l) => l.direction === "out" && l.traitName === trait.name);
          const traitListens = externalLinks.filter((l) => l.direction === "in" && l.traitName === trait.name);
          return /* @__PURE__ */ jsxs("div", { className: "px-3 py-2 border-b border-[var(--color-border)]", children: [
            /* @__PURE__ */ jsx("div", { className: "text-xs font-semibold text-[var(--color-foreground)] mb-1", children: trait.name }),
            detail && /* @__PURE__ */ jsx(MiniStateMachine, { data: detail, annotations: annotations?.[trait.name], className: "mb-1" }),
            (traitEmits.length > 0 || traitListens.length > 0) && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-[9px] mt-1", children: [
              traitListens.map((l) => /* @__PURE__ */ jsxs("span", { style: { color: CONNECTION_COLORS.emitListen.color }, children: [
                "\u25C0~~",
                " ",
                l.eventName
              ] }, l.eventName)),
              traitListens.length > 0 && traitEmits.length > 0 && /* @__PURE__ */ jsx("span", { className: "flex-1" }),
              traitEmits.map((l) => /* @__PURE__ */ jsxs("span", { style: { color: CONNECTION_COLORS.emitListen.color }, className: "ml-auto", children: [
                l.eventName,
                " ",
                "~~\u25B6"
              ] }, l.eventName))
            ] })
          ] }, trait.name);
        }),
        pages.length > 0 && /* @__PURE__ */ jsx("div", { className: "px-3 py-1.5 flex items-center gap-2 flex-wrap", children: pages.map((p) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-0.5", children: [
          /* @__PURE__ */ jsx("svg", { width: 10, height: 10, viewBox: "0 0 12 12", children: /* @__PURE__ */ jsx(AvlPage, { x: 6, y: 6, size: 5 }) }),
          /* @__PURE__ */ jsx("span", { className: "text-xs font-mono text-[var(--color-muted-foreground)]", children: p.route })
        ] }, p.name)) })
      ]
    }
  );
};
ModuleCardInner.displayName = "ModuleCardInner";
var ModuleCard = (props) => {
  const nodeId = useNodeId();
  if (nodeId !== null) return /* @__PURE__ */ jsx(ModuleCardInner, { ...props });
  return /* @__PURE__ */ jsx(ReactFlowProvider, { children: /* @__PURE__ */ jsx(ModuleCardInner, { ...props }) });
};
ModuleCard.displayName = "ModuleCard";
var Navigation = ({
  items,
  orientation = "horizontal",
  className,
  ...rest
}) => {
  const renderNavigationItem = (item, hasSubMenu) => {
    if (hasSubMenu) {
      const menuItems = item.subMenu.map((subItem) => ({
        id: subItem.id,
        label: subItem.label,
        icon: subItem.icon,
        badge: subItem.badge,
        disabled: subItem.disabled,
        onClick: subItem.onClick
      }));
      return /* @__PURE__ */ jsx(
        Menu,
        {
          trigger: /* @__PURE__ */ jsxs(
            Button,
            {
              variant: item.isActive ? "primary" : "ghost",
              size: "sm",
              icon: item.icon,
              disabled: item.disabled,
              "aria-current": item.isActive ? "page" : void 0,
              children: [
                item.label,
                item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: item.badge })
              ]
            }
          ),
          items: menuItems,
          position: orientation === "horizontal" ? "bottom-left" : "bottom-right"
        },
        item.id
      );
    }
    return /* @__PURE__ */ jsxs(
      Button,
      {
        variant: item.isActive ? "primary" : "ghost",
        size: "sm",
        icon: item.icon,
        href: item.href,
        onClick: item.onClick,
        disabled: item.disabled,
        "aria-current": item.isActive ? "page" : void 0,
        className: "relative",
        children: [
          item.label,
          item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", className: "absolute -top-1 -right-1", children: item.badge })
        ]
      },
      item.id
    );
  };
  return /* @__PURE__ */ jsx(
    Box,
    {
      as: "nav",
      ...domPassthrough(rest),
      className: cn(
        "flex",
        orientation === "horizontal" ? "flex-row items-center gap-1" : "flex-col gap-1",
        className
      ),
      children: items.map((item) => {
        const hasSubMenu = !!(item.subMenu && item.subMenu.length > 0);
        return renderNavigationItem(item, hasSubMenu);
      })
    }
  );
};
Navigation.displayName = "Navigation";
function useSafeEventBus6() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var sizeStyles11 = {
  sm: {
    button: "w-7 h-7",
    text: "text-sm min-w-[2rem]",
    icon: "w-3 h-3"
  },
  md: {
    button: "w-9 h-9",
    text: "text-base min-w-[2.5rem]",
    icon: "w-4 h-4"
  },
  lg: {
    button: "w-11 h-11",
    text: "text-lg min-w-[3rem]",
    icon: "w-5 h-5"
  }
};
var LONG_PRESS_DELAY = 400;
var LONG_PRESS_INTERVAL = 100;
var NumberStepper = ({
  value = 0,
  min,
  max,
  step = 1,
  size: size2 = "md",
  disabled = false,
  onChange,
  action,
  actionPayload,
  className,
  label,
  ...rest
}) => {
  const eventBus = useSafeEventBus6();
  const { t } = useTranslate();
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const isAtMin = min !== void 0 && value <= min;
  const isAtMax = max !== void 0 && value >= max;
  const styles = sizeStyles11[size2];
  const emitChange = useCallback(
    (newValue) => {
      const clamped = Math.round(newValue / step) * step;
      const finalValue = Math.max(min ?? -Infinity, Math.min(max ?? Infinity, clamped));
      onChange?.(finalValue);
      if (action) {
        eventBus.emit(`UI:${action}`, { ...actionPayload, value: finalValue });
      }
    },
    [onChange, action, actionPayload, eventBus, min, max, step]
  );
  const startLongPress = useCallback(
    (delta) => {
      timeoutRef.current = setTimeout(() => {
        intervalRef.current = setInterval(() => {
          emitChange(value + delta);
        }, LONG_PRESS_INTERVAL);
      }, LONG_PRESS_DELAY);
    },
    [emitChange, value]
  );
  const stopLongPress = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  useEffect(() => {
    return () => {
      stopLongPress();
    };
  }, [stopLongPress]);
  const handleDecrement = () => {
    if (!isAtMin) emitChange(value - step);
  };
  const handleIncrement = () => {
    if (!isAtMax) emitChange(value + step);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex items-center",
        "rounded-interactive",
        "border-[length:var(--border-width)] border-border",
        "bg-surface",
        disabled && "opacity-50 cursor-not-allowed",
        className
      ),
      role: "group",
      "aria-label": rest["aria-label"] ?? label ?? t("numberStepper.ariaLabel"),
      children: [
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: handleDecrement,
            onMouseDown: () => !isAtMin && startLongPress(-step),
            onMouseUp: stopLongPress,
            onMouseLeave: stopLongPress,
            onTouchStart: () => !isAtMin && startLongPress(-step),
            onTouchEnd: stopLongPress,
            disabled: disabled || isAtMin,
            className: cn(
              "inline-flex items-center justify-center",
              "rounded-l-interactive",
              "text-foreground",
              "hover:bg-muted",
              "active:bg-muted",
              "transition-colors duration-instant",
              "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
              "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
              styles.button
            ),
            "aria-label": t("aria.decrease"),
            children: /* @__PURE__ */ jsx(Icon, { name: "minus", className: styles.icon })
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: cn(
              "text-center font-medium tabular-nums",
              "text-foreground",
              "border-x-[length:var(--border-width)] border-border",
              "px-1 select-none",
              styles.text
            ),
            "aria-live": "polite",
            "aria-atomic": "true",
            children: value
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: handleIncrement,
            onMouseDown: () => !isAtMax && startLongPress(step),
            onMouseUp: stopLongPress,
            onMouseLeave: stopLongPress,
            onTouchStart: () => !isAtMax && startLongPress(step),
            onTouchEnd: stopLongPress,
            disabled: disabled || isAtMax,
            className: cn(
              "inline-flex items-center justify-center",
              "rounded-r-interactive",
              "text-foreground",
              "hover:bg-muted",
              "active:bg-muted",
              "transition-colors duration-instant",
              "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent",
              "focus:outline-none focus-visible:ring-[length:var(--focus-ring-width)] focus-visible:ring-ring focus-visible:ring-inset",
              styles.button
            ),
            "aria-label": t("aria.increase"),
            children: /* @__PURE__ */ jsx(Icon, { name: "plus", className: styles.icon })
          }
        )
      ]
    }
  );
};
NumberStepper.displayName = "NumberStepper";
var formatPriceDelta = (delta) => {
  const sign = delta >= 0 ? "+" : "-";
  return `${sign}$${Math.abs(delta).toFixed(2)}`;
};
var constraintHint = (constraint, t) => {
  if (constraint.type === "single") {
    return constraint.required ? t("optionConstraint.requiredOne") : t("optionConstraint.optionalOne");
  }
  const { min, max } = constraint;
  if (min && max) {
    return min === max ? t("optionConstraint.pickExactly", { count: min }) : t("optionConstraint.pickRange", { min, max });
  }
  if (min) return t("optionConstraint.pickAtLeast", { count: min });
  if (max) return t("optionConstraint.pickUpTo", { count: max });
  return t("optionConstraint.optional");
};
var validateSelection = (selected, constraint, t) => {
  if (constraint.type === "single") {
    if (constraint.required && selected.length === 0) {
      return t("optionConstraint.error.pickOne");
    }
    if (selected.length > 1) {
      return t("optionConstraint.error.pickOnlyOne");
    }
    return void 0;
  }
  const { min, max } = constraint;
  if (min !== void 0 && selected.length < min) {
    const remaining = min - selected.length;
    return t("optionConstraint.error.pickMore", { count: remaining });
  }
  if (max !== void 0 && selected.length > max) {
    const excess = selected.length - max;
    return t("optionConstraint.error.removeOptions", { count: excess });
  }
  return void 0;
};
var OptionConstraintGroup = ({
  groupId,
  title,
  description,
  options,
  constraint = { type: "single" },
  selected = [],
  onChange,
  changeEvent,
  size: size2 = "md",
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const hint = constraintHint(constraint, t);
  const error = validateSelection(selected, constraint, t);
  const inputName = `option-${groupId}`;
  const labelTextSize = size2 === "sm" ? "text-sm" : "text-base";
  const optionGap = size2 === "sm" ? "gap-2" : "gap-2.5";
  const emitChange = useCallback((next) => {
    onChange?.(next);
    if (changeEvent) {
      eventBus.emit(`UI:${changeEvent}`, { selected: next });
    }
  }, [onChange, changeEvent, eventBus]);
  const toggle = (optionId, checked) => {
    if (constraint.type === "single") {
      emitChange(checked ? [optionId] : []);
      return;
    }
    if (checked) {
      if (selected.includes(optionId)) return;
      emitChange([...selected, optionId]);
    } else {
      emitChange(selected.filter((id) => id !== optionId));
    }
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      as: "fieldset",
      className: cn("space-y-2", className),
      "aria-describedby": [rest["aria-describedby"], `${groupId}-hint`].filter(Boolean).join(" "),
      children: [
        /* @__PURE__ */ jsxs(Box, { className: "flex items-baseline justify-between gap-2", children: [
          /* @__PURE__ */ jsx(Typography, { as: "legend", variant: "label", weight: "semibold", children: title }),
          /* @__PURE__ */ jsx(
            Typography,
            {
              id: `${groupId}-hint`,
              variant: "caption",
              color: constraint.type === "single" && constraint.required ? "error" : "muted",
              children: hint
            }
          )
        ] }),
        description && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: description }),
        /* @__PURE__ */ jsx(Box, { className: cn("flex flex-col", optionGap), children: options.map((option) => {
          const isChecked = selected.includes(option.id);
          const isDisabled = option.disabled || option.outOfStock;
          const optionId = `${inputName}-${option.id}`;
          return /* @__PURE__ */ jsxs(
            Label,
            {
              htmlFor: optionId,
              className: cn(
                "flex items-center gap-2.5 cursor-pointer select-none font-normal",
                isDisabled && "cursor-not-allowed opacity-60"
              ),
              children: [
                constraint.type === "single" ? /* @__PURE__ */ jsx(
                  Radio,
                  {
                    id: optionId,
                    name: inputName,
                    value: option.id,
                    checked: isChecked,
                    disabled: isDisabled,
                    onChange: (e) => toggle(option.id, e.target.checked),
                    className: "h-4 w-4 accent-primary",
                    "aria-invalid": !!error
                  }
                ) : /* @__PURE__ */ jsx(
                  Checkbox,
                  {
                    id: optionId,
                    name: inputName,
                    value: option.id,
                    checked: isChecked,
                    disabled: isDisabled,
                    onChange: (e) => toggle(option.id, e.target.checked),
                    className: "h-4 w-4 accent-primary",
                    "aria-invalid": !!error
                  }
                ),
                /* @__PURE__ */ jsx(
                  Typography,
                  {
                    as: "span",
                    className: cn(
                      "flex-1",
                      labelTextSize,
                      "text-foreground",
                      option.outOfStock && "line-through"
                    ),
                    children: option.label
                  }
                ),
                option.priceDelta !== void 0 && option.priceDelta !== 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatPriceDelta(option.priceDelta) }),
                option.outOfStock && /* @__PURE__ */ jsx(
                  Typography,
                  {
                    variant: "caption",
                    color: "warning",
                    className: "rounded-interactive border border-warning/40 px-1.5 py-0.5",
                    children: t("optionConstraint.outOfStock")
                  }
                )
              ]
            },
            option.id
          );
        }) }),
        error && /* @__PURE__ */ jsx(Box, { role: "alert", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "error", children: error }) })
      ]
    }
  );
};
OptionConstraintGroup.displayName = "OptionConstraintGroup";
var ORBITAL_CONFIGS = {
  "1s": {
    type: "1s",
    name: "1s Orbital",
    color: "var(--color-series-1)",
    glowColor: "color-mix(in srgb, var(--color-series-1) 30%, transparent)",
    lobes: 1,
    hasNode: false,
    scale: 0.6
  },
  "2s": {
    type: "2s",
    name: "2s Orbital",
    color: "var(--color-series-2)",
    glowColor: "color-mix(in srgb, var(--color-series-2) 30%, transparent)",
    lobes: 1,
    hasNode: false,
    scale: 0.8
  },
  "2p": {
    type: "2p",
    name: "2p Orbital",
    color: "var(--color-series-3)",
    glowColor: "color-mix(in srgb, var(--color-series-3) 30%, transparent)",
    lobes: 2,
    hasNode: false,
    scale: 1
  },
  "3s": {
    type: "3s",
    name: "3s Orbital",
    color: "var(--color-series-4)",
    glowColor: "color-mix(in srgb, var(--color-series-4) 30%, transparent)",
    lobes: 1,
    hasNode: true,
    scale: 1
  },
  "3p": {
    type: "3p",
    name: "3p Orbital",
    color: "var(--color-series-5)",
    glowColor: "color-mix(in srgb, var(--color-series-5) 30%, transparent)",
    lobes: 2,
    hasNode: true,
    scale: 1.1
  },
  "3d": {
    type: "3d",
    name: "3d Orbital",
    color: "var(--color-series-6)",
    glowColor: "color-mix(in srgb, var(--color-series-6) 30%, transparent)",
    lobes: 4,
    hasNode: true,
    scale: 1.2
  },
  "4f": {
    type: "4f",
    name: "4f Orbital",
    color: "var(--color-series-7)",
    glowColor: "color-mix(in srgb, var(--color-series-7) 30%, transparent)",
    lobes: 6,
    hasNode: true,
    scale: 1.3
  }
};
var SIZE_MAP = {
  sm: 120,
  md: 200,
  lg: 300,
  xl: 400
};
function calculateComplexity(schema) {
  if (!schema) return 1;
  const entities = schema.dataEntities || 0;
  const pages = schema.ui?.pages?.length || 0;
  const traits = schema.traits || 0;
  const sections = schema.ui?.pages?.reduce(
    (acc, page) => acc + (page.sections || 0),
    0
  ) || 0;
  return entities * 3 + pages * 2 + traits * 2 + sections * 1;
}
function getOrbitalType(complexity) {
  if (complexity <= 3) return "1s";
  if (complexity <= 8) return "2s";
  if (complexity <= 15) return "2p";
  if (complexity <= 25) return "3s";
  if (complexity <= 40) return "3p";
  if (complexity <= 60) return "3d";
  return "4f";
}
var OrbitalSphere = ({
  config,
  size: size2,
  animated
}) => {
  const sphereSize = size2 * config.scale * 0.4;
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: "absolute rounded-full",
      style: {
        width: sphereSize,
        height: sphereSize,
        background: `radial-gradient(circle at 30% 30%, color-mix(in srgb, ${config.color} 87%, transparent), color-mix(in srgb, ${config.color} 53%, transparent) 50%, color-mix(in srgb, ${config.color} 27%, transparent) 100%)`,
        boxShadow: `
          inset -10px -10px 20px color-mix(in srgb, var(--color-foreground) 30%, transparent),
          inset 5px 5px 15px color-mix(in srgb, var(--surface-diagram) 20%, transparent),
          0 0 ${size2 * 0.15}px ${config.glowColor},
          0 0 ${size2 * 0.3}px ${config.glowColor}
        `,
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        animation: animated ? "orbital-pulse 3s ease-in-out infinite" : void 0
      }
    }
  );
};
var DumbbellOrbital = ({
  config,
  size: size2,
  animated,
  rotation = 0
}) => {
  const lobeSize = size2 * config.scale * 0.25;
  const offset = size2 * 0.18;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: "absolute",
      style: {
        width: size2,
        height: size2,
        left: "50%",
        top: "50%",
        transform: `translate(-50%, -50%) rotate(${rotation}deg)`,
        animation: animated ? "orbital-rotate 8s linear infinite" : void 0
      },
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute rounded-full",
            style: {
              width: lobeSize,
              height: lobeSize * 1.4,
              background: `radial-gradient(ellipse at 50% 30%, color-mix(in srgb, ${config.color} 87%, transparent), color-mix(in srgb, ${config.color} 40%, transparent) 70%, transparent 100%)`,
              boxShadow: `0 0 ${size2 * 0.1}px ${config.glowColor}`,
              left: "50%",
              top: `calc(50% - ${offset}px)`,
              transform: "translate(-50%, -100%)",
              borderRadius: "50% 50% 40% 40%"
            }
          }
        ),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute rounded-full",
            style: {
              width: lobeSize,
              height: lobeSize * 1.4,
              background: `radial-gradient(ellipse at 50% 70%, color-mix(in srgb, ${config.color} 87%, transparent), color-mix(in srgb, ${config.color} 40%, transparent) 70%, transparent 100%)`,
              boxShadow: `0 0 ${size2 * 0.1}px ${config.glowColor}`,
              left: "50%",
              bottom: `calc(50% - ${offset}px)`,
              transform: "translate(-50%, 100%)",
              borderRadius: "40% 40% 50% 50%"
            }
          }
        ),
        config.hasNode && /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute rounded-full bg-foreground",
            style: {
              width: size2 * 0.06,
              height: size2 * 0.06,
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: `0 0 ${size2 * 0.05}px color-mix(in srgb, var(--surface-diagram) 80%, transparent)`
            }
          }
        )
      ]
    }
  );
};
var CloverleafOrbital = ({
  config,
  size: size2,
  animated
}) => {
  const lobes = config.lobes;
  const angleStep = 360 / lobes;
  const lobeSize = size2 * 0.18;
  const lobeDistance = size2 * 0.22;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: "absolute",
      style: {
        width: size2,
        height: size2,
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        animation: animated ? "orbital-rotate 12s linear infinite" : void 0
      },
      children: [
        Array.from({ length: lobes }).map((_, i) => {
          const angle = i * angleStep * (Math.PI / 180);
          const x = Math.cos(angle) * lobeDistance;
          const y = Math.sin(angle) * lobeDistance;
          return /* @__PURE__ */ jsx(
            Box,
            {
              className: "absolute rounded-full",
              style: {
                width: lobeSize,
                height: lobeSize * 1.3,
                background: `radial-gradient(ellipse at 50% 40%, color-mix(in srgb, ${config.color} 87%, transparent), color-mix(in srgb, ${config.color} 33%, transparent) 80%, transparent 100%)`,
                boxShadow: `0 0 ${size2 * 0.08}px ${config.glowColor}`,
                left: `calc(50% + ${x}px)`,
                top: `calc(50% + ${y}px)`,
                transform: `translate(-50%, -50%) rotate(${i * angleStep + 90}deg)`
              }
            },
            i
          );
        }),
        /* @__PURE__ */ jsx(
          Box,
          {
            className: "absolute rounded-full bg-foreground",
            style: {
              width: size2 * 0.08,
              height: size2 * 0.08,
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
              boxShadow: `0 0 ${size2 * 0.06}px color-mix(in srgb, var(--surface-diagram) 90%, transparent)`
            }
          }
        )
      ]
    }
  );
};
var OrbitalVisualization = ({
  schema,
  complexity: overrideComplexity,
  size: size2 = "md",
  showLabel = true,
  animated = true,
  onClick,
  className = "",
  ...rest
}) => {
  const complexity = useMemo(() => {
    if (overrideComplexity !== void 0) return overrideComplexity;
    return calculateComplexity(schema);
  }, [schema, overrideComplexity]);
  const orbitalType = useMemo(() => getOrbitalType(complexity), [complexity]);
  const config = ORBITAL_CONFIGS[orbitalType];
  const pixelSize = SIZE_MAP[size2];
  const renderOrbital = () => {
    switch (config.lobes) {
      case 1:
        return /* @__PURE__ */ jsx(OrbitalSphere, { config, size: pixelSize, animated });
      case 2:
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            DumbbellOrbital,
            {
              config,
              size: pixelSize,
              animated,
              rotation: 0
            }
          ),
          config.hasNode && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              DumbbellOrbital,
              {
                config,
                size: pixelSize * 0.7,
                animated,
                rotation: 60
              }
            ),
            /* @__PURE__ */ jsx(
              DumbbellOrbital,
              {
                config,
                size: pixelSize * 0.7,
                animated,
                rotation: 120
              }
            )
          ] })
        ] });
      case 4:
      case 6:
        return /* @__PURE__ */ jsx(
          CloverleafOrbital,
          {
            config,
            size: pixelSize,
            animated
          }
        );
      default:
        return /* @__PURE__ */ jsx(OrbitalSphere, { config, size: pixelSize, animated });
    }
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      className: cn("relative flex flex-col items-center justify-center", className),
      style: { width: pixelSize, height: pixelSize + (showLabel ? 60 : 0) },
      onClick,
      role: onClick ? "button" : rest.role,
      tabIndex: onClick ? 0 : rest.tabIndex,
      children: [
        /* @__PURE__ */ jsxs(
          Box,
          {
            className: "relative",
            style: {
              width: pixelSize,
              height: pixelSize,
              perspective: pixelSize * 2,
              cursor: onClick ? "pointer" : "default"
            },
            children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  className: "absolute rounded-full opacity-30",
                  style: {
                    width: pixelSize * 0.8,
                    height: pixelSize * 0.8,
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    background: `radial-gradient(circle, ${config.glowColor} 0%, transparent 70%)`,
                    filter: "blur(20px)"
                  }
                }
              ),
              renderOrbital()
            ]
          }
        ),
        showLabel && /* @__PURE__ */ jsxs(Box, { className: "mt-4 text-center", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "body", className: "text-lg font-semibold text-foreground", children: config.name }),
          /* @__PURE__ */ jsxs(Typography, { variant: "small", color: "muted", children: [
            "Complexity: ",
            complexity,
            " units"
          ] })
        ] }),
        /* @__PURE__ */ jsx("style", { children: `
        @keyframes orbital-pulse {
          0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
          50% { transform: translate(-50%, -50%) scale(1.05); opacity: 0.9; }
        }

        @keyframes orbital-rotate {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }
      ` })
      ]
    }
  );
};
OrbitalVisualization.displayName = "OrbitalVisualization";
var MAX_VISIBLE_ACTIONS = 2;
var PageHeader = ({
  title,
  icon,
  subtitle,
  showBack = false,
  backEvent = "BACK",
  breadcrumbs,
  status,
  actions,
  isLoading,
  tabs,
  activeTab,
  onTabChange,
  children,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const statusBadge = typeof status === "string" ? status ? { label: status } : void 0 : status;
  const handleBack = () => {
    eventBus.emit(`UI:${backEvent}`);
  };
  const createActionHandler = (action) => () => {
    if (action.event) {
      eventBus.emit(`UI:${action.event}`);
    }
    if (action.navigatesTo) {
      eventBus.emit("UI:NAVIGATE", { url: action.navigatesTo });
    }
    if (action.onClick) {
      action.onClick();
    }
  };
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("w-full min-w-0", className), children: [
    breadcrumbs && breadcrumbs.length > 0 && /* @__PURE__ */ jsx(Breadcrumb, { items: breadcrumbs.map((crumb) => ({ label: crumb.label, href: crumb.href })), className: "mb-4" }),
    /* @__PURE__ */ jsxs(Box, { className: "flex flex-wrap items-start justify-between gap-x-4 gap-y-3", children: [
      /* @__PURE__ */ jsxs(Box, { className: "flex items-start gap-4 min-w-0", children: [
        showBack && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            onClick: handleBack,
            icon: "arrow-left",
            "aria-label": t("common.back"),
            className: "mt-1 p-2 rtl:-scale-x-100"
          }
        ),
        /* @__PURE__ */ jsxs(Box, { className: "min-w-0", children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-3", children: [
            icon && (typeof icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: icon, size: "lg", className: "shrink-0 text-muted-foreground" }) : /* @__PURE__ */ jsx(Icon, { icon, size: "lg", className: "shrink-0 text-muted-foreground" })),
            /* @__PURE__ */ jsx(Typography, { variant: "h1", className: "text-2xl text-foreground", children: title != null ? String(title) : "" }),
            statusBadge && /* @__PURE__ */ jsx(Badge, { variant: statusBadge.variant || "default", size: "sm", children: statusBadge.label })
          ] }),
          subtitle != null && subtitle !== "" && /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", className: "mt-1 text-sm", children: String(subtitle) })
        ] })
      ] }),
      actions && actions.length > 0 && /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-2 shrink-0", children: [
        actions.slice(0, MAX_VISIBLE_ACTIONS).map((action, idx) => /* @__PURE__ */ jsx(
          Button,
          {
            "data-event": action.event,
            "data-testid": action.event ? actionTestId(action.event) : void 0,
            variant: action.variant || (idx === 0 ? "primary" : "secondary"),
            leftIcon: action.icon || void 0,
            onClick: createActionHandler(action),
            isLoading: action.loading || isLoading,
            disabled: action.disabled,
            className: idx > 0 ? "hidden sm:inline-flex" : void 0,
            children: action.label
          },
          `action-${idx}`
        )),
        actions.length > 1 && /* @__PURE__ */ jsx(Box, { className: "sm:hidden", children: /* @__PURE__ */ jsx(
          Menu,
          {
            position: "bottom-end",
            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "page-header-overflow-compact", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "sm" }) }),
            items: actions.slice(1).map((action) => ({
              label: action.label,
              icon: action.icon,
              disabled: action.disabled || isLoading,
              variant: action.variant === "danger" ? "danger" : "default",
              onClick: createActionHandler(action)
            }))
          }
        ) }),
        actions.length > MAX_VISIBLE_ACTIONS && /* @__PURE__ */ jsx(Box, { className: "hidden sm:block", children: /* @__PURE__ */ jsx(
          Menu,
          {
            position: "bottom-end",
            trigger: /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", "aria-label": t("common.actions"), "data-testid": "page-header-overflow", children: /* @__PURE__ */ jsx(Icon, { name: "more-horizontal", size: "sm" }) }),
            items: actions.slice(MAX_VISIBLE_ACTIONS).map((action) => ({
              label: action.label,
              icon: action.icon,
              disabled: action.disabled || isLoading,
              variant: action.variant === "danger" ? "danger" : "default",
              onClick: createActionHandler(action)
            }))
          }
        ) })
      ] })
    ] }),
    tabs && tabs.length > 0 && /* @__PURE__ */ jsx(
      Tabs,
      {
        items: tabs.map((tab) => ({ id: tab.value, label: tab.label, badge: tab.count })),
        activeTab,
        onTabChange,
        variant: "underline",
        className: "mt-6"
      }
    ),
    children
  ] });
};
PageHeader.displayName = "PageHeader";
var Pagination = ({
  currentPage,
  totalPages,
  onPageChange = () => {
  },
  showPageSize = false,
  pageSizeOptions = [10, 20, 50, 100],
  pageSize,
  onPageSizeChange,
  showJumpToPage = false,
  showTotal = false,
  totalItems,
  maxVisiblePages = 7,
  className,
  pageChangeEvent,
  pageSizeChangeEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [jumpToPage, setJumpToPage] = useState("");
  const handlePageChange = (page) => {
    if (pageChangeEvent) eventBus.emit(`UI:${pageChangeEvent}`, { page });
    onPageChange(page);
  };
  const handlePageSizeChange = (size2) => {
    if (pageSizeChangeEvent) eventBus.emit(`UI:${pageSizeChangeEvent}`, { pageSize: size2 });
    onPageSizeChange?.(size2);
  };
  const handleJumpToPage = () => {
    const page = parseInt(jumpToPage, 10);
    if (page >= 1 && page <= totalPages) {
      handlePageChange(page);
      setJumpToPage("");
    }
  };
  const getPageNumbers = () => {
    const pages = [];
    const halfVisible = Math.floor(maxVisiblePages / 2);
    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= halfVisible + 1) {
        for (let i = 1; i <= maxVisiblePages - 2; i++) {
          pages.push(i);
        }
        pages.push("ellipsis");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - halfVisible) {
        pages.push(1);
        pages.push("ellipsis");
        for (let i = totalPages - maxVisiblePages + 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push("ellipsis");
        for (let i = currentPage - halfVisible + 2; i <= currentPage + halfVisible - 2; i++) {
          pages.push(i);
        }
        pages.push("ellipsis");
        pages.push(totalPages);
      }
    }
    return pages;
  };
  const pageNumbers = getPageNumbers();
  return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), as: "nav", "aria-label": rest["aria-label"] ?? t("pagination.label"), className: cn("@container w-full", className), children: /* @__PURE__ */ jsxs(HStack, { align: "center", className: "flex-wrap justify-between gap-x-4 gap-y-2", children: [
    /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", className: "flex-wrap", children: [
      showTotal && totalItems !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "small", color: "secondary", children: [
        t("pagination.total"),
        " ",
        totalItems
      ] }),
      showPageSize && pageSize && onPageSizeChange && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: t("pagination.show") }),
        /* @__PURE__ */ jsx(
          Select,
          {
            value: String(pageSize),
            onValueChange: (v) => handlePageSizeChange(Number(v)),
            options: pageSizeOptions.map((size2) => ({
              value: String(size2),
              label: String(size2)
            })),
            className: "px-2 py-1 text-sm"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "sm",
          onClick: () => handlePageChange(currentPage - 1),
          disabled: currentPage === 1,
          icon: "chevron-left",
          "aria-label": t("pagination.previous"),
          children: /* @__PURE__ */ jsx(Box, { as: "span", className: "hidden @md:inline", children: t("pagination.previous") })
        }
      ),
      /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", className: "px-2 tabular-nums @md:hidden", children: t("pagination.pageOf", { page: currentPage, total: totalPages }) }),
      /* @__PURE__ */ jsx(HStack, { align: "center", gap: "xs", className: "hidden @md:flex", children: pageNumbers.map((page, index) => {
        if (page === "ellipsis") {
          return /* @__PURE__ */ jsx(Typography, { variant: "small", color: "muted", "aria-hidden": "true", className: "px-2", children: "\u2026" }, `ellipsis-${index}`);
        }
        const isActive = page === currentPage;
        return /* @__PURE__ */ jsx(
          Button,
          {
            variant: isActive ? "primary" : "ghost",
            size: "sm",
            onClick: () => handlePageChange(page),
            "aria-current": isActive ? "page" : void 0,
            className: "min-w-[2.5rem] tabular-nums",
            children: page
          },
          page
        );
      }) }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "secondary",
          size: "sm",
          onClick: () => handlePageChange(currentPage + 1),
          disabled: currentPage === totalPages,
          iconRight: "chevron-right",
          "aria-label": t("pagination.next"),
          children: /* @__PURE__ */ jsx(Box, { as: "span", className: "hidden @md:inline", children: t("pagination.next") })
        }
      )
    ] }),
    showJumpToPage && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "sm", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: t("pagination.goTo") }),
      /* @__PURE__ */ jsx(
        Input,
        {
          type: "number",
          value: jumpToPage,
          onChange: (e) => setJumpToPage(e.target.value),
          placeholder: t("pagination.jumpPlaceholder"),
          className: "w-20",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              handleJumpToPage();
            }
          }
        }
      ),
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: handleJumpToPage, children: t("pagination.go") })
    ] })
  ] }) });
};
Pagination.displayName = "Pagination";
var physicsLog = createLogger("almadar:ui:physics-canvas");
var SERIES_TONES3 = ["series-1", "series-2", "series-3", "series-4", "series-5", "series-6", "series-7", "series-8"];
function seriesTone3(i) {
  return SERIES_TONES3[i % SERIES_TONES3.length];
}
function formatMeterValue(v) {
  return Number.isInteger(v) ? String(v) : String(Number(v.toFixed(2)));
}
function sceneObjectShapes(obj, canvasWidth, canvasHeight) {
  const out = [];
  const color = obj.color ?? "ink";
  switch (obj.kind) {
    case "ground": {
      const xStart = obj.x1 ?? 0;
      const xEnd = obj.x2 ?? canvasWidth;
      const y = obj.y ?? 0;
      out.push({ type: "line", x1: xStart, y1: y, x2: xEnd, y2: y, color, stroke: "normal" });
      for (let hx = xStart + 7; hx <= xEnd; hx += 14) {
        out.push({ type: "line", x1: hx, y1: y, x2: hx - 7, y2: y + 7, color, stroke: "thin" });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x: (xStart + xEnd) / 2,
          y: y - 10,
          text: obj.label,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      break;
    }
    case "wall": {
      const yStart = obj.y1 ?? 0;
      const yEnd = obj.y2 ?? canvasHeight;
      const x = obj.x ?? 0;
      out.push({ type: "line", x1: x, y1: yStart, x2: x, y2: yEnd, color, stroke: "normal" });
      for (let hy = yStart + 7; hy <= yEnd; hy += 14) {
        out.push({ type: "line", x1: x, y1: hy, x2: x - 7, y2: hy + 7, color, stroke: "thin" });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x: x + 12,
          y: (yStart + yEnd) / 2,
          text: obj.label,
          tone: "label",
          textSize: "sm",
          align: "left"
        });
      }
      break;
    }
    case "ramp": {
      const x1 = obj.x1 ?? 0;
      const y1 = obj.y1 ?? 0;
      const x2 = obj.x2 ?? canvasWidth;
      const y2 = obj.y2 ?? canvasHeight;
      out.push({
        type: "polygon",
        points: [
          { x: x1, y: y1 },
          { x: x2, y: y2 },
          { x: x1, y: y2 }
        ],
        color,
        fill: obj.fill ?? "fill",
        stroke: "normal"
      });
      if (obj.label) {
        out.push({
          type: "text",
          x: (2 * x1 + x2) / 3,
          y: (y1 + 2 * y2) / 3,
          text: obj.label,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      break;
    }
    case "box": {
      const x = obj.x ?? 0;
      const y = obj.y ?? 0;
      const w = obj.width ?? 40;
      const h = obj.height ?? 40;
      out.push({ type: "rect", x, y, width: w, height: h, color, fill: obj.fill, stroke: "normal" });
      if (obj.label) {
        out.push({
          type: "text",
          x: x + w / 2,
          y: y + h / 2,
          text: obj.label,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      break;
    }
    case "pivot": {
      const x = obj.x ?? 0;
      const y = obj.y ?? 0;
      out.push({ type: "circle", x, y, radius: 5, color, fill: color, fillStyle: "solid" });
      out.push({ type: "line", x1: x - 14, y1: y - 8, x2: x + 14, y2: y - 8, color, stroke: "thin" });
      for (let k = 0; k < 5; k++) {
        const hx = x - 14 + 7 * k;
        out.push({ type: "line", x1: hx, y1: y - 8, x2: hx - 6, y2: y - 14, color, stroke: "thin" });
      }
      if (obj.label) {
        out.push({
          type: "text",
          x,
          y: y - 30,
          text: obj.label,
          tone: "label",
          textSize: "sm",
          align: "center"
        });
      }
      break;
    }
  }
  return out;
}
function trailShapes(trail) {
  const n = trail.points.length;
  if (n < 2) return [];
  const color = trail.color ?? "guide";
  const fade = trail.fade ?? true;
  const globalOpacity = trail.opacity ?? 1;
  const out = [];
  for (let i = 0; i < n - 1; i++) {
    const a = trail.points[i];
    const b = trail.points[i + 1];
    const segmentOpacity = fade ? 0.12 + 0.68 * i / (n - 1) : 0.6;
    out.push({
      type: "line",
      x1: a.x,
      y1: a.y,
      x2: b.x,
      y2: b.y,
      color,
      lineWidth: trail.width,
      stroke: "normal",
      opacity: segmentOpacity * globalOpacity
    });
  }
  return out;
}
function constraintShapes(c, a, b) {
  const color = c.color ?? "ink";
  const kind = c.kind ?? "rod";
  if (kind === "rod") {
    return [{ type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y, color, stroke: "normal" }];
  }
  if (kind === "string") {
    return [{ type: "line", x1: a.x, y1: a.y, x2: b.x, y2: b.y, color, stroke: "normal", dash: "dashed" }];
  }
  const COILS = 8;
  const AMP = 7;
  const LEAD = 10;
  const dx = b.x - a.x;
  const dy = b.y - a.y;
  const dist = Math.max(1e-6, Math.hypot(dx, dy));
  const ux = dx / dist;
  const uy = dy / dist;
  const perpX = -uy;
  const perpY = ux;
  const aPrime = { x: a.x + LEAD * ux, y: a.y + LEAD * uy };
  const bPrime = { x: b.x - LEAD * ux, y: b.y - LEAD * uy };
  const m = 2 * COILS;
  const polyline = [{ x: a.x, y: a.y }, aPrime];
  for (let j = 1; j <= m; j++) {
    const t = j / (m + 1);
    const baseX = aPrime.x + t * (bPrime.x - aPrime.x);
    const baseY = aPrime.y + t * (bPrime.y - aPrime.y);
    const sign = j % 2 === 0 ? 1 : -1;
    polyline.push({ x: baseX + sign * AMP * perpX, y: baseY + sign * AMP * perpY });
  }
  polyline.push(bPrime, { x: b.x, y: b.y });
  const out = [];
  for (let i = 1; i < polyline.length; i++) {
    out.push({
      type: "line",
      x1: polyline[i - 1].x,
      y1: polyline[i - 1].y,
      x2: polyline[i].x,
      y2: polyline[i].y,
      color,
      stroke: "normal"
    });
  }
  return out;
}
function vectorShapes(v, bodyById) {
  let ax;
  let ay;
  let anchorRadius = 0;
  if (v.body) {
    const anchor = bodyById.get(v.body);
    if (!anchor) return [];
    ax = anchor.x;
    ay = anchor.y;
    anchorRadius = anchor.radius ?? 12;
  } else {
    ax = v.x ?? 0;
    ay = v.y ?? 0;
  }
  const scale = v.scale ?? 1;
  const color = v.color ?? "series-5";
  const tx = ax + v.dx * scale;
  const ty = ay + v.dy * scale;
  const out = [{ type: "arrow", x1: ax, y1: ay, x2: tx, y2: ty, color, stroke: "bold", dash: v.dash }];
  if (v.label) {
    const len = Math.hypot(tx - ax, ty - ay);
    const ux = len > 1e-6 ? (tx - ax) / len : 0;
    const uy = len > 1e-6 ? (ty - ay) / len : -1;
    const reach = Math.max(len, anchorRadius) + 8;
    out.push({
      type: "text",
      x: ax + reach * ux,
      y: ay + reach * uy,
      text: v.label,
      textCase: "verbatim",
      color,
      textSize: "sm",
      align: "center"
    });
  }
  return out;
}
function angleMarkerShapes(a) {
  const radius = a.radius ?? 26;
  const color = a.color ?? "series-4";
  const out = [
    {
      type: "ellipse",
      x: a.x,
      y: a.y,
      width: radius * 2,
      height: radius * 2,
      startAngle: a.from,
      endAngle: a.to,
      color,
      stroke: "normal"
    }
  ];
  if (a.label) {
    const mid = (a.from + a.to) / 2 * (Math.PI / 180);
    out.push({
      type: "text",
      x: a.x + (radius + 13) * Math.cos(mid),
      y: a.y + (radius + 13) * Math.sin(mid),
      text: a.label,
      textCase: "verbatim",
      color,
      textSize: "sm",
      align: "center"
    });
  }
  return out;
}
function fieldShapes(field, canvasWidth, canvasHeight) {
  const spacing = field.spacing ?? 48;
  const size2 = field.size ?? 14;
  const color = field.color ?? "guide";
  const regionX = field.x ?? 0;
  const regionY = field.y ?? 0;
  const regionW = field.width ?? canvasWidth;
  const regionH = field.height ?? canvasHeight;
  const out = [];
  for (let gx = regionX + spacing / 2; gx < regionX + regionW; gx += spacing) {
    for (let gy = regionY + spacing / 2; gy < regionY + regionH; gy += spacing) {
      if (field.kind === "arrows") {
        const rad = (field.angle ?? 0) * Math.PI / 180;
        const hx = Math.cos(rad) * size2 / 2;
        const hy = Math.sin(rad) * size2 / 2;
        out.push({ type: "arrow", x1: gx - hx, y1: gy - hy, x2: gx + hx, y2: gy + hy, color, stroke: "normal" });
      } else if (field.kind === "into") {
        const r = size2 / 3;
        const d = 0.6 * r * Math.SQRT1_2;
        out.push({ type: "circle", x: gx, y: gy, radius: r, color });
        out.push({ type: "line", x1: gx - d, y1: gy - d, x2: gx + d, y2: gy + d, color, stroke: "thin" });
        out.push({ type: "line", x1: gx - d, y1: gy + d, x2: gx + d, y2: gy - d, color, stroke: "thin" });
      } else {
        const r = size2 / 3;
        out.push({ type: "circle", x: gx, y: gy, radius: r, color });
        out.push({ type: "circle", x: gx, y: gy, radius: 1.5, color, fill: color, fillStyle: "solid" });
      }
    }
  }
  return out;
}
function meterShapes(meters, canvasHeight) {
  const n = meters.length;
  const out = [];
  const sharedMax = Math.max(1e-6, ...meters.map((m) => m.value));
  meters.forEach((meter, i) => {
    const rowY = canvasHeight - 10 - 16 * (n - i);
    const color = meter.color ?? seriesTone3(i);
    const M = meter.max ?? sharedMax;
    const w = Math.round(Math.min(1, Math.max(0, meter.value / M)) * 110);
    out.push({ type: "text", x: 8, y: rowY + 8, text: meter.label, tone: "label", textSize: "xs" });
    out.push({ type: "rect", x: 52, y: rowY, width: w, height: 10, color, fill: color, fillStyle: "solid" });
    out.push({
      type: "text",
      x: 166,
      y: rowY + 8,
      text: formatMeterValue(meter.value),
      tone: "label",
      textSize: "xs"
    });
  });
  return out;
}
var PhysicsCanvas = ({
  className,
  width = 600,
  height = 400,
  title,
  backgroundColor,
  series,
  keyMap,
  keyUpMap,
  mode = "2d",
  camera,
  lighting,
  post,
  bodies = [],
  constraints = [],
  showVelocity = true,
  showForces = false,
  velocityScale = 20,
  forceScale = 20,
  sceneObjects = [],
  trails = [],
  vectors = [],
  surface3d,
  vectors3d = [],
  vectorScale = 1,
  angles = [],
  field,
  meters = [],
  shapes = [],
  readouts,
  traces,
  showGrid,
  shadows,
  interactive,
  animate = false,
  onShapeClick,
  isLoading,
  error,
  ...rest
}) => {
  const derivedShapes = useMemo(() => {
    const out = [];
    const bodyById = /* @__PURE__ */ new Map();
    for (const b of bodies) {
      if (b.id) bodyById.set(b.id, b);
    }
    if (field) out.push(...fieldShapes(field, width, height));
    for (const obj of sceneObjects) out.push(...sceneObjectShapes(obj, width, height));
    for (const trail of trails) out.push(...trailShapes(trail));
    for (const c of constraints) {
      const a = bodyById.get(c.from);
      const b = bodyById.get(c.to);
      if (!a || !b) continue;
      out.push(...constraintShapes(c, a, b));
    }
    bodies.forEach((b, bi) => {
      const bodyColor = b.color ?? seriesTone3(bi);
      out.push({
        type: "circle",
        x: b.x,
        y: b.y,
        radius: b.radius ?? 12,
        color: bodyColor,
        fill: bodyColor,
        fillStyle: "solid",
        id: b.id
      });
      if (b.label) {
        out.push({
          type: "text",
          x: b.x + (b.radius ?? 12) + 6,
          y: b.y - (b.radius ?? 12) - 6,
          text: b.label,
          tone: "ink",
          textSize: "sm"
        });
      }
      if (showVelocity && b.vx != null && b.vy != null && (b.vx !== 0 || b.vy !== 0)) {
        out.push({
          type: "arrow",
          x1: b.x,
          y1: b.y,
          x2: b.x + b.vx * velocityScale,
          y2: b.y + b.vy * velocityScale,
          color: "series-3",
          stroke: "bold"
        });
      }
      if (showForces && b.fx != null && b.fy != null && (b.fx !== 0 || b.fy !== 0)) {
        out.push({
          type: "arrow",
          x1: b.x,
          y1: b.y,
          x2: b.x + b.fx * forceScale,
          y2: b.y + b.fy * forceScale,
          color: "series-5",
          stroke: "bold"
        });
      }
    });
    for (const v of vectors) out.push(...vectorShapes(v, bodyById));
    for (const a of angles) out.push(...angleMarkerShapes(a));
    if (meters.length > 0) out.push(...meterShapes(meters, height));
    out.push(...shapes);
    return out;
  }, [
    bodies,
    constraints,
    showVelocity,
    showForces,
    velocityScale,
    forceScale,
    sceneObjects,
    trails,
    vectors,
    angles,
    field,
    meters,
    shapes,
    width,
    height
  ]);
  const drawables3D = useMemo(() => {
    if (mode !== "3d") return [];
    const tone3d = (value, fallback) => value ?? fallback;
    if (shapes.length > 0) {
      physicsLog.debug("shapes ignored in 3D mode (pixel-authored 2D vocabulary)", { count: shapes.length });
    }
    if (sceneObjects.length > 0) {
      physicsLog.debug("sceneObjects ignored in 3D mode (pixel-authored 2D vocabulary)", { count: sceneObjects.length });
    }
    if (vectors.length > 0) {
      physicsLog.debug("vectors ignored in 3D mode (pixel-authored 2D vocabulary)", { count: vectors.length });
    }
    if (angles.length > 0) {
      physicsLog.debug("angles ignored in 3D mode (pixel-authored 2D vocabulary)", { count: angles.length });
    }
    if (field) {
      physicsLog.debug("field ignored in 3D mode (pixel-authored 2D vocabulary)");
    }
    if (meters.length > 0) {
      physicsLog.debug("meters ignored in 3D mode (pixel-authored 2D vocabulary)", { count: meters.length });
    }
    if (animate) {
      physicsLog.debug("animate ignored in 3D mode (motion is entity-state driven)");
    }
    const out = [];
    const labelColor = "ink";
    const bodyById = /* @__PURE__ */ new Map();
    for (const b of bodies) {
      if (b.id) bodyById.set(b.id, b);
    }
    for (const c of constraints) {
      const a = bodyById.get(c.from);
      const b = bodyById.get(c.to);
      if (!a || !b) continue;
      const rodRadius = Math.max(0.05, Math.min(a.radius ?? 0.5, b.radius ?? 0.5) * 0.15);
      const rod = cylinderBetween([a.x, a.y, a.z ?? 0], [b.x, b.y, b.z ?? 0], rodRadius, tone3d(c.color, "ink"));
      if (rod) out.push(rod);
    }
    bodies.forEach((b, bi) => {
      const radius = b.radius ?? 0.5;
      const bz = b.z ?? 0;
      out.push(meshSphere(b.id, b.x, b.y, bz, radius, tone3d(b.color, seriesTone3(bi))));
      if (b.label) {
        out.push(billboardLabel(b.label, b.x, b.y, bz + radius, { color: labelColor }));
      }
      const vx = b.vx ?? 0;
      const vy = b.vy ?? 0;
      const vz = b.vz ?? 0;
      const arrowRadius = Math.max(0.05, radius * 0.15);
      if (showVelocity && (vx !== 0 || vy !== 0 || vz !== 0)) {
        const arrow = arrowBetween(
          [b.x, b.y, bz],
          [b.x + vx * velocityScale, b.y + vy * velocityScale, bz + vz * velocityScale],
          tone3d("series-3", "series-3"),
          arrowRadius
        );
        if (arrow) out.push(arrow);
      }
      const fx = b.fx ?? 0;
      const fy = b.fy ?? 0;
      const fz = b.fz ?? 0;
      if (showForces && (fx !== 0 || fy !== 0 || fz !== 0)) {
        const arrow = arrowBetween(
          [b.x, b.y, bz],
          [b.x + fx * forceScale, b.y + fy * forceScale, bz + fz * forceScale],
          tone3d("series-5", "series-5"),
          arrowRadius
        );
        if (arrow) out.push(arrow);
      }
    });
    for (const trail of trails) {
      if (trail.fade !== void 0) {
        physicsLog.debug("trail.fade ignored in 3D mode (2D-only fade curve \u2014 3D draws an opaque tube)", { id: trail.id });
      }
      const points = trail.points.map((p) => [p.x, p.y, p.z ?? 0]);
      out.push(
        ...polylineTube(points, trail.width ?? 0.05, tone3d(trail.color, "guide"), {
          ...trail.opacity !== void 0 ? { opacity: trail.opacity } : {}
        })
      );
    }
    if (surface3d) {
      out.push(
        ...heightFieldMesh({
          ...surface3d,
          color: tone3d(surface3d.color, "series-1"),
          bands: surface3d.bands?.map((band) => ({ ...band, color: tone3d(band.color, "series-1") }))
        })
      );
    }
    if (vectors3d.length > 0) {
      out.push(
        ...arrowField(
          vectors3d.map((v) => ({
            id: v.id,
            from: [v.x, v.y, v.z ?? 0],
            delta: [v.dx, v.dy, v.dz ?? 0],
            color: tone3d(v.color, "series-5"),
            label: v.label,
            width: v.width
          })),
          { scale: vectorScale, labelColor }
        )
      );
    }
    return out;
  }, [
    mode,
    bodies,
    constraints,
    showVelocity,
    showForces,
    velocityScale,
    forceScale,
    shapes,
    sceneObjects,
    trails,
    vectors,
    surface3d,
    vectors3d,
    vectorScale,
    angles,
    field,
    meters,
    animate,
    backgroundColor
  ]);
  const bodyIndexById = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    vectors3d.forEach((v, i) => {
      if (v.id) m.set(v.id, i);
    });
    bodies.forEach((b, i) => {
      if (b.id) m.set(b.id, i);
    });
    return m;
  }, [bodies, vectors3d]);
  if (mode === "3d") {
    return /* @__PURE__ */ jsx(
      LearningScene3D,
      {
        ...domPassthrough(rest),
        className,
        width,
        height,
        title,
        backgroundColor,
        series,
        drawables: drawables3D,
        camera,
        lighting,
        post,
        showGrid,
        shadows,
        interactive,
        isLoading,
        error,
        onItemClick: get3DClickPayload(onShapeClick, bodyIndexById)
      }
    );
  }
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className, children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }) : null,
    /* @__PURE__ */ jsx(
      LearningCanvas,
      {
        width,
        height,
        backgroundColor,
        series,
        keyMap,
        keyUpMap,
        shapes: derivedShapes,
        readouts,
        traces,
        interactive: interactive ?? false,
        animate,
        onShapeClick,
        isLoading,
        error
      }
    )
  ] }) });
};
var STATUS_CLASSES = {
  empty: "bg-surface border-border text-foreground",
  seated: "bg-surface border-success text-foreground",
  ordered: "bg-surface border-warning text-foreground",
  "awaiting-bill": "bg-surface border-info text-foreground",
  cleaning: "bg-muted border-border text-muted-foreground"
};
var STATUS_BADGE = {
  empty: { variant: "default", labelKey: "positionedCanvas.status.empty" },
  seated: { variant: "success", labelKey: "positionedCanvas.status.seated" },
  ordered: { variant: "warning", labelKey: "positionedCanvas.status.ordered" },
  "awaiting-bill": { variant: "info", labelKey: "positionedCanvas.status.awaitingBill" },
  cleaning: { variant: "neutral", labelKey: "positionedCanvas.status.cleaning" }
};
function getShapeClasses(shape) {
  switch (shape) {
    case "round":
      return "rounded-full w-24 h-24";
    case "square":
      return "rounded-container w-24 h-24";
    case "rectangle":
      return "rounded-container w-36 h-20";
  }
}
function getStatusIcon(status) {
  switch (status) {
    case "seated":
      return /* @__PURE__ */ jsx(Icon, { name: "users", className: "w-4 h-4" });
    case "ordered":
      return /* @__PURE__ */ jsx(Icon, { name: "coffee", className: "w-4 h-4" });
    case "awaiting-bill":
      return /* @__PURE__ */ jsx(Icon, { name: "alert-circle", className: "w-4 h-4" });
    default:
      return null;
  }
}
var PositionedCanvas = ({
  items: itemsProp,
  width = 800,
  height = 600,
  selectedId = null,
  editable = false,
  onSelect,
  onMove,
  selectEvent,
  moveEvent,
  className,
  ...rest
}) => {
  const containerRef = useRef(null);
  const dragRef = useRef(null);
  const [draggingId, setDraggingId] = useState(null);
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const items = Array.isArray(itemsProp) ? itemsProp : [];
  const handlePointerDown = useCallback(
    (e, item) => {
      if (!editable) return;
      const target = e.currentTarget;
      const rect = target.getBoundingClientRect();
      dragRef.current = {
        id: item.id,
        pointerId: e.pointerId,
        offsetX: e.clientX - rect.left,
        offsetY: e.clientY - rect.top,
        moved: false
      };
      target.setPointerCapture(e.pointerId);
      setDraggingId(item.id);
    },
    [editable]
  );
  const handlePointerMove = useCallback(
    (e) => {
      const drag = dragRef.current;
      const container = containerRef.current;
      if (!drag || !container || drag.pointerId !== e.pointerId) return;
      const containerRect = container.getBoundingClientRect();
      const target = e.currentTarget;
      const itemWidth = target.offsetWidth;
      const itemHeight = target.offsetHeight;
      const newX = e.clientX - containerRect.left - drag.offsetX;
      const newY = e.clientY - containerRect.top - drag.offsetY;
      const clampedX = Math.max(0, Math.min(width - itemWidth, newX));
      const clampedY = Math.max(0, Math.min(height - itemHeight, newY));
      drag.moved = true;
      onMove?.(drag.id, clampedX, clampedY);
      if (moveEvent) {
        eventBus.emit(`UI:${moveEvent}`, { id: drag.id, x: clampedX, y: clampedY });
      }
    },
    [width, height, onMove, moveEvent, eventBus]
  );
  const toggleSelect = useCallback(
    (itemId) => {
      const next = selectedId === itemId ? null : itemId;
      onSelect?.(next);
      if (selectEvent) {
        eventBus.emit(`UI:${selectEvent}`, { id: next });
      }
    },
    [selectedId, onSelect, selectEvent, eventBus]
  );
  const selectable = onSelect !== void 0 || selectEvent !== void 0;
  const handlePointerUp = useCallback(
    (e, item) => {
      const drag = dragRef.current;
      if (!drag || drag.pointerId !== e.pointerId) return;
      const target = e.currentTarget;
      if (target.hasPointerCapture(e.pointerId)) {
        target.releasePointerCapture(e.pointerId);
      }
      const wasDrag = drag.moved;
      dragRef.current = null;
      setDraggingId(null);
      if (!wasDrag) toggleSelect(item.id);
    },
    [toggleSelect]
  );
  const handleContainerClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        onSelect?.(null);
        if (selectEvent) {
          eventBus.emit(`UI:${selectEvent}`, { id: null });
        }
      }
    },
    [onSelect, selectEvent, eventBus]
  );
  return (
    // Outer scroll viewport: caps the visual footprint to the parent's
    // available width on small screens. The inner plane keeps its fixed
    // {width × height} coordinate system (items are positioned by
    // absolute item.x/item.y), so a phone-sized viewport pans inside
    // the larger logical canvas rather than busting the layout.
    /* @__PURE__ */ jsx(
      Box,
      {
        role: "group",
        "aria-label": t("aria.positionedCanvas"),
        ...domPassthrough(rest),
        className: cn("max-w-full overflow-auto rounded-container", className),
        children: /* @__PURE__ */ jsx(
          Box,
          {
            ref: containerRef,
            "data-testid": "positioned-canvas",
            className: "relative bg-background border border-border rounded-container overflow-hidden touch-none",
            style: { width, height },
            onClick: handleContainerClick,
            children: items.map((item) => {
              const itemId = item.id;
              const label = item.label;
              const x = item.x;
              const y = item.y;
              const capacity = item.capacity;
              const partySize = item.partySize;
              const serverName = item.serverName;
              const status = item.status ?? "empty";
              const shape = item.shape ?? "round";
              const isSelected = selectedId === itemId;
              const isDragging = draggingId === itemId;
              const statusBadge = STATUS_BADGE[status];
              return /* @__PURE__ */ jsxs(
                Box,
                {
                  "data-testid": `item-node-${itemId}`,
                  "data-status": status,
                  className: cn(
                    "absolute flex flex-col items-center justify-center gap-1 border-heavy select-none",
                    "transition-shadow",
                    STATUS_CLASSES[status],
                    getShapeClasses(shape),
                    editable ? "cursor-move" : "cursor-pointer",
                    isSelected && "outline outline-2 outline-offset-2 outline-primary shadow-elevation-card",
                    isDragging && "shadow-elevation-popover z-10"
                  ),
                  style: { left: x, top: y, touchAction: "none" },
                  ...selectable ? {
                    role: "button",
                    tabIndex: 0,
                    "aria-pressed": isSelected,
                    onKeyDown: (e) => {
                      if (e.target !== e.currentTarget || e.key !== "Enter" && e.key !== " ") return;
                      e.preventDefault();
                      toggleSelect(itemId);
                    }
                  } : {},
                  onPointerDown: (e) => handlePointerDown(e, item),
                  onPointerMove: handlePointerMove,
                  onPointerUp: (e) => handlePointerUp(e, item),
                  onPointerCancel: (e) => handlePointerUp(e, item),
                  children: [
                    /* @__PURE__ */ jsxs(Box, { className: "flex items-center gap-1", children: [
                      getStatusIcon(status),
                      /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", children: label })
                    ] }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: partySize !== void 0 && status === "seated" ? `${partySize}/${capacity}` : t("positionedCanvas.capacity", { count: capacity }) }),
                    /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "sr-only", children: t(statusBadge.labelKey) }),
                    status === "seated" && serverName && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", className: "truncate max-w-[80%]", children: serverName }),
                    isSelected && /* @__PURE__ */ jsx(
                      Badge,
                      {
                        variant: statusBadge.variant,
                        size: "sm",
                        className: "absolute -top-2 -right-2",
                        children: t(statusBadge.labelKey)
                      }
                    )
                  ]
                },
                itemId
              );
            })
          }
        )
      }
    )
  );
};
PositionedCanvas.displayName = "PositionedCanvas";
var sizeMap7 = {
  sm: { dot: 6, active: 8 },
  md: { dot: 8, active: 10 },
  lg: { dot: 10, active: 14 }
};
var stateColors = {
  active: "var(--color-primary)",
  complete: "var(--color-success, #22c55e)",
  pending: "var(--color-muted, #d4d4d8)"
};
var ProgressDots = ({
  count,
  currentIndex,
  getState,
  onDotClick,
  className,
  size: size2 = "md",
  ...rest
}) => {
  const { t } = useTranslate();
  const defaultGetState = useCallback(
    (index) => {
      if (index === currentIndex) return "active";
      return "pending";
    },
    [currentIndex]
  );
  const resolveState = getState ?? defaultGetState;
  const dims = sizeMap7[size2];
  return /* @__PURE__ */ jsx(HStack, { gap: "xs", align: "center", className: cn(className), ...domPassthrough(rest), children: Array.from({ length: count }, (_, index) => {
    const state = resolveState(index);
    const isActive = state === "active";
    const dotSize = isActive ? dims.active : dims.dot;
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex items-center justify-center",
          onDotClick && "cursor-pointer"
        ),
        style: onDotClick ? { minWidth: 24, minHeight: 24 } : void 0,
        ...pressableProps(onDotClick ? () => onDotClick(index) : void 0),
        "aria-current": isActive ? "step" : void 0,
        "aria-label": onDotClick ? t("wizard.stepOf", { current: String(index + 1), total: String(count) }) : void 0,
        children: /* @__PURE__ */ jsx(
          Box,
          {
            className: "rounded-full transition-all duration-fast",
            style: {
              width: dotSize,
              height: dotSize,
              backgroundColor: stateColors[state],
              transform: isActive ? "scale(1.2)" : "scale(1)"
            }
          }
        )
      },
      index
    );
  }) });
};
ProgressDots.displayName = "ProgressDots";
function useSafeEventBus7() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var SAFETY_TIMEOUT_MS = 5e3;
var PullToRefresh = ({
  refreshEvent,
  refreshPayload,
  threshold = 60,
  children,
  className,
  ...rest
}) => {
  const eventBus = useSafeEventBus7();
  const safetyTimerRef = useRef(null);
  const handleRefresh = useCallback(() => {
    eventBus.emit(`UI:${refreshEvent}`, refreshPayload ?? {});
  }, [eventBus, refreshEvent, refreshPayload]);
  const { pullDistance, isPulling, isRefreshing, containerProps, endRefresh } = usePullToRefresh(handleRefresh, { threshold });
  useEffect(() => {
    if (isRefreshing) {
      safetyTimerRef.current = setTimeout(() => {
        endRefresh();
      }, SAFETY_TIMEOUT_MS);
      return () => {
        if (safetyTimerRef.current) {
          clearTimeout(safetyTimerRef.current);
          safetyTimerRef.current = null;
        }
      };
    }
  }, [isRefreshing, endRefresh]);
  useEffect(() => {
    return () => {
      if (safetyTimerRef.current) {
        clearTimeout(safetyTimerRef.current);
      }
    };
  }, []);
  const pullProgress = Math.min(pullDistance / threshold, 1);
  const showIndicator = pullDistance > 0 || isRefreshing;
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), position: "relative", overflow: "hidden", className: cn("w-full", className), children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        position: "absolute",
        display: "flex",
        className: cn(
          "top-0 left-0 right-0 z-10",
          "items-center justify-center",
          "transition-opacity duration-fast",
          showIndicator ? "opacity-100" : "opacity-0"
        ),
        style: {
          height: threshold,
          transform: `translateY(${showIndicator ? 0 : -threshold}px)`,
          pointerEvents: "none"
        },
        children: /* @__PURE__ */ jsx(
          Box,
          {
            className: "transition-transform duration-fast",
            style: {
              transform: `scale(${isRefreshing ? 1 : pullProgress})`,
              opacity: isRefreshing ? 1 : pullProgress
            },
            children: /* @__PURE__ */ jsx(
              Spinner,
              {
                size: pullProgress >= 0.5 ? "md" : "sm",
                className: cn(
                  "text-primary",
                  isRefreshing && "animate-spin"
                )
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Box,
      {
        fullWidth: true,
        className: cn(
          "min-h-0",
          isPulling && "select-none"
        ),
        ...containerProps,
        children
      }
    )
  ] });
};
PullToRefresh.displayName = "PullToRefresh";
var QrScanner = ({
  onScan,
  scanEvent,
  onError,
  facingMode = "environment",
  paused = false,
  showOverlay = true,
  showCameraControls = true,
  fallback,
  className,
  ...rest
}) => {
  useEventBus();
  const { t } = useTranslate();
  const tRef = useRef(t);
  tRef.current = t;
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const scanIntervalRef = useRef(null);
  const [currentFacing, setCurrentFacing] = useState(facingMode);
  const [isPaused, setIsPaused] = useState(paused);
  const [cameraError, setCameraError] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const stopStream = useCallback(() => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    setIsReady(false);
  }, []);
  const startStream = useCallback(async () => {
    if (typeof navigator === "undefined" || !navigator.mediaDevices?.getUserMedia) {
      const err = new Error(tRef.current("qrScanner.apiUnavailable"));
      setCameraError(err);
      onError?.(err);
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: currentFacing }
      });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play().catch(() => {
        });
      }
      setCameraError(null);
      setIsReady(true);
    } catch (e) {
      const err = e instanceof Error ? e : new Error(String(e));
      setCameraError(err);
      onError?.(err);
      setIsReady(false);
    }
  }, [currentFacing, onError]);
  useEffect(() => {
    if (isPaused) {
      stopStream();
      return;
    }
    void startStream();
    return () => {
      stopStream();
    };
  }, [currentFacing, isPaused, startStream, stopStream]);
  useEffect(() => {
    setIsPaused(paused);
  }, [paused]);
  useEffect(() => {
    setCurrentFacing(facingMode);
  }, [facingMode]);
  useEffect(() => {
    if (!isReady || isPaused) return;
    scanIntervalRef.current = setInterval(() => {
    }, 200);
    return () => {
      if (scanIntervalRef.current) {
        clearInterval(scanIntervalRef.current);
        scanIntervalRef.current = null;
      }
    };
  }, [isReady, isPaused]);
  const toggleFacing = useCallback(() => {
    setCurrentFacing((f3) => f3 === "environment" ? "user" : "environment");
  }, []);
  const togglePause = useCallback(() => {
    setIsPaused((p) => !p);
  }, []);
  const videoExtraProps = {
    playsInline: true,
    muted: true
  };
  if (cameraError && fallback) {
    return /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), position: "relative", className, children: fallback });
  }
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      position: "relative",
      overflow: "hidden",
      rounded: "sm",
      className: cn(
        // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
        "bg-black",
        "aspect-square w-full max-w-md",
        className
      ),
      "data-pattern": "qr-scanner",
      role: "region",
      "aria-label": rest["aria-label"] ?? t("aria.qrScanner"),
      children: [
        /* @__PURE__ */ jsx(
          Box,
          {
            as: "video",
            ref: videoRef,
            position: "absolute",
            fullWidth: true,
            fullHeight: true,
            className: "inset-0 object-cover",
            "aria-hidden": "true",
            ...videoExtraProps
          }
        ),
        showOverlay && isReady && !isPaused && /* @__PURE__ */ jsxs(Box, { position: "absolute", className: "pointer-events-none inset-0", children: [
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "left-[15%] top-[15%] h-8 w-8 border-l-heavy border-t-heavy border-white" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "right-[15%] top-[15%] h-8 w-8 border-r-heavy border-t-heavy border-white" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-[15%] left-[15%] h-8 w-8 border-b-heavy border-l-heavy border-white" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "bottom-[15%] right-[15%] h-8 w-8 border-b-heavy border-r-heavy border-white" }),
          /* @__PURE__ */ jsx(Box, { position: "absolute", className: "left-[15%] right-[15%] top-1/2 h-px bg-white opacity-60" })
        ] }),
        cameraError && !fallback && /* @__PURE__ */ jsxs(
          Box,
          {
            position: "absolute",
            display: "flex",
            padding: "lg",
            className: "inset-0 flex-col items-center justify-center gap-2 bg-black bg-opacity-80 text-center",
            children: [
              /* @__PURE__ */ jsx(Icon, { name: "camera", className: "h-8 w-8 text-white", "aria-hidden": "true" }),
              /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-white", children: t("qrScanner.cameraUnavailable") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-white opacity-70", children: cameraError.message })
            ]
          }
        ),
        isPaused && !cameraError && /* @__PURE__ */ jsx(
          Box,
          {
            position: "absolute",
            display: "flex",
            className: "inset-0 items-center justify-center bg-black bg-opacity-60",
            children: /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "text-white", children: t("qrScanner.paused") })
          }
        ),
        showCameraControls && /* @__PURE__ */ jsxs(
          Box,
          {
            position: "absolute",
            display: "flex",
            className: "bottom-3 left-1/2 -translate-x-1/2 gap-2",
            children: [
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "button",
                  onClick: togglePause,
                  className: cn(
                    // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                    "rounded-full bg-black bg-opacity-60 p-2 text-white",
                    // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                    "hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                  ),
                  "aria-label": isPaused ? t("qrScanner.resumeScanning") : t("qrScanner.pauseScanning"),
                  children: isPaused ? /* @__PURE__ */ jsx(Icon, { name: "play", className: "h-4 w-4" }) : /* @__PURE__ */ jsx(Icon, { name: "pause", className: "h-4 w-4" })
                }
              ),
              /* @__PURE__ */ jsx(
                Button,
                {
                  type: "button",
                  onClick: toggleFacing,
                  className: cn(
                    // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                    "rounded-full bg-black bg-opacity-60 p-2 text-white",
                    // eslint-disable-next-line almadar/no-hardcoded-colors -- media overlay: always over a dark scrim
                    "hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
                  ),
                  "aria-label": currentFacing === "environment" ? t("qrScanner.switchToFrontCamera") : t("qrScanner.switchToRearCamera"),
                  children: /* @__PURE__ */ jsx(Icon, { name: "refresh-cw", className: "h-4 w-4" })
                }
              )
            ]
          }
        )
      ]
    }
  );
};
QrScanner.displayName = "QrScanner";
var ReflectionBlock = ({
  prompt,
  index,
  savedNote,
  saveEvent = "SAVE_REFLECTION",
  className,
  ...rest
}) => {
  const [note, setNote] = useState(savedNote ?? "");
  const [isExpanded, setIsExpanded] = useState(false);
  const { emit } = useEventBus();
  const { t } = useTranslate();
  const handleSave = () => {
    emit(`UI:${saveEvent}`, { index, note });
    setIsExpanded(false);
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "my-6 border-l-heavy border-warning bg-warning/10 rounded-r-container p-4",
        className
      ),
      children: /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-3", children: [
        /* @__PURE__ */ jsx(PauseCircle, { className: "text-warning flex-shrink-0 mt-1", size: 20 }),
        /* @__PURE__ */ jsxs("div", { className: "flex-1", children: [
          /* @__PURE__ */ jsx("div", { className: "font-medium text-warning mb-2", children: t("reflection.title") }),
          /* @__PURE__ */ jsx("p", { className: "text-foreground text-sm mb-3", children: prompt }),
          isExpanded ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "textarea",
              {
                className: "w-full p-2 border border-input rounded-interactive text-sm bg-card text-foreground focus:ring-2 focus:ring-ring focus:border-transparent",
                placeholder: t("reflection.placeholder"),
                value: note,
                onChange: (e) => setNote(e.target.value),
                rows: 2
              }
            ),
            /* @__PURE__ */ jsx(
              "button",
              {
                onClick: handleSave,
                className: "mt-2 text-sm px-3 py-1 bg-warning text-warning-foreground rounded-interactive hover:opacity-90 transition-colors",
                children: t("reflection.saveContinue")
              }
            )
          ] }) : /* @__PURE__ */ jsx(
            "button",
            {
              onClick: () => setIsExpanded(true),
              className: "text-sm text-warning hover:underline",
              children: savedNote ? t("reflection.answeredEdit") : t("reflection.answerQuestion")
            }
          )
        ] })
      ] })
    }
  );
};
ReflectionBlock.displayName = "ReflectionBlock";
var RepeatableFormSection = ({
  sectionType,
  title,
  items,
  renderItem,
  minItems = 0,
  maxItems = Infinity,
  allowReorder = false,
  addLabel,
  emptyMessage,
  readOnly = false,
  className,
  onAdd,
  onRemove,
  onReorder,
  trackAddedInState = false,
  currentState,
  showAuditInfo = false,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t, locale } = useTranslate();
  const resolvedAddLabel = addLabel ?? t("common.add");
  const resolvedEmptyMessage = emptyMessage ?? t("empty.noItemsAdded");
  const safeItems = items ?? [];
  const canAdd = !readOnly && safeItems.length < maxItems;
  const canRemove = !readOnly && safeItems.length > minItems;
  const handleAdd = useCallback(() => {
    onAdd?.();
    const eventPayload = {
      sectionType,
      index: safeItems.length
    };
    if (trackAddedInState && currentState) {
      eventPayload.addedInState = currentState;
      eventPayload.addedAt = (/* @__PURE__ */ new Date()).toISOString();
    }
    eventBus.emit("UI:SECTION_ADDED", eventPayload);
  }, [
    sectionType,
    safeItems.length,
    onAdd,
    eventBus,
    trackAddedInState,
    currentState
  ]);
  const handleRemove = useCallback(
    (itemId, index) => {
      onRemove?.(itemId, index);
      eventBus.emit("UI:SECTION_REMOVED", { sectionType, index, itemId });
    },
    [sectionType, onRemove, eventBus]
  );
  const canReorder = allowReorder && !readOnly;
  const handleMove = useCallback(
    (fromIndex, toIndex) => onReorder?.(fromIndex, toIndex),
    [onReorder]
  );
  return /* @__PURE__ */ jsxs(VStack, { ...domPassthrough(rest), gap: "md", className: cn("w-full", className), children: [
    /* @__PURE__ */ jsxs(HStack, { justify: "between", align: "center", children: [
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "h4", children: title }),
        /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
          "(",
          safeItems.length,
          maxItems !== Infinity ? `/${maxItems}` : "",
          ")"
        ] })
      ] }),
      canAdd && /* @__PURE__ */ jsxs(Button, { variant: "secondary", size: "sm", onClick: handleAdd, children: [
        /* @__PURE__ */ jsx(Icon, { name: "plus", size: "sm", className: "mr-1" }),
        resolvedAddLabel
      ] })
    ] }),
    safeItems.length === 0 ? /* @__PURE__ */ jsx(Card, { className: "p-6", children: /* @__PURE__ */ jsxs(VStack, { align: "center", gap: "sm", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: resolvedEmptyMessage }),
      canAdd && /* @__PURE__ */ jsxs(Button, { variant: "primary", size: "sm", onClick: handleAdd, children: [
        /* @__PURE__ */ jsx(Icon, { name: "plus", size: "sm", className: "mr-1" }),
        resolvedAddLabel
      ] })
    ] }) }) : /* @__PURE__ */ jsx(VStack, { gap: "sm", children: safeItems.map((item, index) => /* @__PURE__ */ jsx(Card, { className: "p-4", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
      showAuditInfo && (item.addedInState || item.addedAt) && /* @__PURE__ */ jsxs(
        HStack,
        {
          justify: "between",
          align: "center",
          className: "pb-2 border-b border-border",
          children: [
            /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: item.addedInState && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
              t("repeatable.addedIn"),
              " ",
              /* @__PURE__ */ jsx(
                Typography,
                {
                  as: "span",
                  variant: "caption",
                  weight: "semibold",
                  children: item.addedInState
                }
              )
            ] }) }),
            item.addedAt && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: new Date(item.addedAt).toLocaleString(locale) })
          ]
        }
      ),
      /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "start", children: [
        canReorder && /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "chevron-up",
              "aria-label": t("common.moveUp"),
              disabled: index === 0,
              onClick: () => handleMove(index, index - 1)
            }
          ),
          /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              size: "sm",
              icon: "chevron-down",
              "aria-label": t("common.moveDown"),
              disabled: index === safeItems.length - 1,
              onClick: () => handleMove(index, index + 1)
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "flex-1", children: renderItem(item, index) }),
        canRemove && /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "sm",
            onClick: () => handleRemove(item.id, index),
            "aria-label": t("common.remove"),
            className: "text-foreground hover:bg-error/10",
            children: /* @__PURE__ */ jsx(Icon, { name: "trash-2", size: "sm" })
          }
        )
      ] })
    ] }) }, item.id)) }),
    safeItems.length < minItems && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "warning", children: minItems === 1 ? t("repeatable.minItemsOne") : t("repeatable.minItems", { count: minItems }) })
  ] });
};
RepeatableFormSection.displayName = "RepeatableFormSection";
function useDebugData() {
  const [data, setData] = React93.useState(() => ({
    traits: [],
    ticks: [],
    guards: [],
    events: [],
    entitySnapshot: null,
    verification: {
      checks: [],
      transitions: [],
      bridge: null,
      summary: { totalChecks: 0, passed: 0, failed: 0, warnings: 0, pending: 0 }
    },
    lastUpdate: Date.now()
  }));
  React93.useEffect(() => {
    const updateData = () => {
      setData({
        traits: getAllTraits(),
        ticks: getAllTicks(),
        guards: getGuardHistory(),
        events: getDebugEvents(),
        entitySnapshot: getEntitySnapshot(),
        verification: {
          checks: getAllChecks(),
          transitions: getTransitions(),
          bridge: getBridgeHealth(),
          summary: getSummary()
        },
        lastUpdate: Date.now()
      });
    };
    updateData();
    const unsubTraits = subscribeToTraitChanges(updateData);
    const unsubTicks = subscribeToTickChanges(updateData);
    const unsubGuards = subscribeToGuardChanges(updateData);
    const unsubEvents = subscribeToDebugEvents(updateData);
    const unsubVerification = subscribeToVerification(updateData);
    const pollInterval = setInterval(() => {
      setData((prev) => ({
        ...prev,
        entitySnapshot: getEntitySnapshot(),
        lastUpdate: Date.now()
      }));
    }, 500);
    return () => {
      unsubTraits();
      unsubTicks();
      unsubGuards();
      unsubEvents();
      unsubVerification();
      clearInterval(pollInterval);
    };
  }, []);
  return data;
}
function layoutGraph(states, transitions, initialState, width, height) {
  if (states.length === 0) return [];
  const layers = /* @__PURE__ */ new Map();
  const queue = [initialState];
  layers.set(initialState, 0);
  while (queue.length > 0) {
    const current = queue.shift();
    const layer = layers.get(current);
    for (const tr of transitions) {
      if (tr.from === current && !layers.has(tr.to)) {
        layers.set(tr.to, layer + 1);
        queue.push(tr.to);
      }
    }
  }
  for (const s of states) {
    if (!layers.has(s)) layers.set(s, layers.size > 0 ? Math.max(...layers.values()) + 1 : 0);
  }
  const layerGroups = /* @__PURE__ */ new Map();
  for (const [state, layer] of layers) {
    const group = layerGroups.get(layer) ?? [];
    group.push(state);
    layerGroups.set(layer, group);
  }
  const maxLayer = Math.max(...layerGroups.keys(), 0);
  const padX = 24;
  const padY = 20;
  const usableW = width - padX * 2;
  const usableH = height - padY * 2;
  const positions = [];
  for (const [layer, group] of layerGroups) {
    const y = maxLayer === 0 ? usableH / 2 + padY : padY + layer / maxLayer * usableH;
    for (let i = 0; i < group.length; i++) {
      const x = group.length === 1 ? width / 2 : padX + i / (group.length - 1) * usableW;
      positions.push({ x, y, state: group[i] });
    }
  }
  return positions;
}
function WalkMinimap() {
  const { t } = useTranslate();
  const [walkStep, setWalkStep] = React93.useState(null);
  const [traits, setTraits] = React93.useState([]);
  const [coveredEdges, setCoveredEdges] = React93.useState([]);
  const [completedTraits, setCompletedTraits] = React93.useState(/* @__PURE__ */ new Set());
  const prevTraitRef = React93.useRef(null);
  React93.useEffect(() => {
    const interval = setInterval(() => {
      const w = window;
      const step = w.__orbitalWalkStep;
      const traitConfigs = w.__orbitalWalkTraits;
      const edges = w.__orbitalCoveredEdges;
      if (step) setWalkStep(step);
      if (traitConfigs) setTraits(traitConfigs);
      if (edges) setCoveredEdges(edges);
      if (step && prevTraitRef.current && prevTraitRef.current !== step.traitName) {
        setCompletedTraits((prev) => new Set(prev).add(prevTraitRef.current));
      }
      if (step) prevTraitRef.current = step.traitName;
    }, 250);
    return () => clearInterval(interval);
  }, []);
  if (!walkStep || traits.length === 0) return null;
  const activeTrait = traits.find((trait) => trait.name === walkStep.traitName);
  const engineCount = coveredEdges.filter((e) => e.phase === "engine").length;
  const domCount = coveredEdges.filter((e) => e.phase === "dom").length;
  const totalTransitions = traits.reduce((sum, trait) => sum + trait.transitions.length, 0);
  const activeEdgeKeys = new Set(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).map((e) => `${e.from}+${e.event}->${e.to}`)
  );
  const activeEdgePhases = new Map(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).map((e) => [`${e.from}+${e.event}->${e.to}`, e.phase])
  );
  const currentEdgeKey = `${walkStep.from}+${walkStep.event}->${walkStep.to}`;
  const graphW = 260;
  const graphH = 120;
  const nodeR = 10;
  const positions = activeTrait ? layoutGraph(activeTrait.states, activeTrait.transitions, activeTrait.initialState, graphW, graphH) : [];
  const posMap = new Map(positions.map((p) => [p.state, p]));
  const visitedStates = new Set(
    coveredEdges.filter((e) => e.trait === walkStep.traitName).flatMap((e) => [e.from, e.to])
  );
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "w-64 flex-shrink-0 border-l border-border bg-[var(--color-card)] overflow-hidden", children: [
    /* @__PURE__ */ jsx(Box, { className: "px-2 py-1.5 border-b border-border overflow-x-auto", children: /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-nowrap", children: traits.map((trait) => {
      const isDone = completedTraits.has(trait.name);
      const isActive = trait.name === walkStep.traitName;
      const variant = isDone ? "success" : isActive ? "info" : "neutral";
      const shortName = trait.name.replace(/^[A-Z][a-z]+/, "");
      return /* @__PURE__ */ jsxs(
        Badge,
        {
          variant,
          size: "sm",
          "aria-current": isActive ? "step" : void 0,
          className: `flex-shrink-0 text-[9px] ${isActive ? "ring-1 ring-info" : ""}`,
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", "aria-hidden": "true", as: "span", children: isDone ? "\u2713" : isActive ? "\u25CF" : "\u25CB" }),
            " ",
            shortName || trait.name,
            isDone && /* @__PURE__ */ jsx(Typography, { variant: "caption", as: "span", className: "sr-only", children: t("aria.walkTraitDone") }),
            !isDone && !isActive && /* @__PURE__ */ jsx(Typography, { variant: "caption", as: "span", className: "sr-only", children: t("aria.walkTraitPending") })
          ]
        },
        trait.name
      );
    }) }) }),
    /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-1 py-1", children: activeTrait && /* @__PURE__ */ jsxs(
      "svg",
      {
        width: graphW,
        height: graphH,
        viewBox: `0 0 ${graphW} ${graphH}`,
        role: "img",
        "aria-label": t("aria.walkGraph", { trait: activeTrait.name, from: walkStep.from, to: walkStep.to }),
        children: [
          /* @__PURE__ */ jsxs("defs", { children: [
            /* @__PURE__ */ jsx("marker", { id: "mm-arrow", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#888" }) }),
            /* @__PURE__ */ jsx("marker", { id: "mm-arrow-green", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#22c55e" }) }),
            /* @__PURE__ */ jsx("marker", { id: "mm-arrow-cyan", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#06b6d4" }) }),
            /* @__PURE__ */ jsx("marker", { id: "mm-arrow-yellow", markerWidth: "6", markerHeight: "4", refX: "6", refY: "2", orient: "auto", children: /* @__PURE__ */ jsx("path", { d: "M0,0 L6,2 L0,4", fill: "#eab308" }) })
          ] }),
          activeTrait.transitions.map((tr, i) => {
            const fromPos = posMap.get(tr.from);
            const toPos = posMap.get(tr.to);
            if (!fromPos || !toPos) return null;
            const key = `${tr.from}+${tr.event}->${tr.to}`;
            const isCurrent = key === currentEdgeKey && !walkStep.isRepositioning;
            const isCovered = activeEdgeKeys.has(key);
            const phase = activeEdgePhases.get(key);
            let stroke = "#555";
            let markerEnd = "url(#mm-arrow)";
            let strokeWidth = 1;
            let opacity = 0.4;
            if (isCurrent) {
              stroke = "#eab308";
              markerEnd = "url(#mm-arrow-yellow)";
              strokeWidth = 2.5;
              opacity = 1;
            } else if (isCovered && phase === "dom") {
              stroke = "#06b6d4";
              markerEnd = "url(#mm-arrow-cyan)";
              strokeWidth = 1.5;
              opacity = 0.9;
            } else if (isCovered) {
              stroke = "#22c55e";
              markerEnd = "url(#mm-arrow-green)";
              strokeWidth = 1.5;
              opacity = 0.9;
            }
            if (tr.from === tr.to) {
              const cx = fromPos.x;
              const cy = fromPos.y - nodeR - 8;
              return /* @__PURE__ */ jsxs("g", { children: [
                /* @__PURE__ */ jsx(
                  "path",
                  {
                    d: `M${cx - 5},${fromPos.y - nodeR} C${cx - 18},${cy - 14} ${cx + 18},${cy - 14} ${cx + 5},${fromPos.y - nodeR}`,
                    fill: "none",
                    stroke,
                    strokeWidth,
                    opacity,
                    markerEnd
                  }
                ),
                /* @__PURE__ */ jsx("text", { x: cx, y: cy - 12, textAnchor: "middle", fontSize: "7", fill: stroke, opacity, children: tr.event.length > 10 ? tr.event.slice(0, 8) + ".." : tr.event })
              ] }, `e-${i}`);
            }
            const dx = toPos.x - fromPos.x;
            const dy = toPos.y - fromPos.y;
            const len = Math.sqrt(dx * dx + dy * dy) || 1;
            const nx = -dy / len;
            const ny = dx / len;
            const hasReverse = activeTrait.transitions.some(
              (t2) => t2.from === tr.to && t2.to === tr.from
            );
            const offset = hasReverse ? 4 : 0;
            const x1 = fromPos.x + dx / len * nodeR + nx * offset;
            const y1 = fromPos.y + dy / len * nodeR + ny * offset;
            const x2 = toPos.x - dx / len * (nodeR + 6) + nx * offset;
            const y2 = toPos.y - dy / len * (nodeR + 6) + ny * offset;
            const mx = (x1 + x2) / 2 + nx * 8;
            const my = (y1 + y2) / 2 + ny * 8;
            return /* @__PURE__ */ jsxs("g", { children: [
              /* @__PURE__ */ jsx(
                "line",
                {
                  x1,
                  y1,
                  x2,
                  y2,
                  stroke,
                  strokeWidth,
                  opacity,
                  markerEnd,
                  children: isCurrent && /* @__PURE__ */ jsx("animate", { attributeName: "opacity", values: "1;0.4;1", dur: "0.8s", repeatCount: "indefinite" })
                }
              ),
              /* @__PURE__ */ jsx("text", { x: mx, y: my, textAnchor: "middle", fontSize: "7", fill: stroke, opacity: Math.min(opacity + 0.2, 1), children: tr.event.length > 12 ? tr.event.slice(0, 10) + ".." : tr.event })
            ] }, `e-${i}`);
          }),
          positions.map((pos) => {
            const isCurrentState = pos.state === walkStep.from || pos.state === walkStep.to;
            const isVisited = visitedStates.has(pos.state);
            const isInitial = pos.state === activeTrait.initialState;
            let fill = "#333";
            let strokeColor = "#555";
            let sw = 1;
            if (isCurrentState) {
              fill = "#1e40af";
              strokeColor = "#3b82f6";
              sw = 2;
            } else if (isVisited) {
              fill = "#166534";
              strokeColor = "#22c55e";
              sw = 1.5;
            }
            return /* @__PURE__ */ jsxs("g", { children: [
              isInitial && /* @__PURE__ */ jsx("circle", { cx: pos.x, cy: pos.y, r: nodeR + 3, fill: "none", stroke: "#3b82f6", strokeWidth: 1, opacity: 0.4 }),
              /* @__PURE__ */ jsx(
                "circle",
                {
                  cx: pos.x,
                  cy: pos.y,
                  r: nodeR,
                  fill,
                  stroke: strokeColor,
                  strokeWidth: sw,
                  children: isCurrentState && /* @__PURE__ */ jsx("animate", { attributeName: "r", values: `${nodeR};${nodeR + 2};${nodeR}`, dur: "1s", repeatCount: "indefinite" })
                }
              ),
              /* @__PURE__ */ jsx(
                "text",
                {
                  x: pos.x,
                  y: pos.y + nodeR + 10,
                  textAnchor: "middle",
                  fontSize: "8",
                  fill: "#aaa",
                  children: pos.state.length > 10 ? pos.state.slice(0, 8) + ".." : pos.state
                }
              )
            ] }, pos.state);
          })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(Box, { className: "px-2 py-1 border-t border-border", children: /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center justify-between", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-xs font-mono text-success", children: t("walkMinimap.engineProgress", { done: engineCount, total: totalTransitions }) }),
      domCount > 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-xs font-mono text-info", children: t("walkMinimap.domCount", { count: domCount }) }),
      /* @__PURE__ */ jsx(Badge, { variant: walkStep.phase === "engine" ? "info" : "warning", size: "sm", className: "text-[9px]", children: walkStep.phase === "engine" ? t("walkMinimap.engine") : t("walkMinimap.dom") })
    ] }) })
  ] });
}
WalkMinimap.displayName = "WalkMinimap";
function TraitsTab({ traits }) {
  const { t } = useTranslate();
  if (traits.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noActiveTraits"),
        description: t("debug.traitsMountHint"),
        className: "py-8"
      }
    );
  }
  const accordionItems = traits.map((trait) => ({
    id: trait.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 w-full", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-primary", children: trait.name }),
      /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: trait.currentState }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: t("debug.transitionsCount", { count: trait.transitionCount }) })
    ] }),
    content: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.states") }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: trait.states.map((state) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant: state === trait.currentState ? "success" : "default",
            size: "sm",
            children: state
          },
          state
        )) })
      ] }),
      trait.transitions.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.transitions") }),
        /* @__PURE__ */ jsx(Stack, { gap: "xs", children: trait.transitions.map((t2, i) => /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono", children: [
          t2.from,
          " \u2192 ",
          t2.to,
          " ",
          /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
            "(",
            t2.event,
            ")"
          ] }),
          t2.guard && /* @__PURE__ */ jsxs("span", { className: "text-warning", children: [
            " [",
            t2.guard,
            "]"
          ] })
        ] }, i)) })
      ] }),
      trait.guards.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.guards") }),
        /* @__PURE__ */ jsx(Stack, { gap: "xs", children: trait.guards.map((g, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "small", children: g.name }),
          /* @__PURE__ */ jsx(Badge, { variant: g.lastResult === true ? "success" : g.lastResult === false ? "danger" : "default", size: "sm", children: g.lastResult === void 0 ? "?" : g.lastResult ? "\u2713" : "\u2717" })
        ] }, i)) })
      ] })
    ] })
  }));
  return /* @__PURE__ */ jsx("div", { className: "debug-tab debug-tab--traits", children: /* @__PURE__ */ jsx(Accordion, { items: accordionItems, multiple: true }) });
}
TraitsTab.displayName = "TraitsTab";
function TicksTab({ ticks }) {
  const { t, locale } = useTranslate();
  const numberFormat = new Intl.NumberFormat(locale);
  const activeTicks = ticks.filter((tick) => tick.active);
  const inactiveTicks = ticks.filter((tick) => !tick.active);
  if (ticks.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noTicks"),
        description: t("debug.ticksHint"),
        className: "py-8"
      }
    );
  }
  const formatTime2 = (ms) => {
    if (ms === 0) return t("debug.never");
    const seconds = Math.floor((Date.now() - ms) / 1e3);
    if (seconds < 1) return t("debug.justNow");
    if (seconds < 60) return t("debug.secondsAgo", { count: numberFormat.format(seconds) });
    return t("debug.minutesAgo", { count: numberFormat.format(Math.floor(seconds / 60)) });
  };
  const TickCard = ({ tick, active }) => /* @__PURE__ */ jsxs(Card, { className: `p-3 ${!active ? "opacity-50" : ""}`, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-2", children: [
      /* @__PURE__ */ jsx("span", { className: `w-2 h-2 rounded-full ${active ? "bg-success" : "bg-muted-foreground"}` }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-warning", children: tick.name }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: tick.traitName })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex gap-3 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsx("span", { children: t("debug.tickInterval", { count: numberFormat.format(tick.interval) }) }),
      /* @__PURE__ */ jsx("span", { children: t(tick.runCount === 1 ? "debug.tickRunOne" : "debug.tickRunOther", { count: numberFormat.format(tick.runCount) }) }),
      /* @__PURE__ */ jsx("span", { children: t("debug.tickExec", { count: new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(tick.executionTime) }) }),
      /* @__PURE__ */ jsx("span", { children: formatTime2(tick.lastRun) })
    ] }),
    tick.guardName && /* @__PURE__ */ jsx("div", { className: "mt-2", children: /* @__PURE__ */ jsxs(Badge, { variant: tick.guardPassed ? "success" : "danger", size: "sm", children: [
      tick.guardName,
      ": ",
      tick.guardPassed ? "\u2713" : "\u2717"
    ] }) })
  ] });
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--ticks", children: [
    activeTicks.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.activeCount", { count: activeTicks.length }) }),
      /* @__PURE__ */ jsx(Stack, { gap: "sm", children: activeTicks.map((tick) => /* @__PURE__ */ jsx(TickCard, { tick, active: true }, tick.id)) })
    ] }),
    inactiveTicks.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.inactiveCount", { count: inactiveTicks.length }) }),
      /* @__PURE__ */ jsx(Stack, { gap: "sm", children: inactiveTicks.map((tick) => /* @__PURE__ */ jsx(TickCard, { tick, active: false }, tick.id)) })
    ] })
  ] });
}
TicksTab.displayName = "TicksTab";
function EntitiesTab({ snapshot }) {
  const { t } = useTranslate();
  if (!snapshot) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEntityData"),
        description: t("debug.debugModeHint"),
        className: "py-8"
      }
    );
  }
  const singletonEntries = Object.entries(snapshot.singletons);
  const runtimeEntities = snapshot.runtime;
  const persistentEntries = Object.entries(snapshot.persistent);
  if (singletonEntries.length === 0 && runtimeEntities.length === 0 && persistentEntries.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEntities"),
        description: t("debug.entitiesSpawnHint"),
        className: "py-8"
      }
    );
  }
  const singletonItems = singletonEntries.map(([name, data]) => ({
    id: `singleton-${name}`,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", children: t("debug.singleton") }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-info", children: name })
    ] }),
    content: /* @__PURE__ */ jsx("pre", { className: "text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-40", children: JSON.stringify(data, null, 2) })
  }));
  const runtimeItems = runtimeEntities.slice(0, 20).map((entity) => ({
    id: entity.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-info", children: entity.type }),
      /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground", children: [
        "#",
        entity.id.slice(0, 8)
      ] })
    ] }),
    content: /* @__PURE__ */ jsx("pre", { className: "text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-40", children: JSON.stringify(entity.data, null, 2) })
  }));
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--entities", children: [
    singletonItems.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.singletonsCount", { count: singletonItems.length }) }),
      /* @__PURE__ */ jsx(Accordion, { items: singletonItems, multiple: true })
    ] }),
    runtimeItems.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-4", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.runtimeCount", { count: runtimeEntities.length }) }),
      /* @__PURE__ */ jsx(Accordion, { items: runtimeItems, multiple: true }),
      runtimeEntities.length > 20 && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground text-center mt-2", children: t("debug.moreEntities", { count: runtimeEntities.length - 20 }) })
    ] }),
    persistentEntries.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-2", children: t("debug.persistent") }),
      /* @__PURE__ */ jsx(Stack, { gap: "xs", children: persistentEntries.map(([type, info]) => /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between py-1", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", children: type }),
        /* @__PURE__ */ jsx(Badge, { variant: info.loaded ? "success" : "default", size: "sm", children: info.loaded ? t("debug.loadedCount", { count: info.count }) : t("debug.notLoaded") })
      ] }, type)) })
    ] })
  ] });
}
EntitiesTab.displayName = "EntitiesTab";
var TYPE_BADGES = {
  trait: { variant: "primary", icon: "\u{1F504}" },
  tick: { variant: "warning", icon: "\u23F1\uFE0F" },
  guard: { variant: "warning", icon: "\u{1F6E1}\uFE0F" },
  entity: { variant: "info", icon: "\u{1F4E6}" },
  event: { variant: "success", icon: "\u26A1" },
  state: { variant: "danger", icon: "\u{1F4CA}" }
};
function EventFlowTab({ events }) {
  const { t, locale } = useTranslate();
  const [filter, setFilter] = React93.useState("all");
  const containerRef = React93.useRef(null);
  const [autoScroll, setAutoScroll] = React93.useState(true);
  React93.useEffect(() => {
    if (autoScroll && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [events.length, autoScroll]);
  const filteredEvents = React93.useMemo(() => {
    if (filter === "all") return events;
    return events.filter((e) => e.type === filter);
  }, [events, filter]);
  const formatTime2 = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString(locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) + "." + String(date.getMilliseconds()).padStart(3, "0");
  };
  if (events.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noEventsYet"),
        description: t("debug.eventsExecuteHint"),
        className: "py-8"
      }
    );
  }
  const eventTypes = Object.keys(TYPE_BADGES).filter(
    (type) => events.some((e) => e.type === type)
  );
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--events", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 mb-3 flex-wrap", children: [
      /* @__PURE__ */ jsxs(ButtonGroup, { children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: filter === "all" ? "primary" : "secondary",
            onClick: () => setFilter("all"),
            children: t("debug.allCount", { count: events.length })
          }
        ),
        eventTypes.map((type) => {
          const count = events.filter((e) => e.type === type).length;
          const { icon } = TYPE_BADGES[type];
          return /* @__PURE__ */ jsxs(
            Button,
            {
              size: "sm",
              variant: filter === type ? "primary" : "secondary",
              onClick: () => setFilter(type),
              children: [
                icon,
                " ",
                count
              ]
            },
            type
          );
        })
      ] }),
      /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs text-muted-foreground ml-auto cursor-pointer", children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: autoScroll,
            onChange: (e) => setAutoScroll(e.target.checked)
          }
        ),
        t("debug.autoScroll")
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: containerRef,
        className: "max-h-64 overflow-y-auto space-y-1 bg-muted rounded p-2",
        children: filteredEvents.slice(-100).map((event) => {
          const { variant, icon } = TYPE_BADGES[event.type] || { variant: "default", icon: "\u2022" };
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: "flex items-start gap-2 text-xs py-1 hover:bg-muted/50 rounded px-1",
              children: [
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono min-w-[65px]", children: formatTime2(event.timestamp) }),
                /* @__PURE__ */ jsx("span", { children: icon }),
                /* @__PURE__ */ jsx(Badge, { variant, size: "sm", className: "min-w-[60px] justify-center", children: event.source }),
                /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: event.message })
              ]
            },
            event.id
          );
        })
      }
    )
  ] });
}
EventFlowTab.displayName = "EventFlowTab";
function GuardsPanel({ guards }) {
  const { t, locale } = useTranslate();
  const [filter, setFilter] = React93.useState("all");
  if (guards.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noGuardEvaluations"),
        description: t("debug.guardEvaluationsHint"),
        className: "py-8"
      }
    );
  }
  const passedCount = guards.filter((g) => g.result).length;
  const failedCount = guards.length - passedCount;
  const filteredGuards = React93.useMemo(() => {
    if (filter === "all") return guards;
    if (filter === "passed") return guards.filter((g) => g.result);
    return guards.filter((g) => !g.result);
  }, [guards, filter]);
  const formatTime2 = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString(locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  };
  const accordionItems = filteredGuards.slice(-50).reverse().map((guard) => ({
    id: guard.id,
    header: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 w-full", children: [
      /* @__PURE__ */ jsx(Badge, { variant: guard.result ? "success" : "danger", size: "sm", children: guard.result ? "\u2713" : "\u2717" }),
      /* @__PURE__ */ jsx(Typography, { variant: "body", weight: "semibold", className: "text-warning", children: guard.guardName }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: guard.context.type === "transition" ? `${guard.context.transitionFrom} \u2192 ${guard.context.transitionTo}` : guard.context.tickName }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: formatTime2(guard.timestamp) })
    ] }),
    content: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.expression") }),
        /* @__PURE__ */ jsx("code", { className: "block mt-1 text-xs text-foreground bg-warning/10 px-2 py-1 rounded", children: guard.expression })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.inputs") }),
        /* @__PURE__ */ jsx("pre", { className: "mt-1 text-xs text-muted-foreground bg-muted p-2 rounded overflow-auto max-h-24", children: JSON.stringify(guard.inputs, null, 2) })
      ] }),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground", children: t("debug.trait") }),
        /* @__PURE__ */ jsx(Typography, { variant: "small", children: guard.context.traitName })
      ] })
    ] })
  }));
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--guards", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex gap-3", children: [
        /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
          "\u2713 ",
          passedCount
        ] }),
        /* @__PURE__ */ jsxs(Badge, { variant: "danger", size: "sm", children: [
          "\u2717 ",
          failedCount
        ] })
      ] }),
      /* @__PURE__ */ jsxs(ButtonGroup, { children: [
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "all" ? "primary" : "secondary", onClick: () => setFilter("all"), children: t("debug.filterAll") }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "passed" ? "primary" : "secondary", onClick: () => setFilter("passed"), children: t("debug.filterPassed") }),
        /* @__PURE__ */ jsx(Button, { size: "sm", variant: filter === "failed" ? "primary" : "secondary", onClick: () => setFilter("failed"), children: t("debug.filterFailed") })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "max-h-80 overflow-y-auto", children: /* @__PURE__ */ jsx(Accordion, { items: accordionItems }) })
  ] });
}
GuardsPanel.displayName = "GuardsPanel";
var STATUS_CONFIG = {
  pass: { variant: "success", icon: "\u2713", label: "PASS" },
  fail: { variant: "danger", icon: "\u2717", label: "FAIL" },
  warn: { variant: "warning", icon: "!", label: "WARN" },
  pending: { variant: "default", icon: "?", label: "PENDING" }
};
function VerificationTab({ checks, summary }) {
  const { t, locale } = useTranslate();
  const timeFormat = new Intl.DateTimeFormat(locale, { hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
  if (checks.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noVerificationChecks"),
        description: t("debug.verificationHint"),
        className: "py-8"
      }
    );
  }
  const sortOrder = { fail: 0, warn: 1, pending: 2, pass: 3 };
  const sorted = [...checks].sort(
    (a, b) => (sortOrder[a.status] ?? 4) - (sortOrder[b.status] ?? 4)
  );
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--verification", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 mb-3 p-2 bg-muted rounded", children: [
      /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: t("debug.passedCount", { count: summary.passed }) }),
      summary.failed > 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: t("debug.failedCount", { count: summary.failed }) }),
      summary.warnings > 0 && /* @__PURE__ */ jsx(Badge, { variant: "warning", size: "sm", children: t("debug.warningsCount", { count: summary.warnings }) }),
      summary.pending > 0 && /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", children: t("debug.pendingCount", { count: summary.pending }) }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: t("debug.totalChecksCount", { count: summary.totalChecks }) })
    ] }),
    /* @__PURE__ */ jsx("div", { className: "max-h-64 overflow-y-auto space-y-1", children: /* @__PURE__ */ jsx(Stack, { gap: "xs", children: sorted.map((check) => {
      const config = STATUS_CONFIG[check.status] || STATUS_CONFIG.pending;
      return /* @__PURE__ */ jsxs(
        "div",
        {
          className: "flex items-start gap-2 p-2 rounded hover:bg-muted/50",
          children: [
            /* @__PURE__ */ jsx(Badge, { variant: config.variant, size: "sm", className: "min-w-[20px] justify-center mt-0.5", children: config.icon }),
            /* @__PURE__ */ jsxs("div", { className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "small", className: "break-words", children: check.label }),
              check.details && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground break-words", children: check.details })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono text-xs shrink-0", children: timeFormat.format(new Date(check.updatedAt)) })
          ]
        },
        check.id
      );
    }) }) })
  ] });
}
VerificationTab.displayName = "VerificationTab";
var EFFECT_STATUS_VARIANT = {
  executed: "success",
  failed: "danger",
  skipped: "warning"
};
function EffectBadge({ effect }) {
  const variant = EFFECT_STATUS_VARIANT[effect.status] || "default";
  const icon = effect.status === "executed" ? "\u2713" : effect.status === "failed" ? "\u2717" : "-";
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1 text-xs font-mono bg-muted rounded px-1.5 py-0.5", children: [
    /* @__PURE__ */ jsx(Badge, { variant, size: "sm", className: "!text-[9px] !px-1 !py-0", children: icon }),
    /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: effect.type }),
    effect.error && /* @__PURE__ */ jsx("span", { className: "text-error truncate max-w-[120px]", title: effect.error, children: effect.error })
  ] });
}
function TransitionTimeline({ transitions }) {
  const { t, locale } = useTranslate();
  const containerRef = React93.useRef(null);
  const [autoScroll, setAutoScroll] = React93.useState(true);
  const [expandedId, setExpandedId] = React93.useState(null);
  React93.useEffect(() => {
    if (autoScroll && containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [transitions.length, autoScroll]);
  if (transitions.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noTransitionsRecorded"),
        description: t("debug.transitionsProcessHint"),
        className: "py-8"
      }
    );
  }
  const formatTime2 = (ts) => {
    const d = new Date(ts);
    return d.toLocaleTimeString(locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) + "." + String(d.getMilliseconds()).padStart(3, "0");
  };
  const sorted = [...transitions].reverse();
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--timeline", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between mb-2", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("debug.transitionsRecorded", { count: transitions.length }) }),
      /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-1 text-xs text-muted-foreground cursor-pointer", children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            checked: autoScroll,
            onChange: (e) => setAutoScroll(e.target.checked)
          }
        ),
        t("debug.autoScroll")
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: containerRef,
        className: "max-h-80 overflow-y-auto space-y-0",
        children: sorted.map((trace, idx) => {
          const isExpanded = expandedId === trace.id;
          const hasFailedEffects = trace.effects.some((e) => e.status === "failed");
          const allPassed = trace.effects.length > 0 && trace.effects.every((e) => e.status === "executed");
          return /* @__PURE__ */ jsxs(
            "div",
            {
              className: `
                                relative pl-6 pb-3 border-l-heavy cursor-pointer
                                hover:bg-muted/50 rounded-r
                                ${hasFailedEffects ? "border-error" : "border-border"}
                            `,
              ...pressableProps(() => setExpandedId(isExpanded ? null : trace.id)),
              "aria-expanded": isExpanded,
              children: [
                /* @__PURE__ */ jsx("div", { className: `
                                absolute left-[-5px] top-1 w-2 h-2 rounded-full
                                ${hasFailedEffects ? "bg-error" : allPassed ? "bg-success" : "bg-muted-foreground"}
                            ` }),
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-xs py-1 px-2", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono min-w-[65px]", children: formatTime2(trace.timestamp) }),
                  /* @__PURE__ */ jsx(Badge, { variant: "primary", size: "sm", className: "min-w-[60px] justify-center", children: trace.traitName }),
                  /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono text-muted-foreground", children: [
                    trace.from,
                    " ",
                    /* @__PURE__ */ jsx("span", { className: "text-muted-foreground/50", children: "\u2192" }),
                    " ",
                    trace.to
                  ] }),
                  /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: trace.event }),
                  trace.guardResult !== void 0 && /* @__PURE__ */ jsxs(
                    Badge,
                    {
                      variant: trace.guardResult ? "success" : "danger",
                      size: "sm",
                      children: [
                        t("debug.guardLabel"),
                        " ",
                        trace.guardResult ? "\u2713" : "\u2717"
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground ml-auto", children: t("debug.effectsCount", { count: trace.effects.length }) })
                ] }),
                isExpanded && trace.effects.length > 0 && /* @__PURE__ */ jsx("div", { className: "ml-2 mt-1 mb-2 pl-2 border-l border-border space-y-1", children: trace.effects.map((effect, eIdx) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
                  /* @__PURE__ */ jsx(EffectBadge, { effect }),
                  effect.args.length > 0 && /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground font-mono text-xs truncate max-w-[200px]", children: JSON.stringify(effect.args) }),
                  effect.durationMs !== void 0 && /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "text-muted-foreground text-xs", children: [
                    effect.durationMs,
                    "ms"
                  ] })
                ] }, eIdx)) })
              ]
            },
            trace.id
          );
        })
      }
    )
  ] });
}
TransitionTimeline.displayName = "TransitionTimeline";
function StatRow({ label, value, variant }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between py-1.5 border-b border-border last:border-b-0", children: [
    /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: label }),
    variant ? /* @__PURE__ */ jsx(Badge, { variant, size: "sm", children: String(value) }) : /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "semibold", className: "font-mono", children: String(value) })
  ] });
}
function ServerBridgeTab({ bridge }) {
  const { t, locale } = useTranslate();
  if (!bridge) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noBridgeData"),
        description: t("debug.bridgeInitHint"),
        className: "py-8"
      }
    );
  }
  const formatTime2 = (ts) => {
    if (ts === 0) return t("debug.never");
    const d = new Date(ts);
    return d.toLocaleTimeString(locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  };
  return /* @__PURE__ */ jsx("div", { className: "debug-tab debug-tab--bridge", children: /* @__PURE__ */ jsxs(Stack, { gap: "sm", children: [
    /* @__PURE__ */ jsxs(Card, { className: "p-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 mb-3", children: [
        /* @__PURE__ */ jsx("div", { className: `w-3 h-3 rounded-full ${bridge.connected ? "bg-success animate-pulse" : "bg-error"}` }),
        /* @__PURE__ */ jsx(Typography, { variant: "h6", children: bridge.connected ? t("debug.connected") : t("debug.disconnected") })
      ] }),
      /* @__PURE__ */ jsxs(Stack, { gap: "xs", children: [
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.status"),
            value: bridge.connected ? t("debug.connected") : t("debug.disconnected"),
            variant: bridge.connected ? "success" : "danger"
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.eventsForwarded"),
            value: bridge.eventsForwarded
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.eventsReceived"),
            value: bridge.eventsReceived
          }
        ),
        /* @__PURE__ */ jsx(
          StatRow,
          {
            label: t("debug.lastHeartbeat"),
            value: formatTime2(bridge.lastHeartbeat)
          }
        )
      ] })
    ] }),
    bridge.lastError && /* @__PURE__ */ jsxs(Card, { className: "p-3 border-error/30 bg-error/10", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "semibold", className: "text-error mb-1", children: t("debug.lastError") }),
      /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-error font-mono break-all", children: bridge.lastError })
    ] }),
    bridge.connected && /* @__PURE__ */ jsx("div", { className: "text-center py-2", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: t("debug.totalEventsProcessed", { count: bridge.eventsForwarded + bridge.eventsReceived }) }) })
  ] }) });
}
ServerBridgeTab.displayName = "ServerBridgeTab";
function extractPayloadFields(schema, eventName) {
  if (!schema) return [];
  for (const orbital of schema.orbitals) {
    const traitRefs = orbital.traits ?? [];
    for (const traitRef of traitRefs) {
      if (!isInlineTrait(traitRef)) continue;
      const inlineTrait = traitRef;
      const sm = inlineTrait.stateMachine;
      if (!sm) continue;
      const events = sm.events ?? [];
      for (const evt of events) {
        if (evt.name !== eventName) continue;
        const payloadFields = evt.payloadSchema ?? [];
        return payloadFields.map((f3) => ({
          name: f3.name,
          type: f3.type ?? "string"
        }));
      }
    }
  }
  return [];
}
function buildAutoPayload(fields) {
  const payload = {};
  for (const field of fields) {
    switch (field.type) {
      case "number":
      case "integer":
      case "float":
        payload[field.name] = 1;
        break;
      case "boolean":
        payload[field.name] = true;
        break;
      default:
        payload[field.name] = `test-${field.name}`;
        break;
    }
  }
  return payload;
}
function getAvailableEvents(traits) {
  const eventMap = /* @__PURE__ */ new Map();
  for (const trait of traits) {
    for (const t of trait.transitions) {
      if (t.from !== trait.currentState) continue;
      const existing = eventMap.get(t.event);
      if (existing) {
        existing.traits.add(trait.name);
        existing.transitions.push({ ...t, traitName: trait.name });
      } else {
        eventMap.set(t.event, {
          traits: /* @__PURE__ */ new Set([trait.name]),
          transitions: [{ ...t, traitName: trait.name }]
        });
      }
    }
  }
  return Array.from(eventMap.entries()).map(([event, data]) => ({
    event,
    traits: Array.from(data.traits),
    transitions: data.transitions
  }));
}
function getAllEvents(traits) {
  const all = /* @__PURE__ */ new Set();
  for (const trait of traits) {
    for (const t of trait.transitions) {
      all.add(t.event);
    }
  }
  return all;
}
function EventDispatcherTab({ traits, schema }) {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const [log12, setLog] = React93.useState([]);
  const prevStatesRef = React93.useRef(/* @__PURE__ */ new Map());
  React93.useEffect(() => {
    for (const trait of traits) {
      const prev = prevStatesRef.current.get(trait.id);
      if (prev && prev !== trait.currentState) {
        setLog((l) => [
          { traitName: trait.name, event: "?", from: prev, to: trait.currentState, timestamp: Date.now() },
          ...l
        ].slice(0, 5));
      }
      prevStatesRef.current.set(trait.id, trait.currentState);
    }
  }, [traits]);
  if (traits.length === 0) {
    return /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: t("debug.noActiveTraits"),
        description: t("debug.traitsInitHint"),
        className: "py-8"
      }
    );
  }
  const availableEvents = getAvailableEvents(traits);
  const allEvents = getAllEvents(traits);
  const unavailableEvents = Array.from(allEvents).filter(
    (e) => !availableEvents.some((ae) => ae.event === e)
  );
  const handleFireEvent = (eventName) => {
    const payloadFields = extractPayloadFields(schema, eventName);
    const payload = payloadFields.length > 0 ? buildAutoPayload(payloadFields) : {};
    eventBus.emit(`UI:${eventName}`, payload);
  };
  return /* @__PURE__ */ jsxs("div", { className: "debug-tab debug-tab--dispatch", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.activeStates") }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: traits.map((trait) => /* @__PURE__ */ jsxs(Badge, { variant: "success", size: "sm", children: [
        trait.name,
        ": ",
        trait.currentState
      ] }, trait.id)) })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.availableEvents") }),
      availableEvents.length === 0 ? /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground italic", children: t("debug.noTransitionsFromState") }) : /* @__PURE__ */ jsx(Stack, { gap: "xs", children: availableEvents.map(({ event, transitions }) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            onClick: () => handleFireEvent(event),
            variant: "primary",
            size: "sm",
            className: "font-mono text-xs",
            children: event
          }
        ),
        /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-muted-foreground", children: transitions.map((t2) => `${t2.from} -> ${t2.to}`).join(", ") }),
        transitions.some((tr) => tr.guard) && /* @__PURE__ */ jsx(Badge, { variant: "warning", size: "sm", children: t("debug.guarded") })
      ] }, event)) })
    ] }),
    unavailableEvents.length > 0 && /* @__PURE__ */ jsxs("div", { className: "mb-3", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.otherEvents") }),
      /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: unavailableEvents.map((event) => /* @__PURE__ */ jsx(Badge, { variant: "default", size: "sm", className: "opacity-50", children: event }, event)) })
    ] }),
    log12.length > 0 && /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "text-muted-foreground mb-1", children: t("debug.recentTransitions") }),
      /* @__PURE__ */ jsx(Stack, { gap: "xs", children: log12.map((entry, i) => /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "font-mono text-xs", children: [
        /* @__PURE__ */ jsx("span", { className: "text-primary", children: entry.traitName }),
        " ",
        /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: entry.from }),
        " -> ",
        /* @__PURE__ */ jsx("span", { className: "text-success", children: entry.to })
      ] }, i)) })
    ] })
  ] });
}
EventDispatcherTab.displayName = "EventDispatcherTab";
function ServerResponseRow({ sr }) {
  const { t } = useTranslate();
  const entityEntries = Object.entries(sr.dataEntities);
  return /* @__PURE__ */ jsxs("div", { className: "ml-4 pl-2 border-l border-primary py-0.5 text-xs font-mono", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs("span", { className: sr.success ? "text-success" : "text-error", children: [
        sr.success ? "\u2713" : "\u2717",
        " ",
        t("debug.server")
      ] }),
      /* @__PURE__ */ jsx("span", { className: "text-primary", children: sr.orbitalName }),
      sr.clientEffects > 0 && /* @__PURE__ */ jsx("span", { className: "px-1 rounded bg-primary/10 text-foreground", children: t("debug.clientEffectsCount", { count: sr.clientEffects }) }),
      sr.emittedEvents.length > 0 && /* @__PURE__ */ jsxs("span", { className: "px-1 rounded bg-primary/10 text-foreground", children: [
        t("debug.emitLabel"),
        " ",
        sr.emittedEvents.join(", ")
      ] }),
      sr.error && /* @__PURE__ */ jsx("span", { className: "px-1 rounded bg-error/10 text-foreground truncate max-w-[300px]", children: sr.error })
    ] }),
    entityEntries.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1 mt-0.5", children: entityEntries.map(([name, count]) => /* @__PURE__ */ jsxs("span", { className: "px-1 rounded bg-[var(--color-card)] text-foreground", children: [
      name,
      ": ",
      t("debug.rowsCount", { count })
    ] }, name)) })
  ] });
}
function TransitionRow({ trace }) {
  const { t } = useTranslate();
  const isServerEntry = !!trace.serverResponse && trace.traitName.startsWith("server:");
  const hasFailedEffects = trace.effects.some((e) => e.status === "failed");
  if (isServerEntry && trace.serverResponse) {
    return /* @__PURE__ */ jsxs("div", { className: "py-0.5 border-b border-border last:border-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2 text-xs font-mono", children: [
        /* @__PURE__ */ jsx("span", { className: "mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0 bg-primary" }),
        /* @__PURE__ */ jsx(Badge, { variant: "warning", size: "sm", className: "flex-shrink-0", children: trace.event }),
        /* @__PURE__ */ jsx("span", { className: "text-primary flex-shrink-0", children: t("debug.serverResponse") })
      ] }),
      /* @__PURE__ */ jsx(ServerResponseRow, { sr: trace.serverResponse })
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "py-0.5 border-b border-border last:border-0", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2 text-xs font-mono", children: [
      /* @__PURE__ */ jsx("span", { className: cn(
        "mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0",
        hasFailedEffects ? "bg-error" : "bg-success"
      ) }),
      /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", className: "flex-shrink-0", children: trace.event }),
      /* @__PURE__ */ jsx("span", { className: "text-foreground flex-shrink-0", children: trace.traitName }),
      /* @__PURE__ */ jsxs("span", { className: "text-foreground/70 flex-shrink-0", children: [
        trace.from,
        " ",
        "\u2192",
        " ",
        trace.to
      ] })
    ] }),
    trace.effects.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1 ml-6 mt-0.5", children: trace.effects.map((eff, i) => /* @__PURE__ */ jsxs("span", { className: cn(
      "px-1 rounded text-xs",
      eff.status === "executed" ? "bg-success/10 text-foreground" : eff.status === "failed" ? "bg-error/10 text-foreground" : "bg-warning/10 text-foreground"
    ), children: [
      eff.status === "executed" ? "\u2713" : eff.status === "failed" ? "\u2717" : "-",
      " ",
      eff.type,
      eff.args.length > 0 && /* @__PURE__ */ jsx("span", { className: "text-foreground/50 ml-0.5", children: JSON.stringify(eff.args).slice(0, 40) })
    ] }, i)) }),
    trace.serverResponse && /* @__PURE__ */ jsx(ServerResponseRow, { sr: trace.serverResponse })
  ] });
}
function VerifyModePanel({
  className,
  a11y,
  failedChecks,
  transitions,
  traitStates,
  serverCount,
  localCount
}) {
  const { t } = useTranslate();
  const [expanded, setExpanded] = React93.useState(true);
  const scrollRef = React93.useRef(null);
  const prevCountRef = React93.useRef(0);
  React93.useEffect(() => {
    if (expanded && transitions.length > prevCountRef.current && scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
    prevCountRef.current = transitions.length;
  }, [transitions.length, expanded]);
  const hudBottom = typeof document !== "undefined" ? document.getElementById("runtime-debugger-portal") : null;
  const panel = /* @__PURE__ */ jsxs(
    "div",
    {
      ...a11y,
      className: cn(
        "runtime-debugger runtime-debugger--verify",
        "flex flex-col bg-[var(--color-card)] text-[var(--color-foreground)] border-t-heavy border-accent",
        hudBottom ? "" : "fixed bottom-0 left-0 right-0",
        className
      ),
      "data-testid": "debugger-verify",
      "data-expanded": expanded ? "true" : "false",
      style: { height: expanded ? "25vh" : "auto", zIndex: hudBottom ? void 0 : 40 },
      children: [
        /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            onClick: () => setExpanded((v) => !v),
            className: "px-3 py-1.5 flex items-center gap-3 text-xs font-mono border-b border-border flex-shrink-0 w-full text-left hover:bg-[var(--color-card-hover,transparent)] cursor-pointer",
            "aria-expanded": expanded,
            "aria-label": expanded ? t("debug.collapseVerificationTimeline") : t("debug.expandVerificationTimeline"),
            "data-testid": "debugger-verify-toggle",
            children: [
              /* @__PURE__ */ jsx("span", { className: "text-foreground/50 w-3", "aria-hidden": true, children: expanded ? "\u25BE" : "\u25B8" }),
              /* @__PURE__ */ jsx(Badge, { variant: failedChecks > 0 ? "danger" : "success", size: "sm", children: failedChecks > 0 ? t("debug.failCount", { count: failedChecks }) : t("debug.ok") }),
              /* @__PURE__ */ jsx("span", { className: "text-foreground/70", children: t("debug.localCount", { count: localCount }) }),
              /* @__PURE__ */ jsx("span", { className: "text-primary", children: t("debug.serverCount", { count: serverCount }) }),
              traitStates && /* @__PURE__ */ jsx("span", { className: "text-accent truncate max-w-[400px]", children: traitStates }),
              !expanded && transitions.length > 0 && /* @__PURE__ */ jsx("span", { className: "ml-auto text-foreground/50", children: t("debug.transitionsCount", { count: transitions.length }) })
            ]
          }
        ),
        expanded && /* @__PURE__ */ jsxs("div", { className: "flex-1 flex overflow-hidden", children: [
          /* @__PURE__ */ jsx("div", { ref: scrollRef, className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ jsx("div", { className: "px-2 py-1", children: transitions.length === 0 ? /* @__PURE__ */ jsx("div", { className: "text-foreground/50 text-xs font-mono py-2 text-center", children: t("debug.waitingForTransitions") }) : /* @__PURE__ */ jsx("div", { className: "space-y-0.5", children: transitions.map((trace) => /* @__PURE__ */ jsx(TransitionRow, { trace }, trace.id)) }) }) }),
          /* @__PURE__ */ jsx(WalkMinimap, {})
        ] })
      ]
    }
  );
  return hudBottom ? createPortal(panel, hudBottom) : panel;
}
function RuntimeDebugger({
  position = "bottom-right",
  defaultCollapsed = true,
  className,
  mode = "floating",
  defaultTab,
  schema,
  ...rest
}) {
  const a11y = domPassthrough(rest);
  const { t } = useTranslate();
  const [isCollapsed, setIsCollapsed] = React93.useState(mode === "verify" ? true : defaultCollapsed);
  const [isVisible, setIsVisible] = React93.useState(mode === "inline" || mode === "verify" || isDebugEnabled2());
  const debugData = useDebugData();
  React93.useEffect(() => {
    if (mode === "inline") return;
    return onDebugToggle((enabled) => {
      setIsVisible(enabled);
      if (enabled) {
        setIsCollapsed(false);
      }
    });
  }, [mode]);
  React93.useEffect(() => {
    if (mode === "inline") return;
    const handleKeyDown = (e) => {
      if (e.key === "`" && isVisible) {
        const target = e.target;
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") return;
        setIsCollapsed((prev) => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isVisible, mode]);
  if (!isVisible) {
    return null;
  }
  const positionClasses2 = {
    "bottom-right": "bottom-4 right-4",
    "bottom-left": "bottom-4 left-4",
    "top-right": "top-4 right-4",
    "top-left": "top-4 left-4"
  };
  const { verification } = debugData;
  const failedChecks = verification.summary.failed;
  const tabItems = [
    {
      id: "dispatch",
      label: t("debug.tabDispatch"),
      badge: debugData.traits.length || void 0,
      content: /* @__PURE__ */ jsx(EventDispatcherTab, { traits: debugData.traits, schema })
    },
    {
      id: "verify",
      label: failedChecks > 0 ? t("debug.tabVerifyAlert") : t("debug.tabVerify"),
      badge: verification.summary.totalChecks || void 0,
      content: /* @__PURE__ */ jsx(VerificationTab, { checks: verification.checks, summary: verification.summary })
    },
    {
      id: "timeline",
      label: t("debug.tabTimeline"),
      badge: verification.transitions.length || void 0,
      content: /* @__PURE__ */ jsx(TransitionTimeline, { transitions: verification.transitions })
    },
    {
      id: "bridge",
      label: t("debug.tabBridge"),
      badge: verification.bridge?.connected ? void 0 : 1,
      content: /* @__PURE__ */ jsx(ServerBridgeTab, { bridge: verification.bridge })
    },
    {
      id: "traits",
      label: t("debug.tabTraits"),
      badge: debugData.traits.length || void 0,
      content: /* @__PURE__ */ jsx(TraitsTab, { traits: debugData.traits })
    },
    {
      id: "ticks",
      label: t("debug.tabTicks"),
      badge: debugData.ticks.filter((tick) => tick.active).length || void 0,
      content: /* @__PURE__ */ jsx(TicksTab, { ticks: debugData.ticks })
    },
    {
      id: "entities",
      label: t("debug.tabEntities"),
      badge: debugData.entitySnapshot?.runtime.length || void 0,
      content: /* @__PURE__ */ jsx(EntitiesTab, { snapshot: debugData.entitySnapshot })
    },
    {
      id: "events",
      label: t("debug.tabEvents"),
      badge: debugData.events.length > 0 ? debugData.events.length : void 0,
      content: /* @__PURE__ */ jsx(EventFlowTab, { events: debugData.events })
    },
    {
      id: "guards",
      label: t("debug.tabGuards"),
      badge: debugData.guards.filter((g) => !g.result).length || void 0,
      content: /* @__PURE__ */ jsx(GuardsPanel, { guards: debugData.guards })
    }
  ];
  if (mode === "inline") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        ...a11y,
        className: cn(
          "runtime-debugger",
          "runtime-debugger--inline",
          className
        ),
        "data-testid": "debugger-inline",
        children: /* @__PURE__ */ jsxs(Card, { className: cn(
          "runtime-debugger__panel",
          isCollapsed ? "runtime-debugger__panel--inline-collapsed" : "runtime-debugger__panel--inline"
        ), children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "runtime-debugger__header",
              ...pressableProps(() => setIsCollapsed((prev) => !prev)),
              "aria-expanded": !isCollapsed,
              style: { cursor: "pointer", userSelect: "none" },
              children: /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                /* @__PURE__ */ jsxs(Typography, { variant: "h6", style: { fontSize: "0.75rem" }, children: [
                  isCollapsed ? "\u25B6" : "\u25BC",
                  " ",
                  t("debug.debugger")
                ] }),
                failedChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: t("debug.failedCount", { count: failedChecks }) }) : debugData.traits.length > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: t("debug.traitsCount", { count: debugData.traits.length }) }) : /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t("debug.idle") })
              ] })
            }
          ),
          !isCollapsed && /* @__PURE__ */ jsx("div", { className: "runtime-debugger__content", children: /* @__PURE__ */ jsx(
            Tabs,
            {
              items: tabItems,
              defaultActiveTab: defaultTab,
              variant: "pills",
              className: "runtime-debugger__tabs"
            }
          ) })
        ] })
      }
    );
  }
  if (mode === "verify") {
    const traitStates = debugData.traits.map((t2) => `${t2.name}:${t2.currentState}`).join(" | ");
    const serverEntries = verification.transitions.filter((t2) => t2.serverResponse);
    const localEntries = verification.transitions.filter((t2) => !t2.serverResponse);
    return /* @__PURE__ */ jsx(
      VerifyModePanel,
      {
        a11y,
        className,
        failedChecks,
        transitions: verification.transitions,
        traitStates,
        serverCount: serverEntries.length,
        localCount: localEntries.length
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...a11y,
      className: cn(
        "runtime-debugger",
        "fixed",
        positionClasses2[position],
        isCollapsed ? "runtime-debugger--collapsed" : "runtime-debugger--expanded",
        className
      ),
      "data-testid": isCollapsed ? "debugger-collapsed" : "debugger-expanded",
      style: { zIndex: 99999 },
      children: isCollapsed ? /* @__PURE__ */ jsx(
        Button,
        {
          onClick: () => setIsCollapsed(false),
          variant: "secondary",
          size: "sm",
          className: "runtime-debugger__toggle",
          title: t("debug.openDebugger"),
          children: failedChecks > 0 ? /* @__PURE__ */ jsxs("span", { className: "relative", children: [
            /* @__PURE__ */ jsx("span", { children: "V" }),
            /* @__PURE__ */ jsx("span", { className: "absolute -top-1 -right-2 w-2 h-2 bg-error rounded-full" })
          ] }) : /* @__PURE__ */ jsx("span", { children: "V" })
        }
      ) : /* @__PURE__ */ jsxs(Card, { className: "runtime-debugger__panel", children: [
        /* @__PURE__ */ jsxs("div", { className: "runtime-debugger__header", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx("span", { className: "text-lg", children: "V" }),
            /* @__PURE__ */ jsx(Typography, { variant: "h6", children: t("debug.kflowVerifier") }),
            failedChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: t("debug.failedCount", { count: failedChecks }) }) : verification.summary.totalChecks > 0 ? /* @__PURE__ */ jsx(Badge, { variant: "success", size: "sm", children: t("debug.allPassing") }) : /* @__PURE__ */ jsx(Badge, { variant: "info", size: "sm", children: t("debug.runtime") })
          ] }),
          /* @__PURE__ */ jsx(
            Button,
            {
              onClick: () => setIsCollapsed(true),
              variant: "ghost",
              size: "sm",
              icon: "x",
              title: t("debug.close"),
              "aria-label": t("debug.close")
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "runtime-debugger__content", children: /* @__PURE__ */ jsx(
          Tabs,
          {
            items: tabItems,
            defaultActiveTab: defaultTab,
            variant: "pills",
            className: "runtime-debugger__tabs"
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "runtime-debugger__footer", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-foreground/50", children: t("debug.toggleHint") }) })
      ] })
    }
  );
}
RuntimeDebugger.displayName = "RuntimeDebugger";
function boxedChildren(el) {
  return [...el.children].flatMap(
    (child) => child instanceof HTMLElement && getComputedStyle(child).display !== "contents" ? [child] : boxedChildren(child)
  );
}
var MIN_DIAGRAM_WIDTH = 200;
var ScaledDiagram = ({
  children,
  className,
  ...rest
}) => {
  const { t: _t, direction } = useTranslate();
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const [layout, setLayout] = useState(null);
  const measure = useCallback(() => {
    const wrapper = wrapperRef.current;
    const content = contentRef.current;
    if (!wrapper || !content) return;
    const containerW = wrapper.clientWidth;
    if (containerW <= 0) return;
    let diagramW = 0;
    let diagramH = 0;
    const children2 = boxedChildren(content);
    for (let i = 0; i < children2.length; i++) {
      const child = children2[i];
      const w = child.style?.width;
      const h = child.style?.height;
      if (w && /^\d+/.test(w) && h && /^\d+/.test(h)) {
        diagramW = parseFloat(w);
        diagramH = parseFloat(h);
        break;
      }
      if (child.offsetWidth > MIN_DIAGRAM_WIDTH) {
        diagramW = child.offsetWidth;
        diagramH = child.offsetHeight;
        break;
      }
    }
    if (diagramW < MIN_DIAGRAM_WIDTH || diagramH <= 0) {
      setLayout((prev) => prev === null ? prev : null);
      return;
    }
    const s = Math.min(1, containerW / diagramW);
    const height = diagramH * s;
    setLayout((prev) => prev !== null && prev.scale === s && prev.height === height ? prev : { scale: s, height });
  }, []);
  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;
    let raf1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => measure());
    });
    const ro = new ResizeObserver(() => measure());
    ro.observe(content);
    return () => {
      cancelAnimationFrame(raf1);
      ro.disconnect();
    };
  }, [measure, children]);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;
    const ro = new ResizeObserver(() => measure());
    ro.observe(wrapper);
    return () => ro.disconnect();
  }, [measure]);
  const hasLayout = layout !== null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...domPassthrough(rest),
      ref: wrapperRef,
      className: cn("w-full", className),
      style: {
        // Only clip overflow once we have a valid measurement
        overflow: hasLayout ? "hidden" : void 0,
        height: hasLayout ? layout.height : void 0
      },
      children: /* @__PURE__ */ jsx(
        Box,
        {
          ref: contentRef,
          style: {
            width: "max-content",
            // RTL content overflows to the left, so it shrinks toward its right edge.
            transformOrigin: direction === "rtl" ? "top right" : "top left",
            transform: hasLayout && layout.scale < 1 ? `scale(${layout.scale})` : void 0
          },
          children
        }
      )
    }
  );
};
ScaledDiagram.displayName = "ScaledDiagram";
var paddingStyles3 = {
  none: "p-0",
  sm: "p-3",
  md: "p-4",
  lg: "p-6",
  xl: "p-8"
};
var variantStyles6 = {
  default: "",
  // An explicit surface, like Card: always paints, and blocks inside stay flat.
  card: "surface-content",
  bordered: [
    "border-[length:var(--border-width)] border-border",
    "rounded-container"
  ].join(" "),
  filled: "bg-muted rounded-container"
};
var Section = ({
  title,
  description,
  action,
  padding = "md",
  variant = "default",
  divider = false,
  className,
  children,
  headerClassName,
  contentClassName,
  as: Component = "section",
  ...rest
}) => {
  const hasHeader = title || description || action;
  const wrap = (node) => variant === "card" ? /* @__PURE__ */ jsx(SurfaceBoundary, { children: node }) : node;
  return React93__default.createElement(
    Component,
    {
      ...domPassthrough(rest),
      className: cn(
        paddingStyles3[padding],
        variantStyles6[variant],
        className
      )
    },
    wrap(/* @__PURE__ */ jsxs(Fragment, { children: [
      hasHeader && /* @__PURE__ */ jsxs(
        Box,
        {
          className: cn(
            "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-4",
            divider && "pb-4 mb-4 border-b-[length:var(--border-width)] border-border",
            !divider && "mb-4",
            headerClassName
          ),
          children: [
            /* @__PURE__ */ jsxs(Box, { className: "flex-1 min-w-0", children: [
              title && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "h4",
                  className: "text-foreground",
                  children: title
                }
              ),
              description && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "body",
                  color: "muted",
                  className: "mt-1",
                  children: description
                }
              )
            ] }),
            action && /* @__PURE__ */ jsx(Box, { className: "flex-shrink-0 flex items-center gap-2", children: action })
          ]
        }
      ),
      /* @__PURE__ */ jsx(Box, { className: contentClassName, children })
    ] }))
  );
};
Section.displayName = "Section";
var SegmentRenderer = ({
  segments: segmentsProp,
  lesson,
  activationSaveEvent,
  reflectionSaveEvent,
  bloomAnswerEvent,
  askEvent,
  noteEvent,
  askLabel,
  noteLabel,
  annotations,
  annotationEvent,
  className,
  containerClassName,
  userProgress,
  runCodeEvent,
  resetCodeEvent,
  codeOutputs,
  runningCode,
  onRenderVisualization,
  ...rest
}) => {
  const segments = useMemo(
    () => lesson !== void 0 ? parseLessonSegments(lesson) : segmentsProp ?? [],
    [lesson, segmentsProp]
  );
  const annotationOwner = useMemo(() => {
    const owner = /* @__PURE__ */ new Map();
    for (const annotation of annotations ?? []) {
      const at = segments.findIndex((s) => s.type === "markdown" && s.content.includes(annotation.text));
      if (at >= 0) owner.set(at, [...owner.get(at) ?? [], annotation]);
    }
    return owner;
  }, [annotations, segments]);
  if (segments.length === 0) return null;
  let reflectIndex = 0;
  let bloomIndex = 0;
  return /* @__PURE__ */ jsx(SelectionAnnotator, { askEvent, noteEvent, askLabel, noteLabel, children: /* @__PURE__ */ jsx(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "border border-border rounded-container p-2 md:p-4 overflow-x-auto space-y-6",
        containerClassName,
        className
      ),
      children: segments.map((segment, index) => {
        if (segment.type === "markdown") {
          return /* @__PURE__ */ jsx(
            MarkdownContent,
            {
              content: segment.content,
              annotations: annotationOwner.get(index),
              annotationEvent
            },
            `md-${index}`
          );
        }
        if (segment.type === "code") {
          if (segment.language === "mermaid") {
            return /* @__PURE__ */ jsx(MermaidDiagram, { code: segment.content }, `code-${index}`);
          }
          if (segment.runnable && runCodeEvent) {
            const runId = String(index);
            return /* @__PURE__ */ jsx(
              CodeRunnerPanel,
              {
                language: segment.language,
                code: segment.content,
                runnable: true,
                runEvent: runCodeEvent,
                resetEvent: resetCodeEvent,
                runId,
                output: codeOutputs?.[runId] ?? null,
                running: runningCode === runId
              },
              `code-${index}`
            );
          }
          return /* @__PURE__ */ jsx(
            CodeBlock,
            {
              language: segment.language ?? "text",
              code: segment.content
            },
            `code-${index}`
          );
        }
        if (segment.type === "quiz") {
          return /* @__PURE__ */ jsx(QuizBlock, { question: segment.question, answer: segment.answer }, `quiz-${index}`);
        }
        if (segment.type === "activate") {
          return /* @__PURE__ */ jsx(
            ActivationBlock,
            {
              question: segment.question,
              savedResponse: userProgress?.activationResponse,
              saveEvent: activationSaveEvent
            },
            `activate-${index}`
          );
        }
        if (segment.type === "connect") {
          return /* @__PURE__ */ jsx(ConnectionBlock, { content: segment.content }, `connect-${index}`);
        }
        if (segment.type === "reflect") {
          const ri = reflectIndex++;
          return /* @__PURE__ */ jsx(
            ReflectionBlock,
            {
              prompt: segment.prompt,
              index: ri,
              savedNote: userProgress?.reflectionNotes?.[ri],
              saveEvent: reflectionSaveEvent
            },
            `reflect-${index}`
          );
        }
        if (segment.type === "bloom") {
          const bi = bloomIndex++;
          return /* @__PURE__ */ jsx(
            BloomQuizBlock,
            {
              level: segment.level,
              question: segment.question,
              answer: segment.answer,
              index: bi,
              isAnswered: userProgress?.bloomAnswered?.[bi],
              answerEvent: bloomAnswerEvent
            },
            `bloom-${index}`
          );
        }
        if (segment.type === "visualization") {
          return onRenderVisualization ? onRenderVisualization(segment.visualizationType, segment.description, index) ?? null : null;
        }
        return null;
      })
    }
  ) });
};
SegmentRenderer.displayName = "SegmentRenderer";
var SidePanel = ({
  title,
  children,
  isOpen,
  onClose,
  width = "w-full sm:w-96",
  position = "right",
  showOverlay = true,
  className,
  closeEvent,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const handleClose = () => {
    if (closeEvent) eventBus.emit(`UI:${closeEvent}`, {});
    onClose();
  };
  const { mounted, className: panelAnim, onAnimationEnd } = usePresence(isOpen, { animation: "drawer" });
  const drawerSign = position === "right" ? 1 : -1;
  if (!mounted) return null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    showOverlay && /* @__PURE__ */ jsx(Presence, { show: isOpen, animation: "overlay", children: /* @__PURE__ */ jsx(
      Box,
      {
        className: "fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden",
        onClick: handleClose
      }
    ) }),
    /* @__PURE__ */ jsxs(
      Aside,
      {
        ...domPassthrough(rest),
        className: cn(
          "fixed top-16 lg:top-0 bottom-0 z-[60]",
          "bg-card surface-material",
          "border-l-heavy border-border",
          position === "left" && "border-l-0 border-r-heavy",
          "flex flex-col",
          panelAnim,
          width,
          position === "right" ? "right-0" : "left-0",
          className
        ),
        style: { "--motion-drawer-sign": drawerSign },
        onAnimationEnd,
        children: [
          /* @__PURE__ */ jsxs(Box, { className: "flex items-center justify-between p-4 border-b-heavy border-border sticky top-0 bg-card z-10", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "h6", children: title }),
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                icon: "x",
                onClick: handleClose,
                "aria-label": t("aria.closePanel"),
                children: /* @__PURE__ */ jsx(Typography, { variant: "small", as: "span", className: "sr-only", children: t("aria.closePanel") })
              }
            )
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "p-4 flex-1 overflow-y-auto", children: /* @__PURE__ */ jsx(SurfaceBoundary, { children }) })
        ]
      }
    )
  ] });
};
SidePanel.displayName = "SidePanel";
var SidebarNavItem = ({ item, collapsed }) => {
  const isActive = item.active ?? item.isActive;
  return /* @__PURE__ */ jsxs(
    Button,
    {
      variant: "ghost",
      href: item.href,
      onClick: item.onClick,
      className: cn(
        "w-full flex items-center gap-3 px-3 py-2.5 transition-all duration-fast group relative",
        "rounded-interactive border-[length:var(--border-width-thin)] border-transparent",
        isActive ? [
          "bg-primary text-primary-foreground",
          "font-medium shadow-elevation-interactive",
          "border-primary translate-x-1 rtl:-translate-x-1 -translate-y-0.5"
        ].join(" ") : [
          "text-foreground",
          "hover:bg-muted hover:border-border",
          "active:bg-primary active:text-primary-foreground"
        ].join(" ")
      ),
      title: collapsed ? item.label : void 0,
      "aria-current": isActive ? "page" : void 0,
      children: [
        item.icon && (typeof item.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: item.icon, size: "sm", className: cn("min-w-[20px] flex-shrink-0", isActive && "text-primary-foreground") }) : /* @__PURE__ */ jsx(Icon, { icon: item.icon, size: "sm", className: cn("min-w-[20px] flex-shrink-0", isActive && "text-primary-foreground") })),
        !collapsed && /* @__PURE__ */ jsx(Typography, { variant: "body", color: isActive ? "inherit" : "primary", className: "font-medium truncate flex-1 text-start", children: item.label }),
        !collapsed && item.badge !== void 0 && /* @__PURE__ */ jsx(Badge, { variant: "danger", size: "sm", children: item.badge }),
        collapsed && /* @__PURE__ */ jsx(Box, { className: cn(
          "absolute start-full ms-2 px-2 py-1 text-xs opacity-0 group-hover:opacity-100",
          "pointer-events-none whitespace-nowrap z-50 transition-opacity",
          "bg-primary text-primary-foreground",
          "border-[length:var(--border-width-thin)] border-border",
          "rounded-interactive"
        ), children: item.label })
      ]
    }
  );
};
var Sidebar = ({
  logo,
  logoSrc,
  brandName = "KFlow",
  items,
  userSection,
  footerContent,
  collapsed: controlledCollapsed,
  defaultCollapsed = false,
  collapseChangeEvent,
  hideCollapseButton = false,
  showCloseButton = false,
  closeEvent,
  logoClickEvent,
  className,
  ...rest
}) => {
  const { emit } = useEventBus();
  const { t } = useTranslate();
  const [internalCollapsed, setInternalCollapsed] = useState(defaultCollapsed);
  const collapsed = controlledCollapsed !== void 0 ? controlledCollapsed : internalCollapsed;
  const handleToggle = useCallback(() => {
    const newCollapsed = !collapsed;
    if (controlledCollapsed === void 0) {
      setInternalCollapsed(newCollapsed);
    }
    if (collapseChangeEvent) {
      emit(collapseChangeEvent, { collapsed: newCollapsed });
    }
  }, [collapsed, controlledCollapsed, collapseChangeEvent, emit]);
  const handleClose = useCallback(() => {
    if (closeEvent) {
      emit(closeEvent, {});
    }
  }, [closeEvent, emit]);
  const handleLogoClick = useCallback(() => {
    if (logoClickEvent) {
      emit(logoClickEvent, {});
    }
  }, [logoClickEvent, emit]);
  return /* @__PURE__ */ jsxs(
    Box,
    {
      as: "aside",
      ...domPassthrough(rest),
      className: cn(
        "flex flex-col h-full",
        "bg-card border-e border-border",
        "transition-all duration-normal ease-standard",
        collapsed ? "w-20" : "w-64",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(Box, { className: "h-16 flex items-center justify-between px-4 border-b border-border flex-shrink-0", children: [
          /* @__PURE__ */ jsxs(
            Box,
            {
              className: cn(
                "flex items-center gap-3 cursor-pointer",
                collapsed && "justify-center w-full"
              ),
              ...pressableProps(logoClickEvent ? handleLogoClick : void 0),
              "aria-label": logoClickEvent ? brandName : void 0,
              children: [
                logo ? typeof logo === "string" ? /* @__PURE__ */ jsx("img", { src: logo, alt: brandName, className: "h-8 w-8" }) : logo : logoSrc ? /* @__PURE__ */ jsx("img", { src: logoSrc, alt: brandName, className: "h-8 w-8" }) : /* @__PURE__ */ jsx(Box, { className: "h-8 w-8 bg-primary flex items-center justify-center rounded-interactive", children: /* @__PURE__ */ jsx(Typography, { variant: "small", className: "text-primary-foreground font-bold text-sm", children: "K" }) }),
                !collapsed && /* @__PURE__ */ jsx(Typography, { variant: "body", className: "heading-voice text-xl text-foreground", children: brandName })
              ]
            }
          ),
          !hideCollapseButton && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: handleToggle,
              className: cn(
                "p-1.5 hover:bg-muted text-foreground hidden lg:block",
                "rounded-interactive",
                collapsed && "mx-auto"
              ),
              title: collapsed ? t("sidebar.expand") : t("sidebar.collapse"),
              children: collapsed ? /* @__PURE__ */ jsx(ChevronRight, { size: 18 }) : /* @__PURE__ */ jsx(ChevronLeft, { size: 18 })
            }
          ),
          showCloseButton && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: handleClose,
              className: "p-1.5 hover:bg-muted text-foreground lg:hidden rounded-interactive",
              "aria-label": t("sidebar.close"),
              children: /* @__PURE__ */ jsx(X, { size: 18 })
            }
          )
        ] }),
        /* @__PURE__ */ jsx(Box, { as: "nav", className: "flex-1 py-6 px-3 space-y-1 overflow-y-auto", children: items.map((item) => /* @__PURE__ */ jsx(
          SidebarNavItem,
          {
            item,
            collapsed
          },
          item.id
        )) }),
        (footerContent || userSection) && /* @__PURE__ */ jsxs(Box, { className: "p-3 border-t border-border space-y-1 flex-shrink-0", children: [
          /* @__PURE__ */ jsxs(Box, { className: cn(
            "flex items-center",
            collapsed ? "justify-center flex-col gap-4" : "justify-between px-2"
          ), children: [
            footerContent && /* @__PURE__ */ jsx(Box, { className: "flex items-center", children: footerContent }),
            userSection && /* @__PURE__ */ jsx(Box, { className: "flex items-center", children: userSection })
          ] }),
          collapsed && !hideCollapseButton && /* @__PURE__ */ jsx(
            Button,
            {
              variant: "ghost",
              onClick: handleToggle,
              className: "w-full flex justify-center p-2 mt-2 text-muted-foreground hover:text-foreground lg:hidden",
              children: /* @__PURE__ */ jsx(ChevronRight, { size: 20 })
            }
          )
        ] })
      ]
    }
  );
};
Sidebar.displayName = "Sidebar";
var SignaturePad = ({
  label,
  helperText,
  strokeColor,
  strokeWidth = 2,
  height = 200,
  readOnly = false,
  value,
  onChange,
  signEvent,
  clearEvent,
  isLoading = false,
  error,
  className,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const resolvedLabel = label ?? t("signaturePad.label");
  const resolvedHelperText = helperText ?? t("signaturePad.helperText");
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [hasSignature, setHasSignature] = useState(!!value);
  useEffect(() => {
    if (value && canvasRef.current) {
      const ctx = canvasRef.current.getContext("2d");
      if (!ctx) return;
      const img = new Image();
      img.onload = () => {
        ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
        ctx.drawImage(img, 0, 0);
        setHasSignature(true);
      };
      img.src = value;
    }
  }, [value]);
  const getCoords = useCallback(
    (e) => {
      const canvas = canvasRef.current;
      if (!canvas) return { x: 0, y: 0 };
      const rect = canvas.getBoundingClientRect();
      if ("touches" in e) {
        const touch = e.touches[0];
        return {
          x: touch.clientX - rect.left,
          y: touch.clientY - rect.top
        };
      }
      return {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top
      };
    },
    []
  );
  const startDrawing = useCallback(
    (e) => {
      if (readOnly) return;
      const ctx = canvasRef.current?.getContext("2d");
      if (!ctx) return;
      const { x, y } = getCoords(e);
      ctx.beginPath();
      ctx.moveTo(x, y);
      setIsDrawing(true);
    },
    [readOnly, getCoords]
  );
  const draw = useCallback(
    (e) => {
      if (!isDrawing || readOnly) return;
      const ctx = canvasRef.current?.getContext("2d");
      if (!ctx) return;
      const { x, y } = getCoords(e);
      const resolvedColor = strokeColor || "var(--color-foreground)";
      ctx.strokeStyle = resolvedColor;
      ctx.lineWidth = strokeWidth;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.lineTo(x, y);
      ctx.stroke();
    },
    [isDrawing, readOnly, strokeColor, strokeWidth, getCoords]
  );
  const stopDrawing = useCallback(() => {
    if (isDrawing) {
      setIsDrawing(false);
      setHasSignature(true);
      const dataUrl = canvasRef.current?.toDataURL("image/png") ?? null;
      onChange?.(dataUrl);
    }
  }, [isDrawing, onChange]);
  const clearSignature = useCallback(() => {
    const ctx = canvasRef.current?.getContext("2d");
    if (ctx && canvasRef.current) {
      ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
    }
    setHasSignature(false);
    onChange?.(null);
    if (clearEvent) {
      eventBus.emit(`UI:${clearEvent}`, {});
    }
  }, [onChange, clearEvent, eventBus]);
  const confirmSignature = useCallback(() => {
    const dataUrl = canvasRef.current?.toDataURL("image/png") ?? null;
    if (signEvent) {
      eventBus.emit(`UI:${signEvent}`, { signature: dataUrl });
    }
  }, [signEvent, eventBus]);
  if (isLoading) {
    return /* @__PURE__ */ jsx(LoadingState, { message: t("common.loading"), className });
  }
  if (error) {
    return /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: t("display.signaturePadError"),
        message: error.message,
        className
      }
    );
  }
  return /* @__PURE__ */ jsx(Card, { className: cn("p-4", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", children: [
    resolvedLabel && /* @__PURE__ */ jsx(Typography, { variant: "label", weight: "medium", children: resolvedLabel }),
    /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "w-full rounded-container border border-border",
          "bg-background",
          readOnly && "opacity-60 cursor-not-allowed",
          !readOnly && "cursor-crosshair"
        ),
        children: /* @__PURE__ */ jsx(
          "canvas",
          {
            ref: canvasRef,
            width: 600,
            height,
            className: "w-full touch-none",
            style: { height },
            role: "img",
            "aria-label": resolvedLabel || t("signaturePad.label"),
            ...domPassthrough(rest),
            onMouseDown: startDrawing,
            onMouseMove: draw,
            onMouseUp: stopDrawing,
            onMouseLeave: stopDrawing,
            onTouchStart: startDrawing,
            onTouchMove: draw,
            onTouchEnd: stopDrawing
          }
        )
      }
    ),
    resolvedHelperText && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: resolvedHelperText }),
    !readOnly && /* @__PURE__ */ jsxs(HStack, { gap: "sm", justify: "end", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          icon: Eraser,
          onClick: clearSignature,
          disabled: !hasSignature,
          children: t("signaturePad.clear")
        }
      ),
      signEvent && /* @__PURE__ */ jsx(
        Button,
        {
          variant: "primary",
          size: "sm",
          icon: Check,
          onClick: confirmSignature,
          disabled: !hasSignature,
          children: t("signaturePad.confirm")
        }
      )
    ] })
  ] }) });
};
SignaturePad.displayName = "SignaturePad";
var LogosVariant = ({ items }) => /* @__PURE__ */ jsx(HStack, { gap: "xl", justify: "center", className: "flex-wrap", children: items.map((item) => /* @__PURE__ */ jsx(
  Box,
  {
    className: "opacity-60 hover:opacity-100 transition-opacity cursor-default",
    children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "center", children: [
      item.logo && /* @__PURE__ */ jsx(
        Box,
        {
          className: "w-12 h-12 bg-contain bg-center bg-no-repeat",
          style: { backgroundImage: `url(${item.logo})` }
        }
      ),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: item.name })
    ] })
  },
  item.name
)) });
LogosVariant.displayName = "SocialProof.LogosVariant";
var QuotesVariant = ({ items }) => {
  const cols = items.length >= 3 ? 3 : items.length >= 2 ? 2 : 1;
  return /* @__PURE__ */ jsx(SimpleGrid, { cols, gap: "md", children: items.map((item) => /* @__PURE__ */ jsx(Card, { variant: "bordered", padding: "md", children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", align: "start", children: [
    item.quote && /* @__PURE__ */ jsxs(Typography, { variant: "body", className: "italic", children: [
      "\u201C",
      item.quote,
      "\u201D"
    ] }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: item.name })
  ] }) }, item.name)) });
};
QuotesVariant.displayName = "SocialProof.QuotesVariant";
var BadgesVariant = ({ items }) => /* @__PURE__ */ jsx(HStack, { gap: "sm", justify: "center", className: "flex-wrap", children: items.map((item) => /* @__PURE__ */ jsx(Badge, { size: "md", children: item.name }, item.name)) });
BadgesVariant.displayName = "SocialProof.BadgesVariant";
var SocialProof = ({
  items,
  variant = "logos",
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn(className), children: [
    variant === "logos" && /* @__PURE__ */ jsx(LogosVariant, { items }),
    variant === "quotes" && /* @__PURE__ */ jsx(QuotesVariant, { items }),
    variant === "badges" && /* @__PURE__ */ jsx(BadgesVariant, { items })
  ] });
};
SocialProof.displayName = "SocialProof";
var EMPTY_ITEMS = [];
function useSafeEventBus8() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
function SortableListInner({
  items: initialItemsProp = EMPTY_ITEMS,
  renderItem,
  reorderEvent,
  reorderPayload,
  dragHandlePosition = "left",
  className,
  ...rest
}) {
  const eventBus = useSafeEventBus8();
  const initialItems = Array.isArray(initialItemsProp) ? initialItemsProp : initialItemsProp ? [initialItemsProp] : [];
  const handleReorder = useCallback(
    (fromIndex, toIndex, item) => {
      eventBus.emit(`UI:${reorderEvent}`, {
        fromIndex,
        toIndex,
        item,
        ...reorderPayload
      });
    },
    [eventBus, reorderEvent, reorderPayload]
  );
  const {
    items,
    dragIndex,
    dragOverIndex,
    isDragging,
    getDragHandleProps,
    getItemProps
  } = useDragReorder(initialItems, handleReorder);
  return /* @__PURE__ */ jsx(VStack, { ...domPassthrough(rest), gap: "none", className: cn("w-full", className), children: items.map((item, index) => {
    const { "aria-dropeffect": ariaDropEffect, ...itemProps } = getItemProps(index);
    const { "aria-grabbed": ariaGrabbed, ...handleRest } = getDragHandleProps(index);
    const isBeingDragged = dragIndex === index;
    const showDropIndicator = isDragging && dragOverIndex === index && dragOverIndex !== dragIndex;
    const dragHandle = /* @__PURE__ */ jsx(
      Box,
      {
        className: cn(
          "flex items-center justify-center",
          "text-muted-foreground",
          "hover:text-foreground",
          "transition-colors duration-instant",
          "px-1"
        ),
        "aria-grabbed": ariaGrabbed,
        ...handleRest,
        children: /* @__PURE__ */ jsx(Icon, { name: "grip-vertical", size: "sm" })
      }
    );
    return /* @__PURE__ */ jsxs(
      Box,
      {
        "aria-dropeffect": ariaDropEffect,
        ...itemProps,
        children: [
          showDropIndicator && /* @__PURE__ */ jsx(
            Box,
            {
              className: "h-0.5 bg-primary rounded-full",
              style: { margin: "0 8px" }
            }
          ),
          /* @__PURE__ */ jsxs(
            HStack,
            {
              gap: "sm",
              align: "center",
              className: cn(
                "transition-opacity duration-fast",
                isBeingDragged && "opacity-50"
              ),
              children: [
                dragHandlePosition === "left" && dragHandle,
                /* @__PURE__ */ jsx(Box, { className: "flex-1 min-w-0", children: typeof renderItem === "function" ? renderItem(item, index) : JSON.stringify(item) }),
                dragHandlePosition === "right" && dragHandle
              ]
            }
          )
        ]
      },
      index
    );
  }) });
}
var SortableList = SortableListInner;
SortableList.displayName = "SortableList";
var gapStyles7 = {
  none: "gap-0",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8"
};
var alignStyles3 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch"
};
var ratioStyles = {
  "1:1": ["w-1/2", "w-1/2"],
  "1:2": ["w-1/3", "w-2/3"],
  "2:1": ["w-2/3", "w-1/3"],
  "1:3": ["w-1/4", "w-3/4"],
  "3:1": ["w-3/4", "w-1/4"],
  "1:4": ["w-1/5", "w-4/5"],
  "4:1": ["w-4/5", "w-1/5"],
  "2:3": ["w-2/5", "w-3/5"],
  "3:2": ["w-3/5", "w-2/5"]
};
var breakpointPrefixes = {
  sm: "@sm:",
  md: "@md:",
  lg: "@lg:",
  xl: "@xl:"
};
var Split = ({
  ratio = "1:1",
  gap = "md",
  reverse = false,
  stackOnMobile = true,
  stackBreakpoint = "md",
  align = "stretch",
  className,
  leftClassName,
  rightClassName,
  children,
  ...rest
}) => {
  const [left, right] = children;
  const [leftRatio, rightRatio] = ratioStyles[ratio];
  const bp = breakpointPrefixes[stackBreakpoint];
  const leftWidth = stackOnMobile ? `w-full ${bp}${leftRatio}` : leftRatio;
  const rightWidth = stackOnMobile ? `w-full ${bp}${rightRatio}` : rightRatio;
  const row = /* @__PURE__ */ jsxs(
    Box,
    {
      className: cn(
        "flex",
        stackOnMobile ? `flex-col ${bp}flex-row` : "flex-row",
        reverse && (stackOnMobile ? `${bp}flex-row-reverse` : "flex-row-reverse"),
        gapStyles7[gap],
        alignStyles3[align],
        stackOnMobile ? void 0 : className
      ),
      ...stackOnMobile ? {} : domPassthrough(rest),
      children: [
        /* @__PURE__ */ jsx(Box, { className: cn(leftWidth, leftClassName), children: left }),
        /* @__PURE__ */ jsx(Box, { className: cn(rightWidth, rightClassName), children: right })
      ]
    }
  );
  return stackOnMobile ? /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("@container w-full", className), children: row }) : row;
};
Split.displayName = "Split";
function useSafeEventBus9() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var sizeStyles12 = {
  sm: { star: "w-4 h-4", gap: "gap-0.5" },
  md: { star: "w-6 h-6", gap: "gap-1" },
  lg: { star: "w-8 h-8", gap: "gap-1.5" }
};
var StarRating = ({
  value = 0,
  max = 5,
  readOnly = false,
  precision = "full",
  size: size2 = "md",
  action,
  actionPayload,
  onChange,
  className,
  label,
  ...rest
}) => {
  const [hoverValue, setHoverValue] = useState(null);
  const eventBus = useSafeEventBus9();
  const styles = sizeStyles12[size2];
  const displayValue = hoverValue ?? value;
  const { t } = useTranslate();
  const emitChange = useCallback(
    (newValue) => {
      onChange?.(newValue);
      if (action) {
        eventBus.emit(`UI:${action}`, { ...actionPayload, value: newValue });
      }
    },
    [onChange, action, actionPayload, eventBus]
  );
  const handleStarClick = (starIndex, isHalf) => {
    if (readOnly) return;
    const newValue = isHalf && precision === "half" ? starIndex + 0.5 : starIndex + 1;
    emitChange(newValue);
  };
  const handleStarHover = (starIndex, isHalf) => {
    if (readOnly) return;
    const newValue = isHalf && precision === "half" ? starIndex + 0.5 : starIndex + 1;
    setHoverValue(newValue);
  };
  const handleKeyDown = (e) => {
    if (readOnly) return;
    const stepSize = precision === "half" ? 0.5 : 1;
    if (e.key === "ArrowRight" || e.key === "ArrowUp") {
      e.preventDefault();
      emitChange(Math.min(max, value + stepSize));
    } else if (e.key === "ArrowLeft" || e.key === "ArrowDown") {
      e.preventDefault();
      emitChange(Math.max(0, value - stepSize));
    } else if (e.key === "Home") {
      e.preventDefault();
      emitChange(0);
    } else if (e.key === "End") {
      e.preventDefault();
      emitChange(max);
    }
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      ...domPassthrough(rest),
      className: cn(
        "inline-flex items-center",
        styles.gap,
        !readOnly && "cursor-pointer",
        className
      ),
      role: readOnly ? "img" : "slider",
      "aria-label": rest["aria-label"] ?? label ?? t("aria.ratingValue", { value, max }),
      "aria-valuemin": readOnly ? void 0 : 0,
      "aria-valuemax": readOnly ? void 0 : max,
      "aria-valuenow": readOnly ? void 0 : value,
      "aria-valuetext": readOnly ? void 0 : t("aria.ratingValue", { value, max }),
      tabIndex: readOnly ? void 0 : 0,
      onKeyDown: handleKeyDown,
      onPointerLeave: () => setHoverValue(null),
      children: Array.from({ length: max }, (_, i) => {
        const fillLevel = Math.max(0, Math.min(1, displayValue - i));
        const isFull = fillLevel >= 1;
        const isHalf = fillLevel >= 0.5 && fillLevel < 1;
        return /* @__PURE__ */ jsxs(
          "span",
          {
            "aria-hidden": "true",
            className: "relative inline-block",
            onClick: () => handleStarClick(i, false),
            onPointerMove: (e) => {
              if (readOnly) return;
              const rect = e.currentTarget.getBoundingClientRect();
              const isLeftHalf = e.clientX - rect.left < rect.width / 2;
              handleStarHover(i, isLeftHalf);
            },
            children: [
              /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "star",
                  className: cn(
                    styles.star,
                    "text-foreground/30",
                    "transition-colors duration-instant"
                  ),
                  strokeWidth: 1.5
                }
              ),
              (isFull || isHalf) && /* @__PURE__ */ jsx(
                Icon,
                {
                  name: "star",
                  className: cn(
                    styles.star,
                    "absolute inset-0",
                    "text-warning fill-warning",
                    "transition-colors duration-instant"
                  ),
                  strokeWidth: 1.5,
                  style: isHalf ? { clipPath: "inset(0 50% 0 0)" } : void 0
                }
              ),
              !readOnly && precision === "half" && /* @__PURE__ */ jsx(
                "span",
                {
                  className: "absolute inset-0 w-1/2",
                  onClick: (e) => {
                    e.stopPropagation();
                    handleStarClick(i, true);
                  }
                }
              )
            ]
          },
          i
        );
      })
    }
  );
};
StarRating.displayName = "StarRating";
var StatCard = ({
  label: propLabel,
  title: propTitle,
  value: propValue,
  previousValue,
  currentValue,
  trend: manualTrend,
  trendDirection: manualDirection,
  invertTrend = false,
  icon: iconProp,
  iconBg = "bg-muted",
  iconColor = "text-foreground",
  subtitle,
  action,
  className,
  // Schema-based props
  entity,
  metrics,
  sparklineData,
  isLoading: externalLoading,
  error: externalError,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const tileClass = cn(contentSurface.className ?? "rounded-container border border-border", "p-4");
  const Icon2 = typeof iconProp === "string" ? resolveIcon(iconProp) ?? void 0 : iconProp;
  const labelToUse = propLabel ?? propTitle;
  const eventBus = useEventBus();
  const { t, locale } = useTranslate();
  const fmt2 = useFormatContext();
  const handleActionClick = React93__default.useCallback(() => {
    if (action?.event) {
      eventBus.emit(`UI:${action.event}`, {});
    }
    if (action?.onClick) {
      action.onClick();
    }
  }, [action, eventBus]);
  const data = Array.isArray(entity) ? entity : entity ? [entity] : [];
  const isLoading = externalLoading ?? false;
  const error = externalError;
  const computeMetricValue = React93__default.useCallback(
    (metric, items) => {
      if (metric.value !== void 0) return metric.value;
      const rows2 = metric.filter ? items.filter((item) => item[metric.filter.field] === metric.filter.equals) : items;
      if (metric.aggregate === "count") return rows2.length;
      if (!metric.field) return 0;
      const field = metric.field;
      return rows2.reduce((acc, item) => {
        const val = item[field];
        return acc + (typeof val === "number" ? val : 0);
      }, 0);
    },
    []
  );
  const schemaStats = React93__default.useMemo(() => {
    if (!metrics || metrics.length === 0) return null;
    return metrics.map((metric) => ({
      label: metric.label,
      value: computeMetricValue(metric, data),
      format: metric.format
    }));
  }, [metrics, data, computeMetricValue]);
  const calculatedTrend = React93__default.useMemo(() => {
    if (manualTrend !== void 0) return manualTrend;
    if (previousValue === void 0 || currentValue === void 0)
      return void 0;
    if (previousValue === 0) return currentValue > 0 ? 100 : 0;
    return (currentValue - previousValue) / previousValue * 100;
  }, [manualTrend, previousValue, currentValue]);
  if (schemaStats && schemaStats.length > 1) {
    if (isLoading) {
      return contentSurface.provide(
        /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("grid gap-4 grid-cols-[repeat(auto-fit,minmax(min(10rem,100%),1fr))]", className), children: schemaStats.map((_, idx) => /* @__PURE__ */ jsx(Box, { className: tileClass, children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "animate-pulse", children: [
          /* @__PURE__ */ jsx(Box, { className: "h-3 bg-muted rounded w-16" }),
          /* @__PURE__ */ jsx(Box, { className: "h-6 bg-muted rounded w-12" })
        ] }) }, idx)) })
      );
    }
    return contentSurface.provide(
      /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn("grid gap-4 grid-cols-[repeat(auto-fit,minmax(min(10rem,100%),1fr))]", className), children: schemaStats.map((stat, idx) => /* @__PURE__ */ jsxs(Box, { className: tileClass, children: [
        /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: stat.label }),
        /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "text-xl tabular-nums", children: formatValue(stat.value, stat.format ?? "number", fmt2) })
      ] }, idx)) })
    );
  }
  const label = schemaStats?.[0]?.label || labelToUse || t("statCard.defaultLabel");
  const normalizedPropValue = Array.isArray(propValue) ? propValue[0] ?? propValue.length : propValue;
  const value = schemaStats?.[0]?.value ?? normalizedPropValue ?? 0;
  const trendDirection = manualDirection || (calculatedTrend === void 0 || calculatedTrend === 0 ? "neutral" : calculatedTrend > 0 ? "up" : "down");
  const isPositive = invertTrend ? trendDirection === "down" : trendDirection === "up";
  const TrendIcon = trendDirection === "up" ? TrendingUp : trendDirection === "down" ? TrendingDown : Minus;
  if (error) {
    return contentSurface.provide(
      /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-6 rounded-container", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
        /* @__PURE__ */ jsx(Typography, { variant: "small", color: "error", children: t("error.generic") + ": " + error.message })
      ] }) })
    );
  }
  if (isLoading) {
    return contentSurface.provide(
      /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-6 rounded-container", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "sm", className: "animate-pulse", children: [
        /* @__PURE__ */ jsx(Box, { className: "h-4 bg-muted rounded w-24" }),
        /* @__PURE__ */ jsx(Box, { className: "h-8 bg-muted rounded w-32" }),
        /* @__PURE__ */ jsx(Box, { className: "h-4 bg-muted rounded w-20" })
      ] }) })
    );
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "p-6 rounded-container", className), children: [
      /* @__PURE__ */ jsxs(HStack, { align: "start", justify: "between", children: [
        /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
          /* @__PURE__ */ jsx(Typography, { variant: "h4", className: "text-2xl tabular-nums", children: typeof value === "number" ? formatValue(value, schemaStats?.[0]?.format ?? "number", fmt2) : value }),
          calculatedTrend !== void 0 && /* @__PURE__ */ jsxs(HStack, { align: "center", gap: "xs", children: [
            /* @__PURE__ */ jsxs(
              HStack,
              {
                align: "center",
                gap: "none",
                className: cn(
                  "gap-0.5 text-sm font-bold",
                  isPositive ? "text-success" : trendDirection === "neutral" ? "text-muted-foreground" : "text-error"
                ),
                children: [
                  /* @__PURE__ */ jsx(TrendIcon, { className: "h-4 w-4" }),
                  /* @__PURE__ */ jsx(Typography, { variant: "caption", as: "span", children: new Intl.NumberFormat(locale, { style: "percent", maximumFractionDigits: 1 }).format(Math.abs(calculatedTrend) / 100) })
                ]
              }
            ),
            /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", as: "span", children: t("statCard.vsLastPeriod") })
          ] }),
          subtitle && !calculatedTrend && /* @__PURE__ */ jsx(Typography, { variant: "small", color: "secondary", children: subtitle })
        ] }),
        /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "end", children: [
          Icon2 && /* @__PURE__ */ jsx(Box, { className: cn("p-3", iconBg), children: /* @__PURE__ */ jsx(Icon2, { className: cn("h-6 w-6", iconColor) }) }),
          sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto" })
        ] })
      ] }),
      action && /* @__PURE__ */ jsxs(
        Button,
        {
          variant: "ghost",
          onClick: handleActionClick,
          className: "mt-4 text-sm font-bold text-foreground hover:underline",
          "data-testid": action.event ? actionTestId(action.event) : void 0,
          children: [
            action.label,
            " \u2192"
          ]
        }
      )
    ] })
  );
};
StatCard.displayName = "StatCard";
var lookStyles9 = {
  elevated: "",
  flat: "shadow-none",
  "progress-backed": "",
  gauge: "",
  sparkline: ""
};
function composeDisplayValue(value, format, max, prefix, suffix, fmt2 = {}) {
  const formatted = value == null ? "0" : formatValue(value, format, fmt2);
  const withMax = max != null && max > 0 ? `${formatted} / ${new Intl.NumberFormat(fmt2.locale).format(max)}` : formatted;
  return `${prefix ?? ""}${withMax}${suffix ?? ""}`;
}
var variantColor = {
  default: "text-foreground",
  primary: "text-primary",
  success: "text-success",
  warning: "text-warning",
  error: "text-error",
  info: "text-info"
};
var StatDisplay = ({
  label,
  value,
  max,
  target,
  trend,
  trendPolarity = "higher-is-better",
  trendFormat = "absolute",
  sparklineData,
  clickEvent,
  prefix,
  suffix,
  icon: iconProp,
  iconBg = "bg-muted",
  iconColor = "text-foreground",
  format,
  size: size2 = "md",
  variant = "default",
  compact = false,
  look = "elevated",
  className,
  isLoading = false,
  skeleton = { variant: "stats", columns: 1 },
  error = null,
  surface = "auto",
  ...rest
}) => {
  const contentSurface = useContentSurface(surface);
  const eventBus = useEventBus();
  const fmt2 = useFormatContext();
  const handleClick = useCallback(() => {
    if (clickEvent) eventBus.emit(`UI:${clickEvent}`, { metricLabel: label });
  }, [clickEvent, eventBus, label]);
  const ResolvedIcon = typeof iconProp === "string" ? resolveIcon(iconProp) : typeof iconProp === "function" ? iconProp : null;
  const iconSizes3 = { sm: "h-4 w-4", md: "h-5 w-5", lg: "h-6 w-6" };
  const valueSizes = { sm: "text-lg", md: "text-2xl", lg: "text-3xl" };
  const padSizes = { sm: "p-3", md: "p-4", lg: "p-6" };
  const displayValue = composeDisplayValue(value, format, max, prefix, suffix, fmt2);
  const numericValue = typeof value === "number" ? value : Number(value);
  const showTarget = typeof target === "number" && target > 0 && Number.isFinite(numericValue);
  const targetPct = showTarget ? Math.max(0, Math.min(100, numericValue / target * 100)) : 0;
  const showTrend = typeof trend === "number" && trend !== 0 && Number.isFinite(trend);
  const trendUp = showTrend && trend > 0;
  const trendIsGood = trendPolarity === "lower-is-better" ? !trendUp : trendUp;
  const trendMagnitude = Math.abs(trend);
  const trendSuffix = trendFormat === "percent" ? "%" : "";
  const trendLabel = showTrend ? `${trendUp ? "\u2191" : "\u2193"} ${trendMagnitude}${trendSuffix}` : "";
  if (error) {
    return contentSurface.provide(
      /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: cn(contentSurface.className, "rounded-container", padSizes[size2], className), children: /* @__PURE__ */ jsx(Typography, { variant: "small", color: "error", children: error.message }) })
    );
  }
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton, { spec: skeleton, className });
  }
  if (compact) {
    return /* @__PURE__ */ jsxs(
      HStack,
      {
        ...domPassthrough(rest),
        gap: "sm",
        className: cn("items-center", clickEvent && "cursor-pointer hover:opacity-80", className),
        ...pressableProps(clickEvent ? handleClick : void 0),
        children: [
          ResolvedIcon && /* @__PURE__ */ jsx(ResolvedIcon, { className: cn(iconSizes3[size2], iconColor) }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: label }),
          /* @__PURE__ */ jsx(Typography, { variant: "h4", className: cn("", valueSizes[size2], variantColor[variant]), children: displayValue }),
          showTrend && /* @__PURE__ */ jsx(Typography, { variant: "caption", className: cn("font-semibold", trendIsGood ? "text-success" : "text-error"), children: trendLabel }),
          sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto", width: 60, height: 20 })
        ]
      }
    );
  }
  return contentSurface.provide(
    /* @__PURE__ */ jsx(
      Box,
      {
        ...domPassthrough(rest),
        className: cn(contentSurface.className, "rounded-container", padSizes[size2], lookStyles9[look], clickEvent && "cursor-pointer hover:shadow-elevation-dialog transition-shadow", className),
        ...pressableProps(clickEvent ? handleClick : void 0),
        children: /* @__PURE__ */ jsxs(HStack, { align: "start", justify: "between", children: [
          /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "space-y-1 flex-1", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "overline", color: "secondary", children: label }),
            /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "end", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "h4", className: cn("", valueSizes[size2], variantColor[variant]), children: displayValue }),
              showTrend && /* @__PURE__ */ jsx(
                Typography,
                {
                  variant: "caption",
                  className: cn("font-semibold pb-1", trendIsGood ? "text-success" : "text-error"),
                  children: trendLabel
                }
              )
            ] }),
            showTarget && /* @__PURE__ */ jsx(Box, { className: "mt-2 h-1.5 w-full bg-muted rounded-full overflow-hidden", children: /* @__PURE__ */ jsx(
              Box,
              {
                className: cn("h-full rounded-full transition-all", `bg-${variant === "default" ? "primary" : variant}`),
                style: { width: `${targetPct}%` }
              }
            ) })
          ] }),
          /* @__PURE__ */ jsxs(VStack, { gap: "xs", align: "end", children: [
            ResolvedIcon && /* @__PURE__ */ jsx(Box, { className: cn("p-3 rounded-container", iconBg), children: /* @__PURE__ */ jsx(ResolvedIcon, { className: cn(iconSizes3[size2], iconColor) }) }),
            sparklineData && sparklineData.length > 1 && /* @__PURE__ */ jsx(Sparkline, { data: sparklineData, color: "auto" })
          ] })
        ] })
      }
    )
  );
};
StatDisplay.displayName = "StatDisplay";
var StateMachineView = ({ trait, isLoading = false, error = null, className, ...rest }) => {
  const { t } = useTranslate();
  if (isLoading) return /* @__PURE__ */ jsx(LoadingState, { message: t("stateMachine.loading") });
  if (error) return /* @__PURE__ */ jsx(ErrorState, { message: error instanceof Error ? error.message : String(error) });
  if (!trait) {
    return /* @__PURE__ */ jsx(Box, { "data-testid": "state-machine-view-empty", padding: "lg", className: "text-center", children: /* @__PURE__ */ jsx(Typography, { variant: "body", color: "muted", children: t("stateMachine.noStateMachine") }) });
  }
  return /* @__PURE__ */ jsx(AvlStateMachine, { trait, className, ...rest });
};
StateMachineView.displayName = "StateMachineView";
function groupByOrbital(subagents, unattachedLabel) {
  const map = /* @__PURE__ */ new Map();
  for (const sub of subagents) {
    const key = sub.orbitalName ?? unattachedLabel;
    const arr = map.get(key) ?? [];
    arr.push(sub);
    map.set(key, arr);
  }
  return map;
}
function statusIconName(status) {
  switch (status) {
    case "running":
      return "loader";
    case "complete":
      return "check";
    case "error":
      return "x";
    default:
      return "circle";
  }
}
function lastMessage(sub) {
  if (sub.messages.length === 0) return void 0;
  return sub.messages[sub.messages.length - 1].message;
}
function formatHHMMSS(ts, locale) {
  return new Intl.DateTimeFormat(locale, { hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" }).format(new Date(ts));
}
function compactJson(value) {
  if (value === void 0 || value === null) return "";
  if (typeof value === "string") return value;
  try {
    const json = JSON.stringify(value);
    if (json.length <= 240) return json;
    return json.slice(0, 239) + "\u2026";
  } catch {
    return String(value);
  }
}
function tryPrettyJson(s) {
  try {
    return JSON.stringify(JSON.parse(s), null, 2);
  } catch {
    return null;
  }
}
function summarizeArgs(args) {
  const keys = Object.keys(args);
  if (keys.length === 0) return "";
  return keys.slice(0, 3).join(", ") + (keys.length > 3 ? ", \u2026" : "");
}
function previewText(text, max = 120) {
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 1) + "\u2026" : text;
}
function coordinatorToActivityItems(activities, t) {
  return activities.flatMap((a) => {
    switch (a.type) {
      case "tool_call":
        return [{ type: "tool_call", tool: a.tool, argsText: a.argsText, timestamp: a.timestamp }];
      case "tool_result":
        return [{ type: "tool_result", tool: a.tool, resultText: a.resultText, success: a.success, timestamp: a.timestamp }];
      case "message":
        return [{
          type: "message",
          role: a.role,
          content: a.content,
          timestamp: a.timestamp
        }];
      case "error":
        return [{
          type: "message",
          role: "system",
          content: t("subagentTrace.errorMessage", { message: a.message }),
          timestamp: a.timestamp
        }];
      case "coordinator_decision":
      case "plan_committed":
      case "pending_question":
      case "clarification_question":
      case "analysis":
      case "orbital_started":
      case "orbital_done":
      case "schema_change":
      case "done":
      case "cancelled":
        return [];
      case "llm_response":
        return [{
          type: "message",
          role: "assistant",
          content: a.content,
          timestamp: a.timestamp
        }];
      case "file_operation":
        return [{
          type: "file_operation",
          operation: a.operation,
          path: a.path,
          success: a.success,
          timestamp: a.timestamp
        }];
      case "schema_diff":
        return [{
          type: "schema_diff",
          filePath: a.filePath,
          hunks: a.hunks,
          timestamp: a.timestamp
        }];
    }
  });
}
function pluckCoordinatorState(activities) {
  let decision = null;
  let plan = null;
  const pendingQuestions = [];
  for (const a of activities) {
    if (a.type === "coordinator_decision") decision = a;
    else if (a.type === "plan_committed") plan = a;
    else if (a.type === "pending_question") pendingQuestions.push(a);
  }
  return { decision, plan, pendingQuestions };
}
var InlineActivityRow = ({ activity }) => {
  const { locale } = useTranslate();
  const time = formatHHMMSS(activity.timestamp, locale);
  const baseRow = "items-start px-3 py-1 hover:bg-[var(--color-surface)]";
  if (activity.type === "tool_call") {
    return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
      /* @__PURE__ */ jsx(Icon, { name: "terminal", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-primary)]" }),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] font-mono break-all whitespace-pre-wrap", children: [
        /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", weight: "semibold", className: "text-[11px] font-mono", children: activity.tool }),
        activity.argsText !== "" && activity.argsText !== "{}" && /* @__PURE__ */ jsxs(Typography, { as: "span", variant: "caption", color: "muted", className: "text-[11px] font-mono", children: [
          " ",
          activity.argsText
        ] })
      ] }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
    ] });
  }
  if (activity.type === "tool_result") {
    const success = activity.success !== false;
    return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
      /* @__PURE__ */ jsx(
        Icon,
        {
          name: success ? "check" : "x",
          size: "xs",
          className: `mt-0.5 flex-shrink-0 ${success ? "text-[var(--color-success)]" : "text-[var(--color-danger)]"}`
        }
      ),
      /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] font-mono break-all whitespace-pre-wrap", children: [
        /* @__PURE__ */ jsxs(Typography, { as: "span", variant: "caption", color: "muted", className: "text-[11px] font-mono", children: [
          activity.tool,
          ":",
          " "
        ] }),
        /* @__PURE__ */ jsx(Typography, { as: "span", variant: "caption", className: "text-[11px] font-mono", children: activity.resultText })
      ] }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
    ] });
  }
  if (activity.type === "message") {
    const role = activity.role;
    const iconName = role === "user" ? "user" : role === "system" ? "info" : "sparkles";
    const roleColor = role === "user" ? "text-[var(--color-primary)]" : role === "system" ? "text-[var(--color-muted-foreground)]" : "text-[var(--color-foreground)]";
    return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
      /* @__PURE__ */ jsx(Icon, { name: iconName, size: "xs", className: `mt-0.5 flex-shrink-0 ${roleColor}` }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] whitespace-pre-wrap break-words", children: activity.content }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
    ] });
  }
  if (activity.type === "error") {
    return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
      /* @__PURE__ */ jsx(Icon, { name: "alert-triangle", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-danger)]" }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "flex-1 min-w-0 text-[11px] text-[var(--color-danger)] whitespace-pre-wrap break-words", children: activity.message }),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
    ] });
  }
  return /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: baseRow, children: [
    /* @__PURE__ */ jsx(Icon, { name: "file", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-muted-foreground)]" }),
    /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "flex-1 min-w-0 text-[11px] font-mono break-all", children: [
      "[",
      activity.type,
      "] ",
      compactJson(activity)
    ] }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] flex-shrink-0 tabular-nums mt-0.5", children: time })
  ] });
};
var InlineActivityStream = ({ activities, autoScroll = true, className }) => {
  const endRef = React93__default.useRef(null);
  React93__default.useEffect(() => {
    if (!autoScroll) return;
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [activities.length, autoScroll]);
  return /* @__PURE__ */ jsxs(Box, { className, children: [
    activities.map((a, i) => /* @__PURE__ */ jsx(InlineActivityRow, { activity: a }, `${a.timestamp}-${i}`)),
    /* @__PURE__ */ jsx(Box, { ref: endRef })
  ] });
};
var CoordinatorCard = ({ snapshot, className }) => {
  const { t } = useTranslate();
  const { decision, plan, pendingQuestions } = snapshot;
  if (!decision && !plan && pendingQuestions.length === 0) return null;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      className: `px-3 py-2 border-b border-[var(--color-border)] bg-[var(--color-muted)]/30 ${className ?? ""}`,
      children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center mb-2", children: [
          /* @__PURE__ */ jsx(Icon, { name: "compass", size: "xs" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") })
        ] }),
        decision && /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "mb-2", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide", children: t("subagentTrace.organism") }),
            /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: decision.organism }),
            decision.priorOrganism && decision.priorOrganism !== decision.organism && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.wasOrganism", { organism: decision.priorOrganism }) })
          ] }),
          decision.reason && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[11px] mt-0.5", children: decision.reason })
        ] }),
        plan && plan.orbitals.length > 0 && /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "mb-2", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide mb-0.5", children: plan.orbitals.length === 1 ? t("subagentTrace.planOrbital", { count: plan.orbitals.length }) : t("subagentTrace.planOrbitals", { count: plan.orbitals.length }) }),
          /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "flex-wrap", children: plan.orbitals.map((o) => /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: o }, o)) })
        ] }),
        pendingQuestions.length > 0 && /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px] uppercase tracking-wide mb-0.5", children: pendingQuestions.length === 1 ? t("subagentTrace.pendingQuestion", { count: pendingQuestions.length }) : t("subagentTrace.pendingQuestions", { count: pendingQuestions.length }) }),
          pendingQuestions.map((q) => /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-start", children: [
            /* @__PURE__ */ jsx(Icon, { name: "help-circle", size: "xs", className: "mt-0.5 flex-shrink-0 text-[var(--color-warning)]" }),
            /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "text-[11px] flex-1 min-w-0", children: [
              q.question,
              q.orbitalName && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px] ml-1", children: [
                "(",
                q.orbitalName,
                ")"
              ] })
            ] })
          ] }, q.questionId))
        ] })
      ]
    }
  );
};
function subagentMessagesToActivities(messages) {
  return messages.map((m) => {
    if (m.tool) {
      return {
        type: "tool_call",
        tool: m.tool,
        argsText: m.message,
        timestamp: m.timestamp
      };
    }
    return {
      type: "message",
      role: "system",
      content: m.message,
      timestamp: m.timestamp
    };
  });
}
var SubagentRow = ({ subagent }) => {
  const recent = lastMessage(subagent);
  return /* @__PURE__ */ jsxs(
    HStack,
    {
      gap: "sm",
      className: "items-start px-3 py-2 border-b border-[var(--color-border)]",
      children: [
        /* @__PURE__ */ jsx(Box, { className: "pt-0.5", children: /* @__PURE__ */ jsx(Icon, { name: statusIconName(subagent.status), size: "xs" }) }),
        /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-medium truncate", children: subagent.name }),
            /* @__PURE__ */ jsx(Badge, { variant: "default", children: subagent.role })
          ] }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "truncate", children: recent ?? subagent.task })
        ] })
      ]
    }
  );
};
var OrbitalGroup = ({ orbitalName, subagents }) => {
  const { t } = useTranslate();
  const runningCount = subagents.filter((s) => s.status === "running").length;
  const completeCount = subagents.filter((s) => s.status === "complete").length;
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "border-b border-[var(--color-border)]", children: [
    /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        className: "items-center px-3 py-2 bg-[var(--color-surface)] border-b border-[var(--color-border)]",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "circle", size: "xs" }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1 truncate", children: orbitalName }),
          /* @__PURE__ */ jsx(Badge, { variant: "default", children: runningCount > 0 ? t("subagentTrace.countRunning", { count: runningCount }) : t("subagentTrace.countDone", { count: completeCount }) })
        ]
      }
    ),
    subagents.map((sub) => /* @__PURE__ */ jsx(SubagentRow, { subagent: sub }, sub.id))
  ] });
};
var SubagentRichCard = ({ subagent }) => {
  const { t } = useTranslate();
  const activities = React93__default.useMemo(
    () => subagentMessagesToActivities(subagent.messages),
    [subagent.messages]
  );
  return /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "border-b border-[var(--color-border)] p-3", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-center mb-2", children: [
      /* @__PURE__ */ jsx(
        Box,
        {
          style: {
            width: 8,
            height: 8,
            borderRadius: "50%",
            flexShrink: 0,
            backgroundColor: subagent.status === "complete" ? "var(--color-success)" : subagent.status === "error" ? "var(--color-error)" : "var(--color-primary)",
            ...subagent.status === "running" ? { animation: "pulse 1.5s infinite" } : {}
          }
        }
      ),
      /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1 truncate", children: subagent.name }),
      /* @__PURE__ */ jsx(Badge, { variant: subagent.role === "deterministic" ? "default" : subagent.role === "llm" ? "info" : "warning", children: subagent.role }),
      subagent.durationMs !== void 0 && subagent.durationMs > 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: subagent.durationMs < 1e3 ? `${subagent.durationMs}ms` : `${(subagent.durationMs / 1e3).toFixed(1)}s` })
    ] }),
    /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-2", children: subagent.task }),
    activities.length > 0 ? /* @__PURE__ */ jsx(Box, { className: "max-h-64 overflow-y-auto border-t border-[var(--color-border)]", children: /* @__PURE__ */ jsx(InlineActivityStream, { activities, autoScroll: true }) }) : /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "italic text-[10px]", children: subagent.status === "complete" ? t("subagentTrace.noConversationLog") : t("subagentTrace.waitingForProcessData") })
  ] });
};
var roleBadgeVariant = {
  system: "neutral",
  user: "info",
  assistant: "default",
  tool: "warning"
};
var ChatMessageRow = ({ message, index }) => {
  const { t } = useTranslate();
  const { role, content, toolCalls, reasoningContent, toolCallId, toolName } = message;
  if (role === "tool") {
    const pretty = tryPrettyJson(content);
    const title = `${toolName ?? t("subagentTrace.role.tool")} \u2192${toolCallId ? ` ${toolCallId.slice(0, 8)}` : ""}`;
    const body = pretty !== null ? /* @__PURE__ */ jsx(CodeBlock, { code: pretty, language: "json", maxHeight: "24rem" }) : /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap font-mono text-[11px]", children: content });
    const items = [{ id: `tool-${index}`, title, content: body }];
    return /* @__PURE__ */ jsx(Box, { className: "px-3 py-2 border-b border-[var(--color-border)]", children: /* @__PURE__ */ jsx(Accordion, { items }) });
  }
  const hasReasoning = typeof reasoningContent === "string" && reasoningContent.length > 0;
  const hasToolCalls = Array.isArray(toolCalls) && toolCalls.length > 0;
  return /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "px-3 py-2 border-b border-[var(--color-border)]", children: [
    /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
      /* @__PURE__ */ jsx(Badge, { variant: roleBadgeVariant[role], className: "text-[10px] uppercase", children: t(`subagentTrace.role.${role}`) }),
      hasReasoning && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: [
        "\xB7 ",
        t("subagentTrace.thinking")
      ] }),
      hasToolCalls && /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: [
        "\xB7 ",
        toolCalls.length === 1 ? t("subagentTrace.toolCallCount", { count: toolCalls.length }) : t("subagentTrace.toolCallCountPlural", { count: toolCalls.length })
      ] })
    ] }),
    hasReasoning && /* @__PURE__ */ jsx(Accordion, { items: [{
      id: `reasoning-${index}`,
      title: t("subagentTrace.reasoning"),
      content: /* @__PURE__ */ jsx(MarkdownContent, { content: reasoningContent })
    }] }),
    content.length > 0 && /* @__PURE__ */ jsx(MarkdownContent, { content }),
    hasToolCalls && /* @__PURE__ */ jsx(
      Accordion,
      {
        multiple: true,
        items: toolCalls.map((tc, i) => ({
          id: `tc-${index}-${i}`,
          title: `${tc.name}(${summarizeArgs(tc.args)})`,
          content: /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(tc.args, null, 2), language: "json", maxHeight: "24rem" })
        }))
      }
    )
  ] });
};
var CoordinatorConversation = ({ messages, autoScroll = true, className }) => {
  const endRef = React93__default.useRef(null);
  React93__default.useEffect(() => {
    if (!autoScroll) return;
    endRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [messages.length, autoScroll]);
  return /* @__PURE__ */ jsxs(Box, { className, children: [
    messages.map((m, i) => /* @__PURE__ */ jsx(ChatMessageRow, { message: m, index: i }, `msg-${i}`)),
    /* @__PURE__ */ jsx(Box, { ref: endRef })
  ] });
};
function buildTimelineItems(messages, activities, subagents) {
  const items = [];
  if (messages) {
    messages.forEach((m, i) => items.push({ source: "message", data: m, index: i }));
  }
  if (activities) {
    activities.forEach((a) => items.push({ source: "activity", data: a }));
  }
  subagents.forEach((s) => items.push({ source: "subagent", data: s }));
  return items;
}
function timelineItemIcon(item) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return { name: "terminal", color: "text-[var(--color-primary)]" };
      if (m.reasoningContent) return { name: "sparkles", color: "text-[var(--color-primary)]" };
      if (m.role === "user") return { name: "user", color: "text-[var(--color-primary)]" };
      return { name: "message-square", color: "text-[var(--color-muted-foreground)]" };
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return { name: "terminal", color: "text-[var(--color-primary)]" };
        case "tool_result":
          return { name: a.success !== false ? "check" : "x", color: a.success !== false ? "text-[var(--color-success)]" : "text-[var(--color-danger)]" };
        case "error":
          return { name: "alert-triangle", color: "text-[var(--color-danger)]" };
        case "file_operation":
          return { name: "file", color: "text-[var(--color-muted-foreground)]" };
        case "schema_diff":
          return { name: "git-commit", color: "text-[var(--color-muted-foreground)]" };
        default:
          return { name: "info", color: "text-[var(--color-muted-foreground)]" };
      }
    }
    case "subagent":
      return { name: "bot", color: "text-[var(--color-primary)]" };
  }
}
function activityTypeLabel(type, t) {
  return t(`subagentTrace.activityType.${type}`);
}
function timelineItemLabel(item, t) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return t("subagentTrace.role.tool");
      if (m.reasoningContent) return t("subagentTrace.thinking");
      return t(`subagentTrace.role.${m.role}`);
    }
    case "activity":
      return activityTypeLabel(item.data.type, t);
    case "subagent":
      return t("subagentTrace.subagent");
  }
}
function timelineItemPreview(item, t) {
  switch (item.source) {
    case "message": {
      const m = item.data;
      if (m.role === "tool") return `${m.toolName ?? t("subagentTrace.role.tool")} \u2192 ${m.toolCallId?.slice(0, 8) ?? ""}`;
      if (m.reasoningContent) return previewText(m.reasoningContent, 120);
      return previewText(m.content, 120);
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return `${a.tool}(${previewText(a.argsText, 120)})`;
        case "tool_result":
          return `${a.tool}: ${previewText(a.resultText, 120)}`;
        case "message":
          return previewText(a.content, 120);
        case "error":
          return previewText(a.message, 120);
        case "file_operation":
          return `${t(`subagentTrace.fileOperation.${a.operation}`)} ${a.path}`;
        case "schema_diff":
          return t("subagentTrace.diffPreview", { path: a.filePath });
        default:
          return String(a.type);
      }
    }
    case "subagent":
      return `${item.data.name} \xB7 ${item.data.task}`;
  }
}
function timelineItemTimeLabel(item, locale) {
  if (item.source === "activity") return formatHHMMSS(item.data.timestamp, locale);
  if (item.source === "subagent") {
    const ts = item.data.messages[0]?.timestamp;
    return ts !== void 0 ? formatHHMMSS(ts, locale) : void 0;
  }
  return void 0;
}
function TraceDetailContent({ item }) {
  const { t, locale } = useTranslate();
  switch (item.source) {
    case "message": {
      const m = item.data;
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        /* @__PURE__ */ jsx(HStack, { gap: "xs", className: "items-center", children: /* @__PURE__ */ jsx(Badge, { variant: roleBadgeVariant[m.role], className: "text-[10px] uppercase", children: t(`subagentTrace.role.${m.role}`) }) }),
        typeof m.reasoningContent === "string" && m.reasoningContent.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.reasoning") }),
          /* @__PURE__ */ jsx(MarkdownContent, { content: m.reasoningContent })
        ] }),
        m.content.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.content") }),
          m.role === "tool" ? (() => {
            const pretty = tryPrettyJson(m.content);
            return pretty !== null ? /* @__PURE__ */ jsx(CodeBlock, { code: pretty, language: "json", maxHeight: "24rem" }) : /* @__PURE__ */ jsx(Typography, { variant: "body", className: "whitespace-pre-wrap font-mono text-[11px]", children: m.content });
          })() : /* @__PURE__ */ jsx(MarkdownContent, { content: m.content })
        ] }),
        Array.isArray(m.toolCalls) && m.toolCalls.length > 0 && /* @__PURE__ */ jsxs(Box, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "mb-1", children: t("subagentTrace.toolCalls") }),
          /* @__PURE__ */ jsx(
            Accordion,
            {
              multiple: true,
              items: m.toolCalls.map((tc, i) => ({
                id: `tc-detail-${i}`,
                title: `${tc.name}(${summarizeArgs(tc.args)})`,
                content: /* @__PURE__ */ jsx(CodeBlock, { code: JSON.stringify(tc.args, null, 2), language: "json", maxHeight: "24rem" })
              }))
            }
          )
        ] })
      ] });
    }
    case "activity": {
      const a = item.data;
      switch (a.type) {
        case "tool_call":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: activityTypeLabel("tool_call", t) }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.tool }),
            /* @__PURE__ */ jsx(CodeBlock, { code: a.argsText, language: "json", maxHeight: "60vh" })
          ] });
        case "tool_result":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: a.success !== false ? "default" : "warning", className: "text-[10px]", children: a.success !== false ? t("subagentTrace.success") : t("subagentTrace.fail") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.tool }),
            /* @__PURE__ */ jsx(CodeBlock, { code: a.resultText, language: "json", maxHeight: "60vh" })
          ] });
        case "message":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: t(`subagentTrace.role.${a.role}`) }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "whitespace-pre-wrap", children: a.content })
          ] });
        case "error":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "warning", className: "text-[10px]", children: t("subagentTrace.badgeError") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", className: "whitespace-pre-wrap text-[var(--color-danger)]", children: a.message })
          ] });
        case "file_operation":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: t("subagentTrace.badgeFile") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsxs(Typography, { variant: "body2", children: [
              t(`subagentTrace.fileOperation.${a.operation}`),
              " ",
              a.path
            ] })
          ] });
        case "schema_diff":
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
              /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: t("subagentTrace.badgeDiff") }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) })
            ] }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: a.filePath })
          ] });
        default:
          return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(a.timestamp, locale) }),
            /* @__PURE__ */ jsx(Typography, { variant: "body2", children: String(a.type) })
          ] });
      }
    }
    case "subagent": {
      const s = item.data;
      const activities = subagentMessagesToActivities(s.messages);
      const ts = s.messages[0]?.timestamp;
      return /* @__PURE__ */ jsxs(VStack, { gap: "md", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
          /* @__PURE__ */ jsx(Badge, { variant: "default", className: "text-[10px]", children: s.role }),
          ts !== void 0 && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: formatHHMMSS(ts, locale) })
        ] }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", weight: "semibold", children: s.name }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", children: s.task }),
        activities.length > 0 && /* @__PURE__ */ jsx(Box, { className: "border-t border-[var(--color-border)] pt-2", children: /* @__PURE__ */ jsx(InlineActivityStream, { activities, autoScroll: false }) })
      ] });
    }
  }
}
var SubagentTracePanel = ({
  subagents,
  focusedOrbital,
  disclosureLevel,
  open,
  onClose,
  className,
  mode = "overlay",
  coordinatorActivities,
  coordinatorMessages,
  ...rest
}) => {
  const { t, locale } = useTranslate();
  const [selectedItem, setSelectedItem] = useState(null);
  const densityLabel = (rich) => rich ? t("subagentTrace.densityRich") : t("subagentTrace.densityCompact");
  if (mode === "overlay" && !open) return null;
  const isTabMode = mode === "tab";
  const isRichMode = isTabMode || disclosureLevel >= 3;
  if (isTabMode) {
    const timelineItems = buildTimelineItems(coordinatorMessages, coordinatorActivities, subagents);
    const hasData = timelineItems.length > 0;
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: `h-full w-full bg-[var(--color-card)] overflow-hidden flex flex-col ${className ?? ""}`, children: [
      /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1", children: t("subagentTrace.trace") }),
            onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
          ]
        }
      ),
      !hasData && /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-4", children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "text-center", children: t("subagentTrace.noAgentActivity") }) }),
      hasData && /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto", children: /* @__PURE__ */ jsx(VStack, { gap: "none", children: timelineItems.map((item, i) => {
        const { name: iconName, color: iconColor } = timelineItemIcon(item);
        const isLast = i === timelineItems.length - 1;
        return /* @__PURE__ */ jsxs(
          Box,
          {
            className: "flex items-start px-3 py-2 border-b border-[var(--color-border)] hover:bg-[var(--color-muted)]/30 transition-colors duration-fast cursor-pointer",
            ...pressableProps(() => setSelectedItem(item)),
            children: [
              /* @__PURE__ */ jsxs(Box, { className: "flex flex-col items-center mr-3 mt-0.5", style: { width: 20 }, children: [
                /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: "rounded-full flex-shrink-0",
                    style: {
                      width: 8,
                      height: 8,
                      backgroundColor: "var(--color-primary)"
                    }
                  }
                ),
                !isLast && /* @__PURE__ */ jsx(
                  Box,
                  {
                    className: "flex-1",
                    style: {
                      width: 2,
                      backgroundColor: "var(--color-border)",
                      marginTop: 4,
                      minHeight: 24
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsxs(VStack, { gap: "xs", className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center", children: [
                  /* @__PURE__ */ jsx(Icon, { name: iconName, size: "xs", className: `flex-shrink-0 ${iconColor}` }),
                  timelineItemTimeLabel(item, locale) && /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: timelineItemTimeLabel(item, locale) }),
                  /* @__PURE__ */ jsx(Badge, { variant: "neutral", className: "text-[10px]", children: timelineItemLabel(item, t) })
                ] }),
                /* @__PURE__ */ jsxs(HStack, { gap: "sm", className: "items-start", children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", className: "flex-1 min-w-0 line-clamp-2", children: timelineItemPreview(item, t) }),
                  /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", className: "flex-shrink-0 mt-0", onClick: (e) => {
                    e.stopPropagation();
                    setSelectedItem(item);
                  }, children: /* @__PURE__ */ jsx(Icon, { name: "maximize-2", size: "xs" }) })
                ] })
              ] })
            ]
          },
          `${item.source}-${i}`
        );
      }) }) }),
      /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen: selectedItem !== null,
          onClose: () => setSelectedItem(null),
          title: selectedItem ? `${timelineItemLabel(selectedItem, t)}${timelineItemTimeLabel(selectedItem, locale) ? ` \xB7 ${timelineItemTimeLabel(selectedItem, locale)}` : ""}` : "",
          size: "lg",
          children: selectedItem && /* @__PURE__ */ jsx(TraceDetailContent, { item: selectedItem })
        }
      )
    ] });
  }
  const filtered = focusedOrbital ? subagents.filter((s) => s.orbitalName === focusedOrbital) : subagents;
  const wrapperClass = isRichMode ? `absolute inset-x-3 bottom-3 sm:inset-x-auto sm:top-3 sm:right-3 sm:bottom-3 w-full sm:w-[28rem] max-w-[calc(100vw-1.5rem)] max-h-[60vh] sm:max-h-none bg-[var(--color-card)] border border-[var(--color-border)] rounded-container shadow-elevation-popover surface-material overflow-hidden flex flex-col ${className ?? ""}` : `absolute inset-x-3 bottom-3 sm:inset-x-auto sm:top-3 sm:right-3 sm:bottom-3 w-full sm:w-80 max-w-[calc(100vw-1.5rem)] max-h-[60vh] sm:max-h-none bg-[var(--color-card)] border border-[var(--color-border)] rounded-container shadow-elevation-popover surface-material overflow-hidden flex flex-col ${className ?? ""}`;
  const wrapperStyle = { zIndex: 20 };
  const hasCoordinatorData = coordinatorMessages && coordinatorMessages.length > 0 || coordinatorActivities && coordinatorActivities.length > 0;
  if (filtered.length === 0 && !hasCoordinatorData) {
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: wrapperClass, style: wrapperStyle, children: [
      /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold flex-1", children: t("subagentTrace.subagents") }),
            onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
          ]
        }
      ),
      /* @__PURE__ */ jsx(Box, { className: "flex-1 flex items-center justify-center px-4", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-center", children: focusedOrbital ? t("subagentTrace.noSubagentsForOrbital", { orbital: focusedOrbital }) : t("subagentTrace.noSubagentsActive") }) })
    ] });
  }
  if (focusedOrbital) {
    return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: wrapperClass, style: wrapperStyle, children: [
      /* @__PURE__ */ jsxs(
        HStack,
        {
          gap: "sm",
          className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
          children: [
            /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
            /* @__PURE__ */ jsxs(VStack, { gap: "none", className: "flex-1 min-w-0", children: [
              /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold truncate", children: focusedOrbital }),
              /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "muted", children: [
                filtered.length === 1 ? t("subagentTrace.subagentCount", { count: filtered.length }) : t("subagentTrace.subagentCountPlural", { count: filtered.length }),
                " \xB7 ",
                densityLabel(isRichMode)
              ] })
            ] }),
            onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
          ]
        }
      ),
      /* @__PURE__ */ jsx(Box, { className: "flex-1 overflow-y-auto", children: filtered.map((sub) => isRichMode ? /* @__PURE__ */ jsx(SubagentRichCard, { subagent: sub }, sub.id) : /* @__PURE__ */ jsx(SubagentRow, { subagent: sub }, sub.id)) })
    ] });
  }
  const grouped = groupByOrbital(filtered, t("subagentTrace.unattached"));
  const coordinatorSnapshot = pluckCoordinatorState(coordinatorActivities ?? []);
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: wrapperClass, style: wrapperStyle, children: [
    /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        className: "items-center px-3 py-2 border-b border-[var(--color-border)]",
        children: [
          /* @__PURE__ */ jsx(Icon, { name: "activity", size: "sm" }),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", className: "font-semibold flex-1", children: [
            t("subagentTrace.subagentsWithCount", { count: filtered.length }),
            " \xB7 ",
            densityLabel(isRichMode)
          ] }),
          onClose && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onClose, children: /* @__PURE__ */ jsx(Icon, { name: "x", size: "xs" }) })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(Box, { className: "flex-1 overflow-y-auto", children: [
      !focusedOrbital && isRichMode && /* @__PURE__ */ jsx(CoordinatorCard, { snapshot: coordinatorSnapshot }),
      coordinatorMessages && coordinatorMessages.length > 0 ? /* @__PURE__ */ jsxs(Box, { className: "border-b border-[var(--color-border)]", children: [
        /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center px-3 py-1.5 bg-[var(--color-card)] border-b border-[var(--color-border)]", children: [
          /* @__PURE__ */ jsx(Box, { style: { width: 6, height: 6, borderRadius: "50%", backgroundColor: "var(--color-primary)", flexShrink: 0 } }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.messagesCount", { count: coordinatorMessages.length }) })
        ] }),
        /* @__PURE__ */ jsx(Box, { className: "max-h-[36rem] overflow-y-auto", children: /* @__PURE__ */ jsx(CoordinatorConversation, { messages: coordinatorMessages, autoScroll: true }) })
      ] }) : coordinatorActivities && coordinatorActivities.length > 0 && (() => {
        const filteredCoordinator = coordinatorActivities;
        if (filteredCoordinator.length === 0) return null;
        return /* @__PURE__ */ jsxs(Box, { className: "border-b border-[var(--color-border)]", children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", className: "items-center px-3 py-1.5 bg-[var(--color-card)] border-b border-[var(--color-border)]", children: [
            /* @__PURE__ */ jsx(Box, { style: { width: 6, height: 6, borderRadius: "50%", backgroundColor: "var(--color-primary)", flexShrink: 0 } }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-semibold text-[11px]", children: t("subagentTrace.coordinator") }),
            /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", className: "text-[10px]", children: t("subagentTrace.eventsCount", { count: filteredCoordinator.length }) })
          ] }),
          /* @__PURE__ */ jsx(Box, { className: "max-h-60 overflow-y-auto", children: /* @__PURE__ */ jsx(
            InlineActivityStream,
            {
              activities: coordinatorToActivityItems(filteredCoordinator, t),
              autoScroll: true
            }
          ) })
        ] });
      })(),
      isRichMode ? filtered.map((sub) => /* @__PURE__ */ jsx(SubagentRichCard, { subagent: sub }, sub.id)) : Array.from(grouped.entries()).map(([orbitalName, subs]) => /* @__PURE__ */ jsx(
        OrbitalGroup,
        {
          orbitalName,
          subagents: subs
        },
        orbitalName
      ))
    ] })
  ] });
};
SubagentTracePanel.displayName = "SubagentTracePanel";
function useSafeEventBus10() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var SwipeableRow = ({
  leftActions: leftActionDefs = [],
  rightActions: rightActionDefs = [],
  threshold = 80,
  children,
  itemData,
  className,
  ...rest
}) => {
  const eventBus = useSafeEventBus10();
  const rowActions = useRowActions();
  const leftActions = rowActions(leftActionDefs, itemData ?? {});
  const rightActions = rowActions(rightActionDefs, itemData ?? {});
  const [revealState, setRevealState] = useState("closed");
  const [offsetX, setOffsetX] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  const startXRef = useRef(0);
  const startYRef = useRef(0);
  const trackingRef = useRef(false);
  const lockedAxisRef = useRef(null);
  const actionsWidth = threshold;
  const handleActionClick = useCallback(
    (action) => {
      eventBus.emit(`UI:${action.event}`, {
        ...action.eventPayload,
        row: itemData
      });
      setRevealState("closed");
      setOffsetX(0);
    },
    [eventBus, itemData]
  );
  const handlePointerDown = useCallback(
    (e) => {
      if (e.button !== 0) return;
      startXRef.current = e.clientX;
      startYRef.current = e.clientY;
      trackingRef.current = true;
      lockedAxisRef.current = null;
      setIsSwiping(false);
      e.currentTarget.setPointerCapture(e.pointerId);
    },
    []
  );
  const handlePointerMove = useCallback(
    (e) => {
      if (!trackingRef.current) return;
      const dx = e.clientX - startXRef.current;
      const dy = e.clientY - startYRef.current;
      if (lockedAxisRef.current === null && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        lockedAxisRef.current = Math.abs(dx) > Math.abs(dy) ? "horizontal" : "vertical";
      }
      if (lockedAxisRef.current !== "horizontal") return;
      setIsSwiping(true);
      let newOffset = dx;
      if (revealState === "left") {
        newOffset = actionsWidth + dx;
      } else if (revealState === "right") {
        newOffset = -actionsWidth + dx;
      }
      const maxLeft = leftActions.length > 0 ? actionsWidth : 0;
      const maxRight = rightActions.length > 0 ? actionsWidth : 0;
      const clamped = Math.max(-maxRight, Math.min(maxLeft, newOffset));
      setOffsetX(clamped);
    },
    [revealState, actionsWidth, leftActions.length, rightActions.length]
  );
  const handlePointerUp = useCallback(
    () => {
      trackingRef.current = false;
      if (!isSwiping) {
        if (revealState !== "closed") {
          setRevealState("closed");
          setOffsetX(0);
        }
        setIsSwiping(false);
        return;
      }
      setIsSwiping(false);
      if (offsetX > threshold / 2 && leftActions.length > 0) {
        setRevealState("right");
        setOffsetX(actionsWidth);
      } else if (offsetX < -(threshold / 2) && rightActions.length > 0) {
        setRevealState("left");
        setOffsetX(-actionsWidth);
      } else {
        setRevealState("closed");
        setOffsetX(0);
      }
    },
    [isSwiping, offsetX, threshold, leftActions.length, rightActions.length, actionsWidth, revealState]
  );
  const handlePointerCancel = useCallback(() => {
    trackingRef.current = false;
    setIsSwiping(false);
    setRevealState("closed");
    setOffsetX(0);
  }, []);
  const renderActions = (actions, side) => {
    if (actions.length === 0) return null;
    return /* @__PURE__ */ jsx(
      HStack,
      {
        gap: "xs",
        align: "stretch",
        className: cn(
          "absolute top-0 bottom-0",
          side === "left" ? "left-0" : "right-0"
        ),
        style: {
          width: `${actionsWidth}px`
        },
        children: actions.map((action, idx) => /* @__PURE__ */ jsxs(
          Button,
          {
            variant: action.variant ?? "secondary",
            size: "sm",
            icon: action.icon,
            onClick: () => handleActionClick(action),
            className: "flex-1 rounded-none h-full",
            children: [
              action.icon ? typeof action.icon === "string" ? /* @__PURE__ */ jsx(Icon, { name: action.icon, size: "sm" }) : /* @__PURE__ */ jsx(Icon, { icon: action.icon, size: "sm" }) : null,
              action.label
            ]
          },
          `${action.event}-${idx}`
        ))
      }
    );
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      overflow: "hidden",
      position: "relative",
      className: cn(
        "touch-pan-y",
        className
      ),
      children: [
        renderActions(leftActions, "left"),
        renderActions(rightActions, "right"),
        /* @__PURE__ */ jsx(
          Box,
          {
            style: {
              transform: `translateX(${offsetX}px)`,
              transition: isSwiping ? "none" : "transform 200ms ease-out"
            },
            className: cn(
              "relative bg-surface",
              "select-none"
            ),
            onPointerDown: handlePointerDown,
            onPointerMove: handlePointerMove,
            onPointerUp: handlePointerUp,
            onPointerCancel: handlePointerCancel,
            children
          }
        )
      ]
    }
  );
};
SwipeableRow.displayName = "SwipeableRow";
var TabbedContainer = ({
  tabs,
  defaultTab,
  activeTab: controlledActiveTab,
  onTabChange,
  position = "top",
  className,
  ...rest
}) => {
  const items = (tabs ?? []).map((tab) => ({
    id: tab.id,
    label: tab.label,
    badge: tab.badge,
    disabled: tab.disabled,
    content: tab.content ?? null
  }));
  return /* @__PURE__ */ jsx(
    Tabs,
    {
      ...domPassthrough(rest),
      items,
      defaultActiveTab: defaultTab,
      activeTab: controlledActiveTab,
      onTabChange,
      orientation: position === "left" ? "vertical" : "horizontal",
      className: cn("h-full", className)
    }
  );
};
TabbedContainer.displayName = "TabbedContainer";
function extractToastProps(children) {
  if (!React93__default.isValidElement(children)) {
    if (typeof children === "string") {
      return { message: children };
    }
    return {};
  }
  const props = children.props;
  return {
    message: typeof props.message === "string" ? props.message : void 0,
    variant: props.variant,
    title: typeof props.title === "string" ? props.title : void 0
  };
}
var ToastSlot = ({
  children,
  variant: overrideVariant,
  title: overrideTitle,
  duration = 5e3,
  className,
  sourceTrait,
  ...rest
}) => {
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const schemaCtx = useEntitySchemaOptional();
  const isVisible = Boolean(children);
  const extracted = extractToastProps(children);
  const variant = overrideVariant || extracted.variant || "info";
  const title = overrideTitle || extracted.title;
  const message = extracted.message || (typeof children === "string" ? children : "");
  const handleDismiss = () => {
    const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
    const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
    eventBus.emit(`${prefix}DISMISS`);
    eventBus.emit(`${prefix}CLOSE`);
  };
  if (!isVisible) return null;
  const isCustomContent = React93__default.isValidElement(children) && !message;
  return /* @__PURE__ */ jsx(ThemedPortal, { children: /* @__PURE__ */ jsx(Box, { ...domPassthrough(rest), className: "fixed bottom-4 right-4 z-50", children: isCustomContent ? children : /* @__PURE__ */ jsx(
    Toast,
    {
      variant,
      title,
      message: message || t("toast.notification"),
      duration,
      onDismiss: handleDismiss,
      className
    }
  ) }) });
};
ToastSlot.displayName = "ToastSlot";
function isDiffRevision(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value) && "id" in value && typeof value.id === "string" && "label" in value && typeof value.label === "string" && "content" in value && typeof value.content === "string";
}
function toRevisions(value) {
  if (!Array.isArray(value)) return [];
  const out = [];
  for (const item of value) if (isDiffRevision(item)) out.push(item);
  return out;
}
var firstValue = (v) => typeof v === "string" ? v : v[0] ?? "";
var CONTEXT_LINES = 3;
var MIN_HIDDEN = 4;
function collapseUnchanged(rows2, expanded) {
  const isUnchanged = (row) => row?.kind === "line" && row.line.type === "unchanged";
  const out = [];
  let i = 0;
  while (i < rows2.length) {
    if (!isUnchanged(rows2[i])) {
      out.push(rows2[i]);
      i++;
      continue;
    }
    let j = i;
    while (j < rows2.length && isUnchanged(rows2[j])) j++;
    const keepHead = rows2[i - 1]?.kind === "line" ? CONTEXT_LINES : 0;
    const keepTail = rows2[j]?.kind === "line" ? CONTEXT_LINES : 0;
    const hidden = j - i - keepHead - keepTail;
    const id = i + keepHead;
    if (hidden < MIN_HIDDEN || expanded.has(id)) {
      out.push(...rows2.slice(i, j));
    } else {
      out.push(...rows2.slice(i, i + keepHead), { kind: "gap", id, count: hidden }, ...rows2.slice(j - keepTail, j));
    }
    i = j;
  }
  return out;
}
var INLINE_STYLES = {
  added: { bg: "bg-success/10", prefix: "+", text: "text-success" },
  removed: { bg: "bg-error/10", prefix: "-", text: "text-error" },
  unchanged: { bg: "", prefix: " ", text: "text-foreground" },
  context: { bg: "", prefix: " ", text: "text-muted-foreground" }
};
var VersionDiffInner = ({
  revisions: revisionsProp,
  hunks,
  beforeId,
  afterId,
  view = "side-by-side",
  onSelectBefore,
  onSelectAfter,
  onRevert,
  selectBeforeEvent,
  selectAfterEvent,
  revertEvent,
  language,
  className,
  ...rest
}) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const revisions = useMemo(() => toRevisions(revisionsProp), [revisionsProp]);
  const fallbackBefore = revisions[0]?.id ?? "";
  const fallbackAfter = revisions[1]?.id ?? revisions[0]?.id ?? "";
  const [internalBefore, setInternalBefore] = useState(beforeId ?? fallbackBefore);
  const [internalAfter, setInternalAfter] = useState(afterId ?? fallbackAfter);
  const [activeView, setActiveView] = useState(view);
  useEffect(() => setActiveView(view), [view]);
  const activeBeforeId = beforeId ?? internalBefore;
  const activeAfterId = afterId ?? internalAfter;
  const beforeRev = useMemo(
    () => revisions.find((r) => r.id === activeBeforeId) ?? revisions[0],
    [revisions, activeBeforeId]
  );
  const afterRev = useMemo(
    () => revisions.find((r) => r.id === activeAfterId) ?? revisions[1] ?? revisions[0],
    [revisions, activeAfterId]
  );
  const rows2 = useMemo(() => {
    if (hunks) {
      return hunks.flatMap((h) => [
        { kind: "header", header: h.header },
        ...h.lines.map((line2) => ({ kind: "line", line: line2 }))
      ]);
    }
    return computeLineDiff(beforeRev?.content ?? "", afterRev?.content ?? "").map((line2) => ({ kind: "line", line: line2 }));
  }, [hunks, beforeRev, afterRev]);
  const [expanded, setExpanded] = useState(() => /* @__PURE__ */ new Set());
  useEffect(() => setExpanded(/* @__PURE__ */ new Set()), [rows2]);
  const shown = useMemo(() => collapseUnchanged(rows2, expanded), [rows2, expanded]);
  const stats = useMemo(() => {
    let added = 0;
    let removed = 0;
    for (const row of rows2) {
      if (row.kind !== "line") continue;
      if (row.line.type === "added") added++;
      else if (row.line.type === "removed") removed++;
    }
    return { added, removed };
  }, [rows2]);
  const handleBeforeChange = useCallback(
    (v) => {
      const id = firstValue(v);
      setInternalBefore(id);
      onSelectBefore?.(id);
      if (selectBeforeEvent) eventBus.emit(`UI:${selectBeforeEvent}`, { id });
    },
    [onSelectBefore, selectBeforeEvent, eventBus]
  );
  const handleAfterChange = useCallback(
    (v) => {
      const id = firstValue(v);
      setInternalAfter(id);
      onSelectAfter?.(id);
      if (selectAfterEvent) eventBus.emit(`UI:${selectAfterEvent}`, { id });
    },
    [onSelectAfter, selectAfterEvent, eventBus]
  );
  const handleViewToggle = useCallback(() => {
    setActiveView((v) => v === "side-by-side" ? "inline" : "side-by-side");
  }, []);
  const handleRevert = useCallback(() => {
    if (beforeRev) {
      onRevert?.(beforeRev.id);
      if (revertEvent) eventBus.emit(`UI:${revertEvent}`, { id: beforeRev.id });
    }
  }, [beforeRev, onRevert, revertEvent, eventBus]);
  const options = useMemo(
    () => revisions.map((r) => ({ value: r.id, label: r.label })),
    [revisions]
  );
  const renderHeader = (header, key) => /* @__PURE__ */ jsx(Box, { className: "px-3 py-1 bg-info/10 border-y border-border", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "font-mono text-info", children: header }) }, key);
  const renderGap = (row, key) => /* @__PURE__ */ jsx(
    Button,
    {
      variant: "ghost",
      size: "sm",
      icon: "chevrons-up-down",
      "data-testid": "version-diff-gap",
      className: "w-full justify-start rounded-none bg-muted/40 text-muted-foreground",
      onClick: () => setExpanded((open) => new Set(open).add(row.id)),
      children: t("versionDiff.unchangedLines", { count: row.count })
    },
    key
  );
  const renderColumn = (side) => /* @__PURE__ */ jsx(VStack, { gap: "none", className: "font-mono text-xs", children: shown.map((row, idx) => {
    if (row.kind === "header") return renderHeader(row.header, `${side}-h-${idx}`);
    if (row.kind === "gap") return renderGap(row, `${side}-g-${row.id}`);
    const { line: line2 } = row;
    const hidden = side === "before" ? line2.type === "added" : line2.type === "removed";
    if (hidden) return null;
    const changed = side === "before" ? line2.type === "removed" : line2.type === "added";
    return /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "none",
        align: "start",
        className: cn("px-3 py-0.5", changed && (side === "before" ? "bg-error/10" : "bg-success/10")),
        children: [
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              color: "secondary",
              className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
              children: (side === "before" ? line2.beforeLineNumber : line2.afterLineNumber) ?? ""
            }
          ),
          /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: cn(
                "font-mono flex-1 min-w-0 whitespace-pre",
                changed ? side === "before" ? "text-error" : "text-success" : "text-foreground"
              ),
              children: line2.content || " "
            }
          )
        ]
      },
      `${side}-${idx}`
    );
  }) });
  const isEmpty = hunks !== void 0 && hunks.length === 0;
  return /* @__PURE__ */ jsx(Card, { ...domPassthrough(rest), className: cn("overflow-hidden", className), children: /* @__PURE__ */ jsxs(VStack, { gap: "none", children: [
    /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        align: "center",
        justify: "between",
        className: "px-4 py-2 border-b border-border bg-muted/30 flex-wrap",
        children: [
          /* @__PURE__ */ jsxs(HStack, { gap: "sm", align: "center", className: "flex-wrap", children: [
            /* @__PURE__ */ jsx(Icon, { name: "git-commit", size: "sm", className: "text-muted-foreground" }),
            !hunks && /* @__PURE__ */ jsxs(Fragment, { children: [
              /* @__PURE__ */ jsx(Typography, { variant: "small", weight: "medium", className: "whitespace-nowrap", children: t("versionDiff.compare") }),
              /* @__PURE__ */ jsx(Box, { className: "min-w-0 md:min-w-[160px]", children: /* @__PURE__ */ jsx(
                Select,
                {
                  options,
                  value: activeBeforeId,
                  onValueChange: handleBeforeChange,
                  "aria-label": t("versionDiff.beforeRevision")
                }
              ) }),
              /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "secondary", children: t("versionDiff.to") }),
              /* @__PURE__ */ jsx(Box, { className: "min-w-0 md:min-w-[160px]", children: /* @__PURE__ */ jsx(
                Select,
                {
                  options,
                  value: activeAfterId,
                  onValueChange: handleAfterChange,
                  "aria-label": t("versionDiff.afterRevision")
                }
              ) })
            ] }),
            language && /* @__PURE__ */ jsx(Badge, { variant: "default", children: language }),
            /* @__PURE__ */ jsxs(Badge, { variant: "success", children: [
              "+",
              stats.added
            ] }),
            /* @__PURE__ */ jsxs(Badge, { variant: "error", children: [
              "-",
              stats.removed
            ] })
          ] }),
          /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                variant: "ghost",
                size: "sm",
                icon: activeView === "side-by-side" ? "align-left" : "columns",
                onClick: handleViewToggle,
                "aria-label": activeView === "side-by-side" ? t("versionDiff.switchToInline") : t("versionDiff.switchToSideBySide")
              }
            ),
            !hunks && (onRevert || revertEvent) && /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: "rotate-ccw", onClick: handleRevert, children: t("versionDiff.revert") })
          ] })
        ]
      }
    ),
    !hunks && (beforeRev?.author || beforeRev?.timestamp || afterRev?.author || afterRev?.timestamp) && /* @__PURE__ */ jsxs(
      HStack,
      {
        gap: "sm",
        align: "center",
        justify: "between",
        className: "px-4 py-1 border-b border-border bg-muted/10",
        children: [
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
            beforeRev?.label,
            beforeRev?.author ? t("versionDiff.byAuthor", { author: beforeRev.author }) : "",
            beforeRev?.timestamp ? ` (${beforeRev.timestamp})` : ""
          ] }),
          /* @__PURE__ */ jsxs(Typography, { variant: "caption", color: "secondary", className: "truncate", children: [
            afterRev?.label,
            afterRev?.author ? t("versionDiff.byAuthor", { author: afterRev.author }) : "",
            afterRev?.timestamp ? ` (${afterRev.timestamp})` : ""
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Box, { className: "overflow-auto bg-muted/20", style: { maxHeight: 600 }, role: "region", tabIndex: 0, "aria-label": t("versionDiff.changes"), children: isEmpty ? /* @__PURE__ */ jsx(Box, { className: "py-8", "data-testid": "version-diff-empty", children: /* @__PURE__ */ jsx(Typography, { variant: "body2", color: "muted", align: "center", children: t("versionDiff.noChanges") }) }) : activeView === "side-by-side" ? /* @__PURE__ */ jsxs(Box, { className: "grid grid-cols-1 md:grid-cols-2", children: [
      /* @__PURE__ */ jsx(Box, { className: "min-w-0 overflow-x-auto border-b md:border-b-0 md:border-r border-border", "data-testid": "version-diff-before", children: renderColumn("before") }),
      /* @__PURE__ */ jsx(Box, { className: "min-w-0 overflow-x-auto", "data-testid": "version-diff-after", children: renderColumn("after") })
    ] }) : /* @__PURE__ */ jsx(VStack, { gap: "none", className: "font-mono text-xs", children: shown.map((row, idx) => {
      if (row.kind === "header") return renderHeader(row.header, `i-h-${idx}`);
      if (row.kind === "gap") return renderGap(row, `i-g-${row.id}`);
      const { line: line2 } = row;
      const style = INLINE_STYLES[line2.type];
      return /* @__PURE__ */ jsxs(HStack, { gap: "none", align: "start", className: cn("px-4 py-0.5", style.bg), children: [
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            color: "secondary",
            className: "w-8 text-right mr-2 select-none tabular-nums flex-shrink-0",
            children: line2.beforeLineNumber ?? ""
          }
        ),
        /* @__PURE__ */ jsx(
          Typography,
          {
            variant: "caption",
            color: "secondary",
            className: "w-8 text-right mr-3 select-none tabular-nums flex-shrink-0",
            children: line2.afterLineNumber ?? ""
          }
        ),
        /* @__PURE__ */ jsxs(
          Typography,
          {
            variant: "caption",
            className: cn("font-mono flex-1 min-w-0 whitespace-pre", style.text),
            children: [
              /* @__PURE__ */ jsx(Box, { as: "span", className: "select-none opacity-50 mr-2", children: style.prefix }),
              line2.content || " "
            ]
          }
        )
      ] }, `i-${idx}`);
    }) }) })
  ] }) });
};
var VersionDiff = React93__default.memo(VersionDiffInner);
VersionDiff.displayName = "VersionDiff";
var actionTypeLabelKeys = {
  measure: "violationAlert.actionType.measure",
  admin: "violationAlert.actionType.admin",
  penalty: "violationAlert.actionType.penalty"
};
var actionTypeIcons = {
  measure: "alert-triangle",
  admin: "alert-circle",
  penalty: "shield-alert"
};
var ViolationAlert = ({
  violation,
  severity,
  dismissible = false,
  onDismiss,
  onNavigateToField,
  compact = false,
  className,
  message,
  ...rest
}) => {
  const { t } = useTranslate();
  const fallbackMessage = message ?? t("violationAlert.fallbackMessage");
  const resolvedViolation = violation ?? {
    law: "",
    article: "",
    message: fallbackMessage,
    actionType: "measure"
  };
  const effectiveSeverity = severity ?? (resolvedViolation.actionType === "measure" ? "warning" : "error");
  const citation = t("violationAlert.citation", { law: resolvedViolation.law, article: resolvedViolation.article });
  const icon = actionTypeIcons[resolvedViolation.actionType];
  const dismiss = dismissible && onDismiss ? { dismissible: true, onDismiss } : {};
  if (compact) {
    return /* @__PURE__ */ jsx(Alert, { ...domPassthrough(rest), variant: effectiveSeverity, icon, title: citation, className: cn("px-3 py-2", className), ...dismiss, children: resolvedViolation.message });
  }
  const navigate = resolvedViolation.fieldId && onNavigateToField ? resolvedViolation.fieldId : void 0;
  return /* @__PURE__ */ jsx(
    Alert,
    {
      ...domPassthrough(rest),
      variant: effectiveSeverity,
      icon,
      title: citation,
      className,
      ...dismiss,
      actions: navigate ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", icon: "arrow-right", onClick: () => onNavigateToField?.(navigate), children: t("violationAlert.goToField") }) : void 0,
      children: /* @__PURE__ */ jsxs(VStack, { gap: "xs", children: [
        /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t(actionTypeLabelKeys[resolvedViolation.actionType]) }),
        /* @__PURE__ */ jsx(Typography, { variant: "body2", children: resolvedViolation.message }),
        resolvedViolation.adminAction && /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", wrap: true, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("violationAlert.adminLabel") }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", children: resolvedViolation.adminAction })
        ] }),
        resolvedViolation.penaltyAction && /* @__PURE__ */ jsxs(HStack, { gap: "xs", align: "center", wrap: true, children: [
          /* @__PURE__ */ jsx(Typography, { variant: "caption", color: "muted", children: t("violationAlert.penaltyLabel") }),
          /* @__PURE__ */ jsx(Typography, { variant: "caption", weight: "semibold", children: resolvedViolation.penaltyAction })
        ] })
      ] })
    }
  );
};
ViolationAlert.displayName = "ViolationAlert";
var WizardContainer = ({
  steps,
  currentStep: controlledStep,
  onStepChange,
  onComplete,
  showProgress = true,
  allowBack = true,
  compact = false,
  className,
  nextEvent,
  backEvent,
  completeEvent,
  ...rest
}) => {
  const { t } = useTranslate();
  const eventBus = useEventBus();
  const [internalStep, setInternalStep] = useState(0);
  const normalizedControlledStep = (() => {
    if (controlledStep === void 0 || controlledStep === null)
      return void 0;
    if (typeof controlledStep === "number") return controlledStep;
    if (typeof controlledStep === "string") return parseInt(controlledStep, 10);
    const num2 = Number(controlledStep);
    return isNaN(num2) ? void 0 : num2;
  })();
  const currentStep = normalizedControlledStep !== void 0 ? normalizedControlledStep : internalStep;
  const totalSteps = steps.length;
  const currentStepData = steps[currentStep];
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;
  const goToStep = useCallback(
    (stepIndex) => {
      if (stepIndex < 0 || stepIndex >= totalSteps) return;
      if (controlledStep === void 0) {
        setInternalStep(stepIndex);
      }
      onStepChange?.(stepIndex);
    },
    [controlledStep, totalSteps, onStepChange]
  );
  const handleNext = () => {
    if (currentStepData.isValid && !currentStepData.isValid()) {
      return;
    }
    if (isLastStep) {
      if (completeEvent) eventBus.emit(`UI:${completeEvent}`, { step: currentStep });
      onComplete?.();
    } else {
      if (nextEvent) eventBus.emit(`UI:${nextEvent}`, { step: currentStep + 1 });
      goToStep(currentStep + 1);
    }
  };
  const handleBack = () => {
    if (!isFirstStep && allowBack) {
      if (backEvent) eventBus.emit(`UI:${backEvent}`, { step: currentStep - 1 });
      goToStep(currentStep - 1);
    }
  };
  return /* @__PURE__ */ jsxs(Box, { ...domPassthrough(rest), className: cn("flex flex-col h-full", className), children: [
    showProgress && /* @__PURE__ */ jsx(
      WizardProgress,
      {
        steps: steps.map((step, index) => ({
          id: step.id ?? step.tabId ?? `step-${index}`,
          title: step.title ?? step.name ?? t("wizard.stepOf", { current: index + 1, total: totalSteps })
        })),
        currentStep,
        onStepClick: goToStep,
        allowNavigation: allowBack,
        compact
      }
    ),
    !compact && currentStepData && /* @__PURE__ */ jsxs(
      Box,
      {
        paddingX: "lg",
        paddingY: "md",
        border: true,
        className: "border-b-heavy border-x-0 border-t-0 border-border",
        children: [
          /* @__PURE__ */ jsx(Typography, { variant: "h4", as: "h2", children: currentStepData.title ?? currentStepData.name ?? t("wizard.stepOf", { current: currentStep + 1, total: totalSteps }) }),
          currentStepData.description && /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "body2",
              className: "text-muted-foreground mt-1",
              children: currentStepData.description
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(Box, { className: cn("flex-1 overflow-auto", compact ? "p-4" : "p-6"), children: currentStepData?.content }),
    /* @__PURE__ */ jsxs(
      Box,
      {
        border: true,
        className: cn(
          "border-t-heavy border-x-0 border-b-0 border-border flex justify-between",
          compact ? "px-4 py-2" : "px-6 py-4"
        ),
        children: [
          /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "secondary",
              onClick: handleBack,
              disabled: isFirstStep || !allowBack,
              children: [
                /* @__PURE__ */ jsx(Icon, { icon: ChevronLeft, size: "sm" }),
                t("wizard.back")
              ]
            }
          ),
          /* @__PURE__ */ jsx(HStack, { gap: "sm", align: "center", children: /* @__PURE__ */ jsx(
            Typography,
            {
              variant: "caption",
              className: "text-muted-foreground",
              children: t("wizard.stepOf", { current: String(currentStep + 1), total: String(steps.length) })
            }
          ) }),
          /* @__PURE__ */ jsxs(Button, { variant: "primary", onClick: handleNext, children: [
            isLastStep ? t("wizard.complete") : t("wizard.next"),
            !isLastStep && /* @__PURE__ */ jsx(Icon, { icon: ChevronRight, size: "sm" })
          ] })
        ]
      }
    )
  ] });
};
WizardContainer.displayName = "WizardContainer";
function useSafeEventBus11() {
  try {
    return useEventBus();
  } catch {
    return { emit: () => {
    }, on: () => () => {
    }, once: () => {
    } };
  }
}
var WizardNavigation = ({
  currentStep,
  totalSteps,
  isValid = true,
  showBack = true,
  showNext = true,
  showComplete = true,
  backLabel,
  nextLabel,
  completeLabel,
  onBack = "WIZARD_BACK",
  onNext = "WIZARD_NEXT",
  onComplete = "WIZARD_COMPLETE",
  onBackClick,
  onNextClick,
  onCompleteClick,
  compact = false,
  className,
  ...rest
}) => {
  const eventBus = useSafeEventBus11();
  const { t } = useTranslate();
  const resolvedBackLabel = backLabel ?? t("wizard.back");
  const resolvedNextLabel = nextLabel ?? t("wizard.next");
  const resolvedCompleteLabel = completeLabel ?? t("wizard.complete");
  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === totalSteps - 1;
  const handleBack = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      eventBus.emit(`UI:${onBack}`, { currentStep, totalSteps });
    }
  };
  const handleNext = () => {
    if (onNextClick) {
      onNextClick();
    } else {
      eventBus.emit(`UI:${onNext}`, { currentStep, totalSteps });
    }
  };
  const handleComplete = () => {
    if (onCompleteClick) {
      onCompleteClick();
    } else {
      eventBus.emit(`UI:${onComplete}`, { currentStep, totalSteps });
    }
  };
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ...domPassthrough(rest),
      border: true,
      className: cn(
        // `flex-wrap gap-2` lets the Back / Step / Next trio reflow on
        // narrow viewports rather than crushing the step counter.
        "border-t-heavy border-x-0 border-b-0 border-border flex flex-wrap gap-2 justify-between items-center",
        compact ? "px-4 py-2" : "px-6 py-4",
        className
      ),
      children: [
        showBack ? /* @__PURE__ */ jsxs(Button, { variant: "secondary", onClick: handleBack, disabled: isFirstStep, children: [
          /* @__PURE__ */ jsx(Icon, { name: "chevron-left", size: "sm" }),
          resolvedBackLabel
        ] }) : /* @__PURE__ */ jsx(Box, {}),
        /* @__PURE__ */ jsx(HStack, { align: "center", gap: "sm", children: /* @__PURE__ */ jsx(Typography, { variant: "caption", className: "text-muted-foreground", children: t("wizard.stepOf", { current: String(currentStep + 1), total: String(totalSteps) }) }) }),
        isLastStep && showComplete ? /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: handleComplete, disabled: !isValid, children: resolvedCompleteLabel }) : showNext ? /* @__PURE__ */ jsxs(Button, { variant: "primary", onClick: handleNext, disabled: !isValid, children: [
          resolvedNextLabel,
          /* @__PURE__ */ jsx(Icon, { name: "chevron-right", size: "sm" })
        ] }) : /* @__PURE__ */ jsx(Box, {})
      ]
    }
  );
};
WizardNavigation.displayName = "WizardNavigation";

// components/core/organisms/component-registry.generated.ts
var COMPONENT_REGISTRY = {
  get "Accordion"() {
    return Accordion;
  },
  get "ActionPalette"() {
    return ActionPalette;
  },
  get "ActionTile"() {
    return ActionTile;
  },
  get "ActivationBlock"() {
    return ActivationBlock;
  },
  get "AgentActivityFeed"() {
    return AgentActivityFeed;
  },
  get "AgentActivityRow"() {
    return AgentActivityRow;
  },
  get "AgentChatFeed"() {
    return AgentChatFeed;
  },
  get "Alert"() {
    return AlertPattern;
  },
  get "AlertPattern"() {
    return AlertPattern;
  },
  get "AlgoGraphCanvas"() {
    return AlgoGraphCanvas;
  },
  get "AlgorithmCanvas"() {
    return AlgorithmCanvas;
  },
  get "AnimatedCounter"() {
    return AnimatedCounter;
  },
  get "AnimatedGraphic"() {
    return AnimatedGraphic;
  },
  get "AnimatedReveal"() {
    return AnimatedReveal;
  },
  get "Aside"() {
    return Aside;
  },
  get "AtlasImage"() {
    return AtlasImage;
  },
  get "AtlasPanel"() {
    return AtlasPanel;
  },
  get "AuthLayout"() {
    return AuthLayout;
  },
  get "Avatar"() {
    return Avatar;
  },
  get "AvlGlyph"() {
    return AvlGlyph;
  },
  get "AvlStateMachine"() {
    return AvlStateMachine;
  },
  get "AvlTransitionExplainer"() {
    return AvlTransitionExplainer;
  },
  get "Badge"() {
    return Badge;
  },
  get "BehaviorView"() {
    return BehaviorView;
  },
  get "BiologyCanvas"() {
    return BiologyCanvas;
  },
  get "BloomQuizBlock"() {
    return BloomQuizBlock;
  },
  get "Box"() {
    return BoxPattern;
  },
  get "BoxPattern"() {
    return BoxPattern;
  },
  get "BranchingLogicBuilder"() {
    return BranchingLogicBuilder;
  },
  get "Breadcrumb"() {
    return Breadcrumb;
  },
  get "Button"() {
    return ButtonPattern;
  },
  get "ButtonGroup"() {
    return ButtonGroup;
  },
  get "ButtonPattern"() {
    return ButtonPattern;
  },
  get "CalendarGrid"() {
    return CalendarGrid;
  },
  get "Canvas"() {
    return Canvas;
  },
  get "Canvas2D"() {
    return Canvas2D;
  },
  get "Card"() {
    return Card;
  },
  get "Carousel"() {
    return Carousel;
  },
  get "Center"() {
    return Center;
  },
  get "ChangeList"() {
    return ChangeList;
  },
  get "Chart"() {
    return Chart;
  },
  get "ChartLegend"() {
    return ChartLegend;
  },
  get "ChatBar"() {
    return ChatBar;
  },
  get "Checkbox"() {
    return Checkbox;
  },
  get "ChemistryCanvas"() {
    return ChemistryCanvas;
  },
  get "ChoiceButton"() {
    return ChoiceButton;
  },
  get "CodeBlock"() {
    return CodeBlock;
  },
  get "CodeRunnerPanel"() {
    return CodeRunnerPanel;
  },
  get "CommandPalette"() {
    return CommandPalette;
  },
  get "CommitRow"() {
    return CommitRow;
  },
  get "ConditionalWrapper"() {
    return ConditionalWrapper;
  },
  get "ConfettiEffect"() {
    return ConfettiEffect;
  },
  get "ConfirmDialog"() {
    return ConfirmDialog;
  },
  get "ConnectionBlock"() {
    return ConnectionBlock;
  },
  get "Container"() {
    return Container;
  },
  get "ContentRenderer"() {
    return ContentRenderer;
  },
  get "ControlButton"() {
    return ControlButton;
  },
  get "ControlGrid"() {
    return ControlGrid;
  },
  get "CounterTemplate"() {
    return CounterTemplate;
  },
  get "DashboardGrid"() {
    return DashboardGrid;
  },
  get "DashboardLayout"() {
    return DashboardLayout;
  },
  get "DataGrid"() {
    return DataGrid;
  },
  get "DataList"() {
    return DataList;
  },
  get "DateRangePicker"() {
    return DateRangePicker;
  },
  get "DateRangeSelector"() {
    return DateRangeSelector;
  },
  get "DayCell"() {
    return DayCell;
  },
  get "DetailPanel"() {
    return DetailPanel;
  },
  get "Dialog"() {
    return Dialog;
  },
  get "DialogueBubble"() {
    return DialogueBubble;
  },
  get "Divider"() {
    return DividerPattern;
  },
  get "DividerPattern"() {
    return DividerPattern;
  },
  get "DocBreadcrumb"() {
    return DocBreadcrumb;
  },
  get "DocPagination"() {
    return DocPagination;
  },
  get "DocSearch"() {
    return DocSearch;
  },
  get "DocSidebar"() {
    return DocSidebar;
  },
  get "DocTOC"() {
    return DocTOC;
  },
  get "DockLayout"() {
    return DockLayout;
  },
  get "DocumentDetails"() {
    return DocumentDetails;
  },
  get "DocumentPanel"() {
    return DocumentPanel;
  },
  get "DocumentViewer"() {
    return DocumentViewer;
  },
  get "DrawFxLayer"() {
    return DrawFxLayer;
  },
  get "DrawGroup"() {
    return DrawGroup;
  },
  get "DrawMesh"() {
    return DrawMesh;
  },
  get "DrawShape"() {
    return DrawShape;
  },
  get "DrawShapeLayer"() {
    return DrawShapeLayer;
  },
  get "DrawSkinnedMesh"() {
    return DrawSkinnedMesh;
  },
  get "DrawSprite"() {
    return DrawSprite;
  },
  get "DrawSpriteLayer"() {
    return DrawSpriteLayer;
  },
  get "DrawText"() {
    return DrawText;
  },
  get "DrawTextLayer"() {
    return DrawTextLayer;
  },
  get "Drawer"() {
    return Drawer;
  },
  get "DrawerSlot"() {
    return DrawerSlot;
  },
  get "EdgeDecoration"() {
    return EdgeDecoration;
  },
  get "EmojiPicker"() {
    return EmojiPicker;
  },
  get "EmptyState"() {
    return EmptyState;
  },
  get "ErrorBoundary"() {
    return ErrorBoundary;
  },
  get "ErrorState"() {
    return ErrorState;
  },
  get "FeatureCard"() {
    return FeatureCard;
  },
  get "FeatureGrid"() {
    return FeatureGrid;
  },
  get "FileTree"() {
    return FileTree;
  },
  get "FilterGroup"() {
    return FilterGroup;
  },
  get "FilterPill"() {
    return FilterPill;
  },
  get "Flex"() {
    return Flex;
  },
  get "FlipCard"() {
    return FlipCard;
  },
  get "FlipContainer"() {
    return FlipContainer;
  },
  get "FloatingActionButton"() {
    return FloatingActionButton;
  },
  get "FloatingToolbar"() {
    return FloatingToolbar;
  },
  get "FlowCanvas"() {
    return FlowCanvas;
  },
  get "Form"() {
    return Form;
  },
  get "FormField"() {
    return FormField;
  },
  get "FormLayout"() {
    return FormLayout;
  },
  get "FormSectionHeader"() {
    return FormSectionHeader;
  },
  get "FxOverlay"() {
    return FxOverlay;
  },
  get "GameAudioCue"() {
    return GameAudioCue;
  },
  get "GameAudioToggle"() {
    return GameAudioToggle;
  },
  get "GameHud"() {
    return GameHud;
  },
  get "GameIcon"() {
    return GameIcon;
  },
  get "GameMenu"() {
    return GameMenu;
  },
  get "GameShell"() {
    return GameShell;
  },
  get "Gantt"() {
    return Gantt;
  },
  get "GenericAppTemplate"() {
    return GenericAppTemplate;
  },
  get "GeometricPattern"() {
    return GeometricPattern;
  },
  get "GradientDivider"() {
    return GradientDivider;
  },
  get "GraphCanvas"() {
    return GraphCanvas;
  },
  get "GraphView"() {
    return GraphView;
  },
  get "Grid"() {
    return Grid;
  },
  get "HStack"() {
    return HStack;
  },
  get "Header"() {
    return Header;
  },
  get "HealthBar"() {
    return HealthBar;
  },
  get "Icon"() {
    return Icon;
  },
  get "IconButton"() {
    return IconButtonPattern;
  },
  get "IconButtonPattern"() {
    return IconButtonPattern;
  },
  get "Image"() {
    return Image2;
  },
  get "ImportPreviewTree"() {
    return ImportPreviewTree;
  },
  get "ImportProgress"() {
    return ImportProgress;
  },
  get "ImportSourcePicker"() {
    return ImportSourcePicker;
  },
  get "InfiniteScrollSentinel"() {
    return InfiniteScrollSentinel;
  },
  get "Input"() {
    return Input;
  },
  get "InputGroup"() {
    return InputGroup;
  },
  get "JazariStateMachine"() {
    return JazariStateMachine;
  },
  get "Label"() {
    return LabelPattern;
  },
  get "LabelPattern"() {
    return LabelPattern;
  },
  get "LawReferenceTooltip"() {
    return LawReferenceTooltip;
  },
  get "LayersPanel"() {
    return LayersPanel;
  },
  get "LearningCanvas"() {
    return LearningCanvas;
  },
  get "Lightbox"() {
    return Lightbox;
  },
  get "LikertScale"() {
    return LikertScale;
  },
  get "LineChart"() {
    return LineChart2;
  },
  get "LoadingState"() {
    return LoadingState;
  },
  get "MapView"() {
    return MapView;
  },
  get "MarkdownContent"() {
    return MarkdownContent;
  },
  get "MasterDetailLayout"() {
    return MasterDetailLayout;
  },
  get "MathCanvas"() {
    return MathCanvas;
  },
  get "MatrixQuestion"() {
    return MatrixQuestion;
  },
  get "MediaGallery"() {
    return MediaGallery;
  },
  get "Menu"() {
    return Menu;
  },
  get "Meter"() {
    return Meter;
  },
  get "Modal"() {
    return Modal;
  },
  get "ModalSlot"() {
    return ModalSlot;
  },
  get "ModuleCard"() {
    return ModuleCard;
  },
  get "Navigation"() {
    return Navigation;
  },
  get "NumberStepper"() {
    return NumberStepper;
  },
  get "OptionConstraintGroup"() {
    return OptionConstraintGroup;
  },
  get "OrbInspector"() {
    return OrbInspector;
  },
  get "OrbitalVisualization"() {
    return OrbitalVisualization;
  },
  get "Overlay"() {
    return Overlay;
  },
  get "PageHeader"() {
    return PageHeader;
  },
  get "PageTransition"() {
    return PageTransition;
  },
  get "Pagination"() {
    return Pagination;
  },
  get "PatternTile"() {
    return PatternTile;
  },
  get "PhysicsCanvas"() {
    return PhysicsCanvas;
  },
  get "Popover"() {
    return Popover;
  },
  get "PositionedCanvas"() {
    return PositionedCanvas;
  },
  get "Presence"() {
    return Presence;
  },
  get "ProgressBar"() {
    return ProgressBar;
  },
  get "ProgressDots"() {
    return ProgressDots;
  },
  get "PullToRefresh"() {
    return PullToRefresh;
  },
  get "QrScanner"() {
    return QrScanner;
  },
  get "QuizBlock"() {
    return QuizBlock;
  },
  get "Radio"() {
    return Radio;
  },
  get "RangeSlider"() {
    return RangeSlider;
  },
  get "ReflectionBlock"() {
    return ReflectionBlock;
  },
  get "RelationSelect"() {
    return RelationSelect;
  },
  get "RepeatableFormSection"() {
    return RepeatableFormSection;
  },
  get "ReplyTree"() {
    return ReplyTree;
  },
  get "RichTextEditor"() {
    return RichTextEditor;
  },
  get "RuntimeDebugger"() {
    return RuntimeDebugger;
  },
  get "ScaledDiagram"() {
    return ScaledDiagram;
  },
  get "ScoreDisplay"() {
    return ScoreDisplay;
  },
  get "SearchInput"() {
    return SearchInput;
  },
  get "Section"() {
    return Section;
  },
  get "SectionHeader"() {
    return SectionHeader;
  },
  get "SegmentRenderer"() {
    return SegmentRenderer;
  },
  get "Select"() {
    return Select;
  },
  get "SequenceBar"() {
    return SequenceBar;
  },
  get "SidePanel"() {
    return SidePanel;
  },
  get "Sidebar"() {
    return Sidebar;
  },
  get "SignaturePad"() {
    return SignaturePad;
  },
  get "SimpleGrid"() {
    return SimpleGrid;
  },
  get "Skeleton"() {
    return Skeleton;
  },
  get "SocialProof"() {
    return SocialProof;
  },
  get "SortableList"() {
    return SortableList;
  },
  get "Spacer"() {
    return SpacerPattern;
  },
  get "SpacerPattern"() {
    return SpacerPattern;
  },
  get "Sparkline"() {
    return Sparkline;
  },
  get "Spinner"() {
    return Spinner;
  },
  get "Split"() {
    return Split;
  },
  get "SplitPane"() {
    return SplitPane;
  },
  get "Stack"() {
    return Stack;
  },
  get "StarRating"() {
    return StarRating;
  },
  get "StatBadge"() {
    return StatBadge;
  },
  get "StatCard"() {
    return StatCard;
  },
  get "StatDisplay"() {
    return StatDisplay;
  },
  get "StateGraph"() {
    return StateGraph;
  },
  get "StateJsonView"() {
    return StateJsonView;
  },
  get "StateMachineView"() {
    return StateMachineView;
  },
  get "StatusDot"() {
    return StatusDot;
  },
  get "SubagentTracePanel"() {
    return SubagentTracePanel;
  },
  get "SvgBranch"() {
    return SvgBranch;
  },
  get "SvgConnection"() {
    return SvgConnection;
  },
  get "SvgFlow"() {
    return SvgFlow;
  },
  get "SvgGrid"() {
    return SvgGrid;
  },
  get "SvgLobe"() {
    return SvgLobe;
  },
  get "SvgMesh"() {
    return SvgMesh;
  },
  get "SvgMorph"() {
    return SvgMorph;
  },
  get "SvgNode"() {
    return SvgNode;
  },
  get "SvgPulse"() {
    return SvgPulse;
  },
  get "SvgRing"() {
    return SvgRing;
  },
  get "SvgShield"() {
    return SvgShield;
  },
  get "SvgStack"() {
    return SvgStack;
  },
  get "SwipeableRow"() {
    return SwipeableRow;
  },
  get "Switch"() {
    return Switch;
  },
  get "TabbedContainer"() {
    return TabbedContainer;
  },
  get "TableView"() {
    return TableView;
  },
  get "Tabs"() {
    return Tabs;
  },
  get "TagInput"() {
    return TagInput;
  },
  get "TextHighlight"() {
    return TextHighlight;
  },
  get "Textarea"() {
    return Textarea;
  },
  get "ThemeToggle"() {
    return ThemeToggle;
  },
  get "TimeSlotCell"() {
    return TimeSlotCell;
  },
  get "Timeline"() {
    return Timeline;
  },
  get "TimerDisplay"() {
    return TimerDisplay;
  },
  get "Toast"() {
    return Toast;
  },
  get "ToastSlot"() {
    return ToastSlot;
  },
  get "Tooltip"() {
    return Tooltip;
  },
  get "TopNavItem"() {
    return TopNavItem;
  },
  get "TraitFrame"() {
    return TraitFrame;
  },
  get "TraitSlot"() {
    return TraitSlot;
  },
  get "TrendIndicator"() {
    return TrendIndicator;
  },
  get "TypewriterText"() {
    return TypewriterText;
  },
  get "Typography"() {
    return Typography;
  },
  get "UISlotComponent"() {
    return UISlotComponent;
  },
  get "UISlotRenderer"() {
    return UISlotRenderer;
  },
  get "UploadDropZone"() {
    return UploadDropZone;
  },
  get "VStack"() {
    return VStack;
  },
  get "VersionDiff"() {
    return VersionDiff;
  },
  get "ViolationAlert"() {
    return ViolationAlert;
  },
  get "VoteStack"() {
    return VoteStack;
  },
  get "WizardContainer"() {
    return WizardContainer;
  },
  get "WizardNavigation"() {
    return WizardNavigation;
  },
  get "WizardProgress"() {
    return WizardProgress;
  },
  // Semantic aliases
  get "Text"() {
    return TextPattern;
  }
};
var scopeWrapLog = createLogger("almadar:ui:scope-wrap");
var LazyTraitValueFrame = React93__default.lazy(() => import('./TraitValueFrame-3HJ2B45P.js'));
var LazyBehaviorValueFrame = React93__default.lazy(() => import('./BehaviorValueFrame-ODYQ63E4.js'));
var TRAIT_BINDING_RE = /^@trait\.([A-Z][A-Za-z0-9]*)$/;
function slotPropsOf(content) {
  return typeof content.props === "string" ? {} : content.props;
}
var SuspenseConfigContext = createContext({ enabled: false });
function SuspenseConfigProvider({
  config,
  children
}) {
  return React93__default.createElement(
    SuspenseConfigContext.Provider,
    { value: config },
    children
  );
}
SuspenseConfigProvider.displayName = "SuspenseConfigProvider";
var SLOT_SKELETON_MAP = {
  main: "table",
  sidebar: "card",
  modal: "form",
  drawer: "form"
};
function getSlotFallback(slot, config) {
  if (config.slotFallbacks?.[slot]) return config.slotFallbacks[slot];
  const variant = SLOT_SKELETON_MAP[slot] ?? "text";
  return /* @__PURE__ */ jsx(Skeleton, { variant });
}
function getComponentForPattern2(patternType) {
  const mapping = getComponentForPattern(patternType);
  if (!mapping) {
    return null;
  }
  return COMPONENT_REGISTRY[mapping] ?? null;
}
function enrichFormFields(fields, entityDef) {
  const fieldMap = new Map(entityDef.fields.map((f3) => [f3.name, f3]));
  return fields.map((field) => {
    if (typeof field === "string") {
      const entityField = fieldMap.get(field);
      if (entityField) {
        const enriched = {
          name: field,
          label: field,
          type: entityField.type,
          required: entityField.required ?? false
        };
        if (entityField.description) {
          enriched.hint = entityField.description;
        }
        if (entityField.values && entityField.values.length > 0) {
          enriched.values = entityField.values;
        } else if (entityField.enumValues && entityField.enumValues.length > 0) {
          enriched.values = entityField.enumValues;
        }
        if (entityField.relation) {
          enriched.relation = {
            entity: entityField.relation.entity,
            cardinality: entityField.relation.cardinality
          };
        }
        return enriched;
      }
      return { name: field, label: field };
    }
    if (field && typeof field === "object" && !Array.isArray(field) && !React93__default.isValidElement(field) && !(field instanceof Date)) {
      const obj = field;
      const fieldName2 = typeof obj.name === "string" ? obj.name : typeof obj.field === "string" ? obj.field : void 0;
      if (!fieldName2) return field;
      if (obj.type || obj.inputType) return field;
      const entityField = fieldMap.get(fieldName2);
      if (!entityField) return field;
      const enriched = { ...obj, type: entityField.type };
      if (entityField.required && !("required" in obj)) {
        enriched.required = true;
      }
      if (entityField.description && !obj.hint && !obj.help) {
        enriched.hint = entityField.description;
      }
      if (!obj.values && !obj.options) {
        if (entityField.values && entityField.values.length > 0) {
          enriched.values = entityField.values;
        } else if (entityField.enumValues && entityField.enumValues.length > 0) {
          enriched.values = entityField.enumValues;
        }
      }
      if (!obj.relation && entityField.relation) {
        enriched.relation = {
          entity: entityField.relation.entity,
          cardinality: entityField.relation.cardinality
        };
      }
      return enriched;
    }
    return field;
  });
}
function enrichDetailFields(fields, entityDef) {
  const fieldMap = new Map(entityDef.fields.map((f3) => [f3.name, f3]));
  const metaFor = (name) => {
    const entityField = fieldMap.get(name);
    if (!entityField) return void 0;
    const meta = { type: entityField.type };
    const values = entityField.values ?? entityField.enumValues;
    if (values && values.length > 0) meta.values = values;
    if (entityField.relation) {
      meta.relation = {
        entity: entityField.relation.entity,
        cardinality: entityField.relation.cardinality
      };
    }
    return meta;
  };
  return fields.map((field) => {
    if (typeof field === "string") {
      const meta = metaFor(field);
      return meta ? { key: field, ...meta } : field;
    }
    if (field && typeof field === "object" && !Array.isArray(field) && !React93__default.isValidElement(field) && !(field instanceof Date)) {
      const obj = field;
      const fieldName2 = typeof obj.key === "string" ? obj.key : typeof obj.name === "string" ? obj.name : void 0;
      if (!fieldName2 || obj.type) return field;
      const meta = metaFor(fieldName2);
      return meta ? { ...obj, ...meta } : field;
    }
    return field;
  });
}
var CONTENT_NODE_SLOTS = /* @__PURE__ */ new Set([
  "logo",
  "master",
  "detail",
  "trigger",
  "content",
  "addons",
  "hud",
  "fallback",
  "controls",
  "overlay"
]);
var PATTERNS_WITH_CHILDREN = /* @__PURE__ */ new Set([
  "stack",
  "vstack",
  "hstack",
  "box",
  "canvas",
  "canvas-2d",
  "grid",
  "center",
  "card",
  "tooltip",
  "popover",
  "container",
  "simple-grid",
  "custom",
  "dashboard-layout",
  "game-shell",
  "game-template",
  "scaled-diagram",
  "master-detail",
  "form-field",
  "form-section",
  "form",
  "accordion",
  "tabs",
  "tab-content",
  "collapsible",
  "alert",
  "dialog"
]);
function resolveCompiledChildren(children, presence) {
  return typeof children === "function" ? children(presence) : children;
}
function isAnimatedPortalSlot(slot) {
  return slot === "modal" || slot === "drawer";
}
function useSlotPresence(value, hold = false) {
  const last = useRef(null);
  const current = useRef(value);
  current.current = value;
  const [, rerender] = useReducer((n) => n + 1, 0);
  if (value !== null) last.current = value;
  const onExited = useCallback(() => {
    if (current.current !== null) return;
    last.current = null;
    rerender();
  }, []);
  const open = value !== null || hold && last.current !== null;
  return { shown: value ?? last.current, open, onExited };
}
function renderContainedPortal(slot, content, onDismiss, open, onExited) {
  const slotContent = /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: content.sourceTrait, children: /* @__PURE__ */ jsx(SlotContentRenderer, { content, onDismiss, presence: { open, onExited } }) });
  const slotId = `slot-${slot}`;
  switch (slot) {
    case "modal":
      if (SELF_OVERLAY_PATTERN_TYPES.has(content.pattern)) {
        return /* @__PURE__ */ jsx(Box, { id: slotId, className: "contents", children: slotContent });
      }
      return /* @__PURE__ */ jsx(
        Modal,
        {
          contained: true,
          isOpen: open,
          onExited,
          onClose: onDismiss,
          title: slotPropsOf(content).title,
          size: slotPropsOf(content).size,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
    case "dock":
      return /* @__PURE__ */ jsx(DockSlotFrame, { open, onExited, onDismiss, contained: true, children: /* @__PURE__ */ jsx(Box, { id: slotId, className: "flex min-h-0 flex-1 flex-col", children: slotContent }) });
    case "drawer":
      if (content.pattern === "detail-panel" && slotPropsOf(content).slideOver === true) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            id: slotId,
            className: "absolute inset-0 z-50 overflow-hidden bg-scrim",
            onClick: onDismiss,
            children: /* @__PURE__ */ jsx(
              Box,
              {
                className: "absolute inset-y-0 right-0 pointer-events-auto",
                onClick: (e) => e.stopPropagation(),
                children: slotContent
              }
            )
          }
        );
      }
      return /* @__PURE__ */ jsx(
        Drawer,
        {
          contained: true,
          isOpen: open,
          onExited,
          onClose: onDismiss,
          title: slotPropsOf(content).title,
          position: slotPropsOf(content).position ?? "right",
          width: slotPropsOf(content).width,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
    case "toast":
      return /* @__PURE__ */ jsx(Box, { id: slotId, className: "absolute top-4 right-4 z-50", children: /* @__PURE__ */ jsx(SlotToasts, { content, onDismiss }) });
    case "overlay":
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "absolute inset-0 z-50 flex items-center justify-center overflow-auto bg-scrim",
          onClick: onDismiss,
          children: /* @__PURE__ */ jsx(Box, { className: "max-h-full overflow-auto", onClick: (e) => e.stopPropagation(), children: slotContent })
        }
      );
    case "center":
      return /* @__PURE__ */ jsx(Box, { id: slotId, className: "absolute inset-0 z-50 flex items-center justify-center pointer-events-none overflow-auto", children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto max-h-full overflow-auto", children: slotContent }) });
    default:
      return /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent });
  }
}
function MaybeTraitScope({
  sourceTrait,
  children
}) {
  const schemaCtx = useEntitySchemaOptional();
  const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
  const wrap = sourceTrait !== void 0 && orbital !== void 0;
  scopeWrapLog.debug("decide", {
    sourceTrait,
    schemaCtxPresent: schemaCtx !== null,
    orbitalsByTraitSize: schemaCtx?.orbitalsByTrait.size ?? 0,
    orbital,
    wrap
  });
  if (wrap) {
    return /* @__PURE__ */ jsx(TraitScopeProvider, { orbital, trait: sourceTrait, children });
  }
  if (sourceTrait !== void 0 && schemaCtx !== null) {
    scopeWrapLog.warn("decline", {
      sourceTrait,
      orbitalsByTraitSize: schemaCtx.orbitalsByTrait.size,
      reason: "sourceTrait not in orbitalsByTrait \u2014 children render unscoped"
    });
  }
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function UISlotComponent(props) {
  const pendingScope = usePendingScopeValue();
  const inner = /* @__PURE__ */ jsx(RenderSlotProvider, { slot: props.slot, children: /* @__PURE__ */ jsx(PendingScopeContext.Provider, { value: pendingScope, children: /* @__PURE__ */ jsx(UISlotComponentInner, { ...props }) }) });
  return props.slot === "system" ? /* @__PURE__ */ jsx(Box, { className: "sr-only", children: inner }) : inner;
}
function UISlotComponentInner({
  slot,
  portal = false,
  position,
  className,
  children,
  pattern,
  sourceTrait,
  enter,
  awaitingSkeleton,
  fallback,
  mode = "replace"
}) {
  const { slots, clear } = useUISlots();
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const suspenseConfig = useContext(SuspenseConfigContext);
  const contained = useContext(SlotContainedContext);
  const schemaCtx = useEntitySchemaOptional();
  const rawContent = slots[slot];
  const runtimeAwaiting = useAwaitingSkeleton({ slot });
  const awaiting = isPortalSlot(slot) ? void 0 : awaitingSkeleton ?? runtimeAwaiting;
  const regionClassName = fallback !== void 0 ? cn("contents", className) : className;
  const binding = useEntityBindingSnapshot(rawContent?.sourceTrait);
  const i18n = useRenderI18n$1();
  const content = useMemo(() => {
    if (!rawContent) return rawContent;
    const resolvedProps = resolveRenderBindingMarkers(
      rawContent.props,
      rawContent.sourceTrait,
      binding.entity,
      binding.config,
      binding.state,
      i18n
    );
    return resolvedProps === rawContent.props ? rawContent : { ...rawContent, props: resolvedProps };
  }, [rawContent, binding.entity, binding.config, binding.state, i18n]);
  const animatedPortal = isAnimatedPortalSlot(slot);
  const holdForPending = useScopeHasPending(useContext(PendingScopeContext));
  const runtimePresence = useSlotPresence(portal && animatedPortal ? content ?? null : null, holdForPending);
  const compiledPresence = useSlotPresence(
    children !== void 0 && pattern !== "clear" && animatedPortal ? { children, pattern, sourceTrait } : null,
    holdForPending
  );
  const compiledMode = children !== void 0;
  const runtimeRootEnterValue = content ? slotPropsOf(content).enter : void 0;
  const runtimeRootEnter = asEnterAnimation(typeof runtimeRootEnterValue === "string" ? runtimeRootEnterValue : void 0);
  const slotEnterActive = fallback === void 0 && !isPortalSlot(slot) && (compiledMode ? pattern !== "clear" : Boolean(content)) && slotPlaysDefaultEnter(compiledMode ? enter : runtimeRootEnter);
  const slotContentKey = compiledMode ? `${sourceTrait ?? ""}:${pattern ?? ""}` : `${content?.sourceTrait ?? ""}:${content?.pattern ?? ""}`;
  const slotBoxRef = useRef(null);
  useSlotEnterRestart(slotBoxRef, slotContentKey, slotEnterActive);
  if (children !== void 0) {
    if (pattern === "clear") {
      const last = compiledPresence.shown;
      if (last === null && awaiting !== void 0) {
        return /* @__PURE__ */ jsx(Box, { id: `slot-${slot}`, className: cn("ui-slot", `ui-slot-${slot}`, className), "data-slot-mode": "awaiting", children: /* @__PURE__ */ jsx(SkeletonTree, { node: awaiting }) });
      }
      const selfOverlay = last !== null && last.pattern !== void 0 && SELF_OVERLAY_PATTERN_TYPES.has(last.pattern);
      const held = compiledPresence.open;
      if (last === null || selfOverlay && typeof last.children !== "function" && !held) {
        return null;
      }
      if (contained) {
        if (!held) return null;
        return /* @__PURE__ */ jsx(
          Box,
          {
            id: `slot-${slot}`,
            className: cn("ui-slot", `ui-slot-${slot}`, className),
            "data-pattern": last.pattern,
            "data-source-trait": last.sourceTrait,
            children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: last.sourceTrait, children: resolveCompiledChildren(last.children, { open: true, onExited: compiledPresence.onExited }) })
          }
        );
      }
      return /* @__PURE__ */ jsx(
        CompiledPortal,
        {
          slot,
          className,
          pattern: last.pattern,
          sourceTrait: last.sourceTrait,
          open: held,
          onExited: compiledPresence.onExited,
          children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: last.sourceTrait, children: resolveCompiledChildren(last.children, { open: held, onExited: compiledPresence.onExited }) })
        }
      );
    }
    const openChildren = resolveCompiledChildren(children, { open: true, onExited: compiledPresence.onExited });
    if (isPortalSlot(slot)) {
      if (contained && slot === "dock") {
        return /* @__PURE__ */ jsx(
          DockSlotFrame,
          {
            open: true,
            onExited: compiledPresence.onExited,
            onDismiss: () => {
              const orbital = sourceTrait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
              const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
              eventBus.emit(`${prefix}CLOSE`);
              eventBus.emit(`${prefix}CANCEL`);
              clear(slot);
            },
            contained: true,
            children: /* @__PURE__ */ jsx(Box, { id: `slot-${slot}`, className: cn("ui-slot", `ui-slot-${slot}`, "flex min-h-0 flex-1 flex-col", className), "data-pattern": pattern, "data-source-trait": sourceTrait, children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children: openChildren }) })
          }
        );
      }
      if (contained) {
        return /* @__PURE__ */ jsx(
          Box,
          {
            id: `slot-${slot}`,
            className: cn("ui-slot", `ui-slot-${slot}`, className),
            "data-pattern": pattern,
            "data-source-trait": sourceTrait,
            children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children: openChildren })
          }
        );
      }
      return /* @__PURE__ */ jsx(
        CompiledPortal,
        {
          slot,
          className,
          pattern,
          sourceTrait,
          open: true,
          onExited: compiledPresence.onExited,
          children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children: openChildren })
        }
      );
    }
    return /* @__PURE__ */ jsx(
      Box,
      {
        ref: slotBoxRef,
        id: `slot-${slot}`,
        className: cn("ui-slot", `ui-slot-${slot}`, slotEnterActive && ENTER_SLOT_CLASS, className),
        "data-pattern": pattern,
        "data-source-trait": sourceTrait,
        children: /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait, children: openChildren })
      }
    );
  }
  const shownContent = content ?? runtimePresence.shown;
  const slotOpen = content !== null && content !== void 0 || runtimePresence.open;
  if (!shownContent) {
    if (fallback !== void 0) {
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: `slot-${slot}`,
          className: cn("ui-slot", `ui-slot-${slot}`, regionClassName),
          "data-testid": `ui-slot-${slot}`,
          "data-slot-mode": "fallback",
          children: fallback
        }
      );
    }
    if (!portal) {
      return /* @__PURE__ */ jsx(
        Box,
        {
          id: `slot-${slot}`,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-testid": `ui-slot-${slot}`,
          "data-slot-mode": awaiting !== void 0 ? "awaiting" : "empty",
          children: awaiting !== void 0 ? /* @__PURE__ */ jsx(SkeletonTree, { node: awaiting }) : null
        }
      );
    }
    return null;
  }
  const handleDismiss = () => {
    if (slot === "modal" || slot === "drawer" || slot === "dock") {
      const trait = shownContent.sourceTrait;
      const orbital = trait !== void 0 && schemaCtx !== null ? schemaCtx.orbitalsByTrait.get(trait) : void 0;
      const prefix = orbital !== void 0 && trait !== void 0 ? `UI:${orbital}.${trait}.` : "UI:";
      eventBus.emit(`${prefix}CLOSE`);
      eventBus.emit(`${prefix}CANCEL`);
    }
    clear(slot);
  };
  if (portal) {
    const inlineFallback = mode === "append" && fallback !== void 0 ? /* @__PURE__ */ jsx(
      Box,
      {
        id: `slot-${slot}-fallback`,
        className: cn("ui-slot", `ui-slot-${slot}-fallback`, regionClassName),
        "data-testid": `ui-slot-${slot}-fallback`,
        "data-slot-mode": "append",
        children: fallback
      }
    ) : null;
    if (contained) {
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        inlineFallback,
        renderContainedPortal(slot, shownContent, handleDismiss, slotOpen, runtimePresence.onExited)
      ] });
    }
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      inlineFallback,
      /* @__PURE__ */ jsx(
        SlotPortal,
        {
          slot,
          content: shownContent,
          position,
          onDismiss: handleDismiss,
          open: slotOpen,
          onExited: runtimePresence.onExited
        }
      )
    ] });
  }
  const slotContent = /* @__PURE__ */ jsx(SlotContentRenderer, { content: shownContent, onDismiss: handleDismiss });
  const wrappedContent = suspenseConfig.enabled ? /* @__PURE__ */ jsx(ErrorBoundary, { children: /* @__PURE__ */ jsx(Suspense, { fallback: getSlotFallback(slot, suspenseConfig), children: slotContent }) }) : /* @__PURE__ */ jsx(ErrorBoundary, { children: slotContent });
  const showFallback = mode === "append" && fallback !== void 0;
  return /* @__PURE__ */ jsxs(
    Box,
    {
      ref: slotBoxRef,
      id: `slot-${slot}`,
      className: cn("ui-slot", `ui-slot-${slot}`, slotEnterActive && ENTER_SLOT_CLASS, regionClassName),
      "data-pattern": shownContent.pattern,
      "data-source-trait": shownContent.sourceTrait,
      "data-testid": `ui-slot-${slot}`,
      "data-slot-mode": showFallback ? "append" : "content",
      children: [
        showFallback ? fallback : null,
        /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: shownContent.sourceTrait, children: wrappedContent })
      ]
    }
  );
}
var DOCK_INSET = "384px";
function DockSlotFrame({ open, onExited, onDismiss, contained = false, children }) {
  const compact = useCompactLayout();
  const { t } = useTranslate();
  const panelRef = useRef(null);
  const pushes = open && !compact;
  useEffect(() => {
    if (!pushes) return;
    if (contained) {
      const host = panelRef.current?.closest(".ui-slot-renderer");
      if (!host) return;
      host.style.setProperty("--almadar-dock-contained-inset", DOCK_INSET);
      return () => {
        host.style.removeProperty("--almadar-dock-contained-inset");
      };
    }
    const root = document.documentElement;
    root.style.setProperty("--almadar-dock-inset", DOCK_INSET);
    return () => {
      root.style.removeProperty("--almadar-dock-inset");
    };
  }, [pushes, contained]);
  useEffect(() => {
    if (!open && !compact) onExited();
  }, [open, compact, onExited]);
  if (compact) {
    return /* @__PURE__ */ jsx(Drawer, { isOpen: open, onExited, onClose: onDismiss, position: "right", width: "md", showCloseButton: false, contained, children: /* @__PURE__ */ jsx(Box, { "data-testid": "dock-sheet-fill", className: "flex h-full min-h-0 flex-col", children }) });
  }
  if (!open) return null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      ref: panelRef,
      role: "complementary",
      "aria-label": t("aria.dockPanel"),
      className: cn(
        contained ? "absolute" : "fixed",
        "inset-y-0 end-0 z-[850] flex w-96 flex-col border-s border-[var(--color-border)] bg-[var(--color-card)] shadow-[var(--shadow-lg)]"
      ),
      children: /* @__PURE__ */ jsx(Box, { className: "flex min-h-0 flex-1 flex-col overflow-y-auto", children })
    }
  );
}
function CompiledPortal({ slot, className, pattern, sourceTrait, children, open, onExited }) {
  const [portalRoot, setPortalRoot] = useState(null);
  const slotsBus = useUISlots();
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const compiledPortalSchemaCtx = useEntitySchemaOptional();
  useEffect(() => {
    setPortalRoot(getOrCreatePortalRoot());
  }, []);
  const handleDismiss = () => {
    if (slot === "modal" || slot === "drawer" || slot === "dock") {
      const orbital = sourceTrait !== void 0 && compiledPortalSchemaCtx !== null ? compiledPortalSchemaCtx.orbitalsByTrait.get(sourceTrait) : void 0;
      const prefix = orbital !== void 0 && sourceTrait !== void 0 ? `UI:${orbital}.${sourceTrait}.` : "UI:";
      eventBus.emit(`${prefix}CLOSE`);
      eventBus.emit(`${prefix}CANCEL`);
    }
    slotsBus.clear(slot);
  };
  if (!portalRoot) return null;
  const slotId = `slot-${slot}`;
  let wrapper;
  switch (slot) {
    case "modal": {
      const innerContent = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      );
      wrapper = pattern !== void 0 && SELF_OVERLAY_PATTERN_TYPES.has(pattern) ? innerContent : /* @__PURE__ */ jsx(Modal, { isOpen: open, onExited, onClose: handleDismiss, showCloseButton: true, size: "lg", children: innerContent });
      break;
    }
    case "drawer":
      wrapper = /* @__PURE__ */ jsx(Drawer, { isOpen: open, onExited, onClose: handleDismiss, position: "right", children: /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      ) });
      break;
    case "dock":
      wrapper = /* @__PURE__ */ jsx(DockSlotFrame, { open, onExited, onDismiss: handleDismiss, children: /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, "flex min-h-0 flex-1 flex-col", className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      ) });
      break;
    case "toast":
      wrapper = /* @__PURE__ */ jsx(Box, { className: "fixed top-4 right-4 z-50", children: /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      ) });
      break;
    default:
      wrapper = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: cn("ui-slot", `ui-slot-${slot}`, className),
          "data-pattern": pattern,
          "data-source-trait": sourceTrait,
          children
        }
      );
  }
  return /* @__PURE__ */ jsx(ThemedPortal, { container: portalRoot, children: wrapper });
}
function SlotPortal({
  slot,
  content,
  position,
  onDismiss,
  open,
  onExited
}) {
  const [portalRoot, setPortalRoot] = useState(null);
  useEffect(() => {
    setPortalRoot(getOrCreatePortalRoot());
  }, []);
  if (!portalRoot) return null;
  const slotId = `slot-${slot}`;
  const slotContent = /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: content.sourceTrait, children: /* @__PURE__ */ jsx(SlotContentRenderer, { content, onDismiss, presence: { open, onExited } }) });
  let wrapper;
  switch (slot) {
    case "modal":
      wrapper = SELF_OVERLAY_PATTERN_TYPES.has(content.pattern) ? /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent }) : /* @__PURE__ */ jsx(
        Modal,
        {
          isOpen: open,
          onExited,
          onClose: onDismiss,
          title: slotPropsOf(content).title,
          size: slotPropsOf(content).size,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
      break;
    case "drawer":
      wrapper = /* @__PURE__ */ jsx(
        Drawer,
        {
          isOpen: open,
          onExited,
          onClose: onDismiss,
          title: slotPropsOf(content).title,
          position: slotPropsOf(content).position ?? "right",
          width: slotPropsOf(content).width,
          children: /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent })
        }
      );
      break;
    case "dock":
      wrapper = /* @__PURE__ */ jsx(DockSlotFrame, { open, onExited, onDismiss, children: /* @__PURE__ */ jsx(Box, { id: slotId, className: "flex min-h-0 flex-1 flex-col", children: slotContent }) });
      break;
    case "toast":
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, className: cn("fixed z-50", getToastPosition(position)), children: /* @__PURE__ */ jsx(SlotToasts, { content, onDismiss }) });
      break;
    case "overlay":
      wrapper = /* @__PURE__ */ jsx(
        Box,
        {
          id: slotId,
          className: "fixed inset-0 z-50 bg-scrim flex items-center justify-center",
          onClick: onDismiss,
          children: /* @__PURE__ */ jsx(Box, { onClick: (e) => e.stopPropagation(), children: slotContent })
        }
      );
      break;
    case "center":
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, className: "fixed inset-0 z-50 flex items-center justify-center pointer-events-none", children: /* @__PURE__ */ jsx(Box, { className: "pointer-events-auto", children: slotContent }) });
      break;
    default:
      wrapper = /* @__PURE__ */ jsx(Box, { id: slotId, children: slotContent });
  }
  return /* @__PURE__ */ jsx(ThemedPortal, { container: portalRoot, children: wrapper });
}
var TOAST_VARIANTS = ["success", "error", "warning", "info"];
function stringField(value, key) {
  const field = Reflect.get(value, key);
  return typeof field === "string" ? field : void 0;
}
function toastEntry(key, value, sourceTrait) {
  const variant = stringField(value, "variant");
  return {
    key,
    variant: TOAST_VARIANTS.find((v) => v === variant),
    title: stringField(value, "title"),
    message: stringField(value, "message") ?? "",
    sourceTrait
  };
}
function slotToastEntries(content) {
  const props = slotPropsOf(content);
  const children = props.children;
  if (content.pattern === "stack" && Array.isArray(children)) {
    const entries = [];
    children.forEach((child, index) => {
      if (typeof child !== "object" || child === null) return;
      entries.push(toastEntry(`${content.id}-${index}`, child, stringField(child, "_sourceTrait")));
    });
    return entries;
  }
  return [toastEntry(content.id, props, content.sourceTrait)];
}
function SlotToasts({ content, onDismiss }) {
  const { clearBySource } = useUISlots();
  const entries = slotToastEntries(content);
  return /* @__PURE__ */ jsx(Box, { className: "flex flex-col gap-2", children: entries.map((entry) => {
    const trait = entry.sourceTrait;
    return /* @__PURE__ */ jsx(
      Toast,
      {
        variant: entry.variant ?? "info",
        title: entry.title,
        message: entry.message,
        onDismiss: entries.length > 1 && trait !== void 0 ? () => clearBySource("toast", trait) : onDismiss
      },
      entry.key
    );
  }) });
}
function getToastPosition(position) {
  switch (position) {
    case "top-left":
      return "top-4 left-4";
    case "top-right":
      return "top-4 right-4";
    case "bottom-left":
      return "bottom-4 left-4";
    case "bottom-right":
      return "bottom-4 right-4";
    default:
      return "top-4 right-4";
  }
}
function renderPatternChildren(children, onDismiss, parentId = "root", parentPath = "root", sourceTrait, orbCtx) {
  if (children === void 0 || children === null) return null;
  const childrenArray = Array.isArray(children) ? children : typeof children === "string" || typeof children === "object" && ("type" in children || isTraitValue(children) || isBehaviorRefValue(children)) ? [children] : [];
  if (childrenArray.length === 0) return null;
  return childrenArray.map((child, index) => {
    if (typeof child === "string") {
      const match = TRAIT_BINDING_RE.exec(child);
      if (match) {
        const traitName = match[1];
        const key = `${parentId}-${index}-trait:${traitName}`;
        return /* @__PURE__ */ jsx(TraitFrame, { traitName }, key);
      }
      return /* @__PURE__ */ jsx(React93__default.Fragment, { children: child }, `${parentId}-${index}`);
    }
    if (!child || typeof child !== "object") return null;
    if (isTraitValue(child)) {
      return /* @__PURE__ */ jsx(React93__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(LazyTraitValueFrame, { value: child }) }, `${parentId}-${index}-value:${child.behavior}.${child.trait}`);
    }
    if (isBehaviorRefValue(child)) {
      return /* @__PURE__ */ jsx(React93__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(LazyBehaviorValueFrame, { value: child }) }, `${parentId}-${index}-behavior:${child.behavior}`);
    }
    const childId = `${parentId}-${index}`;
    const childPath = parentPath === "root" ? `root.children.${index}` : `${parentPath}.children.${index}`;
    const childAsRecord = child;
    const { type: _childType, props: nestedProps, _id: _childNodeId, _sourceTrait: childSourceTrait, children: _childChildren, ...flatProps } = childAsRecord;
    const resolvedProps = nestedProps !== void 0 ? nestedProps : flatProps;
    if (_childChildren !== void 0 && nestedProps === void 0) {
      resolvedProps.children = _childChildren;
    }
    const childKids = resolvedProps.children;
    const childlessStack = (_childType === "stack" || _childType === "vstack" || _childType === "hstack") && resolvedProps.className === void 0 && resolvedProps.style === void 0 && (childKids === void 0 || childKids === null || Array.isArray(childKids) && !childKids.length);
    if (childlessStack) {
      return null;
    }
    const childContent = {
      id: childId,
      pattern: child.type,
      props: resolvedProps,
      priority: 0,
      nodeId: child._id,
      // Inherit sourceTrait from the parent slot so nested patterns
      // (e.g. form-section inside a stack) can resolve entityDef via
      // the trait's linkedEntity for form-field enrichment. The orbCtx
      // (slot/transition/state/entity) propagates the same way so every
      // nested node carries a complete contextual-edit address. A child
      // carrying its own `_sourceTrait` (multi-source slot stack) owns it
      // outright — inheriting the synthetic wrapper's sentinel instead
      // would erase the real owner.
      ...childSourceTrait !== void 0 ? { sourceTrait: childSourceTrait } : sourceTrait !== void 0 && { sourceTrait },
      ...orbCtx ?? {}
    };
    const renderedChild = /* @__PURE__ */ jsx(
      SlotContentRenderer,
      {
        content: childContent,
        onDismiss,
        patternPath: childPath
      },
      childId
    );
    return childSourceTrait !== void 0 ? /* @__PURE__ */ jsx(MaybeTraitScope, { sourceTrait: childSourceTrait, children: renderedChild }, childId) : renderedChild;
  });
}
function toDrawableNodes(children) {
  if (children === void 0 || children === null) return [];
  const arr = Array.isArray(children) ? children : [children];
  const nodes = [];
  for (const child of arr) {
    if (!child || typeof child !== "object") continue;
    const rec = child;
    const { type, props: nested, _id: _drop, ...flat } = rec;
    const fields = nested !== void 0 ? nested : flat;
    nodes.push({ ...fields, type });
  }
  return nodes;
}
function isPatternConfig(value) {
  if (value === null || value === void 0) return false;
  if (typeof value !== "object") return false;
  if (Array.isArray(value)) return false;
  if (React93__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  if (typeof value === "function") return false;
  const record = value;
  return "type" in record && typeof record.type === "string" && getComponentForPattern(record.type) !== null;
}
function PatternDate({ value }) {
  const { locale } = useTranslate();
  return /* @__PURE__ */ jsx(Fragment, { children: new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "short" }).format(value) });
}
function renderPatternValue(value) {
  if (value === null || value === void 0) return null;
  if (typeof value === "boolean" || typeof value === "function") return null;
  if (typeof value === "number") return value;
  if (typeof value === "string") return renderPatternChildren(value, () => {
  });
  if (value instanceof Date) return /* @__PURE__ */ jsx(PatternDate, { value });
  if (React93__default.isValidElement(value)) return value;
  if (Array.isArray(value)) {
    return value.map((item, index) => /* @__PURE__ */ jsx(React93__default.Fragment, { children: renderPatternValue(item) }, index));
  }
  if (isTraitValue(value)) {
    return /* @__PURE__ */ jsx(React93__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(LazyTraitValueFrame, { value }) });
  }
  if (isBehaviorRefValue(value)) {
    return /* @__PURE__ */ jsx(React93__default.Suspense, { fallback: null, children: /* @__PURE__ */ jsx(LazyBehaviorValueFrame, { value }) });
  }
  if (isPatternConfig(value)) {
    const { type, ...props } = value;
    return renderPatternChildren({ type, props }, () => {
    });
  }
  return null;
}
function isPlainConfigObject(value) {
  if (React93__default.isValidElement(value)) return false;
  if (value instanceof Date) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}
var traitRefPresenceCache = /* @__PURE__ */ new WeakMap();
function subtreeHasTraitRef(value) {
  if (isEvaluatorResolvedData(value)) return false;
  const cached = traitRefPresenceCache.get(value);
  if (cached !== void 0) return cached;
  let found = false;
  const children = Array.isArray(value) ? value : Object.values(value);
  for (const child of children) {
    if (typeof child === "string" && TRAIT_BINDING_RE.test(child)) {
      found = true;
      break;
    }
    if (isRenderBindingMarker(child)) continue;
    if (Array.isArray(child)) {
      if (subtreeHasTraitRef(child)) {
        found = true;
        break;
      }
    } else if (child !== null && typeof child === "object" && isPlainConfigObject(child)) {
      if (subtreeHasTraitRef(child)) {
        found = true;
        break;
      }
    }
  }
  traitRefPresenceCache.set(value, found);
  return found;
}
function substituteTraitRefsDeep(value, pathKey) {
  if (isRenderBindingMarker(value)) return value;
  if (typeof value === "string") {
    const match = TRAIT_BINDING_RE.exec(value);
    if (match) {
      const traitName = match[1];
      return /* @__PURE__ */ jsx(TraitFrame, { traitName }, `${pathKey}:${traitName}`);
    }
    return value;
  }
  if (typeof value === "number" || typeof value === "boolean" || value === null || value === void 0 || typeof value === "function") {
    return value;
  }
  if (Array.isArray(value)) {
    if (!subtreeHasTraitRef(value)) return value;
    return value.map(
      (item, i) => substituteTraitRefsDeep(item, `${pathKey}[${i}]`)
    );
  }
  if (typeof value === "object" && isPlainConfigObject(value)) {
    if (!subtreeHasTraitRef(value)) return value;
    const out = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = substituteTraitRefsDeep(v, `${pathKey}.${k}`);
    }
    return out;
  }
  return value;
}
function renderPatternProps(props, onDismiss, propsSchema) {
  const rendered = {};
  for (const [key, value] of Object.entries(props)) {
    if (key === "children") {
      rendered[key] = value;
    } else if (isPatternConfig(value)) {
      const nestedProps = {};
      for (const [k, v] of Object.entries(value)) {
        if (k !== "type") nestedProps[k] = v;
      }
      const childContent = {
        id: `prop-${key}`,
        pattern: value.type,
        props: nestedProps,
        priority: 0
      };
      rendered[key] = /* @__PURE__ */ jsx(SlotContentRenderer, { content: childContent, onDismiss });
    } else if (Array.isArray(value)) {
      const nodeFields = Object.entries(propsSchema?.[key]?.items?.properties ?? {}).filter(([, def]) => def?.types.includes("node") === true).map(([name]) => name);
      const hasNodeField = (el) => typeof el === "object" && el !== null && !Array.isArray(el) && isPlainConfigObject(el) && nodeFields.some((f3) => isPatternConfig(el[f3]));
      const holdsNodes = nodeFields.length > 0 && !isEvaluatorResolvedData(value) && value.some((el) => hasNodeField(el));
      if (holdsNodes || !isEvaluatorResolvedData(value) && value.some((el) => isPatternConfig(el))) ; else if (!subtreeHasTraitRef(value)) {
        rendered[key] = value;
        continue;
      }
      const isDataArray = propsSchema?.[key]?.items?.types?.includes("object") ?? false;
      rendered[key] = value.map((item, i) => {
        const el = item;
        if (!isDataArray && isPatternConfig(el)) {
          const nestedProps = {};
          for (const [k, v] of Object.entries(el)) {
            if (k !== "type") nestedProps[k] = v;
          }
          const childContent = {
            id: `prop-${key}-${i}`,
            pattern: el.type,
            props: nestedProps,
            priority: 0
          };
          return /* @__PURE__ */ jsx(SlotContentRenderer, { content: childContent, onDismiss }, i);
        }
        if (hasNodeField(el)) {
          const item2 = {};
          for (const [k, v] of Object.entries(el)) {
            if (nodeFields.includes(k) && isPatternConfig(v)) {
              const nestedProps = {};
              for (const [pk, pv] of Object.entries(v)) {
                if (pk !== "type") nestedProps[pk] = pv;
              }
              item2[k] = /* @__PURE__ */ jsx(SlotContentRenderer, { content: { id: `prop-${key}-${i}-${k}`, pattern: v.type, props: nestedProps, priority: 0 }, onDismiss });
            } else {
              item2[k] = substituteTraitRefsDeep(v, `prop:${key}[${i}].${k}`);
            }
          }
          return item2;
        }
        return substituteTraitRefsDeep(el, `prop:${key}[${i}]`);
      });
    } else {
      rendered[key] = substituteTraitRefsDeep(value, `prop:${key}`);
    }
  }
  return rendered;
}
function SlotContentRenderer({
  content,
  onDismiss,
  patternPath,
  presence
}) {
  const ambientScope = useTraitScope();
  const bindingTrait = content.sourceTrait ?? ambientScope?.trait;
  const binding = useEntityBindingSnapshot(bindingTrait);
  const i18n = useRenderI18n$1();
  const liveProps = useMemo(
    () => resolveRenderBindingMarkers(content.props, bindingTrait, binding.entity, binding.config, binding.state, i18n),
    [content.props, bindingTrait, binding.entity, binding.config, binding.state, i18n]
  );
  const propsObj = typeof liveProps === "string" ? {} : liveProps;
  const entityProp = propsObj.entity;
  if (content.pattern === "form-section") {
    slotLog.debug("SlotContentRenderer:form-section-render", {
      contentId: content.id,
      sourceTrait: content.sourceTrait,
      entityRefId: refId(entityProp),
      entityIsObject: entityProp !== null && typeof entityProp === "object" && !Array.isArray(entityProp)
    });
  }
  const entityDeclaredString = getPatternDefinition(content.pattern)?.propsSchema?.entity?.types?.includes("string") === true;
  if (typeof entityProp === "string" && entityProp.length > 0 && !entityDeclaredString) {
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production") {
      throw new Error(
        `[UISlotRenderer] Received string 'entity: "${entityProp}"' at render time. The V2 flow requires pre-resolved data; declare a fetch success listener and pass 'entity: @payload.data'. See docs/Almadar_Entity_V2_Plan.md \xA76.`
      );
    }
  }
  const eventBus = useEventBus();
  const { t } = useTranslate();
  const schemaCtx = useEntitySchemaOptional();
  let entityDef;
  if (typeof entityProp === "string" && entityProp.length > 0 && schemaCtx) {
    entityDef = schemaCtx.entities.get(entityProp);
  } else if (schemaCtx && content.sourceTrait !== void 0) {
    const linkedEntity = schemaCtx.traitLinkedEntities.get(content.sourceTrait);
    if (linkedEntity !== void 0) {
      entityDef = schemaCtx.entities.get(linkedEntity);
    }
  }
  const orbitalName = schemaCtx && content.sourceTrait !== void 0 ? schemaCtx.orbitalsByTrait.get(content.sourceTrait) : void 0;
  const PatternComponent = getComponentForPattern2(content.pattern);
  if (!PatternComponent && typeof liveProps === "string") {
    const traitRefMatch = TRAIT_BINDING_RE.exec(liveProps);
    if (traitRefMatch) {
      return /* @__PURE__ */ jsx(TraitFrame, { traitName: traitRefMatch[1] }, `${content.id}:trait`);
    }
  }
  if (PatternComponent) {
    const childrenConfig = propsObj.children;
    const isSingleChild = typeof childrenConfig === "string" || typeof childrenConfig === "object" && childrenConfig !== null && !Array.isArray(childrenConfig) && "type" in childrenConfig;
    const hasChildren = PATTERNS_WITH_CHILDREN.has(content.pattern) || Array.isArray(childrenConfig) && childrenConfig.length > 0 || isSingleChild;
    const isDrawHost = isDrawHostPattern(content.pattern);
    const arr = Array.isArray(childrenConfig) ? childrenConfig : childrenConfig ? [childrenConfig] : [];
    const hasTraitChildren = arr.some(
      (c) => typeof c === "string" && TRAIT_BINDING_RE.test(c)
    );
    const drawHostUsesReactChildren = isDrawHost && hasTraitChildren;
    const myPath = patternPath ?? "root";
    const renderedChildren = hasChildren && (!isDrawHost || drawHostUsesReactChildren) ? renderPatternChildren(childrenConfig, onDismiss, content.id, myPath, content.sourceTrait, {
      slot: content.slot,
      transitionEvent: content.transitionEvent,
      fromState: content.fromState,
      entity: content.entity
    }) : void 0;
    const incomingChildren = propsObj.children;
    const childrenIsRenderFn = typeof incomingChildren === "function";
    const { children: _childrenConfig, ...restPropsNoChildren } = propsObj;
    const restProps = childrenIsRenderFn ? { ...restPropsNoChildren, children: incomingChildren } : restPropsNoChildren;
    const nodeSlotOverrides = {};
    for (const slotKey of CONTENT_NODE_SLOTS) {
      const slotVal = restProps[slotKey];
      if (slotVal === void 0 || slotVal === null) continue;
      if (React93__default.isValidElement(slotVal) || typeof slotVal === "string" || typeof slotVal === "number" || typeof slotVal === "boolean") continue;
      const typelessChildren = !Array.isArray(slotVal) && typeof slotVal === "object" && !("type" in slotVal) && Array.isArray(slotVal.children) ? slotVal.children : void 0;
      if (typelessChildren !== void 0 || Array.isArray(slotVal) || typeof slotVal === "object" && "type" in slotVal) {
        nodeSlotOverrides[slotKey] = renderPatternChildren(
          typelessChildren ?? slotVal,
          onDismiss,
          `${content.id}-${slotKey}`,
          `${myPath}.${slotKey}`,
          content.sourceTrait,
          { slot: content.slot, transitionEvent: content.transitionEvent, fromState: content.fromState, entity: content.entity }
        );
      }
    }
    const patternDef = getPatternDefinition(content.pattern);
    const propsSchema = patternDef?.propsSchema;
    const renderedProps = renderPatternProps(restProps, onDismiss, propsSchema);
    if (propsSchema) {
      for (const [propKey, propValue] of Object.entries(renderedProps)) {
        if (typeof propValue !== "string") continue;
        const propDef = propsSchema[propKey];
        if (!propDef || propDef.kind !== "callback") continue;
        if (propValue === "") continue;
        renderedProps[propKey] = wrapCallbackForEvent(
          `UI:${propValue}`,
          propDef.callbackArgs,
          (eventKey, payload) => eventBus.emit(eventKey, payload)
        );
      }
    }
    if (propsSchema) {
      for (const [propKey, propDef] of Object.entries(propsSchema)) {
        const isDate = propDef.types?.some(
          (t2) => t2 === "date" || t2 === "datetime" || t2 === "timestamp"
        );
        if (!isDate) continue;
        const v = renderedProps[propKey];
        if (typeof v === "string" || typeof v === "number") {
          renderedProps[propKey] = new Date(v);
        } else if (v == null && propDef.required) {
          renderedProps[propKey] = /* @__PURE__ */ new Date();
        }
      }
    }
    const finalProps = renderedProps;
    for (const [k, v] of Object.entries(nodeSlotOverrides)) {
      finalProps[k] = v;
    }
    if (isDrawHost && !drawHostUsesReactChildren && Array.isArray(childrenConfig) && childrenConfig.length > 0) {
      finalProps.drawables = toDrawableNodes(childrenConfig);
    }
    const entityVal = finalProps.entity;
    const resolvedItems = Array.isArray(entityVal) && entityVal[0] !== "fn" ? entityVal : null;
    if (resolvedItems && resolvedItems.length > 0 && !finalProps.fields && !finalProps.columns) {
      const sample = resolvedItems[0];
      if (sample && typeof sample === "object" && !Array.isArray(sample) && !React93__default.isValidElement(sample) && !(sample instanceof Date)) {
        const keys = Object.keys(sample).filter((k) => k !== "id" && k !== "_id");
        finalProps.fields = keys.map((k, i) => ({ name: k, variant: i === 0 ? "h4" : "body" }));
      }
    }
    const fieldsContract = getPatternFieldsContract(content.pattern) ?? (getPatternDefinition(content.pattern) === null && content.pattern.includes("form") ? "form" : void 0);
    if (fieldsContract && entityDef && Array.isArray(finalProps.fields) && finalProps.fields[0] !== "fn") {
      finalProps.fields = fieldsContract === "form" ? enrichFormFields([...finalProps.fields], entityDef) : enrichDetailFields([...finalProps.fields], entityDef);
    }
    const typeMismatches = propTypeMismatches(propsSchema, finalProps, renderedChildren !== void 0 ? ["children"] : []);
    if (typeMismatches.length > 0) {
      slotLog.error("SlotContentRenderer:prop-type-mismatch", {
        pattern: content.pattern,
        sourceTrait: content.sourceTrait,
        mismatches: typeMismatches.map((m) => `${m.prop}: expected ${m.expected.join(" | ")}, got ${m.got}`)
      });
      return /* @__PURE__ */ jsx(
        Box,
        {
          className: "p-4 text-sm border border-dashed border-error rounded-container",
          "data-testid": PATTERN_PROP_TYPE_ERROR_TESTID,
          "data-orb-pattern": content.pattern,
          "data-orb-trait": content.sourceTrait,
          "data-orb-slot": content.slot,
          "data-orb-path": myPath,
          children: typeMismatches.map((m) => /* @__PURE__ */ jsx(Typography, { variant: "small", color: "error", children: `${content.pattern}.${m.prop}: expected ${m.expected.join(" | ")}, got ${m.got}` }, m.prop))
        }
      );
    }
    const nodeEnterClass = enterClassName(
      asEnterAnimation(typeof finalProps.enter === "string" ? finalProps.enter : void 0),
      typeof finalProps.enterDelay === "number" ? finalProps.enterDelay : void 0
    );
    delete finalProps.enter;
    delete finalProps.enterDelay;
    if (propsSchema?.skeleton?.kind === "skeleton") delete finalProps.skeleton;
    if (nodeEnterClass) {
      finalProps.className = cn(typeof finalProps.className === "string" ? finalProps.className : void 0, nodeEnterClass);
    }
    const acceptsChildren = PATTERNS_WITH_CHILDREN.has(content.pattern);
    return /* @__PURE__ */ jsx(
      Box,
      {
        className: "slot-content contents",
        "data-pattern": content.pattern,
        "data-id": content.id,
        "data-node-id": content.nodeId,
        "data-source-trait": content.sourceTrait,
        "data-pattern-path": myPath,
        "data-pattern-type": content.pattern,
        "data-accepts-children": acceptsChildren ? "true" : void 0,
        "data-orb-trait": content.sourceTrait,
        "data-orb-slot": content.slot,
        "data-orb-transition": content.transitionEvent,
        "data-orb-state": content.fromState,
        "data-orb-entity": content.entity,
        "data-orb-path": myPath,
        "data-orb-pattern": content.pattern,
        "data-orb-orbital": orbitalName,
        children: presence !== void 0 && SELF_OVERLAY_PATTERN_TYPES.has(content.pattern) ? /* @__PURE__ */ jsx(PatternComponent, { ...finalProps, isOpen: presence.open, onExited: presence.onExited, children: renderedChildren }) : renderedChildren !== void 0 ? /* @__PURE__ */ jsx(PatternComponent, { ...finalProps, children: renderedChildren }) : /* @__PURE__ */ jsx(PatternComponent, { ...finalProps })
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Box,
    {
      className: "slot-content",
      "data-pattern": content.pattern,
      "data-id": content.id,
      "data-node-id": content.nodeId,
      "data-source-trait": content.sourceTrait,
      "data-orb-trait": content.sourceTrait,
      "data-orb-slot": content.slot,
      "data-orb-transition": content.transitionEvent,
      "data-orb-state": content.fromState,
      "data-orb-entity": content.entity,
      "data-orb-path": patternPath ?? "root",
      "data-orb-pattern": content.pattern,
      "data-orb-orbital": orbitalName,
      children: propsObj.children ?? /* @__PURE__ */ jsxs(Box, { className: "p-4 text-sm text-muted-foreground border border-dashed border-border rounded-container", children: [
        "Unknown pattern: ",
        content.pattern,
        content.sourceTrait && /* @__PURE__ */ jsxs(Typography, { variant: "small", className: "ml-2", children: [
          "(from ",
          content.sourceTrait,
          ")"
        ] })
      ] })
    }
  );
}
function UISlotRenderer({
  includeHud = false,
  hudMode = "fixed",
  includeFloating = false,
  className,
  suspense,
  pageKey
}) {
  const isContained = hudMode === "inline";
  const suspenseConfig = suspense === true ? { enabled: true } : suspense && typeof suspense === "object" ? suspense : { enabled: false };
  const content = /* @__PURE__ */ jsxs(Box, { className: cn(
    "ui-slot-renderer relative min-h-full",
    className
  ), children: [
    /* @__PURE__ */ jsxs(Box, { className: "flex min-h-full flex-col lg:flex-row", children: [
      /* @__PURE__ */ jsx(UISlotComponent, { slot: "sidebar", className: "ui-slot-sidebar min-w-0 lg:shrink-0" }),
      pageKey !== void 0 ? /* @__PURE__ */ jsx(PageTransition, { locationKey: pageKey, className: "flex flex-1 min-w-0 flex-col", children: /* @__PURE__ */ jsx(UISlotComponent, { slot: "main", className: "ui-slot-main flex-1 min-w-0 min-h-[200px]" }) }) : /* @__PURE__ */ jsx(UISlotComponent, { slot: "main", className: "ui-slot-main flex-1 min-w-0 min-h-[200px]" })
    ] }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "dock", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "modal", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "drawer", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "overlay", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "center", portal: true }),
    /* @__PURE__ */ jsx(UISlotComponent, { slot: "toast", portal: true, position: "top-right" }),
    includeHud && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        UISlotComponent,
        {
          slot: "hud-top",
          className: isContained ? "absolute top-0 left-0 right-0 z-40" : "fixed top-0 inset-x-0 z-40"
        }
      ),
      /* @__PURE__ */ jsx(
        UISlotComponent,
        {
          slot: "hud-bottom",
          className: isContained ? "absolute bottom-0 left-0 right-0 z-40" : "fixed bottom-0 inset-x-0 z-40"
        }
      )
    ] }),
    includeFloating ? /* @__PURE__ */ jsx(
      UISlotComponent,
      {
        slot: "floating",
        className: isContained ? "absolute top-2 left-2 z-50" : "fixed z-50",
        draggable: true
      }
    ) : /* @__PURE__ */ jsx(UISlotComponent, { slot: "floating", portal: true })
  ] });
  let wrapped = content;
  if (suspenseConfig.enabled) {
    wrapped = /* @__PURE__ */ jsx(SuspenseConfigProvider, { config: suspenseConfig, children: wrapped });
  }
  if (isContained) {
    wrapped = /* @__PURE__ */ jsx(SlotContainedContext.Provider, { value: true, children: wrapped });
  }
  return wrapped;
}
UISlotRenderer.displayName = "UISlotRenderer";

export { ALL_PRESETS, AVL_GLYPH_KINDS, AVL_GRAPH_NODE_TYPES, Accordion, ActionPalette, ActionTile, ActivationBlock, AgentActivityFeed, AgentActivityRow, AgentChatFeed, AgentThinkingRow, Alert, AlgoGraphCanvas, AlgorithmCanvas, AnimatedCounter, AnimatedGraphic, AnimatedReveal, Aside, AtlasImage, AtlasPanel, AuthLayout, Avatar, AvlApplication, AvlBinding, AvlBindingRef, AvlCircuit, AvlEffect, AvlEffectChip, AvlEntity, AvlEvent, AvlField, AvlFieldType, AvlGlyph, AvlGraphCanvas, AvlGuard, AvlLiteral, AvlOperator, AvlOrbital, AvlPage, AvlPersistence, AvlSExpr, AvlState, AvlStateMachine, AvlTrait, AvlTransition, AvlTransitionDetail, AvlTransitionExplainer, Badge, BehaviorView, BiologyCanvas, BloomQuizBlock, BranchingLogicBuilder, Breadcrumb, BrowserPlayground, Button, ButtonGroup, CANVAS_TOOLS, COMPACT_MEDIA_QUERY, CalendarGrid, Canvas, Canvas2D, CanvasDndProvider, CanvasVerifyContext, Card, Card2, CardBody, CardContent, CardFooter, CardHeader, CardTitle, Carousel, Center, ChangeList, Chart, ChartLegend, ChatBar, Checkbox, ChemistryCanvas, ChoiceButton, CodeBlock, CodeRunnerPanel, CollapsibleSection, CommandPalette, CommitRow, ConditionalWrapper, ConfettiEffect, ConfirmDialog, ConnectionBlock, Container, ContentRenderer, ControlButton, ControlGrid, CounterTemplate, DEFAULT_LIKERT_OPTION_KEYS, DEFAULT_MATRIX_COLUMN_KEYS, DIAMOND_TOP_Y, DashboardGrid, DashboardLayout, DataGrid, DataList, DateRangePicker, DateRangeSelector, DayCell, DependencyColumnNode, DependencyNode, DetailPanel, Dialog, DialogueBubble, Divider, DocBreadcrumb, DocPagination, DocSearch, DocSidebar, DocTOC, DockLayout, DocumentDetails, DocumentPanel, DocumentViewer, DrawShapeLayer, DrawSprite, DrawSpriteLayer, DrawText, DrawTextLayer, Drawer, DrawerSlot, EDITABLE, ELEMENT_SELECTED_EVENT, EdgeDecoration, EditorCheckbox, EditorSelect, EditorSlider, EditorTextInput, EditorToolbar, ElementEditAccessContext, EmojiPicker, EmptyState, ErrorBoundary, ErrorState, EventFlowEdge, FEATURE_COLORS, FEATURE_TYPES, FIELD_TYPE_SHAPES, FLOOR_HEIGHT, FeatureCard, FeatureGrid, FileTree, FilterGroup, FilterPill, Flex, FlipCard, FlipContainer, FloatingActionButton, FloatingToolbar, FlowCanvas, Form, FormActions, FormField, FormLayout, FormSection, FormSectionHeader, FxOverlay, GameAudioCue, GameAudioToggle, GameHud, GameIcon, GameMenu, GameShell, Gantt, GenericAppTemplate, GeometricPattern, GradientDivider, GraphCanvas, GraphView, Grid, GridPicker, Header, HealthBar, Icon, IconButton, Image2 as Image, ImportPreviewTree, ImportProgress, ImportSourcePicker, InfiniteScrollSentinel, Input, InputGroup, JazariStateMachine, JsonTreeEditor, KnobField, KnobSettingRow, LIVE_STATE, Label, LawReferenceTooltip, LayersPanel, LearningCanvas, LearningScene3D, Lightbox, LikertScale, LineChart2 as LineChart, LoadingState, MapView, MarkdownContent, MasterDetailLayout, MathCanvas, MatrixQuestion, MediaGallery, Menu, Meter, MiniStateMachine, Modal, ModalSlot, ModuleCard, Navigation, NumberStepper, OptionConstraintGroup, OrbInspector, OrbPreview, OrbPreviewNode, OrbitalVisualization, Overlay, PageHeader, PageTransition, Pagination, PatternTile, PhysicsCanvas, Popover, PositionedCanvas, ProgressBar, ProgressDots, PullToRefresh, QrScanner, QuizBlock, Radio, RangeSlider, ReflectionBlock, RelationSelect, RepeatableFormSection, ReplyTree, RichTextEditor, RuntimeDebugger, SHEET_COLUMNS, SPRITE_SHEET_LAYOUT, ScaledDiagram, ScoreDisplay, SearchInput, Section, SectionHeader, SegmentRenderer, Select, SequenceBar, SidePanel, Sidebar, SignaturePad, SimpleGrid, Skeleton, SkeletonTree, SlotContainedContext, SlotContentRenderer, SocialProof, SortableList, Spacer, Sparkline, Spinner, Split, SplitPane, StarRating, StatBadge, StatCard, StatDisplay, StateGraph, StateJsonView, StateMachineView, StatusBar, StatusDot, SubagentTracePanel, SuspenseConfigProvider, SvgBranch, SvgConnection, SvgFlow, SvgGrid, SvgLobe, SvgMesh, SvgMorph, SvgNode, SvgPulse, SvgRing, SvgShield, SvgStack, SwipeableRow, Switch, SystemBandNode, SystemMapContext, SystemNode, TERRAIN_COLORS, TILE_HEIGHT, TILE_WIDTH, TabbedContainer, TableView, Tabs, TagInput, TerrainPalette, TextHighlight, Textarea, ThemeToggle, ThemedPortal, TimeSlotCell, Timeline, TimerDisplay, Toast, ToastSlot, Tooltip, TopNavItem, TraitFrame, TraitSlot, TraitStateViewer, TrendIndicator, TypewriterText, UISlotComponent, UISlotRenderer, UploadDropZone, VersionDiff, ViolationAlert, VoteStack, WizardContainer, WizardNavigation, WizardProgress, activityRowFacts, applyCompletion, applySuggestions, arbitraryClassesOf, armPosition, armsOf, arrowBetween, billboardLabel, boardEntity, bool, calculateAttackTargets, calculateValidMoves, canvasViewGraph, clearSchemaCache, computeTraitLayout, createInitialGameState, createUnitAnimationState, cylinderBetween, dependencyReach, deriveEditFocusFromElement, dispatchCommandPaletteCommand, dropBusEvent, edgePath, firedTransition, flowNeighbors, get3DClickPayload, getCurrentFrame, getTileDimensions, groupIntoConversations, hasCanvasTool, inferDirection, initialStateOf, isoToScreen, layeredGraph, makeAsset, makeAssetMap, meshSphere, num, objAvailableActions, objAvailableEvents, objCurrentState, objIcon, objId, objMaxRules, objName, objRules, objStates, optionForPlayedStep, parseEditFocus, parseLayerId, pendulum, projectileMotion, propAccessAt, registerCodeLanguageLoader, renderPatternValue, resolveFrame, resolveSheetDirection, rows, sanitizeRichHtml, schemaToDependencyGraph, schemaToLayerItems, schemaToOverviewGraph, screenToIso, springOscillator, stateMachinePlayback, stateOptionsOf, str, tickAnimationState, toCodeLanguage, traitFlowGraph, transitionAnimation, transitionPlayback, unitHealth, unitPosition, unitTeam, useAtlasSliceDataUrl, useCamera, useCanvasDraggable, useCanvasDroppable, useCompactLayout, useDockLayout, useGameAudio, useImageCache, useInlineTextEdit, useResolvedSchema, useTraitStateMachine, useUnitSpriteAtlas, vec2 };
